"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Shipwell v2 Core API
 * Shipwell\'s v2 Core API contains most shipping and carrier-specific supply chain endpoints. It is written according to OAS specifications. To make use of this API reference, use the side nav to find the endpoints you need. Endpoints are categorized by use case.
 *
 * The version of the OpenAPI document: 2.7.477
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyLogoImageTypeEnum = exports.CompanyInternationalPreferencesCurrencyEnum = exports.ChargeCategory = exports.CarrierStatusCarrierAssignmentAllOfCarrierStatusEnum = exports.CarrierStatusCarrierAssignmentCarrierStatusEnum = exports.CarrierStatus = exports.CarrierSelectionPageResponseCarrierStatusEnum = exports.CarrierRelationshipExternalPaymentProcessorSyncStatusEnum = exports.CarrierRelationshipCarrierStatusEnum = exports.CarrierPointOfContactAllOfJobTitleEnum = exports.CarrierPointOfContactJobTitleEnum = exports.CarrierInsuranceInsurancePolicyTypeEnum = exports.CarrierExclusionRuleLocationConstraintDirectionEnum = exports.CarrierExclusionRuleLinearDimensionUnitEnum = exports.CarrierELDProviderTrackingStatusEnum = exports.CarrierELDProviderConnectionStatusEnum = exports.CarrierCapacityRecordPickupDayOfWeekEnum = exports.BillToOverrideDirectionEnum = exports.BillRemitToRelationshipEnum = exports.BillDocumentsContentTypeEnum = exports.BillProcessingStatusEnum = exports.BillPaymentStatusEnum = exports.BaseShipmentVersionEnum = exports.BaseShipmentTotalDeclaredValueCurrencyEnum = exports.BaseShipmentRailCarStatusEnum = exports.BaseShipmentPreferredCurrencyEnum = exports.BaseShipmentParcelPickupStatusEnum = exports.BaseProductDescriptionWeightUnitEnum = exports.BaseProductDescriptionValuePerPieceCurrencyEnum = exports.BaseProductDescriptionTempUnitEnum = exports.BaseProductDescriptionLengthUnitEnum = exports.BaseProductDescriptionHazmatPackingGroupEnum = exports.BaseCarrierRelationshipExternalPaymentProcessorSyncStatusEnum = exports.BaseCarrierRelationshipCarrierStatusEnum = exports.AutomationEventSubType = exports.AutomationEventTypeEnum = exports.AutomationEventSubTypeEnum = exports.AutomationEventSourceEnum = exports.AutomationEventResultingAlertLevelEnum = exports.AutomationEventConversationStatusEnum = exports.AlertsDashBoardConfigurationOptionsThresholdDefinitionTypeEnum = exports.AlertEventConfigurationType = exports.AlertEventSecondaryResourceTypeEnum = exports.AlertEventResourceTypeEnum = exports.AlertEventAlertLevelEnum = exports.AlertDashboardSlimCarrierRelationshipCarrierStatusEnum = exports.AccessorialChargeTableStatusEnum = exports.AccessorialChargeTableLocationTypeEnum = exports.AccessorialChargeTableAppliesToEnum = exports.AbstractChargeLineItemUnitAmountCurrencyEnum = void 0;
exports.ELDProvider = exports.ELDDriverStatus = exports.EIAFuelRateEiaFuelPricingAreaEnum = exports.DriverPushNotificationTypesEnum = exports.DriverLogLogTypeEnum = exports.DriverPlatformEnum = exports.DispatchJobStatusEnum = exports.DevicePlatformEnum = exports.CustomFieldFieldTypeEnum = exports.CustomFieldEntityTypesEnum = exports.CurrencyCode = exports.CreatedBySourceTypeEnum = exports.CreateSpotNegotiationQuoteSourceTypeEnum = exports.CreateSpotNegotiationQuoteLaneTypeEnum = exports.CreateSpotNegotiationQuoteCurrencyEnum = exports.CreateShipmentTimelineEventEventTypeEnum = exports.CreateShipmentTimelineEventEventSubTypeEnum = exports.CreateQuoteSourceTypeEnum = exports.CreateQuoteLaneTypeEnum = exports.CreateQuoteCurrencyEnum = exports.ContractStatuses = exports.ContractRateTypes = exports.ContractRateTableBandRateApplicationTypeEnum = exports.ContractRateTableWeightUnitEnum = exports.ContractRateTableRateTypeEnum = exports.ContractRateTableDistanceUnitEnum = exports.ContractRateTableBandCalculationMeasurementEnum = exports.ContractCriteriaByValueRequestTotalWeightUnitEnum = exports.ContractCriteriaByValueRequestRequestTypeEnum = exports.ContractCriteriaByValueRequestModeEnum = exports.ContractCriteriaByValueRequestCurrencyEnum = exports.ContractCriteriaByShipmentRequestRequestTypeEnum = exports.ContractAccessorialTypeEnum = exports.ContractWeightUnitEnum = exports.ContractStatusEnum = exports.ContractRateTypeEnum = exports.ContractRateCurrencyEnum = exports.ContractPerHourStartFieldEnum = exports.ContractPerHourEndFieldEnum = exports.ContractMinimumRateCurrencyEnum = exports.ContractDistanceUnitEnum = exports.ContractAdditionalStopChargesTypeEnum = exports.ContractAdditionalStopChargePerMileCurrencyEnum = exports.ContractAdditionalStopChargeFlatFeeCurrencyEnum = exports.ContainerDetailsDemurrageIncurredCurrencyEnum = exports.ConfiguredFMSConfiguredIntegrationsNameEnum = exports.CompanyPreferencesExternalPushTrackingProviderEnum = exports.CompanyPreferencesExternalPushTrackingExternalIdQualifierEnum = exports.CompanyPreferencesDefaultCarrierStatusEnum = exports.CompanyPreferencesCountryEnum = void 0;
exports.InitiateCheckCallRequestAutomationEventSubTypeEnum = exports.HoursOfServiceResponseStatusEnum = exports.HistoricalPriceSources = exports.GenesisShipmentOptionsSignatureOptionSignatureTypeEnum = exports.GenesisShipmentOptionsCodCollectionTypeEnum = exports.GenesisShipmentOptionsCodCollectionCurrencyEnum = exports.GenesisShipmentOptionsBillToPaymentTypeEnum = exports.GeneratedBy = exports.FullNameDriverPlatformEnum = exports.FuelSurchargeTableStatusEnum = exports.FuelSurchargeTableRegionEnum = exports.FuelSurchargeTableRatesUpdatedDayOfWeekEnum = exports.FuelSurchargeTableRatesUpdateFrequencyEnum = exports.FuelSurchargeTableRateTypeEnum = exports.FuelSurchargeTableLocationTypeEnum = exports.FuelSurchargeTableAppliesToEnum = exports.FreightInvoiceSubStatusType = exports.FreightInvoiceStopsReasonsEnum = exports.FreightInvoiceStatus = exports.FreightInvoiceRemitToEntityTypeEnum = exports.FreightInvoiceProductLineItemsPackagingEnum = exports.FreightInvoiceDocumentMetadataDocumentTypeEnum = exports.FreightInvoiceBillToEntityTypeEnum = exports.FreightClass = exports.FedexShipmentOptionsAllOfSmartPostIndiciaTypeEnum = exports.FedexShipmentOptionsAllOfServiceCodeEnum = exports.FedexShipmentOptionsAllOfPackagingEnum = exports.FedexShipmentOptionsAllOfHomeDeliveryTypeEnum = exports.FedexShipmentOptionsAllOfDropoffTypeEnum = exports.FedexShipmentOptionsAllOfBatteryPackagingTypeEnum = exports.FedexShipmentOptionsAllOfBatteryMaterialTypeEnum = exports.FedexShipmentOptionsAllOfAlcoholRecipientTypeEnum = exports.FedexShipmentOptionsSmartPostIndiciaTypeEnum = exports.FedexShipmentOptionsServiceCodeEnum = exports.FedexShipmentOptionsPackagingEnum = exports.FedexShipmentOptionsHomeDeliveryTypeEnum = exports.FedexShipmentOptionsDropoffTypeEnum = exports.FedexShipmentOptionsBatteryPackagingTypeEnum = exports.FedexShipmentOptionsBatteryMaterialTypeEnum = exports.FedexShipmentOptionsAlcoholRecipientTypeEnum = exports.FedexShipmentOptionsSignatureOptionSignatureTypeEnum = exports.FedexShipmentOptionsCodCollectionTypeEnum = exports.FedexShipmentOptionsCodCollectionCurrencyEnum = exports.FedexShipmentOptionsBillToPaymentTypeEnum = exports.FedexLabelDataHeaders = exports.FedExStockTypes = exports.FedExImageTypes = exports.ExtendedELDProvider = exports.EquipmentTypeValues = exports.EquipmentEnum = void 0;
exports.ProductLineItemWeightUnit = exports.ProductItemUnitType = exports.ProductWeightUnitEnum = exports.ProductValuePerPieceCurrencyEnum = exports.ProductTempUnitEnum = exports.ProductLengthUnitEnum = exports.ProductHazmatPackingGroupEnum = exports.PreProNumberGenerationConfigCheckDigitEnum = exports.PowerUnitStatusEnum = exports.PolicyStatusEnum = exports.PolicyPolicyTypeEnum = exports.PieceDetailAllOfInsuredValueCurrencyEnum = exports.PieceDetailInsuredValueCurrencyEnum = exports.PieceDetailWeightUnitEnum = exports.PieceDetailValuePerPieceCurrencyEnum = exports.PieceDetailTempUnitEnum = exports.PieceDetailLengthUnitEnum = exports.PieceDetailHazmatPackingGroupEnum = exports.PhoneNumberLookupTypeEnum = exports.ParcelPickupStatus = exports.NotificationPreferenceMediumEnum = exports.NetsuiteSuiteAppOrderFieldMappingSwInLineWeightUnitEnum = exports.NetsuiteSuiteAppOrderFieldMappingSwInLineLengthUnitEnum = exports.NetsuiteSuiteAppConfigAuthTypeEnum = exports.NetsuiteCustomFieldTypeEnum = exports.MileageType = exports.MarkupParcelMarkupTypeEnum = exports.MarkupLtlMarkupTypeEnum = exports.MarkupFtlMarkupTypeEnum = exports.LoadCapacityScheduleIntervalEnum = exports.LoadBoardTenderStatuses = exports.LoadBoardShipmentTotalDeclaredValueCurrencyEnum = exports.LoadBoardShipmentTargetRateAmountCurrencyEnum = exports.LoadBoardShipmentSpotNegotiationCarrierStatusEnum = exports.LoadBoardShipmentBuyItNowAmountCurrencyEnum = exports.LoadBoardShipmentBiddingStatusEnum = exports.LoadBoardBiddingStatuses = exports.LegTagColorEnum = exports.LegLocationResponseTrackingStatusEnum = exports.ItemConsolidationLineItemsWeightUnitEnum = exports.ItemConsolidationLineItemsLengthUnitEnum = exports.ItemConsolidationAllocatePiecesWeightUnitEnum = exports.InvoicingShipmentsShipmentIdFreightInvoicesDataRoleEnum = exports.InvoiceableReferenceType = exports.InvoiceUpdateRequestProcessingStatusEnum = exports.InvoiceUpdateRequestPaymentStatusEnum = exports.InvoiceEmailResponseInvoiceResourceTypeEnum = exports.InvoiceProcessingStatusEnum = exports.InvoicePaymentStatusEnum = exports.InlineObject9CategoryEnum = void 0;
exports.RfpLaneOptResponseDistanceUnitsEnum = exports.RfpLaneOptResponseDestinationCountryIsoCodeEnum = exports.RfpCarrierBidRequestOptResponseBidRequestStateEnum = exports.RfpCarrierBidRequestOptRequestBidRequestStateEnum = exports.RelatedOrderItemOrderTypeEnum = exports.RelatedOrderOrderTypeEnum = exports.RecordedEquipmentTypeEldProviderEnum = exports.RecordedELDProviderSupportedProviderNameEnum = exports.RateAssessmentMeasurement = exports.RMISJobStatusTypeEnum = exports.RMISDotTestingInfoOperatingStatusEnum = exports.RFPBidOptResponseStateEnum = exports.RFPBidOptContractWorkflowCreationRecordResponseWorkflowStatusEnum = exports.RFPBidOptContractWorkflowCreationRecordResponseContractsStatusEnum = exports.QuoteChargeLineItemUnitAmountCurrencyEnum = exports.QuoteSourceTypeEnum = exports.QuoteLaneTypeEnum = exports.QuoteCurrencyEnum = exports.PurchaseOrderResponseTransitStatusReasonCodeEnum = exports.PurchaseOrderResponseTransitStatusEnum = exports.PurchaseOrderResponseTaxAmountCurrencyEnum = exports.PurchaseOrderResponseSubtotalAmountCurrencyEnum = exports.PurchaseOrderResponseSourceEnum = exports.PurchaseOrderResponseOverallStatusEnum = exports.PurchaseOrderListResponseTransitStatusReasonCodeEnum = exports.PurchaseOrderListResponseTransitStatusEnum = exports.PurchaseOrderListResponseTaxAmountCurrencyEnum = exports.PurchaseOrderListResponseSubtotalAmountCurrencyEnum = exports.PurchaseOrderListResponseSourceEnum = exports.PurchaseOrderListResponseOverallStatusEnum = exports.PurchaseOrderLineItemResponseWeightUnitEnum = exports.PurchaseOrderLineItemResponseValuePerPieceCurrencyEnum = exports.PurchaseOrderLineItemResponseTempUnitEnum = exports.PurchaseOrderLineItemResponseLengthUnitEnum = exports.PurchaseOrderLineItemResponseHazmatPackingGroupEnum = exports.PurchaseOrderLineItemWeightUnitEnum = exports.PurchaseOrderLineItemValuePerPieceCurrencyEnum = exports.PurchaseOrderLineItemTempUnitEnum = exports.PurchaseOrderLineItemLengthUnitEnum = exports.PurchaseOrderLineItemHazmatPackingGroupEnum = exports.PurchaseOrderAlertReasonCodeEnum = exports.PurchaseOrderAlertAlertTypeEnum = exports.PurchaseOrderTransitStatusReasonCodeEnum = exports.PurchaseOrderTransitStatusEnum = exports.PurchaseOrderTaxAmountCurrencyEnum = exports.PurchaseOrderSubtotalAmountCurrencyEnum = exports.PurchaseOrderSourceEnum = exports.PurchaseOrderOverallStatusEnum = exports.ProductPieceType = exports.ProductPackageType = void 0;
exports.ShipmentMetadataMaxBuyAmountCurrencyEnum = exports.ShipmentMetadataBuyItNowAmountCurrencyEnum = exports.ShipmentMetadataAlertLevelEnum = exports.ShipmentLocationResponseTrackingStatusEnum = exports.ShipmentLineItemDetailInsuredValueCurrencyEnum = exports.ShipmentLineItemDetailWeightUnitEnum = exports.ShipmentLineItemDetailValuePerPieceCurrencyEnum = exports.ShipmentLineItemDetailTempUnitEnum = exports.ShipmentLineItemDetailLengthUnitEnum = exports.ShipmentLineItemDetailHazmatPackingGroupEnum = exports.ShipmentLineItemAllOfInsuredValueCurrencyEnum = exports.ShipmentLineItemInsuredValueCurrencyEnum = exports.ShipmentLineItemWeightUnitEnum = exports.ShipmentLineItemValuePerPieceCurrencyEnum = exports.ShipmentLineItemTempUnitEnum = exports.ShipmentLineItemLengthUnitEnum = exports.ShipmentLineItemHazmatPackingGroupEnum = exports.ShipmentDocumentSignatureSignatoryRoleEnum = exports.ShipmentDocumentSignSignatoryRoleEnum = exports.ShipmentDocumentMetadataAllOfTypeEnum = exports.ShipmentDocumentMetadataTypeEnum = exports.ShipmentChargeLineItemUnitAmountCurrencyEnum = exports.ShipmentAlertLevel = exports.ShipmentVersionEnum = exports.ShipmentTotalDeclaredValueCurrencyEnum = exports.ShipmentRailCarStatusEnum = exports.ShipmentPreferredCurrencyEnum = exports.ShipmentParcelPickupStatusEnum = exports.SettlementsDashboardSubStatusType = exports.SettlementsDashboardSource = exports.SettlementsDashboardGeneratedBy = exports.ServiceProviderStatusEnum = exports.ServiceProviderCapabilitiesEnum = exports.ServiceLevelAgreementStatuses = exports.ServiceLevelAgreementIntervals = exports.ServiceLevelAgreementStatusEnum = exports.ServiceLevelAgreementPositionEnum = exports.ServiceLevelAgreementMinimumOnTimePickupIntervalEnum = exports.ServiceLevelAgreementMinimumOnTimeDeliveryIntervalEnum = exports.ServiceLevelAgreementMinimumAcceptanceIntervalEnum = exports.ServiceLevelAgreementCommittedLoadsIntervalEnum = exports.ServiceLevelAgreementCapacityIntervalEnum = exports.ServiceLevelAgreementAwardedLoadsIntervalEnum = exports.SMSTrackingDriverActionActionEnum = exports.RfpRowResponseModeEnum = exports.RfpRowResponseEquipmentEnum = exports.RfpLaneOptResponsePriceVolatilityTextEnum = exports.RfpLaneOptResponseOriginCountryIsoCodeEnum = exports.RfpLaneOptResponseModeEnum = exports.RfpLaneOptResponseEquipmentEnum = void 0;
exports.TenderGetAllOfCarrierStatusEnum = exports.TenderGetStatusEnum = exports.TenderGetCarrierStatusEnum = exports.TenderGetLaneTypeEnum = exports.TenderEquipmentEventRequestTypeCodeEnum = exports.TenderCreateLaneTypeEnum = exports.TenderBaseLaneTypeEnum = exports.TenderAcceptRejectDetailsStatusEnum = exports.TenderAcceptRejectTypeEnum = exports.TenderAcceptRejectRejectionCodeEnum = exports.SupplierInviteResponseStatusEnum = exports.SupplierInviteStatusEnum = exports.StopEventStopEventTypeEnum = exports.StopEventStopEventReasonCodeEnum = exports.StopDetailStatusReasonCodeEnum = exports.StopDetailStatusEnum = exports.StopAlertReasonCodeEnum = exports.StopAlertAlertTypeEnum = exports.StopStatusReasonCodeEnum = exports.StopStatusEnum = exports.SpotNegotiationQuoteDocumentTypeEnum = exports.SpotNegotiationCarrierStatusEnum = exports.SlimStopStatusReasonCodeEnum = exports.SlimStopStatusEnum = exports.SlimShipmentVersionEnum = exports.SlimShipmentTotalDeclaredValueCurrencyEnum = exports.SlimShipmentRailCarStatusEnum = exports.SlimShipmentPreferredCurrencyEnum = exports.SlimShipmentParcelPickupStatusEnum = exports.SlimRMISDotTestingInfoOperatingStatusEnum = exports.SlimRMISCarrierStatusStatusEnum = exports.SlimRMISCarrierStatusEnum = exports.SlimPowerUnitStatusEnum = exports.SlimDriverPlatformEnum = exports.SlimCarrierStatusCarrierAssignmentCarrierStatusEnum = exports.SlimCarrierRelationshipExternalPaymentProcessorSyncStatusEnum = exports.SlimCarrierRelationshipCarrierStatusEnum = exports.ShippingDashboardRowType = exports.ShippingDashboardRowTenderStatusEnum = exports.ShipmentTimelineFilterPreferencesGroupTypeEnum = exports.ShipmentTimelineEventEventTypeEnum = exports.ShipmentTimelineEventEventSubTypeEnum = exports.ShipmentTagColorEnum = exports.ShipmentStatesValues = exports.ShipmentSpotNegotiationCarrierStatusEnum = exports.ShipmentMetadataAlertWithShipmentTypeEnum = exports.ShipmentMetadataAlertWithShipmentSubtypeEnum = exports.ShipmentMetadataAlertTypeEnum = exports.ShipmentMetadataAlertSubtypeEnum = exports.ShipmentMetadataTargetRateAmountCurrencyEnum = void 0;
exports.BillingApiAxiosParamCreator = exports.AnalyticsApi = exports.AnalyticsApiFactory = exports.AnalyticsApiFp = exports.AnalyticsApiAxiosParamCreator = exports.AlertEventsApi = exports.AlertEventsApiFactory = exports.AlertEventsApiFp = exports.AlertEventsApiAxiosParamCreator = exports.USPSShipmentOptionsAllOfServiceCodeEnum = exports.USPSShipmentOptionsAllOfPackagingEnum = exports.USPSShipmentOptionsServiceCodeEnum = exports.USPSShipmentOptionsPackagingEnum = exports.USPSShipmentOptionsSignatureOptionSignatureTypeEnum = exports.USPSShipmentOptionsCodCollectionTypeEnum = exports.USPSShipmentOptionsCodCollectionCurrencyEnum = exports.USPSShipmentOptionsBillToPaymentTypeEnum = exports.UPSStockTypes = exports.UPSShipmentOptionsAllOfServiceCodeEnum = exports.UPSShipmentOptionsAllOfPackagingEnum = exports.UPSShipmentOptionsAllOfAlcoholRecipientTypeEnum = exports.UPSShipmentOptionsServiceCodeEnum = exports.UPSShipmentOptionsPackagingEnum = exports.UPSShipmentOptionsAlcoholRecipientTypeEnum = exports.UPSShipmentOptionsSignatureOptionSignatureTypeEnum = exports.UPSShipmentOptionsCodCollectionTypeEnum = exports.UPSShipmentOptionsCodCollectionCurrencyEnum = exports.UPSShipmentOptionsBillToPaymentTypeEnum = exports.UPSOauthRefreshStatusStatusEnum = exports.UPSImageTypes = exports.TriumphPayVendorPaymentAccountDataWithFactorCompanyChangeDocumentsPaymentTypeEnum = exports.TriumphPayVendorPaymentAccountDataPaymentTypeEnum = exports.TriumphPayVendorSyncStatusEnum = exports.TriumphPayPaymentAccountTypes = exports.TriumphPayCarrierSyncedInvoiceStatusEnum = exports.TriumphPayCarrierSyncedInvoicePaymentTypeEnum = exports.TriumphPayCarrierPaymentAccountPaymentTypeEnum = exports.TrackingSourceValues = exports.TotalWeightOverrideUnitEnum = exports.TenderStopLocationEventRequestEventTypeEnum = exports.TenderShipmentStateEventRequestStatusEnum = exports.TenderRequestWeightUnitEnum = exports.TenderRequestTemperatureUnitEnum = exports.TenderRequestShipmentStopReasonEnum = exports.TenderRequestShipmentStopAccessorialsEnum = exports.TenderRequestShipmentAccessorialsEnum = exports.TenderRequestLengthUnitEnum = exports.TenderRequestEquipmentTypeCodeEnum = exports.TenderRejectRequestRejectionCodeEnum = exports.TenderGetAllOfStatusEnum = void 0;
exports.DockSchedulingApiFactory = exports.DockSchedulingApiFp = exports.DockSchedulingApiAxiosParamCreator = exports.DevicesApi = exports.DevicesApiFactory = exports.DevicesApiFp = exports.DevicesApiAxiosParamCreator = exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.ContractsApi = exports.ContractsApiFactory = exports.ContractsApiFp = exports.ContractsApiAxiosParamCreator = exports.CompaniesApi = exports.CompaniesApiFactory = exports.CompaniesApiFp = exports.CompaniesApiAxiosParamCreator = exports.CevaApi = exports.CevaApiFactory = exports.CevaApiFp = exports.CevaApiAxiosParamCreator = exports.CarriersApi = exports.CarriersApiFactory = exports.CarriersApiFp = exports.CarriersApiAxiosParamCreator = exports.CarrierTagsApi = exports.CarrierTagsApiFactory = exports.CarrierTagsApiFp = exports.CarrierTagsApiAxiosParamCreator = exports.CarrierRelationshipsApi = exports.CarrierRelationshipsApiFactory = exports.CarrierRelationshipsApiFp = exports.CarrierRelationshipsApiAxiosParamCreator = exports.CarrierComplianceApi = exports.CarrierComplianceApiFactory = exports.CarrierComplianceApiFp = exports.CarrierComplianceApiAxiosParamCreator = exports.CarrierCapacityApi = exports.CarrierCapacityApiFactory = exports.CarrierCapacityApiFp = exports.CarrierCapacityApiAxiosParamCreator = exports.CarrierBidsApi = exports.CarrierBidsApiFactory = exports.CarrierBidsApiFp = exports.CarrierBidsApiAxiosParamCreator = exports.BillingApi = exports.BillingApiFactory = exports.BillingApiFp = void 0;
exports.MultiModeApiAxiosParamCreator = exports.LocationsApi = exports.LocationsApiFactory = exports.LocationsApiFp = exports.LocationsApiAxiosParamCreator = exports.LocateApi = exports.LocateApiFactory = exports.LocateApiFp = exports.LocateApiAxiosParamCreator = exports.LoadboardApi = exports.LoadboardApiFactory = exports.LoadboardApiFp = exports.LoadboardApiAxiosParamCreator = exports.LegsApi = exports.LegsApiFactory = exports.LegsApiFp = exports.LegsApiAxiosParamCreator = exports.InvoicingApi = exports.InvoicingApiFactory = exports.InvoicingApiFp = exports.InvoicingApiAxiosParamCreator = exports.IntegrationsApi = exports.IntegrationsApiFactory = exports.IntegrationsApiFp = exports.IntegrationsApiAxiosParamCreator = exports.InboxApi = exports.InboxApiFactory = exports.InboxApiFp = exports.InboxApiAxiosParamCreator = exports.ImportsApi = exports.ImportsApiFactory = exports.ImportsApiFp = exports.ImportsApiAxiosParamCreator = exports.FuelSurchargeRatesApi = exports.FuelSurchargeRatesApiFactory = exports.FuelSurchargeRatesApiFp = exports.FuelSurchargeRatesApiAxiosParamCreator = exports.DriversApi = exports.DriversApiFactory = exports.DriversApiFp = exports.DriversApiAxiosParamCreator = exports.DriverTextFlowApi = exports.DriverTextFlowApiFactory = exports.DriverTextFlowApiFp = exports.DriverTextFlowApiAxiosParamCreator = exports.DocumentsApi = exports.DocumentsApiFactory = exports.DocumentsApiFp = exports.DocumentsApiAxiosParamCreator = exports.DockSchedulingApi = void 0;
exports.RateConfigurationApiFactory = exports.RateConfigurationApiFp = exports.RateConfigurationApiAxiosParamCreator = exports.QuotingApi = exports.QuotingApiFactory = exports.QuotingApiFp = exports.QuotingApiAxiosParamCreator = exports.PushNotifictionsApi = exports.PushNotifictionsApiFactory = exports.PushNotifictionsApiFp = exports.PushNotifictionsApiAxiosParamCreator = exports.PushNotificationsApi = exports.PushNotificationsApiFactory = exports.PushNotificationsApiFp = exports.PushNotificationsApiAxiosParamCreator = exports.PurchaseOrdersApi = exports.PurchaseOrdersApiFactory = exports.PurchaseOrdersApiFp = exports.PurchaseOrdersApiAxiosParamCreator = exports.ProductsApi = exports.ProductsApiFactory = exports.ProductsApiFp = exports.ProductsApiAxiosParamCreator = exports.PrivateMarketApi = exports.PrivateMarketApiFactory = exports.PrivateMarketApiFp = exports.PrivateMarketApiAxiosParamCreator = exports.PoliciesApi = exports.PoliciesApiFactory = exports.PoliciesApiFp = exports.PoliciesApiAxiosParamCreator = exports.PermissionsApi = exports.PermissionsApiFactory = exports.PermissionsApiFp = exports.PermissionsApiAxiosParamCreator = exports.PaymentsApi = exports.PaymentsApiFactory = exports.PaymentsApiFp = exports.PaymentsApiAxiosParamCreator = exports.OrdersApi = exports.OrdersApiFactory = exports.OrdersApiFp = exports.OrdersApiAxiosParamCreator = exports.NotificationPreferencesApi = exports.NotificationPreferencesApiFactory = exports.NotificationPreferencesApiFp = exports.NotificationPreferencesApiAxiosParamCreator = exports.MultiModeApi = exports.MultiModeApiFactory = exports.MultiModeApiFp = void 0;
exports.ShippingDashboardApiAxiosParamCreator = exports.ShipperRelationshipApi = exports.ShipperRelationshipApiFactory = exports.ShipperRelationshipApiFp = exports.ShipperRelationshipApiAxiosParamCreator = exports.ShipperCarrierRelationshipsApi = exports.ShipperCarrierRelationshipsApiFactory = exports.ShipperCarrierRelationshipsApiFp = exports.ShipperCarrierRelationshipsApiAxiosParamCreator = exports.ShipmentsApi = exports.ShipmentsApiFactory = exports.ShipmentsApiFp = exports.ShipmentsApiAxiosParamCreator = exports.ShipmentMasterListApi = exports.ShipmentMasterListApiFactory = exports.ShipmentMasterListApiFp = exports.ShipmentMasterListApiAxiosParamCreator = exports.ShipmentActionsApi = exports.ShipmentActionsApiFactory = exports.ShipmentActionsApiFp = exports.ShipmentActionsApiAxiosParamCreator = exports.ServiceProvidersApi = exports.ServiceProvidersApiFactory = exports.ServiceProvidersApiFp = exports.ServiceProvidersApiAxiosParamCreator = exports.ServiceLevelAgreementsApi = exports.ServiceLevelAgreementsApiFactory = exports.ServiceLevelAgreementsApiFp = exports.ServiceLevelAgreementsApiAxiosParamCreator = exports.RfpOptimizedApi = exports.RfpOptimizedApiFactory = exports.RfpOptimizedApiFp = exports.RfpOptimizedApiAxiosParamCreator = exports.RfpAutomationApi = exports.RfpAutomationApiFactory = exports.RfpAutomationApiFp = exports.RfpAutomationApiAxiosParamCreator = exports.RegistrationApi = exports.RegistrationApiFactory = exports.RegistrationApiFp = exports.RegistrationApiAxiosParamCreator = exports.ReferenceDataApi = exports.ReferenceDataApiFactory = exports.ReferenceDataApiFp = exports.ReferenceDataApiAxiosParamCreator = exports.RateTablesApi = exports.RateTablesApiFactory = exports.RateTablesApiFp = exports.RateTablesApiAxiosParamCreator = exports.RateConfigurationApi = void 0;
exports.VendorRelationshipsApi = exports.VendorRelationshipsApiFactory = exports.VendorRelationshipsApiFp = exports.VendorRelationshipsApiAxiosParamCreator = exports.UsersApi = exports.UsersApiFactory = exports.UsersApiFp = exports.UsersApiAxiosParamCreator = exports.TendersApi = exports.TendersApiFactory = exports.TendersApiFp = exports.TendersApiAxiosParamCreator = exports.TasksApi = exports.TasksApiFactory = exports.TasksApiFp = exports.TasksApiAxiosParamCreator = exports.SuppliersApi = exports.SuppliersApiFactory = exports.SuppliersApiFp = exports.SuppliersApiAxiosParamCreator = exports.SpotNegotiationsApi = exports.SpotNegotiationsApiFactory = exports.SpotNegotiationsApiFp = exports.SpotNegotiationsApiAxiosParamCreator = exports.SmsApi = exports.SmsApiFactory = exports.SmsApiFp = exports.SmsApiAxiosParamCreator = exports.ShipwellUiApi = exports.ShipwellUiApiFactory = exports.ShipwellUiApiFp = exports.ShipwellUiApiAxiosParamCreator = exports.ShippingDashboardApi = exports.ShippingDashboardApiFactory = exports.ShippingDashboardApiFp = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
exports.AbstractChargeLineItemUnitAmountCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.AccessorialChargeTableAppliesToEnum = {
    CarrierSide: 'CARRIER_SIDE',
    CustomerSide: 'CUSTOMER_SIDE'
};
exports.AccessorialChargeTableLocationTypeEnum = {
    Delivery: 'DELIVERY',
    Pickup: 'PICKUP'
};
exports.AccessorialChargeTableStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
};
exports.AlertDashboardSlimCarrierRelationshipCarrierStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    DoNotUse: 'DO_NOT_USE'
};
exports.AlertEventAlertLevelEnum = {
    Alert: 'ALERT',
    Info: 'INFO'
};
exports.AlertEventResourceTypeEnum = {
    Carrier: 'carrier',
    Driver: 'driver',
    CarrierInsurance: 'carrier_insurance',
    RmisCarrierInsurance: 'rmis_carrier_insurance',
    SaferwatchCarrierInsurance: 'saferwatch_carrier_insurance',
    Shipment: 'shipment',
    Stop: 'stop'
};
exports.AlertEventSecondaryResourceTypeEnum = {
    Carrier: 'carrier',
    Driver: 'driver',
    CarrierInsurance: 'carrier_insurance',
    RmisCarrierInsurance: 'rmis_carrier_insurance',
    SaferwatchCarrierInsurance: 'saferwatch_carrier_insurance',
    Shipment: 'shipment',
    Stop: 'stop'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.AlertEventConfigurationType = {
    LatePickup: 'LATE_PICKUP',
    LateDelivery: 'LATE_DELIVERY',
    RunningLate: 'RUNNING_LATE',
    CarrierNotAssigned: 'CARRIER_NOT_ASSIGNED',
    NotTracking: 'NOT_TRACKING',
    InactiveCarrier: 'INACTIVE_CARRIER',
    TaggedShipment: 'TAGGED_SHIPMENT',
    WatchedShipment: 'WATCHED_SHIPMENT',
    ResolvedAlerts: 'RESOLVED_ALERTS',
    PowerUnitNotAssigned: 'POWER_UNIT_NOT_ASSIGNED',
    Detention: 'DETENTION',
    CarrierInsuranceExpired: 'CARRIER_INSURANCE_EXPIRED',
    TrackingAtRisk: 'TRACKING_AT_RISK',
    AppointmentRequired: 'APPOINTMENT_REQUIRED'
};
exports.AlertsDashBoardConfigurationOptionsThresholdDefinitionTypeEnum = {
    Counter: 'COUNTER',
    Tag: 'TAG'
};
exports.AutomationEventConversationStatusEnum = {
    Busy: 'busy',
    Canceled: 'canceled',
    Completed: 'completed',
    Failed: 'failed',
    InProgress: 'in-progress',
    NoAnswer: 'no-answer',
    Queued: 'queued',
    Ringing: 'ringing'
};
exports.AutomationEventResultingAlertLevelEnum = {
    High: 'HIGH',
    Medium: 'MEDIUM',
    Low: 'LOW'
};
exports.AutomationEventSourceEnum = {
    Call: 'CALL',
    Text: 'TEXT',
    Email: 'EMAIL'
};
exports.AutomationEventSubTypeEnum = {
    LocationCheckIn: 'LOCATION_CHECK_IN',
    PrePickup: 'PRE_PICKUP'
};
exports.AutomationEventTypeEnum = {
    Call: 'CALL',
    Text: 'TEXT',
    Email: 'EMAIL'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.AutomationEventSubType = {
    LocationCheckIn: 'LOCATION_CHECK_IN',
    PrePickup: 'PRE_PICKUP'
};
exports.BaseCarrierRelationshipCarrierStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    DoNotUse: 'DO_NOT_USE'
};
exports.BaseCarrierRelationshipExternalPaymentProcessorSyncStatusEnum = {
    Current: 'CURRENT',
    SyncError: 'SYNC_ERROR'
};
exports.BaseProductDescriptionHazmatPackingGroupEnum = {
    I: 'I',
    Ii: 'II',
    Iii: 'III'
};
exports.BaseProductDescriptionLengthUnitEnum = {
    Cm: 'CM',
    In: 'IN',
    Ft: 'FT',
    M: 'M'
};
exports.BaseProductDescriptionTempUnitEnum = {
    F: 'F',
    C: 'C'
};
exports.BaseProductDescriptionValuePerPieceCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.BaseProductDescriptionWeightUnitEnum = {
    Kg: 'KG',
    Lb: 'LB'
};
exports.BaseShipmentParcelPickupStatusEnum = {
    Cancelled: 'CANCELLED',
    Delayed: 'DELAYED',
    Delivered: 'DELIVERED',
    InTransit: 'IN_TRANSIT',
    NotScheduled: 'NOT_SCHEDULED',
    Scheduled: 'SCHEDULED'
};
exports.BaseShipmentPreferredCurrencyEnum = {
    Cad: 'CAD',
    Cny: 'CNY',
    Eur: 'EUR',
    Mxn: 'MXN',
    Usd: 'USD'
};
exports.BaseShipmentRailCarStatusEnum = {
    ArrivalTransitLocation: 'ARRIVAL_TRANSIT_LOCATION',
    BadOrder: 'BAD_ORDER',
    ArrivalAtDestination: 'ARRIVAL_AT_DESTINATION',
    MotorCarrierDeparture: 'MOTOR_CARRIER_DEPARTURE',
    FlatcarBadOrder: 'FLATCAR_BAD_ORDER',
    BadOrderRelease: 'BAD_ORDER_RELEASE',
    EquipmentDelayedOrHeld: 'EQUIPMENT_DELAYED_OR_HELD',
    EquipmentOfferedInInterchange: 'EQUIPMENT_OFFERED_IN_INTERCHANGE',
    InterchangeDelivery: 'INTERCHANGE_DELIVERY',
    IntermodalInterchange: 'INTERMODAL_INTERCHANGE',
    MotorCarrierArrival: 'MOTOR_CARRIER_ARRIVAL',
    MotorCarrierMove: 'MOTOR_CARRIER_MOVE',
    NoBill: 'NO_BILL',
    Departure: 'DEPARTURE',
    FlatcarBadOrderRelease: 'FLATCAR_BAD_ORDER_RELEASE',
    InterchangeReceived: 'INTERCHANGE_RECEIVED',
    Storage: 'STORAGE',
    Ramped: 'RAMPED',
    DeRamped: 'DE_RAMPED',
    Released: 'RELEASED',
    Pull: 'PULL',
    ConstructivePlacementNotify: 'CONSTRUCTIVE_PLACEMENT_NOTIFY',
    ActualPlacement: 'ACTUAL_PLACEMENT',
    Eta: 'ETA',
    LadingTransferTo: 'LADING_TRANSFER_TO',
    LadingTransferFrom: 'LADING_TRANSFER_FROM',
    ReleaseFromHoldOrMiscellaneous: 'RELEASE_FROM_HOLD_OR_MISCELLANEOUS'
};
exports.BaseShipmentTotalDeclaredValueCurrencyEnum = {
    Cad: 'CAD',
    Cny: 'CNY',
    Eur: 'EUR',
    Mxn: 'MXN',
    Usd: 'USD'
};
exports.BaseShipmentVersionEnum = {
    NUMBER_2: 2,
    NUMBER_3: 3
};
exports.BillPaymentStatusEnum = {
    DueInNumberOfDaysDays: 'Due in {Number of days} days',
    OverdueByNumberOfDaysDays: 'Overdue by {Number of days} days',
    Paid: 'Paid'
};
exports.BillProcessingStatusEnum = {
    Processing: 'PROCESSING',
    Success: 'SUCCESS',
    Error: 'ERROR'
};
exports.BillDocumentsContentTypeEnum = {
    ShipmentDocument: 'shipment document'
};
exports.BillRemitToRelationshipEnum = {
    Self: 'SELF',
    FactorCompany: 'FACTOR_COMPANY'
};
exports.BillToOverrideDirectionEnum = {
    Prepaid: 'PREPAID',
    Collect: 'COLLECT',
    _3RdParty: '3RD_PARTY'
};
exports.CarrierCapacityRecordPickupDayOfWeekEnum = {
    Monday: 'MONDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
    Thursday: 'THURSDAY',
    Friday: 'FRIDAY',
    Saturday: 'SATURDAY',
    Sunday: 'SUNDAY'
};
exports.CarrierELDProviderConnectionStatusEnum = {
    Active: 'Active',
    Inactive: 'Inactive'
};
exports.CarrierELDProviderTrackingStatusEnum = {
    Active: 'Active',
    Inactive: 'Inactive'
};
exports.CarrierExclusionRuleLinearDimensionUnitEnum = {
    Cm: 'CM',
    In: 'IN',
    Ft: 'FT',
    M: 'M'
};
exports.CarrierExclusionRuleLocationConstraintDirectionEnum = {
    Inbound: 'INBOUND',
    Outbound: 'OUTBOUND',
    Any: 'ANY'
};
exports.CarrierInsuranceInsurancePolicyTypeEnum = {
    Auto: 'auto',
    Cargo: 'cargo',
    Excess: 'excess',
    General: 'general',
    Interchange: 'interchange',
    Reefer: 'reefer',
    Umbrella: 'umbrella',
    Workers: 'workers'
};
exports.CarrierPointOfContactJobTitleEnum = {
    Admin: 'ADMIN',
    Billing: 'BILLING',
    OwnerOperator: 'OWNER_OPERATOR',
    Driver: 'DRIVER',
    Dispatcher: 'DISPATCHER',
    Other: 'OTHER'
};
exports.CarrierPointOfContactAllOfJobTitleEnum = {
    Admin: 'ADMIN',
    Billing: 'BILLING',
    OwnerOperator: 'OWNER_OPERATOR',
    Driver: 'DRIVER',
    Dispatcher: 'DISPATCHER',
    Other: 'OTHER'
};
exports.CarrierRelationshipCarrierStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    DoNotUse: 'DO_NOT_USE'
};
exports.CarrierRelationshipExternalPaymentProcessorSyncStatusEnum = {
    Current: 'CURRENT',
    SyncError: 'SYNC_ERROR'
};
exports.CarrierSelectionPageResponseCarrierStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    DoNotUse: 'DO_NOT_USE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CarrierStatus = {
    Empty: '',
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    DoNotUse: 'DO_NOT_USE'
};
exports.CarrierStatusCarrierAssignmentCarrierStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    DoNotUse: 'DO_NOT_USE'
};
exports.CarrierStatusCarrierAssignmentAllOfCarrierStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    DoNotUse: 'DO_NOT_USE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ChargeCategory = {
    Acc: 'ACC',
    Adjustment: 'ADJUSTMENT',
    Detention: 'DETENTION',
    Fsc: 'FSC',
    Fuel: 'FUEL',
    Insurance: 'INSURANCE',
    Layover: 'LAYOVER',
    Lh: 'LH',
    Other: 'OTHER',
    Sf: 'SF',
    Tax: 'TAX',
    Teamdrivers: 'TEAMDRIVERS',
    Tonu: 'TONU',
    Variance: 'VARIANCE'
};
exports.CompanyInternationalPreferencesCurrencyEnum = {
    Cad: 'CAD',
    Cny: 'CNY',
    Eur: 'EUR',
    Mxn: 'MXN',
    Usd: 'USD'
};
exports.CompanyLogoImageTypeEnum = {
    LogoColor: 'LOGO_COLOR',
    LogoWhite: 'LOGO_WHITE',
    InlineColor: 'INLINE_COLOR',
    InlineWhite: 'INLINE_WHITE'
};
exports.CompanyPreferencesCountryEnum = {
    Us: 'US',
    Ca: 'CA'
};
exports.CompanyPreferencesDefaultCarrierStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    DoNotUse: 'DO_NOT_USE'
};
exports.CompanyPreferencesExternalPushTrackingExternalIdQualifierEnum = {
    CustomerReferenceNumber: 'CUSTOMER_REFERENCE_NUMBER',
    BolNumber: 'BOL_NUMBER',
    ReferenceId: 'REFERENCE_ID',
    Name: 'NAME'
};
exports.CompanyPreferencesExternalPushTrackingProviderEnum = {
    P44: 'P44',
    FourKites: 'FOUR_KITES',
    Shippeo: 'SHIPPEO'
};
exports.ConfiguredFMSConfiguredIntegrationsNameEnum = {
    Netsuite: 'NETSUITE',
    Quickbooks: 'QUICKBOOKS'
};
exports.ContainerDetailsDemurrageIncurredCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.ContractAdditionalStopChargeFlatFeeCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.ContractAdditionalStopChargePerMileCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.ContractAdditionalStopChargesTypeEnum = {
    ChargePerAdditionalStop: 'CHARGE_PER_ADDITIONAL_STOP',
    CustomStopCharges: 'CUSTOM_STOP_CHARGES'
};
exports.ContractDistanceUnitEnum = {
    Mile: 'MILE',
    Kilometer: 'KILOMETER'
};
exports.ContractMinimumRateCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.ContractPerHourEndFieldEnum = {
    PickupDepartureTime: 'PICKUP_DEPARTURE_TIME',
    DeliveryArrivalTime: 'DELIVERY_ARRIVAL_TIME',
    DeliveryDepartureTime: 'DELIVERY_DEPARTURE_TIME'
};
exports.ContractPerHourStartFieldEnum = {
    PickupArrivalTime: 'PICKUP_ARRIVAL_TIME',
    PickupDepartureTime: 'PICKUP_DEPARTURE_TIME',
    DeliveryArrivalTime: 'DELIVERY_ARRIVAL_TIME'
};
exports.ContractRateCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.ContractRateTypeEnum = {
    PerMile: 'PER_MILE',
    PerHour: 'PER_HOUR',
    FlatRate: 'FLAT_RATE',
    RateTable: 'RATE_TABLE'
};
exports.ContractStatusEnum = {
    Active: 'ACTIVE',
    Paused: 'PAUSED',
    Suspended: 'SUSPENDED',
    Expired: 'EXPIRED'
};
exports.ContractWeightUnitEnum = {
    Ton: 'TON',
    Lb: 'LB',
    Kg: 'KG',
    Cwt: 'CWT'
};
exports.ContractAccessorialTypeEnum = {
    Pickup: 'pickup',
    Dropoff: 'dropoff',
    NonSpecific: 'non-specific',
    Guaranteed: 'guaranteed',
    ServiceLevel: 'service-level',
    InsideDelivery: 'inside-delivery',
    ExcessiveLength: 'excessive-length',
    AccessorialStatus: 'accessorial-status',
    Other: 'other'
};
exports.ContractCriteriaByShipmentRequestRequestTypeEnum = {
    ByShipment: 'BY_SHIPMENT'
};
exports.ContractCriteriaByValueRequestCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.ContractCriteriaByValueRequestModeEnum = {
    Ltl: 'LTL',
    Ftl: 'FTL',
    Vltl: 'VLTL',
    Dryage: 'DRYAGE',
    Parcel: 'PARCEL',
    Rail: 'RAIL'
};
exports.ContractCriteriaByValueRequestRequestTypeEnum = {
    ByValue: 'BY_VALUE'
};
exports.ContractCriteriaByValueRequestTotalWeightUnitEnum = {
    Lb: 'LB',
    Kg: 'KG'
};
exports.ContractRateTableBandCalculationMeasurementEnum = {
    Distance: 'DISTANCE',
    HandlingUnit: 'HANDLING_UNIT',
    Weight: 'WEIGHT'
};
exports.ContractRateTableDistanceUnitEnum = {
    Mile: 'MILE',
    Kilometer: 'KILOMETER'
};
exports.ContractRateTableRateTypeEnum = {
    PerMile: 'PER_MILE',
    PerHour: 'PER_HOUR',
    FlatRate: 'FLAT_RATE',
    RateTable: 'RATE_TABLE'
};
exports.ContractRateTableWeightUnitEnum = {
    Ton: 'TON',
    Lb: 'LB',
    Kg: 'KG',
    Cwt: 'CWT'
};
exports.ContractRateTableBandRateApplicationTypeEnum = {
    RatePerUnit: 'RATE_PER_UNIT',
    FlatRate: 'FLAT_RATE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ContractRateTypes = {
    PerMile: 'PER_MILE',
    FlatRate: 'FLAT_RATE',
    RateTable: 'RATE_TABLE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ContractStatuses = {
    Active: 'ACTIVE',
    Paused: 'PAUSED',
    Suspended: 'SUSPENDED',
    Expired: 'EXPIRED'
};
exports.CreateQuoteCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.CreateQuoteLaneTypeEnum = {
    Direct: 'DIRECT',
    Interline: 'INTERLINE',
    Unspecified: 'UNSPECIFIED'
};
exports.CreateQuoteSourceTypeEnum = {
    Instant: 'INSTANT',
    Manual: 'MANUAL',
    PrivateMarketplace: 'PRIVATE_MARKETPLACE'
};
exports.CreateShipmentTimelineEventEventSubTypeEnum = {
    AtDelivery: 'AT_DELIVERY',
    AtLocation: 'AT_LOCATION',
    AtPickup: 'AT_PICKUP',
    AtStop: 'AT_STOP',
    Canceled: 'CANCELED',
    Delayed: 'DELAYED',
    Delivered: 'DELIVERED',
    DeliveredException: 'DELIVERED_EXCEPTION',
    Delivery: 'DELIVERY',
    DeliveryAppointment: 'DELIVERY_APPOINTMENT',
    DeliveryMissed: 'DELIVERY_MISSED',
    Departed: 'DEPARTED',
    DepartedStop: 'DEPARTED_STOP',
    Departure: 'DEPARTURE',
    DepartureMissed: 'DEPARTURE_MISSED',
    Dispatched: 'DISPATCHED',
    EnRoute: 'EN_ROUTE',
    Exception: 'EXCEPTION',
    Held: 'HELD',
    InTransit: 'IN_TRANSIT',
    Info: 'INFO',
    Interline: 'INTERLINE',
    InterlineDelivered: 'INTERLINE_DELIVERED',
    InterlineMissed: 'INTERLINE_MISSED',
    OutForDelivery: 'OUT_FOR_DELIVERY',
    PickedUp: 'PICKED_UP',
    Pickup: 'PICKUP',
    PickupMissed: 'PICKUP_MISSED',
    StopCancelled: 'STOP_CANCELLED',
    StopCompleted: 'STOP_COMPLETED'
};
exports.CreateShipmentTimelineEventEventTypeEnum = {
    AtDelivery: 'AT_DELIVERY',
    AtPickup: 'AT_PICKUP',
    Booked: 'BOOKED',
    Cancelled: 'CANCELLED',
    CarrierMatched: 'CARRIER_MATCHED',
    Delivered: 'DELIVERED',
    DetailsChanged: 'DETAILS_CHANGED',
    Dispatched: 'DISPATCHED',
    DriverAssigned: 'DRIVER_ASSIGNED',
    EtaChanged: 'ETA_CHANGED',
    Info: 'INFO',
    LocationUpdated: 'LOCATION_UPDATED',
    PickedUp: 'PICKED_UP',
    TrackReceived: 'TRACK_RECEIVED',
    StopCompleted: 'STOP_COMPLETED',
    StopEvent: 'STOP_EVENT'
};
exports.CreateSpotNegotiationQuoteCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.CreateSpotNegotiationQuoteLaneTypeEnum = {
    Direct: 'DIRECT',
    Interline: 'INTERLINE',
    Unspecified: 'UNSPECIFIED'
};
exports.CreateSpotNegotiationQuoteSourceTypeEnum = {
    Instant: 'INSTANT',
    Manual: 'MANUAL',
    PrivateMarketplace: 'PRIVATE_MARKETPLACE'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.CreatedBySourceTypeEnum = {
    ShipwellWeb: 'SHIPWELL_WEB',
    Import: 'IMPORT',
    Tender: 'TENDER',
    ShipwellWebUnauth: 'SHIPWELL_WEB_UNAUTH',
    Other: 'OTHER'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CurrencyCode = {
    Cad: 'CAD',
    Cny: 'CNY',
    Eur: 'EUR',
    Mxn: 'MXN',
    Usd: 'USD'
};
exports.CustomFieldEntityTypesEnum = {
    PurchaseOrder: 'purchase_order',
    PurchaseOrderLineItem: 'purchase_order_line_item',
    PurchaseOrderStop: 'purchase_order_stop',
    Shipment: 'shipment',
    Customer: 'customer',
    ShipmentLineItem: 'shipment_line_item',
    ShipmentStop: 'shipment_stop',
    ShipmentChargeLineItem: 'shipment_charge_line_item'
};
exports.CustomFieldFieldTypeEnum = {
    String: 'STRING',
    Boolean: 'BOOLEAN',
    Datetime: 'DATETIME',
    Selection: 'SELECTION'
};
exports.DevicePlatformEnum = {
    IOs: 'iOS',
    Android: 'ANDROID'
};
exports.DispatchJobStatusEnum = {
    Processing: 'PROCESSING',
    Success: 'SUCCESS',
    Error: 'ERROR',
    Canceled: 'CANCELED',
    CancelError: 'CANCEL_ERROR'
};
exports.DriverPlatformEnum = {
    IOs: 'iOS',
    Android: 'ANDROID'
};
exports.DriverLogLogTypeEnum = {
    AppInstalled: 'APP_INSTALLED',
    AppOpened: 'APP_OPENED',
    Tracking: 'TRACKING',
    SignIn: 'SIGN_IN',
    SignOut: 'SIGN_OUT',
    AppInstallRequestSent: 'APP_INSTALL_REQUEST_SENT'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DriverPushNotificationTypesEnum = {
    NewMessage: 'new_message',
    UpcomingPickup: 'upcoming_pickup',
    StopCompletion: 'stop_completion',
    TrackingRequest: 'tracking_request'
};
exports.EIAFuelRateEiaFuelPricingAreaEnum = {
    Us: 'US',
    EastCoast: 'EAST_COAST',
    NewEngland: 'NEW_ENGLAND',
    CentralAtlantic: 'CENTRAL_ATLANTIC',
    LowerAtlantic: 'LOWER_ATLANTIC',
    Midwest: 'MIDWEST',
    GulfCoast: 'GULF_COAST',
    RockyMountain: 'ROCKY_MOUNTAIN',
    WestCoast: 'WEST_COAST',
    WestCoastLessCalifornia: 'WEST_COAST_LESS_CALIFORNIA',
    California: 'CALIFORNIA'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ELDDriverStatus = {
    Driving: 'driving',
    OffDutyNotDriving: 'off_duty_not_driving',
    OffDuty: 'off_duty',
    Sleeper: 'sleeper'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ELDProvider = {
    Eroad: 'eroad',
    Fleetmatics: 'fleetmatics',
    Fleetup: 'fleetup',
    Geotab: 'geotab',
    Ise: 'ise',
    Jjkeller: 'jjkeller',
    KeepTruckin: 'keep_truckin',
    OmnitracsVlv: 'omnitracs_vlv',
    Peoplenet: 'peoplenet',
    Samsara: 'samsara',
    Teletrac: 'teletrac',
    Zonar: 'zonar'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.EquipmentEnum = {
    AutoCarrier: 'AUTO_CARRIER',
    Autohauler: 'AUTOHAULER',
    BTrain: 'B_TRAIN',
    Bulk: 'BULK',
    Conestoga: 'CONESTOGA',
    Container: 'CONTAINER',
    ContainerBreakBulk: 'CONTAINER_BREAK_BULK',
    ContainerStandard20Foot: 'CONTAINER_STANDARD_20_FOOT',
    ContainerStandard40Foot: 'CONTAINER_STANDARD_40_FOOT',
    ContainerFlatTrack20Foot: 'CONTAINER_FLAT_TRACK_20_FOOT',
    ContainerFlatTrack40Foot: 'CONTAINER_FLAT_TRACK_40_FOOT',
    ContainerHeavyTested20Foot: 'CONTAINER_HEAVY_TESTED_20_FOOT',
    ContainerHighCube40Foot: 'CONTAINER_HIGH_CUBE_40_FOOT',
    ContainerHighCube45Foot: 'CONTAINER_HIGH_CUBE_45_FOOT',
    ContainerInsulated: 'CONTAINER_INSULATED',
    ContainerIsoTank20Foot: 'CONTAINER_ISO_TANK_20_FOOT',
    ContainerIsoTank24Foot: 'CONTAINER_ISO_TANK_24_FOOT',
    ContainerIsoTank40Foot: 'CONTAINER_ISO_TANK_40_FOOT',
    ContainerOpenTop20Foot: 'CONTAINER_OPEN_TOP_20_FOOT',
    ContainerOpenTop40Foot: 'CONTAINER_OPEN_TOP_40_FOOT',
    ContainerReefer20Foot: 'CONTAINER_REEFER_20_FOOT',
    ContainerReefer40Foot: 'CONTAINER_REEFER_40_FOOT',
    ContainerRefrigerated: 'CONTAINER_REFRIGERATED',
    Conveyor: 'CONVEYOR',
    CurtainSide: 'CURTAIN_SIDE',
    DoubleDrop: 'DOUBLE_DROP',
    DropDeck: 'DROP_DECK',
    DropDeckLandoll: 'DROP_DECK_LANDOLL',
    DryVan: 'DRY_VAN',
    DumpTrailer: 'DUMP_TRAILER',
    Flatbed: 'FLATBED',
    Flatbed53Foot: 'FLATBED_53_FOOT',
    FlatbedAirRide: 'FLATBED_AIR_RIDE',
    FlatbedConestoga: 'FLATBED_CONESTOGA',
    FlatbedDouble: 'FLATBED_DOUBLE',
    FlatbedHotshot: 'FLATBED_HOTSHOT',
    FlatbedMaxi: 'FLATBED_MAXI',
    FlatbedOverdimension: 'FLATBED_OVERDIMENSION',
    Hopper: 'HOPPER',
    HopperBottom: 'HOPPER_BOTTOM',
    InsulatedVan: 'INSULATED_VAN',
    Lowboy: 'LOWBOY',
    LowboyOverdimension: 'LOWBOY_OVERDIMENSION',
    MovingVan: 'MOVING_VAN',
    Other: 'OTHER',
    Pneumatic: 'PNEUMATIC',
    PowerOnly: 'POWER_ONLY',
    Reefer: 'REEFER',
    ReeferAirRide: 'REEFER_AIR_RIDE',
    ReeferDouble: 'REEFER_DOUBLE',
    ReeferIntermodal: 'REEFER_INTERMODAL',
    RemovableGooseneck: 'REMOVABLE_GOOSENECK',
    StepDeck: 'STEP_DECK',
    StepdeckConestoga: 'STEPDECK_CONESTOGA',
    StraightBoxTruck: 'STRAIGHT_BOX_TRUCK',
    StretchTrailer: 'STRETCH_TRAILER',
    Tanker: 'TANKER',
    TankerAluminum: 'TANKER_ALUMINUM',
    TankerIntermodal: 'TANKER_INTERMODAL',
    TankerSteel: 'TANKER_STEEL',
    Tilt: 'TILT',
    TruckAndTrailer: 'TRUCK_AND_TRAILER',
    VanAirRide: 'VAN_AIR_RIDE',
    VanDouble: 'VAN_DOUBLE',
    VanInsulated: 'VAN_INSULATED',
    VanIntermodal: 'VAN_INTERMODAL',
    VanOpenTop: 'VAN_OPEN_TOP',
    VanRollerBed: 'VAN_ROLLER_BED',
    VanSprinter: 'VAN_SPRINTER',
    VanTriple: 'VAN_TRIPLE',
    VanVented: 'VAN_VENTED',
    VanWithCurtains: 'VAN_WITH_CURTAINS',
    Container53Foot: 'CONTAINER_53_FOOT',
    HalfTonTruck: 'HALF_TON_TRUCK',
    OneTonTruck: 'ONE_TON_TRUCK',
    MiniFloatTrailerAndTruck: 'MINI_FLOAT_TRAILER_AND_TRUCK',
    Towing: 'TOWING',
    Conestoga48: 'CONESTOGA_48',
    Conestoga53: 'CONESTOGA_53',
    FlatbedConestoga48: 'FLATBED_CONESTOGA_48',
    FlatbedConestoga53: 'FLATBED_CONESTOGA_53',
    StepdeckConestoga48: 'STEPDECK_CONESTOGA_48',
    StepdeckConestoga53: 'STEPDECK_CONESTOGA_53',
    CoFlatbed: 'CO_FLATBED',
    CoStakeBed: 'CO_STAKE_BED',
    Tiltbed48Wench: 'TILTBED_48_WENCH',
    WreckerTiltbed: 'WRECKER_TILTBED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.EquipmentTypeValues = {
    Aircraft: 'AIRCRAFT',
    Autohauler: 'AUTOHAULER',
    AutoCarrier: 'AUTO_CARRIER',
    AutoMax: 'AUTO_MAX',
    AutoRackBiLevel: 'AUTO_RACK_BI_LEVEL',
    AutoRackTriLevel: 'AUTO_RACK_TRI_LEVEL',
    Boxcar: 'BOXCAR',
    Bulk: 'BULK',
    BulkheadFlatcar: 'BULKHEAD_FLATCAR',
    BTrain: 'B_TRAIN',
    CargoVan: 'CARGO_VAN',
    CenterbeamFlatcar: 'CENTERBEAM_FLATCAR',
    ChainTieDownFlatcar: 'CHAIN_TIE_DOWN_FLATCAR',
    CoalCar: 'COAL_CAR',
    CoilSteelRailcar: 'COIL_STEEL_RAILCAR',
    Conestoga: 'CONESTOGA',
    Conestoga48: 'CONESTOGA_48',
    Conestoga53: 'CONESTOGA_53',
    Container: 'CONTAINER',
    Container53Foot: 'CONTAINER_53_FOOT',
    ContainerBreakBulk: 'CONTAINER_BREAK_BULK',
    ContainerFlatTrack20Foot: 'CONTAINER_FLAT_TRACK_20_FOOT',
    ContainerFlatTrack40Foot: 'CONTAINER_FLAT_TRACK_40_FOOT',
    ContainerHeavyTested20Foot: 'CONTAINER_HEAVY_TESTED_20_FOOT',
    ContainerHighCube20Foot: 'CONTAINER_HIGH_CUBE_20_FOOT',
    ContainerHighCube40Foot: 'CONTAINER_HIGH_CUBE_40_FOOT',
    ContainerHighCube45Foot: 'CONTAINER_HIGH_CUBE_45_FOOT',
    ContainerInsulated: 'CONTAINER_INSULATED',
    ContainerIsoTank20Foot: 'CONTAINER_ISO_TANK_20_FOOT',
    ContainerIsoTank24Foot: 'CONTAINER_ISO_TANK_24_FOOT',
    ContainerIsoTank40Foot: 'CONTAINER_ISO_TANK_40_FOOT',
    ContainerOpenTop20Foot: 'CONTAINER_OPEN_TOP_20_FOOT',
    ContainerOpenTop40Foot: 'CONTAINER_OPEN_TOP_40_FOOT',
    ContainerOversize: 'CONTAINER_OVERSIZE',
    ContainerReefer20Foot: 'CONTAINER_REEFER_20_FOOT',
    ContainerReefer40Foot: 'CONTAINER_REEFER_40_FOOT',
    ContainerReeferTank20Foot: 'CONTAINER_REEFER_TANK_20_FOOT',
    ContainerRefrigerated: 'CONTAINER_REFRIGERATED',
    ContainerStandard20Foot: 'CONTAINER_STANDARD_20_FOOT',
    ContainerStandard40Foot: 'CONTAINER_STANDARD_40_FOOT',
    Conveyor: 'CONVEYOR',
    CoveredCoilRailcar: 'COVERED_COIL_RAILCAR',
    CoveredHopper: 'COVERED_HOPPER',
    CoFlatbed: 'CO_FLATBED',
    CoStakeBed: 'CO_STAKE_BED',
    CryoRailcar: 'CRYO_RAILCAR',
    CurtainSide: 'CURTAIN_SIDE',
    CustomerPickup: 'CUSTOMER_PICKUP',
    DoubleDrop: 'DOUBLE_DROP',
    Driveaway: 'DRIVEAWAY',
    DropDeck: 'DROP_DECK',
    DropDeckLandoll: 'DROP_DECK_LANDOLL',
    DropTrailer: 'DROP_TRAILER',
    DryBulkTanker: 'DRY_BULK_TANKER',
    DryVan: 'DRY_VAN',
    DumpTrailer: 'DUMP_TRAILER',
    Flatbed: 'FLATBED',
    Flatbed53Foot: 'FLATBED_53_FOOT',
    FlatbedAirRide: 'FLATBED_AIR_RIDE',
    FlatbedConestoga: 'FLATBED_CONESTOGA',
    FlatbedConestoga48: 'FLATBED_CONESTOGA_48',
    FlatbedConestoga53: 'FLATBED_CONESTOGA_53',
    FlatbedDouble: 'FLATBED_DOUBLE',
    FlatbedHotshot: 'FLATBED_HOTSHOT',
    FlatbedMaxi: 'FLATBED_MAXI',
    FlatbedOverdimension: 'FLATBED_OVERDIMENSION',
    FourAxleHeavyHaulTrailer: 'FOUR_AXLE_HEAVY_HAUL_TRAILER',
    Gondola: 'GONDOLA',
    HalfTonTruck: 'HALF_TON_TRUCK',
    Hopper: 'HOPPER',
    HopperBottom: 'HOPPER_BOTTOM',
    InsulatedVan: 'INSULATED_VAN',
    LiquidBulkTanker: 'LIQUID_BULK_TANKER',
    Lowboy: 'LOWBOY',
    LowboyOverdimension: 'LOWBOY_OVERDIMENSION',
    MiniFloatTrailerAndTruck: 'MINI_FLOAT_TRAILER_AND_TRUCK',
    MiniVan: 'MINI_VAN',
    MovingVan: 'MOVING_VAN',
    MultiCompartment: 'MULTI_COMPARTMENT',
    OneTonTruck: 'ONE_TON_TRUCK',
    OpenTopHopper: 'OPEN_TOP_HOPPER',
    Other: 'OTHER',
    PipeFlatcar: 'PIPE_FLATCAR',
    Pneumatic: 'PNEUMATIC',
    PowerOnly: 'POWER_ONLY',
    Reefer: 'REEFER',
    ReeferAirRide: 'REEFER_AIR_RIDE',
    ReeferDouble: 'REEFER_DOUBLE',
    ReeferIntermodal: 'REEFER_INTERMODAL',
    RefrigeratedBoxcar: 'REFRIGERATED_BOXCAR',
    RemovableGooseneck: 'REMOVABLE_GOOSENECK',
    Sedan: 'SEDAN',
    StepdeckConestoga: 'STEPDECK_CONESTOGA',
    StepdeckConestoga48: 'STEPDECK_CONESTOGA_48',
    StepdeckConestoga53: 'STEPDECK_CONESTOGA_53',
    StepDeck: 'STEP_DECK',
    StraightBoxTruck: 'STRAIGHT_BOX_TRUCK',
    StretchTrailer: 'STRETCH_TRAILER',
    Tanker: 'TANKER',
    TankerAluminum: 'TANKER_ALUMINUM',
    TankerIntermodal: 'TANKER_INTERMODAL',
    TankerSteel: 'TANKER_STEEL',
    TboxRailcar: 'TBOX_RAILCAR',
    TempControlledTrailer: 'TEMP_CONTROLLED_TRAILER',
    Tilt: 'TILT',
    Tiltbed48Wench: 'TILTBED_48_WENCH',
    Towing: 'TOWING',
    Trailer: 'TRAILER',
    TruckAndTrailer: 'TRUCK_AND_TRAILER',
    VanAirRide: 'VAN_AIR_RIDE',
    VanDouble: 'VAN_DOUBLE',
    VanInsulated: 'VAN_INSULATED',
    VanIntermodal: 'VAN_INTERMODAL',
    VanOpenTop: 'VAN_OPEN_TOP',
    VanRollerBed: 'VAN_ROLLER_BED',
    VanSprinter: 'VAN_SPRINTER',
    VanTriple: 'VAN_TRIPLE',
    VanVented: 'VAN_VENTED',
    VanWithCurtains: 'VAN_WITH_CURTAINS',
    WreckerTiltbed: 'WRECKER_TILTBED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ExtendedELDProvider = {
    Eroad: 'eroad',
    Fleetmatics: 'fleetmatics',
    Fleetup: 'fleetup',
    Geotab: 'geotab',
    Ise: 'ise',
    Jjkeller: 'jjkeller',
    KeepTruckin: 'keep_truckin',
    OmnitracsVlv: 'omnitracs_vlv',
    Peoplenet: 'peoplenet',
    Samsara: 'samsara',
    Teletrac: 'teletrac',
    Zonar: 'zonar',
    Other: 'other'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.FedExImageTypes = {
    Epl2: 'EPL2',
    Pdf: 'PDF',
    Zplii: 'ZPLII'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.FedExStockTypes = {
    Paper4X6: 'PAPER_4X6',
    Paper4X675: 'PAPER_4X6.75',
    Paper4X8: 'PAPER_4X8',
    Paper4X9: 'PAPER_4X9',
    Paper7X475: 'PAPER_7X4.75',
    Paper85X11BottomHalfLabel: 'PAPER_8.5X11_BOTTOM_HALF_LABEL',
    Paper85X11TopHalfLabel: 'PAPER_8.5X11_TOP_HALF_LABEL',
    Stock4X6: 'STOCK_4X6',
    Stock4X675LeadingDocTab: 'STOCK_4X6.75_LEADING_DOC_TAB',
    Stock4X675TrailingDocTab: 'STOCK_4X6.75_TRAILING_DOC_TAB',
    Stock4X8: 'STOCK_4X8',
    Stock4X9: 'STOCK_4X9',
    Stock4X9LeadingDocTab: 'STOCK_4X9_LEADING_DOC_TAB',
    Stock4X9TrailingDocTab: 'STOCK_4X9_TRAILING_DOC_TAB'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.FedexLabelDataHeaders = {
    CustomerReferenceNumber: 'CUSTOMER_REFERENCE_NUMBER',
    ShipDate: 'SHIP_DATE',
    ServiceType: 'SERVICE_TYPE',
    ShipWeight: 'SHIP_WEIGHT',
    PoNumber: 'PO_NUMBER',
    TrackingNumber: 'TRACKING_NUMBER'
};
exports.FedexShipmentOptionsBillToPaymentTypeEnum = {
    Collect: 'COLLECT',
    Recipient: 'RECIPIENT',
    Sender: 'SENDER',
    ThirdParty: 'THIRD_PARTY'
};
exports.FedexShipmentOptionsCodCollectionCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.FedexShipmentOptionsCodCollectionTypeEnum = {
    Any: 'ANY',
    CompanyCheck: 'COMPANY_CHECK',
    GuaranteedFunds: 'GUARANTEED_FUNDS',
    PersonalCheck: 'PERSONAL_CHECK'
};
exports.FedexShipmentOptionsSignatureOptionSignatureTypeEnum = {
    AdultSignature: 'ADULT_SIGNATURE',
    DirectSignature: 'DIRECT_SIGNATURE',
    NoSignature: 'NO_SIGNATURE',
    IndirectSignature: 'INDIRECT_SIGNATURE',
    ServiceDefault: 'SERVICE_DEFAULT'
};
exports.FedexShipmentOptionsAlcoholRecipientTypeEnum = {
    Consumer: 'CONSUMER',
    Licensee: 'LICENSEE'
};
exports.FedexShipmentOptionsBatteryMaterialTypeEnum = {
    Ion: 'LITHIUM_ION',
    Metal: 'LITHIUM_METAL'
};
exports.FedexShipmentOptionsBatteryPackagingTypeEnum = {
    ContainedInEquipment: 'CONTAINED_IN_EQUIPMENT',
    PackedWithEquipment: 'PACKED_WITH_EQUIPMENT'
};
exports.FedexShipmentOptionsDropoffTypeEnum = {
    RegularPickup: 'REGULAR_PICKUP',
    Station: 'STATION',
    RequestCourier: 'REQUEST_COURIER',
    BusinessServiceCenter: 'BUSINESS_SERVICE_CENTER',
    DropBox: 'DROP_BOX'
};
exports.FedexShipmentOptionsHomeDeliveryTypeEnum = {
    Appointment: 'APPOINTMENT',
    DateCertain: 'DATE_CERTAIN',
    Evening: 'EVENING'
};
exports.FedexShipmentOptionsPackagingEnum = {
    Fedex10KgBox: 'FEDEX_10KG_BOX',
    Fedex25KgBox: 'FEDEX_25KG_BOX',
    FedexEnvelope: 'FEDEX_ENVELOPE',
    FedexPak: 'FEDEX_PAK',
    FedexSmallBox: 'FEDEX_SMALL_BOX',
    FedexMediumBox: 'FEDEX_MEDIUM_BOX',
    FedexLargeBox: 'FEDEX_LARGE_BOX',
    FedexExtraLargeBox: 'FEDEX_EXTRA_LARGE_BOX',
    FedexTube: 'FEDEX_TUBE',
    FedexBox: 'FEDEX_BOX',
    YourPackaging: 'YOUR_PACKAGING'
};
exports.FedexShipmentOptionsServiceCodeEnum = {
    Fedex1DayFreight: 'FEDEX_1_DAY_FREIGHT',
    Fedex2Day: 'FEDEX_2_DAY',
    Fedex2DayAm: 'FEDEX_2_DAY_AM',
    Fedex2DayFreight: 'FEDEX_2_DAY_FREIGHT',
    Fedex3DayFreight: 'FEDEX_3_DAY_FREIGHT',
    FedexExpressSaver: 'FEDEX_EXPRESS_SAVER',
    FedexFirstFreight: 'FEDEX_FIRST_FREIGHT',
    FedexFreightEconomy: 'FEDEX_FREIGHT_ECONOMY',
    FedexFreightPriority: 'FEDEX_FREIGHT_PRIORITY',
    FedexGround: 'FEDEX_GROUND',
    FirstOvernight: 'FIRST_OVERNIGHT',
    GroundHomeDelivery: 'GROUND_HOME_DELIVERY',
    InternationalEconomy: 'INTERNATIONAL_ECONOMY',
    InternationalEconomyFreight: 'INTERNATIONAL_ECONOMY_FREIGHT',
    InternationalFirst: 'INTERNATIONAL_FIRST',
    InternationalPriority: 'INTERNATIONAL_PRIORITY',
    InternationalPriorityExpress: 'INTERNATIONAL_PRIORITY_EXPRESS',
    InternationalPriorityFreight: 'INTERNATIONAL_PRIORITY_FREIGHT',
    PriorityOvernight: 'PRIORITY_OVERNIGHT',
    SmartPost: 'SMART_POST',
    StandardOvernight: 'STANDARD_OVERNIGHT',
    EuropeFirstInternationalPriority: 'EUROPE_FIRST_INTERNATIONAL_PRIORITY',
    FedexDistanceDeferred: 'FEDEX_DISTANCE_DEFERRED',
    FedexNextDayAfternoon: 'FEDEX_NEXT_DAY_AFTERNOON',
    FedexNextDayEarlyMorning: 'FEDEX_NEXT_DAY_EARLY_MORNING',
    FedexNextDayEndOfDay: 'FEDEX_NEXT_DAY_END_OF_DAY',
    FedexNextDayFreight: 'FEDEX_NEXT_DAY_FREIGHT',
    FedexNextDayMidMorning: 'FEDEX_NEXT_DAY_MID_MORNING',
    SameDay: 'SAME_DAY',
    SameDayCity: 'SAME_DAY_CITY',
    FedexInternationalPriority: 'FEDEX_INTERNATIONAL_PRIORITY'
};
exports.FedexShipmentOptionsSmartPostIndiciaTypeEnum = {
    MediaMail: 'MEDIA_MAIL',
    ParcelSelect: 'PARCEL_SELECT',
    PresortedBoundPrintedMatter: 'PRESORTED_BOUND_PRINTED_MATTER',
    PresortedStandard: 'PRESORTED_STANDARD',
    ParcelReturn: 'PARCEL_RETURN'
};
exports.FedexShipmentOptionsAllOfAlcoholRecipientTypeEnum = {
    Consumer: 'CONSUMER',
    Licensee: 'LICENSEE'
};
exports.FedexShipmentOptionsAllOfBatteryMaterialTypeEnum = {
    Ion: 'LITHIUM_ION',
    Metal: 'LITHIUM_METAL'
};
exports.FedexShipmentOptionsAllOfBatteryPackagingTypeEnum = {
    ContainedInEquipment: 'CONTAINED_IN_EQUIPMENT',
    PackedWithEquipment: 'PACKED_WITH_EQUIPMENT'
};
exports.FedexShipmentOptionsAllOfDropoffTypeEnum = {
    RegularPickup: 'REGULAR_PICKUP',
    Station: 'STATION',
    RequestCourier: 'REQUEST_COURIER',
    BusinessServiceCenter: 'BUSINESS_SERVICE_CENTER',
    DropBox: 'DROP_BOX'
};
exports.FedexShipmentOptionsAllOfHomeDeliveryTypeEnum = {
    Appointment: 'APPOINTMENT',
    DateCertain: 'DATE_CERTAIN',
    Evening: 'EVENING'
};
exports.FedexShipmentOptionsAllOfPackagingEnum = {
    Fedex10KgBox: 'FEDEX_10KG_BOX',
    Fedex25KgBox: 'FEDEX_25KG_BOX',
    FedexEnvelope: 'FEDEX_ENVELOPE',
    FedexPak: 'FEDEX_PAK',
    FedexSmallBox: 'FEDEX_SMALL_BOX',
    FedexMediumBox: 'FEDEX_MEDIUM_BOX',
    FedexLargeBox: 'FEDEX_LARGE_BOX',
    FedexExtraLargeBox: 'FEDEX_EXTRA_LARGE_BOX',
    FedexTube: 'FEDEX_TUBE',
    FedexBox: 'FEDEX_BOX',
    YourPackaging: 'YOUR_PACKAGING'
};
exports.FedexShipmentOptionsAllOfServiceCodeEnum = {
    Fedex1DayFreight: 'FEDEX_1_DAY_FREIGHT',
    Fedex2Day: 'FEDEX_2_DAY',
    Fedex2DayAm: 'FEDEX_2_DAY_AM',
    Fedex2DayFreight: 'FEDEX_2_DAY_FREIGHT',
    Fedex3DayFreight: 'FEDEX_3_DAY_FREIGHT',
    FedexExpressSaver: 'FEDEX_EXPRESS_SAVER',
    FedexFirstFreight: 'FEDEX_FIRST_FREIGHT',
    FedexFreightEconomy: 'FEDEX_FREIGHT_ECONOMY',
    FedexFreightPriority: 'FEDEX_FREIGHT_PRIORITY',
    FedexGround: 'FEDEX_GROUND',
    FirstOvernight: 'FIRST_OVERNIGHT',
    GroundHomeDelivery: 'GROUND_HOME_DELIVERY',
    InternationalEconomy: 'INTERNATIONAL_ECONOMY',
    InternationalEconomyFreight: 'INTERNATIONAL_ECONOMY_FREIGHT',
    InternationalFirst: 'INTERNATIONAL_FIRST',
    InternationalPriority: 'INTERNATIONAL_PRIORITY',
    InternationalPriorityExpress: 'INTERNATIONAL_PRIORITY_EXPRESS',
    InternationalPriorityFreight: 'INTERNATIONAL_PRIORITY_FREIGHT',
    PriorityOvernight: 'PRIORITY_OVERNIGHT',
    SmartPost: 'SMART_POST',
    StandardOvernight: 'STANDARD_OVERNIGHT',
    EuropeFirstInternationalPriority: 'EUROPE_FIRST_INTERNATIONAL_PRIORITY',
    FedexDistanceDeferred: 'FEDEX_DISTANCE_DEFERRED',
    FedexNextDayAfternoon: 'FEDEX_NEXT_DAY_AFTERNOON',
    FedexNextDayEarlyMorning: 'FEDEX_NEXT_DAY_EARLY_MORNING',
    FedexNextDayEndOfDay: 'FEDEX_NEXT_DAY_END_OF_DAY',
    FedexNextDayFreight: 'FEDEX_NEXT_DAY_FREIGHT',
    FedexNextDayMidMorning: 'FEDEX_NEXT_DAY_MID_MORNING',
    SameDay: 'SAME_DAY',
    SameDayCity: 'SAME_DAY_CITY',
    FedexInternationalPriority: 'FEDEX_INTERNATIONAL_PRIORITY'
};
exports.FedexShipmentOptionsAllOfSmartPostIndiciaTypeEnum = {
    MediaMail: 'MEDIA_MAIL',
    ParcelSelect: 'PARCEL_SELECT',
    PresortedBoundPrintedMatter: 'PRESORTED_BOUND_PRINTED_MATTER',
    PresortedStandard: 'PRESORTED_STANDARD',
    ParcelReturn: 'PARCEL_RETURN'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.FreightClass = {
    _50: '50',
    _55: '55',
    _60: '60',
    _65: '65',
    _70: '70',
    _775: '77.5',
    _85: '85',
    _925: '92.5',
    _100: '100',
    _110: '110',
    _125: '125',
    _150: '150',
    _175: '175',
    _200: '200',
    _250: '250',
    _300: '300',
    _400: '400',
    _500: '500'
};
exports.FreightInvoiceBillToEntityTypeEnum = {
    Individual: 'INDIVIDUAL',
    Company: 'COMPANY'
};
exports.FreightInvoiceDocumentMetadataDocumentTypeEnum = {
    Bol: 'BOL',
    Fuel: 'FUEL',
    Lumper: 'LUMPER',
    Hos: 'HOS',
    Signature: 'SIGNATURE',
    RateConfirmation: 'RATE_CONFIRMATION',
    CustomerTender: 'CUSTOMER_TENDER',
    DeliveryReceipt: 'DELIVERY_RECEIPT',
    WeightCertificate: 'WEIGHT_CERTIFICATE',
    OveragesShortagesAndDamages: 'OVERAGES_SHORTAGES_AND_DAMAGES',
    RenditionInvoicePacket: 'RENDITION_INVOICE_PACKET',
    InventoryRelease: 'INVENTORY_RELEASE',
    Invoice: 'INVOICE',
    Insurance: 'INSURANCE',
    ShippingLabel: 'SHIPPING_LABEL',
    CustomsPaperwork: 'CUSTOMS_PAPERWORK',
    PackingSlips: 'PACKING_SLIPS',
    CarrierInvoiceOrBillingStatement: 'CARRIER_INVOICE_OR_BILLING_STATEMENT',
    CustomerInvoice: 'CUSTOMER_INVOICE',
    DeliveryOrder: 'DELIVERY_ORDER',
    FactorInvoiceOrBillingStatement: 'FACTOR_INVOICE_OR_BILLING_STATEMENT',
    LetterOfAssignment: 'LETTER_OF_ASSIGNMENT',
    NmfcCertificate: 'NMFC_CERTIFICATE',
    NoticeOfAssignment: 'NOTICE_OF_ASSIGNMENT',
    NoticeOfRelease: 'NOTICE_OF_RELEASE',
    PackingSlip: 'PACKING_SLIP',
    AdvanceRequest: 'ADVANCE_REQUEST',
    DriverForm: 'DRIVER_FORM',
    TollReceipt: 'TOLL_RECEIPT',
    ExitPass: 'EXIT_PASS',
    WashReceipt: 'WASH_RECEIPT',
    DetentionApproval: 'DETENTION_APPROVAL',
    Fine: 'FINE',
    W9: 'W9',
    Authority: 'AUTHORITY',
    Claim: 'CLAIM',
    Comcheck: 'COMCHECK',
    MasterBillOfLading: 'MASTER_BILL_OF_LADING',
    HouseBillOfLading: 'HOUSE_BILL_OF_LADING',
    Waybill: 'WAYBILL',
    CommercialInvoice: 'COMMERCIAL_INVOICE',
    CertificateOfOrigin: 'CERTIFICATE_OF_ORIGIN',
    InspectionCertificate: 'INSPECTION_CERTIFICATE',
    WeightTicketUnloaded: 'WEIGHT_TICKET_UNLOADED',
    PalletReceipt: 'PALLET_RECEIPT',
    HouseAirwayBill: 'HOUSE_AIRWAY_BILL',
    MasterAirwayBill: 'MASTER_AIRWAY_BILL',
    CustomsClearanceRequest: 'CUSTOMS_CLEARANCE_REQUEST',
    CustomsEntrySummary: 'CUSTOMS_ENTRY_SUMMARY',
    Other: 'OTHER'
};
exports.FreightInvoiceProductLineItemsPackagingEnum = {
    Bag: 'BAG',
    Bale: 'BALE',
    Bin: 'BIN',
    Bottle: 'BOTTLE',
    Box: 'BOX',
    Bucket: 'BUCKET',
    Pail: 'PAIL',
    Bundle: 'BUNDLE',
    Can: 'CAN',
    Carton: 'CARTON',
    Case: 'CASE',
    Coil: 'COIL',
    Crate: 'CRATE',
    Cylinder: 'CYLINDER',
    Drum: 'DRUM',
    Jerrican: 'JERRICAN',
    Package: 'PACKAGE',
    Pieces: 'PIECES',
    Reel: 'REEL',
    Roll: 'ROLL',
    Skid: 'SKID',
    Tube: 'TUBE',
    Container: 'CONTAINER',
    Barrel: 'BARREL',
    Basket: 'BASKET',
    Envelope: 'ENVELOPE',
    Hamper: 'HAMPER',
    None: 'NONE',
    Other: 'OTHER',
    Pallet: 'PALLET',
    Piece: 'PIECE',
    Tank: 'TANK',
    ToteBin: 'TOTE_BIN',
    ToteCan: 'TOTE_CAN',
    FloorLoaded: 'FLOOR_LOADED',
    Unit: 'UNIT'
};
exports.FreightInvoiceRemitToEntityTypeEnum = {
    Individual: 'INDIVIDUAL',
    Company: 'COMPANY'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.FreightInvoiceStatus = {
    Received: 'RECEIVED',
    Passed: 'PASSED',
    Exception: 'EXCEPTION',
    Approved: 'APPROVED',
    Scheduled: 'SCHEDULED',
    Paid: 'PAID',
    Voided: 'VOIDED',
    Rejected: 'REJECTED',
    Reviewing: 'REVIEWING',
    Pending: 'PENDING',
    Disputed: 'DISPUTED',
    Resolved: 'RESOLVED'
};
exports.FreightInvoiceStopsReasonsEnum = {
    Load: 'LOAD',
    Unload: 'UNLOAD'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.FreightInvoiceSubStatusType = {
    NotDelivered: 'NOT_DELIVERED',
    WrongParty: 'WRONG_PARTY',
    WrongAmount: 'WRONG_AMOUNT',
    AlreadyPaid: 'ALREADY_PAID',
    MissingDoc: 'MISSING_DOC',
    NotMatched: 'NOT_MATCHED',
    Other: 'OTHER'
};
exports.FuelSurchargeTableAppliesToEnum = {
    CarrierSide: 'CARRIER_SIDE',
    CustomerSide: 'CUSTOMER_SIDE'
};
exports.FuelSurchargeTableLocationTypeEnum = {
    Delivery: 'DELIVERY',
    Pickup: 'PICKUP'
};
exports.FuelSurchargeTableRateTypeEnum = {
    PerMile: 'PER_MILE',
    PercentOfLineHaul: 'PERCENT_OF_LINE_HAUL'
};
exports.FuelSurchargeTableRatesUpdateFrequencyEnum = {
    Weekly: 'WEEKLY',
    Monthly: 'MONTHLY'
};
exports.FuelSurchargeTableRatesUpdatedDayOfWeekEnum = {
    Monday: 'MONDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
    Thursday: 'THURSDAY',
    Friday: 'FRIDAY',
    Saturday: 'SATURDAY',
    Sunday: 'SUNDAY'
};
exports.FuelSurchargeTableRegionEnum = {
    Us: 'US',
    EastCoast: 'EAST_COAST',
    NewEngland: 'NEW_ENGLAND',
    CentralAtlantic: 'CENTRAL_ATLANTIC',
    LowerAtlantic: 'LOWER_ATLANTIC',
    Midwest: 'MIDWEST',
    GulfCoast: 'GULF_COAST',
    RockyMountain: 'ROCKY_MOUNTAIN',
    WestCoast: 'WEST_COAST',
    WestCoastLessCalifornia: 'WEST_COAST_LESS_CALIFORNIA',
    California: 'CALIFORNIA'
};
exports.FuelSurchargeTableStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
};
exports.FullNameDriverPlatformEnum = {
    IOs: 'iOS',
    Android: 'ANDROID'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.GeneratedBy = {
    ServiceProvider: 'SERVICE_PROVIDER',
    BookingParty: 'BOOKING_PARTY'
};
exports.GenesisShipmentOptionsBillToPaymentTypeEnum = {
    Collect: 'COLLECT',
    Recipient: 'RECIPIENT',
    Sender: 'SENDER',
    ThirdParty: 'THIRD_PARTY'
};
exports.GenesisShipmentOptionsCodCollectionCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.GenesisShipmentOptionsCodCollectionTypeEnum = {
    Any: 'ANY',
    CompanyCheck: 'COMPANY_CHECK',
    GuaranteedFunds: 'GUARANTEED_FUNDS',
    PersonalCheck: 'PERSONAL_CHECK'
};
exports.GenesisShipmentOptionsSignatureOptionSignatureTypeEnum = {
    AdultSignature: 'ADULT_SIGNATURE',
    DirectSignature: 'DIRECT_SIGNATURE',
    NoSignature: 'NO_SIGNATURE',
    IndirectSignature: 'INDIRECT_SIGNATURE',
    ServiceDefault: 'SERVICE_DEFAULT'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.HistoricalPriceSources = {
    ChainalyticsSpot: 'chainalytics_spot',
    DatSpot: 'dat_spot',
    ShipwellInternal: 'shipwell_internal'
};
exports.HoursOfServiceResponseStatusEnum = {
    Driving: 'driving',
    OffDutyNotDriving: 'off_duty_not_driving',
    OffDuty: 'off_duty',
    Sleeper: 'sleeper'
};
exports.InitiateCheckCallRequestAutomationEventSubTypeEnum = {
    LocationCheckIn: 'LOCATION_CHECK_IN',
    PrePickup: 'PRE_PICKUP'
};
exports.InlineObject9CategoryEnum = {
    Acc: 'ACC',
    Adjustment: 'ADJUSTMENT',
    Detention: 'DETENTION',
    Fsc: 'FSC',
    Fuel: 'FUEL',
    Insurance: 'INSURANCE',
    Lh: 'LH',
    Other: 'OTHER',
    Sf: 'SF',
    Tax: 'TAX',
    Tonu: 'TONU',
    Variance: 'VARIANCE'
};
exports.InvoicePaymentStatusEnum = {
    FullyPaid: 'Fully paid',
    PartiallyPaid: 'Partially paid',
    NotPaid: 'Not paid'
};
exports.InvoiceProcessingStatusEnum = {
    Processing: 'PROCESSING',
    Success: 'SUCCESS',
    Error: 'ERROR'
};
exports.InvoiceEmailResponseInvoiceResourceTypeEnum = {
    Invoice: 'invoice'
};
exports.InvoiceUpdateRequestPaymentStatusEnum = {
    FullyPaid: 'Fully paid',
    PartiallyPaid: 'Partially paid',
    NotPaid: 'Not paid'
};
exports.InvoiceUpdateRequestProcessingStatusEnum = {
    Processing: 'PROCESSING',
    Success: 'SUCCESS',
    Error: 'ERROR'
};
/**
 * Valid reference types for an invoiceable.
 * @export
 * @enum {string}
 */
exports.InvoiceableReferenceType = {
    PoNumber: 'PO_NUMBER',
    BolNumber: 'BOL_NUMBER',
    PickupNumber: 'PICKUP_NUMBER',
    CustomerReferenceNumber: 'CUSTOMER_REFERENCE_NUMBER'
};
exports.InvoicingShipmentsShipmentIdFreightInvoicesDataRoleEnum = {
    ServiceProvider: 'SERVICE_PROVIDER',
    BookingParty: 'BOOKING_PARTY'
};
exports.ItemConsolidationAllocatePiecesWeightUnitEnum = {
    Kg: 'KG',
    Lb: 'LB'
};
exports.ItemConsolidationLineItemsLengthUnitEnum = {
    Cm: 'CM',
    In: 'IN',
    Ft: 'FT',
    M: 'M'
};
exports.ItemConsolidationLineItemsWeightUnitEnum = {
    Kg: 'KG',
    Lb: 'LB'
};
exports.LegLocationResponseTrackingStatusEnum = {
    TrackingNotSetup: 'tracking_not_setup',
    NotTracking: 'not_tracking',
    Tracking: 'tracking',
    TrackingComplete: 'tracking_complete'
};
exports.LegTagColorEnum = {
    CherryBomb: 'cherry_bomb',
    ElectricTrees: 'electric_trees',
    FadedWhite: 'faded_white',
    LakeTravis: 'lake_travis',
    RickyFowler: 'ricky_fowler',
    RockBottom: 'rock_bottom',
    SkyShip: 'sky_ship',
    SoCirrus: 'so_cirrus',
    TheHotness: 'the_hotness',
    WellWater: 'well_water'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.LoadBoardBiddingStatuses = {
    Bidding: 'bidding',
    Closed: 'closed',
    Open: 'open',
    Won: 'won',
    Tendered: 'tendered',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Expired: 'expired'
};
exports.LoadBoardShipmentBiddingStatusEnum = {
    Bidding: 'bidding',
    Closed: 'closed',
    Open: 'open',
    Won: 'won',
    Tendered: 'tendered',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Expired: 'expired'
};
exports.LoadBoardShipmentBuyItNowAmountCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.LoadBoardShipmentSpotNegotiationCarrierStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    DoNotUse: 'DO_NOT_USE'
};
exports.LoadBoardShipmentTargetRateAmountCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.LoadBoardShipmentTotalDeclaredValueCurrencyEnum = {
    Usd: 'USD',
    Cad: 'CAD'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.LoadBoardTenderStatuses = {
    Open: 'open',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Revoked: 'revoked',
    Expired: 'expired'
};
exports.LoadCapacityScheduleIntervalEnum = {
    Daily: 'DAILY',
    Weekly: 'WEEKLY',
    Monthly: 'MONTHLY',
    CustomDays: 'CUSTOM_DAYS'
};
exports.MarkupFtlMarkupTypeEnum = {
    FlatFee: 'flat_fee',
    Percentage: 'percentage'
};
exports.MarkupLtlMarkupTypeEnum = {
    FlatFee: 'flat_fee',
    Percentage: 'percentage'
};
exports.MarkupParcelMarkupTypeEnum = {
    FlatFee: 'flat_fee',
    Percentage: 'percentage'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.MileageType = {
    HereMaps: 'HERE_MAPS',
    RandMilemaker: 'RAND_MILEMAKER',
    PcMiler33: 'PC_MILER_33',
    PcMiler34: 'PC_MILER_34',
    PcMiler35: 'PC_MILER_35',
    PcMiler36: 'PC_MILER_36',
    PcMiler37: 'PC_MILER_37',
    PcMilerCurrent: 'PC_MILER_CURRENT'
};
exports.NetsuiteCustomFieldTypeEnum = {
    EntityCustomField: 'entityCustomField',
    TransactionBodyCustomField: 'transactionBodyCustomField'
};
exports.NetsuiteSuiteAppConfigAuthTypeEnum = {
    Oauth2M2M: 'OAUTH2_M2M'
};
exports.NetsuiteSuiteAppOrderFieldMappingSwInLineLengthUnitEnum = {
    Cm: 'CM',
    In: 'IN',
    Ft: 'FT',
    M: 'M'
};
exports.NetsuiteSuiteAppOrderFieldMappingSwInLineWeightUnitEnum = {
    Kg: 'KG',
    Lb: 'LB'
};
exports.NotificationPreferenceMediumEnum = {
    Email: 'email',
    Sms: 'sms',
    Push: 'push',
    Inbox: 'inbox'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ParcelPickupStatus = {
    Cancelled: 'CANCELLED',
    Delayed: 'DELAYED',
    Delivered: 'DELIVERED',
    InTransit: 'IN_TRANSIT',
    NotScheduled: 'NOT_SCHEDULED',
    Scheduled: 'SCHEDULED'
};
exports.PhoneNumberLookupTypeEnum = {
    Landline: 'landline',
    Mobile: 'mobile',
    Unverified: 'unverified',
    Voip: 'voip'
};
exports.PieceDetailHazmatPackingGroupEnum = {
    I: 'I',
    Ii: 'II',
    Iii: 'III'
};
exports.PieceDetailLengthUnitEnum = {
    Cm: 'CM',
    In: 'IN',
    Ft: 'FT',
    M: 'M'
};
exports.PieceDetailTempUnitEnum = {
    F: 'F',
    C: 'C'
};
exports.PieceDetailValuePerPieceCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.PieceDetailWeightUnitEnum = {
    Kg: 'KG',
    Lb: 'LB'
};
exports.PieceDetailInsuredValueCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.PieceDetailAllOfInsuredValueCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.PolicyPolicyTypeEnum = {
    RoutingGuide: 'ROUTING_GUIDE',
    OrderConsolidation: 'ORDER_CONSOLIDATION'
};
exports.PolicyStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
};
exports.PowerUnitStatusEnum = {
    Active: 'Active',
    Inactive: 'Inactive'
};
exports.PreProNumberGenerationConfigCheckDigitEnum = {
    Mod7: 'MOD7',
    Mod10: 'MOD10',
    Mod11: 'MOD11'
};
exports.ProductHazmatPackingGroupEnum = {
    I: 'I',
    Ii: 'II',
    Iii: 'III'
};
exports.ProductLengthUnitEnum = {
    Cm: 'CM',
    In: 'IN',
    Ft: 'FT',
    M: 'M'
};
exports.ProductTempUnitEnum = {
    F: 'F',
    C: 'C'
};
exports.ProductValuePerPieceCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.ProductWeightUnitEnum = {
    Kg: 'KG',
    Lb: 'LB'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ProductItemUnitType = {
    Bag: 'BAG',
    Bale: 'BALE',
    Barrel: 'BARREL',
    Basket: 'BASKET',
    Bin: 'BIN',
    Bottle: 'BOTTLE',
    Box: 'BOX',
    Bucket: 'BUCKET',
    Bundle: 'BUNDLE',
    Can: 'CAN',
    Carton: 'CARTON',
    Case: 'CASE',
    Cm: 'CM',
    Coil: 'COIL',
    Container: 'CONTAINER',
    Crate: 'CRATE',
    CuFt: 'CU_FT',
    CuM: 'CU_M',
    Cylinder: 'CYLINDER',
    Drum: 'DRUM',
    Envelope: 'ENVELOPE',
    FloorLoaded: 'FLOOR_LOADED',
    Ft: 'FT',
    Gallon: 'GALLON',
    Hamper: 'HAMPER',
    In: 'IN',
    Jerrican: 'JERRICAN',
    Kg: 'KG',
    Lb: 'LB',
    Liter: 'LITER',
    M: 'M',
    None: 'NONE',
    Other: 'OTHER',
    Package: 'PACKAGE',
    Pail: 'PAIL',
    Pallet: 'PALLET',
    Piece: 'PIECE',
    ProviderSpecific: 'PROVIDER_SPECIFIC',
    Reel: 'REEL',
    Roll: 'ROLL',
    Skid: 'SKID',
    SqFt: 'SQ_FT',
    SqYd: 'SQ_YD',
    Tank: 'TANK',
    ToteBin: 'TOTE_BIN',
    ToteCan: 'TOTE_CAN',
    Tube: 'TUBE',
    Unit: 'UNIT'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ProductLineItemWeightUnit = {
    Lb: 'LB',
    Kg: 'KG'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ProductPackageType = {
    Bag: 'BAG',
    Bale: 'BALE',
    Bin: 'BIN',
    Bottle: 'BOTTLE',
    Box: 'BOX',
    Bucket: 'BUCKET',
    Bundle: 'BUNDLE',
    Can: 'CAN',
    Carton: 'CARTON',
    Case: 'CASE',
    Coil: 'COIL',
    Crate: 'CRATE',
    Cylinder: 'CYLINDER',
    Drum: 'DRUM',
    FloorLoaded: 'FLOOR_LOADED',
    Jerrican: 'JERRICAN',
    Other: 'OTHER',
    Pail: 'PAIL',
    Pieces: 'PIECES',
    Pkg: 'PKG',
    Plt: 'PLT',
    Reel: 'REEL',
    Roll: 'ROLL',
    Skid: 'SKID',
    ToteBin: 'TOTE_BIN',
    ToteCan: 'TOTE_CAN',
    Tube: 'TUBE',
    Unit: 'UNIT'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ProductPieceType = {
    Bag: 'BAG',
    Bale: 'BALE',
    Bottle: 'BOTTLE',
    Box: 'BOX',
    Bucket: 'BUCKET',
    Bundle: 'BUNDLE',
    Can: 'CAN',
    Carton: 'CARTON',
    Case: 'CASE',
    Coil: 'COIL',
    Crate: 'CRATE',
    Cylinder: 'CYLINDER',
    Drum: 'DRUM',
    Jerrican: 'JERRICAN',
    Package: 'PACKAGE',
    Pail: 'PAIL',
    Pieces: 'PIECES',
    Reel: 'REEL',
    Roll: 'ROLL',
    Skid: 'SKID',
    Tube: 'TUBE'
};
exports.PurchaseOrderOverallStatusEnum = {
    Assigned: 'ASSIGNED',
    Unassigned: 'UNASSIGNED',
    InTransit: 'IN_TRANSIT',
    Delivered: 'DELIVERED',
    Dispatched: 'DISPATCHED',
    OutForDelivery: 'OUT_FOR_DELIVERY'
};
exports.PurchaseOrderSourceEnum = {
    ShipwellWeb: 'SHIPWELL_WEB',
    Import: 'IMPORT',
    Tender: 'TENDER',
    ShipwellWebUnauth: 'SHIPWELL_WEB_UNAUTH'
};
exports.PurchaseOrderSubtotalAmountCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.PurchaseOrderTaxAmountCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.PurchaseOrderTransitStatusEnum = {
    PickedUp: 'PICKED_UP',
    InTransit: 'IN_TRANSIT',
    Delivered: 'DELIVERED',
    Exceptions: 'EXCEPTIONS',
    Cancelled: 'CANCELLED'
};
exports.PurchaseOrderTransitStatusReasonCodeEnum = {
    Accident: 'ACCIDENT',
    AddressCorrectedDeliveryAttempted: 'ADDRESS_CORRECTED_DELIVERY_ATTEMPTED',
    AlternateCarrierDelivered: 'ALTERNATE_CARRIER_DELIVERED',
    AlternateCarrierPickedUp: 'ALTERNATE_CARRIER_PICKED_UP',
    AwaitingExport: 'AWAITING_EXPORT',
    AwaitingImport: 'AWAITING_IMPORT',
    BorderClearance: 'BORDER_CLEARANCE',
    CarrierDispatchError: 'CARRIER_DISPATCH_ERROR',
    CarrierKeyingError: 'CARRIER_KEYING_ERROR',
    CarrierRelated: 'CARRIER_RELATED',
    CartageAgent: 'CARTAGE_AGENT',
    CashNotAvailableFromConsignee: 'CASH_NOT_AVAILABLE_FROM_CONSIGNEE',
    CivilEvent: 'CIVIL_EVENT',
    CollectOnDeliveryRequired: 'COLLECT_ON_DELIVERY_REQUIRED',
    ConsigneeClosed: 'CONSIGNEE_CLOSED',
    ConsigneeRelated: 'CONSIGNEE_RELATED',
    Contaminated: 'CONTAMINATED',
    CreditHold: 'CREDIT_HOLD',
    CustomerRequestedDifferentDeliveryWindow: 'CUSTOMER_REQUESTED_DIFFERENT_DELIVERY_WINDOW',
    CustomerRequestedFutureDelivery: 'CUSTOMER_REQUESTED_FUTURE_DELIVERY',
    CustomerStrike: 'CUSTOMER_STRIKE',
    CustomerVacation: 'CUSTOMER_VACATION',
    CustomerWantedEarlierDelivery: 'CUSTOMER_WANTED_EARLIER_DELIVERY',
    CustomsDocumentationProblem: 'CUSTOMS_DOCUMENTATION_PROBLEM',
    Damaged: 'DAMAGED',
    DeliveryShortage: 'DELIVERY_SHORTAGE',
    DriverNotAvailable: 'DRIVER_NOT_AVAILABLE',
    DriverRelated: 'DRIVER_RELATED',
    EquipmentShortage: 'EQUIPMENT_SHORTAGE',
    EquipmentVolumeNotAvailable: 'EQUIPMENT_VOLUME_NOT_AVAILABLE',
    ExceedsServiceLimitations: 'EXCEEDS_SERVICE_LIMITATIONS',
    FailedToReleaseBilling: 'FAILED_TO_RELEASE_BILLING',
    FlatcarShortage: 'FLATCAR_SHORTAGE',
    HeldForConsignee: 'HELD_FOR_CONSIGNEE',
    HeldForFullCarrierLoad: 'HELD_FOR_FULL_CARRIER_LOAD',
    HeldForPayment: 'HELD_FOR_PAYMENT',
    HeldForProtectiveService: 'HELD_FOR_PROTECTIVE_SERVICE',
    HeldPendingAppointment: 'HELD_PENDING_APPOINTMENT',
    HeldPerShipper: 'HELD_PER_SHIPPER',
    HolidayClosed: 'HOLIDAY_CLOSED',
    HoursOfServiceLimit: 'HOURS_OF_SERVICE_LIMIT',
    ImproperFacilityOrEquipment: 'IMPROPER_FACILITY_OR_EQUIPMENT',
    ImproperInternationalPaperwork: 'IMPROPER_INTERNATIONAL_PAPERWORK',
    ImproperTemperature: 'IMPROPER_TEMPERATURE',
    InconsistentWeight: 'INCONSISTENT_WEIGHT',
    IncorrectAddress: 'INCORRECT_ADDRESS',
    IndirectDelivery: 'INDIRECT_DELIVERY',
    InsufficientDeliveryTime: 'INSUFFICIENT_DELIVERY_TIME',
    InsufficientPickupTime: 'INSUFFICIENT_PICKUP_TIME',
    InsufficientTravelTimeDetected: 'INSUFFICIENT_TRAVEL_TIME_DETECTED',
    InternationalNonCarrierDelay: 'INTERNATIONAL_NON_CARRIER_DELAY',
    LateTenderDispatch: 'LATE_TENDER_DISPATCH',
    LocationChange: 'LOCATION_CHANGE',
    LoadShifted: 'LOAD_SHIFTED',
    MechanicalBreakdown: 'MECHANICAL_BREAKDOWN',
    MisSort: 'MIS_SORT',
    MissedDelivery: 'MISSED_DELIVERY',
    MissedPickUp: 'MISSED_PICK-UP',
    MissingDocuments: 'MISSING_DOCUMENTS',
    NonExpressClearanceDelay: 'NON_EXPRESS_CLEARANCE_DELAY',
    NormalAppointment: 'NORMAL_APPOINTMENT',
    NormalStatus: 'NORMAL_STATUS',
    NoAppointmentScheduled: 'NO_APPOINTMENT_SCHEDULED',
    NoRequestedArrivalDateOrTime: 'NO_REQUESTED_ARRIVAL_DATE_OR_TIME',
    NoRequestedArrivalTimeProvidedByShipper: 'NO_REQUESTED_ARRIVAL_TIME_PROVIDED_BY_SHIPPER',
    Other: 'OTHER',
    PastCutOffTime: 'PAST_CUT_OFF_TIME',
    PrearrangedAppointment: 'PREARRANGED_APPOINTMENT',
    PreviousStop: 'PREVIOUS_STOP',
    ProcessingDelay: 'PROCESSING_DELAY',
    ProductionFalldown: 'PRODUCTION_FALLDOWN',
    RailroadFailedToMeetSchedule: 'RAILROAD_FAILED_TO_MEET_SCHEDULE',
    RecipientUnavailable: 'RECIPIENT_UNAVAILABLE',
    Reconsigned: 'RECONSIGNED',
    ReceivingTimeRestricted: 'RECEIVING_TIME_RESTRICTED',
    RefusedByCustomer: 'REFUSED_BY_CUSTOMER',
    RestrictedArticlesUnacceptable: 'RESTRICTED_ARTICLES_UNACCEPTABLE',
    ReturnedToShipper: 'RETURNED_TO_SHIPPER',
    RoadConditions: 'ROAD_CONDITIONS',
    ShipmentOverweight: 'SHIPMENT_OVERWEIGHT',
    ShipperRelated: 'SHIPPER_RELATED',
    SuspendedAtCustomerRequest: 'SUSPENDED_AT_CUSTOMER_REQUEST',
    TrackingEventAutomatedCall: 'TRACKING_EVENT_AUTOMATED_CALL',
    TrackingEventEdiUpdate: 'TRACKING_EVENT_EDI_UPDATE',
    TrackingEventEldUpdate: 'TRACKING_EVENT_ELD_UPDATE',
    TrackingEventGeofenceBreach: 'TRACKING_EVENT_GEOFENCE_BREACH',
    TrackingEventManualLocationUpdated: 'TRACKING_EVENT_MANUAL_LOCATION_UPDATED',
    TrackingEventMobileApp: 'TRACKING_EVENT_MOBILE_APP',
    TrackingEventMobileAppUpdatedByDriver: 'TRACKING_EVENT_MOBILE_APP_UPDATED_BY_DRIVER',
    TractorConventionalNotAvailable: 'TRACTOR_CONVENTIONAL_NOT_AVAILABLE',
    TractorWithSleeperCarNotAvailable: 'TRACTOR_WITH_SLEEPER_CAR_NOT_AVAILABLE',
    TrailerClassNotAvailable: 'TRAILER_CLASS_NOT_AVAILABLE',
    TrailerNotAvailable: 'TRAILER_NOT_AVAILABLE',
    TrailerNotUsableDueToPriorProduct: 'TRAILER_NOT_USABLE_DUE_TO_PRIOR_PRODUCT',
    TrainDerailment: 'TRAIN_DERAILMENT',
    TrapForCustomer: 'TRAP_FOR_CUSTOMER',
    UnableToContactRecipient: 'UNABLE_TO_CONTACT_RECIPIENT',
    UnableToLocate: 'UNABLE_TO_LOCATE',
    Unknown: 'UNKNOWN',
    WaitingForCustomerPickup: 'WAITING_FOR_CUSTOMER_PICKUP',
    WaitingForCustomerSpecifiedCarrier: 'WAITING_FOR_CUSTOMER_SPECIFIED_CARRIER',
    WaitingInspection: 'WAITING_INSPECTION',
    WaitingShippingInstructions: 'WAITING_SHIPPING_INSTRUCTIONS',
    WeatherOrNaturalDisaster: 'WEATHER_OR_NATURAL_DISASTER'
};
exports.PurchaseOrderAlertAlertTypeEnum = {
    AtRisk: 'AT_RISK',
    Delayed: 'DELAYED',
    Early: 'EARLY',
    Late: 'LATE',
    Other: 'OTHER',
    Waiting: 'WAITING'
};
exports.PurchaseOrderAlertReasonCodeEnum = {
    Accident: 'ACCIDENT',
    AddressCorrectedDeliveryAttempted: 'ADDRESS_CORRECTED_DELIVERY_ATTEMPTED',
    AlternateCarrierDelivered: 'ALTERNATE_CARRIER_DELIVERED',
    AlternateCarrierPickedUp: 'ALTERNATE_CARRIER_PICKED_UP',
    AwaitingExport: 'AWAITING_EXPORT',
    AwaitingImport: 'AWAITING_IMPORT',
    BorderClearance: 'BORDER_CLEARANCE',
    CarrierDispatchError: 'CARRIER_DISPATCH_ERROR',
    CarrierKeyingError: 'CARRIER_KEYING_ERROR',
    CarrierRelated: 'CARRIER_RELATED',
    CartageAgent: 'CARTAGE_AGENT',
    CashNotAvailableFromConsignee: 'CASH_NOT_AVAILABLE_FROM_CONSIGNEE',
    CivilEvent: 'CIVIL_EVENT',
    CollectOnDeliveryRequired: 'COLLECT_ON_DELIVERY_REQUIRED',
    ConsigneeClosed: 'CONSIGNEE_CLOSED',
    ConsigneeRelated: 'CONSIGNEE_RELATED',
    Contaminated: 'CONTAMINATED',
    CreditHold: 'CREDIT_HOLD',
    CustomerRequestedDifferentDeliveryWindow: 'CUSTOMER_REQUESTED_DIFFERENT_DELIVERY_WINDOW',
    CustomerRequestedFutureDelivery: 'CUSTOMER_REQUESTED_FUTURE_DELIVERY',
    CustomerStrike: 'CUSTOMER_STRIKE',
    CustomerVacation: 'CUSTOMER_VACATION',
    CustomerWantedEarlierDelivery: 'CUSTOMER_WANTED_EARLIER_DELIVERY',
    CustomsDocumentationProblem: 'CUSTOMS_DOCUMENTATION_PROBLEM',
    Damaged: 'DAMAGED',
    DeliveryShortage: 'DELIVERY_SHORTAGE',
    DriverNotAvailable: 'DRIVER_NOT_AVAILABLE',
    DriverRelated: 'DRIVER_RELATED',
    EquipmentShortage: 'EQUIPMENT_SHORTAGE',
    EquipmentVolumeNotAvailable: 'EQUIPMENT_VOLUME_NOT_AVAILABLE',
    ExceedsServiceLimitations: 'EXCEEDS_SERVICE_LIMITATIONS',
    FailedToReleaseBilling: 'FAILED_TO_RELEASE_BILLING',
    FlatcarShortage: 'FLATCAR_SHORTAGE',
    HeldForConsignee: 'HELD_FOR_CONSIGNEE',
    HeldForFullCarrierLoad: 'HELD_FOR_FULL_CARRIER_LOAD',
    HeldForPayment: 'HELD_FOR_PAYMENT',
    HeldForProtectiveService: 'HELD_FOR_PROTECTIVE_SERVICE',
    HeldPendingAppointment: 'HELD_PENDING_APPOINTMENT',
    HeldPerShipper: 'HELD_PER_SHIPPER',
    HolidayClosed: 'HOLIDAY_CLOSED',
    HoursOfServiceLimit: 'HOURS_OF_SERVICE_LIMIT',
    ImproperFacilityOrEquipment: 'IMPROPER_FACILITY_OR_EQUIPMENT',
    ImproperInternationalPaperwork: 'IMPROPER_INTERNATIONAL_PAPERWORK',
    ImproperTemperature: 'IMPROPER_TEMPERATURE',
    InconsistentWeight: 'INCONSISTENT_WEIGHT',
    IncorrectAddress: 'INCORRECT_ADDRESS',
    IndirectDelivery: 'INDIRECT_DELIVERY',
    InsufficientDeliveryTime: 'INSUFFICIENT_DELIVERY_TIME',
    InsufficientPickupTime: 'INSUFFICIENT_PICKUP_TIME',
    InsufficientTravelTimeDetected: 'INSUFFICIENT_TRAVEL_TIME_DETECTED',
    InternationalNonCarrierDelay: 'INTERNATIONAL_NON_CARRIER_DELAY',
    LateTenderDispatch: 'LATE_TENDER_DISPATCH',
    LocationChange: 'LOCATION_CHANGE',
    LoadShifted: 'LOAD_SHIFTED',
    MechanicalBreakdown: 'MECHANICAL_BREAKDOWN',
    MisSort: 'MIS_SORT',
    MissedDelivery: 'MISSED_DELIVERY',
    MissedPickUp: 'MISSED_PICK-UP',
    MissingDocuments: 'MISSING_DOCUMENTS',
    NonExpressClearanceDelay: 'NON_EXPRESS_CLEARANCE_DELAY',
    NormalAppointment: 'NORMAL_APPOINTMENT',
    NormalStatus: 'NORMAL_STATUS',
    NoAppointmentScheduled: 'NO_APPOINTMENT_SCHEDULED',
    NoRequestedArrivalDateOrTime: 'NO_REQUESTED_ARRIVAL_DATE_OR_TIME',
    NoRequestedArrivalTimeProvidedByShipper: 'NO_REQUESTED_ARRIVAL_TIME_PROVIDED_BY_SHIPPER',
    Other: 'OTHER',
    PastCutOffTime: 'PAST_CUT_OFF_TIME',
    PrearrangedAppointment: 'PREARRANGED_APPOINTMENT',
    PreviousStop: 'PREVIOUS_STOP',
    ProcessingDelay: 'PROCESSING_DELAY',
    ProductionFalldown: 'PRODUCTION_FALLDOWN',
    RailroadFailedToMeetSchedule: 'RAILROAD_FAILED_TO_MEET_SCHEDULE',
    RecipientUnavailable: 'RECIPIENT_UNAVAILABLE',
    Reconsigned: 'RECONSIGNED',
    ReceivingTimeRestricted: 'RECEIVING_TIME_RESTRICTED',
    RefusedByCustomer: 'REFUSED_BY_CUSTOMER',
    RestrictedArticlesUnacceptable: 'RESTRICTED_ARTICLES_UNACCEPTABLE',
    ReturnedToShipper: 'RETURNED_TO_SHIPPER',
    RoadConditions: 'ROAD_CONDITIONS',
    ShipmentOverweight: 'SHIPMENT_OVERWEIGHT',
    ShipperRelated: 'SHIPPER_RELATED',
    SuspendedAtCustomerRequest: 'SUSPENDED_AT_CUSTOMER_REQUEST',
    TrackingEventAutomatedCall: 'TRACKING_EVENT_AUTOMATED_CALL',
    TrackingEventEdiUpdate: 'TRACKING_EVENT_EDI_UPDATE',
    TrackingEventEldUpdate: 'TRACKING_EVENT_ELD_UPDATE',
    TrackingEventGeofenceBreach: 'TRACKING_EVENT_GEOFENCE_BREACH',
    TrackingEventManualLocationUpdated: 'TRACKING_EVENT_MANUAL_LOCATION_UPDATED',
    TrackingEventMobileApp: 'TRACKING_EVENT_MOBILE_APP',
    TrackingEventMobileAppUpdatedByDriver: 'TRACKING_EVENT_MOBILE_APP_UPDATED_BY_DRIVER',
    TractorConventionalNotAvailable: 'TRACTOR_CONVENTIONAL_NOT_AVAILABLE',
    TractorWithSleeperCarNotAvailable: 'TRACTOR_WITH_SLEEPER_CAR_NOT_AVAILABLE',
    TrailerClassNotAvailable: 'TRAILER_CLASS_NOT_AVAILABLE',
    TrailerNotAvailable: 'TRAILER_NOT_AVAILABLE',
    TrailerNotUsableDueToPriorProduct: 'TRAILER_NOT_USABLE_DUE_TO_PRIOR_PRODUCT',
    TrainDerailment: 'TRAIN_DERAILMENT',
    TrapForCustomer: 'TRAP_FOR_CUSTOMER',
    UnableToContactRecipient: 'UNABLE_TO_CONTACT_RECIPIENT',
    UnableToLocate: 'UNABLE_TO_LOCATE',
    Unknown: 'UNKNOWN',
    WaitingForCustomerPickup: 'WAITING_FOR_CUSTOMER_PICKUP',
    WaitingForCustomerSpecifiedCarrier: 'WAITING_FOR_CUSTOMER_SPECIFIED_CARRIER',
    WaitingInspection: 'WAITING_INSPECTION',
    WaitingShippingInstructions: 'WAITING_SHIPPING_INSTRUCTIONS',
    WeatherOrNaturalDisaster: 'WEATHER_OR_NATURAL_DISASTER'
};
exports.PurchaseOrderLineItemHazmatPackingGroupEnum = {
    I: 'I',
    Ii: 'II',
    Iii: 'III'
};
exports.PurchaseOrderLineItemLengthUnitEnum = {
    Cm: 'CM',
    In: 'IN',
    Ft: 'FT',
    M: 'M'
};
exports.PurchaseOrderLineItemTempUnitEnum = {
    F: 'F',
    C: 'C'
};
exports.PurchaseOrderLineItemValuePerPieceCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.PurchaseOrderLineItemWeightUnitEnum = {
    Kg: 'KG',
    Lb: 'LB'
};
exports.PurchaseOrderLineItemResponseHazmatPackingGroupEnum = {
    I: 'I',
    Ii: 'II',
    Iii: 'III'
};
exports.PurchaseOrderLineItemResponseLengthUnitEnum = {
    Cm: 'CM',
    In: 'IN',
    Ft: 'FT',
    M: 'M'
};
exports.PurchaseOrderLineItemResponseTempUnitEnum = {
    F: 'F',
    C: 'C'
};
exports.PurchaseOrderLineItemResponseValuePerPieceCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.PurchaseOrderLineItemResponseWeightUnitEnum = {
    Kg: 'KG',
    Lb: 'LB'
};
exports.PurchaseOrderListResponseOverallStatusEnum = {
    Assigned: 'ASSIGNED',
    Unassigned: 'UNASSIGNED',
    InTransit: 'IN_TRANSIT',
    Delivered: 'DELIVERED',
    Dispatched: 'DISPATCHED',
    OutForDelivery: 'OUT_FOR_DELIVERY'
};
exports.PurchaseOrderListResponseSourceEnum = {
    ShipwellWeb: 'SHIPWELL_WEB',
    Import: 'IMPORT',
    Tender: 'TENDER',
    ShipwellWebUnauth: 'SHIPWELL_WEB_UNAUTH'
};
exports.PurchaseOrderListResponseSubtotalAmountCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.PurchaseOrderListResponseTaxAmountCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.PurchaseOrderListResponseTransitStatusEnum = {
    PickedUp: 'PICKED_UP',
    InTransit: 'IN_TRANSIT',
    Delivered: 'DELIVERED',
    Exceptions: 'EXCEPTIONS',
    Cancelled: 'CANCELLED'
};
exports.PurchaseOrderListResponseTransitStatusReasonCodeEnum = {
    Accident: 'ACCIDENT',
    AddressCorrectedDeliveryAttempted: 'ADDRESS_CORRECTED_DELIVERY_ATTEMPTED',
    AlternateCarrierDelivered: 'ALTERNATE_CARRIER_DELIVERED',
    AlternateCarrierPickedUp: 'ALTERNATE_CARRIER_PICKED_UP',
    AwaitingExport: 'AWAITING_EXPORT',
    AwaitingImport: 'AWAITING_IMPORT',
    BorderClearance: 'BORDER_CLEARANCE',
    CarrierDispatchError: 'CARRIER_DISPATCH_ERROR',
    CarrierKeyingError: 'CARRIER_KEYING_ERROR',
    CarrierRelated: 'CARRIER_RELATED',
    CartageAgent: 'CARTAGE_AGENT',
    CashNotAvailableFromConsignee: 'CASH_NOT_AVAILABLE_FROM_CONSIGNEE',
    CivilEvent: 'CIVIL_EVENT',
    CollectOnDeliveryRequired: 'COLLECT_ON_DELIVERY_REQUIRED',
    ConsigneeClosed: 'CONSIGNEE_CLOSED',
    ConsigneeRelated: 'CONSIGNEE_RELATED',
    Contaminated: 'CONTAMINATED',
    CreditHold: 'CREDIT_HOLD',
    CustomerRequestedDifferentDeliveryWindow: 'CUSTOMER_REQUESTED_DIFFERENT_DELIVERY_WINDOW',
    CustomerRequestedFutureDelivery: 'CUSTOMER_REQUESTED_FUTURE_DELIVERY',
    CustomerStrike: 'CUSTOMER_STRIKE',
    CustomerVacation: 'CUSTOMER_VACATION',
    CustomerWantedEarlierDelivery: 'CUSTOMER_WANTED_EARLIER_DELIVERY',
    CustomsDocumentationProblem: 'CUSTOMS_DOCUMENTATION_PROBLEM',
    Damaged: 'DAMAGED',
    DeliveryShortage: 'DELIVERY_SHORTAGE',
    DriverNotAvailable: 'DRIVER_NOT_AVAILABLE',
    DriverRelated: 'DRIVER_RELATED',
    EquipmentShortage: 'EQUIPMENT_SHORTAGE',
    EquipmentVolumeNotAvailable: 'EQUIPMENT_VOLUME_NOT_AVAILABLE',
    ExceedsServiceLimitations: 'EXCEEDS_SERVICE_LIMITATIONS',
    FailedToReleaseBilling: 'FAILED_TO_RELEASE_BILLING',
    FlatcarShortage: 'FLATCAR_SHORTAGE',
    HeldForConsignee: 'HELD_FOR_CONSIGNEE',
    HeldForFullCarrierLoad: 'HELD_FOR_FULL_CARRIER_LOAD',
    HeldForPayment: 'HELD_FOR_PAYMENT',
    HeldForProtectiveService: 'HELD_FOR_PROTECTIVE_SERVICE',
    HeldPendingAppointment: 'HELD_PENDING_APPOINTMENT',
    HeldPerShipper: 'HELD_PER_SHIPPER',
    HolidayClosed: 'HOLIDAY_CLOSED',
    HoursOfServiceLimit: 'HOURS_OF_SERVICE_LIMIT',
    ImproperFacilityOrEquipment: 'IMPROPER_FACILITY_OR_EQUIPMENT',
    ImproperInternationalPaperwork: 'IMPROPER_INTERNATIONAL_PAPERWORK',
    ImproperTemperature: 'IMPROPER_TEMPERATURE',
    InconsistentWeight: 'INCONSISTENT_WEIGHT',
    IncorrectAddress: 'INCORRECT_ADDRESS',
    IndirectDelivery: 'INDIRECT_DELIVERY',
    InsufficientDeliveryTime: 'INSUFFICIENT_DELIVERY_TIME',
    InsufficientPickupTime: 'INSUFFICIENT_PICKUP_TIME',
    InsufficientTravelTimeDetected: 'INSUFFICIENT_TRAVEL_TIME_DETECTED',
    InternationalNonCarrierDelay: 'INTERNATIONAL_NON_CARRIER_DELAY',
    LateTenderDispatch: 'LATE_TENDER_DISPATCH',
    LocationChange: 'LOCATION_CHANGE',
    LoadShifted: 'LOAD_SHIFTED',
    MechanicalBreakdown: 'MECHANICAL_BREAKDOWN',
    MisSort: 'MIS_SORT',
    MissedDelivery: 'MISSED_DELIVERY',
    MissedPickUp: 'MISSED_PICK-UP',
    MissingDocuments: 'MISSING_DOCUMENTS',
    NonExpressClearanceDelay: 'NON_EXPRESS_CLEARANCE_DELAY',
    NormalAppointment: 'NORMAL_APPOINTMENT',
    NormalStatus: 'NORMAL_STATUS',
    NoAppointmentScheduled: 'NO_APPOINTMENT_SCHEDULED',
    NoRequestedArrivalDateOrTime: 'NO_REQUESTED_ARRIVAL_DATE_OR_TIME',
    NoRequestedArrivalTimeProvidedByShipper: 'NO_REQUESTED_ARRIVAL_TIME_PROVIDED_BY_SHIPPER',
    Other: 'OTHER',
    PastCutOffTime: 'PAST_CUT_OFF_TIME',
    PrearrangedAppointment: 'PREARRANGED_APPOINTMENT',
    PreviousStop: 'PREVIOUS_STOP',
    ProcessingDelay: 'PROCESSING_DELAY',
    ProductionFalldown: 'PRODUCTION_FALLDOWN',
    RailroadFailedToMeetSchedule: 'RAILROAD_FAILED_TO_MEET_SCHEDULE',
    RecipientUnavailable: 'RECIPIENT_UNAVAILABLE',
    Reconsigned: 'RECONSIGNED',
    ReceivingTimeRestricted: 'RECEIVING_TIME_RESTRICTED',
    RefusedByCustomer: 'REFUSED_BY_CUSTOMER',
    RestrictedArticlesUnacceptable: 'RESTRICTED_ARTICLES_UNACCEPTABLE',
    ReturnedToShipper: 'RETURNED_TO_SHIPPER',
    RoadConditions: 'ROAD_CONDITIONS',
    ShipmentOverweight: 'SHIPMENT_OVERWEIGHT',
    ShipperRelated: 'SHIPPER_RELATED',
    SuspendedAtCustomerRequest: 'SUSPENDED_AT_CUSTOMER_REQUEST',
    TrackingEventAutomatedCall: 'TRACKING_EVENT_AUTOMATED_CALL',
    TrackingEventEdiUpdate: 'TRACKING_EVENT_EDI_UPDATE',
    TrackingEventEldUpdate: 'TRACKING_EVENT_ELD_UPDATE',
    TrackingEventGeofenceBreach: 'TRACKING_EVENT_GEOFENCE_BREACH',
    TrackingEventManualLocationUpdated: 'TRACKING_EVENT_MANUAL_LOCATION_UPDATED',
    TrackingEventMobileApp: 'TRACKING_EVENT_MOBILE_APP',
    TrackingEventMobileAppUpdatedByDriver: 'TRACKING_EVENT_MOBILE_APP_UPDATED_BY_DRIVER',
    TractorConventionalNotAvailable: 'TRACTOR_CONVENTIONAL_NOT_AVAILABLE',
    TractorWithSleeperCarNotAvailable: 'TRACTOR_WITH_SLEEPER_CAR_NOT_AVAILABLE',
    TrailerClassNotAvailable: 'TRAILER_CLASS_NOT_AVAILABLE',
    TrailerNotAvailable: 'TRAILER_NOT_AVAILABLE',
    TrailerNotUsableDueToPriorProduct: 'TRAILER_NOT_USABLE_DUE_TO_PRIOR_PRODUCT',
    TrainDerailment: 'TRAIN_DERAILMENT',
    TrapForCustomer: 'TRAP_FOR_CUSTOMER',
    UnableToContactRecipient: 'UNABLE_TO_CONTACT_RECIPIENT',
    UnableToLocate: 'UNABLE_TO_LOCATE',
    Unknown: 'UNKNOWN',
    WaitingForCustomerPickup: 'WAITING_FOR_CUSTOMER_PICKUP',
    WaitingForCustomerSpecifiedCarrier: 'WAITING_FOR_CUSTOMER_SPECIFIED_CARRIER',
    WaitingInspection: 'WAITING_INSPECTION',
    WaitingShippingInstructions: 'WAITING_SHIPPING_INSTRUCTIONS',
    WeatherOrNaturalDisaster: 'WEATHER_OR_NATURAL_DISASTER'
};
exports.PurchaseOrderResponseOverallStatusEnum = {
    Assigned: 'ASSIGNED',
    Unassigned: 'UNASSIGNED',
    InTransit: 'IN_TRANSIT',
    Delivered: 'DELIVERED',
    Dispatched: 'DISPATCHED',
    OutForDelivery: 'OUT_FOR_DELIVERY'
};
exports.PurchaseOrderResponseSourceEnum = {
    ShipwellWeb: 'SHIPWELL_WEB',
    Import: 'IMPORT',
    Tender: 'TENDER',
    ShipwellWebUnauth: 'SHIPWELL_WEB_UNAUTH'
};
exports.PurchaseOrderResponseSubtotalAmountCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.PurchaseOrderResponseTaxAmountCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.PurchaseOrderResponseTransitStatusEnum = {
    PickedUp: 'PICKED_UP',
    InTransit: 'IN_TRANSIT',
    Delivered: 'DELIVERED',
    Exceptions: 'EXCEPTIONS',
    Cancelled: 'CANCELLED'
};
exports.PurchaseOrderResponseTransitStatusReasonCodeEnum = {
    Accident: 'ACCIDENT',
    AddressCorrectedDeliveryAttempted: 'ADDRESS_CORRECTED_DELIVERY_ATTEMPTED',
    AlternateCarrierDelivered: 'ALTERNATE_CARRIER_DELIVERED',
    AlternateCarrierPickedUp: 'ALTERNATE_CARRIER_PICKED_UP',
    AwaitingExport: 'AWAITING_EXPORT',
    AwaitingImport: 'AWAITING_IMPORT',
    BorderClearance: 'BORDER_CLEARANCE',
    CarrierDispatchError: 'CARRIER_DISPATCH_ERROR',
    CarrierKeyingError: 'CARRIER_KEYING_ERROR',
    CarrierRelated: 'CARRIER_RELATED',
    CartageAgent: 'CARTAGE_AGENT',
    CashNotAvailableFromConsignee: 'CASH_NOT_AVAILABLE_FROM_CONSIGNEE',
    CivilEvent: 'CIVIL_EVENT',
    CollectOnDeliveryRequired: 'COLLECT_ON_DELIVERY_REQUIRED',
    ConsigneeClosed: 'CONSIGNEE_CLOSED',
    ConsigneeRelated: 'CONSIGNEE_RELATED',
    Contaminated: 'CONTAMINATED',
    CreditHold: 'CREDIT_HOLD',
    CustomerRequestedDifferentDeliveryWindow: 'CUSTOMER_REQUESTED_DIFFERENT_DELIVERY_WINDOW',
    CustomerRequestedFutureDelivery: 'CUSTOMER_REQUESTED_FUTURE_DELIVERY',
    CustomerStrike: 'CUSTOMER_STRIKE',
    CustomerVacation: 'CUSTOMER_VACATION',
    CustomerWantedEarlierDelivery: 'CUSTOMER_WANTED_EARLIER_DELIVERY',
    CustomsDocumentationProblem: 'CUSTOMS_DOCUMENTATION_PROBLEM',
    Damaged: 'DAMAGED',
    DeliveryShortage: 'DELIVERY_SHORTAGE',
    DriverNotAvailable: 'DRIVER_NOT_AVAILABLE',
    DriverRelated: 'DRIVER_RELATED',
    EquipmentShortage: 'EQUIPMENT_SHORTAGE',
    EquipmentVolumeNotAvailable: 'EQUIPMENT_VOLUME_NOT_AVAILABLE',
    ExceedsServiceLimitations: 'EXCEEDS_SERVICE_LIMITATIONS',
    FailedToReleaseBilling: 'FAILED_TO_RELEASE_BILLING',
    FlatcarShortage: 'FLATCAR_SHORTAGE',
    HeldForConsignee: 'HELD_FOR_CONSIGNEE',
    HeldForFullCarrierLoad: 'HELD_FOR_FULL_CARRIER_LOAD',
    HeldForPayment: 'HELD_FOR_PAYMENT',
    HeldForProtectiveService: 'HELD_FOR_PROTECTIVE_SERVICE',
    HeldPendingAppointment: 'HELD_PENDING_APPOINTMENT',
    HeldPerShipper: 'HELD_PER_SHIPPER',
    HolidayClosed: 'HOLIDAY_CLOSED',
    HoursOfServiceLimit: 'HOURS_OF_SERVICE_LIMIT',
    ImproperFacilityOrEquipment: 'IMPROPER_FACILITY_OR_EQUIPMENT',
    ImproperInternationalPaperwork: 'IMPROPER_INTERNATIONAL_PAPERWORK',
    ImproperTemperature: 'IMPROPER_TEMPERATURE',
    InconsistentWeight: 'INCONSISTENT_WEIGHT',
    IncorrectAddress: 'INCORRECT_ADDRESS',
    IndirectDelivery: 'INDIRECT_DELIVERY',
    InsufficientDeliveryTime: 'INSUFFICIENT_DELIVERY_TIME',
    InsufficientPickupTime: 'INSUFFICIENT_PICKUP_TIME',
    InsufficientTravelTimeDetected: 'INSUFFICIENT_TRAVEL_TIME_DETECTED',
    InternationalNonCarrierDelay: 'INTERNATIONAL_NON_CARRIER_DELAY',
    LateTenderDispatch: 'LATE_TENDER_DISPATCH',
    LocationChange: 'LOCATION_CHANGE',
    LoadShifted: 'LOAD_SHIFTED',
    MechanicalBreakdown: 'MECHANICAL_BREAKDOWN',
    MisSort: 'MIS_SORT',
    MissedDelivery: 'MISSED_DELIVERY',
    MissedPickUp: 'MISSED_PICK-UP',
    MissingDocuments: 'MISSING_DOCUMENTS',
    NonExpressClearanceDelay: 'NON_EXPRESS_CLEARANCE_DELAY',
    NormalAppointment: 'NORMAL_APPOINTMENT',
    NormalStatus: 'NORMAL_STATUS',
    NoAppointmentScheduled: 'NO_APPOINTMENT_SCHEDULED',
    NoRequestedArrivalDateOrTime: 'NO_REQUESTED_ARRIVAL_DATE_OR_TIME',
    NoRequestedArrivalTimeProvidedByShipper: 'NO_REQUESTED_ARRIVAL_TIME_PROVIDED_BY_SHIPPER',
    Other: 'OTHER',
    PastCutOffTime: 'PAST_CUT_OFF_TIME',
    PrearrangedAppointment: 'PREARRANGED_APPOINTMENT',
    PreviousStop: 'PREVIOUS_STOP',
    ProcessingDelay: 'PROCESSING_DELAY',
    ProductionFalldown: 'PRODUCTION_FALLDOWN',
    RailroadFailedToMeetSchedule: 'RAILROAD_FAILED_TO_MEET_SCHEDULE',
    RecipientUnavailable: 'RECIPIENT_UNAVAILABLE',
    Reconsigned: 'RECONSIGNED',
    ReceivingTimeRestricted: 'RECEIVING_TIME_RESTRICTED',
    RefusedByCustomer: 'REFUSED_BY_CUSTOMER',
    RestrictedArticlesUnacceptable: 'RESTRICTED_ARTICLES_UNACCEPTABLE',
    ReturnedToShipper: 'RETURNED_TO_SHIPPER',
    RoadConditions: 'ROAD_CONDITIONS',
    ShipmentOverweight: 'SHIPMENT_OVERWEIGHT',
    ShipperRelated: 'SHIPPER_RELATED',
    SuspendedAtCustomerRequest: 'SUSPENDED_AT_CUSTOMER_REQUEST',
    TrackingEventAutomatedCall: 'TRACKING_EVENT_AUTOMATED_CALL',
    TrackingEventEdiUpdate: 'TRACKING_EVENT_EDI_UPDATE',
    TrackingEventEldUpdate: 'TRACKING_EVENT_ELD_UPDATE',
    TrackingEventGeofenceBreach: 'TRACKING_EVENT_GEOFENCE_BREACH',
    TrackingEventManualLocationUpdated: 'TRACKING_EVENT_MANUAL_LOCATION_UPDATED',
    TrackingEventMobileApp: 'TRACKING_EVENT_MOBILE_APP',
    TrackingEventMobileAppUpdatedByDriver: 'TRACKING_EVENT_MOBILE_APP_UPDATED_BY_DRIVER',
    TractorConventionalNotAvailable: 'TRACTOR_CONVENTIONAL_NOT_AVAILABLE',
    TractorWithSleeperCarNotAvailable: 'TRACTOR_WITH_SLEEPER_CAR_NOT_AVAILABLE',
    TrailerClassNotAvailable: 'TRAILER_CLASS_NOT_AVAILABLE',
    TrailerNotAvailable: 'TRAILER_NOT_AVAILABLE',
    TrailerNotUsableDueToPriorProduct: 'TRAILER_NOT_USABLE_DUE_TO_PRIOR_PRODUCT',
    TrainDerailment: 'TRAIN_DERAILMENT',
    TrapForCustomer: 'TRAP_FOR_CUSTOMER',
    UnableToContactRecipient: 'UNABLE_TO_CONTACT_RECIPIENT',
    UnableToLocate: 'UNABLE_TO_LOCATE',
    Unknown: 'UNKNOWN',
    WaitingForCustomerPickup: 'WAITING_FOR_CUSTOMER_PICKUP',
    WaitingForCustomerSpecifiedCarrier: 'WAITING_FOR_CUSTOMER_SPECIFIED_CARRIER',
    WaitingInspection: 'WAITING_INSPECTION',
    WaitingShippingInstructions: 'WAITING_SHIPPING_INSTRUCTIONS',
    WeatherOrNaturalDisaster: 'WEATHER_OR_NATURAL_DISASTER'
};
exports.QuoteCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.QuoteLaneTypeEnum = {
    Direct: 'DIRECT',
    Interline: 'INTERLINE',
    Unspecified: 'UNSPECIFIED'
};
exports.QuoteSourceTypeEnum = {
    Instant: 'INSTANT',
    Manual: 'MANUAL',
    PrivateMarketplace: 'PRIVATE_MARKETPLACE'
};
exports.QuoteChargeLineItemUnitAmountCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.RFPBidOptContractWorkflowCreationRecordResponseContractsStatusEnum = {
    InProgress: 'IN_PROGRESS',
    AllContractsCreated: 'ALL_CONTRACTS_CREATED',
    SomeContractsCreated: 'SOME_CONTRACTS_CREATED',
    NoContractsCreated: 'NO_CONTRACTS_CREATED'
};
exports.RFPBidOptContractWorkflowCreationRecordResponseWorkflowStatusEnum = {
    InProgress: 'IN_PROGRESS',
    WorkflowCreated: 'WORKFLOW_CREATED',
    WorkflowCreationFailed: 'WORKFLOW_CREATION_FAILED'
};
exports.RFPBidOptResponseStateEnum = {
    LanesNotImported: 'LANES_NOT_IMPORTED',
    Created: 'CREATED',
    BidRequested: 'BID_REQUESTED',
    BidComplete: 'BID_COMPLETE',
    ContractsCreateRequested: 'CONTRACTS_CREATE_REQUESTED',
    ContractsRgCreateRequested: 'CONTRACTS_RG_CREATE_REQUESTED'
};
exports.RMISDotTestingInfoOperatingStatusEnum = {
    Active: 'ACTIVE',
    AuthorizedForHhg: 'AUTHORIZED_FOR_HHG',
    AuthorizedForPassenger: 'AUTHORIZED_FOR_PASSENGER',
    AuthorizedForProperty: 'AUTHORIZED_FOR_PROPERTY',
    InactiveUsdotNumber: 'INACTIVE_USDOT_NUMBER',
    NotAuthorized: 'NOT_AUTHORIZED',
    OutOfService: 'OUT_OF_SERVICE'
};
exports.RMISJobStatusTypeEnum = {
    Ftp: 'FTP',
    Api: 'API'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.RateAssessmentMeasurement = {
    Distance: 'DISTANCE',
    HandlingUnit: 'HANDLING_UNIT',
    Weight: 'WEIGHT',
    PerHour: 'PER_HOUR'
};
exports.RecordedELDProviderSupportedProviderNameEnum = {
    Eroad: 'eroad',
    Fleetmatics: 'fleetmatics',
    Fleetup: 'fleetup',
    Geotab: 'geotab',
    Ise: 'ise',
    Jjkeller: 'jjkeller',
    KeepTruckin: 'keep_truckin',
    OmnitracsVlv: 'omnitracs_vlv',
    Peoplenet: 'peoplenet',
    Samsara: 'samsara',
    Teletrac: 'teletrac',
    Zonar: 'zonar',
    Other: 'other'
};
exports.RecordedEquipmentTypeEldProviderEnum = {
    Eroad: 'eroad',
    Fleetmatics: 'fleetmatics',
    Fleetup: 'fleetup',
    Geotab: 'geotab',
    Ise: 'ise',
    Jjkeller: 'jjkeller',
    KeepTruckin: 'keep_truckin',
    OmnitracsVlv: 'omnitracs_vlv',
    Peoplenet: 'peoplenet',
    Samsara: 'samsara',
    Teletrac: 'teletrac',
    Zonar: 'zonar'
};
exports.RelatedOrderOrderTypeEnum = {
    SalesOrder: 'SALES_ORDER',
    PurchaseOrder: 'PURCHASE_ORDER'
};
exports.RelatedOrderItemOrderTypeEnum = {
    SalesOrder: 'SALES_ORDER',
    PurchaseOrder: 'PURCHASE_ORDER'
};
exports.RfpCarrierBidRequestOptRequestBidRequestStateEnum = {
    RequestNotDownloaded: 'REQUEST_NOT_DOWNLOADED',
    RequestDownloaded: 'REQUEST_DOWNLOADED',
    ResponseUploaded: 'RESPONSE_UPLOADED'
};
exports.RfpCarrierBidRequestOptResponseBidRequestStateEnum = {
    RequestNotDownloaded: 'REQUEST_NOT_DOWNLOADED',
    RequestDownloaded: 'REQUEST_DOWNLOADED',
    ResponseUploaded: 'RESPONSE_UPLOADED'
};
exports.RfpLaneOptResponseDestinationCountryIsoCodeEnum = {
    Us: 'US',
    Ca: 'CA'
};
exports.RfpLaneOptResponseDistanceUnitsEnum = {
    Mile: 'MILE',
    Kilometer: 'KILOMETER'
};
exports.RfpLaneOptResponseEquipmentEnum = {
    AutoCarrier: 'AUTO_CARRIER',
    Autohauler: 'AUTOHAULER',
    BTrain: 'B_TRAIN',
    Bulk: 'BULK',
    Conestoga: 'CONESTOGA',
    Container: 'CONTAINER',
    ContainerBreakBulk: 'CONTAINER_BREAK_BULK',
    ContainerStandard20Foot: 'CONTAINER_STANDARD_20_FOOT',
    ContainerStandard40Foot: 'CONTAINER_STANDARD_40_FOOT',
    ContainerFlatTrack20Foot: 'CONTAINER_FLAT_TRACK_20_FOOT',
    ContainerFlatTrack40Foot: 'CONTAINER_FLAT_TRACK_40_FOOT',
    ContainerHeavyTested20Foot: 'CONTAINER_HEAVY_TESTED_20_FOOT',
    ContainerHighCube40Foot: 'CONTAINER_HIGH_CUBE_40_FOOT',
    ContainerHighCube45Foot: 'CONTAINER_HIGH_CUBE_45_FOOT',
    ContainerInsulated: 'CONTAINER_INSULATED',
    ContainerIsoTank20Foot: 'CONTAINER_ISO_TANK_20_FOOT',
    ContainerIsoTank24Foot: 'CONTAINER_ISO_TANK_24_FOOT',
    ContainerIsoTank40Foot: 'CONTAINER_ISO_TANK_40_FOOT',
    ContainerOpenTop20Foot: 'CONTAINER_OPEN_TOP_20_FOOT',
    ContainerOpenTop40Foot: 'CONTAINER_OPEN_TOP_40_FOOT',
    ContainerReefer20Foot: 'CONTAINER_REEFER_20_FOOT',
    ContainerReefer40Foot: 'CONTAINER_REEFER_40_FOOT',
    ContainerRefrigerated: 'CONTAINER_REFRIGERATED',
    Conveyor: 'CONVEYOR',
    CurtainSide: 'CURTAIN_SIDE',
    DoubleDrop: 'DOUBLE_DROP',
    DropDeck: 'DROP_DECK',
    DropDeckLandoll: 'DROP_DECK_LANDOLL',
    DryVan: 'DRY_VAN',
    DumpTrailer: 'DUMP_TRAILER',
    Flatbed: 'FLATBED',
    Flatbed53Foot: 'FLATBED_53_FOOT',
    FlatbedAirRide: 'FLATBED_AIR_RIDE',
    FlatbedConestoga: 'FLATBED_CONESTOGA',
    FlatbedDouble: 'FLATBED_DOUBLE',
    FlatbedHotshot: 'FLATBED_HOTSHOT',
    FlatbedMaxi: 'FLATBED_MAXI',
    FlatbedOverdimension: 'FLATBED_OVERDIMENSION',
    Hopper: 'HOPPER',
    HopperBottom: 'HOPPER_BOTTOM',
    InsulatedVan: 'INSULATED_VAN',
    Lowboy: 'LOWBOY',
    LowboyOverdimension: 'LOWBOY_OVERDIMENSION',
    MovingVan: 'MOVING_VAN',
    Other: 'OTHER',
    Pneumatic: 'PNEUMATIC',
    PowerOnly: 'POWER_ONLY',
    Reefer: 'REEFER',
    ReeferAirRide: 'REEFER_AIR_RIDE',
    ReeferDouble: 'REEFER_DOUBLE',
    ReeferIntermodal: 'REEFER_INTERMODAL',
    RemovableGooseneck: 'REMOVABLE_GOOSENECK',
    StepDeck: 'STEP_DECK',
    StepdeckConestoga: 'STEPDECK_CONESTOGA',
    StraightBoxTruck: 'STRAIGHT_BOX_TRUCK',
    StretchTrailer: 'STRETCH_TRAILER',
    Tanker: 'TANKER',
    TankerAluminum: 'TANKER_ALUMINUM',
    TankerIntermodal: 'TANKER_INTERMODAL',
    TankerSteel: 'TANKER_STEEL',
    Tilt: 'TILT',
    TruckAndTrailer: 'TRUCK_AND_TRAILER',
    VanAirRide: 'VAN_AIR_RIDE',
    VanDouble: 'VAN_DOUBLE',
    VanInsulated: 'VAN_INSULATED',
    VanIntermodal: 'VAN_INTERMODAL',
    VanOpenTop: 'VAN_OPEN_TOP',
    VanRollerBed: 'VAN_ROLLER_BED',
    VanSprinter: 'VAN_SPRINTER',
    VanTriple: 'VAN_TRIPLE',
    VanVented: 'VAN_VENTED',
    VanWithCurtains: 'VAN_WITH_CURTAINS',
    Container53Foot: 'CONTAINER_53_FOOT'
};
exports.RfpLaneOptResponseModeEnum = {
    Ltl: 'LTL',
    Ftl: 'FTL',
    Vltl: 'VLTL',
    Dryage: 'DRYAGE',
    Parcel: 'PARCEL'
};
exports.RfpLaneOptResponseOriginCountryIsoCodeEnum = {
    Us: 'US',
    Ca: 'CA'
};
exports.RfpLaneOptResponsePriceVolatilityTextEnum = {
    Low: 'LOW',
    Medium: 'MEDIUM',
    High: 'HIGH'
};
exports.RfpRowResponseEquipmentEnum = {
    AutoCarrier: 'AUTO_CARRIER',
    Autohauler: 'AUTOHAULER',
    BTrain: 'B_TRAIN',
    Bulk: 'BULK',
    Conestoga: 'CONESTOGA',
    Container: 'CONTAINER',
    ContainerBreakBulk: 'CONTAINER_BREAK_BULK',
    ContainerStandard20Foot: 'CONTAINER_STANDARD_20_FOOT',
    ContainerStandard40Foot: 'CONTAINER_STANDARD_40_FOOT',
    ContainerFlatTrack20Foot: 'CONTAINER_FLAT_TRACK_20_FOOT',
    ContainerFlatTrack40Foot: 'CONTAINER_FLAT_TRACK_40_FOOT',
    ContainerHeavyTested20Foot: 'CONTAINER_HEAVY_TESTED_20_FOOT',
    ContainerHighCube40Foot: 'CONTAINER_HIGH_CUBE_40_FOOT',
    ContainerHighCube45Foot: 'CONTAINER_HIGH_CUBE_45_FOOT',
    ContainerInsulated: 'CONTAINER_INSULATED',
    ContainerIsoTank20Foot: 'CONTAINER_ISO_TANK_20_FOOT',
    ContainerIsoTank24Foot: 'CONTAINER_ISO_TANK_24_FOOT',
    ContainerIsoTank40Foot: 'CONTAINER_ISO_TANK_40_FOOT',
    ContainerOpenTop20Foot: 'CONTAINER_OPEN_TOP_20_FOOT',
    ContainerOpenTop40Foot: 'CONTAINER_OPEN_TOP_40_FOOT',
    ContainerReefer20Foot: 'CONTAINER_REEFER_20_FOOT',
    ContainerReefer40Foot: 'CONTAINER_REEFER_40_FOOT',
    ContainerRefrigerated: 'CONTAINER_REFRIGERATED',
    Conveyor: 'CONVEYOR',
    CurtainSide: 'CURTAIN_SIDE',
    DoubleDrop: 'DOUBLE_DROP',
    DropDeck: 'DROP_DECK',
    DropDeckLandoll: 'DROP_DECK_LANDOLL',
    DryVan: 'DRY_VAN',
    DumpTrailer: 'DUMP_TRAILER',
    Flatbed: 'FLATBED',
    Flatbed53Foot: 'FLATBED_53_FOOT',
    FlatbedAirRide: 'FLATBED_AIR_RIDE',
    FlatbedConestoga: 'FLATBED_CONESTOGA',
    FlatbedDouble: 'FLATBED_DOUBLE',
    FlatbedHotshot: 'FLATBED_HOTSHOT',
    FlatbedMaxi: 'FLATBED_MAXI',
    FlatbedOverdimension: 'FLATBED_OVERDIMENSION',
    Hopper: 'HOPPER',
    HopperBottom: 'HOPPER_BOTTOM',
    InsulatedVan: 'INSULATED_VAN',
    Lowboy: 'LOWBOY',
    LowboyOverdimension: 'LOWBOY_OVERDIMENSION',
    MovingVan: 'MOVING_VAN',
    Other: 'OTHER',
    Pneumatic: 'PNEUMATIC',
    PowerOnly: 'POWER_ONLY',
    Reefer: 'REEFER',
    ReeferAirRide: 'REEFER_AIR_RIDE',
    ReeferDouble: 'REEFER_DOUBLE',
    ReeferIntermodal: 'REEFER_INTERMODAL',
    RemovableGooseneck: 'REMOVABLE_GOOSENECK',
    StepDeck: 'STEP_DECK',
    StepdeckConestoga: 'STEPDECK_CONESTOGA',
    StraightBoxTruck: 'STRAIGHT_BOX_TRUCK',
    StretchTrailer: 'STRETCH_TRAILER',
    Tanker: 'TANKER',
    TankerAluminum: 'TANKER_ALUMINUM',
    TankerIntermodal: 'TANKER_INTERMODAL',
    TankerSteel: 'TANKER_STEEL',
    Tilt: 'TILT',
    TruckAndTrailer: 'TRUCK_AND_TRAILER',
    VanAirRide: 'VAN_AIR_RIDE',
    VanDouble: 'VAN_DOUBLE',
    VanInsulated: 'VAN_INSULATED',
    VanIntermodal: 'VAN_INTERMODAL',
    VanOpenTop: 'VAN_OPEN_TOP',
    VanRollerBed: 'VAN_ROLLER_BED',
    VanSprinter: 'VAN_SPRINTER',
    VanTriple: 'VAN_TRIPLE',
    VanVented: 'VAN_VENTED',
    VanWithCurtains: 'VAN_WITH_CURTAINS',
    Container53Foot: 'CONTAINER_53_FOOT'
};
exports.RfpRowResponseModeEnum = {
    Ltl: 'LTL',
    Ftl: 'FTL',
    Vltl: 'VLTL',
    Dryage: 'DRYAGE',
    Parcel: 'PARCEL'
};
exports.SMSTrackingDriverActionActionEnum = {
    Accept: 'ACCEPT',
    Reject: 'REJECT'
};
exports.ServiceLevelAgreementAwardedLoadsIntervalEnum = {
    Day: 'DAY',
    Week: 'WEEK',
    Month: 'MONTH'
};
exports.ServiceLevelAgreementCapacityIntervalEnum = {
    Day: 'DAY',
    Week: 'WEEK',
    Month: 'MONTH',
    Year: 'YEAR'
};
exports.ServiceLevelAgreementCommittedLoadsIntervalEnum = {
    Day: 'DAY',
    Week: 'WEEK',
    Month: 'MONTH',
    Year: 'YEAR'
};
exports.ServiceLevelAgreementMinimumAcceptanceIntervalEnum = {
    Day: 'DAY',
    Week: 'WEEK',
    Month: 'MONTH',
    Year: 'YEAR'
};
exports.ServiceLevelAgreementMinimumOnTimeDeliveryIntervalEnum = {
    Day: 'DAY',
    Week: 'WEEK',
    Month: 'MONTH'
};
exports.ServiceLevelAgreementMinimumOnTimePickupIntervalEnum = {
    Day: 'DAY',
    Week: 'WEEK',
    Month: 'MONTH'
};
exports.ServiceLevelAgreementPositionEnum = {
    Primary: 'PRIMARY',
    Secondary: 'SECONDARY',
    Tertiary: 'TERTIARY',
    Backup: 'BACKUP'
};
exports.ServiceLevelAgreementStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ServiceLevelAgreementIntervals = {
    Day: 'DAY',
    Week: 'WEEK',
    Month: 'MONTH',
    Year: 'YEAR'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ServiceLevelAgreementStatuses = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ServiceProviderCapabilitiesEnum = {
    Transload: 'TRANSLOAD',
    TerminalFee: 'TERMINAL_FEE',
    Storage: 'STORAGE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ServiceProviderStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SettlementsDashboardGeneratedBy = {
    ServiceProvider: 'SERVICE_PROVIDER',
    BookingParty: 'BOOKING_PARTY'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SettlementsDashboardSource = {
    Edi210: 'EDI_210',
    Dfm: 'DFM',
    ShipwellWeb: 'SHIPWELL_WEB',
    UploadedInvoice: 'UPLOADED_INVOICE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SettlementsDashboardSubStatusType = {
    NotDelivered: 'NOT_DELIVERED',
    WrongParty: 'WRONG_PARTY',
    WrongAmount: 'WRONG_AMOUNT',
    AlreadyPaid: 'ALREADY_PAID',
    MissingDoc: 'MISSING_DOC',
    NotMatched: 'NOT_MATCHED',
    Other: 'OTHER'
};
exports.ShipmentParcelPickupStatusEnum = {
    Cancelled: 'CANCELLED',
    Delayed: 'DELAYED',
    Delivered: 'DELIVERED',
    InTransit: 'IN_TRANSIT',
    NotScheduled: 'NOT_SCHEDULED',
    Scheduled: 'SCHEDULED'
};
exports.ShipmentPreferredCurrencyEnum = {
    Cad: 'CAD',
    Cny: 'CNY',
    Eur: 'EUR',
    Mxn: 'MXN',
    Usd: 'USD'
};
exports.ShipmentRailCarStatusEnum = {
    ArrivalTransitLocation: 'ARRIVAL_TRANSIT_LOCATION',
    BadOrder: 'BAD_ORDER',
    ArrivalAtDestination: 'ARRIVAL_AT_DESTINATION',
    MotorCarrierDeparture: 'MOTOR_CARRIER_DEPARTURE',
    FlatcarBadOrder: 'FLATCAR_BAD_ORDER',
    BadOrderRelease: 'BAD_ORDER_RELEASE',
    EquipmentDelayedOrHeld: 'EQUIPMENT_DELAYED_OR_HELD',
    EquipmentOfferedInInterchange: 'EQUIPMENT_OFFERED_IN_INTERCHANGE',
    InterchangeDelivery: 'INTERCHANGE_DELIVERY',
    IntermodalInterchange: 'INTERMODAL_INTERCHANGE',
    MotorCarrierArrival: 'MOTOR_CARRIER_ARRIVAL',
    MotorCarrierMove: 'MOTOR_CARRIER_MOVE',
    NoBill: 'NO_BILL',
    Departure: 'DEPARTURE',
    FlatcarBadOrderRelease: 'FLATCAR_BAD_ORDER_RELEASE',
    InterchangeReceived: 'INTERCHANGE_RECEIVED',
    Storage: 'STORAGE',
    Ramped: 'RAMPED',
    DeRamped: 'DE_RAMPED',
    Released: 'RELEASED',
    Pull: 'PULL',
    ConstructivePlacementNotify: 'CONSTRUCTIVE_PLACEMENT_NOTIFY',
    ActualPlacement: 'ACTUAL_PLACEMENT',
    Eta: 'ETA',
    LadingTransferTo: 'LADING_TRANSFER_TO',
    LadingTransferFrom: 'LADING_TRANSFER_FROM',
    ReleaseFromHoldOrMiscellaneous: 'RELEASE_FROM_HOLD_OR_MISCELLANEOUS'
};
exports.ShipmentTotalDeclaredValueCurrencyEnum = {
    Cad: 'CAD',
    Cny: 'CNY',
    Eur: 'EUR',
    Mxn: 'MXN',
    Usd: 'USD'
};
exports.ShipmentVersionEnum = {
    NUMBER_2: 2,
    NUMBER_3: 3
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ShipmentAlertLevel = {
    High: 'HIGH',
    Medium: 'MEDIUM',
    Low: 'LOW'
};
exports.ShipmentChargeLineItemUnitAmountCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.ShipmentDocumentMetadataTypeEnum = {
    Bol: 'BOL',
    Fuel: 'FUEL',
    Lumper: 'LUMPER',
    Hos: 'HOS',
    Signature: 'SIGNATURE',
    RateConfirmation: 'RATE_CONFIRMATION',
    CustomerTender: 'CUSTOMER_TENDER',
    DeliveryReceipt: 'DELIVERY_RECEIPT',
    WeightCertificate: 'WEIGHT_CERTIFICATE',
    OveragesShortagesAndDamages: 'OVERAGES_SHORTAGES_AND_DAMAGES',
    RenditionInvoicePacket: 'RENDITION_INVOICE_PACKET',
    InventoryRelease: 'INVENTORY_RELEASE',
    Invoice: 'INVOICE',
    Insurance: 'INSURANCE',
    ShippingLabel: 'SHIPPING_LABEL',
    CustomsPaperwork: 'CUSTOMS_PAPERWORK',
    PackingSlips: 'PACKING_SLIPS',
    Other: 'OTHER'
};
exports.ShipmentDocumentMetadataAllOfTypeEnum = {
    Bol: 'BOL',
    Fuel: 'FUEL',
    Lumper: 'LUMPER',
    Hos: 'HOS',
    Signature: 'SIGNATURE',
    RateConfirmation: 'RATE_CONFIRMATION',
    CustomerTender: 'CUSTOMER_TENDER',
    DeliveryReceipt: 'DELIVERY_RECEIPT',
    WeightCertificate: 'WEIGHT_CERTIFICATE',
    OveragesShortagesAndDamages: 'OVERAGES_SHORTAGES_AND_DAMAGES',
    RenditionInvoicePacket: 'RENDITION_INVOICE_PACKET',
    InventoryRelease: 'INVENTORY_RELEASE',
    Invoice: 'INVOICE',
    Insurance: 'INSURANCE',
    ShippingLabel: 'SHIPPING_LABEL',
    CustomsPaperwork: 'CUSTOMS_PAPERWORK',
    PackingSlips: 'PACKING_SLIPS',
    Other: 'OTHER'
};
exports.ShipmentDocumentSignSignatoryRoleEnum = {
    Customer: 'CUSTOMER',
    DockWorker: 'DOCK_WORKER',
    Driver: 'DRIVER',
    Other: 'OTHER',
    Security: 'SECURITY',
    Supervisor: 'SUPERVISOR',
    Supplier: 'SUPPLIER'
};
exports.ShipmentDocumentSignatureSignatoryRoleEnum = {
    Customer: 'CUSTOMER',
    DockWorker: 'DOCK_WORKER',
    Driver: 'DRIVER',
    Other: 'OTHER',
    Security: 'SECURITY',
    Supervisor: 'SUPERVISOR',
    Supplier: 'SUPPLIER'
};
exports.ShipmentLineItemHazmatPackingGroupEnum = {
    I: 'I',
    Ii: 'II',
    Iii: 'III'
};
exports.ShipmentLineItemLengthUnitEnum = {
    Cm: 'CM',
    In: 'IN',
    Ft: 'FT',
    M: 'M'
};
exports.ShipmentLineItemTempUnitEnum = {
    F: 'F',
    C: 'C'
};
exports.ShipmentLineItemValuePerPieceCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.ShipmentLineItemWeightUnitEnum = {
    Kg: 'KG',
    Lb: 'LB'
};
exports.ShipmentLineItemInsuredValueCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.ShipmentLineItemAllOfInsuredValueCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.ShipmentLineItemDetailHazmatPackingGroupEnum = {
    I: 'I',
    Ii: 'II',
    Iii: 'III'
};
exports.ShipmentLineItemDetailLengthUnitEnum = {
    Cm: 'CM',
    In: 'IN',
    Ft: 'FT',
    M: 'M'
};
exports.ShipmentLineItemDetailTempUnitEnum = {
    F: 'F',
    C: 'C'
};
exports.ShipmentLineItemDetailValuePerPieceCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.ShipmentLineItemDetailWeightUnitEnum = {
    Kg: 'KG',
    Lb: 'LB'
};
exports.ShipmentLineItemDetailInsuredValueCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.ShipmentLocationResponseTrackingStatusEnum = {
    TrackingNotSetup: 'tracking_not_setup',
    NotTracking: 'not_tracking',
    Tracking: 'tracking',
    TrackingComplete: 'tracking_complete'
};
exports.ShipmentMetadataAlertLevelEnum = {
    High: 'HIGH',
    Medium: 'MEDIUM',
    Low: 'LOW'
};
exports.ShipmentMetadataBuyItNowAmountCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.ShipmentMetadataMaxBuyAmountCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.ShipmentMetadataTargetRateAmountCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.ShipmentMetadataAlertSubtypeEnum = {
    AppNotInstalled: 'APP_NOT_INSTALLED',
    DriverPermissions: 'DRIVER_PERMISSIONS',
    DriverLocation: 'DRIVER_LOCATION',
    DriverMultipleShipments: 'DRIVER_MULTIPLE_SHIPMENTS',
    Other: 'OTHER'
};
exports.ShipmentMetadataAlertTypeEnum = {
    CarrierInsuranceExceeded: 'CARRIER_INSURANCE_EXCEEDED',
    MobileDeviceAlert: 'MOBILE_DEVICE_ALERT',
    NonActiveCarrier: 'NON_ACTIVE_CARRIER',
    NoTrackingAlert: 'NO_TRACKING_ALERT',
    MismatchesLoadType: 'MISMATCHES_LOAD_TYPE',
    Other: 'OTHER'
};
exports.ShipmentMetadataAlertWithShipmentSubtypeEnum = {
    AppNotInstalled: 'APP_NOT_INSTALLED',
    DriverPermissions: 'DRIVER_PERMISSIONS',
    DriverLocation: 'DRIVER_LOCATION',
    DriverMultipleShipments: 'DRIVER_MULTIPLE_SHIPMENTS',
    Other: 'OTHER'
};
exports.ShipmentMetadataAlertWithShipmentTypeEnum = {
    CarrierInsuranceExceeded: 'CARRIER_INSURANCE_EXCEEDED',
    MobileDeviceAlert: 'MOBILE_DEVICE_ALERT',
    NonActiveCarrier: 'NON_ACTIVE_CARRIER',
    NoTrackingAlert: 'NO_TRACKING_ALERT',
    MismatchesLoadType: 'MISMATCHES_LOAD_TYPE',
    Other: 'OTHER'
};
exports.ShipmentSpotNegotiationCarrierStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    DoNotUse: 'DO_NOT_USE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ShipmentStatesValues = {
    AppointmentPending: 'appointment_pending',
    AtPickup: 'at_pickup',
    AtDelivery: 'at_delivery',
    Cancelled: 'cancelled',
    CarrierConfirmed: 'carrier_confirmed',
    Delivered: 'delivered',
    Dispatched: 'dispatched',
    Draft: 'draft',
    InTransit: 'in_transit',
    QuoteAccepted: 'quote_accepted',
    Quoting: 'quoting',
    Reconciled: 'reconciled',
    Tendered: 'tendered',
    AvailableAtRailFacility: 'available_at_rail_facility',
    Available: 'available',
    LoadedOnRail: 'loaded_on_rail',
    AtOriginAirport: 'at_origin_airport',
    Loaded: 'loaded',
    VesselArrived: 'vessel_arrived',
    FullOutgated: 'full_outgated',
    Exception: 'exception',
    FullOutgatedFromRailFacility: 'full_outgated_from_rail_facility',
    FullIngated: 'full_ingated',
    DepartedOnRail: 'departed_on_rail',
    AtDestinationAirport: 'at_destination_airport',
    EmptyOutgated: 'empty_outgated',
    AtOriginPort: 'at_origin_port',
    Discharged: 'discharged',
    ClearedCustoms: 'cleared_customs',
    ArrivedAtRailFacility: 'arrived_at_rail_facility',
    CustomsReview: 'customs_review',
    AtDestinationPort: 'at_destination_port',
    VesselDeparted: 'vessel_departed',
    EmptyReturned: 'empty_returned',
    CustomsHold: 'customs_hold'
};
exports.ShipmentTagColorEnum = {
    CherryBomb: 'cherry_bomb',
    ElectricTrees: 'electric_trees',
    FadedWhite: 'faded_white',
    LakeTravis: 'lake_travis',
    RickyFowler: 'ricky_fowler',
    RockBottom: 'rock_bottom',
    SkyShip: 'sky_ship',
    SoCirrus: 'so_cirrus',
    TheHotness: 'the_hotness',
    WellWater: 'well_water'
};
exports.ShipmentTimelineEventEventSubTypeEnum = {
    AtDelivery: 'AT_DELIVERY',
    AtLocation: 'AT_LOCATION',
    AtPickup: 'AT_PICKUP',
    AtStop: 'AT_STOP',
    Canceled: 'CANCELED',
    Delayed: 'DELAYED',
    Delivered: 'DELIVERED',
    DeliveredException: 'DELIVERED_EXCEPTION',
    Delivery: 'DELIVERY',
    DeliveryAppointment: 'DELIVERY_APPOINTMENT',
    DeliveryMissed: 'DELIVERY_MISSED',
    Departed: 'DEPARTED',
    DepartedStop: 'DEPARTED_STOP',
    Departure: 'DEPARTURE',
    DepartureMissed: 'DEPARTURE_MISSED',
    Dispatched: 'DISPATCHED',
    EnRoute: 'EN_ROUTE',
    Exception: 'EXCEPTION',
    Held: 'HELD',
    InTransit: 'IN_TRANSIT',
    Info: 'INFO',
    Interline: 'INTERLINE',
    InterlineDelivered: 'INTERLINE_DELIVERED',
    InterlineMissed: 'INTERLINE_MISSED',
    OutForDelivery: 'OUT_FOR_DELIVERY',
    PickedUp: 'PICKED_UP',
    Pickup: 'PICKUP',
    PickupMissed: 'PICKUP_MISSED',
    StopCancelled: 'STOP_CANCELLED',
    StopCompleted: 'STOP_COMPLETED'
};
exports.ShipmentTimelineEventEventTypeEnum = {
    AtDelivery: 'AT_DELIVERY',
    AtPickup: 'AT_PICKUP',
    Booked: 'BOOKED',
    Cancelled: 'CANCELLED',
    CarrierMatched: 'CARRIER_MATCHED',
    Delivered: 'DELIVERED',
    DetailsChanged: 'DETAILS_CHANGED',
    Dispatched: 'DISPATCHED',
    DriverAssigned: 'DRIVER_ASSIGNED',
    EtaChanged: 'ETA_CHANGED',
    Info: 'INFO',
    LocationUpdated: 'LOCATION_UPDATED',
    PickedUp: 'PICKED_UP',
    TrackReceived: 'TRACK_RECEIVED',
    StopCompleted: 'STOP_COMPLETED',
    StopEvent: 'STOP_EVENT'
};
exports.ShipmentTimelineFilterPreferencesGroupTypeEnum = {
    Status: 'status',
    Location: 'location'
};
exports.ShippingDashboardRowTenderStatusEnum = {
    Open: 'open',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Revoked: 'revoked',
    Expired: 'expired',
    Updated: 'updated'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ShippingDashboardRowType = {
    Leg: 'LEG',
    LegacyShipment: 'LEGACY_SHIPMENT',
    Service: 'SERVICE'
};
exports.SlimCarrierRelationshipCarrierStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    DoNotUse: 'DO_NOT_USE'
};
exports.SlimCarrierRelationshipExternalPaymentProcessorSyncStatusEnum = {
    Current: 'CURRENT',
    SyncError: 'SYNC_ERROR'
};
exports.SlimCarrierStatusCarrierAssignmentCarrierStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    DoNotUse: 'DO_NOT_USE'
};
exports.SlimDriverPlatformEnum = {
    IOs: 'iOS',
    Android: 'ANDROID'
};
exports.SlimPowerUnitStatusEnum = {
    Active: 'Active',
    Inactive: 'Inactive'
};
exports.SlimRMISCarrierStatusEnum = {
    Certified: 'CERTIFIED',
    NotCertified: 'NOT_CERTIFIED',
    Unknown: 'UNKNOWN'
};
exports.SlimRMISCarrierStatusStatusEnum = {
    Certified: 'CERTIFIED',
    NotCertified: 'NOT_CERTIFIED',
    NotOnRmis: 'NOT_ON_RMIS',
    Unknown: 'UNKNOWN'
};
exports.SlimRMISDotTestingInfoOperatingStatusEnum = {
    Active: 'ACTIVE',
    AuthorizedForHhg: 'AUTHORIZED_FOR_HHG',
    AuthorizedForPassenger: 'AUTHORIZED_FOR_PASSENGER',
    AuthorizedForProperty: 'AUTHORIZED_FOR_PROPERTY',
    InactiveUsdotNumber: 'INACTIVE_USDOT_NUMBER',
    NotAuthorized: 'NOT_AUTHORIZED',
    OutOfService: 'OUT_OF_SERVICE'
};
exports.SlimShipmentParcelPickupStatusEnum = {
    Cancelled: 'CANCELLED',
    Delayed: 'DELAYED',
    Delivered: 'DELIVERED',
    InTransit: 'IN_TRANSIT',
    NotScheduled: 'NOT_SCHEDULED',
    Scheduled: 'SCHEDULED'
};
exports.SlimShipmentPreferredCurrencyEnum = {
    Cad: 'CAD',
    Cny: 'CNY',
    Eur: 'EUR',
    Mxn: 'MXN',
    Usd: 'USD'
};
exports.SlimShipmentRailCarStatusEnum = {
    ArrivalTransitLocation: 'ARRIVAL_TRANSIT_LOCATION',
    BadOrder: 'BAD_ORDER',
    ArrivalAtDestination: 'ARRIVAL_AT_DESTINATION',
    MotorCarrierDeparture: 'MOTOR_CARRIER_DEPARTURE',
    FlatcarBadOrder: 'FLATCAR_BAD_ORDER',
    BadOrderRelease: 'BAD_ORDER_RELEASE',
    EquipmentDelayedOrHeld: 'EQUIPMENT_DELAYED_OR_HELD',
    EquipmentOfferedInInterchange: 'EQUIPMENT_OFFERED_IN_INTERCHANGE',
    InterchangeDelivery: 'INTERCHANGE_DELIVERY',
    IntermodalInterchange: 'INTERMODAL_INTERCHANGE',
    MotorCarrierArrival: 'MOTOR_CARRIER_ARRIVAL',
    MotorCarrierMove: 'MOTOR_CARRIER_MOVE',
    NoBill: 'NO_BILL',
    Departure: 'DEPARTURE',
    FlatcarBadOrderRelease: 'FLATCAR_BAD_ORDER_RELEASE',
    InterchangeReceived: 'INTERCHANGE_RECEIVED',
    Storage: 'STORAGE',
    Ramped: 'RAMPED',
    DeRamped: 'DE_RAMPED',
    Released: 'RELEASED',
    Pull: 'PULL',
    ConstructivePlacementNotify: 'CONSTRUCTIVE_PLACEMENT_NOTIFY',
    ActualPlacement: 'ACTUAL_PLACEMENT',
    Eta: 'ETA',
    LadingTransferTo: 'LADING_TRANSFER_TO',
    LadingTransferFrom: 'LADING_TRANSFER_FROM',
    ReleaseFromHoldOrMiscellaneous: 'RELEASE_FROM_HOLD_OR_MISCELLANEOUS'
};
exports.SlimShipmentTotalDeclaredValueCurrencyEnum = {
    Cad: 'CAD',
    Cny: 'CNY',
    Eur: 'EUR',
    Mxn: 'MXN',
    Usd: 'USD'
};
exports.SlimShipmentVersionEnum = {
    NUMBER_2: 2,
    NUMBER_3: 3
};
exports.SlimStopStatusEnum = {
    AtStop: 'AT_STOP',
    Cancelled: 'CANCELLED',
    Departed: 'DEPARTED',
    EnRoute: 'EN_ROUTE'
};
exports.SlimStopStatusReasonCodeEnum = {
    Accident: 'ACCIDENT',
    AddressCorrectedDeliveryAttempted: 'ADDRESS_CORRECTED_DELIVERY_ATTEMPTED',
    AlternateCarrierDelivered: 'ALTERNATE_CARRIER_DELIVERED',
    AlternateCarrierPickedUp: 'ALTERNATE_CARRIER_PICKED_UP',
    AwaitingExport: 'AWAITING_EXPORT',
    AwaitingImport: 'AWAITING_IMPORT',
    BorderClearance: 'BORDER_CLEARANCE',
    CarrierDispatchError: 'CARRIER_DISPATCH_ERROR',
    CarrierKeyingError: 'CARRIER_KEYING_ERROR',
    CarrierRelated: 'CARRIER_RELATED',
    CartageAgent: 'CARTAGE_AGENT',
    CashNotAvailableFromConsignee: 'CASH_NOT_AVAILABLE_FROM_CONSIGNEE',
    CivilEvent: 'CIVIL_EVENT',
    CollectOnDeliveryRequired: 'COLLECT_ON_DELIVERY_REQUIRED',
    ConsigneeClosed: 'CONSIGNEE_CLOSED',
    ConsigneeRelated: 'CONSIGNEE_RELATED',
    Contaminated: 'CONTAMINATED',
    CreditHold: 'CREDIT_HOLD',
    CustomerRequestedDifferentDeliveryWindow: 'CUSTOMER_REQUESTED_DIFFERENT_DELIVERY_WINDOW',
    CustomerRequestedFutureDelivery: 'CUSTOMER_REQUESTED_FUTURE_DELIVERY',
    CustomerStrike: 'CUSTOMER_STRIKE',
    CustomerVacation: 'CUSTOMER_VACATION',
    CustomerWantedEarlierDelivery: 'CUSTOMER_WANTED_EARLIER_DELIVERY',
    CustomsDocumentationProblem: 'CUSTOMS_DOCUMENTATION_PROBLEM',
    Damaged: 'DAMAGED',
    DeliveryShortage: 'DELIVERY_SHORTAGE',
    DriverNotAvailable: 'DRIVER_NOT_AVAILABLE',
    DriverRelated: 'DRIVER_RELATED',
    EquipmentShortage: 'EQUIPMENT_SHORTAGE',
    EquipmentVolumeNotAvailable: 'EQUIPMENT_VOLUME_NOT_AVAILABLE',
    ExceedsServiceLimitations: 'EXCEEDS_SERVICE_LIMITATIONS',
    FailedToReleaseBilling: 'FAILED_TO_RELEASE_BILLING',
    FlatcarShortage: 'FLATCAR_SHORTAGE',
    HeldForConsignee: 'HELD_FOR_CONSIGNEE',
    HeldForFullCarrierLoad: 'HELD_FOR_FULL_CARRIER_LOAD',
    HeldForPayment: 'HELD_FOR_PAYMENT',
    HeldForProtectiveService: 'HELD_FOR_PROTECTIVE_SERVICE',
    HeldPendingAppointment: 'HELD_PENDING_APPOINTMENT',
    HeldPerShipper: 'HELD_PER_SHIPPER',
    HolidayClosed: 'HOLIDAY_CLOSED',
    HoursOfServiceLimit: 'HOURS_OF_SERVICE_LIMIT',
    ImproperFacilityOrEquipment: 'IMPROPER_FACILITY_OR_EQUIPMENT',
    ImproperInternationalPaperwork: 'IMPROPER_INTERNATIONAL_PAPERWORK',
    ImproperTemperature: 'IMPROPER_TEMPERATURE',
    InconsistentWeight: 'INCONSISTENT_WEIGHT',
    IncorrectAddress: 'INCORRECT_ADDRESS',
    IndirectDelivery: 'INDIRECT_DELIVERY',
    InsufficientDeliveryTime: 'INSUFFICIENT_DELIVERY_TIME',
    InsufficientPickupTime: 'INSUFFICIENT_PICKUP_TIME',
    InsufficientTravelTimeDetected: 'INSUFFICIENT_TRAVEL_TIME_DETECTED',
    InternationalNonCarrierDelay: 'INTERNATIONAL_NON_CARRIER_DELAY',
    LateTenderDispatch: 'LATE_TENDER_DISPATCH',
    LocationChange: 'LOCATION_CHANGE',
    LoadShifted: 'LOAD_SHIFTED',
    MechanicalBreakdown: 'MECHANICAL_BREAKDOWN',
    MisSort: 'MIS_SORT',
    MissedDelivery: 'MISSED_DELIVERY',
    MissedPickUp: 'MISSED_PICK-UP',
    MissingDocuments: 'MISSING_DOCUMENTS',
    NonExpressClearanceDelay: 'NON_EXPRESS_CLEARANCE_DELAY',
    NormalAppointment: 'NORMAL_APPOINTMENT',
    NormalStatus: 'NORMAL_STATUS',
    NoAppointmentScheduled: 'NO_APPOINTMENT_SCHEDULED',
    NoRequestedArrivalDateOrTime: 'NO_REQUESTED_ARRIVAL_DATE_OR_TIME',
    NoRequestedArrivalTimeProvidedByShipper: 'NO_REQUESTED_ARRIVAL_TIME_PROVIDED_BY_SHIPPER',
    Other: 'OTHER',
    PastCutOffTime: 'PAST_CUT_OFF_TIME',
    PrearrangedAppointment: 'PREARRANGED_APPOINTMENT',
    PreviousStop: 'PREVIOUS_STOP',
    ProcessingDelay: 'PROCESSING_DELAY',
    ProductionFalldown: 'PRODUCTION_FALLDOWN',
    RailroadFailedToMeetSchedule: 'RAILROAD_FAILED_TO_MEET_SCHEDULE',
    RecipientUnavailable: 'RECIPIENT_UNAVAILABLE',
    Reconsigned: 'RECONSIGNED',
    ReceivingTimeRestricted: 'RECEIVING_TIME_RESTRICTED',
    RefusedByCustomer: 'REFUSED_BY_CUSTOMER',
    RestrictedArticlesUnacceptable: 'RESTRICTED_ARTICLES_UNACCEPTABLE',
    ReturnedToShipper: 'RETURNED_TO_SHIPPER',
    RoadConditions: 'ROAD_CONDITIONS',
    ShipmentOverweight: 'SHIPMENT_OVERWEIGHT',
    ShipperRelated: 'SHIPPER_RELATED',
    SuspendedAtCustomerRequest: 'SUSPENDED_AT_CUSTOMER_REQUEST',
    TrackingEventAutomatedCall: 'TRACKING_EVENT_AUTOMATED_CALL',
    TrackingEventEdiUpdate: 'TRACKING_EVENT_EDI_UPDATE',
    TrackingEventEldUpdate: 'TRACKING_EVENT_ELD_UPDATE',
    TrackingEventGeofenceBreach: 'TRACKING_EVENT_GEOFENCE_BREACH',
    TrackingEventManualLocationUpdated: 'TRACKING_EVENT_MANUAL_LOCATION_UPDATED',
    TrackingEventMobileApp: 'TRACKING_EVENT_MOBILE_APP',
    TrackingEventMobileAppUpdatedByDriver: 'TRACKING_EVENT_MOBILE_APP_UPDATED_BY_DRIVER',
    TractorConventionalNotAvailable: 'TRACTOR_CONVENTIONAL_NOT_AVAILABLE',
    TractorWithSleeperCarNotAvailable: 'TRACTOR_WITH_SLEEPER_CAR_NOT_AVAILABLE',
    TrailerClassNotAvailable: 'TRAILER_CLASS_NOT_AVAILABLE',
    TrailerNotAvailable: 'TRAILER_NOT_AVAILABLE',
    TrailerNotUsableDueToPriorProduct: 'TRAILER_NOT_USABLE_DUE_TO_PRIOR_PRODUCT',
    TrainDerailment: 'TRAIN_DERAILMENT',
    TrapForCustomer: 'TRAP_FOR_CUSTOMER',
    UnableToContactRecipient: 'UNABLE_TO_CONTACT_RECIPIENT',
    UnableToLocate: 'UNABLE_TO_LOCATE',
    Unknown: 'UNKNOWN',
    WaitingForCustomerPickup: 'WAITING_FOR_CUSTOMER_PICKUP',
    WaitingForCustomerSpecifiedCarrier: 'WAITING_FOR_CUSTOMER_SPECIFIED_CARRIER',
    WaitingInspection: 'WAITING_INSPECTION',
    WaitingShippingInstructions: 'WAITING_SHIPPING_INSTRUCTIONS',
    WeatherOrNaturalDisaster: 'WEATHER_OR_NATURAL_DISASTER'
};
exports.SpotNegotiationCarrierStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    DoNotUse: 'DO_NOT_USE'
};
exports.SpotNegotiationQuoteDocumentTypeEnum = {
    Bol: 'BOL',
    Fuel: 'FUEL',
    Lumper: 'LUMPER',
    Hos: 'HOS',
    Signature: 'SIGNATURE',
    RateConfirmation: 'RATE_CONFIRMATION',
    CustomerTender: 'CUSTOMER_TENDER',
    DeliveryReceipt: 'DELIVERY_RECEIPT',
    WeightCertificate: 'WEIGHT_CERTIFICATE',
    OveragesShortagesAndDamages: 'OVERAGES_SHORTAGES_AND_DAMAGES',
    RenditionInvoicePacket: 'RENDITION_INVOICE_PACKET',
    InventoryRelease: 'INVENTORY_RELEASE',
    Invoice: 'INVOICE',
    Insurance: 'INSURANCE',
    ShippingLabel: 'SHIPPING_LABEL',
    CustomsPaperwork: 'CUSTOMS_PAPERWORK',
    PackingSlips: 'PACKING_SLIPS',
    Other: 'OTHER'
};
exports.StopStatusEnum = {
    AtStop: 'AT_STOP',
    Cancelled: 'CANCELLED',
    Departed: 'DEPARTED',
    EnRoute: 'EN_ROUTE'
};
exports.StopStatusReasonCodeEnum = {
    Accident: 'ACCIDENT',
    AddressCorrectedDeliveryAttempted: 'ADDRESS_CORRECTED_DELIVERY_ATTEMPTED',
    AlternateCarrierDelivered: 'ALTERNATE_CARRIER_DELIVERED',
    AlternateCarrierPickedUp: 'ALTERNATE_CARRIER_PICKED_UP',
    AwaitingExport: 'AWAITING_EXPORT',
    AwaitingImport: 'AWAITING_IMPORT',
    BorderClearance: 'BORDER_CLEARANCE',
    CarrierDispatchError: 'CARRIER_DISPATCH_ERROR',
    CarrierKeyingError: 'CARRIER_KEYING_ERROR',
    CarrierRelated: 'CARRIER_RELATED',
    CartageAgent: 'CARTAGE_AGENT',
    CashNotAvailableFromConsignee: 'CASH_NOT_AVAILABLE_FROM_CONSIGNEE',
    CivilEvent: 'CIVIL_EVENT',
    CollectOnDeliveryRequired: 'COLLECT_ON_DELIVERY_REQUIRED',
    ConsigneeClosed: 'CONSIGNEE_CLOSED',
    ConsigneeRelated: 'CONSIGNEE_RELATED',
    Contaminated: 'CONTAMINATED',
    CreditHold: 'CREDIT_HOLD',
    CustomerRequestedDifferentDeliveryWindow: 'CUSTOMER_REQUESTED_DIFFERENT_DELIVERY_WINDOW',
    CustomerRequestedFutureDelivery: 'CUSTOMER_REQUESTED_FUTURE_DELIVERY',
    CustomerStrike: 'CUSTOMER_STRIKE',
    CustomerVacation: 'CUSTOMER_VACATION',
    CustomerWantedEarlierDelivery: 'CUSTOMER_WANTED_EARLIER_DELIVERY',
    CustomsDocumentationProblem: 'CUSTOMS_DOCUMENTATION_PROBLEM',
    Damaged: 'DAMAGED',
    DeliveryShortage: 'DELIVERY_SHORTAGE',
    DriverNotAvailable: 'DRIVER_NOT_AVAILABLE',
    DriverRelated: 'DRIVER_RELATED',
    EquipmentShortage: 'EQUIPMENT_SHORTAGE',
    EquipmentVolumeNotAvailable: 'EQUIPMENT_VOLUME_NOT_AVAILABLE',
    ExceedsServiceLimitations: 'EXCEEDS_SERVICE_LIMITATIONS',
    FailedToReleaseBilling: 'FAILED_TO_RELEASE_BILLING',
    FlatcarShortage: 'FLATCAR_SHORTAGE',
    HeldForConsignee: 'HELD_FOR_CONSIGNEE',
    HeldForFullCarrierLoad: 'HELD_FOR_FULL_CARRIER_LOAD',
    HeldForPayment: 'HELD_FOR_PAYMENT',
    HeldForProtectiveService: 'HELD_FOR_PROTECTIVE_SERVICE',
    HeldPendingAppointment: 'HELD_PENDING_APPOINTMENT',
    HeldPerShipper: 'HELD_PER_SHIPPER',
    HolidayClosed: 'HOLIDAY_CLOSED',
    HoursOfServiceLimit: 'HOURS_OF_SERVICE_LIMIT',
    ImproperFacilityOrEquipment: 'IMPROPER_FACILITY_OR_EQUIPMENT',
    ImproperInternationalPaperwork: 'IMPROPER_INTERNATIONAL_PAPERWORK',
    ImproperTemperature: 'IMPROPER_TEMPERATURE',
    InconsistentWeight: 'INCONSISTENT_WEIGHT',
    IncorrectAddress: 'INCORRECT_ADDRESS',
    IndirectDelivery: 'INDIRECT_DELIVERY',
    InsufficientDeliveryTime: 'INSUFFICIENT_DELIVERY_TIME',
    InsufficientPickupTime: 'INSUFFICIENT_PICKUP_TIME',
    InsufficientTravelTimeDetected: 'INSUFFICIENT_TRAVEL_TIME_DETECTED',
    InternationalNonCarrierDelay: 'INTERNATIONAL_NON_CARRIER_DELAY',
    LateTenderDispatch: 'LATE_TENDER_DISPATCH',
    LocationChange: 'LOCATION_CHANGE',
    LoadShifted: 'LOAD_SHIFTED',
    MechanicalBreakdown: 'MECHANICAL_BREAKDOWN',
    MisSort: 'MIS_SORT',
    MissedDelivery: 'MISSED_DELIVERY',
    MissedPickUp: 'MISSED_PICK-UP',
    MissingDocuments: 'MISSING_DOCUMENTS',
    NonExpressClearanceDelay: 'NON_EXPRESS_CLEARANCE_DELAY',
    NormalAppointment: 'NORMAL_APPOINTMENT',
    NormalStatus: 'NORMAL_STATUS',
    NoAppointmentScheduled: 'NO_APPOINTMENT_SCHEDULED',
    NoRequestedArrivalDateOrTime: 'NO_REQUESTED_ARRIVAL_DATE_OR_TIME',
    NoRequestedArrivalTimeProvidedByShipper: 'NO_REQUESTED_ARRIVAL_TIME_PROVIDED_BY_SHIPPER',
    Other: 'OTHER',
    PastCutOffTime: 'PAST_CUT_OFF_TIME',
    PrearrangedAppointment: 'PREARRANGED_APPOINTMENT',
    PreviousStop: 'PREVIOUS_STOP',
    ProcessingDelay: 'PROCESSING_DELAY',
    ProductionFalldown: 'PRODUCTION_FALLDOWN',
    RailroadFailedToMeetSchedule: 'RAILROAD_FAILED_TO_MEET_SCHEDULE',
    RecipientUnavailable: 'RECIPIENT_UNAVAILABLE',
    Reconsigned: 'RECONSIGNED',
    ReceivingTimeRestricted: 'RECEIVING_TIME_RESTRICTED',
    RefusedByCustomer: 'REFUSED_BY_CUSTOMER',
    RestrictedArticlesUnacceptable: 'RESTRICTED_ARTICLES_UNACCEPTABLE',
    ReturnedToShipper: 'RETURNED_TO_SHIPPER',
    RoadConditions: 'ROAD_CONDITIONS',
    ShipmentOverweight: 'SHIPMENT_OVERWEIGHT',
    ShipperRelated: 'SHIPPER_RELATED',
    SuspendedAtCustomerRequest: 'SUSPENDED_AT_CUSTOMER_REQUEST',
    TrackingEventAutomatedCall: 'TRACKING_EVENT_AUTOMATED_CALL',
    TrackingEventEdiUpdate: 'TRACKING_EVENT_EDI_UPDATE',
    TrackingEventEldUpdate: 'TRACKING_EVENT_ELD_UPDATE',
    TrackingEventGeofenceBreach: 'TRACKING_EVENT_GEOFENCE_BREACH',
    TrackingEventManualLocationUpdated: 'TRACKING_EVENT_MANUAL_LOCATION_UPDATED',
    TrackingEventMobileApp: 'TRACKING_EVENT_MOBILE_APP',
    TrackingEventMobileAppUpdatedByDriver: 'TRACKING_EVENT_MOBILE_APP_UPDATED_BY_DRIVER',
    TractorConventionalNotAvailable: 'TRACTOR_CONVENTIONAL_NOT_AVAILABLE',
    TractorWithSleeperCarNotAvailable: 'TRACTOR_WITH_SLEEPER_CAR_NOT_AVAILABLE',
    TrailerClassNotAvailable: 'TRAILER_CLASS_NOT_AVAILABLE',
    TrailerNotAvailable: 'TRAILER_NOT_AVAILABLE',
    TrailerNotUsableDueToPriorProduct: 'TRAILER_NOT_USABLE_DUE_TO_PRIOR_PRODUCT',
    TrainDerailment: 'TRAIN_DERAILMENT',
    TrapForCustomer: 'TRAP_FOR_CUSTOMER',
    UnableToContactRecipient: 'UNABLE_TO_CONTACT_RECIPIENT',
    UnableToLocate: 'UNABLE_TO_LOCATE',
    Unknown: 'UNKNOWN',
    WaitingForCustomerPickup: 'WAITING_FOR_CUSTOMER_PICKUP',
    WaitingForCustomerSpecifiedCarrier: 'WAITING_FOR_CUSTOMER_SPECIFIED_CARRIER',
    WaitingInspection: 'WAITING_INSPECTION',
    WaitingShippingInstructions: 'WAITING_SHIPPING_INSTRUCTIONS',
    WeatherOrNaturalDisaster: 'WEATHER_OR_NATURAL_DISASTER'
};
exports.StopAlertAlertTypeEnum = {
    AtRisk: 'AT_RISK',
    Delayed: 'DELAYED',
    Early: 'EARLY',
    Late: 'LATE',
    Other: 'OTHER',
    Waiting: 'WAITING',
    Detention: 'DETENTION',
    NoMatchedLoadType: 'NO_MATCHED_LOAD_TYPE'
};
exports.StopAlertReasonCodeEnum = {
    Accident: 'ACCIDENT',
    AddressCorrectedDeliveryAttempted: 'ADDRESS_CORRECTED_DELIVERY_ATTEMPTED',
    AlternateCarrierDelivered: 'ALTERNATE_CARRIER_DELIVERED',
    AlternateCarrierPickedUp: 'ALTERNATE_CARRIER_PICKED_UP',
    AwaitingExport: 'AWAITING_EXPORT',
    AwaitingImport: 'AWAITING_IMPORT',
    BorderClearance: 'BORDER_CLEARANCE',
    CarrierDispatchError: 'CARRIER_DISPATCH_ERROR',
    CarrierKeyingError: 'CARRIER_KEYING_ERROR',
    CarrierRelated: 'CARRIER_RELATED',
    CartageAgent: 'CARTAGE_AGENT',
    CashNotAvailableFromConsignee: 'CASH_NOT_AVAILABLE_FROM_CONSIGNEE',
    CivilEvent: 'CIVIL_EVENT',
    CollectOnDeliveryRequired: 'COLLECT_ON_DELIVERY_REQUIRED',
    ConsigneeClosed: 'CONSIGNEE_CLOSED',
    ConsigneeRelated: 'CONSIGNEE_RELATED',
    Contaminated: 'CONTAMINATED',
    CreditHold: 'CREDIT_HOLD',
    CustomerRequestedDifferentDeliveryWindow: 'CUSTOMER_REQUESTED_DIFFERENT_DELIVERY_WINDOW',
    CustomerRequestedFutureDelivery: 'CUSTOMER_REQUESTED_FUTURE_DELIVERY',
    CustomerStrike: 'CUSTOMER_STRIKE',
    CustomerVacation: 'CUSTOMER_VACATION',
    CustomerWantedEarlierDelivery: 'CUSTOMER_WANTED_EARLIER_DELIVERY',
    CustomsDocumentationProblem: 'CUSTOMS_DOCUMENTATION_PROBLEM',
    Damaged: 'DAMAGED',
    DeliveryShortage: 'DELIVERY_SHORTAGE',
    DriverNotAvailable: 'DRIVER_NOT_AVAILABLE',
    DriverRelated: 'DRIVER_RELATED',
    EquipmentShortage: 'EQUIPMENT_SHORTAGE',
    EquipmentVolumeNotAvailable: 'EQUIPMENT_VOLUME_NOT_AVAILABLE',
    ExceedsServiceLimitations: 'EXCEEDS_SERVICE_LIMITATIONS',
    FailedToReleaseBilling: 'FAILED_TO_RELEASE_BILLING',
    FlatcarShortage: 'FLATCAR_SHORTAGE',
    HeldForConsignee: 'HELD_FOR_CONSIGNEE',
    HeldForFullCarrierLoad: 'HELD_FOR_FULL_CARRIER_LOAD',
    HeldForPayment: 'HELD_FOR_PAYMENT',
    HeldForProtectiveService: 'HELD_FOR_PROTECTIVE_SERVICE',
    HeldPendingAppointment: 'HELD_PENDING_APPOINTMENT',
    HeldPerShipper: 'HELD_PER_SHIPPER',
    HolidayClosed: 'HOLIDAY_CLOSED',
    HoursOfServiceLimit: 'HOURS_OF_SERVICE_LIMIT',
    ImproperFacilityOrEquipment: 'IMPROPER_FACILITY_OR_EQUIPMENT',
    ImproperInternationalPaperwork: 'IMPROPER_INTERNATIONAL_PAPERWORK',
    ImproperTemperature: 'IMPROPER_TEMPERATURE',
    InconsistentWeight: 'INCONSISTENT_WEIGHT',
    IncorrectAddress: 'INCORRECT_ADDRESS',
    IndirectDelivery: 'INDIRECT_DELIVERY',
    InsufficientDeliveryTime: 'INSUFFICIENT_DELIVERY_TIME',
    InsufficientPickupTime: 'INSUFFICIENT_PICKUP_TIME',
    InsufficientTravelTimeDetected: 'INSUFFICIENT_TRAVEL_TIME_DETECTED',
    InternationalNonCarrierDelay: 'INTERNATIONAL_NON_CARRIER_DELAY',
    LateTenderDispatch: 'LATE_TENDER_DISPATCH',
    LocationChange: 'LOCATION_CHANGE',
    LoadShifted: 'LOAD_SHIFTED',
    MechanicalBreakdown: 'MECHANICAL_BREAKDOWN',
    MisSort: 'MIS_SORT',
    MissedDelivery: 'MISSED_DELIVERY',
    MissedPickUp: 'MISSED_PICK-UP',
    MissingDocuments: 'MISSING_DOCUMENTS',
    NonExpressClearanceDelay: 'NON_EXPRESS_CLEARANCE_DELAY',
    NormalAppointment: 'NORMAL_APPOINTMENT',
    NormalStatus: 'NORMAL_STATUS',
    NoAppointmentScheduled: 'NO_APPOINTMENT_SCHEDULED',
    NoRequestedArrivalDateOrTime: 'NO_REQUESTED_ARRIVAL_DATE_OR_TIME',
    NoRequestedArrivalTimeProvidedByShipper: 'NO_REQUESTED_ARRIVAL_TIME_PROVIDED_BY_SHIPPER',
    Other: 'OTHER',
    PastCutOffTime: 'PAST_CUT_OFF_TIME',
    PrearrangedAppointment: 'PREARRANGED_APPOINTMENT',
    PreviousStop: 'PREVIOUS_STOP',
    ProcessingDelay: 'PROCESSING_DELAY',
    ProductionFalldown: 'PRODUCTION_FALLDOWN',
    RailroadFailedToMeetSchedule: 'RAILROAD_FAILED_TO_MEET_SCHEDULE',
    RecipientUnavailable: 'RECIPIENT_UNAVAILABLE',
    Reconsigned: 'RECONSIGNED',
    ReceivingTimeRestricted: 'RECEIVING_TIME_RESTRICTED',
    RefusedByCustomer: 'REFUSED_BY_CUSTOMER',
    RestrictedArticlesUnacceptable: 'RESTRICTED_ARTICLES_UNACCEPTABLE',
    ReturnedToShipper: 'RETURNED_TO_SHIPPER',
    RoadConditions: 'ROAD_CONDITIONS',
    ShipmentOverweight: 'SHIPMENT_OVERWEIGHT',
    ShipperRelated: 'SHIPPER_RELATED',
    SuspendedAtCustomerRequest: 'SUSPENDED_AT_CUSTOMER_REQUEST',
    TrackingEventAutomatedCall: 'TRACKING_EVENT_AUTOMATED_CALL',
    TrackingEventEdiUpdate: 'TRACKING_EVENT_EDI_UPDATE',
    TrackingEventEldUpdate: 'TRACKING_EVENT_ELD_UPDATE',
    TrackingEventGeofenceBreach: 'TRACKING_EVENT_GEOFENCE_BREACH',
    TrackingEventManualLocationUpdated: 'TRACKING_EVENT_MANUAL_LOCATION_UPDATED',
    TrackingEventMobileApp: 'TRACKING_EVENT_MOBILE_APP',
    TrackingEventMobileAppUpdatedByDriver: 'TRACKING_EVENT_MOBILE_APP_UPDATED_BY_DRIVER',
    TractorConventionalNotAvailable: 'TRACTOR_CONVENTIONAL_NOT_AVAILABLE',
    TractorWithSleeperCarNotAvailable: 'TRACTOR_WITH_SLEEPER_CAR_NOT_AVAILABLE',
    TrailerClassNotAvailable: 'TRAILER_CLASS_NOT_AVAILABLE',
    TrailerNotAvailable: 'TRAILER_NOT_AVAILABLE',
    TrailerNotUsableDueToPriorProduct: 'TRAILER_NOT_USABLE_DUE_TO_PRIOR_PRODUCT',
    TrainDerailment: 'TRAIN_DERAILMENT',
    TrapForCustomer: 'TRAP_FOR_CUSTOMER',
    UnableToContactRecipient: 'UNABLE_TO_CONTACT_RECIPIENT',
    UnableToLocate: 'UNABLE_TO_LOCATE',
    Unknown: 'UNKNOWN',
    WaitingForCustomerPickup: 'WAITING_FOR_CUSTOMER_PICKUP',
    WaitingForCustomerSpecifiedCarrier: 'WAITING_FOR_CUSTOMER_SPECIFIED_CARRIER',
    WaitingInspection: 'WAITING_INSPECTION',
    WaitingShippingInstructions: 'WAITING_SHIPPING_INSTRUCTIONS',
    WeatherOrNaturalDisaster: 'WEATHER_OR_NATURAL_DISASTER'
};
exports.StopDetailStatusEnum = {
    AtStop: 'AT_STOP',
    Cancelled: 'CANCELLED',
    Departed: 'DEPARTED',
    EnRoute: 'EN_ROUTE'
};
exports.StopDetailStatusReasonCodeEnum = {
    Accident: 'ACCIDENT',
    AddressCorrectedDeliveryAttempted: 'ADDRESS_CORRECTED_DELIVERY_ATTEMPTED',
    AlternateCarrierDelivered: 'ALTERNATE_CARRIER_DELIVERED',
    AlternateCarrierPickedUp: 'ALTERNATE_CARRIER_PICKED_UP',
    AwaitingExport: 'AWAITING_EXPORT',
    AwaitingImport: 'AWAITING_IMPORT',
    BorderClearance: 'BORDER_CLEARANCE',
    CarrierDispatchError: 'CARRIER_DISPATCH_ERROR',
    CarrierKeyingError: 'CARRIER_KEYING_ERROR',
    CarrierRelated: 'CARRIER_RELATED',
    CartageAgent: 'CARTAGE_AGENT',
    CashNotAvailableFromConsignee: 'CASH_NOT_AVAILABLE_FROM_CONSIGNEE',
    CivilEvent: 'CIVIL_EVENT',
    CollectOnDeliveryRequired: 'COLLECT_ON_DELIVERY_REQUIRED',
    ConsigneeClosed: 'CONSIGNEE_CLOSED',
    ConsigneeRelated: 'CONSIGNEE_RELATED',
    Contaminated: 'CONTAMINATED',
    CreditHold: 'CREDIT_HOLD',
    CustomerRequestedDifferentDeliveryWindow: 'CUSTOMER_REQUESTED_DIFFERENT_DELIVERY_WINDOW',
    CustomerRequestedFutureDelivery: 'CUSTOMER_REQUESTED_FUTURE_DELIVERY',
    CustomerStrike: 'CUSTOMER_STRIKE',
    CustomerVacation: 'CUSTOMER_VACATION',
    CustomerWantedEarlierDelivery: 'CUSTOMER_WANTED_EARLIER_DELIVERY',
    CustomsDocumentationProblem: 'CUSTOMS_DOCUMENTATION_PROBLEM',
    Damaged: 'DAMAGED',
    DeliveryShortage: 'DELIVERY_SHORTAGE',
    DriverNotAvailable: 'DRIVER_NOT_AVAILABLE',
    DriverRelated: 'DRIVER_RELATED',
    EquipmentShortage: 'EQUIPMENT_SHORTAGE',
    EquipmentVolumeNotAvailable: 'EQUIPMENT_VOLUME_NOT_AVAILABLE',
    ExceedsServiceLimitations: 'EXCEEDS_SERVICE_LIMITATIONS',
    FailedToReleaseBilling: 'FAILED_TO_RELEASE_BILLING',
    FlatcarShortage: 'FLATCAR_SHORTAGE',
    HeldForConsignee: 'HELD_FOR_CONSIGNEE',
    HeldForFullCarrierLoad: 'HELD_FOR_FULL_CARRIER_LOAD',
    HeldForPayment: 'HELD_FOR_PAYMENT',
    HeldForProtectiveService: 'HELD_FOR_PROTECTIVE_SERVICE',
    HeldPendingAppointment: 'HELD_PENDING_APPOINTMENT',
    HeldPerShipper: 'HELD_PER_SHIPPER',
    HolidayClosed: 'HOLIDAY_CLOSED',
    HoursOfServiceLimit: 'HOURS_OF_SERVICE_LIMIT',
    ImproperFacilityOrEquipment: 'IMPROPER_FACILITY_OR_EQUIPMENT',
    ImproperInternationalPaperwork: 'IMPROPER_INTERNATIONAL_PAPERWORK',
    ImproperTemperature: 'IMPROPER_TEMPERATURE',
    InconsistentWeight: 'INCONSISTENT_WEIGHT',
    IncorrectAddress: 'INCORRECT_ADDRESS',
    IndirectDelivery: 'INDIRECT_DELIVERY',
    InsufficientDeliveryTime: 'INSUFFICIENT_DELIVERY_TIME',
    InsufficientPickupTime: 'INSUFFICIENT_PICKUP_TIME',
    InsufficientTravelTimeDetected: 'INSUFFICIENT_TRAVEL_TIME_DETECTED',
    InternationalNonCarrierDelay: 'INTERNATIONAL_NON_CARRIER_DELAY',
    LateTenderDispatch: 'LATE_TENDER_DISPATCH',
    LocationChange: 'LOCATION_CHANGE',
    LoadShifted: 'LOAD_SHIFTED',
    MechanicalBreakdown: 'MECHANICAL_BREAKDOWN',
    MisSort: 'MIS_SORT',
    MissedDelivery: 'MISSED_DELIVERY',
    MissedPickUp: 'MISSED_PICK-UP',
    MissingDocuments: 'MISSING_DOCUMENTS',
    NonExpressClearanceDelay: 'NON_EXPRESS_CLEARANCE_DELAY',
    NormalAppointment: 'NORMAL_APPOINTMENT',
    NormalStatus: 'NORMAL_STATUS',
    NoAppointmentScheduled: 'NO_APPOINTMENT_SCHEDULED',
    NoRequestedArrivalDateOrTime: 'NO_REQUESTED_ARRIVAL_DATE_OR_TIME',
    NoRequestedArrivalTimeProvidedByShipper: 'NO_REQUESTED_ARRIVAL_TIME_PROVIDED_BY_SHIPPER',
    Other: 'OTHER',
    PastCutOffTime: 'PAST_CUT_OFF_TIME',
    PrearrangedAppointment: 'PREARRANGED_APPOINTMENT',
    PreviousStop: 'PREVIOUS_STOP',
    ProcessingDelay: 'PROCESSING_DELAY',
    ProductionFalldown: 'PRODUCTION_FALLDOWN',
    RailroadFailedToMeetSchedule: 'RAILROAD_FAILED_TO_MEET_SCHEDULE',
    RecipientUnavailable: 'RECIPIENT_UNAVAILABLE',
    Reconsigned: 'RECONSIGNED',
    ReceivingTimeRestricted: 'RECEIVING_TIME_RESTRICTED',
    RefusedByCustomer: 'REFUSED_BY_CUSTOMER',
    RestrictedArticlesUnacceptable: 'RESTRICTED_ARTICLES_UNACCEPTABLE',
    ReturnedToShipper: 'RETURNED_TO_SHIPPER',
    RoadConditions: 'ROAD_CONDITIONS',
    ShipmentOverweight: 'SHIPMENT_OVERWEIGHT',
    ShipperRelated: 'SHIPPER_RELATED',
    SuspendedAtCustomerRequest: 'SUSPENDED_AT_CUSTOMER_REQUEST',
    TrackingEventAutomatedCall: 'TRACKING_EVENT_AUTOMATED_CALL',
    TrackingEventEdiUpdate: 'TRACKING_EVENT_EDI_UPDATE',
    TrackingEventEldUpdate: 'TRACKING_EVENT_ELD_UPDATE',
    TrackingEventGeofenceBreach: 'TRACKING_EVENT_GEOFENCE_BREACH',
    TrackingEventManualLocationUpdated: 'TRACKING_EVENT_MANUAL_LOCATION_UPDATED',
    TrackingEventMobileApp: 'TRACKING_EVENT_MOBILE_APP',
    TrackingEventMobileAppUpdatedByDriver: 'TRACKING_EVENT_MOBILE_APP_UPDATED_BY_DRIVER',
    TractorConventionalNotAvailable: 'TRACTOR_CONVENTIONAL_NOT_AVAILABLE',
    TractorWithSleeperCarNotAvailable: 'TRACTOR_WITH_SLEEPER_CAR_NOT_AVAILABLE',
    TrailerClassNotAvailable: 'TRAILER_CLASS_NOT_AVAILABLE',
    TrailerNotAvailable: 'TRAILER_NOT_AVAILABLE',
    TrailerNotUsableDueToPriorProduct: 'TRAILER_NOT_USABLE_DUE_TO_PRIOR_PRODUCT',
    TrainDerailment: 'TRAIN_DERAILMENT',
    TrapForCustomer: 'TRAP_FOR_CUSTOMER',
    UnableToContactRecipient: 'UNABLE_TO_CONTACT_RECIPIENT',
    UnableToLocate: 'UNABLE_TO_LOCATE',
    Unknown: 'UNKNOWN',
    WaitingForCustomerPickup: 'WAITING_FOR_CUSTOMER_PICKUP',
    WaitingForCustomerSpecifiedCarrier: 'WAITING_FOR_CUSTOMER_SPECIFIED_CARRIER',
    WaitingInspection: 'WAITING_INSPECTION',
    WaitingShippingInstructions: 'WAITING_SHIPPING_INSTRUCTIONS',
    WeatherOrNaturalDisaster: 'WEATHER_OR_NATURAL_DISASTER'
};
exports.StopEventStopEventReasonCodeEnum = {
    Accident: 'ACCIDENT',
    AlternateCarrierDelivered: 'ALTERNATE_CARRIER_DELIVERED',
    AlternateCarrierPickedUp: 'ALTERNATE_CARRIER_PICKED_UP',
    AwaitingImport: 'AWAITING_IMPORT',
    BorderClearance: 'BORDER_CLEARANCE',
    CarrierKeyingError: 'CARRIER_KEYING_ERROR',
    CarrierRelated: 'CARRIER_RELATED',
    CashNotAvailableFromConsignee: 'CASH_NOT_AVAILABLE_FROM_CONSIGNEE',
    CivilEvent: 'CIVIL_EVENT',
    CollectOnDeliveryRequired: 'COLLECT_ON_DELIVERY_REQUIRED',
    ConsigneeClosed: 'CONSIGNEE_CLOSED',
    ConsigneeRelated: 'CONSIGNEE_RELATED',
    Contaminated: 'CONTAMINATED',
    CreditHold: 'CREDIT_HOLD',
    CustomerRequestedDifferentDeliveryWindow: 'CUSTOMER_REQUESTED_DIFFERENT_DELIVERY_WINDOW',
    CustomsDocumentationProblem: 'CUSTOMS_DOCUMENTATION_PROBLEM',
    CustomsDocumentationProblems: 'CUSTOMS_DOCUMENTATION_PROBLEMS',
    Damaged: 'DAMAGED',
    DeliveryShortage: 'DELIVERY_SHORTAGE',
    DriverNotAvailable: 'DRIVER_NOT_AVAILABLE',
    DriverRelated: 'DRIVER_RELATED',
    EquipmentShortage: 'EQUIPMENT_SHORTAGE',
    EquipmentVolumeNotAvailable: 'EQUIPMENT_VOLUME_NOT_AVAILABLE',
    ExceedsServiceLimitations: 'EXCEEDS_SERVICE_LIMITATIONS',
    FailedToReleaseBilling: 'FAILED_TO_RELEASE_BILLING',
    HeldForFullCarrierLoad: 'HELD_FOR_FULL_CARRIER_LOAD',
    HeldForPayment: 'HELD_FOR_PAYMENT',
    HeldForProtectiveService: 'HELD_FOR_PROTECTIVE_SERVICE',
    HeldPendingAppointment: 'HELD_PENDING_APPOINTMENT',
    HolidayClosed: 'HOLIDAY_CLOSED',
    ImproperFacilityOrEquipment: 'IMPROPER_FACILITY_OR_EQUIPMENT',
    ImproperTemperature: 'IMPROPER_TEMPERATURE',
    InconsistentWeight: 'INCONSISTENT_WEIGHT',
    IncorrectAddress: 'INCORRECT_ADDRESS',
    InsufficientDeliveryTime: 'INSUFFICIENT_DELIVERY_TIME',
    InsufficientPickupTime: 'INSUFFICIENT_PICKUP_TIME',
    InsufficientTravelTimeDetected: 'INSUFFICIENT_TRAVEL_TIME_DETECTED',
    InternationalNonCarrierDelay: 'INTERNATIONAL_NON_CARRIER_DELAY',
    MechanicalBreakdown: 'MECHANICAL_BREAKDOWN',
    MissingDocuments: 'MISSING_DOCUMENTS',
    MisSort: 'MIS_SORT',
    NonExpressClearanceDelay: 'NON_EXPRESS_CLEARANCE_DELAY',
    NormalAppointment: 'NORMAL_APPOINTMENT',
    NormalStatus: 'NORMAL_STATUS',
    NoAppointmentScheduled: 'NO_APPOINTMENT_SCHEDULED',
    NoRequestedArrivalDateOrTime: 'NO_REQUESTED_ARRIVAL_DATE_OR_TIME',
    Other: 'OTHER',
    PastCutOffTime: 'PAST_CUT_OFF_TIME',
    ProcessingDelay: 'PROCESSING_DELAY',
    RailroadFailedToMeetSchedule: 'RAILROAD_FAILED_TO_MEET_SCHEDULE',
    RecipientUnavailable: 'RECIPIENT_UNAVAILABLE',
    Reconsigned: 'RECONSIGNED',
    RestrictedArticlesUnacceptable: 'RESTRICTED_ARTICLES_UNACCEPTABLE',
    ReturnedToShipper: 'RETURNED_TO_SHIPPER',
    RoadConditions: 'ROAD_CONDITIONS',
    ShipmentOverweight: 'SHIPMENT_OVERWEIGHT',
    ShipperRelated: 'SHIPPER_RELATED',
    TrackingEventAutomatedCall: 'TRACKING_EVENT_AUTOMATED_CALL',
    TrackingEventEdiUpdate: 'TRACKING_EVENT_EDI_UPDATE',
    TrackingEventEldUpdate: 'TRACKING_EVENT_ELD_UPDATE',
    TrackingEventGeofenceBreach: 'TRACKING_EVENT_GEOFENCE_BREACH',
    TrackingEventManualLocationUpdated: 'TRACKING_EVENT_MANUAL_LOCATION_UPDATED',
    TrackingEventMobileApp: 'TRACKING_EVENT_MOBILE_APP',
    TrackingEventMobileAppUpdatedByDriver: 'TRACKING_EVENT_MOBILE_APP_UPDATED_BY_DRIVER',
    TrainDerailment: 'TRAIN_DERAILMENT',
    UnableToContactRecipient: 'UNABLE_TO_CONTACT_RECIPIENT',
    UnableToLocate: 'UNABLE_TO_LOCATE',
    Unknown: 'UNKNOWN',
    WaitingForCustomerPickup: 'WAITING_FOR_CUSTOMER_PICKUP',
    WaitingInspection: 'WAITING_INSPECTION',
    WaitingShippingInstructions: 'WAITING_SHIPPING_INSTRUCTIONS',
    WeatherOrNaturalDisaster: 'WEATHER_OR_NATURAL_DISASTER'
};
exports.StopEventStopEventTypeEnum = {
    ArrivedAtCustoms: 'ARRIVED_AT_CUSTOMS',
    ArrivedAtIntermodalRamp: 'ARRIVED_AT_INTERMODAL_RAMP',
    ArrivedAtStop: 'ARRIVED_AT_STOP',
    ArrivedAtStopEarly: 'ARRIVED_AT_STOP_EARLY',
    ArrivedAtStopLate: 'ARRIVED_AT_STOP_LATE',
    ArrivedDeliveryLoadingDock: 'ARRIVED_DELIVERY_LOADING_DOCK',
    ArrivedPickupLoadingDock: 'ARRIVED_PICKUP_LOADING_DOCK',
    ActualArrivedAtTimeUpdated: 'ACTUAL_ARRIVED_AT_TIME_UPDATED',
    AttemptedDelivery: 'ATTEMPTED_DELIVERY',
    AttemptedPickup: 'ATTEMPTED_PICKUP',
    BeganLoading: 'BEGAN_LOADING',
    BeganUnloading: 'BEGAN_UNLOADING',
    DeliveryAppointmentSet: 'DELIVERY_APPOINTMENT_SET',
    DeliveryCompleted: 'DELIVERY_COMPLETED',
    DeliveryCompletedWithExceptions: 'DELIVERY_COMPLETED_WITH_EXCEPTIONS',
    DepartedStop: 'DEPARTED_STOP',
    DepartedStopEarly: 'DEPARTED_STOP_EARLY',
    DepartedStopLate: 'DEPARTED_STOP_LATE',
    DepartedStopWithExceptions: 'DEPARTED_STOP_WITH_EXCEPTIONS',
    CompletedTimeUpdated: 'COMPLETED_TIME_UPDATED',
    CarrierSpottedAtStop: 'CARRIER_SPOTTED_AT_STOP',
    CompletedLoading: 'COMPLETED_LOADING',
    CompletedUnloading: 'COMPLETED_UNLOADING',
    DeliveryNotCompleted: 'DELIVERY_NOT_COMPLETED',
    EnRouteToStop: 'EN_ROUTE_TO_STOP',
    EstimatedArrivalTimeUpdated: 'ESTIMATED_ARRIVAL_TIME_UPDATED',
    EstimatedDepartureTimeUpdated: 'ESTIMATED_DEPARTURE_TIME_UPDATED',
    GatedIn: 'GATED_IN',
    GatedOut: 'GATED_OUT',
    MissedAppointmentWindow: 'MISSED_APPOINTMENT_WINDOW',
    MissedArrivalWindow: 'MISSED_ARRIVAL_WINDOW',
    PaperworkReceived: 'PAPERWORK_RECEIVED',
    PaperworkRequested: 'PAPERWORK_REQUESTED',
    PaperworkSent: 'PAPERWORK_SENT',
    PickupAppointmentSet: 'PICKUP_APPOINTMENT_SET',
    PickupCompleted: 'PICKUP_COMPLETED',
    PickupCompletedWithExceptions: 'PICKUP_COMPLETED_WITH_EXCEPTIONS',
    PickupNotCompleted: 'PICKUP_NOT_COMPLETED',
    RefusedByConsignee: 'REFUSED_BY_CONSIGNEE',
    ShipmentHeldAtCustoms: 'SHIPMENT_HELD_AT_CUSTOMS',
    ShipmentHeldAtStop: 'SHIPMENT_HELD_AT_STOP',
    ShipmentReconsigned: 'SHIPMENT_RECONSIGNED',
    ShipmentReturnedToShipper: 'SHIPMENT_RETURNED_TO_SHIPPER',
    ShipmentTransferredToAnotherCarrier: 'SHIPMENT_TRANSFERRED_TO_ANOTHER_CARRIER',
    StopCanceled: 'STOP_CANCELED',
    CarrierRemovedFromShipment: 'CARRIER_REMOVED_FROM_SHIPMENT',
    TrailerClosedOut: 'TRAILER_CLOSED_OUT',
    TransferredToConnectingLine: 'TRANSFERRED_TO_CONNECTING_LINE',
    DetentionLoading: 'DETENTION_LOADING',
    DetentionUnloading: 'DETENTION_UNLOADING'
};
exports.SupplierInviteStatusEnum = {
    Booked: 'BOOKED',
    Cancelled: 'CANCELLED',
    Requested: 'REQUESTED',
    UnableToBook: 'UNABLE_TO_BOOK',
    PendingBooking: 'PENDING_BOOKING'
};
exports.SupplierInviteResponseStatusEnum = {
    Booked: 'BOOKED',
    Cancelled: 'CANCELLED',
    Requested: 'REQUESTED',
    UnableToBook: 'UNABLE_TO_BOOK',
    PendingBooking: 'PENDING_BOOKING'
};
exports.TenderAcceptRejectRejectionCodeEnum = {
    A13: 'A13',
    Equ: 'EQU',
    Cpu: 'CPU',
    Ll1: 'LL1',
    Ll2: 'LL2',
    Cna: 'CNA',
    Ase: 'ASE'
};
exports.TenderAcceptRejectTypeEnum = {
    Accept: 'ACCEPT',
    Reject: 'REJECT'
};
exports.TenderAcceptRejectDetailsStatusEnum = {
    Open: 'open',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Revoked: 'revoked',
    Expired: 'expired',
    Updated: 'updated'
};
exports.TenderBaseLaneTypeEnum = {
    Direct: 'DIRECT',
    Interline: 'INTERLINE',
    Unspecified: 'UNSPECIFIED'
};
exports.TenderCreateLaneTypeEnum = {
    Direct: 'DIRECT',
    Interline: 'INTERLINE',
    Unspecified: 'UNSPECIFIED'
};
exports.TenderEquipmentEventRequestTypeCodeEnum = {
    Bulk: 'BULK',
    Container: 'CONTAINER',
    Conestoga: 'CONESTOGA',
    DryVan: 'DRY_VAN',
    DoubleDrop: 'DOUBLE_DROP',
    DropDeck: 'DROP_DECK',
    Flatbed: 'FLATBED',
    FlatbedConestoga: 'FLATBED_CONESTOGA',
    Other: 'OTHER',
    Reefer: 'REEFER',
    TruckAndTrailer: 'TRUCK_AND_TRAILER',
    VanVented: 'VAN_VENTED'
};
exports.TenderGetLaneTypeEnum = {
    Direct: 'DIRECT',
    Interline: 'INTERLINE',
    Unspecified: 'UNSPECIFIED'
};
exports.TenderGetCarrierStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    DoNotUse: 'DO_NOT_USE'
};
exports.TenderGetStatusEnum = {
    Open: 'open',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Revoked: 'revoked',
    Expired: 'expired'
};
exports.TenderGetAllOfCarrierStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    DoNotUse: 'DO_NOT_USE'
};
exports.TenderGetAllOfStatusEnum = {
    Open: 'open',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Revoked: 'revoked',
    Expired: 'expired'
};
exports.TenderRejectRequestRejectionCodeEnum = {
    A13: 'A13',
    Equ: 'EQU',
    Cpu: 'CPU',
    Ll1: 'LL1',
    Ll2: 'LL2',
    Cna: 'CNA',
    Ase: 'ASE'
};
exports.TenderRequestEquipmentTypeCodeEnum = {
    Bulk: 'BULK',
    Container: 'CONTAINER',
    Conestoga: 'CONESTOGA',
    DryVan: 'DRY_VAN',
    DoubleDrop: 'DOUBLE_DROP',
    DropDeck: 'DROP_DECK',
    Flatbed: 'FLATBED',
    FlatbedConestoga: 'FLATBED_CONESTOGA',
    Other: 'OTHER',
    Reefer: 'REEFER',
    TruckAndTrailer: 'TRUCK_AND_TRAILER',
    VanVented: 'VAN_VENTED'
};
exports.TenderRequestLengthUnitEnum = {
    In: 'IN',
    Ft: 'FT'
};
exports.TenderRequestShipmentAccessorialsEnum = {
    Guaranteed: 'GUARANTEED',
    Hazmat: 'HAZMAT',
    NotifyBeforeDelivery: 'NOTIFY_BEFORE_DELIVERY'
};
exports.TenderRequestShipmentStopAccessorialsEnum = {
    AppointmentRequested: 'APPOINTMENT_REQUESTED',
    Liftgate: 'LIFTGATE',
    ConventionTradeshow: 'CONVENTION_TRADESHOW',
    ConstructionSite: 'CONSTRUCTION_SITE',
    InsidePickupDelivery: 'INSIDE_PICKUP_DELIVERY',
    LimitedAccess: 'LIMITED_ACCESS',
    Farm: 'FARM'
};
exports.TenderRequestShipmentStopReasonEnum = {
    Load: 'LOAD',
    Unload: 'UNLOAD'
};
exports.TenderRequestTemperatureUnitEnum = {
    C: 'C',
    F: 'F'
};
exports.TenderRequestWeightUnitEnum = {
    Kg: 'KG',
    Lbs: 'LBS'
};
exports.TenderShipmentStateEventRequestStatusEnum = {
    TenderedForDelivery: 'TENDERED_FOR_DELIVERY',
    InTransit: 'IN_TRANSIT',
    Cancelled: 'CANCELLED',
    Loading: 'LOADING',
    Delayed: 'DELAYED',
    Delivered: 'DELIVERED',
    Held: 'HELD'
};
exports.TenderStopLocationEventRequestEventTypeEnum = {
    Arrival: 'ARRIVAL',
    AtLocation: 'AT_LOCATION',
    Attempt: 'ATTEMPT',
    Completed: 'COMPLETED',
    Departure: 'DEPARTURE',
    Exception: 'EXCEPTION',
    Missed: 'MISSED'
};
exports.TotalWeightOverrideUnitEnum = {
    Kg: 'KG',
    Lb: 'LB'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.TrackingSourceValues = {
    ChRobinson: 'ch_robinson',
    Checkcall: 'checkcall',
    Edi: 'edi',
    Eld: 'eld',
    MobileApp: 'mobile_app',
    WebApp: 'web_app',
    ContainerTracking: 'container_tracking',
    RailCarTracking: 'rail_car_tracking',
    AirTracking: 'air_tracking',
    Unknown: 'unknown'
};
exports.TriumphPayCarrierPaymentAccountPaymentTypeEnum = {
    AchBank: 'ACH_BANK',
    MailCheck: 'MAIL_CHECK',
    Factor: 'FACTOR'
};
exports.TriumphPayCarrierSyncedInvoicePaymentTypeEnum = {
    Ach: 'ACH',
    Check: 'Check',
    Factor: 'Factor'
};
exports.TriumphPayCarrierSyncedInvoiceStatusEnum = {
    Pending: 'Pending',
    Approved: 'Approved',
    Paid: 'Paid',
    Held: 'Held',
    MissingCarrier: 'Missing Carrier',
    Removed: 'Removed',
    PendingReissue: 'Pending Reissue',
    MissingBank: 'Missing Bank'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.TriumphPayPaymentAccountTypes = {
    AchBank: 'ACH_BANK',
    MailCheck: 'MAIL_CHECK',
    Factor: 'FACTOR'
};
exports.TriumphPayVendorSyncStatusEnum = {
    NotSetUp: 'NOT_SET_UP',
    Current: 'CURRENT',
    SyncError: 'SYNC_ERROR'
};
exports.TriumphPayVendorPaymentAccountDataPaymentTypeEnum = {
    AchBank: 'ACH_BANK',
    MailCheck: 'MAIL_CHECK',
    Factor: 'FACTOR'
};
exports.TriumphPayVendorPaymentAccountDataWithFactorCompanyChangeDocumentsPaymentTypeEnum = {
    AchBank: 'ACH_BANK',
    MailCheck: 'MAIL_CHECK',
    Factor: 'FACTOR'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.UPSImageTypes = {
    Png: 'PNG',
    Pdf: 'PDF',
    Zpl: 'ZPL',
    Epl: 'EPL'
};
exports.UPSOauthRefreshStatusStatusEnum = {
    Processing: 'PROCESSING',
    Success: 'SUCCESS',
    Failed: 'FAILED'
};
exports.UPSShipmentOptionsBillToPaymentTypeEnum = {
    Collect: 'COLLECT',
    Recipient: 'RECIPIENT',
    Sender: 'SENDER',
    ThirdParty: 'THIRD_PARTY'
};
exports.UPSShipmentOptionsCodCollectionCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.UPSShipmentOptionsCodCollectionTypeEnum = {
    Any: 'ANY',
    CompanyCheck: 'COMPANY_CHECK',
    GuaranteedFunds: 'GUARANTEED_FUNDS',
    PersonalCheck: 'PERSONAL_CHECK'
};
exports.UPSShipmentOptionsSignatureOptionSignatureTypeEnum = {
    AdultSignature: 'ADULT_SIGNATURE',
    DirectSignature: 'DIRECT_SIGNATURE',
    NoSignature: 'NO_SIGNATURE',
    IndirectSignature: 'INDIRECT_SIGNATURE',
    ServiceDefault: 'SERVICE_DEFAULT'
};
exports.UPSShipmentOptionsAlcoholRecipientTypeEnum = {
    Consumer: 'CONSUMER',
    Licensee: 'LICENSEE'
};
exports.UPSShipmentOptionsPackagingEnum = {
    UpsLetter: 'UPS_LETTER',
    UpsExpressBox: 'UPS_EXPRESS_BOX',
    Ups25KgBox: 'UPS_25KG_BOX',
    Ups10KgBox: 'UPS_10_KG_BOX',
    UpsTube: 'UPS_TUBE',
    UpsPak: 'UPS_PAK',
    UpsSmallExpressBox: 'UPS_SMALL_EXPRESS_BOX',
    UpsMediumExpressBox: 'UPS_MEDIUM_EXPRESS_BOX',
    UpsLargeExpressBox: 'UPS_LARGE_EXPRESS_BOX',
    YourPackaging: 'YOUR_PACKAGING'
};
exports.UPSShipmentOptionsServiceCodeEnum = {
    Ground: 'GROUND',
    UpsStandard: 'UPS_STANDARD',
    UpsSaver: 'UPS_SAVER',
    Express: 'EXPRESS',
    ExpressPlus: 'EXPRESS_PLUS',
    Expedited: 'EXPEDITED',
    NextDayAir: 'NEXT_DAY_AIR',
    NextDayAirSaver: 'NEXT_DAY_AIR_SAVER',
    NextDayAirEarlyAm: 'NEXT_DAY_AIR_EARLY_AM',
    SecondDayAir: 'SECOND_DAY_AIR',
    SecondDayAirAm: 'SECOND_DAY_AIR_AM',
    ThreeDaySelect: 'THREE_DAY_SELECT'
};
exports.UPSShipmentOptionsAllOfAlcoholRecipientTypeEnum = {
    Consumer: 'CONSUMER',
    Licensee: 'LICENSEE'
};
exports.UPSShipmentOptionsAllOfPackagingEnum = {
    UpsLetter: 'UPS_LETTER',
    UpsExpressBox: 'UPS_EXPRESS_BOX',
    Ups25KgBox: 'UPS_25KG_BOX',
    Ups10KgBox: 'UPS_10_KG_BOX',
    UpsTube: 'UPS_TUBE',
    UpsPak: 'UPS_PAK',
    UpsSmallExpressBox: 'UPS_SMALL_EXPRESS_BOX',
    UpsMediumExpressBox: 'UPS_MEDIUM_EXPRESS_BOX',
    UpsLargeExpressBox: 'UPS_LARGE_EXPRESS_BOX',
    YourPackaging: 'YOUR_PACKAGING'
};
exports.UPSShipmentOptionsAllOfServiceCodeEnum = {
    Ground: 'GROUND',
    UpsStandard: 'UPS_STANDARD',
    UpsSaver: 'UPS_SAVER',
    Express: 'EXPRESS',
    ExpressPlus: 'EXPRESS_PLUS',
    Expedited: 'EXPEDITED',
    NextDayAir: 'NEXT_DAY_AIR',
    NextDayAirSaver: 'NEXT_DAY_AIR_SAVER',
    NextDayAirEarlyAm: 'NEXT_DAY_AIR_EARLY_AM',
    SecondDayAir: 'SECOND_DAY_AIR',
    SecondDayAirAm: 'SECOND_DAY_AIR_AM',
    ThreeDaySelect: 'THREE_DAY_SELECT'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.UPSStockTypes = {
    _4X6: 'STOCK_4X6',
    _4X8: 'STOCK_4X8'
};
exports.USPSShipmentOptionsBillToPaymentTypeEnum = {
    Collect: 'COLLECT',
    Recipient: 'RECIPIENT',
    Sender: 'SENDER',
    ThirdParty: 'THIRD_PARTY'
};
exports.USPSShipmentOptionsCodCollectionCurrencyEnum = {
    Cad: 'CAD',
    Usd: 'USD'
};
exports.USPSShipmentOptionsCodCollectionTypeEnum = {
    Any: 'ANY',
    CompanyCheck: 'COMPANY_CHECK',
    GuaranteedFunds: 'GUARANTEED_FUNDS',
    PersonalCheck: 'PERSONAL_CHECK'
};
exports.USPSShipmentOptionsSignatureOptionSignatureTypeEnum = {
    AdultSignature: 'ADULT_SIGNATURE',
    DirectSignature: 'DIRECT_SIGNATURE',
    NoSignature: 'NO_SIGNATURE',
    IndirectSignature: 'INDIRECT_SIGNATURE',
    ServiceDefault: 'SERVICE_DEFAULT'
};
exports.USPSShipmentOptionsPackagingEnum = {
    UspsLetter: 'USPS_LETTER',
    UspsFlat: 'USPS_FLAT',
    UspsFlatRateEnvelope: 'USPS_FLAT_RATE_ENVELOPE',
    UspsFlatRateLegalEnvelope: 'USPS_FLAT_RATE_LEGAL_ENVELOPE',
    UspsFlatRatePaddedEnvelope: 'USPS_FLAT_RATE_PADDED_ENVELOPE',
    UspsParcel: 'USPS_PARCEL',
    UspsIrregularParcel: 'USPS_IRREGULAR_PARCEL',
    UspsSoftPack: 'USPS_SOFT_PACK',
    UspsSmallFlatRateBox: 'USPS_SMALL_FLAT_RATE_BOX',
    UspsMediumFlatRateBox: 'USPS_MEDIUM_FLAT_RATE_BOX',
    UspsLargeFlatRateBox: 'USPS_LARGE_FLAT_RATE_BOX',
    UspsLargeFlatRateBoxApofpo: 'USPS_LARGE_FLAT_RATE_BOX_APOFPO',
    UspsRegionalRateBoxA: 'USPS_REGIONAL_RATE_BOX_A',
    UspsRegionalRateBoxB: 'USPS_REGIONAL_RATE_BOX_B',
    UspsLargeParcel: 'USPS_LARGE_PARCEL',
    UspsFlatRateGiftCardEnvelope: 'USPS_FLAT_RATE_GIFT_CARD_ENVELOPE',
    UspsFlatRateWindowEnvelope: 'USPS_FLAT_RATE_WINDOW_ENVELOPE',
    UspsFlatRateCardboardEnvelope: 'USPS_FLAT_RATE_CARDBOARD_ENVELOPE',
    UspsSmallFlatRateEnvelope: 'USPS_SMALL_FLAT_RATE_ENVELOPE',
    UspsLargeFlatRateBoardGameBox: 'USPS_LARGE_FLAT_RATE_BOARD_GAME_BOX',
    YourPackaging: 'YOUR_PACKAGING'
};
exports.USPSShipmentOptionsServiceCodeEnum = {
    First: 'FIRST',
    Priority: 'PRIORITY',
    Express: 'EXPRESS',
    ParcelSelect: 'PARCEL_SELECT',
    LibraryMail: 'LIBRARY_MAIL',
    MediaMail: 'MEDIA_MAIL'
};
exports.USPSShipmentOptionsAllOfPackagingEnum = {
    UspsLetter: 'USPS_LETTER',
    UspsFlat: 'USPS_FLAT',
    UspsFlatRateEnvelope: 'USPS_FLAT_RATE_ENVELOPE',
    UspsFlatRateLegalEnvelope: 'USPS_FLAT_RATE_LEGAL_ENVELOPE',
    UspsFlatRatePaddedEnvelope: 'USPS_FLAT_RATE_PADDED_ENVELOPE',
    UspsParcel: 'USPS_PARCEL',
    UspsIrregularParcel: 'USPS_IRREGULAR_PARCEL',
    UspsSoftPack: 'USPS_SOFT_PACK',
    UspsSmallFlatRateBox: 'USPS_SMALL_FLAT_RATE_BOX',
    UspsMediumFlatRateBox: 'USPS_MEDIUM_FLAT_RATE_BOX',
    UspsLargeFlatRateBox: 'USPS_LARGE_FLAT_RATE_BOX',
    UspsLargeFlatRateBoxApofpo: 'USPS_LARGE_FLAT_RATE_BOX_APOFPO',
    UspsRegionalRateBoxA: 'USPS_REGIONAL_RATE_BOX_A',
    UspsRegionalRateBoxB: 'USPS_REGIONAL_RATE_BOX_B',
    UspsLargeParcel: 'USPS_LARGE_PARCEL',
    UspsFlatRateGiftCardEnvelope: 'USPS_FLAT_RATE_GIFT_CARD_ENVELOPE',
    UspsFlatRateWindowEnvelope: 'USPS_FLAT_RATE_WINDOW_ENVELOPE',
    UspsFlatRateCardboardEnvelope: 'USPS_FLAT_RATE_CARDBOARD_ENVELOPE',
    UspsSmallFlatRateEnvelope: 'USPS_SMALL_FLAT_RATE_ENVELOPE',
    UspsLargeFlatRateBoardGameBox: 'USPS_LARGE_FLAT_RATE_BOARD_GAME_BOX',
    YourPackaging: 'YOUR_PACKAGING'
};
exports.USPSShipmentOptionsAllOfServiceCodeEnum = {
    First: 'FIRST',
    Priority: 'PRIORITY',
    Express: 'EXPRESS',
    ParcelSelect: 'PARCEL_SELECT',
    LibraryMail: 'LIBRARY_MAIL',
    MediaMail: 'MEDIA_MAIL'
};
/**
 * AlertEventsApi - axios parameter creator
 * @export
 */
var AlertEventsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Assign/Unassign users to an alert event
         * @param {string} alertEventId The id of the alert event
         * @param {InlineObject} inlineObject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertEventsAlertEventIdAssignUsersPost: function (alertEventId, inlineObject, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'alertEventId' is not null or undefined
                            (0, common_1.assertParamExists)('alertEventsAlertEventIdAssignUsersPost', 'alertEventId', alertEventId);
                            // verify required parameter 'inlineObject' is not null or undefined
                            (0, common_1.assertParamExists)('alertEventsAlertEventIdAssignUsersPost', 'inlineObject', inlineObject);
                            localVarPath = "/alert-events/{alertEventId}/assign-users/"
                                .replace("{".concat("alertEventId", "}"), encodeURIComponent(String(alertEventId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about an alert event
         * @param {string} alertEventId The id of the alert event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertEventsAlertEventIdGet: function (alertEventId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'alertEventId' is not null or undefined
                            (0, common_1.assertParamExists)('alertEventsAlertEventIdGet', 'alertEventId', alertEventId);
                            localVarPath = "/alert-events/{alertEventId}/"
                                .replace("{".concat("alertEventId", "}"), encodeURIComponent(String(alertEventId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Resolve an alert event
         * @param {string} alertEventId The id of the alert event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertEventsAlertEventIdResolvePost: function (alertEventId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'alertEventId' is not null or undefined
                            (0, common_1.assertParamExists)('alertEventsAlertEventIdResolvePost', 'alertEventId', alertEventId);
                            localVarPath = "/alert-events/{alertEventId}/resolve/"
                                .replace("{".concat("alertEventId", "}"), encodeURIComponent(String(alertEventId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of alert events scoped to the authorization token.
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [shipmentId] The id of the shipment
         * @param {string} [alertLevel] The alert level
         * @param {string} [resourceId] The resource_id
         * @param {string} [resourceType] The resource_type
         * @param {string} [secondaryResourceId] The secondary_resource_id
         * @param {string} [secondaryResourceType] The secondary_resource_type
         * @param {string} [configurationId] The configuration id
         * @param {string} [assignedTo] The assigned_to user id
         * @param {boolean} [assignedToIsnull] Filter unassigned
         * @param {string} [resolvedBy] The resolved_by user id
         * @param {boolean} [resolvedByIsnull] Filter unresolved by user
         * @param {string} [resolvedAt] The resolved_at date-time
         * @param {boolean} [resolvedAtIsnull] Filter unresolved
         * @param {string} [resolvedAtGte] Filter resolved on or after a certain date and time
         * @param {string} [resolvedAtLte] Filter resolved on or before a certain date and time
         * @param {string} [snoozedUntil] The snoozed_until date-time
         * @param {boolean} [snoozedUntilIsnull] Filter not snoozed
         * @param {string} [snoozedUntilGte] Filter snoozed until on or after a certain date and time
         * @param {string} [snoozedUntilLte] Filter snoozed until on or before a certain date and time
         * @param {string} [snoozedBy] The snoozed_by user id
         * @param {boolean} [snoozedByIsnull] Filter not snoozed by user
         * @param {string} [createdAt] The created_at date-time
         * @param {string} [createdAtGte] Filter created on or after a certain date and time
         * @param {string} [createdAtLte] Filter created on or before a certain date and time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertEventsGet: function (page, pageSize, ordering, shipmentId, alertLevel, resourceId, resourceType, secondaryResourceId, secondaryResourceType, configurationId, assignedTo, assignedToIsnull, resolvedBy, resolvedByIsnull, resolvedAt, resolvedAtIsnull, resolvedAtGte, resolvedAtLte, snoozedUntil, snoozedUntilIsnull, snoozedUntilGte, snoozedUntilLte, snoozedBy, snoozedByIsnull, createdAt, createdAtGte, createdAtLte, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/alert-events/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (shipmentId !== undefined) {
                                localVarQueryParameter['shipment_id'] = shipmentId;
                            }
                            if (alertLevel !== undefined) {
                                localVarQueryParameter['alert_level'] = alertLevel;
                            }
                            if (resourceId !== undefined) {
                                localVarQueryParameter['resource_id'] = resourceId;
                            }
                            if (resourceType !== undefined) {
                                localVarQueryParameter['resource_type'] = resourceType;
                            }
                            if (secondaryResourceId !== undefined) {
                                localVarQueryParameter['secondary_resource_id'] = secondaryResourceId;
                            }
                            if (secondaryResourceType !== undefined) {
                                localVarQueryParameter['secondary_resource_type'] = secondaryResourceType;
                            }
                            if (configurationId !== undefined) {
                                localVarQueryParameter['configuration_id'] = configurationId;
                            }
                            if (assignedTo !== undefined) {
                                localVarQueryParameter['assigned_to'] = assignedTo;
                            }
                            if (assignedToIsnull !== undefined) {
                                localVarQueryParameter['assigned_to__isnull'] = assignedToIsnull;
                            }
                            if (resolvedBy !== undefined) {
                                localVarQueryParameter['resolved_by'] = resolvedBy;
                            }
                            if (resolvedByIsnull !== undefined) {
                                localVarQueryParameter['resolved_by__isnull'] = resolvedByIsnull;
                            }
                            if (resolvedAt !== undefined) {
                                localVarQueryParameter['resolved_at'] = (resolvedAt instanceof Date) ?
                                    resolvedAt.toISOString() :
                                    resolvedAt;
                            }
                            if (resolvedAtIsnull !== undefined) {
                                localVarQueryParameter['resolved_at__isnull'] = resolvedAtIsnull;
                            }
                            if (resolvedAtGte !== undefined) {
                                localVarQueryParameter['resolved_at__gte'] = (resolvedAtGte instanceof Date) ?
                                    resolvedAtGte.toISOString().substr(0, 10) :
                                    resolvedAtGte;
                            }
                            if (resolvedAtLte !== undefined) {
                                localVarQueryParameter['resolved_at__lte'] = (resolvedAtLte instanceof Date) ?
                                    resolvedAtLte.toISOString().substr(0, 10) :
                                    resolvedAtLte;
                            }
                            if (snoozedUntil !== undefined) {
                                localVarQueryParameter['snoozed_until'] = (snoozedUntil instanceof Date) ?
                                    snoozedUntil.toISOString() :
                                    snoozedUntil;
                            }
                            if (snoozedUntilIsnull !== undefined) {
                                localVarQueryParameter['snoozed_until__isnull'] = snoozedUntilIsnull;
                            }
                            if (snoozedUntilGte !== undefined) {
                                localVarQueryParameter['snoozed_until__gte'] = (snoozedUntilGte instanceof Date) ?
                                    snoozedUntilGte.toISOString().substr(0, 10) :
                                    snoozedUntilGte;
                            }
                            if (snoozedUntilLte !== undefined) {
                                localVarQueryParameter['snoozed_until__lte'] = (snoozedUntilLte instanceof Date) ?
                                    snoozedUntilLte.toISOString().substr(0, 10) :
                                    snoozedUntilLte;
                            }
                            if (snoozedBy !== undefined) {
                                localVarQueryParameter['snoozed_by'] = snoozedBy;
                            }
                            if (snoozedByIsnull !== undefined) {
                                localVarQueryParameter['snoozed_by__isnull'] = snoozedByIsnull;
                            }
                            if (createdAt !== undefined) {
                                localVarQueryParameter['created_at'] = (createdAt instanceof Date) ?
                                    createdAt.toISOString() :
                                    createdAt;
                            }
                            if (createdAtGte !== undefined) {
                                localVarQueryParameter['created_at__gte'] = (createdAtGte instanceof Date) ?
                                    createdAtGte.toISOString().substr(0, 10) :
                                    createdAtGte;
                            }
                            if (createdAtLte !== undefined) {
                                localVarQueryParameter['created_at__lte'] = (createdAtLte instanceof Date) ?
                                    createdAtLte.toISOString().substr(0, 10) :
                                    createdAtLte;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AlertEventsApiAxiosParamCreator = AlertEventsApiAxiosParamCreator;
/**
 * AlertEventsApi - functional programming interface
 * @export
 */
var AlertEventsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AlertEventsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Assign/Unassign users to an alert event
         * @param {string} alertEventId The id of the alert event
         * @param {InlineObject} inlineObject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertEventsAlertEventIdAssignUsersPost: function (alertEventId, inlineObject, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.alertEventsAlertEventIdAssignUsersPost(alertEventId, inlineObject, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about an alert event
         * @param {string} alertEventId The id of the alert event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertEventsAlertEventIdGet: function (alertEventId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.alertEventsAlertEventIdGet(alertEventId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Resolve an alert event
         * @param {string} alertEventId The id of the alert event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertEventsAlertEventIdResolvePost: function (alertEventId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.alertEventsAlertEventIdResolvePost(alertEventId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of alert events scoped to the authorization token.
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [shipmentId] The id of the shipment
         * @param {string} [alertLevel] The alert level
         * @param {string} [resourceId] The resource_id
         * @param {string} [resourceType] The resource_type
         * @param {string} [secondaryResourceId] The secondary_resource_id
         * @param {string} [secondaryResourceType] The secondary_resource_type
         * @param {string} [configurationId] The configuration id
         * @param {string} [assignedTo] The assigned_to user id
         * @param {boolean} [assignedToIsnull] Filter unassigned
         * @param {string} [resolvedBy] The resolved_by user id
         * @param {boolean} [resolvedByIsnull] Filter unresolved by user
         * @param {string} [resolvedAt] The resolved_at date-time
         * @param {boolean} [resolvedAtIsnull] Filter unresolved
         * @param {string} [resolvedAtGte] Filter resolved on or after a certain date and time
         * @param {string} [resolvedAtLte] Filter resolved on or before a certain date and time
         * @param {string} [snoozedUntil] The snoozed_until date-time
         * @param {boolean} [snoozedUntilIsnull] Filter not snoozed
         * @param {string} [snoozedUntilGte] Filter snoozed until on or after a certain date and time
         * @param {string} [snoozedUntilLte] Filter snoozed until on or before a certain date and time
         * @param {string} [snoozedBy] The snoozed_by user id
         * @param {boolean} [snoozedByIsnull] Filter not snoozed by user
         * @param {string} [createdAt] The created_at date-time
         * @param {string} [createdAtGte] Filter created on or after a certain date and time
         * @param {string} [createdAtLte] Filter created on or before a certain date and time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertEventsGet: function (page, pageSize, ordering, shipmentId, alertLevel, resourceId, resourceType, secondaryResourceId, secondaryResourceType, configurationId, assignedTo, assignedToIsnull, resolvedBy, resolvedByIsnull, resolvedAt, resolvedAtIsnull, resolvedAtGte, resolvedAtLte, snoozedUntil, snoozedUntilIsnull, snoozedUntilGte, snoozedUntilLte, snoozedBy, snoozedByIsnull, createdAt, createdAtGte, createdAtLte, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.alertEventsGet(page, pageSize, ordering, shipmentId, alertLevel, resourceId, resourceType, secondaryResourceId, secondaryResourceType, configurationId, assignedTo, assignedToIsnull, resolvedBy, resolvedByIsnull, resolvedAt, resolvedAtIsnull, resolvedAtGte, resolvedAtLte, snoozedUntil, snoozedUntilIsnull, snoozedUntilGte, snoozedUntilLte, snoozedBy, snoozedByIsnull, createdAt, createdAtGte, createdAtLte, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.AlertEventsApiFp = AlertEventsApiFp;
/**
 * AlertEventsApi - factory interface
 * @export
 */
var AlertEventsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AlertEventsApiFp)(configuration);
    return {
        /**
         *
         * @summary Assign/Unassign users to an alert event
         * @param {string} alertEventId The id of the alert event
         * @param {InlineObject} inlineObject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertEventsAlertEventIdAssignUsersPost: function (alertEventId, inlineObject, options) {
            return localVarFp.alertEventsAlertEventIdAssignUsersPost(alertEventId, inlineObject, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about an alert event
         * @param {string} alertEventId The id of the alert event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertEventsAlertEventIdGet: function (alertEventId, options) {
            return localVarFp.alertEventsAlertEventIdGet(alertEventId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Resolve an alert event
         * @param {string} alertEventId The id of the alert event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertEventsAlertEventIdResolvePost: function (alertEventId, options) {
            return localVarFp.alertEventsAlertEventIdResolvePost(alertEventId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a list of alert events scoped to the authorization token.
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [shipmentId] The id of the shipment
         * @param {string} [alertLevel] The alert level
         * @param {string} [resourceId] The resource_id
         * @param {string} [resourceType] The resource_type
         * @param {string} [secondaryResourceId] The secondary_resource_id
         * @param {string} [secondaryResourceType] The secondary_resource_type
         * @param {string} [configurationId] The configuration id
         * @param {string} [assignedTo] The assigned_to user id
         * @param {boolean} [assignedToIsnull] Filter unassigned
         * @param {string} [resolvedBy] The resolved_by user id
         * @param {boolean} [resolvedByIsnull] Filter unresolved by user
         * @param {string} [resolvedAt] The resolved_at date-time
         * @param {boolean} [resolvedAtIsnull] Filter unresolved
         * @param {string} [resolvedAtGte] Filter resolved on or after a certain date and time
         * @param {string} [resolvedAtLte] Filter resolved on or before a certain date and time
         * @param {string} [snoozedUntil] The snoozed_until date-time
         * @param {boolean} [snoozedUntilIsnull] Filter not snoozed
         * @param {string} [snoozedUntilGte] Filter snoozed until on or after a certain date and time
         * @param {string} [snoozedUntilLte] Filter snoozed until on or before a certain date and time
         * @param {string} [snoozedBy] The snoozed_by user id
         * @param {boolean} [snoozedByIsnull] Filter not snoozed by user
         * @param {string} [createdAt] The created_at date-time
         * @param {string} [createdAtGte] Filter created on or after a certain date and time
         * @param {string} [createdAtLte] Filter created on or before a certain date and time
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        alertEventsGet: function (page, pageSize, ordering, shipmentId, alertLevel, resourceId, resourceType, secondaryResourceId, secondaryResourceType, configurationId, assignedTo, assignedToIsnull, resolvedBy, resolvedByIsnull, resolvedAt, resolvedAtIsnull, resolvedAtGte, resolvedAtLte, snoozedUntil, snoozedUntilIsnull, snoozedUntilGte, snoozedUntilLte, snoozedBy, snoozedByIsnull, createdAt, createdAtGte, createdAtLte, options) {
            return localVarFp.alertEventsGet(page, pageSize, ordering, shipmentId, alertLevel, resourceId, resourceType, secondaryResourceId, secondaryResourceType, configurationId, assignedTo, assignedToIsnull, resolvedBy, resolvedByIsnull, resolvedAt, resolvedAtIsnull, resolvedAtGte, resolvedAtLte, snoozedUntil, snoozedUntilIsnull, snoozedUntilGte, snoozedUntilLte, snoozedBy, snoozedByIsnull, createdAt, createdAtGte, createdAtLte, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AlertEventsApiFactory = AlertEventsApiFactory;
/**
 * AlertEventsApi - object-oriented interface
 * @export
 * @class AlertEventsApi
 * @extends {BaseAPI}
 */
var AlertEventsApi = /** @class */ (function (_super) {
    __extends(AlertEventsApi, _super);
    function AlertEventsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Assign/Unassign users to an alert event
     * @param {string} alertEventId The id of the alert event
     * @param {InlineObject} inlineObject
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertEventsApi
     */
    AlertEventsApi.prototype.alertEventsAlertEventIdAssignUsersPost = function (alertEventId, inlineObject, options) {
        var _this = this;
        return (0, exports.AlertEventsApiFp)(this.configuration).alertEventsAlertEventIdAssignUsersPost(alertEventId, inlineObject, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about an alert event
     * @param {string} alertEventId The id of the alert event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertEventsApi
     */
    AlertEventsApi.prototype.alertEventsAlertEventIdGet = function (alertEventId, options) {
        var _this = this;
        return (0, exports.AlertEventsApiFp)(this.configuration).alertEventsAlertEventIdGet(alertEventId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Resolve an alert event
     * @param {string} alertEventId The id of the alert event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertEventsApi
     */
    AlertEventsApi.prototype.alertEventsAlertEventIdResolvePost = function (alertEventId, options) {
        var _this = this;
        return (0, exports.AlertEventsApiFp)(this.configuration).alertEventsAlertEventIdResolvePost(alertEventId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a list of alert events scoped to the authorization token.
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [shipmentId] The id of the shipment
     * @param {string} [alertLevel] The alert level
     * @param {string} [resourceId] The resource_id
     * @param {string} [resourceType] The resource_type
     * @param {string} [secondaryResourceId] The secondary_resource_id
     * @param {string} [secondaryResourceType] The secondary_resource_type
     * @param {string} [configurationId] The configuration id
     * @param {string} [assignedTo] The assigned_to user id
     * @param {boolean} [assignedToIsnull] Filter unassigned
     * @param {string} [resolvedBy] The resolved_by user id
     * @param {boolean} [resolvedByIsnull] Filter unresolved by user
     * @param {string} [resolvedAt] The resolved_at date-time
     * @param {boolean} [resolvedAtIsnull] Filter unresolved
     * @param {string} [resolvedAtGte] Filter resolved on or after a certain date and time
     * @param {string} [resolvedAtLte] Filter resolved on or before a certain date and time
     * @param {string} [snoozedUntil] The snoozed_until date-time
     * @param {boolean} [snoozedUntilIsnull] Filter not snoozed
     * @param {string} [snoozedUntilGte] Filter snoozed until on or after a certain date and time
     * @param {string} [snoozedUntilLte] Filter snoozed until on or before a certain date and time
     * @param {string} [snoozedBy] The snoozed_by user id
     * @param {boolean} [snoozedByIsnull] Filter not snoozed by user
     * @param {string} [createdAt] The created_at date-time
     * @param {string} [createdAtGte] Filter created on or after a certain date and time
     * @param {string} [createdAtLte] Filter created on or before a certain date and time
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertEventsApi
     */
    AlertEventsApi.prototype.alertEventsGet = function (page, pageSize, ordering, shipmentId, alertLevel, resourceId, resourceType, secondaryResourceId, secondaryResourceType, configurationId, assignedTo, assignedToIsnull, resolvedBy, resolvedByIsnull, resolvedAt, resolvedAtIsnull, resolvedAtGte, resolvedAtLte, snoozedUntil, snoozedUntilIsnull, snoozedUntilGte, snoozedUntilLte, snoozedBy, snoozedByIsnull, createdAt, createdAtGte, createdAtLte, options) {
        var _this = this;
        return (0, exports.AlertEventsApiFp)(this.configuration).alertEventsGet(page, pageSize, ordering, shipmentId, alertLevel, resourceId, resourceType, secondaryResourceId, secondaryResourceType, configurationId, assignedTo, assignedToIsnull, resolvedBy, resolvedByIsnull, resolvedAt, resolvedAtIsnull, resolvedAtGte, resolvedAtLte, snoozedUntil, snoozedUntilIsnull, snoozedUntilGte, snoozedUntilLte, snoozedBy, snoozedByIsnull, createdAt, createdAtGte, createdAtLte, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AlertEventsApi;
}(base_1.BaseAPI));
exports.AlertEventsApi = AlertEventsApi;
/**
 * AnalyticsApi - axios parameter creator
 * @export
 */
var AnalyticsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Resources a user has available under the \'managed\' space
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsIntegrationsLookerContentGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/analytics/integrations/looker/content/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary URL formatted in looker\'s SSO structure for embedded resources
         * @param {string} lookerResource URL to a looker resource that needs to be embedded
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsIntegrationsLookerSignurlGet: function (lookerResource, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'lookerResource' is not null or undefined
                            (0, common_1.assertParamExists)('analyticsIntegrationsLookerSignurlGet', 'lookerResource', lookerResource);
                            localVarPath = "/analytics/integrations/looker/signurl/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (lookerResource !== undefined) {
                                localVarQueryParameter['looker_resource'] = lookerResource;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AnalyticsApiAxiosParamCreator = AnalyticsApiAxiosParamCreator;
/**
 * AnalyticsApi - functional programming interface
 * @export
 */
var AnalyticsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AnalyticsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Resources a user has available under the \'managed\' space
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsIntegrationsLookerContentGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.analyticsIntegrationsLookerContentGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary URL formatted in looker\'s SSO structure for embedded resources
         * @param {string} lookerResource URL to a looker resource that needs to be embedded
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsIntegrationsLookerSignurlGet: function (lookerResource, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.analyticsIntegrationsLookerSignurlGet(lookerResource, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.AnalyticsApiFp = AnalyticsApiFp;
/**
 * AnalyticsApi - factory interface
 * @export
 */
var AnalyticsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AnalyticsApiFp)(configuration);
    return {
        /**
         *
         * @summary Resources a user has available under the \'managed\' space
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsIntegrationsLookerContentGet: function (options) {
            return localVarFp.analyticsIntegrationsLookerContentGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary URL formatted in looker\'s SSO structure for embedded resources
         * @param {string} lookerResource URL to a looker resource that needs to be embedded
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsIntegrationsLookerSignurlGet: function (lookerResource, options) {
            return localVarFp.analyticsIntegrationsLookerSignurlGet(lookerResource, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AnalyticsApiFactory = AnalyticsApiFactory;
/**
 * AnalyticsApi - object-oriented interface
 * @export
 * @class AnalyticsApi
 * @extends {BaseAPI}
 */
var AnalyticsApi = /** @class */ (function (_super) {
    __extends(AnalyticsApi, _super);
    function AnalyticsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Resources a user has available under the \'managed\' space
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    AnalyticsApi.prototype.analyticsIntegrationsLookerContentGet = function (options) {
        var _this = this;
        return (0, exports.AnalyticsApiFp)(this.configuration).analyticsIntegrationsLookerContentGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary URL formatted in looker\'s SSO structure for embedded resources
     * @param {string} lookerResource URL to a looker resource that needs to be embedded
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    AnalyticsApi.prototype.analyticsIntegrationsLookerSignurlGet = function (lookerResource, options) {
        var _this = this;
        return (0, exports.AnalyticsApiFp)(this.configuration).analyticsIntegrationsLookerSignurlGet(lookerResource, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AnalyticsApi;
}(base_1.BaseAPI));
exports.AnalyticsApi = AnalyticsApi;
/**
 * BillingApi - axios parameter creator
 * @export
 */
var BillingApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get information about a specific bill
         * @param {string} billId The id of the bill within Shipwell
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingBillsBillIdGet: function (billId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'billId' is not null or undefined
                            (0, common_1.assertParamExists)('billingBillsBillIdGet', 'billId', billId);
                            localVarPath = "/billing/bills/{billId}"
                                .replace("{".concat("billId", "}"), encodeURIComponent(String(billId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Mark a currently processing bill as error
         * @param {string} billId The id of the bill within Shipwell
         * @param {InlineObject1} inlineObject1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingBillsBillIdProcessingErroredPost: function (billId, inlineObject1, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'billId' is not null or undefined
                            (0, common_1.assertParamExists)('billingBillsBillIdProcessingErroredPost', 'billId', billId);
                            // verify required parameter 'inlineObject1' is not null or undefined
                            (0, common_1.assertParamExists)('billingBillsBillIdProcessingErroredPost', 'inlineObject1', inlineObject1);
                            localVarPath = "/billing/bills/{billId}/processing-errored/"
                                .replace("{".concat("billId", "}"), encodeURIComponent(String(billId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject1, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a specific bill
         * @param {string} billId The id of the bill within Shipwell
         * @param {Bill} bill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingBillsBillIdPut: function (billId, bill, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'billId' is not null or undefined
                            (0, common_1.assertParamExists)('billingBillsBillIdPut', 'billId', billId);
                            // verify required parameter 'bill' is not null or undefined
                            (0, common_1.assertParamExists)('billingBillsBillIdPut', 'bill', bill);
                            localVarPath = "/billing/bills/{billId}"
                                .replace("{".concat("billId", "}"), encodeURIComponent(String(billId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bill, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List all bills for the currently authenticated company
         * @param {string} [docNumber] String, if present, will filter bills by their doc_number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingBillsGet: function (docNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/billing/bills/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (docNumber !== undefined) {
                                localVarQueryParameter['doc_number'] = docNumber;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of available Quickbooks General Ledger Accounts (Bank Checking, Expense)
         * @param {'Bank' | 'Expense'} [accountType] The type of General Ledger Account to retrieve
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksAccountsGet: function (accountType, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/billing/integrations/quickbooks/accounts/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (accountType !== undefined) {
                                localVarQueryParameter['account-type'] = accountType;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Populates Quickbooks Bank Checking and Expense Accounts to the platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksAccountsPost: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/billing/integrations/quickbooks/accounts/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of available Quickbooks Expense Classes
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksExpenseClassesGet: function (page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/billing/integrations/quickbooks/expense-classes/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Populates Quickbooks Expense Classes to the platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksExpenseClassesPost: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/billing/integrations/quickbooks/expense-classes/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of Quickbooks Expense Class and Account to ChargeLineItemCategory mappings
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksExpensesCategoriesMappingGet: function (page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/billing/integrations/quickbooks/expenses-categories-mapping/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a mapping for Quickbooks Expense Class and Account to ChargeLineItemCategory
         * @param {InlineObject2} inlineObject2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksExpensesCategoriesMappingPost: function (inlineObject2, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'inlineObject2' is not null or undefined
                            (0, common_1.assertParamExists)('billingIntegrationsQuickbooksExpensesCategoriesMappingPost', 'inlineObject2', inlineObject2);
                            localVarPath = "/billing/integrations/quickbooks/expenses-categories-mapping/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject2, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a QuickbooksExpensesCategoryMapping
         * @param {string} quickbooksExpensesCategoryMappingId The id of the QuickbooksExpenses to Category Mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksExpensesCategoriesMappingQuickbooksExpensesCategoryMappingIdDelete: function (quickbooksExpensesCategoryMappingId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'quickbooksExpensesCategoryMappingId' is not null or undefined
                            (0, common_1.assertParamExists)('billingIntegrationsQuickbooksExpensesCategoriesMappingQuickbooksExpensesCategoryMappingIdDelete', 'quickbooksExpensesCategoryMappingId', quickbooksExpensesCategoryMappingId);
                            localVarPath = "/billing/integrations/quickbooks/expenses-categories-mapping/{quickbooksExpensesCategoryMappingId}/"
                                .replace("{".concat("quickbooksExpensesCategoryMappingId", "}"), encodeURIComponent(String(quickbooksExpensesCategoryMappingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve specific Quickbooks Expense Account and Class to ChargeLineItemCategory mapping
         * @param {string} quickbooksExpensesCategoryMappingId The id of the QuickbooksExpenses to Category Mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksExpensesCategoriesMappingQuickbooksExpensesCategoryMappingIdGet: function (quickbooksExpensesCategoryMappingId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'quickbooksExpensesCategoryMappingId' is not null or undefined
                            (0, common_1.assertParamExists)('billingIntegrationsQuickbooksExpensesCategoriesMappingQuickbooksExpensesCategoryMappingIdGet', 'quickbooksExpensesCategoryMappingId', quickbooksExpensesCategoryMappingId);
                            localVarPath = "/billing/integrations/quickbooks/expenses-categories-mapping/{quickbooksExpensesCategoryMappingId}/"
                                .replace("{".concat("quickbooksExpensesCategoryMappingId", "}"), encodeURIComponent(String(quickbooksExpensesCategoryMappingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a QuickbooksExpensesCategory Mapping
         * @param {string} quickbooksExpensesCategoryMappingId The id of the QuickbooksExpenses to Category Mapping
         * @param {QuickbooksExpensesCategoryMapping} quickbooksExpensesCategoryMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksExpensesCategoriesMappingQuickbooksExpensesCategoryMappingIdPut: function (quickbooksExpensesCategoryMappingId, quickbooksExpensesCategoryMapping, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'quickbooksExpensesCategoryMappingId' is not null or undefined
                            (0, common_1.assertParamExists)('billingIntegrationsQuickbooksExpensesCategoriesMappingQuickbooksExpensesCategoryMappingIdPut', 'quickbooksExpensesCategoryMappingId', quickbooksExpensesCategoryMappingId);
                            // verify required parameter 'quickbooksExpensesCategoryMapping' is not null or undefined
                            (0, common_1.assertParamExists)('billingIntegrationsQuickbooksExpensesCategoriesMappingQuickbooksExpensesCategoryMappingIdPut', 'quickbooksExpensesCategoryMapping', quickbooksExpensesCategoryMapping);
                            localVarPath = "/billing/integrations/quickbooks/expenses-categories-mapping/{quickbooksExpensesCategoryMappingId}/"
                                .replace("{".concat("quickbooksExpensesCategoryMappingId", "}"), encodeURIComponent(String(quickbooksExpensesCategoryMappingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(quickbooksExpensesCategoryMapping, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of bills for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [q] search query
         * @param {'PROCESSING' | 'ERROR' | 'SUCCESS'} [processingStatus] Filter invoices or bills by processing status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingShipmentsShipmentIdBillsGet: function (shipmentId, page, pageSize, q, processingStatus, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('billingShipmentsShipmentIdBillsGet', 'shipmentId', shipmentId);
                            localVarPath = "/billing/shipments/{shipmentId}/bills/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (processingStatus !== undefined) {
                                localVarQueryParameter['processing_status'] = processingStatus;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a bill for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {InlineObject3} inlineObject3
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingShipmentsShipmentIdBillsPost: function (shipmentId, inlineObject3, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('billingShipmentsShipmentIdBillsPost', 'shipmentId', shipmentId);
                            // verify required parameter 'inlineObject3' is not null or undefined
                            (0, common_1.assertParamExists)('billingShipmentsShipmentIdBillsPost', 'inlineObject3', inlineObject3);
                            localVarPath = "/billing/shipments/{shipmentId}/bills/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject3, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns all delivered shipments that need a vendor-side bill. By default, returns shipments with the state delivered. Can be filtered by the status parameter.
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingUnbilledShipmentsGet: function (page, pageSize, status, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/billing/unbilled-shipments/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (status) {
                                localVarQueryParameter['status'] = status;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.BillingApiAxiosParamCreator = BillingApiAxiosParamCreator;
/**
 * BillingApi - functional programming interface
 * @export
 */
var BillingApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.BillingApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get information about a specific bill
         * @param {string} billId The id of the bill within Shipwell
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingBillsBillIdGet: function (billId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.billingBillsBillIdGet(billId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Mark a currently processing bill as error
         * @param {string} billId The id of the bill within Shipwell
         * @param {InlineObject1} inlineObject1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingBillsBillIdProcessingErroredPost: function (billId, inlineObject1, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.billingBillsBillIdProcessingErroredPost(billId, inlineObject1, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a specific bill
         * @param {string} billId The id of the bill within Shipwell
         * @param {Bill} bill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingBillsBillIdPut: function (billId, bill, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.billingBillsBillIdPut(billId, bill, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List all bills for the currently authenticated company
         * @param {string} [docNumber] String, if present, will filter bills by their doc_number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingBillsGet: function (docNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.billingBillsGet(docNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of available Quickbooks General Ledger Accounts (Bank Checking, Expense)
         * @param {'Bank' | 'Expense'} [accountType] The type of General Ledger Account to retrieve
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksAccountsGet: function (accountType, page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.billingIntegrationsQuickbooksAccountsGet(accountType, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Populates Quickbooks Bank Checking and Expense Accounts to the platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksAccountsPost: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.billingIntegrationsQuickbooksAccountsPost(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of available Quickbooks Expense Classes
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksExpenseClassesGet: function (page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.billingIntegrationsQuickbooksExpenseClassesGet(page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Populates Quickbooks Expense Classes to the platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksExpenseClassesPost: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.billingIntegrationsQuickbooksExpenseClassesPost(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of Quickbooks Expense Class and Account to ChargeLineItemCategory mappings
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksExpensesCategoriesMappingGet: function (page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.billingIntegrationsQuickbooksExpensesCategoriesMappingGet(page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a mapping for Quickbooks Expense Class and Account to ChargeLineItemCategory
         * @param {InlineObject2} inlineObject2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksExpensesCategoriesMappingPost: function (inlineObject2, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.billingIntegrationsQuickbooksExpensesCategoriesMappingPost(inlineObject2, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a QuickbooksExpensesCategoryMapping
         * @param {string} quickbooksExpensesCategoryMappingId The id of the QuickbooksExpenses to Category Mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksExpensesCategoriesMappingQuickbooksExpensesCategoryMappingIdDelete: function (quickbooksExpensesCategoryMappingId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.billingIntegrationsQuickbooksExpensesCategoriesMappingQuickbooksExpensesCategoryMappingIdDelete(quickbooksExpensesCategoryMappingId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve specific Quickbooks Expense Account and Class to ChargeLineItemCategory mapping
         * @param {string} quickbooksExpensesCategoryMappingId The id of the QuickbooksExpenses to Category Mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksExpensesCategoriesMappingQuickbooksExpensesCategoryMappingIdGet: function (quickbooksExpensesCategoryMappingId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.billingIntegrationsQuickbooksExpensesCategoriesMappingQuickbooksExpensesCategoryMappingIdGet(quickbooksExpensesCategoryMappingId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a QuickbooksExpensesCategory Mapping
         * @param {string} quickbooksExpensesCategoryMappingId The id of the QuickbooksExpenses to Category Mapping
         * @param {QuickbooksExpensesCategoryMapping} quickbooksExpensesCategoryMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksExpensesCategoriesMappingQuickbooksExpensesCategoryMappingIdPut: function (quickbooksExpensesCategoryMappingId, quickbooksExpensesCategoryMapping, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.billingIntegrationsQuickbooksExpensesCategoriesMappingQuickbooksExpensesCategoryMappingIdPut(quickbooksExpensesCategoryMappingId, quickbooksExpensesCategoryMapping, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of bills for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [q] search query
         * @param {'PROCESSING' | 'ERROR' | 'SUCCESS'} [processingStatus] Filter invoices or bills by processing status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingShipmentsShipmentIdBillsGet: function (shipmentId, page, pageSize, q, processingStatus, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.billingShipmentsShipmentIdBillsGet(shipmentId, page, pageSize, q, processingStatus, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a bill for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {InlineObject3} inlineObject3
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingShipmentsShipmentIdBillsPost: function (shipmentId, inlineObject3, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.billingShipmentsShipmentIdBillsPost(shipmentId, inlineObject3, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns all delivered shipments that need a vendor-side bill. By default, returns shipments with the state delivered. Can be filtered by the status parameter.
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingUnbilledShipmentsGet: function (page, pageSize, status, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.billingUnbilledShipmentsGet(page, pageSize, status, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.BillingApiFp = BillingApiFp;
/**
 * BillingApi - factory interface
 * @export
 */
var BillingApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.BillingApiFp)(configuration);
    return {
        /**
         *
         * @summary Get information about a specific bill
         * @param {string} billId The id of the bill within Shipwell
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingBillsBillIdGet: function (billId, options) {
            return localVarFp.billingBillsBillIdGet(billId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Mark a currently processing bill as error
         * @param {string} billId The id of the bill within Shipwell
         * @param {InlineObject1} inlineObject1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingBillsBillIdProcessingErroredPost: function (billId, inlineObject1, options) {
            return localVarFp.billingBillsBillIdProcessingErroredPost(billId, inlineObject1, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a specific bill
         * @param {string} billId The id of the bill within Shipwell
         * @param {Bill} bill
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingBillsBillIdPut: function (billId, bill, options) {
            return localVarFp.billingBillsBillIdPut(billId, bill, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List all bills for the currently authenticated company
         * @param {string} [docNumber] String, if present, will filter bills by their doc_number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingBillsGet: function (docNumber, options) {
            return localVarFp.billingBillsGet(docNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a list of available Quickbooks General Ledger Accounts (Bank Checking, Expense)
         * @param {'Bank' | 'Expense'} [accountType] The type of General Ledger Account to retrieve
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksAccountsGet: function (accountType, page, pageSize, options) {
            return localVarFp.billingIntegrationsQuickbooksAccountsGet(accountType, page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Populates Quickbooks Bank Checking and Expense Accounts to the platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksAccountsPost: function (options) {
            return localVarFp.billingIntegrationsQuickbooksAccountsPost(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a list of available Quickbooks Expense Classes
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksExpenseClassesGet: function (page, pageSize, options) {
            return localVarFp.billingIntegrationsQuickbooksExpenseClassesGet(page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Populates Quickbooks Expense Classes to the platform
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksExpenseClassesPost: function (options) {
            return localVarFp.billingIntegrationsQuickbooksExpenseClassesPost(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a list of Quickbooks Expense Class and Account to ChargeLineItemCategory mappings
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksExpensesCategoriesMappingGet: function (page, pageSize, options) {
            return localVarFp.billingIntegrationsQuickbooksExpensesCategoriesMappingGet(page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a mapping for Quickbooks Expense Class and Account to ChargeLineItemCategory
         * @param {InlineObject2} inlineObject2
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksExpensesCategoriesMappingPost: function (inlineObject2, options) {
            return localVarFp.billingIntegrationsQuickbooksExpensesCategoriesMappingPost(inlineObject2, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a QuickbooksExpensesCategoryMapping
         * @param {string} quickbooksExpensesCategoryMappingId The id of the QuickbooksExpenses to Category Mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksExpensesCategoriesMappingQuickbooksExpensesCategoryMappingIdDelete: function (quickbooksExpensesCategoryMappingId, options) {
            return localVarFp.billingIntegrationsQuickbooksExpensesCategoriesMappingQuickbooksExpensesCategoryMappingIdDelete(quickbooksExpensesCategoryMappingId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve specific Quickbooks Expense Account and Class to ChargeLineItemCategory mapping
         * @param {string} quickbooksExpensesCategoryMappingId The id of the QuickbooksExpenses to Category Mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksExpensesCategoriesMappingQuickbooksExpensesCategoryMappingIdGet: function (quickbooksExpensesCategoryMappingId, options) {
            return localVarFp.billingIntegrationsQuickbooksExpensesCategoriesMappingQuickbooksExpensesCategoryMappingIdGet(quickbooksExpensesCategoryMappingId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a QuickbooksExpensesCategory Mapping
         * @param {string} quickbooksExpensesCategoryMappingId The id of the QuickbooksExpenses to Category Mapping
         * @param {QuickbooksExpensesCategoryMapping} quickbooksExpensesCategoryMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingIntegrationsQuickbooksExpensesCategoriesMappingQuickbooksExpensesCategoryMappingIdPut: function (quickbooksExpensesCategoryMappingId, quickbooksExpensesCategoryMapping, options) {
            return localVarFp.billingIntegrationsQuickbooksExpensesCategoriesMappingQuickbooksExpensesCategoryMappingIdPut(quickbooksExpensesCategoryMappingId, quickbooksExpensesCategoryMapping, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a list of bills for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [q] search query
         * @param {'PROCESSING' | 'ERROR' | 'SUCCESS'} [processingStatus] Filter invoices or bills by processing status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingShipmentsShipmentIdBillsGet: function (shipmentId, page, pageSize, q, processingStatus, options) {
            return localVarFp.billingShipmentsShipmentIdBillsGet(shipmentId, page, pageSize, q, processingStatus, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a bill for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {InlineObject3} inlineObject3
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingShipmentsShipmentIdBillsPost: function (shipmentId, inlineObject3, options) {
            return localVarFp.billingShipmentsShipmentIdBillsPost(shipmentId, inlineObject3, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns all delivered shipments that need a vendor-side bill. By default, returns shipments with the state delivered. Can be filtered by the status parameter.
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        billingUnbilledShipmentsGet: function (page, pageSize, status, options) {
            return localVarFp.billingUnbilledShipmentsGet(page, pageSize, status, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.BillingApiFactory = BillingApiFactory;
/**
 * BillingApi - object-oriented interface
 * @export
 * @class BillingApi
 * @extends {BaseAPI}
 */
var BillingApi = /** @class */ (function (_super) {
    __extends(BillingApi, _super);
    function BillingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get information about a specific bill
     * @param {string} billId The id of the bill within Shipwell
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.billingBillsBillIdGet = function (billId, options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).billingBillsBillIdGet(billId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Mark a currently processing bill as error
     * @param {string} billId The id of the bill within Shipwell
     * @param {InlineObject1} inlineObject1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.billingBillsBillIdProcessingErroredPost = function (billId, inlineObject1, options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).billingBillsBillIdProcessingErroredPost(billId, inlineObject1, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a specific bill
     * @param {string} billId The id of the bill within Shipwell
     * @param {Bill} bill
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.billingBillsBillIdPut = function (billId, bill, options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).billingBillsBillIdPut(billId, bill, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List all bills for the currently authenticated company
     * @param {string} [docNumber] String, if present, will filter bills by their doc_number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.billingBillsGet = function (docNumber, options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).billingBillsGet(docNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a list of available Quickbooks General Ledger Accounts (Bank Checking, Expense)
     * @param {'Bank' | 'Expense'} [accountType] The type of General Ledger Account to retrieve
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.billingIntegrationsQuickbooksAccountsGet = function (accountType, page, pageSize, options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).billingIntegrationsQuickbooksAccountsGet(accountType, page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Populates Quickbooks Bank Checking and Expense Accounts to the platform
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.billingIntegrationsQuickbooksAccountsPost = function (options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).billingIntegrationsQuickbooksAccountsPost(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a list of available Quickbooks Expense Classes
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.billingIntegrationsQuickbooksExpenseClassesGet = function (page, pageSize, options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).billingIntegrationsQuickbooksExpenseClassesGet(page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Populates Quickbooks Expense Classes to the platform
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.billingIntegrationsQuickbooksExpenseClassesPost = function (options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).billingIntegrationsQuickbooksExpenseClassesPost(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a list of Quickbooks Expense Class and Account to ChargeLineItemCategory mappings
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.billingIntegrationsQuickbooksExpensesCategoriesMappingGet = function (page, pageSize, options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).billingIntegrationsQuickbooksExpensesCategoriesMappingGet(page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a mapping for Quickbooks Expense Class and Account to ChargeLineItemCategory
     * @param {InlineObject2} inlineObject2
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.billingIntegrationsQuickbooksExpensesCategoriesMappingPost = function (inlineObject2, options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).billingIntegrationsQuickbooksExpensesCategoriesMappingPost(inlineObject2, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a QuickbooksExpensesCategoryMapping
     * @param {string} quickbooksExpensesCategoryMappingId The id of the QuickbooksExpenses to Category Mapping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.billingIntegrationsQuickbooksExpensesCategoriesMappingQuickbooksExpensesCategoryMappingIdDelete = function (quickbooksExpensesCategoryMappingId, options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).billingIntegrationsQuickbooksExpensesCategoriesMappingQuickbooksExpensesCategoryMappingIdDelete(quickbooksExpensesCategoryMappingId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve specific Quickbooks Expense Account and Class to ChargeLineItemCategory mapping
     * @param {string} quickbooksExpensesCategoryMappingId The id of the QuickbooksExpenses to Category Mapping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.billingIntegrationsQuickbooksExpensesCategoriesMappingQuickbooksExpensesCategoryMappingIdGet = function (quickbooksExpensesCategoryMappingId, options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).billingIntegrationsQuickbooksExpensesCategoriesMappingQuickbooksExpensesCategoryMappingIdGet(quickbooksExpensesCategoryMappingId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a QuickbooksExpensesCategory Mapping
     * @param {string} quickbooksExpensesCategoryMappingId The id of the QuickbooksExpenses to Category Mapping
     * @param {QuickbooksExpensesCategoryMapping} quickbooksExpensesCategoryMapping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.billingIntegrationsQuickbooksExpensesCategoriesMappingQuickbooksExpensesCategoryMappingIdPut = function (quickbooksExpensesCategoryMappingId, quickbooksExpensesCategoryMapping, options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).billingIntegrationsQuickbooksExpensesCategoriesMappingQuickbooksExpensesCategoryMappingIdPut(quickbooksExpensesCategoryMappingId, quickbooksExpensesCategoryMapping, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a list of bills for a shipment
     * @param {string} shipmentId The id of the shipment
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [q] search query
     * @param {'PROCESSING' | 'ERROR' | 'SUCCESS'} [processingStatus] Filter invoices or bills by processing status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.billingShipmentsShipmentIdBillsGet = function (shipmentId, page, pageSize, q, processingStatus, options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).billingShipmentsShipmentIdBillsGet(shipmentId, page, pageSize, q, processingStatus, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a bill for a shipment
     * @param {string} shipmentId The id of the shipment
     * @param {InlineObject3} inlineObject3
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.billingShipmentsShipmentIdBillsPost = function (shipmentId, inlineObject3, options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).billingShipmentsShipmentIdBillsPost(shipmentId, inlineObject3, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns all delivered shipments that need a vendor-side bill. By default, returns shipments with the state delivered. Can be filtered by the status parameter.
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingApi
     */
    BillingApi.prototype.billingUnbilledShipmentsGet = function (page, pageSize, status, options) {
        var _this = this;
        return (0, exports.BillingApiFp)(this.configuration).billingUnbilledShipmentsGet(page, pageSize, status, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return BillingApi;
}(base_1.BaseAPI));
exports.BillingApi = BillingApi;
/**
 * CarrierBidsApi - axios parameter creator
 * @export
 */
var CarrierBidsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Delete a carrier bid
         * @param {string} carrierBidId The id of the carrier bid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCarrierBidsCarrierBidIdDelete: function (carrierBidId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierBidId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingCarrierBidsCarrierBidIdDelete', 'carrierBidId', carrierBidId);
                            localVarPath = "/quoting/carrier-bids/{carrierBidId}/"
                                .replace("{".concat("carrierBidId", "}"), encodeURIComponent(String(carrierBidId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a carrier bid
         * @param {string} carrierBidId The id of the carrier bid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCarrierBidsCarrierBidIdGet: function (carrierBidId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierBidId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingCarrierBidsCarrierBidIdGet', 'carrierBidId', carrierBidId);
                            localVarPath = "/quoting/carrier-bids/{carrierBidId}/"
                                .replace("{".concat("carrierBidId", "}"), encodeURIComponent(String(carrierBidId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a carrier bid
         * @param {string} carrierBidId The id of the carrier bid
         * @param {CarrierBid} carrierBid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCarrierBidsCarrierBidIdPut: function (carrierBidId, carrierBid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierBidId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingCarrierBidsCarrierBidIdPut', 'carrierBidId', carrierBidId);
                            // verify required parameter 'carrierBid' is not null or undefined
                            (0, common_1.assertParamExists)('quotingCarrierBidsCarrierBidIdPut', 'carrierBid', carrierBid);
                            localVarPath = "/quoting/carrier-bids/{carrierBidId}/"
                                .replace("{".concat("carrierBidId", "}"), encodeURIComponent(String(carrierBidId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(carrierBid, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List all carrier bids
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [shipmentId] Filter objects down to bids matching the provided shipment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCarrierBidsGet: function (page, pageSize, ordering, shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/quoting/carrier-bids/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (shipmentId !== undefined) {
                                localVarQueryParameter['shipment_id'] = shipmentId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a carrier bid
         * @param {CarrierBid} carrierBid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCarrierBidsPost: function (carrierBid, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierBid' is not null or undefined
                            (0, common_1.assertParamExists)('quotingCarrierBidsPost', 'carrierBid', carrierBid);
                            localVarPath = "/quoting/carrier-bids/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(carrierBid, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List carrier bidding-specific information about shipments
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
         * @param {boolean} [open] Filter on whether or not a shipment is open
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCarrierBidsShipmentSummaryGet: function (page, pageSize, ordering, q, status, open, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/quoting/carrier-bids/shipment-summary/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (status) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (open !== undefined) {
                                localVarQueryParameter['open'] = open;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CarrierBidsApiAxiosParamCreator = CarrierBidsApiAxiosParamCreator;
/**
 * CarrierBidsApi - functional programming interface
 * @export
 */
var CarrierBidsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CarrierBidsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Delete a carrier bid
         * @param {string} carrierBidId The id of the carrier bid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCarrierBidsCarrierBidIdDelete: function (carrierBidId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingCarrierBidsCarrierBidIdDelete(carrierBidId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a carrier bid
         * @param {string} carrierBidId The id of the carrier bid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCarrierBidsCarrierBidIdGet: function (carrierBidId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingCarrierBidsCarrierBidIdGet(carrierBidId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a carrier bid
         * @param {string} carrierBidId The id of the carrier bid
         * @param {CarrierBid} carrierBid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCarrierBidsCarrierBidIdPut: function (carrierBidId, carrierBid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingCarrierBidsCarrierBidIdPut(carrierBidId, carrierBid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List all carrier bids
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [shipmentId] Filter objects down to bids matching the provided shipment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCarrierBidsGet: function (page, pageSize, ordering, shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingCarrierBidsGet(page, pageSize, ordering, shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a carrier bid
         * @param {CarrierBid} carrierBid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCarrierBidsPost: function (carrierBid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingCarrierBidsPost(carrierBid, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List carrier bidding-specific information about shipments
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
         * @param {boolean} [open] Filter on whether or not a shipment is open
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCarrierBidsShipmentSummaryGet: function (page, pageSize, ordering, q, status, open, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingCarrierBidsShipmentSummaryGet(page, pageSize, ordering, q, status, open, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CarrierBidsApiFp = CarrierBidsApiFp;
/**
 * CarrierBidsApi - factory interface
 * @export
 */
var CarrierBidsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CarrierBidsApiFp)(configuration);
    return {
        /**
         *
         * @summary Delete a carrier bid
         * @param {string} carrierBidId The id of the carrier bid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCarrierBidsCarrierBidIdDelete: function (carrierBidId, options) {
            return localVarFp.quotingCarrierBidsCarrierBidIdDelete(carrierBidId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a carrier bid
         * @param {string} carrierBidId The id of the carrier bid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCarrierBidsCarrierBidIdGet: function (carrierBidId, options) {
            return localVarFp.quotingCarrierBidsCarrierBidIdGet(carrierBidId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a carrier bid
         * @param {string} carrierBidId The id of the carrier bid
         * @param {CarrierBid} carrierBid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCarrierBidsCarrierBidIdPut: function (carrierBidId, carrierBid, options) {
            return localVarFp.quotingCarrierBidsCarrierBidIdPut(carrierBidId, carrierBid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List all carrier bids
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [shipmentId] Filter objects down to bids matching the provided shipment ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCarrierBidsGet: function (page, pageSize, ordering, shipmentId, options) {
            return localVarFp.quotingCarrierBidsGet(page, pageSize, ordering, shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a carrier bid
         * @param {CarrierBid} carrierBid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCarrierBidsPost: function (carrierBid, options) {
            return localVarFp.quotingCarrierBidsPost(carrierBid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List carrier bidding-specific information about shipments
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
         * @param {boolean} [open] Filter on whether or not a shipment is open
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCarrierBidsShipmentSummaryGet: function (page, pageSize, ordering, q, status, open, options) {
            return localVarFp.quotingCarrierBidsShipmentSummaryGet(page, pageSize, ordering, q, status, open, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CarrierBidsApiFactory = CarrierBidsApiFactory;
/**
 * CarrierBidsApi - object-oriented interface
 * @export
 * @class CarrierBidsApi
 * @extends {BaseAPI}
 */
var CarrierBidsApi = /** @class */ (function (_super) {
    __extends(CarrierBidsApi, _super);
    function CarrierBidsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Delete a carrier bid
     * @param {string} carrierBidId The id of the carrier bid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierBidsApi
     */
    CarrierBidsApi.prototype.quotingCarrierBidsCarrierBidIdDelete = function (carrierBidId, options) {
        var _this = this;
        return (0, exports.CarrierBidsApiFp)(this.configuration).quotingCarrierBidsCarrierBidIdDelete(carrierBidId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a carrier bid
     * @param {string} carrierBidId The id of the carrier bid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierBidsApi
     */
    CarrierBidsApi.prototype.quotingCarrierBidsCarrierBidIdGet = function (carrierBidId, options) {
        var _this = this;
        return (0, exports.CarrierBidsApiFp)(this.configuration).quotingCarrierBidsCarrierBidIdGet(carrierBidId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a carrier bid
     * @param {string} carrierBidId The id of the carrier bid
     * @param {CarrierBid} carrierBid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierBidsApi
     */
    CarrierBidsApi.prototype.quotingCarrierBidsCarrierBidIdPut = function (carrierBidId, carrierBid, options) {
        var _this = this;
        return (0, exports.CarrierBidsApiFp)(this.configuration).quotingCarrierBidsCarrierBidIdPut(carrierBidId, carrierBid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List all carrier bids
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [shipmentId] Filter objects down to bids matching the provided shipment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierBidsApi
     */
    CarrierBidsApi.prototype.quotingCarrierBidsGet = function (page, pageSize, ordering, shipmentId, options) {
        var _this = this;
        return (0, exports.CarrierBidsApiFp)(this.configuration).quotingCarrierBidsGet(page, pageSize, ordering, shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a carrier bid
     * @param {CarrierBid} carrierBid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierBidsApi
     */
    CarrierBidsApi.prototype.quotingCarrierBidsPost = function (carrierBid, options) {
        var _this = this;
        return (0, exports.CarrierBidsApiFp)(this.configuration).quotingCarrierBidsPost(carrierBid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List carrier bidding-specific information about shipments
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
     * @param {boolean} [open] Filter on whether or not a shipment is open
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierBidsApi
     */
    CarrierBidsApi.prototype.quotingCarrierBidsShipmentSummaryGet = function (page, pageSize, ordering, q, status, open, options) {
        var _this = this;
        return (0, exports.CarrierBidsApiFp)(this.configuration).quotingCarrierBidsShipmentSummaryGet(page, pageSize, ordering, q, status, open, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CarrierBidsApi;
}(base_1.BaseAPI));
exports.CarrierBidsApi = CarrierBidsApi;
/**
 * CarrierCapacityApi - axios parameter creator
 * @export
 */
var CarrierCapacityApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get information on whether carrier has capacity or not
         * @param {string} shipmentId The id of the shipment for which carrier capacity should be determined
         * @param {string} contractId The id of the contract between customer and carrier required to determine carrier capacity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierCapacityCarrierCapacityAvailableGet: function (shipmentId, contractId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierCapacityCarrierCapacityAvailableGet', 'shipmentId', shipmentId);
                            // verify required parameter 'contractId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierCapacityCarrierCapacityAvailableGet', 'contractId', contractId);
                            localVarPath = "/carrier-capacity/carrier-capacity/available/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (shipmentId !== undefined) {
                                localVarQueryParameter['shipment_id'] = shipmentId;
                            }
                            if (contractId !== undefined) {
                                localVarQueryParameter['contract_id'] = contractId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get specified carrier capacity record
         * @param {string} carrierCapacityRecordId The id of the carrier capacity record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierCapacityCarrierCapacityCarrierCapacityRecordIdGet: function (carrierCapacityRecordId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierCapacityRecordId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierCapacityCarrierCapacityCarrierCapacityRecordIdGet', 'carrierCapacityRecordId', carrierCapacityRecordId);
                            localVarPath = "/carrier-capacity/carrier-capacity/{carrierCapacityRecordId}/"
                                .replace("{".concat("carrierCapacityRecordId", "}"), encodeURIComponent(String(carrierCapacityRecordId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of carrier capacity record
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [carrierCapacityCarrierId] The id of the carrier company
         * @param {string} [pickupCustomerLocationReference] The location reference of the AddressBook
         * @param {string} [pickupDate] The pickup date
         * @param {string} [pickupDateLt] The pickup date
         * @param {string} [pickupDateLte] The pickup date
         * @param {string} [pickupDateGt] The pickup date
         * @param {string} [pickupDateGte] The pickup date
         * @param {string} [pickupAddress1] The address_1 of the pickup address for a CarrierCapacityRecord
         * @param {string} [pickupAddress2] The address_2 of the pickup address for a CarrierCapacityRecord
         * @param {string} [pickupCity] The city of the pickup address for a CarrierCapacityRecord
         * @param {string} [pickupStateProvince] The state_province of the pickup address for a CarrierCapacityRecord
         * @param {string} [pickupCountry] The country of the pickup address for a CarrierCapacityRecord
         * @param {string} [pickupPostalCode] The postal_code of the pickup address for a CarrierCapacityRecord
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierCapacityCarrierCapacityGet: function (page, pageSize, ordering, carrierCapacityCarrierId, pickupCustomerLocationReference, pickupDate, pickupDateLt, pickupDateLte, pickupDateGt, pickupDateGte, pickupAddress1, pickupAddress2, pickupCity, pickupStateProvince, pickupCountry, pickupPostalCode, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/carrier-capacity/carrier-capacity/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (carrierCapacityCarrierId !== undefined) {
                                localVarQueryParameter['carrier_capacity_carrier_id'] = carrierCapacityCarrierId;
                            }
                            if (pickupCustomerLocationReference !== undefined) {
                                localVarQueryParameter['pickup_customer_location_reference'] = pickupCustomerLocationReference;
                            }
                            if (pickupDate !== undefined) {
                                localVarQueryParameter['pickup_date'] = (pickupDate instanceof Date) ?
                                    pickupDate.toISOString().substr(0, 10) :
                                    pickupDate;
                            }
                            if (pickupDateLt !== undefined) {
                                localVarQueryParameter['pickup_date__lt'] = (pickupDateLt instanceof Date) ?
                                    pickupDateLt.toISOString().substr(0, 10) :
                                    pickupDateLt;
                            }
                            if (pickupDateLte !== undefined) {
                                localVarQueryParameter['pickup_date__lte'] = (pickupDateLte instanceof Date) ?
                                    pickupDateLte.toISOString().substr(0, 10) :
                                    pickupDateLte;
                            }
                            if (pickupDateGt !== undefined) {
                                localVarQueryParameter['pickup_date__gt'] = (pickupDateGt instanceof Date) ?
                                    pickupDateGt.toISOString().substr(0, 10) :
                                    pickupDateGt;
                            }
                            if (pickupDateGte !== undefined) {
                                localVarQueryParameter['pickup_date__gte'] = (pickupDateGte instanceof Date) ?
                                    pickupDateGte.toISOString().substr(0, 10) :
                                    pickupDateGte;
                            }
                            if (pickupAddress1 !== undefined) {
                                localVarQueryParameter['pickup_address_1'] = pickupAddress1;
                            }
                            if (pickupAddress2 !== undefined) {
                                localVarQueryParameter['pickup_address_2'] = pickupAddress2;
                            }
                            if (pickupCity !== undefined) {
                                localVarQueryParameter['pickup_city'] = pickupCity;
                            }
                            if (pickupStateProvince !== undefined) {
                                localVarQueryParameter['pickup_state_province'] = pickupStateProvince;
                            }
                            if (pickupCountry !== undefined) {
                                localVarQueryParameter['pickup_country'] = pickupCountry;
                            }
                            if (pickupPostalCode !== undefined) {
                                localVarQueryParameter['pickup_postal_code'] = pickupPostalCode;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information on whether location has capacity or not
         * @param {string} shipmentId The id of the shipment for which location capacity should be determined
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierCapacityLocationCapacityAvailableGet: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierCapacityLocationCapacityAvailableGet', 'shipmentId', shipmentId);
                            localVarPath = "/carrier-capacity/location-capacity/available/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (shipmentId !== undefined) {
                                localVarQueryParameter['shipment_id'] = shipmentId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CarrierCapacityApiAxiosParamCreator = CarrierCapacityApiAxiosParamCreator;
/**
 * CarrierCapacityApi - functional programming interface
 * @export
 */
var CarrierCapacityApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CarrierCapacityApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get information on whether carrier has capacity or not
         * @param {string} shipmentId The id of the shipment for which carrier capacity should be determined
         * @param {string} contractId The id of the contract between customer and carrier required to determine carrier capacity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierCapacityCarrierCapacityAvailableGet: function (shipmentId, contractId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierCapacityCarrierCapacityAvailableGet(shipmentId, contractId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get specified carrier capacity record
         * @param {string} carrierCapacityRecordId The id of the carrier capacity record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierCapacityCarrierCapacityCarrierCapacityRecordIdGet: function (carrierCapacityRecordId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierCapacityCarrierCapacityCarrierCapacityRecordIdGet(carrierCapacityRecordId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of carrier capacity record
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [carrierCapacityCarrierId] The id of the carrier company
         * @param {string} [pickupCustomerLocationReference] The location reference of the AddressBook
         * @param {string} [pickupDate] The pickup date
         * @param {string} [pickupDateLt] The pickup date
         * @param {string} [pickupDateLte] The pickup date
         * @param {string} [pickupDateGt] The pickup date
         * @param {string} [pickupDateGte] The pickup date
         * @param {string} [pickupAddress1] The address_1 of the pickup address for a CarrierCapacityRecord
         * @param {string} [pickupAddress2] The address_2 of the pickup address for a CarrierCapacityRecord
         * @param {string} [pickupCity] The city of the pickup address for a CarrierCapacityRecord
         * @param {string} [pickupStateProvince] The state_province of the pickup address for a CarrierCapacityRecord
         * @param {string} [pickupCountry] The country of the pickup address for a CarrierCapacityRecord
         * @param {string} [pickupPostalCode] The postal_code of the pickup address for a CarrierCapacityRecord
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierCapacityCarrierCapacityGet: function (page, pageSize, ordering, carrierCapacityCarrierId, pickupCustomerLocationReference, pickupDate, pickupDateLt, pickupDateLte, pickupDateGt, pickupDateGte, pickupAddress1, pickupAddress2, pickupCity, pickupStateProvince, pickupCountry, pickupPostalCode, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierCapacityCarrierCapacityGet(page, pageSize, ordering, carrierCapacityCarrierId, pickupCustomerLocationReference, pickupDate, pickupDateLt, pickupDateLte, pickupDateGt, pickupDateGte, pickupAddress1, pickupAddress2, pickupCity, pickupStateProvince, pickupCountry, pickupPostalCode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information on whether location has capacity or not
         * @param {string} shipmentId The id of the shipment for which location capacity should be determined
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierCapacityLocationCapacityAvailableGet: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierCapacityLocationCapacityAvailableGet(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CarrierCapacityApiFp = CarrierCapacityApiFp;
/**
 * CarrierCapacityApi - factory interface
 * @export
 */
var CarrierCapacityApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CarrierCapacityApiFp)(configuration);
    return {
        /**
         *
         * @summary Get information on whether carrier has capacity or not
         * @param {string} shipmentId The id of the shipment for which carrier capacity should be determined
         * @param {string} contractId The id of the contract between customer and carrier required to determine carrier capacity
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierCapacityCarrierCapacityAvailableGet: function (shipmentId, contractId, options) {
            return localVarFp.carrierCapacityCarrierCapacityAvailableGet(shipmentId, contractId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get specified carrier capacity record
         * @param {string} carrierCapacityRecordId The id of the carrier capacity record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierCapacityCarrierCapacityCarrierCapacityRecordIdGet: function (carrierCapacityRecordId, options) {
            return localVarFp.carrierCapacityCarrierCapacityCarrierCapacityRecordIdGet(carrierCapacityRecordId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a list of carrier capacity record
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [carrierCapacityCarrierId] The id of the carrier company
         * @param {string} [pickupCustomerLocationReference] The location reference of the AddressBook
         * @param {string} [pickupDate] The pickup date
         * @param {string} [pickupDateLt] The pickup date
         * @param {string} [pickupDateLte] The pickup date
         * @param {string} [pickupDateGt] The pickup date
         * @param {string} [pickupDateGte] The pickup date
         * @param {string} [pickupAddress1] The address_1 of the pickup address for a CarrierCapacityRecord
         * @param {string} [pickupAddress2] The address_2 of the pickup address for a CarrierCapacityRecord
         * @param {string} [pickupCity] The city of the pickup address for a CarrierCapacityRecord
         * @param {string} [pickupStateProvince] The state_province of the pickup address for a CarrierCapacityRecord
         * @param {string} [pickupCountry] The country of the pickup address for a CarrierCapacityRecord
         * @param {string} [pickupPostalCode] The postal_code of the pickup address for a CarrierCapacityRecord
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierCapacityCarrierCapacityGet: function (page, pageSize, ordering, carrierCapacityCarrierId, pickupCustomerLocationReference, pickupDate, pickupDateLt, pickupDateLte, pickupDateGt, pickupDateGte, pickupAddress1, pickupAddress2, pickupCity, pickupStateProvince, pickupCountry, pickupPostalCode, options) {
            return localVarFp.carrierCapacityCarrierCapacityGet(page, pageSize, ordering, carrierCapacityCarrierId, pickupCustomerLocationReference, pickupDate, pickupDateLt, pickupDateLte, pickupDateGt, pickupDateGte, pickupAddress1, pickupAddress2, pickupCity, pickupStateProvince, pickupCountry, pickupPostalCode, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information on whether location has capacity or not
         * @param {string} shipmentId The id of the shipment for which location capacity should be determined
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierCapacityLocationCapacityAvailableGet: function (shipmentId, options) {
            return localVarFp.carrierCapacityLocationCapacityAvailableGet(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CarrierCapacityApiFactory = CarrierCapacityApiFactory;
/**
 * CarrierCapacityApi - object-oriented interface
 * @export
 * @class CarrierCapacityApi
 * @extends {BaseAPI}
 */
var CarrierCapacityApi = /** @class */ (function (_super) {
    __extends(CarrierCapacityApi, _super);
    function CarrierCapacityApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get information on whether carrier has capacity or not
     * @param {string} shipmentId The id of the shipment for which carrier capacity should be determined
     * @param {string} contractId The id of the contract between customer and carrier required to determine carrier capacity
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierCapacityApi
     */
    CarrierCapacityApi.prototype.carrierCapacityCarrierCapacityAvailableGet = function (shipmentId, contractId, options) {
        var _this = this;
        return (0, exports.CarrierCapacityApiFp)(this.configuration).carrierCapacityCarrierCapacityAvailableGet(shipmentId, contractId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get specified carrier capacity record
     * @param {string} carrierCapacityRecordId The id of the carrier capacity record
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierCapacityApi
     */
    CarrierCapacityApi.prototype.carrierCapacityCarrierCapacityCarrierCapacityRecordIdGet = function (carrierCapacityRecordId, options) {
        var _this = this;
        return (0, exports.CarrierCapacityApiFp)(this.configuration).carrierCapacityCarrierCapacityCarrierCapacityRecordIdGet(carrierCapacityRecordId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a list of carrier capacity record
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [carrierCapacityCarrierId] The id of the carrier company
     * @param {string} [pickupCustomerLocationReference] The location reference of the AddressBook
     * @param {string} [pickupDate] The pickup date
     * @param {string} [pickupDateLt] The pickup date
     * @param {string} [pickupDateLte] The pickup date
     * @param {string} [pickupDateGt] The pickup date
     * @param {string} [pickupDateGte] The pickup date
     * @param {string} [pickupAddress1] The address_1 of the pickup address for a CarrierCapacityRecord
     * @param {string} [pickupAddress2] The address_2 of the pickup address for a CarrierCapacityRecord
     * @param {string} [pickupCity] The city of the pickup address for a CarrierCapacityRecord
     * @param {string} [pickupStateProvince] The state_province of the pickup address for a CarrierCapacityRecord
     * @param {string} [pickupCountry] The country of the pickup address for a CarrierCapacityRecord
     * @param {string} [pickupPostalCode] The postal_code of the pickup address for a CarrierCapacityRecord
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierCapacityApi
     */
    CarrierCapacityApi.prototype.carrierCapacityCarrierCapacityGet = function (page, pageSize, ordering, carrierCapacityCarrierId, pickupCustomerLocationReference, pickupDate, pickupDateLt, pickupDateLte, pickupDateGt, pickupDateGte, pickupAddress1, pickupAddress2, pickupCity, pickupStateProvince, pickupCountry, pickupPostalCode, options) {
        var _this = this;
        return (0, exports.CarrierCapacityApiFp)(this.configuration).carrierCapacityCarrierCapacityGet(page, pageSize, ordering, carrierCapacityCarrierId, pickupCustomerLocationReference, pickupDate, pickupDateLt, pickupDateLte, pickupDateGt, pickupDateGte, pickupAddress1, pickupAddress2, pickupCity, pickupStateProvince, pickupCountry, pickupPostalCode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information on whether location has capacity or not
     * @param {string} shipmentId The id of the shipment for which location capacity should be determined
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierCapacityApi
     */
    CarrierCapacityApi.prototype.carrierCapacityLocationCapacityAvailableGet = function (shipmentId, options) {
        var _this = this;
        return (0, exports.CarrierCapacityApiFp)(this.configuration).carrierCapacityLocationCapacityAvailableGet(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CarrierCapacityApi;
}(base_1.BaseAPI));
exports.CarrierCapacityApi = CarrierCapacityApi;
/**
 * CarrierComplianceApi - axios parameter creator
 * @export
 */
var CarrierComplianceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Delete a registered Fedex API account
         * @param {string} fedexAccountNumber Fedex account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsFedexAuthApiRegistrationFedexAccountNumberDelete: function (fedexAccountNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'fedexAccountNumber' is not null or undefined
                            (0, common_1.assertParamExists)('carrierComplianceIntegrationsFedexAuthApiRegistrationFedexAccountNumberDelete', 'fedexAccountNumber', fedexAccountNumber);
                            localVarPath = "/carrier-compliance/integrations/fedex/auth/api-registration/{fedexAccountNumber}"
                                .replace("{".concat("fedexAccountNumber", "}"), encodeURIComponent(String(fedexAccountNumber)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain Fedex API account information
         * @param {string} fedexAccountNumber Fedex account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsFedexAuthApiRegistrationFedexAccountNumberGet: function (fedexAccountNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'fedexAccountNumber' is not null or undefined
                            (0, common_1.assertParamExists)('carrierComplianceIntegrationsFedexAuthApiRegistrationFedexAccountNumberGet', 'fedexAccountNumber', fedexAccountNumber);
                            localVarPath = "/carrier-compliance/integrations/fedex/auth/api-registration/{fedexAccountNumber}"
                                .replace("{".concat("fedexAccountNumber", "}"), encodeURIComponent(String(fedexAccountNumber)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain a list af Fedex API accounts information
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsFedexAuthApiRegistrationGet: function (page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/carrier-compliance/integrations/fedex/auth/api-registration/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Check if a user\'s company has an Fedex integration enabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsFedexAuthCheckGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/carrier-compliance/integrations/fedex/auth/check/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Disconnect Fedex integration for the company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsFedexDisconnectDelete: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/carrier-compliance/integrations/fedex/disconnect/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain RMIS API account information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthApiRegistrationGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/carrier-compliance/integrations/rmis/auth/api-registration/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Company has to have an account with RMIS before registering with Shipwell.
         * @summary Register company\'s RMIS API account with Shipwell
         * @param {RMISAPIAccountRequest} rMISAPIAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthApiRegistrationPost: function (rMISAPIAccountRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rMISAPIAccountRequest' is not null or undefined
                            (0, common_1.assertParamExists)('carrierComplianceIntegrationsRmisAuthApiRegistrationPost', 'rMISAPIAccountRequest', rMISAPIAccountRequest);
                            localVarPath = "/carrier-compliance/integrations/rmis/auth/api-registration/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rMISAPIAccountRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a registered RMIS API account
         * @param {string} rmisAPIAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthApiRegistrationRmisAPIAccountIdDelete: function (rmisAPIAccountId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rmisAPIAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierComplianceIntegrationsRmisAuthApiRegistrationRmisAPIAccountIdDelete', 'rmisAPIAccountId', rmisAPIAccountId);
                            localVarPath = "/carrier-compliance/integrations/rmis/auth/api-registration/{rmisAPIAccountId}/"
                                .replace("{".concat("rmisAPIAccountId", "}"), encodeURIComponent(String(rmisAPIAccountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates registered company\'s RMIS API account with Shipwell
         * @param {string} rmisAPIAccountId
         * @param {RMISAPIAccountRequest} rMISAPIAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthApiRegistrationRmisAPIAccountIdPut: function (rmisAPIAccountId, rMISAPIAccountRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rmisAPIAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierComplianceIntegrationsRmisAuthApiRegistrationRmisAPIAccountIdPut', 'rmisAPIAccountId', rmisAPIAccountId);
                            // verify required parameter 'rMISAPIAccountRequest' is not null or undefined
                            (0, common_1.assertParamExists)('carrierComplianceIntegrationsRmisAuthApiRegistrationRmisAPIAccountIdPut', 'rMISAPIAccountRequest', rMISAPIAccountRequest);
                            localVarPath = "/carrier-compliance/integrations/rmis/auth/api-registration/{rmisAPIAccountId}/"
                                .replace("{".concat("rmisAPIAccountId", "}"), encodeURIComponent(String(rmisAPIAccountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rMISAPIAccountRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Check if a user\'s company has an RMIS integration enabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthCheckGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/carrier-compliance/integrations/rmis/auth/check/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain RMIS FTP account information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthFtpRegistrationGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/carrier-compliance/integrations/rmis/auth/ftp-registration/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Company has to have an account with RMIS before registering with Shipwell.
         * @summary Register company\'s RMIS FTP account with Shipwell
         * @param {RMISFTPAccountRequest} rMISFTPAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthFtpRegistrationPost: function (rMISFTPAccountRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rMISFTPAccountRequest' is not null or undefined
                            (0, common_1.assertParamExists)('carrierComplianceIntegrationsRmisAuthFtpRegistrationPost', 'rMISFTPAccountRequest', rMISFTPAccountRequest);
                            localVarPath = "/carrier-compliance/integrations/rmis/auth/ftp-registration/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rMISFTPAccountRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a registered RMIS FTP account
         * @param {string} rmisFTPAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthFtpRegistrationRmisFTPAccountIdDelete: function (rmisFTPAccountId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rmisFTPAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierComplianceIntegrationsRmisAuthFtpRegistrationRmisFTPAccountIdDelete', 'rmisFTPAccountId', rmisFTPAccountId);
                            localVarPath = "/carrier-compliance/integrations/rmis/auth/ftp-registration/{rmisFTPAccountId}/"
                                .replace("{".concat("rmisFTPAccountId", "}"), encodeURIComponent(String(rmisFTPAccountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates registered company\'s RMIS FTP account with Shipwell
         * @param {string} rmisFTPAccountId
         * @param {RMISFTPAccountRequest} rMISFTPAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthFtpRegistrationRmisFTPAccountIdPut: function (rmisFTPAccountId, rMISFTPAccountRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rmisFTPAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierComplianceIntegrationsRmisAuthFtpRegistrationRmisFTPAccountIdPut', 'rmisFTPAccountId', rmisFTPAccountId);
                            // verify required parameter 'rMISFTPAccountRequest' is not null or undefined
                            (0, common_1.assertParamExists)('carrierComplianceIntegrationsRmisAuthFtpRegistrationRmisFTPAccountIdPut', 'rMISFTPAccountRequest', rMISFTPAccountRequest);
                            localVarPath = "/carrier-compliance/integrations/rmis/auth/ftp-registration/{rmisFTPAccountId}/"
                                .replace("{".concat("rmisFTPAccountId", "}"), encodeURIComponent(String(rmisFTPAccountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rMISFTPAccountRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Post final update for completed Informatica RMIS process
         * @param {RMISJobStatus} rMISJobStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisJobStatusPost: function (rMISJobStatus, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rMISJobStatus' is not null or undefined
                            (0, common_1.assertParamExists)('carrierComplianceIntegrationsRmisJobStatusPost', 'rMISJobStatus', rMISJobStatus);
                            localVarPath = "/carrier-compliance/integrations/rmis/job-status/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rMISJobStatus, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Kick off RMIS FTP sync
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisSyncPost: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/carrier-compliance/integrations/rmis/sync/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain SaferWatch API account information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchAuthApiRegistrationGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/carrier-compliance/integrations/saferwatch/auth/api-registration/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Company has to have an account with SaferWatch before registering with Shipwell.
         * @summary Register company\'s SaferWatch API account with Shipwell
         * @param {SaferWatchAccountRequest} saferWatchAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchAuthApiRegistrationPost: function (saferWatchAccountRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'saferWatchAccountRequest' is not null or undefined
                            (0, common_1.assertParamExists)('carrierComplianceIntegrationsSaferwatchAuthApiRegistrationPost', 'saferWatchAccountRequest', saferWatchAccountRequest);
                            localVarPath = "/carrier-compliance/integrations/saferwatch/auth/api-registration/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saferWatchAccountRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a registered SaferWatch API account
         * @param {string} saferWatchAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchAuthApiRegistrationSaferWatchAccountIdDelete: function (saferWatchAccountId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'saferWatchAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierComplianceIntegrationsSaferwatchAuthApiRegistrationSaferWatchAccountIdDelete', 'saferWatchAccountId', saferWatchAccountId);
                            localVarPath = "/carrier-compliance/integrations/saferwatch/auth/api-registration/{saferWatchAccountId}"
                                .replace("{".concat("saferWatchAccountId", "}"), encodeURIComponent(String(saferWatchAccountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates registered company\'s SaferWatch API account with Shipwell
         * @param {string} saferWatchAccountId
         * @param {SaferWatchAccountRequest} saferWatchAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchAuthApiRegistrationSaferWatchAccountIdPut: function (saferWatchAccountId, saferWatchAccountRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'saferWatchAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierComplianceIntegrationsSaferwatchAuthApiRegistrationSaferWatchAccountIdPut', 'saferWatchAccountId', saferWatchAccountId);
                            // verify required parameter 'saferWatchAccountRequest' is not null or undefined
                            (0, common_1.assertParamExists)('carrierComplianceIntegrationsSaferwatchAuthApiRegistrationSaferWatchAccountIdPut', 'saferWatchAccountRequest', saferWatchAccountRequest);
                            localVarPath = "/carrier-compliance/integrations/saferwatch/auth/api-registration/{saferWatchAccountId}"
                                .replace("{".concat("saferWatchAccountId", "}"), encodeURIComponent(String(saferWatchAccountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saferWatchAccountRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Check if a user\'s company has an SaferWatch integration enabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchAuthCheckGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/carrier-compliance/integrations/saferwatch/auth/check/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Post SaferWatch job status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchJobStatusPost: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/carrier-compliance/integrations/saferwatch/job-status/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Kick off SaferWatch sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchSyncPost: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/carrier-compliance/integrations/saferwatch/sync/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update RMIS carrier profile
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} rmisCarrierProfileId The id of an rmis carrier profile
         * @param {RMISCarrier} rMISCarrier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdRmisCarrierProfileRmisCarrierProfileIdPut: function (carrierRelationshipId, rmisCarrierProfileId, rMISCarrier, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdRmisCarrierProfileRmisCarrierProfileIdPut', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'rmisCarrierProfileId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdRmisCarrierProfileRmisCarrierProfileIdPut', 'rmisCarrierProfileId', rmisCarrierProfileId);
                            // verify required parameter 'rMISCarrier' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdRmisCarrierProfileRmisCarrierProfileIdPut', 'rMISCarrier', rMISCarrier);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/rmis-carrier-profile/{rmisCarrierProfileId}/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)))
                                .replace("{".concat("rmisCarrierProfileId", "}"), encodeURIComponent(String(rmisCarrierProfileId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rMISCarrier, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update SaferWatch carrier profile
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} saferWatchCarrierProfileId The id of a saferwatch carrier profile
         * @param {SaferWatchCarrier} saferWatchCarrier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfileSaferwatchCarrierProfileIdPut: function (carrierRelationshipId, saferWatchCarrierProfileId, saferWatchCarrier, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfileSaferwatchCarrierProfileIdPut', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'saferWatchCarrierProfileId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfileSaferwatchCarrierProfileIdPut', 'saferWatchCarrierProfileId', saferWatchCarrierProfileId);
                            // verify required parameter 'saferWatchCarrier' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfileSaferwatchCarrierProfileIdPut', 'saferWatchCarrier', saferWatchCarrier);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/saferwatch-carrier-profile/{saferwatchCarrierProfileId}/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)))
                                .replace("{".concat("saferWatchCarrierProfileId", "}"), encodeURIComponent(String(saferWatchCarrierProfileId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saferWatchCarrier, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CarrierComplianceApiAxiosParamCreator = CarrierComplianceApiAxiosParamCreator;
/**
 * CarrierComplianceApi - functional programming interface
 * @export
 */
var CarrierComplianceApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CarrierComplianceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Delete a registered Fedex API account
         * @param {string} fedexAccountNumber Fedex account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsFedexAuthApiRegistrationFedexAccountNumberDelete: function (fedexAccountNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsFedexAuthApiRegistrationFedexAccountNumberDelete(fedexAccountNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain Fedex API account information
         * @param {string} fedexAccountNumber Fedex account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsFedexAuthApiRegistrationFedexAccountNumberGet: function (fedexAccountNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsFedexAuthApiRegistrationFedexAccountNumberGet(fedexAccountNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain a list af Fedex API accounts information
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsFedexAuthApiRegistrationGet: function (page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsFedexAuthApiRegistrationGet(page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Check if a user\'s company has an Fedex integration enabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsFedexAuthCheckGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsFedexAuthCheckGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Disconnect Fedex integration for the company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsFedexDisconnectDelete: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsFedexDisconnectDelete(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain RMIS API account information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthApiRegistrationGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsRmisAuthApiRegistrationGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Company has to have an account with RMIS before registering with Shipwell.
         * @summary Register company\'s RMIS API account with Shipwell
         * @param {RMISAPIAccountRequest} rMISAPIAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthApiRegistrationPost: function (rMISAPIAccountRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsRmisAuthApiRegistrationPost(rMISAPIAccountRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a registered RMIS API account
         * @param {string} rmisAPIAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthApiRegistrationRmisAPIAccountIdDelete: function (rmisAPIAccountId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsRmisAuthApiRegistrationRmisAPIAccountIdDelete(rmisAPIAccountId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates registered company\'s RMIS API account with Shipwell
         * @param {string} rmisAPIAccountId
         * @param {RMISAPIAccountRequest} rMISAPIAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthApiRegistrationRmisAPIAccountIdPut: function (rmisAPIAccountId, rMISAPIAccountRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsRmisAuthApiRegistrationRmisAPIAccountIdPut(rmisAPIAccountId, rMISAPIAccountRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Check if a user\'s company has an RMIS integration enabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthCheckGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsRmisAuthCheckGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain RMIS FTP account information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthFtpRegistrationGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsRmisAuthFtpRegistrationGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Company has to have an account with RMIS before registering with Shipwell.
         * @summary Register company\'s RMIS FTP account with Shipwell
         * @param {RMISFTPAccountRequest} rMISFTPAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthFtpRegistrationPost: function (rMISFTPAccountRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsRmisAuthFtpRegistrationPost(rMISFTPAccountRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a registered RMIS FTP account
         * @param {string} rmisFTPAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthFtpRegistrationRmisFTPAccountIdDelete: function (rmisFTPAccountId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsRmisAuthFtpRegistrationRmisFTPAccountIdDelete(rmisFTPAccountId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates registered company\'s RMIS FTP account with Shipwell
         * @param {string} rmisFTPAccountId
         * @param {RMISFTPAccountRequest} rMISFTPAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthFtpRegistrationRmisFTPAccountIdPut: function (rmisFTPAccountId, rMISFTPAccountRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsRmisAuthFtpRegistrationRmisFTPAccountIdPut(rmisFTPAccountId, rMISFTPAccountRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Post final update for completed Informatica RMIS process
         * @param {RMISJobStatus} rMISJobStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisJobStatusPost: function (rMISJobStatus, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsRmisJobStatusPost(rMISJobStatus, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Kick off RMIS FTP sync
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisSyncPost: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsRmisSyncPost(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain SaferWatch API account information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchAuthApiRegistrationGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsSaferwatchAuthApiRegistrationGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Company has to have an account with SaferWatch before registering with Shipwell.
         * @summary Register company\'s SaferWatch API account with Shipwell
         * @param {SaferWatchAccountRequest} saferWatchAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchAuthApiRegistrationPost: function (saferWatchAccountRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsSaferwatchAuthApiRegistrationPost(saferWatchAccountRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a registered SaferWatch API account
         * @param {string} saferWatchAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchAuthApiRegistrationSaferWatchAccountIdDelete: function (saferWatchAccountId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsSaferwatchAuthApiRegistrationSaferWatchAccountIdDelete(saferWatchAccountId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates registered company\'s SaferWatch API account with Shipwell
         * @param {string} saferWatchAccountId
         * @param {SaferWatchAccountRequest} saferWatchAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchAuthApiRegistrationSaferWatchAccountIdPut: function (saferWatchAccountId, saferWatchAccountRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsSaferwatchAuthApiRegistrationSaferWatchAccountIdPut(saferWatchAccountId, saferWatchAccountRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Check if a user\'s company has an SaferWatch integration enabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchAuthCheckGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsSaferwatchAuthCheckGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Post SaferWatch job status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchJobStatusPost: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsSaferwatchJobStatusPost(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Kick off SaferWatch sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchSyncPost: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsSaferwatchSyncPost(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update RMIS carrier profile
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} rmisCarrierProfileId The id of an rmis carrier profile
         * @param {RMISCarrier} rMISCarrier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdRmisCarrierProfileRmisCarrierProfileIdPut: function (carrierRelationshipId, rmisCarrierProfileId, rMISCarrier, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdRmisCarrierProfileRmisCarrierProfileIdPut(carrierRelationshipId, rmisCarrierProfileId, rMISCarrier, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update SaferWatch carrier profile
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} saferWatchCarrierProfileId The id of a saferwatch carrier profile
         * @param {SaferWatchCarrier} saferWatchCarrier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfileSaferwatchCarrierProfileIdPut: function (carrierRelationshipId, saferWatchCarrierProfileId, saferWatchCarrier, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfileSaferwatchCarrierProfileIdPut(carrierRelationshipId, saferWatchCarrierProfileId, saferWatchCarrier, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CarrierComplianceApiFp = CarrierComplianceApiFp;
/**
 * CarrierComplianceApi - factory interface
 * @export
 */
var CarrierComplianceApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CarrierComplianceApiFp)(configuration);
    return {
        /**
         *
         * @summary Delete a registered Fedex API account
         * @param {string} fedexAccountNumber Fedex account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsFedexAuthApiRegistrationFedexAccountNumberDelete: function (fedexAccountNumber, options) {
            return localVarFp.carrierComplianceIntegrationsFedexAuthApiRegistrationFedexAccountNumberDelete(fedexAccountNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Obtain Fedex API account information
         * @param {string} fedexAccountNumber Fedex account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsFedexAuthApiRegistrationFedexAccountNumberGet: function (fedexAccountNumber, options) {
            return localVarFp.carrierComplianceIntegrationsFedexAuthApiRegistrationFedexAccountNumberGet(fedexAccountNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Obtain a list af Fedex API accounts information
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsFedexAuthApiRegistrationGet: function (page, pageSize, options) {
            return localVarFp.carrierComplianceIntegrationsFedexAuthApiRegistrationGet(page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Check if a user\'s company has an Fedex integration enabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsFedexAuthCheckGet: function (options) {
            return localVarFp.carrierComplianceIntegrationsFedexAuthCheckGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Disconnect Fedex integration for the company.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsFedexDisconnectDelete: function (options) {
            return localVarFp.carrierComplianceIntegrationsFedexDisconnectDelete(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Obtain RMIS API account information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthApiRegistrationGet: function (options) {
            return localVarFp.carrierComplianceIntegrationsRmisAuthApiRegistrationGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Company has to have an account with RMIS before registering with Shipwell.
         * @summary Register company\'s RMIS API account with Shipwell
         * @param {RMISAPIAccountRequest} rMISAPIAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthApiRegistrationPost: function (rMISAPIAccountRequest, options) {
            return localVarFp.carrierComplianceIntegrationsRmisAuthApiRegistrationPost(rMISAPIAccountRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a registered RMIS API account
         * @param {string} rmisAPIAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthApiRegistrationRmisAPIAccountIdDelete: function (rmisAPIAccountId, options) {
            return localVarFp.carrierComplianceIntegrationsRmisAuthApiRegistrationRmisAPIAccountIdDelete(rmisAPIAccountId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates registered company\'s RMIS API account with Shipwell
         * @param {string} rmisAPIAccountId
         * @param {RMISAPIAccountRequest} rMISAPIAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthApiRegistrationRmisAPIAccountIdPut: function (rmisAPIAccountId, rMISAPIAccountRequest, options) {
            return localVarFp.carrierComplianceIntegrationsRmisAuthApiRegistrationRmisAPIAccountIdPut(rmisAPIAccountId, rMISAPIAccountRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Check if a user\'s company has an RMIS integration enabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthCheckGet: function (options) {
            return localVarFp.carrierComplianceIntegrationsRmisAuthCheckGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Obtain RMIS FTP account information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthFtpRegistrationGet: function (options) {
            return localVarFp.carrierComplianceIntegrationsRmisAuthFtpRegistrationGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Company has to have an account with RMIS before registering with Shipwell.
         * @summary Register company\'s RMIS FTP account with Shipwell
         * @param {RMISFTPAccountRequest} rMISFTPAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthFtpRegistrationPost: function (rMISFTPAccountRequest, options) {
            return localVarFp.carrierComplianceIntegrationsRmisAuthFtpRegistrationPost(rMISFTPAccountRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a registered RMIS FTP account
         * @param {string} rmisFTPAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthFtpRegistrationRmisFTPAccountIdDelete: function (rmisFTPAccountId, options) {
            return localVarFp.carrierComplianceIntegrationsRmisAuthFtpRegistrationRmisFTPAccountIdDelete(rmisFTPAccountId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates registered company\'s RMIS FTP account with Shipwell
         * @param {string} rmisFTPAccountId
         * @param {RMISFTPAccountRequest} rMISFTPAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisAuthFtpRegistrationRmisFTPAccountIdPut: function (rmisFTPAccountId, rMISFTPAccountRequest, options) {
            return localVarFp.carrierComplianceIntegrationsRmisAuthFtpRegistrationRmisFTPAccountIdPut(rmisFTPAccountId, rMISFTPAccountRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Post final update for completed Informatica RMIS process
         * @param {RMISJobStatus} rMISJobStatus
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisJobStatusPost: function (rMISJobStatus, options) {
            return localVarFp.carrierComplianceIntegrationsRmisJobStatusPost(rMISJobStatus, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Kick off RMIS FTP sync
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisSyncPost: function (options) {
            return localVarFp.carrierComplianceIntegrationsRmisSyncPost(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Obtain SaferWatch API account information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchAuthApiRegistrationGet: function (options) {
            return localVarFp.carrierComplianceIntegrationsSaferwatchAuthApiRegistrationGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Company has to have an account with SaferWatch before registering with Shipwell.
         * @summary Register company\'s SaferWatch API account with Shipwell
         * @param {SaferWatchAccountRequest} saferWatchAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchAuthApiRegistrationPost: function (saferWatchAccountRequest, options) {
            return localVarFp.carrierComplianceIntegrationsSaferwatchAuthApiRegistrationPost(saferWatchAccountRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a registered SaferWatch API account
         * @param {string} saferWatchAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchAuthApiRegistrationSaferWatchAccountIdDelete: function (saferWatchAccountId, options) {
            return localVarFp.carrierComplianceIntegrationsSaferwatchAuthApiRegistrationSaferWatchAccountIdDelete(saferWatchAccountId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates registered company\'s SaferWatch API account with Shipwell
         * @param {string} saferWatchAccountId
         * @param {SaferWatchAccountRequest} saferWatchAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchAuthApiRegistrationSaferWatchAccountIdPut: function (saferWatchAccountId, saferWatchAccountRequest, options) {
            return localVarFp.carrierComplianceIntegrationsSaferwatchAuthApiRegistrationSaferWatchAccountIdPut(saferWatchAccountId, saferWatchAccountRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Check if a user\'s company has an SaferWatch integration enabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchAuthCheckGet: function (options) {
            return localVarFp.carrierComplianceIntegrationsSaferwatchAuthCheckGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Post SaferWatch job status.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchJobStatusPost: function (options) {
            return localVarFp.carrierComplianceIntegrationsSaferwatchJobStatusPost(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Kick off SaferWatch sync.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchSyncPost: function (options) {
            return localVarFp.carrierComplianceIntegrationsSaferwatchSyncPost(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update RMIS carrier profile
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} rmisCarrierProfileId The id of an rmis carrier profile
         * @param {RMISCarrier} rMISCarrier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdRmisCarrierProfileRmisCarrierProfileIdPut: function (carrierRelationshipId, rmisCarrierProfileId, rMISCarrier, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdRmisCarrierProfileRmisCarrierProfileIdPut(carrierRelationshipId, rmisCarrierProfileId, rMISCarrier, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update SaferWatch carrier profile
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} saferWatchCarrierProfileId The id of a saferwatch carrier profile
         * @param {SaferWatchCarrier} saferWatchCarrier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfileSaferwatchCarrierProfileIdPut: function (carrierRelationshipId, saferWatchCarrierProfileId, saferWatchCarrier, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfileSaferwatchCarrierProfileIdPut(carrierRelationshipId, saferWatchCarrierProfileId, saferWatchCarrier, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CarrierComplianceApiFactory = CarrierComplianceApiFactory;
/**
 * CarrierComplianceApi - object-oriented interface
 * @export
 * @class CarrierComplianceApi
 * @extends {BaseAPI}
 */
var CarrierComplianceApi = /** @class */ (function (_super) {
    __extends(CarrierComplianceApi, _super);
    function CarrierComplianceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Delete a registered Fedex API account
     * @param {string} fedexAccountNumber Fedex account number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierComplianceApi
     */
    CarrierComplianceApi.prototype.carrierComplianceIntegrationsFedexAuthApiRegistrationFedexAccountNumberDelete = function (fedexAccountNumber, options) {
        var _this = this;
        return (0, exports.CarrierComplianceApiFp)(this.configuration).carrierComplianceIntegrationsFedexAuthApiRegistrationFedexAccountNumberDelete(fedexAccountNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Obtain Fedex API account information
     * @param {string} fedexAccountNumber Fedex account number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierComplianceApi
     */
    CarrierComplianceApi.prototype.carrierComplianceIntegrationsFedexAuthApiRegistrationFedexAccountNumberGet = function (fedexAccountNumber, options) {
        var _this = this;
        return (0, exports.CarrierComplianceApiFp)(this.configuration).carrierComplianceIntegrationsFedexAuthApiRegistrationFedexAccountNumberGet(fedexAccountNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Obtain a list af Fedex API accounts information
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierComplianceApi
     */
    CarrierComplianceApi.prototype.carrierComplianceIntegrationsFedexAuthApiRegistrationGet = function (page, pageSize, options) {
        var _this = this;
        return (0, exports.CarrierComplianceApiFp)(this.configuration).carrierComplianceIntegrationsFedexAuthApiRegistrationGet(page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Check if a user\'s company has an Fedex integration enabled
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierComplianceApi
     */
    CarrierComplianceApi.prototype.carrierComplianceIntegrationsFedexAuthCheckGet = function (options) {
        var _this = this;
        return (0, exports.CarrierComplianceApiFp)(this.configuration).carrierComplianceIntegrationsFedexAuthCheckGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Disconnect Fedex integration for the company.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierComplianceApi
     */
    CarrierComplianceApi.prototype.carrierComplianceIntegrationsFedexDisconnectDelete = function (options) {
        var _this = this;
        return (0, exports.CarrierComplianceApiFp)(this.configuration).carrierComplianceIntegrationsFedexDisconnectDelete(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Obtain RMIS API account information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierComplianceApi
     */
    CarrierComplianceApi.prototype.carrierComplianceIntegrationsRmisAuthApiRegistrationGet = function (options) {
        var _this = this;
        return (0, exports.CarrierComplianceApiFp)(this.configuration).carrierComplianceIntegrationsRmisAuthApiRegistrationGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Company has to have an account with RMIS before registering with Shipwell.
     * @summary Register company\'s RMIS API account with Shipwell
     * @param {RMISAPIAccountRequest} rMISAPIAccountRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierComplianceApi
     */
    CarrierComplianceApi.prototype.carrierComplianceIntegrationsRmisAuthApiRegistrationPost = function (rMISAPIAccountRequest, options) {
        var _this = this;
        return (0, exports.CarrierComplianceApiFp)(this.configuration).carrierComplianceIntegrationsRmisAuthApiRegistrationPost(rMISAPIAccountRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a registered RMIS API account
     * @param {string} rmisAPIAccountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierComplianceApi
     */
    CarrierComplianceApi.prototype.carrierComplianceIntegrationsRmisAuthApiRegistrationRmisAPIAccountIdDelete = function (rmisAPIAccountId, options) {
        var _this = this;
        return (0, exports.CarrierComplianceApiFp)(this.configuration).carrierComplianceIntegrationsRmisAuthApiRegistrationRmisAPIAccountIdDelete(rmisAPIAccountId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates registered company\'s RMIS API account with Shipwell
     * @param {string} rmisAPIAccountId
     * @param {RMISAPIAccountRequest} rMISAPIAccountRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierComplianceApi
     */
    CarrierComplianceApi.prototype.carrierComplianceIntegrationsRmisAuthApiRegistrationRmisAPIAccountIdPut = function (rmisAPIAccountId, rMISAPIAccountRequest, options) {
        var _this = this;
        return (0, exports.CarrierComplianceApiFp)(this.configuration).carrierComplianceIntegrationsRmisAuthApiRegistrationRmisAPIAccountIdPut(rmisAPIAccountId, rMISAPIAccountRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Check if a user\'s company has an RMIS integration enabled
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierComplianceApi
     */
    CarrierComplianceApi.prototype.carrierComplianceIntegrationsRmisAuthCheckGet = function (options) {
        var _this = this;
        return (0, exports.CarrierComplianceApiFp)(this.configuration).carrierComplianceIntegrationsRmisAuthCheckGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Obtain RMIS FTP account information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierComplianceApi
     */
    CarrierComplianceApi.prototype.carrierComplianceIntegrationsRmisAuthFtpRegistrationGet = function (options) {
        var _this = this;
        return (0, exports.CarrierComplianceApiFp)(this.configuration).carrierComplianceIntegrationsRmisAuthFtpRegistrationGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Company has to have an account with RMIS before registering with Shipwell.
     * @summary Register company\'s RMIS FTP account with Shipwell
     * @param {RMISFTPAccountRequest} rMISFTPAccountRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierComplianceApi
     */
    CarrierComplianceApi.prototype.carrierComplianceIntegrationsRmisAuthFtpRegistrationPost = function (rMISFTPAccountRequest, options) {
        var _this = this;
        return (0, exports.CarrierComplianceApiFp)(this.configuration).carrierComplianceIntegrationsRmisAuthFtpRegistrationPost(rMISFTPAccountRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a registered RMIS FTP account
     * @param {string} rmisFTPAccountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierComplianceApi
     */
    CarrierComplianceApi.prototype.carrierComplianceIntegrationsRmisAuthFtpRegistrationRmisFTPAccountIdDelete = function (rmisFTPAccountId, options) {
        var _this = this;
        return (0, exports.CarrierComplianceApiFp)(this.configuration).carrierComplianceIntegrationsRmisAuthFtpRegistrationRmisFTPAccountIdDelete(rmisFTPAccountId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates registered company\'s RMIS FTP account with Shipwell
     * @param {string} rmisFTPAccountId
     * @param {RMISFTPAccountRequest} rMISFTPAccountRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierComplianceApi
     */
    CarrierComplianceApi.prototype.carrierComplianceIntegrationsRmisAuthFtpRegistrationRmisFTPAccountIdPut = function (rmisFTPAccountId, rMISFTPAccountRequest, options) {
        var _this = this;
        return (0, exports.CarrierComplianceApiFp)(this.configuration).carrierComplianceIntegrationsRmisAuthFtpRegistrationRmisFTPAccountIdPut(rmisFTPAccountId, rMISFTPAccountRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Post final update for completed Informatica RMIS process
     * @param {RMISJobStatus} rMISJobStatus
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierComplianceApi
     */
    CarrierComplianceApi.prototype.carrierComplianceIntegrationsRmisJobStatusPost = function (rMISJobStatus, options) {
        var _this = this;
        return (0, exports.CarrierComplianceApiFp)(this.configuration).carrierComplianceIntegrationsRmisJobStatusPost(rMISJobStatus, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Kick off RMIS FTP sync
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierComplianceApi
     */
    CarrierComplianceApi.prototype.carrierComplianceIntegrationsRmisSyncPost = function (options) {
        var _this = this;
        return (0, exports.CarrierComplianceApiFp)(this.configuration).carrierComplianceIntegrationsRmisSyncPost(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Obtain SaferWatch API account information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierComplianceApi
     */
    CarrierComplianceApi.prototype.carrierComplianceIntegrationsSaferwatchAuthApiRegistrationGet = function (options) {
        var _this = this;
        return (0, exports.CarrierComplianceApiFp)(this.configuration).carrierComplianceIntegrationsSaferwatchAuthApiRegistrationGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Company has to have an account with SaferWatch before registering with Shipwell.
     * @summary Register company\'s SaferWatch API account with Shipwell
     * @param {SaferWatchAccountRequest} saferWatchAccountRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierComplianceApi
     */
    CarrierComplianceApi.prototype.carrierComplianceIntegrationsSaferwatchAuthApiRegistrationPost = function (saferWatchAccountRequest, options) {
        var _this = this;
        return (0, exports.CarrierComplianceApiFp)(this.configuration).carrierComplianceIntegrationsSaferwatchAuthApiRegistrationPost(saferWatchAccountRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a registered SaferWatch API account
     * @param {string} saferWatchAccountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierComplianceApi
     */
    CarrierComplianceApi.prototype.carrierComplianceIntegrationsSaferwatchAuthApiRegistrationSaferWatchAccountIdDelete = function (saferWatchAccountId, options) {
        var _this = this;
        return (0, exports.CarrierComplianceApiFp)(this.configuration).carrierComplianceIntegrationsSaferwatchAuthApiRegistrationSaferWatchAccountIdDelete(saferWatchAccountId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates registered company\'s SaferWatch API account with Shipwell
     * @param {string} saferWatchAccountId
     * @param {SaferWatchAccountRequest} saferWatchAccountRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierComplianceApi
     */
    CarrierComplianceApi.prototype.carrierComplianceIntegrationsSaferwatchAuthApiRegistrationSaferWatchAccountIdPut = function (saferWatchAccountId, saferWatchAccountRequest, options) {
        var _this = this;
        return (0, exports.CarrierComplianceApiFp)(this.configuration).carrierComplianceIntegrationsSaferwatchAuthApiRegistrationSaferWatchAccountIdPut(saferWatchAccountId, saferWatchAccountRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Check if a user\'s company has an SaferWatch integration enabled
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierComplianceApi
     */
    CarrierComplianceApi.prototype.carrierComplianceIntegrationsSaferwatchAuthCheckGet = function (options) {
        var _this = this;
        return (0, exports.CarrierComplianceApiFp)(this.configuration).carrierComplianceIntegrationsSaferwatchAuthCheckGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Post SaferWatch job status.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierComplianceApi
     */
    CarrierComplianceApi.prototype.carrierComplianceIntegrationsSaferwatchJobStatusPost = function (options) {
        var _this = this;
        return (0, exports.CarrierComplianceApiFp)(this.configuration).carrierComplianceIntegrationsSaferwatchJobStatusPost(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Kick off SaferWatch sync.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierComplianceApi
     */
    CarrierComplianceApi.prototype.carrierComplianceIntegrationsSaferwatchSyncPost = function (options) {
        var _this = this;
        return (0, exports.CarrierComplianceApiFp)(this.configuration).carrierComplianceIntegrationsSaferwatchSyncPost(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update RMIS carrier profile
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {string} rmisCarrierProfileId The id of an rmis carrier profile
     * @param {RMISCarrier} rMISCarrier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierComplianceApi
     */
    CarrierComplianceApi.prototype.carrierRelationshipsCarrierRelationshipIdRmisCarrierProfileRmisCarrierProfileIdPut = function (carrierRelationshipId, rmisCarrierProfileId, rMISCarrier, options) {
        var _this = this;
        return (0, exports.CarrierComplianceApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdRmisCarrierProfileRmisCarrierProfileIdPut(carrierRelationshipId, rmisCarrierProfileId, rMISCarrier, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update SaferWatch carrier profile
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {string} saferWatchCarrierProfileId The id of a saferwatch carrier profile
     * @param {SaferWatchCarrier} saferWatchCarrier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierComplianceApi
     */
    CarrierComplianceApi.prototype.carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfileSaferwatchCarrierProfileIdPut = function (carrierRelationshipId, saferWatchCarrierProfileId, saferWatchCarrier, options) {
        var _this = this;
        return (0, exports.CarrierComplianceApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfileSaferwatchCarrierProfileIdPut(carrierRelationshipId, saferWatchCarrierProfileId, saferWatchCarrier, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CarrierComplianceApi;
}(base_1.BaseAPI));
exports.CarrierComplianceApi = CarrierComplianceApi;
/**
 * CarrierRelationshipsApi - axios parameter creator
 * @export
 */
var CarrierRelationshipsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get FMCSA Carrier Compliance policy settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsFmcsaPolicyGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/carrier-compliance/integrations/fmcsa/policy/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update FMCSA Carrier Compliance policy settings
         * @param {FMCSACarrierPolicy} fMCSACarrierPolicy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsFmcsaPolicyPut: function (fMCSACarrierPolicy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'fMCSACarrierPolicy' is not null or undefined
                            (0, common_1.assertParamExists)('carrierComplianceIntegrationsFmcsaPolicyPut', 'fMCSACarrierPolicy', fMCSACarrierPolicy);
                            localVarPath = "/carrier-compliance/integrations/fmcsa/policy/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(fMCSACarrierPolicy, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get RMIS Carrier Compliance policy settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisPolicyGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/carrier-compliance/integrations/rmis/policy/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update RMIS Carrier Compliance policy settings
         * @param {string} rmisPolicyId The id of an rmis policy
         * @param {RMISCarrierPolicy} rMISCarrierPolicy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisPolicyRmisPolicyIdPut: function (rmisPolicyId, rMISCarrierPolicy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rmisPolicyId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierComplianceIntegrationsRmisPolicyRmisPolicyIdPut', 'rmisPolicyId', rmisPolicyId);
                            // verify required parameter 'rMISCarrierPolicy' is not null or undefined
                            (0, common_1.assertParamExists)('carrierComplianceIntegrationsRmisPolicyRmisPolicyIdPut', 'rMISCarrierPolicy', rMISCarrierPolicy);
                            localVarPath = "/carrier-compliance/integrations/rmis/policy/{rmisPolicyId}/"
                                .replace("{".concat("rmisPolicyId", "}"), encodeURIComponent(String(rmisPolicyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rMISCarrierPolicy, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get SaferWatch Carrier Compliance policy settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchPolicyGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/carrier-compliance/integrations/saferwatch/policy/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update SaferWatch Carrier Compliance policy settings
         * @param {SaferWatchCarrierPolicy} saferWatchCarrierPolicy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchPolicyPut: function (saferWatchCarrierPolicy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'saferWatchCarrierPolicy' is not null or undefined
                            (0, common_1.assertParamExists)('carrierComplianceIntegrationsSaferwatchPolicyPut', 'saferWatchCarrierPolicy', saferWatchCarrierPolicy);
                            localVarPath = "/carrier-compliance/integrations/saferwatch/policy/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saferWatchCarrierPolicy, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve an embed URL for a looker dashboard about the carrier
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdAnalyticsGet: function (carrierRelationshipId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdAnalyticsGet', 'carrierRelationshipId', carrierRelationshipId);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/analytics/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdDelete: function (carrierRelationshipId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdDelete', 'carrierRelationshipId', carrierRelationshipId);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a Document
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} documentId The id of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdDelete: function (carrierRelationshipId, documentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdDelete', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdDelete', 'documentId', documentId);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/documents/{documentId}/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)))
                                .replace("{".concat("documentId", "}"), encodeURIComponent(String(documentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get metadata about a document
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} documentId The id of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdGet: function (carrierRelationshipId, documentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdGet', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdGet', 'documentId', documentId);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/documents/{documentId}/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)))
                                .replace("{".concat("documentId", "}"), encodeURIComponent(String(documentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update metadata about a document
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} documentId The id of the document
         * @param {ShipmentDocumentMetadata} shipmentDocumentMetadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdPut: function (carrierRelationshipId, documentId, shipmentDocumentMetadata, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdPut', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdPut', 'documentId', documentId);
                            // verify required parameter 'shipmentDocumentMetadata' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdPut', 'shipmentDocumentMetadata', shipmentDocumentMetadata);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/documents/{documentId}/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)))
                                .replace("{".concat("documentId", "}"), encodeURIComponent(String(documentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shipmentDocumentMetadata, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get metadata about documents on a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdDocumentsGet: function (carrierRelationshipId, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdDocumentsGet', 'carrierRelationshipId', carrierRelationshipId);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/documents/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a document on a shipment
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {PostBrokeragesBrokerageidShipperRelationshipsShipperrelationshipidDocuments} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdDocumentsPost: function (carrierRelationshipId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdDocumentsPost', 'carrierRelationshipId', carrierRelationshipId);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/documents/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List ELD providers for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEldProvidersGet: function (carrierRelationshipId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdEldProvidersGet', 'carrierRelationshipId', carrierRelationshipId);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/eld-providers/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create an ELD provider entry for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {RecordedELDProvider} recordedELDProvider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEldProvidersPost: function (carrierRelationshipId, recordedELDProvider, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdEldProvidersPost', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'recordedELDProvider' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdEldProvidersPost', 'recordedELDProvider', recordedELDProvider);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/eld-providers/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(recordedELDProvider, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete an ELD provider entry for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} recordedELDProviderId The id of the recorded ELD provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdDelete: function (carrierRelationshipId, recordedELDProviderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdDelete', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'recordedELDProviderId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdDelete', 'recordedELDProviderId', recordedELDProviderId);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/eld-providers/{recordedELDProviderId}/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)))
                                .replace("{".concat("recordedELDProviderId", "}"), encodeURIComponent(String(recordedELDProviderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve an ELD provider entry for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} recordedELDProviderId The id of the recorded ELD provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdGet: function (carrierRelationshipId, recordedELDProviderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdGet', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'recordedELDProviderId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdGet', 'recordedELDProviderId', recordedELDProviderId);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/eld-providers/{recordedELDProviderId}/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)))
                                .replace("{".concat("recordedELDProviderId", "}"), encodeURIComponent(String(recordedELDProviderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an ELD provider entry for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} recordedELDProviderId The id of the recorded ELD provider
         * @param {RecordedELDProvider} recordedELDProvider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdPut: function (carrierRelationshipId, recordedELDProviderId, recordedELDProvider, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdPut', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'recordedELDProviderId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdPut', 'recordedELDProviderId', recordedELDProviderId);
                            // verify required parameter 'recordedELDProvider' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdPut', 'recordedELDProvider', recordedELDProvider);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/eld-providers/{recordedELDProviderId}/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)))
                                .replace("{".concat("recordedELDProviderId", "}"), encodeURIComponent(String(recordedELDProviderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(recordedELDProvider, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List equipment types for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEquipmentTypesGet: function (carrierRelationshipId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdEquipmentTypesGet', 'carrierRelationshipId', carrierRelationshipId);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/equipment-types/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create an equipment type entry for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {RecordedEquipmentType} recordedEquipmentType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEquipmentTypesPost: function (carrierRelationshipId, recordedEquipmentType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdEquipmentTypesPost', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'recordedEquipmentType' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdEquipmentTypesPost', 'recordedEquipmentType', recordedEquipmentType);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/equipment-types/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(recordedEquipmentType, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete an equipment type entry for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} recordedEquipmentTypeId The id of the recorded equipment type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdDelete: function (carrierRelationshipId, recordedEquipmentTypeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdDelete', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'recordedEquipmentTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdDelete', 'recordedEquipmentTypeId', recordedEquipmentTypeId);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/equipment-types/{recordedEquipmentTypeId}/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)))
                                .replace("{".concat("recordedEquipmentTypeId", "}"), encodeURIComponent(String(recordedEquipmentTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve an equipment type entry for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} recordedEquipmentTypeId The id of the recorded equipment type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdGet: function (carrierRelationshipId, recordedEquipmentTypeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdGet', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'recordedEquipmentTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdGet', 'recordedEquipmentTypeId', recordedEquipmentTypeId);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/equipment-types/{recordedEquipmentTypeId}/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)))
                                .replace("{".concat("recordedEquipmentTypeId", "}"), encodeURIComponent(String(recordedEquipmentTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an equipment type entry for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} recordedEquipmentTypeId The id of the recorded equipment type
         * @param {RecordedEquipmentType} recordedEquipmentType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdPut: function (carrierRelationshipId, recordedEquipmentTypeId, recordedEquipmentType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdPut', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'recordedEquipmentTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdPut', 'recordedEquipmentTypeId', recordedEquipmentTypeId);
                            // verify required parameter 'recordedEquipmentType' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdPut', 'recordedEquipmentType', recordedEquipmentType);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/equipment-types/{recordedEquipmentTypeId}/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)))
                                .replace("{".concat("recordedEquipmentTypeId", "}"), encodeURIComponent(String(recordedEquipmentTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(recordedEquipmentType, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete an exclusion rule for a carrier
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} carrierExclusionRuleId The id of the carrier exclusion rule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdDelete: function (carrierRelationshipId, carrierExclusionRuleId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdDelete', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'carrierExclusionRuleId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdDelete', 'carrierExclusionRuleId', carrierExclusionRuleId);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/exclusion-rules/{carrierExclusionRuleId}/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)))
                                .replace("{".concat("carrierExclusionRuleId", "}"), encodeURIComponent(String(carrierExclusionRuleId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about an exclusion rule for a carrier
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} carrierExclusionRuleId The id of the carrier exclusion rule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdGet: function (carrierRelationshipId, carrierExclusionRuleId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdGet', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'carrierExclusionRuleId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdGet', 'carrierExclusionRuleId', carrierExclusionRuleId);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/exclusion-rules/{carrierExclusionRuleId}/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)))
                                .replace("{".concat("carrierExclusionRuleId", "}"), encodeURIComponent(String(carrierExclusionRuleId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an exclusion rule for a carrier
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} carrierExclusionRuleId The id of the carrier exclusion rule
         * @param {CarrierExclusionRule} carrierExclusionRule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdPut: function (carrierRelationshipId, carrierExclusionRuleId, carrierExclusionRule, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdPut', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'carrierExclusionRuleId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdPut', 'carrierExclusionRuleId', carrierExclusionRuleId);
                            // verify required parameter 'carrierExclusionRule' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdPut', 'carrierExclusionRule', carrierExclusionRule);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/exclusion-rules/{carrierExclusionRuleId}/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)))
                                .replace("{".concat("carrierExclusionRuleId", "}"), encodeURIComponent(String(carrierExclusionRuleId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(carrierExclusionRule, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a list of exclusion rules for a carrier
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdExclusionRulesGet: function (carrierRelationshipId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdExclusionRulesGet', 'carrierRelationshipId', carrierRelationshipId);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/exclusion-rules/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new exclusion rule for a carrier
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {CarrierExclusionRule} carrierExclusionRule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdExclusionRulesPost: function (carrierRelationshipId, carrierExclusionRule, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdExclusionRulesPost', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'carrierExclusionRule' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdExclusionRulesPost', 'carrierExclusionRule', carrierExclusionRule);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/exclusion-rules/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(carrierExclusionRule, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdGet: function (carrierRelationshipId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdGet', 'carrierRelationshipId', carrierRelationshipId);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a point of contact for a carrier
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} carrierRelationshipPointOfContactId The id of a vendor relationship point of contact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdPointOfContactsCarrierRelationshipPointOfContactIdGet: function (carrierRelationshipId, carrierRelationshipPointOfContactId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdPointOfContactsCarrierRelationshipPointOfContactIdGet', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'carrierRelationshipPointOfContactId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdPointOfContactsCarrierRelationshipPointOfContactIdGet', 'carrierRelationshipPointOfContactId', carrierRelationshipPointOfContactId);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/point-of-contacts/{carrierRelationshipPointOfContactId}/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)))
                                .replace("{".concat("carrierRelationshipPointOfContactId", "}"), encodeURIComponent(String(carrierRelationshipPointOfContactId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Re-send an email to a carrier point of contact inviting them to the load board
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} carrierRelationshipPointOfContactId The id of a vendor relationship point of contact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdPointOfContactsCarrierRelationshipPointOfContactIdSendLoadBoardInvitePost: function (carrierRelationshipId, carrierRelationshipPointOfContactId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdPointOfContactsCarrierRelationshipPointOfContactIdSendLoadBoardInvitePost', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'carrierRelationshipPointOfContactId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdPointOfContactsCarrierRelationshipPointOfContactIdSendLoadBoardInvitePost', 'carrierRelationshipPointOfContactId', carrierRelationshipPointOfContactId);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/point-of-contacts/{carrierRelationshipPointOfContactId}/send-load-board-invite/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)))
                                .replace("{".concat("carrierRelationshipPointOfContactId", "}"), encodeURIComponent(String(carrierRelationshipPointOfContactId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a list of points of contact for a carrier
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdPointOfContactsGet: function (carrierRelationshipId, page, pageSize, ordering, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdPointOfContactsGet', 'carrierRelationshipId', carrierRelationshipId);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/point-of-contacts/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update information about a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {CarrierRelationship} carrierRelationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdPut: function (carrierRelationshipId, carrierRelationship, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdPut', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'carrierRelationship' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdPut', 'carrierRelationship', carrierRelationship);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(carrierRelationship, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create new RMIS carrier profile
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {RMISCarrier} rMISCarrier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdRmisCarrierProfilePost: function (carrierRelationshipId, rMISCarrier, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdRmisCarrierProfilePost', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'rMISCarrier' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdRmisCarrierProfilePost', 'rMISCarrier', rMISCarrier);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/rmis-carrier-profile/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rMISCarrier, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete RMIS carrier profile
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} rmisCarrierProfileId The id of an rmis carrier profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdRmisCarrierProfileRmisCarrierProfileIdDelete: function (carrierRelationshipId, rmisCarrierProfileId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdRmisCarrierProfileRmisCarrierProfileIdDelete', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'rmisCarrierProfileId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdRmisCarrierProfileRmisCarrierProfileIdDelete', 'rmisCarrierProfileId', rmisCarrierProfileId);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/rmis-carrier-profile/{rmisCarrierProfileId}/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)))
                                .replace("{".concat("rmisCarrierProfileId", "}"), encodeURIComponent(String(rmisCarrierProfileId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create new SaferWatch carrier profile
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {SaferWatchCarrier} saferWatchCarrier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfilePost: function (carrierRelationshipId, saferWatchCarrier, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfilePost', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'saferWatchCarrier' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfilePost', 'saferWatchCarrier', saferWatchCarrier);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/saferwatch-carrier-profile/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saferWatchCarrier, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete SaferWatch carrier profile
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} saferWatchCarrierProfileId The id of a saferwatch carrier profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfileSaferwatchCarrierProfileIdDelete: function (carrierRelationshipId, saferWatchCarrierProfileId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfileSaferwatchCarrierProfileIdDelete', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'saferWatchCarrierProfileId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfileSaferwatchCarrierProfileIdDelete', 'saferWatchCarrierProfileId', saferWatchCarrierProfileId);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/saferwatch-carrier-profile/{saferwatchCarrierProfileId}/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)))
                                .replace("{".concat("saferWatchCarrierProfileId", "}"), encodeURIComponent(String(saferWatchCarrierProfileId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the list of relationships with carriers
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {Array<string>} [id] Return objects whose ID is one of those provided
         * @param {string} [carrierOwnerId] Return vendor relationships where carrier_owner has this User ID
         * @param {string} [carrierOwnerEmailContains] Return vendor relationships where carrier_owner email address contains the value provided
         * @param {string} [carrierOwnerNameContains] Return vendor relationships where carrier_owner name contains the value provided
         * @param {'ACTIVE' | 'INACTIVE' | 'DO_NOT_USE'} [carrierStatus] Return vendor relationships where carrier_status equals the value provided
         * @param {string} [billingAddressContains] Return objects where the company billing address contains this string
         * @param {string} [companyContains] Return objects where the company name contains this string
         * @param {string} [mailingAddressContains] Return objects where the company mailing address contains this string
         * @param {string} [primaryEmailContains] Return objects where the company primary email contains this string
         * @param {string} [primaryPhoneNumberContains] Return objects where the company primary phone number contains this string
         * @param {string} [mcNumber] search by this (exact) mc number
         * @param {string} [mcNumberContains] Return companies where the mc number contains this string
         * @param {string} [pointOfContactsContains] Return objects where a point of contact contains this string in their name or email
         * @param {Array<string>} [tags] Return objects with these (exact) tags
         * @param {string} [tagsContains] Return objects where one of the tags contains this string
         * @param {string} [usdot] search by this (exact) usdot number
         * @param {string} [usdotContains] Return companies where the usdot number contains this string
         * @param {string} [vendorId] Return shipments with this exact value as the vendor Carrier id
         * @param {boolean} [loadBoardEnabled] Return vendor relationships that have at least one load board enabled point of contact
         * @param {boolean} [hasDirectIntegration] Return vendor relationships where Shipwell has a direct integration with the vendor
         * @param {string} [driversContains] Return objects where a driver contains this string in their full_name or phone_number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsGet: function (page, pageSize, ordering, q, id, carrierOwnerId, carrierOwnerEmailContains, carrierOwnerNameContains, carrierStatus, billingAddressContains, companyContains, mailingAddressContains, primaryEmailContains, primaryPhoneNumberContains, mcNumber, mcNumberContains, pointOfContactsContains, tags, tagsContains, usdot, usdotContains, vendorId, loadBoardEnabled, hasDirectIntegration, driversContains, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/carrier-relationships/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (carrierOwnerId !== undefined) {
                                localVarQueryParameter['carrier_owner_id'] = carrierOwnerId;
                            }
                            if (carrierOwnerEmailContains !== undefined) {
                                localVarQueryParameter['carrier_owner_email__contains'] = carrierOwnerEmailContains;
                            }
                            if (carrierOwnerNameContains !== undefined) {
                                localVarQueryParameter['carrier_owner_name__contains'] = carrierOwnerNameContains;
                            }
                            if (carrierStatus !== undefined) {
                                localVarQueryParameter['carrier_status'] = carrierStatus;
                            }
                            if (billingAddressContains !== undefined) {
                                localVarQueryParameter['billing_address__contains'] = billingAddressContains;
                            }
                            if (companyContains !== undefined) {
                                localVarQueryParameter['company__contains'] = companyContains;
                            }
                            if (mailingAddressContains !== undefined) {
                                localVarQueryParameter['mailing_address__contains'] = mailingAddressContains;
                            }
                            if (primaryEmailContains !== undefined) {
                                localVarQueryParameter['primary_email__contains'] = primaryEmailContains;
                            }
                            if (primaryPhoneNumberContains !== undefined) {
                                localVarQueryParameter['primary_phone_number__contains'] = primaryPhoneNumberContains;
                            }
                            if (mcNumber !== undefined) {
                                localVarQueryParameter['mc_number'] = mcNumber;
                            }
                            if (mcNumberContains !== undefined) {
                                localVarQueryParameter['mc_number__contains'] = mcNumberContains;
                            }
                            if (pointOfContactsContains !== undefined) {
                                localVarQueryParameter['point_of_contacts__contains'] = pointOfContactsContains;
                            }
                            if (tags) {
                                localVarQueryParameter['tags'] = tags;
                            }
                            if (tagsContains !== undefined) {
                                localVarQueryParameter['tags__contains'] = tagsContains;
                            }
                            if (usdot !== undefined) {
                                localVarQueryParameter['usdot'] = usdot;
                            }
                            if (usdotContains !== undefined) {
                                localVarQueryParameter['usdot__contains'] = usdotContains;
                            }
                            if (vendorId !== undefined) {
                                localVarQueryParameter['vendor_id'] = vendorId;
                            }
                            if (loadBoardEnabled !== undefined) {
                                localVarQueryParameter['load_board_enabled'] = loadBoardEnabled;
                            }
                            if (hasDirectIntegration !== undefined) {
                                localVarQueryParameter['has_direct_integration'] = hasDirectIntegration;
                            }
                            if (driversContains !== undefined) {
                                localVarQueryParameter['drivers__contains'] = driversContains;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new relationship with a carrier.  If the carrier does not exist, it will be created.
         * @param {boolean} manualEntry If the entry is being manually added instead of via search, set this to true
         * @param {CarrierRelationship} carrierRelationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsPost: function (manualEntry, carrierRelationship, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'manualEntry' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsPost', 'manualEntry', manualEntry);
                            // verify required parameter 'carrierRelationship' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsPost', 'carrierRelationship', carrierRelationship);
                            localVarPath = "/carrier-relationships/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (manualEntry !== undefined) {
                                localVarQueryParameter['manual_entry'] = manualEntry;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(carrierRelationship, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a FMCSA and carrier reported data about a carrier given a USDOT
         * @param {string} [usdot] search by this (exact) usdot number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersGet: function (usdot, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/carriers/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (usdot !== undefined) {
                                localVarQueryParameter['usdot'] = usdot;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Reports inaccurate carrier data to the Shipwell team
         * @param {InaccurateCarrier} inaccurateCarrier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersReportInaccuratePost: function (inaccurateCarrier, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'inaccurateCarrier' is not null or undefined
                            (0, common_1.assertParamExists)('carriersReportInaccuratePost', 'inaccurateCarrier', inaccurateCarrier);
                            localVarPath = "/carriers/report-inaccurate/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inaccurateCarrier, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Search for a list of carriers
         * @param {string} [q] search query
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersSearchGet: function (q, page, pageSize, ordering, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/carriers/search/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CarrierRelationshipsApiAxiosParamCreator = CarrierRelationshipsApiAxiosParamCreator;
/**
 * CarrierRelationshipsApi - functional programming interface
 * @export
 */
var CarrierRelationshipsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CarrierRelationshipsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get FMCSA Carrier Compliance policy settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsFmcsaPolicyGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsFmcsaPolicyGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update FMCSA Carrier Compliance policy settings
         * @param {FMCSACarrierPolicy} fMCSACarrierPolicy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsFmcsaPolicyPut: function (fMCSACarrierPolicy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsFmcsaPolicyPut(fMCSACarrierPolicy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get RMIS Carrier Compliance policy settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisPolicyGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsRmisPolicyGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update RMIS Carrier Compliance policy settings
         * @param {string} rmisPolicyId The id of an rmis policy
         * @param {RMISCarrierPolicy} rMISCarrierPolicy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisPolicyRmisPolicyIdPut: function (rmisPolicyId, rMISCarrierPolicy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsRmisPolicyRmisPolicyIdPut(rmisPolicyId, rMISCarrierPolicy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get SaferWatch Carrier Compliance policy settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchPolicyGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsSaferwatchPolicyGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update SaferWatch Carrier Compliance policy settings
         * @param {SaferWatchCarrierPolicy} saferWatchCarrierPolicy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchPolicyPut: function (saferWatchCarrierPolicy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierComplianceIntegrationsSaferwatchPolicyPut(saferWatchCarrierPolicy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve an embed URL for a looker dashboard about the carrier
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdAnalyticsGet: function (carrierRelationshipId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdAnalyticsGet(carrierRelationshipId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdDelete: function (carrierRelationshipId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdDelete(carrierRelationshipId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a Document
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} documentId The id of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdDelete: function (carrierRelationshipId, documentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdDelete(carrierRelationshipId, documentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get metadata about a document
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} documentId The id of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdGet: function (carrierRelationshipId, documentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdGet(carrierRelationshipId, documentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update metadata about a document
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} documentId The id of the document
         * @param {ShipmentDocumentMetadata} shipmentDocumentMetadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdPut: function (carrierRelationshipId, documentId, shipmentDocumentMetadata, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdPut(carrierRelationshipId, documentId, shipmentDocumentMetadata, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get metadata about documents on a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdDocumentsGet: function (carrierRelationshipId, page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdDocumentsGet(carrierRelationshipId, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a document on a shipment
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {PostBrokeragesBrokerageidShipperRelationshipsShipperrelationshipidDocuments} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdDocumentsPost: function (carrierRelationshipId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdDocumentsPost(carrierRelationshipId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List ELD providers for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEldProvidersGet: function (carrierRelationshipId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdEldProvidersGet(carrierRelationshipId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create an ELD provider entry for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {RecordedELDProvider} recordedELDProvider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEldProvidersPost: function (carrierRelationshipId, recordedELDProvider, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdEldProvidersPost(carrierRelationshipId, recordedELDProvider, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete an ELD provider entry for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} recordedELDProviderId The id of the recorded ELD provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdDelete: function (carrierRelationshipId, recordedELDProviderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdDelete(carrierRelationshipId, recordedELDProviderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve an ELD provider entry for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} recordedELDProviderId The id of the recorded ELD provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdGet: function (carrierRelationshipId, recordedELDProviderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdGet(carrierRelationshipId, recordedELDProviderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an ELD provider entry for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} recordedELDProviderId The id of the recorded ELD provider
         * @param {RecordedELDProvider} recordedELDProvider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdPut: function (carrierRelationshipId, recordedELDProviderId, recordedELDProvider, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdPut(carrierRelationshipId, recordedELDProviderId, recordedELDProvider, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List equipment types for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEquipmentTypesGet: function (carrierRelationshipId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdEquipmentTypesGet(carrierRelationshipId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create an equipment type entry for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {RecordedEquipmentType} recordedEquipmentType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEquipmentTypesPost: function (carrierRelationshipId, recordedEquipmentType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdEquipmentTypesPost(carrierRelationshipId, recordedEquipmentType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete an equipment type entry for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} recordedEquipmentTypeId The id of the recorded equipment type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdDelete: function (carrierRelationshipId, recordedEquipmentTypeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdDelete(carrierRelationshipId, recordedEquipmentTypeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve an equipment type entry for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} recordedEquipmentTypeId The id of the recorded equipment type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdGet: function (carrierRelationshipId, recordedEquipmentTypeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdGet(carrierRelationshipId, recordedEquipmentTypeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an equipment type entry for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} recordedEquipmentTypeId The id of the recorded equipment type
         * @param {RecordedEquipmentType} recordedEquipmentType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdPut: function (carrierRelationshipId, recordedEquipmentTypeId, recordedEquipmentType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdPut(carrierRelationshipId, recordedEquipmentTypeId, recordedEquipmentType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete an exclusion rule for a carrier
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} carrierExclusionRuleId The id of the carrier exclusion rule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdDelete: function (carrierRelationshipId, carrierExclusionRuleId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdDelete(carrierRelationshipId, carrierExclusionRuleId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about an exclusion rule for a carrier
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} carrierExclusionRuleId The id of the carrier exclusion rule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdGet: function (carrierRelationshipId, carrierExclusionRuleId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdGet(carrierRelationshipId, carrierExclusionRuleId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an exclusion rule for a carrier
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} carrierExclusionRuleId The id of the carrier exclusion rule
         * @param {CarrierExclusionRule} carrierExclusionRule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdPut: function (carrierRelationshipId, carrierExclusionRuleId, carrierExclusionRule, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdPut(carrierRelationshipId, carrierExclusionRuleId, carrierExclusionRule, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a list of exclusion rules for a carrier
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdExclusionRulesGet: function (carrierRelationshipId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdExclusionRulesGet(carrierRelationshipId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new exclusion rule for a carrier
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {CarrierExclusionRule} carrierExclusionRule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdExclusionRulesPost: function (carrierRelationshipId, carrierExclusionRule, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdExclusionRulesPost(carrierRelationshipId, carrierExclusionRule, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdGet: function (carrierRelationshipId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdGet(carrierRelationshipId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a point of contact for a carrier
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} carrierRelationshipPointOfContactId The id of a vendor relationship point of contact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdPointOfContactsCarrierRelationshipPointOfContactIdGet: function (carrierRelationshipId, carrierRelationshipPointOfContactId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdPointOfContactsCarrierRelationshipPointOfContactIdGet(carrierRelationshipId, carrierRelationshipPointOfContactId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Re-send an email to a carrier point of contact inviting them to the load board
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} carrierRelationshipPointOfContactId The id of a vendor relationship point of contact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdPointOfContactsCarrierRelationshipPointOfContactIdSendLoadBoardInvitePost: function (carrierRelationshipId, carrierRelationshipPointOfContactId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdPointOfContactsCarrierRelationshipPointOfContactIdSendLoadBoardInvitePost(carrierRelationshipId, carrierRelationshipPointOfContactId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a list of points of contact for a carrier
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdPointOfContactsGet: function (carrierRelationshipId, page, pageSize, ordering, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdPointOfContactsGet(carrierRelationshipId, page, pageSize, ordering, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update information about a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {CarrierRelationship} carrierRelationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdPut: function (carrierRelationshipId, carrierRelationship, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdPut(carrierRelationshipId, carrierRelationship, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create new RMIS carrier profile
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {RMISCarrier} rMISCarrier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdRmisCarrierProfilePost: function (carrierRelationshipId, rMISCarrier, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdRmisCarrierProfilePost(carrierRelationshipId, rMISCarrier, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete RMIS carrier profile
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} rmisCarrierProfileId The id of an rmis carrier profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdRmisCarrierProfileRmisCarrierProfileIdDelete: function (carrierRelationshipId, rmisCarrierProfileId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdRmisCarrierProfileRmisCarrierProfileIdDelete(carrierRelationshipId, rmisCarrierProfileId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create new SaferWatch carrier profile
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {SaferWatchCarrier} saferWatchCarrier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfilePost: function (carrierRelationshipId, saferWatchCarrier, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfilePost(carrierRelationshipId, saferWatchCarrier, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete SaferWatch carrier profile
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} saferWatchCarrierProfileId The id of a saferwatch carrier profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfileSaferwatchCarrierProfileIdDelete: function (carrierRelationshipId, saferWatchCarrierProfileId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfileSaferwatchCarrierProfileIdDelete(carrierRelationshipId, saferWatchCarrierProfileId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the list of relationships with carriers
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {Array<string>} [id] Return objects whose ID is one of those provided
         * @param {string} [carrierOwnerId] Return vendor relationships where carrier_owner has this User ID
         * @param {string} [carrierOwnerEmailContains] Return vendor relationships where carrier_owner email address contains the value provided
         * @param {string} [carrierOwnerNameContains] Return vendor relationships where carrier_owner name contains the value provided
         * @param {'ACTIVE' | 'INACTIVE' | 'DO_NOT_USE'} [carrierStatus] Return vendor relationships where carrier_status equals the value provided
         * @param {string} [billingAddressContains] Return objects where the company billing address contains this string
         * @param {string} [companyContains] Return objects where the company name contains this string
         * @param {string} [mailingAddressContains] Return objects where the company mailing address contains this string
         * @param {string} [primaryEmailContains] Return objects where the company primary email contains this string
         * @param {string} [primaryPhoneNumberContains] Return objects where the company primary phone number contains this string
         * @param {string} [mcNumber] search by this (exact) mc number
         * @param {string} [mcNumberContains] Return companies where the mc number contains this string
         * @param {string} [pointOfContactsContains] Return objects where a point of contact contains this string in their name or email
         * @param {Array<string>} [tags] Return objects with these (exact) tags
         * @param {string} [tagsContains] Return objects where one of the tags contains this string
         * @param {string} [usdot] search by this (exact) usdot number
         * @param {string} [usdotContains] Return companies where the usdot number contains this string
         * @param {string} [vendorId] Return shipments with this exact value as the vendor Carrier id
         * @param {boolean} [loadBoardEnabled] Return vendor relationships that have at least one load board enabled point of contact
         * @param {boolean} [hasDirectIntegration] Return vendor relationships where Shipwell has a direct integration with the vendor
         * @param {string} [driversContains] Return objects where a driver contains this string in their full_name or phone_number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsGet: function (page, pageSize, ordering, q, id, carrierOwnerId, carrierOwnerEmailContains, carrierOwnerNameContains, carrierStatus, billingAddressContains, companyContains, mailingAddressContains, primaryEmailContains, primaryPhoneNumberContains, mcNumber, mcNumberContains, pointOfContactsContains, tags, tagsContains, usdot, usdotContains, vendorId, loadBoardEnabled, hasDirectIntegration, driversContains, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsGet(page, pageSize, ordering, q, id, carrierOwnerId, carrierOwnerEmailContains, carrierOwnerNameContains, carrierStatus, billingAddressContains, companyContains, mailingAddressContains, primaryEmailContains, primaryPhoneNumberContains, mcNumber, mcNumberContains, pointOfContactsContains, tags, tagsContains, usdot, usdotContains, vendorId, loadBoardEnabled, hasDirectIntegration, driversContains, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new relationship with a carrier.  If the carrier does not exist, it will be created.
         * @param {boolean} manualEntry If the entry is being manually added instead of via search, set this to true
         * @param {CarrierRelationship} carrierRelationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsPost: function (manualEntry, carrierRelationship, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsPost(manualEntry, carrierRelationship, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a FMCSA and carrier reported data about a carrier given a USDOT
         * @param {string} [usdot] search by this (exact) usdot number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersGet: function (usdot, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carriersGet(usdot, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Reports inaccurate carrier data to the Shipwell team
         * @param {InaccurateCarrier} inaccurateCarrier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersReportInaccuratePost: function (inaccurateCarrier, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carriersReportInaccuratePost(inaccurateCarrier, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Search for a list of carriers
         * @param {string} [q] search query
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersSearchGet: function (q, page, pageSize, ordering, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carriersSearchGet(q, page, pageSize, ordering, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CarrierRelationshipsApiFp = CarrierRelationshipsApiFp;
/**
 * CarrierRelationshipsApi - factory interface
 * @export
 */
var CarrierRelationshipsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CarrierRelationshipsApiFp)(configuration);
    return {
        /**
         *
         * @summary Get FMCSA Carrier Compliance policy settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsFmcsaPolicyGet: function (options) {
            return localVarFp.carrierComplianceIntegrationsFmcsaPolicyGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update FMCSA Carrier Compliance policy settings
         * @param {FMCSACarrierPolicy} fMCSACarrierPolicy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsFmcsaPolicyPut: function (fMCSACarrierPolicy, options) {
            return localVarFp.carrierComplianceIntegrationsFmcsaPolicyPut(fMCSACarrierPolicy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get RMIS Carrier Compliance policy settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisPolicyGet: function (options) {
            return localVarFp.carrierComplianceIntegrationsRmisPolicyGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update RMIS Carrier Compliance policy settings
         * @param {string} rmisPolicyId The id of an rmis policy
         * @param {RMISCarrierPolicy} rMISCarrierPolicy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsRmisPolicyRmisPolicyIdPut: function (rmisPolicyId, rMISCarrierPolicy, options) {
            return localVarFp.carrierComplianceIntegrationsRmisPolicyRmisPolicyIdPut(rmisPolicyId, rMISCarrierPolicy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get SaferWatch Carrier Compliance policy settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchPolicyGet: function (options) {
            return localVarFp.carrierComplianceIntegrationsSaferwatchPolicyGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update SaferWatch Carrier Compliance policy settings
         * @param {SaferWatchCarrierPolicy} saferWatchCarrierPolicy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierComplianceIntegrationsSaferwatchPolicyPut: function (saferWatchCarrierPolicy, options) {
            return localVarFp.carrierComplianceIntegrationsSaferwatchPolicyPut(saferWatchCarrierPolicy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve an embed URL for a looker dashboard about the carrier
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdAnalyticsGet: function (carrierRelationshipId, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdAnalyticsGet(carrierRelationshipId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdDelete: function (carrierRelationshipId, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdDelete(carrierRelationshipId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a Document
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} documentId The id of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdDelete: function (carrierRelationshipId, documentId, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdDelete(carrierRelationshipId, documentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get metadata about a document
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} documentId The id of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdGet: function (carrierRelationshipId, documentId, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdGet(carrierRelationshipId, documentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update metadata about a document
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} documentId The id of the document
         * @param {ShipmentDocumentMetadata} shipmentDocumentMetadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdPut: function (carrierRelationshipId, documentId, shipmentDocumentMetadata, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdPut(carrierRelationshipId, documentId, shipmentDocumentMetadata, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get metadata about documents on a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdDocumentsGet: function (carrierRelationshipId, page, pageSize, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdDocumentsGet(carrierRelationshipId, page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a document on a shipment
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {PostBrokeragesBrokerageidShipperRelationshipsShipperrelationshipidDocuments} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdDocumentsPost: function (carrierRelationshipId, body, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdDocumentsPost(carrierRelationshipId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List ELD providers for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEldProvidersGet: function (carrierRelationshipId, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdEldProvidersGet(carrierRelationshipId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create an ELD provider entry for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {RecordedELDProvider} recordedELDProvider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEldProvidersPost: function (carrierRelationshipId, recordedELDProvider, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdEldProvidersPost(carrierRelationshipId, recordedELDProvider, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete an ELD provider entry for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} recordedELDProviderId The id of the recorded ELD provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdDelete: function (carrierRelationshipId, recordedELDProviderId, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdDelete(carrierRelationshipId, recordedELDProviderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve an ELD provider entry for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} recordedELDProviderId The id of the recorded ELD provider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdGet: function (carrierRelationshipId, recordedELDProviderId, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdGet(carrierRelationshipId, recordedELDProviderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update an ELD provider entry for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} recordedELDProviderId The id of the recorded ELD provider
         * @param {RecordedELDProvider} recordedELDProvider
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdPut: function (carrierRelationshipId, recordedELDProviderId, recordedELDProvider, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdPut(carrierRelationshipId, recordedELDProviderId, recordedELDProvider, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List equipment types for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEquipmentTypesGet: function (carrierRelationshipId, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdEquipmentTypesGet(carrierRelationshipId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create an equipment type entry for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {RecordedEquipmentType} recordedEquipmentType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEquipmentTypesPost: function (carrierRelationshipId, recordedEquipmentType, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdEquipmentTypesPost(carrierRelationshipId, recordedEquipmentType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete an equipment type entry for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} recordedEquipmentTypeId The id of the recorded equipment type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdDelete: function (carrierRelationshipId, recordedEquipmentTypeId, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdDelete(carrierRelationshipId, recordedEquipmentTypeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve an equipment type entry for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} recordedEquipmentTypeId The id of the recorded equipment type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdGet: function (carrierRelationshipId, recordedEquipmentTypeId, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdGet(carrierRelationshipId, recordedEquipmentTypeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update an equipment type entry for a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} recordedEquipmentTypeId The id of the recorded equipment type
         * @param {RecordedEquipmentType} recordedEquipmentType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdPut: function (carrierRelationshipId, recordedEquipmentTypeId, recordedEquipmentType, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdPut(carrierRelationshipId, recordedEquipmentTypeId, recordedEquipmentType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete an exclusion rule for a carrier
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} carrierExclusionRuleId The id of the carrier exclusion rule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdDelete: function (carrierRelationshipId, carrierExclusionRuleId, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdDelete(carrierRelationshipId, carrierExclusionRuleId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about an exclusion rule for a carrier
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} carrierExclusionRuleId The id of the carrier exclusion rule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdGet: function (carrierRelationshipId, carrierExclusionRuleId, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdGet(carrierRelationshipId, carrierExclusionRuleId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update an exclusion rule for a carrier
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} carrierExclusionRuleId The id of the carrier exclusion rule
         * @param {CarrierExclusionRule} carrierExclusionRule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdPut: function (carrierRelationshipId, carrierExclusionRuleId, carrierExclusionRule, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdPut(carrierRelationshipId, carrierExclusionRuleId, carrierExclusionRule, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a list of exclusion rules for a carrier
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdExclusionRulesGet: function (carrierRelationshipId, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdExclusionRulesGet(carrierRelationshipId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new exclusion rule for a carrier
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {CarrierExclusionRule} carrierExclusionRule
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdExclusionRulesPost: function (carrierRelationshipId, carrierExclusionRule, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdExclusionRulesPost(carrierRelationshipId, carrierExclusionRule, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdGet: function (carrierRelationshipId, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdGet(carrierRelationshipId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about a point of contact for a carrier
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} carrierRelationshipPointOfContactId The id of a vendor relationship point of contact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdPointOfContactsCarrierRelationshipPointOfContactIdGet: function (carrierRelationshipId, carrierRelationshipPointOfContactId, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdPointOfContactsCarrierRelationshipPointOfContactIdGet(carrierRelationshipId, carrierRelationshipPointOfContactId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Re-send an email to a carrier point of contact inviting them to the load board
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} carrierRelationshipPointOfContactId The id of a vendor relationship point of contact
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdPointOfContactsCarrierRelationshipPointOfContactIdSendLoadBoardInvitePost: function (carrierRelationshipId, carrierRelationshipPointOfContactId, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdPointOfContactsCarrierRelationshipPointOfContactIdSendLoadBoardInvitePost(carrierRelationshipId, carrierRelationshipPointOfContactId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a list of points of contact for a carrier
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdPointOfContactsGet: function (carrierRelationshipId, page, pageSize, ordering, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdPointOfContactsGet(carrierRelationshipId, page, pageSize, ordering, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update information about a carrier relationship
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {CarrierRelationship} carrierRelationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdPut: function (carrierRelationshipId, carrierRelationship, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdPut(carrierRelationshipId, carrierRelationship, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create new RMIS carrier profile
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {RMISCarrier} rMISCarrier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdRmisCarrierProfilePost: function (carrierRelationshipId, rMISCarrier, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdRmisCarrierProfilePost(carrierRelationshipId, rMISCarrier, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete RMIS carrier profile
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} rmisCarrierProfileId The id of an rmis carrier profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdRmisCarrierProfileRmisCarrierProfileIdDelete: function (carrierRelationshipId, rmisCarrierProfileId, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdRmisCarrierProfileRmisCarrierProfileIdDelete(carrierRelationshipId, rmisCarrierProfileId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create new SaferWatch carrier profile
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {SaferWatchCarrier} saferWatchCarrier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfilePost: function (carrierRelationshipId, saferWatchCarrier, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfilePost(carrierRelationshipId, saferWatchCarrier, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete SaferWatch carrier profile
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} saferWatchCarrierProfileId The id of a saferwatch carrier profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfileSaferwatchCarrierProfileIdDelete: function (carrierRelationshipId, saferWatchCarrierProfileId, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfileSaferwatchCarrierProfileIdDelete(carrierRelationshipId, saferWatchCarrierProfileId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get the list of relationships with carriers
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {Array<string>} [id] Return objects whose ID is one of those provided
         * @param {string} [carrierOwnerId] Return vendor relationships where carrier_owner has this User ID
         * @param {string} [carrierOwnerEmailContains] Return vendor relationships where carrier_owner email address contains the value provided
         * @param {string} [carrierOwnerNameContains] Return vendor relationships where carrier_owner name contains the value provided
         * @param {'ACTIVE' | 'INACTIVE' | 'DO_NOT_USE'} [carrierStatus] Return vendor relationships where carrier_status equals the value provided
         * @param {string} [billingAddressContains] Return objects where the company billing address contains this string
         * @param {string} [companyContains] Return objects where the company name contains this string
         * @param {string} [mailingAddressContains] Return objects where the company mailing address contains this string
         * @param {string} [primaryEmailContains] Return objects where the company primary email contains this string
         * @param {string} [primaryPhoneNumberContains] Return objects where the company primary phone number contains this string
         * @param {string} [mcNumber] search by this (exact) mc number
         * @param {string} [mcNumberContains] Return companies where the mc number contains this string
         * @param {string} [pointOfContactsContains] Return objects where a point of contact contains this string in their name or email
         * @param {Array<string>} [tags] Return objects with these (exact) tags
         * @param {string} [tagsContains] Return objects where one of the tags contains this string
         * @param {string} [usdot] search by this (exact) usdot number
         * @param {string} [usdotContains] Return companies where the usdot number contains this string
         * @param {string} [vendorId] Return shipments with this exact value as the vendor Carrier id
         * @param {boolean} [loadBoardEnabled] Return vendor relationships that have at least one load board enabled point of contact
         * @param {boolean} [hasDirectIntegration] Return vendor relationships where Shipwell has a direct integration with the vendor
         * @param {string} [driversContains] Return objects where a driver contains this string in their full_name or phone_number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsGet: function (page, pageSize, ordering, q, id, carrierOwnerId, carrierOwnerEmailContains, carrierOwnerNameContains, carrierStatus, billingAddressContains, companyContains, mailingAddressContains, primaryEmailContains, primaryPhoneNumberContains, mcNumber, mcNumberContains, pointOfContactsContains, tags, tagsContains, usdot, usdotContains, vendorId, loadBoardEnabled, hasDirectIntegration, driversContains, options) {
            return localVarFp.carrierRelationshipsGet(page, pageSize, ordering, q, id, carrierOwnerId, carrierOwnerEmailContains, carrierOwnerNameContains, carrierStatus, billingAddressContains, companyContains, mailingAddressContains, primaryEmailContains, primaryPhoneNumberContains, mcNumber, mcNumberContains, pointOfContactsContains, tags, tagsContains, usdot, usdotContains, vendorId, loadBoardEnabled, hasDirectIntegration, driversContains, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a new relationship with a carrier.  If the carrier does not exist, it will be created.
         * @param {boolean} manualEntry If the entry is being manually added instead of via search, set this to true
         * @param {CarrierRelationship} carrierRelationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsPost: function (manualEntry, carrierRelationship, options) {
            return localVarFp.carrierRelationshipsPost(manualEntry, carrierRelationship, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a FMCSA and carrier reported data about a carrier given a USDOT
         * @param {string} [usdot] search by this (exact) usdot number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersGet: function (usdot, options) {
            return localVarFp.carriersGet(usdot, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Reports inaccurate carrier data to the Shipwell team
         * @param {InaccurateCarrier} inaccurateCarrier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersReportInaccuratePost: function (inaccurateCarrier, options) {
            return localVarFp.carriersReportInaccuratePost(inaccurateCarrier, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Search for a list of carriers
         * @param {string} [q] search query
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersSearchGet: function (q, page, pageSize, ordering, options) {
            return localVarFp.carriersSearchGet(q, page, pageSize, ordering, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CarrierRelationshipsApiFactory = CarrierRelationshipsApiFactory;
/**
 * CarrierRelationshipsApi - object-oriented interface
 * @export
 * @class CarrierRelationshipsApi
 * @extends {BaseAPI}
 */
var CarrierRelationshipsApi = /** @class */ (function (_super) {
    __extends(CarrierRelationshipsApi, _super);
    function CarrierRelationshipsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get FMCSA Carrier Compliance policy settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierComplianceIntegrationsFmcsaPolicyGet = function (options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierComplianceIntegrationsFmcsaPolicyGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update FMCSA Carrier Compliance policy settings
     * @param {FMCSACarrierPolicy} fMCSACarrierPolicy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierComplianceIntegrationsFmcsaPolicyPut = function (fMCSACarrierPolicy, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierComplianceIntegrationsFmcsaPolicyPut(fMCSACarrierPolicy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get RMIS Carrier Compliance policy settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierComplianceIntegrationsRmisPolicyGet = function (options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierComplianceIntegrationsRmisPolicyGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update RMIS Carrier Compliance policy settings
     * @param {string} rmisPolicyId The id of an rmis policy
     * @param {RMISCarrierPolicy} rMISCarrierPolicy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierComplianceIntegrationsRmisPolicyRmisPolicyIdPut = function (rmisPolicyId, rMISCarrierPolicy, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierComplianceIntegrationsRmisPolicyRmisPolicyIdPut(rmisPolicyId, rMISCarrierPolicy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get SaferWatch Carrier Compliance policy settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierComplianceIntegrationsSaferwatchPolicyGet = function (options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierComplianceIntegrationsSaferwatchPolicyGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update SaferWatch Carrier Compliance policy settings
     * @param {SaferWatchCarrierPolicy} saferWatchCarrierPolicy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierComplianceIntegrationsSaferwatchPolicyPut = function (saferWatchCarrierPolicy, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierComplianceIntegrationsSaferwatchPolicyPut(saferWatchCarrierPolicy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve an embed URL for a looker dashboard about the carrier
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdAnalyticsGet = function (carrierRelationshipId, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdAnalyticsGet(carrierRelationshipId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a carrier relationship
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdDelete = function (carrierRelationshipId, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdDelete(carrierRelationshipId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a Document
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {string} documentId The id of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdDelete = function (carrierRelationshipId, documentId, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdDelete(carrierRelationshipId, documentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get metadata about a document
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {string} documentId The id of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdGet = function (carrierRelationshipId, documentId, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdGet(carrierRelationshipId, documentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update metadata about a document
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {string} documentId The id of the document
     * @param {ShipmentDocumentMetadata} shipmentDocumentMetadata
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdPut = function (carrierRelationshipId, documentId, shipmentDocumentMetadata, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdDocumentsDocumentIdPut(carrierRelationshipId, documentId, shipmentDocumentMetadata, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get metadata about documents on a carrier relationship
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdDocumentsGet = function (carrierRelationshipId, page, pageSize, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdDocumentsGet(carrierRelationshipId, page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a document on a shipment
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {PostBrokeragesBrokerageidShipperRelationshipsShipperrelationshipidDocuments} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdDocumentsPost = function (carrierRelationshipId, body, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdDocumentsPost(carrierRelationshipId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List ELD providers for a carrier relationship
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdEldProvidersGet = function (carrierRelationshipId, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdEldProvidersGet(carrierRelationshipId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create an ELD provider entry for a carrier relationship
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {RecordedELDProvider} recordedELDProvider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdEldProvidersPost = function (carrierRelationshipId, recordedELDProvider, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdEldProvidersPost(carrierRelationshipId, recordedELDProvider, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete an ELD provider entry for a carrier relationship
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {string} recordedELDProviderId The id of the recorded ELD provider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdDelete = function (carrierRelationshipId, recordedELDProviderId, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdDelete(carrierRelationshipId, recordedELDProviderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve an ELD provider entry for a carrier relationship
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {string} recordedELDProviderId The id of the recorded ELD provider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdGet = function (carrierRelationshipId, recordedELDProviderId, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdGet(carrierRelationshipId, recordedELDProviderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update an ELD provider entry for a carrier relationship
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {string} recordedELDProviderId The id of the recorded ELD provider
     * @param {RecordedELDProvider} recordedELDProvider
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdPut = function (carrierRelationshipId, recordedELDProviderId, recordedELDProvider, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdEldProvidersRecordedELDProviderIdPut(carrierRelationshipId, recordedELDProviderId, recordedELDProvider, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List equipment types for a carrier relationship
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdEquipmentTypesGet = function (carrierRelationshipId, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdEquipmentTypesGet(carrierRelationshipId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create an equipment type entry for a carrier relationship
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {RecordedEquipmentType} recordedEquipmentType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdEquipmentTypesPost = function (carrierRelationshipId, recordedEquipmentType, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdEquipmentTypesPost(carrierRelationshipId, recordedEquipmentType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete an equipment type entry for a carrier relationship
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {string} recordedEquipmentTypeId The id of the recorded equipment type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdDelete = function (carrierRelationshipId, recordedEquipmentTypeId, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdDelete(carrierRelationshipId, recordedEquipmentTypeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve an equipment type entry for a carrier relationship
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {string} recordedEquipmentTypeId The id of the recorded equipment type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdGet = function (carrierRelationshipId, recordedEquipmentTypeId, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdGet(carrierRelationshipId, recordedEquipmentTypeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update an equipment type entry for a carrier relationship
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {string} recordedEquipmentTypeId The id of the recorded equipment type
     * @param {RecordedEquipmentType} recordedEquipmentType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdPut = function (carrierRelationshipId, recordedEquipmentTypeId, recordedEquipmentType, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdEquipmentTypesRecordedEquipmentTypeIdPut(carrierRelationshipId, recordedEquipmentTypeId, recordedEquipmentType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete an exclusion rule for a carrier
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {string} carrierExclusionRuleId The id of the carrier exclusion rule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdDelete = function (carrierRelationshipId, carrierExclusionRuleId, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdDelete(carrierRelationshipId, carrierExclusionRuleId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about an exclusion rule for a carrier
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {string} carrierExclusionRuleId The id of the carrier exclusion rule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdGet = function (carrierRelationshipId, carrierExclusionRuleId, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdGet(carrierRelationshipId, carrierExclusionRuleId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update an exclusion rule for a carrier
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {string} carrierExclusionRuleId The id of the carrier exclusion rule
     * @param {CarrierExclusionRule} carrierExclusionRule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdPut = function (carrierRelationshipId, carrierExclusionRuleId, carrierExclusionRule, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdExclusionRulesCarrierExclusionRuleIdPut(carrierRelationshipId, carrierExclusionRuleId, carrierExclusionRule, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a list of exclusion rules for a carrier
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdExclusionRulesGet = function (carrierRelationshipId, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdExclusionRulesGet(carrierRelationshipId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new exclusion rule for a carrier
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {CarrierExclusionRule} carrierExclusionRule
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdExclusionRulesPost = function (carrierRelationshipId, carrierExclusionRule, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdExclusionRulesPost(carrierRelationshipId, carrierExclusionRule, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about a carrier relationship
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdGet = function (carrierRelationshipId, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdGet(carrierRelationshipId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about a point of contact for a carrier
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {string} carrierRelationshipPointOfContactId The id of a vendor relationship point of contact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdPointOfContactsCarrierRelationshipPointOfContactIdGet = function (carrierRelationshipId, carrierRelationshipPointOfContactId, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdPointOfContactsCarrierRelationshipPointOfContactIdGet(carrierRelationshipId, carrierRelationshipPointOfContactId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Re-send an email to a carrier point of contact inviting them to the load board
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {string} carrierRelationshipPointOfContactId The id of a vendor relationship point of contact
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdPointOfContactsCarrierRelationshipPointOfContactIdSendLoadBoardInvitePost = function (carrierRelationshipId, carrierRelationshipPointOfContactId, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdPointOfContactsCarrierRelationshipPointOfContactIdSendLoadBoardInvitePost(carrierRelationshipId, carrierRelationshipPointOfContactId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a list of points of contact for a carrier
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdPointOfContactsGet = function (carrierRelationshipId, page, pageSize, ordering, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdPointOfContactsGet(carrierRelationshipId, page, pageSize, ordering, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update information about a carrier relationship
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {CarrierRelationship} carrierRelationship
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdPut = function (carrierRelationshipId, carrierRelationship, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdPut(carrierRelationshipId, carrierRelationship, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create new RMIS carrier profile
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {RMISCarrier} rMISCarrier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdRmisCarrierProfilePost = function (carrierRelationshipId, rMISCarrier, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdRmisCarrierProfilePost(carrierRelationshipId, rMISCarrier, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete RMIS carrier profile
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {string} rmisCarrierProfileId The id of an rmis carrier profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdRmisCarrierProfileRmisCarrierProfileIdDelete = function (carrierRelationshipId, rmisCarrierProfileId, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdRmisCarrierProfileRmisCarrierProfileIdDelete(carrierRelationshipId, rmisCarrierProfileId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create new SaferWatch carrier profile
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {SaferWatchCarrier} saferWatchCarrier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfilePost = function (carrierRelationshipId, saferWatchCarrier, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfilePost(carrierRelationshipId, saferWatchCarrier, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete SaferWatch carrier profile
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {string} saferWatchCarrierProfileId The id of a saferwatch carrier profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfileSaferwatchCarrierProfileIdDelete = function (carrierRelationshipId, saferWatchCarrierProfileId, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdSaferwatchCarrierProfileSaferwatchCarrierProfileIdDelete(carrierRelationshipId, saferWatchCarrierProfileId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get the list of relationships with carriers
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {Array<string>} [id] Return objects whose ID is one of those provided
     * @param {string} [carrierOwnerId] Return vendor relationships where carrier_owner has this User ID
     * @param {string} [carrierOwnerEmailContains] Return vendor relationships where carrier_owner email address contains the value provided
     * @param {string} [carrierOwnerNameContains] Return vendor relationships where carrier_owner name contains the value provided
     * @param {'ACTIVE' | 'INACTIVE' | 'DO_NOT_USE'} [carrierStatus] Return vendor relationships where carrier_status equals the value provided
     * @param {string} [billingAddressContains] Return objects where the company billing address contains this string
     * @param {string} [companyContains] Return objects where the company name contains this string
     * @param {string} [mailingAddressContains] Return objects where the company mailing address contains this string
     * @param {string} [primaryEmailContains] Return objects where the company primary email contains this string
     * @param {string} [primaryPhoneNumberContains] Return objects where the company primary phone number contains this string
     * @param {string} [mcNumber] search by this (exact) mc number
     * @param {string} [mcNumberContains] Return companies where the mc number contains this string
     * @param {string} [pointOfContactsContains] Return objects where a point of contact contains this string in their name or email
     * @param {Array<string>} [tags] Return objects with these (exact) tags
     * @param {string} [tagsContains] Return objects where one of the tags contains this string
     * @param {string} [usdot] search by this (exact) usdot number
     * @param {string} [usdotContains] Return companies where the usdot number contains this string
     * @param {string} [vendorId] Return shipments with this exact value as the vendor Carrier id
     * @param {boolean} [loadBoardEnabled] Return vendor relationships that have at least one load board enabled point of contact
     * @param {boolean} [hasDirectIntegration] Return vendor relationships where Shipwell has a direct integration with the vendor
     * @param {string} [driversContains] Return objects where a driver contains this string in their full_name or phone_number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsGet = function (page, pageSize, ordering, q, id, carrierOwnerId, carrierOwnerEmailContains, carrierOwnerNameContains, carrierStatus, billingAddressContains, companyContains, mailingAddressContains, primaryEmailContains, primaryPhoneNumberContains, mcNumber, mcNumberContains, pointOfContactsContains, tags, tagsContains, usdot, usdotContains, vendorId, loadBoardEnabled, hasDirectIntegration, driversContains, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsGet(page, pageSize, ordering, q, id, carrierOwnerId, carrierOwnerEmailContains, carrierOwnerNameContains, carrierStatus, billingAddressContains, companyContains, mailingAddressContains, primaryEmailContains, primaryPhoneNumberContains, mcNumber, mcNumberContains, pointOfContactsContains, tags, tagsContains, usdot, usdotContains, vendorId, loadBoardEnabled, hasDirectIntegration, driversContains, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a new relationship with a carrier.  If the carrier does not exist, it will be created.
     * @param {boolean} manualEntry If the entry is being manually added instead of via search, set this to true
     * @param {CarrierRelationship} carrierRelationship
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carrierRelationshipsPost = function (manualEntry, carrierRelationship, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carrierRelationshipsPost(manualEntry, carrierRelationship, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a FMCSA and carrier reported data about a carrier given a USDOT
     * @param {string} [usdot] search by this (exact) usdot number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carriersGet = function (usdot, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carriersGet(usdot, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Reports inaccurate carrier data to the Shipwell team
     * @param {InaccurateCarrier} inaccurateCarrier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carriersReportInaccuratePost = function (inaccurateCarrier, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carriersReportInaccuratePost(inaccurateCarrier, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Search for a list of carriers
     * @param {string} [q] search query
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierRelationshipsApi
     */
    CarrierRelationshipsApi.prototype.carriersSearchGet = function (q, page, pageSize, ordering, options) {
        var _this = this;
        return (0, exports.CarrierRelationshipsApiFp)(this.configuration).carriersSearchGet(q, page, pageSize, ordering, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CarrierRelationshipsApi;
}(base_1.BaseAPI));
exports.CarrierRelationshipsApi = CarrierRelationshipsApi;
/**
 * CarrierTagsApi - axios parameter creator
 * @export
 */
var CarrierTagsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get a list of available carrier point of contact tags
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierPocTagsGet: function (page, pageSize, ordering, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/carrier-poc-tags/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new carrier point of contact tag
         * @param {CarrierPocTag} carrierPocTag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierPocTagsPost: function (carrierPocTag, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierPocTag' is not null or undefined
                            (0, common_1.assertParamExists)('carrierPocTagsPost', 'carrierPocTag', carrierPocTag);
                            localVarPath = "/carrier-poc-tags/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(carrierPocTag, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a carrier point of contact tag
         * @param {string} tagId The id of the tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierPocTagsTagIdDelete: function (tagId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tagId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierPocTagsTagIdDelete', 'tagId', tagId);
                            localVarPath = "/carrier-poc-tags/{tagId}/"
                                .replace("{".concat("tagId", "}"), encodeURIComponent(String(tagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a carrier point of contact tag
         * @param {string} tagId The id of the tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierPocTagsTagIdGet: function (tagId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tagId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierPocTagsTagIdGet', 'tagId', tagId);
                            localVarPath = "/carrier-poc-tags/{tagId}/"
                                .replace("{".concat("tagId", "}"), encodeURIComponent(String(tagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update the carrier point of contact tag
         * @param {string} tagId The id of the tag
         * @param {CarrierPocTag} carrierPocTag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierPocTagsTagIdPut: function (tagId, carrierPocTag, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tagId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierPocTagsTagIdPut', 'tagId', tagId);
                            // verify required parameter 'carrierPocTag' is not null or undefined
                            (0, common_1.assertParamExists)('carrierPocTagsTagIdPut', 'carrierPocTag', carrierPocTag);
                            localVarPath = "/carrier-poc-tags/{tagId}/"
                                .replace("{".concat("tagId", "}"), encodeURIComponent(String(tagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(carrierPocTag, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of available carrier tags
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [name] Return vendor tags that contain this name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierTagsGet: function (page, pageSize, ordering, name, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/carrier-tags/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (name !== undefined) {
                                localVarQueryParameter['name'] = name;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new carrier tag
         * @param {CarrierTag} carrierTag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierTagsPost: function (carrierTag, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierTag' is not null or undefined
                            (0, common_1.assertParamExists)('carrierTagsPost', 'carrierTag', carrierTag);
                            localVarPath = "/carrier-tags/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(carrierTag, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a carrier tag
         * @param {string} tagId The id of the tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierTagsTagIdDelete: function (tagId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tagId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierTagsTagIdDelete', 'tagId', tagId);
                            localVarPath = "/carrier-tags/{tagId}/"
                                .replace("{".concat("tagId", "}"), encodeURIComponent(String(tagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a carrier tag
         * @param {string} tagId The id of the tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierTagsTagIdGet: function (tagId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tagId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierTagsTagIdGet', 'tagId', tagId);
                            localVarPath = "/carrier-tags/{tagId}/"
                                .replace("{".concat("tagId", "}"), encodeURIComponent(String(tagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update the carrier tag
         * @param {string} tagId The id of the tag
         * @param {CarrierTag} carrierTag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierTagsTagIdPut: function (tagId, carrierTag, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tagId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierTagsTagIdPut', 'tagId', tagId);
                            // verify required parameter 'carrierTag' is not null or undefined
                            (0, common_1.assertParamExists)('carrierTagsTagIdPut', 'carrierTag', carrierTag);
                            localVarPath = "/carrier-tags/{tagId}/"
                                .replace("{".concat("tagId", "}"), encodeURIComponent(String(tagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(carrierTag, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CarrierTagsApiAxiosParamCreator = CarrierTagsApiAxiosParamCreator;
/**
 * CarrierTagsApi - functional programming interface
 * @export
 */
var CarrierTagsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CarrierTagsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get a list of available carrier point of contact tags
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierPocTagsGet: function (page, pageSize, ordering, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierPocTagsGet(page, pageSize, ordering, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new carrier point of contact tag
         * @param {CarrierPocTag} carrierPocTag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierPocTagsPost: function (carrierPocTag, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierPocTagsPost(carrierPocTag, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a carrier point of contact tag
         * @param {string} tagId The id of the tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierPocTagsTagIdDelete: function (tagId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierPocTagsTagIdDelete(tagId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a carrier point of contact tag
         * @param {string} tagId The id of the tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierPocTagsTagIdGet: function (tagId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierPocTagsTagIdGet(tagId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update the carrier point of contact tag
         * @param {string} tagId The id of the tag
         * @param {CarrierPocTag} carrierPocTag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierPocTagsTagIdPut: function (tagId, carrierPocTag, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierPocTagsTagIdPut(tagId, carrierPocTag, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of available carrier tags
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [name] Return vendor tags that contain this name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierTagsGet: function (page, pageSize, ordering, name, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierTagsGet(page, pageSize, ordering, name, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new carrier tag
         * @param {CarrierTag} carrierTag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierTagsPost: function (carrierTag, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierTagsPost(carrierTag, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a carrier tag
         * @param {string} tagId The id of the tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierTagsTagIdDelete: function (tagId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierTagsTagIdDelete(tagId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a carrier tag
         * @param {string} tagId The id of the tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierTagsTagIdGet: function (tagId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierTagsTagIdGet(tagId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update the carrier tag
         * @param {string} tagId The id of the tag
         * @param {CarrierTag} carrierTag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierTagsTagIdPut: function (tagId, carrierTag, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierTagsTagIdPut(tagId, carrierTag, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CarrierTagsApiFp = CarrierTagsApiFp;
/**
 * CarrierTagsApi - factory interface
 * @export
 */
var CarrierTagsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CarrierTagsApiFp)(configuration);
    return {
        /**
         *
         * @summary Get a list of available carrier point of contact tags
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierPocTagsGet: function (page, pageSize, ordering, options) {
            return localVarFp.carrierPocTagsGet(page, pageSize, ordering, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new carrier point of contact tag
         * @param {CarrierPocTag} carrierPocTag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierPocTagsPost: function (carrierPocTag, options) {
            return localVarFp.carrierPocTagsPost(carrierPocTag, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a carrier point of contact tag
         * @param {string} tagId The id of the tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierPocTagsTagIdDelete: function (tagId, options) {
            return localVarFp.carrierPocTagsTagIdDelete(tagId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about a carrier point of contact tag
         * @param {string} tagId The id of the tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierPocTagsTagIdGet: function (tagId, options) {
            return localVarFp.carrierPocTagsTagIdGet(tagId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update the carrier point of contact tag
         * @param {string} tagId The id of the tag
         * @param {CarrierPocTag} carrierPocTag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierPocTagsTagIdPut: function (tagId, carrierPocTag, options) {
            return localVarFp.carrierPocTagsTagIdPut(tagId, carrierPocTag, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a list of available carrier tags
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [name] Return vendor tags that contain this name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierTagsGet: function (page, pageSize, ordering, name, options) {
            return localVarFp.carrierTagsGet(page, pageSize, ordering, name, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new carrier tag
         * @param {CarrierTag} carrierTag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierTagsPost: function (carrierTag, options) {
            return localVarFp.carrierTagsPost(carrierTag, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a carrier tag
         * @param {string} tagId The id of the tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierTagsTagIdDelete: function (tagId, options) {
            return localVarFp.carrierTagsTagIdDelete(tagId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about a carrier tag
         * @param {string} tagId The id of the tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierTagsTagIdGet: function (tagId, options) {
            return localVarFp.carrierTagsTagIdGet(tagId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update the carrier tag
         * @param {string} tagId The id of the tag
         * @param {CarrierTag} carrierTag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierTagsTagIdPut: function (tagId, carrierTag, options) {
            return localVarFp.carrierTagsTagIdPut(tagId, carrierTag, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CarrierTagsApiFactory = CarrierTagsApiFactory;
/**
 * CarrierTagsApi - object-oriented interface
 * @export
 * @class CarrierTagsApi
 * @extends {BaseAPI}
 */
var CarrierTagsApi = /** @class */ (function (_super) {
    __extends(CarrierTagsApi, _super);
    function CarrierTagsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get a list of available carrier point of contact tags
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierTagsApi
     */
    CarrierTagsApi.prototype.carrierPocTagsGet = function (page, pageSize, ordering, options) {
        var _this = this;
        return (0, exports.CarrierTagsApiFp)(this.configuration).carrierPocTagsGet(page, pageSize, ordering, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new carrier point of contact tag
     * @param {CarrierPocTag} carrierPocTag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierTagsApi
     */
    CarrierTagsApi.prototype.carrierPocTagsPost = function (carrierPocTag, options) {
        var _this = this;
        return (0, exports.CarrierTagsApiFp)(this.configuration).carrierPocTagsPost(carrierPocTag, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a carrier point of contact tag
     * @param {string} tagId The id of the tag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierTagsApi
     */
    CarrierTagsApi.prototype.carrierPocTagsTagIdDelete = function (tagId, options) {
        var _this = this;
        return (0, exports.CarrierTagsApiFp)(this.configuration).carrierPocTagsTagIdDelete(tagId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about a carrier point of contact tag
     * @param {string} tagId The id of the tag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierTagsApi
     */
    CarrierTagsApi.prototype.carrierPocTagsTagIdGet = function (tagId, options) {
        var _this = this;
        return (0, exports.CarrierTagsApiFp)(this.configuration).carrierPocTagsTagIdGet(tagId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update the carrier point of contact tag
     * @param {string} tagId The id of the tag
     * @param {CarrierPocTag} carrierPocTag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierTagsApi
     */
    CarrierTagsApi.prototype.carrierPocTagsTagIdPut = function (tagId, carrierPocTag, options) {
        var _this = this;
        return (0, exports.CarrierTagsApiFp)(this.configuration).carrierPocTagsTagIdPut(tagId, carrierPocTag, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a list of available carrier tags
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [name] Return vendor tags that contain this name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierTagsApi
     */
    CarrierTagsApi.prototype.carrierTagsGet = function (page, pageSize, ordering, name, options) {
        var _this = this;
        return (0, exports.CarrierTagsApiFp)(this.configuration).carrierTagsGet(page, pageSize, ordering, name, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new carrier tag
     * @param {CarrierTag} carrierTag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierTagsApi
     */
    CarrierTagsApi.prototype.carrierTagsPost = function (carrierTag, options) {
        var _this = this;
        return (0, exports.CarrierTagsApiFp)(this.configuration).carrierTagsPost(carrierTag, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a carrier tag
     * @param {string} tagId The id of the tag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierTagsApi
     */
    CarrierTagsApi.prototype.carrierTagsTagIdDelete = function (tagId, options) {
        var _this = this;
        return (0, exports.CarrierTagsApiFp)(this.configuration).carrierTagsTagIdDelete(tagId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about a carrier tag
     * @param {string} tagId The id of the tag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierTagsApi
     */
    CarrierTagsApi.prototype.carrierTagsTagIdGet = function (tagId, options) {
        var _this = this;
        return (0, exports.CarrierTagsApiFp)(this.configuration).carrierTagsTagIdGet(tagId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update the carrier tag
     * @param {string} tagId The id of the tag
     * @param {CarrierTag} carrierTag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarrierTagsApi
     */
    CarrierTagsApi.prototype.carrierTagsTagIdPut = function (tagId, carrierTag, options) {
        var _this = this;
        return (0, exports.CarrierTagsApiFp)(this.configuration).carrierTagsTagIdPut(tagId, carrierTag, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CarrierTagsApi;
}(base_1.BaseAPI));
exports.CarrierTagsApi = CarrierTagsApi;
/**
 * CarriersApi - axios parameter creator
 * @export
 */
var CarriersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Creates or Updates ELD Credentials
         * @param {string} carrierId The id of the carrier
         * @param {ELDCredentials} eLDCredentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdEldsCredentialsPost: function (carrierId, eLDCredentials, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdEldsCredentialsPost', 'carrierId', carrierId);
                            // verify required parameter 'eLDCredentials' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdEldsCredentialsPost', 'eLDCredentials', eLDCredentials);
                            localVarPath = "/carriers/{carrierId}/elds/credentials/"
                                .replace("{".concat("carrierId", "}"), encodeURIComponent(String(carrierId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(eLDCredentials, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Hours of Service for the driver
         * @param {string} carrierId The id of the carrier
         * @param {string} driverId The id of the driver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdEldsHosDriverIdGet: function (carrierId, driverId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdEldsHosDriverIdGet', 'carrierId', carrierId);
                            // verify required parameter 'driverId' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdEldsHosDriverIdGet', 'driverId', driverId);
                            localVarPath = "/carriers/{carrierId}/elds/hos/{driverId}/"
                                .replace("{".concat("carrierId", "}"), encodeURIComponent(String(carrierId)))
                                .replace("{".concat("driverId", "}"), encodeURIComponent(String(driverId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all driver hours of service for the carrier
         * @param {string} carrierId The id of the carrier
         * @param {Array<string>} [providers] An array of providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdEldsHosGet: function (carrierId, providers, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdEldsHosGet', 'carrierId', carrierId);
                            localVarPath = "/carriers/{carrierId}/elds/hos/"
                                .replace("{".concat("carrierId", "}"), encodeURIComponent(String(carrierId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (providers) {
                                localVarQueryParameter['providers'] = providers;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get most recently reported Locations for the fleet
         * @param {string} carrierId The id of the carrier
         * @param {Array<string>} [providers] An array of providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdEldsPowerUnitLocationsGet: function (carrierId, providers, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdEldsPowerUnitLocationsGet', 'carrierId', carrierId);
                            localVarPath = "/carriers/{carrierId}/elds/power-unit-locations/"
                                .replace("{".concat("carrierId", "}"), encodeURIComponent(String(carrierId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (providers) {
                                localVarQueryParameter['providers'] = providers;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the most recent location for the power unit
         * @param {string} carrierId The id of the carrier
         * @param {string} powerUnitId The id of the power unit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdEldsPowerUnitLocationsPowerUnitIdGet: function (carrierId, powerUnitId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdEldsPowerUnitLocationsPowerUnitIdGet', 'carrierId', carrierId);
                            // verify required parameter 'powerUnitId' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdEldsPowerUnitLocationsPowerUnitIdGet', 'powerUnitId', powerUnitId);
                            localVarPath = "/carriers/{carrierId}/elds/power-unit-locations/{powerUnitId}/"
                                .replace("{".concat("carrierId", "}"), encodeURIComponent(String(carrierId)))
                                .replace("{".concat("powerUnitId", "}"), encodeURIComponent(String(powerUnitId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Power units for a carrier
         * @param {string} carrierId The id of the carrier
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [powerUnitName] PowerUnit name to query on
         * @param {string} [powerUnitNameContains] PowerUnit name substring to query on. Ignored if also querying for exact name.
         * @param {'Active' | 'Inactive'} [status] The power unit status to filter on
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdPowerUnitsGet: function (carrierId, page, pageSize, ordering, powerUnitName, powerUnitNameContains, status, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdPowerUnitsGet', 'carrierId', carrierId);
                            localVarPath = "/carriers/{carrierId}/power-units/"
                                .replace("{".concat("carrierId", "}"), encodeURIComponent(String(carrierId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (powerUnitName !== undefined) {
                                localVarQueryParameter['power_unit_name'] = powerUnitName;
                            }
                            if (powerUnitNameContains !== undefined) {
                                localVarQueryParameter['power_unit_name__contains'] = powerUnitNameContains;
                            }
                            if (status !== undefined) {
                                localVarQueryParameter['status'] = status;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * If this Carrier has an ELD Provider, calling this with no body, will pull the power units from the provider
         * @summary Creates a new power unit
         * @param {string} carrierId The id of the carrier
         * @param {PowerUnit} powerUnit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdPowerUnitsPost: function (carrierId, powerUnit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdPowerUnitsPost', 'carrierId', carrierId);
                            // verify required parameter 'powerUnit' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdPowerUnitsPost', 'powerUnit', powerUnit);
                            localVarPath = "/carriers/{carrierId}/power-units/"
                                .replace("{".concat("carrierId", "}"), encodeURIComponent(String(carrierId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(powerUnit, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a power unit
         * @param {string} carrierId The id of the carrier
         * @param {string} powerUnitId The id of the power unit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdPowerUnitsPowerUnitIdDelete: function (carrierId, powerUnitId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdPowerUnitsPowerUnitIdDelete', 'carrierId', carrierId);
                            // verify required parameter 'powerUnitId' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdPowerUnitsPowerUnitIdDelete', 'powerUnitId', powerUnitId);
                            localVarPath = "/carriers/{carrierId}/power-units/{powerUnitId}/"
                                .replace("{".concat("carrierId", "}"), encodeURIComponent(String(carrierId)))
                                .replace("{".concat("powerUnitId", "}"), encodeURIComponent(String(powerUnitId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a power unit
         * @param {string} carrierId The id of the carrier
         * @param {string} powerUnitId The id of the power unit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdPowerUnitsPowerUnitIdGet: function (carrierId, powerUnitId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdPowerUnitsPowerUnitIdGet', 'carrierId', carrierId);
                            // verify required parameter 'powerUnitId' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdPowerUnitsPowerUnitIdGet', 'powerUnitId', powerUnitId);
                            localVarPath = "/carriers/{carrierId}/power-units/{powerUnitId}/"
                                .replace("{".concat("carrierId", "}"), encodeURIComponent(String(carrierId)))
                                .replace("{".concat("powerUnitId", "}"), encodeURIComponent(String(powerUnitId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update information about a power unit
         * @param {string} carrierId The id of the carrier
         * @param {string} powerUnitId The id of the power unit
         * @param {PowerUnit} powerUnit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdPowerUnitsPowerUnitIdPut: function (carrierId, powerUnitId, powerUnit, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdPowerUnitsPowerUnitIdPut', 'carrierId', carrierId);
                            // verify required parameter 'powerUnitId' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdPowerUnitsPowerUnitIdPut', 'powerUnitId', powerUnitId);
                            // verify required parameter 'powerUnit' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdPowerUnitsPowerUnitIdPut', 'powerUnit', powerUnit);
                            localVarPath = "/carriers/{carrierId}/power-units/{powerUnitId}/"
                                .replace("{".concat("carrierId", "}"), encodeURIComponent(String(carrierId)))
                                .replace("{".concat("powerUnitId", "}"), encodeURIComponent(String(powerUnitId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(powerUnit, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Active shipments that have this power-unit assigned
         * @param {string} carrierId The id of the carrier
         * @param {string} powerUnitId The id of the power unit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdPowerUnitsPowerUnitIdShipmentsGet: function (carrierId, powerUnitId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdPowerUnitsPowerUnitIdShipmentsGet', 'carrierId', carrierId);
                            // verify required parameter 'powerUnitId' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdPowerUnitsPowerUnitIdShipmentsGet', 'powerUnitId', powerUnitId);
                            localVarPath = "/carriers/{carrierId}/power-units/{powerUnitId}/shipments/"
                                .replace("{".concat("carrierId", "}"), encodeURIComponent(String(carrierId)))
                                .replace("{".concat("powerUnitId", "}"), encodeURIComponent(String(powerUnitId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Trailers for a carrier
         * @param {string} carrierId The id of the carrier
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdTrailersGet: function (carrierId, page, pageSize, ordering, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdTrailersGet', 'carrierId', carrierId);
                            localVarPath = "/carriers/{carrierId}/trailers/"
                                .replace("{".concat("carrierId", "}"), encodeURIComponent(String(carrierId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new trailer
         * @param {string} carrierId The id of the carrier
         * @param {Trailer} trailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdTrailersPost: function (carrierId, trailer, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdTrailersPost', 'carrierId', carrierId);
                            // verify required parameter 'trailer' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdTrailersPost', 'trailer', trailer);
                            localVarPath = "/carriers/{carrierId}/trailers/"
                                .replace("{".concat("carrierId", "}"), encodeURIComponent(String(carrierId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(trailer, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a trailer
         * @param {string} carrierId The id of the carrier
         * @param {string} trailerId The id of the trailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdTrailersTrailerIdDelete: function (carrierId, trailerId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdTrailersTrailerIdDelete', 'carrierId', carrierId);
                            // verify required parameter 'trailerId' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdTrailersTrailerIdDelete', 'trailerId', trailerId);
                            localVarPath = "/carriers/{carrierId}/trailers/{trailerId}/"
                                .replace("{".concat("carrierId", "}"), encodeURIComponent(String(carrierId)))
                                .replace("{".concat("trailerId", "}"), encodeURIComponent(String(trailerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a trailer
         * @param {string} carrierId The id of the carrier
         * @param {string} trailerId The id of the trailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdTrailersTrailerIdGet: function (carrierId, trailerId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdTrailersTrailerIdGet', 'carrierId', carrierId);
                            // verify required parameter 'trailerId' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdTrailersTrailerIdGet', 'trailerId', trailerId);
                            localVarPath = "/carriers/{carrierId}/trailers/{trailerId}/"
                                .replace("{".concat("carrierId", "}"), encodeURIComponent(String(carrierId)))
                                .replace("{".concat("trailerId", "}"), encodeURIComponent(String(trailerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update information about a trailer
         * @param {string} carrierId The id of the carrier
         * @param {string} trailerId The id of the trailer
         * @param {Trailer} trailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdTrailersTrailerIdPut: function (carrierId, trailerId, trailer, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierId' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdTrailersTrailerIdPut', 'carrierId', carrierId);
                            // verify required parameter 'trailerId' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdTrailersTrailerIdPut', 'trailerId', trailerId);
                            // verify required parameter 'trailer' is not null or undefined
                            (0, common_1.assertParamExists)('carriersCarrierIdTrailersTrailerIdPut', 'trailer', trailer);
                            localVarPath = "/carriers/{carrierId}/trailers/{trailerId}/"
                                .replace("{".concat("carrierId", "}"), encodeURIComponent(String(carrierId)))
                                .replace("{".concat("trailerId", "}"), encodeURIComponent(String(trailerId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(trailer, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a list of all vendors that support some form of automated quoting, dispatching, tracking, or imaging
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersIntegrationsAutomatedVendorsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/carriers/integrations/automated-vendors/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Notify creators of shipments if they stop tracking.
         * @param {NotifyShipmentsNotTracking} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersNotifyShipmentsNotTrackingPost: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/carriers/notify-shipments-not-tracking/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Allows an SLU dispatcher to request access to Assets
         * @param {AssetsAccessBody} assetsAccessBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersUpgradePermissionRequestPost: function (assetsAccessBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'assetsAccessBody' is not null or undefined
                            (0, common_1.assertParamExists)('carriersUpgradePermissionRequestPost', 'assetsAccessBody', assetsAccessBody);
                            localVarPath = "/carriers/upgrade-permission-request/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(assetsAccessBody, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new driver. If the company has an ELD Provider, doing a post with an empty body will pull the drivers from the ELD Service and create users if the driver phone number and email are unique
         * @param {string} companyId The id of the company
         * @param {Driver} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDriversPost: function (companyId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdDriversPost', 'companyId', companyId);
                            localVarPath = "/companies/{companyId}/drivers/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Link a user to a driver if the relationship doesn\'t already exist
         * @param {string} companyId The id of the company
         * @param {string} userId The id of the user
         * @param {LinkDriver} linkDriver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdUsersUserIdLinkDriverPost: function (companyId, userId, linkDriver, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdUsersUserIdLinkDriverPost', 'companyId', companyId);
                            // verify required parameter 'userId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdUsersUserIdLinkDriverPost', 'userId', userId);
                            // verify required parameter 'linkDriver' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdUsersUserIdLinkDriverPost', 'linkDriver', linkDriver);
                            localVarPath = "/companies/{companyId}/users/{userId}/link-driver/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)))
                                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(linkDriver, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CarriersApiAxiosParamCreator = CarriersApiAxiosParamCreator;
/**
 * CarriersApi - functional programming interface
 * @export
 */
var CarriersApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CarriersApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Creates or Updates ELD Credentials
         * @param {string} carrierId The id of the carrier
         * @param {ELDCredentials} eLDCredentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdEldsCredentialsPost: function (carrierId, eLDCredentials, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carriersCarrierIdEldsCredentialsPost(carrierId, eLDCredentials, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Hours of Service for the driver
         * @param {string} carrierId The id of the carrier
         * @param {string} driverId The id of the driver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdEldsHosDriverIdGet: function (carrierId, driverId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carriersCarrierIdEldsHosDriverIdGet(carrierId, driverId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get all driver hours of service for the carrier
         * @param {string} carrierId The id of the carrier
         * @param {Array<string>} [providers] An array of providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdEldsHosGet: function (carrierId, providers, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carriersCarrierIdEldsHosGet(carrierId, providers, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get most recently reported Locations for the fleet
         * @param {string} carrierId The id of the carrier
         * @param {Array<string>} [providers] An array of providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdEldsPowerUnitLocationsGet: function (carrierId, providers, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carriersCarrierIdEldsPowerUnitLocationsGet(carrierId, providers, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the most recent location for the power unit
         * @param {string} carrierId The id of the carrier
         * @param {string} powerUnitId The id of the power unit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdEldsPowerUnitLocationsPowerUnitIdGet: function (carrierId, powerUnitId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carriersCarrierIdEldsPowerUnitLocationsPowerUnitIdGet(carrierId, powerUnitId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Power units for a carrier
         * @param {string} carrierId The id of the carrier
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [powerUnitName] PowerUnit name to query on
         * @param {string} [powerUnitNameContains] PowerUnit name substring to query on. Ignored if also querying for exact name.
         * @param {'Active' | 'Inactive'} [status] The power unit status to filter on
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdPowerUnitsGet: function (carrierId, page, pageSize, ordering, powerUnitName, powerUnitNameContains, status, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carriersCarrierIdPowerUnitsGet(carrierId, page, pageSize, ordering, powerUnitName, powerUnitNameContains, status, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * If this Carrier has an ELD Provider, calling this with no body, will pull the power units from the provider
         * @summary Creates a new power unit
         * @param {string} carrierId The id of the carrier
         * @param {PowerUnit} powerUnit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdPowerUnitsPost: function (carrierId, powerUnit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carriersCarrierIdPowerUnitsPost(carrierId, powerUnit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a power unit
         * @param {string} carrierId The id of the carrier
         * @param {string} powerUnitId The id of the power unit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdPowerUnitsPowerUnitIdDelete: function (carrierId, powerUnitId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carriersCarrierIdPowerUnitsPowerUnitIdDelete(carrierId, powerUnitId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a power unit
         * @param {string} carrierId The id of the carrier
         * @param {string} powerUnitId The id of the power unit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdPowerUnitsPowerUnitIdGet: function (carrierId, powerUnitId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carriersCarrierIdPowerUnitsPowerUnitIdGet(carrierId, powerUnitId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update information about a power unit
         * @param {string} carrierId The id of the carrier
         * @param {string} powerUnitId The id of the power unit
         * @param {PowerUnit} powerUnit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdPowerUnitsPowerUnitIdPut: function (carrierId, powerUnitId, powerUnit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carriersCarrierIdPowerUnitsPowerUnitIdPut(carrierId, powerUnitId, powerUnit, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Active shipments that have this power-unit assigned
         * @param {string} carrierId The id of the carrier
         * @param {string} powerUnitId The id of the power unit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdPowerUnitsPowerUnitIdShipmentsGet: function (carrierId, powerUnitId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carriersCarrierIdPowerUnitsPowerUnitIdShipmentsGet(carrierId, powerUnitId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Trailers for a carrier
         * @param {string} carrierId The id of the carrier
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdTrailersGet: function (carrierId, page, pageSize, ordering, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carriersCarrierIdTrailersGet(carrierId, page, pageSize, ordering, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new trailer
         * @param {string} carrierId The id of the carrier
         * @param {Trailer} trailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdTrailersPost: function (carrierId, trailer, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carriersCarrierIdTrailersPost(carrierId, trailer, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a trailer
         * @param {string} carrierId The id of the carrier
         * @param {string} trailerId The id of the trailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdTrailersTrailerIdDelete: function (carrierId, trailerId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carriersCarrierIdTrailersTrailerIdDelete(carrierId, trailerId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a trailer
         * @param {string} carrierId The id of the carrier
         * @param {string} trailerId The id of the trailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdTrailersTrailerIdGet: function (carrierId, trailerId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carriersCarrierIdTrailersTrailerIdGet(carrierId, trailerId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update information about a trailer
         * @param {string} carrierId The id of the carrier
         * @param {string} trailerId The id of the trailer
         * @param {Trailer} trailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdTrailersTrailerIdPut: function (carrierId, trailerId, trailer, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carriersCarrierIdTrailersTrailerIdPut(carrierId, trailerId, trailer, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a list of all vendors that support some form of automated quoting, dispatching, tracking, or imaging
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersIntegrationsAutomatedVendorsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carriersIntegrationsAutomatedVendorsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Notify creators of shipments if they stop tracking.
         * @param {NotifyShipmentsNotTracking} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersNotifyShipmentsNotTrackingPost: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carriersNotifyShipmentsNotTrackingPost(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Allows an SLU dispatcher to request access to Assets
         * @param {AssetsAccessBody} assetsAccessBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersUpgradePermissionRequestPost: function (assetsAccessBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carriersUpgradePermissionRequestPost(assetsAccessBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new driver. If the company has an ELD Provider, doing a post with an empty body will pull the drivers from the ELD Service and create users if the driver phone number and email are unique
         * @param {string} companyId The id of the company
         * @param {Driver} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDriversPost: function (companyId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdDriversPost(companyId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Link a user to a driver if the relationship doesn\'t already exist
         * @param {string} companyId The id of the company
         * @param {string} userId The id of the user
         * @param {LinkDriver} linkDriver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdUsersUserIdLinkDriverPost: function (companyId, userId, linkDriver, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdUsersUserIdLinkDriverPost(companyId, userId, linkDriver, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CarriersApiFp = CarriersApiFp;
/**
 * CarriersApi - factory interface
 * @export
 */
var CarriersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CarriersApiFp)(configuration);
    return {
        /**
         *
         * @summary Creates or Updates ELD Credentials
         * @param {string} carrierId The id of the carrier
         * @param {ELDCredentials} eLDCredentials
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdEldsCredentialsPost: function (carrierId, eLDCredentials, options) {
            return localVarFp.carriersCarrierIdEldsCredentialsPost(carrierId, eLDCredentials, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Hours of Service for the driver
         * @param {string} carrierId The id of the carrier
         * @param {string} driverId The id of the driver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdEldsHosDriverIdGet: function (carrierId, driverId, options) {
            return localVarFp.carriersCarrierIdEldsHosDriverIdGet(carrierId, driverId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get all driver hours of service for the carrier
         * @param {string} carrierId The id of the carrier
         * @param {Array<string>} [providers] An array of providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdEldsHosGet: function (carrierId, providers, options) {
            return localVarFp.carriersCarrierIdEldsHosGet(carrierId, providers, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get most recently reported Locations for the fleet
         * @param {string} carrierId The id of the carrier
         * @param {Array<string>} [providers] An array of providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdEldsPowerUnitLocationsGet: function (carrierId, providers, options) {
            return localVarFp.carriersCarrierIdEldsPowerUnitLocationsGet(carrierId, providers, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get the most recent location for the power unit
         * @param {string} carrierId The id of the carrier
         * @param {string} powerUnitId The id of the power unit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdEldsPowerUnitLocationsPowerUnitIdGet: function (carrierId, powerUnitId, options) {
            return localVarFp.carriersCarrierIdEldsPowerUnitLocationsPowerUnitIdGet(carrierId, powerUnitId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Power units for a carrier
         * @param {string} carrierId The id of the carrier
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [powerUnitName] PowerUnit name to query on
         * @param {string} [powerUnitNameContains] PowerUnit name substring to query on. Ignored if also querying for exact name.
         * @param {'Active' | 'Inactive'} [status] The power unit status to filter on
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdPowerUnitsGet: function (carrierId, page, pageSize, ordering, powerUnitName, powerUnitNameContains, status, options) {
            return localVarFp.carriersCarrierIdPowerUnitsGet(carrierId, page, pageSize, ordering, powerUnitName, powerUnitNameContains, status, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * If this Carrier has an ELD Provider, calling this with no body, will pull the power units from the provider
         * @summary Creates a new power unit
         * @param {string} carrierId The id of the carrier
         * @param {PowerUnit} powerUnit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdPowerUnitsPost: function (carrierId, powerUnit, options) {
            return localVarFp.carriersCarrierIdPowerUnitsPost(carrierId, powerUnit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a power unit
         * @param {string} carrierId The id of the carrier
         * @param {string} powerUnitId The id of the power unit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdPowerUnitsPowerUnitIdDelete: function (carrierId, powerUnitId, options) {
            return localVarFp.carriersCarrierIdPowerUnitsPowerUnitIdDelete(carrierId, powerUnitId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about a power unit
         * @param {string} carrierId The id of the carrier
         * @param {string} powerUnitId The id of the power unit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdPowerUnitsPowerUnitIdGet: function (carrierId, powerUnitId, options) {
            return localVarFp.carriersCarrierIdPowerUnitsPowerUnitIdGet(carrierId, powerUnitId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update information about a power unit
         * @param {string} carrierId The id of the carrier
         * @param {string} powerUnitId The id of the power unit
         * @param {PowerUnit} powerUnit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdPowerUnitsPowerUnitIdPut: function (carrierId, powerUnitId, powerUnit, options) {
            return localVarFp.carriersCarrierIdPowerUnitsPowerUnitIdPut(carrierId, powerUnitId, powerUnit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Active shipments that have this power-unit assigned
         * @param {string} carrierId The id of the carrier
         * @param {string} powerUnitId The id of the power unit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdPowerUnitsPowerUnitIdShipmentsGet: function (carrierId, powerUnitId, options) {
            return localVarFp.carriersCarrierIdPowerUnitsPowerUnitIdShipmentsGet(carrierId, powerUnitId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Trailers for a carrier
         * @param {string} carrierId The id of the carrier
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdTrailersGet: function (carrierId, page, pageSize, ordering, options) {
            return localVarFp.carriersCarrierIdTrailersGet(carrierId, page, pageSize, ordering, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a new trailer
         * @param {string} carrierId The id of the carrier
         * @param {Trailer} trailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdTrailersPost: function (carrierId, trailer, options) {
            return localVarFp.carriersCarrierIdTrailersPost(carrierId, trailer, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a trailer
         * @param {string} carrierId The id of the carrier
         * @param {string} trailerId The id of the trailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdTrailersTrailerIdDelete: function (carrierId, trailerId, options) {
            return localVarFp.carriersCarrierIdTrailersTrailerIdDelete(carrierId, trailerId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about a trailer
         * @param {string} carrierId The id of the carrier
         * @param {string} trailerId The id of the trailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdTrailersTrailerIdGet: function (carrierId, trailerId, options) {
            return localVarFp.carriersCarrierIdTrailersTrailerIdGet(carrierId, trailerId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update information about a trailer
         * @param {string} carrierId The id of the carrier
         * @param {string} trailerId The id of the trailer
         * @param {Trailer} trailer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersCarrierIdTrailersTrailerIdPut: function (carrierId, trailerId, trailer, options) {
            return localVarFp.carriersCarrierIdTrailersTrailerIdPut(carrierId, trailerId, trailer, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a list of all vendors that support some form of automated quoting, dispatching, tracking, or imaging
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersIntegrationsAutomatedVendorsGet: function (options) {
            return localVarFp.carriersIntegrationsAutomatedVendorsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Notify creators of shipments if they stop tracking.
         * @param {NotifyShipmentsNotTracking} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersNotifyShipmentsNotTrackingPost: function (body, options) {
            return localVarFp.carriersNotifyShipmentsNotTrackingPost(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Allows an SLU dispatcher to request access to Assets
         * @param {AssetsAccessBody} assetsAccessBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carriersUpgradePermissionRequestPost: function (assetsAccessBody, options) {
            return localVarFp.carriersUpgradePermissionRequestPost(assetsAccessBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a new driver. If the company has an ELD Provider, doing a post with an empty body will pull the drivers from the ELD Service and create users if the driver phone number and email are unique
         * @param {string} companyId The id of the company
         * @param {Driver} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDriversPost: function (companyId, body, options) {
            return localVarFp.companiesCompanyIdDriversPost(companyId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Link a user to a driver if the relationship doesn\'t already exist
         * @param {string} companyId The id of the company
         * @param {string} userId The id of the user
         * @param {LinkDriver} linkDriver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdUsersUserIdLinkDriverPost: function (companyId, userId, linkDriver, options) {
            return localVarFp.companiesCompanyIdUsersUserIdLinkDriverPost(companyId, userId, linkDriver, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CarriersApiFactory = CarriersApiFactory;
/**
 * CarriersApi - object-oriented interface
 * @export
 * @class CarriersApi
 * @extends {BaseAPI}
 */
var CarriersApi = /** @class */ (function (_super) {
    __extends(CarriersApi, _super);
    function CarriersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Creates or Updates ELD Credentials
     * @param {string} carrierId The id of the carrier
     * @param {ELDCredentials} eLDCredentials
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    CarriersApi.prototype.carriersCarrierIdEldsCredentialsPost = function (carrierId, eLDCredentials, options) {
        var _this = this;
        return (0, exports.CarriersApiFp)(this.configuration).carriersCarrierIdEldsCredentialsPost(carrierId, eLDCredentials, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Hours of Service for the driver
     * @param {string} carrierId The id of the carrier
     * @param {string} driverId The id of the driver
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    CarriersApi.prototype.carriersCarrierIdEldsHosDriverIdGet = function (carrierId, driverId, options) {
        var _this = this;
        return (0, exports.CarriersApiFp)(this.configuration).carriersCarrierIdEldsHosDriverIdGet(carrierId, driverId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get all driver hours of service for the carrier
     * @param {string} carrierId The id of the carrier
     * @param {Array<string>} [providers] An array of providers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    CarriersApi.prototype.carriersCarrierIdEldsHosGet = function (carrierId, providers, options) {
        var _this = this;
        return (0, exports.CarriersApiFp)(this.configuration).carriersCarrierIdEldsHosGet(carrierId, providers, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get most recently reported Locations for the fleet
     * @param {string} carrierId The id of the carrier
     * @param {Array<string>} [providers] An array of providers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    CarriersApi.prototype.carriersCarrierIdEldsPowerUnitLocationsGet = function (carrierId, providers, options) {
        var _this = this;
        return (0, exports.CarriersApiFp)(this.configuration).carriersCarrierIdEldsPowerUnitLocationsGet(carrierId, providers, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get the most recent location for the power unit
     * @param {string} carrierId The id of the carrier
     * @param {string} powerUnitId The id of the power unit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    CarriersApi.prototype.carriersCarrierIdEldsPowerUnitLocationsPowerUnitIdGet = function (carrierId, powerUnitId, options) {
        var _this = this;
        return (0, exports.CarriersApiFp)(this.configuration).carriersCarrierIdEldsPowerUnitLocationsPowerUnitIdGet(carrierId, powerUnitId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Power units for a carrier
     * @param {string} carrierId The id of the carrier
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [powerUnitName] PowerUnit name to query on
     * @param {string} [powerUnitNameContains] PowerUnit name substring to query on. Ignored if also querying for exact name.
     * @param {'Active' | 'Inactive'} [status] The power unit status to filter on
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    CarriersApi.prototype.carriersCarrierIdPowerUnitsGet = function (carrierId, page, pageSize, ordering, powerUnitName, powerUnitNameContains, status, options) {
        var _this = this;
        return (0, exports.CarriersApiFp)(this.configuration).carriersCarrierIdPowerUnitsGet(carrierId, page, pageSize, ordering, powerUnitName, powerUnitNameContains, status, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * If this Carrier has an ELD Provider, calling this with no body, will pull the power units from the provider
     * @summary Creates a new power unit
     * @param {string} carrierId The id of the carrier
     * @param {PowerUnit} powerUnit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    CarriersApi.prototype.carriersCarrierIdPowerUnitsPost = function (carrierId, powerUnit, options) {
        var _this = this;
        return (0, exports.CarriersApiFp)(this.configuration).carriersCarrierIdPowerUnitsPost(carrierId, powerUnit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a power unit
     * @param {string} carrierId The id of the carrier
     * @param {string} powerUnitId The id of the power unit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    CarriersApi.prototype.carriersCarrierIdPowerUnitsPowerUnitIdDelete = function (carrierId, powerUnitId, options) {
        var _this = this;
        return (0, exports.CarriersApiFp)(this.configuration).carriersCarrierIdPowerUnitsPowerUnitIdDelete(carrierId, powerUnitId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about a power unit
     * @param {string} carrierId The id of the carrier
     * @param {string} powerUnitId The id of the power unit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    CarriersApi.prototype.carriersCarrierIdPowerUnitsPowerUnitIdGet = function (carrierId, powerUnitId, options) {
        var _this = this;
        return (0, exports.CarriersApiFp)(this.configuration).carriersCarrierIdPowerUnitsPowerUnitIdGet(carrierId, powerUnitId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update information about a power unit
     * @param {string} carrierId The id of the carrier
     * @param {string} powerUnitId The id of the power unit
     * @param {PowerUnit} powerUnit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    CarriersApi.prototype.carriersCarrierIdPowerUnitsPowerUnitIdPut = function (carrierId, powerUnitId, powerUnit, options) {
        var _this = this;
        return (0, exports.CarriersApiFp)(this.configuration).carriersCarrierIdPowerUnitsPowerUnitIdPut(carrierId, powerUnitId, powerUnit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Active shipments that have this power-unit assigned
     * @param {string} carrierId The id of the carrier
     * @param {string} powerUnitId The id of the power unit
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    CarriersApi.prototype.carriersCarrierIdPowerUnitsPowerUnitIdShipmentsGet = function (carrierId, powerUnitId, options) {
        var _this = this;
        return (0, exports.CarriersApiFp)(this.configuration).carriersCarrierIdPowerUnitsPowerUnitIdShipmentsGet(carrierId, powerUnitId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Trailers for a carrier
     * @param {string} carrierId The id of the carrier
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    CarriersApi.prototype.carriersCarrierIdTrailersGet = function (carrierId, page, pageSize, ordering, options) {
        var _this = this;
        return (0, exports.CarriersApiFp)(this.configuration).carriersCarrierIdTrailersGet(carrierId, page, pageSize, ordering, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a new trailer
     * @param {string} carrierId The id of the carrier
     * @param {Trailer} trailer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    CarriersApi.prototype.carriersCarrierIdTrailersPost = function (carrierId, trailer, options) {
        var _this = this;
        return (0, exports.CarriersApiFp)(this.configuration).carriersCarrierIdTrailersPost(carrierId, trailer, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a trailer
     * @param {string} carrierId The id of the carrier
     * @param {string} trailerId The id of the trailer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    CarriersApi.prototype.carriersCarrierIdTrailersTrailerIdDelete = function (carrierId, trailerId, options) {
        var _this = this;
        return (0, exports.CarriersApiFp)(this.configuration).carriersCarrierIdTrailersTrailerIdDelete(carrierId, trailerId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about a trailer
     * @param {string} carrierId The id of the carrier
     * @param {string} trailerId The id of the trailer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    CarriersApi.prototype.carriersCarrierIdTrailersTrailerIdGet = function (carrierId, trailerId, options) {
        var _this = this;
        return (0, exports.CarriersApiFp)(this.configuration).carriersCarrierIdTrailersTrailerIdGet(carrierId, trailerId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update information about a trailer
     * @param {string} carrierId The id of the carrier
     * @param {string} trailerId The id of the trailer
     * @param {Trailer} trailer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    CarriersApi.prototype.carriersCarrierIdTrailersTrailerIdPut = function (carrierId, trailerId, trailer, options) {
        var _this = this;
        return (0, exports.CarriersApiFp)(this.configuration).carriersCarrierIdTrailersTrailerIdPut(carrierId, trailerId, trailer, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a list of all vendors that support some form of automated quoting, dispatching, tracking, or imaging
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    CarriersApi.prototype.carriersIntegrationsAutomatedVendorsGet = function (options) {
        var _this = this;
        return (0, exports.CarriersApiFp)(this.configuration).carriersIntegrationsAutomatedVendorsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Notify creators of shipments if they stop tracking.
     * @param {NotifyShipmentsNotTracking} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    CarriersApi.prototype.carriersNotifyShipmentsNotTrackingPost = function (body, options) {
        var _this = this;
        return (0, exports.CarriersApiFp)(this.configuration).carriersNotifyShipmentsNotTrackingPost(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Allows an SLU dispatcher to request access to Assets
     * @param {AssetsAccessBody} assetsAccessBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    CarriersApi.prototype.carriersUpgradePermissionRequestPost = function (assetsAccessBody, options) {
        var _this = this;
        return (0, exports.CarriersApiFp)(this.configuration).carriersUpgradePermissionRequestPost(assetsAccessBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a new driver. If the company has an ELD Provider, doing a post with an empty body will pull the drivers from the ELD Service and create users if the driver phone number and email are unique
     * @param {string} companyId The id of the company
     * @param {Driver} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    CarriersApi.prototype.companiesCompanyIdDriversPost = function (companyId, body, options) {
        var _this = this;
        return (0, exports.CarriersApiFp)(this.configuration).companiesCompanyIdDriversPost(companyId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Link a user to a driver if the relationship doesn\'t already exist
     * @param {string} companyId The id of the company
     * @param {string} userId The id of the user
     * @param {LinkDriver} linkDriver
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CarriersApi
     */
    CarriersApi.prototype.companiesCompanyIdUsersUserIdLinkDriverPost = function (companyId, userId, linkDriver, options) {
        var _this = this;
        return (0, exports.CarriersApiFp)(this.configuration).companiesCompanyIdUsersUserIdLinkDriverPost(companyId, userId, linkDriver, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CarriersApi;
}(base_1.BaseAPI));
exports.CarriersApi = CarriersApi;
/**
 * CevaApi - axios parameter creator
 * @export
 */
var CevaApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary List of CEVA customer specific rates.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCevaServiceLevelRatesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/quoting/ceva/service-level-rates/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List of CEVA rate zone definitions by state and zip.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCevaStateZoneRatesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/quoting/ceva/state-zone-rates/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List of CEVA zone to zone mappings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCevaZoneRateScaleGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/quoting/ceva/zone-rate-scale/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CevaApiAxiosParamCreator = CevaApiAxiosParamCreator;
/**
 * CevaApi - functional programming interface
 * @export
 */
var CevaApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CevaApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary List of CEVA customer specific rates.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCevaServiceLevelRatesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingCevaServiceLevelRatesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List of CEVA rate zone definitions by state and zip.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCevaStateZoneRatesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingCevaStateZoneRatesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List of CEVA zone to zone mappings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCevaZoneRateScaleGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingCevaZoneRateScaleGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CevaApiFp = CevaApiFp;
/**
 * CevaApi - factory interface
 * @export
 */
var CevaApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CevaApiFp)(configuration);
    return {
        /**
         *
         * @summary List of CEVA customer specific rates.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCevaServiceLevelRatesGet: function (options) {
            return localVarFp.quotingCevaServiceLevelRatesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List of CEVA rate zone definitions by state and zip.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCevaStateZoneRatesGet: function (options) {
            return localVarFp.quotingCevaStateZoneRatesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List of CEVA zone to zone mappings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingCevaZoneRateScaleGet: function (options) {
            return localVarFp.quotingCevaZoneRateScaleGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CevaApiFactory = CevaApiFactory;
/**
 * CevaApi - object-oriented interface
 * @export
 * @class CevaApi
 * @extends {BaseAPI}
 */
var CevaApi = /** @class */ (function (_super) {
    __extends(CevaApi, _super);
    function CevaApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary List of CEVA customer specific rates.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CevaApi
     */
    CevaApi.prototype.quotingCevaServiceLevelRatesGet = function (options) {
        var _this = this;
        return (0, exports.CevaApiFp)(this.configuration).quotingCevaServiceLevelRatesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List of CEVA rate zone definitions by state and zip.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CevaApi
     */
    CevaApi.prototype.quotingCevaStateZoneRatesGet = function (options) {
        var _this = this;
        return (0, exports.CevaApiFp)(this.configuration).quotingCevaStateZoneRatesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List of CEVA zone to zone mappings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CevaApi
     */
    CevaApi.prototype.quotingCevaZoneRateScaleGet = function (options) {
        var _this = this;
        return (0, exports.CevaApiFp)(this.configuration).quotingCevaZoneRateScaleGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CevaApi;
}(base_1.BaseAPI));
exports.CevaApi = CevaApi;
/**
 * CompaniesApi - axios parameter creator
 * @export
 */
var CompaniesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Determine if a driver may be linked to a company based off their email address
         * @param {string} email A valid email address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCanLinkDriverGet: function (email, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'email' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCanLinkDriverGet', 'email', email);
                            localVarPath = "/companies/can-link-driver/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (email !== undefined) {
                                localVarQueryParameter['email'] = email;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a custom field
         * @param {string} companyId The id of the company
         * @param {string} customFieldId The id of the custom field
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdCustomFieldsCustomFieldIdDelete: function (companyId, customFieldId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdCustomFieldsCustomFieldIdDelete', 'companyId', companyId);
                            // verify required parameter 'customFieldId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdCustomFieldsCustomFieldIdDelete', 'customFieldId', customFieldId);
                            localVarPath = "/companies/{companyId}/custom-fields/{customFieldId}/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)))
                                .replace("{".concat("customFieldId", "}"), encodeURIComponent(String(customFieldId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a custom field
         * @param {string} companyId The id of the company
         * @param {string} customFieldId The id of the custom field
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdCustomFieldsCustomFieldIdGet: function (companyId, customFieldId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdCustomFieldsCustomFieldIdGet', 'companyId', companyId);
                            // verify required parameter 'customFieldId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdCustomFieldsCustomFieldIdGet', 'customFieldId', customFieldId);
                            localVarPath = "/companies/{companyId}/custom-fields/{customFieldId}/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)))
                                .replace("{".concat("customFieldId", "}"), encodeURIComponent(String(customFieldId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a custom field
         * @param {string} companyId The id of the company
         * @param {string} customFieldId The id of the custom field
         * @param {CustomField} customField
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdCustomFieldsCustomFieldIdPut: function (companyId, customFieldId, customField, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdCustomFieldsCustomFieldIdPut', 'companyId', companyId);
                            // verify required parameter 'customFieldId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdCustomFieldsCustomFieldIdPut', 'customFieldId', customFieldId);
                            // verify required parameter 'customField' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdCustomFieldsCustomFieldIdPut', 'customField', customField);
                            localVarPath = "/companies/{companyId}/custom-fields/{customFieldId}/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)))
                                .replace("{".concat("customFieldId", "}"), encodeURIComponent(String(customFieldId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customField, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a list of custom fields
         * @param {string} companyId The id of the company
         * @param {string} [entityType] Entity type of the Custom Field
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [shipmentId] Include CustomFields where shipment_id is allowed to request user
         * @param {string} [orderId] Include CustomFields where order_id is allowed to request user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdCustomFieldsGet: function (companyId, entityType, page, pageSize, ordering, shipmentId, orderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdCustomFieldsGet', 'companyId', companyId);
                            localVarPath = "/companies/{companyId}/custom-fields/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (entityType !== undefined) {
                                localVarQueryParameter['entity_type'] = entityType;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (shipmentId !== undefined) {
                                localVarQueryParameter['shipment_id'] = shipmentId;
                            }
                            if (orderId !== undefined) {
                                localVarQueryParameter['order_id'] = orderId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a custom field
         * @param {string} companyId The id of the company
         * @param {CustomField} customField
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdCustomFieldsPost: function (companyId, customField, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdCustomFieldsPost', 'companyId', companyId);
                            // verify required parameter 'customField' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdCustomFieldsPost', 'customField', customField);
                            localVarPath = "/companies/{companyId}/custom-fields/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(customField, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about the companies dashboard
         * @param {string} companyId The id of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDashboardGet: function (companyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdDashboardGet', 'companyId', companyId);
                            localVarPath = "/companies/{companyId}/dashboard/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a company
         * @param {string} companyId The id of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDelete: function (companyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdDelete', 'companyId', companyId);
                            localVarPath = "/companies/{companyId}/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a Company Document
         * @param {string} companyId The id of the company
         * @param {string} documentId The id of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDocumentsDocumentIdDelete: function (companyId, documentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdDocumentsDocumentIdDelete', 'companyId', companyId);
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdDocumentsDocumentIdDelete', 'documentId', documentId);
                            localVarPath = "/companies/{companyId}/documents/{documentId}/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)))
                                .replace("{".concat("documentId", "}"), encodeURIComponent(String(documentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get metadata about a company document
         * @param {string} companyId The id of the company
         * @param {string} documentId The id of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDocumentsDocumentIdGet: function (companyId, documentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdDocumentsDocumentIdGet', 'companyId', companyId);
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdDocumentsDocumentIdGet', 'documentId', documentId);
                            localVarPath = "/companies/{companyId}/documents/{documentId}/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)))
                                .replace("{".concat("documentId", "}"), encodeURIComponent(String(documentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update metadata about a company document
         * @param {string} companyId The id of the company
         * @param {string} documentId The id of the document
         * @param {DocumentMetadata} documentMetadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDocumentsDocumentIdPut: function (companyId, documentId, documentMetadata, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdDocumentsDocumentIdPut', 'companyId', companyId);
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdDocumentsDocumentIdPut', 'documentId', documentId);
                            // verify required parameter 'documentMetadata' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdDocumentsDocumentIdPut', 'documentMetadata', documentMetadata);
                            localVarPath = "/companies/{companyId}/documents/{documentId}/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)))
                                .replace("{".concat("documentId", "}"), encodeURIComponent(String(documentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(documentMetadata, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get metadata about documents on a company
         * @param {string} companyId The id of the company
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDocumentsGet: function (companyId, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdDocumentsGet', 'companyId', companyId);
                            localVarPath = "/companies/{companyId}/documents/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a document on a company
         * @param {string} companyId The id of the company
         * @param {string} description
         * @param {any} file
         * @param {string} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDocumentsPost: function (companyId, description, file, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdDocumentsPost', 'companyId', companyId);
                            // verify required parameter 'description' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdDocumentsPost', 'description', description);
                            // verify required parameter 'file' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdDocumentsPost', 'file', file);
                            // verify required parameter 'type' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdDocumentsPost', 'type', type);
                            localVarPath = "/companies/{companyId}/documents/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (description !== undefined) {
                                localVarFormParams.append('description', description);
                            }
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            if (type !== undefined) {
                                localVarFormParams.append('type', type);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a driver
         * @param {string} companyId The id of the company
         * @param {string} driverId The id of the driver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDriversDriverIdDelete: function (companyId, driverId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdDriversDriverIdDelete', 'companyId', companyId);
                            // verify required parameter 'driverId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdDriversDriverIdDelete', 'driverId', driverId);
                            localVarPath = "/companies/{companyId}/drivers/{driverId}/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)))
                                .replace("{".concat("driverId", "}"), encodeURIComponent(String(driverId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a driver associated to a company
         * @param {string} companyId The id of the company
         * @param {string} driverId The id of the driver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDriversDriverIdGet: function (companyId, driverId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdDriversDriverIdGet', 'companyId', companyId);
                            // verify required parameter 'driverId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdDriversDriverIdGet', 'driverId', driverId);
                            localVarPath = "/companies/{companyId}/drivers/{driverId}/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)))
                                .replace("{".concat("driverId", "}"), encodeURIComponent(String(driverId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a driver
         * @param {string} companyId The id of the company
         * @param {string} driverId The id of the driver
         * @param {Driver} driver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDriversDriverIdPut: function (companyId, driverId, driver, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdDriversDriverIdPut', 'companyId', companyId);
                            // verify required parameter 'driverId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdDriversDriverIdPut', 'driverId', driverId);
                            // verify required parameter 'driver' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdDriversDriverIdPut', 'driver', driver);
                            localVarPath = "/companies/{companyId}/drivers/{driverId}/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)))
                                .replace("{".concat("driverId", "}"), encodeURIComponent(String(driverId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(driver, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of drivers associated to a company
         * @param {string} companyId The id of the company
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {Array<string>} [providers] An array of providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDriversGet: function (companyId, page, pageSize, ordering, providers, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdDriversGet', 'companyId', companyId);
                            localVarPath = "/companies/{companyId}/drivers/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (providers) {
                                localVarQueryParameter['providers'] = providers;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a company
         * @param {string} companyId The id of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdGet: function (companyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdGet', 'companyId', companyId);
                            localVarPath = "/companies/{companyId}/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain the company\'s international preferences
         * @param {string} companyId The id of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdInternationalPreferencesGet: function (companyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdInternationalPreferencesGet', 'companyId', companyId);
                            localVarPath = "/companies/{companyId}/international-preferences/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update the company\'s international preferences
         * @param {string} companyId The id of the company
         * @param {CompanyInternationalPreferences} companyInternationalPreferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdInternationalPreferencesPut: function (companyId, companyInternationalPreferences, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdInternationalPreferencesPut', 'companyId', companyId);
                            // verify required parameter 'companyInternationalPreferences' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdInternationalPreferencesPut', 'companyInternationalPreferences', companyInternationalPreferences);
                            localVarPath = "/companies/{companyId}/international-preferences/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(companyInternationalPreferences, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain the company\'s preferences
         * @param {string} companyId The id of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdPreferencesGet: function (companyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdPreferencesGet', 'companyId', companyId);
                            localVarPath = "/companies/{companyId}/preferences/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update the company\'s preferences
         * @param {string} companyId The id of the company
         * @param {CompanyPreferences} companyPreferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdPreferencesPut: function (companyId, companyPreferences, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdPreferencesPut', 'companyId', companyId);
                            // verify required parameter 'companyPreferences' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdPreferencesPut', 'companyPreferences', companyPreferences);
                            localVarPath = "/companies/{companyId}/preferences/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(companyPreferences, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a company
         * @param {string} companyId The id of the company
         * @param {Company} company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdPut: function (companyId, company, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdPut', 'companyId', companyId);
                            // verify required parameter 'company' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdPut', 'company', company);
                            localVarPath = "/companies/{companyId}/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(company, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of a company\'s tracking notification configs.
         * @param {string} companyId The id of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdTrackingNotificationConfigGet: function (companyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdTrackingNotificationConfigGet', 'companyId', companyId);
                            localVarPath = "/companies/{companyId}/tracking-notification-config/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new tracking notification config
         * @param {string} companyId The id of the company
         * @param {TrackingNotificationConfig} trackingNotificationConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdTrackingNotificationConfigPost: function (companyId, trackingNotificationConfig, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdTrackingNotificationConfigPost', 'companyId', companyId);
                            // verify required parameter 'trackingNotificationConfig' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdTrackingNotificationConfigPost', 'trackingNotificationConfig', trackingNotificationConfig);
                            localVarPath = "/companies/{companyId}/tracking-notification-config/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(trackingNotificationConfig, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a tracking notification config
         * @param {string} companyId The id of the company
         * @param {string} trackingNotificationConfigId The ID of the tracking notification config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdTrackingNotificationConfigTrackingNotificationConfigIdGet: function (companyId, trackingNotificationConfigId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdTrackingNotificationConfigTrackingNotificationConfigIdGet', 'companyId', companyId);
                            // verify required parameter 'trackingNotificationConfigId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdTrackingNotificationConfigTrackingNotificationConfigIdGet', 'trackingNotificationConfigId', trackingNotificationConfigId);
                            localVarPath = "/companies/{companyId}/tracking-notification-config/{trackingNotificationConfigId}/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)))
                                .replace("{".concat("trackingNotificationConfigId", "}"), encodeURIComponent(String(trackingNotificationConfigId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates an existing tracking notification config
         * @param {string} companyId The id of the company
         * @param {string} trackingNotificationConfigId The ID of the tracking notification config
         * @param {TrackingNotificationConfig} trackingNotificationConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdTrackingNotificationConfigTrackingNotificationConfigIdPut: function (companyId, trackingNotificationConfigId, trackingNotificationConfig, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdTrackingNotificationConfigTrackingNotificationConfigIdPut', 'companyId', companyId);
                            // verify required parameter 'trackingNotificationConfigId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdTrackingNotificationConfigTrackingNotificationConfigIdPut', 'trackingNotificationConfigId', trackingNotificationConfigId);
                            // verify required parameter 'trackingNotificationConfig' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdTrackingNotificationConfigTrackingNotificationConfigIdPut', 'trackingNotificationConfig', trackingNotificationConfig);
                            localVarPath = "/companies/{companyId}/tracking-notification-config/{trackingNotificationConfigId}/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)))
                                .replace("{".concat("trackingNotificationConfigId", "}"), encodeURIComponent(String(trackingNotificationConfigId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(trackingNotificationConfig, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of companies scoped to the authorization token.
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [carrierId] The id of the carrier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesGet: function (page, pageSize, ordering, carrierId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/companies/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (carrierId !== undefined) {
                                localVarQueryParameter['carrierId'] = carrierId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all identifying codes supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesIdentifyingCodesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/companies/identifying-codes/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary A list of logos associated with a company. The company can be identified through the optional subdomain query parameter or using the authenticated Company, with the subdomain option taking precedence.
         * @param {string} [subdomain] search by a company\&#39;s subdomain
         * @param {string} [imageType] optional parameter to search for a particular image type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesLogosGet: function (subdomain, imageType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/companies/logos/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (subdomain !== undefined) {
                        localVarQueryParameter['subdomain'] = subdomain;
                    }
                    if (imageType !== undefined) {
                        localVarQueryParameter['image_type'] = imageType;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Returns the current settings of company parcel label configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyParcelConfigGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/company-parcel-config/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update settings of company parcel label configuration
         * @param {UpdateCompanyParcelLabelConfigSchema} updateCompanyParcelLabelConfigSchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyParcelConfigPut: function (updateCompanyParcelLabelConfigSchema, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'updateCompanyParcelLabelConfigSchema' is not null or undefined
                            (0, common_1.assertParamExists)('companyParcelConfigPut', 'updateCompanyParcelLabelConfigSchema', updateCompanyParcelLabelConfigSchema);
                            localVarPath = "/company-parcel-config/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateCompanyParcelLabelConfigSchema, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CompaniesApiAxiosParamCreator = CompaniesApiAxiosParamCreator;
/**
 * CompaniesApi - functional programming interface
 * @export
 */
var CompaniesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CompaniesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Determine if a driver may be linked to a company based off their email address
         * @param {string} email A valid email address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCanLinkDriverGet: function (email, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCanLinkDriverGet(email, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a custom field
         * @param {string} companyId The id of the company
         * @param {string} customFieldId The id of the custom field
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdCustomFieldsCustomFieldIdDelete: function (companyId, customFieldId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdCustomFieldsCustomFieldIdDelete(companyId, customFieldId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a custom field
         * @param {string} companyId The id of the company
         * @param {string} customFieldId The id of the custom field
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdCustomFieldsCustomFieldIdGet: function (companyId, customFieldId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdCustomFieldsCustomFieldIdGet(companyId, customFieldId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a custom field
         * @param {string} companyId The id of the company
         * @param {string} customFieldId The id of the custom field
         * @param {CustomField} customField
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdCustomFieldsCustomFieldIdPut: function (companyId, customFieldId, customField, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdCustomFieldsCustomFieldIdPut(companyId, customFieldId, customField, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a list of custom fields
         * @param {string} companyId The id of the company
         * @param {string} [entityType] Entity type of the Custom Field
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [shipmentId] Include CustomFields where shipment_id is allowed to request user
         * @param {string} [orderId] Include CustomFields where order_id is allowed to request user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdCustomFieldsGet: function (companyId, entityType, page, pageSize, ordering, shipmentId, orderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdCustomFieldsGet(companyId, entityType, page, pageSize, ordering, shipmentId, orderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a custom field
         * @param {string} companyId The id of the company
         * @param {CustomField} customField
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdCustomFieldsPost: function (companyId, customField, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdCustomFieldsPost(companyId, customField, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about the companies dashboard
         * @param {string} companyId The id of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDashboardGet: function (companyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdDashboardGet(companyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a company
         * @param {string} companyId The id of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDelete: function (companyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdDelete(companyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a Company Document
         * @param {string} companyId The id of the company
         * @param {string} documentId The id of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDocumentsDocumentIdDelete: function (companyId, documentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdDocumentsDocumentIdDelete(companyId, documentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get metadata about a company document
         * @param {string} companyId The id of the company
         * @param {string} documentId The id of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDocumentsDocumentIdGet: function (companyId, documentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdDocumentsDocumentIdGet(companyId, documentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update metadata about a company document
         * @param {string} companyId The id of the company
         * @param {string} documentId The id of the document
         * @param {DocumentMetadata} documentMetadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDocumentsDocumentIdPut: function (companyId, documentId, documentMetadata, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdDocumentsDocumentIdPut(companyId, documentId, documentMetadata, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get metadata about documents on a company
         * @param {string} companyId The id of the company
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDocumentsGet: function (companyId, page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdDocumentsGet(companyId, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a document on a company
         * @param {string} companyId The id of the company
         * @param {string} description
         * @param {any} file
         * @param {string} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDocumentsPost: function (companyId, description, file, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdDocumentsPost(companyId, description, file, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a driver
         * @param {string} companyId The id of the company
         * @param {string} driverId The id of the driver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDriversDriverIdDelete: function (companyId, driverId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdDriversDriverIdDelete(companyId, driverId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a driver associated to a company
         * @param {string} companyId The id of the company
         * @param {string} driverId The id of the driver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDriversDriverIdGet: function (companyId, driverId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdDriversDriverIdGet(companyId, driverId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a driver
         * @param {string} companyId The id of the company
         * @param {string} driverId The id of the driver
         * @param {Driver} driver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDriversDriverIdPut: function (companyId, driverId, driver, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdDriversDriverIdPut(companyId, driverId, driver, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of drivers associated to a company
         * @param {string} companyId The id of the company
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {Array<string>} [providers] An array of providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDriversGet: function (companyId, page, pageSize, ordering, providers, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdDriversGet(companyId, page, pageSize, ordering, providers, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a company
         * @param {string} companyId The id of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdGet: function (companyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdGet(companyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain the company\'s international preferences
         * @param {string} companyId The id of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdInternationalPreferencesGet: function (companyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdInternationalPreferencesGet(companyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update the company\'s international preferences
         * @param {string} companyId The id of the company
         * @param {CompanyInternationalPreferences} companyInternationalPreferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdInternationalPreferencesPut: function (companyId, companyInternationalPreferences, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdInternationalPreferencesPut(companyId, companyInternationalPreferences, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain the company\'s preferences
         * @param {string} companyId The id of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdPreferencesGet: function (companyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdPreferencesGet(companyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update the company\'s preferences
         * @param {string} companyId The id of the company
         * @param {CompanyPreferences} companyPreferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdPreferencesPut: function (companyId, companyPreferences, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdPreferencesPut(companyId, companyPreferences, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a company
         * @param {string} companyId The id of the company
         * @param {Company} company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdPut: function (companyId, company, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdPut(companyId, company, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of a company\'s tracking notification configs.
         * @param {string} companyId The id of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdTrackingNotificationConfigGet: function (companyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdTrackingNotificationConfigGet(companyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new tracking notification config
         * @param {string} companyId The id of the company
         * @param {TrackingNotificationConfig} trackingNotificationConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdTrackingNotificationConfigPost: function (companyId, trackingNotificationConfig, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdTrackingNotificationConfigPost(companyId, trackingNotificationConfig, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a tracking notification config
         * @param {string} companyId The id of the company
         * @param {string} trackingNotificationConfigId The ID of the tracking notification config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdTrackingNotificationConfigTrackingNotificationConfigIdGet: function (companyId, trackingNotificationConfigId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdTrackingNotificationConfigTrackingNotificationConfigIdGet(companyId, trackingNotificationConfigId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates an existing tracking notification config
         * @param {string} companyId The id of the company
         * @param {string} trackingNotificationConfigId The ID of the tracking notification config
         * @param {TrackingNotificationConfig} trackingNotificationConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdTrackingNotificationConfigTrackingNotificationConfigIdPut: function (companyId, trackingNotificationConfigId, trackingNotificationConfig, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdTrackingNotificationConfigTrackingNotificationConfigIdPut(companyId, trackingNotificationConfigId, trackingNotificationConfig, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of companies scoped to the authorization token.
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [carrierId] The id of the carrier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesGet: function (page, pageSize, ordering, carrierId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesGet(page, pageSize, ordering, carrierId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all identifying codes supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesIdentifyingCodesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesIdentifyingCodesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of logos associated with a company. The company can be identified through the optional subdomain query parameter or using the authenticated Company, with the subdomain option taking precedence.
         * @param {string} [subdomain] search by a company\&#39;s subdomain
         * @param {string} [imageType] optional parameter to search for a particular image type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesLogosGet: function (subdomain, imageType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesLogosGet(subdomain, imageType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the current settings of company parcel label configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyParcelConfigGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companyParcelConfigGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update settings of company parcel label configuration
         * @param {UpdateCompanyParcelLabelConfigSchema} updateCompanyParcelLabelConfigSchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyParcelConfigPut: function (updateCompanyParcelLabelConfigSchema, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companyParcelConfigPut(updateCompanyParcelLabelConfigSchema, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CompaniesApiFp = CompaniesApiFp;
/**
 * CompaniesApi - factory interface
 * @export
 */
var CompaniesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CompaniesApiFp)(configuration);
    return {
        /**
         *
         * @summary Determine if a driver may be linked to a company based off their email address
         * @param {string} email A valid email address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCanLinkDriverGet: function (email, options) {
            return localVarFp.companiesCanLinkDriverGet(email, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a custom field
         * @param {string} companyId The id of the company
         * @param {string} customFieldId The id of the custom field
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdCustomFieldsCustomFieldIdDelete: function (companyId, customFieldId, options) {
            return localVarFp.companiesCompanyIdCustomFieldsCustomFieldIdDelete(companyId, customFieldId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a custom field
         * @param {string} companyId The id of the company
         * @param {string} customFieldId The id of the custom field
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdCustomFieldsCustomFieldIdGet: function (companyId, customFieldId, options) {
            return localVarFp.companiesCompanyIdCustomFieldsCustomFieldIdGet(companyId, customFieldId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a custom field
         * @param {string} companyId The id of the company
         * @param {string} customFieldId The id of the custom field
         * @param {CustomField} customField
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdCustomFieldsCustomFieldIdPut: function (companyId, customFieldId, customField, options) {
            return localVarFp.companiesCompanyIdCustomFieldsCustomFieldIdPut(companyId, customFieldId, customField, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a list of custom fields
         * @param {string} companyId The id of the company
         * @param {string} [entityType] Entity type of the Custom Field
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [shipmentId] Include CustomFields where shipment_id is allowed to request user
         * @param {string} [orderId] Include CustomFields where order_id is allowed to request user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdCustomFieldsGet: function (companyId, entityType, page, pageSize, ordering, shipmentId, orderId, options) {
            return localVarFp.companiesCompanyIdCustomFieldsGet(companyId, entityType, page, pageSize, ordering, shipmentId, orderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a custom field
         * @param {string} companyId The id of the company
         * @param {CustomField} customField
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdCustomFieldsPost: function (companyId, customField, options) {
            return localVarFp.companiesCompanyIdCustomFieldsPost(companyId, customField, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about the companies dashboard
         * @param {string} companyId The id of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDashboardGet: function (companyId, options) {
            return localVarFp.companiesCompanyIdDashboardGet(companyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a company
         * @param {string} companyId The id of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDelete: function (companyId, options) {
            return localVarFp.companiesCompanyIdDelete(companyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a Company Document
         * @param {string} companyId The id of the company
         * @param {string} documentId The id of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDocumentsDocumentIdDelete: function (companyId, documentId, options) {
            return localVarFp.companiesCompanyIdDocumentsDocumentIdDelete(companyId, documentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get metadata about a company document
         * @param {string} companyId The id of the company
         * @param {string} documentId The id of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDocumentsDocumentIdGet: function (companyId, documentId, options) {
            return localVarFp.companiesCompanyIdDocumentsDocumentIdGet(companyId, documentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update metadata about a company document
         * @param {string} companyId The id of the company
         * @param {string} documentId The id of the document
         * @param {DocumentMetadata} documentMetadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDocumentsDocumentIdPut: function (companyId, documentId, documentMetadata, options) {
            return localVarFp.companiesCompanyIdDocumentsDocumentIdPut(companyId, documentId, documentMetadata, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get metadata about documents on a company
         * @param {string} companyId The id of the company
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDocumentsGet: function (companyId, page, pageSize, options) {
            return localVarFp.companiesCompanyIdDocumentsGet(companyId, page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a document on a company
         * @param {string} companyId The id of the company
         * @param {string} description
         * @param {any} file
         * @param {string} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDocumentsPost: function (companyId, description, file, type, options) {
            return localVarFp.companiesCompanyIdDocumentsPost(companyId, description, file, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a driver
         * @param {string} companyId The id of the company
         * @param {string} driverId The id of the driver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDriversDriverIdDelete: function (companyId, driverId, options) {
            return localVarFp.companiesCompanyIdDriversDriverIdDelete(companyId, driverId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a driver associated to a company
         * @param {string} companyId The id of the company
         * @param {string} driverId The id of the driver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDriversDriverIdGet: function (companyId, driverId, options) {
            return localVarFp.companiesCompanyIdDriversDriverIdGet(companyId, driverId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a driver
         * @param {string} companyId The id of the company
         * @param {string} driverId The id of the driver
         * @param {Driver} driver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDriversDriverIdPut: function (companyId, driverId, driver, options) {
            return localVarFp.companiesCompanyIdDriversDriverIdPut(companyId, driverId, driver, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a list of drivers associated to a company
         * @param {string} companyId The id of the company
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {Array<string>} [providers] An array of providers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdDriversGet: function (companyId, page, pageSize, ordering, providers, options) {
            return localVarFp.companiesCompanyIdDriversGet(companyId, page, pageSize, ordering, providers, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about a company
         * @param {string} companyId The id of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdGet: function (companyId, options) {
            return localVarFp.companiesCompanyIdGet(companyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Obtain the company\'s international preferences
         * @param {string} companyId The id of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdInternationalPreferencesGet: function (companyId, options) {
            return localVarFp.companiesCompanyIdInternationalPreferencesGet(companyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update the company\'s international preferences
         * @param {string} companyId The id of the company
         * @param {CompanyInternationalPreferences} companyInternationalPreferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdInternationalPreferencesPut: function (companyId, companyInternationalPreferences, options) {
            return localVarFp.companiesCompanyIdInternationalPreferencesPut(companyId, companyInternationalPreferences, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Obtain the company\'s preferences
         * @param {string} companyId The id of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdPreferencesGet: function (companyId, options) {
            return localVarFp.companiesCompanyIdPreferencesGet(companyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update the company\'s preferences
         * @param {string} companyId The id of the company
         * @param {CompanyPreferences} companyPreferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdPreferencesPut: function (companyId, companyPreferences, options) {
            return localVarFp.companiesCompanyIdPreferencesPut(companyId, companyPreferences, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a company
         * @param {string} companyId The id of the company
         * @param {Company} company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdPut: function (companyId, company, options) {
            return localVarFp.companiesCompanyIdPut(companyId, company, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a list of a company\'s tracking notification configs.
         * @param {string} companyId The id of the company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdTrackingNotificationConfigGet: function (companyId, options) {
            return localVarFp.companiesCompanyIdTrackingNotificationConfigGet(companyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a new tracking notification config
         * @param {string} companyId The id of the company
         * @param {TrackingNotificationConfig} trackingNotificationConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdTrackingNotificationConfigPost: function (companyId, trackingNotificationConfig, options) {
            return localVarFp.companiesCompanyIdTrackingNotificationConfigPost(companyId, trackingNotificationConfig, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about a tracking notification config
         * @param {string} companyId The id of the company
         * @param {string} trackingNotificationConfigId The ID of the tracking notification config
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdTrackingNotificationConfigTrackingNotificationConfigIdGet: function (companyId, trackingNotificationConfigId, options) {
            return localVarFp.companiesCompanyIdTrackingNotificationConfigTrackingNotificationConfigIdGet(companyId, trackingNotificationConfigId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates an existing tracking notification config
         * @param {string} companyId The id of the company
         * @param {string} trackingNotificationConfigId The ID of the tracking notification config
         * @param {TrackingNotificationConfig} trackingNotificationConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdTrackingNotificationConfigTrackingNotificationConfigIdPut: function (companyId, trackingNotificationConfigId, trackingNotificationConfig, options) {
            return localVarFp.companiesCompanyIdTrackingNotificationConfigTrackingNotificationConfigIdPut(companyId, trackingNotificationConfigId, trackingNotificationConfig, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a list of companies scoped to the authorization token.
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [carrierId] The id of the carrier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesGet: function (page, pageSize, ordering, carrierId, options) {
            return localVarFp.companiesGet(page, pageSize, ordering, carrierId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary A list of all identifying codes supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesIdentifyingCodesGet: function (options) {
            return localVarFp.companiesIdentifyingCodesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary A list of logos associated with a company. The company can be identified through the optional subdomain query parameter or using the authenticated Company, with the subdomain option taking precedence.
         * @param {string} [subdomain] search by a company\&#39;s subdomain
         * @param {string} [imageType] optional parameter to search for a particular image type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesLogosGet: function (subdomain, imageType, options) {
            return localVarFp.companiesLogosGet(subdomain, imageType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the current settings of company parcel label configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyParcelConfigGet: function (options) {
            return localVarFp.companyParcelConfigGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update settings of company parcel label configuration
         * @param {UpdateCompanyParcelLabelConfigSchema} updateCompanyParcelLabelConfigSchema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyParcelConfigPut: function (updateCompanyParcelLabelConfigSchema, options) {
            return localVarFp.companyParcelConfigPut(updateCompanyParcelLabelConfigSchema, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CompaniesApiFactory = CompaniesApiFactory;
/**
 * CompaniesApi - object-oriented interface
 * @export
 * @class CompaniesApi
 * @extends {BaseAPI}
 */
var CompaniesApi = /** @class */ (function (_super) {
    __extends(CompaniesApi, _super);
    function CompaniesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Determine if a driver may be linked to a company based off their email address
     * @param {string} email A valid email address
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCanLinkDriverGet = function (email, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCanLinkDriverGet(email, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a custom field
     * @param {string} companyId The id of the company
     * @param {string} customFieldId The id of the custom field
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCompanyIdCustomFieldsCustomFieldIdDelete = function (companyId, customFieldId, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCompanyIdCustomFieldsCustomFieldIdDelete(companyId, customFieldId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a custom field
     * @param {string} companyId The id of the company
     * @param {string} customFieldId The id of the custom field
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCompanyIdCustomFieldsCustomFieldIdGet = function (companyId, customFieldId, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCompanyIdCustomFieldsCustomFieldIdGet(companyId, customFieldId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a custom field
     * @param {string} companyId The id of the company
     * @param {string} customFieldId The id of the custom field
     * @param {CustomField} customField
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCompanyIdCustomFieldsCustomFieldIdPut = function (companyId, customFieldId, customField, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCompanyIdCustomFieldsCustomFieldIdPut(companyId, customFieldId, customField, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a list of custom fields
     * @param {string} companyId The id of the company
     * @param {string} [entityType] Entity type of the Custom Field
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [shipmentId] Include CustomFields where shipment_id is allowed to request user
     * @param {string} [orderId] Include CustomFields where order_id is allowed to request user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCompanyIdCustomFieldsGet = function (companyId, entityType, page, pageSize, ordering, shipmentId, orderId, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCompanyIdCustomFieldsGet(companyId, entityType, page, pageSize, ordering, shipmentId, orderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a custom field
     * @param {string} companyId The id of the company
     * @param {CustomField} customField
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCompanyIdCustomFieldsPost = function (companyId, customField, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCompanyIdCustomFieldsPost(companyId, customField, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about the companies dashboard
     * @param {string} companyId The id of the company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCompanyIdDashboardGet = function (companyId, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCompanyIdDashboardGet(companyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a company
     * @param {string} companyId The id of the company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCompanyIdDelete = function (companyId, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCompanyIdDelete(companyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a Company Document
     * @param {string} companyId The id of the company
     * @param {string} documentId The id of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCompanyIdDocumentsDocumentIdDelete = function (companyId, documentId, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCompanyIdDocumentsDocumentIdDelete(companyId, documentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get metadata about a company document
     * @param {string} companyId The id of the company
     * @param {string} documentId The id of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCompanyIdDocumentsDocumentIdGet = function (companyId, documentId, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCompanyIdDocumentsDocumentIdGet(companyId, documentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update metadata about a company document
     * @param {string} companyId The id of the company
     * @param {string} documentId The id of the document
     * @param {DocumentMetadata} documentMetadata
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCompanyIdDocumentsDocumentIdPut = function (companyId, documentId, documentMetadata, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCompanyIdDocumentsDocumentIdPut(companyId, documentId, documentMetadata, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get metadata about documents on a company
     * @param {string} companyId The id of the company
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCompanyIdDocumentsGet = function (companyId, page, pageSize, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCompanyIdDocumentsGet(companyId, page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a document on a company
     * @param {string} companyId The id of the company
     * @param {string} description
     * @param {any} file
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCompanyIdDocumentsPost = function (companyId, description, file, type, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCompanyIdDocumentsPost(companyId, description, file, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a driver
     * @param {string} companyId The id of the company
     * @param {string} driverId The id of the driver
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCompanyIdDriversDriverIdDelete = function (companyId, driverId, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCompanyIdDriversDriverIdDelete(companyId, driverId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a driver associated to a company
     * @param {string} companyId The id of the company
     * @param {string} driverId The id of the driver
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCompanyIdDriversDriverIdGet = function (companyId, driverId, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCompanyIdDriversDriverIdGet(companyId, driverId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a driver
     * @param {string} companyId The id of the company
     * @param {string} driverId The id of the driver
     * @param {Driver} driver
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCompanyIdDriversDriverIdPut = function (companyId, driverId, driver, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCompanyIdDriversDriverIdPut(companyId, driverId, driver, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a list of drivers associated to a company
     * @param {string} companyId The id of the company
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {Array<string>} [providers] An array of providers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCompanyIdDriversGet = function (companyId, page, pageSize, ordering, providers, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCompanyIdDriversGet(companyId, page, pageSize, ordering, providers, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about a company
     * @param {string} companyId The id of the company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCompanyIdGet = function (companyId, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCompanyIdGet(companyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Obtain the company\'s international preferences
     * @param {string} companyId The id of the company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCompanyIdInternationalPreferencesGet = function (companyId, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCompanyIdInternationalPreferencesGet(companyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update the company\'s international preferences
     * @param {string} companyId The id of the company
     * @param {CompanyInternationalPreferences} companyInternationalPreferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCompanyIdInternationalPreferencesPut = function (companyId, companyInternationalPreferences, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCompanyIdInternationalPreferencesPut(companyId, companyInternationalPreferences, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Obtain the company\'s preferences
     * @param {string} companyId The id of the company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCompanyIdPreferencesGet = function (companyId, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCompanyIdPreferencesGet(companyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update the company\'s preferences
     * @param {string} companyId The id of the company
     * @param {CompanyPreferences} companyPreferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCompanyIdPreferencesPut = function (companyId, companyPreferences, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCompanyIdPreferencesPut(companyId, companyPreferences, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a company
     * @param {string} companyId The id of the company
     * @param {Company} company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCompanyIdPut = function (companyId, company, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCompanyIdPut(companyId, company, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a list of a company\'s tracking notification configs.
     * @param {string} companyId The id of the company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCompanyIdTrackingNotificationConfigGet = function (companyId, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCompanyIdTrackingNotificationConfigGet(companyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a new tracking notification config
     * @param {string} companyId The id of the company
     * @param {TrackingNotificationConfig} trackingNotificationConfig
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCompanyIdTrackingNotificationConfigPost = function (companyId, trackingNotificationConfig, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCompanyIdTrackingNotificationConfigPost(companyId, trackingNotificationConfig, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about a tracking notification config
     * @param {string} companyId The id of the company
     * @param {string} trackingNotificationConfigId The ID of the tracking notification config
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCompanyIdTrackingNotificationConfigTrackingNotificationConfigIdGet = function (companyId, trackingNotificationConfigId, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCompanyIdTrackingNotificationConfigTrackingNotificationConfigIdGet(companyId, trackingNotificationConfigId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates an existing tracking notification config
     * @param {string} companyId The id of the company
     * @param {string} trackingNotificationConfigId The ID of the tracking notification config
     * @param {TrackingNotificationConfig} trackingNotificationConfig
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesCompanyIdTrackingNotificationConfigTrackingNotificationConfigIdPut = function (companyId, trackingNotificationConfigId, trackingNotificationConfig, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesCompanyIdTrackingNotificationConfigTrackingNotificationConfigIdPut(companyId, trackingNotificationConfigId, trackingNotificationConfig, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a list of companies scoped to the authorization token.
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [carrierId] The id of the carrier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesGet = function (page, pageSize, ordering, carrierId, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesGet(page, pageSize, ordering, carrierId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary A list of all identifying codes supported by the API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesIdentifyingCodesGet = function (options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesIdentifyingCodesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary A list of logos associated with a company. The company can be identified through the optional subdomain query parameter or using the authenticated Company, with the subdomain option taking precedence.
     * @param {string} [subdomain] search by a company\&#39;s subdomain
     * @param {string} [imageType] optional parameter to search for a particular image type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companiesLogosGet = function (subdomain, imageType, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companiesLogosGet(subdomain, imageType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the current settings of company parcel label configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companyParcelConfigGet = function (options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companyParcelConfigGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update settings of company parcel label configuration
     * @param {UpdateCompanyParcelLabelConfigSchema} updateCompanyParcelLabelConfigSchema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.companyParcelConfigPut = function (updateCompanyParcelLabelConfigSchema, options) {
        var _this = this;
        return (0, exports.CompaniesApiFp)(this.configuration).companyParcelConfigPut(updateCompanyParcelLabelConfigSchema, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CompaniesApi;
}(base_1.BaseAPI));
exports.CompaniesApi = CompaniesApi;
/**
 * ContractsApi - axios parameter creator
 * @export
 */
var ContractsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Delete a Contract
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} contractId The id of a contract
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdContractsContractIdDelete: function (carrierRelationshipId, contractId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdContractsContractIdDelete', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'contractId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdContractsContractIdDelete', 'contractId', contractId);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/contracts/{contractId}/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)))
                                .replace("{".concat("contractId", "}"), encodeURIComponent(String(contractId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a Contract by Carrier Relationship Id and Contract Id
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} contractId The id of a contract
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdContractsContractIdGet: function (carrierRelationshipId, contractId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdContractsContractIdGet', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'contractId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdContractsContractIdGet', 'contractId', contractId);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/contracts/{contractId}/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)))
                                .replace("{".concat("contractId", "}"), encodeURIComponent(String(contractId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a Contract
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} contractId The id of a contract
         * @param {Contract} contract
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdContractsContractIdPut: function (carrierRelationshipId, contractId, contract, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdContractsContractIdPut', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'contractId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdContractsContractIdPut', 'contractId', contractId);
                            // verify required parameter 'contract' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdContractsContractIdPut', 'contract', contract);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/contracts/{contractId}/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)))
                                .replace("{".concat("contractId", "}"), encodeURIComponent(String(contractId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(contract, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List contracts
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [destinationContains] Return shipments with this value in the destination
         * @param {string} [destinationStateProvince] Return shipments with this state province on its destination stop
         * @param {string} [originContains] Return shipments with this value in the origin
         * @param {string} [originStateProvince] Return shipments with this state province on its origin stop
         * @param {string} [nameContains] Include Contracts where name contains this string
         * @param {string} [status] Include Contracts where status is exactly this string
         * @param {string} [createdAt] For requesting data created at a certain datetime
         * @param {string} [updatedAt] For requesting data updated at a certain datetime
         * @param {number} [rate] The rate
         * @param {string} [carrierNameContains] Name of the carrier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdContractsGet: function (carrierRelationshipId, page, pageSize, ordering, q, destinationContains, destinationStateProvince, originContains, originStateProvince, nameContains, status, createdAt, updatedAt, rate, carrierNameContains, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdContractsGet', 'carrierRelationshipId', carrierRelationshipId);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/contracts/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (destinationContains !== undefined) {
                                localVarQueryParameter['destination__contains'] = destinationContains;
                            }
                            if (destinationStateProvince !== undefined) {
                                localVarQueryParameter['destination_state_province'] = destinationStateProvince;
                            }
                            if (originContains !== undefined) {
                                localVarQueryParameter['origin__contains'] = originContains;
                            }
                            if (originStateProvince !== undefined) {
                                localVarQueryParameter['origin_state_province'] = originStateProvince;
                            }
                            if (nameContains !== undefined) {
                                localVarQueryParameter['name__contains'] = nameContains;
                            }
                            if (status !== undefined) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (createdAt !== undefined) {
                                localVarQueryParameter['created_at'] = (createdAt instanceof Date) ?
                                    createdAt.toISOString() :
                                    createdAt;
                            }
                            if (updatedAt !== undefined) {
                                localVarQueryParameter['updated_at'] = (updatedAt instanceof Date) ?
                                    updatedAt.toISOString() :
                                    updatedAt;
                            }
                            if (rate !== undefined) {
                                localVarQueryParameter['rate'] = rate;
                            }
                            if (carrierNameContains !== undefined) {
                                localVarQueryParameter['carrier_name__contains'] = carrierNameContains;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new contract
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {Contract} contract
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdContractsPost: function (carrierRelationshipId, contract, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdContractsPost', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'contract' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdContractsPost', 'contract', contract);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/contracts/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(contract, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns Contracts and Lanes that match provided criteria
         * @param {ContractCriteriaRequest} [contractCriteriaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractsApplicableContractsPost: function (contractCriteriaRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/contracts/applicable-contracts/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(contractCriteriaRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns charge items for a given shipment and contract
         * @param {string} contractId The id of a contract
         * @param {ContractCriteriaRequest} [contractCriteriaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractsContractIdCalculateChargeItemsPost: function (contractId, contractCriteriaRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'contractId' is not null or undefined
                            (0, common_1.assertParamExists)('contractsContractIdCalculateChargeItemsPost', 'contractId', contractId);
                            localVarPath = "/contracts/{contractId}/calculate-charge-items/"
                                .replace("{".concat("contractId", "}"), encodeURIComponent(String(contractId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(contractCriteriaRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List lanes belonging to contract
         * @param {string} contractId The id of a contract
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractsContractIdContractLanesGet: function (contractId, page, pageSize, ordering, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'contractId' is not null or undefined
                            (0, common_1.assertParamExists)('contractsContractIdContractLanesGet', 'contractId', contractId);
                            localVarPath = "/contracts/{contractId}/contract-lanes/"
                                .replace("{".concat("contractId", "}"), encodeURIComponent(String(contractId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a Contract
         * @param {string} contractId The id of a contract
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractsContractIdGet: function (contractId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'contractId' is not null or undefined
                            (0, common_1.assertParamExists)('contractsContractIdGet', 'contractId', contractId);
                            localVarPath = "/contracts/{contractId}/"
                                .replace("{".concat("contractId", "}"), encodeURIComponent(String(contractId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List contracts
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {Array<string>} [destinationsContains] Return shipments with this value in the destinations
         * @param {Array<string>} [destinationsStateProvince] Return shipments with this state province on its destinations
         * @param {Array<string>} [originsContains] Return shipments with this value in the origins
         * @param {Array<string>} [originsStateProvince] Return shipments with this state province on its origins
         * @param {Array<string>} [additionalStopsContains] Return contracts with this value in the additional_stops
         * @param {Array<string>} [additionalStopsStateProvince] Return contracts with this state province on its additional_stops
         * @param {number} [numberOfStops] The number of all contracts stops
         * @param {string} [nameContains] Include Contracts where name contains this string
         * @param {string} [status] Include Contracts where status is exactly this string
         * @param {Array<string>} [equipmentTypes] Return contracts with equipment types
         * @param {Array<string>} [modes] Return contracts with shipment mode codes
         * @param {Array<string>} [carrierRelationshipId] The id of the vendor relationship
         * @param {string} [createdAt] For requesting data created at a certain datetime
         * @param {string} [updatedAt] For requesting data updated at a certain datetime
         * @param {number} [rate] The rate
         * @param {string} [carrierNameContains] Name of the carrier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractsGet: function (page, pageSize, ordering, q, destinationsContains, destinationsStateProvince, originsContains, originsStateProvince, additionalStopsContains, additionalStopsStateProvince, numberOfStops, nameContains, status, equipmentTypes, modes, carrierRelationshipId, createdAt, updatedAt, rate, carrierNameContains, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/contracts/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (destinationsContains) {
                                localVarQueryParameter['destinations__contains'] = destinationsContains;
                            }
                            if (destinationsStateProvince) {
                                localVarQueryParameter['destinations_state_province'] = destinationsStateProvince;
                            }
                            if (originsContains) {
                                localVarQueryParameter['origins__contains'] = originsContains;
                            }
                            if (originsStateProvince) {
                                localVarQueryParameter['origins_state_province'] = originsStateProvince;
                            }
                            if (additionalStopsContains) {
                                localVarQueryParameter['additional_stops__contains'] = additionalStopsContains;
                            }
                            if (additionalStopsStateProvince) {
                                localVarQueryParameter['additional_stops_state_province'] = additionalStopsStateProvince;
                            }
                            if (numberOfStops !== undefined) {
                                localVarQueryParameter['number_of_stops'] = numberOfStops;
                            }
                            if (nameContains !== undefined) {
                                localVarQueryParameter['name__contains'] = nameContains;
                            }
                            if (status !== undefined) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (equipmentTypes) {
                                localVarQueryParameter['equipment_types'] = equipmentTypes;
                            }
                            if (modes) {
                                localVarQueryParameter['modes'] = modes;
                            }
                            if (carrierRelationshipId) {
                                localVarQueryParameter['carrier_relationship_id'] = carrierRelationshipId;
                            }
                            if (createdAt !== undefined) {
                                localVarQueryParameter['created_at'] = (createdAt instanceof Date) ?
                                    createdAt.toISOString() :
                                    createdAt;
                            }
                            if (updatedAt !== undefined) {
                                localVarQueryParameter['updated_at'] = (updatedAt instanceof Date) ?
                                    updatedAt.toISOString() :
                                    updatedAt;
                            }
                            if (rate !== undefined) {
                                localVarQueryParameter['rate'] = rate;
                            }
                            if (carrierNameContains !== undefined) {
                                localVarQueryParameter['carrier_name__contains'] = carrierNameContains;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ContractsApiAxiosParamCreator = ContractsApiAxiosParamCreator;
/**
 * ContractsApi - functional programming interface
 * @export
 */
var ContractsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ContractsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Delete a Contract
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} contractId The id of a contract
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdContractsContractIdDelete: function (carrierRelationshipId, contractId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdContractsContractIdDelete(carrierRelationshipId, contractId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a Contract by Carrier Relationship Id and Contract Id
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} contractId The id of a contract
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdContractsContractIdGet: function (carrierRelationshipId, contractId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdContractsContractIdGet(carrierRelationshipId, contractId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a Contract
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} contractId The id of a contract
         * @param {Contract} contract
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdContractsContractIdPut: function (carrierRelationshipId, contractId, contract, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdContractsContractIdPut(carrierRelationshipId, contractId, contract, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List contracts
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [destinationContains] Return shipments with this value in the destination
         * @param {string} [destinationStateProvince] Return shipments with this state province on its destination stop
         * @param {string} [originContains] Return shipments with this value in the origin
         * @param {string} [originStateProvince] Return shipments with this state province on its origin stop
         * @param {string} [nameContains] Include Contracts where name contains this string
         * @param {string} [status] Include Contracts where status is exactly this string
         * @param {string} [createdAt] For requesting data created at a certain datetime
         * @param {string} [updatedAt] For requesting data updated at a certain datetime
         * @param {number} [rate] The rate
         * @param {string} [carrierNameContains] Name of the carrier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdContractsGet: function (carrierRelationshipId, page, pageSize, ordering, q, destinationContains, destinationStateProvince, originContains, originStateProvince, nameContains, status, createdAt, updatedAt, rate, carrierNameContains, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdContractsGet(carrierRelationshipId, page, pageSize, ordering, q, destinationContains, destinationStateProvince, originContains, originStateProvince, nameContains, status, createdAt, updatedAt, rate, carrierNameContains, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new contract
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {Contract} contract
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdContractsPost: function (carrierRelationshipId, contract, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdContractsPost(carrierRelationshipId, contract, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns Contracts and Lanes that match provided criteria
         * @param {ContractCriteriaRequest} [contractCriteriaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractsApplicableContractsPost: function (contractCriteriaRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.contractsApplicableContractsPost(contractCriteriaRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns charge items for a given shipment and contract
         * @param {string} contractId The id of a contract
         * @param {ContractCriteriaRequest} [contractCriteriaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractsContractIdCalculateChargeItemsPost: function (contractId, contractCriteriaRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.contractsContractIdCalculateChargeItemsPost(contractId, contractCriteriaRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List lanes belonging to contract
         * @param {string} contractId The id of a contract
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractsContractIdContractLanesGet: function (contractId, page, pageSize, ordering, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.contractsContractIdContractLanesGet(contractId, page, pageSize, ordering, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a Contract
         * @param {string} contractId The id of a contract
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractsContractIdGet: function (contractId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.contractsContractIdGet(contractId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List contracts
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {Array<string>} [destinationsContains] Return shipments with this value in the destinations
         * @param {Array<string>} [destinationsStateProvince] Return shipments with this state province on its destinations
         * @param {Array<string>} [originsContains] Return shipments with this value in the origins
         * @param {Array<string>} [originsStateProvince] Return shipments with this state province on its origins
         * @param {Array<string>} [additionalStopsContains] Return contracts with this value in the additional_stops
         * @param {Array<string>} [additionalStopsStateProvince] Return contracts with this state province on its additional_stops
         * @param {number} [numberOfStops] The number of all contracts stops
         * @param {string} [nameContains] Include Contracts where name contains this string
         * @param {string} [status] Include Contracts where status is exactly this string
         * @param {Array<string>} [equipmentTypes] Return contracts with equipment types
         * @param {Array<string>} [modes] Return contracts with shipment mode codes
         * @param {Array<string>} [carrierRelationshipId] The id of the vendor relationship
         * @param {string} [createdAt] For requesting data created at a certain datetime
         * @param {string} [updatedAt] For requesting data updated at a certain datetime
         * @param {number} [rate] The rate
         * @param {string} [carrierNameContains] Name of the carrier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractsGet: function (page, pageSize, ordering, q, destinationsContains, destinationsStateProvince, originsContains, originsStateProvince, additionalStopsContains, additionalStopsStateProvince, numberOfStops, nameContains, status, equipmentTypes, modes, carrierRelationshipId, createdAt, updatedAt, rate, carrierNameContains, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.contractsGet(page, pageSize, ordering, q, destinationsContains, destinationsStateProvince, originsContains, originsStateProvince, additionalStopsContains, additionalStopsStateProvince, numberOfStops, nameContains, status, equipmentTypes, modes, carrierRelationshipId, createdAt, updatedAt, rate, carrierNameContains, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ContractsApiFp = ContractsApiFp;
/**
 * ContractsApi - factory interface
 * @export
 */
var ContractsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ContractsApiFp)(configuration);
    return {
        /**
         *
         * @summary Delete a Contract
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} contractId The id of a contract
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdContractsContractIdDelete: function (carrierRelationshipId, contractId, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdContractsContractIdDelete(carrierRelationshipId, contractId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a Contract by Carrier Relationship Id and Contract Id
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} contractId The id of a contract
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdContractsContractIdGet: function (carrierRelationshipId, contractId, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdContractsContractIdGet(carrierRelationshipId, contractId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a Contract
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {string} contractId The id of a contract
         * @param {Contract} contract
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdContractsContractIdPut: function (carrierRelationshipId, contractId, contract, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdContractsContractIdPut(carrierRelationshipId, contractId, contract, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List contracts
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [destinationContains] Return shipments with this value in the destination
         * @param {string} [destinationStateProvince] Return shipments with this state province on its destination stop
         * @param {string} [originContains] Return shipments with this value in the origin
         * @param {string} [originStateProvince] Return shipments with this state province on its origin stop
         * @param {string} [nameContains] Include Contracts where name contains this string
         * @param {string} [status] Include Contracts where status is exactly this string
         * @param {string} [createdAt] For requesting data created at a certain datetime
         * @param {string} [updatedAt] For requesting data updated at a certain datetime
         * @param {number} [rate] The rate
         * @param {string} [carrierNameContains] Name of the carrier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdContractsGet: function (carrierRelationshipId, page, pageSize, ordering, q, destinationContains, destinationStateProvince, originContains, originStateProvince, nameContains, status, createdAt, updatedAt, rate, carrierNameContains, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdContractsGet(carrierRelationshipId, page, pageSize, ordering, q, destinationContains, destinationStateProvince, originContains, originStateProvince, nameContains, status, createdAt, updatedAt, rate, carrierNameContains, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new contract
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {Contract} contract
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdContractsPost: function (carrierRelationshipId, contract, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdContractsPost(carrierRelationshipId, contract, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns Contracts and Lanes that match provided criteria
         * @param {ContractCriteriaRequest} [contractCriteriaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractsApplicableContractsPost: function (contractCriteriaRequest, options) {
            return localVarFp.contractsApplicableContractsPost(contractCriteriaRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns charge items for a given shipment and contract
         * @param {string} contractId The id of a contract
         * @param {ContractCriteriaRequest} [contractCriteriaRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractsContractIdCalculateChargeItemsPost: function (contractId, contractCriteriaRequest, options) {
            return localVarFp.contractsContractIdCalculateChargeItemsPost(contractId, contractCriteriaRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List lanes belonging to contract
         * @param {string} contractId The id of a contract
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractsContractIdContractLanesGet: function (contractId, page, pageSize, ordering, options) {
            return localVarFp.contractsContractIdContractLanesGet(contractId, page, pageSize, ordering, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a Contract
         * @param {string} contractId The id of a contract
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractsContractIdGet: function (contractId, options) {
            return localVarFp.contractsContractIdGet(contractId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List contracts
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {Array<string>} [destinationsContains] Return shipments with this value in the destinations
         * @param {Array<string>} [destinationsStateProvince] Return shipments with this state province on its destinations
         * @param {Array<string>} [originsContains] Return shipments with this value in the origins
         * @param {Array<string>} [originsStateProvince] Return shipments with this state province on its origins
         * @param {Array<string>} [additionalStopsContains] Return contracts with this value in the additional_stops
         * @param {Array<string>} [additionalStopsStateProvince] Return contracts with this state province on its additional_stops
         * @param {number} [numberOfStops] The number of all contracts stops
         * @param {string} [nameContains] Include Contracts where name contains this string
         * @param {string} [status] Include Contracts where status is exactly this string
         * @param {Array<string>} [equipmentTypes] Return contracts with equipment types
         * @param {Array<string>} [modes] Return contracts with shipment mode codes
         * @param {Array<string>} [carrierRelationshipId] The id of the vendor relationship
         * @param {string} [createdAt] For requesting data created at a certain datetime
         * @param {string} [updatedAt] For requesting data updated at a certain datetime
         * @param {number} [rate] The rate
         * @param {string} [carrierNameContains] Name of the carrier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        contractsGet: function (page, pageSize, ordering, q, destinationsContains, destinationsStateProvince, originsContains, originsStateProvince, additionalStopsContains, additionalStopsStateProvince, numberOfStops, nameContains, status, equipmentTypes, modes, carrierRelationshipId, createdAt, updatedAt, rate, carrierNameContains, options) {
            return localVarFp.contractsGet(page, pageSize, ordering, q, destinationsContains, destinationsStateProvince, originsContains, originsStateProvince, additionalStopsContains, additionalStopsStateProvince, numberOfStops, nameContains, status, equipmentTypes, modes, carrierRelationshipId, createdAt, updatedAt, rate, carrierNameContains, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ContractsApiFactory = ContractsApiFactory;
/**
 * ContractsApi - object-oriented interface
 * @export
 * @class ContractsApi
 * @extends {BaseAPI}
 */
var ContractsApi = /** @class */ (function (_super) {
    __extends(ContractsApi, _super);
    function ContractsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Delete a Contract
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {string} contractId The id of a contract
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    ContractsApi.prototype.carrierRelationshipsCarrierRelationshipIdContractsContractIdDelete = function (carrierRelationshipId, contractId, options) {
        var _this = this;
        return (0, exports.ContractsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdContractsContractIdDelete(carrierRelationshipId, contractId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a Contract by Carrier Relationship Id and Contract Id
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {string} contractId The id of a contract
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    ContractsApi.prototype.carrierRelationshipsCarrierRelationshipIdContractsContractIdGet = function (carrierRelationshipId, contractId, options) {
        var _this = this;
        return (0, exports.ContractsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdContractsContractIdGet(carrierRelationshipId, contractId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a Contract
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {string} contractId The id of a contract
     * @param {Contract} contract
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    ContractsApi.prototype.carrierRelationshipsCarrierRelationshipIdContractsContractIdPut = function (carrierRelationshipId, contractId, contract, options) {
        var _this = this;
        return (0, exports.ContractsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdContractsContractIdPut(carrierRelationshipId, contractId, contract, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List contracts
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {string} [destinationContains] Return shipments with this value in the destination
     * @param {string} [destinationStateProvince] Return shipments with this state province on its destination stop
     * @param {string} [originContains] Return shipments with this value in the origin
     * @param {string} [originStateProvince] Return shipments with this state province on its origin stop
     * @param {string} [nameContains] Include Contracts where name contains this string
     * @param {string} [status] Include Contracts where status is exactly this string
     * @param {string} [createdAt] For requesting data created at a certain datetime
     * @param {string} [updatedAt] For requesting data updated at a certain datetime
     * @param {number} [rate] The rate
     * @param {string} [carrierNameContains] Name of the carrier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    ContractsApi.prototype.carrierRelationshipsCarrierRelationshipIdContractsGet = function (carrierRelationshipId, page, pageSize, ordering, q, destinationContains, destinationStateProvince, originContains, originStateProvince, nameContains, status, createdAt, updatedAt, rate, carrierNameContains, options) {
        var _this = this;
        return (0, exports.ContractsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdContractsGet(carrierRelationshipId, page, pageSize, ordering, q, destinationContains, destinationStateProvince, originContains, originStateProvince, nameContains, status, createdAt, updatedAt, rate, carrierNameContains, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new contract
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {Contract} contract
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    ContractsApi.prototype.carrierRelationshipsCarrierRelationshipIdContractsPost = function (carrierRelationshipId, contract, options) {
        var _this = this;
        return (0, exports.ContractsApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdContractsPost(carrierRelationshipId, contract, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns Contracts and Lanes that match provided criteria
     * @param {ContractCriteriaRequest} [contractCriteriaRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    ContractsApi.prototype.contractsApplicableContractsPost = function (contractCriteriaRequest, options) {
        var _this = this;
        return (0, exports.ContractsApiFp)(this.configuration).contractsApplicableContractsPost(contractCriteriaRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns charge items for a given shipment and contract
     * @param {string} contractId The id of a contract
     * @param {ContractCriteriaRequest} [contractCriteriaRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    ContractsApi.prototype.contractsContractIdCalculateChargeItemsPost = function (contractId, contractCriteriaRequest, options) {
        var _this = this;
        return (0, exports.ContractsApiFp)(this.configuration).contractsContractIdCalculateChargeItemsPost(contractId, contractCriteriaRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List lanes belonging to contract
     * @param {string} contractId The id of a contract
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    ContractsApi.prototype.contractsContractIdContractLanesGet = function (contractId, page, pageSize, ordering, options) {
        var _this = this;
        return (0, exports.ContractsApiFp)(this.configuration).contractsContractIdContractLanesGet(contractId, page, pageSize, ordering, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a Contract
     * @param {string} contractId The id of a contract
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    ContractsApi.prototype.contractsContractIdGet = function (contractId, options) {
        var _this = this;
        return (0, exports.ContractsApiFp)(this.configuration).contractsContractIdGet(contractId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List contracts
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {Array<string>} [destinationsContains] Return shipments with this value in the destinations
     * @param {Array<string>} [destinationsStateProvince] Return shipments with this state province on its destinations
     * @param {Array<string>} [originsContains] Return shipments with this value in the origins
     * @param {Array<string>} [originsStateProvince] Return shipments with this state province on its origins
     * @param {Array<string>} [additionalStopsContains] Return contracts with this value in the additional_stops
     * @param {Array<string>} [additionalStopsStateProvince] Return contracts with this state province on its additional_stops
     * @param {number} [numberOfStops] The number of all contracts stops
     * @param {string} [nameContains] Include Contracts where name contains this string
     * @param {string} [status] Include Contracts where status is exactly this string
     * @param {Array<string>} [equipmentTypes] Return contracts with equipment types
     * @param {Array<string>} [modes] Return contracts with shipment mode codes
     * @param {Array<string>} [carrierRelationshipId] The id of the vendor relationship
     * @param {string} [createdAt] For requesting data created at a certain datetime
     * @param {string} [updatedAt] For requesting data updated at a certain datetime
     * @param {number} [rate] The rate
     * @param {string} [carrierNameContains] Name of the carrier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApi
     */
    ContractsApi.prototype.contractsGet = function (page, pageSize, ordering, q, destinationsContains, destinationsStateProvince, originsContains, originsStateProvince, additionalStopsContains, additionalStopsStateProvince, numberOfStops, nameContains, status, equipmentTypes, modes, carrierRelationshipId, createdAt, updatedAt, rate, carrierNameContains, options) {
        var _this = this;
        return (0, exports.ContractsApiFp)(this.configuration).contractsGet(page, pageSize, ordering, q, destinationsContains, destinationsStateProvince, originsContains, originsStateProvince, additionalStopsContains, additionalStopsStateProvince, numberOfStops, nameContains, status, equipmentTypes, modes, carrierRelationshipId, createdAt, updatedAt, rate, carrierNameContains, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ContractsApi;
}(base_1.BaseAPI));
exports.ContractsApi = ContractsApi;
/**
 * DefaultApi - axios parameter creator
 * @export
 */
var DefaultApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns the oauth status of the UPS account.
         * @summary Refresh the UPS account oauth status
         * @param {string} upsAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationUPSUpsAccountIdRefreshOauthStatusPost: function (upsAccountId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'upsAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('registrationUPSUpsAccountIdRefreshOauthStatusPost', 'upsAccountId', upsAccountId);
                            localVarPath = "/registration/UPS/{upsAccountId}/refresh-oauth-status/"
                                .replace("{".concat("upsAccountId", "}"), encodeURIComponent(String(upsAccountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Driver\'s action to an SMS to locate request
         * @param {string} shipmentId The id of the shipment
         * @param {SMSTrackingDriverAction} [sMSTrackingDriverAction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdSmsTrackingDriverActionPost: function (shipmentId, sMSTrackingDriverAction, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdSmsTrackingDriverActionPost', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/sms-tracking/driver-action/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(sMSTrackingDriverAction, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
var DefaultApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        /**
         * Returns the oauth status of the UPS account.
         * @summary Refresh the UPS account oauth status
         * @param {string} upsAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationUPSUpsAccountIdRefreshOauthStatusPost: function (upsAccountId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.registrationUPSUpsAccountIdRefreshOauthStatusPost(upsAccountId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Driver\'s action to an SMS to locate request
         * @param {string} shipmentId The id of the shipment
         * @param {SMSTrackingDriverAction} [sMSTrackingDriverAction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdSmsTrackingDriverActionPost: function (shipmentId, sMSTrackingDriverAction, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdSmsTrackingDriverActionPost(shipmentId, sMSTrackingDriverAction, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
var DefaultApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        /**
         * Returns the oauth status of the UPS account.
         * @summary Refresh the UPS account oauth status
         * @param {string} upsAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationUPSUpsAccountIdRefreshOauthStatusPost: function (upsAccountId, options) {
            return localVarFp.registrationUPSUpsAccountIdRefreshOauthStatusPost(upsAccountId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Driver\'s action to an SMS to locate request
         * @param {string} shipmentId The id of the shipment
         * @param {SMSTrackingDriverAction} [sMSTrackingDriverAction]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdSmsTrackingDriverActionPost: function (shipmentId, sMSTrackingDriverAction, options) {
            return localVarFp.shipmentsShipmentIdSmsTrackingDriverActionPost(shipmentId, sMSTrackingDriverAction, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
var DefaultApi = /** @class */ (function (_super) {
    __extends(DefaultApi, _super);
    function DefaultApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns the oauth status of the UPS account.
     * @summary Refresh the UPS account oauth status
     * @param {string} upsAccountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.registrationUPSUpsAccountIdRefreshOauthStatusPost = function (upsAccountId, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).registrationUPSUpsAccountIdRefreshOauthStatusPost(upsAccountId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Driver\'s action to an SMS to locate request
     * @param {string} shipmentId The id of the shipment
     * @param {SMSTrackingDriverAction} [sMSTrackingDriverAction]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    DefaultApi.prototype.shipmentsShipmentIdSmsTrackingDriverActionPost = function (shipmentId, sMSTrackingDriverAction, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).shipmentsShipmentIdSmsTrackingDriverActionPost(shipmentId, sMSTrackingDriverAction, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DefaultApi;
}(base_1.BaseAPI));
exports.DefaultApi = DefaultApi;
/**
 * DevicesApi - axios parameter creator
 * @export
 */
var DevicesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Delete a device registration
         * @param {string} deviceId The id of the device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesDeviceIdDelete: function (deviceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'deviceId' is not null or undefined
                            (0, common_1.assertParamExists)('devicesDeviceIdDelete', 'deviceId', deviceId);
                            localVarPath = "/devices/{deviceId}/"
                                .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a device registration
         * @param {Device} device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesPost: function (device, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'device' is not null or undefined
                            (0, common_1.assertParamExists)('devicesPost', 'device', device);
                            localVarPath = "/devices/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(device, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DevicesApiAxiosParamCreator = DevicesApiAxiosParamCreator;
/**
 * DevicesApi - functional programming interface
 * @export
 */
var DevicesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DevicesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Delete a device registration
         * @param {string} deviceId The id of the device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesDeviceIdDelete: function (deviceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.devicesDeviceIdDelete(deviceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a device registration
         * @param {Device} device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesPost: function (device, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.devicesPost(device, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DevicesApiFp = DevicesApiFp;
/**
 * DevicesApi - factory interface
 * @export
 */
var DevicesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DevicesApiFp)(configuration);
    return {
        /**
         *
         * @summary Delete a device registration
         * @param {string} deviceId The id of the device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesDeviceIdDelete: function (deviceId, options) {
            return localVarFp.devicesDeviceIdDelete(deviceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a device registration
         * @param {Device} device
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        devicesPost: function (device, options) {
            return localVarFp.devicesPost(device, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DevicesApiFactory = DevicesApiFactory;
/**
 * DevicesApi - object-oriented interface
 * @export
 * @class DevicesApi
 * @extends {BaseAPI}
 */
var DevicesApi = /** @class */ (function (_super) {
    __extends(DevicesApi, _super);
    function DevicesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Delete a device registration
     * @param {string} deviceId The id of the device
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    DevicesApi.prototype.devicesDeviceIdDelete = function (deviceId, options) {
        var _this = this;
        return (0, exports.DevicesApiFp)(this.configuration).devicesDeviceIdDelete(deviceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a device registration
     * @param {Device} device
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    DevicesApi.prototype.devicesPost = function (device, options) {
        var _this = this;
        return (0, exports.DevicesApiFp)(this.configuration).devicesPost(device, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DevicesApi;
}(base_1.BaseAPI));
exports.DevicesApi = DevicesApi;
/**
 * DockSchedulingApi - axios parameter creator
 * @export
 */
var DockSchedulingApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiDockSchedulingPermissionsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipwell-ui/dock-scheduling/permissions/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DockSchedulingApiAxiosParamCreator = DockSchedulingApiAxiosParamCreator;
/**
 * DockSchedulingApi - functional programming interface
 * @export
 */
var DockSchedulingApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DockSchedulingApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiDockSchedulingPermissionsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiDockSchedulingPermissionsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DockSchedulingApiFp = DockSchedulingApiFp;
/**
 * DockSchedulingApi - factory interface
 * @export
 */
var DockSchedulingApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DockSchedulingApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiDockSchedulingPermissionsGet: function (options) {
            return localVarFp.shipwellUiDockSchedulingPermissionsGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DockSchedulingApiFactory = DockSchedulingApiFactory;
/**
 * DockSchedulingApi - object-oriented interface
 * @export
 * @class DockSchedulingApi
 * @extends {BaseAPI}
 */
var DockSchedulingApi = /** @class */ (function (_super) {
    __extends(DockSchedulingApi, _super);
    function DockSchedulingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DockSchedulingApi
     */
    DockSchedulingApi.prototype.shipwellUiDockSchedulingPermissionsGet = function (options) {
        var _this = this;
        return (0, exports.DockSchedulingApiFp)(this.configuration).shipwellUiDockSchedulingPermissionsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DockSchedulingApi;
}(base_1.BaseAPI));
exports.DockSchedulingApi = DockSchedulingApi;
/**
 * DocumentsApi - axios parameter creator
 * @export
 */
var DocumentsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary A list of all the currently supported document types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsDocumentTypesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/documents/document-types/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Generate shipping labels in bulk
         * @param {BulkPrintLabelsRequest} bulkPrintLabelsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsGenerateLabelsPost: function (bulkPrintLabelsRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bulkPrintLabelsRequest' is not null or undefined
                            (0, common_1.assertParamExists)('documentsGenerateLabelsPost', 'bulkPrintLabelsRequest', bulkPrintLabelsRequest);
                            localVarPath = "/documents/generate-labels/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bulkPrintLabelsRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Generate a House BOL for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShipmentsShipmentIdGenerateDrayageHouseBolGet: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiShipmentsShipmentIdGenerateDrayageHouseBolGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipwell-ui/shipments/{shipmentId}/generate-drayage-house-bol/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DocumentsApiAxiosParamCreator = DocumentsApiAxiosParamCreator;
/**
 * DocumentsApi - functional programming interface
 * @export
 */
var DocumentsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DocumentsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary A list of all the currently supported document types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsDocumentTypesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.documentsDocumentTypesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Generate shipping labels in bulk
         * @param {BulkPrintLabelsRequest} bulkPrintLabelsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsGenerateLabelsPost: function (bulkPrintLabelsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.documentsGenerateLabelsPost(bulkPrintLabelsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Generate a House BOL for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShipmentsShipmentIdGenerateDrayageHouseBolGet: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiShipmentsShipmentIdGenerateDrayageHouseBolGet(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DocumentsApiFp = DocumentsApiFp;
/**
 * DocumentsApi - factory interface
 * @export
 */
var DocumentsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DocumentsApiFp)(configuration);
    return {
        /**
         *
         * @summary A list of all the currently supported document types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsDocumentTypesGet: function (options) {
            return localVarFp.documentsDocumentTypesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Generate shipping labels in bulk
         * @param {BulkPrintLabelsRequest} bulkPrintLabelsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        documentsGenerateLabelsPost: function (bulkPrintLabelsRequest, options) {
            return localVarFp.documentsGenerateLabelsPost(bulkPrintLabelsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Generate a House BOL for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShipmentsShipmentIdGenerateDrayageHouseBolGet: function (shipmentId, options) {
            return localVarFp.shipwellUiShipmentsShipmentIdGenerateDrayageHouseBolGet(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DocumentsApiFactory = DocumentsApiFactory;
/**
 * DocumentsApi - object-oriented interface
 * @export
 * @class DocumentsApi
 * @extends {BaseAPI}
 */
var DocumentsApi = /** @class */ (function (_super) {
    __extends(DocumentsApi, _super);
    function DocumentsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary A list of all the currently supported document types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    DocumentsApi.prototype.documentsDocumentTypesGet = function (options) {
        var _this = this;
        return (0, exports.DocumentsApiFp)(this.configuration).documentsDocumentTypesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Generate shipping labels in bulk
     * @param {BulkPrintLabelsRequest} bulkPrintLabelsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    DocumentsApi.prototype.documentsGenerateLabelsPost = function (bulkPrintLabelsRequest, options) {
        var _this = this;
        return (0, exports.DocumentsApiFp)(this.configuration).documentsGenerateLabelsPost(bulkPrintLabelsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Generate a House BOL for a shipment
     * @param {string} shipmentId The id of the shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    DocumentsApi.prototype.shipwellUiShipmentsShipmentIdGenerateDrayageHouseBolGet = function (shipmentId, options) {
        var _this = this;
        return (0, exports.DocumentsApiFp)(this.configuration).shipwellUiShipmentsShipmentIdGenerateDrayageHouseBolGet(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DocumentsApi;
}(base_1.BaseAPI));
exports.DocumentsApi = DocumentsApi;
/**
 * DriverTextFlowApi - axios parameter creator
 * @export
 */
var DriverTextFlowApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Gets the current text message templates.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        automationDriverTextsMessageTemplatesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/automation/driver-texts/message-templates/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates text message templates to new values.
         * @param {TextMessageTemplates} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        automationDriverTextsMessageTemplatesPut: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/automation/driver-texts/message-templates/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DriverTextFlowApiAxiosParamCreator = DriverTextFlowApiAxiosParamCreator;
/**
 * DriverTextFlowApi - functional programming interface
 * @export
 */
var DriverTextFlowApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DriverTextFlowApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Gets the current text message templates.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        automationDriverTextsMessageTemplatesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.automationDriverTextsMessageTemplatesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates text message templates to new values.
         * @param {TextMessageTemplates} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        automationDriverTextsMessageTemplatesPut: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.automationDriverTextsMessageTemplatesPut(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DriverTextFlowApiFp = DriverTextFlowApiFp;
/**
 * DriverTextFlowApi - factory interface
 * @export
 */
var DriverTextFlowApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DriverTextFlowApiFp)(configuration);
    return {
        /**
         *
         * @summary Gets the current text message templates.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        automationDriverTextsMessageTemplatesGet: function (options) {
            return localVarFp.automationDriverTextsMessageTemplatesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates text message templates to new values.
         * @param {TextMessageTemplates} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        automationDriverTextsMessageTemplatesPut: function (body, options) {
            return localVarFp.automationDriverTextsMessageTemplatesPut(body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DriverTextFlowApiFactory = DriverTextFlowApiFactory;
/**
 * DriverTextFlowApi - object-oriented interface
 * @export
 * @class DriverTextFlowApi
 * @extends {BaseAPI}
 */
var DriverTextFlowApi = /** @class */ (function (_super) {
    __extends(DriverTextFlowApi, _super);
    function DriverTextFlowApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Gets the current text message templates.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverTextFlowApi
     */
    DriverTextFlowApi.prototype.automationDriverTextsMessageTemplatesGet = function (options) {
        var _this = this;
        return (0, exports.DriverTextFlowApiFp)(this.configuration).automationDriverTextsMessageTemplatesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates text message templates to new values.
     * @param {TextMessageTemplates} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriverTextFlowApi
     */
    DriverTextFlowApi.prototype.automationDriverTextsMessageTemplatesPut = function (body, options) {
        var _this = this;
        return (0, exports.DriverTextFlowApiFp)(this.configuration).automationDriverTextsMessageTemplatesPut(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DriverTextFlowApi;
}(base_1.BaseAPI));
exports.DriverTextFlowApi = DriverTextFlowApi;
/**
 * DriversApi - axios parameter creator
 * @export
 */
var DriversApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Returns a list of logs for a driver
         * @param {string} [driverId] The driver to retrieve logs for. If not provided, the currently logged in driver will be used.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversLogGet: function (driverId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/drivers/log/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (driverId !== undefined) {
                                localVarQueryParameter['driverId'] = driverId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new log event for a driver
         * @param {InlineObject6} inlineObject6
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversLogPost: function (inlineObject6, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'inlineObject6' is not null or undefined
                            (0, common_1.assertParamExists)('driversLogPost', 'inlineObject6', inlineObject6);
                            localVarPath = "/drivers/log/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject6, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns information about the current authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversMeGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/drivers/me/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates information about the current authenticated user
         * @param {Driver} driver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversMePut: function (driver, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'driver' is not null or undefined
                            (0, common_1.assertParamExists)('driversMePut', 'driver', driver);
                            localVarPath = "/drivers/me/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(driver, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of messages a driver is assigned to
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversMessagesGet: function (page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/drivers/messages/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Mark a Driver\'s Shipment Message as read
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversMessagesShipmentIdMarkAsReadPost: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('driversMessagesShipmentIdMarkAsReadPost', 'shipmentId', shipmentId);
                            localVarPath = "/drivers/messages/{shipmentId}/mark-as-read/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Mark a Driver\'s Shipment Message as unread
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversMessagesShipmentIdMarkAsUnreadPost: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('driversMessagesShipmentIdMarkAsUnreadPost', 'shipmentId', shipmentId);
                            localVarPath = "/drivers/messages/{shipmentId}/mark-as-unread/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a driver\'s total and unread thread count.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversMessagesUnreadThreadsCountGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/drivers/messages/unread-threads-count/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Driver response to stop complete push notification
         * @param {string} stopId The id of the stop
         * @param {CompletePushResponse} completePushResponse
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversNotificationsStopsStopIdCompletePost: function (stopId, completePushResponse, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'stopId' is not null or undefined
                            (0, common_1.assertParamExists)('driversNotificationsStopsStopIdCompletePost', 'stopId', stopId);
                            // verify required parameter 'completePushResponse' is not null or undefined
                            (0, common_1.assertParamExists)('driversNotificationsStopsStopIdCompletePost', 'completePushResponse', completePushResponse);
                            localVarPath = "/drivers/notifications/stops/{stopId}/complete/"
                                .replace("{".concat("stopId", "}"), encodeURIComponent(String(stopId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(completePushResponse, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Driver response to pickup push notification
         * @param {string} stopId The id of the stop
         * @param {PickupPushResponse} pickupPushResponse
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversNotificationsStopsStopIdPickupPost: function (stopId, pickupPushResponse, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'stopId' is not null or undefined
                            (0, common_1.assertParamExists)('driversNotificationsStopsStopIdPickupPost', 'stopId', stopId);
                            // verify required parameter 'pickupPushResponse' is not null or undefined
                            (0, common_1.assertParamExists)('driversNotificationsStopsStopIdPickupPost', 'pickupPushResponse', pickupPushResponse);
                            localVarPath = "/drivers/notifications/stops/{stopId}/pickup/"
                                .replace("{".concat("stopId", "}"), encodeURIComponent(String(stopId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(pickupPushResponse, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Allows a driver to request a 4 digit pin for android. An SMS will be sent to the provided phone number.
         * @param {DriverPinRequest} driverPinRequest
         * @param {boolean} [createDriver] Whether or not to create a driver if it does not exist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversPinAndroidPost: function (driverPinRequest, createDriver, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'driverPinRequest' is not null or undefined
                    (0, common_1.assertParamExists)('driversPinAndroidPost', 'driverPinRequest', driverPinRequest);
                    localVarPath = "/drivers/pin/android/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (createDriver !== undefined) {
                        localVarQueryParameter['createDriver'] = createDriver;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(driverPinRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Allows a driver to request a 4 digit pin for iOS. An SMS will be sent to the provided phone number.
         * @param {DriverPinRequest} driverPinRequest
         * @param {boolean} [createDriver] Whether or not to create a driver if it does not exist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversPinIosPost: function (driverPinRequest, createDriver, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'driverPinRequest' is not null or undefined
                    (0, common_1.assertParamExists)('driversPinIosPost', 'driverPinRequest', driverPinRequest);
                    localVarPath = "/drivers/pin/ios/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (createDriver !== undefined) {
                        localVarQueryParameter['createDriver'] = createDriver;
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(driverPinRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Sends driver a shipment a tracking push notification
         * @param {InlineObject7} inlineObject7
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversPushNotificationsTrackingPost: function (inlineObject7, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'inlineObject7' is not null or undefined
                            (0, common_1.assertParamExists)('driversPushNotificationsTrackingPost', 'inlineObject7', inlineObject7);
                            localVarPath = "/drivers/push-notifications/tracking/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject7, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of shipments assigned to a specific driver
         * @param {'current' | 'upcoming' | 'active' | 'past'} [timeFrame] Return shipments that are within the given time frame. active &#x3D; current + upcoming
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [customer] Return shipments with this exact value as the customer company name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversShipmentsGet: function (timeFrame, page, pageSize, ordering, q, customer, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/drivers/shipments/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (timeFrame !== undefined) {
                                localVarQueryParameter['time_frame'] = timeFrame;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (customer !== undefined) {
                                localVarQueryParameter['customer'] = customer;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Driver rating of a location after completing a Stop.
         * @param {string} stopId The id of the stop
         * @param {LocationRating} locationRating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversStopsStopIdRateLocationPost: function (stopId, locationRating, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'stopId' is not null or undefined
                            (0, common_1.assertParamExists)('driversStopsStopIdRateLocationPost', 'stopId', stopId);
                            // verify required parameter 'locationRating' is not null or undefined
                            (0, common_1.assertParamExists)('driversStopsStopIdRateLocationPost', 'locationRating', locationRating);
                            localVarPath = "/drivers/stops/{stopId}/rate-location/"
                                .replace("{".concat("stopId", "}"), encodeURIComponent(String(stopId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(locationRating, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Allows a driver to login with their phone number and a 4 digit pin
         * @param {DriverLogin} driverLogin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversTokenPost: function (driverLogin, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'driverLogin' is not null or undefined
                    (0, common_1.assertParamExists)('driversTokenPost', 'driverLogin', driverLogin);
                    localVarPath = "/drivers/token/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(driverLogin, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DriversApiAxiosParamCreator = DriversApiAxiosParamCreator;
/**
 * DriversApi - functional programming interface
 * @export
 */
var DriversApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DriversApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Returns a list of logs for a driver
         * @param {string} [driverId] The driver to retrieve logs for. If not provided, the currently logged in driver will be used.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversLogGet: function (driverId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.driversLogGet(driverId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new log event for a driver
         * @param {InlineObject6} inlineObject6
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversLogPost: function (inlineObject6, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.driversLogPost(inlineObject6, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns information about the current authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversMeGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.driversMeGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates information about the current authenticated user
         * @param {Driver} driver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversMePut: function (driver, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.driversMePut(driver, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of messages a driver is assigned to
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversMessagesGet: function (page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.driversMessagesGet(page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Mark a Driver\'s Shipment Message as read
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversMessagesShipmentIdMarkAsReadPost: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.driversMessagesShipmentIdMarkAsReadPost(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Mark a Driver\'s Shipment Message as unread
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversMessagesShipmentIdMarkAsUnreadPost: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.driversMessagesShipmentIdMarkAsUnreadPost(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a driver\'s total and unread thread count.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversMessagesUnreadThreadsCountGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.driversMessagesUnreadThreadsCountGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Driver response to stop complete push notification
         * @param {string} stopId The id of the stop
         * @param {CompletePushResponse} completePushResponse
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversNotificationsStopsStopIdCompletePost: function (stopId, completePushResponse, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.driversNotificationsStopsStopIdCompletePost(stopId, completePushResponse, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Driver response to pickup push notification
         * @param {string} stopId The id of the stop
         * @param {PickupPushResponse} pickupPushResponse
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversNotificationsStopsStopIdPickupPost: function (stopId, pickupPushResponse, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.driversNotificationsStopsStopIdPickupPost(stopId, pickupPushResponse, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Allows a driver to request a 4 digit pin for android. An SMS will be sent to the provided phone number.
         * @param {DriverPinRequest} driverPinRequest
         * @param {boolean} [createDriver] Whether or not to create a driver if it does not exist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversPinAndroidPost: function (driverPinRequest, createDriver, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.driversPinAndroidPost(driverPinRequest, createDriver, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Allows a driver to request a 4 digit pin for iOS. An SMS will be sent to the provided phone number.
         * @param {DriverPinRequest} driverPinRequest
         * @param {boolean} [createDriver] Whether or not to create a driver if it does not exist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversPinIosPost: function (driverPinRequest, createDriver, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.driversPinIosPost(driverPinRequest, createDriver, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Sends driver a shipment a tracking push notification
         * @param {InlineObject7} inlineObject7
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversPushNotificationsTrackingPost: function (inlineObject7, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.driversPushNotificationsTrackingPost(inlineObject7, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of shipments assigned to a specific driver
         * @param {'current' | 'upcoming' | 'active' | 'past'} [timeFrame] Return shipments that are within the given time frame. active &#x3D; current + upcoming
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [customer] Return shipments with this exact value as the customer company name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversShipmentsGet: function (timeFrame, page, pageSize, ordering, q, customer, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.driversShipmentsGet(timeFrame, page, pageSize, ordering, q, customer, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Driver rating of a location after completing a Stop.
         * @param {string} stopId The id of the stop
         * @param {LocationRating} locationRating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversStopsStopIdRateLocationPost: function (stopId, locationRating, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.driversStopsStopIdRateLocationPost(stopId, locationRating, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Allows a driver to login with their phone number and a 4 digit pin
         * @param {DriverLogin} driverLogin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversTokenPost: function (driverLogin, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.driversTokenPost(driverLogin, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DriversApiFp = DriversApiFp;
/**
 * DriversApi - factory interface
 * @export
 */
var DriversApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DriversApiFp)(configuration);
    return {
        /**
         *
         * @summary Returns a list of logs for a driver
         * @param {string} [driverId] The driver to retrieve logs for. If not provided, the currently logged in driver will be used.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversLogGet: function (driverId, options) {
            return localVarFp.driversLogGet(driverId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a new log event for a driver
         * @param {InlineObject6} inlineObject6
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversLogPost: function (inlineObject6, options) {
            return localVarFp.driversLogPost(inlineObject6, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns information about the current authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversMeGet: function (options) {
            return localVarFp.driversMeGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates information about the current authenticated user
         * @param {Driver} driver
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversMePut: function (driver, options) {
            return localVarFp.driversMePut(driver, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a list of messages a driver is assigned to
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversMessagesGet: function (page, pageSize, options) {
            return localVarFp.driversMessagesGet(page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Mark a Driver\'s Shipment Message as read
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversMessagesShipmentIdMarkAsReadPost: function (shipmentId, options) {
            return localVarFp.driversMessagesShipmentIdMarkAsReadPost(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Mark a Driver\'s Shipment Message as unread
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversMessagesShipmentIdMarkAsUnreadPost: function (shipmentId, options) {
            return localVarFp.driversMessagesShipmentIdMarkAsUnreadPost(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a driver\'s total and unread thread count.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversMessagesUnreadThreadsCountGet: function (options) {
            return localVarFp.driversMessagesUnreadThreadsCountGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Driver response to stop complete push notification
         * @param {string} stopId The id of the stop
         * @param {CompletePushResponse} completePushResponse
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversNotificationsStopsStopIdCompletePost: function (stopId, completePushResponse, options) {
            return localVarFp.driversNotificationsStopsStopIdCompletePost(stopId, completePushResponse, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Driver response to pickup push notification
         * @param {string} stopId The id of the stop
         * @param {PickupPushResponse} pickupPushResponse
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversNotificationsStopsStopIdPickupPost: function (stopId, pickupPushResponse, options) {
            return localVarFp.driversNotificationsStopsStopIdPickupPost(stopId, pickupPushResponse, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Allows a driver to request a 4 digit pin for android. An SMS will be sent to the provided phone number.
         * @param {DriverPinRequest} driverPinRequest
         * @param {boolean} [createDriver] Whether or not to create a driver if it does not exist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversPinAndroidPost: function (driverPinRequest, createDriver, options) {
            return localVarFp.driversPinAndroidPost(driverPinRequest, createDriver, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Allows a driver to request a 4 digit pin for iOS. An SMS will be sent to the provided phone number.
         * @param {DriverPinRequest} driverPinRequest
         * @param {boolean} [createDriver] Whether or not to create a driver if it does not exist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversPinIosPost: function (driverPinRequest, createDriver, options) {
            return localVarFp.driversPinIosPost(driverPinRequest, createDriver, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Sends driver a shipment a tracking push notification
         * @param {InlineObject7} inlineObject7
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversPushNotificationsTrackingPost: function (inlineObject7, options) {
            return localVarFp.driversPushNotificationsTrackingPost(inlineObject7, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a list of shipments assigned to a specific driver
         * @param {'current' | 'upcoming' | 'active' | 'past'} [timeFrame] Return shipments that are within the given time frame. active &#x3D; current + upcoming
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [customer] Return shipments with this exact value as the customer company name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversShipmentsGet: function (timeFrame, page, pageSize, ordering, q, customer, options) {
            return localVarFp.driversShipmentsGet(timeFrame, page, pageSize, ordering, q, customer, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Driver rating of a location after completing a Stop.
         * @param {string} stopId The id of the stop
         * @param {LocationRating} locationRating
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversStopsStopIdRateLocationPost: function (stopId, locationRating, options) {
            return localVarFp.driversStopsStopIdRateLocationPost(stopId, locationRating, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Allows a driver to login with their phone number and a 4 digit pin
         * @param {DriverLogin} driverLogin
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        driversTokenPost: function (driverLogin, options) {
            return localVarFp.driversTokenPost(driverLogin, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DriversApiFactory = DriversApiFactory;
/**
 * DriversApi - object-oriented interface
 * @export
 * @class DriversApi
 * @extends {BaseAPI}
 */
var DriversApi = /** @class */ (function (_super) {
    __extends(DriversApi, _super);
    function DriversApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Returns a list of logs for a driver
     * @param {string} [driverId] The driver to retrieve logs for. If not provided, the currently logged in driver will be used.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    DriversApi.prototype.driversLogGet = function (driverId, options) {
        var _this = this;
        return (0, exports.DriversApiFp)(this.configuration).driversLogGet(driverId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a new log event for a driver
     * @param {InlineObject6} inlineObject6
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    DriversApi.prototype.driversLogPost = function (inlineObject6, options) {
        var _this = this;
        return (0, exports.DriversApiFp)(this.configuration).driversLogPost(inlineObject6, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns information about the current authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    DriversApi.prototype.driversMeGet = function (options) {
        var _this = this;
        return (0, exports.DriversApiFp)(this.configuration).driversMeGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates information about the current authenticated user
     * @param {Driver} driver
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    DriversApi.prototype.driversMePut = function (driver, options) {
        var _this = this;
        return (0, exports.DriversApiFp)(this.configuration).driversMePut(driver, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a list of messages a driver is assigned to
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    DriversApi.prototype.driversMessagesGet = function (page, pageSize, options) {
        var _this = this;
        return (0, exports.DriversApiFp)(this.configuration).driversMessagesGet(page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Mark a Driver\'s Shipment Message as read
     * @param {string} shipmentId The id of the shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    DriversApi.prototype.driversMessagesShipmentIdMarkAsReadPost = function (shipmentId, options) {
        var _this = this;
        return (0, exports.DriversApiFp)(this.configuration).driversMessagesShipmentIdMarkAsReadPost(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Mark a Driver\'s Shipment Message as unread
     * @param {string} shipmentId The id of the shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    DriversApi.prototype.driversMessagesShipmentIdMarkAsUnreadPost = function (shipmentId, options) {
        var _this = this;
        return (0, exports.DriversApiFp)(this.configuration).driversMessagesShipmentIdMarkAsUnreadPost(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a driver\'s total and unread thread count.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    DriversApi.prototype.driversMessagesUnreadThreadsCountGet = function (options) {
        var _this = this;
        return (0, exports.DriversApiFp)(this.configuration).driversMessagesUnreadThreadsCountGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Driver response to stop complete push notification
     * @param {string} stopId The id of the stop
     * @param {CompletePushResponse} completePushResponse
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    DriversApi.prototype.driversNotificationsStopsStopIdCompletePost = function (stopId, completePushResponse, options) {
        var _this = this;
        return (0, exports.DriversApiFp)(this.configuration).driversNotificationsStopsStopIdCompletePost(stopId, completePushResponse, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Driver response to pickup push notification
     * @param {string} stopId The id of the stop
     * @param {PickupPushResponse} pickupPushResponse
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    DriversApi.prototype.driversNotificationsStopsStopIdPickupPost = function (stopId, pickupPushResponse, options) {
        var _this = this;
        return (0, exports.DriversApiFp)(this.configuration).driversNotificationsStopsStopIdPickupPost(stopId, pickupPushResponse, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Allows a driver to request a 4 digit pin for android. An SMS will be sent to the provided phone number.
     * @param {DriverPinRequest} driverPinRequest
     * @param {boolean} [createDriver] Whether or not to create a driver if it does not exist
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    DriversApi.prototype.driversPinAndroidPost = function (driverPinRequest, createDriver, options) {
        var _this = this;
        return (0, exports.DriversApiFp)(this.configuration).driversPinAndroidPost(driverPinRequest, createDriver, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Allows a driver to request a 4 digit pin for iOS. An SMS will be sent to the provided phone number.
     * @param {DriverPinRequest} driverPinRequest
     * @param {boolean} [createDriver] Whether or not to create a driver if it does not exist
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    DriversApi.prototype.driversPinIosPost = function (driverPinRequest, createDriver, options) {
        var _this = this;
        return (0, exports.DriversApiFp)(this.configuration).driversPinIosPost(driverPinRequest, createDriver, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Sends driver a shipment a tracking push notification
     * @param {InlineObject7} inlineObject7
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    DriversApi.prototype.driversPushNotificationsTrackingPost = function (inlineObject7, options) {
        var _this = this;
        return (0, exports.DriversApiFp)(this.configuration).driversPushNotificationsTrackingPost(inlineObject7, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a list of shipments assigned to a specific driver
     * @param {'current' | 'upcoming' | 'active' | 'past'} [timeFrame] Return shipments that are within the given time frame. active &#x3D; current + upcoming
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {string} [customer] Return shipments with this exact value as the customer company name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    DriversApi.prototype.driversShipmentsGet = function (timeFrame, page, pageSize, ordering, q, customer, options) {
        var _this = this;
        return (0, exports.DriversApiFp)(this.configuration).driversShipmentsGet(timeFrame, page, pageSize, ordering, q, customer, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Driver rating of a location after completing a Stop.
     * @param {string} stopId The id of the stop
     * @param {LocationRating} locationRating
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    DriversApi.prototype.driversStopsStopIdRateLocationPost = function (stopId, locationRating, options) {
        var _this = this;
        return (0, exports.DriversApiFp)(this.configuration).driversStopsStopIdRateLocationPost(stopId, locationRating, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Allows a driver to login with their phone number and a 4 digit pin
     * @param {DriverLogin} driverLogin
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriversApi
     */
    DriversApi.prototype.driversTokenPost = function (driverLogin, options) {
        var _this = this;
        return (0, exports.DriversApiFp)(this.configuration).driversTokenPost(driverLogin, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DriversApi;
}(base_1.BaseAPI));
exports.DriversApi = DriversApi;
/**
 * FuelSurchargeRatesApi - axios parameter creator
 * @export
 */
var FuelSurchargeRatesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary List of fuel surcharge rates obtained from the Energy Information Administration\'s(EIA) API.
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [fromDate] get all fuel surcharge rates published after this date (YYYY-MM-DD).
         * @param {string} [endDate] get all fuel surcharge rates published before this date (YYYY-MM-DD).
         * @param {string} [date] get all fuel surcharge rates published exactly on this date (YYYY-MM-DD).
         * @param {'US' | 'EAST_COAST' | 'NEW_ENGLAND' | 'CENTRAL_ATLANTIC' | 'LOWER_ATLANTIC' | 'MIDWEST' | 'GULF_COAST' | 'ROCKY_MOUNTAIN' | 'WEST_COAST' | 'WEST_COAST_LESS_CALIFORNIA' | 'CALIFORNIA'} [region] get all fuel surcharge rates for this region
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesEiaFuelSurchargeRatesGet: function (page, pageSize, ordering, fromDate, endDate, date, region, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/quoting/rate-tables/eia/fuel-surcharge-rates/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (fromDate !== undefined) {
                                localVarQueryParameter['from_date'] = (fromDate instanceof Date) ?
                                    fromDate.toISOString().substr(0, 10) :
                                    fromDate;
                            }
                            if (endDate !== undefined) {
                                localVarQueryParameter['end_date'] = (endDate instanceof Date) ?
                                    endDate.toISOString().substr(0, 10) :
                                    endDate;
                            }
                            if (date !== undefined) {
                                localVarQueryParameter['date'] = (date instanceof Date) ?
                                    date.toISOString().substr(0, 10) :
                                    date;
                            }
                            if (region !== undefined) {
                                localVarQueryParameter['region'] = region;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.FuelSurchargeRatesApiAxiosParamCreator = FuelSurchargeRatesApiAxiosParamCreator;
/**
 * FuelSurchargeRatesApi - functional programming interface
 * @export
 */
var FuelSurchargeRatesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.FuelSurchargeRatesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary List of fuel surcharge rates obtained from the Energy Information Administration\'s(EIA) API.
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [fromDate] get all fuel surcharge rates published after this date (YYYY-MM-DD).
         * @param {string} [endDate] get all fuel surcharge rates published before this date (YYYY-MM-DD).
         * @param {string} [date] get all fuel surcharge rates published exactly on this date (YYYY-MM-DD).
         * @param {'US' | 'EAST_COAST' | 'NEW_ENGLAND' | 'CENTRAL_ATLANTIC' | 'LOWER_ATLANTIC' | 'MIDWEST' | 'GULF_COAST' | 'ROCKY_MOUNTAIN' | 'WEST_COAST' | 'WEST_COAST_LESS_CALIFORNIA' | 'CALIFORNIA'} [region] get all fuel surcharge rates for this region
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesEiaFuelSurchargeRatesGet: function (page, pageSize, ordering, fromDate, endDate, date, region, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingRateTablesEiaFuelSurchargeRatesGet(page, pageSize, ordering, fromDate, endDate, date, region, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.FuelSurchargeRatesApiFp = FuelSurchargeRatesApiFp;
/**
 * FuelSurchargeRatesApi - factory interface
 * @export
 */
var FuelSurchargeRatesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.FuelSurchargeRatesApiFp)(configuration);
    return {
        /**
         *
         * @summary List of fuel surcharge rates obtained from the Energy Information Administration\'s(EIA) API.
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [fromDate] get all fuel surcharge rates published after this date (YYYY-MM-DD).
         * @param {string} [endDate] get all fuel surcharge rates published before this date (YYYY-MM-DD).
         * @param {string} [date] get all fuel surcharge rates published exactly on this date (YYYY-MM-DD).
         * @param {'US' | 'EAST_COAST' | 'NEW_ENGLAND' | 'CENTRAL_ATLANTIC' | 'LOWER_ATLANTIC' | 'MIDWEST' | 'GULF_COAST' | 'ROCKY_MOUNTAIN' | 'WEST_COAST' | 'WEST_COAST_LESS_CALIFORNIA' | 'CALIFORNIA'} [region] get all fuel surcharge rates for this region
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesEiaFuelSurchargeRatesGet: function (page, pageSize, ordering, fromDate, endDate, date, region, options) {
            return localVarFp.quotingRateTablesEiaFuelSurchargeRatesGet(page, pageSize, ordering, fromDate, endDate, date, region, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.FuelSurchargeRatesApiFactory = FuelSurchargeRatesApiFactory;
/**
 * FuelSurchargeRatesApi - object-oriented interface
 * @export
 * @class FuelSurchargeRatesApi
 * @extends {BaseAPI}
 */
var FuelSurchargeRatesApi = /** @class */ (function (_super) {
    __extends(FuelSurchargeRatesApi, _super);
    function FuelSurchargeRatesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary List of fuel surcharge rates obtained from the Energy Information Administration\'s(EIA) API.
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [fromDate] get all fuel surcharge rates published after this date (YYYY-MM-DD).
     * @param {string} [endDate] get all fuel surcharge rates published before this date (YYYY-MM-DD).
     * @param {string} [date] get all fuel surcharge rates published exactly on this date (YYYY-MM-DD).
     * @param {'US' | 'EAST_COAST' | 'NEW_ENGLAND' | 'CENTRAL_ATLANTIC' | 'LOWER_ATLANTIC' | 'MIDWEST' | 'GULF_COAST' | 'ROCKY_MOUNTAIN' | 'WEST_COAST' | 'WEST_COAST_LESS_CALIFORNIA' | 'CALIFORNIA'} [region] get all fuel surcharge rates for this region
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FuelSurchargeRatesApi
     */
    FuelSurchargeRatesApi.prototype.quotingRateTablesEiaFuelSurchargeRatesGet = function (page, pageSize, ordering, fromDate, endDate, date, region, options) {
        var _this = this;
        return (0, exports.FuelSurchargeRatesApiFp)(this.configuration).quotingRateTablesEiaFuelSurchargeRatesGet(page, pageSize, ordering, fromDate, endDate, date, region, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return FuelSurchargeRatesApi;
}(base_1.BaseAPI));
exports.FuelSurchargeRatesApi = FuelSurchargeRatesApi;
/**
 * ImportsApi - axios parameter creator
 * @export
 */
var ImportsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get a list or errors for an import jobs
         * @param {string} importJobId The id of an import job
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importJobsImportJobIdErrorsGet: function (importJobId, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'importJobId' is not null or undefined
                            (0, common_1.assertParamExists)('importJobsImportJobIdErrorsGet', 'importJobId', importJobId);
                            localVarPath = "/import-jobs/{importJobId}/errors/"
                                .replace("{".concat("importJobId", "}"), encodeURIComponent(String(importJobId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of imports
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsGet: function (page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/imports/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list column mappings for an import
         * @param {string} importId The id of an import
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdColumnMappingsGet: function (importId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'importId' is not null or undefined
                            (0, common_1.assertParamExists)('importsImportIdColumnMappingsGet', 'importId', importId);
                            localVarPath = "/imports/{importId}/column-mappings/"
                                .replace("{".concat("importId", "}"), encodeURIComponent(String(importId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about an import column mapping
         * @param {string} importId The id of an import
         * @param {string} importColumnMappingId The id of an import column mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdColumnMappingsImportColumnMappingIdGet: function (importId, importColumnMappingId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'importId' is not null or undefined
                            (0, common_1.assertParamExists)('importsImportIdColumnMappingsImportColumnMappingIdGet', 'importId', importId);
                            // verify required parameter 'importColumnMappingId' is not null or undefined
                            (0, common_1.assertParamExists)('importsImportIdColumnMappingsImportColumnMappingIdGet', 'importColumnMappingId', importColumnMappingId);
                            localVarPath = "/imports/{importId}/column-mappings/{importColumnMappingId}/"
                                .replace("{".concat("importId", "}"), encodeURIComponent(String(importId)))
                                .replace("{".concat("importColumnMappingId", "}"), encodeURIComponent(String(importColumnMappingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an import column mapping
         * @param {string} importId The id of an import
         * @param {string} importColumnMappingId The id of an import column mapping
         * @param {ImportColumnMapping} importColumnMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdColumnMappingsImportColumnMappingIdPut: function (importId, importColumnMappingId, importColumnMapping, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'importId' is not null or undefined
                            (0, common_1.assertParamExists)('importsImportIdColumnMappingsImportColumnMappingIdPut', 'importId', importId);
                            // verify required parameter 'importColumnMappingId' is not null or undefined
                            (0, common_1.assertParamExists)('importsImportIdColumnMappingsImportColumnMappingIdPut', 'importColumnMappingId', importColumnMappingId);
                            // verify required parameter 'importColumnMapping' is not null or undefined
                            (0, common_1.assertParamExists)('importsImportIdColumnMappingsImportColumnMappingIdPut', 'importColumnMapping', importColumnMapping);
                            localVarPath = "/imports/{importId}/column-mappings/{importColumnMappingId}/"
                                .replace("{".concat("importId", "}"), encodeURIComponent(String(importId)))
                                .replace("{".concat("importColumnMappingId", "}"), encodeURIComponent(String(importColumnMappingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(importColumnMapping, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about an import
         * @param {string} importId The id of an import
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdGet: function (importId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'importId' is not null or undefined
                            (0, common_1.assertParamExists)('importsImportIdGet', 'importId', importId);
                            localVarPath = "/imports/{importId}/"
                                .replace("{".concat("importId", "}"), encodeURIComponent(String(importId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list jobs for an import
         * @param {string} importId The id of an import
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdJobsGet: function (importId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'importId' is not null or undefined
                            (0, common_1.assertParamExists)('importsImportIdJobsGet', 'importId', importId);
                            localVarPath = "/imports/{importId}/jobs/"
                                .replace("{".concat("importId", "}"), encodeURIComponent(String(importId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a job for an import
         * @param {string} importId The id of an import
         * @param {string} importJobId The id of an import job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdJobsImportJobIdGet: function (importId, importJobId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'importId' is not null or undefined
                            (0, common_1.assertParamExists)('importsImportIdJobsImportJobIdGet', 'importId', importId);
                            // verify required parameter 'importJobId' is not null or undefined
                            (0, common_1.assertParamExists)('importsImportIdJobsImportJobIdGet', 'importJobId', importJobId);
                            localVarPath = "/imports/{importId}/jobs/{importJobId}/"
                                .replace("{".concat("importId", "}"), encodeURIComponent(String(importId)))
                                .replace("{".concat("importJobId", "}"), encodeURIComponent(String(importJobId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Validates then saves an import. This commits all data.
         * @param {string} importId The id of an import
         * @param {boolean} validateOnly Whether imports should only validate the data or commit it to the database
         * @param {string} [fuelSurchargeTableId] The ID of the fuel surcharge table instance the rates should be imported into. Only required if using the \&quot;Fuel Surcharge Table Rates\&quot; importer
         * @param {string} [rfpBidId] The ID of the RFPBid instance to which the imported RFPRows belong to
         * @param {string} [rfpBidOptId] The ID of the RFPBidOpt instance to which the imported RFPRows belong to
         * @param {string} [rfpCarrierBidRequestId] The ID of the Carrier bid request instance
         * @param {string} [rateTableId] The ID of the rate table instance the data should be imported into. Only required if using the \&quot;Discount Percentages\&quot; or \&quot;Rate Minimums\&quot; importer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdJobsPost: function (importId, validateOnly, fuelSurchargeTableId, rfpBidId, rfpBidOptId, rfpCarrierBidRequestId, rateTableId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'importId' is not null or undefined
                            (0, common_1.assertParamExists)('importsImportIdJobsPost', 'importId', importId);
                            // verify required parameter 'validateOnly' is not null or undefined
                            (0, common_1.assertParamExists)('importsImportIdJobsPost', 'validateOnly', validateOnly);
                            localVarPath = "/imports/{importId}/jobs/"
                                .replace("{".concat("importId", "}"), encodeURIComponent(String(importId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (validateOnly !== undefined) {
                                localVarQueryParameter['validateOnly'] = validateOnly;
                            }
                            if (fuelSurchargeTableId !== undefined) {
                                localVarQueryParameter['fuel_surcharge_table_id'] = fuelSurchargeTableId;
                            }
                            if (rfpBidId !== undefined) {
                                localVarQueryParameter['rfp_bid_id'] = rfpBidId;
                            }
                            if (rfpBidOptId !== undefined) {
                                localVarQueryParameter['rfp_bid_opt_id'] = rfpBidOptId;
                            }
                            if (rfpCarrierBidRequestId !== undefined) {
                                localVarQueryParameter['rfp_carrier_bid_request_id'] = rfpCarrierBidRequestId;
                            }
                            if (rateTableId !== undefined) {
                                localVarQueryParameter['rate_table_id'] = rateTableId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an import
         * @param {string} importId The id of an import
         * @param {DataImport} dataImport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdPut: function (importId, dataImport, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'importId' is not null or undefined
                            (0, common_1.assertParamExists)('importsImportIdPut', 'importId', importId);
                            // verify required parameter 'dataImport' is not null or undefined
                            (0, common_1.assertParamExists)('importsImportIdPut', 'dataImport', dataImport);
                            localVarPath = "/imports/{importId}/"
                                .replace("{".concat("importId", "}"), encodeURIComponent(String(importId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(dataImport, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list rows for an import
         * @param {string} importId The id of an import
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdRowsGet: function (importId, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'importId' is not null or undefined
                            (0, common_1.assertParamExists)('importsImportIdRowsGet', 'importId', importId);
                            localVarPath = "/imports/{importId}/rows/"
                                .replace("{".concat("importId", "}"), encodeURIComponent(String(importId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about an import row
         * @param {string} importId The id of an import
         * @param {string} importRowId The id of an import row
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdRowsImportRowIdGet: function (importId, importRowId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'importId' is not null or undefined
                            (0, common_1.assertParamExists)('importsImportIdRowsImportRowIdGet', 'importId', importId);
                            // verify required parameter 'importRowId' is not null or undefined
                            (0, common_1.assertParamExists)('importsImportIdRowsImportRowIdGet', 'importRowId', importRowId);
                            localVarPath = "/imports/{importId}/rows/{importRowId}/"
                                .replace("{".concat("importId", "}"), encodeURIComponent(String(importId)))
                                .replace("{".concat("importRowId", "}"), encodeURIComponent(String(importRowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an import row
         * @param {string} importId The id of an import
         * @param {string} importRowId The id of an import row
         * @param {ImportRow} importRow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdRowsImportRowIdPut: function (importId, importRowId, importRow, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'importId' is not null or undefined
                            (0, common_1.assertParamExists)('importsImportIdRowsImportRowIdPut', 'importId', importId);
                            // verify required parameter 'importRowId' is not null or undefined
                            (0, common_1.assertParamExists)('importsImportIdRowsImportRowIdPut', 'importRowId', importRowId);
                            // verify required parameter 'importRow' is not null or undefined
                            (0, common_1.assertParamExists)('importsImportIdRowsImportRowIdPut', 'importRow', importRow);
                            localVarPath = "/imports/{importId}/rows/{importRowId}/"
                                .replace("{".concat("importId", "}"), encodeURIComponent(String(importId)))
                                .replace("{".concat("importRowId", "}"), encodeURIComponent(String(importRowId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(importRow, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an import value
         * @param {string} importId The id of an import
         * @param {string} importValueId The id of an import value
         * @param {ImportValue} importValue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdValuesImportValueIdPut: function (importId, importValueId, importValue, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'importId' is not null or undefined
                            (0, common_1.assertParamExists)('importsImportIdValuesImportValueIdPut', 'importId', importId);
                            // verify required parameter 'importValueId' is not null or undefined
                            (0, common_1.assertParamExists)('importsImportIdValuesImportValueIdPut', 'importValueId', importValueId);
                            // verify required parameter 'importValue' is not null or undefined
                            (0, common_1.assertParamExists)('importsImportIdValuesImportValueIdPut', 'importValue', importValue);
                            localVarPath = "/imports/{importId}/values/{importValueId}/"
                                .replace("{".concat("importId", "}"), encodeURIComponent(String(importId)))
                                .replace("{".concat("importValueId", "}"), encodeURIComponent(String(importValueId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(importValue, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all fields allowed to be imported for a given importable-type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportableFieldsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/imports/importable-fields/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all object types allowed to be imported. Key is the key which is used elsewhere, value is the human readable string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportableTypesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/imports/importable-types/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new import
         * @param {string} type
         * @param {any} [csvFile]
         * @param {string} [googleSheetId]
         * @param {string} [googleSheetTab]
         * @param {boolean} [isComplete]
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsPost: function (type, csvFile, googleSheetId, googleSheetTab, isComplete, name, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'type' is not null or undefined
                            (0, common_1.assertParamExists)('importsPost', 'type', type);
                            localVarPath = "/imports/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (csvFile !== undefined) {
                                localVarFormParams.append('csv_file', csvFile);
                            }
                            if (googleSheetId !== undefined) {
                                localVarFormParams.append('google_sheet_id', googleSheetId);
                            }
                            if (googleSheetTab !== undefined) {
                                localVarFormParams.append('google_sheet_tab', googleSheetTab);
                            }
                            if (isComplete !== undefined) {
                                localVarFormParams.append('is_complete', isComplete);
                            }
                            if (name !== undefined) {
                                localVarFormParams.append('name', name);
                            }
                            if (type !== undefined) {
                                localVarFormParams.append('type', type);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ImportsApiAxiosParamCreator = ImportsApiAxiosParamCreator;
/**
 * ImportsApi - functional programming interface
 * @export
 */
var ImportsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ImportsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get a list or errors for an import jobs
         * @param {string} importJobId The id of an import job
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importJobsImportJobIdErrorsGet: function (importJobId, page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.importJobsImportJobIdErrorsGet(importJobId, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of imports
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsGet: function (page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.importsGet(page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list column mappings for an import
         * @param {string} importId The id of an import
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdColumnMappingsGet: function (importId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.importsImportIdColumnMappingsGet(importId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about an import column mapping
         * @param {string} importId The id of an import
         * @param {string} importColumnMappingId The id of an import column mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdColumnMappingsImportColumnMappingIdGet: function (importId, importColumnMappingId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.importsImportIdColumnMappingsImportColumnMappingIdGet(importId, importColumnMappingId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an import column mapping
         * @param {string} importId The id of an import
         * @param {string} importColumnMappingId The id of an import column mapping
         * @param {ImportColumnMapping} importColumnMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdColumnMappingsImportColumnMappingIdPut: function (importId, importColumnMappingId, importColumnMapping, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.importsImportIdColumnMappingsImportColumnMappingIdPut(importId, importColumnMappingId, importColumnMapping, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about an import
         * @param {string} importId The id of an import
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdGet: function (importId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.importsImportIdGet(importId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list jobs for an import
         * @param {string} importId The id of an import
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdJobsGet: function (importId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.importsImportIdJobsGet(importId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a job for an import
         * @param {string} importId The id of an import
         * @param {string} importJobId The id of an import job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdJobsImportJobIdGet: function (importId, importJobId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.importsImportIdJobsImportJobIdGet(importId, importJobId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Validates then saves an import. This commits all data.
         * @param {string} importId The id of an import
         * @param {boolean} validateOnly Whether imports should only validate the data or commit it to the database
         * @param {string} [fuelSurchargeTableId] The ID of the fuel surcharge table instance the rates should be imported into. Only required if using the \&quot;Fuel Surcharge Table Rates\&quot; importer
         * @param {string} [rfpBidId] The ID of the RFPBid instance to which the imported RFPRows belong to
         * @param {string} [rfpBidOptId] The ID of the RFPBidOpt instance to which the imported RFPRows belong to
         * @param {string} [rfpCarrierBidRequestId] The ID of the Carrier bid request instance
         * @param {string} [rateTableId] The ID of the rate table instance the data should be imported into. Only required if using the \&quot;Discount Percentages\&quot; or \&quot;Rate Minimums\&quot; importer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdJobsPost: function (importId, validateOnly, fuelSurchargeTableId, rfpBidId, rfpBidOptId, rfpCarrierBidRequestId, rateTableId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.importsImportIdJobsPost(importId, validateOnly, fuelSurchargeTableId, rfpBidId, rfpBidOptId, rfpCarrierBidRequestId, rateTableId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an import
         * @param {string} importId The id of an import
         * @param {DataImport} dataImport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdPut: function (importId, dataImport, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.importsImportIdPut(importId, dataImport, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list rows for an import
         * @param {string} importId The id of an import
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdRowsGet: function (importId, page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.importsImportIdRowsGet(importId, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about an import row
         * @param {string} importId The id of an import
         * @param {string} importRowId The id of an import row
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdRowsImportRowIdGet: function (importId, importRowId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.importsImportIdRowsImportRowIdGet(importId, importRowId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an import row
         * @param {string} importId The id of an import
         * @param {string} importRowId The id of an import row
         * @param {ImportRow} importRow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdRowsImportRowIdPut: function (importId, importRowId, importRow, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.importsImportIdRowsImportRowIdPut(importId, importRowId, importRow, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an import value
         * @param {string} importId The id of an import
         * @param {string} importValueId The id of an import value
         * @param {ImportValue} importValue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdValuesImportValueIdPut: function (importId, importValueId, importValue, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.importsImportIdValuesImportValueIdPut(importId, importValueId, importValue, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all fields allowed to be imported for a given importable-type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportableFieldsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.importsImportableFieldsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all object types allowed to be imported. Key is the key which is used elsewhere, value is the human readable string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportableTypesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.importsImportableTypesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new import
         * @param {string} type
         * @param {any} [csvFile]
         * @param {string} [googleSheetId]
         * @param {string} [googleSheetTab]
         * @param {boolean} [isComplete]
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsPost: function (type, csvFile, googleSheetId, googleSheetTab, isComplete, name, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.importsPost(type, csvFile, googleSheetId, googleSheetTab, isComplete, name, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ImportsApiFp = ImportsApiFp;
/**
 * ImportsApi - factory interface
 * @export
 */
var ImportsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ImportsApiFp)(configuration);
    return {
        /**
         *
         * @summary Get a list or errors for an import jobs
         * @param {string} importJobId The id of an import job
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importJobsImportJobIdErrorsGet: function (importJobId, page, pageSize, options) {
            return localVarFp.importJobsImportJobIdErrorsGet(importJobId, page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a list of imports
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsGet: function (page, pageSize, options) {
            return localVarFp.importsGet(page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a list column mappings for an import
         * @param {string} importId The id of an import
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdColumnMappingsGet: function (importId, options) {
            return localVarFp.importsImportIdColumnMappingsGet(importId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about an import column mapping
         * @param {string} importId The id of an import
         * @param {string} importColumnMappingId The id of an import column mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdColumnMappingsImportColumnMappingIdGet: function (importId, importColumnMappingId, options) {
            return localVarFp.importsImportIdColumnMappingsImportColumnMappingIdGet(importId, importColumnMappingId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update an import column mapping
         * @param {string} importId The id of an import
         * @param {string} importColumnMappingId The id of an import column mapping
         * @param {ImportColumnMapping} importColumnMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdColumnMappingsImportColumnMappingIdPut: function (importId, importColumnMappingId, importColumnMapping, options) {
            return localVarFp.importsImportIdColumnMappingsImportColumnMappingIdPut(importId, importColumnMappingId, importColumnMapping, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about an import
         * @param {string} importId The id of an import
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdGet: function (importId, options) {
            return localVarFp.importsImportIdGet(importId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a list jobs for an import
         * @param {string} importId The id of an import
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdJobsGet: function (importId, options) {
            return localVarFp.importsImportIdJobsGet(importId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a job for an import
         * @param {string} importId The id of an import
         * @param {string} importJobId The id of an import job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdJobsImportJobIdGet: function (importId, importJobId, options) {
            return localVarFp.importsImportIdJobsImportJobIdGet(importId, importJobId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Validates then saves an import. This commits all data.
         * @param {string} importId The id of an import
         * @param {boolean} validateOnly Whether imports should only validate the data or commit it to the database
         * @param {string} [fuelSurchargeTableId] The ID of the fuel surcharge table instance the rates should be imported into. Only required if using the \&quot;Fuel Surcharge Table Rates\&quot; importer
         * @param {string} [rfpBidId] The ID of the RFPBid instance to which the imported RFPRows belong to
         * @param {string} [rfpBidOptId] The ID of the RFPBidOpt instance to which the imported RFPRows belong to
         * @param {string} [rfpCarrierBidRequestId] The ID of the Carrier bid request instance
         * @param {string} [rateTableId] The ID of the rate table instance the data should be imported into. Only required if using the \&quot;Discount Percentages\&quot; or \&quot;Rate Minimums\&quot; importer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdJobsPost: function (importId, validateOnly, fuelSurchargeTableId, rfpBidId, rfpBidOptId, rfpCarrierBidRequestId, rateTableId, options) {
            return localVarFp.importsImportIdJobsPost(importId, validateOnly, fuelSurchargeTableId, rfpBidId, rfpBidOptId, rfpCarrierBidRequestId, rateTableId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update an import
         * @param {string} importId The id of an import
         * @param {DataImport} dataImport
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdPut: function (importId, dataImport, options) {
            return localVarFp.importsImportIdPut(importId, dataImport, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a list rows for an import
         * @param {string} importId The id of an import
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdRowsGet: function (importId, page, pageSize, options) {
            return localVarFp.importsImportIdRowsGet(importId, page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about an import row
         * @param {string} importId The id of an import
         * @param {string} importRowId The id of an import row
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdRowsImportRowIdGet: function (importId, importRowId, options) {
            return localVarFp.importsImportIdRowsImportRowIdGet(importId, importRowId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update an import row
         * @param {string} importId The id of an import
         * @param {string} importRowId The id of an import row
         * @param {ImportRow} importRow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdRowsImportRowIdPut: function (importId, importRowId, importRow, options) {
            return localVarFp.importsImportIdRowsImportRowIdPut(importId, importRowId, importRow, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update an import value
         * @param {string} importId The id of an import
         * @param {string} importValueId The id of an import value
         * @param {ImportValue} importValue
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportIdValuesImportValueIdPut: function (importId, importValueId, importValue, options) {
            return localVarFp.importsImportIdValuesImportValueIdPut(importId, importValueId, importValue, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary A list of all fields allowed to be imported for a given importable-type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportableFieldsGet: function (options) {
            return localVarFp.importsImportableFieldsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary A list of all object types allowed to be imported. Key is the key which is used elsewhere, value is the human readable string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsImportableTypesGet: function (options) {
            return localVarFp.importsImportableTypesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a new import
         * @param {string} type
         * @param {any} [csvFile]
         * @param {string} [googleSheetId]
         * @param {string} [googleSheetTab]
         * @param {boolean} [isComplete]
         * @param {string} [name]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importsPost: function (type, csvFile, googleSheetId, googleSheetTab, isComplete, name, options) {
            return localVarFp.importsPost(type, csvFile, googleSheetId, googleSheetTab, isComplete, name, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ImportsApiFactory = ImportsApiFactory;
/**
 * ImportsApi - object-oriented interface
 * @export
 * @class ImportsApi
 * @extends {BaseAPI}
 */
var ImportsApi = /** @class */ (function (_super) {
    __extends(ImportsApi, _super);
    function ImportsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get a list or errors for an import jobs
     * @param {string} importJobId The id of an import job
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportsApi
     */
    ImportsApi.prototype.importJobsImportJobIdErrorsGet = function (importJobId, page, pageSize, options) {
        var _this = this;
        return (0, exports.ImportsApiFp)(this.configuration).importJobsImportJobIdErrorsGet(importJobId, page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a list of imports
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportsApi
     */
    ImportsApi.prototype.importsGet = function (page, pageSize, options) {
        var _this = this;
        return (0, exports.ImportsApiFp)(this.configuration).importsGet(page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a list column mappings for an import
     * @param {string} importId The id of an import
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportsApi
     */
    ImportsApi.prototype.importsImportIdColumnMappingsGet = function (importId, options) {
        var _this = this;
        return (0, exports.ImportsApiFp)(this.configuration).importsImportIdColumnMappingsGet(importId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about an import column mapping
     * @param {string} importId The id of an import
     * @param {string} importColumnMappingId The id of an import column mapping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportsApi
     */
    ImportsApi.prototype.importsImportIdColumnMappingsImportColumnMappingIdGet = function (importId, importColumnMappingId, options) {
        var _this = this;
        return (0, exports.ImportsApiFp)(this.configuration).importsImportIdColumnMappingsImportColumnMappingIdGet(importId, importColumnMappingId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update an import column mapping
     * @param {string} importId The id of an import
     * @param {string} importColumnMappingId The id of an import column mapping
     * @param {ImportColumnMapping} importColumnMapping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportsApi
     */
    ImportsApi.prototype.importsImportIdColumnMappingsImportColumnMappingIdPut = function (importId, importColumnMappingId, importColumnMapping, options) {
        var _this = this;
        return (0, exports.ImportsApiFp)(this.configuration).importsImportIdColumnMappingsImportColumnMappingIdPut(importId, importColumnMappingId, importColumnMapping, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about an import
     * @param {string} importId The id of an import
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportsApi
     */
    ImportsApi.prototype.importsImportIdGet = function (importId, options) {
        var _this = this;
        return (0, exports.ImportsApiFp)(this.configuration).importsImportIdGet(importId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a list jobs for an import
     * @param {string} importId The id of an import
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportsApi
     */
    ImportsApi.prototype.importsImportIdJobsGet = function (importId, options) {
        var _this = this;
        return (0, exports.ImportsApiFp)(this.configuration).importsImportIdJobsGet(importId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a job for an import
     * @param {string} importId The id of an import
     * @param {string} importJobId The id of an import job
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportsApi
     */
    ImportsApi.prototype.importsImportIdJobsImportJobIdGet = function (importId, importJobId, options) {
        var _this = this;
        return (0, exports.ImportsApiFp)(this.configuration).importsImportIdJobsImportJobIdGet(importId, importJobId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Validates then saves an import. This commits all data.
     * @param {string} importId The id of an import
     * @param {boolean} validateOnly Whether imports should only validate the data or commit it to the database
     * @param {string} [fuelSurchargeTableId] The ID of the fuel surcharge table instance the rates should be imported into. Only required if using the \&quot;Fuel Surcharge Table Rates\&quot; importer
     * @param {string} [rfpBidId] The ID of the RFPBid instance to which the imported RFPRows belong to
     * @param {string} [rfpBidOptId] The ID of the RFPBidOpt instance to which the imported RFPRows belong to
     * @param {string} [rfpCarrierBidRequestId] The ID of the Carrier bid request instance
     * @param {string} [rateTableId] The ID of the rate table instance the data should be imported into. Only required if using the \&quot;Discount Percentages\&quot; or \&quot;Rate Minimums\&quot; importer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportsApi
     */
    ImportsApi.prototype.importsImportIdJobsPost = function (importId, validateOnly, fuelSurchargeTableId, rfpBidId, rfpBidOptId, rfpCarrierBidRequestId, rateTableId, options) {
        var _this = this;
        return (0, exports.ImportsApiFp)(this.configuration).importsImportIdJobsPost(importId, validateOnly, fuelSurchargeTableId, rfpBidId, rfpBidOptId, rfpCarrierBidRequestId, rateTableId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update an import
     * @param {string} importId The id of an import
     * @param {DataImport} dataImport
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportsApi
     */
    ImportsApi.prototype.importsImportIdPut = function (importId, dataImport, options) {
        var _this = this;
        return (0, exports.ImportsApiFp)(this.configuration).importsImportIdPut(importId, dataImport, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a list rows for an import
     * @param {string} importId The id of an import
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportsApi
     */
    ImportsApi.prototype.importsImportIdRowsGet = function (importId, page, pageSize, options) {
        var _this = this;
        return (0, exports.ImportsApiFp)(this.configuration).importsImportIdRowsGet(importId, page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about an import row
     * @param {string} importId The id of an import
     * @param {string} importRowId The id of an import row
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportsApi
     */
    ImportsApi.prototype.importsImportIdRowsImportRowIdGet = function (importId, importRowId, options) {
        var _this = this;
        return (0, exports.ImportsApiFp)(this.configuration).importsImportIdRowsImportRowIdGet(importId, importRowId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update an import row
     * @param {string} importId The id of an import
     * @param {string} importRowId The id of an import row
     * @param {ImportRow} importRow
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportsApi
     */
    ImportsApi.prototype.importsImportIdRowsImportRowIdPut = function (importId, importRowId, importRow, options) {
        var _this = this;
        return (0, exports.ImportsApiFp)(this.configuration).importsImportIdRowsImportRowIdPut(importId, importRowId, importRow, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update an import value
     * @param {string} importId The id of an import
     * @param {string} importValueId The id of an import value
     * @param {ImportValue} importValue
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportsApi
     */
    ImportsApi.prototype.importsImportIdValuesImportValueIdPut = function (importId, importValueId, importValue, options) {
        var _this = this;
        return (0, exports.ImportsApiFp)(this.configuration).importsImportIdValuesImportValueIdPut(importId, importValueId, importValue, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary A list of all fields allowed to be imported for a given importable-type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportsApi
     */
    ImportsApi.prototype.importsImportableFieldsGet = function (options) {
        var _this = this;
        return (0, exports.ImportsApiFp)(this.configuration).importsImportableFieldsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary A list of all object types allowed to be imported. Key is the key which is used elsewhere, value is the human readable string
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportsApi
     */
    ImportsApi.prototype.importsImportableTypesGet = function (options) {
        var _this = this;
        return (0, exports.ImportsApiFp)(this.configuration).importsImportableTypesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a new import
     * @param {string} type
     * @param {any} [csvFile]
     * @param {string} [googleSheetId]
     * @param {string} [googleSheetTab]
     * @param {boolean} [isComplete]
     * @param {string} [name]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportsApi
     */
    ImportsApi.prototype.importsPost = function (type, csvFile, googleSheetId, googleSheetTab, isComplete, name, options) {
        var _this = this;
        return (0, exports.ImportsApiFp)(this.configuration).importsPost(type, csvFile, googleSheetId, googleSheetTab, isComplete, name, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ImportsApi;
}(base_1.BaseAPI));
exports.ImportsApi = ImportsApi;
/**
 * InboxApi - axios parameter creator
 * @export
 */
var InboxApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Delete all inbox messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboxDeleteAllDelete: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/inbox/delete_all/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of a user\'s inbox messages
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {boolean} [read] filter on whether or not an object has been read
         * @param {string} [since] filter on objects since a datetime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboxGet: function (page, pageSize, ordering, read, since, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/inbox/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (read !== undefined) {
                                localVarQueryParameter['read'] = read;
                            }
                            if (since !== undefined) {
                                localVarQueryParameter['since'] = (since instanceof Date) ?
                                    since.toISOString() :
                                    since;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Mark all inbox messages as read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboxMarkAllAsReadGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/inbox/mark_all_as_read/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Mark all inbox messages as unread
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboxMarkAllAsUnreadGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/inbox/mark_all_as_unread/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a message
         * @param {string} messageId The id of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboxMessageIdDelete: function (messageId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'messageId' is not null or undefined
                            (0, common_1.assertParamExists)('inboxMessageIdDelete', 'messageId', messageId);
                            localVarPath = "/inbox/{messageId}/"
                                .replace("{".concat("messageId", "}"), encodeURIComponent(String(messageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a specific message
         * @param {string} messageId The id of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboxMessageIdGet: function (messageId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'messageId' is not null or undefined
                            (0, common_1.assertParamExists)('inboxMessageIdGet', 'messageId', messageId);
                            localVarPath = "/inbox/{messageId}/"
                                .replace("{".concat("messageId", "}"), encodeURIComponent(String(messageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a specific message
         * @param {string} messageId The id of the message
         * @param {InboxMessage} inboxMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboxMessageIdPut: function (messageId, inboxMessage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'messageId' is not null or undefined
                            (0, common_1.assertParamExists)('inboxMessageIdPut', 'messageId', messageId);
                            // verify required parameter 'inboxMessage' is not null or undefined
                            (0, common_1.assertParamExists)('inboxMessageIdPut', 'inboxMessage', inboxMessage);
                            localVarPath = "/inbox/{messageId}/"
                                .replace("{".concat("messageId", "}"), encodeURIComponent(String(messageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inboxMessage, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.InboxApiAxiosParamCreator = InboxApiAxiosParamCreator;
/**
 * InboxApi - functional programming interface
 * @export
 */
var InboxApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.InboxApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Delete all inbox messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboxDeleteAllDelete: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.inboxDeleteAllDelete(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of a user\'s inbox messages
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {boolean} [read] filter on whether or not an object has been read
         * @param {string} [since] filter on objects since a datetime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboxGet: function (page, pageSize, ordering, read, since, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.inboxGet(page, pageSize, ordering, read, since, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Mark all inbox messages as read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboxMarkAllAsReadGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.inboxMarkAllAsReadGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Mark all inbox messages as unread
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboxMarkAllAsUnreadGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.inboxMarkAllAsUnreadGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a message
         * @param {string} messageId The id of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboxMessageIdDelete: function (messageId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.inboxMessageIdDelete(messageId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a specific message
         * @param {string} messageId The id of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboxMessageIdGet: function (messageId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.inboxMessageIdGet(messageId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a specific message
         * @param {string} messageId The id of the message
         * @param {InboxMessage} inboxMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboxMessageIdPut: function (messageId, inboxMessage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.inboxMessageIdPut(messageId, inboxMessage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.InboxApiFp = InboxApiFp;
/**
 * InboxApi - factory interface
 * @export
 */
var InboxApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.InboxApiFp)(configuration);
    return {
        /**
         *
         * @summary Delete all inbox messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboxDeleteAllDelete: function (options) {
            return localVarFp.inboxDeleteAllDelete(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a list of a user\'s inbox messages
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {boolean} [read] filter on whether or not an object has been read
         * @param {string} [since] filter on objects since a datetime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboxGet: function (page, pageSize, ordering, read, since, options) {
            return localVarFp.inboxGet(page, pageSize, ordering, read, since, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Mark all inbox messages as read
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboxMarkAllAsReadGet: function (options) {
            return localVarFp.inboxMarkAllAsReadGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Mark all inbox messages as unread
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboxMarkAllAsUnreadGet: function (options) {
            return localVarFp.inboxMarkAllAsUnreadGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a message
         * @param {string} messageId The id of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboxMessageIdDelete: function (messageId, options) {
            return localVarFp.inboxMessageIdDelete(messageId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a specific message
         * @param {string} messageId The id of the message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboxMessageIdGet: function (messageId, options) {
            return localVarFp.inboxMessageIdGet(messageId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a specific message
         * @param {string} messageId The id of the message
         * @param {InboxMessage} inboxMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inboxMessageIdPut: function (messageId, inboxMessage, options) {
            return localVarFp.inboxMessageIdPut(messageId, inboxMessage, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.InboxApiFactory = InboxApiFactory;
/**
 * InboxApi - object-oriented interface
 * @export
 * @class InboxApi
 * @extends {BaseAPI}
 */
var InboxApi = /** @class */ (function (_super) {
    __extends(InboxApi, _super);
    function InboxApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Delete all inbox messages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboxApi
     */
    InboxApi.prototype.inboxDeleteAllDelete = function (options) {
        var _this = this;
        return (0, exports.InboxApiFp)(this.configuration).inboxDeleteAllDelete(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a list of a user\'s inbox messages
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {boolean} [read] filter on whether or not an object has been read
     * @param {string} [since] filter on objects since a datetime
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboxApi
     */
    InboxApi.prototype.inboxGet = function (page, pageSize, ordering, read, since, options) {
        var _this = this;
        return (0, exports.InboxApiFp)(this.configuration).inboxGet(page, pageSize, ordering, read, since, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Mark all inbox messages as read
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboxApi
     */
    InboxApi.prototype.inboxMarkAllAsReadGet = function (options) {
        var _this = this;
        return (0, exports.InboxApiFp)(this.configuration).inboxMarkAllAsReadGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Mark all inbox messages as unread
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboxApi
     */
    InboxApi.prototype.inboxMarkAllAsUnreadGet = function (options) {
        var _this = this;
        return (0, exports.InboxApiFp)(this.configuration).inboxMarkAllAsUnreadGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a message
     * @param {string} messageId The id of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboxApi
     */
    InboxApi.prototype.inboxMessageIdDelete = function (messageId, options) {
        var _this = this;
        return (0, exports.InboxApiFp)(this.configuration).inboxMessageIdDelete(messageId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a specific message
     * @param {string} messageId The id of the message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboxApi
     */
    InboxApi.prototype.inboxMessageIdGet = function (messageId, options) {
        var _this = this;
        return (0, exports.InboxApiFp)(this.configuration).inboxMessageIdGet(messageId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a specific message
     * @param {string} messageId The id of the message
     * @param {InboxMessage} inboxMessage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InboxApi
     */
    InboxApi.prototype.inboxMessageIdPut = function (messageId, inboxMessage, options) {
        var _this = this;
        return (0, exports.InboxApiFp)(this.configuration).inboxMessageIdPut(messageId, inboxMessage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return InboxApi;
}(base_1.BaseAPI));
exports.InboxApi = InboxApi;
/**
 * IntegrationsApi - axios parameter creator
 * @export
 */
var IntegrationsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Check if a user\'s company has a CH Robinson integration enabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsChrobinsonAuthCheckGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/integrations/chrobinson/auth/check/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a registered CHRobinson account
         * @param {string} chrobinsonAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsChrobinsonAuthRegistrationChrobinsonAccountIdDelete: function (chrobinsonAccountId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'chrobinsonAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('integrationsChrobinsonAuthRegistrationChrobinsonAccountIdDelete', 'chrobinsonAccountId', chrobinsonAccountId);
                            localVarPath = "/integrations/chrobinson/auth/registration/{chrobinsonAccountId}/"
                                .replace("{".concat("chrobinsonAccountId", "}"), encodeURIComponent(String(chrobinsonAccountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates registered company\'s CHRobinson account with Shipwell
         * @param {string} chrobinsonAccountId
         * @param {CHRobinsonAccountRequest} cHRobinsonAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsChrobinsonAuthRegistrationChrobinsonAccountIdPut: function (chrobinsonAccountId, cHRobinsonAccountRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'chrobinsonAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('integrationsChrobinsonAuthRegistrationChrobinsonAccountIdPut', 'chrobinsonAccountId', chrobinsonAccountId);
                            // verify required parameter 'cHRobinsonAccountRequest' is not null or undefined
                            (0, common_1.assertParamExists)('integrationsChrobinsonAuthRegistrationChrobinsonAccountIdPut', 'cHRobinsonAccountRequest', cHRobinsonAccountRequest);
                            localVarPath = "/integrations/chrobinson/auth/registration/{chrobinsonAccountId}/"
                                .replace("{".concat("chrobinsonAccountId", "}"), encodeURIComponent(String(chrobinsonAccountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(cHRobinsonAccountRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain CHRobinson account information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsChrobinsonAuthRegistrationGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/integrations/chrobinson/auth/registration/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Company has to have an account with CHRobinson before registering with Shipwell.
         * @summary Register company\'s CHRobinson account with Shipwell
         * @param {CHRobinsonAccountRequest} cHRobinsonAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsChrobinsonAuthRegistrationPost: function (cHRobinsonAccountRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'cHRobinsonAccountRequest' is not null or undefined
                            (0, common_1.assertParamExists)('integrationsChrobinsonAuthRegistrationPost', 'cHRobinsonAccountRequest', cHRobinsonAccountRequest);
                            localVarPath = "/integrations/chrobinson/auth/registration/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(cHRobinsonAccountRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a company\'s Netsuite category mappings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigCategoryMappingsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/integrations/netsuite/config/category-mappings/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a company\'s Netsuite category mappings.
         * @param {NetsuiteConfigCategoryMappings} netsuiteConfigCategoryMappings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigCategoryMappingsPut: function (netsuiteConfigCategoryMappings, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'netsuiteConfigCategoryMappings' is not null or undefined
                            (0, common_1.assertParamExists)('integrationsNetsuiteConfigCategoryMappingsPut', 'netsuiteConfigCategoryMappings', netsuiteConfigCategoryMappings);
                            localVarPath = "/integrations/netsuite/config/category-mappings/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(netsuiteConfigCategoryMappings, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Removes the Netsuite integration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigDelete: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/integrations/netsuite/config/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a company\'s Netsuite field mappings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigFieldMappingsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/integrations/netsuite/config/field-mappings/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a company\'s Netsuite field mappings.
         * @param {NetsuiteConfigFieldMappings} netsuiteConfigFieldMappings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigFieldMappingsPut: function (netsuiteConfigFieldMappings, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'netsuiteConfigFieldMappings' is not null or undefined
                            (0, common_1.assertParamExists)('integrationsNetsuiteConfigFieldMappingsPut', 'netsuiteConfigFieldMappings', netsuiteConfigFieldMappings);
                            localVarPath = "/integrations/netsuite/config/field-mappings/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(netsuiteConfigFieldMappings, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a company\'s Netsuite Configuration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/integrations/netsuite/config/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary All of the category options for mapping Shipwell items, obtained from the configured Netsuite account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigOptionsCategoriesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/integrations/netsuite/config/options/categories/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Company mapping options for various field defaults needed to be set for the Netsuite integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigOptionsCompanyGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/integrations/netsuite/config/options/company/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary All of the custom field options for mapping various fields from Shipwell to Netsuite, obtained from an authenticated Netsuite account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigOptionsCustomFieldsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/integrations/netsuite/config/options/custom-fields/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a company\'s Netsuite Configuration.
         * @param {NetsuiteConfig} netsuiteConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigPost: function (netsuiteConfig, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'netsuiteConfig' is not null or undefined
                            (0, common_1.assertParamExists)('integrationsNetsuiteConfigPost', 'netsuiteConfig', netsuiteConfig);
                            localVarPath = "/integrations/netsuite/config/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(netsuiteConfig, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a company\'s Netsuite Configuration.
         * @param {NetsuiteConfig} netsuiteConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigPut: function (netsuiteConfig, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'netsuiteConfig' is not null or undefined
                            (0, common_1.assertParamExists)('integrationsNetsuiteConfigPut', 'netsuiteConfig', netsuiteConfig);
                            localVarPath = "/integrations/netsuite/config/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(netsuiteConfig, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Sends request to NetSuite API to retrieve list of currently active custom fields.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappCustomFieldsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/integrations/netsuite/config/suiteapp/custom-fields/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Removes the Netsuite SuiteApp integration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappDelete: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/integrations/netsuite/config/suiteapp/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a company\'s Netsuite SuiteApp Configuration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/integrations/netsuite/config/suiteapp/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves encoded JSON Web Token for use when requesting bearer token from NetSuite API.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappJwtGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/integrations/netsuite/config/suiteapp/jwt/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets current order field mapping for NetSuite.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappOrderFieldMappingGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/integrations/netsuite/config/suiteapp/order-field-mapping/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates the order field mapping for NetSuite.
         * @param {NetsuiteSuiteAppOrderFieldMapping} netsuiteSuiteAppOrderFieldMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappOrderFieldMappingPut: function (netsuiteSuiteAppOrderFieldMapping, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'netsuiteSuiteAppOrderFieldMapping' is not null or undefined
                            (0, common_1.assertParamExists)('integrationsNetsuiteConfigSuiteappOrderFieldMappingPut', 'netsuiteSuiteAppOrderFieldMapping', netsuiteSuiteAppOrderFieldMapping);
                            localVarPath = "/integrations/netsuite/config/suiteapp/order-field-mapping/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(netsuiteSuiteAppOrderFieldMapping, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a company\'s Netsuite SuiteApp Configuration.
         * @param {NetsuiteSuiteAppConfig} netsuiteSuiteAppConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappPost: function (netsuiteSuiteAppConfig, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'netsuiteSuiteAppConfig' is not null or undefined
                            (0, common_1.assertParamExists)('integrationsNetsuiteConfigSuiteappPost', 'netsuiteSuiteAppConfig', netsuiteSuiteAppConfig);
                            localVarPath = "/integrations/netsuite/config/suiteapp/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(netsuiteSuiteAppConfig, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a company\'s Netsuite SuiteApp Configuration.
         * @param {NetsuiteSuiteAppConfig} netsuiteSuiteAppConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappPut: function (netsuiteSuiteAppConfig, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'netsuiteSuiteAppConfig' is not null or undefined
                            (0, common_1.assertParamExists)('integrationsNetsuiteConfigSuiteappPut', 'netsuiteSuiteAppConfig', netsuiteSuiteAppConfig);
                            localVarPath = "/integrations/netsuite/config/suiteapp/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(netsuiteSuiteAppConfig, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Refresh Netsuite SuiteApp Configuration for company. This generates new keys, certificate and erases existing certificate_id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappRefreshPut: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/integrations/netsuite/config/suiteapp/refresh/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Sends request to NetSuite API for new bearer token utilizing client SuiteApp config. Can be used to validate credentials.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappTokenGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/integrations/netsuite/config/suiteapp/token/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves an order by ID
         * @param {string} accountId NS Account id
         * @param {string} orderId ID of the order to manage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteSuiteappAccountIdOrdersOrderIdGet: function (accountId, orderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'accountId' is not null or undefined
                            (0, common_1.assertParamExists)('integrationsNetsuiteSuiteappAccountIdOrdersOrderIdGet', 'accountId', accountId);
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('integrationsNetsuiteSuiteappAccountIdOrdersOrderIdGet', 'orderId', orderId);
                            localVarPath = "/integrations/netsuite/suiteapp/{account_id}/orders/{order_id}/"
                                .replace("{".concat("account_id", "}"), encodeURIComponent(String(accountId)))
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates an existing order by ID
         * @param {string} accountId NS Account id
         * @param {string} orderId ID of the order to manage
         * @param {NetsuiteSuiteAppOrder} netsuiteSuiteAppOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteSuiteappAccountIdOrdersOrderIdPut: function (accountId, orderId, netsuiteSuiteAppOrder, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'accountId' is not null or undefined
                            (0, common_1.assertParamExists)('integrationsNetsuiteSuiteappAccountIdOrdersOrderIdPut', 'accountId', accountId);
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('integrationsNetsuiteSuiteappAccountIdOrdersOrderIdPut', 'orderId', orderId);
                            // verify required parameter 'netsuiteSuiteAppOrder' is not null or undefined
                            (0, common_1.assertParamExists)('integrationsNetsuiteSuiteappAccountIdOrdersOrderIdPut', 'netsuiteSuiteAppOrder', netsuiteSuiteAppOrder);
                            localVarPath = "/integrations/netsuite/suiteapp/{account_id}/orders/{order_id}/"
                                .replace("{".concat("account_id", "}"), encodeURIComponent(String(accountId)))
                                .replace("{".concat("order_id", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(netsuiteSuiteAppOrder, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new order
         * @param {string} accountId NS Account id
         * @param {NetsuiteSuiteAppOrder} netsuiteSuiteAppOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteSuiteappAccountIdOrdersPost: function (accountId, netsuiteSuiteAppOrder, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'accountId' is not null or undefined
                            (0, common_1.assertParamExists)('integrationsNetsuiteSuiteappAccountIdOrdersPost', 'accountId', accountId);
                            // verify required parameter 'netsuiteSuiteAppOrder' is not null or undefined
                            (0, common_1.assertParamExists)('integrationsNetsuiteSuiteappAccountIdOrdersPost', 'netsuiteSuiteAppOrder', netsuiteSuiteAppOrder);
                            localVarPath = "/integrations/netsuite/suiteapp/{account_id}/orders/"
                                .replace("{".concat("account_id", "}"), encodeURIComponent(String(accountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(netsuiteSuiteAppOrder, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.IntegrationsApiAxiosParamCreator = IntegrationsApiAxiosParamCreator;
/**
 * IntegrationsApi - functional programming interface
 * @export
 */
var IntegrationsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.IntegrationsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Check if a user\'s company has a CH Robinson integration enabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsChrobinsonAuthCheckGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsChrobinsonAuthCheckGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a registered CHRobinson account
         * @param {string} chrobinsonAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsChrobinsonAuthRegistrationChrobinsonAccountIdDelete: function (chrobinsonAccountId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsChrobinsonAuthRegistrationChrobinsonAccountIdDelete(chrobinsonAccountId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates registered company\'s CHRobinson account with Shipwell
         * @param {string} chrobinsonAccountId
         * @param {CHRobinsonAccountRequest} cHRobinsonAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsChrobinsonAuthRegistrationChrobinsonAccountIdPut: function (chrobinsonAccountId, cHRobinsonAccountRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsChrobinsonAuthRegistrationChrobinsonAccountIdPut(chrobinsonAccountId, cHRobinsonAccountRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain CHRobinson account information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsChrobinsonAuthRegistrationGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsChrobinsonAuthRegistrationGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Company has to have an account with CHRobinson before registering with Shipwell.
         * @summary Register company\'s CHRobinson account with Shipwell
         * @param {CHRobinsonAccountRequest} cHRobinsonAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsChrobinsonAuthRegistrationPost: function (cHRobinsonAccountRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsChrobinsonAuthRegistrationPost(cHRobinsonAccountRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a company\'s Netsuite category mappings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigCategoryMappingsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsNetsuiteConfigCategoryMappingsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a company\'s Netsuite category mappings.
         * @param {NetsuiteConfigCategoryMappings} netsuiteConfigCategoryMappings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigCategoryMappingsPut: function (netsuiteConfigCategoryMappings, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsNetsuiteConfigCategoryMappingsPut(netsuiteConfigCategoryMappings, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Removes the Netsuite integration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigDelete: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsNetsuiteConfigDelete(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a company\'s Netsuite field mappings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigFieldMappingsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsNetsuiteConfigFieldMappingsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a company\'s Netsuite field mappings.
         * @param {NetsuiteConfigFieldMappings} netsuiteConfigFieldMappings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigFieldMappingsPut: function (netsuiteConfigFieldMappings, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsNetsuiteConfigFieldMappingsPut(netsuiteConfigFieldMappings, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a company\'s Netsuite Configuration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsNetsuiteConfigGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary All of the category options for mapping Shipwell items, obtained from the configured Netsuite account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigOptionsCategoriesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsNetsuiteConfigOptionsCategoriesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Company mapping options for various field defaults needed to be set for the Netsuite integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigOptionsCompanyGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsNetsuiteConfigOptionsCompanyGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary All of the custom field options for mapping various fields from Shipwell to Netsuite, obtained from an authenticated Netsuite account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigOptionsCustomFieldsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsNetsuiteConfigOptionsCustomFieldsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a company\'s Netsuite Configuration.
         * @param {NetsuiteConfig} netsuiteConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigPost: function (netsuiteConfig, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsNetsuiteConfigPost(netsuiteConfig, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a company\'s Netsuite Configuration.
         * @param {NetsuiteConfig} netsuiteConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigPut: function (netsuiteConfig, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsNetsuiteConfigPut(netsuiteConfig, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Sends request to NetSuite API to retrieve list of currently active custom fields.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappCustomFieldsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsNetsuiteConfigSuiteappCustomFieldsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Removes the Netsuite SuiteApp integration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappDelete: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsNetsuiteConfigSuiteappDelete(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a company\'s Netsuite SuiteApp Configuration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsNetsuiteConfigSuiteappGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves encoded JSON Web Token for use when requesting bearer token from NetSuite API.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappJwtGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsNetsuiteConfigSuiteappJwtGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Gets current order field mapping for NetSuite.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappOrderFieldMappingGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsNetsuiteConfigSuiteappOrderFieldMappingGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates the order field mapping for NetSuite.
         * @param {NetsuiteSuiteAppOrderFieldMapping} netsuiteSuiteAppOrderFieldMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappOrderFieldMappingPut: function (netsuiteSuiteAppOrderFieldMapping, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsNetsuiteConfigSuiteappOrderFieldMappingPut(netsuiteSuiteAppOrderFieldMapping, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a company\'s Netsuite SuiteApp Configuration.
         * @param {NetsuiteSuiteAppConfig} netsuiteSuiteAppConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappPost: function (netsuiteSuiteAppConfig, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsNetsuiteConfigSuiteappPost(netsuiteSuiteAppConfig, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates a company\'s Netsuite SuiteApp Configuration.
         * @param {NetsuiteSuiteAppConfig} netsuiteSuiteAppConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappPut: function (netsuiteSuiteAppConfig, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsNetsuiteConfigSuiteappPut(netsuiteSuiteAppConfig, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Refresh Netsuite SuiteApp Configuration for company. This generates new keys, certificate and erases existing certificate_id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappRefreshPut: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsNetsuiteConfigSuiteappRefreshPut(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Sends request to NetSuite API for new bearer token utilizing client SuiteApp config. Can be used to validate credentials.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappTokenGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsNetsuiteConfigSuiteappTokenGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves an order by ID
         * @param {string} accountId NS Account id
         * @param {string} orderId ID of the order to manage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteSuiteappAccountIdOrdersOrderIdGet: function (accountId, orderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsNetsuiteSuiteappAccountIdOrdersOrderIdGet(accountId, orderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates an existing order by ID
         * @param {string} accountId NS Account id
         * @param {string} orderId ID of the order to manage
         * @param {NetsuiteSuiteAppOrder} netsuiteSuiteAppOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteSuiteappAccountIdOrdersOrderIdPut: function (accountId, orderId, netsuiteSuiteAppOrder, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsNetsuiteSuiteappAccountIdOrdersOrderIdPut(accountId, orderId, netsuiteSuiteAppOrder, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new order
         * @param {string} accountId NS Account id
         * @param {NetsuiteSuiteAppOrder} netsuiteSuiteAppOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteSuiteappAccountIdOrdersPost: function (accountId, netsuiteSuiteAppOrder, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsNetsuiteSuiteappAccountIdOrdersPost(accountId, netsuiteSuiteAppOrder, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.IntegrationsApiFp = IntegrationsApiFp;
/**
 * IntegrationsApi - factory interface
 * @export
 */
var IntegrationsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.IntegrationsApiFp)(configuration);
    return {
        /**
         *
         * @summary Check if a user\'s company has a CH Robinson integration enabled
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsChrobinsonAuthCheckGet: function (options) {
            return localVarFp.integrationsChrobinsonAuthCheckGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a registered CHRobinson account
         * @param {string} chrobinsonAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsChrobinsonAuthRegistrationChrobinsonAccountIdDelete: function (chrobinsonAccountId, options) {
            return localVarFp.integrationsChrobinsonAuthRegistrationChrobinsonAccountIdDelete(chrobinsonAccountId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates registered company\'s CHRobinson account with Shipwell
         * @param {string} chrobinsonAccountId
         * @param {CHRobinsonAccountRequest} cHRobinsonAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsChrobinsonAuthRegistrationChrobinsonAccountIdPut: function (chrobinsonAccountId, cHRobinsonAccountRequest, options) {
            return localVarFp.integrationsChrobinsonAuthRegistrationChrobinsonAccountIdPut(chrobinsonAccountId, cHRobinsonAccountRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Obtain CHRobinson account information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsChrobinsonAuthRegistrationGet: function (options) {
            return localVarFp.integrationsChrobinsonAuthRegistrationGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Company has to have an account with CHRobinson before registering with Shipwell.
         * @summary Register company\'s CHRobinson account with Shipwell
         * @param {CHRobinsonAccountRequest} cHRobinsonAccountRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsChrobinsonAuthRegistrationPost: function (cHRobinsonAccountRequest, options) {
            return localVarFp.integrationsChrobinsonAuthRegistrationPost(cHRobinsonAccountRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a company\'s Netsuite category mappings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigCategoryMappingsGet: function (options) {
            return localVarFp.integrationsNetsuiteConfigCategoryMappingsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates a company\'s Netsuite category mappings.
         * @param {NetsuiteConfigCategoryMappings} netsuiteConfigCategoryMappings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigCategoryMappingsPut: function (netsuiteConfigCategoryMappings, options) {
            return localVarFp.integrationsNetsuiteConfigCategoryMappingsPut(netsuiteConfigCategoryMappings, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Removes the Netsuite integration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigDelete: function (options) {
            return localVarFp.integrationsNetsuiteConfigDelete(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a company\'s Netsuite field mappings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigFieldMappingsGet: function (options) {
            return localVarFp.integrationsNetsuiteConfigFieldMappingsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates a company\'s Netsuite field mappings.
         * @param {NetsuiteConfigFieldMappings} netsuiteConfigFieldMappings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigFieldMappingsPut: function (netsuiteConfigFieldMappings, options) {
            return localVarFp.integrationsNetsuiteConfigFieldMappingsPut(netsuiteConfigFieldMappings, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a company\'s Netsuite Configuration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigGet: function (options) {
            return localVarFp.integrationsNetsuiteConfigGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary All of the category options for mapping Shipwell items, obtained from the configured Netsuite account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigOptionsCategoriesGet: function (options) {
            return localVarFp.integrationsNetsuiteConfigOptionsCategoriesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Company mapping options for various field defaults needed to be set for the Netsuite integration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigOptionsCompanyGet: function (options) {
            return localVarFp.integrationsNetsuiteConfigOptionsCompanyGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary All of the custom field options for mapping various fields from Shipwell to Netsuite, obtained from an authenticated Netsuite account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigOptionsCustomFieldsGet: function (options) {
            return localVarFp.integrationsNetsuiteConfigOptionsCustomFieldsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a company\'s Netsuite Configuration.
         * @param {NetsuiteConfig} netsuiteConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigPost: function (netsuiteConfig, options) {
            return localVarFp.integrationsNetsuiteConfigPost(netsuiteConfig, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates a company\'s Netsuite Configuration.
         * @param {NetsuiteConfig} netsuiteConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigPut: function (netsuiteConfig, options) {
            return localVarFp.integrationsNetsuiteConfigPut(netsuiteConfig, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Sends request to NetSuite API to retrieve list of currently active custom fields.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappCustomFieldsGet: function (options) {
            return localVarFp.integrationsNetsuiteConfigSuiteappCustomFieldsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Removes the Netsuite SuiteApp integration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappDelete: function (options) {
            return localVarFp.integrationsNetsuiteConfigSuiteappDelete(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a company\'s Netsuite SuiteApp Configuration.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappGet: function (options) {
            return localVarFp.integrationsNetsuiteConfigSuiteappGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves encoded JSON Web Token for use when requesting bearer token from NetSuite API.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappJwtGet: function (options) {
            return localVarFp.integrationsNetsuiteConfigSuiteappJwtGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Gets current order field mapping for NetSuite.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappOrderFieldMappingGet: function (options) {
            return localVarFp.integrationsNetsuiteConfigSuiteappOrderFieldMappingGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates the order field mapping for NetSuite.
         * @param {NetsuiteSuiteAppOrderFieldMapping} netsuiteSuiteAppOrderFieldMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappOrderFieldMappingPut: function (netsuiteSuiteAppOrderFieldMapping, options) {
            return localVarFp.integrationsNetsuiteConfigSuiteappOrderFieldMappingPut(netsuiteSuiteAppOrderFieldMapping, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a company\'s Netsuite SuiteApp Configuration.
         * @param {NetsuiteSuiteAppConfig} netsuiteSuiteAppConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappPost: function (netsuiteSuiteAppConfig, options) {
            return localVarFp.integrationsNetsuiteConfigSuiteappPost(netsuiteSuiteAppConfig, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates a company\'s Netsuite SuiteApp Configuration.
         * @param {NetsuiteSuiteAppConfig} netsuiteSuiteAppConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappPut: function (netsuiteSuiteAppConfig, options) {
            return localVarFp.integrationsNetsuiteConfigSuiteappPut(netsuiteSuiteAppConfig, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Refresh Netsuite SuiteApp Configuration for company. This generates new keys, certificate and erases existing certificate_id.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappRefreshPut: function (options) {
            return localVarFp.integrationsNetsuiteConfigSuiteappRefreshPut(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Sends request to NetSuite API for new bearer token utilizing client SuiteApp config. Can be used to validate credentials.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteConfigSuiteappTokenGet: function (options) {
            return localVarFp.integrationsNetsuiteConfigSuiteappTokenGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves an order by ID
         * @param {string} accountId NS Account id
         * @param {string} orderId ID of the order to manage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteSuiteappAccountIdOrdersOrderIdGet: function (accountId, orderId, options) {
            return localVarFp.integrationsNetsuiteSuiteappAccountIdOrdersOrderIdGet(accountId, orderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates an existing order by ID
         * @param {string} accountId NS Account id
         * @param {string} orderId ID of the order to manage
         * @param {NetsuiteSuiteAppOrder} netsuiteSuiteAppOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteSuiteappAccountIdOrdersOrderIdPut: function (accountId, orderId, netsuiteSuiteAppOrder, options) {
            return localVarFp.integrationsNetsuiteSuiteappAccountIdOrdersOrderIdPut(accountId, orderId, netsuiteSuiteAppOrder, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a new order
         * @param {string} accountId NS Account id
         * @param {NetsuiteSuiteAppOrder} netsuiteSuiteAppOrder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsNetsuiteSuiteappAccountIdOrdersPost: function (accountId, netsuiteSuiteAppOrder, options) {
            return localVarFp.integrationsNetsuiteSuiteappAccountIdOrdersPost(accountId, netsuiteSuiteAppOrder, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.IntegrationsApiFactory = IntegrationsApiFactory;
/**
 * IntegrationsApi - object-oriented interface
 * @export
 * @class IntegrationsApi
 * @extends {BaseAPI}
 */
var IntegrationsApi = /** @class */ (function (_super) {
    __extends(IntegrationsApi, _super);
    function IntegrationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Check if a user\'s company has a CH Robinson integration enabled
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsChrobinsonAuthCheckGet = function (options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsChrobinsonAuthCheckGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a registered CHRobinson account
     * @param {string} chrobinsonAccountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsChrobinsonAuthRegistrationChrobinsonAccountIdDelete = function (chrobinsonAccountId, options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsChrobinsonAuthRegistrationChrobinsonAccountIdDelete(chrobinsonAccountId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates registered company\'s CHRobinson account with Shipwell
     * @param {string} chrobinsonAccountId
     * @param {CHRobinsonAccountRequest} cHRobinsonAccountRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsChrobinsonAuthRegistrationChrobinsonAccountIdPut = function (chrobinsonAccountId, cHRobinsonAccountRequest, options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsChrobinsonAuthRegistrationChrobinsonAccountIdPut(chrobinsonAccountId, cHRobinsonAccountRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Obtain CHRobinson account information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsChrobinsonAuthRegistrationGet = function (options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsChrobinsonAuthRegistrationGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Company has to have an account with CHRobinson before registering with Shipwell.
     * @summary Register company\'s CHRobinson account with Shipwell
     * @param {CHRobinsonAccountRequest} cHRobinsonAccountRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsChrobinsonAuthRegistrationPost = function (cHRobinsonAccountRequest, options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsChrobinsonAuthRegistrationPost(cHRobinsonAccountRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a company\'s Netsuite category mappings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsNetsuiteConfigCategoryMappingsGet = function (options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsNetsuiteConfigCategoryMappingsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates a company\'s Netsuite category mappings.
     * @param {NetsuiteConfigCategoryMappings} netsuiteConfigCategoryMappings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsNetsuiteConfigCategoryMappingsPut = function (netsuiteConfigCategoryMappings, options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsNetsuiteConfigCategoryMappingsPut(netsuiteConfigCategoryMappings, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Removes the Netsuite integration.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsNetsuiteConfigDelete = function (options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsNetsuiteConfigDelete(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a company\'s Netsuite field mappings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsNetsuiteConfigFieldMappingsGet = function (options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsNetsuiteConfigFieldMappingsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates a company\'s Netsuite field mappings.
     * @param {NetsuiteConfigFieldMappings} netsuiteConfigFieldMappings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsNetsuiteConfigFieldMappingsPut = function (netsuiteConfigFieldMappings, options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsNetsuiteConfigFieldMappingsPut(netsuiteConfigFieldMappings, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a company\'s Netsuite Configuration.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsNetsuiteConfigGet = function (options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsNetsuiteConfigGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary All of the category options for mapping Shipwell items, obtained from the configured Netsuite account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsNetsuiteConfigOptionsCategoriesGet = function (options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsNetsuiteConfigOptionsCategoriesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Company mapping options for various field defaults needed to be set for the Netsuite integration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsNetsuiteConfigOptionsCompanyGet = function (options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsNetsuiteConfigOptionsCompanyGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary All of the custom field options for mapping various fields from Shipwell to Netsuite, obtained from an authenticated Netsuite account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsNetsuiteConfigOptionsCustomFieldsGet = function (options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsNetsuiteConfigOptionsCustomFieldsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a company\'s Netsuite Configuration.
     * @param {NetsuiteConfig} netsuiteConfig
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsNetsuiteConfigPost = function (netsuiteConfig, options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsNetsuiteConfigPost(netsuiteConfig, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates a company\'s Netsuite Configuration.
     * @param {NetsuiteConfig} netsuiteConfig
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsNetsuiteConfigPut = function (netsuiteConfig, options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsNetsuiteConfigPut(netsuiteConfig, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Sends request to NetSuite API to retrieve list of currently active custom fields.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsNetsuiteConfigSuiteappCustomFieldsGet = function (options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsNetsuiteConfigSuiteappCustomFieldsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Removes the Netsuite SuiteApp integration.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsNetsuiteConfigSuiteappDelete = function (options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsNetsuiteConfigSuiteappDelete(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a company\'s Netsuite SuiteApp Configuration.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsNetsuiteConfigSuiteappGet = function (options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsNetsuiteConfigSuiteappGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves encoded JSON Web Token for use when requesting bearer token from NetSuite API.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsNetsuiteConfigSuiteappJwtGet = function (options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsNetsuiteConfigSuiteappJwtGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Gets current order field mapping for NetSuite.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsNetsuiteConfigSuiteappOrderFieldMappingGet = function (options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsNetsuiteConfigSuiteappOrderFieldMappingGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates the order field mapping for NetSuite.
     * @param {NetsuiteSuiteAppOrderFieldMapping} netsuiteSuiteAppOrderFieldMapping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsNetsuiteConfigSuiteappOrderFieldMappingPut = function (netsuiteSuiteAppOrderFieldMapping, options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsNetsuiteConfigSuiteappOrderFieldMappingPut(netsuiteSuiteAppOrderFieldMapping, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a company\'s Netsuite SuiteApp Configuration.
     * @param {NetsuiteSuiteAppConfig} netsuiteSuiteAppConfig
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsNetsuiteConfigSuiteappPost = function (netsuiteSuiteAppConfig, options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsNetsuiteConfigSuiteappPost(netsuiteSuiteAppConfig, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates a company\'s Netsuite SuiteApp Configuration.
     * @param {NetsuiteSuiteAppConfig} netsuiteSuiteAppConfig
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsNetsuiteConfigSuiteappPut = function (netsuiteSuiteAppConfig, options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsNetsuiteConfigSuiteappPut(netsuiteSuiteAppConfig, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Refresh Netsuite SuiteApp Configuration for company. This generates new keys, certificate and erases existing certificate_id.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsNetsuiteConfigSuiteappRefreshPut = function (options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsNetsuiteConfigSuiteappRefreshPut(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Sends request to NetSuite API for new bearer token utilizing client SuiteApp config. Can be used to validate credentials.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsNetsuiteConfigSuiteappTokenGet = function (options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsNetsuiteConfigSuiteappTokenGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves an order by ID
     * @param {string} accountId NS Account id
     * @param {string} orderId ID of the order to manage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsNetsuiteSuiteappAccountIdOrdersOrderIdGet = function (accountId, orderId, options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsNetsuiteSuiteappAccountIdOrdersOrderIdGet(accountId, orderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates an existing order by ID
     * @param {string} accountId NS Account id
     * @param {string} orderId ID of the order to manage
     * @param {NetsuiteSuiteAppOrder} netsuiteSuiteAppOrder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsNetsuiteSuiteappAccountIdOrdersOrderIdPut = function (accountId, orderId, netsuiteSuiteAppOrder, options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsNetsuiteSuiteappAccountIdOrdersOrderIdPut(accountId, orderId, netsuiteSuiteAppOrder, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a new order
     * @param {string} accountId NS Account id
     * @param {NetsuiteSuiteAppOrder} netsuiteSuiteAppOrder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationsApi
     */
    IntegrationsApi.prototype.integrationsNetsuiteSuiteappAccountIdOrdersPost = function (accountId, netsuiteSuiteAppOrder, options) {
        var _this = this;
        return (0, exports.IntegrationsApiFp)(this.configuration).integrationsNetsuiteSuiteappAccountIdOrdersPost(accountId, netsuiteSuiteAppOrder, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return IntegrationsApi;
}(base_1.BaseAPI));
exports.IntegrationsApi = IntegrationsApi;
/**
 * InvoicingApi - axios parameter creator
 * @export
 */
var InvoicingApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Returns all Financial Management Systems that are configured
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsFmsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/integrations/fms/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns Quickbooks Authorization details for a given company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksAuthAuthorizationDetailsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/invoicing/integrations/quickbooks/auth/authorization-details/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Checks if a user has authenticated with quickbooks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksAuthCheckGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/invoicing/integrations/quickbooks/auth/check/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Initiates quickbooks authentication for logged in user with Shipwell API
         * @param {string} [redirectUrl] The route to redirect to after successful quickbooks authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksAuthGet: function (redirectUrl, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/invoicing/integrations/quickbooks/auth/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (redirectUrl !== undefined) {
                                localVarQueryParameter['redirect_url'] = redirectUrl;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Revokes Quickbooks Authorization for a given company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksAuthRevokeAuthorizationPost: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/invoicing/integrations/quickbooks/auth/revoke-authorization/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of Quickbooks Items to Charge Line Item Category mappings
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksItemCategoriesMappingGet: function (page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/invoicing/integrations/quickbooks/item-categories-mapping/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a mapping for Quickbooks Item to Charge Line Item Category
         * @param {InlineObject9} inlineObject9
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksItemCategoriesMappingPost: function (inlineObject9, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'inlineObject9' is not null or undefined
                            (0, common_1.assertParamExists)('invoicingIntegrationsQuickbooksItemCategoriesMappingPost', 'inlineObject9', inlineObject9);
                            localVarPath = "/invoicing/integrations/quickbooks/item-categories-mapping/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject9, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a Quickbooks Item Category Mapping
         * @param {string} quickbooksItemCategoryMappingId The id of the Quickbooks Item to Category Mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksItemCategoriesMappingQuickbooksItemCategoryMappingIdDelete: function (quickbooksItemCategoryMappingId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'quickbooksItemCategoryMappingId' is not null or undefined
                            (0, common_1.assertParamExists)('invoicingIntegrationsQuickbooksItemCategoriesMappingQuickbooksItemCategoryMappingIdDelete', 'quickbooksItemCategoryMappingId', quickbooksItemCategoryMappingId);
                            localVarPath = "/invoicing/integrations/quickbooks/item-categories-mapping/{quickbooksItemCategoryMappingId}/"
                                .replace("{".concat("quickbooksItemCategoryMappingId", "}"), encodeURIComponent(String(quickbooksItemCategoryMappingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve specific QuickbooksItem to Charge Line Item Category mapping
         * @param {string} quickbooksItemCategoryMappingId The id of the Quickbooks Item to Category Mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksItemCategoriesMappingQuickbooksItemCategoryMappingIdGet: function (quickbooksItemCategoryMappingId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'quickbooksItemCategoryMappingId' is not null or undefined
                            (0, common_1.assertParamExists)('invoicingIntegrationsQuickbooksItemCategoriesMappingQuickbooksItemCategoryMappingIdGet', 'quickbooksItemCategoryMappingId', quickbooksItemCategoryMappingId);
                            localVarPath = "/invoicing/integrations/quickbooks/item-categories-mapping/{quickbooksItemCategoryMappingId}/"
                                .replace("{".concat("quickbooksItemCategoryMappingId", "}"), encodeURIComponent(String(quickbooksItemCategoryMappingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a QuickbooksItem Category Mapping
         * @param {string} quickbooksItemCategoryMappingId The id of the Quickbooks Item to Category Mapping
         * @param {QuickbooksItemCategoryMapping} quickbooksItemCategoryMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksItemCategoriesMappingQuickbooksItemCategoryMappingIdPut: function (quickbooksItemCategoryMappingId, quickbooksItemCategoryMapping, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'quickbooksItemCategoryMappingId' is not null or undefined
                            (0, common_1.assertParamExists)('invoicingIntegrationsQuickbooksItemCategoriesMappingQuickbooksItemCategoryMappingIdPut', 'quickbooksItemCategoryMappingId', quickbooksItemCategoryMappingId);
                            // verify required parameter 'quickbooksItemCategoryMapping' is not null or undefined
                            (0, common_1.assertParamExists)('invoicingIntegrationsQuickbooksItemCategoriesMappingQuickbooksItemCategoryMappingIdPut', 'quickbooksItemCategoryMapping', quickbooksItemCategoryMapping);
                            localVarPath = "/invoicing/integrations/quickbooks/item-categories-mapping/{quickbooksItemCategoryMappingId}/"
                                .replace("{".concat("quickbooksItemCategoryMappingId", "}"), encodeURIComponent(String(quickbooksItemCategoryMappingId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(quickbooksItemCategoryMapping, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the user company\'s Quickbooks Items saved in our database
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksItemsGet: function (page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/invoicing/integrations/quickbooks/items/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Fetch all Quickbooks Items from Quickbooks and save them to our database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksItemsPost: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/invoicing/integrations/quickbooks/items/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List all invoices for a company
         * @param {string} companyId The id of the company
         * @param {string} [docNumber] String, if present, will get an invoice by Doc Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingInvoicesGet: function (companyId, docNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('invoicingInvoicesGet', 'companyId', companyId);
                            localVarPath = "/invoicing/invoices/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (docNumber !== undefined) {
                                localVarQueryParameter['doc_number'] = docNumber;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Send an invoice via email
         * @param {string} invoiceId The id of an invoice
         * @param {InlineObject10} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingInvoicesInvoiceIdEmailPost: function (invoiceId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'invoiceId' is not null or undefined
                            (0, common_1.assertParamExists)('invoicingInvoicesInvoiceIdEmailPost', 'invoiceId', invoiceId);
                            localVarPath = "/invoicing/invoices/{invoiceId}/email/"
                                .replace("{".concat("invoiceId", "}"), encodeURIComponent(String(invoiceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Successfully retrieved an invoice for a company
         * @summary Retrieve invoice for a company
         * @param {string} invoiceId The id of an invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingInvoicesInvoiceIdGet: function (invoiceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'invoiceId' is not null or undefined
                            (0, common_1.assertParamExists)('invoicingInvoicesInvoiceIdGet', 'invoiceId', invoiceId);
                            localVarPath = "/invoicing/invoices/{invoiceId}/"
                                .replace("{".concat("invoiceId", "}"), encodeURIComponent(String(invoiceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Mark a currently processing invoice as error
         * @param {string} invoiceId The id of an invoice
         * @param {InlineObject11} inlineObject11
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingInvoicesInvoiceIdProcessingErroredPost: function (invoiceId, inlineObject11, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'invoiceId' is not null or undefined
                            (0, common_1.assertParamExists)('invoicingInvoicesInvoiceIdProcessingErroredPost', 'invoiceId', invoiceId);
                            // verify required parameter 'inlineObject11' is not null or undefined
                            (0, common_1.assertParamExists)('invoicingInvoicesInvoiceIdProcessingErroredPost', 'inlineObject11', inlineObject11);
                            localVarPath = "/invoicing/invoices/{invoiceId}/processing-errored/"
                                .replace("{".concat("invoiceId", "}"), encodeURIComponent(String(invoiceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject11, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates the details of the invoice. If any line items are provided with an `id` the matching line items are updated. If there is not an id field in the line item or it cannot be found, that line item is added to the invoice.
         * @summary Update invoice
         * @param {string} invoiceId The id of an invoice
         * @param {InvoiceUpdateRequest} invoiceUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingInvoicesInvoiceIdPut: function (invoiceId, invoiceUpdateRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'invoiceId' is not null or undefined
                            (0, common_1.assertParamExists)('invoicingInvoicesInvoiceIdPut', 'invoiceId', invoiceId);
                            // verify required parameter 'invoiceUpdateRequest' is not null or undefined
                            (0, common_1.assertParamExists)('invoicingInvoicesInvoiceIdPut', 'invoiceUpdateRequest', invoiceUpdateRequest);
                            localVarPath = "/invoicing/invoices/{invoiceId}/"
                                .replace("{".concat("invoiceId", "}"), encodeURIComponent(String(invoiceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(invoiceUpdateRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Void an invoice
         * @param {string} invoiceId The id of an invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingInvoicesInvoiceIdVoidPost: function (invoiceId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'invoiceId' is not null or undefined
                            (0, common_1.assertParamExists)('invoicingInvoicesInvoiceIdVoidPost', 'invoiceId', invoiceId);
                            localVarPath = "/invoicing/invoices/{invoiceId}/void/"
                                .replace("{".concat("invoiceId", "}"), encodeURIComponent(String(invoiceId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a new Freight Invoice for a Shipment. If no `charge_line_items` are provided, items are automatically generated from the charge items on the Shipment
         * @summary Create a Freight Invoice for the Shipment
         * @param {string} shipmentId The id of the shipment
         * @param {InvoicingShipmentsShipmentIdFreightInvoicesData} data
         * @param {Array<any>} [documents]
         * @param {FreightInvoiceDocumentsMetadata} [documentsMetadata]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingShipmentsShipmentIdFreightInvoicesPost: function (shipmentId, data, documents, documentsMetadata, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('invoicingShipmentsShipmentIdFreightInvoicesPost', 'shipmentId', shipmentId);
                            // verify required parameter 'data' is not null or undefined
                            (0, common_1.assertParamExists)('invoicingShipmentsShipmentIdFreightInvoicesPost', 'data', data);
                            localVarPath = "/invoicing/shipments/{shipmentId}/freight-invoices/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (data !== undefined) {
                                localVarFormParams.append('data', new Blob([JSON.stringify(data)], { type: "application/json", }));
                            }
                            if (documents) {
                                documents.forEach(function (element) {
                                    localVarFormParams.append('documents', element);
                                });
                            }
                            if (documentsMetadata !== undefined) {
                                localVarFormParams.append('documents_metadata', new Blob([JSON.stringify(documentsMetadata)], { type: "application/json", }));
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns Customer\'s Invoice Rule Configurations
         * @param {string} shipmentId The id of the shipment
         * @param {'carrier_generated' | 'shipper_generated'} invoiceSource Get Customer\&#39;s invoice rules based on invoice source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingShipmentsShipmentIdInvoiceRuleConfigurationsGet: function (shipmentId, invoiceSource, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('invoicingShipmentsShipmentIdInvoiceRuleConfigurationsGet', 'shipmentId', shipmentId);
                            // verify required parameter 'invoiceSource' is not null or undefined
                            (0, common_1.assertParamExists)('invoicingShipmentsShipmentIdInvoiceRuleConfigurationsGet', 'invoiceSource', invoiceSource);
                            localVarPath = "/invoicing/shipments/{shipmentId}/invoice-rule-configurations/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (invoiceSource !== undefined) {
                                localVarQueryParameter['invoice_source'] = invoiceSource;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List invoices for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {'PROCESSING' | 'ERROR' | 'SUCCESS'} [processingStatus] Filter invoices or bills by processing status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingShipmentsShipmentIdInvoicesGet: function (shipmentId, page, pageSize, processingStatus, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('invoicingShipmentsShipmentIdInvoicesGet', 'shipmentId', shipmentId);
                            localVarPath = "/invoicing/shipments/{shipmentId}/invoices/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (processingStatus !== undefined) {
                                localVarQueryParameter['processing_status'] = processingStatus;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a new Invoice for a Shipment within the configured Financial Management System. If no `line_items` are provided, items are automatically generated from the charge items on the Shipment
         * @summary Create an invoice for the shipment on the configured FMS
         * @param {string} shipmentId The id of the shipment
         * @param {InlineObject13} inlineObject13
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingShipmentsShipmentIdInvoicesPost: function (shipmentId, inlineObject13, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('invoicingShipmentsShipmentIdInvoicesPost', 'shipmentId', shipmentId);
                            // verify required parameter 'inlineObject13' is not null or undefined
                            (0, common_1.assertParamExists)('invoicingShipmentsShipmentIdInvoicesPost', 'inlineObject13', inlineObject13);
                            localVarPath = "/invoicing/shipments/{shipmentId}/invoices/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject13, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns all shipments that need a customer-side invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingUninvoicedShipmentsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/invoicing/uninvoiced-shipments/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.InvoicingApiAxiosParamCreator = InvoicingApiAxiosParamCreator;
/**
 * InvoicingApi - functional programming interface
 * @export
 */
var InvoicingApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.InvoicingApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Returns all Financial Management Systems that are configured
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsFmsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.integrationsFmsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns Quickbooks Authorization details for a given company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksAuthAuthorizationDetailsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.invoicingIntegrationsQuickbooksAuthAuthorizationDetailsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Checks if a user has authenticated with quickbooks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksAuthCheckGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.invoicingIntegrationsQuickbooksAuthCheckGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Initiates quickbooks authentication for logged in user with Shipwell API
         * @param {string} [redirectUrl] The route to redirect to after successful quickbooks authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksAuthGet: function (redirectUrl, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.invoicingIntegrationsQuickbooksAuthGet(redirectUrl, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Revokes Quickbooks Authorization for a given company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksAuthRevokeAuthorizationPost: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.invoicingIntegrationsQuickbooksAuthRevokeAuthorizationPost(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of Quickbooks Items to Charge Line Item Category mappings
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksItemCategoriesMappingGet: function (page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.invoicingIntegrationsQuickbooksItemCategoriesMappingGet(page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a mapping for Quickbooks Item to Charge Line Item Category
         * @param {InlineObject9} inlineObject9
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksItemCategoriesMappingPost: function (inlineObject9, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.invoicingIntegrationsQuickbooksItemCategoriesMappingPost(inlineObject9, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a Quickbooks Item Category Mapping
         * @param {string} quickbooksItemCategoryMappingId The id of the Quickbooks Item to Category Mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksItemCategoriesMappingQuickbooksItemCategoryMappingIdDelete: function (quickbooksItemCategoryMappingId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.invoicingIntegrationsQuickbooksItemCategoriesMappingQuickbooksItemCategoryMappingIdDelete(quickbooksItemCategoryMappingId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve specific QuickbooksItem to Charge Line Item Category mapping
         * @param {string} quickbooksItemCategoryMappingId The id of the Quickbooks Item to Category Mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksItemCategoriesMappingQuickbooksItemCategoryMappingIdGet: function (quickbooksItemCategoryMappingId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.invoicingIntegrationsQuickbooksItemCategoriesMappingQuickbooksItemCategoryMappingIdGet(quickbooksItemCategoryMappingId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a QuickbooksItem Category Mapping
         * @param {string} quickbooksItemCategoryMappingId The id of the Quickbooks Item to Category Mapping
         * @param {QuickbooksItemCategoryMapping} quickbooksItemCategoryMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksItemCategoriesMappingQuickbooksItemCategoryMappingIdPut: function (quickbooksItemCategoryMappingId, quickbooksItemCategoryMapping, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.invoicingIntegrationsQuickbooksItemCategoriesMappingQuickbooksItemCategoryMappingIdPut(quickbooksItemCategoryMappingId, quickbooksItemCategoryMapping, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the user company\'s Quickbooks Items saved in our database
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksItemsGet: function (page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.invoicingIntegrationsQuickbooksItemsGet(page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Fetch all Quickbooks Items from Quickbooks and save them to our database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksItemsPost: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.invoicingIntegrationsQuickbooksItemsPost(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List all invoices for a company
         * @param {string} companyId The id of the company
         * @param {string} [docNumber] String, if present, will get an invoice by Doc Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingInvoicesGet: function (companyId, docNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.invoicingInvoicesGet(companyId, docNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Send an invoice via email
         * @param {string} invoiceId The id of an invoice
         * @param {InlineObject10} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingInvoicesInvoiceIdEmailPost: function (invoiceId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.invoicingInvoicesInvoiceIdEmailPost(invoiceId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Successfully retrieved an invoice for a company
         * @summary Retrieve invoice for a company
         * @param {string} invoiceId The id of an invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingInvoicesInvoiceIdGet: function (invoiceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.invoicingInvoicesInvoiceIdGet(invoiceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Mark a currently processing invoice as error
         * @param {string} invoiceId The id of an invoice
         * @param {InlineObject11} inlineObject11
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingInvoicesInvoiceIdProcessingErroredPost: function (invoiceId, inlineObject11, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.invoicingInvoicesInvoiceIdProcessingErroredPost(invoiceId, inlineObject11, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Updates the details of the invoice. If any line items are provided with an `id` the matching line items are updated. If there is not an id field in the line item or it cannot be found, that line item is added to the invoice.
         * @summary Update invoice
         * @param {string} invoiceId The id of an invoice
         * @param {InvoiceUpdateRequest} invoiceUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingInvoicesInvoiceIdPut: function (invoiceId, invoiceUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.invoicingInvoicesInvoiceIdPut(invoiceId, invoiceUpdateRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Void an invoice
         * @param {string} invoiceId The id of an invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingInvoicesInvoiceIdVoidPost: function (invoiceId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.invoicingInvoicesInvoiceIdVoidPost(invoiceId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create a new Freight Invoice for a Shipment. If no `charge_line_items` are provided, items are automatically generated from the charge items on the Shipment
         * @summary Create a Freight Invoice for the Shipment
         * @param {string} shipmentId The id of the shipment
         * @param {InvoicingShipmentsShipmentIdFreightInvoicesData} data
         * @param {Array<any>} [documents]
         * @param {FreightInvoiceDocumentsMetadata} [documentsMetadata]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingShipmentsShipmentIdFreightInvoicesPost: function (shipmentId, data, documents, documentsMetadata, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.invoicingShipmentsShipmentIdFreightInvoicesPost(shipmentId, data, documents, documentsMetadata, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns Customer\'s Invoice Rule Configurations
         * @param {string} shipmentId The id of the shipment
         * @param {'carrier_generated' | 'shipper_generated'} invoiceSource Get Customer\&#39;s invoice rules based on invoice source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingShipmentsShipmentIdInvoiceRuleConfigurationsGet: function (shipmentId, invoiceSource, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.invoicingShipmentsShipmentIdInvoiceRuleConfigurationsGet(shipmentId, invoiceSource, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List invoices for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {'PROCESSING' | 'ERROR' | 'SUCCESS'} [processingStatus] Filter invoices or bills by processing status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingShipmentsShipmentIdInvoicesGet: function (shipmentId, page, pageSize, processingStatus, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.invoicingShipmentsShipmentIdInvoicesGet(shipmentId, page, pageSize, processingStatus, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create a new Invoice for a Shipment within the configured Financial Management System. If no `line_items` are provided, items are automatically generated from the charge items on the Shipment
         * @summary Create an invoice for the shipment on the configured FMS
         * @param {string} shipmentId The id of the shipment
         * @param {InlineObject13} inlineObject13
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingShipmentsShipmentIdInvoicesPost: function (shipmentId, inlineObject13, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.invoicingShipmentsShipmentIdInvoicesPost(shipmentId, inlineObject13, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns all shipments that need a customer-side invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingUninvoicedShipmentsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.invoicingUninvoicedShipmentsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.InvoicingApiFp = InvoicingApiFp;
/**
 * InvoicingApi - factory interface
 * @export
 */
var InvoicingApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.InvoicingApiFp)(configuration);
    return {
        /**
         *
         * @summary Returns all Financial Management Systems that are configured
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        integrationsFmsGet: function (options) {
            return localVarFp.integrationsFmsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns Quickbooks Authorization details for a given company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksAuthAuthorizationDetailsGet: function (options) {
            return localVarFp.invoicingIntegrationsQuickbooksAuthAuthorizationDetailsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Checks if a user has authenticated with quickbooks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksAuthCheckGet: function (options) {
            return localVarFp.invoicingIntegrationsQuickbooksAuthCheckGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Initiates quickbooks authentication for logged in user with Shipwell API
         * @param {string} [redirectUrl] The route to redirect to after successful quickbooks authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksAuthGet: function (redirectUrl, options) {
            return localVarFp.invoicingIntegrationsQuickbooksAuthGet(redirectUrl, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Revokes Quickbooks Authorization for a given company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksAuthRevokeAuthorizationPost: function (options) {
            return localVarFp.invoicingIntegrationsQuickbooksAuthRevokeAuthorizationPost(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a list of Quickbooks Items to Charge Line Item Category mappings
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksItemCategoriesMappingGet: function (page, pageSize, options) {
            return localVarFp.invoicingIntegrationsQuickbooksItemCategoriesMappingGet(page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a mapping for Quickbooks Item to Charge Line Item Category
         * @param {InlineObject9} inlineObject9
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksItemCategoriesMappingPost: function (inlineObject9, options) {
            return localVarFp.invoicingIntegrationsQuickbooksItemCategoriesMappingPost(inlineObject9, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a Quickbooks Item Category Mapping
         * @param {string} quickbooksItemCategoryMappingId The id of the Quickbooks Item to Category Mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksItemCategoriesMappingQuickbooksItemCategoryMappingIdDelete: function (quickbooksItemCategoryMappingId, options) {
            return localVarFp.invoicingIntegrationsQuickbooksItemCategoriesMappingQuickbooksItemCategoryMappingIdDelete(quickbooksItemCategoryMappingId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve specific QuickbooksItem to Charge Line Item Category mapping
         * @param {string} quickbooksItemCategoryMappingId The id of the Quickbooks Item to Category Mapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksItemCategoriesMappingQuickbooksItemCategoryMappingIdGet: function (quickbooksItemCategoryMappingId, options) {
            return localVarFp.invoicingIntegrationsQuickbooksItemCategoriesMappingQuickbooksItemCategoryMappingIdGet(quickbooksItemCategoryMappingId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a QuickbooksItem Category Mapping
         * @param {string} quickbooksItemCategoryMappingId The id of the Quickbooks Item to Category Mapping
         * @param {QuickbooksItemCategoryMapping} quickbooksItemCategoryMapping
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksItemCategoriesMappingQuickbooksItemCategoryMappingIdPut: function (quickbooksItemCategoryMappingId, quickbooksItemCategoryMapping, options) {
            return localVarFp.invoicingIntegrationsQuickbooksItemCategoriesMappingQuickbooksItemCategoryMappingIdPut(quickbooksItemCategoryMappingId, quickbooksItemCategoryMapping, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the user company\'s Quickbooks Items saved in our database
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksItemsGet: function (page, pageSize, options) {
            return localVarFp.invoicingIntegrationsQuickbooksItemsGet(page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Fetch all Quickbooks Items from Quickbooks and save them to our database
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingIntegrationsQuickbooksItemsPost: function (options) {
            return localVarFp.invoicingIntegrationsQuickbooksItemsPost(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List all invoices for a company
         * @param {string} companyId The id of the company
         * @param {string} [docNumber] String, if present, will get an invoice by Doc Number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingInvoicesGet: function (companyId, docNumber, options) {
            return localVarFp.invoicingInvoicesGet(companyId, docNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Send an invoice via email
         * @param {string} invoiceId The id of an invoice
         * @param {InlineObject10} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingInvoicesInvoiceIdEmailPost: function (invoiceId, body, options) {
            return localVarFp.invoicingInvoicesInvoiceIdEmailPost(invoiceId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Successfully retrieved an invoice for a company
         * @summary Retrieve invoice for a company
         * @param {string} invoiceId The id of an invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingInvoicesInvoiceIdGet: function (invoiceId, options) {
            return localVarFp.invoicingInvoicesInvoiceIdGet(invoiceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Mark a currently processing invoice as error
         * @param {string} invoiceId The id of an invoice
         * @param {InlineObject11} inlineObject11
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingInvoicesInvoiceIdProcessingErroredPost: function (invoiceId, inlineObject11, options) {
            return localVarFp.invoicingInvoicesInvoiceIdProcessingErroredPost(invoiceId, inlineObject11, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates the details of the invoice. If any line items are provided with an `id` the matching line items are updated. If there is not an id field in the line item or it cannot be found, that line item is added to the invoice.
         * @summary Update invoice
         * @param {string} invoiceId The id of an invoice
         * @param {InvoiceUpdateRequest} invoiceUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingInvoicesInvoiceIdPut: function (invoiceId, invoiceUpdateRequest, options) {
            return localVarFp.invoicingInvoicesInvoiceIdPut(invoiceId, invoiceUpdateRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Void an invoice
         * @param {string} invoiceId The id of an invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingInvoicesInvoiceIdVoidPost: function (invoiceId, options) {
            return localVarFp.invoicingInvoicesInvoiceIdVoidPost(invoiceId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a new Freight Invoice for a Shipment. If no `charge_line_items` are provided, items are automatically generated from the charge items on the Shipment
         * @summary Create a Freight Invoice for the Shipment
         * @param {string} shipmentId The id of the shipment
         * @param {InvoicingShipmentsShipmentIdFreightInvoicesData} data
         * @param {Array<any>} [documents]
         * @param {FreightInvoiceDocumentsMetadata} [documentsMetadata]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingShipmentsShipmentIdFreightInvoicesPost: function (shipmentId, data, documents, documentsMetadata, options) {
            return localVarFp.invoicingShipmentsShipmentIdFreightInvoicesPost(shipmentId, data, documents, documentsMetadata, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns Customer\'s Invoice Rule Configurations
         * @param {string} shipmentId The id of the shipment
         * @param {'carrier_generated' | 'shipper_generated'} invoiceSource Get Customer\&#39;s invoice rules based on invoice source
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingShipmentsShipmentIdInvoiceRuleConfigurationsGet: function (shipmentId, invoiceSource, options) {
            return localVarFp.invoicingShipmentsShipmentIdInvoiceRuleConfigurationsGet(shipmentId, invoiceSource, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List invoices for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {'PROCESSING' | 'ERROR' | 'SUCCESS'} [processingStatus] Filter invoices or bills by processing status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingShipmentsShipmentIdInvoicesGet: function (shipmentId, page, pageSize, processingStatus, options) {
            return localVarFp.invoicingShipmentsShipmentIdInvoicesGet(shipmentId, page, pageSize, processingStatus, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a new Invoice for a Shipment within the configured Financial Management System. If no `line_items` are provided, items are automatically generated from the charge items on the Shipment
         * @summary Create an invoice for the shipment on the configured FMS
         * @param {string} shipmentId The id of the shipment
         * @param {InlineObject13} inlineObject13
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingShipmentsShipmentIdInvoicesPost: function (shipmentId, inlineObject13, options) {
            return localVarFp.invoicingShipmentsShipmentIdInvoicesPost(shipmentId, inlineObject13, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns all shipments that need a customer-side invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoicingUninvoicedShipmentsGet: function (options) {
            return localVarFp.invoicingUninvoicedShipmentsGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.InvoicingApiFactory = InvoicingApiFactory;
/**
 * InvoicingApi - object-oriented interface
 * @export
 * @class InvoicingApi
 * @extends {BaseAPI}
 */
var InvoicingApi = /** @class */ (function (_super) {
    __extends(InvoicingApi, _super);
    function InvoicingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Returns all Financial Management Systems that are configured
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    InvoicingApi.prototype.integrationsFmsGet = function (options) {
        var _this = this;
        return (0, exports.InvoicingApiFp)(this.configuration).integrationsFmsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns Quickbooks Authorization details for a given company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    InvoicingApi.prototype.invoicingIntegrationsQuickbooksAuthAuthorizationDetailsGet = function (options) {
        var _this = this;
        return (0, exports.InvoicingApiFp)(this.configuration).invoicingIntegrationsQuickbooksAuthAuthorizationDetailsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Checks if a user has authenticated with quickbooks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    InvoicingApi.prototype.invoicingIntegrationsQuickbooksAuthCheckGet = function (options) {
        var _this = this;
        return (0, exports.InvoicingApiFp)(this.configuration).invoicingIntegrationsQuickbooksAuthCheckGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Initiates quickbooks authentication for logged in user with Shipwell API
     * @param {string} [redirectUrl] The route to redirect to after successful quickbooks authentication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    InvoicingApi.prototype.invoicingIntegrationsQuickbooksAuthGet = function (redirectUrl, options) {
        var _this = this;
        return (0, exports.InvoicingApiFp)(this.configuration).invoicingIntegrationsQuickbooksAuthGet(redirectUrl, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Revokes Quickbooks Authorization for a given company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    InvoicingApi.prototype.invoicingIntegrationsQuickbooksAuthRevokeAuthorizationPost = function (options) {
        var _this = this;
        return (0, exports.InvoicingApiFp)(this.configuration).invoicingIntegrationsQuickbooksAuthRevokeAuthorizationPost(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a list of Quickbooks Items to Charge Line Item Category mappings
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    InvoicingApi.prototype.invoicingIntegrationsQuickbooksItemCategoriesMappingGet = function (page, pageSize, options) {
        var _this = this;
        return (0, exports.InvoicingApiFp)(this.configuration).invoicingIntegrationsQuickbooksItemCategoriesMappingGet(page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a mapping for Quickbooks Item to Charge Line Item Category
     * @param {InlineObject9} inlineObject9
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    InvoicingApi.prototype.invoicingIntegrationsQuickbooksItemCategoriesMappingPost = function (inlineObject9, options) {
        var _this = this;
        return (0, exports.InvoicingApiFp)(this.configuration).invoicingIntegrationsQuickbooksItemCategoriesMappingPost(inlineObject9, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a Quickbooks Item Category Mapping
     * @param {string} quickbooksItemCategoryMappingId The id of the Quickbooks Item to Category Mapping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    InvoicingApi.prototype.invoicingIntegrationsQuickbooksItemCategoriesMappingQuickbooksItemCategoryMappingIdDelete = function (quickbooksItemCategoryMappingId, options) {
        var _this = this;
        return (0, exports.InvoicingApiFp)(this.configuration).invoicingIntegrationsQuickbooksItemCategoriesMappingQuickbooksItemCategoryMappingIdDelete(quickbooksItemCategoryMappingId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve specific QuickbooksItem to Charge Line Item Category mapping
     * @param {string} quickbooksItemCategoryMappingId The id of the Quickbooks Item to Category Mapping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    InvoicingApi.prototype.invoicingIntegrationsQuickbooksItemCategoriesMappingQuickbooksItemCategoryMappingIdGet = function (quickbooksItemCategoryMappingId, options) {
        var _this = this;
        return (0, exports.InvoicingApiFp)(this.configuration).invoicingIntegrationsQuickbooksItemCategoriesMappingQuickbooksItemCategoryMappingIdGet(quickbooksItemCategoryMappingId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a QuickbooksItem Category Mapping
     * @param {string} quickbooksItemCategoryMappingId The id of the Quickbooks Item to Category Mapping
     * @param {QuickbooksItemCategoryMapping} quickbooksItemCategoryMapping
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    InvoicingApi.prototype.invoicingIntegrationsQuickbooksItemCategoriesMappingQuickbooksItemCategoryMappingIdPut = function (quickbooksItemCategoryMappingId, quickbooksItemCategoryMapping, options) {
        var _this = this;
        return (0, exports.InvoicingApiFp)(this.configuration).invoicingIntegrationsQuickbooksItemCategoriesMappingQuickbooksItemCategoryMappingIdPut(quickbooksItemCategoryMappingId, quickbooksItemCategoryMapping, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the user company\'s Quickbooks Items saved in our database
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    InvoicingApi.prototype.invoicingIntegrationsQuickbooksItemsGet = function (page, pageSize, options) {
        var _this = this;
        return (0, exports.InvoicingApiFp)(this.configuration).invoicingIntegrationsQuickbooksItemsGet(page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Fetch all Quickbooks Items from Quickbooks and save them to our database
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    InvoicingApi.prototype.invoicingIntegrationsQuickbooksItemsPost = function (options) {
        var _this = this;
        return (0, exports.InvoicingApiFp)(this.configuration).invoicingIntegrationsQuickbooksItemsPost(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List all invoices for a company
     * @param {string} companyId The id of the company
     * @param {string} [docNumber] String, if present, will get an invoice by Doc Number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    InvoicingApi.prototype.invoicingInvoicesGet = function (companyId, docNumber, options) {
        var _this = this;
        return (0, exports.InvoicingApiFp)(this.configuration).invoicingInvoicesGet(companyId, docNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Send an invoice via email
     * @param {string} invoiceId The id of an invoice
     * @param {InlineObject10} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    InvoicingApi.prototype.invoicingInvoicesInvoiceIdEmailPost = function (invoiceId, body, options) {
        var _this = this;
        return (0, exports.InvoicingApiFp)(this.configuration).invoicingInvoicesInvoiceIdEmailPost(invoiceId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Successfully retrieved an invoice for a company
     * @summary Retrieve invoice for a company
     * @param {string} invoiceId The id of an invoice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    InvoicingApi.prototype.invoicingInvoicesInvoiceIdGet = function (invoiceId, options) {
        var _this = this;
        return (0, exports.InvoicingApiFp)(this.configuration).invoicingInvoicesInvoiceIdGet(invoiceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Mark a currently processing invoice as error
     * @param {string} invoiceId The id of an invoice
     * @param {InlineObject11} inlineObject11
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    InvoicingApi.prototype.invoicingInvoicesInvoiceIdProcessingErroredPost = function (invoiceId, inlineObject11, options) {
        var _this = this;
        return (0, exports.InvoicingApiFp)(this.configuration).invoicingInvoicesInvoiceIdProcessingErroredPost(invoiceId, inlineObject11, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates the details of the invoice. If any line items are provided with an `id` the matching line items are updated. If there is not an id field in the line item or it cannot be found, that line item is added to the invoice.
     * @summary Update invoice
     * @param {string} invoiceId The id of an invoice
     * @param {InvoiceUpdateRequest} invoiceUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    InvoicingApi.prototype.invoicingInvoicesInvoiceIdPut = function (invoiceId, invoiceUpdateRequest, options) {
        var _this = this;
        return (0, exports.InvoicingApiFp)(this.configuration).invoicingInvoicesInvoiceIdPut(invoiceId, invoiceUpdateRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Void an invoice
     * @param {string} invoiceId The id of an invoice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    InvoicingApi.prototype.invoicingInvoicesInvoiceIdVoidPost = function (invoiceId, options) {
        var _this = this;
        return (0, exports.InvoicingApiFp)(this.configuration).invoicingInvoicesInvoiceIdVoidPost(invoiceId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a new Freight Invoice for a Shipment. If no `charge_line_items` are provided, items are automatically generated from the charge items on the Shipment
     * @summary Create a Freight Invoice for the Shipment
     * @param {string} shipmentId The id of the shipment
     * @param {InvoicingShipmentsShipmentIdFreightInvoicesData} data
     * @param {Array<any>} [documents]
     * @param {FreightInvoiceDocumentsMetadata} [documentsMetadata]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    InvoicingApi.prototype.invoicingShipmentsShipmentIdFreightInvoicesPost = function (shipmentId, data, documents, documentsMetadata, options) {
        var _this = this;
        return (0, exports.InvoicingApiFp)(this.configuration).invoicingShipmentsShipmentIdFreightInvoicesPost(shipmentId, data, documents, documentsMetadata, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns Customer\'s Invoice Rule Configurations
     * @param {string} shipmentId The id of the shipment
     * @param {'carrier_generated' | 'shipper_generated'} invoiceSource Get Customer\&#39;s invoice rules based on invoice source
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    InvoicingApi.prototype.invoicingShipmentsShipmentIdInvoiceRuleConfigurationsGet = function (shipmentId, invoiceSource, options) {
        var _this = this;
        return (0, exports.InvoicingApiFp)(this.configuration).invoicingShipmentsShipmentIdInvoiceRuleConfigurationsGet(shipmentId, invoiceSource, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List invoices for a shipment
     * @param {string} shipmentId The id of the shipment
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {'PROCESSING' | 'ERROR' | 'SUCCESS'} [processingStatus] Filter invoices or bills by processing status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    InvoicingApi.prototype.invoicingShipmentsShipmentIdInvoicesGet = function (shipmentId, page, pageSize, processingStatus, options) {
        var _this = this;
        return (0, exports.InvoicingApiFp)(this.configuration).invoicingShipmentsShipmentIdInvoicesGet(shipmentId, page, pageSize, processingStatus, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a new Invoice for a Shipment within the configured Financial Management System. If no `line_items` are provided, items are automatically generated from the charge items on the Shipment
     * @summary Create an invoice for the shipment on the configured FMS
     * @param {string} shipmentId The id of the shipment
     * @param {InlineObject13} inlineObject13
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    InvoicingApi.prototype.invoicingShipmentsShipmentIdInvoicesPost = function (shipmentId, inlineObject13, options) {
        var _this = this;
        return (0, exports.InvoicingApiFp)(this.configuration).invoicingShipmentsShipmentIdInvoicesPost(shipmentId, inlineObject13, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns all shipments that need a customer-side invoice
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicingApi
     */
    InvoicingApi.prototype.invoicingUninvoicedShipmentsGet = function (options) {
        var _this = this;
        return (0, exports.InvoicingApiFp)(this.configuration).invoicingUninvoicedShipmentsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return InvoicingApi;
}(base_1.BaseAPI));
exports.InvoicingApi = InvoicingApi;
/**
 * LegsApi - axios parameter creator
 * @export
 */
var LegsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Return a tags associated to leg
         * @param {string} legId The id of the leg
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legsLegIdTagsGet: function (legId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'legId' is not null or undefined
                            (0, common_1.assertParamExists)('legsLegIdTagsGet', 'legId', legId);
                            localVarPath = "/legs/{legId}/tags/"
                                .replace("{".concat("legId", "}"), encodeURIComponent(String(legId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Remove tag from leg
         * @param {string} legId The id of the leg
         * @param {string} tagId The id of the tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legsLegIdTagsTagIdDelete: function (legId, tagId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'legId' is not null or undefined
                            (0, common_1.assertParamExists)('legsLegIdTagsTagIdDelete', 'legId', legId);
                            // verify required parameter 'tagId' is not null or undefined
                            (0, common_1.assertParamExists)('legsLegIdTagsTagIdDelete', 'tagId', tagId);
                            localVarPath = "/legs/{legId}/tags/{tagId}/"
                                .replace("{".concat("legId", "}"), encodeURIComponent(String(legId)))
                                .replace("{".concat("tagId", "}"), encodeURIComponent(String(tagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Add tag to leg
         * @param {string} legId The id of the leg
         * @param {string} tagId The id of the tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legsLegIdTagsTagIdPost: function (legId, tagId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'legId' is not null or undefined
                            (0, common_1.assertParamExists)('legsLegIdTagsTagIdPost', 'legId', legId);
                            // verify required parameter 'tagId' is not null or undefined
                            (0, common_1.assertParamExists)('legsLegIdTagsTagIdPost', 'tagId', tagId);
                            localVarPath = "/legs/{legId}/tags/{tagId}/"
                                .replace("{".concat("legId", "}"), encodeURIComponent(String(legId)))
                                .replace("{".concat("tagId", "}"), encodeURIComponent(String(tagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get locations for the leg
         * @param {string} legId The id of the leg
         * @param {string} [beginDatetime] For requesting data starting at a given date
         * @param {string} [endDatetime] For requesting data ending at a given date
         * @param {string} [filterDistance] Applies a distance filter and only returns points greater than filter_distance km apart. To return all, set this to -1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legsLegIdTrackingGet: function (legId, beginDatetime, endDatetime, filterDistance, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'legId' is not null or undefined
                            (0, common_1.assertParamExists)('legsLegIdTrackingGet', 'legId', legId);
                            localVarPath = "/legs/{legId}/tracking/"
                                .replace("{".concat("legId", "}"), encodeURIComponent(String(legId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (beginDatetime !== undefined) {
                                localVarQueryParameter['beginDatetime'] = (beginDatetime instanceof Date) ?
                                    beginDatetime.toISOString() :
                                    beginDatetime;
                            }
                            if (endDatetime !== undefined) {
                                localVarQueryParameter['endDatetime'] = (endDatetime instanceof Date) ?
                                    endDatetime.toISOString() :
                                    endDatetime;
                            }
                            if (filterDistance !== undefined) {
                                localVarQueryParameter['filter_distance'] = filterDistance;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Manually update Leg Location
         * @param {string} legId The id of the leg
         * @param {ELDLocationUpdateRequest} eLDLocationUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legsLegIdTrackingPost: function (legId, eLDLocationUpdateRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'legId' is not null or undefined
                            (0, common_1.assertParamExists)('legsLegIdTrackingPost', 'legId', legId);
                            // verify required parameter 'eLDLocationUpdateRequest' is not null or undefined
                            (0, common_1.assertParamExists)('legsLegIdTrackingPost', 'eLDLocationUpdateRequest', eLDLocationUpdateRequest);
                            localVarPath = "/legs/{legId}/tracking/"
                                .replace("{".concat("legId", "}"), encodeURIComponent(String(legId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(eLDLocationUpdateRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.LegsApiAxiosParamCreator = LegsApiAxiosParamCreator;
/**
 * LegsApi - functional programming interface
 * @export
 */
var LegsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LegsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Return a tags associated to leg
         * @param {string} legId The id of the leg
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legsLegIdTagsGet: function (legId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.legsLegIdTagsGet(legId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Remove tag from leg
         * @param {string} legId The id of the leg
         * @param {string} tagId The id of the tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legsLegIdTagsTagIdDelete: function (legId, tagId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.legsLegIdTagsTagIdDelete(legId, tagId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Add tag to leg
         * @param {string} legId The id of the leg
         * @param {string} tagId The id of the tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legsLegIdTagsTagIdPost: function (legId, tagId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.legsLegIdTagsTagIdPost(legId, tagId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get locations for the leg
         * @param {string} legId The id of the leg
         * @param {string} [beginDatetime] For requesting data starting at a given date
         * @param {string} [endDatetime] For requesting data ending at a given date
         * @param {string} [filterDistance] Applies a distance filter and only returns points greater than filter_distance km apart. To return all, set this to -1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legsLegIdTrackingGet: function (legId, beginDatetime, endDatetime, filterDistance, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.legsLegIdTrackingGet(legId, beginDatetime, endDatetime, filterDistance, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Manually update Leg Location
         * @param {string} legId The id of the leg
         * @param {ELDLocationUpdateRequest} eLDLocationUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legsLegIdTrackingPost: function (legId, eLDLocationUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.legsLegIdTrackingPost(legId, eLDLocationUpdateRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.LegsApiFp = LegsApiFp;
/**
 * LegsApi - factory interface
 * @export
 */
var LegsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LegsApiFp)(configuration);
    return {
        /**
         *
         * @summary Return a tags associated to leg
         * @param {string} legId The id of the leg
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legsLegIdTagsGet: function (legId, options) {
            return localVarFp.legsLegIdTagsGet(legId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Remove tag from leg
         * @param {string} legId The id of the leg
         * @param {string} tagId The id of the tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legsLegIdTagsTagIdDelete: function (legId, tagId, options) {
            return localVarFp.legsLegIdTagsTagIdDelete(legId, tagId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Add tag to leg
         * @param {string} legId The id of the leg
         * @param {string} tagId The id of the tag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legsLegIdTagsTagIdPost: function (legId, tagId, options) {
            return localVarFp.legsLegIdTagsTagIdPost(legId, tagId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get locations for the leg
         * @param {string} legId The id of the leg
         * @param {string} [beginDatetime] For requesting data starting at a given date
         * @param {string} [endDatetime] For requesting data ending at a given date
         * @param {string} [filterDistance] Applies a distance filter and only returns points greater than filter_distance km apart. To return all, set this to -1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legsLegIdTrackingGet: function (legId, beginDatetime, endDatetime, filterDistance, options) {
            return localVarFp.legsLegIdTrackingGet(legId, beginDatetime, endDatetime, filterDistance, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Manually update Leg Location
         * @param {string} legId The id of the leg
         * @param {ELDLocationUpdateRequest} eLDLocationUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        legsLegIdTrackingPost: function (legId, eLDLocationUpdateRequest, options) {
            return localVarFp.legsLegIdTrackingPost(legId, eLDLocationUpdateRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LegsApiFactory = LegsApiFactory;
/**
 * LegsApi - object-oriented interface
 * @export
 * @class LegsApi
 * @extends {BaseAPI}
 */
var LegsApi = /** @class */ (function (_super) {
    __extends(LegsApi, _super);
    function LegsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Return a tags associated to leg
     * @param {string} legId The id of the leg
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsApi
     */
    LegsApi.prototype.legsLegIdTagsGet = function (legId, options) {
        var _this = this;
        return (0, exports.LegsApiFp)(this.configuration).legsLegIdTagsGet(legId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Remove tag from leg
     * @param {string} legId The id of the leg
     * @param {string} tagId The id of the tag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsApi
     */
    LegsApi.prototype.legsLegIdTagsTagIdDelete = function (legId, tagId, options) {
        var _this = this;
        return (0, exports.LegsApiFp)(this.configuration).legsLegIdTagsTagIdDelete(legId, tagId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Add tag to leg
     * @param {string} legId The id of the leg
     * @param {string} tagId The id of the tag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsApi
     */
    LegsApi.prototype.legsLegIdTagsTagIdPost = function (legId, tagId, options) {
        var _this = this;
        return (0, exports.LegsApiFp)(this.configuration).legsLegIdTagsTagIdPost(legId, tagId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get locations for the leg
     * @param {string} legId The id of the leg
     * @param {string} [beginDatetime] For requesting data starting at a given date
     * @param {string} [endDatetime] For requesting data ending at a given date
     * @param {string} [filterDistance] Applies a distance filter and only returns points greater than filter_distance km apart. To return all, set this to -1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsApi
     */
    LegsApi.prototype.legsLegIdTrackingGet = function (legId, beginDatetime, endDatetime, filterDistance, options) {
        var _this = this;
        return (0, exports.LegsApiFp)(this.configuration).legsLegIdTrackingGet(legId, beginDatetime, endDatetime, filterDistance, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Manually update Leg Location
     * @param {string} legId The id of the leg
     * @param {ELDLocationUpdateRequest} eLDLocationUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LegsApi
     */
    LegsApi.prototype.legsLegIdTrackingPost = function (legId, eLDLocationUpdateRequest, options) {
        var _this = this;
        return (0, exports.LegsApiFp)(this.configuration).legsLegIdTrackingPost(legId, eLDLocationUpdateRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LegsApi;
}(base_1.BaseAPI));
exports.LegsApi = LegsApi;
/**
 * LoadboardApi - axios parameter creator
 * @export
 */
var LoadboardApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary List all shipments available on a carrier load board
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [activeVendorAssignment] Include or exclude shipments with active CarrierAssignments
         * @param {boolean} [archived] Filter on whether or not a shipment is archived
         * @param {Array<string>} [bolNumber] Include shipments with these BOL Numbers
         * @param {string} [bolNumberContains] Return shipments where the BOL number contains this value
         * @param {Array<string>} [bolNumberExclude] Exclude shipments with these BOL Numbers
         * @param {number} [buyItNowAmountGte] Return shipments with a buy-it-now amount greater than or equal to this value
         * @param {number} [buyItNowAmountLte] Return shipments with a buy-it-now amount less than or equal to this value
         * @param {string} [customer] Return shipments with this exact value as the customer company name
         * @param {string} [customerContains] Return shipments where the customer company name contains this value
         * @param {string} [customerId] Return shipments with this exact id for the customer company
         * @param {Array<string>} [customerReferenceNumber] Include shipments with these Customer Reference Numbers
         * @param {string} [customerReferenceNumberContains] Include shipments where the Customer Reference Numbers contains this value
         * @param {Array<string>} [customerReferenceNumberExclude] Exclude shipments with these Customer Reference Numbers
         * @param {string} [deliveryStopsContains] Return shipments with this value in one of its dropoff stops
         * @param {string} [deliveryStopsCompanyNameContains] Return shipments with this value in one of its delivery stops location company_name
         * @param {string} [destinationContains] Return shipments with this value in the destination
         * @param {string} [destinationStateProvince] Return shipments with this state province on its destination stop
         * @param {string} [deliveryStopsStateProvince] Return shipments with this state province on its delivery stops
         * @param {string} [drayageBookingNumberContains] Include shipments where the drayage booking number contains this value
         * @param {string} [drayageChassisNumberContains] Include shipments where the drayage chassis number contains this value
         * @param {string} [drayageContainerNumberContains] Include shipments where the drayage container number contains this value
         * @param {string} [drayageContainerReturnDateGte] Include shipments where the drayage container return date is greater than or equal to this value
         * @param {string} [drayageContainerReturnDateLte] Include shipments where the drayage container return date is less than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateGte] Include shipments where the drayage estimated arrival date is greater than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateLte] Include shipments where the drayage estimated arrival date is less than or equal to this value
         * @param {string} [drayageLastFreeDateGte] Include shipments where the drayage last free datetime is greater than or equal to this value
         * @param {string} [drayageLastFreeDateLte] Include shipments where the drayage last free datetime is less than or equal to this value
         * @param {string} [drayageReleaseDateGte] Include shipments where the drayage release datetime is greater than or equal to this value
         * @param {string} [drayageReleaseDateLte] Include shipments where the drayage release datetime is less than or equal to this value
         * @param {string} [drayageSealNumberContains] Include shipments where the drayage seal number contains this value
         * @param {string} [dropoffGte] Return shipments with a dropoff stop with a planned date greater than or equal to this value
         * @param {string} [dropoffLte] Return shipments with a dropoff stop with a planned data less than or equal to this value
         * @param {string} [expiresAtGte] Include load board shipments where expires_at is greater than or equal to this value
         * @param {string} [expiresAtLte] Include load board shipments where expires_at is less than or equal to this value
         * @param {Array<'bidding' | 'closed' | 'open' | 'won' | 'tendered' | 'accepted' | 'rejected' | 'expired'>} [biddingStatus] The bidding status of shipments on the load board
         * @param {Array<'open' | 'accepted' | 'rejected' | 'revoked' | 'expired'>} [tenderStatus] The tender status of shipments on the load board
         * @param {boolean} [loadBoardEnabled] Filter on whether or not a shipment is posted on the company load board
         * @param {string} [nameContains] Return shipments where the shipment name contains this value
         * @param {boolean} [open] Filter on whether or not a shipment is open
         * @param {string} [originContains] Return shipments with this value in the origin
         * @param {string} [originStateProvince] Return shipments with this state province on its origin stop
         * @param {string} [pickupStopsStateProvince] Return shipments with this state province on its pickup stops
         * @param {string} [pickupStopsContains] Return shipments with this value in one of its pickup stops
         * @param {string} [pickupStopsCompanyNameContains] Return shipments with this value in one of its pickup stops location company_name
         * @param {string} [pickupGte] Return shipments with a pickup stop with a planned date greater than or equal to this value
         * @param {string} [pickupLte] Return shipments with a pickup stop with a planned date less than or equal to this value
         * @param {Array<string>} [pickupNumber] Include shipments with these Pickup Numbers
         * @param {string} [pickupNumberContains] Include shipments where the Pickup Number contains this value
         * @param {Array<string>} [pickupNumberExclude] Exclude shipments with these Pickup Numbers
         * @param {Array<string>} [proNumber] Include shipments with these PRO Numbers
         * @param {string} [proNumberContains] Return shipments where the PRO number contains this value
         * @param {Array<string>} [proNumberExclude] Exclude shipments with these PRO Numbers
         * @param {Array<string>} [purchaseOrderNumber] Include shipments with these PO Numbers
         * @param {string} [purchaseOrderNumberContains] Include shipments where the PO number contains this value
         * @param {Array<string>} [purchaseOrderNumberExclude] Exclude shipments with these PO Numbers
         * @param {Array<string>} [referenceId] Include shipments with these Reference IDs
         * @param {string} [referenceIdContains] Include shipments where the reference ID contains this value
         * @param {Array<string>} [referenceIdExclude] Exclude shipments with these Reference IDs
         * @param {Array<string>} [masterAirWaybill] Include shipments with these Master Air Waybill Numbers
         * @param {string} [masterAirWaybillContains] Include shipments where the Master Air Waybill number contains this value
         * @param {Array<string>} [houseAirWaybill] Include shipments with these House Air Waybill Numbers
         * @param {string} [houseAirWaybillContains] Include shipments where the House Air Waybill number contains this value
         * @param {Array<string>} [reps] Include shipments with these reps
         * @param {Array<string>} [requestedEquipmentTypes] Return shipments where the load board offering company requests these equipment type machine readable codes
         * @param {Array<string>} [requestedEquipmentTypesContains] Return shipments where the load board offering company requests equipment types that partially match machine readable codes
         * @param {Array<string>} [requestedShipmentModes] Return shipments where the load board offering company requests these shipment mode codes
         * @param {string} [createdAtGte] Include shipments where created_at is greater than or equal to the time value
         * @param {string} [createdAtLte] Include shipments where created_at is less than or equal to this value
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [statusExclude] Exclude shipments with these statuses
         * @param {string} [statusContains] Include shipments where the status contains this string
         * @param {Array<string>} [tags] Include only shipments with at least one matching ShipmentTag
         * @param {string} [stopsContains] Return shipments with this value in one of its stops
         * @param {string} [stopsCompanyNameContains] Return shipments with this value in one of its stops location company_name
         * @param {string} [stopsStateProvince] Return shipments with this state province on one of its stops
         * @param {number} [totalMilesGte] Return shipments with total miles greater than or equal to this value
         * @param {number} [totalMilesLte] Return shipments with total miles less than or equal to this value
         * @param {string} [vendorId] Return shipments with this exact value as the vendor Carrier id
         * @param {string} [vendorContains] Return shipments where the vendor company name contains this value
         * @param {number} [totalWeightOverrideGte] Return shipments with weight greater than or equal to this value
         * @param {number} [totalWeightOverrideLte] Return shipments with weight less than or equal to this value
         * @param {number} [originRadius] Radius from origin stop
         * @param {number} [originLat] Latitude of location to filter on for origin stop
         * @param {number} [originLon] Longitude of location to filter on for origin stop
         * @param {number} [pickupRadius] Radius from a pickup stop
         * @param {number} [pickupLat] Latitude of location to filter on for pickup stop
         * @param {number} [pickupLon] Longitude of location to filter on for pickup stop
         * @param {number} [destinationRadius] Radius from the destination stop
         * @param {number} [destinationLat] Latitude of location to filter on for destination stop
         * @param {number} [destinationLon] Longitude of location to filter on for destination stop
         * @param {number} [deliveryRadius] Radius from a delivery stop
         * @param {number} [deliveryLat] Latitude of location to filter on for delivery stop
         * @param {number} [deliveryLon] Longitude of location to filter on for delivery stop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingLoadboardGet: function (page, pageSize, ordering, q, activeVendorAssignment, archived, bolNumber, bolNumberContains, bolNumberExclude, buyItNowAmountGte, buyItNowAmountLte, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, dropoffGte, dropoffLte, expiresAtGte, expiresAtLte, biddingStatus, tenderStatus, loadBoardEnabled, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, pickupGte, pickupLte, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, requestedEquipmentTypes, requestedEquipmentTypesContains, requestedShipmentModes, createdAtGte, createdAtLte, status, statusExclude, statusContains, tags, stopsContains, stopsCompanyNameContains, stopsStateProvince, totalMilesGte, totalMilesLte, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/quoting/loadboard/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (activeVendorAssignment !== undefined) {
                                localVarQueryParameter['active_vendor_assignment'] = activeVendorAssignment;
                            }
                            if (archived !== undefined) {
                                localVarQueryParameter['archived'] = archived;
                            }
                            if (bolNumber) {
                                localVarQueryParameter['bol_number'] = bolNumber;
                            }
                            if (bolNumberContains !== undefined) {
                                localVarQueryParameter['bol_number__contains'] = bolNumberContains;
                            }
                            if (bolNumberExclude) {
                                localVarQueryParameter['bol_number__exclude'] = bolNumberExclude;
                            }
                            if (buyItNowAmountGte !== undefined) {
                                localVarQueryParameter['buy_it_now_amount__gte'] = buyItNowAmountGte;
                            }
                            if (buyItNowAmountLte !== undefined) {
                                localVarQueryParameter['buy_it_now_amount__lte'] = buyItNowAmountLte;
                            }
                            if (customer !== undefined) {
                                localVarQueryParameter['customer'] = customer;
                            }
                            if (customerContains !== undefined) {
                                localVarQueryParameter['customer__contains'] = customerContains;
                            }
                            if (customerId !== undefined) {
                                localVarQueryParameter['customer_id'] = customerId;
                            }
                            if (customerReferenceNumber) {
                                localVarQueryParameter['customer_reference_number'] = customerReferenceNumber;
                            }
                            if (customerReferenceNumberContains !== undefined) {
                                localVarQueryParameter['customer_reference_number__contains'] = customerReferenceNumberContains;
                            }
                            if (customerReferenceNumberExclude) {
                                localVarQueryParameter['customer_reference_number__exclude'] = customerReferenceNumberExclude;
                            }
                            if (deliveryStopsContains !== undefined) {
                                localVarQueryParameter['delivery_stops__contains'] = deliveryStopsContains;
                            }
                            if (deliveryStopsCompanyNameContains !== undefined) {
                                localVarQueryParameter['delivery_stops_company_name__contains'] = deliveryStopsCompanyNameContains;
                            }
                            if (destinationContains !== undefined) {
                                localVarQueryParameter['destination__contains'] = destinationContains;
                            }
                            if (destinationStateProvince !== undefined) {
                                localVarQueryParameter['destination_state_province'] = destinationStateProvince;
                            }
                            if (deliveryStopsStateProvince !== undefined) {
                                localVarQueryParameter['delivery_stops_state_province'] = deliveryStopsStateProvince;
                            }
                            if (drayageBookingNumberContains !== undefined) {
                                localVarQueryParameter['drayage_booking_number__contains'] = drayageBookingNumberContains;
                            }
                            if (drayageChassisNumberContains !== undefined) {
                                localVarQueryParameter['drayage_chassis_number__contains'] = drayageChassisNumberContains;
                            }
                            if (drayageContainerNumberContains !== undefined) {
                                localVarQueryParameter['drayage_container_number__contains'] = drayageContainerNumberContains;
                            }
                            if (drayageContainerReturnDateGte !== undefined) {
                                localVarQueryParameter['drayage_container_return_date__gte'] = drayageContainerReturnDateGte;
                            }
                            if (drayageContainerReturnDateLte !== undefined) {
                                localVarQueryParameter['drayage_container_return_date__lte'] = drayageContainerReturnDateLte;
                            }
                            if (drayageEstimatedArrivalDateGte !== undefined) {
                                localVarQueryParameter['drayage_estimated_arrival_date__gte'] = drayageEstimatedArrivalDateGte;
                            }
                            if (drayageEstimatedArrivalDateLte !== undefined) {
                                localVarQueryParameter['drayage_estimated_arrival_date__lte'] = drayageEstimatedArrivalDateLte;
                            }
                            if (drayageLastFreeDateGte !== undefined) {
                                localVarQueryParameter['drayage_last_free_date__gte'] = drayageLastFreeDateGte;
                            }
                            if (drayageLastFreeDateLte !== undefined) {
                                localVarQueryParameter['drayage_last_free_date__lte'] = drayageLastFreeDateLte;
                            }
                            if (drayageReleaseDateGte !== undefined) {
                                localVarQueryParameter['drayage_release_date__gte'] = drayageReleaseDateGte;
                            }
                            if (drayageReleaseDateLte !== undefined) {
                                localVarQueryParameter['drayage_release_date__lte'] = drayageReleaseDateLte;
                            }
                            if (drayageSealNumberContains !== undefined) {
                                localVarQueryParameter['drayage_seal_number__contains'] = drayageSealNumberContains;
                            }
                            if (dropoffGte !== undefined) {
                                localVarQueryParameter['dropoff__gte'] = (dropoffGte instanceof Date) ?
                                    dropoffGte.toISOString().substr(0, 10) :
                                    dropoffGte;
                            }
                            if (dropoffLte !== undefined) {
                                localVarQueryParameter['dropoff__lte'] = (dropoffLte instanceof Date) ?
                                    dropoffLte.toISOString().substr(0, 10) :
                                    dropoffLte;
                            }
                            if (expiresAtGte !== undefined) {
                                localVarQueryParameter['expires_at__gte'] = (expiresAtGte instanceof Date) ?
                                    expiresAtGte.toISOString().substr(0, 10) :
                                    expiresAtGte;
                            }
                            if (expiresAtLte !== undefined) {
                                localVarQueryParameter['expires_at__lte'] = (expiresAtLte instanceof Date) ?
                                    expiresAtLte.toISOString().substr(0, 10) :
                                    expiresAtLte;
                            }
                            if (biddingStatus) {
                                localVarQueryParameter['bidding_status'] = biddingStatus;
                            }
                            if (tenderStatus) {
                                localVarQueryParameter['tender_status'] = tenderStatus;
                            }
                            if (loadBoardEnabled !== undefined) {
                                localVarQueryParameter['load_board_enabled'] = loadBoardEnabled;
                            }
                            if (nameContains !== undefined) {
                                localVarQueryParameter['name__contains'] = nameContains;
                            }
                            if (open !== undefined) {
                                localVarQueryParameter['open'] = open;
                            }
                            if (originContains !== undefined) {
                                localVarQueryParameter['origin__contains'] = originContains;
                            }
                            if (originStateProvince !== undefined) {
                                localVarQueryParameter['origin_state_province'] = originStateProvince;
                            }
                            if (pickupStopsStateProvince !== undefined) {
                                localVarQueryParameter['pickup_stops_state_province'] = pickupStopsStateProvince;
                            }
                            if (pickupStopsContains !== undefined) {
                                localVarQueryParameter['pickup_stops__contains'] = pickupStopsContains;
                            }
                            if (pickupStopsCompanyNameContains !== undefined) {
                                localVarQueryParameter['pickup_stops_company_name__contains'] = pickupStopsCompanyNameContains;
                            }
                            if (pickupGte !== undefined) {
                                localVarQueryParameter['pickup__gte'] = (pickupGte instanceof Date) ?
                                    pickupGte.toISOString().substr(0, 10) :
                                    pickupGte;
                            }
                            if (pickupLte !== undefined) {
                                localVarQueryParameter['pickup__lte'] = (pickupLte instanceof Date) ?
                                    pickupLte.toISOString().substr(0, 10) :
                                    pickupLte;
                            }
                            if (pickupNumber) {
                                localVarQueryParameter['pickup_number'] = pickupNumber;
                            }
                            if (pickupNumberContains !== undefined) {
                                localVarQueryParameter['pickup_number__contains'] = pickupNumberContains;
                            }
                            if (pickupNumberExclude) {
                                localVarQueryParameter['pickup_number__exclude'] = pickupNumberExclude;
                            }
                            if (proNumber) {
                                localVarQueryParameter['pro_number'] = proNumber;
                            }
                            if (proNumberContains !== undefined) {
                                localVarQueryParameter['pro_number__contains'] = proNumberContains;
                            }
                            if (proNumberExclude) {
                                localVarQueryParameter['pro_number__exclude'] = proNumberExclude;
                            }
                            if (purchaseOrderNumber) {
                                localVarQueryParameter['purchase_order_number'] = purchaseOrderNumber;
                            }
                            if (purchaseOrderNumberContains !== undefined) {
                                localVarQueryParameter['purchase_order_number__contains'] = purchaseOrderNumberContains;
                            }
                            if (purchaseOrderNumberExclude) {
                                localVarQueryParameter['purchase_order_number__exclude'] = purchaseOrderNumberExclude;
                            }
                            if (referenceId) {
                                localVarQueryParameter['reference_id'] = referenceId;
                            }
                            if (referenceIdContains !== undefined) {
                                localVarQueryParameter['reference_id__contains'] = referenceIdContains;
                            }
                            if (referenceIdExclude) {
                                localVarQueryParameter['reference_id__exclude'] = referenceIdExclude;
                            }
                            if (masterAirWaybill) {
                                localVarQueryParameter['master_air_waybill'] = masterAirWaybill;
                            }
                            if (masterAirWaybillContains !== undefined) {
                                localVarQueryParameter['master_air_waybill__contains'] = masterAirWaybillContains;
                            }
                            if (houseAirWaybill) {
                                localVarQueryParameter['house_air_waybill'] = houseAirWaybill;
                            }
                            if (houseAirWaybillContains !== undefined) {
                                localVarQueryParameter['house_air_waybill__contains'] = houseAirWaybillContains;
                            }
                            if (reps) {
                                localVarQueryParameter['reps'] = reps;
                            }
                            if (requestedEquipmentTypes) {
                                localVarQueryParameter['requested_equipment_types'] = requestedEquipmentTypes;
                            }
                            if (requestedEquipmentTypesContains) {
                                localVarQueryParameter['requested_equipment_types__contains'] = requestedEquipmentTypesContains;
                            }
                            if (requestedShipmentModes) {
                                localVarQueryParameter['requested_shipment_modes'] = requestedShipmentModes;
                            }
                            if (createdAtGte !== undefined) {
                                localVarQueryParameter['created_at__gte'] = (createdAtGte instanceof Date) ?
                                    createdAtGte.toISOString() :
                                    createdAtGte;
                            }
                            if (createdAtLte !== undefined) {
                                localVarQueryParameter['created_at__lte'] = (createdAtLte instanceof Date) ?
                                    createdAtLte.toISOString() :
                                    createdAtLte;
                            }
                            if (status) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (statusExclude) {
                                localVarQueryParameter['status__exclude'] = statusExclude;
                            }
                            if (statusContains !== undefined) {
                                localVarQueryParameter['status__contains'] = statusContains;
                            }
                            if (tags) {
                                localVarQueryParameter['tags'] = tags;
                            }
                            if (stopsContains !== undefined) {
                                localVarQueryParameter['stops__contains'] = stopsContains;
                            }
                            if (stopsCompanyNameContains !== undefined) {
                                localVarQueryParameter['stops_company_name__contains'] = stopsCompanyNameContains;
                            }
                            if (stopsStateProvince !== undefined) {
                                localVarQueryParameter['stops_state_province'] = stopsStateProvince;
                            }
                            if (totalMilesGte !== undefined) {
                                localVarQueryParameter['total_miles__gte'] = totalMilesGte;
                            }
                            if (totalMilesLte !== undefined) {
                                localVarQueryParameter['total_miles__lte'] = totalMilesLte;
                            }
                            if (vendorId !== undefined) {
                                localVarQueryParameter['vendor_id'] = vendorId;
                            }
                            if (vendorContains !== undefined) {
                                localVarQueryParameter['vendor__contains'] = vendorContains;
                            }
                            if (totalWeightOverrideGte !== undefined) {
                                localVarQueryParameter['total_weight_override__gte'] = totalWeightOverrideGte;
                            }
                            if (totalWeightOverrideLte !== undefined) {
                                localVarQueryParameter['total_weight_override__lte'] = totalWeightOverrideLte;
                            }
                            if (originRadius !== undefined) {
                                localVarQueryParameter['origin_radius'] = originRadius;
                            }
                            if (originLat !== undefined) {
                                localVarQueryParameter['origin_lat'] = originLat;
                            }
                            if (originLon !== undefined) {
                                localVarQueryParameter['origin_lon'] = originLon;
                            }
                            if (pickupRadius !== undefined) {
                                localVarQueryParameter['pickup_radius'] = pickupRadius;
                            }
                            if (pickupLat !== undefined) {
                                localVarQueryParameter['pickup_lat'] = pickupLat;
                            }
                            if (pickupLon !== undefined) {
                                localVarQueryParameter['pickup_lon'] = pickupLon;
                            }
                            if (destinationRadius !== undefined) {
                                localVarQueryParameter['destination_radius'] = destinationRadius;
                            }
                            if (destinationLat !== undefined) {
                                localVarQueryParameter['destination_lat'] = destinationLat;
                            }
                            if (destinationLon !== undefined) {
                                localVarQueryParameter['destination_lon'] = destinationLon;
                            }
                            if (deliveryRadius !== undefined) {
                                localVarQueryParameter['delivery_radius'] = deliveryRadius;
                            }
                            if (deliveryLat !== undefined) {
                                localVarQueryParameter['delivery_lat'] = deliveryLat;
                            }
                            if (deliveryLon !== undefined) {
                                localVarQueryParameter['delivery_lon'] = deliveryLon;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a load board shipment by its id
         * @param {string} loadBoardShipmentId The load board ID of a shipment on the load board
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingLoadboardLoadBoardShipmentIdGet: function (loadBoardShipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loadBoardShipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingLoadboardLoadBoardShipmentIdGet', 'loadBoardShipmentId', loadBoardShipmentId);
                            localVarPath = "/quoting/loadboard/{loadBoardShipmentId}/"
                                .replace("{".concat("loadBoardShipmentId", "}"), encodeURIComponent(String(loadBoardShipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a spot negotiation for a load board shipment
         * @param {string} loadBoardShipmentId The load board ID of a shipment on the load board
         * @param {SpotNegotiation} spotNegotiation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingLoadboardLoadBoardShipmentIdSpotNegotiationsPost: function (loadBoardShipmentId, spotNegotiation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'loadBoardShipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingLoadboardLoadBoardShipmentIdSpotNegotiationsPost', 'loadBoardShipmentId', loadBoardShipmentId);
                            // verify required parameter 'spotNegotiation' is not null or undefined
                            (0, common_1.assertParamExists)('quotingLoadboardLoadBoardShipmentIdSpotNegotiationsPost', 'spotNegotiation', spotNegotiation);
                            localVarPath = "/quoting/loadboard/{loadBoardShipmentId}/spot-negotiations/"
                                .replace("{".concat("loadBoardShipmentId", "}"), encodeURIComponent(String(loadBoardShipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(spotNegotiation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.LoadboardApiAxiosParamCreator = LoadboardApiAxiosParamCreator;
/**
 * LoadboardApi - functional programming interface
 * @export
 */
var LoadboardApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LoadboardApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary List all shipments available on a carrier load board
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [activeVendorAssignment] Include or exclude shipments with active CarrierAssignments
         * @param {boolean} [archived] Filter on whether or not a shipment is archived
         * @param {Array<string>} [bolNumber] Include shipments with these BOL Numbers
         * @param {string} [bolNumberContains] Return shipments where the BOL number contains this value
         * @param {Array<string>} [bolNumberExclude] Exclude shipments with these BOL Numbers
         * @param {number} [buyItNowAmountGte] Return shipments with a buy-it-now amount greater than or equal to this value
         * @param {number} [buyItNowAmountLte] Return shipments with a buy-it-now amount less than or equal to this value
         * @param {string} [customer] Return shipments with this exact value as the customer company name
         * @param {string} [customerContains] Return shipments where the customer company name contains this value
         * @param {string} [customerId] Return shipments with this exact id for the customer company
         * @param {Array<string>} [customerReferenceNumber] Include shipments with these Customer Reference Numbers
         * @param {string} [customerReferenceNumberContains] Include shipments where the Customer Reference Numbers contains this value
         * @param {Array<string>} [customerReferenceNumberExclude] Exclude shipments with these Customer Reference Numbers
         * @param {string} [deliveryStopsContains] Return shipments with this value in one of its dropoff stops
         * @param {string} [deliveryStopsCompanyNameContains] Return shipments with this value in one of its delivery stops location company_name
         * @param {string} [destinationContains] Return shipments with this value in the destination
         * @param {string} [destinationStateProvince] Return shipments with this state province on its destination stop
         * @param {string} [deliveryStopsStateProvince] Return shipments with this state province on its delivery stops
         * @param {string} [drayageBookingNumberContains] Include shipments where the drayage booking number contains this value
         * @param {string} [drayageChassisNumberContains] Include shipments where the drayage chassis number contains this value
         * @param {string} [drayageContainerNumberContains] Include shipments where the drayage container number contains this value
         * @param {string} [drayageContainerReturnDateGte] Include shipments where the drayage container return date is greater than or equal to this value
         * @param {string} [drayageContainerReturnDateLte] Include shipments where the drayage container return date is less than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateGte] Include shipments where the drayage estimated arrival date is greater than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateLte] Include shipments where the drayage estimated arrival date is less than or equal to this value
         * @param {string} [drayageLastFreeDateGte] Include shipments where the drayage last free datetime is greater than or equal to this value
         * @param {string} [drayageLastFreeDateLte] Include shipments where the drayage last free datetime is less than or equal to this value
         * @param {string} [drayageReleaseDateGte] Include shipments where the drayage release datetime is greater than or equal to this value
         * @param {string} [drayageReleaseDateLte] Include shipments where the drayage release datetime is less than or equal to this value
         * @param {string} [drayageSealNumberContains] Include shipments where the drayage seal number contains this value
         * @param {string} [dropoffGte] Return shipments with a dropoff stop with a planned date greater than or equal to this value
         * @param {string} [dropoffLte] Return shipments with a dropoff stop with a planned data less than or equal to this value
         * @param {string} [expiresAtGte] Include load board shipments where expires_at is greater than or equal to this value
         * @param {string} [expiresAtLte] Include load board shipments where expires_at is less than or equal to this value
         * @param {Array<'bidding' | 'closed' | 'open' | 'won' | 'tendered' | 'accepted' | 'rejected' | 'expired'>} [biddingStatus] The bidding status of shipments on the load board
         * @param {Array<'open' | 'accepted' | 'rejected' | 'revoked' | 'expired'>} [tenderStatus] The tender status of shipments on the load board
         * @param {boolean} [loadBoardEnabled] Filter on whether or not a shipment is posted on the company load board
         * @param {string} [nameContains] Return shipments where the shipment name contains this value
         * @param {boolean} [open] Filter on whether or not a shipment is open
         * @param {string} [originContains] Return shipments with this value in the origin
         * @param {string} [originStateProvince] Return shipments with this state province on its origin stop
         * @param {string} [pickupStopsStateProvince] Return shipments with this state province on its pickup stops
         * @param {string} [pickupStopsContains] Return shipments with this value in one of its pickup stops
         * @param {string} [pickupStopsCompanyNameContains] Return shipments with this value in one of its pickup stops location company_name
         * @param {string} [pickupGte] Return shipments with a pickup stop with a planned date greater than or equal to this value
         * @param {string} [pickupLte] Return shipments with a pickup stop with a planned date less than or equal to this value
         * @param {Array<string>} [pickupNumber] Include shipments with these Pickup Numbers
         * @param {string} [pickupNumberContains] Include shipments where the Pickup Number contains this value
         * @param {Array<string>} [pickupNumberExclude] Exclude shipments with these Pickup Numbers
         * @param {Array<string>} [proNumber] Include shipments with these PRO Numbers
         * @param {string} [proNumberContains] Return shipments where the PRO number contains this value
         * @param {Array<string>} [proNumberExclude] Exclude shipments with these PRO Numbers
         * @param {Array<string>} [purchaseOrderNumber] Include shipments with these PO Numbers
         * @param {string} [purchaseOrderNumberContains] Include shipments where the PO number contains this value
         * @param {Array<string>} [purchaseOrderNumberExclude] Exclude shipments with these PO Numbers
         * @param {Array<string>} [referenceId] Include shipments with these Reference IDs
         * @param {string} [referenceIdContains] Include shipments where the reference ID contains this value
         * @param {Array<string>} [referenceIdExclude] Exclude shipments with these Reference IDs
         * @param {Array<string>} [masterAirWaybill] Include shipments with these Master Air Waybill Numbers
         * @param {string} [masterAirWaybillContains] Include shipments where the Master Air Waybill number contains this value
         * @param {Array<string>} [houseAirWaybill] Include shipments with these House Air Waybill Numbers
         * @param {string} [houseAirWaybillContains] Include shipments where the House Air Waybill number contains this value
         * @param {Array<string>} [reps] Include shipments with these reps
         * @param {Array<string>} [requestedEquipmentTypes] Return shipments where the load board offering company requests these equipment type machine readable codes
         * @param {Array<string>} [requestedEquipmentTypesContains] Return shipments where the load board offering company requests equipment types that partially match machine readable codes
         * @param {Array<string>} [requestedShipmentModes] Return shipments where the load board offering company requests these shipment mode codes
         * @param {string} [createdAtGte] Include shipments where created_at is greater than or equal to the time value
         * @param {string} [createdAtLte] Include shipments where created_at is less than or equal to this value
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [statusExclude] Exclude shipments with these statuses
         * @param {string} [statusContains] Include shipments where the status contains this string
         * @param {Array<string>} [tags] Include only shipments with at least one matching ShipmentTag
         * @param {string} [stopsContains] Return shipments with this value in one of its stops
         * @param {string} [stopsCompanyNameContains] Return shipments with this value in one of its stops location company_name
         * @param {string} [stopsStateProvince] Return shipments with this state province on one of its stops
         * @param {number} [totalMilesGte] Return shipments with total miles greater than or equal to this value
         * @param {number} [totalMilesLte] Return shipments with total miles less than or equal to this value
         * @param {string} [vendorId] Return shipments with this exact value as the vendor Carrier id
         * @param {string} [vendorContains] Return shipments where the vendor company name contains this value
         * @param {number} [totalWeightOverrideGte] Return shipments with weight greater than or equal to this value
         * @param {number} [totalWeightOverrideLte] Return shipments with weight less than or equal to this value
         * @param {number} [originRadius] Radius from origin stop
         * @param {number} [originLat] Latitude of location to filter on for origin stop
         * @param {number} [originLon] Longitude of location to filter on for origin stop
         * @param {number} [pickupRadius] Radius from a pickup stop
         * @param {number} [pickupLat] Latitude of location to filter on for pickup stop
         * @param {number} [pickupLon] Longitude of location to filter on for pickup stop
         * @param {number} [destinationRadius] Radius from the destination stop
         * @param {number} [destinationLat] Latitude of location to filter on for destination stop
         * @param {number} [destinationLon] Longitude of location to filter on for destination stop
         * @param {number} [deliveryRadius] Radius from a delivery stop
         * @param {number} [deliveryLat] Latitude of location to filter on for delivery stop
         * @param {number} [deliveryLon] Longitude of location to filter on for delivery stop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingLoadboardGet: function (page, pageSize, ordering, q, activeVendorAssignment, archived, bolNumber, bolNumberContains, bolNumberExclude, buyItNowAmountGte, buyItNowAmountLte, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, dropoffGte, dropoffLte, expiresAtGte, expiresAtLte, biddingStatus, tenderStatus, loadBoardEnabled, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, pickupGte, pickupLte, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, requestedEquipmentTypes, requestedEquipmentTypesContains, requestedShipmentModes, createdAtGte, createdAtLte, status, statusExclude, statusContains, tags, stopsContains, stopsCompanyNameContains, stopsStateProvince, totalMilesGte, totalMilesLte, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingLoadboardGet(page, pageSize, ordering, q, activeVendorAssignment, archived, bolNumber, bolNumberContains, bolNumberExclude, buyItNowAmountGte, buyItNowAmountLte, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, dropoffGte, dropoffLte, expiresAtGte, expiresAtLte, biddingStatus, tenderStatus, loadBoardEnabled, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, pickupGte, pickupLte, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, requestedEquipmentTypes, requestedEquipmentTypesContains, requestedShipmentModes, createdAtGte, createdAtLte, status, statusExclude, statusContains, tags, stopsContains, stopsCompanyNameContains, stopsStateProvince, totalMilesGte, totalMilesLte, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a load board shipment by its id
         * @param {string} loadBoardShipmentId The load board ID of a shipment on the load board
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingLoadboardLoadBoardShipmentIdGet: function (loadBoardShipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingLoadboardLoadBoardShipmentIdGet(loadBoardShipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a spot negotiation for a load board shipment
         * @param {string} loadBoardShipmentId The load board ID of a shipment on the load board
         * @param {SpotNegotiation} spotNegotiation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingLoadboardLoadBoardShipmentIdSpotNegotiationsPost: function (loadBoardShipmentId, spotNegotiation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingLoadboardLoadBoardShipmentIdSpotNegotiationsPost(loadBoardShipmentId, spotNegotiation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.LoadboardApiFp = LoadboardApiFp;
/**
 * LoadboardApi - factory interface
 * @export
 */
var LoadboardApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LoadboardApiFp)(configuration);
    return {
        /**
         *
         * @summary List all shipments available on a carrier load board
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [activeVendorAssignment] Include or exclude shipments with active CarrierAssignments
         * @param {boolean} [archived] Filter on whether or not a shipment is archived
         * @param {Array<string>} [bolNumber] Include shipments with these BOL Numbers
         * @param {string} [bolNumberContains] Return shipments where the BOL number contains this value
         * @param {Array<string>} [bolNumberExclude] Exclude shipments with these BOL Numbers
         * @param {number} [buyItNowAmountGte] Return shipments with a buy-it-now amount greater than or equal to this value
         * @param {number} [buyItNowAmountLte] Return shipments with a buy-it-now amount less than or equal to this value
         * @param {string} [customer] Return shipments with this exact value as the customer company name
         * @param {string} [customerContains] Return shipments where the customer company name contains this value
         * @param {string} [customerId] Return shipments with this exact id for the customer company
         * @param {Array<string>} [customerReferenceNumber] Include shipments with these Customer Reference Numbers
         * @param {string} [customerReferenceNumberContains] Include shipments where the Customer Reference Numbers contains this value
         * @param {Array<string>} [customerReferenceNumberExclude] Exclude shipments with these Customer Reference Numbers
         * @param {string} [deliveryStopsContains] Return shipments with this value in one of its dropoff stops
         * @param {string} [deliveryStopsCompanyNameContains] Return shipments with this value in one of its delivery stops location company_name
         * @param {string} [destinationContains] Return shipments with this value in the destination
         * @param {string} [destinationStateProvince] Return shipments with this state province on its destination stop
         * @param {string} [deliveryStopsStateProvince] Return shipments with this state province on its delivery stops
         * @param {string} [drayageBookingNumberContains] Include shipments where the drayage booking number contains this value
         * @param {string} [drayageChassisNumberContains] Include shipments where the drayage chassis number contains this value
         * @param {string} [drayageContainerNumberContains] Include shipments where the drayage container number contains this value
         * @param {string} [drayageContainerReturnDateGte] Include shipments where the drayage container return date is greater than or equal to this value
         * @param {string} [drayageContainerReturnDateLte] Include shipments where the drayage container return date is less than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateGte] Include shipments where the drayage estimated arrival date is greater than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateLte] Include shipments where the drayage estimated arrival date is less than or equal to this value
         * @param {string} [drayageLastFreeDateGte] Include shipments where the drayage last free datetime is greater than or equal to this value
         * @param {string} [drayageLastFreeDateLte] Include shipments where the drayage last free datetime is less than or equal to this value
         * @param {string} [drayageReleaseDateGte] Include shipments where the drayage release datetime is greater than or equal to this value
         * @param {string} [drayageReleaseDateLte] Include shipments where the drayage release datetime is less than or equal to this value
         * @param {string} [drayageSealNumberContains] Include shipments where the drayage seal number contains this value
         * @param {string} [dropoffGte] Return shipments with a dropoff stop with a planned date greater than or equal to this value
         * @param {string} [dropoffLte] Return shipments with a dropoff stop with a planned data less than or equal to this value
         * @param {string} [expiresAtGte] Include load board shipments where expires_at is greater than or equal to this value
         * @param {string} [expiresAtLte] Include load board shipments where expires_at is less than or equal to this value
         * @param {Array<'bidding' | 'closed' | 'open' | 'won' | 'tendered' | 'accepted' | 'rejected' | 'expired'>} [biddingStatus] The bidding status of shipments on the load board
         * @param {Array<'open' | 'accepted' | 'rejected' | 'revoked' | 'expired'>} [tenderStatus] The tender status of shipments on the load board
         * @param {boolean} [loadBoardEnabled] Filter on whether or not a shipment is posted on the company load board
         * @param {string} [nameContains] Return shipments where the shipment name contains this value
         * @param {boolean} [open] Filter on whether or not a shipment is open
         * @param {string} [originContains] Return shipments with this value in the origin
         * @param {string} [originStateProvince] Return shipments with this state province on its origin stop
         * @param {string} [pickupStopsStateProvince] Return shipments with this state province on its pickup stops
         * @param {string} [pickupStopsContains] Return shipments with this value in one of its pickup stops
         * @param {string} [pickupStopsCompanyNameContains] Return shipments with this value in one of its pickup stops location company_name
         * @param {string} [pickupGte] Return shipments with a pickup stop with a planned date greater than or equal to this value
         * @param {string} [pickupLte] Return shipments with a pickup stop with a planned date less than or equal to this value
         * @param {Array<string>} [pickupNumber] Include shipments with these Pickup Numbers
         * @param {string} [pickupNumberContains] Include shipments where the Pickup Number contains this value
         * @param {Array<string>} [pickupNumberExclude] Exclude shipments with these Pickup Numbers
         * @param {Array<string>} [proNumber] Include shipments with these PRO Numbers
         * @param {string} [proNumberContains] Return shipments where the PRO number contains this value
         * @param {Array<string>} [proNumberExclude] Exclude shipments with these PRO Numbers
         * @param {Array<string>} [purchaseOrderNumber] Include shipments with these PO Numbers
         * @param {string} [purchaseOrderNumberContains] Include shipments where the PO number contains this value
         * @param {Array<string>} [purchaseOrderNumberExclude] Exclude shipments with these PO Numbers
         * @param {Array<string>} [referenceId] Include shipments with these Reference IDs
         * @param {string} [referenceIdContains] Include shipments where the reference ID contains this value
         * @param {Array<string>} [referenceIdExclude] Exclude shipments with these Reference IDs
         * @param {Array<string>} [masterAirWaybill] Include shipments with these Master Air Waybill Numbers
         * @param {string} [masterAirWaybillContains] Include shipments where the Master Air Waybill number contains this value
         * @param {Array<string>} [houseAirWaybill] Include shipments with these House Air Waybill Numbers
         * @param {string} [houseAirWaybillContains] Include shipments where the House Air Waybill number contains this value
         * @param {Array<string>} [reps] Include shipments with these reps
         * @param {Array<string>} [requestedEquipmentTypes] Return shipments where the load board offering company requests these equipment type machine readable codes
         * @param {Array<string>} [requestedEquipmentTypesContains] Return shipments where the load board offering company requests equipment types that partially match machine readable codes
         * @param {Array<string>} [requestedShipmentModes] Return shipments where the load board offering company requests these shipment mode codes
         * @param {string} [createdAtGte] Include shipments where created_at is greater than or equal to the time value
         * @param {string} [createdAtLte] Include shipments where created_at is less than or equal to this value
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [statusExclude] Exclude shipments with these statuses
         * @param {string} [statusContains] Include shipments where the status contains this string
         * @param {Array<string>} [tags] Include only shipments with at least one matching ShipmentTag
         * @param {string} [stopsContains] Return shipments with this value in one of its stops
         * @param {string} [stopsCompanyNameContains] Return shipments with this value in one of its stops location company_name
         * @param {string} [stopsStateProvince] Return shipments with this state province on one of its stops
         * @param {number} [totalMilesGte] Return shipments with total miles greater than or equal to this value
         * @param {number} [totalMilesLte] Return shipments with total miles less than or equal to this value
         * @param {string} [vendorId] Return shipments with this exact value as the vendor Carrier id
         * @param {string} [vendorContains] Return shipments where the vendor company name contains this value
         * @param {number} [totalWeightOverrideGte] Return shipments with weight greater than or equal to this value
         * @param {number} [totalWeightOverrideLte] Return shipments with weight less than or equal to this value
         * @param {number} [originRadius] Radius from origin stop
         * @param {number} [originLat] Latitude of location to filter on for origin stop
         * @param {number} [originLon] Longitude of location to filter on for origin stop
         * @param {number} [pickupRadius] Radius from a pickup stop
         * @param {number} [pickupLat] Latitude of location to filter on for pickup stop
         * @param {number} [pickupLon] Longitude of location to filter on for pickup stop
         * @param {number} [destinationRadius] Radius from the destination stop
         * @param {number} [destinationLat] Latitude of location to filter on for destination stop
         * @param {number} [destinationLon] Longitude of location to filter on for destination stop
         * @param {number} [deliveryRadius] Radius from a delivery stop
         * @param {number} [deliveryLat] Latitude of location to filter on for delivery stop
         * @param {number} [deliveryLon] Longitude of location to filter on for delivery stop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingLoadboardGet: function (page, pageSize, ordering, q, activeVendorAssignment, archived, bolNumber, bolNumberContains, bolNumberExclude, buyItNowAmountGte, buyItNowAmountLte, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, dropoffGte, dropoffLte, expiresAtGte, expiresAtLte, biddingStatus, tenderStatus, loadBoardEnabled, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, pickupGte, pickupLte, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, requestedEquipmentTypes, requestedEquipmentTypesContains, requestedShipmentModes, createdAtGte, createdAtLte, status, statusExclude, statusContains, tags, stopsContains, stopsCompanyNameContains, stopsStateProvince, totalMilesGte, totalMilesLte, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, options) {
            return localVarFp.quotingLoadboardGet(page, pageSize, ordering, q, activeVendorAssignment, archived, bolNumber, bolNumberContains, bolNumberExclude, buyItNowAmountGte, buyItNowAmountLte, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, dropoffGte, dropoffLte, expiresAtGte, expiresAtLte, biddingStatus, tenderStatus, loadBoardEnabled, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, pickupGte, pickupLte, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, requestedEquipmentTypes, requestedEquipmentTypesContains, requestedShipmentModes, createdAtGte, createdAtLte, status, statusExclude, statusContains, tags, stopsContains, stopsCompanyNameContains, stopsStateProvince, totalMilesGte, totalMilesLte, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a load board shipment by its id
         * @param {string} loadBoardShipmentId The load board ID of a shipment on the load board
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingLoadboardLoadBoardShipmentIdGet: function (loadBoardShipmentId, options) {
            return localVarFp.quotingLoadboardLoadBoardShipmentIdGet(loadBoardShipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a spot negotiation for a load board shipment
         * @param {string} loadBoardShipmentId The load board ID of a shipment on the load board
         * @param {SpotNegotiation} spotNegotiation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingLoadboardLoadBoardShipmentIdSpotNegotiationsPost: function (loadBoardShipmentId, spotNegotiation, options) {
            return localVarFp.quotingLoadboardLoadBoardShipmentIdSpotNegotiationsPost(loadBoardShipmentId, spotNegotiation, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LoadboardApiFactory = LoadboardApiFactory;
/**
 * LoadboardApi - object-oriented interface
 * @export
 * @class LoadboardApi
 * @extends {BaseAPI}
 */
var LoadboardApi = /** @class */ (function (_super) {
    __extends(LoadboardApi, _super);
    function LoadboardApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary List all shipments available on a carrier load board
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {boolean} [activeVendorAssignment] Include or exclude shipments with active CarrierAssignments
     * @param {boolean} [archived] Filter on whether or not a shipment is archived
     * @param {Array<string>} [bolNumber] Include shipments with these BOL Numbers
     * @param {string} [bolNumberContains] Return shipments where the BOL number contains this value
     * @param {Array<string>} [bolNumberExclude] Exclude shipments with these BOL Numbers
     * @param {number} [buyItNowAmountGte] Return shipments with a buy-it-now amount greater than or equal to this value
     * @param {number} [buyItNowAmountLte] Return shipments with a buy-it-now amount less than or equal to this value
     * @param {string} [customer] Return shipments with this exact value as the customer company name
     * @param {string} [customerContains] Return shipments where the customer company name contains this value
     * @param {string} [customerId] Return shipments with this exact id for the customer company
     * @param {Array<string>} [customerReferenceNumber] Include shipments with these Customer Reference Numbers
     * @param {string} [customerReferenceNumberContains] Include shipments where the Customer Reference Numbers contains this value
     * @param {Array<string>} [customerReferenceNumberExclude] Exclude shipments with these Customer Reference Numbers
     * @param {string} [deliveryStopsContains] Return shipments with this value in one of its dropoff stops
     * @param {string} [deliveryStopsCompanyNameContains] Return shipments with this value in one of its delivery stops location company_name
     * @param {string} [destinationContains] Return shipments with this value in the destination
     * @param {string} [destinationStateProvince] Return shipments with this state province on its destination stop
     * @param {string} [deliveryStopsStateProvince] Return shipments with this state province on its delivery stops
     * @param {string} [drayageBookingNumberContains] Include shipments where the drayage booking number contains this value
     * @param {string} [drayageChassisNumberContains] Include shipments where the drayage chassis number contains this value
     * @param {string} [drayageContainerNumberContains] Include shipments where the drayage container number contains this value
     * @param {string} [drayageContainerReturnDateGte] Include shipments where the drayage container return date is greater than or equal to this value
     * @param {string} [drayageContainerReturnDateLte] Include shipments where the drayage container return date is less than or equal to this value
     * @param {string} [drayageEstimatedArrivalDateGte] Include shipments where the drayage estimated arrival date is greater than or equal to this value
     * @param {string} [drayageEstimatedArrivalDateLte] Include shipments where the drayage estimated arrival date is less than or equal to this value
     * @param {string} [drayageLastFreeDateGte] Include shipments where the drayage last free datetime is greater than or equal to this value
     * @param {string} [drayageLastFreeDateLte] Include shipments where the drayage last free datetime is less than or equal to this value
     * @param {string} [drayageReleaseDateGte] Include shipments where the drayage release datetime is greater than or equal to this value
     * @param {string} [drayageReleaseDateLte] Include shipments where the drayage release datetime is less than or equal to this value
     * @param {string} [drayageSealNumberContains] Include shipments where the drayage seal number contains this value
     * @param {string} [dropoffGte] Return shipments with a dropoff stop with a planned date greater than or equal to this value
     * @param {string} [dropoffLte] Return shipments with a dropoff stop with a planned data less than or equal to this value
     * @param {string} [expiresAtGte] Include load board shipments where expires_at is greater than or equal to this value
     * @param {string} [expiresAtLte] Include load board shipments where expires_at is less than or equal to this value
     * @param {Array<'bidding' | 'closed' | 'open' | 'won' | 'tendered' | 'accepted' | 'rejected' | 'expired'>} [biddingStatus] The bidding status of shipments on the load board
     * @param {Array<'open' | 'accepted' | 'rejected' | 'revoked' | 'expired'>} [tenderStatus] The tender status of shipments on the load board
     * @param {boolean} [loadBoardEnabled] Filter on whether or not a shipment is posted on the company load board
     * @param {string} [nameContains] Return shipments where the shipment name contains this value
     * @param {boolean} [open] Filter on whether or not a shipment is open
     * @param {string} [originContains] Return shipments with this value in the origin
     * @param {string} [originStateProvince] Return shipments with this state province on its origin stop
     * @param {string} [pickupStopsStateProvince] Return shipments with this state province on its pickup stops
     * @param {string} [pickupStopsContains] Return shipments with this value in one of its pickup stops
     * @param {string} [pickupStopsCompanyNameContains] Return shipments with this value in one of its pickup stops location company_name
     * @param {string} [pickupGte] Return shipments with a pickup stop with a planned date greater than or equal to this value
     * @param {string} [pickupLte] Return shipments with a pickup stop with a planned date less than or equal to this value
     * @param {Array<string>} [pickupNumber] Include shipments with these Pickup Numbers
     * @param {string} [pickupNumberContains] Include shipments where the Pickup Number contains this value
     * @param {Array<string>} [pickupNumberExclude] Exclude shipments with these Pickup Numbers
     * @param {Array<string>} [proNumber] Include shipments with these PRO Numbers
     * @param {string} [proNumberContains] Return shipments where the PRO number contains this value
     * @param {Array<string>} [proNumberExclude] Exclude shipments with these PRO Numbers
     * @param {Array<string>} [purchaseOrderNumber] Include shipments with these PO Numbers
     * @param {string} [purchaseOrderNumberContains] Include shipments where the PO number contains this value
     * @param {Array<string>} [purchaseOrderNumberExclude] Exclude shipments with these PO Numbers
     * @param {Array<string>} [referenceId] Include shipments with these Reference IDs
     * @param {string} [referenceIdContains] Include shipments where the reference ID contains this value
     * @param {Array<string>} [referenceIdExclude] Exclude shipments with these Reference IDs
     * @param {Array<string>} [masterAirWaybill] Include shipments with these Master Air Waybill Numbers
     * @param {string} [masterAirWaybillContains] Include shipments where the Master Air Waybill number contains this value
     * @param {Array<string>} [houseAirWaybill] Include shipments with these House Air Waybill Numbers
     * @param {string} [houseAirWaybillContains] Include shipments where the House Air Waybill number contains this value
     * @param {Array<string>} [reps] Include shipments with these reps
     * @param {Array<string>} [requestedEquipmentTypes] Return shipments where the load board offering company requests these equipment type machine readable codes
     * @param {Array<string>} [requestedEquipmentTypesContains] Return shipments where the load board offering company requests equipment types that partially match machine readable codes
     * @param {Array<string>} [requestedShipmentModes] Return shipments where the load board offering company requests these shipment mode codes
     * @param {string} [createdAtGte] Include shipments where created_at is greater than or equal to the time value
     * @param {string} [createdAtLte] Include shipments where created_at is less than or equal to this value
     * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
     * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [statusExclude] Exclude shipments with these statuses
     * @param {string} [statusContains] Include shipments where the status contains this string
     * @param {Array<string>} [tags] Include only shipments with at least one matching ShipmentTag
     * @param {string} [stopsContains] Return shipments with this value in one of its stops
     * @param {string} [stopsCompanyNameContains] Return shipments with this value in one of its stops location company_name
     * @param {string} [stopsStateProvince] Return shipments with this state province on one of its stops
     * @param {number} [totalMilesGte] Return shipments with total miles greater than or equal to this value
     * @param {number} [totalMilesLte] Return shipments with total miles less than or equal to this value
     * @param {string} [vendorId] Return shipments with this exact value as the vendor Carrier id
     * @param {string} [vendorContains] Return shipments where the vendor company name contains this value
     * @param {number} [totalWeightOverrideGte] Return shipments with weight greater than or equal to this value
     * @param {number} [totalWeightOverrideLte] Return shipments with weight less than or equal to this value
     * @param {number} [originRadius] Radius from origin stop
     * @param {number} [originLat] Latitude of location to filter on for origin stop
     * @param {number} [originLon] Longitude of location to filter on for origin stop
     * @param {number} [pickupRadius] Radius from a pickup stop
     * @param {number} [pickupLat] Latitude of location to filter on for pickup stop
     * @param {number} [pickupLon] Longitude of location to filter on for pickup stop
     * @param {number} [destinationRadius] Radius from the destination stop
     * @param {number} [destinationLat] Latitude of location to filter on for destination stop
     * @param {number} [destinationLon] Longitude of location to filter on for destination stop
     * @param {number} [deliveryRadius] Radius from a delivery stop
     * @param {number} [deliveryLat] Latitude of location to filter on for delivery stop
     * @param {number} [deliveryLon] Longitude of location to filter on for delivery stop
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadboardApi
     */
    LoadboardApi.prototype.quotingLoadboardGet = function (page, pageSize, ordering, q, activeVendorAssignment, archived, bolNumber, bolNumberContains, bolNumberExclude, buyItNowAmountGte, buyItNowAmountLte, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, dropoffGte, dropoffLte, expiresAtGte, expiresAtLte, biddingStatus, tenderStatus, loadBoardEnabled, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, pickupGte, pickupLte, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, requestedEquipmentTypes, requestedEquipmentTypesContains, requestedShipmentModes, createdAtGte, createdAtLte, status, statusExclude, statusContains, tags, stopsContains, stopsCompanyNameContains, stopsStateProvince, totalMilesGte, totalMilesLte, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, options) {
        var _this = this;
        return (0, exports.LoadboardApiFp)(this.configuration).quotingLoadboardGet(page, pageSize, ordering, q, activeVendorAssignment, archived, bolNumber, bolNumberContains, bolNumberExclude, buyItNowAmountGte, buyItNowAmountLte, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, dropoffGte, dropoffLte, expiresAtGte, expiresAtLte, biddingStatus, tenderStatus, loadBoardEnabled, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, pickupGte, pickupLte, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, requestedEquipmentTypes, requestedEquipmentTypesContains, requestedShipmentModes, createdAtGte, createdAtLte, status, statusExclude, statusContains, tags, stopsContains, stopsCompanyNameContains, stopsStateProvince, totalMilesGte, totalMilesLte, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a load board shipment by its id
     * @param {string} loadBoardShipmentId The load board ID of a shipment on the load board
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadboardApi
     */
    LoadboardApi.prototype.quotingLoadboardLoadBoardShipmentIdGet = function (loadBoardShipmentId, options) {
        var _this = this;
        return (0, exports.LoadboardApiFp)(this.configuration).quotingLoadboardLoadBoardShipmentIdGet(loadBoardShipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a spot negotiation for a load board shipment
     * @param {string} loadBoardShipmentId The load board ID of a shipment on the load board
     * @param {SpotNegotiation} spotNegotiation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LoadboardApi
     */
    LoadboardApi.prototype.quotingLoadboardLoadBoardShipmentIdSpotNegotiationsPost = function (loadBoardShipmentId, spotNegotiation, options) {
        var _this = this;
        return (0, exports.LoadboardApiFp)(this.configuration).quotingLoadboardLoadBoardShipmentIdSpotNegotiationsPost(loadBoardShipmentId, spotNegotiation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LoadboardApi;
}(base_1.BaseAPI));
exports.LoadboardApi = LoadboardApi;
/**
 * LocateApi - axios parameter creator
 * @export
 */
var LocateApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Send an SMS to locate request to a Driver
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdSmsTrackingPost: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdSmsTrackingPost', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/sms-tracking/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.LocateApiAxiosParamCreator = LocateApiAxiosParamCreator;
/**
 * LocateApi - functional programming interface
 * @export
 */
var LocateApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LocateApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Send an SMS to locate request to a Driver
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdSmsTrackingPost: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdSmsTrackingPost(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.LocateApiFp = LocateApiFp;
/**
 * LocateApi - factory interface
 * @export
 */
var LocateApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LocateApiFp)(configuration);
    return {
        /**
         *
         * @summary Send an SMS to locate request to a Driver
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdSmsTrackingPost: function (shipmentId, options) {
            return localVarFp.shipmentsShipmentIdSmsTrackingPost(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LocateApiFactory = LocateApiFactory;
/**
 * LocateApi - object-oriented interface
 * @export
 * @class LocateApi
 * @extends {BaseAPI}
 */
var LocateApi = /** @class */ (function (_super) {
    __extends(LocateApi, _super);
    function LocateApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Send an SMS to locate request to a Driver
     * @param {string} shipmentId The id of the shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocateApi
     */
    LocateApi.prototype.shipmentsShipmentIdSmsTrackingPost = function (shipmentId, options) {
        var _this = this;
        return (0, exports.LocateApiFp)(this.configuration).shipmentsShipmentIdSmsTrackingPost(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LocateApi;
}(base_1.BaseAPI));
exports.LocateApi = LocateApi;
/**
 * LocationsApi - axios parameter creator
 * @export
 */
var LocationsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Delete an address book entry
         * @param {string} addressBookId The id of a company address book entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressBookAddressBookIdDelete: function (addressBookId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'addressBookId' is not null or undefined
                            (0, common_1.assertParamExists)('addressBookAddressBookIdDelete', 'addressBookId', addressBookId);
                            localVarPath = "/address-book/{addressBookId}/"
                                .replace("{".concat("addressBookId", "}"), encodeURIComponent(String(addressBookId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about an address book entry
         * @param {string} addressBookId The id of a company address book entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressBookAddressBookIdGet: function (addressBookId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'addressBookId' is not null or undefined
                            (0, common_1.assertParamExists)('addressBookAddressBookIdGet', 'addressBookId', addressBookId);
                            localVarPath = "/address-book/{addressBookId}/"
                                .replace("{".concat("addressBookId", "}"), encodeURIComponent(String(addressBookId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an address book entry or add point of contacts
         * @param {string} addressBookId The id of a company address book entry
         * @param {AddressBookEntry} addressBookEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressBookAddressBookIdPut: function (addressBookId, addressBookEntry, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'addressBookId' is not null or undefined
                            (0, common_1.assertParamExists)('addressBookAddressBookIdPut', 'addressBookId', addressBookId);
                            // verify required parameter 'addressBookEntry' is not null or undefined
                            (0, common_1.assertParamExists)('addressBookAddressBookIdPut', 'addressBookEntry', addressBookEntry);
                            localVarPath = "/address-book/{addressBookId}/"
                                .replace("{".concat("addressBookId", "}"), encodeURIComponent(String(addressBookId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(addressBookEntry, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of address book entries
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressBookGet: function (page, pageSize, ordering, q, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/address-book/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new address book entry
         * @param {AddressBookEntry} addressBookEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressBookPost: function (addressBookEntry, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'addressBookEntry' is not null or undefined
                            (0, common_1.assertParamExists)('addressBookPost', 'addressBookEntry', addressBookEntry);
                            localVarPath = "/address-book/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(addressBookEntry, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of all available location types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationTypesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/location-types/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * This will validate and return back components, timezone, and any warnings or errors
         * @summary Validate a formatted address
         * @param {FormattedAddress} formattedAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationsAddressesValidatePost: function (formattedAddress, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'formattedAddress' is not null or undefined
                            (0, common_1.assertParamExists)('locationsAddressesValidatePost', 'formattedAddress', formattedAddress);
                            localVarPath = "/locations/addresses/validate/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(formattedAddress, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This will take in two addresses and return the distance between them
         * @summary Get the distance between two locations
         * @param {DistanceRequest} distanceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationsDistancePost: function (distanceRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'distanceRequest' is not null or undefined
                            (0, common_1.assertParamExists)('locationsDistancePost', 'distanceRequest', distanceRequest);
                            localVarPath = "/locations/distance/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(distanceRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.LocationsApiAxiosParamCreator = LocationsApiAxiosParamCreator;
/**
 * LocationsApi - functional programming interface
 * @export
 */
var LocationsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LocationsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Delete an address book entry
         * @param {string} addressBookId The id of a company address book entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressBookAddressBookIdDelete: function (addressBookId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addressBookAddressBookIdDelete(addressBookId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about an address book entry
         * @param {string} addressBookId The id of a company address book entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressBookAddressBookIdGet: function (addressBookId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addressBookAddressBookIdGet(addressBookId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an address book entry or add point of contacts
         * @param {string} addressBookId The id of a company address book entry
         * @param {AddressBookEntry} addressBookEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressBookAddressBookIdPut: function (addressBookId, addressBookEntry, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addressBookAddressBookIdPut(addressBookId, addressBookEntry, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of address book entries
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressBookGet: function (page, pageSize, ordering, q, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addressBookGet(page, pageSize, ordering, q, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new address book entry
         * @param {AddressBookEntry} addressBookEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressBookPost: function (addressBookEntry, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addressBookPost(addressBookEntry, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of all available location types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationTypesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.locationTypesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This will validate and return back components, timezone, and any warnings or errors
         * @summary Validate a formatted address
         * @param {FormattedAddress} formattedAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationsAddressesValidatePost: function (formattedAddress, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.locationsAddressesValidatePost(formattedAddress, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This will take in two addresses and return the distance between them
         * @summary Get the distance between two locations
         * @param {DistanceRequest} distanceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationsDistancePost: function (distanceRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.locationsDistancePost(distanceRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.LocationsApiFp = LocationsApiFp;
/**
 * LocationsApi - factory interface
 * @export
 */
var LocationsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LocationsApiFp)(configuration);
    return {
        /**
         *
         * @summary Delete an address book entry
         * @param {string} addressBookId The id of a company address book entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressBookAddressBookIdDelete: function (addressBookId, options) {
            return localVarFp.addressBookAddressBookIdDelete(addressBookId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about an address book entry
         * @param {string} addressBookId The id of a company address book entry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressBookAddressBookIdGet: function (addressBookId, options) {
            return localVarFp.addressBookAddressBookIdGet(addressBookId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update an address book entry or add point of contacts
         * @param {string} addressBookId The id of a company address book entry
         * @param {AddressBookEntry} addressBookEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressBookAddressBookIdPut: function (addressBookId, addressBookEntry, options) {
            return localVarFp.addressBookAddressBookIdPut(addressBookId, addressBookEntry, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a list of address book entries
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressBookGet: function (page, pageSize, ordering, q, options) {
            return localVarFp.addressBookGet(page, pageSize, ordering, q, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a new address book entry
         * @param {AddressBookEntry} addressBookEntry
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressBookPost: function (addressBookEntry, options) {
            return localVarFp.addressBookPost(addressBookEntry, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a list of all available location types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationTypesGet: function (options) {
            return localVarFp.locationTypesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This will validate and return back components, timezone, and any warnings or errors
         * @summary Validate a formatted address
         * @param {FormattedAddress} formattedAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationsAddressesValidatePost: function (formattedAddress, options) {
            return localVarFp.locationsAddressesValidatePost(formattedAddress, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This will take in two addresses and return the distance between them
         * @summary Get the distance between two locations
         * @param {DistanceRequest} distanceRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        locationsDistancePost: function (distanceRequest, options) {
            return localVarFp.locationsDistancePost(distanceRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LocationsApiFactory = LocationsApiFactory;
/**
 * LocationsApi - object-oriented interface
 * @export
 * @class LocationsApi
 * @extends {BaseAPI}
 */
var LocationsApi = /** @class */ (function (_super) {
    __extends(LocationsApi, _super);
    function LocationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Delete an address book entry
     * @param {string} addressBookId The id of a company address book entry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    LocationsApi.prototype.addressBookAddressBookIdDelete = function (addressBookId, options) {
        var _this = this;
        return (0, exports.LocationsApiFp)(this.configuration).addressBookAddressBookIdDelete(addressBookId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about an address book entry
     * @param {string} addressBookId The id of a company address book entry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    LocationsApi.prototype.addressBookAddressBookIdGet = function (addressBookId, options) {
        var _this = this;
        return (0, exports.LocationsApiFp)(this.configuration).addressBookAddressBookIdGet(addressBookId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update an address book entry or add point of contacts
     * @param {string} addressBookId The id of a company address book entry
     * @param {AddressBookEntry} addressBookEntry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    LocationsApi.prototype.addressBookAddressBookIdPut = function (addressBookId, addressBookEntry, options) {
        var _this = this;
        return (0, exports.LocationsApiFp)(this.configuration).addressBookAddressBookIdPut(addressBookId, addressBookEntry, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a list of address book entries
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    LocationsApi.prototype.addressBookGet = function (page, pageSize, ordering, q, options) {
        var _this = this;
        return (0, exports.LocationsApiFp)(this.configuration).addressBookGet(page, pageSize, ordering, q, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a new address book entry
     * @param {AddressBookEntry} addressBookEntry
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    LocationsApi.prototype.addressBookPost = function (addressBookEntry, options) {
        var _this = this;
        return (0, exports.LocationsApiFp)(this.configuration).addressBookPost(addressBookEntry, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a list of all available location types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    LocationsApi.prototype.locationTypesGet = function (options) {
        var _this = this;
        return (0, exports.LocationsApiFp)(this.configuration).locationTypesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This will validate and return back components, timezone, and any warnings or errors
     * @summary Validate a formatted address
     * @param {FormattedAddress} formattedAddress
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    LocationsApi.prototype.locationsAddressesValidatePost = function (formattedAddress, options) {
        var _this = this;
        return (0, exports.LocationsApiFp)(this.configuration).locationsAddressesValidatePost(formattedAddress, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This will take in two addresses and return the distance between them
     * @summary Get the distance between two locations
     * @param {DistanceRequest} distanceRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocationsApi
     */
    LocationsApi.prototype.locationsDistancePost = function (distanceRequest, options) {
        var _this = this;
        return (0, exports.LocationsApiFp)(this.configuration).locationsDistancePost(distanceRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LocationsApi;
}(base_1.BaseAPI));
exports.LocationsApi = LocationsApi;
/**
 * MultiModeApi - axios parameter creator
 * @export
 */
var MultiModeApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Generate csv file containing resources within date range
         * @param {CSVFinancialsExportRequest} [cSVFinancialsExportRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        multiModeCsvFinancialsExportPost: function (cSVFinancialsExportRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/multi-mode/csv-financials-export/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(cSVFinancialsExportRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.MultiModeApiAxiosParamCreator = MultiModeApiAxiosParamCreator;
/**
 * MultiModeApi - functional programming interface
 * @export
 */
var MultiModeApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.MultiModeApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Generate csv file containing resources within date range
         * @param {CSVFinancialsExportRequest} [cSVFinancialsExportRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        multiModeCsvFinancialsExportPost: function (cSVFinancialsExportRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.multiModeCsvFinancialsExportPost(cSVFinancialsExportRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.MultiModeApiFp = MultiModeApiFp;
/**
 * MultiModeApi - factory interface
 * @export
 */
var MultiModeApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.MultiModeApiFp)(configuration);
    return {
        /**
         *
         * @summary Generate csv file containing resources within date range
         * @param {CSVFinancialsExportRequest} [cSVFinancialsExportRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        multiModeCsvFinancialsExportPost: function (cSVFinancialsExportRequest, options) {
            return localVarFp.multiModeCsvFinancialsExportPost(cSVFinancialsExportRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.MultiModeApiFactory = MultiModeApiFactory;
/**
 * MultiModeApi - object-oriented interface
 * @export
 * @class MultiModeApi
 * @extends {BaseAPI}
 */
var MultiModeApi = /** @class */ (function (_super) {
    __extends(MultiModeApi, _super);
    function MultiModeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Generate csv file containing resources within date range
     * @param {CSVFinancialsExportRequest} [cSVFinancialsExportRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MultiModeApi
     */
    MultiModeApi.prototype.multiModeCsvFinancialsExportPost = function (cSVFinancialsExportRequest, options) {
        var _this = this;
        return (0, exports.MultiModeApiFp)(this.configuration).multiModeCsvFinancialsExportPost(cSVFinancialsExportRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MultiModeApi;
}(base_1.BaseAPI));
exports.MultiModeApi = MultiModeApi;
/**
 * NotificationPreferencesApi - axios parameter creator
 * @export
 */
var NotificationPreferencesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Obtain a list of a user\'s notification preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationPreferencesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/notification-preferences/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a list of a user\'s notification preferences
         * @param {Array<NotificationPreference>} notificationPreference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationPreferencesPut: function (notificationPreference, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'notificationPreference' is not null or undefined
                            (0, common_1.assertParamExists)('notificationPreferencesPut', 'notificationPreference', notificationPreference);
                            localVarPath = "/notification-preferences/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(notificationPreference, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.NotificationPreferencesApiAxiosParamCreator = NotificationPreferencesApiAxiosParamCreator;
/**
 * NotificationPreferencesApi - functional programming interface
 * @export
 */
var NotificationPreferencesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.NotificationPreferencesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Obtain a list of a user\'s notification preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationPreferencesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.notificationPreferencesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a list of a user\'s notification preferences
         * @param {Array<NotificationPreference>} notificationPreference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationPreferencesPut: function (notificationPreference, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.notificationPreferencesPut(notificationPreference, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.NotificationPreferencesApiFp = NotificationPreferencesApiFp;
/**
 * NotificationPreferencesApi - factory interface
 * @export
 */
var NotificationPreferencesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.NotificationPreferencesApiFp)(configuration);
    return {
        /**
         *
         * @summary Obtain a list of a user\'s notification preferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationPreferencesGet: function (options) {
            return localVarFp.notificationPreferencesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a list of a user\'s notification preferences
         * @param {Array<NotificationPreference>} notificationPreference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationPreferencesPut: function (notificationPreference, options) {
            return localVarFp.notificationPreferencesPut(notificationPreference, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.NotificationPreferencesApiFactory = NotificationPreferencesApiFactory;
/**
 * NotificationPreferencesApi - object-oriented interface
 * @export
 * @class NotificationPreferencesApi
 * @extends {BaseAPI}
 */
var NotificationPreferencesApi = /** @class */ (function (_super) {
    __extends(NotificationPreferencesApi, _super);
    function NotificationPreferencesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Obtain a list of a user\'s notification preferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationPreferencesApi
     */
    NotificationPreferencesApi.prototype.notificationPreferencesGet = function (options) {
        var _this = this;
        return (0, exports.NotificationPreferencesApiFp)(this.configuration).notificationPreferencesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a list of a user\'s notification preferences
     * @param {Array<NotificationPreference>} notificationPreference
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationPreferencesApi
     */
    NotificationPreferencesApi.prototype.notificationPreferencesPut = function (notificationPreference, options) {
        var _this = this;
        return (0, exports.NotificationPreferencesApiFp)(this.configuration).notificationPreferencesPut(notificationPreference, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return NotificationPreferencesApi;
}(base_1.BaseAPI));
exports.NotificationPreferencesApi = NotificationPreferencesApi;
/**
 * OrdersApi - axios parameter creator
 * @export
 */
var OrdersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary List supplier invites created by user
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [onlyMyShipments] Whether to fetch all company requests or ones created by the user
         * @param {string} [createdAtGte] Include SupplierInvites where created_at is greater than or equal to this value
         * @param {string} [createdAtLte] Include SupplierInvites where created_at is less than or equal to this value
         * @param {string} [updatedAtGte] Include SupplierInvites where updated_at is greater than or equal to this value
         * @param {string} [updatedAtLte] Include SupplierInvites where updated_at is less than or equal to this value
         * @param {string} [revokedAtGte] Include SupplierInvites where revoked_at is greater than or equal to this value
         * @param {string} [revokedAtLte] Include SupplierInvites where revoked_at is less than or equal to this value
         * @param {string} [bookedAtGte] Include SupplierInvites where booked_at is greater than or equal to this value
         * @param {string} [bookedAtLte] Include SupplierInvites where booked_at is less than or equal to this value
         * @param {string} [sentByUserName] Return objects where the sent_by_user name is equal to this string
         * @param {string} [sentByUserNameContains] Return objects where one of the sent_by_user name contains this string
         * @param {string} [supplierEmailAddress] Return objects where the supplier_email_address is equal to this string
         * @param {string} [supplierEmailAddressContains] Return objects where one of the supplier_email_address contains this string
         * @param {boolean} [expressDelivery] Return objects where express_delivery is this value
         * @param {string} [messageToSupplierContains] Return objects where the message_to_supplier contains this string
         * @param {Array<'BOOKED' | 'CANCELLED' | 'REQUESTED' | 'UNABLE_TO_BOOK'>} [status] Include Supplier Invite with these statuses
         * @param {string} [shipmentCreatedAtGte] Include SupplierInvites where the Shipment created_at is greater than or equal to this value
         * @param {string} [shipmentCreatedAtLte] Include SupplierInvites where Shipment created_at is less than or equal to this value
         * @param {string} [shipmentReferenceId] Include SupplierInvites where the Shipment reference_id is this value
         * @param {string} [shipmentReferenceIdContains] Return objects where one of the Shipment reference_id contains this string
         * @param {string} [poNumber] Return objects where the po_number is equal to this string
         * @param {string} [poNumberContains] Return objects where the po_number contains this string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersSupplierInvitesGet: function (page, pageSize, ordering, q, onlyMyShipments, createdAtGte, createdAtLte, updatedAtGte, updatedAtLte, revokedAtGte, revokedAtLte, bookedAtGte, bookedAtLte, sentByUserName, sentByUserNameContains, supplierEmailAddress, supplierEmailAddressContains, expressDelivery, messageToSupplierContains, status, shipmentCreatedAtGte, shipmentCreatedAtLte, shipmentReferenceId, shipmentReferenceIdContains, poNumber, poNumberContains, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/orders/supplier-invites/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (onlyMyShipments !== undefined) {
                                localVarQueryParameter['only_my_shipments'] = onlyMyShipments;
                            }
                            if (createdAtGte !== undefined) {
                                localVarQueryParameter['created_at__gte'] = (createdAtGte instanceof Date) ?
                                    createdAtGte.toISOString().substr(0, 10) :
                                    createdAtGte;
                            }
                            if (createdAtLte !== undefined) {
                                localVarQueryParameter['created_at__lte'] = (createdAtLte instanceof Date) ?
                                    createdAtLte.toISOString().substr(0, 10) :
                                    createdAtLte;
                            }
                            if (updatedAtGte !== undefined) {
                                localVarQueryParameter['updated_at__gte'] = (updatedAtGte instanceof Date) ?
                                    updatedAtGte.toISOString().substr(0, 10) :
                                    updatedAtGte;
                            }
                            if (updatedAtLte !== undefined) {
                                localVarQueryParameter['updated_at__lte'] = (updatedAtLte instanceof Date) ?
                                    updatedAtLte.toISOString().substr(0, 10) :
                                    updatedAtLte;
                            }
                            if (revokedAtGte !== undefined) {
                                localVarQueryParameter['revoked_at__gte'] = (revokedAtGte instanceof Date) ?
                                    revokedAtGte.toISOString().substr(0, 10) :
                                    revokedAtGte;
                            }
                            if (revokedAtLte !== undefined) {
                                localVarQueryParameter['revoked_at__lte'] = (revokedAtLte instanceof Date) ?
                                    revokedAtLte.toISOString().substr(0, 10) :
                                    revokedAtLte;
                            }
                            if (bookedAtGte !== undefined) {
                                localVarQueryParameter['booked_at__gte'] = (bookedAtGte instanceof Date) ?
                                    bookedAtGte.toISOString().substr(0, 10) :
                                    bookedAtGte;
                            }
                            if (bookedAtLte !== undefined) {
                                localVarQueryParameter['booked_at__lte'] = (bookedAtLte instanceof Date) ?
                                    bookedAtLte.toISOString().substr(0, 10) :
                                    bookedAtLte;
                            }
                            if (sentByUserName !== undefined) {
                                localVarQueryParameter['sent_by_user_name'] = sentByUserName;
                            }
                            if (sentByUserNameContains !== undefined) {
                                localVarQueryParameter['sent_by_user_name__contains'] = sentByUserNameContains;
                            }
                            if (supplierEmailAddress !== undefined) {
                                localVarQueryParameter['supplier_email_address'] = supplierEmailAddress;
                            }
                            if (supplierEmailAddressContains !== undefined) {
                                localVarQueryParameter['supplier_email_address__contains'] = supplierEmailAddressContains;
                            }
                            if (expressDelivery !== undefined) {
                                localVarQueryParameter['express_delivery'] = expressDelivery;
                            }
                            if (messageToSupplierContains !== undefined) {
                                localVarQueryParameter['message_to_supplier__contains'] = messageToSupplierContains;
                            }
                            if (status) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (shipmentCreatedAtGte !== undefined) {
                                localVarQueryParameter['shipment_created_at__gte'] = (shipmentCreatedAtGte instanceof Date) ?
                                    shipmentCreatedAtGte.toISOString().substr(0, 10) :
                                    shipmentCreatedAtGte;
                            }
                            if (shipmentCreatedAtLte !== undefined) {
                                localVarQueryParameter['shipment_created_at__lte'] = (shipmentCreatedAtLte instanceof Date) ?
                                    shipmentCreatedAtLte.toISOString().substr(0, 10) :
                                    shipmentCreatedAtLte;
                            }
                            if (shipmentReferenceId !== undefined) {
                                localVarQueryParameter['shipment_reference_id'] = shipmentReferenceId;
                            }
                            if (shipmentReferenceIdContains !== undefined) {
                                localVarQueryParameter['shipment_reference_id__contains'] = shipmentReferenceIdContains;
                            }
                            if (poNumber !== undefined) {
                                localVarQueryParameter['po_number'] = poNumber;
                            }
                            if (poNumberContains !== undefined) {
                                localVarQueryParameter['po_number__contains'] = poNumberContains;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create supplier invite for company if supplier invite feature enabled
         * @param {SupplierInvite} supplierInvite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersSupplierInvitesPost: function (supplierInvite, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'supplierInvite' is not null or undefined
                            (0, common_1.assertParamExists)('ordersSupplierInvitesPost', 'supplierInvite', supplierInvite);
                            localVarPath = "/orders/supplier-invites/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(supplierInvite, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve supplier invite
         * @param {string} supplierInviteKey The token key for the supplier invite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersSupplierInvitesSupplierInviteKeyGet: function (supplierInviteKey, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'supplierInviteKey' is not null or undefined
                            (0, common_1.assertParamExists)('ordersSupplierInvitesSupplierInviteKeyGet', 'supplierInviteKey', supplierInviteKey);
                            localVarPath = "/orders/supplier-invites/{supplierInviteKey}/"
                                .replace("{".concat("supplierInviteKey", "}"), encodeURIComponent(String(supplierInviteKey)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update supplier invite
         * @param {string} supplierInviteKey The token key for the supplier invite
         * @param {SupplierInvite} supplierInvite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersSupplierInvitesSupplierInviteKeyPut: function (supplierInviteKey, supplierInvite, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'supplierInviteKey' is not null or undefined
                            (0, common_1.assertParamExists)('ordersSupplierInvitesSupplierInviteKeyPut', 'supplierInviteKey', supplierInviteKey);
                            // verify required parameter 'supplierInvite' is not null or undefined
                            (0, common_1.assertParamExists)('ordersSupplierInvitesSupplierInviteKeyPut', 'supplierInvite', supplierInvite);
                            localVarPath = "/orders/supplier-invites/{supplierInviteKey}/"
                                .replace("{".concat("supplierInviteKey", "}"), encodeURIComponent(String(supplierInviteKey)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(supplierInvite, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.OrdersApiAxiosParamCreator = OrdersApiAxiosParamCreator;
/**
 * OrdersApi - functional programming interface
 * @export
 */
var OrdersApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OrdersApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary List supplier invites created by user
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [onlyMyShipments] Whether to fetch all company requests or ones created by the user
         * @param {string} [createdAtGte] Include SupplierInvites where created_at is greater than or equal to this value
         * @param {string} [createdAtLte] Include SupplierInvites where created_at is less than or equal to this value
         * @param {string} [updatedAtGte] Include SupplierInvites where updated_at is greater than or equal to this value
         * @param {string} [updatedAtLte] Include SupplierInvites where updated_at is less than or equal to this value
         * @param {string} [revokedAtGte] Include SupplierInvites where revoked_at is greater than or equal to this value
         * @param {string} [revokedAtLte] Include SupplierInvites where revoked_at is less than or equal to this value
         * @param {string} [bookedAtGte] Include SupplierInvites where booked_at is greater than or equal to this value
         * @param {string} [bookedAtLte] Include SupplierInvites where booked_at is less than or equal to this value
         * @param {string} [sentByUserName] Return objects where the sent_by_user name is equal to this string
         * @param {string} [sentByUserNameContains] Return objects where one of the sent_by_user name contains this string
         * @param {string} [supplierEmailAddress] Return objects where the supplier_email_address is equal to this string
         * @param {string} [supplierEmailAddressContains] Return objects where one of the supplier_email_address contains this string
         * @param {boolean} [expressDelivery] Return objects where express_delivery is this value
         * @param {string} [messageToSupplierContains] Return objects where the message_to_supplier contains this string
         * @param {Array<'BOOKED' | 'CANCELLED' | 'REQUESTED' | 'UNABLE_TO_BOOK'>} [status] Include Supplier Invite with these statuses
         * @param {string} [shipmentCreatedAtGte] Include SupplierInvites where the Shipment created_at is greater than or equal to this value
         * @param {string} [shipmentCreatedAtLte] Include SupplierInvites where Shipment created_at is less than or equal to this value
         * @param {string} [shipmentReferenceId] Include SupplierInvites where the Shipment reference_id is this value
         * @param {string} [shipmentReferenceIdContains] Return objects where one of the Shipment reference_id contains this string
         * @param {string} [poNumber] Return objects where the po_number is equal to this string
         * @param {string} [poNumberContains] Return objects where the po_number contains this string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersSupplierInvitesGet: function (page, pageSize, ordering, q, onlyMyShipments, createdAtGte, createdAtLte, updatedAtGte, updatedAtLte, revokedAtGte, revokedAtLte, bookedAtGte, bookedAtLte, sentByUserName, sentByUserNameContains, supplierEmailAddress, supplierEmailAddressContains, expressDelivery, messageToSupplierContains, status, shipmentCreatedAtGte, shipmentCreatedAtLte, shipmentReferenceId, shipmentReferenceIdContains, poNumber, poNumberContains, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ordersSupplierInvitesGet(page, pageSize, ordering, q, onlyMyShipments, createdAtGte, createdAtLte, updatedAtGte, updatedAtLte, revokedAtGte, revokedAtLte, bookedAtGte, bookedAtLte, sentByUserName, sentByUserNameContains, supplierEmailAddress, supplierEmailAddressContains, expressDelivery, messageToSupplierContains, status, shipmentCreatedAtGte, shipmentCreatedAtLte, shipmentReferenceId, shipmentReferenceIdContains, poNumber, poNumberContains, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create supplier invite for company if supplier invite feature enabled
         * @param {SupplierInvite} supplierInvite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersSupplierInvitesPost: function (supplierInvite, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ordersSupplierInvitesPost(supplierInvite, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve supplier invite
         * @param {string} supplierInviteKey The token key for the supplier invite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersSupplierInvitesSupplierInviteKeyGet: function (supplierInviteKey, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ordersSupplierInvitesSupplierInviteKeyGet(supplierInviteKey, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update supplier invite
         * @param {string} supplierInviteKey The token key for the supplier invite
         * @param {SupplierInvite} supplierInvite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersSupplierInvitesSupplierInviteKeyPut: function (supplierInviteKey, supplierInvite, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.ordersSupplierInvitesSupplierInviteKeyPut(supplierInviteKey, supplierInvite, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.OrdersApiFp = OrdersApiFp;
/**
 * OrdersApi - factory interface
 * @export
 */
var OrdersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OrdersApiFp)(configuration);
    return {
        /**
         *
         * @summary List supplier invites created by user
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [onlyMyShipments] Whether to fetch all company requests or ones created by the user
         * @param {string} [createdAtGte] Include SupplierInvites where created_at is greater than or equal to this value
         * @param {string} [createdAtLte] Include SupplierInvites where created_at is less than or equal to this value
         * @param {string} [updatedAtGte] Include SupplierInvites where updated_at is greater than or equal to this value
         * @param {string} [updatedAtLte] Include SupplierInvites where updated_at is less than or equal to this value
         * @param {string} [revokedAtGte] Include SupplierInvites where revoked_at is greater than or equal to this value
         * @param {string} [revokedAtLte] Include SupplierInvites where revoked_at is less than or equal to this value
         * @param {string} [bookedAtGte] Include SupplierInvites where booked_at is greater than or equal to this value
         * @param {string} [bookedAtLte] Include SupplierInvites where booked_at is less than or equal to this value
         * @param {string} [sentByUserName] Return objects where the sent_by_user name is equal to this string
         * @param {string} [sentByUserNameContains] Return objects where one of the sent_by_user name contains this string
         * @param {string} [supplierEmailAddress] Return objects where the supplier_email_address is equal to this string
         * @param {string} [supplierEmailAddressContains] Return objects where one of the supplier_email_address contains this string
         * @param {boolean} [expressDelivery] Return objects where express_delivery is this value
         * @param {string} [messageToSupplierContains] Return objects where the message_to_supplier contains this string
         * @param {Array<'BOOKED' | 'CANCELLED' | 'REQUESTED' | 'UNABLE_TO_BOOK'>} [status] Include Supplier Invite with these statuses
         * @param {string} [shipmentCreatedAtGte] Include SupplierInvites where the Shipment created_at is greater than or equal to this value
         * @param {string} [shipmentCreatedAtLte] Include SupplierInvites where Shipment created_at is less than or equal to this value
         * @param {string} [shipmentReferenceId] Include SupplierInvites where the Shipment reference_id is this value
         * @param {string} [shipmentReferenceIdContains] Return objects where one of the Shipment reference_id contains this string
         * @param {string} [poNumber] Return objects where the po_number is equal to this string
         * @param {string} [poNumberContains] Return objects where the po_number contains this string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersSupplierInvitesGet: function (page, pageSize, ordering, q, onlyMyShipments, createdAtGte, createdAtLte, updatedAtGte, updatedAtLte, revokedAtGte, revokedAtLte, bookedAtGte, bookedAtLte, sentByUserName, sentByUserNameContains, supplierEmailAddress, supplierEmailAddressContains, expressDelivery, messageToSupplierContains, status, shipmentCreatedAtGte, shipmentCreatedAtLte, shipmentReferenceId, shipmentReferenceIdContains, poNumber, poNumberContains, options) {
            return localVarFp.ordersSupplierInvitesGet(page, pageSize, ordering, q, onlyMyShipments, createdAtGte, createdAtLte, updatedAtGte, updatedAtLte, revokedAtGte, revokedAtLte, bookedAtGte, bookedAtLte, sentByUserName, sentByUserNameContains, supplierEmailAddress, supplierEmailAddressContains, expressDelivery, messageToSupplierContains, status, shipmentCreatedAtGte, shipmentCreatedAtLte, shipmentReferenceId, shipmentReferenceIdContains, poNumber, poNumberContains, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create supplier invite for company if supplier invite feature enabled
         * @param {SupplierInvite} supplierInvite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersSupplierInvitesPost: function (supplierInvite, options) {
            return localVarFp.ordersSupplierInvitesPost(supplierInvite, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve supplier invite
         * @param {string} supplierInviteKey The token key for the supplier invite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersSupplierInvitesSupplierInviteKeyGet: function (supplierInviteKey, options) {
            return localVarFp.ordersSupplierInvitesSupplierInviteKeyGet(supplierInviteKey, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update supplier invite
         * @param {string} supplierInviteKey The token key for the supplier invite
         * @param {SupplierInvite} supplierInvite
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersSupplierInvitesSupplierInviteKeyPut: function (supplierInviteKey, supplierInvite, options) {
            return localVarFp.ordersSupplierInvitesSupplierInviteKeyPut(supplierInviteKey, supplierInvite, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OrdersApiFactory = OrdersApiFactory;
/**
 * OrdersApi - object-oriented interface
 * @export
 * @class OrdersApi
 * @extends {BaseAPI}
 */
var OrdersApi = /** @class */ (function (_super) {
    __extends(OrdersApi, _super);
    function OrdersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary List supplier invites created by user
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {boolean} [onlyMyShipments] Whether to fetch all company requests or ones created by the user
     * @param {string} [createdAtGte] Include SupplierInvites where created_at is greater than or equal to this value
     * @param {string} [createdAtLte] Include SupplierInvites where created_at is less than or equal to this value
     * @param {string} [updatedAtGte] Include SupplierInvites where updated_at is greater than or equal to this value
     * @param {string} [updatedAtLte] Include SupplierInvites where updated_at is less than or equal to this value
     * @param {string} [revokedAtGte] Include SupplierInvites where revoked_at is greater than or equal to this value
     * @param {string} [revokedAtLte] Include SupplierInvites where revoked_at is less than or equal to this value
     * @param {string} [bookedAtGte] Include SupplierInvites where booked_at is greater than or equal to this value
     * @param {string} [bookedAtLte] Include SupplierInvites where booked_at is less than or equal to this value
     * @param {string} [sentByUserName] Return objects where the sent_by_user name is equal to this string
     * @param {string} [sentByUserNameContains] Return objects where one of the sent_by_user name contains this string
     * @param {string} [supplierEmailAddress] Return objects where the supplier_email_address is equal to this string
     * @param {string} [supplierEmailAddressContains] Return objects where one of the supplier_email_address contains this string
     * @param {boolean} [expressDelivery] Return objects where express_delivery is this value
     * @param {string} [messageToSupplierContains] Return objects where the message_to_supplier contains this string
     * @param {Array<'BOOKED' | 'CANCELLED' | 'REQUESTED' | 'UNABLE_TO_BOOK'>} [status] Include Supplier Invite with these statuses
     * @param {string} [shipmentCreatedAtGte] Include SupplierInvites where the Shipment created_at is greater than or equal to this value
     * @param {string} [shipmentCreatedAtLte] Include SupplierInvites where Shipment created_at is less than or equal to this value
     * @param {string} [shipmentReferenceId] Include SupplierInvites where the Shipment reference_id is this value
     * @param {string} [shipmentReferenceIdContains] Return objects where one of the Shipment reference_id contains this string
     * @param {string} [poNumber] Return objects where the po_number is equal to this string
     * @param {string} [poNumberContains] Return objects where the po_number contains this string
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    OrdersApi.prototype.ordersSupplierInvitesGet = function (page, pageSize, ordering, q, onlyMyShipments, createdAtGte, createdAtLte, updatedAtGte, updatedAtLte, revokedAtGte, revokedAtLte, bookedAtGte, bookedAtLte, sentByUserName, sentByUserNameContains, supplierEmailAddress, supplierEmailAddressContains, expressDelivery, messageToSupplierContains, status, shipmentCreatedAtGte, shipmentCreatedAtLte, shipmentReferenceId, shipmentReferenceIdContains, poNumber, poNumberContains, options) {
        var _this = this;
        return (0, exports.OrdersApiFp)(this.configuration).ordersSupplierInvitesGet(page, pageSize, ordering, q, onlyMyShipments, createdAtGte, createdAtLte, updatedAtGte, updatedAtLte, revokedAtGte, revokedAtLte, bookedAtGte, bookedAtLte, sentByUserName, sentByUserNameContains, supplierEmailAddress, supplierEmailAddressContains, expressDelivery, messageToSupplierContains, status, shipmentCreatedAtGte, shipmentCreatedAtLte, shipmentReferenceId, shipmentReferenceIdContains, poNumber, poNumberContains, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create supplier invite for company if supplier invite feature enabled
     * @param {SupplierInvite} supplierInvite
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    OrdersApi.prototype.ordersSupplierInvitesPost = function (supplierInvite, options) {
        var _this = this;
        return (0, exports.OrdersApiFp)(this.configuration).ordersSupplierInvitesPost(supplierInvite, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve supplier invite
     * @param {string} supplierInviteKey The token key for the supplier invite
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    OrdersApi.prototype.ordersSupplierInvitesSupplierInviteKeyGet = function (supplierInviteKey, options) {
        var _this = this;
        return (0, exports.OrdersApiFp)(this.configuration).ordersSupplierInvitesSupplierInviteKeyGet(supplierInviteKey, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update supplier invite
     * @param {string} supplierInviteKey The token key for the supplier invite
     * @param {SupplierInvite} supplierInvite
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    OrdersApi.prototype.ordersSupplierInvitesSupplierInviteKeyPut = function (supplierInviteKey, supplierInvite, options) {
        var _this = this;
        return (0, exports.OrdersApiFp)(this.configuration).ordersSupplierInvitesSupplierInviteKeyPut(supplierInviteKey, supplierInvite, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OrdersApi;
}(base_1.BaseAPI));
exports.OrdersApi = OrdersApi;
/**
 * PaymentsApi - axios parameter creator
 * @export
 */
var PaymentsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Returns Triumph Pay authorization details for a given company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthAuthorizationDetailsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/payments/integrations/triumph-pay/auth/authorization-details/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Checks if a user has authenticated with Triumph Pay
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthCheckGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/payments/integrations/triumph-pay/auth/check/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a company\'s Triumph Pay documents submission email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthEmailGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/payments/integrations/triumph-pay/auth/email/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Add the user\'s company\'s Triumph Pay documents submission email
         * @param {TriumphPayDocumentsSubmissionEmail} triumphPayDocumentsSubmissionEmail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthEmailPost: function (triumphPayDocumentsSubmissionEmail, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'triumphPayDocumentsSubmissionEmail' is not null or undefined
                            (0, common_1.assertParamExists)('paymentsIntegrationsTriumphPayAuthEmailPost', 'triumphPayDocumentsSubmissionEmail', triumphPayDocumentsSubmissionEmail);
                            localVarPath = "/payments/integrations/triumph-pay/auth/email/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(triumphPayDocumentsSubmissionEmail, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a company\'s Triumph Pay documents submission email
         * @param {string} triumphSettingsId The id of the company\&#39;s triumph pay settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthEmailTriumphSettingsIdGet: function (triumphSettingsId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'triumphSettingsId' is not null or undefined
                            (0, common_1.assertParamExists)('paymentsIntegrationsTriumphPayAuthEmailTriumphSettingsIdGet', 'triumphSettingsId', triumphSettingsId);
                            localVarPath = "/payments/integrations/triumph-pay/auth/email/{triumphSettingsId}/"
                                .replace("{".concat("triumphSettingsId", "}"), encodeURIComponent(String(triumphSettingsId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update the user\'s company\'s Triumph Pay documents submission email
         * @param {string} triumphSettingsId The id of the company\&#39;s triumph pay settings
         * @param {TriumphPayDocumentsSubmissionEmail} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthEmailTriumphSettingsIdPatch: function (triumphSettingsId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'triumphSettingsId' is not null or undefined
                            (0, common_1.assertParamExists)('paymentsIntegrationsTriumphPayAuthEmailTriumphSettingsIdPatch', 'triumphSettingsId', triumphSettingsId);
                            localVarPath = "/payments/integrations/triumph-pay/auth/email/{triumphSettingsId}/"
                                .replace("{".concat("triumphSettingsId", "}"), encodeURIComponent(String(triumphSettingsId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update the user\'s company\'s Triumph Pay documents submission email
         * @param {string} triumphSettingsId The id of the company\&#39;s triumph pay settings
         * @param {TriumphPayDocumentsSubmissionEmail} triumphPayDocumentsSubmissionEmail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthEmailTriumphSettingsIdPut: function (triumphSettingsId, triumphPayDocumentsSubmissionEmail, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'triumphSettingsId' is not null or undefined
                            (0, common_1.assertParamExists)('paymentsIntegrationsTriumphPayAuthEmailTriumphSettingsIdPut', 'triumphSettingsId', triumphSettingsId);
                            // verify required parameter 'triumphPayDocumentsSubmissionEmail' is not null or undefined
                            (0, common_1.assertParamExists)('paymentsIntegrationsTriumphPayAuthEmailTriumphSettingsIdPut', 'triumphPayDocumentsSubmissionEmail', triumphPayDocumentsSubmissionEmail);
                            localVarPath = "/payments/integrations/triumph-pay/auth/email/{triumphSettingsId}/"
                                .replace("{".concat("triumphSettingsId", "}"), encodeURIComponent(String(triumphSettingsId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(triumphPayDocumentsSubmissionEmail, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Initiates Triumph Pay authentication for logged in user with Shipwell API
         * @param {string} [redirectUrl] The route to redirect to after successful Triumph Pay authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthGet: function (redirectUrl, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/payments/integrations/triumph-pay/auth/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (redirectUrl !== undefined) {
                                localVarQueryParameter['redirect_url'] = redirectUrl;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Revokes Triumph Pay authorization for a given company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthRevokeAuthorizationPost: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/payments/integrations/triumph-pay/auth/revoke-authorization/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This endpoint will retry creating a TriumphPay Invoice
         * @summary Retry invoice creation to TriumphPay
         * @param {string} billId The id of the bill within Shipwell
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayRetryInvoiceCreationBillIdPost: function (billId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'billId' is not null or undefined
                            (0, common_1.assertParamExists)('paymentsIntegrationsTriumphPayRetryInvoiceCreationBillIdPost', 'billId', billId);
                            localVarPath = "/payments/integrations/triumph-pay/retry-invoice-creation/{billId}/"
                                .replace("{".concat("billId", "}"), encodeURIComponent(String(billId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve values for ApprovedDateSource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPaySettingsApprovedDateSourceGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/payments/integrations/triumph-pay/settings/approved-date-source/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete user\'s company\'s Triumph Pay configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPaySettingsDelete: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/payments/integrations/triumph-pay/settings/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a company\'s Triumph Pay documents submission email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPaySettingsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/payments/integrations/triumph-pay/settings/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update the user\'s company\'s Triumph Pay configuration
         * @param {TriumphPayAuthSettings} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPaySettingsPut: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/payments/integrations/triumph-pay/settings/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * This will validate and return back addresses relating to triumph pay
         * @summary Validate a formatted address for triumph pay
         * @param {FormattedAddress} formattedAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayValidateMailtoAddressPost: function (formattedAddress, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'formattedAddress' is not null or undefined
                            (0, common_1.assertParamExists)('paymentsIntegrationsTriumphPayValidateMailtoAddressPost', 'formattedAddress', formattedAddress);
                            localVarPath = "/payments/integrations/triumph-pay/validate-mailto-address/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(formattedAddress, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Establishes a vendor connection to TriumphPay
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsEstablishTriumphPayConnectionCarrierRelationshipIdPost: function (carrierRelationshipId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('paymentsIntegrationsTriumphPayVendorsEstablishTriumphPayConnectionCarrierRelationshipIdPost', 'carrierRelationshipId', carrierRelationshipId);
                            localVarPath = "/payments/integrations/triumph-pay/vendors/establish-triumph-pay-connection/{carrierRelationshipId}/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Return a list of vendors that have been synced to Triumph Pay
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsGet: function (page, pageSize, ordering, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/payments/integrations/triumph-pay/vendors/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Return a vendors details synced with Triumph Pay
         * @param {string} triumphId The id of the vendor triumph pay record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsTriumphIdGet: function (triumphId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'triumphId' is not null or undefined
                            (0, common_1.assertParamExists)('paymentsIntegrationsTriumphPayVendorsTriumphIdGet', 'triumphId', triumphId);
                            localVarPath = "/payments/integrations/triumph-pay/vendors/{triumphId}/"
                                .replace("{".concat("triumphId", "}"), encodeURIComponent(String(triumphId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Return a vendor\'s triumph pay invoices synced with Triumph Pay
         * @param {string} triumphId The id of the vendor triumph pay record
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [shipmentId] The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsTriumphIdInvoicesGet: function (triumphId, page, pageSize, shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'triumphId' is not null or undefined
                            (0, common_1.assertParamExists)('paymentsIntegrationsTriumphPayVendorsTriumphIdInvoicesGet', 'triumphId', triumphId);
                            localVarPath = "/payments/integrations/triumph-pay/vendors/{triumphId}/invoices/"
                                .replace("{".concat("triumphId", "}"), encodeURIComponent(String(triumphId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (shipmentId !== undefined) {
                                localVarQueryParameter['shipment_id'] = shipmentId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates pay_via_triumph_pay field of the current Triumph Pay vendor
         * @param {string} triumphId The id of the vendor triumph pay record
         * @param {PostTriumphPayVendor} [postTriumphPayVendor]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsTriumphIdPayViaTriumphPayPost: function (triumphId, postTriumphPayVendor, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'triumphId' is not null or undefined
                            (0, common_1.assertParamExists)('paymentsIntegrationsTriumphPayVendorsTriumphIdPayViaTriumphPayPost', 'triumphId', triumphId);
                            localVarPath = "/payments/integrations/triumph-pay/vendors/{triumphId}/pay-via-triumph-pay/"
                                .replace("{".concat("triumphId", "}"), encodeURIComponent(String(triumphId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(postTriumphPayVendor, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a vendor\'s payment account on Triumph Pay
         * @param {string} triumphId The id of the vendor triumph pay record
         * @param {TriumphPayVendorPaymentAccountData} triumphPayVendorPaymentAccountData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesPost: function (triumphId, triumphPayVendorPaymentAccountData, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'triumphId' is not null or undefined
                            (0, common_1.assertParamExists)('paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesPost', 'triumphId', triumphId);
                            // verify required parameter 'triumphPayVendorPaymentAccountData' is not null or undefined
                            (0, common_1.assertParamExists)('paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesPost', 'triumphPayVendorPaymentAccountData', triumphPayVendorPaymentAccountData);
                            localVarPath = "/payments/integrations/triumph-pay/vendors/{triumphId}/payment-types/"
                                .replace("{".concat("triumphId", "}"), encodeURIComponent(String(triumphId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(triumphPayVendorPaymentAccountData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a payment account belonging to vendor from Triumph Pay
         * @param {string} triumphId The id of the vendor triumph pay record
         * @param {string} triumphPaymentTypeId The id of the payment type synced to triumph pay
         * @param {LetterOfReleaseDocument} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdDelete: function (triumphId, triumphPaymentTypeId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'triumphId' is not null or undefined
                            (0, common_1.assertParamExists)('paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdDelete', 'triumphId', triumphId);
                            // verify required parameter 'triumphPaymentTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdDelete', 'triumphPaymentTypeId', triumphPaymentTypeId);
                            localVarPath = "/payments/integrations/triumph-pay/vendors/{triumphId}/payment-types/{triumphPaymentTypeId}/"
                                .replace("{".concat("triumphId", "}"), encodeURIComponent(String(triumphId)))
                                .replace("{".concat("triumphPaymentTypeId", "}"), encodeURIComponent(String(triumphPaymentTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Return a vendor\'s payment accounts details synced with Triumph Pay
         * @param {string} triumphId The id of the vendor triumph pay record
         * @param {string} triumphPaymentTypeId The id of the payment type synced to triumph pay
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdGet: function (triumphId, triumphPaymentTypeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'triumphId' is not null or undefined
                            (0, common_1.assertParamExists)('paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdGet', 'triumphId', triumphId);
                            // verify required parameter 'triumphPaymentTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdGet', 'triumphPaymentTypeId', triumphPaymentTypeId);
                            localVarPath = "/payments/integrations/triumph-pay/vendors/{triumphId}/payment-types/{triumphPaymentTypeId}/"
                                .replace("{".concat("triumphId", "}"), encodeURIComponent(String(triumphId)))
                                .replace("{".concat("triumphPaymentTypeId", "}"), encodeURIComponent(String(triumphPaymentTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a vendor\'s payment type details on Triumph Pay
         * @param {string} triumphId The id of the vendor triumph pay record
         * @param {string} triumphPaymentTypeId The id of the payment type synced to triumph pay
         * @param {TriumphPayVendorPaymentAccountDataWithFactorCompanyChangeDocuments} [body] The payment type information to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdPut: function (triumphId, triumphPaymentTypeId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'triumphId' is not null or undefined
                            (0, common_1.assertParamExists)('paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdPut', 'triumphId', triumphId);
                            // verify required parameter 'triumphPaymentTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdPut', 'triumphPaymentTypeId', triumphPaymentTypeId);
                            localVarPath = "/payments/integrations/triumph-pay/vendors/{triumphId}/payment-types/{triumphPaymentTypeId}/"
                                .replace("{".concat("triumphId", "}"), encodeURIComponent(String(triumphId)))
                                .replace("{".concat("triumphPaymentTypeId", "}"), encodeURIComponent(String(triumphPaymentTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Set a vendor\'s payment account as default on Triumph Pay
         * @param {string} triumphId The id of the vendor triumph pay record
         * @param {string} triumphPaymentTypeId The id of the payment type synced to triumph pay
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdSetDefaultPost: function (triumphId, triumphPaymentTypeId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'triumphId' is not null or undefined
                            (0, common_1.assertParamExists)('paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdSetDefaultPost', 'triumphId', triumphId);
                            // verify required parameter 'triumphPaymentTypeId' is not null or undefined
                            (0, common_1.assertParamExists)('paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdSetDefaultPost', 'triumphPaymentTypeId', triumphPaymentTypeId);
                            localVarPath = "/payments/integrations/triumph-pay/vendors/{triumphId}/payment-types/{triumphPaymentTypeId}/set-default/"
                                .replace("{".concat("triumphId", "}"), encodeURIComponent(String(triumphId)))
                                .replace("{".concat("triumphPaymentTypeId", "}"), encodeURIComponent(String(triumphPaymentTypeId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all triumph pay vendor factoring company entries
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [q] search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsVendorFactoringCompaniesGet: function (page, pageSize, q, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/payments/integrations/triumph-pay/vendors/vendor-factoring-companies/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PaymentsApiAxiosParamCreator = PaymentsApiAxiosParamCreator;
/**
 * PaymentsApi - functional programming interface
 * @export
 */
var PaymentsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PaymentsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Returns Triumph Pay authorization details for a given company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthAuthorizationDetailsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentsIntegrationsTriumphPayAuthAuthorizationDetailsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Checks if a user has authenticated with Triumph Pay
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthCheckGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentsIntegrationsTriumphPayAuthCheckGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a company\'s Triumph Pay documents submission email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthEmailGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentsIntegrationsTriumphPayAuthEmailGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Add the user\'s company\'s Triumph Pay documents submission email
         * @param {TriumphPayDocumentsSubmissionEmail} triumphPayDocumentsSubmissionEmail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthEmailPost: function (triumphPayDocumentsSubmissionEmail, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentsIntegrationsTriumphPayAuthEmailPost(triumphPayDocumentsSubmissionEmail, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a company\'s Triumph Pay documents submission email
         * @param {string} triumphSettingsId The id of the company\&#39;s triumph pay settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthEmailTriumphSettingsIdGet: function (triumphSettingsId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentsIntegrationsTriumphPayAuthEmailTriumphSettingsIdGet(triumphSettingsId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update the user\'s company\'s Triumph Pay documents submission email
         * @param {string} triumphSettingsId The id of the company\&#39;s triumph pay settings
         * @param {TriumphPayDocumentsSubmissionEmail} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthEmailTriumphSettingsIdPatch: function (triumphSettingsId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentsIntegrationsTriumphPayAuthEmailTriumphSettingsIdPatch(triumphSettingsId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update the user\'s company\'s Triumph Pay documents submission email
         * @param {string} triumphSettingsId The id of the company\&#39;s triumph pay settings
         * @param {TriumphPayDocumentsSubmissionEmail} triumphPayDocumentsSubmissionEmail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthEmailTriumphSettingsIdPut: function (triumphSettingsId, triumphPayDocumentsSubmissionEmail, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentsIntegrationsTriumphPayAuthEmailTriumphSettingsIdPut(triumphSettingsId, triumphPayDocumentsSubmissionEmail, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Initiates Triumph Pay authentication for logged in user with Shipwell API
         * @param {string} [redirectUrl] The route to redirect to after successful Triumph Pay authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthGet: function (redirectUrl, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentsIntegrationsTriumphPayAuthGet(redirectUrl, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Revokes Triumph Pay authorization for a given company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthRevokeAuthorizationPost: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentsIntegrationsTriumphPayAuthRevokeAuthorizationPost(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This endpoint will retry creating a TriumphPay Invoice
         * @summary Retry invoice creation to TriumphPay
         * @param {string} billId The id of the bill within Shipwell
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayRetryInvoiceCreationBillIdPost: function (billId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentsIntegrationsTriumphPayRetryInvoiceCreationBillIdPost(billId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve values for ApprovedDateSource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPaySettingsApprovedDateSourceGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentsIntegrationsTriumphPaySettingsApprovedDateSourceGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete user\'s company\'s Triumph Pay configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPaySettingsDelete: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentsIntegrationsTriumphPaySettingsDelete(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a company\'s Triumph Pay documents submission email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPaySettingsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentsIntegrationsTriumphPaySettingsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update the user\'s company\'s Triumph Pay configuration
         * @param {TriumphPayAuthSettings} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPaySettingsPut: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentsIntegrationsTriumphPaySettingsPut(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * This will validate and return back addresses relating to triumph pay
         * @summary Validate a formatted address for triumph pay
         * @param {FormattedAddress} formattedAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayValidateMailtoAddressPost: function (formattedAddress, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentsIntegrationsTriumphPayValidateMailtoAddressPost(formattedAddress, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Establishes a vendor connection to TriumphPay
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsEstablishTriumphPayConnectionCarrierRelationshipIdPost: function (carrierRelationshipId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentsIntegrationsTriumphPayVendorsEstablishTriumphPayConnectionCarrierRelationshipIdPost(carrierRelationshipId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Return a list of vendors that have been synced to Triumph Pay
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsGet: function (page, pageSize, ordering, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentsIntegrationsTriumphPayVendorsGet(page, pageSize, ordering, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Return a vendors details synced with Triumph Pay
         * @param {string} triumphId The id of the vendor triumph pay record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsTriumphIdGet: function (triumphId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentsIntegrationsTriumphPayVendorsTriumphIdGet(triumphId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Return a vendor\'s triumph pay invoices synced with Triumph Pay
         * @param {string} triumphId The id of the vendor triumph pay record
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [shipmentId] The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsTriumphIdInvoicesGet: function (triumphId, page, pageSize, shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentsIntegrationsTriumphPayVendorsTriumphIdInvoicesGet(triumphId, page, pageSize, shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates pay_via_triumph_pay field of the current Triumph Pay vendor
         * @param {string} triumphId The id of the vendor triumph pay record
         * @param {PostTriumphPayVendor} [postTriumphPayVendor]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsTriumphIdPayViaTriumphPayPost: function (triumphId, postTriumphPayVendor, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentsIntegrationsTriumphPayVendorsTriumphIdPayViaTriumphPayPost(triumphId, postTriumphPayVendor, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a vendor\'s payment account on Triumph Pay
         * @param {string} triumphId The id of the vendor triumph pay record
         * @param {TriumphPayVendorPaymentAccountData} triumphPayVendorPaymentAccountData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesPost: function (triumphId, triumphPayVendorPaymentAccountData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesPost(triumphId, triumphPayVendorPaymentAccountData, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a payment account belonging to vendor from Triumph Pay
         * @param {string} triumphId The id of the vendor triumph pay record
         * @param {string} triumphPaymentTypeId The id of the payment type synced to triumph pay
         * @param {LetterOfReleaseDocument} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdDelete: function (triumphId, triumphPaymentTypeId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdDelete(triumphId, triumphPaymentTypeId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Return a vendor\'s payment accounts details synced with Triumph Pay
         * @param {string} triumphId The id of the vendor triumph pay record
         * @param {string} triumphPaymentTypeId The id of the payment type synced to triumph pay
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdGet: function (triumphId, triumphPaymentTypeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdGet(triumphId, triumphPaymentTypeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a vendor\'s payment type details on Triumph Pay
         * @param {string} triumphId The id of the vendor triumph pay record
         * @param {string} triumphPaymentTypeId The id of the payment type synced to triumph pay
         * @param {TriumphPayVendorPaymentAccountDataWithFactorCompanyChangeDocuments} [body] The payment type information to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdPut: function (triumphId, triumphPaymentTypeId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdPut(triumphId, triumphPaymentTypeId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Set a vendor\'s payment account as default on Triumph Pay
         * @param {string} triumphId The id of the vendor triumph pay record
         * @param {string} triumphPaymentTypeId The id of the payment type synced to triumph pay
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdSetDefaultPost: function (triumphId, triumphPaymentTypeId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdSetDefaultPost(triumphId, triumphPaymentTypeId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all triumph pay vendor factoring company entries
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [q] search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsVendorFactoringCompaniesGet: function (page, pageSize, q, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.paymentsIntegrationsTriumphPayVendorsVendorFactoringCompaniesGet(page, pageSize, q, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PaymentsApiFp = PaymentsApiFp;
/**
 * PaymentsApi - factory interface
 * @export
 */
var PaymentsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PaymentsApiFp)(configuration);
    return {
        /**
         *
         * @summary Returns Triumph Pay authorization details for a given company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthAuthorizationDetailsGet: function (options) {
            return localVarFp.paymentsIntegrationsTriumphPayAuthAuthorizationDetailsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Checks if a user has authenticated with Triumph Pay
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthCheckGet: function (options) {
            return localVarFp.paymentsIntegrationsTriumphPayAuthCheckGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a company\'s Triumph Pay documents submission email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthEmailGet: function (options) {
            return localVarFp.paymentsIntegrationsTriumphPayAuthEmailGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Add the user\'s company\'s Triumph Pay documents submission email
         * @param {TriumphPayDocumentsSubmissionEmail} triumphPayDocumentsSubmissionEmail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthEmailPost: function (triumphPayDocumentsSubmissionEmail, options) {
            return localVarFp.paymentsIntegrationsTriumphPayAuthEmailPost(triumphPayDocumentsSubmissionEmail, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a company\'s Triumph Pay documents submission email
         * @param {string} triumphSettingsId The id of the company\&#39;s triumph pay settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthEmailTriumphSettingsIdGet: function (triumphSettingsId, options) {
            return localVarFp.paymentsIntegrationsTriumphPayAuthEmailTriumphSettingsIdGet(triumphSettingsId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update the user\'s company\'s Triumph Pay documents submission email
         * @param {string} triumphSettingsId The id of the company\&#39;s triumph pay settings
         * @param {TriumphPayDocumentsSubmissionEmail} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthEmailTriumphSettingsIdPatch: function (triumphSettingsId, body, options) {
            return localVarFp.paymentsIntegrationsTriumphPayAuthEmailTriumphSettingsIdPatch(triumphSettingsId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update the user\'s company\'s Triumph Pay documents submission email
         * @param {string} triumphSettingsId The id of the company\&#39;s triumph pay settings
         * @param {TriumphPayDocumentsSubmissionEmail} triumphPayDocumentsSubmissionEmail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthEmailTriumphSettingsIdPut: function (triumphSettingsId, triumphPayDocumentsSubmissionEmail, options) {
            return localVarFp.paymentsIntegrationsTriumphPayAuthEmailTriumphSettingsIdPut(triumphSettingsId, triumphPayDocumentsSubmissionEmail, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Initiates Triumph Pay authentication for logged in user with Shipwell API
         * @param {string} [redirectUrl] The route to redirect to after successful Triumph Pay authentication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthGet: function (redirectUrl, options) {
            return localVarFp.paymentsIntegrationsTriumphPayAuthGet(redirectUrl, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Revokes Triumph Pay authorization for a given company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayAuthRevokeAuthorizationPost: function (options) {
            return localVarFp.paymentsIntegrationsTriumphPayAuthRevokeAuthorizationPost(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This endpoint will retry creating a TriumphPay Invoice
         * @summary Retry invoice creation to TriumphPay
         * @param {string} billId The id of the bill within Shipwell
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayRetryInvoiceCreationBillIdPost: function (billId, options) {
            return localVarFp.paymentsIntegrationsTriumphPayRetryInvoiceCreationBillIdPost(billId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve values for ApprovedDateSource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPaySettingsApprovedDateSourceGet: function (options) {
            return localVarFp.paymentsIntegrationsTriumphPaySettingsApprovedDateSourceGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete user\'s company\'s Triumph Pay configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPaySettingsDelete: function (options) {
            return localVarFp.paymentsIntegrationsTriumphPaySettingsDelete(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a company\'s Triumph Pay documents submission email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPaySettingsGet: function (options) {
            return localVarFp.paymentsIntegrationsTriumphPaySettingsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update the user\'s company\'s Triumph Pay configuration
         * @param {TriumphPayAuthSettings} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPaySettingsPut: function (body, options) {
            return localVarFp.paymentsIntegrationsTriumphPaySettingsPut(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * This will validate and return back addresses relating to triumph pay
         * @summary Validate a formatted address for triumph pay
         * @param {FormattedAddress} formattedAddress
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayValidateMailtoAddressPost: function (formattedAddress, options) {
            return localVarFp.paymentsIntegrationsTriumphPayValidateMailtoAddressPost(formattedAddress, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Establishes a vendor connection to TriumphPay
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsEstablishTriumphPayConnectionCarrierRelationshipIdPost: function (carrierRelationshipId, options) {
            return localVarFp.paymentsIntegrationsTriumphPayVendorsEstablishTriumphPayConnectionCarrierRelationshipIdPost(carrierRelationshipId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Return a list of vendors that have been synced to Triumph Pay
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsGet: function (page, pageSize, ordering, options) {
            return localVarFp.paymentsIntegrationsTriumphPayVendorsGet(page, pageSize, ordering, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Return a vendors details synced with Triumph Pay
         * @param {string} triumphId The id of the vendor triumph pay record
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsTriumphIdGet: function (triumphId, options) {
            return localVarFp.paymentsIntegrationsTriumphPayVendorsTriumphIdGet(triumphId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Return a vendor\'s triumph pay invoices synced with Triumph Pay
         * @param {string} triumphId The id of the vendor triumph pay record
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [shipmentId] The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsTriumphIdInvoicesGet: function (triumphId, page, pageSize, shipmentId, options) {
            return localVarFp.paymentsIntegrationsTriumphPayVendorsTriumphIdInvoicesGet(triumphId, page, pageSize, shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates pay_via_triumph_pay field of the current Triumph Pay vendor
         * @param {string} triumphId The id of the vendor triumph pay record
         * @param {PostTriumphPayVendor} [postTriumphPayVendor]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsTriumphIdPayViaTriumphPayPost: function (triumphId, postTriumphPayVendor, options) {
            return localVarFp.paymentsIntegrationsTriumphPayVendorsTriumphIdPayViaTriumphPayPost(triumphId, postTriumphPayVendor, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a vendor\'s payment account on Triumph Pay
         * @param {string} triumphId The id of the vendor triumph pay record
         * @param {TriumphPayVendorPaymentAccountData} triumphPayVendorPaymentAccountData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesPost: function (triumphId, triumphPayVendorPaymentAccountData, options) {
            return localVarFp.paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesPost(triumphId, triumphPayVendorPaymentAccountData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a payment account belonging to vendor from Triumph Pay
         * @param {string} triumphId The id of the vendor triumph pay record
         * @param {string} triumphPaymentTypeId The id of the payment type synced to triumph pay
         * @param {LetterOfReleaseDocument} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdDelete: function (triumphId, triumphPaymentTypeId, body, options) {
            return localVarFp.paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdDelete(triumphId, triumphPaymentTypeId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Return a vendor\'s payment accounts details synced with Triumph Pay
         * @param {string} triumphId The id of the vendor triumph pay record
         * @param {string} triumphPaymentTypeId The id of the payment type synced to triumph pay
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdGet: function (triumphId, triumphPaymentTypeId, options) {
            return localVarFp.paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdGet(triumphId, triumphPaymentTypeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a vendor\'s payment type details on Triumph Pay
         * @param {string} triumphId The id of the vendor triumph pay record
         * @param {string} triumphPaymentTypeId The id of the payment type synced to triumph pay
         * @param {TriumphPayVendorPaymentAccountDataWithFactorCompanyChangeDocuments} [body] The payment type information to update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdPut: function (triumphId, triumphPaymentTypeId, body, options) {
            return localVarFp.paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdPut(triumphId, triumphPaymentTypeId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Set a vendor\'s payment account as default on Triumph Pay
         * @param {string} triumphId The id of the vendor triumph pay record
         * @param {string} triumphPaymentTypeId The id of the payment type synced to triumph pay
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdSetDefaultPost: function (triumphId, triumphPaymentTypeId, options) {
            return localVarFp.paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdSetDefaultPost(triumphId, triumphPaymentTypeId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary A list of all triumph pay vendor factoring company entries
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [q] search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsIntegrationsTriumphPayVendorsVendorFactoringCompaniesGet: function (page, pageSize, q, options) {
            return localVarFp.paymentsIntegrationsTriumphPayVendorsVendorFactoringCompaniesGet(page, pageSize, q, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PaymentsApiFactory = PaymentsApiFactory;
/**
 * PaymentsApi - object-oriented interface
 * @export
 * @class PaymentsApi
 * @extends {BaseAPI}
 */
var PaymentsApi = /** @class */ (function (_super) {
    __extends(PaymentsApi, _super);
    function PaymentsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Returns Triumph Pay authorization details for a given company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    PaymentsApi.prototype.paymentsIntegrationsTriumphPayAuthAuthorizationDetailsGet = function (options) {
        var _this = this;
        return (0, exports.PaymentsApiFp)(this.configuration).paymentsIntegrationsTriumphPayAuthAuthorizationDetailsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Checks if a user has authenticated with Triumph Pay
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    PaymentsApi.prototype.paymentsIntegrationsTriumphPayAuthCheckGet = function (options) {
        var _this = this;
        return (0, exports.PaymentsApiFp)(this.configuration).paymentsIntegrationsTriumphPayAuthCheckGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a company\'s Triumph Pay documents submission email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    PaymentsApi.prototype.paymentsIntegrationsTriumphPayAuthEmailGet = function (options) {
        var _this = this;
        return (0, exports.PaymentsApiFp)(this.configuration).paymentsIntegrationsTriumphPayAuthEmailGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Add the user\'s company\'s Triumph Pay documents submission email
     * @param {TriumphPayDocumentsSubmissionEmail} triumphPayDocumentsSubmissionEmail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    PaymentsApi.prototype.paymentsIntegrationsTriumphPayAuthEmailPost = function (triumphPayDocumentsSubmissionEmail, options) {
        var _this = this;
        return (0, exports.PaymentsApiFp)(this.configuration).paymentsIntegrationsTriumphPayAuthEmailPost(triumphPayDocumentsSubmissionEmail, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a company\'s Triumph Pay documents submission email
     * @param {string} triumphSettingsId The id of the company\&#39;s triumph pay settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    PaymentsApi.prototype.paymentsIntegrationsTriumphPayAuthEmailTriumphSettingsIdGet = function (triumphSettingsId, options) {
        var _this = this;
        return (0, exports.PaymentsApiFp)(this.configuration).paymentsIntegrationsTriumphPayAuthEmailTriumphSettingsIdGet(triumphSettingsId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update the user\'s company\'s Triumph Pay documents submission email
     * @param {string} triumphSettingsId The id of the company\&#39;s triumph pay settings
     * @param {TriumphPayDocumentsSubmissionEmail} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    PaymentsApi.prototype.paymentsIntegrationsTriumphPayAuthEmailTriumphSettingsIdPatch = function (triumphSettingsId, body, options) {
        var _this = this;
        return (0, exports.PaymentsApiFp)(this.configuration).paymentsIntegrationsTriumphPayAuthEmailTriumphSettingsIdPatch(triumphSettingsId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update the user\'s company\'s Triumph Pay documents submission email
     * @param {string} triumphSettingsId The id of the company\&#39;s triumph pay settings
     * @param {TriumphPayDocumentsSubmissionEmail} triumphPayDocumentsSubmissionEmail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    PaymentsApi.prototype.paymentsIntegrationsTriumphPayAuthEmailTriumphSettingsIdPut = function (triumphSettingsId, triumphPayDocumentsSubmissionEmail, options) {
        var _this = this;
        return (0, exports.PaymentsApiFp)(this.configuration).paymentsIntegrationsTriumphPayAuthEmailTriumphSettingsIdPut(triumphSettingsId, triumphPayDocumentsSubmissionEmail, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Initiates Triumph Pay authentication for logged in user with Shipwell API
     * @param {string} [redirectUrl] The route to redirect to after successful Triumph Pay authentication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    PaymentsApi.prototype.paymentsIntegrationsTriumphPayAuthGet = function (redirectUrl, options) {
        var _this = this;
        return (0, exports.PaymentsApiFp)(this.configuration).paymentsIntegrationsTriumphPayAuthGet(redirectUrl, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Revokes Triumph Pay authorization for a given company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    PaymentsApi.prototype.paymentsIntegrationsTriumphPayAuthRevokeAuthorizationPost = function (options) {
        var _this = this;
        return (0, exports.PaymentsApiFp)(this.configuration).paymentsIntegrationsTriumphPayAuthRevokeAuthorizationPost(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This endpoint will retry creating a TriumphPay Invoice
     * @summary Retry invoice creation to TriumphPay
     * @param {string} billId The id of the bill within Shipwell
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    PaymentsApi.prototype.paymentsIntegrationsTriumphPayRetryInvoiceCreationBillIdPost = function (billId, options) {
        var _this = this;
        return (0, exports.PaymentsApiFp)(this.configuration).paymentsIntegrationsTriumphPayRetryInvoiceCreationBillIdPost(billId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve values for ApprovedDateSource
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    PaymentsApi.prototype.paymentsIntegrationsTriumphPaySettingsApprovedDateSourceGet = function (options) {
        var _this = this;
        return (0, exports.PaymentsApiFp)(this.configuration).paymentsIntegrationsTriumphPaySettingsApprovedDateSourceGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete user\'s company\'s Triumph Pay configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    PaymentsApi.prototype.paymentsIntegrationsTriumphPaySettingsDelete = function (options) {
        var _this = this;
        return (0, exports.PaymentsApiFp)(this.configuration).paymentsIntegrationsTriumphPaySettingsDelete(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a company\'s Triumph Pay documents submission email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    PaymentsApi.prototype.paymentsIntegrationsTriumphPaySettingsGet = function (options) {
        var _this = this;
        return (0, exports.PaymentsApiFp)(this.configuration).paymentsIntegrationsTriumphPaySettingsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update the user\'s company\'s Triumph Pay configuration
     * @param {TriumphPayAuthSettings} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    PaymentsApi.prototype.paymentsIntegrationsTriumphPaySettingsPut = function (body, options) {
        var _this = this;
        return (0, exports.PaymentsApiFp)(this.configuration).paymentsIntegrationsTriumphPaySettingsPut(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * This will validate and return back addresses relating to triumph pay
     * @summary Validate a formatted address for triumph pay
     * @param {FormattedAddress} formattedAddress
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    PaymentsApi.prototype.paymentsIntegrationsTriumphPayValidateMailtoAddressPost = function (formattedAddress, options) {
        var _this = this;
        return (0, exports.PaymentsApiFp)(this.configuration).paymentsIntegrationsTriumphPayValidateMailtoAddressPost(formattedAddress, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Establishes a vendor connection to TriumphPay
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    PaymentsApi.prototype.paymentsIntegrationsTriumphPayVendorsEstablishTriumphPayConnectionCarrierRelationshipIdPost = function (carrierRelationshipId, options) {
        var _this = this;
        return (0, exports.PaymentsApiFp)(this.configuration).paymentsIntegrationsTriumphPayVendorsEstablishTriumphPayConnectionCarrierRelationshipIdPost(carrierRelationshipId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Return a list of vendors that have been synced to Triumph Pay
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    PaymentsApi.prototype.paymentsIntegrationsTriumphPayVendorsGet = function (page, pageSize, ordering, options) {
        var _this = this;
        return (0, exports.PaymentsApiFp)(this.configuration).paymentsIntegrationsTriumphPayVendorsGet(page, pageSize, ordering, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Return a vendors details synced with Triumph Pay
     * @param {string} triumphId The id of the vendor triumph pay record
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    PaymentsApi.prototype.paymentsIntegrationsTriumphPayVendorsTriumphIdGet = function (triumphId, options) {
        var _this = this;
        return (0, exports.PaymentsApiFp)(this.configuration).paymentsIntegrationsTriumphPayVendorsTriumphIdGet(triumphId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Return a vendor\'s triumph pay invoices synced with Triumph Pay
     * @param {string} triumphId The id of the vendor triumph pay record
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [shipmentId] The id of the shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    PaymentsApi.prototype.paymentsIntegrationsTriumphPayVendorsTriumphIdInvoicesGet = function (triumphId, page, pageSize, shipmentId, options) {
        var _this = this;
        return (0, exports.PaymentsApiFp)(this.configuration).paymentsIntegrationsTriumphPayVendorsTriumphIdInvoicesGet(triumphId, page, pageSize, shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates pay_via_triumph_pay field of the current Triumph Pay vendor
     * @param {string} triumphId The id of the vendor triumph pay record
     * @param {PostTriumphPayVendor} [postTriumphPayVendor]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    PaymentsApi.prototype.paymentsIntegrationsTriumphPayVendorsTriumphIdPayViaTriumphPayPost = function (triumphId, postTriumphPayVendor, options) {
        var _this = this;
        return (0, exports.PaymentsApiFp)(this.configuration).paymentsIntegrationsTriumphPayVendorsTriumphIdPayViaTriumphPayPost(triumphId, postTriumphPayVendor, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a vendor\'s payment account on Triumph Pay
     * @param {string} triumphId The id of the vendor triumph pay record
     * @param {TriumphPayVendorPaymentAccountData} triumphPayVendorPaymentAccountData
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    PaymentsApi.prototype.paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesPost = function (triumphId, triumphPayVendorPaymentAccountData, options) {
        var _this = this;
        return (0, exports.PaymentsApiFp)(this.configuration).paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesPost(triumphId, triumphPayVendorPaymentAccountData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a payment account belonging to vendor from Triumph Pay
     * @param {string} triumphId The id of the vendor triumph pay record
     * @param {string} triumphPaymentTypeId The id of the payment type synced to triumph pay
     * @param {LetterOfReleaseDocument} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    PaymentsApi.prototype.paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdDelete = function (triumphId, triumphPaymentTypeId, body, options) {
        var _this = this;
        return (0, exports.PaymentsApiFp)(this.configuration).paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdDelete(triumphId, triumphPaymentTypeId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Return a vendor\'s payment accounts details synced with Triumph Pay
     * @param {string} triumphId The id of the vendor triumph pay record
     * @param {string} triumphPaymentTypeId The id of the payment type synced to triumph pay
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    PaymentsApi.prototype.paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdGet = function (triumphId, triumphPaymentTypeId, options) {
        var _this = this;
        return (0, exports.PaymentsApiFp)(this.configuration).paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdGet(triumphId, triumphPaymentTypeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a vendor\'s payment type details on Triumph Pay
     * @param {string} triumphId The id of the vendor triumph pay record
     * @param {string} triumphPaymentTypeId The id of the payment type synced to triumph pay
     * @param {TriumphPayVendorPaymentAccountDataWithFactorCompanyChangeDocuments} [body] The payment type information to update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    PaymentsApi.prototype.paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdPut = function (triumphId, triumphPaymentTypeId, body, options) {
        var _this = this;
        return (0, exports.PaymentsApiFp)(this.configuration).paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdPut(triumphId, triumphPaymentTypeId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Set a vendor\'s payment account as default on Triumph Pay
     * @param {string} triumphId The id of the vendor triumph pay record
     * @param {string} triumphPaymentTypeId The id of the payment type synced to triumph pay
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    PaymentsApi.prototype.paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdSetDefaultPost = function (triumphId, triumphPaymentTypeId, options) {
        var _this = this;
        return (0, exports.PaymentsApiFp)(this.configuration).paymentsIntegrationsTriumphPayVendorsTriumphIdPaymentTypesTriumphPaymentTypeIdSetDefaultPost(triumphId, triumphPaymentTypeId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary A list of all triumph pay vendor factoring company entries
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [q] search query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    PaymentsApi.prototype.paymentsIntegrationsTriumphPayVendorsVendorFactoringCompaniesGet = function (page, pageSize, q, options) {
        var _this = this;
        return (0, exports.PaymentsApiFp)(this.configuration).paymentsIntegrationsTriumphPayVendorsVendorFactoringCompaniesGet(page, pageSize, q, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PaymentsApi;
}(base_1.BaseAPI));
exports.PaymentsApi = PaymentsApi;
/**
 * PermissionsApi - axios parameter creator
 * @export
 */
var PermissionsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Returns a dictionary of all permission categories and their underlying permissions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/permissions/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PermissionsApiAxiosParamCreator = PermissionsApiAxiosParamCreator;
/**
 * PermissionsApi - functional programming interface
 * @export
 */
var PermissionsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PermissionsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Returns a dictionary of all permission categories and their underlying permissions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.permissionsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PermissionsApiFp = PermissionsApiFp;
/**
 * PermissionsApi - factory interface
 * @export
 */
var PermissionsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PermissionsApiFp)(configuration);
    return {
        /**
         *
         * @summary Returns a dictionary of all permission categories and their underlying permissions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        permissionsGet: function (options) {
            return localVarFp.permissionsGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PermissionsApiFactory = PermissionsApiFactory;
/**
 * PermissionsApi - object-oriented interface
 * @export
 * @class PermissionsApi
 * @extends {BaseAPI}
 */
var PermissionsApi = /** @class */ (function (_super) {
    __extends(PermissionsApi, _super);
    function PermissionsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Returns a dictionary of all permission categories and their underlying permissions.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApi
     */
    PermissionsApi.prototype.permissionsGet = function (options) {
        var _this = this;
        return (0, exports.PermissionsApiFp)(this.configuration).permissionsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PermissionsApi;
}(base_1.BaseAPI));
exports.PermissionsApi = PermissionsApi;
/**
 * PoliciesApi - axios parameter creator
 * @export
 */
var PoliciesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary List of policies
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [createdAt] For requesting data created at a certain datetime
         * @param {string} [updatedAt] For requesting data updated at a certain datetime
         * @param {Array<string>} [destinationsContains] Return shipments with this value in the destinations
         * @param {Array<string>} [destinationsStateProvince] Return shipments with this state province on its destinations
         * @param {Array<string>} [originsContains] Return shipments with this value in the origins
         * @param {Array<string>} [originsStateProvince] Return shipments with this state province on its origins
         * @param {Array<string>} [equipmentTypes] Return contracts with equipment types
         * @param {Array<string>} [modes] Return contracts with shipment mode codes
         * @param {string} [nameContains] Include Policies where name contains this string
         * @param {string} [endDateGte] Include Policies where end date is greater than or equal to this date
         * @param {string} [endDateLte] Include Policies where end date is less than or equal to this date
         * @param {string} [startDateGte] Include Policies where start date is greater than or equal to this date
         * @param {string} [startDateLte] Include Policies where start date is less than or equal to this date
         * @param {'ACTIVE' | 'INACTIVE'} [status] Include Policies where status is equal to this value
         * @param {'ROUTING_GUIDE' | 'ORDER_CONSOLIDATION'} [policyType] Include policies where the policy type is equal to this value
         * @param {string} [reference] Include policies with this reference ID
         * @param {Array<string>} [workflowId] Include policies with this Workflow ID
         * @param {boolean} [hasError]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routingGuidePoliciesGet: function (page, pageSize, ordering, q, createdAt, updatedAt, destinationsContains, destinationsStateProvince, originsContains, originsStateProvince, equipmentTypes, modes, nameContains, endDateGte, endDateLte, startDateGte, startDateLte, status, policyType, reference, workflowId, hasError, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/routing-guide/policies/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (createdAt !== undefined) {
                                localVarQueryParameter['created_at'] = (createdAt instanceof Date) ?
                                    createdAt.toISOString() :
                                    createdAt;
                            }
                            if (updatedAt !== undefined) {
                                localVarQueryParameter['updated_at'] = (updatedAt instanceof Date) ?
                                    updatedAt.toISOString() :
                                    updatedAt;
                            }
                            if (destinationsContains) {
                                localVarQueryParameter['destinations__contains'] = destinationsContains;
                            }
                            if (destinationsStateProvince) {
                                localVarQueryParameter['destinations_state_province'] = destinationsStateProvince;
                            }
                            if (originsContains) {
                                localVarQueryParameter['origins__contains'] = originsContains;
                            }
                            if (originsStateProvince) {
                                localVarQueryParameter['origins_state_province'] = originsStateProvince;
                            }
                            if (equipmentTypes) {
                                localVarQueryParameter['equipment_types'] = equipmentTypes;
                            }
                            if (modes) {
                                localVarQueryParameter['modes'] = modes;
                            }
                            if (nameContains !== undefined) {
                                localVarQueryParameter['name__contains'] = nameContains;
                            }
                            if (endDateGte !== undefined) {
                                localVarQueryParameter['end_date__gte'] = (endDateGte instanceof Date) ?
                                    endDateGte.toISOString().substr(0, 10) :
                                    endDateGte;
                            }
                            if (endDateLte !== undefined) {
                                localVarQueryParameter['end_date__lte'] = (endDateLte instanceof Date) ?
                                    endDateLte.toISOString().substr(0, 10) :
                                    endDateLte;
                            }
                            if (startDateGte !== undefined) {
                                localVarQueryParameter['start_date__gte'] = (startDateGte instanceof Date) ?
                                    startDateGte.toISOString().substr(0, 10) :
                                    startDateGte;
                            }
                            if (startDateLte !== undefined) {
                                localVarQueryParameter['start_date__lte'] = (startDateLte instanceof Date) ?
                                    startDateLte.toISOString().substr(0, 10) :
                                    startDateLte;
                            }
                            if (status !== undefined) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (policyType !== undefined) {
                                localVarQueryParameter['policy_type'] = policyType;
                            }
                            if (reference !== undefined) {
                                localVarQueryParameter['reference'] = reference;
                            }
                            if (workflowId) {
                                localVarQueryParameter['workflow_id'] = workflowId;
                            }
                            if (hasError !== undefined) {
                                localVarQueryParameter['has_error'] = hasError;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Convert a Policy into a StructuredConditional that can be used as a triggering condition within Workflow Automation
         * @param {string} policyId The id of a policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routingGuidePoliciesPolicyIdConditionalTriggerGet: function (policyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'policyId' is not null or undefined
                            (0, common_1.assertParamExists)('routingGuidePoliciesPolicyIdConditionalTriggerGet', 'policyId', policyId);
                            localVarPath = "/routing-guide/policies/{policyId}/conditional-trigger/"
                                .replace("{".concat("policyId", "}"), encodeURIComponent(String(policyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a Policy
         * @param {string} policyId The id of a policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routingGuidePoliciesPolicyIdDelete: function (policyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'policyId' is not null or undefined
                            (0, common_1.assertParamExists)('routingGuidePoliciesPolicyIdDelete', 'policyId', policyId);
                            localVarPath = "/routing-guide/policies/{policyId}/"
                                .replace("{".concat("policyId", "}"), encodeURIComponent(String(policyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a Policy
         * @param {string} policyId The id of a policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routingGuidePoliciesPolicyIdGet: function (policyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'policyId' is not null or undefined
                            (0, common_1.assertParamExists)('routingGuidePoliciesPolicyIdGet', 'policyId', policyId);
                            localVarPath = "/routing-guide/policies/{policyId}/"
                                .replace("{".concat("policyId", "}"), encodeURIComponent(String(policyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a Policy
         * @param {string} policyId The id of a policy
         * @param {Policy} policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routingGuidePoliciesPolicyIdPut: function (policyId, policy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'policyId' is not null or undefined
                            (0, common_1.assertParamExists)('routingGuidePoliciesPolicyIdPut', 'policyId', policyId);
                            // verify required parameter 'policy' is not null or undefined
                            (0, common_1.assertParamExists)('routingGuidePoliciesPolicyIdPut', 'policy', policy);
                            localVarPath = "/routing-guide/policies/{policyId}/"
                                .replace("{".concat("policyId", "}"), encodeURIComponent(String(policyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(policy, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new policy
         * @param {Policy} policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routingGuidePoliciesPost: function (policy, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'policy' is not null or undefined
                            (0, common_1.assertParamExists)('routingGuidePoliciesPost', 'policy', policy);
                            localVarPath = "/routing-guide/policies/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(policy, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PoliciesApiAxiosParamCreator = PoliciesApiAxiosParamCreator;
/**
 * PoliciesApi - functional programming interface
 * @export
 */
var PoliciesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PoliciesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary List of policies
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [createdAt] For requesting data created at a certain datetime
         * @param {string} [updatedAt] For requesting data updated at a certain datetime
         * @param {Array<string>} [destinationsContains] Return shipments with this value in the destinations
         * @param {Array<string>} [destinationsStateProvince] Return shipments with this state province on its destinations
         * @param {Array<string>} [originsContains] Return shipments with this value in the origins
         * @param {Array<string>} [originsStateProvince] Return shipments with this state province on its origins
         * @param {Array<string>} [equipmentTypes] Return contracts with equipment types
         * @param {Array<string>} [modes] Return contracts with shipment mode codes
         * @param {string} [nameContains] Include Policies where name contains this string
         * @param {string} [endDateGte] Include Policies where end date is greater than or equal to this date
         * @param {string} [endDateLte] Include Policies where end date is less than or equal to this date
         * @param {string} [startDateGte] Include Policies where start date is greater than or equal to this date
         * @param {string} [startDateLte] Include Policies where start date is less than or equal to this date
         * @param {'ACTIVE' | 'INACTIVE'} [status] Include Policies where status is equal to this value
         * @param {'ROUTING_GUIDE' | 'ORDER_CONSOLIDATION'} [policyType] Include policies where the policy type is equal to this value
         * @param {string} [reference] Include policies with this reference ID
         * @param {Array<string>} [workflowId] Include policies with this Workflow ID
         * @param {boolean} [hasError]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routingGuidePoliciesGet: function (page, pageSize, ordering, q, createdAt, updatedAt, destinationsContains, destinationsStateProvince, originsContains, originsStateProvince, equipmentTypes, modes, nameContains, endDateGte, endDateLte, startDateGte, startDateLte, status, policyType, reference, workflowId, hasError, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.routingGuidePoliciesGet(page, pageSize, ordering, q, createdAt, updatedAt, destinationsContains, destinationsStateProvince, originsContains, originsStateProvince, equipmentTypes, modes, nameContains, endDateGte, endDateLte, startDateGte, startDateLte, status, policyType, reference, workflowId, hasError, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Convert a Policy into a StructuredConditional that can be used as a triggering condition within Workflow Automation
         * @param {string} policyId The id of a policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routingGuidePoliciesPolicyIdConditionalTriggerGet: function (policyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.routingGuidePoliciesPolicyIdConditionalTriggerGet(policyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a Policy
         * @param {string} policyId The id of a policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routingGuidePoliciesPolicyIdDelete: function (policyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.routingGuidePoliciesPolicyIdDelete(policyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a Policy
         * @param {string} policyId The id of a policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routingGuidePoliciesPolicyIdGet: function (policyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.routingGuidePoliciesPolicyIdGet(policyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a Policy
         * @param {string} policyId The id of a policy
         * @param {Policy} policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routingGuidePoliciesPolicyIdPut: function (policyId, policy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.routingGuidePoliciesPolicyIdPut(policyId, policy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new policy
         * @param {Policy} policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routingGuidePoliciesPost: function (policy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.routingGuidePoliciesPost(policy, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PoliciesApiFp = PoliciesApiFp;
/**
 * PoliciesApi - factory interface
 * @export
 */
var PoliciesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PoliciesApiFp)(configuration);
    return {
        /**
         *
         * @summary List of policies
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [createdAt] For requesting data created at a certain datetime
         * @param {string} [updatedAt] For requesting data updated at a certain datetime
         * @param {Array<string>} [destinationsContains] Return shipments with this value in the destinations
         * @param {Array<string>} [destinationsStateProvince] Return shipments with this state province on its destinations
         * @param {Array<string>} [originsContains] Return shipments with this value in the origins
         * @param {Array<string>} [originsStateProvince] Return shipments with this state province on its origins
         * @param {Array<string>} [equipmentTypes] Return contracts with equipment types
         * @param {Array<string>} [modes] Return contracts with shipment mode codes
         * @param {string} [nameContains] Include Policies where name contains this string
         * @param {string} [endDateGte] Include Policies where end date is greater than or equal to this date
         * @param {string} [endDateLte] Include Policies where end date is less than or equal to this date
         * @param {string} [startDateGte] Include Policies where start date is greater than or equal to this date
         * @param {string} [startDateLte] Include Policies where start date is less than or equal to this date
         * @param {'ACTIVE' | 'INACTIVE'} [status] Include Policies where status is equal to this value
         * @param {'ROUTING_GUIDE' | 'ORDER_CONSOLIDATION'} [policyType] Include policies where the policy type is equal to this value
         * @param {string} [reference] Include policies with this reference ID
         * @param {Array<string>} [workflowId] Include policies with this Workflow ID
         * @param {boolean} [hasError]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routingGuidePoliciesGet: function (page, pageSize, ordering, q, createdAt, updatedAt, destinationsContains, destinationsStateProvince, originsContains, originsStateProvince, equipmentTypes, modes, nameContains, endDateGte, endDateLte, startDateGte, startDateLte, status, policyType, reference, workflowId, hasError, options) {
            return localVarFp.routingGuidePoliciesGet(page, pageSize, ordering, q, createdAt, updatedAt, destinationsContains, destinationsStateProvince, originsContains, originsStateProvince, equipmentTypes, modes, nameContains, endDateGte, endDateLte, startDateGte, startDateLte, status, policyType, reference, workflowId, hasError, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Convert a Policy into a StructuredConditional that can be used as a triggering condition within Workflow Automation
         * @param {string} policyId The id of a policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routingGuidePoliciesPolicyIdConditionalTriggerGet: function (policyId, options) {
            return localVarFp.routingGuidePoliciesPolicyIdConditionalTriggerGet(policyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a Policy
         * @param {string} policyId The id of a policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routingGuidePoliciesPolicyIdDelete: function (policyId, options) {
            return localVarFp.routingGuidePoliciesPolicyIdDelete(policyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a Policy
         * @param {string} policyId The id of a policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routingGuidePoliciesPolicyIdGet: function (policyId, options) {
            return localVarFp.routingGuidePoliciesPolicyIdGet(policyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a Policy
         * @param {string} policyId The id of a policy
         * @param {Policy} policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routingGuidePoliciesPolicyIdPut: function (policyId, policy, options) {
            return localVarFp.routingGuidePoliciesPolicyIdPut(policyId, policy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new policy
         * @param {Policy} policy
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        routingGuidePoliciesPost: function (policy, options) {
            return localVarFp.routingGuidePoliciesPost(policy, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PoliciesApiFactory = PoliciesApiFactory;
/**
 * PoliciesApi - object-oriented interface
 * @export
 * @class PoliciesApi
 * @extends {BaseAPI}
 */
var PoliciesApi = /** @class */ (function (_super) {
    __extends(PoliciesApi, _super);
    function PoliciesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary List of policies
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {string} [createdAt] For requesting data created at a certain datetime
     * @param {string} [updatedAt] For requesting data updated at a certain datetime
     * @param {Array<string>} [destinationsContains] Return shipments with this value in the destinations
     * @param {Array<string>} [destinationsStateProvince] Return shipments with this state province on its destinations
     * @param {Array<string>} [originsContains] Return shipments with this value in the origins
     * @param {Array<string>} [originsStateProvince] Return shipments with this state province on its origins
     * @param {Array<string>} [equipmentTypes] Return contracts with equipment types
     * @param {Array<string>} [modes] Return contracts with shipment mode codes
     * @param {string} [nameContains] Include Policies where name contains this string
     * @param {string} [endDateGte] Include Policies where end date is greater than or equal to this date
     * @param {string} [endDateLte] Include Policies where end date is less than or equal to this date
     * @param {string} [startDateGte] Include Policies where start date is greater than or equal to this date
     * @param {string} [startDateLte] Include Policies where start date is less than or equal to this date
     * @param {'ACTIVE' | 'INACTIVE'} [status] Include Policies where status is equal to this value
     * @param {'ROUTING_GUIDE' | 'ORDER_CONSOLIDATION'} [policyType] Include policies where the policy type is equal to this value
     * @param {string} [reference] Include policies with this reference ID
     * @param {Array<string>} [workflowId] Include policies with this Workflow ID
     * @param {boolean} [hasError]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.routingGuidePoliciesGet = function (page, pageSize, ordering, q, createdAt, updatedAt, destinationsContains, destinationsStateProvince, originsContains, originsStateProvince, equipmentTypes, modes, nameContains, endDateGte, endDateLte, startDateGte, startDateLte, status, policyType, reference, workflowId, hasError, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).routingGuidePoliciesGet(page, pageSize, ordering, q, createdAt, updatedAt, destinationsContains, destinationsStateProvince, originsContains, originsStateProvince, equipmentTypes, modes, nameContains, endDateGte, endDateLte, startDateGte, startDateLte, status, policyType, reference, workflowId, hasError, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Convert a Policy into a StructuredConditional that can be used as a triggering condition within Workflow Automation
     * @param {string} policyId The id of a policy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.routingGuidePoliciesPolicyIdConditionalTriggerGet = function (policyId, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).routingGuidePoliciesPolicyIdConditionalTriggerGet(policyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a Policy
     * @param {string} policyId The id of a policy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.routingGuidePoliciesPolicyIdDelete = function (policyId, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).routingGuidePoliciesPolicyIdDelete(policyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a Policy
     * @param {string} policyId The id of a policy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.routingGuidePoliciesPolicyIdGet = function (policyId, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).routingGuidePoliciesPolicyIdGet(policyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a Policy
     * @param {string} policyId The id of a policy
     * @param {Policy} policy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.routingGuidePoliciesPolicyIdPut = function (policyId, policy, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).routingGuidePoliciesPolicyIdPut(policyId, policy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new policy
     * @param {Policy} policy
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PoliciesApi
     */
    PoliciesApi.prototype.routingGuidePoliciesPost = function (policy, options) {
        var _this = this;
        return (0, exports.PoliciesApiFp)(this.configuration).routingGuidePoliciesPost(policy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PoliciesApi;
}(base_1.BaseAPI));
exports.PoliciesApi = PoliciesApi;
/**
 * PrivateMarketApi - axios parameter creator
 * @export
 */
var PrivateMarketApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Retrieve a SpotNegotiation for the given RFQ that is outbound to a customer rather than inbound from solicited capacity providers
         * @param {string} rfqId The id of the rfq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketRfqsRfqIdCustomerNegotiationGet: function (rfqId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfqId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketRfqsRfqIdCustomerNegotiationGet', 'rfqId', rfqId);
                            localVarPath = "/quoting/privatemarket/rfqs/{rfqId}/customer-negotiation/"
                                .replace("{".concat("rfqId", "}"), encodeURIComponent(String(rfqId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a preview of the HTML Email that will be sent and the included message
         * @param {string} rfqId The id of the rfq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketRfqsRfqIdCustomerNegotiationPreviewGet: function (rfqId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfqId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketRfqsRfqIdCustomerNegotiationPreviewGet', 'rfqId', rfqId);
                            localVarPath = "/quoting/privatemarket/rfqs/{rfqId}/customer-negotiation-preview/"
                                .replace("{".concat("rfqId", "}"), encodeURIComponent(String(rfqId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a SpotNegotiation for the given RFQ that is outbound to a customer rather than inbound from solicited capacity providers
         * @param {string} rfqId The id of the rfq
         * @param {SpotNegotiation} spotNegotiation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketRfqsRfqIdCustomerNegotiationPut: function (rfqId, spotNegotiation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfqId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketRfqsRfqIdCustomerNegotiationPut', 'rfqId', rfqId);
                            // verify required parameter 'spotNegotiation' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketRfqsRfqIdCustomerNegotiationPut', 'spotNegotiation', spotNegotiation);
                            localVarPath = "/quoting/privatemarket/rfqs/{rfqId}/customer-negotiation/"
                                .replace("{".concat("rfqId", "}"), encodeURIComponent(String(rfqId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(spotNegotiation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a preview of the HTML Email that will be sent and the included message
         * @param {string} rfqId The id of the rfq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketRfqsRfqIdSpotNegotiationPreviewGet: function (rfqId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfqId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketRfqsRfqIdSpotNegotiationPreviewGet', 'rfqId', rfqId);
                            localVarPath = "/quoting/privatemarket/rfqs/{rfqId}/spot-negotiation-preview/"
                                .replace("{".concat("rfqId", "}"), encodeURIComponent(String(rfqId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List all SpotNegotiations under this RFQ
         * @param {string} rfqId The id of the rfq
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {boolean} [expandQuotes] Integer boolean, if equal to True SpotNegotiations will expand Quotes under the SpotNegotiation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketRfqsRfqIdSpotNegotiationsGet: function (rfqId, page, pageSize, ordering, expandQuotes, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfqId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketRfqsRfqIdSpotNegotiationsGet', 'rfqId', rfqId);
                            localVarPath = "/quoting/privatemarket/rfqs/{rfqId}/spot-negotiations/"
                                .replace("{".concat("rfqId", "}"), encodeURIComponent(String(rfqId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (expandQuotes !== undefined) {
                                localVarQueryParameter['expand_quotes'] = expandQuotes;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary For a given Shipment id, find the most recently created SpotNegotiation for which the authenticated Company is the solicited company
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketShipmentsShipmentIdDiscoverSolicitedNegotiationGet: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketShipmentsShipmentIdDiscoverSolicitedNegotiationGet', 'shipmentId', shipmentId);
                            localVarPath = "/quoting/privatemarket/shipments/{shipmentId}/discover-solicited-negotiation/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Bulk create SpotNegotiations for an RFQ and emails
         * @param {BulkCreateSpotNegotiationRequest} bulkCreateSpotNegotiationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsPost: function (bulkCreateSpotNegotiationRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'bulkCreateSpotNegotiationRequest' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsPost', 'bulkCreateSpotNegotiationRequest', bulkCreateSpotNegotiationRequest);
                            localVarPath = "/quoting/privatemarket/spot-negotiations/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bulkCreateSpotNegotiationRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Award or decline a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {AwardDeclineQuoteRequest} awardDeclineQuoteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdAwardDeclineQuoteSpotNegotiationQuoteIdPut: function (spotNegotiationId, spotNegotiationQuoteId, awardDeclineQuoteRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsSpotNegotiationIdAwardDeclineQuoteSpotNegotiationQuoteIdPut', 'spotNegotiationId', spotNegotiationId);
                            // verify required parameter 'spotNegotiationQuoteId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsSpotNegotiationIdAwardDeclineQuoteSpotNegotiationQuoteIdPut', 'spotNegotiationQuoteId', spotNegotiationQuoteId);
                            // verify required parameter 'awardDeclineQuoteRequest' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsSpotNegotiationIdAwardDeclineQuoteSpotNegotiationQuoteIdPut', 'awardDeclineQuoteRequest', awardDeclineQuoteRequest);
                            localVarPath = "/quoting/privatemarket/spot-negotiations/{spotNegotiationId}/award-decline-quote/{spotNegotiationQuoteId}/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)))
                                .replace("{".concat("spotNegotiationQuoteId", "}"), encodeURIComponent(String(spotNegotiationQuoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(awardDeclineQuoteRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a SpotNegotiation
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdGet: function (spotNegotiationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsSpotNegotiationIdGet', 'spotNegotiationId', spotNegotiationId);
                            localVarPath = "/quoting/privatemarket/spot-negotiations/{spotNegotiationId}/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Link/unlink an existing Quote to a SpotNegotiation
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {LinkQuoteToSpotNegotiationRequest} linkQuoteToSpotNegotiationRequest
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdLinkQuotePut: function (spotNegotiationId, linkQuoteToSpotNegotiationRequest, xCompanyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsSpotNegotiationIdLinkQuotePut', 'spotNegotiationId', spotNegotiationId);
                            // verify required parameter 'linkQuoteToSpotNegotiationRequest' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsSpotNegotiationIdLinkQuotePut', 'linkQuoteToSpotNegotiationRequest', linkQuoteToSpotNegotiationRequest);
                            localVarPath = "/quoting/privatemarket/spot-negotiations/{spotNegotiationId}/link-quote/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (xCompanyId !== undefined && xCompanyId !== null) {
                                localVarHeaderParameter['X-Company-Id'] = String(xCompanyId);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(linkQuoteToSpotNegotiationRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of messages for a SpotNegotiation
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesGet: function (spotNegotiationId, page, pageSize, ordering, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesGet', 'spotNegotiationId', spotNegotiationId);
                            localVarPath = "/quoting/privatemarket/spot-negotiations/{spotNegotiationId}/messages/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new SpotNegotiationMessage
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {SpotNegotiationMessage} spotNegotiationMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesPost: function (spotNegotiationId, spotNegotiationMessage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesPost', 'spotNegotiationId', spotNegotiationId);
                            // verify required parameter 'spotNegotiationMessage' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesPost', 'spotNegotiationMessage', spotNegotiationMessage);
                            localVarPath = "/quoting/privatemarket/spot-negotiations/{spotNegotiationId}/messages/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(spotNegotiationMessage, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a SpotNegotiationMessage
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationMessageId The id of the spot negotiation message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdDelete: function (spotNegotiationId, spotNegotiationMessageId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdDelete', 'spotNegotiationId', spotNegotiationId);
                            // verify required parameter 'spotNegotiationMessageId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdDelete', 'spotNegotiationMessageId', spotNegotiationMessageId);
                            localVarPath = "/quoting/privatemarket/spot-negotiations/{spotNegotiationId}/messages/{spotNegotiationMessageId}/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)))
                                .replace("{".concat("spotNegotiationMessageId", "}"), encodeURIComponent(String(spotNegotiationMessageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about SpotNegotiationMessage
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationMessageId The id of the spot negotiation message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdGet: function (spotNegotiationId, spotNegotiationMessageId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdGet', 'spotNegotiationId', spotNegotiationId);
                            // verify required parameter 'spotNegotiationMessageId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdGet', 'spotNegotiationMessageId', spotNegotiationMessageId);
                            localVarPath = "/quoting/privatemarket/spot-negotiations/{spotNegotiationId}/messages/{spotNegotiationMessageId}/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)))
                                .replace("{".concat("spotNegotiationMessageId", "}"), encodeURIComponent(String(spotNegotiationMessageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a SpotNegotiationMessage
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationMessageId The id of the spot negotiation message
         * @param {SpotNegotiationMessage} spotNegotiationMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdPut: function (spotNegotiationId, spotNegotiationMessageId, spotNegotiationMessage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdPut', 'spotNegotiationId', spotNegotiationId);
                            // verify required parameter 'spotNegotiationMessageId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdPut', 'spotNegotiationMessageId', spotNegotiationMessageId);
                            // verify required parameter 'spotNegotiationMessage' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdPut', 'spotNegotiationMessage', spotNegotiationMessage);
                            localVarPath = "/quoting/privatemarket/spot-negotiations/{spotNegotiationId}/messages/{spotNegotiationMessageId}/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)))
                                .replace("{".concat("spotNegotiationMessageId", "}"), encodeURIComponent(String(spotNegotiationMessageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(spotNegotiationMessage, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of quotes for a SpotNegotiation
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {boolean} [includeFailures] If true, include failed Quotes in the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesGet: function (spotNegotiationId, page, pageSize, ordering, includeFailures, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesGet', 'spotNegotiationId', spotNegotiationId);
                            localVarPath = "/quoting/privatemarket/spot-negotiations/{spotNegotiationId}/quotes/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (includeFailures !== undefined) {
                                localVarQueryParameter['include_failures'] = includeFailures;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {CreateSpotNegotiationQuote} createSpotNegotiationQuote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesPost: function (spotNegotiationId, createSpotNegotiationQuote, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesPost', 'spotNegotiationId', spotNegotiationId);
                            // verify required parameter 'createSpotNegotiationQuote' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesPost', 'createSpotNegotiationQuote', createSpotNegotiationQuote);
                            localVarPath = "/quoting/privatemarket/spot-negotiations/{spotNegotiationId}/quotes/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createSpotNegotiationQuote, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDelete: function (spotNegotiationId, spotNegotiationQuoteId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDelete', 'spotNegotiationId', spotNegotiationId);
                            // verify required parameter 'spotNegotiationQuoteId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDelete', 'spotNegotiationQuoteId', spotNegotiationQuoteId);
                            localVarPath = "/quoting/privatemarket/spot-negotiations/{spotNegotiationId}/quotes/{spotNegotiationQuoteId}/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)))
                                .replace("{".concat("spotNegotiationQuoteId", "}"), encodeURIComponent(String(spotNegotiationQuoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdGet: function (spotNegotiationId, spotNegotiationQuoteId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdGet', 'spotNegotiationId', spotNegotiationId);
                            // verify required parameter 'spotNegotiationQuoteId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdGet', 'spotNegotiationQuoteId', spotNegotiationQuoteId);
                            localVarPath = "/quoting/privatemarket/spot-negotiations/{spotNegotiationId}/quotes/{spotNegotiationQuoteId}/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)))
                                .replace("{".concat("spotNegotiationQuoteId", "}"), encodeURIComponent(String(spotNegotiationQuoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {Quote} quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdPut: function (spotNegotiationId, spotNegotiationQuoteId, quote, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdPut', 'spotNegotiationId', spotNegotiationId);
                            // verify required parameter 'spotNegotiationQuoteId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdPut', 'spotNegotiationQuoteId', spotNegotiationQuoteId);
                            // verify required parameter 'quote' is not null or undefined
                            (0, common_1.assertParamExists)('quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdPut', 'quote', quote);
                            localVarPath = "/quoting/privatemarket/spot-negotiations/{spotNegotiationId}/quotes/{spotNegotiationQuoteId}/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)))
                                .replace("{".concat("spotNegotiationQuoteId", "}"), encodeURIComponent(String(spotNegotiationQuoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(quote, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PrivateMarketApiAxiosParamCreator = PrivateMarketApiAxiosParamCreator;
/**
 * PrivateMarketApi - functional programming interface
 * @export
 */
var PrivateMarketApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PrivateMarketApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Retrieve a SpotNegotiation for the given RFQ that is outbound to a customer rather than inbound from solicited capacity providers
         * @param {string} rfqId The id of the rfq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketRfqsRfqIdCustomerNegotiationGet: function (rfqId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingPrivatemarketRfqsRfqIdCustomerNegotiationGet(rfqId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a preview of the HTML Email that will be sent and the included message
         * @param {string} rfqId The id of the rfq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketRfqsRfqIdCustomerNegotiationPreviewGet: function (rfqId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingPrivatemarketRfqsRfqIdCustomerNegotiationPreviewGet(rfqId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a SpotNegotiation for the given RFQ that is outbound to a customer rather than inbound from solicited capacity providers
         * @param {string} rfqId The id of the rfq
         * @param {SpotNegotiation} spotNegotiation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketRfqsRfqIdCustomerNegotiationPut: function (rfqId, spotNegotiation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingPrivatemarketRfqsRfqIdCustomerNegotiationPut(rfqId, spotNegotiation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a preview of the HTML Email that will be sent and the included message
         * @param {string} rfqId The id of the rfq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketRfqsRfqIdSpotNegotiationPreviewGet: function (rfqId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingPrivatemarketRfqsRfqIdSpotNegotiationPreviewGet(rfqId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List all SpotNegotiations under this RFQ
         * @param {string} rfqId The id of the rfq
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {boolean} [expandQuotes] Integer boolean, if equal to True SpotNegotiations will expand Quotes under the SpotNegotiation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketRfqsRfqIdSpotNegotiationsGet: function (rfqId, page, pageSize, ordering, expandQuotes, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingPrivatemarketRfqsRfqIdSpotNegotiationsGet(rfqId, page, pageSize, ordering, expandQuotes, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary For a given Shipment id, find the most recently created SpotNegotiation for which the authenticated Company is the solicited company
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketShipmentsShipmentIdDiscoverSolicitedNegotiationGet: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingPrivatemarketShipmentsShipmentIdDiscoverSolicitedNegotiationGet(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Bulk create SpotNegotiations for an RFQ and emails
         * @param {BulkCreateSpotNegotiationRequest} bulkCreateSpotNegotiationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsPost: function (bulkCreateSpotNegotiationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingPrivatemarketSpotNegotiationsPost(bulkCreateSpotNegotiationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Award or decline a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {AwardDeclineQuoteRequest} awardDeclineQuoteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdAwardDeclineQuoteSpotNegotiationQuoteIdPut: function (spotNegotiationId, spotNegotiationQuoteId, awardDeclineQuoteRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdAwardDeclineQuoteSpotNegotiationQuoteIdPut(spotNegotiationId, spotNegotiationQuoteId, awardDeclineQuoteRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a SpotNegotiation
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdGet: function (spotNegotiationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdGet(spotNegotiationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Link/unlink an existing Quote to a SpotNegotiation
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {LinkQuoteToSpotNegotiationRequest} linkQuoteToSpotNegotiationRequest
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdLinkQuotePut: function (spotNegotiationId, linkQuoteToSpotNegotiationRequest, xCompanyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdLinkQuotePut(spotNegotiationId, linkQuoteToSpotNegotiationRequest, xCompanyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of messages for a SpotNegotiation
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesGet: function (spotNegotiationId, page, pageSize, ordering, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesGet(spotNegotiationId, page, pageSize, ordering, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new SpotNegotiationMessage
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {SpotNegotiationMessage} spotNegotiationMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesPost: function (spotNegotiationId, spotNegotiationMessage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesPost(spotNegotiationId, spotNegotiationMessage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a SpotNegotiationMessage
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationMessageId The id of the spot negotiation message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdDelete: function (spotNegotiationId, spotNegotiationMessageId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdDelete(spotNegotiationId, spotNegotiationMessageId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about SpotNegotiationMessage
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationMessageId The id of the spot negotiation message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdGet: function (spotNegotiationId, spotNegotiationMessageId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdGet(spotNegotiationId, spotNegotiationMessageId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a SpotNegotiationMessage
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationMessageId The id of the spot negotiation message
         * @param {SpotNegotiationMessage} spotNegotiationMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdPut: function (spotNegotiationId, spotNegotiationMessageId, spotNegotiationMessage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdPut(spotNegotiationId, spotNegotiationMessageId, spotNegotiationMessage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of quotes for a SpotNegotiation
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {boolean} [includeFailures] If true, include failed Quotes in the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesGet: function (spotNegotiationId, page, pageSize, ordering, includeFailures, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesGet(spotNegotiationId, page, pageSize, ordering, includeFailures, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {CreateSpotNegotiationQuote} createSpotNegotiationQuote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesPost: function (spotNegotiationId, createSpotNegotiationQuote, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesPost(spotNegotiationId, createSpotNegotiationQuote, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDelete: function (spotNegotiationId, spotNegotiationQuoteId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDelete(spotNegotiationId, spotNegotiationQuoteId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdGet: function (spotNegotiationId, spotNegotiationQuoteId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdGet(spotNegotiationId, spotNegotiationQuoteId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {Quote} quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdPut: function (spotNegotiationId, spotNegotiationQuoteId, quote, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdPut(spotNegotiationId, spotNegotiationQuoteId, quote, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PrivateMarketApiFp = PrivateMarketApiFp;
/**
 * PrivateMarketApi - factory interface
 * @export
 */
var PrivateMarketApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PrivateMarketApiFp)(configuration);
    return {
        /**
         *
         * @summary Retrieve a SpotNegotiation for the given RFQ that is outbound to a customer rather than inbound from solicited capacity providers
         * @param {string} rfqId The id of the rfq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketRfqsRfqIdCustomerNegotiationGet: function (rfqId, options) {
            return localVarFp.quotingPrivatemarketRfqsRfqIdCustomerNegotiationGet(rfqId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a preview of the HTML Email that will be sent and the included message
         * @param {string} rfqId The id of the rfq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketRfqsRfqIdCustomerNegotiationPreviewGet: function (rfqId, options) {
            return localVarFp.quotingPrivatemarketRfqsRfqIdCustomerNegotiationPreviewGet(rfqId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a SpotNegotiation for the given RFQ that is outbound to a customer rather than inbound from solicited capacity providers
         * @param {string} rfqId The id of the rfq
         * @param {SpotNegotiation} spotNegotiation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketRfqsRfqIdCustomerNegotiationPut: function (rfqId, spotNegotiation, options) {
            return localVarFp.quotingPrivatemarketRfqsRfqIdCustomerNegotiationPut(rfqId, spotNegotiation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a preview of the HTML Email that will be sent and the included message
         * @param {string} rfqId The id of the rfq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketRfqsRfqIdSpotNegotiationPreviewGet: function (rfqId, options) {
            return localVarFp.quotingPrivatemarketRfqsRfqIdSpotNegotiationPreviewGet(rfqId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List all SpotNegotiations under this RFQ
         * @param {string} rfqId The id of the rfq
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {boolean} [expandQuotes] Integer boolean, if equal to True SpotNegotiations will expand Quotes under the SpotNegotiation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketRfqsRfqIdSpotNegotiationsGet: function (rfqId, page, pageSize, ordering, expandQuotes, options) {
            return localVarFp.quotingPrivatemarketRfqsRfqIdSpotNegotiationsGet(rfqId, page, pageSize, ordering, expandQuotes, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary For a given Shipment id, find the most recently created SpotNegotiation for which the authenticated Company is the solicited company
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketShipmentsShipmentIdDiscoverSolicitedNegotiationGet: function (shipmentId, options) {
            return localVarFp.quotingPrivatemarketShipmentsShipmentIdDiscoverSolicitedNegotiationGet(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Bulk create SpotNegotiations for an RFQ and emails
         * @param {BulkCreateSpotNegotiationRequest} bulkCreateSpotNegotiationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsPost: function (bulkCreateSpotNegotiationRequest, options) {
            return localVarFp.quotingPrivatemarketSpotNegotiationsPost(bulkCreateSpotNegotiationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Award or decline a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {AwardDeclineQuoteRequest} awardDeclineQuoteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdAwardDeclineQuoteSpotNegotiationQuoteIdPut: function (spotNegotiationId, spotNegotiationQuoteId, awardDeclineQuoteRequest, options) {
            return localVarFp.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdAwardDeclineQuoteSpotNegotiationQuoteIdPut(spotNegotiationId, spotNegotiationQuoteId, awardDeclineQuoteRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a SpotNegotiation
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdGet: function (spotNegotiationId, options) {
            return localVarFp.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdGet(spotNegotiationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Link/unlink an existing Quote to a SpotNegotiation
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {LinkQuoteToSpotNegotiationRequest} linkQuoteToSpotNegotiationRequest
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdLinkQuotePut: function (spotNegotiationId, linkQuoteToSpotNegotiationRequest, xCompanyId, options) {
            return localVarFp.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdLinkQuotePut(spotNegotiationId, linkQuoteToSpotNegotiationRequest, xCompanyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a list of messages for a SpotNegotiation
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesGet: function (spotNegotiationId, page, pageSize, ordering, options) {
            return localVarFp.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesGet(spotNegotiationId, page, pageSize, ordering, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new SpotNegotiationMessage
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {SpotNegotiationMessage} spotNegotiationMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesPost: function (spotNegotiationId, spotNegotiationMessage, options) {
            return localVarFp.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesPost(spotNegotiationId, spotNegotiationMessage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a SpotNegotiationMessage
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationMessageId The id of the spot negotiation message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdDelete: function (spotNegotiationId, spotNegotiationMessageId, options) {
            return localVarFp.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdDelete(spotNegotiationId, spotNegotiationMessageId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about SpotNegotiationMessage
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationMessageId The id of the spot negotiation message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdGet: function (spotNegotiationId, spotNegotiationMessageId, options) {
            return localVarFp.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdGet(spotNegotiationId, spotNegotiationMessageId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a SpotNegotiationMessage
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationMessageId The id of the spot negotiation message
         * @param {SpotNegotiationMessage} spotNegotiationMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdPut: function (spotNegotiationId, spotNegotiationMessageId, spotNegotiationMessage, options) {
            return localVarFp.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdPut(spotNegotiationId, spotNegotiationMessageId, spotNegotiationMessage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a list of quotes for a SpotNegotiation
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {boolean} [includeFailures] If true, include failed Quotes in the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesGet: function (spotNegotiationId, page, pageSize, ordering, includeFailures, options) {
            return localVarFp.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesGet(spotNegotiationId, page, pageSize, ordering, includeFailures, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {CreateSpotNegotiationQuote} createSpotNegotiationQuote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesPost: function (spotNegotiationId, createSpotNegotiationQuote, options) {
            return localVarFp.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesPost(spotNegotiationId, createSpotNegotiationQuote, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDelete: function (spotNegotiationId, spotNegotiationQuoteId, options) {
            return localVarFp.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDelete(spotNegotiationId, spotNegotiationQuoteId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdGet: function (spotNegotiationId, spotNegotiationQuoteId, options) {
            return localVarFp.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdGet(spotNegotiationId, spotNegotiationQuoteId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {Quote} quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdPut: function (spotNegotiationId, spotNegotiationQuoteId, quote, options) {
            return localVarFp.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdPut(spotNegotiationId, spotNegotiationQuoteId, quote, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PrivateMarketApiFactory = PrivateMarketApiFactory;
/**
 * PrivateMarketApi - object-oriented interface
 * @export
 * @class PrivateMarketApi
 * @extends {BaseAPI}
 */
var PrivateMarketApi = /** @class */ (function (_super) {
    __extends(PrivateMarketApi, _super);
    function PrivateMarketApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Retrieve a SpotNegotiation for the given RFQ that is outbound to a customer rather than inbound from solicited capacity providers
     * @param {string} rfqId The id of the rfq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateMarketApi
     */
    PrivateMarketApi.prototype.quotingPrivatemarketRfqsRfqIdCustomerNegotiationGet = function (rfqId, options) {
        var _this = this;
        return (0, exports.PrivateMarketApiFp)(this.configuration).quotingPrivatemarketRfqsRfqIdCustomerNegotiationGet(rfqId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a preview of the HTML Email that will be sent and the included message
     * @param {string} rfqId The id of the rfq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateMarketApi
     */
    PrivateMarketApi.prototype.quotingPrivatemarketRfqsRfqIdCustomerNegotiationPreviewGet = function (rfqId, options) {
        var _this = this;
        return (0, exports.PrivateMarketApiFp)(this.configuration).quotingPrivatemarketRfqsRfqIdCustomerNegotiationPreviewGet(rfqId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a SpotNegotiation for the given RFQ that is outbound to a customer rather than inbound from solicited capacity providers
     * @param {string} rfqId The id of the rfq
     * @param {SpotNegotiation} spotNegotiation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateMarketApi
     */
    PrivateMarketApi.prototype.quotingPrivatemarketRfqsRfqIdCustomerNegotiationPut = function (rfqId, spotNegotiation, options) {
        var _this = this;
        return (0, exports.PrivateMarketApiFp)(this.configuration).quotingPrivatemarketRfqsRfqIdCustomerNegotiationPut(rfqId, spotNegotiation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a preview of the HTML Email that will be sent and the included message
     * @param {string} rfqId The id of the rfq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateMarketApi
     */
    PrivateMarketApi.prototype.quotingPrivatemarketRfqsRfqIdSpotNegotiationPreviewGet = function (rfqId, options) {
        var _this = this;
        return (0, exports.PrivateMarketApiFp)(this.configuration).quotingPrivatemarketRfqsRfqIdSpotNegotiationPreviewGet(rfqId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List all SpotNegotiations under this RFQ
     * @param {string} rfqId The id of the rfq
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {boolean} [expandQuotes] Integer boolean, if equal to True SpotNegotiations will expand Quotes under the SpotNegotiation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateMarketApi
     */
    PrivateMarketApi.prototype.quotingPrivatemarketRfqsRfqIdSpotNegotiationsGet = function (rfqId, page, pageSize, ordering, expandQuotes, options) {
        var _this = this;
        return (0, exports.PrivateMarketApiFp)(this.configuration).quotingPrivatemarketRfqsRfqIdSpotNegotiationsGet(rfqId, page, pageSize, ordering, expandQuotes, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary For a given Shipment id, find the most recently created SpotNegotiation for which the authenticated Company is the solicited company
     * @param {string} shipmentId The id of the shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateMarketApi
     */
    PrivateMarketApi.prototype.quotingPrivatemarketShipmentsShipmentIdDiscoverSolicitedNegotiationGet = function (shipmentId, options) {
        var _this = this;
        return (0, exports.PrivateMarketApiFp)(this.configuration).quotingPrivatemarketShipmentsShipmentIdDiscoverSolicitedNegotiationGet(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Bulk create SpotNegotiations for an RFQ and emails
     * @param {BulkCreateSpotNegotiationRequest} bulkCreateSpotNegotiationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateMarketApi
     */
    PrivateMarketApi.prototype.quotingPrivatemarketSpotNegotiationsPost = function (bulkCreateSpotNegotiationRequest, options) {
        var _this = this;
        return (0, exports.PrivateMarketApiFp)(this.configuration).quotingPrivatemarketSpotNegotiationsPost(bulkCreateSpotNegotiationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Award or decline a SpotNegotiation Quote
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
     * @param {AwardDeclineQuoteRequest} awardDeclineQuoteRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateMarketApi
     */
    PrivateMarketApi.prototype.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdAwardDeclineQuoteSpotNegotiationQuoteIdPut = function (spotNegotiationId, spotNegotiationQuoteId, awardDeclineQuoteRequest, options) {
        var _this = this;
        return (0, exports.PrivateMarketApiFp)(this.configuration).quotingPrivatemarketSpotNegotiationsSpotNegotiationIdAwardDeclineQuoteSpotNegotiationQuoteIdPut(spotNegotiationId, spotNegotiationQuoteId, awardDeclineQuoteRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a SpotNegotiation
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateMarketApi
     */
    PrivateMarketApi.prototype.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdGet = function (spotNegotiationId, options) {
        var _this = this;
        return (0, exports.PrivateMarketApiFp)(this.configuration).quotingPrivatemarketSpotNegotiationsSpotNegotiationIdGet(spotNegotiationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Link/unlink an existing Quote to a SpotNegotiation
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {LinkQuoteToSpotNegotiationRequest} linkQuoteToSpotNegotiationRequest
     * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateMarketApi
     */
    PrivateMarketApi.prototype.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdLinkQuotePut = function (spotNegotiationId, linkQuoteToSpotNegotiationRequest, xCompanyId, options) {
        var _this = this;
        return (0, exports.PrivateMarketApiFp)(this.configuration).quotingPrivatemarketSpotNegotiationsSpotNegotiationIdLinkQuotePut(spotNegotiationId, linkQuoteToSpotNegotiationRequest, xCompanyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a list of messages for a SpotNegotiation
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateMarketApi
     */
    PrivateMarketApi.prototype.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesGet = function (spotNegotiationId, page, pageSize, ordering, options) {
        var _this = this;
        return (0, exports.PrivateMarketApiFp)(this.configuration).quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesGet(spotNegotiationId, page, pageSize, ordering, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new SpotNegotiationMessage
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {SpotNegotiationMessage} spotNegotiationMessage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateMarketApi
     */
    PrivateMarketApi.prototype.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesPost = function (spotNegotiationId, spotNegotiationMessage, options) {
        var _this = this;
        return (0, exports.PrivateMarketApiFp)(this.configuration).quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesPost(spotNegotiationId, spotNegotiationMessage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a SpotNegotiationMessage
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {string} spotNegotiationMessageId The id of the spot negotiation message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateMarketApi
     */
    PrivateMarketApi.prototype.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdDelete = function (spotNegotiationId, spotNegotiationMessageId, options) {
        var _this = this;
        return (0, exports.PrivateMarketApiFp)(this.configuration).quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdDelete(spotNegotiationId, spotNegotiationMessageId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about SpotNegotiationMessage
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {string} spotNegotiationMessageId The id of the spot negotiation message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateMarketApi
     */
    PrivateMarketApi.prototype.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdGet = function (spotNegotiationId, spotNegotiationMessageId, options) {
        var _this = this;
        return (0, exports.PrivateMarketApiFp)(this.configuration).quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdGet(spotNegotiationId, spotNegotiationMessageId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a SpotNegotiationMessage
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {string} spotNegotiationMessageId The id of the spot negotiation message
     * @param {SpotNegotiationMessage} spotNegotiationMessage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateMarketApi
     */
    PrivateMarketApi.prototype.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdPut = function (spotNegotiationId, spotNegotiationMessageId, spotNegotiationMessage, options) {
        var _this = this;
        return (0, exports.PrivateMarketApiFp)(this.configuration).quotingPrivatemarketSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdPut(spotNegotiationId, spotNegotiationMessageId, spotNegotiationMessage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a list of quotes for a SpotNegotiation
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {boolean} [includeFailures] If true, include failed Quotes in the result set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateMarketApi
     */
    PrivateMarketApi.prototype.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesGet = function (spotNegotiationId, page, pageSize, ordering, includeFailures, options) {
        var _this = this;
        return (0, exports.PrivateMarketApiFp)(this.configuration).quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesGet(spotNegotiationId, page, pageSize, ordering, includeFailures, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new SpotNegotiation Quote
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {CreateSpotNegotiationQuote} createSpotNegotiationQuote
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateMarketApi
     */
    PrivateMarketApi.prototype.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesPost = function (spotNegotiationId, createSpotNegotiationQuote, options) {
        var _this = this;
        return (0, exports.PrivateMarketApiFp)(this.configuration).quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesPost(spotNegotiationId, createSpotNegotiationQuote, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a SpotNegotiation Quote
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateMarketApi
     */
    PrivateMarketApi.prototype.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDelete = function (spotNegotiationId, spotNegotiationQuoteId, options) {
        var _this = this;
        return (0, exports.PrivateMarketApiFp)(this.configuration).quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDelete(spotNegotiationId, spotNegotiationQuoteId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about a SpotNegotiation Quote
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateMarketApi
     */
    PrivateMarketApi.prototype.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdGet = function (spotNegotiationId, spotNegotiationQuoteId, options) {
        var _this = this;
        return (0, exports.PrivateMarketApiFp)(this.configuration).quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdGet(spotNegotiationId, spotNegotiationQuoteId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a SpotNegotiation Quote
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
     * @param {Quote} quote
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PrivateMarketApi
     */
    PrivateMarketApi.prototype.quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdPut = function (spotNegotiationId, spotNegotiationQuoteId, quote, options) {
        var _this = this;
        return (0, exports.PrivateMarketApiFp)(this.configuration).quotingPrivatemarketSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdPut(spotNegotiationId, spotNegotiationQuoteId, quote, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PrivateMarketApi;
}(base_1.BaseAPI));
exports.PrivateMarketApi = PrivateMarketApi;
/**
 * ProductsApi - axios parameter creator
 * @export
 */
var ProductsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Return a list of products for a company
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [descriptionContains] Include products where the description contains this string
         * @param {string} [productRefContains] Include products where the product ref contains this string
         * @param {string} [packageTypeContains] Include products where the package type contains this string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsGet: function (page, pageSize, ordering, q, descriptionContains, productRefContains, packageTypeContains, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/products/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (descriptionContains !== undefined) {
                                localVarQueryParameter['description__contains'] = descriptionContains;
                            }
                            if (productRefContains !== undefined) {
                                localVarQueryParameter['product_ref__contains'] = productRefContains;
                            }
                            if (packageTypeContains !== undefined) {
                                localVarQueryParameter['package_type__contains'] = packageTypeContains;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a Product
         * @param {PostProducts} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsPost: function (body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/products/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a product
         * @param {string} productId The id of the product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsProductIdDelete: function (productId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'productId' is not null or undefined
                            (0, common_1.assertParamExists)('productsProductIdDelete', 'productId', productId);
                            localVarPath = "/products/{productId}/"
                                .replace("{".concat("productId", "}"), encodeURIComponent(String(productId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Return a specific product
         * @param {string} productId The id of the product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsProductIdGet: function (productId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'productId' is not null or undefined
                            (0, common_1.assertParamExists)('productsProductIdGet', 'productId', productId);
                            localVarPath = "/products/{productId}/"
                                .replace("{".concat("productId", "}"), encodeURIComponent(String(productId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a product
         * @param {string} productId The id of the product
         * @param {PostProducts} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsProductIdPut: function (productId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'productId' is not null or undefined
                            (0, common_1.assertParamExists)('productsProductIdPut', 'productId', productId);
                            localVarPath = "/products/{productId}/"
                                .replace("{".concat("productId", "}"), encodeURIComponent(String(productId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ProductsApiAxiosParamCreator = ProductsApiAxiosParamCreator;
/**
 * ProductsApi - functional programming interface
 * @export
 */
var ProductsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ProductsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Return a list of products for a company
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [descriptionContains] Include products where the description contains this string
         * @param {string} [productRefContains] Include products where the product ref contains this string
         * @param {string} [packageTypeContains] Include products where the package type contains this string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsGet: function (page, pageSize, ordering, q, descriptionContains, productRefContains, packageTypeContains, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.productsGet(page, pageSize, ordering, q, descriptionContains, productRefContains, packageTypeContains, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a Product
         * @param {PostProducts} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsPost: function (body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.productsPost(body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a product
         * @param {string} productId The id of the product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsProductIdDelete: function (productId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.productsProductIdDelete(productId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Return a specific product
         * @param {string} productId The id of the product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsProductIdGet: function (productId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.productsProductIdGet(productId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a product
         * @param {string} productId The id of the product
         * @param {PostProducts} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsProductIdPut: function (productId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.productsProductIdPut(productId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ProductsApiFp = ProductsApiFp;
/**
 * ProductsApi - factory interface
 * @export
 */
var ProductsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ProductsApiFp)(configuration);
    return {
        /**
         *
         * @summary Return a list of products for a company
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [descriptionContains] Include products where the description contains this string
         * @param {string} [productRefContains] Include products where the product ref contains this string
         * @param {string} [packageTypeContains] Include products where the package type contains this string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsGet: function (page, pageSize, ordering, q, descriptionContains, productRefContains, packageTypeContains, options) {
            return localVarFp.productsGet(page, pageSize, ordering, q, descriptionContains, productRefContains, packageTypeContains, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a Product
         * @param {PostProducts} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsPost: function (body, options) {
            return localVarFp.productsPost(body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a product
         * @param {string} productId The id of the product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsProductIdDelete: function (productId, options) {
            return localVarFp.productsProductIdDelete(productId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Return a specific product
         * @param {string} productId The id of the product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsProductIdGet: function (productId, options) {
            return localVarFp.productsProductIdGet(productId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a product
         * @param {string} productId The id of the product
         * @param {PostProducts} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productsProductIdPut: function (productId, body, options) {
            return localVarFp.productsProductIdPut(productId, body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ProductsApiFactory = ProductsApiFactory;
/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
var ProductsApi = /** @class */ (function (_super) {
    __extends(ProductsApi, _super);
    function ProductsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Return a list of products for a company
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {string} [descriptionContains] Include products where the description contains this string
     * @param {string} [productRefContains] Include products where the product ref contains this string
     * @param {string} [packageTypeContains] Include products where the package type contains this string
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.productsGet = function (page, pageSize, ordering, q, descriptionContains, productRefContains, packageTypeContains, options) {
        var _this = this;
        return (0, exports.ProductsApiFp)(this.configuration).productsGet(page, pageSize, ordering, q, descriptionContains, productRefContains, packageTypeContains, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a Product
     * @param {PostProducts} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.productsPost = function (body, options) {
        var _this = this;
        return (0, exports.ProductsApiFp)(this.configuration).productsPost(body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a product
     * @param {string} productId The id of the product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.productsProductIdDelete = function (productId, options) {
        var _this = this;
        return (0, exports.ProductsApiFp)(this.configuration).productsProductIdDelete(productId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Return a specific product
     * @param {string} productId The id of the product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.productsProductIdGet = function (productId, options) {
        var _this = this;
        return (0, exports.ProductsApiFp)(this.configuration).productsProductIdGet(productId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a product
     * @param {string} productId The id of the product
     * @param {PostProducts} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    ProductsApi.prototype.productsProductIdPut = function (productId, body, options) {
        var _this = this;
        return (0, exports.ProductsApiFp)(this.configuration).productsProductIdPut(productId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ProductsApi;
}(base_1.BaseAPI));
exports.ProductsApi = ProductsApi;
/**
 * PurchaseOrdersApi - axios parameter creator
 * @export
 */
var PurchaseOrdersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Build a shipment from shipment assembly `(Legacy/v2)`
         * @param {PurchaseOrderBuildShipmentAssemblyRequest} purchaseOrderBuildShipmentAssemblyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersBuildShipmentAssemblyPost: function (purchaseOrderBuildShipmentAssemblyRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'purchaseOrderBuildShipmentAssemblyRequest' is not null or undefined
                            (0, common_1.assertParamExists)('purchaseOrdersBuildShipmentAssemblyPost', 'purchaseOrderBuildShipmentAssemblyRequest', purchaseOrderBuildShipmentAssemblyRequest);
                            localVarPath = "/purchase-orders/build-shipment-assembly/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(purchaseOrderBuildShipmentAssemblyRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Build a shipment from purchase orders `(Legacy/v2)`
         * @param {InlineObject14} [inlineObject14]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        purchaseOrdersBuildShipmentPost: function (inlineObject14, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/purchase-orders/build-shipment/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject14, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List purchase orders `(Legacy/v2)`
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [archived] Filter on whether or not a PurchaseOrder is archived
         * @param {string} [createdAt] Include PurchaseOrders where created_at is equal to this value
         * @param {string} [createdAtGte] Include PurchaseOrders where created_at is greater than or equal to this value
         * @param {string} [createdAtLte] Include PurchaseOrders where created_at is less than or equal to this value
         * @param {string} [createdByUserContains] Include PurchaseOrders where created_by_user object contains this string e.g first_name, last_name or email
         * @param {Array<string>} [createdByUserId] Include PurchaseOrders where created_by_user_id is in the array.
         * @param {string} [createdByUserName] Include PurchaseOrders where created_by_user_name is exactly this string
         * @param {string} [createdByUserNameContains] Include PurchaseOrders where created_by_user_name contains this string
         * @param {string} [customerExternalIdContains] Include PurchaseOrders where customer_external_id contains this string
         * @param {string} [customerNameContains] Include PurchaseOrders where customer_name contains this string
         * @param {string} [descriptionContains] Include PurchaseOrders where description contains this string
         * @param {string} [destinationAddressContains] Include PurchaseOrders where destination_address contains this string
         * @param {string} [invoiceExternalIdContains] Include PurchaseOrders where invoice_external_id contains this string
         * @param {string} [originAddressContains] Include PurchaseOrders where origin_address contains this string
         * @param {string} [plannedDeliveryStartDatetime] Include PurchaseOrders where planned_delivery_start_datetime is equal to this value
         * @param {string} [plannedDeliveryEndDatetime] Include PurchaseOrders where planned_delivery_end_datetime is equal to this value
         * @param {string} [plannedDeliveryStartDatetimeGte] Include PurchaseOrders where planned_delivery_start_datetime is greater than or equal to this value
         * @param {string} [plannedDeliveryEndDatetimeGte] Include PurchaseOrders where planned_delivery_end_datetime is greater than or equal to this value
         * @param {string} [plannedDeliveryStartDatetimeLte] Include PurchaseOrders where planned_delivery_start_datetime is less than or equal to this value
         * @param {string} [plannedDeliveryEndDatetimeLte] Include PurchaseOrders where planned_delivery_end_datetime is less than or equal to this value
         * @param {string} [plannedPickupStartDatetime] Include PurchaseOrders where planned_pickup_start_datetime is equal to this value
         * @param {string} [plannedPickupEndDatetime] Include PurchaseOrders where planned_pickup_end_datetime is equal to this value
         * @param {string} [plannedPickupStartDatetimeGte] Include PurchaseOrders where planned_pickup_start_datetime__gte is greater than or equal to this value
         * @param {string} [plannedPickupEndDatetimeGte] Include PurchaseOrders where planned_pickup_end_datetime is greater than or equal to this value
         * @param {string} [plannedPickupStartDatetimeLte] Include PurchaseOrders where planned_pickup_start_datetime__gte is less than or equal to this value
         * @param {string} [plannedPickupEndDatetimeLte] Include PurchaseOrders where planned_pickup_end_datetime is less than or equal to this value
         * @param {string} [actualDeliveryDatetime] Include PurchaseOrders where actual_delivery_datetime is equal to this value
         * @param {string} [actualPickupDatetime] Include PurchaseOrders where actual_pickup_datetime is equal to this value
         * @param {string} [actualDeliveryDatetimeGte] Include PurchaseOrders where actual_delivery_datetime is greater than or equal to this value
         * @param {string} [actualPickupDatetimeGte] Include PurchaseOrders where actual_pickup_datetime is greater than or equal to this value
         * @param {string} [actualDeliveryDatetimeLte] Include PurchaseOrders where actual_delivery_datetime is less than or equal to this value
         * @param {string} [actualPickupDatetimeLte] Include PurchaseOrders where actual_pickup_datetime is less than or equal to this value
         * @param {Array<'ASSIGNED' | 'UNASSIGNED' | 'IN_TRANSIT' | 'DELIVERED' | 'DISPATCHED' | 'OUT_FOR_DELIVERY'>} [overallStatus] Return PurchaseOrders with an overall_status provided
         * @param {string} [orderNumberContains] Include PurchaseOrders where order_number contains this string
         * @param {string} [purchaseOrderNumberContains] Include PurchaseOrders where purchase_order_number contains this string
         * @param {boolean} [shipmentAssigned] Include PurchaseOrders that have/do not have a shipment assigned
         * @param {string} [shipmentId] Include PurchaseOrders where shipment_id is exactly this string
         * @param {string} [shipmentReferenceId] Include PurchaseOrders where shipment_reference_id is exactly this string
         * @param {Array<'SHIPWELL_WEB' | 'IMPORT' | 'TENDER' | 'SHIPWELL_WEB_UNAUTH'>} [source] Return PurchaseOrders created by sources in the array.
         * @param {string} [sourceSystemIdContains] Include PurchaseOrders where source_system_id contains this string
         * @param {string} [status] Include PurchaseOrders where status is exactly this string
         * @param {number} [totalPriceGte] Include PurchaseOrders where total_price is greater than or equal to this amount
         * @param {number} [totalPriceLte] Include PurchaseOrders where total_price is less than or equal to this amount
         * @param {string} [supplierExternalIdContains] Include PurchaseOrders where vendor_external_id contains this string
         * @param {string} [supplierNameContains] Include PurchaseOrders where vendor_name contains this string
         * @param {string} [name] Include PurchaseOrders where name is exactly this string
         * @param {Array<string>} [shipmentShipwellCustomData] Include shipments that contain these shipment-level custom data values
         * @param {Array<string>} [purchaseOrderShipwellCustomData] Include purchase orders that contain these level custom data values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersGet: function (page, pageSize, ordering, q, archived, createdAt, createdAtGte, createdAtLte, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customerExternalIdContains, customerNameContains, descriptionContains, destinationAddressContains, invoiceExternalIdContains, originAddressContains, plannedDeliveryStartDatetime, plannedDeliveryEndDatetime, plannedDeliveryStartDatetimeGte, plannedDeliveryEndDatetimeGte, plannedDeliveryStartDatetimeLte, plannedDeliveryEndDatetimeLte, plannedPickupStartDatetime, plannedPickupEndDatetime, plannedPickupStartDatetimeGte, plannedPickupEndDatetimeGte, plannedPickupStartDatetimeLte, plannedPickupEndDatetimeLte, actualDeliveryDatetime, actualPickupDatetime, actualDeliveryDatetimeGte, actualPickupDatetimeGte, actualDeliveryDatetimeLte, actualPickupDatetimeLte, overallStatus, orderNumberContains, purchaseOrderNumberContains, shipmentAssigned, shipmentId, shipmentReferenceId, source, sourceSystemIdContains, status, totalPriceGte, totalPriceLte, supplierExternalIdContains, supplierNameContains, name, shipmentShipwellCustomData, purchaseOrderShipwellCustomData, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/purchase-orders/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (archived !== undefined) {
                                localVarQueryParameter['archived'] = archived;
                            }
                            if (createdAt !== undefined) {
                                localVarQueryParameter['created_at'] = (createdAt instanceof Date) ?
                                    createdAt.toISOString().substr(0, 10) :
                                    createdAt;
                            }
                            if (createdAtGte !== undefined) {
                                localVarQueryParameter['created_at__gte'] = (createdAtGte instanceof Date) ?
                                    createdAtGte.toISOString().substr(0, 10) :
                                    createdAtGte;
                            }
                            if (createdAtLte !== undefined) {
                                localVarQueryParameter['created_at__lte'] = (createdAtLte instanceof Date) ?
                                    createdAtLte.toISOString().substr(0, 10) :
                                    createdAtLte;
                            }
                            if (createdByUserContains !== undefined) {
                                localVarQueryParameter['created_by_user__contains'] = createdByUserContains;
                            }
                            if (createdByUserId) {
                                localVarQueryParameter['created_by_user_id'] = createdByUserId;
                            }
                            if (createdByUserName !== undefined) {
                                localVarQueryParameter['created_by_user_name'] = createdByUserName;
                            }
                            if (createdByUserNameContains !== undefined) {
                                localVarQueryParameter['created_by_user_name__contains'] = createdByUserNameContains;
                            }
                            if (customerExternalIdContains !== undefined) {
                                localVarQueryParameter['customer_external_id__contains'] = customerExternalIdContains;
                            }
                            if (customerNameContains !== undefined) {
                                localVarQueryParameter['customer_name__contains'] = customerNameContains;
                            }
                            if (descriptionContains !== undefined) {
                                localVarQueryParameter['description__contains'] = descriptionContains;
                            }
                            if (destinationAddressContains !== undefined) {
                                localVarQueryParameter['destination_address__contains'] = destinationAddressContains;
                            }
                            if (invoiceExternalIdContains !== undefined) {
                                localVarQueryParameter['invoice_external_id__contains'] = invoiceExternalIdContains;
                            }
                            if (originAddressContains !== undefined) {
                                localVarQueryParameter['origin_address__contains'] = originAddressContains;
                            }
                            if (plannedDeliveryStartDatetime !== undefined) {
                                localVarQueryParameter['planned_delivery_start_datetime'] = (plannedDeliveryStartDatetime instanceof Date) ?
                                    plannedDeliveryStartDatetime.toISOString() :
                                    plannedDeliveryStartDatetime;
                            }
                            if (plannedDeliveryEndDatetime !== undefined) {
                                localVarQueryParameter['planned_delivery_end_datetime'] = (plannedDeliveryEndDatetime instanceof Date) ?
                                    plannedDeliveryEndDatetime.toISOString() :
                                    plannedDeliveryEndDatetime;
                            }
                            if (plannedDeliveryStartDatetimeGte !== undefined) {
                                localVarQueryParameter['planned_delivery_start_datetime__gte'] = (plannedDeliveryStartDatetimeGte instanceof Date) ?
                                    plannedDeliveryStartDatetimeGte.toISOString() :
                                    plannedDeliveryStartDatetimeGte;
                            }
                            if (plannedDeliveryEndDatetimeGte !== undefined) {
                                localVarQueryParameter['planned_delivery_end_datetime__gte'] = (plannedDeliveryEndDatetimeGte instanceof Date) ?
                                    plannedDeliveryEndDatetimeGte.toISOString() :
                                    plannedDeliveryEndDatetimeGte;
                            }
                            if (plannedDeliveryStartDatetimeLte !== undefined) {
                                localVarQueryParameter['planned_delivery_start_datetime__lte'] = (plannedDeliveryStartDatetimeLte instanceof Date) ?
                                    plannedDeliveryStartDatetimeLte.toISOString() :
                                    plannedDeliveryStartDatetimeLte;
                            }
                            if (plannedDeliveryEndDatetimeLte !== undefined) {
                                localVarQueryParameter['planned_delivery_end_datetime__lte'] = (plannedDeliveryEndDatetimeLte instanceof Date) ?
                                    plannedDeliveryEndDatetimeLte.toISOString() :
                                    plannedDeliveryEndDatetimeLte;
                            }
                            if (plannedPickupStartDatetime !== undefined) {
                                localVarQueryParameter['planned_pickup_start_datetime'] = (plannedPickupStartDatetime instanceof Date) ?
                                    plannedPickupStartDatetime.toISOString() :
                                    plannedPickupStartDatetime;
                            }
                            if (plannedPickupEndDatetime !== undefined) {
                                localVarQueryParameter['planned_pickup_end_datetime'] = (plannedPickupEndDatetime instanceof Date) ?
                                    plannedPickupEndDatetime.toISOString() :
                                    plannedPickupEndDatetime;
                            }
                            if (plannedPickupStartDatetimeGte !== undefined) {
                                localVarQueryParameter['planned_pickup_start_datetime__gte'] = (plannedPickupStartDatetimeGte instanceof Date) ?
                                    plannedPickupStartDatetimeGte.toISOString() :
                                    plannedPickupStartDatetimeGte;
                            }
                            if (plannedPickupEndDatetimeGte !== undefined) {
                                localVarQueryParameter['planned_pickup_end_datetime__gte'] = (plannedPickupEndDatetimeGte instanceof Date) ?
                                    plannedPickupEndDatetimeGte.toISOString() :
                                    plannedPickupEndDatetimeGte;
                            }
                            if (plannedPickupStartDatetimeLte !== undefined) {
                                localVarQueryParameter['planned_pickup_start_datetime__lte'] = (plannedPickupStartDatetimeLte instanceof Date) ?
                                    plannedPickupStartDatetimeLte.toISOString() :
                                    plannedPickupStartDatetimeLte;
                            }
                            if (plannedPickupEndDatetimeLte !== undefined) {
                                localVarQueryParameter['planned_pickup_end_datetime__lte'] = (plannedPickupEndDatetimeLte instanceof Date) ?
                                    plannedPickupEndDatetimeLte.toISOString() :
                                    plannedPickupEndDatetimeLte;
                            }
                            if (actualDeliveryDatetime !== undefined) {
                                localVarQueryParameter['actual_delivery_datetime'] = (actualDeliveryDatetime instanceof Date) ?
                                    actualDeliveryDatetime.toISOString() :
                                    actualDeliveryDatetime;
                            }
                            if (actualPickupDatetime !== undefined) {
                                localVarQueryParameter['actual_pickup_datetime'] = (actualPickupDatetime instanceof Date) ?
                                    actualPickupDatetime.toISOString() :
                                    actualPickupDatetime;
                            }
                            if (actualDeliveryDatetimeGte !== undefined) {
                                localVarQueryParameter['actual_delivery_datetime__gte'] = (actualDeliveryDatetimeGte instanceof Date) ?
                                    actualDeliveryDatetimeGte.toISOString() :
                                    actualDeliveryDatetimeGte;
                            }
                            if (actualPickupDatetimeGte !== undefined) {
                                localVarQueryParameter['actual_pickup_datetime__gte'] = (actualPickupDatetimeGte instanceof Date) ?
                                    actualPickupDatetimeGte.toISOString() :
                                    actualPickupDatetimeGte;
                            }
                            if (actualDeliveryDatetimeLte !== undefined) {
                                localVarQueryParameter['actual_delivery_datetime__lte'] = (actualDeliveryDatetimeLte instanceof Date) ?
                                    actualDeliveryDatetimeLte.toISOString() :
                                    actualDeliveryDatetimeLte;
                            }
                            if (actualPickupDatetimeLte !== undefined) {
                                localVarQueryParameter['actual_pickup_datetime__lte'] = (actualPickupDatetimeLte instanceof Date) ?
                                    actualPickupDatetimeLte.toISOString() :
                                    actualPickupDatetimeLte;
                            }
                            if (overallStatus) {
                                localVarQueryParameter['overall_status'] = overallStatus;
                            }
                            if (orderNumberContains !== undefined) {
                                localVarQueryParameter['order_number__contains'] = orderNumberContains;
                            }
                            if (purchaseOrderNumberContains !== undefined) {
                                localVarQueryParameter['purchase_order_number__contains'] = purchaseOrderNumberContains;
                            }
                            if (shipmentAssigned !== undefined) {
                                localVarQueryParameter['shipment_assigned'] = shipmentAssigned;
                            }
                            if (shipmentId !== undefined) {
                                localVarQueryParameter['shipment_id'] = shipmentId;
                            }
                            if (shipmentReferenceId !== undefined) {
                                localVarQueryParameter['shipment_reference_id'] = shipmentReferenceId;
                            }
                            if (source) {
                                localVarQueryParameter['source'] = source;
                            }
                            if (sourceSystemIdContains !== undefined) {
                                localVarQueryParameter['source_system_id__contains'] = sourceSystemIdContains;
                            }
                            if (status !== undefined) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (totalPriceGte !== undefined) {
                                localVarQueryParameter['total_price__gte'] = totalPriceGte;
                            }
                            if (totalPriceLte !== undefined) {
                                localVarQueryParameter['total_price__lte'] = totalPriceLte;
                            }
                            if (supplierExternalIdContains !== undefined) {
                                localVarQueryParameter['supplier_external_id__contains'] = supplierExternalIdContains;
                            }
                            if (supplierNameContains !== undefined) {
                                localVarQueryParameter['supplier_name__contains'] = supplierNameContains;
                            }
                            if (name !== undefined) {
                                localVarQueryParameter['name'] = name;
                            }
                            if (shipmentShipwellCustomData) {
                                localVarQueryParameter['shipment_shipwell_custom_data'] = shipmentShipwellCustomData;
                            }
                            if (purchaseOrderShipwellCustomData) {
                                localVarQueryParameter['purchase_order_shipwell_custom_data'] = purchaseOrderShipwellCustomData;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new purchase order `(Legacy/v2)`
         * @param {PurchaseOrder} [purchaseOrder] ## Create/Update an order The route includes &#x60;/purchase-orders/&#x60; but should be considered as generic orders. It does not imply there is a different route for sales orders and transfer orders. This will be updated in the future with an enhanced data model to support different order types, for now use the purchase order for all types of orders and if needed extend the the object with &#x60;custom_data&#x60; to specify the type of order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPost: function (purchaseOrder, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/purchase-orders/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(purchaseOrder, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a PurchaseOrder `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdDelete: function (purchaseOrderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'purchaseOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('purchaseOrdersPurchaseOrderIdDelete', 'purchaseOrderId', purchaseOrderId);
                            localVarPath = "/purchase-orders/{purchaseOrderId}/"
                                .replace("{".concat("purchaseOrderId", "}"), encodeURIComponent(String(purchaseOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a PurchaseOrder `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdGet: function (purchaseOrderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'purchaseOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('purchaseOrdersPurchaseOrderIdGet', 'purchaseOrderId', purchaseOrderId);
                            localVarPath = "/purchase-orders/{purchaseOrderId}/"
                                .replace("{".concat("purchaseOrderId", "}"), encodeURIComponent(String(purchaseOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Initiate an order consolidation workflow for the given purchase order `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {InitiateOrderConsolidationRequest} initiateOrderConsolidationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdInitiateOrderConsolidationWorkflowPost: function (purchaseOrderId, initiateOrderConsolidationRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'purchaseOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('purchaseOrdersPurchaseOrderIdInitiateOrderConsolidationWorkflowPost', 'purchaseOrderId', purchaseOrderId);
                            // verify required parameter 'initiateOrderConsolidationRequest' is not null or undefined
                            (0, common_1.assertParamExists)('purchaseOrdersPurchaseOrderIdInitiateOrderConsolidationWorkflowPost', 'initiateOrderConsolidationRequest', initiateOrderConsolidationRequest);
                            localVarPath = "/purchase-orders/{purchaseOrderId}/initiate-order-consolidation-workflow/"
                                .replace("{".concat("purchaseOrderId", "}"), encodeURIComponent(String(purchaseOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(initiateOrderConsolidationRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of line items for a given purchase order `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdLineItemsGet: function (purchaseOrderId, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'purchaseOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('purchaseOrdersPurchaseOrderIdLineItemsGet', 'purchaseOrderId', purchaseOrderId);
                            localVarPath = "/purchase-orders/{purchaseOrderId}/line-items/"
                                .replace("{".concat("purchaseOrderId", "}"), encodeURIComponent(String(purchaseOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new PurchaseOrderLineItem `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {PurchaseOrderLineItem} [purchaseOrderLineItem] ## Create/Update a PurchaseOrderLineItem Line items are a list of products associated with the order. The product_ref field is used to link the line item to products in either the Shipwell system or your ERP system, but it is not required. This body also includes product-related options, such as &#x60;description&#x60;, &#x60;length&#x60;, and &#x60;length_unit&#x60;. You can add multiple line items to an order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdLineItemsPost: function (purchaseOrderId, purchaseOrderLineItem, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'purchaseOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('purchaseOrdersPurchaseOrderIdLineItemsPost', 'purchaseOrderId', purchaseOrderId);
                            localVarPath = "/purchase-orders/{purchaseOrderId}/line-items/"
                                .replace("{".concat("purchaseOrderId", "}"), encodeURIComponent(String(purchaseOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(purchaseOrderLineItem, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a PurchaseOrderLineItem `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {string} purchaseOrderLineItemId The id of the purchase order line item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdDelete: function (purchaseOrderId, purchaseOrderLineItemId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'purchaseOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdDelete', 'purchaseOrderId', purchaseOrderId);
                            // verify required parameter 'purchaseOrderLineItemId' is not null or undefined
                            (0, common_1.assertParamExists)('purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdDelete', 'purchaseOrderLineItemId', purchaseOrderLineItemId);
                            localVarPath = "/purchase-orders/{purchaseOrderId}/line-items/{purchaseOrderLineItemId}/"
                                .replace("{".concat("purchaseOrderId", "}"), encodeURIComponent(String(purchaseOrderId)))
                                .replace("{".concat("purchaseOrderLineItemId", "}"), encodeURIComponent(String(purchaseOrderLineItemId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a PurchaseOrderLineItem `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {string} purchaseOrderLineItemId The id of the purchase order line item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdGet: function (purchaseOrderId, purchaseOrderLineItemId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'purchaseOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdGet', 'purchaseOrderId', purchaseOrderId);
                            // verify required parameter 'purchaseOrderLineItemId' is not null or undefined
                            (0, common_1.assertParamExists)('purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdGet', 'purchaseOrderLineItemId', purchaseOrderLineItemId);
                            localVarPath = "/purchase-orders/{purchaseOrderId}/line-items/{purchaseOrderLineItemId}/"
                                .replace("{".concat("purchaseOrderId", "}"), encodeURIComponent(String(purchaseOrderId)))
                                .replace("{".concat("purchaseOrderLineItemId", "}"), encodeURIComponent(String(purchaseOrderLineItemId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a PurchaseOrderLineItem `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {string} purchaseOrderLineItemId The id of the purchase order line item
         * @param {PurchaseOrderLineItem} [purchaseOrderLineItem] ## Create/Update a PurchaseOrderLineItem Line items are a list of products associated with the order. The product_ref field is used to link the line item to products in either the Shipwell system or your ERP system, but it is not required. This body also includes product-related options, such as &#x60;description&#x60;, &#x60;length&#x60;, and &#x60;length_unit&#x60;. You can add multiple line items to an order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdPut: function (purchaseOrderId, purchaseOrderLineItemId, purchaseOrderLineItem, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'purchaseOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdPut', 'purchaseOrderId', purchaseOrderId);
                            // verify required parameter 'purchaseOrderLineItemId' is not null or undefined
                            (0, common_1.assertParamExists)('purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdPut', 'purchaseOrderLineItemId', purchaseOrderLineItemId);
                            localVarPath = "/purchase-orders/{purchaseOrderId}/line-items/{purchaseOrderLineItemId}/"
                                .replace("{".concat("purchaseOrderId", "}"), encodeURIComponent(String(purchaseOrderId)))
                                .replace("{".concat("purchaseOrderLineItemId", "}"), encodeURIComponent(String(purchaseOrderLineItemId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(purchaseOrderLineItem, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a PurchaseOrder `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {PurchaseOrder} [purchaseOrder] ## Create/Update an order The route includes &#x60;/purchase-orders/&#x60; but should be considered as generic orders. It does not imply there is a different route for sales orders and transfer orders. This will be updated in the future with an enhanced data model to support different order types, for now use the purchase order for all types of orders and if needed extend the the object with &#x60;custom_data&#x60; to specify the type of order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdPut: function (purchaseOrderId, purchaseOrder, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'purchaseOrderId' is not null or undefined
                            (0, common_1.assertParamExists)('purchaseOrdersPurchaseOrderIdPut', 'purchaseOrderId', purchaseOrderId);
                            localVarPath = "/purchase-orders/{purchaseOrderId}/"
                                .replace("{".concat("purchaseOrderId", "}"), encodeURIComponent(String(purchaseOrderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(purchaseOrder, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an existing shipment with purchase orders `(Legacy/v2)`
         * @param {InlineObject15} [inlineObject15]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersUpdateBuiltShipmentPut: function (inlineObject15, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/purchase-orders/update-built-shipment/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject15, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PurchaseOrdersApiAxiosParamCreator = PurchaseOrdersApiAxiosParamCreator;
/**
 * PurchaseOrdersApi - functional programming interface
 * @export
 */
var PurchaseOrdersApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PurchaseOrdersApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Build a shipment from shipment assembly `(Legacy/v2)`
         * @param {PurchaseOrderBuildShipmentAssemblyRequest} purchaseOrderBuildShipmentAssemblyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersBuildShipmentAssemblyPost: function (purchaseOrderBuildShipmentAssemblyRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.purchaseOrdersBuildShipmentAssemblyPost(purchaseOrderBuildShipmentAssemblyRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Build a shipment from purchase orders `(Legacy/v2)`
         * @param {InlineObject14} [inlineObject14]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        purchaseOrdersBuildShipmentPost: function (inlineObject14, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.purchaseOrdersBuildShipmentPost(inlineObject14, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List purchase orders `(Legacy/v2)`
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [archived] Filter on whether or not a PurchaseOrder is archived
         * @param {string} [createdAt] Include PurchaseOrders where created_at is equal to this value
         * @param {string} [createdAtGte] Include PurchaseOrders where created_at is greater than or equal to this value
         * @param {string} [createdAtLte] Include PurchaseOrders where created_at is less than or equal to this value
         * @param {string} [createdByUserContains] Include PurchaseOrders where created_by_user object contains this string e.g first_name, last_name or email
         * @param {Array<string>} [createdByUserId] Include PurchaseOrders where created_by_user_id is in the array.
         * @param {string} [createdByUserName] Include PurchaseOrders where created_by_user_name is exactly this string
         * @param {string} [createdByUserNameContains] Include PurchaseOrders where created_by_user_name contains this string
         * @param {string} [customerExternalIdContains] Include PurchaseOrders where customer_external_id contains this string
         * @param {string} [customerNameContains] Include PurchaseOrders where customer_name contains this string
         * @param {string} [descriptionContains] Include PurchaseOrders where description contains this string
         * @param {string} [destinationAddressContains] Include PurchaseOrders where destination_address contains this string
         * @param {string} [invoiceExternalIdContains] Include PurchaseOrders where invoice_external_id contains this string
         * @param {string} [originAddressContains] Include PurchaseOrders where origin_address contains this string
         * @param {string} [plannedDeliveryStartDatetime] Include PurchaseOrders where planned_delivery_start_datetime is equal to this value
         * @param {string} [plannedDeliveryEndDatetime] Include PurchaseOrders where planned_delivery_end_datetime is equal to this value
         * @param {string} [plannedDeliveryStartDatetimeGte] Include PurchaseOrders where planned_delivery_start_datetime is greater than or equal to this value
         * @param {string} [plannedDeliveryEndDatetimeGte] Include PurchaseOrders where planned_delivery_end_datetime is greater than or equal to this value
         * @param {string} [plannedDeliveryStartDatetimeLte] Include PurchaseOrders where planned_delivery_start_datetime is less than or equal to this value
         * @param {string} [plannedDeliveryEndDatetimeLte] Include PurchaseOrders where planned_delivery_end_datetime is less than or equal to this value
         * @param {string} [plannedPickupStartDatetime] Include PurchaseOrders where planned_pickup_start_datetime is equal to this value
         * @param {string} [plannedPickupEndDatetime] Include PurchaseOrders where planned_pickup_end_datetime is equal to this value
         * @param {string} [plannedPickupStartDatetimeGte] Include PurchaseOrders where planned_pickup_start_datetime__gte is greater than or equal to this value
         * @param {string} [plannedPickupEndDatetimeGte] Include PurchaseOrders where planned_pickup_end_datetime is greater than or equal to this value
         * @param {string} [plannedPickupStartDatetimeLte] Include PurchaseOrders where planned_pickup_start_datetime__gte is less than or equal to this value
         * @param {string} [plannedPickupEndDatetimeLte] Include PurchaseOrders where planned_pickup_end_datetime is less than or equal to this value
         * @param {string} [actualDeliveryDatetime] Include PurchaseOrders where actual_delivery_datetime is equal to this value
         * @param {string} [actualPickupDatetime] Include PurchaseOrders where actual_pickup_datetime is equal to this value
         * @param {string} [actualDeliveryDatetimeGte] Include PurchaseOrders where actual_delivery_datetime is greater than or equal to this value
         * @param {string} [actualPickupDatetimeGte] Include PurchaseOrders where actual_pickup_datetime is greater than or equal to this value
         * @param {string} [actualDeliveryDatetimeLte] Include PurchaseOrders where actual_delivery_datetime is less than or equal to this value
         * @param {string} [actualPickupDatetimeLte] Include PurchaseOrders where actual_pickup_datetime is less than or equal to this value
         * @param {Array<'ASSIGNED' | 'UNASSIGNED' | 'IN_TRANSIT' | 'DELIVERED' | 'DISPATCHED' | 'OUT_FOR_DELIVERY'>} [overallStatus] Return PurchaseOrders with an overall_status provided
         * @param {string} [orderNumberContains] Include PurchaseOrders where order_number contains this string
         * @param {string} [purchaseOrderNumberContains] Include PurchaseOrders where purchase_order_number contains this string
         * @param {boolean} [shipmentAssigned] Include PurchaseOrders that have/do not have a shipment assigned
         * @param {string} [shipmentId] Include PurchaseOrders where shipment_id is exactly this string
         * @param {string} [shipmentReferenceId] Include PurchaseOrders where shipment_reference_id is exactly this string
         * @param {Array<'SHIPWELL_WEB' | 'IMPORT' | 'TENDER' | 'SHIPWELL_WEB_UNAUTH'>} [source] Return PurchaseOrders created by sources in the array.
         * @param {string} [sourceSystemIdContains] Include PurchaseOrders where source_system_id contains this string
         * @param {string} [status] Include PurchaseOrders where status is exactly this string
         * @param {number} [totalPriceGte] Include PurchaseOrders where total_price is greater than or equal to this amount
         * @param {number} [totalPriceLte] Include PurchaseOrders where total_price is less than or equal to this amount
         * @param {string} [supplierExternalIdContains] Include PurchaseOrders where vendor_external_id contains this string
         * @param {string} [supplierNameContains] Include PurchaseOrders where vendor_name contains this string
         * @param {string} [name] Include PurchaseOrders where name is exactly this string
         * @param {Array<string>} [shipmentShipwellCustomData] Include shipments that contain these shipment-level custom data values
         * @param {Array<string>} [purchaseOrderShipwellCustomData] Include purchase orders that contain these level custom data values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersGet: function (page, pageSize, ordering, q, archived, createdAt, createdAtGte, createdAtLte, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customerExternalIdContains, customerNameContains, descriptionContains, destinationAddressContains, invoiceExternalIdContains, originAddressContains, plannedDeliveryStartDatetime, plannedDeliveryEndDatetime, plannedDeliveryStartDatetimeGte, plannedDeliveryEndDatetimeGte, plannedDeliveryStartDatetimeLte, plannedDeliveryEndDatetimeLte, plannedPickupStartDatetime, plannedPickupEndDatetime, plannedPickupStartDatetimeGte, plannedPickupEndDatetimeGte, plannedPickupStartDatetimeLte, plannedPickupEndDatetimeLte, actualDeliveryDatetime, actualPickupDatetime, actualDeliveryDatetimeGte, actualPickupDatetimeGte, actualDeliveryDatetimeLte, actualPickupDatetimeLte, overallStatus, orderNumberContains, purchaseOrderNumberContains, shipmentAssigned, shipmentId, shipmentReferenceId, source, sourceSystemIdContains, status, totalPriceGte, totalPriceLte, supplierExternalIdContains, supplierNameContains, name, shipmentShipwellCustomData, purchaseOrderShipwellCustomData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.purchaseOrdersGet(page, pageSize, ordering, q, archived, createdAt, createdAtGte, createdAtLte, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customerExternalIdContains, customerNameContains, descriptionContains, destinationAddressContains, invoiceExternalIdContains, originAddressContains, plannedDeliveryStartDatetime, plannedDeliveryEndDatetime, plannedDeliveryStartDatetimeGte, plannedDeliveryEndDatetimeGte, plannedDeliveryStartDatetimeLte, plannedDeliveryEndDatetimeLte, plannedPickupStartDatetime, plannedPickupEndDatetime, plannedPickupStartDatetimeGte, plannedPickupEndDatetimeGte, plannedPickupStartDatetimeLte, plannedPickupEndDatetimeLte, actualDeliveryDatetime, actualPickupDatetime, actualDeliveryDatetimeGte, actualPickupDatetimeGte, actualDeliveryDatetimeLte, actualPickupDatetimeLte, overallStatus, orderNumberContains, purchaseOrderNumberContains, shipmentAssigned, shipmentId, shipmentReferenceId, source, sourceSystemIdContains, status, totalPriceGte, totalPriceLte, supplierExternalIdContains, supplierNameContains, name, shipmentShipwellCustomData, purchaseOrderShipwellCustomData, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new purchase order `(Legacy/v2)`
         * @param {PurchaseOrder} [purchaseOrder] ## Create/Update an order The route includes &#x60;/purchase-orders/&#x60; but should be considered as generic orders. It does not imply there is a different route for sales orders and transfer orders. This will be updated in the future with an enhanced data model to support different order types, for now use the purchase order for all types of orders and if needed extend the the object with &#x60;custom_data&#x60; to specify the type of order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPost: function (purchaseOrder, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.purchaseOrdersPost(purchaseOrder, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a PurchaseOrder `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdDelete: function (purchaseOrderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.purchaseOrdersPurchaseOrderIdDelete(purchaseOrderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a PurchaseOrder `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdGet: function (purchaseOrderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.purchaseOrdersPurchaseOrderIdGet(purchaseOrderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Initiate an order consolidation workflow for the given purchase order `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {InitiateOrderConsolidationRequest} initiateOrderConsolidationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdInitiateOrderConsolidationWorkflowPost: function (purchaseOrderId, initiateOrderConsolidationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.purchaseOrdersPurchaseOrderIdInitiateOrderConsolidationWorkflowPost(purchaseOrderId, initiateOrderConsolidationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of line items for a given purchase order `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdLineItemsGet: function (purchaseOrderId, page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.purchaseOrdersPurchaseOrderIdLineItemsGet(purchaseOrderId, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new PurchaseOrderLineItem `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {PurchaseOrderLineItem} [purchaseOrderLineItem] ## Create/Update a PurchaseOrderLineItem Line items are a list of products associated with the order. The product_ref field is used to link the line item to products in either the Shipwell system or your ERP system, but it is not required. This body also includes product-related options, such as &#x60;description&#x60;, &#x60;length&#x60;, and &#x60;length_unit&#x60;. You can add multiple line items to an order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdLineItemsPost: function (purchaseOrderId, purchaseOrderLineItem, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.purchaseOrdersPurchaseOrderIdLineItemsPost(purchaseOrderId, purchaseOrderLineItem, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a PurchaseOrderLineItem `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {string} purchaseOrderLineItemId The id of the purchase order line item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdDelete: function (purchaseOrderId, purchaseOrderLineItemId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdDelete(purchaseOrderId, purchaseOrderLineItemId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a PurchaseOrderLineItem `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {string} purchaseOrderLineItemId The id of the purchase order line item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdGet: function (purchaseOrderId, purchaseOrderLineItemId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdGet(purchaseOrderId, purchaseOrderLineItemId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a PurchaseOrderLineItem `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {string} purchaseOrderLineItemId The id of the purchase order line item
         * @param {PurchaseOrderLineItem} [purchaseOrderLineItem] ## Create/Update a PurchaseOrderLineItem Line items are a list of products associated with the order. The product_ref field is used to link the line item to products in either the Shipwell system or your ERP system, but it is not required. This body also includes product-related options, such as &#x60;description&#x60;, &#x60;length&#x60;, and &#x60;length_unit&#x60;. You can add multiple line items to an order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdPut: function (purchaseOrderId, purchaseOrderLineItemId, purchaseOrderLineItem, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdPut(purchaseOrderId, purchaseOrderLineItemId, purchaseOrderLineItem, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a PurchaseOrder `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {PurchaseOrder} [purchaseOrder] ## Create/Update an order The route includes &#x60;/purchase-orders/&#x60; but should be considered as generic orders. It does not imply there is a different route for sales orders and transfer orders. This will be updated in the future with an enhanced data model to support different order types, for now use the purchase order for all types of orders and if needed extend the the object with &#x60;custom_data&#x60; to specify the type of order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdPut: function (purchaseOrderId, purchaseOrder, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.purchaseOrdersPurchaseOrderIdPut(purchaseOrderId, purchaseOrder, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an existing shipment with purchase orders `(Legacy/v2)`
         * @param {InlineObject15} [inlineObject15]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersUpdateBuiltShipmentPut: function (inlineObject15, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.purchaseOrdersUpdateBuiltShipmentPut(inlineObject15, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PurchaseOrdersApiFp = PurchaseOrdersApiFp;
/**
 * PurchaseOrdersApi - factory interface
 * @export
 */
var PurchaseOrdersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PurchaseOrdersApiFp)(configuration);
    return {
        /**
         *
         * @summary Build a shipment from shipment assembly `(Legacy/v2)`
         * @param {PurchaseOrderBuildShipmentAssemblyRequest} purchaseOrderBuildShipmentAssemblyRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersBuildShipmentAssemblyPost: function (purchaseOrderBuildShipmentAssemblyRequest, options) {
            return localVarFp.purchaseOrdersBuildShipmentAssemblyPost(purchaseOrderBuildShipmentAssemblyRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Build a shipment from purchase orders `(Legacy/v2)`
         * @param {InlineObject14} [inlineObject14]
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        purchaseOrdersBuildShipmentPost: function (inlineObject14, options) {
            return localVarFp.purchaseOrdersBuildShipmentPost(inlineObject14, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List purchase orders `(Legacy/v2)`
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [archived] Filter on whether or not a PurchaseOrder is archived
         * @param {string} [createdAt] Include PurchaseOrders where created_at is equal to this value
         * @param {string} [createdAtGte] Include PurchaseOrders where created_at is greater than or equal to this value
         * @param {string} [createdAtLte] Include PurchaseOrders where created_at is less than or equal to this value
         * @param {string} [createdByUserContains] Include PurchaseOrders where created_by_user object contains this string e.g first_name, last_name or email
         * @param {Array<string>} [createdByUserId] Include PurchaseOrders where created_by_user_id is in the array.
         * @param {string} [createdByUserName] Include PurchaseOrders where created_by_user_name is exactly this string
         * @param {string} [createdByUserNameContains] Include PurchaseOrders where created_by_user_name contains this string
         * @param {string} [customerExternalIdContains] Include PurchaseOrders where customer_external_id contains this string
         * @param {string} [customerNameContains] Include PurchaseOrders where customer_name contains this string
         * @param {string} [descriptionContains] Include PurchaseOrders where description contains this string
         * @param {string} [destinationAddressContains] Include PurchaseOrders where destination_address contains this string
         * @param {string} [invoiceExternalIdContains] Include PurchaseOrders where invoice_external_id contains this string
         * @param {string} [originAddressContains] Include PurchaseOrders where origin_address contains this string
         * @param {string} [plannedDeliveryStartDatetime] Include PurchaseOrders where planned_delivery_start_datetime is equal to this value
         * @param {string} [plannedDeliveryEndDatetime] Include PurchaseOrders where planned_delivery_end_datetime is equal to this value
         * @param {string} [plannedDeliveryStartDatetimeGte] Include PurchaseOrders where planned_delivery_start_datetime is greater than or equal to this value
         * @param {string} [plannedDeliveryEndDatetimeGte] Include PurchaseOrders where planned_delivery_end_datetime is greater than or equal to this value
         * @param {string} [plannedDeliveryStartDatetimeLte] Include PurchaseOrders where planned_delivery_start_datetime is less than or equal to this value
         * @param {string} [plannedDeliveryEndDatetimeLte] Include PurchaseOrders where planned_delivery_end_datetime is less than or equal to this value
         * @param {string} [plannedPickupStartDatetime] Include PurchaseOrders where planned_pickup_start_datetime is equal to this value
         * @param {string} [plannedPickupEndDatetime] Include PurchaseOrders where planned_pickup_end_datetime is equal to this value
         * @param {string} [plannedPickupStartDatetimeGte] Include PurchaseOrders where planned_pickup_start_datetime__gte is greater than or equal to this value
         * @param {string} [plannedPickupEndDatetimeGte] Include PurchaseOrders where planned_pickup_end_datetime is greater than or equal to this value
         * @param {string} [plannedPickupStartDatetimeLte] Include PurchaseOrders where planned_pickup_start_datetime__gte is less than or equal to this value
         * @param {string} [plannedPickupEndDatetimeLte] Include PurchaseOrders where planned_pickup_end_datetime is less than or equal to this value
         * @param {string} [actualDeliveryDatetime] Include PurchaseOrders where actual_delivery_datetime is equal to this value
         * @param {string} [actualPickupDatetime] Include PurchaseOrders where actual_pickup_datetime is equal to this value
         * @param {string} [actualDeliveryDatetimeGte] Include PurchaseOrders where actual_delivery_datetime is greater than or equal to this value
         * @param {string} [actualPickupDatetimeGte] Include PurchaseOrders where actual_pickup_datetime is greater than or equal to this value
         * @param {string} [actualDeliveryDatetimeLte] Include PurchaseOrders where actual_delivery_datetime is less than or equal to this value
         * @param {string} [actualPickupDatetimeLte] Include PurchaseOrders where actual_pickup_datetime is less than or equal to this value
         * @param {Array<'ASSIGNED' | 'UNASSIGNED' | 'IN_TRANSIT' | 'DELIVERED' | 'DISPATCHED' | 'OUT_FOR_DELIVERY'>} [overallStatus] Return PurchaseOrders with an overall_status provided
         * @param {string} [orderNumberContains] Include PurchaseOrders where order_number contains this string
         * @param {string} [purchaseOrderNumberContains] Include PurchaseOrders where purchase_order_number contains this string
         * @param {boolean} [shipmentAssigned] Include PurchaseOrders that have/do not have a shipment assigned
         * @param {string} [shipmentId] Include PurchaseOrders where shipment_id is exactly this string
         * @param {string} [shipmentReferenceId] Include PurchaseOrders where shipment_reference_id is exactly this string
         * @param {Array<'SHIPWELL_WEB' | 'IMPORT' | 'TENDER' | 'SHIPWELL_WEB_UNAUTH'>} [source] Return PurchaseOrders created by sources in the array.
         * @param {string} [sourceSystemIdContains] Include PurchaseOrders where source_system_id contains this string
         * @param {string} [status] Include PurchaseOrders where status is exactly this string
         * @param {number} [totalPriceGte] Include PurchaseOrders where total_price is greater than or equal to this amount
         * @param {number} [totalPriceLte] Include PurchaseOrders where total_price is less than or equal to this amount
         * @param {string} [supplierExternalIdContains] Include PurchaseOrders where vendor_external_id contains this string
         * @param {string} [supplierNameContains] Include PurchaseOrders where vendor_name contains this string
         * @param {string} [name] Include PurchaseOrders where name is exactly this string
         * @param {Array<string>} [shipmentShipwellCustomData] Include shipments that contain these shipment-level custom data values
         * @param {Array<string>} [purchaseOrderShipwellCustomData] Include purchase orders that contain these level custom data values
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersGet: function (page, pageSize, ordering, q, archived, createdAt, createdAtGte, createdAtLte, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customerExternalIdContains, customerNameContains, descriptionContains, destinationAddressContains, invoiceExternalIdContains, originAddressContains, plannedDeliveryStartDatetime, plannedDeliveryEndDatetime, plannedDeliveryStartDatetimeGte, plannedDeliveryEndDatetimeGte, plannedDeliveryStartDatetimeLte, plannedDeliveryEndDatetimeLte, plannedPickupStartDatetime, plannedPickupEndDatetime, plannedPickupStartDatetimeGte, plannedPickupEndDatetimeGte, plannedPickupStartDatetimeLte, plannedPickupEndDatetimeLte, actualDeliveryDatetime, actualPickupDatetime, actualDeliveryDatetimeGte, actualPickupDatetimeGte, actualDeliveryDatetimeLte, actualPickupDatetimeLte, overallStatus, orderNumberContains, purchaseOrderNumberContains, shipmentAssigned, shipmentId, shipmentReferenceId, source, sourceSystemIdContains, status, totalPriceGte, totalPriceLte, supplierExternalIdContains, supplierNameContains, name, shipmentShipwellCustomData, purchaseOrderShipwellCustomData, options) {
            return localVarFp.purchaseOrdersGet(page, pageSize, ordering, q, archived, createdAt, createdAtGte, createdAtLte, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customerExternalIdContains, customerNameContains, descriptionContains, destinationAddressContains, invoiceExternalIdContains, originAddressContains, plannedDeliveryStartDatetime, plannedDeliveryEndDatetime, plannedDeliveryStartDatetimeGte, plannedDeliveryEndDatetimeGte, plannedDeliveryStartDatetimeLte, plannedDeliveryEndDatetimeLte, plannedPickupStartDatetime, plannedPickupEndDatetime, plannedPickupStartDatetimeGte, plannedPickupEndDatetimeGte, plannedPickupStartDatetimeLte, plannedPickupEndDatetimeLte, actualDeliveryDatetime, actualPickupDatetime, actualDeliveryDatetimeGte, actualPickupDatetimeGte, actualDeliveryDatetimeLte, actualPickupDatetimeLte, overallStatus, orderNumberContains, purchaseOrderNumberContains, shipmentAssigned, shipmentId, shipmentReferenceId, source, sourceSystemIdContains, status, totalPriceGte, totalPriceLte, supplierExternalIdContains, supplierNameContains, name, shipmentShipwellCustomData, purchaseOrderShipwellCustomData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new purchase order `(Legacy/v2)`
         * @param {PurchaseOrder} [purchaseOrder] ## Create/Update an order The route includes &#x60;/purchase-orders/&#x60; but should be considered as generic orders. It does not imply there is a different route for sales orders and transfer orders. This will be updated in the future with an enhanced data model to support different order types, for now use the purchase order for all types of orders and if needed extend the the object with &#x60;custom_data&#x60; to specify the type of order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPost: function (purchaseOrder, options) {
            return localVarFp.purchaseOrdersPost(purchaseOrder, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a PurchaseOrder `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdDelete: function (purchaseOrderId, options) {
            return localVarFp.purchaseOrdersPurchaseOrderIdDelete(purchaseOrderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a PurchaseOrder `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdGet: function (purchaseOrderId, options) {
            return localVarFp.purchaseOrdersPurchaseOrderIdGet(purchaseOrderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Initiate an order consolidation workflow for the given purchase order `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {InitiateOrderConsolidationRequest} initiateOrderConsolidationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdInitiateOrderConsolidationWorkflowPost: function (purchaseOrderId, initiateOrderConsolidationRequest, options) {
            return localVarFp.purchaseOrdersPurchaseOrderIdInitiateOrderConsolidationWorkflowPost(purchaseOrderId, initiateOrderConsolidationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a list of line items for a given purchase order `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdLineItemsGet: function (purchaseOrderId, page, pageSize, options) {
            return localVarFp.purchaseOrdersPurchaseOrderIdLineItemsGet(purchaseOrderId, page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new PurchaseOrderLineItem `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {PurchaseOrderLineItem} [purchaseOrderLineItem] ## Create/Update a PurchaseOrderLineItem Line items are a list of products associated with the order. The product_ref field is used to link the line item to products in either the Shipwell system or your ERP system, but it is not required. This body also includes product-related options, such as &#x60;description&#x60;, &#x60;length&#x60;, and &#x60;length_unit&#x60;. You can add multiple line items to an order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdLineItemsPost: function (purchaseOrderId, purchaseOrderLineItem, options) {
            return localVarFp.purchaseOrdersPurchaseOrderIdLineItemsPost(purchaseOrderId, purchaseOrderLineItem, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a PurchaseOrderLineItem `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {string} purchaseOrderLineItemId The id of the purchase order line item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdDelete: function (purchaseOrderId, purchaseOrderLineItemId, options) {
            return localVarFp.purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdDelete(purchaseOrderId, purchaseOrderLineItemId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about a PurchaseOrderLineItem `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {string} purchaseOrderLineItemId The id of the purchase order line item
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdGet: function (purchaseOrderId, purchaseOrderLineItemId, options) {
            return localVarFp.purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdGet(purchaseOrderId, purchaseOrderLineItemId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a PurchaseOrderLineItem `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {string} purchaseOrderLineItemId The id of the purchase order line item
         * @param {PurchaseOrderLineItem} [purchaseOrderLineItem] ## Create/Update a PurchaseOrderLineItem Line items are a list of products associated with the order. The product_ref field is used to link the line item to products in either the Shipwell system or your ERP system, but it is not required. This body also includes product-related options, such as &#x60;description&#x60;, &#x60;length&#x60;, and &#x60;length_unit&#x60;. You can add multiple line items to an order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdPut: function (purchaseOrderId, purchaseOrderLineItemId, purchaseOrderLineItem, options) {
            return localVarFp.purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdPut(purchaseOrderId, purchaseOrderLineItemId, purchaseOrderLineItem, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a PurchaseOrder `(Legacy/v2)`
         * @param {string} purchaseOrderId The id of the purchase order
         * @param {PurchaseOrder} [purchaseOrder] ## Create/Update an order The route includes &#x60;/purchase-orders/&#x60; but should be considered as generic orders. It does not imply there is a different route for sales orders and transfer orders. This will be updated in the future with an enhanced data model to support different order types, for now use the purchase order for all types of orders and if needed extend the the object with &#x60;custom_data&#x60; to specify the type of order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersPurchaseOrderIdPut: function (purchaseOrderId, purchaseOrder, options) {
            return localVarFp.purchaseOrdersPurchaseOrderIdPut(purchaseOrderId, purchaseOrder, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update an existing shipment with purchase orders `(Legacy/v2)`
         * @param {InlineObject15} [inlineObject15]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersUpdateBuiltShipmentPut: function (inlineObject15, options) {
            return localVarFp.purchaseOrdersUpdateBuiltShipmentPut(inlineObject15, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PurchaseOrdersApiFactory = PurchaseOrdersApiFactory;
/**
 * PurchaseOrdersApi - object-oriented interface
 * @export
 * @class PurchaseOrdersApi
 * @extends {BaseAPI}
 */
var PurchaseOrdersApi = /** @class */ (function (_super) {
    __extends(PurchaseOrdersApi, _super);
    function PurchaseOrdersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Build a shipment from shipment assembly `(Legacy/v2)`
     * @param {PurchaseOrderBuildShipmentAssemblyRequest} purchaseOrderBuildShipmentAssemblyRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.purchaseOrdersBuildShipmentAssemblyPost = function (purchaseOrderBuildShipmentAssemblyRequest, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).purchaseOrdersBuildShipmentAssemblyPost(purchaseOrderBuildShipmentAssemblyRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Build a shipment from purchase orders `(Legacy/v2)`
     * @param {InlineObject14} [inlineObject14]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.purchaseOrdersBuildShipmentPost = function (inlineObject14, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).purchaseOrdersBuildShipmentPost(inlineObject14, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List purchase orders `(Legacy/v2)`
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {boolean} [archived] Filter on whether or not a PurchaseOrder is archived
     * @param {string} [createdAt] Include PurchaseOrders where created_at is equal to this value
     * @param {string} [createdAtGte] Include PurchaseOrders where created_at is greater than or equal to this value
     * @param {string} [createdAtLte] Include PurchaseOrders where created_at is less than or equal to this value
     * @param {string} [createdByUserContains] Include PurchaseOrders where created_by_user object contains this string e.g first_name, last_name or email
     * @param {Array<string>} [createdByUserId] Include PurchaseOrders where created_by_user_id is in the array.
     * @param {string} [createdByUserName] Include PurchaseOrders where created_by_user_name is exactly this string
     * @param {string} [createdByUserNameContains] Include PurchaseOrders where created_by_user_name contains this string
     * @param {string} [customerExternalIdContains] Include PurchaseOrders where customer_external_id contains this string
     * @param {string} [customerNameContains] Include PurchaseOrders where customer_name contains this string
     * @param {string} [descriptionContains] Include PurchaseOrders where description contains this string
     * @param {string} [destinationAddressContains] Include PurchaseOrders where destination_address contains this string
     * @param {string} [invoiceExternalIdContains] Include PurchaseOrders where invoice_external_id contains this string
     * @param {string} [originAddressContains] Include PurchaseOrders where origin_address contains this string
     * @param {string} [plannedDeliveryStartDatetime] Include PurchaseOrders where planned_delivery_start_datetime is equal to this value
     * @param {string} [plannedDeliveryEndDatetime] Include PurchaseOrders where planned_delivery_end_datetime is equal to this value
     * @param {string} [plannedDeliveryStartDatetimeGte] Include PurchaseOrders where planned_delivery_start_datetime is greater than or equal to this value
     * @param {string} [plannedDeliveryEndDatetimeGte] Include PurchaseOrders where planned_delivery_end_datetime is greater than or equal to this value
     * @param {string} [plannedDeliveryStartDatetimeLte] Include PurchaseOrders where planned_delivery_start_datetime is less than or equal to this value
     * @param {string} [plannedDeliveryEndDatetimeLte] Include PurchaseOrders where planned_delivery_end_datetime is less than or equal to this value
     * @param {string} [plannedPickupStartDatetime] Include PurchaseOrders where planned_pickup_start_datetime is equal to this value
     * @param {string} [plannedPickupEndDatetime] Include PurchaseOrders where planned_pickup_end_datetime is equal to this value
     * @param {string} [plannedPickupStartDatetimeGte] Include PurchaseOrders where planned_pickup_start_datetime__gte is greater than or equal to this value
     * @param {string} [plannedPickupEndDatetimeGte] Include PurchaseOrders where planned_pickup_end_datetime is greater than or equal to this value
     * @param {string} [plannedPickupStartDatetimeLte] Include PurchaseOrders where planned_pickup_start_datetime__gte is less than or equal to this value
     * @param {string} [plannedPickupEndDatetimeLte] Include PurchaseOrders where planned_pickup_end_datetime is less than or equal to this value
     * @param {string} [actualDeliveryDatetime] Include PurchaseOrders where actual_delivery_datetime is equal to this value
     * @param {string} [actualPickupDatetime] Include PurchaseOrders where actual_pickup_datetime is equal to this value
     * @param {string} [actualDeliveryDatetimeGte] Include PurchaseOrders where actual_delivery_datetime is greater than or equal to this value
     * @param {string} [actualPickupDatetimeGte] Include PurchaseOrders where actual_pickup_datetime is greater than or equal to this value
     * @param {string} [actualDeliveryDatetimeLte] Include PurchaseOrders where actual_delivery_datetime is less than or equal to this value
     * @param {string} [actualPickupDatetimeLte] Include PurchaseOrders where actual_pickup_datetime is less than or equal to this value
     * @param {Array<'ASSIGNED' | 'UNASSIGNED' | 'IN_TRANSIT' | 'DELIVERED' | 'DISPATCHED' | 'OUT_FOR_DELIVERY'>} [overallStatus] Return PurchaseOrders with an overall_status provided
     * @param {string} [orderNumberContains] Include PurchaseOrders where order_number contains this string
     * @param {string} [purchaseOrderNumberContains] Include PurchaseOrders where purchase_order_number contains this string
     * @param {boolean} [shipmentAssigned] Include PurchaseOrders that have/do not have a shipment assigned
     * @param {string} [shipmentId] Include PurchaseOrders where shipment_id is exactly this string
     * @param {string} [shipmentReferenceId] Include PurchaseOrders where shipment_reference_id is exactly this string
     * @param {Array<'SHIPWELL_WEB' | 'IMPORT' | 'TENDER' | 'SHIPWELL_WEB_UNAUTH'>} [source] Return PurchaseOrders created by sources in the array.
     * @param {string} [sourceSystemIdContains] Include PurchaseOrders where source_system_id contains this string
     * @param {string} [status] Include PurchaseOrders where status is exactly this string
     * @param {number} [totalPriceGte] Include PurchaseOrders where total_price is greater than or equal to this amount
     * @param {number} [totalPriceLte] Include PurchaseOrders where total_price is less than or equal to this amount
     * @param {string} [supplierExternalIdContains] Include PurchaseOrders where vendor_external_id contains this string
     * @param {string} [supplierNameContains] Include PurchaseOrders where vendor_name contains this string
     * @param {string} [name] Include PurchaseOrders where name is exactly this string
     * @param {Array<string>} [shipmentShipwellCustomData] Include shipments that contain these shipment-level custom data values
     * @param {Array<string>} [purchaseOrderShipwellCustomData] Include purchase orders that contain these level custom data values
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.purchaseOrdersGet = function (page, pageSize, ordering, q, archived, createdAt, createdAtGte, createdAtLte, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customerExternalIdContains, customerNameContains, descriptionContains, destinationAddressContains, invoiceExternalIdContains, originAddressContains, plannedDeliveryStartDatetime, plannedDeliveryEndDatetime, plannedDeliveryStartDatetimeGte, plannedDeliveryEndDatetimeGte, plannedDeliveryStartDatetimeLte, plannedDeliveryEndDatetimeLte, plannedPickupStartDatetime, plannedPickupEndDatetime, plannedPickupStartDatetimeGte, plannedPickupEndDatetimeGte, plannedPickupStartDatetimeLte, plannedPickupEndDatetimeLte, actualDeliveryDatetime, actualPickupDatetime, actualDeliveryDatetimeGte, actualPickupDatetimeGte, actualDeliveryDatetimeLte, actualPickupDatetimeLte, overallStatus, orderNumberContains, purchaseOrderNumberContains, shipmentAssigned, shipmentId, shipmentReferenceId, source, sourceSystemIdContains, status, totalPriceGte, totalPriceLte, supplierExternalIdContains, supplierNameContains, name, shipmentShipwellCustomData, purchaseOrderShipwellCustomData, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).purchaseOrdersGet(page, pageSize, ordering, q, archived, createdAt, createdAtGte, createdAtLte, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customerExternalIdContains, customerNameContains, descriptionContains, destinationAddressContains, invoiceExternalIdContains, originAddressContains, plannedDeliveryStartDatetime, plannedDeliveryEndDatetime, plannedDeliveryStartDatetimeGte, plannedDeliveryEndDatetimeGte, plannedDeliveryStartDatetimeLte, plannedDeliveryEndDatetimeLte, plannedPickupStartDatetime, plannedPickupEndDatetime, plannedPickupStartDatetimeGte, plannedPickupEndDatetimeGte, plannedPickupStartDatetimeLte, plannedPickupEndDatetimeLte, actualDeliveryDatetime, actualPickupDatetime, actualDeliveryDatetimeGte, actualPickupDatetimeGte, actualDeliveryDatetimeLte, actualPickupDatetimeLte, overallStatus, orderNumberContains, purchaseOrderNumberContains, shipmentAssigned, shipmentId, shipmentReferenceId, source, sourceSystemIdContains, status, totalPriceGte, totalPriceLte, supplierExternalIdContains, supplierNameContains, name, shipmentShipwellCustomData, purchaseOrderShipwellCustomData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new purchase order `(Legacy/v2)`
     * @param {PurchaseOrder} [purchaseOrder] ## Create/Update an order The route includes &#x60;/purchase-orders/&#x60; but should be considered as generic orders. It does not imply there is a different route for sales orders and transfer orders. This will be updated in the future with an enhanced data model to support different order types, for now use the purchase order for all types of orders and if needed extend the the object with &#x60;custom_data&#x60; to specify the type of order.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.purchaseOrdersPost = function (purchaseOrder, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).purchaseOrdersPost(purchaseOrder, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a PurchaseOrder `(Legacy/v2)`
     * @param {string} purchaseOrderId The id of the purchase order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.purchaseOrdersPurchaseOrderIdDelete = function (purchaseOrderId, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).purchaseOrdersPurchaseOrderIdDelete(purchaseOrderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a PurchaseOrder `(Legacy/v2)`
     * @param {string} purchaseOrderId The id of the purchase order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.purchaseOrdersPurchaseOrderIdGet = function (purchaseOrderId, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).purchaseOrdersPurchaseOrderIdGet(purchaseOrderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Initiate an order consolidation workflow for the given purchase order `(Legacy/v2)`
     * @param {string} purchaseOrderId The id of the purchase order
     * @param {InitiateOrderConsolidationRequest} initiateOrderConsolidationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.purchaseOrdersPurchaseOrderIdInitiateOrderConsolidationWorkflowPost = function (purchaseOrderId, initiateOrderConsolidationRequest, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).purchaseOrdersPurchaseOrderIdInitiateOrderConsolidationWorkflowPost(purchaseOrderId, initiateOrderConsolidationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a list of line items for a given purchase order `(Legacy/v2)`
     * @param {string} purchaseOrderId The id of the purchase order
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.purchaseOrdersPurchaseOrderIdLineItemsGet = function (purchaseOrderId, page, pageSize, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).purchaseOrdersPurchaseOrderIdLineItemsGet(purchaseOrderId, page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new PurchaseOrderLineItem `(Legacy/v2)`
     * @param {string} purchaseOrderId The id of the purchase order
     * @param {PurchaseOrderLineItem} [purchaseOrderLineItem] ## Create/Update a PurchaseOrderLineItem Line items are a list of products associated with the order. The product_ref field is used to link the line item to products in either the Shipwell system or your ERP system, but it is not required. This body also includes product-related options, such as &#x60;description&#x60;, &#x60;length&#x60;, and &#x60;length_unit&#x60;. You can add multiple line items to an order.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.purchaseOrdersPurchaseOrderIdLineItemsPost = function (purchaseOrderId, purchaseOrderLineItem, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).purchaseOrdersPurchaseOrderIdLineItemsPost(purchaseOrderId, purchaseOrderLineItem, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a PurchaseOrderLineItem `(Legacy/v2)`
     * @param {string} purchaseOrderId The id of the purchase order
     * @param {string} purchaseOrderLineItemId The id of the purchase order line item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdDelete = function (purchaseOrderId, purchaseOrderLineItemId, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdDelete(purchaseOrderId, purchaseOrderLineItemId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about a PurchaseOrderLineItem `(Legacy/v2)`
     * @param {string} purchaseOrderId The id of the purchase order
     * @param {string} purchaseOrderLineItemId The id of the purchase order line item
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdGet = function (purchaseOrderId, purchaseOrderLineItemId, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdGet(purchaseOrderId, purchaseOrderLineItemId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a PurchaseOrderLineItem `(Legacy/v2)`
     * @param {string} purchaseOrderId The id of the purchase order
     * @param {string} purchaseOrderLineItemId The id of the purchase order line item
     * @param {PurchaseOrderLineItem} [purchaseOrderLineItem] ## Create/Update a PurchaseOrderLineItem Line items are a list of products associated with the order. The product_ref field is used to link the line item to products in either the Shipwell system or your ERP system, but it is not required. This body also includes product-related options, such as &#x60;description&#x60;, &#x60;length&#x60;, and &#x60;length_unit&#x60;. You can add multiple line items to an order.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdPut = function (purchaseOrderId, purchaseOrderLineItemId, purchaseOrderLineItem, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).purchaseOrdersPurchaseOrderIdLineItemsPurchaseOrderLineItemIdPut(purchaseOrderId, purchaseOrderLineItemId, purchaseOrderLineItem, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a PurchaseOrder `(Legacy/v2)`
     * @param {string} purchaseOrderId The id of the purchase order
     * @param {PurchaseOrder} [purchaseOrder] ## Create/Update an order The route includes &#x60;/purchase-orders/&#x60; but should be considered as generic orders. It does not imply there is a different route for sales orders and transfer orders. This will be updated in the future with an enhanced data model to support different order types, for now use the purchase order for all types of orders and if needed extend the the object with &#x60;custom_data&#x60; to specify the type of order.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.purchaseOrdersPurchaseOrderIdPut = function (purchaseOrderId, purchaseOrder, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).purchaseOrdersPurchaseOrderIdPut(purchaseOrderId, purchaseOrder, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update an existing shipment with purchase orders `(Legacy/v2)`
     * @param {InlineObject15} [inlineObject15]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOrdersApi
     */
    PurchaseOrdersApi.prototype.purchaseOrdersUpdateBuiltShipmentPut = function (inlineObject15, options) {
        var _this = this;
        return (0, exports.PurchaseOrdersApiFp)(this.configuration).purchaseOrdersUpdateBuiltShipmentPut(inlineObject15, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PurchaseOrdersApi;
}(base_1.BaseAPI));
exports.PurchaseOrdersApi = PurchaseOrdersApi;
/**
 * PushNotificationsApi - axios parameter creator
 * @export
 */
var PushNotificationsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary List all push notifications for the request user
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [createdAt] For requesting data created at a certain datetime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushNotificationsGet: function (page, pageSize, ordering, createdAt, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/push-notifications/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (createdAt !== undefined) {
                                localVarQueryParameter['created_at'] = (createdAt instanceof Date) ?
                                    createdAt.toISOString() :
                                    createdAt;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a PushNotification
         * @param {string} pushNotificationId The id of the push notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushNotificationsPushNotificationIdGet: function (pushNotificationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'pushNotificationId' is not null or undefined
                            (0, common_1.assertParamExists)('pushNotificationsPushNotificationIdGet', 'pushNotificationId', pushNotificationId);
                            localVarPath = "/push-notifications/{pushNotificationId}/"
                                .replace("{".concat("pushNotificationId", "}"), encodeURIComponent(String(pushNotificationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PushNotificationsApiAxiosParamCreator = PushNotificationsApiAxiosParamCreator;
/**
 * PushNotificationsApi - functional programming interface
 * @export
 */
var PushNotificationsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PushNotificationsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary List all push notifications for the request user
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [createdAt] For requesting data created at a certain datetime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushNotificationsGet: function (page, pageSize, ordering, createdAt, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.pushNotificationsGet(page, pageSize, ordering, createdAt, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a PushNotification
         * @param {string} pushNotificationId The id of the push notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushNotificationsPushNotificationIdGet: function (pushNotificationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.pushNotificationsPushNotificationIdGet(pushNotificationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PushNotificationsApiFp = PushNotificationsApiFp;
/**
 * PushNotificationsApi - factory interface
 * @export
 */
var PushNotificationsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PushNotificationsApiFp)(configuration);
    return {
        /**
         *
         * @summary List all push notifications for the request user
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [createdAt] For requesting data created at a certain datetime
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushNotificationsGet: function (page, pageSize, ordering, createdAt, options) {
            return localVarFp.pushNotificationsGet(page, pageSize, ordering, createdAt, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a PushNotification
         * @param {string} pushNotificationId The id of the push notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushNotificationsPushNotificationIdGet: function (pushNotificationId, options) {
            return localVarFp.pushNotificationsPushNotificationIdGet(pushNotificationId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PushNotificationsApiFactory = PushNotificationsApiFactory;
/**
 * PushNotificationsApi - object-oriented interface
 * @export
 * @class PushNotificationsApi
 * @extends {BaseAPI}
 */
var PushNotificationsApi = /** @class */ (function (_super) {
    __extends(PushNotificationsApi, _super);
    function PushNotificationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary List all push notifications for the request user
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [createdAt] For requesting data created at a certain datetime
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PushNotificationsApi
     */
    PushNotificationsApi.prototype.pushNotificationsGet = function (page, pageSize, ordering, createdAt, options) {
        var _this = this;
        return (0, exports.PushNotificationsApiFp)(this.configuration).pushNotificationsGet(page, pageSize, ordering, createdAt, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a PushNotification
     * @param {string} pushNotificationId The id of the push notification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PushNotificationsApi
     */
    PushNotificationsApi.prototype.pushNotificationsPushNotificationIdGet = function (pushNotificationId, options) {
        var _this = this;
        return (0, exports.PushNotificationsApiFp)(this.configuration).pushNotificationsPushNotificationIdGet(pushNotificationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PushNotificationsApi;
}(base_1.BaseAPI));
exports.PushNotificationsApi = PushNotificationsApi;
/**
 * PushNotifictionsApi - axios parameter creator
 * @export
 */
var PushNotifictionsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Mark Push Notification as read
         * @param {string} pushNotificationId The id of the push notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushNotificationsPushNotificationIdMarkAsReadPost: function (pushNotificationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'pushNotificationId' is not null or undefined
                            (0, common_1.assertParamExists)('pushNotificationsPushNotificationIdMarkAsReadPost', 'pushNotificationId', pushNotificationId);
                            localVarPath = "/push-notifications/{pushNotificationId}/mark-as-read/"
                                .replace("{".concat("pushNotificationId", "}"), encodeURIComponent(String(pushNotificationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Mark Push Notification as unread
         * @param {string} pushNotificationId The id of the push notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushNotificationsPushNotificationIdMarkAsUnreadPost: function (pushNotificationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'pushNotificationId' is not null or undefined
                            (0, common_1.assertParamExists)('pushNotificationsPushNotificationIdMarkAsUnreadPost', 'pushNotificationId', pushNotificationId);
                            localVarPath = "/push-notifications/{pushNotificationId}/mark-as-unread/"
                                .replace("{".concat("pushNotificationId", "}"), encodeURIComponent(String(pushNotificationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PushNotifictionsApiAxiosParamCreator = PushNotifictionsApiAxiosParamCreator;
/**
 * PushNotifictionsApi - functional programming interface
 * @export
 */
var PushNotifictionsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PushNotifictionsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Mark Push Notification as read
         * @param {string} pushNotificationId The id of the push notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushNotificationsPushNotificationIdMarkAsReadPost: function (pushNotificationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.pushNotificationsPushNotificationIdMarkAsReadPost(pushNotificationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Mark Push Notification as unread
         * @param {string} pushNotificationId The id of the push notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushNotificationsPushNotificationIdMarkAsUnreadPost: function (pushNotificationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.pushNotificationsPushNotificationIdMarkAsUnreadPost(pushNotificationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PushNotifictionsApiFp = PushNotifictionsApiFp;
/**
 * PushNotifictionsApi - factory interface
 * @export
 */
var PushNotifictionsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PushNotifictionsApiFp)(configuration);
    return {
        /**
         *
         * @summary Mark Push Notification as read
         * @param {string} pushNotificationId The id of the push notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushNotificationsPushNotificationIdMarkAsReadPost: function (pushNotificationId, options) {
            return localVarFp.pushNotificationsPushNotificationIdMarkAsReadPost(pushNotificationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Mark Push Notification as unread
         * @param {string} pushNotificationId The id of the push notification
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushNotificationsPushNotificationIdMarkAsUnreadPost: function (pushNotificationId, options) {
            return localVarFp.pushNotificationsPushNotificationIdMarkAsUnreadPost(pushNotificationId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PushNotifictionsApiFactory = PushNotifictionsApiFactory;
/**
 * PushNotifictionsApi - object-oriented interface
 * @export
 * @class PushNotifictionsApi
 * @extends {BaseAPI}
 */
var PushNotifictionsApi = /** @class */ (function (_super) {
    __extends(PushNotifictionsApi, _super);
    function PushNotifictionsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Mark Push Notification as read
     * @param {string} pushNotificationId The id of the push notification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PushNotifictionsApi
     */
    PushNotifictionsApi.prototype.pushNotificationsPushNotificationIdMarkAsReadPost = function (pushNotificationId, options) {
        var _this = this;
        return (0, exports.PushNotifictionsApiFp)(this.configuration).pushNotificationsPushNotificationIdMarkAsReadPost(pushNotificationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Mark Push Notification as unread
     * @param {string} pushNotificationId The id of the push notification
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PushNotifictionsApi
     */
    PushNotifictionsApi.prototype.pushNotificationsPushNotificationIdMarkAsUnreadPost = function (pushNotificationId, options) {
        var _this = this;
        return (0, exports.PushNotifictionsApiFp)(this.configuration).pushNotificationsPushNotificationIdMarkAsUnreadPost(pushNotificationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PushNotifictionsApi;
}(base_1.BaseAPI));
exports.PushNotifictionsApi = PushNotifictionsApi;
/**
 * QuotingApi - axios parameter creator
 * @export
 */
var QuotingApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * An RFQ is a Request For Quote. All quotes will be created under an RFQ.
         * @summary Create a new RFQ, kicking off autoquoting if specified
         * @param {RFQ} rFQ
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsPost: function (rFQ, xCompanyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rFQ' is not null or undefined
                            (0, common_1.assertParamExists)('quotingRfqsPost', 'rFQ', rFQ);
                            localVarPath = "/quoting/rfqs/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (xCompanyId !== undefined && xCompanyId !== null) {
                                localVarHeaderParameter['X-Company-Id'] = String(xCompanyId);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rFQ, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete an RFQ
         * @param {string} rfqId The id of the rfq
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {boolean} [includeFailures] If true, include failed Quotes in the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsRfqIdDelete: function (rfqId, xCompanyId, includeFailures, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfqId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingRfqsRfqIdDelete', 'rfqId', rfqId);
                            localVarPath = "/quoting/rfqs/{rfqId}/"
                                .replace("{".concat("rfqId", "}"), encodeURIComponent(String(rfqId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (includeFailures !== undefined) {
                                localVarQueryParameter['include_failures'] = includeFailures;
                            }
                            if (xCompanyId !== undefined && xCompanyId !== null) {
                                localVarHeaderParameter['X-Company-Id'] = String(xCompanyId);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about an RFQ
         * @param {string} rfqId The id of the rfq
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {boolean} [includeFailures] If true, include failed Quotes in the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsRfqIdGet: function (rfqId, xCompanyId, includeFailures, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfqId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingRfqsRfqIdGet', 'rfqId', rfqId);
                            localVarPath = "/quoting/rfqs/{rfqId}/"
                                .replace("{".concat("rfqId", "}"), encodeURIComponent(String(rfqId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (includeFailures !== undefined) {
                                localVarQueryParameter['include_failures'] = includeFailures;
                            }
                            if (xCompanyId !== undefined && xCompanyId !== null) {
                                localVarHeaderParameter['X-Company-Id'] = String(xCompanyId);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Note: Complexities of updating not implemented
         * @summary Update an RFQ
         * @param {string} rfqId The id of the rfq
         * @param {RFQ} rFQ
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {boolean} [includeFailures] If true, include failed Quotes in the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsRfqIdPut: function (rfqId, rFQ, xCompanyId, includeFailures, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfqId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingRfqsRfqIdPut', 'rfqId', rfqId);
                            // verify required parameter 'rFQ' is not null or undefined
                            (0, common_1.assertParamExists)('quotingRfqsRfqIdPut', 'rFQ', rFQ);
                            localVarPath = "/quoting/rfqs/{rfqId}/"
                                .replace("{".concat("rfqId", "}"), encodeURIComponent(String(rfqId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (includeFailures !== undefined) {
                                localVarQueryParameter['include_failures'] = includeFailures;
                            }
                            if (xCompanyId !== undefined && xCompanyId !== null) {
                                localVarHeaderParameter['X-Company-Id'] = String(xCompanyId);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rFQ, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of all quotes under an RFQ
         * @param {string} rfqId The id of the rfq
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {boolean} [includeFailures] If true, include failed Quotes in the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsRfqIdQuotesGet: function (rfqId, xCompanyId, page, pageSize, ordering, includeFailures, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfqId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingRfqsRfqIdQuotesGet', 'rfqId', rfqId);
                            localVarPath = "/quoting/rfqs/{rfqId}/quotes/"
                                .replace("{".concat("rfqId", "}"), encodeURIComponent(String(rfqId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (includeFailures !== undefined) {
                                localVarQueryParameter['include_failures'] = includeFailures;
                            }
                            if (xCompanyId !== undefined && xCompanyId !== null) {
                                localVarHeaderParameter['X-Company-Id'] = String(xCompanyId);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Note: Need to add more info about creating a quote here
         * @summary Create a new quote under an RFQ
         * @param {string} rfqId The id of the rfq
         * @param {CreateQuote} createQuote
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsRfqIdQuotesPost: function (rfqId, createQuote, xCompanyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfqId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingRfqsRfqIdQuotesPost', 'rfqId', rfqId);
                            // verify required parameter 'createQuote' is not null or undefined
                            (0, common_1.assertParamExists)('quotingRfqsRfqIdQuotesPost', 'createQuote', createQuote);
                            localVarPath = "/quoting/rfqs/{rfqId}/quotes/"
                                .replace("{".concat("rfqId", "}"), encodeURIComponent(String(rfqId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (xCompanyId !== undefined && xCompanyId !== null) {
                                localVarHeaderParameter['X-Company-Id'] = String(xCompanyId);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createQuote, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a Quote
         * @param {string} rfqId The id of the rfq
         * @param {string} quoteId The id of the quote
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsRfqIdQuotesQuoteIdDelete: function (rfqId, quoteId, xCompanyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfqId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingRfqsRfqIdQuotesQuoteIdDelete', 'rfqId', rfqId);
                            // verify required parameter 'quoteId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingRfqsRfqIdQuotesQuoteIdDelete', 'quoteId', quoteId);
                            localVarPath = "/quoting/rfqs/{rfqId}/quotes/{quoteId}/"
                                .replace("{".concat("rfqId", "}"), encodeURIComponent(String(rfqId)))
                                .replace("{".concat("quoteId", "}"), encodeURIComponent(String(quoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (xCompanyId !== undefined && xCompanyId !== null) {
                                localVarHeaderParameter['X-Company-Id'] = String(xCompanyId);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a quote
         * @param {string} rfqId The id of the rfq
         * @param {string} quoteId The id of the quote
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsRfqIdQuotesQuoteIdGet: function (rfqId, quoteId, xCompanyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfqId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingRfqsRfqIdQuotesQuoteIdGet', 'rfqId', rfqId);
                            // verify required parameter 'quoteId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingRfqsRfqIdQuotesQuoteIdGet', 'quoteId', quoteId);
                            localVarPath = "/quoting/rfqs/{rfqId}/quotes/{quoteId}/"
                                .replace("{".concat("rfqId", "}"), encodeURIComponent(String(rfqId)))
                                .replace("{".concat("quoteId", "}"), encodeURIComponent(String(quoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (xCompanyId !== undefined && xCompanyId !== null) {
                                localVarHeaderParameter['X-Company-Id'] = String(xCompanyId);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Note: this route might be eliminated, so create new quotes when possible
         * @summary Update a quote
         * @param {string} rfqId The id of the rfq
         * @param {string} quoteId The id of the quote
         * @param {CreateQuote} createQuote
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsRfqIdQuotesQuoteIdPut: function (rfqId, quoteId, createQuote, xCompanyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfqId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingRfqsRfqIdQuotesQuoteIdPut', 'rfqId', rfqId);
                            // verify required parameter 'quoteId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingRfqsRfqIdQuotesQuoteIdPut', 'quoteId', quoteId);
                            // verify required parameter 'createQuote' is not null or undefined
                            (0, common_1.assertParamExists)('quotingRfqsRfqIdQuotesQuoteIdPut', 'createQuote', createQuote);
                            localVarPath = "/quoting/rfqs/{rfqId}/quotes/{quoteId}/"
                                .replace("{".concat("rfqId", "}"), encodeURIComponent(String(rfqId)))
                                .replace("{".concat("quoteId", "}"), encodeURIComponent(String(quoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (xCompanyId !== undefined && xCompanyId !== null) {
                                localVarHeaderParameter['X-Company-Id'] = String(xCompanyId);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createQuote, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.QuotingApiAxiosParamCreator = QuotingApiAxiosParamCreator;
/**
 * QuotingApi - functional programming interface
 * @export
 */
var QuotingApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.QuotingApiAxiosParamCreator)(configuration);
    return {
        /**
         * An RFQ is a Request For Quote. All quotes will be created under an RFQ.
         * @summary Create a new RFQ, kicking off autoquoting if specified
         * @param {RFQ} rFQ
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsPost: function (rFQ, xCompanyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingRfqsPost(rFQ, xCompanyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete an RFQ
         * @param {string} rfqId The id of the rfq
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {boolean} [includeFailures] If true, include failed Quotes in the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsRfqIdDelete: function (rfqId, xCompanyId, includeFailures, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingRfqsRfqIdDelete(rfqId, xCompanyId, includeFailures, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about an RFQ
         * @param {string} rfqId The id of the rfq
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {boolean} [includeFailures] If true, include failed Quotes in the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsRfqIdGet: function (rfqId, xCompanyId, includeFailures, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingRfqsRfqIdGet(rfqId, xCompanyId, includeFailures, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Note: Complexities of updating not implemented
         * @summary Update an RFQ
         * @param {string} rfqId The id of the rfq
         * @param {RFQ} rFQ
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {boolean} [includeFailures] If true, include failed Quotes in the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsRfqIdPut: function (rfqId, rFQ, xCompanyId, includeFailures, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingRfqsRfqIdPut(rfqId, rFQ, xCompanyId, includeFailures, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of all quotes under an RFQ
         * @param {string} rfqId The id of the rfq
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {boolean} [includeFailures] If true, include failed Quotes in the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsRfqIdQuotesGet: function (rfqId, xCompanyId, page, pageSize, ordering, includeFailures, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingRfqsRfqIdQuotesGet(rfqId, xCompanyId, page, pageSize, ordering, includeFailures, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Note: Need to add more info about creating a quote here
         * @summary Create a new quote under an RFQ
         * @param {string} rfqId The id of the rfq
         * @param {CreateQuote} createQuote
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsRfqIdQuotesPost: function (rfqId, createQuote, xCompanyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingRfqsRfqIdQuotesPost(rfqId, createQuote, xCompanyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a Quote
         * @param {string} rfqId The id of the rfq
         * @param {string} quoteId The id of the quote
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsRfqIdQuotesQuoteIdDelete: function (rfqId, quoteId, xCompanyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingRfqsRfqIdQuotesQuoteIdDelete(rfqId, quoteId, xCompanyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a quote
         * @param {string} rfqId The id of the rfq
         * @param {string} quoteId The id of the quote
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsRfqIdQuotesQuoteIdGet: function (rfqId, quoteId, xCompanyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingRfqsRfqIdQuotesQuoteIdGet(rfqId, quoteId, xCompanyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Note: this route might be eliminated, so create new quotes when possible
         * @summary Update a quote
         * @param {string} rfqId The id of the rfq
         * @param {string} quoteId The id of the quote
         * @param {CreateQuote} createQuote
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsRfqIdQuotesQuoteIdPut: function (rfqId, quoteId, createQuote, xCompanyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingRfqsRfqIdQuotesQuoteIdPut(rfqId, quoteId, createQuote, xCompanyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.QuotingApiFp = QuotingApiFp;
/**
 * QuotingApi - factory interface
 * @export
 */
var QuotingApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.QuotingApiFp)(configuration);
    return {
        /**
         * An RFQ is a Request For Quote. All quotes will be created under an RFQ.
         * @summary Create a new RFQ, kicking off autoquoting if specified
         * @param {RFQ} rFQ
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsPost: function (rFQ, xCompanyId, options) {
            return localVarFp.quotingRfqsPost(rFQ, xCompanyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete an RFQ
         * @param {string} rfqId The id of the rfq
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {boolean} [includeFailures] If true, include failed Quotes in the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsRfqIdDelete: function (rfqId, xCompanyId, includeFailures, options) {
            return localVarFp.quotingRfqsRfqIdDelete(rfqId, xCompanyId, includeFailures, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about an RFQ
         * @param {string} rfqId The id of the rfq
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {boolean} [includeFailures] If true, include failed Quotes in the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsRfqIdGet: function (rfqId, xCompanyId, includeFailures, options) {
            return localVarFp.quotingRfqsRfqIdGet(rfqId, xCompanyId, includeFailures, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Note: Complexities of updating not implemented
         * @summary Update an RFQ
         * @param {string} rfqId The id of the rfq
         * @param {RFQ} rFQ
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {boolean} [includeFailures] If true, include failed Quotes in the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsRfqIdPut: function (rfqId, rFQ, xCompanyId, includeFailures, options) {
            return localVarFp.quotingRfqsRfqIdPut(rfqId, rFQ, xCompanyId, includeFailures, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a list of all quotes under an RFQ
         * @param {string} rfqId The id of the rfq
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {boolean} [includeFailures] If true, include failed Quotes in the result set
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsRfqIdQuotesGet: function (rfqId, xCompanyId, page, pageSize, ordering, includeFailures, options) {
            return localVarFp.quotingRfqsRfqIdQuotesGet(rfqId, xCompanyId, page, pageSize, ordering, includeFailures, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Note: Need to add more info about creating a quote here
         * @summary Create a new quote under an RFQ
         * @param {string} rfqId The id of the rfq
         * @param {CreateQuote} createQuote
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsRfqIdQuotesPost: function (rfqId, createQuote, xCompanyId, options) {
            return localVarFp.quotingRfqsRfqIdQuotesPost(rfqId, createQuote, xCompanyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a Quote
         * @param {string} rfqId The id of the rfq
         * @param {string} quoteId The id of the quote
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsRfqIdQuotesQuoteIdDelete: function (rfqId, quoteId, xCompanyId, options) {
            return localVarFp.quotingRfqsRfqIdQuotesQuoteIdDelete(rfqId, quoteId, xCompanyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about a quote
         * @param {string} rfqId The id of the rfq
         * @param {string} quoteId The id of the quote
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsRfqIdQuotesQuoteIdGet: function (rfqId, quoteId, xCompanyId, options) {
            return localVarFp.quotingRfqsRfqIdQuotesQuoteIdGet(rfqId, quoteId, xCompanyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Note: this route might be eliminated, so create new quotes when possible
         * @summary Update a quote
         * @param {string} rfqId The id of the rfq
         * @param {string} quoteId The id of the quote
         * @param {CreateQuote} createQuote
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRfqsRfqIdQuotesQuoteIdPut: function (rfqId, quoteId, createQuote, xCompanyId, options) {
            return localVarFp.quotingRfqsRfqIdQuotesQuoteIdPut(rfqId, quoteId, createQuote, xCompanyId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.QuotingApiFactory = QuotingApiFactory;
/**
 * QuotingApi - object-oriented interface
 * @export
 * @class QuotingApi
 * @extends {BaseAPI}
 */
var QuotingApi = /** @class */ (function (_super) {
    __extends(QuotingApi, _super);
    function QuotingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * An RFQ is a Request For Quote. All quotes will be created under an RFQ.
     * @summary Create a new RFQ, kicking off autoquoting if specified
     * @param {RFQ} rFQ
     * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotingApi
     */
    QuotingApi.prototype.quotingRfqsPost = function (rFQ, xCompanyId, options) {
        var _this = this;
        return (0, exports.QuotingApiFp)(this.configuration).quotingRfqsPost(rFQ, xCompanyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete an RFQ
     * @param {string} rfqId The id of the rfq
     * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
     * @param {boolean} [includeFailures] If true, include failed Quotes in the result set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotingApi
     */
    QuotingApi.prototype.quotingRfqsRfqIdDelete = function (rfqId, xCompanyId, includeFailures, options) {
        var _this = this;
        return (0, exports.QuotingApiFp)(this.configuration).quotingRfqsRfqIdDelete(rfqId, xCompanyId, includeFailures, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about an RFQ
     * @param {string} rfqId The id of the rfq
     * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
     * @param {boolean} [includeFailures] If true, include failed Quotes in the result set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotingApi
     */
    QuotingApi.prototype.quotingRfqsRfqIdGet = function (rfqId, xCompanyId, includeFailures, options) {
        var _this = this;
        return (0, exports.QuotingApiFp)(this.configuration).quotingRfqsRfqIdGet(rfqId, xCompanyId, includeFailures, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Note: Complexities of updating not implemented
     * @summary Update an RFQ
     * @param {string} rfqId The id of the rfq
     * @param {RFQ} rFQ
     * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
     * @param {boolean} [includeFailures] If true, include failed Quotes in the result set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotingApi
     */
    QuotingApi.prototype.quotingRfqsRfqIdPut = function (rfqId, rFQ, xCompanyId, includeFailures, options) {
        var _this = this;
        return (0, exports.QuotingApiFp)(this.configuration).quotingRfqsRfqIdPut(rfqId, rFQ, xCompanyId, includeFailures, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a list of all quotes under an RFQ
     * @param {string} rfqId The id of the rfq
     * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {boolean} [includeFailures] If true, include failed Quotes in the result set
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotingApi
     */
    QuotingApi.prototype.quotingRfqsRfqIdQuotesGet = function (rfqId, xCompanyId, page, pageSize, ordering, includeFailures, options) {
        var _this = this;
        return (0, exports.QuotingApiFp)(this.configuration).quotingRfqsRfqIdQuotesGet(rfqId, xCompanyId, page, pageSize, ordering, includeFailures, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Note: Need to add more info about creating a quote here
     * @summary Create a new quote under an RFQ
     * @param {string} rfqId The id of the rfq
     * @param {CreateQuote} createQuote
     * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotingApi
     */
    QuotingApi.prototype.quotingRfqsRfqIdQuotesPost = function (rfqId, createQuote, xCompanyId, options) {
        var _this = this;
        return (0, exports.QuotingApiFp)(this.configuration).quotingRfqsRfqIdQuotesPost(rfqId, createQuote, xCompanyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a Quote
     * @param {string} rfqId The id of the rfq
     * @param {string} quoteId The id of the quote
     * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotingApi
     */
    QuotingApi.prototype.quotingRfqsRfqIdQuotesQuoteIdDelete = function (rfqId, quoteId, xCompanyId, options) {
        var _this = this;
        return (0, exports.QuotingApiFp)(this.configuration).quotingRfqsRfqIdQuotesQuoteIdDelete(rfqId, quoteId, xCompanyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about a quote
     * @param {string} rfqId The id of the rfq
     * @param {string} quoteId The id of the quote
     * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotingApi
     */
    QuotingApi.prototype.quotingRfqsRfqIdQuotesQuoteIdGet = function (rfqId, quoteId, xCompanyId, options) {
        var _this = this;
        return (0, exports.QuotingApiFp)(this.configuration).quotingRfqsRfqIdQuotesQuoteIdGet(rfqId, quoteId, xCompanyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Note: this route might be eliminated, so create new quotes when possible
     * @summary Update a quote
     * @param {string} rfqId The id of the rfq
     * @param {string} quoteId The id of the quote
     * @param {CreateQuote} createQuote
     * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuotingApi
     */
    QuotingApi.prototype.quotingRfqsRfqIdQuotesQuoteIdPut = function (rfqId, quoteId, createQuote, xCompanyId, options) {
        var _this = this;
        return (0, exports.QuotingApiFp)(this.configuration).quotingRfqsRfqIdQuotesQuoteIdPut(rfqId, quoteId, createQuote, xCompanyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return QuotingApi;
}(base_1.BaseAPI));
exports.QuotingApi = QuotingApi;
/**
 * RateConfigurationApi - axios parameter creator
 * @export
 */
var RateConfigurationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get information about a P44 Account Identifications
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdRateConfigurationGet: function (carrierRelationshipId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdRateConfigurationGet', 'carrierRelationshipId', carrierRelationshipId);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/rate-configuration/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new contract
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {RateConfiguration} rateConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdRateConfigurationPost: function (carrierRelationshipId, rateConfiguration, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdRateConfigurationPost', 'carrierRelationshipId', carrierRelationshipId);
                            // verify required parameter 'rateConfiguration' is not null or undefined
                            (0, common_1.assertParamExists)('carrierRelationshipsCarrierRelationshipIdRateConfigurationPost', 'rateConfiguration', rateConfiguration);
                            localVarPath = "/carrier-relationships/{carrierRelationshipId}/rate-configuration/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rateConfiguration, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.RateConfigurationApiAxiosParamCreator = RateConfigurationApiAxiosParamCreator;
/**
 * RateConfigurationApi - functional programming interface
 * @export
 */
var RateConfigurationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.RateConfigurationApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get information about a P44 Account Identifications
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdRateConfigurationGet: function (carrierRelationshipId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdRateConfigurationGet(carrierRelationshipId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new contract
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {RateConfiguration} rateConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdRateConfigurationPost: function (carrierRelationshipId, rateConfiguration, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.carrierRelationshipsCarrierRelationshipIdRateConfigurationPost(carrierRelationshipId, rateConfiguration, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.RateConfigurationApiFp = RateConfigurationApiFp;
/**
 * RateConfigurationApi - factory interface
 * @export
 */
var RateConfigurationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.RateConfigurationApiFp)(configuration);
    return {
        /**
         *
         * @summary Get information about a P44 Account Identifications
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdRateConfigurationGet: function (carrierRelationshipId, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdRateConfigurationGet(carrierRelationshipId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new contract
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {RateConfiguration} rateConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierRelationshipsCarrierRelationshipIdRateConfigurationPost: function (carrierRelationshipId, rateConfiguration, options) {
            return localVarFp.carrierRelationshipsCarrierRelationshipIdRateConfigurationPost(carrierRelationshipId, rateConfiguration, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.RateConfigurationApiFactory = RateConfigurationApiFactory;
/**
 * RateConfigurationApi - object-oriented interface
 * @export
 * @class RateConfigurationApi
 * @extends {BaseAPI}
 */
var RateConfigurationApi = /** @class */ (function (_super) {
    __extends(RateConfigurationApi, _super);
    function RateConfigurationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get information about a P44 Account Identifications
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateConfigurationApi
     */
    RateConfigurationApi.prototype.carrierRelationshipsCarrierRelationshipIdRateConfigurationGet = function (carrierRelationshipId, options) {
        var _this = this;
        return (0, exports.RateConfigurationApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdRateConfigurationGet(carrierRelationshipId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new contract
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {RateConfiguration} rateConfiguration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateConfigurationApi
     */
    RateConfigurationApi.prototype.carrierRelationshipsCarrierRelationshipIdRateConfigurationPost = function (carrierRelationshipId, rateConfiguration, options) {
        var _this = this;
        return (0, exports.RateConfigurationApiFp)(this.configuration).carrierRelationshipsCarrierRelationshipIdRateConfigurationPost(carrierRelationshipId, rateConfiguration, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RateConfigurationApi;
}(base_1.BaseAPI));
exports.RateConfigurationApi = RateConfigurationApi;
/**
 * RateTablesApi - axios parameter creator
 * @export
 */
var RateTablesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Delete an AccessorialChargeTable
         * @param {string} accessorialChargeTableId The id of an accessorial charge table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesAccessorialChargeTablesAccessorialChargeTableIdDelete: function (accessorialChargeTableId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'accessorialChargeTableId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingRateTablesAccessorialChargeTablesAccessorialChargeTableIdDelete', 'accessorialChargeTableId', accessorialChargeTableId);
                            localVarPath = "/quoting/rate-tables/accessorial-charge-tables/{accessorialChargeTableId}/"
                                .replace("{".concat("accessorialChargeTableId", "}"), encodeURIComponent(String(accessorialChargeTableId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve an AccessorialChargeTable by ID
         * @param {string} accessorialChargeTableId The id of an accessorial charge table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesAccessorialChargeTablesAccessorialChargeTableIdGet: function (accessorialChargeTableId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'accessorialChargeTableId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingRateTablesAccessorialChargeTablesAccessorialChargeTableIdGet', 'accessorialChargeTableId', accessorialChargeTableId);
                            localVarPath = "/quoting/rate-tables/accessorial-charge-tables/{accessorialChargeTableId}/"
                                .replace("{".concat("accessorialChargeTableId", "}"), encodeURIComponent(String(accessorialChargeTableId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an AccessorialChargeTable
         * @param {string} accessorialChargeTableId The id of an accessorial charge table
         * @param {AccessorialChargeTable} accessorialChargeTable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesAccessorialChargeTablesAccessorialChargeTableIdPut: function (accessorialChargeTableId, accessorialChargeTable, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'accessorialChargeTableId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingRateTablesAccessorialChargeTablesAccessorialChargeTableIdPut', 'accessorialChargeTableId', accessorialChargeTableId);
                            // verify required parameter 'accessorialChargeTable' is not null or undefined
                            (0, common_1.assertParamExists)('quotingRateTablesAccessorialChargeTablesAccessorialChargeTableIdPut', 'accessorialChargeTable', accessorialChargeTable);
                            localVarPath = "/quoting/rate-tables/accessorial-charge-tables/{accessorialChargeTableId}/"
                                .replace("{".concat("accessorialChargeTableId", "}"), encodeURIComponent(String(accessorialChargeTableId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accessorialChargeTable, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List accessorial charge rate tables
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {Array<string>} [equipmentTypes] Return contracts with equipment types
         * @param {Array<string>} [modes] Return contracts with shipment mode codes
         * @param {Array<string>} [locationsContains] Return rate tables with this value in the locations
         * @param {Array<string>} [locationsStateProvinceContains] Return rate tables with this state province on its locations
         * @param {Array<string>} [carrierRelationshipsContains] Return rate tables with this carrier relationship ID in its carrier relationships
         * @param {Array<string>} [customersContains] Return rate tables with this customer company ID in its customers
         * @param {'ACTIVE' | 'INACTIVE'} [status] Include rate tables where status is equal to this value
         * @param {string} [endDateGte] Include rate tables where end date is greater than or equal to this date
         * @param {string} [endDateLte] Include rate tables where end date is less than or equal to this date
         * @param {string} [startDateGte] Include rate tables where start date is greater than or equal to this date
         * @param {string} [startDateLte] Include rate tables where start date is less than or equal to this date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesAccessorialChargeTablesGet: function (page, pageSize, ordering, q, equipmentTypes, modes, locationsContains, locationsStateProvinceContains, carrierRelationshipsContains, customersContains, status, endDateGte, endDateLte, startDateGte, startDateLte, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/quoting/rate-tables/accessorial-charge-tables/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (equipmentTypes) {
                                localVarQueryParameter['equipment_types'] = equipmentTypes;
                            }
                            if (modes) {
                                localVarQueryParameter['modes'] = modes;
                            }
                            if (locationsContains) {
                                localVarQueryParameter['locations__contains'] = locationsContains;
                            }
                            if (locationsStateProvinceContains) {
                                localVarQueryParameter['locations_state_province__contains'] = locationsStateProvinceContains;
                            }
                            if (carrierRelationshipsContains) {
                                localVarQueryParameter['carrier_relationships__contains'] = carrierRelationshipsContains;
                            }
                            if (customersContains) {
                                localVarQueryParameter['customers__contains'] = customersContains;
                            }
                            if (status !== undefined) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (endDateGte !== undefined) {
                                localVarQueryParameter['end_date__gte'] = (endDateGte instanceof Date) ?
                                    endDateGte.toISOString().substr(0, 10) :
                                    endDateGte;
                            }
                            if (endDateLte !== undefined) {
                                localVarQueryParameter['end_date__lte'] = (endDateLte instanceof Date) ?
                                    endDateLte.toISOString().substr(0, 10) :
                                    endDateLte;
                            }
                            if (startDateGte !== undefined) {
                                localVarQueryParameter['start_date__gte'] = (startDateGte instanceof Date) ?
                                    startDateGte.toISOString().substr(0, 10) :
                                    startDateGte;
                            }
                            if (startDateLte !== undefined) {
                                localVarQueryParameter['start_date__lte'] = (startDateLte instanceof Date) ?
                                    startDateLte.toISOString().substr(0, 10) :
                                    startDateLte;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create an AccessorialChargeTable
         * @param {AccessorialChargeTable} accessorialChargeTable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesAccessorialChargeTablesPost: function (accessorialChargeTable, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'accessorialChargeTable' is not null or undefined
                            (0, common_1.assertParamExists)('quotingRateTablesAccessorialChargeTablesPost', 'accessorialChargeTable', accessorialChargeTable);
                            localVarPath = "/quoting/rate-tables/accessorial-charge-tables/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accessorialChargeTable, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a FuelSurchargeTable
         * @param {string} fuelSurchargeTableId The id of a fuel surcharge table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesFuelSurchargeTablesFuelSurchargeTableIdDelete: function (fuelSurchargeTableId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'fuelSurchargeTableId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingRateTablesFuelSurchargeTablesFuelSurchargeTableIdDelete', 'fuelSurchargeTableId', fuelSurchargeTableId);
                            localVarPath = "/quoting/rate-tables/fuel-surcharge-tables/{fuelSurchargeTableId}/"
                                .replace("{".concat("fuelSurchargeTableId", "}"), encodeURIComponent(String(fuelSurchargeTableId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a FuelSurchargeTable by ID
         * @param {string} fuelSurchargeTableId The id of a fuel surcharge table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesFuelSurchargeTablesFuelSurchargeTableIdGet: function (fuelSurchargeTableId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'fuelSurchargeTableId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingRateTablesFuelSurchargeTablesFuelSurchargeTableIdGet', 'fuelSurchargeTableId', fuelSurchargeTableId);
                            localVarPath = "/quoting/rate-tables/fuel-surcharge-tables/{fuelSurchargeTableId}/"
                                .replace("{".concat("fuelSurchargeTableId", "}"), encodeURIComponent(String(fuelSurchargeTableId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a FuelSurchargeTable
         * @param {string} fuelSurchargeTableId The id of a fuel surcharge table
         * @param {FuelSurchargeTable} fuelSurchargeTable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesFuelSurchargeTablesFuelSurchargeTableIdPut: function (fuelSurchargeTableId, fuelSurchargeTable, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'fuelSurchargeTableId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingRateTablesFuelSurchargeTablesFuelSurchargeTableIdPut', 'fuelSurchargeTableId', fuelSurchargeTableId);
                            // verify required parameter 'fuelSurchargeTable' is not null or undefined
                            (0, common_1.assertParamExists)('quotingRateTablesFuelSurchargeTablesFuelSurchargeTableIdPut', 'fuelSurchargeTable', fuelSurchargeTable);
                            localVarPath = "/quoting/rate-tables/fuel-surcharge-tables/{fuelSurchargeTableId}/"
                                .replace("{".concat("fuelSurchargeTableId", "}"), encodeURIComponent(String(fuelSurchargeTableId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(fuelSurchargeTable, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List fuel surcharge rate tables
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {Array<string>} [equipmentTypes] Return contracts with equipment types
         * @param {Array<string>} [modes] Return contracts with shipment mode codes
         * @param {Array<string>} [locationsContains] Return rate tables with this value in the locations
         * @param {Array<string>} [locationsStateProvinceContains] Return rate tables with this state province on its locations
         * @param {Array<string>} [carrierRelationshipsContains] Return rate tables with this carrier relationship ID in its carrier relationships
         * @param {Array<string>} [customersContains] Return rate tables with this customer company ID in its customers
         * @param {'ACTIVE' | 'INACTIVE'} [status] Include rate tables where status is equal to this value
         * @param {string} [endDateGte] Include rate tables where end date is greater than or equal to this date
         * @param {string} [endDateLte] Include rate tables where end date is less than or equal to this date
         * @param {string} [startDateGte] Include rate tables where start date is greater than or equal to this date
         * @param {string} [startDateLte] Include rate tables where start date is less than or equal to this date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesFuelSurchargeTablesGet: function (page, pageSize, ordering, q, equipmentTypes, modes, locationsContains, locationsStateProvinceContains, carrierRelationshipsContains, customersContains, status, endDateGte, endDateLte, startDateGte, startDateLte, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/quoting/rate-tables/fuel-surcharge-tables/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (equipmentTypes) {
                                localVarQueryParameter['equipment_types'] = equipmentTypes;
                            }
                            if (modes) {
                                localVarQueryParameter['modes'] = modes;
                            }
                            if (locationsContains) {
                                localVarQueryParameter['locations__contains'] = locationsContains;
                            }
                            if (locationsStateProvinceContains) {
                                localVarQueryParameter['locations_state_province__contains'] = locationsStateProvinceContains;
                            }
                            if (carrierRelationshipsContains) {
                                localVarQueryParameter['carrier_relationships__contains'] = carrierRelationshipsContains;
                            }
                            if (customersContains) {
                                localVarQueryParameter['customers__contains'] = customersContains;
                            }
                            if (status !== undefined) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (endDateGte !== undefined) {
                                localVarQueryParameter['end_date__gte'] = (endDateGte instanceof Date) ?
                                    endDateGte.toISOString().substr(0, 10) :
                                    endDateGte;
                            }
                            if (endDateLte !== undefined) {
                                localVarQueryParameter['end_date__lte'] = (endDateLte instanceof Date) ?
                                    endDateLte.toISOString().substr(0, 10) :
                                    endDateLte;
                            }
                            if (startDateGte !== undefined) {
                                localVarQueryParameter['start_date__gte'] = (startDateGte instanceof Date) ?
                                    startDateGte.toISOString().substr(0, 10) :
                                    startDateGte;
                            }
                            if (startDateLte !== undefined) {
                                localVarQueryParameter['start_date__lte'] = (startDateLte instanceof Date) ?
                                    startDateLte.toISOString().substr(0, 10) :
                                    startDateLte;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a FuelSurchargeTable
         * @param {FuelSurchargeTable} fuelSurchargeTable
         * @param {boolean} [autoCalculateRows] If true, use the fuel surcharge parameters to compute calculation rows in the backend. If false, then it is expected that calculation rows is included in the post payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesFuelSurchargeTablesPost: function (fuelSurchargeTable, autoCalculateRows, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'fuelSurchargeTable' is not null or undefined
                            (0, common_1.assertParamExists)('quotingRateTablesFuelSurchargeTablesPost', 'fuelSurchargeTable', fuelSurchargeTable);
                            localVarPath = "/quoting/rate-tables/fuel-surcharge-tables/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (autoCalculateRows !== undefined) {
                                localVarQueryParameter['auto_calculate_rows'] = autoCalculateRows;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(fuelSurchargeTable, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.RateTablesApiAxiosParamCreator = RateTablesApiAxiosParamCreator;
/**
 * RateTablesApi - functional programming interface
 * @export
 */
var RateTablesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.RateTablesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Delete an AccessorialChargeTable
         * @param {string} accessorialChargeTableId The id of an accessorial charge table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesAccessorialChargeTablesAccessorialChargeTableIdDelete: function (accessorialChargeTableId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingRateTablesAccessorialChargeTablesAccessorialChargeTableIdDelete(accessorialChargeTableId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve an AccessorialChargeTable by ID
         * @param {string} accessorialChargeTableId The id of an accessorial charge table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesAccessorialChargeTablesAccessorialChargeTableIdGet: function (accessorialChargeTableId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingRateTablesAccessorialChargeTablesAccessorialChargeTableIdGet(accessorialChargeTableId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an AccessorialChargeTable
         * @param {string} accessorialChargeTableId The id of an accessorial charge table
         * @param {AccessorialChargeTable} accessorialChargeTable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesAccessorialChargeTablesAccessorialChargeTableIdPut: function (accessorialChargeTableId, accessorialChargeTable, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingRateTablesAccessorialChargeTablesAccessorialChargeTableIdPut(accessorialChargeTableId, accessorialChargeTable, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List accessorial charge rate tables
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {Array<string>} [equipmentTypes] Return contracts with equipment types
         * @param {Array<string>} [modes] Return contracts with shipment mode codes
         * @param {Array<string>} [locationsContains] Return rate tables with this value in the locations
         * @param {Array<string>} [locationsStateProvinceContains] Return rate tables with this state province on its locations
         * @param {Array<string>} [carrierRelationshipsContains] Return rate tables with this carrier relationship ID in its carrier relationships
         * @param {Array<string>} [customersContains] Return rate tables with this customer company ID in its customers
         * @param {'ACTIVE' | 'INACTIVE'} [status] Include rate tables where status is equal to this value
         * @param {string} [endDateGte] Include rate tables where end date is greater than or equal to this date
         * @param {string} [endDateLte] Include rate tables where end date is less than or equal to this date
         * @param {string} [startDateGte] Include rate tables where start date is greater than or equal to this date
         * @param {string} [startDateLte] Include rate tables where start date is less than or equal to this date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesAccessorialChargeTablesGet: function (page, pageSize, ordering, q, equipmentTypes, modes, locationsContains, locationsStateProvinceContains, carrierRelationshipsContains, customersContains, status, endDateGte, endDateLte, startDateGte, startDateLte, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingRateTablesAccessorialChargeTablesGet(page, pageSize, ordering, q, equipmentTypes, modes, locationsContains, locationsStateProvinceContains, carrierRelationshipsContains, customersContains, status, endDateGte, endDateLte, startDateGte, startDateLte, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create an AccessorialChargeTable
         * @param {AccessorialChargeTable} accessorialChargeTable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesAccessorialChargeTablesPost: function (accessorialChargeTable, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingRateTablesAccessorialChargeTablesPost(accessorialChargeTable, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a FuelSurchargeTable
         * @param {string} fuelSurchargeTableId The id of a fuel surcharge table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesFuelSurchargeTablesFuelSurchargeTableIdDelete: function (fuelSurchargeTableId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingRateTablesFuelSurchargeTablesFuelSurchargeTableIdDelete(fuelSurchargeTableId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a FuelSurchargeTable by ID
         * @param {string} fuelSurchargeTableId The id of a fuel surcharge table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesFuelSurchargeTablesFuelSurchargeTableIdGet: function (fuelSurchargeTableId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingRateTablesFuelSurchargeTablesFuelSurchargeTableIdGet(fuelSurchargeTableId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a FuelSurchargeTable
         * @param {string} fuelSurchargeTableId The id of a fuel surcharge table
         * @param {FuelSurchargeTable} fuelSurchargeTable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesFuelSurchargeTablesFuelSurchargeTableIdPut: function (fuelSurchargeTableId, fuelSurchargeTable, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingRateTablesFuelSurchargeTablesFuelSurchargeTableIdPut(fuelSurchargeTableId, fuelSurchargeTable, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List fuel surcharge rate tables
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {Array<string>} [equipmentTypes] Return contracts with equipment types
         * @param {Array<string>} [modes] Return contracts with shipment mode codes
         * @param {Array<string>} [locationsContains] Return rate tables with this value in the locations
         * @param {Array<string>} [locationsStateProvinceContains] Return rate tables with this state province on its locations
         * @param {Array<string>} [carrierRelationshipsContains] Return rate tables with this carrier relationship ID in its carrier relationships
         * @param {Array<string>} [customersContains] Return rate tables with this customer company ID in its customers
         * @param {'ACTIVE' | 'INACTIVE'} [status] Include rate tables where status is equal to this value
         * @param {string} [endDateGte] Include rate tables where end date is greater than or equal to this date
         * @param {string} [endDateLte] Include rate tables where end date is less than or equal to this date
         * @param {string} [startDateGte] Include rate tables where start date is greater than or equal to this date
         * @param {string} [startDateLte] Include rate tables where start date is less than or equal to this date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesFuelSurchargeTablesGet: function (page, pageSize, ordering, q, equipmentTypes, modes, locationsContains, locationsStateProvinceContains, carrierRelationshipsContains, customersContains, status, endDateGte, endDateLte, startDateGte, startDateLte, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingRateTablesFuelSurchargeTablesGet(page, pageSize, ordering, q, equipmentTypes, modes, locationsContains, locationsStateProvinceContains, carrierRelationshipsContains, customersContains, status, endDateGte, endDateLte, startDateGte, startDateLte, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a FuelSurchargeTable
         * @param {FuelSurchargeTable} fuelSurchargeTable
         * @param {boolean} [autoCalculateRows] If true, use the fuel surcharge parameters to compute calculation rows in the backend. If false, then it is expected that calculation rows is included in the post payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesFuelSurchargeTablesPost: function (fuelSurchargeTable, autoCalculateRows, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingRateTablesFuelSurchargeTablesPost(fuelSurchargeTable, autoCalculateRows, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.RateTablesApiFp = RateTablesApiFp;
/**
 * RateTablesApi - factory interface
 * @export
 */
var RateTablesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.RateTablesApiFp)(configuration);
    return {
        /**
         *
         * @summary Delete an AccessorialChargeTable
         * @param {string} accessorialChargeTableId The id of an accessorial charge table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesAccessorialChargeTablesAccessorialChargeTableIdDelete: function (accessorialChargeTableId, options) {
            return localVarFp.quotingRateTablesAccessorialChargeTablesAccessorialChargeTableIdDelete(accessorialChargeTableId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve an AccessorialChargeTable by ID
         * @param {string} accessorialChargeTableId The id of an accessorial charge table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesAccessorialChargeTablesAccessorialChargeTableIdGet: function (accessorialChargeTableId, options) {
            return localVarFp.quotingRateTablesAccessorialChargeTablesAccessorialChargeTableIdGet(accessorialChargeTableId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update an AccessorialChargeTable
         * @param {string} accessorialChargeTableId The id of an accessorial charge table
         * @param {AccessorialChargeTable} accessorialChargeTable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesAccessorialChargeTablesAccessorialChargeTableIdPut: function (accessorialChargeTableId, accessorialChargeTable, options) {
            return localVarFp.quotingRateTablesAccessorialChargeTablesAccessorialChargeTableIdPut(accessorialChargeTableId, accessorialChargeTable, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List accessorial charge rate tables
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {Array<string>} [equipmentTypes] Return contracts with equipment types
         * @param {Array<string>} [modes] Return contracts with shipment mode codes
         * @param {Array<string>} [locationsContains] Return rate tables with this value in the locations
         * @param {Array<string>} [locationsStateProvinceContains] Return rate tables with this state province on its locations
         * @param {Array<string>} [carrierRelationshipsContains] Return rate tables with this carrier relationship ID in its carrier relationships
         * @param {Array<string>} [customersContains] Return rate tables with this customer company ID in its customers
         * @param {'ACTIVE' | 'INACTIVE'} [status] Include rate tables where status is equal to this value
         * @param {string} [endDateGte] Include rate tables where end date is greater than or equal to this date
         * @param {string} [endDateLte] Include rate tables where end date is less than or equal to this date
         * @param {string} [startDateGte] Include rate tables where start date is greater than or equal to this date
         * @param {string} [startDateLte] Include rate tables where start date is less than or equal to this date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesAccessorialChargeTablesGet: function (page, pageSize, ordering, q, equipmentTypes, modes, locationsContains, locationsStateProvinceContains, carrierRelationshipsContains, customersContains, status, endDateGte, endDateLte, startDateGte, startDateLte, options) {
            return localVarFp.quotingRateTablesAccessorialChargeTablesGet(page, pageSize, ordering, q, equipmentTypes, modes, locationsContains, locationsStateProvinceContains, carrierRelationshipsContains, customersContains, status, endDateGte, endDateLte, startDateGte, startDateLte, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create an AccessorialChargeTable
         * @param {AccessorialChargeTable} accessorialChargeTable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesAccessorialChargeTablesPost: function (accessorialChargeTable, options) {
            return localVarFp.quotingRateTablesAccessorialChargeTablesPost(accessorialChargeTable, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a FuelSurchargeTable
         * @param {string} fuelSurchargeTableId The id of a fuel surcharge table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesFuelSurchargeTablesFuelSurchargeTableIdDelete: function (fuelSurchargeTableId, options) {
            return localVarFp.quotingRateTablesFuelSurchargeTablesFuelSurchargeTableIdDelete(fuelSurchargeTableId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a FuelSurchargeTable by ID
         * @param {string} fuelSurchargeTableId The id of a fuel surcharge table
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesFuelSurchargeTablesFuelSurchargeTableIdGet: function (fuelSurchargeTableId, options) {
            return localVarFp.quotingRateTablesFuelSurchargeTablesFuelSurchargeTableIdGet(fuelSurchargeTableId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a FuelSurchargeTable
         * @param {string} fuelSurchargeTableId The id of a fuel surcharge table
         * @param {FuelSurchargeTable} fuelSurchargeTable
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesFuelSurchargeTablesFuelSurchargeTableIdPut: function (fuelSurchargeTableId, fuelSurchargeTable, options) {
            return localVarFp.quotingRateTablesFuelSurchargeTablesFuelSurchargeTableIdPut(fuelSurchargeTableId, fuelSurchargeTable, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List fuel surcharge rate tables
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {Array<string>} [equipmentTypes] Return contracts with equipment types
         * @param {Array<string>} [modes] Return contracts with shipment mode codes
         * @param {Array<string>} [locationsContains] Return rate tables with this value in the locations
         * @param {Array<string>} [locationsStateProvinceContains] Return rate tables with this state province on its locations
         * @param {Array<string>} [carrierRelationshipsContains] Return rate tables with this carrier relationship ID in its carrier relationships
         * @param {Array<string>} [customersContains] Return rate tables with this customer company ID in its customers
         * @param {'ACTIVE' | 'INACTIVE'} [status] Include rate tables where status is equal to this value
         * @param {string} [endDateGte] Include rate tables where end date is greater than or equal to this date
         * @param {string} [endDateLte] Include rate tables where end date is less than or equal to this date
         * @param {string} [startDateGte] Include rate tables where start date is greater than or equal to this date
         * @param {string} [startDateLte] Include rate tables where start date is less than or equal to this date
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesFuelSurchargeTablesGet: function (page, pageSize, ordering, q, equipmentTypes, modes, locationsContains, locationsStateProvinceContains, carrierRelationshipsContains, customersContains, status, endDateGte, endDateLte, startDateGte, startDateLte, options) {
            return localVarFp.quotingRateTablesFuelSurchargeTablesGet(page, pageSize, ordering, q, equipmentTypes, modes, locationsContains, locationsStateProvinceContains, carrierRelationshipsContains, customersContains, status, endDateGte, endDateLte, startDateGte, startDateLte, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a FuelSurchargeTable
         * @param {FuelSurchargeTable} fuelSurchargeTable
         * @param {boolean} [autoCalculateRows] If true, use the fuel surcharge parameters to compute calculation rows in the backend. If false, then it is expected that calculation rows is included in the post payload
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingRateTablesFuelSurchargeTablesPost: function (fuelSurchargeTable, autoCalculateRows, options) {
            return localVarFp.quotingRateTablesFuelSurchargeTablesPost(fuelSurchargeTable, autoCalculateRows, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.RateTablesApiFactory = RateTablesApiFactory;
/**
 * RateTablesApi - object-oriented interface
 * @export
 * @class RateTablesApi
 * @extends {BaseAPI}
 */
var RateTablesApi = /** @class */ (function (_super) {
    __extends(RateTablesApi, _super);
    function RateTablesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Delete an AccessorialChargeTable
     * @param {string} accessorialChargeTableId The id of an accessorial charge table
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTablesApi
     */
    RateTablesApi.prototype.quotingRateTablesAccessorialChargeTablesAccessorialChargeTableIdDelete = function (accessorialChargeTableId, options) {
        var _this = this;
        return (0, exports.RateTablesApiFp)(this.configuration).quotingRateTablesAccessorialChargeTablesAccessorialChargeTableIdDelete(accessorialChargeTableId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve an AccessorialChargeTable by ID
     * @param {string} accessorialChargeTableId The id of an accessorial charge table
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTablesApi
     */
    RateTablesApi.prototype.quotingRateTablesAccessorialChargeTablesAccessorialChargeTableIdGet = function (accessorialChargeTableId, options) {
        var _this = this;
        return (0, exports.RateTablesApiFp)(this.configuration).quotingRateTablesAccessorialChargeTablesAccessorialChargeTableIdGet(accessorialChargeTableId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update an AccessorialChargeTable
     * @param {string} accessorialChargeTableId The id of an accessorial charge table
     * @param {AccessorialChargeTable} accessorialChargeTable
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTablesApi
     */
    RateTablesApi.prototype.quotingRateTablesAccessorialChargeTablesAccessorialChargeTableIdPut = function (accessorialChargeTableId, accessorialChargeTable, options) {
        var _this = this;
        return (0, exports.RateTablesApiFp)(this.configuration).quotingRateTablesAccessorialChargeTablesAccessorialChargeTableIdPut(accessorialChargeTableId, accessorialChargeTable, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List accessorial charge rate tables
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {Array<string>} [equipmentTypes] Return contracts with equipment types
     * @param {Array<string>} [modes] Return contracts with shipment mode codes
     * @param {Array<string>} [locationsContains] Return rate tables with this value in the locations
     * @param {Array<string>} [locationsStateProvinceContains] Return rate tables with this state province on its locations
     * @param {Array<string>} [carrierRelationshipsContains] Return rate tables with this carrier relationship ID in its carrier relationships
     * @param {Array<string>} [customersContains] Return rate tables with this customer company ID in its customers
     * @param {'ACTIVE' | 'INACTIVE'} [status] Include rate tables where status is equal to this value
     * @param {string} [endDateGte] Include rate tables where end date is greater than or equal to this date
     * @param {string} [endDateLte] Include rate tables where end date is less than or equal to this date
     * @param {string} [startDateGte] Include rate tables where start date is greater than or equal to this date
     * @param {string} [startDateLte] Include rate tables where start date is less than or equal to this date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTablesApi
     */
    RateTablesApi.prototype.quotingRateTablesAccessorialChargeTablesGet = function (page, pageSize, ordering, q, equipmentTypes, modes, locationsContains, locationsStateProvinceContains, carrierRelationshipsContains, customersContains, status, endDateGte, endDateLte, startDateGte, startDateLte, options) {
        var _this = this;
        return (0, exports.RateTablesApiFp)(this.configuration).quotingRateTablesAccessorialChargeTablesGet(page, pageSize, ordering, q, equipmentTypes, modes, locationsContains, locationsStateProvinceContains, carrierRelationshipsContains, customersContains, status, endDateGte, endDateLte, startDateGte, startDateLte, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create an AccessorialChargeTable
     * @param {AccessorialChargeTable} accessorialChargeTable
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTablesApi
     */
    RateTablesApi.prototype.quotingRateTablesAccessorialChargeTablesPost = function (accessorialChargeTable, options) {
        var _this = this;
        return (0, exports.RateTablesApiFp)(this.configuration).quotingRateTablesAccessorialChargeTablesPost(accessorialChargeTable, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a FuelSurchargeTable
     * @param {string} fuelSurchargeTableId The id of a fuel surcharge table
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTablesApi
     */
    RateTablesApi.prototype.quotingRateTablesFuelSurchargeTablesFuelSurchargeTableIdDelete = function (fuelSurchargeTableId, options) {
        var _this = this;
        return (0, exports.RateTablesApiFp)(this.configuration).quotingRateTablesFuelSurchargeTablesFuelSurchargeTableIdDelete(fuelSurchargeTableId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a FuelSurchargeTable by ID
     * @param {string} fuelSurchargeTableId The id of a fuel surcharge table
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTablesApi
     */
    RateTablesApi.prototype.quotingRateTablesFuelSurchargeTablesFuelSurchargeTableIdGet = function (fuelSurchargeTableId, options) {
        var _this = this;
        return (0, exports.RateTablesApiFp)(this.configuration).quotingRateTablesFuelSurchargeTablesFuelSurchargeTableIdGet(fuelSurchargeTableId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a FuelSurchargeTable
     * @param {string} fuelSurchargeTableId The id of a fuel surcharge table
     * @param {FuelSurchargeTable} fuelSurchargeTable
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTablesApi
     */
    RateTablesApi.prototype.quotingRateTablesFuelSurchargeTablesFuelSurchargeTableIdPut = function (fuelSurchargeTableId, fuelSurchargeTable, options) {
        var _this = this;
        return (0, exports.RateTablesApiFp)(this.configuration).quotingRateTablesFuelSurchargeTablesFuelSurchargeTableIdPut(fuelSurchargeTableId, fuelSurchargeTable, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List fuel surcharge rate tables
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {Array<string>} [equipmentTypes] Return contracts with equipment types
     * @param {Array<string>} [modes] Return contracts with shipment mode codes
     * @param {Array<string>} [locationsContains] Return rate tables with this value in the locations
     * @param {Array<string>} [locationsStateProvinceContains] Return rate tables with this state province on its locations
     * @param {Array<string>} [carrierRelationshipsContains] Return rate tables with this carrier relationship ID in its carrier relationships
     * @param {Array<string>} [customersContains] Return rate tables with this customer company ID in its customers
     * @param {'ACTIVE' | 'INACTIVE'} [status] Include rate tables where status is equal to this value
     * @param {string} [endDateGte] Include rate tables where end date is greater than or equal to this date
     * @param {string} [endDateLte] Include rate tables where end date is less than or equal to this date
     * @param {string} [startDateGte] Include rate tables where start date is greater than or equal to this date
     * @param {string} [startDateLte] Include rate tables where start date is less than or equal to this date
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTablesApi
     */
    RateTablesApi.prototype.quotingRateTablesFuelSurchargeTablesGet = function (page, pageSize, ordering, q, equipmentTypes, modes, locationsContains, locationsStateProvinceContains, carrierRelationshipsContains, customersContains, status, endDateGte, endDateLte, startDateGte, startDateLte, options) {
        var _this = this;
        return (0, exports.RateTablesApiFp)(this.configuration).quotingRateTablesFuelSurchargeTablesGet(page, pageSize, ordering, q, equipmentTypes, modes, locationsContains, locationsStateProvinceContains, carrierRelationshipsContains, customersContains, status, endDateGte, endDateLte, startDateGte, startDateLte, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a FuelSurchargeTable
     * @param {FuelSurchargeTable} fuelSurchargeTable
     * @param {boolean} [autoCalculateRows] If true, use the fuel surcharge parameters to compute calculation rows in the backend. If false, then it is expected that calculation rows is included in the post payload
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RateTablesApi
     */
    RateTablesApi.prototype.quotingRateTablesFuelSurchargeTablesPost = function (fuelSurchargeTable, autoCalculateRows, options) {
        var _this = this;
        return (0, exports.RateTablesApiFp)(this.configuration).quotingRateTablesFuelSurchargeTablesPost(fuelSurchargeTable, autoCalculateRows, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RateTablesApi;
}(base_1.BaseAPI));
exports.RateTablesApi = RateTablesApi;
/**
 * ReferenceDataApi - axios parameter creator
 * @export
 */
var ReferenceDataApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary List all charge codes
         * @param {string} [category] Category of the charge code.
         * @param {string} [code] Code of the charge code.
         * @param {string} [id] Id of the charge code.
         * @param {number} [limit] Number of results to return per page.
         * @param {string} [name] Name of the charge code.
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [q] Query across the &#x60;id&#x60; (machine readable identifier), &#x60;code&#x60;, &#x60;name&#x60;, and &#x60;category&#x60; of the charge codes to find matching charge codes that contain the query text or value. The search/query is case insensitive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChargeCodes: function (category, code, id, limit, name, page, q, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/reference-data/charge-codes/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (category !== undefined) {
                                localVarQueryParameter['category'] = category;
                            }
                            if (code !== undefined) {
                                localVarQueryParameter['code'] = code;
                            }
                            if (id !== undefined) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (name !== undefined) {
                                localVarQueryParameter['name'] = name;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all `PurchaseOrder.overall_status` values that could be returned by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersOverallStatusesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/purchase-orders/overall-statuses/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List all UPS custom package types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingUpsPackageTypesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/quoting/ups/package-types/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List all USPS custom package types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingUspsPackageTypesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/quoting/usps/package-types/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all shipment accessorials supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsAccessorialsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/shipments/accessorials/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary A list of all appointment types supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsAppointmentTypesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipments/appointment-types/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all charge line item categories supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsChargeLineItemCategoriesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipments/charge-line-item-categories/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns CSV with requested shipments info, in the same ordering as requested
         * @param {InlineObject21} inlineObject21
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsDownloadCsvPost: function (inlineObject21, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'inlineObject21' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsDownloadCsvPost', 'inlineObject21', inlineObject21);
                            localVarPath = "/shipments/download-csv/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject21, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all Equipment Types supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsEquipmentTypesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipments/equipment-types/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all hazmat supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsHazmatGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipments/hazmat/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all NMFCs supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsNmfcGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipments/nmfc/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all package types supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsPackageTypesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/shipments/package-types/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary A list of all piece types supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsPieceTypesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/shipments/piece-types/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary A list of all service levels supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsServiceLevelsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipments/service-levels/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all shipment modes supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentModesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipments/shipment-modes/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all shipment rep roles supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentRepRolesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipments/shipment-rep-roles/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all shipment states supported by the API
         * @param {boolean} [excludeStopAutomatedStatuses] If true, exclude statuses that can be automated based on stop status transitions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsStatusesGet: function (excludeStopAutomatedStatuses, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipments/statuses/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (excludeStopAutomatedStatuses !== undefined) {
                                localVarQueryParameter['exclude_stop_automated_statuses'] = excludeStopAutomatedStatuses;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List of all stop status reason codes supported by the API along with their categorial groupings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsStopStatusReasonCodesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipments/stop-status-reason-codes/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all point of contact roles/job_titles supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendorsVendorPocRolesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/vendors/vendor-poc-roles/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ReferenceDataApiAxiosParamCreator = ReferenceDataApiAxiosParamCreator;
/**
 * ReferenceDataApi - functional programming interface
 * @export
 */
var ReferenceDataApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ReferenceDataApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary List all charge codes
         * @param {string} [category] Category of the charge code.
         * @param {string} [code] Code of the charge code.
         * @param {string} [id] Id of the charge code.
         * @param {number} [limit] Number of results to return per page.
         * @param {string} [name] Name of the charge code.
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [q] Query across the &#x60;id&#x60; (machine readable identifier), &#x60;code&#x60;, &#x60;name&#x60;, and &#x60;category&#x60; of the charge codes to find matching charge codes that contain the query text or value. The search/query is case insensitive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChargeCodes: function (category, code, id, limit, name, page, q, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listChargeCodes(category, code, id, limit, name, page, q, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all `PurchaseOrder.overall_status` values that could be returned by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersOverallStatusesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.purchaseOrdersOverallStatusesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List all UPS custom package types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingUpsPackageTypesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingUpsPackageTypesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List all USPS custom package types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingUspsPackageTypesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingUspsPackageTypesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all shipment accessorials supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsAccessorialsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsAccessorialsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all appointment types supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsAppointmentTypesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsAppointmentTypesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all charge line item categories supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsChargeLineItemCategoriesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsChargeLineItemCategoriesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns CSV with requested shipments info, in the same ordering as requested
         * @param {InlineObject21} inlineObject21
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsDownloadCsvPost: function (inlineObject21, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsDownloadCsvPost(inlineObject21, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all Equipment Types supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsEquipmentTypesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsEquipmentTypesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all hazmat supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsHazmatGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsHazmatGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all NMFCs supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsNmfcGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsNmfcGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all package types supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsPackageTypesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsPackageTypesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all piece types supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsPieceTypesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsPieceTypesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all service levels supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsServiceLevelsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsServiceLevelsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all shipment modes supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentModesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentModesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all shipment rep roles supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentRepRolesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentRepRolesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all shipment states supported by the API
         * @param {boolean} [excludeStopAutomatedStatuses] If true, exclude statuses that can be automated based on stop status transitions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsStatusesGet: function (excludeStopAutomatedStatuses, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsStatusesGet(excludeStopAutomatedStatuses, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List of all stop status reason codes supported by the API along with their categorial groupings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsStopStatusReasonCodesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsStopStatusReasonCodesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary A list of all point of contact roles/job_titles supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendorsVendorPocRolesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.vendorsVendorPocRolesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ReferenceDataApiFp = ReferenceDataApiFp;
/**
 * ReferenceDataApi - factory interface
 * @export
 */
var ReferenceDataApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ReferenceDataApiFp)(configuration);
    return {
        /**
         *
         * @summary List all charge codes
         * @param {string} [category] Category of the charge code.
         * @param {string} [code] Code of the charge code.
         * @param {string} [id] Id of the charge code.
         * @param {number} [limit] Number of results to return per page.
         * @param {string} [name] Name of the charge code.
         * @param {number} [page] A page number within the paginated result set.
         * @param {string} [q] Query across the &#x60;id&#x60; (machine readable identifier), &#x60;code&#x60;, &#x60;name&#x60;, and &#x60;category&#x60; of the charge codes to find matching charge codes that contain the query text or value. The search/query is case insensitive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChargeCodes: function (category, code, id, limit, name, page, q, options) {
            return localVarFp.listChargeCodes(category, code, id, limit, name, page, q, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary A list of all `PurchaseOrder.overall_status` values that could be returned by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        purchaseOrdersOverallStatusesGet: function (options) {
            return localVarFp.purchaseOrdersOverallStatusesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List all UPS custom package types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingUpsPackageTypesGet: function (options) {
            return localVarFp.quotingUpsPackageTypesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List all USPS custom package types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingUspsPackageTypesGet: function (options) {
            return localVarFp.quotingUspsPackageTypesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary A list of all shipment accessorials supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsAccessorialsGet: function (options) {
            return localVarFp.shipmentsAccessorialsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary A list of all appointment types supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsAppointmentTypesGet: function (options) {
            return localVarFp.shipmentsAppointmentTypesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary A list of all charge line item categories supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsChargeLineItemCategoriesGet: function (options) {
            return localVarFp.shipmentsChargeLineItemCategoriesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns CSV with requested shipments info, in the same ordering as requested
         * @param {InlineObject21} inlineObject21
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsDownloadCsvPost: function (inlineObject21, options) {
            return localVarFp.shipmentsDownloadCsvPost(inlineObject21, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary A list of all Equipment Types supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsEquipmentTypesGet: function (options) {
            return localVarFp.shipmentsEquipmentTypesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary A list of all hazmat supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsHazmatGet: function (options) {
            return localVarFp.shipmentsHazmatGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary A list of all NMFCs supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsNmfcGet: function (options) {
            return localVarFp.shipmentsNmfcGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary A list of all package types supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsPackageTypesGet: function (options) {
            return localVarFp.shipmentsPackageTypesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary A list of all piece types supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsPieceTypesGet: function (options) {
            return localVarFp.shipmentsPieceTypesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary A list of all service levels supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsServiceLevelsGet: function (options) {
            return localVarFp.shipmentsServiceLevelsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary A list of all shipment modes supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentModesGet: function (options) {
            return localVarFp.shipmentsShipmentModesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary A list of all shipment rep roles supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentRepRolesGet: function (options) {
            return localVarFp.shipmentsShipmentRepRolesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary A list of all shipment states supported by the API
         * @param {boolean} [excludeStopAutomatedStatuses] If true, exclude statuses that can be automated based on stop status transitions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsStatusesGet: function (excludeStopAutomatedStatuses, options) {
            return localVarFp.shipmentsStatusesGet(excludeStopAutomatedStatuses, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List of all stop status reason codes supported by the API along with their categorial groupings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsStopStatusReasonCodesGet: function (options) {
            return localVarFp.shipmentsStopStatusReasonCodesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary A list of all point of contact roles/job_titles supported by the API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        vendorsVendorPocRolesGet: function (options) {
            return localVarFp.vendorsVendorPocRolesGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ReferenceDataApiFactory = ReferenceDataApiFactory;
/**
 * ReferenceDataApi - object-oriented interface
 * @export
 * @class ReferenceDataApi
 * @extends {BaseAPI}
 */
var ReferenceDataApi = /** @class */ (function (_super) {
    __extends(ReferenceDataApi, _super);
    function ReferenceDataApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary List all charge codes
     * @param {string} [category] Category of the charge code.
     * @param {string} [code] Code of the charge code.
     * @param {string} [id] Id of the charge code.
     * @param {number} [limit] Number of results to return per page.
     * @param {string} [name] Name of the charge code.
     * @param {number} [page] A page number within the paginated result set.
     * @param {string} [q] Query across the &#x60;id&#x60; (machine readable identifier), &#x60;code&#x60;, &#x60;name&#x60;, and &#x60;category&#x60; of the charge codes to find matching charge codes that contain the query text or value. The search/query is case insensitive.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDataApi
     */
    ReferenceDataApi.prototype.listChargeCodes = function (category, code, id, limit, name, page, q, options) {
        var _this = this;
        return (0, exports.ReferenceDataApiFp)(this.configuration).listChargeCodes(category, code, id, limit, name, page, q, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary A list of all `PurchaseOrder.overall_status` values that could be returned by the API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDataApi
     */
    ReferenceDataApi.prototype.purchaseOrdersOverallStatusesGet = function (options) {
        var _this = this;
        return (0, exports.ReferenceDataApiFp)(this.configuration).purchaseOrdersOverallStatusesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List all UPS custom package types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDataApi
     */
    ReferenceDataApi.prototype.quotingUpsPackageTypesGet = function (options) {
        var _this = this;
        return (0, exports.ReferenceDataApiFp)(this.configuration).quotingUpsPackageTypesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List all USPS custom package types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDataApi
     */
    ReferenceDataApi.prototype.quotingUspsPackageTypesGet = function (options) {
        var _this = this;
        return (0, exports.ReferenceDataApiFp)(this.configuration).quotingUspsPackageTypesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary A list of all shipment accessorials supported by the API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDataApi
     */
    ReferenceDataApi.prototype.shipmentsAccessorialsGet = function (options) {
        var _this = this;
        return (0, exports.ReferenceDataApiFp)(this.configuration).shipmentsAccessorialsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary A list of all appointment types supported by the API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDataApi
     */
    ReferenceDataApi.prototype.shipmentsAppointmentTypesGet = function (options) {
        var _this = this;
        return (0, exports.ReferenceDataApiFp)(this.configuration).shipmentsAppointmentTypesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary A list of all charge line item categories supported by the API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDataApi
     */
    ReferenceDataApi.prototype.shipmentsChargeLineItemCategoriesGet = function (options) {
        var _this = this;
        return (0, exports.ReferenceDataApiFp)(this.configuration).shipmentsChargeLineItemCategoriesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns CSV with requested shipments info, in the same ordering as requested
     * @param {InlineObject21} inlineObject21
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDataApi
     */
    ReferenceDataApi.prototype.shipmentsDownloadCsvPost = function (inlineObject21, options) {
        var _this = this;
        return (0, exports.ReferenceDataApiFp)(this.configuration).shipmentsDownloadCsvPost(inlineObject21, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary A list of all Equipment Types supported by the API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDataApi
     */
    ReferenceDataApi.prototype.shipmentsEquipmentTypesGet = function (options) {
        var _this = this;
        return (0, exports.ReferenceDataApiFp)(this.configuration).shipmentsEquipmentTypesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary A list of all hazmat supported by the API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDataApi
     */
    ReferenceDataApi.prototype.shipmentsHazmatGet = function (options) {
        var _this = this;
        return (0, exports.ReferenceDataApiFp)(this.configuration).shipmentsHazmatGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary A list of all NMFCs supported by the API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDataApi
     */
    ReferenceDataApi.prototype.shipmentsNmfcGet = function (options) {
        var _this = this;
        return (0, exports.ReferenceDataApiFp)(this.configuration).shipmentsNmfcGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary A list of all package types supported by the API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDataApi
     */
    ReferenceDataApi.prototype.shipmentsPackageTypesGet = function (options) {
        var _this = this;
        return (0, exports.ReferenceDataApiFp)(this.configuration).shipmentsPackageTypesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary A list of all piece types supported by the API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDataApi
     */
    ReferenceDataApi.prototype.shipmentsPieceTypesGet = function (options) {
        var _this = this;
        return (0, exports.ReferenceDataApiFp)(this.configuration).shipmentsPieceTypesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary A list of all service levels supported by the API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDataApi
     */
    ReferenceDataApi.prototype.shipmentsServiceLevelsGet = function (options) {
        var _this = this;
        return (0, exports.ReferenceDataApiFp)(this.configuration).shipmentsServiceLevelsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary A list of all shipment modes supported by the API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDataApi
     */
    ReferenceDataApi.prototype.shipmentsShipmentModesGet = function (options) {
        var _this = this;
        return (0, exports.ReferenceDataApiFp)(this.configuration).shipmentsShipmentModesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary A list of all shipment rep roles supported by the API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDataApi
     */
    ReferenceDataApi.prototype.shipmentsShipmentRepRolesGet = function (options) {
        var _this = this;
        return (0, exports.ReferenceDataApiFp)(this.configuration).shipmentsShipmentRepRolesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary A list of all shipment states supported by the API
     * @param {boolean} [excludeStopAutomatedStatuses] If true, exclude statuses that can be automated based on stop status transitions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDataApi
     */
    ReferenceDataApi.prototype.shipmentsStatusesGet = function (excludeStopAutomatedStatuses, options) {
        var _this = this;
        return (0, exports.ReferenceDataApiFp)(this.configuration).shipmentsStatusesGet(excludeStopAutomatedStatuses, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List of all stop status reason codes supported by the API along with their categorial groupings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDataApi
     */
    ReferenceDataApi.prototype.shipmentsStopStatusReasonCodesGet = function (options) {
        var _this = this;
        return (0, exports.ReferenceDataApiFp)(this.configuration).shipmentsStopStatusReasonCodesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary A list of all point of contact roles/job_titles supported by the API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceDataApi
     */
    ReferenceDataApi.prototype.vendorsVendorPocRolesGet = function (options) {
        var _this = this;
        return (0, exports.ReferenceDataApiFp)(this.configuration).vendorsVendorPocRolesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ReferenceDataApi;
}(base_1.BaseAPI));
exports.ReferenceDataApi = ReferenceDataApi;
/**
 * RegistrationApi - axios parameter creator
 * @export
 */
var RegistrationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Delete a registered Fedex account
         * @param {string} fedexAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationFEDEXFedexAccountIdDelete: function (fedexAccountId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'fedexAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('registrationFEDEXFedexAccountIdDelete', 'fedexAccountId', fedexAccountId);
                            localVarPath = "/registration/FEDEX/{fedexAccountId}/"
                                .replace("{".concat("fedexAccountId", "}"), encodeURIComponent(String(fedexAccountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Can only modify freight account number and smart post hub id at this time
         * @summary Update a Company\'s Fedex account with Shipwell
         * @param {string} fedexAccountId
         * @param {FedexAccount} fedexAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationFEDEXFedexAccountIdPut: function (fedexAccountId, fedexAccount, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'fedexAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('registrationFEDEXFedexAccountIdPut', 'fedexAccountId', fedexAccountId);
                            // verify required parameter 'fedexAccount' is not null or undefined
                            (0, common_1.assertParamExists)('registrationFEDEXFedexAccountIdPut', 'fedexAccount', fedexAccount);
                            localVarPath = "/registration/FEDEX/{fedexAccountId}/"
                                .replace("{".concat("fedexAccountId", "}"), encodeURIComponent(String(fedexAccountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(fedexAccount, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain FedexAccount information
         * @param {string} [accountNumber] Fedex account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationFEDEXGet: function (accountNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/registration/FEDEX/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (accountNumber !== undefined) {
                                localVarQueryParameter['account_number'] = accountNumber;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Company has to have an account with Fedex before registering with Shipwell.
         * @summary Registers Company\'s Fedex account with Shipwell
         * @param {RegisterFedex} registerFedex
         * @param {string} [accountNumber] Fedex account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationFEDEXPost: function (registerFedex, accountNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'registerFedex' is not null or undefined
                            (0, common_1.assertParamExists)('registrationFEDEXPost', 'registerFedex', registerFedex);
                            localVarPath = "/registration/FEDEX/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (accountNumber !== undefined) {
                                localVarQueryParameter['account_number'] = accountNumber;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(registerFedex, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain UPSAccount information
         * @param {string} [accountNumber] Fedex account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationUPSGet: function (accountNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/registration/UPS/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (accountNumber !== undefined) {
                                localVarQueryParameter['account_number'] = accountNumber;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Company has to have an account with UPS before registering with Shipwell.
         * @summary Registers Company\'s UPS account with Shipwell
         * @param {RegisterUPS} registerUPS
         * @param {string} [accountNumber] Fedex account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationUPSPost: function (registerUPS, accountNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'registerUPS' is not null or undefined
                            (0, common_1.assertParamExists)('registrationUPSPost', 'registerUPS', registerUPS);
                            localVarPath = "/registration/UPS/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (accountNumber !== undefined) {
                                localVarQueryParameter['account_number'] = accountNumber;
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(registerUPS, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a registered UPS account
         * @param {string} upsAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationUPSUpsAccountIdDelete: function (upsAccountId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'upsAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('registrationUPSUpsAccountIdDelete', 'upsAccountId', upsAccountId);
                            localVarPath = "/registration/UPS/{upsAccountId}/"
                                .replace("{".concat("upsAccountId", "}"), encodeURIComponent(String(upsAccountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Reverify a UPS account with OAuth
         * @param {string} upsAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationUPSUpsAccountIdReverifyPost: function (upsAccountId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'upsAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('registrationUPSUpsAccountIdReverifyPost', 'upsAccountId', upsAccountId);
                            localVarPath = "/registration/UPS/{upsAccountId}/reverify/"
                                .replace("{".concat("upsAccountId", "}"), encodeURIComponent(String(upsAccountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain USPSAccount information
         * @param {string} [accountNumber] Fedex account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationUSPSGet: function (accountNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/registration/USPS/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (accountNumber !== undefined) {
                                localVarQueryParameter['account_number'] = accountNumber;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain USPSAccount information
         * @param {string} uspsAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationUSPSUspsAccountIdGet: function (uspsAccountId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'uspsAccountId' is not null or undefined
                            (0, common_1.assertParamExists)('registrationUSPSUspsAccountIdGet', 'uspsAccountId', uspsAccountId);
                            localVarPath = "/registration/USPS/{uspsAccountId}"
                                .replace("{".concat("uspsAccountId", "}"), encodeURIComponent(String(uspsAccountId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.RegistrationApiAxiosParamCreator = RegistrationApiAxiosParamCreator;
/**
 * RegistrationApi - functional programming interface
 * @export
 */
var RegistrationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.RegistrationApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Delete a registered Fedex account
         * @param {string} fedexAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationFEDEXFedexAccountIdDelete: function (fedexAccountId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.registrationFEDEXFedexAccountIdDelete(fedexAccountId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Can only modify freight account number and smart post hub id at this time
         * @summary Update a Company\'s Fedex account with Shipwell
         * @param {string} fedexAccountId
         * @param {FedexAccount} fedexAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationFEDEXFedexAccountIdPut: function (fedexAccountId, fedexAccount, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.registrationFEDEXFedexAccountIdPut(fedexAccountId, fedexAccount, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain FedexAccount information
         * @param {string} [accountNumber] Fedex account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationFEDEXGet: function (accountNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.registrationFEDEXGet(accountNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Company has to have an account with Fedex before registering with Shipwell.
         * @summary Registers Company\'s Fedex account with Shipwell
         * @param {RegisterFedex} registerFedex
         * @param {string} [accountNumber] Fedex account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationFEDEXPost: function (registerFedex, accountNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.registrationFEDEXPost(registerFedex, accountNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain UPSAccount information
         * @param {string} [accountNumber] Fedex account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationUPSGet: function (accountNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.registrationUPSGet(accountNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Company has to have an account with UPS before registering with Shipwell.
         * @summary Registers Company\'s UPS account with Shipwell
         * @param {RegisterUPS} registerUPS
         * @param {string} [accountNumber] Fedex account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationUPSPost: function (registerUPS, accountNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.registrationUPSPost(registerUPS, accountNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a registered UPS account
         * @param {string} upsAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationUPSUpsAccountIdDelete: function (upsAccountId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.registrationUPSUpsAccountIdDelete(upsAccountId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Reverify a UPS account with OAuth
         * @param {string} upsAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationUPSUpsAccountIdReverifyPost: function (upsAccountId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.registrationUPSUpsAccountIdReverifyPost(upsAccountId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain USPSAccount information
         * @param {string} [accountNumber] Fedex account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationUSPSGet: function (accountNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.registrationUSPSGet(accountNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain USPSAccount information
         * @param {string} uspsAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationUSPSUspsAccountIdGet: function (uspsAccountId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.registrationUSPSUspsAccountIdGet(uspsAccountId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.RegistrationApiFp = RegistrationApiFp;
/**
 * RegistrationApi - factory interface
 * @export
 */
var RegistrationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.RegistrationApiFp)(configuration);
    return {
        /**
         *
         * @summary Delete a registered Fedex account
         * @param {string} fedexAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationFEDEXFedexAccountIdDelete: function (fedexAccountId, options) {
            return localVarFp.registrationFEDEXFedexAccountIdDelete(fedexAccountId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Can only modify freight account number and smart post hub id at this time
         * @summary Update a Company\'s Fedex account with Shipwell
         * @param {string} fedexAccountId
         * @param {FedexAccount} fedexAccount
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationFEDEXFedexAccountIdPut: function (fedexAccountId, fedexAccount, options) {
            return localVarFp.registrationFEDEXFedexAccountIdPut(fedexAccountId, fedexAccount, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Obtain FedexAccount information
         * @param {string} [accountNumber] Fedex account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationFEDEXGet: function (accountNumber, options) {
            return localVarFp.registrationFEDEXGet(accountNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Company has to have an account with Fedex before registering with Shipwell.
         * @summary Registers Company\'s Fedex account with Shipwell
         * @param {RegisterFedex} registerFedex
         * @param {string} [accountNumber] Fedex account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationFEDEXPost: function (registerFedex, accountNumber, options) {
            return localVarFp.registrationFEDEXPost(registerFedex, accountNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Obtain UPSAccount information
         * @param {string} [accountNumber] Fedex account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationUPSGet: function (accountNumber, options) {
            return localVarFp.registrationUPSGet(accountNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Company has to have an account with UPS before registering with Shipwell.
         * @summary Registers Company\'s UPS account with Shipwell
         * @param {RegisterUPS} registerUPS
         * @param {string} [accountNumber] Fedex account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationUPSPost: function (registerUPS, accountNumber, options) {
            return localVarFp.registrationUPSPost(registerUPS, accountNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a registered UPS account
         * @param {string} upsAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationUPSUpsAccountIdDelete: function (upsAccountId, options) {
            return localVarFp.registrationUPSUpsAccountIdDelete(upsAccountId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Reverify a UPS account with OAuth
         * @param {string} upsAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationUPSUpsAccountIdReverifyPost: function (upsAccountId, options) {
            return localVarFp.registrationUPSUpsAccountIdReverifyPost(upsAccountId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Obtain USPSAccount information
         * @param {string} [accountNumber] Fedex account number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationUSPSGet: function (accountNumber, options) {
            return localVarFp.registrationUSPSGet(accountNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Obtain USPSAccount information
         * @param {string} uspsAccountId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registrationUSPSUspsAccountIdGet: function (uspsAccountId, options) {
            return localVarFp.registrationUSPSUspsAccountIdGet(uspsAccountId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.RegistrationApiFactory = RegistrationApiFactory;
/**
 * RegistrationApi - object-oriented interface
 * @export
 * @class RegistrationApi
 * @extends {BaseAPI}
 */
var RegistrationApi = /** @class */ (function (_super) {
    __extends(RegistrationApi, _super);
    function RegistrationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Delete a registered Fedex account
     * @param {string} fedexAccountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    RegistrationApi.prototype.registrationFEDEXFedexAccountIdDelete = function (fedexAccountId, options) {
        var _this = this;
        return (0, exports.RegistrationApiFp)(this.configuration).registrationFEDEXFedexAccountIdDelete(fedexAccountId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Can only modify freight account number and smart post hub id at this time
     * @summary Update a Company\'s Fedex account with Shipwell
     * @param {string} fedexAccountId
     * @param {FedexAccount} fedexAccount
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    RegistrationApi.prototype.registrationFEDEXFedexAccountIdPut = function (fedexAccountId, fedexAccount, options) {
        var _this = this;
        return (0, exports.RegistrationApiFp)(this.configuration).registrationFEDEXFedexAccountIdPut(fedexAccountId, fedexAccount, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Obtain FedexAccount information
     * @param {string} [accountNumber] Fedex account number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    RegistrationApi.prototype.registrationFEDEXGet = function (accountNumber, options) {
        var _this = this;
        return (0, exports.RegistrationApiFp)(this.configuration).registrationFEDEXGet(accountNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Company has to have an account with Fedex before registering with Shipwell.
     * @summary Registers Company\'s Fedex account with Shipwell
     * @param {RegisterFedex} registerFedex
     * @param {string} [accountNumber] Fedex account number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    RegistrationApi.prototype.registrationFEDEXPost = function (registerFedex, accountNumber, options) {
        var _this = this;
        return (0, exports.RegistrationApiFp)(this.configuration).registrationFEDEXPost(registerFedex, accountNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Obtain UPSAccount information
     * @param {string} [accountNumber] Fedex account number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    RegistrationApi.prototype.registrationUPSGet = function (accountNumber, options) {
        var _this = this;
        return (0, exports.RegistrationApiFp)(this.configuration).registrationUPSGet(accountNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Company has to have an account with UPS before registering with Shipwell.
     * @summary Registers Company\'s UPS account with Shipwell
     * @param {RegisterUPS} registerUPS
     * @param {string} [accountNumber] Fedex account number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    RegistrationApi.prototype.registrationUPSPost = function (registerUPS, accountNumber, options) {
        var _this = this;
        return (0, exports.RegistrationApiFp)(this.configuration).registrationUPSPost(registerUPS, accountNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a registered UPS account
     * @param {string} upsAccountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    RegistrationApi.prototype.registrationUPSUpsAccountIdDelete = function (upsAccountId, options) {
        var _this = this;
        return (0, exports.RegistrationApiFp)(this.configuration).registrationUPSUpsAccountIdDelete(upsAccountId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Reverify a UPS account with OAuth
     * @param {string} upsAccountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    RegistrationApi.prototype.registrationUPSUpsAccountIdReverifyPost = function (upsAccountId, options) {
        var _this = this;
        return (0, exports.RegistrationApiFp)(this.configuration).registrationUPSUpsAccountIdReverifyPost(upsAccountId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Obtain USPSAccount information
     * @param {string} [accountNumber] Fedex account number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    RegistrationApi.prototype.registrationUSPSGet = function (accountNumber, options) {
        var _this = this;
        return (0, exports.RegistrationApiFp)(this.configuration).registrationUSPSGet(accountNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Obtain USPSAccount information
     * @param {string} uspsAccountId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegistrationApi
     */
    RegistrationApi.prototype.registrationUSPSUspsAccountIdGet = function (uspsAccountId, options) {
        var _this = this;
        return (0, exports.RegistrationApiFp)(this.configuration).registrationUSPSUspsAccountIdGet(uspsAccountId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RegistrationApi;
}(base_1.BaseAPI));
exports.RegistrationApi = RegistrationApi;
/**
 * RfpAutomationApi - axios parameter creator
 * @export
 */
var RfpAutomationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Obtain a list af RFP bids
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsGet: function (page, pageSize, ordering, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/rfp-automation/rfp-bids/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a RFP bid
         * @param {RfpBidRequest} rfpBidRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsPost: function (rfpBidRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpBidRequest' is not null or undefined
                            (0, common_1.assertParamExists)('rfpAutomationRfpBidsPost', 'rfpBidRequest', rfpBidRequest);
                            localVarPath = "/rfp-automation/rfp-bids/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rfpBidRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a RFP bid
         * @param {string} rfpBidId The id of the rfpBid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsRfpBidIdDelete: function (rfpBidId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpBidId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpAutomationRfpBidsRfpBidIdDelete', 'rfpBidId', rfpBidId);
                            localVarPath = "/rfp-automation/rfp-bids/{rfpBidId}/"
                                .replace("{".concat("rfpBidId", "}"), encodeURIComponent(String(rfpBidId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the imported RFP rows as a csv.
         * @param {string} rfpBidId The id of the rfpBid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsRfpBidIdExportCsvGet: function (rfpBidId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpBidId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpAutomationRfpBidsRfpBidIdExportCsvGet', 'rfpBidId', rfpBidId);
                            localVarPath = "/rfp-automation/rfp-bids/{rfpBidId}/export-csv/"
                                .replace("{".concat("rfpBidId", "}"), encodeURIComponent(String(rfpBidId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain an RFP bid given an RFP bid ID
         * @param {string} rfpBidId The id of the rfpBid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsRfpBidIdGet: function (rfpBidId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpBidId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpAutomationRfpBidsRfpBidIdGet', 'rfpBidId', rfpBidId);
                            localVarPath = "/rfp-automation/rfp-bids/{rfpBidId}/"
                                .replace("{".concat("rfpBidId", "}"), encodeURIComponent(String(rfpBidId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Return the numbers of lanes, contracts and workflows created during import.
         * @param {string} rfpBidId The id of the rfpBid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsRfpBidIdPostImportResultsGet: function (rfpBidId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpBidId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpAutomationRfpBidsRfpBidIdPostImportResultsGet', 'rfpBidId', rfpBidId);
                            localVarPath = "/rfp-automation/rfp-bids/{rfpBidId}/post-import-results/"
                                .replace("{".concat("rfpBidId", "}"), encodeURIComponent(String(rfpBidId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates an RFP bid
         * @param {string} rfpBidId The id of the rfpBid
         * @param {RfpBidRequest} rfpBidRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsRfpBidIdPut: function (rfpBidId, rfpBidRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpBidId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpAutomationRfpBidsRfpBidIdPut', 'rfpBidId', rfpBidId);
                            // verify required parameter 'rfpBidRequest' is not null or undefined
                            (0, common_1.assertParamExists)('rfpAutomationRfpBidsRfpBidIdPut', 'rfpBidRequest', rfpBidRequest);
                            localVarPath = "/rfp-automation/rfp-bids/{rfpBidId}/"
                                .replace("{".concat("rfpBidId", "}"), encodeURIComponent(String(rfpBidId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rfpBidRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain a list af RFP rows
         * @param {string} rfpBidId The id of the rfpBid
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [originCity] The origin city of the rfpRow
         * @param {string} [originCityContains] The origin city of the rfpRow contains this value
         * @param {string} [originState] The origin state of the rfpRow
         * @param {string} [originStateContains] The origin state of the rfpRow contains this value
         * @param {string} [originPostalCode] The origin zip of the rfpRow
         * @param {string} [originPostalCodeContains] The origin zip of the rfpRow contains this value
         * @param {string} [destinationCity] The destination city of the rfpRow
         * @param {string} [destinationCityContains] The destination city of the rfpRow contains this value
         * @param {string} [destinationState] The destination state of the rfpRow
         * @param {string} [destinationStateContains] The destination state of the rfpRow contains this value
         * @param {string} [destinationPostalCode] The destination zip of the rfpRow
         * @param {string} [destinationPostalCodeContains] The destination zip of the rfpRow contains this value
         * @param {string} [carrierReference] The carrier reference of the rfpRow
         * @param {string} [carrierReferenceContains] The carrier reference of the rfpRow contains this value
         * @param {string} [carrierName] The carrier name of the rfpRow
         * @param {string} [carrierNameContains] The carrier name of the rfpRow contains this value
         * @param {string} [rowIdentifier] The row identifier of the rfpRow used by the customer
         * @param {string} [rowIdentifierContains] The row identifier of the rfpRow used by the customer contains this value
         * @param {'LTL' | 'FTL' | 'VLTL' | 'DRYAGE' | 'PARCEL' | 'INTERMODAL'} [mode] The mode of the rfpRow
         * @param {EquipmentEnum} [equipment] The equipment of the rfpRow
         * @param {string} [q] search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsRfpBidIdRfpRowsGet: function (rfpBidId, page, pageSize, ordering, originCity, originCityContains, originState, originStateContains, originPostalCode, originPostalCodeContains, destinationCity, destinationCityContains, destinationState, destinationStateContains, destinationPostalCode, destinationPostalCodeContains, carrierReference, carrierReferenceContains, carrierName, carrierNameContains, rowIdentifier, rowIdentifierContains, mode, equipment, q, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpBidId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpAutomationRfpBidsRfpBidIdRfpRowsGet', 'rfpBidId', rfpBidId);
                            localVarPath = "/rfp-automation/rfp-bids/{rfpBidId}/rfp-rows/"
                                .replace("{".concat("rfpBidId", "}"), encodeURIComponent(String(rfpBidId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (originCity !== undefined) {
                                localVarQueryParameter['origin_city'] = originCity;
                            }
                            if (originCityContains !== undefined) {
                                localVarQueryParameter['origin_city__contains'] = originCityContains;
                            }
                            if (originState !== undefined) {
                                localVarQueryParameter['origin_state'] = originState;
                            }
                            if (originStateContains !== undefined) {
                                localVarQueryParameter['origin_state__contains'] = originStateContains;
                            }
                            if (originPostalCode !== undefined) {
                                localVarQueryParameter['origin_postal_code'] = originPostalCode;
                            }
                            if (originPostalCodeContains !== undefined) {
                                localVarQueryParameter['origin_postal_code__contains'] = originPostalCodeContains;
                            }
                            if (destinationCity !== undefined) {
                                localVarQueryParameter['destination_city'] = destinationCity;
                            }
                            if (destinationCityContains !== undefined) {
                                localVarQueryParameter['destination_city__contains'] = destinationCityContains;
                            }
                            if (destinationState !== undefined) {
                                localVarQueryParameter['destination_state'] = destinationState;
                            }
                            if (destinationStateContains !== undefined) {
                                localVarQueryParameter['destination_state__contains'] = destinationStateContains;
                            }
                            if (destinationPostalCode !== undefined) {
                                localVarQueryParameter['destination_postal_code'] = destinationPostalCode;
                            }
                            if (destinationPostalCodeContains !== undefined) {
                                localVarQueryParameter['destination_postal_code__contains'] = destinationPostalCodeContains;
                            }
                            if (carrierReference !== undefined) {
                                localVarQueryParameter['carrier_reference'] = carrierReference;
                            }
                            if (carrierReferenceContains !== undefined) {
                                localVarQueryParameter['carrier_reference__contains'] = carrierReferenceContains;
                            }
                            if (carrierName !== undefined) {
                                localVarQueryParameter['carrier_name'] = carrierName;
                            }
                            if (carrierNameContains !== undefined) {
                                localVarQueryParameter['carrier_name__contains'] = carrierNameContains;
                            }
                            if (rowIdentifier !== undefined) {
                                localVarQueryParameter['row_identifier'] = rowIdentifier;
                            }
                            if (rowIdentifierContains !== undefined) {
                                localVarQueryParameter['row_identifier__contains'] = rowIdentifierContains;
                            }
                            if (mode !== undefined) {
                                localVarQueryParameter['mode'] = mode;
                            }
                            if (equipment !== undefined) {
                                localVarQueryParameter['equipment'] = equipment;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain an RFP row given an RFP row ID
         * @param {string} rfpRowId The id of the rfpRow
         * @param {string} rfpBidId The id of the rfpBid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsRfpBidIdRfpRowsRfpRowIdGet: function (rfpRowId, rfpBidId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpRowId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpAutomationRfpBidsRfpBidIdRfpRowsRfpRowIdGet', 'rfpRowId', rfpRowId);
                            // verify required parameter 'rfpBidId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpAutomationRfpBidsRfpBidIdRfpRowsRfpRowIdGet', 'rfpBidId', rfpBidId);
                            localVarPath = "/rfp-automation/rfp-bids/{rfpBidId}/rfp-rows/{rfpRowId}/"
                                .replace("{".concat("rfpRowId", "}"), encodeURIComponent(String(rfpRowId)))
                                .replace("{".concat("rfpBidId", "}"), encodeURIComponent(String(rfpBidId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.RfpAutomationApiAxiosParamCreator = RfpAutomationApiAxiosParamCreator;
/**
 * RfpAutomationApi - functional programming interface
 * @export
 */
var RfpAutomationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.RfpAutomationApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Obtain a list af RFP bids
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsGet: function (page, pageSize, ordering, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpAutomationRfpBidsGet(page, pageSize, ordering, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a RFP bid
         * @param {RfpBidRequest} rfpBidRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsPost: function (rfpBidRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpAutomationRfpBidsPost(rfpBidRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a RFP bid
         * @param {string} rfpBidId The id of the rfpBid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsRfpBidIdDelete: function (rfpBidId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpAutomationRfpBidsRfpBidIdDelete(rfpBidId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the imported RFP rows as a csv.
         * @param {string} rfpBidId The id of the rfpBid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsRfpBidIdExportCsvGet: function (rfpBidId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpAutomationRfpBidsRfpBidIdExportCsvGet(rfpBidId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain an RFP bid given an RFP bid ID
         * @param {string} rfpBidId The id of the rfpBid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsRfpBidIdGet: function (rfpBidId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpAutomationRfpBidsRfpBidIdGet(rfpBidId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Return the numbers of lanes, contracts and workflows created during import.
         * @param {string} rfpBidId The id of the rfpBid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsRfpBidIdPostImportResultsGet: function (rfpBidId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpAutomationRfpBidsRfpBidIdPostImportResultsGet(rfpBidId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates an RFP bid
         * @param {string} rfpBidId The id of the rfpBid
         * @param {RfpBidRequest} rfpBidRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsRfpBidIdPut: function (rfpBidId, rfpBidRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpAutomationRfpBidsRfpBidIdPut(rfpBidId, rfpBidRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain a list af RFP rows
         * @param {string} rfpBidId The id of the rfpBid
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [originCity] The origin city of the rfpRow
         * @param {string} [originCityContains] The origin city of the rfpRow contains this value
         * @param {string} [originState] The origin state of the rfpRow
         * @param {string} [originStateContains] The origin state of the rfpRow contains this value
         * @param {string} [originPostalCode] The origin zip of the rfpRow
         * @param {string} [originPostalCodeContains] The origin zip of the rfpRow contains this value
         * @param {string} [destinationCity] The destination city of the rfpRow
         * @param {string} [destinationCityContains] The destination city of the rfpRow contains this value
         * @param {string} [destinationState] The destination state of the rfpRow
         * @param {string} [destinationStateContains] The destination state of the rfpRow contains this value
         * @param {string} [destinationPostalCode] The destination zip of the rfpRow
         * @param {string} [destinationPostalCodeContains] The destination zip of the rfpRow contains this value
         * @param {string} [carrierReference] The carrier reference of the rfpRow
         * @param {string} [carrierReferenceContains] The carrier reference of the rfpRow contains this value
         * @param {string} [carrierName] The carrier name of the rfpRow
         * @param {string} [carrierNameContains] The carrier name of the rfpRow contains this value
         * @param {string} [rowIdentifier] The row identifier of the rfpRow used by the customer
         * @param {string} [rowIdentifierContains] The row identifier of the rfpRow used by the customer contains this value
         * @param {'LTL' | 'FTL' | 'VLTL' | 'DRYAGE' | 'PARCEL' | 'INTERMODAL'} [mode] The mode of the rfpRow
         * @param {EquipmentEnum} [equipment] The equipment of the rfpRow
         * @param {string} [q] search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsRfpBidIdRfpRowsGet: function (rfpBidId, page, pageSize, ordering, originCity, originCityContains, originState, originStateContains, originPostalCode, originPostalCodeContains, destinationCity, destinationCityContains, destinationState, destinationStateContains, destinationPostalCode, destinationPostalCodeContains, carrierReference, carrierReferenceContains, carrierName, carrierNameContains, rowIdentifier, rowIdentifierContains, mode, equipment, q, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpAutomationRfpBidsRfpBidIdRfpRowsGet(rfpBidId, page, pageSize, ordering, originCity, originCityContains, originState, originStateContains, originPostalCode, originPostalCodeContains, destinationCity, destinationCityContains, destinationState, destinationStateContains, destinationPostalCode, destinationPostalCodeContains, carrierReference, carrierReferenceContains, carrierName, carrierNameContains, rowIdentifier, rowIdentifierContains, mode, equipment, q, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain an RFP row given an RFP row ID
         * @param {string} rfpRowId The id of the rfpRow
         * @param {string} rfpBidId The id of the rfpBid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsRfpBidIdRfpRowsRfpRowIdGet: function (rfpRowId, rfpBidId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpAutomationRfpBidsRfpBidIdRfpRowsRfpRowIdGet(rfpRowId, rfpBidId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.RfpAutomationApiFp = RfpAutomationApiFp;
/**
 * RfpAutomationApi - factory interface
 * @export
 */
var RfpAutomationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.RfpAutomationApiFp)(configuration);
    return {
        /**
         *
         * @summary Obtain a list af RFP bids
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsGet: function (page, pageSize, ordering, options) {
            return localVarFp.rfpAutomationRfpBidsGet(page, pageSize, ordering, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a RFP bid
         * @param {RfpBidRequest} rfpBidRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsPost: function (rfpBidRequest, options) {
            return localVarFp.rfpAutomationRfpBidsPost(rfpBidRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a RFP bid
         * @param {string} rfpBidId The id of the rfpBid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsRfpBidIdDelete: function (rfpBidId, options) {
            return localVarFp.rfpAutomationRfpBidsRfpBidIdDelete(rfpBidId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the imported RFP rows as a csv.
         * @param {string} rfpBidId The id of the rfpBid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsRfpBidIdExportCsvGet: function (rfpBidId, options) {
            return localVarFp.rfpAutomationRfpBidsRfpBidIdExportCsvGet(rfpBidId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Obtain an RFP bid given an RFP bid ID
         * @param {string} rfpBidId The id of the rfpBid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsRfpBidIdGet: function (rfpBidId, options) {
            return localVarFp.rfpAutomationRfpBidsRfpBidIdGet(rfpBidId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Return the numbers of lanes, contracts and workflows created during import.
         * @param {string} rfpBidId The id of the rfpBid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsRfpBidIdPostImportResultsGet: function (rfpBidId, options) {
            return localVarFp.rfpAutomationRfpBidsRfpBidIdPostImportResultsGet(rfpBidId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates an RFP bid
         * @param {string} rfpBidId The id of the rfpBid
         * @param {RfpBidRequest} rfpBidRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsRfpBidIdPut: function (rfpBidId, rfpBidRequest, options) {
            return localVarFp.rfpAutomationRfpBidsRfpBidIdPut(rfpBidId, rfpBidRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Obtain a list af RFP rows
         * @param {string} rfpBidId The id of the rfpBid
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [originCity] The origin city of the rfpRow
         * @param {string} [originCityContains] The origin city of the rfpRow contains this value
         * @param {string} [originState] The origin state of the rfpRow
         * @param {string} [originStateContains] The origin state of the rfpRow contains this value
         * @param {string} [originPostalCode] The origin zip of the rfpRow
         * @param {string} [originPostalCodeContains] The origin zip of the rfpRow contains this value
         * @param {string} [destinationCity] The destination city of the rfpRow
         * @param {string} [destinationCityContains] The destination city of the rfpRow contains this value
         * @param {string} [destinationState] The destination state of the rfpRow
         * @param {string} [destinationStateContains] The destination state of the rfpRow contains this value
         * @param {string} [destinationPostalCode] The destination zip of the rfpRow
         * @param {string} [destinationPostalCodeContains] The destination zip of the rfpRow contains this value
         * @param {string} [carrierReference] The carrier reference of the rfpRow
         * @param {string} [carrierReferenceContains] The carrier reference of the rfpRow contains this value
         * @param {string} [carrierName] The carrier name of the rfpRow
         * @param {string} [carrierNameContains] The carrier name of the rfpRow contains this value
         * @param {string} [rowIdentifier] The row identifier of the rfpRow used by the customer
         * @param {string} [rowIdentifierContains] The row identifier of the rfpRow used by the customer contains this value
         * @param {'LTL' | 'FTL' | 'VLTL' | 'DRYAGE' | 'PARCEL' | 'INTERMODAL'} [mode] The mode of the rfpRow
         * @param {EquipmentEnum} [equipment] The equipment of the rfpRow
         * @param {string} [q] search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsRfpBidIdRfpRowsGet: function (rfpBidId, page, pageSize, ordering, originCity, originCityContains, originState, originStateContains, originPostalCode, originPostalCodeContains, destinationCity, destinationCityContains, destinationState, destinationStateContains, destinationPostalCode, destinationPostalCodeContains, carrierReference, carrierReferenceContains, carrierName, carrierNameContains, rowIdentifier, rowIdentifierContains, mode, equipment, q, options) {
            return localVarFp.rfpAutomationRfpBidsRfpBidIdRfpRowsGet(rfpBidId, page, pageSize, ordering, originCity, originCityContains, originState, originStateContains, originPostalCode, originPostalCodeContains, destinationCity, destinationCityContains, destinationState, destinationStateContains, destinationPostalCode, destinationPostalCodeContains, carrierReference, carrierReferenceContains, carrierName, carrierNameContains, rowIdentifier, rowIdentifierContains, mode, equipment, q, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Obtain an RFP row given an RFP row ID
         * @param {string} rfpRowId The id of the rfpRow
         * @param {string} rfpBidId The id of the rfpBid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpAutomationRfpBidsRfpBidIdRfpRowsRfpRowIdGet: function (rfpRowId, rfpBidId, options) {
            return localVarFp.rfpAutomationRfpBidsRfpBidIdRfpRowsRfpRowIdGet(rfpRowId, rfpBidId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.RfpAutomationApiFactory = RfpAutomationApiFactory;
/**
 * RfpAutomationApi - object-oriented interface
 * @export
 * @class RfpAutomationApi
 * @extends {BaseAPI}
 */
var RfpAutomationApi = /** @class */ (function (_super) {
    __extends(RfpAutomationApi, _super);
    function RfpAutomationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Obtain a list af RFP bids
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpAutomationApi
     */
    RfpAutomationApi.prototype.rfpAutomationRfpBidsGet = function (page, pageSize, ordering, options) {
        var _this = this;
        return (0, exports.RfpAutomationApiFp)(this.configuration).rfpAutomationRfpBidsGet(page, pageSize, ordering, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a RFP bid
     * @param {RfpBidRequest} rfpBidRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpAutomationApi
     */
    RfpAutomationApi.prototype.rfpAutomationRfpBidsPost = function (rfpBidRequest, options) {
        var _this = this;
        return (0, exports.RfpAutomationApiFp)(this.configuration).rfpAutomationRfpBidsPost(rfpBidRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a RFP bid
     * @param {string} rfpBidId The id of the rfpBid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpAutomationApi
     */
    RfpAutomationApi.prototype.rfpAutomationRfpBidsRfpBidIdDelete = function (rfpBidId, options) {
        var _this = this;
        return (0, exports.RfpAutomationApiFp)(this.configuration).rfpAutomationRfpBidsRfpBidIdDelete(rfpBidId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the imported RFP rows as a csv.
     * @param {string} rfpBidId The id of the rfpBid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpAutomationApi
     */
    RfpAutomationApi.prototype.rfpAutomationRfpBidsRfpBidIdExportCsvGet = function (rfpBidId, options) {
        var _this = this;
        return (0, exports.RfpAutomationApiFp)(this.configuration).rfpAutomationRfpBidsRfpBidIdExportCsvGet(rfpBidId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Obtain an RFP bid given an RFP bid ID
     * @param {string} rfpBidId The id of the rfpBid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpAutomationApi
     */
    RfpAutomationApi.prototype.rfpAutomationRfpBidsRfpBidIdGet = function (rfpBidId, options) {
        var _this = this;
        return (0, exports.RfpAutomationApiFp)(this.configuration).rfpAutomationRfpBidsRfpBidIdGet(rfpBidId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Return the numbers of lanes, contracts and workflows created during import.
     * @param {string} rfpBidId The id of the rfpBid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpAutomationApi
     */
    RfpAutomationApi.prototype.rfpAutomationRfpBidsRfpBidIdPostImportResultsGet = function (rfpBidId, options) {
        var _this = this;
        return (0, exports.RfpAutomationApiFp)(this.configuration).rfpAutomationRfpBidsRfpBidIdPostImportResultsGet(rfpBidId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates an RFP bid
     * @param {string} rfpBidId The id of the rfpBid
     * @param {RfpBidRequest} rfpBidRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpAutomationApi
     */
    RfpAutomationApi.prototype.rfpAutomationRfpBidsRfpBidIdPut = function (rfpBidId, rfpBidRequest, options) {
        var _this = this;
        return (0, exports.RfpAutomationApiFp)(this.configuration).rfpAutomationRfpBidsRfpBidIdPut(rfpBidId, rfpBidRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Obtain a list af RFP rows
     * @param {string} rfpBidId The id of the rfpBid
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [originCity] The origin city of the rfpRow
     * @param {string} [originCityContains] The origin city of the rfpRow contains this value
     * @param {string} [originState] The origin state of the rfpRow
     * @param {string} [originStateContains] The origin state of the rfpRow contains this value
     * @param {string} [originPostalCode] The origin zip of the rfpRow
     * @param {string} [originPostalCodeContains] The origin zip of the rfpRow contains this value
     * @param {string} [destinationCity] The destination city of the rfpRow
     * @param {string} [destinationCityContains] The destination city of the rfpRow contains this value
     * @param {string} [destinationState] The destination state of the rfpRow
     * @param {string} [destinationStateContains] The destination state of the rfpRow contains this value
     * @param {string} [destinationPostalCode] The destination zip of the rfpRow
     * @param {string} [destinationPostalCodeContains] The destination zip of the rfpRow contains this value
     * @param {string} [carrierReference] The carrier reference of the rfpRow
     * @param {string} [carrierReferenceContains] The carrier reference of the rfpRow contains this value
     * @param {string} [carrierName] The carrier name of the rfpRow
     * @param {string} [carrierNameContains] The carrier name of the rfpRow contains this value
     * @param {string} [rowIdentifier] The row identifier of the rfpRow used by the customer
     * @param {string} [rowIdentifierContains] The row identifier of the rfpRow used by the customer contains this value
     * @param {'LTL' | 'FTL' | 'VLTL' | 'DRYAGE' | 'PARCEL' | 'INTERMODAL'} [mode] The mode of the rfpRow
     * @param {EquipmentEnum} [equipment] The equipment of the rfpRow
     * @param {string} [q] search query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpAutomationApi
     */
    RfpAutomationApi.prototype.rfpAutomationRfpBidsRfpBidIdRfpRowsGet = function (rfpBidId, page, pageSize, ordering, originCity, originCityContains, originState, originStateContains, originPostalCode, originPostalCodeContains, destinationCity, destinationCityContains, destinationState, destinationStateContains, destinationPostalCode, destinationPostalCodeContains, carrierReference, carrierReferenceContains, carrierName, carrierNameContains, rowIdentifier, rowIdentifierContains, mode, equipment, q, options) {
        var _this = this;
        return (0, exports.RfpAutomationApiFp)(this.configuration).rfpAutomationRfpBidsRfpBidIdRfpRowsGet(rfpBidId, page, pageSize, ordering, originCity, originCityContains, originState, originStateContains, originPostalCode, originPostalCodeContains, destinationCity, destinationCityContains, destinationState, destinationStateContains, destinationPostalCode, destinationPostalCodeContains, carrierReference, carrierReferenceContains, carrierName, carrierNameContains, rowIdentifier, rowIdentifierContains, mode, equipment, q, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Obtain an RFP row given an RFP row ID
     * @param {string} rfpRowId The id of the rfpRow
     * @param {string} rfpBidId The id of the rfpBid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpAutomationApi
     */
    RfpAutomationApi.prototype.rfpAutomationRfpBidsRfpBidIdRfpRowsRfpRowIdGet = function (rfpRowId, rfpBidId, options) {
        var _this = this;
        return (0, exports.RfpAutomationApiFp)(this.configuration).rfpAutomationRfpBidsRfpBidIdRfpRowsRfpRowIdGet(rfpRowId, rfpBidId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RfpAutomationApi;
}(base_1.BaseAPI));
exports.RfpAutomationApi = RfpAutomationApi;
/**
 * RfpOptimizedApi - axios parameter creator
 * @export
 */
var RfpOptimizedApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Obtain a list of carrier bid requests
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedCarrierBidRequestsGet: function (page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/rfp-optimized/carrier-bid-requests/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Return a list of RFP documents associated with this carrier bid request
         * @param {string} rfpCarrierBidRequestOptId The id of the RFP Carrier Bid Bid Request object
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdCarrierBidReqDocumentsGet: function (rfpCarrierBidRequestOptId, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpCarrierBidRequestOptId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdCarrierBidReqDocumentsGet', 'rfpCarrierBidRequestOptId', rfpCarrierBidRequestOptId);
                            localVarPath = "/rfp-optimized/carrier-bid-requests/{rfpCarrierBidRequestOptId}/carrier-bid-req-documents/"
                                .replace("{".concat("rfpCarrierBidRequestOptId", "}"), encodeURIComponent(String(rfpCarrierBidRequestOptId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Return a specific RFP document associated with this carrier bid request. Document id is required
         * @param {string} rfpCarrierBidRequestOptId The id of the RFP Carrier Bid Bid Request object
         * @param {string} rfpDocumentId The id of the RFP document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdCarrierBidReqDocumentsRfpDocumentIdGet: function (rfpCarrierBidRequestOptId, rfpDocumentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpCarrierBidRequestOptId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdCarrierBidReqDocumentsRfpDocumentIdGet', 'rfpCarrierBidRequestOptId', rfpCarrierBidRequestOptId);
                            // verify required parameter 'rfpDocumentId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdCarrierBidReqDocumentsRfpDocumentIdGet', 'rfpDocumentId', rfpDocumentId);
                            localVarPath = "/rfp-optimized/carrier-bid-requests/{rfpCarrierBidRequestOptId}/carrier-bid-req-documents/{rfpDocumentId}/"
                                .replace("{".concat("rfpCarrierBidRequestOptId", "}"), encodeURIComponent(String(rfpCarrierBidRequestOptId)))
                                .replace("{".concat("rfpDocumentId", "}"), encodeURIComponent(String(rfpDocumentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns CSV with lane info of an rfp bid that a carrier can download to add bids
         * @param {string} rfpCarrierBidRequestOptId The id of the RFP Carrier Bid Bid Request object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdDownloadCsvGet: function (rfpCarrierBidRequestOptId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpCarrierBidRequestOptId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdDownloadCsvGet', 'rfpCarrierBidRequestOptId', rfpCarrierBidRequestOptId);
                            localVarPath = "/rfp-optimized/carrier-bid-requests/{rfpCarrierBidRequestOptId}/download_csv/"
                                .replace("{".concat("rfpCarrierBidRequestOptId", "}"), encodeURIComponent(String(rfpCarrierBidRequestOptId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Carrier successfully returns an RFP carrier bid request object given a carrier bid ID
         * @param {string} rfpCarrierBidRequestOptId The id of the RFP Carrier Bid Bid Request object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdGet: function (rfpCarrierBidRequestOptId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpCarrierBidRequestOptId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdGet', 'rfpCarrierBidRequestOptId', rfpCarrierBidRequestOptId);
                            localVarPath = "/rfp-optimized/carrier-bid-requests/{rfpCarrierBidRequestOptId}/"
                                .replace("{".concat("rfpCarrierBidRequestOptId", "}"), encodeURIComponent(String(rfpCarrierBidRequestOptId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain a carrier selection page metrics
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [q] search query
         * @param {Array<string>} [tags] Return objects with these (exact) tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedDataMetricsCarrierSelectionGet: function (page, pageSize, q, tags, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/rfp-optimized/data-metrics/carrier-selection/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (tags) {
                                localVarQueryParameter['tags'] = tags;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain a list of optimized RFP bids
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptGet: function (page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/rfp-optimized/rfp-bid-opt/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create an optimized RFP bid
         * @param {RfpBidOptRequest} rfpBidOptRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptPost: function (rfpBidOptRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpBidOptRequest' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedRfpBidOptPost', 'rfpBidOptRequest', rfpBidOptRequest);
                            localVarPath = "/rfp-optimized/rfp-bid-opt/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rfpBidOptRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Customer successfully created an optimized RFP carrier bid request
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {RfpCarrierBidRequestOptRequest} rfpCarrierBidRequestOptRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdCarrierBidRequestPost: function (rfpBidOptId, rfpCarrierBidRequestOptRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpBidOptId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedRfpBidOptRfpBidOptIdCarrierBidRequestPost', 'rfpBidOptId', rfpBidOptId);
                            // verify required parameter 'rfpCarrierBidRequestOptRequest' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedRfpBidOptRfpBidOptIdCarrierBidRequestPost', 'rfpCarrierBidRequestOptRequest', rfpCarrierBidRequestOptRequest);
                            localVarPath = "/rfp-optimized/rfp-bid-opt/{rfpBidOptId}/carrier-bid-request/"
                                .replace("{".concat("rfpBidOptId", "}"), encodeURIComponent(String(rfpBidOptId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rfpCarrierBidRequestOptRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create contracts and routing guides
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {InlineObject18} inlineObject18
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdCreateContractsRgPost: function (rfpBidOptId, inlineObject18, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpBidOptId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedRfpBidOptRfpBidOptIdCreateContractsRgPost', 'rfpBidOptId', rfpBidOptId);
                            // verify required parameter 'inlineObject18' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedRfpBidOptRfpBidOptIdCreateContractsRgPost', 'inlineObject18', inlineObject18);
                            localVarPath = "/rfp-optimized/rfp-bid-opt/{rfpBidOptId}/create-contracts-rg/"
                                .replace("{".concat("rfpBidOptId", "}"), encodeURIComponent(String(rfpBidOptId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject18, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create only contracts
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {InlineObject19} [inlineObject19]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdCreateOnlyContractsPost: function (rfpBidOptId, inlineObject19, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpBidOptId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedRfpBidOptRfpBidOptIdCreateOnlyContractsPost', 'rfpBidOptId', rfpBidOptId);
                            localVarPath = "/rfp-optimized/rfp-bid-opt/{rfpBidOptId}/create-only-contracts/"
                                .replace("{".concat("rfpBidOptId", "}"), encodeURIComponent(String(rfpBidOptId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject19, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete an RFP bid optimized object
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdDelete: function (rfpBidOptId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpBidOptId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedRfpBidOptRfpBidOptIdDelete', 'rfpBidOptId', rfpBidOptId);
                            localVarPath = "/rfp-optimized/rfp-bid-opt/{rfpBidOptId}/"
                                .replace("{".concat("rfpBidOptId", "}"), encodeURIComponent(String(rfpBidOptId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the imported RFP lanes of an optimized rfp bid as a csv.
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdExportCsvGet: function (rfpBidOptId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpBidOptId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedRfpBidOptRfpBidOptIdExportCsvGet', 'rfpBidOptId', rfpBidOptId);
                            localVarPath = "/rfp-optimized/rfp-bid-opt/{rfpBidOptId}/export-csv/"
                                .replace("{".concat("rfpBidOptId", "}"), encodeURIComponent(String(rfpBidOptId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain an RFP bid optimized object given an RFP bid ID
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdGet: function (rfpBidOptId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpBidOptId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedRfpBidOptRfpBidOptIdGet', 'rfpBidOptId', rfpBidOptId);
                            localVarPath = "/rfp-optimized/rfp-bid-opt/{rfpBidOptId}/"
                                .replace("{".concat("rfpBidOptId", "}"), encodeURIComponent(String(rfpBidOptId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates an RFP bid optimization object
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {RfpBidOptRequest} rfpBidOptRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdPut: function (rfpBidOptId, rfpBidOptRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpBidOptId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedRfpBidOptRfpBidOptIdPut', 'rfpBidOptId', rfpBidOptId);
                            // verify required parameter 'rfpBidOptRequest' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedRfpBidOptRfpBidOptIdPut', 'rfpBidOptRequest', rfpBidOptRequest);
                            localVarPath = "/rfp-optimized/rfp-bid-opt/{rfpBidOptId}/"
                                .replace("{".concat("rfpBidOptId", "}"), encodeURIComponent(String(rfpBidOptId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rfpBidOptRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Return a list of RFP documents associated with this RFPBid
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsGet: function (rfpBidOptId, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpBidOptId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsGet', 'rfpBidOptId', rfpBidOptId);
                            localVarPath = "/rfp-optimized/rfp-bid-opt/{rfpBidOptId}/rfp-bid-opt-documents/"
                                .replace("{".concat("rfpBidOptId", "}"), encodeURIComponent(String(rfpBidOptId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a document that is associated with an RFPBidOpt
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {string} description
         * @param {any} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsPost: function (rfpBidOptId, description, file, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpBidOptId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsPost', 'rfpBidOptId', rfpBidOptId);
                            // verify required parameter 'description' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsPost', 'description', description);
                            // verify required parameter 'file' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsPost', 'file', file);
                            localVarPath = "/rfp-optimized/rfp-bid-opt/{rfpBidOptId}/rfp-bid-opt-documents/"
                                .replace("{".concat("rfpBidOptId", "}"), encodeURIComponent(String(rfpBidOptId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (description !== undefined) {
                                localVarFormParams.append('description', description);
                            }
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Return a specific RFP document associated with this RFPBid. Document id is required
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {string} rfpDocumentId The id of the RFP document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsRfpDocumentIdGet: function (rfpBidOptId, rfpDocumentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpBidOptId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsRfpDocumentIdGet', 'rfpBidOptId', rfpBidOptId);
                            // verify required parameter 'rfpDocumentId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsRfpDocumentIdGet', 'rfpDocumentId', rfpDocumentId);
                            localVarPath = "/rfp-optimized/rfp-bid-opt/{rfpBidOptId}/rfp-bid-opt-documents/{rfpDocumentId}/"
                                .replace("{".concat("rfpBidOptId", "}"), encodeURIComponent(String(rfpBidOptId)))
                                .replace("{".concat("rfpDocumentId", "}"), encodeURIComponent(String(rfpDocumentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Return the progress records showing information about the state of contract and workflow creation
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneContractsWorkflowCreationProgressGet: function (rfpBidOptId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpBidOptId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneContractsWorkflowCreationProgressGet', 'rfpBidOptId', rfpBidOptId);
                            localVarPath = "/rfp-optimized/rfp-bid-opt/{rfpBidOptId}/rfp-lane-contracts-workflow-creation-progress/"
                                .replace("{".concat("rfpBidOptId", "}"), encodeURIComponent(String(rfpBidOptId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain a list af RFP lane optimized objects
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [laneId] The customer assigned ID to this RFP Opt lane
         * @param {string} [laneIdContains] The customer assigned ID to this RFP Opt lane contains this value
         * @param {string} [originCity] The origin city of this RFP opt lane
         * @param {string} [originCityContains] The origin city of this RFP opt lane contains this value
         * @param {string} [originState] The origin state of this RFP opt lane
         * @param {string} [originStateContains] The origin state of this RFP opt lane contains this value
         * @param {string} [originPostCode] The origin post code of this RFP opt lane
         * @param {string} [originPostCodeContains] The origin post code of this RFP opt lane contains this value
         * @param {string} [destinationCity] The destination city of this RFP opt lane
         * @param {string} [destinationCityContains] The destination city of this RFP opt lane contains this value
         * @param {string} [destinationState] The destination state of this RFP opt lane
         * @param {string} [destinationStateContains] The destination state of this RFP opt lane contains this value
         * @param {string} [destinationPostCode] The destination post code of this RFP opt lane
         * @param {string} [destinationPostCodeContains] The destination post code of this RFP opt lane contains this value
         * @param {number} [volume] The volume for this RFP opt lane
         * @param {string} [lanePolicyName] The policy associated with this RFP opt lane
         * @param {string} [lanePolicyNameContains] The policy associated with this RFP opt lane contains this value
         * @param {Array<'LOW' | 'MEDIUM' | 'HIGH'>} [priceVolatilityText] The price volatility range. LOW, MEDIUM or HIGH
         * @param {string} [q] search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsGet: function (rfpBidOptId, page, pageSize, ordering, laneId, laneIdContains, originCity, originCityContains, originState, originStateContains, originPostCode, originPostCodeContains, destinationCity, destinationCityContains, destinationState, destinationStateContains, destinationPostCode, destinationPostCodeContains, volume, lanePolicyName, lanePolicyNameContains, priceVolatilityText, q, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpBidOptId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsGet', 'rfpBidOptId', rfpBidOptId);
                            localVarPath = "/rfp-optimized/rfp-bid-opt/{rfpBidOptId}/rfp-lane-opts/"
                                .replace("{".concat("rfpBidOptId", "}"), encodeURIComponent(String(rfpBidOptId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (laneId !== undefined) {
                                localVarQueryParameter['lane_id'] = laneId;
                            }
                            if (laneIdContains !== undefined) {
                                localVarQueryParameter['lane_id__contains'] = laneIdContains;
                            }
                            if (originCity !== undefined) {
                                localVarQueryParameter['origin_city'] = originCity;
                            }
                            if (originCityContains !== undefined) {
                                localVarQueryParameter['origin_city__contains'] = originCityContains;
                            }
                            if (originState !== undefined) {
                                localVarQueryParameter['origin_state'] = originState;
                            }
                            if (originStateContains !== undefined) {
                                localVarQueryParameter['origin_state__contains'] = originStateContains;
                            }
                            if (originPostCode !== undefined) {
                                localVarQueryParameter['origin_post_code'] = originPostCode;
                            }
                            if (originPostCodeContains !== undefined) {
                                localVarQueryParameter['origin_post_code__contains'] = originPostCodeContains;
                            }
                            if (destinationCity !== undefined) {
                                localVarQueryParameter['destination_city'] = destinationCity;
                            }
                            if (destinationCityContains !== undefined) {
                                localVarQueryParameter['destination_city__contains'] = destinationCityContains;
                            }
                            if (destinationState !== undefined) {
                                localVarQueryParameter['destination_state'] = destinationState;
                            }
                            if (destinationStateContains !== undefined) {
                                localVarQueryParameter['destination_state__contains'] = destinationStateContains;
                            }
                            if (destinationPostCode !== undefined) {
                                localVarQueryParameter['destination_post_code'] = destinationPostCode;
                            }
                            if (destinationPostCodeContains !== undefined) {
                                localVarQueryParameter['destination_post_code__contains'] = destinationPostCodeContains;
                            }
                            if (volume !== undefined) {
                                localVarQueryParameter['volume'] = volume;
                            }
                            if (lanePolicyName !== undefined) {
                                localVarQueryParameter['lane_policy_name'] = lanePolicyName;
                            }
                            if (lanePolicyNameContains !== undefined) {
                                localVarQueryParameter['lane_policy_name__contains'] = lanePolicyNameContains;
                            }
                            if (priceVolatilityText) {
                                localVarQueryParameter['price_volatility_text'] = priceVolatilityText;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain an RFP carrier lanes given an RFP lane and bid optimized ID
         * @param {string} rfpLaneOptId The id of the RFP Lane Optimized object
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {boolean} [orderByBidPrice] If true - sort by most recent bid price on lane_carriers instead by order_index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdCarrierLanesGet: function (rfpLaneOptId, rfpBidOptId, orderByBidPrice, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpLaneOptId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdCarrierLanesGet', 'rfpLaneOptId', rfpLaneOptId);
                            // verify required parameter 'rfpBidOptId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdCarrierLanesGet', 'rfpBidOptId', rfpBidOptId);
                            localVarPath = "/rfp-optimized/rfp-bid-opt/{rfpBidOptId}/rfp-lane-opts/{rfpLaneOptId}/carrier-lanes/"
                                .replace("{".concat("rfpLaneOptId", "}"), encodeURIComponent(String(rfpLaneOptId)))
                                .replace("{".concat("rfpBidOptId", "}"), encodeURIComponent(String(rfpBidOptId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (orderByBidPrice !== undefined) {
                                localVarQueryParameter['order_by_bid_price'] = orderByBidPrice;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Set order of RFP carrier lanes given an RFP lane and bid optimized ID
         * @param {string} rfpLaneOptId The id of the RFP Lane Optimized object
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {Array<InlineObject>} [inlineObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdCarrierLanesPut: function (rfpLaneOptId, rfpBidOptId, inlineObject, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpLaneOptId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdCarrierLanesPut', 'rfpLaneOptId', rfpLaneOptId);
                            // verify required parameter 'rfpBidOptId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdCarrierLanesPut', 'rfpBidOptId', rfpBidOptId);
                            localVarPath = "/rfp-optimized/rfp-bid-opt/{rfpBidOptId}/rfp-lane-opts/{rfpLaneOptId}/carrier-lanes/"
                                .replace("{".concat("rfpLaneOptId", "}"), encodeURIComponent(String(rfpLaneOptId)))
                                .replace("{".concat("rfpBidOptId", "}"), encodeURIComponent(String(rfpBidOptId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain an RFP row given an RFP lane and bid optimized ID
         * @param {string} rfpLaneOptId The id of the RFP Lane Optimized object
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdGet: function (rfpLaneOptId, rfpBidOptId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'rfpLaneOptId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdGet', 'rfpLaneOptId', rfpLaneOptId);
                            // verify required parameter 'rfpBidOptId' is not null or undefined
                            (0, common_1.assertParamExists)('rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdGet', 'rfpBidOptId', rfpBidOptId);
                            localVarPath = "/rfp-optimized/rfp-bid-opt/{rfpBidOptId}/rfp-lane-opts/{rfpLaneOptId}/"
                                .replace("{".concat("rfpLaneOptId", "}"), encodeURIComponent(String(rfpLaneOptId)))
                                .replace("{".concat("rfpBidOptId", "}"), encodeURIComponent(String(rfpBidOptId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.RfpOptimizedApiAxiosParamCreator = RfpOptimizedApiAxiosParamCreator;
/**
 * RfpOptimizedApi - functional programming interface
 * @export
 */
var RfpOptimizedApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.RfpOptimizedApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Obtain a list of carrier bid requests
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedCarrierBidRequestsGet: function (page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpOptimizedCarrierBidRequestsGet(page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Return a list of RFP documents associated with this carrier bid request
         * @param {string} rfpCarrierBidRequestOptId The id of the RFP Carrier Bid Bid Request object
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdCarrierBidReqDocumentsGet: function (rfpCarrierBidRequestOptId, page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdCarrierBidReqDocumentsGet(rfpCarrierBidRequestOptId, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Return a specific RFP document associated with this carrier bid request. Document id is required
         * @param {string} rfpCarrierBidRequestOptId The id of the RFP Carrier Bid Bid Request object
         * @param {string} rfpDocumentId The id of the RFP document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdCarrierBidReqDocumentsRfpDocumentIdGet: function (rfpCarrierBidRequestOptId, rfpDocumentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdCarrierBidReqDocumentsRfpDocumentIdGet(rfpCarrierBidRequestOptId, rfpDocumentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns CSV with lane info of an rfp bid that a carrier can download to add bids
         * @param {string} rfpCarrierBidRequestOptId The id of the RFP Carrier Bid Bid Request object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdDownloadCsvGet: function (rfpCarrierBidRequestOptId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdDownloadCsvGet(rfpCarrierBidRequestOptId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Carrier successfully returns an RFP carrier bid request object given a carrier bid ID
         * @param {string} rfpCarrierBidRequestOptId The id of the RFP Carrier Bid Bid Request object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdGet: function (rfpCarrierBidRequestOptId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdGet(rfpCarrierBidRequestOptId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain a carrier selection page metrics
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [q] search query
         * @param {Array<string>} [tags] Return objects with these (exact) tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedDataMetricsCarrierSelectionGet: function (page, pageSize, q, tags, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpOptimizedDataMetricsCarrierSelectionGet(page, pageSize, q, tags, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain a list of optimized RFP bids
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptGet: function (page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpOptimizedRfpBidOptGet(page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create an optimized RFP bid
         * @param {RfpBidOptRequest} rfpBidOptRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptPost: function (rfpBidOptRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpOptimizedRfpBidOptPost(rfpBidOptRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Customer successfully created an optimized RFP carrier bid request
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {RfpCarrierBidRequestOptRequest} rfpCarrierBidRequestOptRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdCarrierBidRequestPost: function (rfpBidOptId, rfpCarrierBidRequestOptRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpOptimizedRfpBidOptRfpBidOptIdCarrierBidRequestPost(rfpBidOptId, rfpCarrierBidRequestOptRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create contracts and routing guides
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {InlineObject18} inlineObject18
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdCreateContractsRgPost: function (rfpBidOptId, inlineObject18, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpOptimizedRfpBidOptRfpBidOptIdCreateContractsRgPost(rfpBidOptId, inlineObject18, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create only contracts
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {InlineObject19} [inlineObject19]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdCreateOnlyContractsPost: function (rfpBidOptId, inlineObject19, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpOptimizedRfpBidOptRfpBidOptIdCreateOnlyContractsPost(rfpBidOptId, inlineObject19, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete an RFP bid optimized object
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdDelete: function (rfpBidOptId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpOptimizedRfpBidOptRfpBidOptIdDelete(rfpBidOptId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the imported RFP lanes of an optimized rfp bid as a csv.
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdExportCsvGet: function (rfpBidOptId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpOptimizedRfpBidOptRfpBidOptIdExportCsvGet(rfpBidOptId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain an RFP bid optimized object given an RFP bid ID
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdGet: function (rfpBidOptId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpOptimizedRfpBidOptRfpBidOptIdGet(rfpBidOptId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates an RFP bid optimization object
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {RfpBidOptRequest} rfpBidOptRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdPut: function (rfpBidOptId, rfpBidOptRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpOptimizedRfpBidOptRfpBidOptIdPut(rfpBidOptId, rfpBidOptRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Return a list of RFP documents associated with this RFPBid
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsGet: function (rfpBidOptId, page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsGet(rfpBidOptId, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a document that is associated with an RFPBidOpt
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {string} description
         * @param {any} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsPost: function (rfpBidOptId, description, file, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsPost(rfpBidOptId, description, file, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Return a specific RFP document associated with this RFPBid. Document id is required
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {string} rfpDocumentId The id of the RFP document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsRfpDocumentIdGet: function (rfpBidOptId, rfpDocumentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsRfpDocumentIdGet(rfpBidOptId, rfpDocumentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Return the progress records showing information about the state of contract and workflow creation
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneContractsWorkflowCreationProgressGet: function (rfpBidOptId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneContractsWorkflowCreationProgressGet(rfpBidOptId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain a list af RFP lane optimized objects
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [laneId] The customer assigned ID to this RFP Opt lane
         * @param {string} [laneIdContains] The customer assigned ID to this RFP Opt lane contains this value
         * @param {string} [originCity] The origin city of this RFP opt lane
         * @param {string} [originCityContains] The origin city of this RFP opt lane contains this value
         * @param {string} [originState] The origin state of this RFP opt lane
         * @param {string} [originStateContains] The origin state of this RFP opt lane contains this value
         * @param {string} [originPostCode] The origin post code of this RFP opt lane
         * @param {string} [originPostCodeContains] The origin post code of this RFP opt lane contains this value
         * @param {string} [destinationCity] The destination city of this RFP opt lane
         * @param {string} [destinationCityContains] The destination city of this RFP opt lane contains this value
         * @param {string} [destinationState] The destination state of this RFP opt lane
         * @param {string} [destinationStateContains] The destination state of this RFP opt lane contains this value
         * @param {string} [destinationPostCode] The destination post code of this RFP opt lane
         * @param {string} [destinationPostCodeContains] The destination post code of this RFP opt lane contains this value
         * @param {number} [volume] The volume for this RFP opt lane
         * @param {string} [lanePolicyName] The policy associated with this RFP opt lane
         * @param {string} [lanePolicyNameContains] The policy associated with this RFP opt lane contains this value
         * @param {Array<'LOW' | 'MEDIUM' | 'HIGH'>} [priceVolatilityText] The price volatility range. LOW, MEDIUM or HIGH
         * @param {string} [q] search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsGet: function (rfpBidOptId, page, pageSize, ordering, laneId, laneIdContains, originCity, originCityContains, originState, originStateContains, originPostCode, originPostCodeContains, destinationCity, destinationCityContains, destinationState, destinationStateContains, destinationPostCode, destinationPostCodeContains, volume, lanePolicyName, lanePolicyNameContains, priceVolatilityText, q, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsGet(rfpBidOptId, page, pageSize, ordering, laneId, laneIdContains, originCity, originCityContains, originState, originStateContains, originPostCode, originPostCodeContains, destinationCity, destinationCityContains, destinationState, destinationStateContains, destinationPostCode, destinationPostCodeContains, volume, lanePolicyName, lanePolicyNameContains, priceVolatilityText, q, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain an RFP carrier lanes given an RFP lane and bid optimized ID
         * @param {string} rfpLaneOptId The id of the RFP Lane Optimized object
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {boolean} [orderByBidPrice] If true - sort by most recent bid price on lane_carriers instead by order_index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdCarrierLanesGet: function (rfpLaneOptId, rfpBidOptId, orderByBidPrice, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdCarrierLanesGet(rfpLaneOptId, rfpBidOptId, orderByBidPrice, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Set order of RFP carrier lanes given an RFP lane and bid optimized ID
         * @param {string} rfpLaneOptId The id of the RFP Lane Optimized object
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {Array<InlineObject>} [inlineObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdCarrierLanesPut: function (rfpLaneOptId, rfpBidOptId, inlineObject, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdCarrierLanesPut(rfpLaneOptId, rfpBidOptId, inlineObject, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Obtain an RFP row given an RFP lane and bid optimized ID
         * @param {string} rfpLaneOptId The id of the RFP Lane Optimized object
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdGet: function (rfpLaneOptId, rfpBidOptId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdGet(rfpLaneOptId, rfpBidOptId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.RfpOptimizedApiFp = RfpOptimizedApiFp;
/**
 * RfpOptimizedApi - factory interface
 * @export
 */
var RfpOptimizedApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.RfpOptimizedApiFp)(configuration);
    return {
        /**
         *
         * @summary Obtain a list of carrier bid requests
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedCarrierBidRequestsGet: function (page, pageSize, options) {
            return localVarFp.rfpOptimizedCarrierBidRequestsGet(page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Return a list of RFP documents associated with this carrier bid request
         * @param {string} rfpCarrierBidRequestOptId The id of the RFP Carrier Bid Bid Request object
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdCarrierBidReqDocumentsGet: function (rfpCarrierBidRequestOptId, page, pageSize, options) {
            return localVarFp.rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdCarrierBidReqDocumentsGet(rfpCarrierBidRequestOptId, page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Return a specific RFP document associated with this carrier bid request. Document id is required
         * @param {string} rfpCarrierBidRequestOptId The id of the RFP Carrier Bid Bid Request object
         * @param {string} rfpDocumentId The id of the RFP document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdCarrierBidReqDocumentsRfpDocumentIdGet: function (rfpCarrierBidRequestOptId, rfpDocumentId, options) {
            return localVarFp.rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdCarrierBidReqDocumentsRfpDocumentIdGet(rfpCarrierBidRequestOptId, rfpDocumentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns CSV with lane info of an rfp bid that a carrier can download to add bids
         * @param {string} rfpCarrierBidRequestOptId The id of the RFP Carrier Bid Bid Request object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdDownloadCsvGet: function (rfpCarrierBidRequestOptId, options) {
            return localVarFp.rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdDownloadCsvGet(rfpCarrierBidRequestOptId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Carrier successfully returns an RFP carrier bid request object given a carrier bid ID
         * @param {string} rfpCarrierBidRequestOptId The id of the RFP Carrier Bid Bid Request object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdGet: function (rfpCarrierBidRequestOptId, options) {
            return localVarFp.rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdGet(rfpCarrierBidRequestOptId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Obtain a carrier selection page metrics
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [q] search query
         * @param {Array<string>} [tags] Return objects with these (exact) tags
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedDataMetricsCarrierSelectionGet: function (page, pageSize, q, tags, options) {
            return localVarFp.rfpOptimizedDataMetricsCarrierSelectionGet(page, pageSize, q, tags, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Obtain a list of optimized RFP bids
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptGet: function (page, pageSize, options) {
            return localVarFp.rfpOptimizedRfpBidOptGet(page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create an optimized RFP bid
         * @param {RfpBidOptRequest} rfpBidOptRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptPost: function (rfpBidOptRequest, options) {
            return localVarFp.rfpOptimizedRfpBidOptPost(rfpBidOptRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Customer successfully created an optimized RFP carrier bid request
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {RfpCarrierBidRequestOptRequest} rfpCarrierBidRequestOptRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdCarrierBidRequestPost: function (rfpBidOptId, rfpCarrierBidRequestOptRequest, options) {
            return localVarFp.rfpOptimizedRfpBidOptRfpBidOptIdCarrierBidRequestPost(rfpBidOptId, rfpCarrierBidRequestOptRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create contracts and routing guides
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {InlineObject18} inlineObject18
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdCreateContractsRgPost: function (rfpBidOptId, inlineObject18, options) {
            return localVarFp.rfpOptimizedRfpBidOptRfpBidOptIdCreateContractsRgPost(rfpBidOptId, inlineObject18, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create only contracts
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {InlineObject19} [inlineObject19]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdCreateOnlyContractsPost: function (rfpBidOptId, inlineObject19, options) {
            return localVarFp.rfpOptimizedRfpBidOptRfpBidOptIdCreateOnlyContractsPost(rfpBidOptId, inlineObject19, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete an RFP bid optimized object
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdDelete: function (rfpBidOptId, options) {
            return localVarFp.rfpOptimizedRfpBidOptRfpBidOptIdDelete(rfpBidOptId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the imported RFP lanes of an optimized rfp bid as a csv.
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdExportCsvGet: function (rfpBidOptId, options) {
            return localVarFp.rfpOptimizedRfpBidOptRfpBidOptIdExportCsvGet(rfpBidOptId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Obtain an RFP bid optimized object given an RFP bid ID
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdGet: function (rfpBidOptId, options) {
            return localVarFp.rfpOptimizedRfpBidOptRfpBidOptIdGet(rfpBidOptId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates an RFP bid optimization object
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {RfpBidOptRequest} rfpBidOptRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdPut: function (rfpBidOptId, rfpBidOptRequest, options) {
            return localVarFp.rfpOptimizedRfpBidOptRfpBidOptIdPut(rfpBidOptId, rfpBidOptRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Return a list of RFP documents associated with this RFPBid
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsGet: function (rfpBidOptId, page, pageSize, options) {
            return localVarFp.rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsGet(rfpBidOptId, page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a document that is associated with an RFPBidOpt
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {string} description
         * @param {any} file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsPost: function (rfpBidOptId, description, file, options) {
            return localVarFp.rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsPost(rfpBidOptId, description, file, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Return a specific RFP document associated with this RFPBid. Document id is required
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {string} rfpDocumentId The id of the RFP document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsRfpDocumentIdGet: function (rfpBidOptId, rfpDocumentId, options) {
            return localVarFp.rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsRfpDocumentIdGet(rfpBidOptId, rfpDocumentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Return the progress records showing information about the state of contract and workflow creation
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneContractsWorkflowCreationProgressGet: function (rfpBidOptId, options) {
            return localVarFp.rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneContractsWorkflowCreationProgressGet(rfpBidOptId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Obtain a list af RFP lane optimized objects
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [laneId] The customer assigned ID to this RFP Opt lane
         * @param {string} [laneIdContains] The customer assigned ID to this RFP Opt lane contains this value
         * @param {string} [originCity] The origin city of this RFP opt lane
         * @param {string} [originCityContains] The origin city of this RFP opt lane contains this value
         * @param {string} [originState] The origin state of this RFP opt lane
         * @param {string} [originStateContains] The origin state of this RFP opt lane contains this value
         * @param {string} [originPostCode] The origin post code of this RFP opt lane
         * @param {string} [originPostCodeContains] The origin post code of this RFP opt lane contains this value
         * @param {string} [destinationCity] The destination city of this RFP opt lane
         * @param {string} [destinationCityContains] The destination city of this RFP opt lane contains this value
         * @param {string} [destinationState] The destination state of this RFP opt lane
         * @param {string} [destinationStateContains] The destination state of this RFP opt lane contains this value
         * @param {string} [destinationPostCode] The destination post code of this RFP opt lane
         * @param {string} [destinationPostCodeContains] The destination post code of this RFP opt lane contains this value
         * @param {number} [volume] The volume for this RFP opt lane
         * @param {string} [lanePolicyName] The policy associated with this RFP opt lane
         * @param {string} [lanePolicyNameContains] The policy associated with this RFP opt lane contains this value
         * @param {Array<'LOW' | 'MEDIUM' | 'HIGH'>} [priceVolatilityText] The price volatility range. LOW, MEDIUM or HIGH
         * @param {string} [q] search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsGet: function (rfpBidOptId, page, pageSize, ordering, laneId, laneIdContains, originCity, originCityContains, originState, originStateContains, originPostCode, originPostCodeContains, destinationCity, destinationCityContains, destinationState, destinationStateContains, destinationPostCode, destinationPostCodeContains, volume, lanePolicyName, lanePolicyNameContains, priceVolatilityText, q, options) {
            return localVarFp.rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsGet(rfpBidOptId, page, pageSize, ordering, laneId, laneIdContains, originCity, originCityContains, originState, originStateContains, originPostCode, originPostCodeContains, destinationCity, destinationCityContains, destinationState, destinationStateContains, destinationPostCode, destinationPostCodeContains, volume, lanePolicyName, lanePolicyNameContains, priceVolatilityText, q, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Obtain an RFP carrier lanes given an RFP lane and bid optimized ID
         * @param {string} rfpLaneOptId The id of the RFP Lane Optimized object
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {boolean} [orderByBidPrice] If true - sort by most recent bid price on lane_carriers instead by order_index
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdCarrierLanesGet: function (rfpLaneOptId, rfpBidOptId, orderByBidPrice, options) {
            return localVarFp.rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdCarrierLanesGet(rfpLaneOptId, rfpBidOptId, orderByBidPrice, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Set order of RFP carrier lanes given an RFP lane and bid optimized ID
         * @param {string} rfpLaneOptId The id of the RFP Lane Optimized object
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {Array<InlineObject>} [inlineObject]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdCarrierLanesPut: function (rfpLaneOptId, rfpBidOptId, inlineObject, options) {
            return localVarFp.rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdCarrierLanesPut(rfpLaneOptId, rfpBidOptId, inlineObject, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Obtain an RFP row given an RFP lane and bid optimized ID
         * @param {string} rfpLaneOptId The id of the RFP Lane Optimized object
         * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdGet: function (rfpLaneOptId, rfpBidOptId, options) {
            return localVarFp.rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdGet(rfpLaneOptId, rfpBidOptId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.RfpOptimizedApiFactory = RfpOptimizedApiFactory;
/**
 * RfpOptimizedApi - object-oriented interface
 * @export
 * @class RfpOptimizedApi
 * @extends {BaseAPI}
 */
var RfpOptimizedApi = /** @class */ (function (_super) {
    __extends(RfpOptimizedApi, _super);
    function RfpOptimizedApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Obtain a list of carrier bid requests
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpOptimizedApi
     */
    RfpOptimizedApi.prototype.rfpOptimizedCarrierBidRequestsGet = function (page, pageSize, options) {
        var _this = this;
        return (0, exports.RfpOptimizedApiFp)(this.configuration).rfpOptimizedCarrierBidRequestsGet(page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Return a list of RFP documents associated with this carrier bid request
     * @param {string} rfpCarrierBidRequestOptId The id of the RFP Carrier Bid Bid Request object
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpOptimizedApi
     */
    RfpOptimizedApi.prototype.rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdCarrierBidReqDocumentsGet = function (rfpCarrierBidRequestOptId, page, pageSize, options) {
        var _this = this;
        return (0, exports.RfpOptimizedApiFp)(this.configuration).rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdCarrierBidReqDocumentsGet(rfpCarrierBidRequestOptId, page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Return a specific RFP document associated with this carrier bid request. Document id is required
     * @param {string} rfpCarrierBidRequestOptId The id of the RFP Carrier Bid Bid Request object
     * @param {string} rfpDocumentId The id of the RFP document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpOptimizedApi
     */
    RfpOptimizedApi.prototype.rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdCarrierBidReqDocumentsRfpDocumentIdGet = function (rfpCarrierBidRequestOptId, rfpDocumentId, options) {
        var _this = this;
        return (0, exports.RfpOptimizedApiFp)(this.configuration).rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdCarrierBidReqDocumentsRfpDocumentIdGet(rfpCarrierBidRequestOptId, rfpDocumentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns CSV with lane info of an rfp bid that a carrier can download to add bids
     * @param {string} rfpCarrierBidRequestOptId The id of the RFP Carrier Bid Bid Request object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpOptimizedApi
     */
    RfpOptimizedApi.prototype.rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdDownloadCsvGet = function (rfpCarrierBidRequestOptId, options) {
        var _this = this;
        return (0, exports.RfpOptimizedApiFp)(this.configuration).rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdDownloadCsvGet(rfpCarrierBidRequestOptId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Carrier successfully returns an RFP carrier bid request object given a carrier bid ID
     * @param {string} rfpCarrierBidRequestOptId The id of the RFP Carrier Bid Bid Request object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpOptimizedApi
     */
    RfpOptimizedApi.prototype.rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdGet = function (rfpCarrierBidRequestOptId, options) {
        var _this = this;
        return (0, exports.RfpOptimizedApiFp)(this.configuration).rfpOptimizedCarrierBidRequestsRfpCarrierBidRequestOptIdGet(rfpCarrierBidRequestOptId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Obtain a carrier selection page metrics
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [q] search query
     * @param {Array<string>} [tags] Return objects with these (exact) tags
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpOptimizedApi
     */
    RfpOptimizedApi.prototype.rfpOptimizedDataMetricsCarrierSelectionGet = function (page, pageSize, q, tags, options) {
        var _this = this;
        return (0, exports.RfpOptimizedApiFp)(this.configuration).rfpOptimizedDataMetricsCarrierSelectionGet(page, pageSize, q, tags, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Obtain a list of optimized RFP bids
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpOptimizedApi
     */
    RfpOptimizedApi.prototype.rfpOptimizedRfpBidOptGet = function (page, pageSize, options) {
        var _this = this;
        return (0, exports.RfpOptimizedApiFp)(this.configuration).rfpOptimizedRfpBidOptGet(page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create an optimized RFP bid
     * @param {RfpBidOptRequest} rfpBidOptRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpOptimizedApi
     */
    RfpOptimizedApi.prototype.rfpOptimizedRfpBidOptPost = function (rfpBidOptRequest, options) {
        var _this = this;
        return (0, exports.RfpOptimizedApiFp)(this.configuration).rfpOptimizedRfpBidOptPost(rfpBidOptRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Customer successfully created an optimized RFP carrier bid request
     * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
     * @param {RfpCarrierBidRequestOptRequest} rfpCarrierBidRequestOptRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpOptimizedApi
     */
    RfpOptimizedApi.prototype.rfpOptimizedRfpBidOptRfpBidOptIdCarrierBidRequestPost = function (rfpBidOptId, rfpCarrierBidRequestOptRequest, options) {
        var _this = this;
        return (0, exports.RfpOptimizedApiFp)(this.configuration).rfpOptimizedRfpBidOptRfpBidOptIdCarrierBidRequestPost(rfpBidOptId, rfpCarrierBidRequestOptRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create contracts and routing guides
     * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
     * @param {InlineObject18} inlineObject18
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpOptimizedApi
     */
    RfpOptimizedApi.prototype.rfpOptimizedRfpBidOptRfpBidOptIdCreateContractsRgPost = function (rfpBidOptId, inlineObject18, options) {
        var _this = this;
        return (0, exports.RfpOptimizedApiFp)(this.configuration).rfpOptimizedRfpBidOptRfpBidOptIdCreateContractsRgPost(rfpBidOptId, inlineObject18, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create only contracts
     * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
     * @param {InlineObject19} [inlineObject19]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpOptimizedApi
     */
    RfpOptimizedApi.prototype.rfpOptimizedRfpBidOptRfpBidOptIdCreateOnlyContractsPost = function (rfpBidOptId, inlineObject19, options) {
        var _this = this;
        return (0, exports.RfpOptimizedApiFp)(this.configuration).rfpOptimizedRfpBidOptRfpBidOptIdCreateOnlyContractsPost(rfpBidOptId, inlineObject19, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete an RFP bid optimized object
     * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpOptimizedApi
     */
    RfpOptimizedApi.prototype.rfpOptimizedRfpBidOptRfpBidOptIdDelete = function (rfpBidOptId, options) {
        var _this = this;
        return (0, exports.RfpOptimizedApiFp)(this.configuration).rfpOptimizedRfpBidOptRfpBidOptIdDelete(rfpBidOptId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the imported RFP lanes of an optimized rfp bid as a csv.
     * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpOptimizedApi
     */
    RfpOptimizedApi.prototype.rfpOptimizedRfpBidOptRfpBidOptIdExportCsvGet = function (rfpBidOptId, options) {
        var _this = this;
        return (0, exports.RfpOptimizedApiFp)(this.configuration).rfpOptimizedRfpBidOptRfpBidOptIdExportCsvGet(rfpBidOptId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Obtain an RFP bid optimized object given an RFP bid ID
     * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpOptimizedApi
     */
    RfpOptimizedApi.prototype.rfpOptimizedRfpBidOptRfpBidOptIdGet = function (rfpBidOptId, options) {
        var _this = this;
        return (0, exports.RfpOptimizedApiFp)(this.configuration).rfpOptimizedRfpBidOptRfpBidOptIdGet(rfpBidOptId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates an RFP bid optimization object
     * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
     * @param {RfpBidOptRequest} rfpBidOptRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpOptimizedApi
     */
    RfpOptimizedApi.prototype.rfpOptimizedRfpBidOptRfpBidOptIdPut = function (rfpBidOptId, rfpBidOptRequest, options) {
        var _this = this;
        return (0, exports.RfpOptimizedApiFp)(this.configuration).rfpOptimizedRfpBidOptRfpBidOptIdPut(rfpBidOptId, rfpBidOptRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Return a list of RFP documents associated with this RFPBid
     * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpOptimizedApi
     */
    RfpOptimizedApi.prototype.rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsGet = function (rfpBidOptId, page, pageSize, options) {
        var _this = this;
        return (0, exports.RfpOptimizedApiFp)(this.configuration).rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsGet(rfpBidOptId, page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a document that is associated with an RFPBidOpt
     * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
     * @param {string} description
     * @param {any} file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpOptimizedApi
     */
    RfpOptimizedApi.prototype.rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsPost = function (rfpBidOptId, description, file, options) {
        var _this = this;
        return (0, exports.RfpOptimizedApiFp)(this.configuration).rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsPost(rfpBidOptId, description, file, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Return a specific RFP document associated with this RFPBid. Document id is required
     * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
     * @param {string} rfpDocumentId The id of the RFP document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpOptimizedApi
     */
    RfpOptimizedApi.prototype.rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsRfpDocumentIdGet = function (rfpBidOptId, rfpDocumentId, options) {
        var _this = this;
        return (0, exports.RfpOptimizedApiFp)(this.configuration).rfpOptimizedRfpBidOptRfpBidOptIdRfpBidOptDocumentsRfpDocumentIdGet(rfpBidOptId, rfpDocumentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Return the progress records showing information about the state of contract and workflow creation
     * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpOptimizedApi
     */
    RfpOptimizedApi.prototype.rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneContractsWorkflowCreationProgressGet = function (rfpBidOptId, options) {
        var _this = this;
        return (0, exports.RfpOptimizedApiFp)(this.configuration).rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneContractsWorkflowCreationProgressGet(rfpBidOptId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Obtain a list af RFP lane optimized objects
     * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [laneId] The customer assigned ID to this RFP Opt lane
     * @param {string} [laneIdContains] The customer assigned ID to this RFP Opt lane contains this value
     * @param {string} [originCity] The origin city of this RFP opt lane
     * @param {string} [originCityContains] The origin city of this RFP opt lane contains this value
     * @param {string} [originState] The origin state of this RFP opt lane
     * @param {string} [originStateContains] The origin state of this RFP opt lane contains this value
     * @param {string} [originPostCode] The origin post code of this RFP opt lane
     * @param {string} [originPostCodeContains] The origin post code of this RFP opt lane contains this value
     * @param {string} [destinationCity] The destination city of this RFP opt lane
     * @param {string} [destinationCityContains] The destination city of this RFP opt lane contains this value
     * @param {string} [destinationState] The destination state of this RFP opt lane
     * @param {string} [destinationStateContains] The destination state of this RFP opt lane contains this value
     * @param {string} [destinationPostCode] The destination post code of this RFP opt lane
     * @param {string} [destinationPostCodeContains] The destination post code of this RFP opt lane contains this value
     * @param {number} [volume] The volume for this RFP opt lane
     * @param {string} [lanePolicyName] The policy associated with this RFP opt lane
     * @param {string} [lanePolicyNameContains] The policy associated with this RFP opt lane contains this value
     * @param {Array<'LOW' | 'MEDIUM' | 'HIGH'>} [priceVolatilityText] The price volatility range. LOW, MEDIUM or HIGH
     * @param {string} [q] search query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpOptimizedApi
     */
    RfpOptimizedApi.prototype.rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsGet = function (rfpBidOptId, page, pageSize, ordering, laneId, laneIdContains, originCity, originCityContains, originState, originStateContains, originPostCode, originPostCodeContains, destinationCity, destinationCityContains, destinationState, destinationStateContains, destinationPostCode, destinationPostCodeContains, volume, lanePolicyName, lanePolicyNameContains, priceVolatilityText, q, options) {
        var _this = this;
        return (0, exports.RfpOptimizedApiFp)(this.configuration).rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsGet(rfpBidOptId, page, pageSize, ordering, laneId, laneIdContains, originCity, originCityContains, originState, originStateContains, originPostCode, originPostCodeContains, destinationCity, destinationCityContains, destinationState, destinationStateContains, destinationPostCode, destinationPostCodeContains, volume, lanePolicyName, lanePolicyNameContains, priceVolatilityText, q, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Obtain an RFP carrier lanes given an RFP lane and bid optimized ID
     * @param {string} rfpLaneOptId The id of the RFP Lane Optimized object
     * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
     * @param {boolean} [orderByBidPrice] If true - sort by most recent bid price on lane_carriers instead by order_index
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpOptimizedApi
     */
    RfpOptimizedApi.prototype.rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdCarrierLanesGet = function (rfpLaneOptId, rfpBidOptId, orderByBidPrice, options) {
        var _this = this;
        return (0, exports.RfpOptimizedApiFp)(this.configuration).rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdCarrierLanesGet(rfpLaneOptId, rfpBidOptId, orderByBidPrice, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Set order of RFP carrier lanes given an RFP lane and bid optimized ID
     * @param {string} rfpLaneOptId The id of the RFP Lane Optimized object
     * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
     * @param {Array<InlineObject>} [inlineObject]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpOptimizedApi
     */
    RfpOptimizedApi.prototype.rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdCarrierLanesPut = function (rfpLaneOptId, rfpBidOptId, inlineObject, options) {
        var _this = this;
        return (0, exports.RfpOptimizedApiFp)(this.configuration).rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdCarrierLanesPut(rfpLaneOptId, rfpBidOptId, inlineObject, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Obtain an RFP row given an RFP lane and bid optimized ID
     * @param {string} rfpLaneOptId The id of the RFP Lane Optimized object
     * @param {string} rfpBidOptId The id of the RFP Bid Optimized object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RfpOptimizedApi
     */
    RfpOptimizedApi.prototype.rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdGet = function (rfpLaneOptId, rfpBidOptId, options) {
        var _this = this;
        return (0, exports.RfpOptimizedApiFp)(this.configuration).rfpOptimizedRfpBidOptRfpBidOptIdRfpLaneOptsRfpLaneOptIdGet(rfpLaneOptId, rfpBidOptId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RfpOptimizedApi;
}(base_1.BaseAPI));
exports.RfpOptimizedApi = RfpOptimizedApi;
/**
 * ServiceLevelAgreementsApi - axios parameter creator
 * @export
 */
var ServiceLevelAgreementsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary List service level agreements
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {'ACTIVE' | 'INACTIVE'} [status] Include ServiceLevelAgreements where status is exactly this string
         * @param {string} [name] Include ServiceLevelAgreements where name matches this string
         * @param {'PRIMARY' | 'SECONDARY' | 'TERTIARY' | 'BACKUP'} [position] Include ServiceLevelAgreements where position is exactly this string
         * @param {string} [startDateGte] Include ServiceLevelAgreements where start date is greater than or equal to this date
         * @param {string} [startDateLte] Include ServiceLevelAgreements where start date is less than or equal to this date
         * @param {string} [endDateGte] Include ServiceLevelAgreements where end date is greater than or equal to this date
         * @param {string} [endDateLte] Include ServiceLevelAgreements where end date is less than or equal to this date
         * @param {number} [awardedLoadsPerDay] Include ServiceLevelAgreements where awarded loads per day is exactly this value
         * @param {number} [capacityPerDay] Include ServiceLevelAgreements where capacity per day is exactly this value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceLevelAgreementsGet: function (page, pageSize, ordering, q, status, name, position, startDateGte, startDateLte, endDateGte, endDateLte, awardedLoadsPerDay, capacityPerDay, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/service-level-agreements/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (status !== undefined) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (name !== undefined) {
                                localVarQueryParameter['name'] = name;
                            }
                            if (position !== undefined) {
                                localVarQueryParameter['position'] = position;
                            }
                            if (startDateGte !== undefined) {
                                localVarQueryParameter['start_date__gte'] = (startDateGte instanceof Date) ?
                                    startDateGte.toISOString().substr(0, 10) :
                                    startDateGte;
                            }
                            if (startDateLte !== undefined) {
                                localVarQueryParameter['start_date__lte'] = (startDateLte instanceof Date) ?
                                    startDateLte.toISOString().substr(0, 10) :
                                    startDateLte;
                            }
                            if (endDateGte !== undefined) {
                                localVarQueryParameter['end_date__gte'] = (endDateGte instanceof Date) ?
                                    endDateGte.toISOString().substr(0, 10) :
                                    endDateGte;
                            }
                            if (endDateLte !== undefined) {
                                localVarQueryParameter['end_date__lte'] = (endDateLte instanceof Date) ?
                                    endDateLte.toISOString().substr(0, 10) :
                                    endDateLte;
                            }
                            if (awardedLoadsPerDay !== undefined) {
                                localVarQueryParameter['awarded_loads_per_day'] = awardedLoadsPerDay;
                            }
                            if (capacityPerDay !== undefined) {
                                localVarQueryParameter['capacity_per_day'] = capacityPerDay;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new ServiceLevelAgreement
         * @param {ServiceLevelAgreement} serviceLevelAgreement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceLevelAgreementsPost: function (serviceLevelAgreement, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'serviceLevelAgreement' is not null or undefined
                            (0, common_1.assertParamExists)('serviceLevelAgreementsPost', 'serviceLevelAgreement', serviceLevelAgreement);
                            localVarPath = "/service-level-agreements/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(serviceLevelAgreement, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a ServiceLevelAgreement
         * @param {string} serviceLevelAgreementId The id of a service level agreement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceLevelAgreementsServiceLevelAgreementIdDelete: function (serviceLevelAgreementId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'serviceLevelAgreementId' is not null or undefined
                            (0, common_1.assertParamExists)('serviceLevelAgreementsServiceLevelAgreementIdDelete', 'serviceLevelAgreementId', serviceLevelAgreementId);
                            localVarPath = "/service-level-agreements/{serviceLevelAgreementId}/"
                                .replace("{".concat("serviceLevelAgreementId", "}"), encodeURIComponent(String(serviceLevelAgreementId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a ServiceLevelAgreement
         * @param {string} serviceLevelAgreementId The id of a service level agreement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceLevelAgreementsServiceLevelAgreementIdGet: function (serviceLevelAgreementId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'serviceLevelAgreementId' is not null or undefined
                            (0, common_1.assertParamExists)('serviceLevelAgreementsServiceLevelAgreementIdGet', 'serviceLevelAgreementId', serviceLevelAgreementId);
                            localVarPath = "/service-level-agreements/{serviceLevelAgreementId}/"
                                .replace("{".concat("serviceLevelAgreementId", "}"), encodeURIComponent(String(serviceLevelAgreementId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a ServiceLevelAgreement
         * @param {string} serviceLevelAgreementId The id of a service level agreement
         * @param {ServiceLevelAgreement} serviceLevelAgreement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceLevelAgreementsServiceLevelAgreementIdPut: function (serviceLevelAgreementId, serviceLevelAgreement, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'serviceLevelAgreementId' is not null or undefined
                            (0, common_1.assertParamExists)('serviceLevelAgreementsServiceLevelAgreementIdPut', 'serviceLevelAgreementId', serviceLevelAgreementId);
                            // verify required parameter 'serviceLevelAgreement' is not null or undefined
                            (0, common_1.assertParamExists)('serviceLevelAgreementsServiceLevelAgreementIdPut', 'serviceLevelAgreement', serviceLevelAgreement);
                            localVarPath = "/service-level-agreements/{serviceLevelAgreementId}/"
                                .replace("{".concat("serviceLevelAgreementId", "}"), encodeURIComponent(String(serviceLevelAgreementId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(serviceLevelAgreement, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ServiceLevelAgreementsApiAxiosParamCreator = ServiceLevelAgreementsApiAxiosParamCreator;
/**
 * ServiceLevelAgreementsApi - functional programming interface
 * @export
 */
var ServiceLevelAgreementsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ServiceLevelAgreementsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary List service level agreements
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {'ACTIVE' | 'INACTIVE'} [status] Include ServiceLevelAgreements where status is exactly this string
         * @param {string} [name] Include ServiceLevelAgreements where name matches this string
         * @param {'PRIMARY' | 'SECONDARY' | 'TERTIARY' | 'BACKUP'} [position] Include ServiceLevelAgreements where position is exactly this string
         * @param {string} [startDateGte] Include ServiceLevelAgreements where start date is greater than or equal to this date
         * @param {string} [startDateLte] Include ServiceLevelAgreements where start date is less than or equal to this date
         * @param {string} [endDateGte] Include ServiceLevelAgreements where end date is greater than or equal to this date
         * @param {string} [endDateLte] Include ServiceLevelAgreements where end date is less than or equal to this date
         * @param {number} [awardedLoadsPerDay] Include ServiceLevelAgreements where awarded loads per day is exactly this value
         * @param {number} [capacityPerDay] Include ServiceLevelAgreements where capacity per day is exactly this value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceLevelAgreementsGet: function (page, pageSize, ordering, q, status, name, position, startDateGte, startDateLte, endDateGte, endDateLte, awardedLoadsPerDay, capacityPerDay, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.serviceLevelAgreementsGet(page, pageSize, ordering, q, status, name, position, startDateGte, startDateLte, endDateGte, endDateLte, awardedLoadsPerDay, capacityPerDay, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new ServiceLevelAgreement
         * @param {ServiceLevelAgreement} serviceLevelAgreement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceLevelAgreementsPost: function (serviceLevelAgreement, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.serviceLevelAgreementsPost(serviceLevelAgreement, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a ServiceLevelAgreement
         * @param {string} serviceLevelAgreementId The id of a service level agreement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceLevelAgreementsServiceLevelAgreementIdDelete: function (serviceLevelAgreementId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.serviceLevelAgreementsServiceLevelAgreementIdDelete(serviceLevelAgreementId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a ServiceLevelAgreement
         * @param {string} serviceLevelAgreementId The id of a service level agreement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceLevelAgreementsServiceLevelAgreementIdGet: function (serviceLevelAgreementId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.serviceLevelAgreementsServiceLevelAgreementIdGet(serviceLevelAgreementId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a ServiceLevelAgreement
         * @param {string} serviceLevelAgreementId The id of a service level agreement
         * @param {ServiceLevelAgreement} serviceLevelAgreement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceLevelAgreementsServiceLevelAgreementIdPut: function (serviceLevelAgreementId, serviceLevelAgreement, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.serviceLevelAgreementsServiceLevelAgreementIdPut(serviceLevelAgreementId, serviceLevelAgreement, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ServiceLevelAgreementsApiFp = ServiceLevelAgreementsApiFp;
/**
 * ServiceLevelAgreementsApi - factory interface
 * @export
 */
var ServiceLevelAgreementsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ServiceLevelAgreementsApiFp)(configuration);
    return {
        /**
         *
         * @summary List service level agreements
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {'ACTIVE' | 'INACTIVE'} [status] Include ServiceLevelAgreements where status is exactly this string
         * @param {string} [name] Include ServiceLevelAgreements where name matches this string
         * @param {'PRIMARY' | 'SECONDARY' | 'TERTIARY' | 'BACKUP'} [position] Include ServiceLevelAgreements where position is exactly this string
         * @param {string} [startDateGte] Include ServiceLevelAgreements where start date is greater than or equal to this date
         * @param {string} [startDateLte] Include ServiceLevelAgreements where start date is less than or equal to this date
         * @param {string} [endDateGte] Include ServiceLevelAgreements where end date is greater than or equal to this date
         * @param {string} [endDateLte] Include ServiceLevelAgreements where end date is less than or equal to this date
         * @param {number} [awardedLoadsPerDay] Include ServiceLevelAgreements where awarded loads per day is exactly this value
         * @param {number} [capacityPerDay] Include ServiceLevelAgreements where capacity per day is exactly this value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceLevelAgreementsGet: function (page, pageSize, ordering, q, status, name, position, startDateGte, startDateLte, endDateGte, endDateLte, awardedLoadsPerDay, capacityPerDay, options) {
            return localVarFp.serviceLevelAgreementsGet(page, pageSize, ordering, q, status, name, position, startDateGte, startDateLte, endDateGte, endDateLte, awardedLoadsPerDay, capacityPerDay, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new ServiceLevelAgreement
         * @param {ServiceLevelAgreement} serviceLevelAgreement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceLevelAgreementsPost: function (serviceLevelAgreement, options) {
            return localVarFp.serviceLevelAgreementsPost(serviceLevelAgreement, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a ServiceLevelAgreement
         * @param {string} serviceLevelAgreementId The id of a service level agreement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceLevelAgreementsServiceLevelAgreementIdDelete: function (serviceLevelAgreementId, options) {
            return localVarFp.serviceLevelAgreementsServiceLevelAgreementIdDelete(serviceLevelAgreementId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a ServiceLevelAgreement
         * @param {string} serviceLevelAgreementId The id of a service level agreement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceLevelAgreementsServiceLevelAgreementIdGet: function (serviceLevelAgreementId, options) {
            return localVarFp.serviceLevelAgreementsServiceLevelAgreementIdGet(serviceLevelAgreementId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a ServiceLevelAgreement
         * @param {string} serviceLevelAgreementId The id of a service level agreement
         * @param {ServiceLevelAgreement} serviceLevelAgreement
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceLevelAgreementsServiceLevelAgreementIdPut: function (serviceLevelAgreementId, serviceLevelAgreement, options) {
            return localVarFp.serviceLevelAgreementsServiceLevelAgreementIdPut(serviceLevelAgreementId, serviceLevelAgreement, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ServiceLevelAgreementsApiFactory = ServiceLevelAgreementsApiFactory;
/**
 * ServiceLevelAgreementsApi - object-oriented interface
 * @export
 * @class ServiceLevelAgreementsApi
 * @extends {BaseAPI}
 */
var ServiceLevelAgreementsApi = /** @class */ (function (_super) {
    __extends(ServiceLevelAgreementsApi, _super);
    function ServiceLevelAgreementsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary List service level agreements
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {'ACTIVE' | 'INACTIVE'} [status] Include ServiceLevelAgreements where status is exactly this string
     * @param {string} [name] Include ServiceLevelAgreements where name matches this string
     * @param {'PRIMARY' | 'SECONDARY' | 'TERTIARY' | 'BACKUP'} [position] Include ServiceLevelAgreements where position is exactly this string
     * @param {string} [startDateGte] Include ServiceLevelAgreements where start date is greater than or equal to this date
     * @param {string} [startDateLte] Include ServiceLevelAgreements where start date is less than or equal to this date
     * @param {string} [endDateGte] Include ServiceLevelAgreements where end date is greater than or equal to this date
     * @param {string} [endDateLte] Include ServiceLevelAgreements where end date is less than or equal to this date
     * @param {number} [awardedLoadsPerDay] Include ServiceLevelAgreements where awarded loads per day is exactly this value
     * @param {number} [capacityPerDay] Include ServiceLevelAgreements where capacity per day is exactly this value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLevelAgreementsApi
     */
    ServiceLevelAgreementsApi.prototype.serviceLevelAgreementsGet = function (page, pageSize, ordering, q, status, name, position, startDateGte, startDateLte, endDateGte, endDateLte, awardedLoadsPerDay, capacityPerDay, options) {
        var _this = this;
        return (0, exports.ServiceLevelAgreementsApiFp)(this.configuration).serviceLevelAgreementsGet(page, pageSize, ordering, q, status, name, position, startDateGte, startDateLte, endDateGte, endDateLte, awardedLoadsPerDay, capacityPerDay, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new ServiceLevelAgreement
     * @param {ServiceLevelAgreement} serviceLevelAgreement
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLevelAgreementsApi
     */
    ServiceLevelAgreementsApi.prototype.serviceLevelAgreementsPost = function (serviceLevelAgreement, options) {
        var _this = this;
        return (0, exports.ServiceLevelAgreementsApiFp)(this.configuration).serviceLevelAgreementsPost(serviceLevelAgreement, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a ServiceLevelAgreement
     * @param {string} serviceLevelAgreementId The id of a service level agreement
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLevelAgreementsApi
     */
    ServiceLevelAgreementsApi.prototype.serviceLevelAgreementsServiceLevelAgreementIdDelete = function (serviceLevelAgreementId, options) {
        var _this = this;
        return (0, exports.ServiceLevelAgreementsApiFp)(this.configuration).serviceLevelAgreementsServiceLevelAgreementIdDelete(serviceLevelAgreementId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a ServiceLevelAgreement
     * @param {string} serviceLevelAgreementId The id of a service level agreement
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLevelAgreementsApi
     */
    ServiceLevelAgreementsApi.prototype.serviceLevelAgreementsServiceLevelAgreementIdGet = function (serviceLevelAgreementId, options) {
        var _this = this;
        return (0, exports.ServiceLevelAgreementsApiFp)(this.configuration).serviceLevelAgreementsServiceLevelAgreementIdGet(serviceLevelAgreementId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a ServiceLevelAgreement
     * @param {string} serviceLevelAgreementId The id of a service level agreement
     * @param {ServiceLevelAgreement} serviceLevelAgreement
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceLevelAgreementsApi
     */
    ServiceLevelAgreementsApi.prototype.serviceLevelAgreementsServiceLevelAgreementIdPut = function (serviceLevelAgreementId, serviceLevelAgreement, options) {
        var _this = this;
        return (0, exports.ServiceLevelAgreementsApiFp)(this.configuration).serviceLevelAgreementsServiceLevelAgreementIdPut(serviceLevelAgreementId, serviceLevelAgreement, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ServiceLevelAgreementsApi;
}(base_1.BaseAPI));
exports.ServiceLevelAgreementsApi = ServiceLevelAgreementsApi;
/**
 * ServiceProvidersApi - axios parameter creator
 * @export
 */
var ServiceProvidersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [tagsContains] Return objects where one of the tags contains this string
         * @param {string} [contactsContains] Return objects where a point of contact contains this string in their name or email
         * @param {string} [name] Service provider name equals this value
         * @param {string} [nameContains] Service Provider name contains this value
         * @param {string} [mailingAddressContains] Return objects where the Service Provider mailing address contains this string
         * @param {string} [billingAddressContains] Return objects where the Service Provider billing address contains this string
         * @param {Array<string>} [capabilities] Return objects with these (exact) capabilities
         * @param {string} [capabilitiesContains] Return objects where the Service Provider capabilities contain this string
         * @param {'ACTIVE' | 'INACTIVE'} [status] Service provider status equals this value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersGet: function (page, pageSize, ordering, q, tagsContains, contactsContains, name, nameContains, mailingAddressContains, billingAddressContains, capabilities, capabilitiesContains, status, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/service-providers/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (tagsContains !== undefined) {
                                localVarQueryParameter['tags__contains'] = tagsContains;
                            }
                            if (contactsContains !== undefined) {
                                localVarQueryParameter['contacts__contains'] = contactsContains;
                            }
                            if (name !== undefined) {
                                localVarQueryParameter['name'] = name;
                            }
                            if (nameContains !== undefined) {
                                localVarQueryParameter['name__contains'] = nameContains;
                            }
                            if (mailingAddressContains !== undefined) {
                                localVarQueryParameter['mailing_address__contains'] = mailingAddressContains;
                            }
                            if (billingAddressContains !== undefined) {
                                localVarQueryParameter['billing_address__contains'] = billingAddressContains;
                            }
                            if (capabilities) {
                                localVarQueryParameter['capabilities'] = capabilities;
                            }
                            if (capabilitiesContains !== undefined) {
                                localVarQueryParameter['capabilities__contains'] = capabilitiesContains;
                            }
                            if (status !== undefined) {
                                localVarQueryParameter['status'] = status;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new Service Provider
         * @param {CreateServiceProvider} [createServiceProvider]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersPost: function (createServiceProvider, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/service-providers/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createServiceProvider, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new contact for a Service Provider
         * @param {string} serviceProviderId Service Provider id
         * @param {CreateUpdateServiceProviderContact} [createUpdateServiceProviderContact]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdContactsPost: function (serviceProviderId, createUpdateServiceProviderContact, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'serviceProviderId' is not null or undefined
                            (0, common_1.assertParamExists)('serviceProvidersServiceProviderIdContactsPost', 'serviceProviderId', serviceProviderId);
                            localVarPath = "/service-providers/{serviceProviderId}/contacts"
                                .replace("{".concat("serviceProviderId", "}"), encodeURIComponent(String(serviceProviderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createUpdateServiceProviderContact, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} serviceProviderId Service Provider id
         * @param {string} serviceProviderContactId Service Provider contact id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdContactsServiceProviderContactIdDelete: function (serviceProviderId, serviceProviderContactId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'serviceProviderId' is not null or undefined
                            (0, common_1.assertParamExists)('serviceProvidersServiceProviderIdContactsServiceProviderContactIdDelete', 'serviceProviderId', serviceProviderId);
                            // verify required parameter 'serviceProviderContactId' is not null or undefined
                            (0, common_1.assertParamExists)('serviceProvidersServiceProviderIdContactsServiceProviderContactIdDelete', 'serviceProviderContactId', serviceProviderContactId);
                            localVarPath = "/service-providers/{serviceProviderId}/contacts/{serviceProviderContactId}"
                                .replace("{".concat("serviceProviderId", "}"), encodeURIComponent(String(serviceProviderId)))
                                .replace("{".concat("serviceProviderContactId", "}"), encodeURIComponent(String(serviceProviderContactId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} serviceProviderId Service Provider id
         * @param {string} serviceProviderContactId Service Provider contact id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdContactsServiceProviderContactIdGet: function (serviceProviderId, serviceProviderContactId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'serviceProviderId' is not null or undefined
                            (0, common_1.assertParamExists)('serviceProvidersServiceProviderIdContactsServiceProviderContactIdGet', 'serviceProviderId', serviceProviderId);
                            // verify required parameter 'serviceProviderContactId' is not null or undefined
                            (0, common_1.assertParamExists)('serviceProvidersServiceProviderIdContactsServiceProviderContactIdGet', 'serviceProviderContactId', serviceProviderContactId);
                            localVarPath = "/service-providers/{serviceProviderId}/contacts/{serviceProviderContactId}"
                                .replace("{".concat("serviceProviderId", "}"), encodeURIComponent(String(serviceProviderId)))
                                .replace("{".concat("serviceProviderContactId", "}"), encodeURIComponent(String(serviceProviderContactId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} serviceProviderId Service Provider id
         * @param {string} serviceProviderContactId Service Provider contact id
         * @param {CreateUpdateServiceProviderContact} [createUpdateServiceProviderContact]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdContactsServiceProviderContactIdPut: function (serviceProviderId, serviceProviderContactId, createUpdateServiceProviderContact, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'serviceProviderId' is not null or undefined
                            (0, common_1.assertParamExists)('serviceProvidersServiceProviderIdContactsServiceProviderContactIdPut', 'serviceProviderId', serviceProviderId);
                            // verify required parameter 'serviceProviderContactId' is not null or undefined
                            (0, common_1.assertParamExists)('serviceProvidersServiceProviderIdContactsServiceProviderContactIdPut', 'serviceProviderContactId', serviceProviderContactId);
                            localVarPath = "/service-providers/{serviceProviderId}/contacts/{serviceProviderContactId}"
                                .replace("{".concat("serviceProviderId", "}"), encodeURIComponent(String(serviceProviderId)))
                                .replace("{".concat("serviceProviderContactId", "}"), encodeURIComponent(String(serviceProviderContactId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createUpdateServiceProviderContact, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} serviceProviderId Service Provider id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdDelete: function (serviceProviderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'serviceProviderId' is not null or undefined
                            (0, common_1.assertParamExists)('serviceProvidersServiceProviderIdDelete', 'serviceProviderId', serviceProviderId);
                            localVarPath = "/service-providers/{serviceProviderId}"
                                .replace("{".concat("serviceProviderId", "}"), encodeURIComponent(String(serviceProviderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} serviceProviderId Service Provider id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdGet: function (serviceProviderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'serviceProviderId' is not null or undefined
                            (0, common_1.assertParamExists)('serviceProvidersServiceProviderIdGet', 'serviceProviderId', serviceProviderId);
                            localVarPath = "/service-providers/{serviceProviderId}"
                                .replace("{".concat("serviceProviderId", "}"), encodeURIComponent(String(serviceProviderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} serviceProviderId Service Provider id
         * @param {UpdateServiceProvider} [updateServiceProvider]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdPut: function (serviceProviderId, updateServiceProvider, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'serviceProviderId' is not null or undefined
                            (0, common_1.assertParamExists)('serviceProvidersServiceProviderIdPut', 'serviceProviderId', serviceProviderId);
                            localVarPath = "/service-providers/{serviceProviderId}"
                                .replace("{".concat("serviceProviderId", "}"), encodeURIComponent(String(serviceProviderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateServiceProvider, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} serviceProviderId Service Provider id
         * @param {AddServiceProviderTag} [addServiceProviderTag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdTagsPost: function (serviceProviderId, addServiceProviderTag, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'serviceProviderId' is not null or undefined
                            (0, common_1.assertParamExists)('serviceProvidersServiceProviderIdTagsPost', 'serviceProviderId', serviceProviderId);
                            localVarPath = "/service-providers/{serviceProviderId}/tags"
                                .replace("{".concat("serviceProviderId", "}"), encodeURIComponent(String(serviceProviderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(addServiceProviderTag, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} serviceProviderId Service Provider id
         * @param {string} serviceProviderTagId Service Provider tag id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdTagsServiceProviderTagIdDelete: function (serviceProviderId, serviceProviderTagId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'serviceProviderId' is not null or undefined
                            (0, common_1.assertParamExists)('serviceProvidersServiceProviderIdTagsServiceProviderTagIdDelete', 'serviceProviderId', serviceProviderId);
                            // verify required parameter 'serviceProviderTagId' is not null or undefined
                            (0, common_1.assertParamExists)('serviceProvidersServiceProviderIdTagsServiceProviderTagIdDelete', 'serviceProviderTagId', serviceProviderTagId);
                            localVarPath = "/service-providers/{serviceProviderId}/tags/{serviceProviderTagId}"
                                .replace("{".concat("serviceProviderId", "}"), encodeURIComponent(String(serviceProviderId)))
                                .replace("{".concat("serviceProviderTagId", "}"), encodeURIComponent(String(serviceProviderTagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ServiceProvidersApiAxiosParamCreator = ServiceProvidersApiAxiosParamCreator;
/**
 * ServiceProvidersApi - functional programming interface
 * @export
 */
var ServiceProvidersApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ServiceProvidersApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [tagsContains] Return objects where one of the tags contains this string
         * @param {string} [contactsContains] Return objects where a point of contact contains this string in their name or email
         * @param {string} [name] Service provider name equals this value
         * @param {string} [nameContains] Service Provider name contains this value
         * @param {string} [mailingAddressContains] Return objects where the Service Provider mailing address contains this string
         * @param {string} [billingAddressContains] Return objects where the Service Provider billing address contains this string
         * @param {Array<string>} [capabilities] Return objects with these (exact) capabilities
         * @param {string} [capabilitiesContains] Return objects where the Service Provider capabilities contain this string
         * @param {'ACTIVE' | 'INACTIVE'} [status] Service provider status equals this value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersGet: function (page, pageSize, ordering, q, tagsContains, contactsContains, name, nameContains, mailingAddressContains, billingAddressContains, capabilities, capabilitiesContains, status, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.serviceProvidersGet(page, pageSize, ordering, q, tagsContains, contactsContains, name, nameContains, mailingAddressContains, billingAddressContains, capabilities, capabilitiesContains, status, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new Service Provider
         * @param {CreateServiceProvider} [createServiceProvider]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersPost: function (createServiceProvider, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.serviceProvidersPost(createServiceProvider, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new contact for a Service Provider
         * @param {string} serviceProviderId Service Provider id
         * @param {CreateUpdateServiceProviderContact} [createUpdateServiceProviderContact]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdContactsPost: function (serviceProviderId, createUpdateServiceProviderContact, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.serviceProvidersServiceProviderIdContactsPost(serviceProviderId, createUpdateServiceProviderContact, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} serviceProviderId Service Provider id
         * @param {string} serviceProviderContactId Service Provider contact id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdContactsServiceProviderContactIdDelete: function (serviceProviderId, serviceProviderContactId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.serviceProvidersServiceProviderIdContactsServiceProviderContactIdDelete(serviceProviderId, serviceProviderContactId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} serviceProviderId Service Provider id
         * @param {string} serviceProviderContactId Service Provider contact id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdContactsServiceProviderContactIdGet: function (serviceProviderId, serviceProviderContactId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.serviceProvidersServiceProviderIdContactsServiceProviderContactIdGet(serviceProviderId, serviceProviderContactId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} serviceProviderId Service Provider id
         * @param {string} serviceProviderContactId Service Provider contact id
         * @param {CreateUpdateServiceProviderContact} [createUpdateServiceProviderContact]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdContactsServiceProviderContactIdPut: function (serviceProviderId, serviceProviderContactId, createUpdateServiceProviderContact, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.serviceProvidersServiceProviderIdContactsServiceProviderContactIdPut(serviceProviderId, serviceProviderContactId, createUpdateServiceProviderContact, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} serviceProviderId Service Provider id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdDelete: function (serviceProviderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.serviceProvidersServiceProviderIdDelete(serviceProviderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} serviceProviderId Service Provider id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdGet: function (serviceProviderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.serviceProvidersServiceProviderIdGet(serviceProviderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} serviceProviderId Service Provider id
         * @param {UpdateServiceProvider} [updateServiceProvider]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdPut: function (serviceProviderId, updateServiceProvider, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.serviceProvidersServiceProviderIdPut(serviceProviderId, updateServiceProvider, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} serviceProviderId Service Provider id
         * @param {AddServiceProviderTag} [addServiceProviderTag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdTagsPost: function (serviceProviderId, addServiceProviderTag, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.serviceProvidersServiceProviderIdTagsPost(serviceProviderId, addServiceProviderTag, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} serviceProviderId Service Provider id
         * @param {string} serviceProviderTagId Service Provider tag id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdTagsServiceProviderTagIdDelete: function (serviceProviderId, serviceProviderTagId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.serviceProvidersServiceProviderIdTagsServiceProviderTagIdDelete(serviceProviderId, serviceProviderTagId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ServiceProvidersApiFp = ServiceProvidersApiFp;
/**
 * ServiceProvidersApi - factory interface
 * @export
 */
var ServiceProvidersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ServiceProvidersApiFp)(configuration);
    return {
        /**
         *
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [tagsContains] Return objects where one of the tags contains this string
         * @param {string} [contactsContains] Return objects where a point of contact contains this string in their name or email
         * @param {string} [name] Service provider name equals this value
         * @param {string} [nameContains] Service Provider name contains this value
         * @param {string} [mailingAddressContains] Return objects where the Service Provider mailing address contains this string
         * @param {string} [billingAddressContains] Return objects where the Service Provider billing address contains this string
         * @param {Array<string>} [capabilities] Return objects with these (exact) capabilities
         * @param {string} [capabilitiesContains] Return objects where the Service Provider capabilities contain this string
         * @param {'ACTIVE' | 'INACTIVE'} [status] Service provider status equals this value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersGet: function (page, pageSize, ordering, q, tagsContains, contactsContains, name, nameContains, mailingAddressContains, billingAddressContains, capabilities, capabilitiesContains, status, options) {
            return localVarFp.serviceProvidersGet(page, pageSize, ordering, q, tagsContains, contactsContains, name, nameContains, mailingAddressContains, billingAddressContains, capabilities, capabilitiesContains, status, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new Service Provider
         * @param {CreateServiceProvider} [createServiceProvider]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersPost: function (createServiceProvider, options) {
            return localVarFp.serviceProvidersPost(createServiceProvider, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new contact for a Service Provider
         * @param {string} serviceProviderId Service Provider id
         * @param {CreateUpdateServiceProviderContact} [createUpdateServiceProviderContact]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdContactsPost: function (serviceProviderId, createUpdateServiceProviderContact, options) {
            return localVarFp.serviceProvidersServiceProviderIdContactsPost(serviceProviderId, createUpdateServiceProviderContact, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} serviceProviderId Service Provider id
         * @param {string} serviceProviderContactId Service Provider contact id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdContactsServiceProviderContactIdDelete: function (serviceProviderId, serviceProviderContactId, options) {
            return localVarFp.serviceProvidersServiceProviderIdContactsServiceProviderContactIdDelete(serviceProviderId, serviceProviderContactId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} serviceProviderId Service Provider id
         * @param {string} serviceProviderContactId Service Provider contact id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdContactsServiceProviderContactIdGet: function (serviceProviderId, serviceProviderContactId, options) {
            return localVarFp.serviceProvidersServiceProviderIdContactsServiceProviderContactIdGet(serviceProviderId, serviceProviderContactId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} serviceProviderId Service Provider id
         * @param {string} serviceProviderContactId Service Provider contact id
         * @param {CreateUpdateServiceProviderContact} [createUpdateServiceProviderContact]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdContactsServiceProviderContactIdPut: function (serviceProviderId, serviceProviderContactId, createUpdateServiceProviderContact, options) {
            return localVarFp.serviceProvidersServiceProviderIdContactsServiceProviderContactIdPut(serviceProviderId, serviceProviderContactId, createUpdateServiceProviderContact, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} serviceProviderId Service Provider id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdDelete: function (serviceProviderId, options) {
            return localVarFp.serviceProvidersServiceProviderIdDelete(serviceProviderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} serviceProviderId Service Provider id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdGet: function (serviceProviderId, options) {
            return localVarFp.serviceProvidersServiceProviderIdGet(serviceProviderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} serviceProviderId Service Provider id
         * @param {UpdateServiceProvider} [updateServiceProvider]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdPut: function (serviceProviderId, updateServiceProvider, options) {
            return localVarFp.serviceProvidersServiceProviderIdPut(serviceProviderId, updateServiceProvider, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} serviceProviderId Service Provider id
         * @param {AddServiceProviderTag} [addServiceProviderTag]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdTagsPost: function (serviceProviderId, addServiceProviderTag, options) {
            return localVarFp.serviceProvidersServiceProviderIdTagsPost(serviceProviderId, addServiceProviderTag, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} serviceProviderId Service Provider id
         * @param {string} serviceProviderTagId Service Provider tag id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        serviceProvidersServiceProviderIdTagsServiceProviderTagIdDelete: function (serviceProviderId, serviceProviderTagId, options) {
            return localVarFp.serviceProvidersServiceProviderIdTagsServiceProviderTagIdDelete(serviceProviderId, serviceProviderTagId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ServiceProvidersApiFactory = ServiceProvidersApiFactory;
/**
 * ServiceProvidersApi - object-oriented interface
 * @export
 * @class ServiceProvidersApi
 * @extends {BaseAPI}
 */
var ServiceProvidersApi = /** @class */ (function (_super) {
    __extends(ServiceProvidersApi, _super);
    function ServiceProvidersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {string} [tagsContains] Return objects where one of the tags contains this string
     * @param {string} [contactsContains] Return objects where a point of contact contains this string in their name or email
     * @param {string} [name] Service provider name equals this value
     * @param {string} [nameContains] Service Provider name contains this value
     * @param {string} [mailingAddressContains] Return objects where the Service Provider mailing address contains this string
     * @param {string} [billingAddressContains] Return objects where the Service Provider billing address contains this string
     * @param {Array<string>} [capabilities] Return objects with these (exact) capabilities
     * @param {string} [capabilitiesContains] Return objects where the Service Provider capabilities contain this string
     * @param {'ACTIVE' | 'INACTIVE'} [status] Service provider status equals this value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceProvidersApi
     */
    ServiceProvidersApi.prototype.serviceProvidersGet = function (page, pageSize, ordering, q, tagsContains, contactsContains, name, nameContains, mailingAddressContains, billingAddressContains, capabilities, capabilitiesContains, status, options) {
        var _this = this;
        return (0, exports.ServiceProvidersApiFp)(this.configuration).serviceProvidersGet(page, pageSize, ordering, q, tagsContains, contactsContains, name, nameContains, mailingAddressContains, billingAddressContains, capabilities, capabilitiesContains, status, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new Service Provider
     * @param {CreateServiceProvider} [createServiceProvider]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceProvidersApi
     */
    ServiceProvidersApi.prototype.serviceProvidersPost = function (createServiceProvider, options) {
        var _this = this;
        return (0, exports.ServiceProvidersApiFp)(this.configuration).serviceProvidersPost(createServiceProvider, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new contact for a Service Provider
     * @param {string} serviceProviderId Service Provider id
     * @param {CreateUpdateServiceProviderContact} [createUpdateServiceProviderContact]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceProvidersApi
     */
    ServiceProvidersApi.prototype.serviceProvidersServiceProviderIdContactsPost = function (serviceProviderId, createUpdateServiceProviderContact, options) {
        var _this = this;
        return (0, exports.ServiceProvidersApiFp)(this.configuration).serviceProvidersServiceProviderIdContactsPost(serviceProviderId, createUpdateServiceProviderContact, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} serviceProviderId Service Provider id
     * @param {string} serviceProviderContactId Service Provider contact id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceProvidersApi
     */
    ServiceProvidersApi.prototype.serviceProvidersServiceProviderIdContactsServiceProviderContactIdDelete = function (serviceProviderId, serviceProviderContactId, options) {
        var _this = this;
        return (0, exports.ServiceProvidersApiFp)(this.configuration).serviceProvidersServiceProviderIdContactsServiceProviderContactIdDelete(serviceProviderId, serviceProviderContactId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} serviceProviderId Service Provider id
     * @param {string} serviceProviderContactId Service Provider contact id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceProvidersApi
     */
    ServiceProvidersApi.prototype.serviceProvidersServiceProviderIdContactsServiceProviderContactIdGet = function (serviceProviderId, serviceProviderContactId, options) {
        var _this = this;
        return (0, exports.ServiceProvidersApiFp)(this.configuration).serviceProvidersServiceProviderIdContactsServiceProviderContactIdGet(serviceProviderId, serviceProviderContactId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} serviceProviderId Service Provider id
     * @param {string} serviceProviderContactId Service Provider contact id
     * @param {CreateUpdateServiceProviderContact} [createUpdateServiceProviderContact]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceProvidersApi
     */
    ServiceProvidersApi.prototype.serviceProvidersServiceProviderIdContactsServiceProviderContactIdPut = function (serviceProviderId, serviceProviderContactId, createUpdateServiceProviderContact, options) {
        var _this = this;
        return (0, exports.ServiceProvidersApiFp)(this.configuration).serviceProvidersServiceProviderIdContactsServiceProviderContactIdPut(serviceProviderId, serviceProviderContactId, createUpdateServiceProviderContact, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} serviceProviderId Service Provider id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceProvidersApi
     */
    ServiceProvidersApi.prototype.serviceProvidersServiceProviderIdDelete = function (serviceProviderId, options) {
        var _this = this;
        return (0, exports.ServiceProvidersApiFp)(this.configuration).serviceProvidersServiceProviderIdDelete(serviceProviderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} serviceProviderId Service Provider id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceProvidersApi
     */
    ServiceProvidersApi.prototype.serviceProvidersServiceProviderIdGet = function (serviceProviderId, options) {
        var _this = this;
        return (0, exports.ServiceProvidersApiFp)(this.configuration).serviceProvidersServiceProviderIdGet(serviceProviderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} serviceProviderId Service Provider id
     * @param {UpdateServiceProvider} [updateServiceProvider]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceProvidersApi
     */
    ServiceProvidersApi.prototype.serviceProvidersServiceProviderIdPut = function (serviceProviderId, updateServiceProvider, options) {
        var _this = this;
        return (0, exports.ServiceProvidersApiFp)(this.configuration).serviceProvidersServiceProviderIdPut(serviceProviderId, updateServiceProvider, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} serviceProviderId Service Provider id
     * @param {AddServiceProviderTag} [addServiceProviderTag]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceProvidersApi
     */
    ServiceProvidersApi.prototype.serviceProvidersServiceProviderIdTagsPost = function (serviceProviderId, addServiceProviderTag, options) {
        var _this = this;
        return (0, exports.ServiceProvidersApiFp)(this.configuration).serviceProvidersServiceProviderIdTagsPost(serviceProviderId, addServiceProviderTag, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} serviceProviderId Service Provider id
     * @param {string} serviceProviderTagId Service Provider tag id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ServiceProvidersApi
     */
    ServiceProvidersApi.prototype.serviceProvidersServiceProviderIdTagsServiceProviderTagIdDelete = function (serviceProviderId, serviceProviderTagId, options) {
        var _this = this;
        return (0, exports.ServiceProvidersApiFp)(this.configuration).serviceProvidersServiceProviderIdTagsServiceProviderTagIdDelete(serviceProviderId, serviceProviderTagId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ServiceProvidersApi;
}(base_1.BaseAPI));
exports.ServiceProvidersApi = ServiceProvidersApi;
/**
 * ShipmentActionsApi - axios parameter creator
 * @export
 */
var ShipmentActionsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Cancel a scheduled pickup
         * @param {string} shipmentPickupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsPickupsShipmentPickupIdCancelPost: function (shipmentPickupId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentPickupId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsPickupsShipmentPickupIdCancelPost', 'shipmentPickupId', shipmentPickupId);
                            localVarPath = "/shipments/pickups/{shipmentPickupId}/cancel/"
                                .replace("{".concat("shipmentPickupId", "}"), encodeURIComponent(String(shipmentPickupId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Award an automated quote to a shipment, assign its carrier, dispatch through carriers API, generate a BOL, and send notifications
         * @param {string} shipmentId The id of the shipment
         * @param {AutoBookRequest} autoBookRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAutoBookPost: function (shipmentId, autoBookRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdAutoBookPost', 'shipmentId', shipmentId);
                            // verify required parameter 'autoBookRequest' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdAutoBookPost', 'autoBookRequest', autoBookRequest);
                            localVarPath = "/shipments/{shipmentId}/auto-book/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(autoBookRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Award a quote to a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {AwardQuoteRequest} awardQuoteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAwardQuotePost: function (shipmentId, awardQuoteRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdAwardQuotePost', 'shipmentId', shipmentId);
                            // verify required parameter 'awardQuoteRequest' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdAwardQuotePost', 'awardQuoteRequest', awardQuoteRequest);
                            localVarPath = "/shipments/{shipmentId}/award-quote/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(awardQuoteRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Cancel a shipment, and notify the currently assigned carrier of cancellation in an email
         * @param {string} shipmentId The id of the shipment
         * @param {CancellationRequest} cancellationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCancelPost: function (shipmentId, cancellationRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdCancelPost', 'shipmentId', shipmentId);
                            // verify required parameter 'cancellationRequest' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdCancelPost', 'cancellationRequest', cancellationRequest);
                            localVarPath = "/shipments/{shipmentId}/cancel/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(cancellationRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Initiate a check call on the given shipment to the provided phone number
         * @param {string} shipmentId The id of the shipment
         * @param {InitiateCheckCallRequest} initiateCheckCallRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdInitiateCheckCallPost: function (shipmentId, initiateCheckCallRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdInitiateCheckCallPost', 'shipmentId', shipmentId);
                            // verify required parameter 'initiateCheckCallRequest' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdInitiateCheckCallPost', 'initiateCheckCallRequest', initiateCheckCallRequest);
                            localVarPath = "/shipments/{shipmentId}/initiate-check-call/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(initiateCheckCallRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Initiate a routing guide workflow for the given shipment
         * @param {string} shipmentId The id of the shipment
         * @param {InitiateRoutingGuideRequest} initiateRoutingGuideRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdRoutingGuideInitiatePost: function (shipmentId, initiateRoutingGuideRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdRoutingGuideInitiatePost', 'shipmentId', shipmentId);
                            // verify required parameter 'initiateRoutingGuideRequest' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdRoutingGuideInitiatePost', 'initiateRoutingGuideRequest', initiateRoutingGuideRequest);
                            localVarPath = "/shipments/{shipmentId}/routing-guide/initiate/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(initiateRoutingGuideRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Trigger sending the shipment booked notification to all applicable actors on a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdSendShipmentBookedGet: function (shipmentId, xCompanyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdSendShipmentBookedGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/send-shipment-booked/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (xCompanyId !== undefined && xCompanyId !== null) {
                                localVarHeaderParameter['X-Company-Id'] = String(xCompanyId);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Share a Shipment with outside parties and get a link to it
         * @param {string} shipmentId The id of the shipment
         * @param {ShareShipment} shareShipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdSharePost: function (shipmentId, shareShipment, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdSharePost', 'shipmentId', shipmentId);
                            // verify required parameter 'shareShipment' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdSharePost', 'shareShipment', shareShipment);
                            localVarPath = "/shipments/{shipmentId}/share/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shareShipment, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ShipmentActionsApiAxiosParamCreator = ShipmentActionsApiAxiosParamCreator;
/**
 * ShipmentActionsApi - functional programming interface
 * @export
 */
var ShipmentActionsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ShipmentActionsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Cancel a scheduled pickup
         * @param {string} shipmentPickupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsPickupsShipmentPickupIdCancelPost: function (shipmentPickupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsPickupsShipmentPickupIdCancelPost(shipmentPickupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Award an automated quote to a shipment, assign its carrier, dispatch through carriers API, generate a BOL, and send notifications
         * @param {string} shipmentId The id of the shipment
         * @param {AutoBookRequest} autoBookRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAutoBookPost: function (shipmentId, autoBookRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdAutoBookPost(shipmentId, autoBookRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Award a quote to a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {AwardQuoteRequest} awardQuoteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAwardQuotePost: function (shipmentId, awardQuoteRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdAwardQuotePost(shipmentId, awardQuoteRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Cancel a shipment, and notify the currently assigned carrier of cancellation in an email
         * @param {string} shipmentId The id of the shipment
         * @param {CancellationRequest} cancellationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCancelPost: function (shipmentId, cancellationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdCancelPost(shipmentId, cancellationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Initiate a check call on the given shipment to the provided phone number
         * @param {string} shipmentId The id of the shipment
         * @param {InitiateCheckCallRequest} initiateCheckCallRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdInitiateCheckCallPost: function (shipmentId, initiateCheckCallRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdInitiateCheckCallPost(shipmentId, initiateCheckCallRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Initiate a routing guide workflow for the given shipment
         * @param {string} shipmentId The id of the shipment
         * @param {InitiateRoutingGuideRequest} initiateRoutingGuideRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdRoutingGuideInitiatePost: function (shipmentId, initiateRoutingGuideRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdRoutingGuideInitiatePost(shipmentId, initiateRoutingGuideRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Trigger sending the shipment booked notification to all applicable actors on a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdSendShipmentBookedGet: function (shipmentId, xCompanyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdSendShipmentBookedGet(shipmentId, xCompanyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Share a Shipment with outside parties and get a link to it
         * @param {string} shipmentId The id of the shipment
         * @param {ShareShipment} shareShipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdSharePost: function (shipmentId, shareShipment, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdSharePost(shipmentId, shareShipment, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ShipmentActionsApiFp = ShipmentActionsApiFp;
/**
 * ShipmentActionsApi - factory interface
 * @export
 */
var ShipmentActionsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ShipmentActionsApiFp)(configuration);
    return {
        /**
         *
         * @summary Cancel a scheduled pickup
         * @param {string} shipmentPickupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsPickupsShipmentPickupIdCancelPost: function (shipmentPickupId, options) {
            return localVarFp.shipmentsPickupsShipmentPickupIdCancelPost(shipmentPickupId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Award an automated quote to a shipment, assign its carrier, dispatch through carriers API, generate a BOL, and send notifications
         * @param {string} shipmentId The id of the shipment
         * @param {AutoBookRequest} autoBookRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAutoBookPost: function (shipmentId, autoBookRequest, options) {
            return localVarFp.shipmentsShipmentIdAutoBookPost(shipmentId, autoBookRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Award a quote to a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {AwardQuoteRequest} awardQuoteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAwardQuotePost: function (shipmentId, awardQuoteRequest, options) {
            return localVarFp.shipmentsShipmentIdAwardQuotePost(shipmentId, awardQuoteRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Cancel a shipment, and notify the currently assigned carrier of cancellation in an email
         * @param {string} shipmentId The id of the shipment
         * @param {CancellationRequest} cancellationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCancelPost: function (shipmentId, cancellationRequest, options) {
            return localVarFp.shipmentsShipmentIdCancelPost(shipmentId, cancellationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Initiate a check call on the given shipment to the provided phone number
         * @param {string} shipmentId The id of the shipment
         * @param {InitiateCheckCallRequest} initiateCheckCallRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdInitiateCheckCallPost: function (shipmentId, initiateCheckCallRequest, options) {
            return localVarFp.shipmentsShipmentIdInitiateCheckCallPost(shipmentId, initiateCheckCallRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Initiate a routing guide workflow for the given shipment
         * @param {string} shipmentId The id of the shipment
         * @param {InitiateRoutingGuideRequest} initiateRoutingGuideRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdRoutingGuideInitiatePost: function (shipmentId, initiateRoutingGuideRequest, options) {
            return localVarFp.shipmentsShipmentIdRoutingGuideInitiatePost(shipmentId, initiateRoutingGuideRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Trigger sending the shipment booked notification to all applicable actors on a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdSendShipmentBookedGet: function (shipmentId, xCompanyId, options) {
            return localVarFp.shipmentsShipmentIdSendShipmentBookedGet(shipmentId, xCompanyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Share a Shipment with outside parties and get a link to it
         * @param {string} shipmentId The id of the shipment
         * @param {ShareShipment} shareShipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdSharePost: function (shipmentId, shareShipment, options) {
            return localVarFp.shipmentsShipmentIdSharePost(shipmentId, shareShipment, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ShipmentActionsApiFactory = ShipmentActionsApiFactory;
/**
 * ShipmentActionsApi - object-oriented interface
 * @export
 * @class ShipmentActionsApi
 * @extends {BaseAPI}
 */
var ShipmentActionsApi = /** @class */ (function (_super) {
    __extends(ShipmentActionsApi, _super);
    function ShipmentActionsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Cancel a scheduled pickup
     * @param {string} shipmentPickupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentActionsApi
     */
    ShipmentActionsApi.prototype.shipmentsPickupsShipmentPickupIdCancelPost = function (shipmentPickupId, options) {
        var _this = this;
        return (0, exports.ShipmentActionsApiFp)(this.configuration).shipmentsPickupsShipmentPickupIdCancelPost(shipmentPickupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Award an automated quote to a shipment, assign its carrier, dispatch through carriers API, generate a BOL, and send notifications
     * @param {string} shipmentId The id of the shipment
     * @param {AutoBookRequest} autoBookRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentActionsApi
     */
    ShipmentActionsApi.prototype.shipmentsShipmentIdAutoBookPost = function (shipmentId, autoBookRequest, options) {
        var _this = this;
        return (0, exports.ShipmentActionsApiFp)(this.configuration).shipmentsShipmentIdAutoBookPost(shipmentId, autoBookRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Award a quote to a shipment
     * @param {string} shipmentId The id of the shipment
     * @param {AwardQuoteRequest} awardQuoteRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentActionsApi
     */
    ShipmentActionsApi.prototype.shipmentsShipmentIdAwardQuotePost = function (shipmentId, awardQuoteRequest, options) {
        var _this = this;
        return (0, exports.ShipmentActionsApiFp)(this.configuration).shipmentsShipmentIdAwardQuotePost(shipmentId, awardQuoteRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Cancel a shipment, and notify the currently assigned carrier of cancellation in an email
     * @param {string} shipmentId The id of the shipment
     * @param {CancellationRequest} cancellationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentActionsApi
     */
    ShipmentActionsApi.prototype.shipmentsShipmentIdCancelPost = function (shipmentId, cancellationRequest, options) {
        var _this = this;
        return (0, exports.ShipmentActionsApiFp)(this.configuration).shipmentsShipmentIdCancelPost(shipmentId, cancellationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Initiate a check call on the given shipment to the provided phone number
     * @param {string} shipmentId The id of the shipment
     * @param {InitiateCheckCallRequest} initiateCheckCallRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentActionsApi
     */
    ShipmentActionsApi.prototype.shipmentsShipmentIdInitiateCheckCallPost = function (shipmentId, initiateCheckCallRequest, options) {
        var _this = this;
        return (0, exports.ShipmentActionsApiFp)(this.configuration).shipmentsShipmentIdInitiateCheckCallPost(shipmentId, initiateCheckCallRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Initiate a routing guide workflow for the given shipment
     * @param {string} shipmentId The id of the shipment
     * @param {InitiateRoutingGuideRequest} initiateRoutingGuideRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentActionsApi
     */
    ShipmentActionsApi.prototype.shipmentsShipmentIdRoutingGuideInitiatePost = function (shipmentId, initiateRoutingGuideRequest, options) {
        var _this = this;
        return (0, exports.ShipmentActionsApiFp)(this.configuration).shipmentsShipmentIdRoutingGuideInitiatePost(shipmentId, initiateRoutingGuideRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Trigger sending the shipment booked notification to all applicable actors on a shipment
     * @param {string} shipmentId The id of the shipment
     * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentActionsApi
     */
    ShipmentActionsApi.prototype.shipmentsShipmentIdSendShipmentBookedGet = function (shipmentId, xCompanyId, options) {
        var _this = this;
        return (0, exports.ShipmentActionsApiFp)(this.configuration).shipmentsShipmentIdSendShipmentBookedGet(shipmentId, xCompanyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Share a Shipment with outside parties and get a link to it
     * @param {string} shipmentId The id of the shipment
     * @param {ShareShipment} shareShipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentActionsApi
     */
    ShipmentActionsApi.prototype.shipmentsShipmentIdSharePost = function (shipmentId, shareShipment, options) {
        var _this = this;
        return (0, exports.ShipmentActionsApiFp)(this.configuration).shipmentsShipmentIdSharePost(shipmentId, shareShipment, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ShipmentActionsApi;
}(base_1.BaseAPI));
exports.ShipmentActionsApi = ShipmentActionsApi;
/**
 * ShipmentMasterListApi - axios parameter creator
 * @export
 */
var ShipmentMasterListApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary List all Fedex custom package types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingFedexPackageTypesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/quoting/fedex/package-types/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ShipmentMasterListApiAxiosParamCreator = ShipmentMasterListApiAxiosParamCreator;
/**
 * ShipmentMasterListApi - functional programming interface
 * @export
 */
var ShipmentMasterListApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ShipmentMasterListApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary List all Fedex custom package types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingFedexPackageTypesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingFedexPackageTypesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ShipmentMasterListApiFp = ShipmentMasterListApiFp;
/**
 * ShipmentMasterListApi - factory interface
 * @export
 */
var ShipmentMasterListApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ShipmentMasterListApiFp)(configuration);
    return {
        /**
         *
         * @summary List all Fedex custom package types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingFedexPackageTypesGet: function (options) {
            return localVarFp.quotingFedexPackageTypesGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ShipmentMasterListApiFactory = ShipmentMasterListApiFactory;
/**
 * ShipmentMasterListApi - object-oriented interface
 * @export
 * @class ShipmentMasterListApi
 * @extends {BaseAPI}
 */
var ShipmentMasterListApi = /** @class */ (function (_super) {
    __extends(ShipmentMasterListApi, _super);
    function ShipmentMasterListApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary List all Fedex custom package types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentMasterListApi
     */
    ShipmentMasterListApi.prototype.quotingFedexPackageTypesGet = function (options) {
        var _this = this;
        return (0, exports.ShipmentMasterListApiFp)(this.configuration).quotingFedexPackageTypesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ShipmentMasterListApi;
}(base_1.BaseAPI));
exports.ShipmentMasterListApi = ShipmentMasterListApi;
/**
 * ShipmentsApi - axios parameter creator
 * @export
 */
var ShipmentsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Generate a BOL number for a shipment (Internal Shipwell Microservice use only)
         * @summary Generate BOL Number
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBolNumber: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('generateBolNumber', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/generate-bol-number/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns auction stats for shipments by their shipment id
         * @param {Array<string>} [shipmentId] Shipment ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsAuctionStatsGet: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipments/auction-stats/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (shipmentId) {
                                localVarQueryParameter['shipment_id'] = shipmentId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List all ShipmentTags for the authenticated company for v3 shipment
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsBundlesShipmentIdTagsGet: function (shipmentId, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsBundlesShipmentIdTagsGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/bundles/{shipmentId}/tags/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a ShipmentTag for v3 shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentTagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsBundlesShipmentIdTagsShipmentTagIdDelete: function (shipmentId, shipmentTagId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsBundlesShipmentIdTagsShipmentTagIdDelete', 'shipmentId', shipmentId);
                            // verify required parameter 'shipmentTagId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsBundlesShipmentIdTagsShipmentTagIdDelete', 'shipmentTagId', shipmentTagId);
                            localVarPath = "/shipments/bundles/{shipmentId}/tags/{shipmentTagId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("shipmentTagId", "}"), encodeURIComponent(String(shipmentTagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a ShipmentTag by its id for v3 shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentTagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsBundlesShipmentIdTagsShipmentTagIdGet: function (shipmentId, shipmentTagId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsBundlesShipmentIdTagsShipmentTagIdGet', 'shipmentId', shipmentId);
                            // verify required parameter 'shipmentTagId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsBundlesShipmentIdTagsShipmentTagIdGet', 'shipmentTagId', shipmentTagId);
                            localVarPath = "/shipments/bundles/{shipmentId}/tags/{shipmentTagId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("shipmentTagId", "}"), encodeURIComponent(String(shipmentTagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Add a ShipmentTag to v3 shipment bundle
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentTagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsBundlesShipmentIdTagsShipmentTagIdPost: function (shipmentId, shipmentTagId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsBundlesShipmentIdTagsShipmentTagIdPost', 'shipmentId', shipmentId);
                            // verify required parameter 'shipmentTagId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsBundlesShipmentIdTagsShipmentTagIdPost', 'shipmentTagId', shipmentTagId);
                            localVarPath = "/shipments/bundles/{shipmentId}/tags/{shipmentTagId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("shipmentTagId", "}"), encodeURIComponent(String(shipmentTagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Return a limited amount of shipment details using API Key authentication and query params to search. Returns an empty list if no query params are passed
         * @param {Array<string>} [bolNumber] Include shipments with these BOL Numbers
         * @param {Array<string>} [pickupNumber] Include shipments with these Pickup Numbers
         * @param {Array<string>} [proNumber] Include shipments with these PRO Numbers
         * @param {Array<string>} [purchaseOrderNumber] Include shipments with these PO Numbers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsExternalGet: function (bolNumber, pickupNumber, proNumber, purchaseOrderNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipments/external/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (bolNumber) {
                                localVarQueryParameter['bol_number'] = bolNumber;
                            }
                            if (pickupNumber) {
                                localVarQueryParameter['pickup_number'] = pickupNumber;
                            }
                            if (proNumber) {
                                localVarQueryParameter['pro_number'] = proNumber;
                            }
                            if (purchaseOrderNumber) {
                                localVarQueryParameter['purchase_order_number'] = purchaseOrderNumber;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a limited amount of shipment details using a query param key instead of authentication
         * @param {string} shipmentId The id of the shipment
         * @param {string} key Secret view key authorizing user to see the Shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsExternalShipmentIdGet: function (shipmentId, key, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'shipmentId' is not null or undefined
                    (0, common_1.assertParamExists)('shipmentsExternalShipmentIdGet', 'shipmentId', shipmentId);
                    // verify required parameter 'key' is not null or undefined
                    (0, common_1.assertParamExists)('shipmentsExternalShipmentIdGet', 'key', key);
                    localVarPath = "/shipments/external/{shipmentId}/"
                        .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (key !== undefined) {
                        localVarQueryParameter['key'] = key;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get locations for the shipment using a query param key instead of authentication
         * @param {string} shipmentId The id of the shipment
         * @param {string} key Secret view key authorizing user to see the Shipment
         * @param {string} [beginDatetime] For requesting data starting at a given date
         * @param {string} [endDatetime] For requesting data ending at a given date
         * @param {string} [filterDistance] Applies a distance filter and only returns points greater than filter_distance km apart. To return all, set this to -1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsExternalShipmentIdTrackingGet: function (shipmentId, key, beginDatetime, endDatetime, filterDistance, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'shipmentId' is not null or undefined
                    (0, common_1.assertParamExists)('shipmentsExternalShipmentIdTrackingGet', 'shipmentId', shipmentId);
                    // verify required parameter 'key' is not null or undefined
                    (0, common_1.assertParamExists)('shipmentsExternalShipmentIdTrackingGet', 'key', key);
                    localVarPath = "/shipments/external/{shipmentId}/tracking/"
                        .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (key !== undefined) {
                        localVarQueryParameter['key'] = key;
                    }
                    if (beginDatetime !== undefined) {
                        localVarQueryParameter['beginDatetime'] = (beginDatetime instanceof Date) ?
                            beginDatetime.toISOString() :
                            beginDatetime;
                    }
                    if (endDatetime !== undefined) {
                        localVarQueryParameter['endDatetime'] = (endDatetime instanceof Date) ?
                            endDatetime.toISOString() :
                            endDatetime;
                    }
                    if (filterDistance !== undefined) {
                        localVarQueryParameter['filter_distance'] = filterDistance;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get a list of shipments
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [activeVendorAssignment] Include or exclude shipments with active CarrierAssignments
         * @param {'MOBILE_DEVICE_ALERT' | 'NON_ACTIVE_CARRIER'} [alertTypes] Filter on shipments that have alerts of this type
         * @param {boolean} [alerts] Filter on whether or not a Shipment has alert messages
         * @param {boolean} [archived] Filter on whether or not a shipment is archived
         * @param {Array<string>} [bolNumber] Include shipments with these BOL Numbers
         * @param {string} [bolNumberContains] Return shipments where the BOL number contains this value
         * @param {Array<string>} [bolNumberExclude] Exclude shipments with these BOL Numbers
         * @param {string} [createdAt] For requesting data created at a certain datetime
         * @param {Array<'SHIPWELL_WEB' | 'IMPORT' | 'TENDER' | 'SHIPWELL_WEB_UNAUTH' | 'OTHER'>} [createdBySource] Return shipments created by sources in the array.
         * @param {string} [createdByUserContains] Return shipments where created_by_user object contains this string e.g first_name, last_name or email
         * @param {Array<string>} [createdByUserId] Return shipments where created_by_user_id in the array.
         * @param {string} [createdByUserName] Return shipments where created_by_user_name is exactly this string
         * @param {string} [createdByUserNameContains] Return shipments where created_by_user_name contains this string
         * @param {string} [customer] Return shipments with this exact value as the customer company name
         * @param {string} [customerContains] Return shipments where the customer company name contains this value
         * @param {string} [customerId] Return shipments with this exact id for the customer company
         * @param {Array<string>} [customerReferenceNumber] Include shipments with these Customer Reference Numbers
         * @param {string} [customerReferenceNumberContains] Include shipments where the Customer Reference Numbers contains this value
         * @param {Array<string>} [customerReferenceNumberExclude] Exclude shipments with these Customer Reference Numbers
         * @param {string} [destinationContains] Return shipments with this value in the destination
         * @param {string} [deliveryStopsContains] Return shipments with this value in one of its dropoff stops
         * @param {string} [deliveryStopsCompanyNameContains] Return shipments with this value in one of its delivery stops location company_name
         * @param {string} [destinationStateProvince] Return shipments with this state province on its destination stop
         * @param {string} [deliveryStopsStateProvince] Return shipments with this state province on its delivery stops
         * @param {string} [drayageBookingNumberContains] Include shipments where the drayage booking number contains this value
         * @param {string} [drayageChassisNumberContains] Include shipments where the drayage chassis number contains this value
         * @param {string} [drayageContainerNumberContains] Include shipments where the drayage container number contains this value
         * @param {string} [drayageContainerReturnDateGte] Include shipments where the drayage container return date is greater than or equal to this value
         * @param {string} [drayageContainerReturnDateLte] Include shipments where the drayage container return date is less than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateGte] Include shipments where the drayage estimated arrival date is greater than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateLte] Include shipments where the drayage estimated arrival date is less than or equal to this value
         * @param {string} [drayageLastFreeDateGte] Include shipments where the drayage last free datetime is greater than or equal to this value
         * @param {string} [drayageLastFreeDateLte] Include shipments where the drayage last free datetime is less than or equal to this value
         * @param {string} [drayageReleaseDateGte] Include shipments where the drayage release datetime is greater than or equal to this value
         * @param {string} [drayageReleaseDateLte] Include shipments where the drayage release datetime is less than or equal to this value
         * @param {string} [drayageSealNumberContains] Include shipments where the drayage seal number contains this value
         * @param {boolean} [driverAssigned] Return shipments where the driver is assigned/unassigned
         * @param {string} [dropoffGte] Return shipments with a dropoff stop with a planned date greater than or equal to this value
         * @param {string} [dropoffLte] Return shipments with a dropoff stop with a planned data less than or equal to this value
         * @param {string} [equipmentType] Return shipments with this equipment type
         * @param {string} [equipmentTypeContains] Return shipments where the equipment type contains this value
         * @param {string} [fedexAccount] Return pickups specific to this FedEx account
         * @param {string} [groupId] Group id for a shipment
         * @param {boolean} [hasInvoice] If true, show shipments which have at least one invoice otherwise show those with none.
         * @param {boolean} [hasBill] If true, show shipments which have at least one bill otherwise show those with none.
         * @param {Array<string>} [include] [v3] A list of properties to include in the response resource
         * @param {boolean} [loadBoardEnabled] Filter on whether or not a shipment is posted on the company load board
         * @param {string} [loadBoardId] Return shipments where the load board ID is equal to this value
         * @param {string} [loadBoardIdContains] Return shipments where the load board ID contains this value
         * @param {string} [mode] Return shipments with this shipment mode
         * @param {string} [modeContains] Return shipments where the shipment mode contains this value
         * @param {string} [nameContains] Return shipments where the shipment name contains this value
         * @param {boolean} [open] Filter on whether or not a shipment is open
         * @param {string} [originContains] Return shipments with this value in the origin
         * @param {string} [originStateProvince] Return shipments with this state province on its origin stop
         * @param {string} [pickupStopsStateProvince] Return shipments with this state province on its pickup stops
         * @param {string} [pickupStopsContains] Return shipments with this value in one of its pickup stops
         * @param {string} [pickupStopsCompanyNameContains] Return shipments with this value in one of its pickup stops location company_name
         * @param {Array<'CANCELLED' | 'DELAYED' | 'DELIVERED' | 'IN_TRANSIT' | 'NOT_SCHEDULED' | 'SCHEDULED'>} [parcelPickupStatus] Include shipments where the parcel pickup status equals one of these values
         * @param {string} [pickupGte] Return shipments with a pickup stop with a planned date greater than or equal to this value
         * @param {string} [updatedAtGte] Return shipments updated greater than or equal to this value
         * @param {string} [updatedAtLte] Return shipments updated less than or equal to this value
         * @param {string} [pickupLte] Return shipments with a pickup stop with a planned date less than or equal to this value
         * @param {string} [pickupId] Include shipments currently associated with the provided ShipmentPickup\&#39;s ID
         * @param {Array<string>} [pickupNumber] Include shipments with these Pickup Numbers
         * @param {string} [pickupNumberContains] Include shipments where the Pickup Number contains this value
         * @param {Array<string>} [pickupNumberExclude] Exclude shipments with these Pickup Numbers
         * @param {Array<string>} [proNumber] Include shipments with these PRO Numbers
         * @param {string} [proNumberContains] Return shipments where the PRO number contains this value
         * @param {Array<string>} [proNumberExclude] Exclude shipments with these PRO Numbers
         * @param {string} [powerUnit] Return shipments where this power unit is assigned
         * @param {Array<string>} [purchaseOrderNumber] Include shipments with these PO Numbers
         * @param {string} [purchaseOrderNumberContains] Include shipments where the PO number contains this value
         * @param {Array<string>} [purchaseOrderNumberExclude] Exclude shipments with these PO Numbers
         * @param {Array<string>} [referenceId] Include shipments with these Reference IDs
         * @param {string} [referenceIdContains] Include shipments where the reference ID contains this value
         * @param {Array<string>} [referenceIdExclude] Exclude shipments with these Reference IDs
         * @param {Array<string>} [masterAirWaybill] Include shipments with these Master Air Waybill Numbers
         * @param {string} [masterAirWaybillContains] Include shipments where the Master Air Waybill number contains this value
         * @param {Array<string>} [houseAirWaybill] Include shipments with these House Air Waybill Numbers
         * @param {string} [houseAirWaybillContains] Include shipments where the House Air Waybill number contains this value
         * @param {Array<string>} [reps] Include shipments with these reps
         * @param {'owner_operator'} [role] Get results based on a specific perspective such as owner_operator
         * @param {string} [serviceLevel] Return shipments with this service level
         * @param {Array<string>} [accessorials] Include only shipments with at least one matching ShipmentAccessorial
         * @param {string} [createdAtGte] Include shipments where created_at is greater than or equal to the time value
         * @param {string} [createdAtLte] Include shipments where created_at is less than or equal to this value
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [statusExclude] Exclude shipments with these statuses
         * @param {string} [statusContains] Include shipments where the status contains this string
         * @param {Array<string>} [tags] Include only shipments with at least one matching ShipmentTag
         * @param {Array<string>} [tagsExclude] Excludes shipments with at least one matching tag
         * @param {Array<string>} [shipmentShipwellCustomData] Include shipments that contain these shipment-level custom data values
         * @param {string} [stopsContains] Return shipments with this value in one of its stops
         * @param {string} [stopsCompanyNameContains] Return shipments with this value in one of its stops location company_name
         * @param {string} [stopsStateProvince] Return shipments with this state province on one of its stops
         * @param {string} [timelineLastUpdatedAtGte] Return shipments where last timeline update was greater than or equal to the value or was never updated
         * @param {string} [timelineLastUpdatedAtLte] Return shipments where last timeline update was less than or equal to the value or was never updated
         * @param {'current' | 'upcoming' | 'active' | 'past'} [timeFrame] Return shipments that are within the given time frame. active &#x3D; current + upcoming
         * @param {number} [totalMilesGte] Return shipments with total miles greater than or equal to this value
         * @param {number} [totalMilesLte] Return shipments with total miles less than or equal to this value
         * @param {string} [upsAccount] Return pickups specific to this UPS account
         * @param {string} [vendorId] Return shipments with this exact value as the vendor Carrier id
         * @param {string} [vendorContains] Return shipments where the vendor company name contains this value
         * @param {number} [totalWeightOverrideGte] Return shipments with weight greater than or equal to this value
         * @param {number} [totalWeightOverrideLte] Return shipments with weight less than or equal to this value
         * @param {number} [originRadius] Radius from origin stop
         * @param {number} [originLat] Latitude of location to filter on for origin stop
         * @param {number} [originLon] Longitude of location to filter on for origin stop
         * @param {number} [pickupRadius] Radius from a pickup stop
         * @param {number} [pickupLat] Latitude of location to filter on for pickup stop
         * @param {number} [pickupLon] Longitude of location to filter on for pickup stop
         * @param {number} [destinationRadius] Radius from the destination stop
         * @param {number} [destinationLat] Latitude of location to filter on for destination stop
         * @param {number} [destinationLon] Longitude of location to filter on for destination stop
         * @param {number} [deliveryRadius] Radius from a delivery stop
         * @param {number} [deliveryLat] Latitude of location to filter on for delivery stop
         * @param {number} [deliveryLon] Longitude of location to filter on for delivery stop
         * @param {Array<'RUNNING' | 'CANCELLED' | 'FAILED' | 'SUCCESS'>} [workflowExecutionStatus] Include shipments with these workflow execution statuses
         * @param {boolean} [showClonedResults] If true, show shipments that have a non null last_cloned_at value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsGet: function (xCompanyId, page, pageSize, ordering, q, activeVendorAssignment, alertTypes, alerts, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, updatedAtGte, updatedAtLte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, accessorials, createdAtGte, createdAtLte, status, statusExclude, statusContains, tags, tagsExclude, shipmentShipwellCustomData, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, workflowExecutionStatus, showClonedResults, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipments/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (activeVendorAssignment !== undefined) {
                                localVarQueryParameter['active_vendor_assignment'] = activeVendorAssignment;
                            }
                            if (alertTypes !== undefined) {
                                localVarQueryParameter['alert_types'] = alertTypes;
                            }
                            if (alerts !== undefined) {
                                localVarQueryParameter['alerts'] = alerts;
                            }
                            if (archived !== undefined) {
                                localVarQueryParameter['archived'] = archived;
                            }
                            if (bolNumber) {
                                localVarQueryParameter['bol_number'] = bolNumber;
                            }
                            if (bolNumberContains !== undefined) {
                                localVarQueryParameter['bol_number__contains'] = bolNumberContains;
                            }
                            if (bolNumberExclude) {
                                localVarQueryParameter['bol_number__exclude'] = bolNumberExclude;
                            }
                            if (createdAt !== undefined) {
                                localVarQueryParameter['created_at'] = (createdAt instanceof Date) ?
                                    createdAt.toISOString() :
                                    createdAt;
                            }
                            if (createdBySource) {
                                localVarQueryParameter['created_by_source'] = createdBySource;
                            }
                            if (createdByUserContains !== undefined) {
                                localVarQueryParameter['created_by_user__contains'] = createdByUserContains;
                            }
                            if (createdByUserId) {
                                localVarQueryParameter['created_by_user_id'] = createdByUserId;
                            }
                            if (createdByUserName !== undefined) {
                                localVarQueryParameter['created_by_user_name'] = createdByUserName;
                            }
                            if (createdByUserNameContains !== undefined) {
                                localVarQueryParameter['created_by_user_name__contains'] = createdByUserNameContains;
                            }
                            if (customer !== undefined) {
                                localVarQueryParameter['customer'] = customer;
                            }
                            if (customerContains !== undefined) {
                                localVarQueryParameter['customer__contains'] = customerContains;
                            }
                            if (customerId !== undefined) {
                                localVarQueryParameter['customer_id'] = customerId;
                            }
                            if (customerReferenceNumber) {
                                localVarQueryParameter['customer_reference_number'] = customerReferenceNumber;
                            }
                            if (customerReferenceNumberContains !== undefined) {
                                localVarQueryParameter['customer_reference_number__contains'] = customerReferenceNumberContains;
                            }
                            if (customerReferenceNumberExclude) {
                                localVarQueryParameter['customer_reference_number__exclude'] = customerReferenceNumberExclude;
                            }
                            if (destinationContains !== undefined) {
                                localVarQueryParameter['destination__contains'] = destinationContains;
                            }
                            if (deliveryStopsContains !== undefined) {
                                localVarQueryParameter['delivery_stops__contains'] = deliveryStopsContains;
                            }
                            if (deliveryStopsCompanyNameContains !== undefined) {
                                localVarQueryParameter['delivery_stops_company_name__contains'] = deliveryStopsCompanyNameContains;
                            }
                            if (destinationStateProvince !== undefined) {
                                localVarQueryParameter['destination_state_province'] = destinationStateProvince;
                            }
                            if (deliveryStopsStateProvince !== undefined) {
                                localVarQueryParameter['delivery_stops_state_province'] = deliveryStopsStateProvince;
                            }
                            if (drayageBookingNumberContains !== undefined) {
                                localVarQueryParameter['drayage_booking_number__contains'] = drayageBookingNumberContains;
                            }
                            if (drayageChassisNumberContains !== undefined) {
                                localVarQueryParameter['drayage_chassis_number__contains'] = drayageChassisNumberContains;
                            }
                            if (drayageContainerNumberContains !== undefined) {
                                localVarQueryParameter['drayage_container_number__contains'] = drayageContainerNumberContains;
                            }
                            if (drayageContainerReturnDateGte !== undefined) {
                                localVarQueryParameter['drayage_container_return_date__gte'] = drayageContainerReturnDateGte;
                            }
                            if (drayageContainerReturnDateLte !== undefined) {
                                localVarQueryParameter['drayage_container_return_date__lte'] = drayageContainerReturnDateLte;
                            }
                            if (drayageEstimatedArrivalDateGte !== undefined) {
                                localVarQueryParameter['drayage_estimated_arrival_date__gte'] = drayageEstimatedArrivalDateGte;
                            }
                            if (drayageEstimatedArrivalDateLte !== undefined) {
                                localVarQueryParameter['drayage_estimated_arrival_date__lte'] = drayageEstimatedArrivalDateLte;
                            }
                            if (drayageLastFreeDateGte !== undefined) {
                                localVarQueryParameter['drayage_last_free_date__gte'] = drayageLastFreeDateGte;
                            }
                            if (drayageLastFreeDateLte !== undefined) {
                                localVarQueryParameter['drayage_last_free_date__lte'] = drayageLastFreeDateLte;
                            }
                            if (drayageReleaseDateGte !== undefined) {
                                localVarQueryParameter['drayage_release_date__gte'] = drayageReleaseDateGte;
                            }
                            if (drayageReleaseDateLte !== undefined) {
                                localVarQueryParameter['drayage_release_date__lte'] = drayageReleaseDateLte;
                            }
                            if (drayageSealNumberContains !== undefined) {
                                localVarQueryParameter['drayage_seal_number__contains'] = drayageSealNumberContains;
                            }
                            if (driverAssigned !== undefined) {
                                localVarQueryParameter['driver_assigned'] = driverAssigned;
                            }
                            if (dropoffGte !== undefined) {
                                localVarQueryParameter['dropoff__gte'] = (dropoffGte instanceof Date) ?
                                    dropoffGte.toISOString().substr(0, 10) :
                                    dropoffGte;
                            }
                            if (dropoffLte !== undefined) {
                                localVarQueryParameter['dropoff__lte'] = (dropoffLte instanceof Date) ?
                                    dropoffLte.toISOString().substr(0, 10) :
                                    dropoffLte;
                            }
                            if (equipmentType !== undefined) {
                                localVarQueryParameter['equipment_type'] = equipmentType;
                            }
                            if (equipmentTypeContains !== undefined) {
                                localVarQueryParameter['equipment_type__contains'] = equipmentTypeContains;
                            }
                            if (fedexAccount !== undefined) {
                                localVarQueryParameter['fedex_account'] = fedexAccount;
                            }
                            if (groupId !== undefined) {
                                localVarQueryParameter['groupId'] = groupId;
                            }
                            if (hasInvoice !== undefined) {
                                localVarQueryParameter['has_invoice'] = hasInvoice;
                            }
                            if (hasBill !== undefined) {
                                localVarQueryParameter['has_bill'] = hasBill;
                            }
                            if (include) {
                                localVarQueryParameter['include'] = include;
                            }
                            if (loadBoardEnabled !== undefined) {
                                localVarQueryParameter['load_board_enabled'] = loadBoardEnabled;
                            }
                            if (loadBoardId !== undefined) {
                                localVarQueryParameter['load_board_id'] = loadBoardId;
                            }
                            if (loadBoardIdContains !== undefined) {
                                localVarQueryParameter['load_board_id__contains'] = loadBoardIdContains;
                            }
                            if (mode !== undefined) {
                                localVarQueryParameter['mode'] = mode;
                            }
                            if (modeContains !== undefined) {
                                localVarQueryParameter['mode__contains'] = modeContains;
                            }
                            if (nameContains !== undefined) {
                                localVarQueryParameter['name__contains'] = nameContains;
                            }
                            if (open !== undefined) {
                                localVarQueryParameter['open'] = open;
                            }
                            if (originContains !== undefined) {
                                localVarQueryParameter['origin__contains'] = originContains;
                            }
                            if (originStateProvince !== undefined) {
                                localVarQueryParameter['origin_state_province'] = originStateProvince;
                            }
                            if (pickupStopsStateProvince !== undefined) {
                                localVarQueryParameter['pickup_stops_state_province'] = pickupStopsStateProvince;
                            }
                            if (pickupStopsContains !== undefined) {
                                localVarQueryParameter['pickup_stops__contains'] = pickupStopsContains;
                            }
                            if (pickupStopsCompanyNameContains !== undefined) {
                                localVarQueryParameter['pickup_stops_company_name__contains'] = pickupStopsCompanyNameContains;
                            }
                            if (parcelPickupStatus) {
                                localVarQueryParameter['parcel_pickup_status'] = parcelPickupStatus;
                            }
                            if (pickupGte !== undefined) {
                                localVarQueryParameter['pickup__gte'] = (pickupGte instanceof Date) ?
                                    pickupGte.toISOString().substr(0, 10) :
                                    pickupGte;
                            }
                            if (updatedAtGte !== undefined) {
                                localVarQueryParameter['updated_at__gte'] = updatedAtGte;
                            }
                            if (updatedAtLte !== undefined) {
                                localVarQueryParameter['updated_at__lte'] = updatedAtLte;
                            }
                            if (pickupLte !== undefined) {
                                localVarQueryParameter['pickup__lte'] = (pickupLte instanceof Date) ?
                                    pickupLte.toISOString().substr(0, 10) :
                                    pickupLte;
                            }
                            if (pickupId !== undefined) {
                                localVarQueryParameter['pickup_id'] = pickupId;
                            }
                            if (pickupNumber) {
                                localVarQueryParameter['pickup_number'] = pickupNumber;
                            }
                            if (pickupNumberContains !== undefined) {
                                localVarQueryParameter['pickup_number__contains'] = pickupNumberContains;
                            }
                            if (pickupNumberExclude) {
                                localVarQueryParameter['pickup_number__exclude'] = pickupNumberExclude;
                            }
                            if (proNumber) {
                                localVarQueryParameter['pro_number'] = proNumber;
                            }
                            if (proNumberContains !== undefined) {
                                localVarQueryParameter['pro_number__contains'] = proNumberContains;
                            }
                            if (proNumberExclude) {
                                localVarQueryParameter['pro_number__exclude'] = proNumberExclude;
                            }
                            if (powerUnit !== undefined) {
                                localVarQueryParameter['power_unit'] = powerUnit;
                            }
                            if (purchaseOrderNumber) {
                                localVarQueryParameter['purchase_order_number'] = purchaseOrderNumber;
                            }
                            if (purchaseOrderNumberContains !== undefined) {
                                localVarQueryParameter['purchase_order_number__contains'] = purchaseOrderNumberContains;
                            }
                            if (purchaseOrderNumberExclude) {
                                localVarQueryParameter['purchase_order_number__exclude'] = purchaseOrderNumberExclude;
                            }
                            if (referenceId) {
                                localVarQueryParameter['reference_id'] = referenceId;
                            }
                            if (referenceIdContains !== undefined) {
                                localVarQueryParameter['reference_id__contains'] = referenceIdContains;
                            }
                            if (referenceIdExclude) {
                                localVarQueryParameter['reference_id__exclude'] = referenceIdExclude;
                            }
                            if (masterAirWaybill) {
                                localVarQueryParameter['master_air_waybill'] = masterAirWaybill;
                            }
                            if (masterAirWaybillContains !== undefined) {
                                localVarQueryParameter['master_air_waybill__contains'] = masterAirWaybillContains;
                            }
                            if (houseAirWaybill) {
                                localVarQueryParameter['house_air_waybill'] = houseAirWaybill;
                            }
                            if (houseAirWaybillContains !== undefined) {
                                localVarQueryParameter['house_air_waybill__contains'] = houseAirWaybillContains;
                            }
                            if (reps) {
                                localVarQueryParameter['reps'] = reps;
                            }
                            if (role !== undefined) {
                                localVarQueryParameter['role'] = role;
                            }
                            if (serviceLevel !== undefined) {
                                localVarQueryParameter['service_level'] = serviceLevel;
                            }
                            if (accessorials) {
                                localVarQueryParameter['accessorials'] = accessorials;
                            }
                            if (createdAtGte !== undefined) {
                                localVarQueryParameter['created_at__gte'] = (createdAtGte instanceof Date) ?
                                    createdAtGte.toISOString() :
                                    createdAtGte;
                            }
                            if (createdAtLte !== undefined) {
                                localVarQueryParameter['created_at__lte'] = (createdAtLte instanceof Date) ?
                                    createdAtLte.toISOString() :
                                    createdAtLte;
                            }
                            if (status) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (statusExclude) {
                                localVarQueryParameter['status__exclude'] = statusExclude;
                            }
                            if (statusContains !== undefined) {
                                localVarQueryParameter['status__contains'] = statusContains;
                            }
                            if (tags) {
                                localVarQueryParameter['tags'] = tags;
                            }
                            if (tagsExclude) {
                                localVarQueryParameter['tags__exclude'] = tagsExclude;
                            }
                            if (shipmentShipwellCustomData) {
                                localVarQueryParameter['shipment_shipwell_custom_data'] = shipmentShipwellCustomData;
                            }
                            if (stopsContains !== undefined) {
                                localVarQueryParameter['stops__contains'] = stopsContains;
                            }
                            if (stopsCompanyNameContains !== undefined) {
                                localVarQueryParameter['stops_company_name__contains'] = stopsCompanyNameContains;
                            }
                            if (stopsStateProvince !== undefined) {
                                localVarQueryParameter['stops_state_province'] = stopsStateProvince;
                            }
                            if (timelineLastUpdatedAtGte !== undefined) {
                                localVarQueryParameter['timeline_last_updated_at__gte'] = timelineLastUpdatedAtGte;
                            }
                            if (timelineLastUpdatedAtLte !== undefined) {
                                localVarQueryParameter['timeline_last_updated_at__lte'] = timelineLastUpdatedAtLte;
                            }
                            if (timeFrame !== undefined) {
                                localVarQueryParameter['time_frame'] = timeFrame;
                            }
                            if (totalMilesGte !== undefined) {
                                localVarQueryParameter['total_miles__gte'] = totalMilesGte;
                            }
                            if (totalMilesLte !== undefined) {
                                localVarQueryParameter['total_miles__lte'] = totalMilesLte;
                            }
                            if (upsAccount !== undefined) {
                                localVarQueryParameter['ups_account'] = upsAccount;
                            }
                            if (vendorId !== undefined) {
                                localVarQueryParameter['vendor_id'] = vendorId;
                            }
                            if (vendorContains !== undefined) {
                                localVarQueryParameter['vendor__contains'] = vendorContains;
                            }
                            if (totalWeightOverrideGte !== undefined) {
                                localVarQueryParameter['total_weight_override__gte'] = totalWeightOverrideGte;
                            }
                            if (totalWeightOverrideLte !== undefined) {
                                localVarQueryParameter['total_weight_override__lte'] = totalWeightOverrideLte;
                            }
                            if (originRadius !== undefined) {
                                localVarQueryParameter['origin_radius'] = originRadius;
                            }
                            if (originLat !== undefined) {
                                localVarQueryParameter['origin_lat'] = originLat;
                            }
                            if (originLon !== undefined) {
                                localVarQueryParameter['origin_lon'] = originLon;
                            }
                            if (pickupRadius !== undefined) {
                                localVarQueryParameter['pickup_radius'] = pickupRadius;
                            }
                            if (pickupLat !== undefined) {
                                localVarQueryParameter['pickup_lat'] = pickupLat;
                            }
                            if (pickupLon !== undefined) {
                                localVarQueryParameter['pickup_lon'] = pickupLon;
                            }
                            if (destinationRadius !== undefined) {
                                localVarQueryParameter['destination_radius'] = destinationRadius;
                            }
                            if (destinationLat !== undefined) {
                                localVarQueryParameter['destination_lat'] = destinationLat;
                            }
                            if (destinationLon !== undefined) {
                                localVarQueryParameter['destination_lon'] = destinationLon;
                            }
                            if (deliveryRadius !== undefined) {
                                localVarQueryParameter['delivery_radius'] = deliveryRadius;
                            }
                            if (deliveryLat !== undefined) {
                                localVarQueryParameter['delivery_lat'] = deliveryLat;
                            }
                            if (deliveryLon !== undefined) {
                                localVarQueryParameter['delivery_lon'] = deliveryLon;
                            }
                            if (workflowExecutionStatus) {
                                localVarQueryParameter['workflow_execution_status'] = workflowExecutionStatus;
                            }
                            if (showClonedResults !== undefined) {
                                localVarQueryParameter['show_cloned_results'] = showClonedResults;
                            }
                            if (xCompanyId !== undefined && xCompanyId !== null) {
                                localVarHeaderParameter['X-Company-Id'] = String(xCompanyId);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Estimate how many linear feet of a truck that ShipmentLineItems would fill if packed optimally
         * @param {LinearFeetEstimate} linearFeetEstimate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsLinearFeetPost: function (linearFeetEstimate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'linearFeetEstimate' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsLinearFeetPost', 'linearFeetEstimate', linearFeetEstimate);
                            localVarPath = "/shipments/linear-feet/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(linearFeetEstimate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List of pickups for a company
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [scheduledDate] Date of a scheduled pickup
         * @param {string} [scheduledDateGte] Return pickups with a scheduled date greater than or equal to this value
         * @param {string} [scheduledDateLte] Return pickups with a scheduled date less than or equal to this value
         * @param {string} [scheduledTimeWindowStartGte] Return pickups with a scheduled start time window date and time greater than or equal to this value
         * @param {string} [scheduledTimeWindowStartLte] Return pickups with a scheduled start time window date and time less than or equal to this value
         * @param {string} [scheduledTimeWindowEndGte] Return pickups with a scheduled end time window date and time greater than or equal to this value
         * @param {string} [scheduledTimeWindowEndLte] Return pickups with a scheduled end time window date and time less than or equal to this value
         * @param {string} [pointOfContact] Include pickups with this point of contact name
         * @param {string} [pointOfContactContains] Include pickups where the point of contact includes this value
         * @param {string} [pointOfContactExcludes] Exclude pickups where the point of contact includes this value
         * @param {string} [specialInstructions] Include pickups with these special instructions
         * @param {string} [specialInstructionsContains] Include pickups where the special instructions includes this value
         * @param {string} [specialInstructionsExcludes] Exclude pickups where the special instructions includes this value
         * @param {string} [pickupNumber] Include pickups with this pickup number
         * @param {string} [pickupNumberContains] Include pickups where the pickup number contains this value
         * @param {string} [pickupNumberExcludes] Exclude pickups with this pickup number
         * @param {string} [providerCode] Include pickups with this provider code
         * @param {string} [providerCarrierCode] Include pickups with this provider carrier code
         * @param {string} [providerCarrierCodeContains] Include pickups where the provider carrier code contains this value
         * @param {string} [providerCarrierCodeExcludes] Exclude pickups with this provider carrier code
         * @param {string} [providerLocationId] Include pickups with this provider location id
         * @param {string} [providerLocationIdContains] Include pickups where the provider location id  contains this value
         * @param {string} [providerLocationIdExcludes] Exclude pickups with this provider location id
         * @param {string} [addressBookEntry] Include pickups with this address book entry id
         * @param {boolean} [isRegularlyScheduled] Include pickups with this is_regularly_scheduled value
         * @param {boolean} [cancelled] Return pickups based on if they are cancelled
         * @param {string} [shipmentIds] Return pickup with that include this shipment
         * @param {string} [company] Return pickups specific to this company
         * @param {string} [fedexAccount] Return pickups specific to this FedEx account
         * @param {string} [upsAccount] Return pickups specific to this UPS account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsPickupsGet: function (page, pageSize, ordering, q, scheduledDate, scheduledDateGte, scheduledDateLte, scheduledTimeWindowStartGte, scheduledTimeWindowStartLte, scheduledTimeWindowEndGte, scheduledTimeWindowEndLte, pointOfContact, pointOfContactContains, pointOfContactExcludes, specialInstructions, specialInstructionsContains, specialInstructionsExcludes, pickupNumber, pickupNumberContains, pickupNumberExcludes, providerCode, providerCarrierCode, providerCarrierCodeContains, providerCarrierCodeExcludes, providerLocationId, providerLocationIdContains, providerLocationIdExcludes, addressBookEntry, isRegularlyScheduled, cancelled, shipmentIds, company, fedexAccount, upsAccount, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipments/pickups/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (scheduledDate !== undefined) {
                                localVarQueryParameter['scheduled_date'] = (scheduledDate instanceof Date) ?
                                    scheduledDate.toISOString().substr(0, 10) :
                                    scheduledDate;
                            }
                            if (scheduledDateGte !== undefined) {
                                localVarQueryParameter['scheduled_date__gte'] = (scheduledDateGte instanceof Date) ?
                                    scheduledDateGte.toISOString().substr(0, 10) :
                                    scheduledDateGte;
                            }
                            if (scheduledDateLte !== undefined) {
                                localVarQueryParameter['scheduled_date__lte'] = (scheduledDateLte instanceof Date) ?
                                    scheduledDateLte.toISOString().substr(0, 10) :
                                    scheduledDateLte;
                            }
                            if (scheduledTimeWindowStartGte !== undefined) {
                                localVarQueryParameter['scheduled_time_window_start__gte'] = scheduledTimeWindowStartGte;
                            }
                            if (scheduledTimeWindowStartLte !== undefined) {
                                localVarQueryParameter['scheduled_time_window_start__lte'] = scheduledTimeWindowStartLte;
                            }
                            if (scheduledTimeWindowEndGte !== undefined) {
                                localVarQueryParameter['scheduled_time_window_end__gte'] = scheduledTimeWindowEndGte;
                            }
                            if (scheduledTimeWindowEndLte !== undefined) {
                                localVarQueryParameter['scheduled_time_window_end__lte'] = scheduledTimeWindowEndLte;
                            }
                            if (pointOfContact !== undefined) {
                                localVarQueryParameter['point_of_contact'] = pointOfContact;
                            }
                            if (pointOfContactContains !== undefined) {
                                localVarQueryParameter['point_of_contact__contains'] = pointOfContactContains;
                            }
                            if (pointOfContactExcludes !== undefined) {
                                localVarQueryParameter['point_of_contact__excludes'] = pointOfContactExcludes;
                            }
                            if (specialInstructions !== undefined) {
                                localVarQueryParameter['special_instructions'] = specialInstructions;
                            }
                            if (specialInstructionsContains !== undefined) {
                                localVarQueryParameter['special_instructions__contains'] = specialInstructionsContains;
                            }
                            if (specialInstructionsExcludes !== undefined) {
                                localVarQueryParameter['special_instructions__excludes'] = specialInstructionsExcludes;
                            }
                            if (pickupNumber !== undefined) {
                                localVarQueryParameter['pickup_number'] = pickupNumber;
                            }
                            if (pickupNumberContains !== undefined) {
                                localVarQueryParameter['pickup_number__contains'] = pickupNumberContains;
                            }
                            if (pickupNumberExcludes !== undefined) {
                                localVarQueryParameter['pickup_number__excludes'] = pickupNumberExcludes;
                            }
                            if (providerCode !== undefined) {
                                localVarQueryParameter['provider_code'] = providerCode;
                            }
                            if (providerCarrierCode !== undefined) {
                                localVarQueryParameter['provider_carrier_code'] = providerCarrierCode;
                            }
                            if (providerCarrierCodeContains !== undefined) {
                                localVarQueryParameter['provider_carrier_code__contains'] = providerCarrierCodeContains;
                            }
                            if (providerCarrierCodeExcludes !== undefined) {
                                localVarQueryParameter['provider_carrier_code__excludes'] = providerCarrierCodeExcludes;
                            }
                            if (providerLocationId !== undefined) {
                                localVarQueryParameter['provider_location_id'] = providerLocationId;
                            }
                            if (providerLocationIdContains !== undefined) {
                                localVarQueryParameter['provider_location_id__contains'] = providerLocationIdContains;
                            }
                            if (providerLocationIdExcludes !== undefined) {
                                localVarQueryParameter['provider_location_id__excludes'] = providerLocationIdExcludes;
                            }
                            if (addressBookEntry !== undefined) {
                                localVarQueryParameter['address_book_entry'] = addressBookEntry;
                            }
                            if (isRegularlyScheduled !== undefined) {
                                localVarQueryParameter['is_regularly_scheduled'] = isRegularlyScheduled;
                            }
                            if (cancelled !== undefined) {
                                localVarQueryParameter['cancelled'] = cancelled;
                            }
                            if (shipmentIds !== undefined) {
                                localVarQueryParameter['shipment_ids'] = shipmentIds;
                            }
                            if (company !== undefined) {
                                localVarQueryParameter['company'] = company;
                            }
                            if (fedexAccount !== undefined) {
                                localVarQueryParameter['fedex_account'] = fedexAccount;
                            }
                            if (upsAccount !== undefined) {
                                localVarQueryParameter['ups_account'] = upsAccount;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Schedule a pickup
         * @param {ScheduleShipmentPickupRequest} scheduleShipmentPickupRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsPickupsPost: function (scheduleShipmentPickupRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'scheduleShipmentPickupRequest' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsPickupsPost', 'scheduleShipmentPickupRequest', scheduleShipmentPickupRequest);
                            localVarPath = "/shipments/pickups/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(scheduleShipmentPickupRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve data for a shipment pickup
         * @param {string} shipmentPickupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsPickupsShipmentPickupIdGet: function (shipmentPickupId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentPickupId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsPickupsShipmentPickupIdGet', 'shipmentPickupId', shipmentPickupId);
                            localVarPath = "/shipments/pickups/{shipmentPickupId}/"
                                .replace("{".concat("shipmentPickupId", "}"), encodeURIComponent(String(shipmentPickupId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a shipment pickup
         * @param {string} shipmentPickupId
         * @param {ShipmentPickup} shipmentPickup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsPickupsShipmentPickupIdPut: function (shipmentPickupId, shipmentPickup, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentPickupId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsPickupsShipmentPickupIdPut', 'shipmentPickupId', shipmentPickupId);
                            // verify required parameter 'shipmentPickup' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsPickupsShipmentPickupIdPut', 'shipmentPickup', shipmentPickup);
                            localVarPath = "/shipments/pickups/{shipmentPickupId}/"
                                .replace("{".concat("shipmentPickupId", "}"), encodeURIComponent(String(shipmentPickupId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shipmentPickup, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Shipments start in a \"draft\" state by default. Only the `metadata` parameter set to `\"open\": false, \"archived\": false,` and `tags:` set to `[]` are required to begin a draft shipment.
         * @summary Create a new Shipment
         * @param {Shipment} shipment
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsPost: function (shipment, xCompanyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipment' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsPost', 'shipment', shipment);
                            localVarPath = "/shipments/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (xCompanyId !== undefined && xCompanyId !== null) {
                                localVarHeaderParameter['X-Company-Id'] = String(xCompanyId);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shipment, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Transform shipments into round trips
         * @param {InlineObject22} [inlineObject22]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsRoundTripJobPost: function (inlineObject22, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipments/round-trip-job/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject22, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Return results from round trip job
         * @param {string} roundTripJobId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsRoundTripJobRoundTripJobIdGet: function (roundTripJobId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'roundTripJobId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsRoundTripJobRoundTripJobIdGet', 'roundTripJobId', roundTripJobId);
                            localVarPath = "/shipments/round-trip-job/{roundTripJobId}"
                                .replace("{".concat("roundTripJobId", "}"), encodeURIComponent(String(roundTripJobId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the shipment OpenAPI schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsSchemaGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/shipments/schema/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Update an existing shipment to add one or more purchase orders
         * @param {string} shipmentId The id of the shipment
         * @param {InlineObject23} [inlineObject23]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAddOrdersPut: function (shipmentId, inlineObject23, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdAddOrdersPut', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/add-orders/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject23, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a shipwell automation event
         * @param {string} shipmentId The id of the shipment
         * @param {string} automationEventId The id of the shipment automation event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAutomationEventsAutomationEventIdDelete: function (shipmentId, automationEventId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdAutomationEventsAutomationEventIdDelete', 'shipmentId', shipmentId);
                            // verify required parameter 'automationEventId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdAutomationEventsAutomationEventIdDelete', 'automationEventId', automationEventId);
                            localVarPath = "/shipments/{shipmentId}/automation/events/{automationEventId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("automationEventId", "}"), encodeURIComponent(String(automationEventId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a shipwell automation event
         * @param {string} shipmentId The id of the shipment
         * @param {string} automationEventId The id of the shipment automation event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAutomationEventsAutomationEventIdGet: function (shipmentId, automationEventId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdAutomationEventsAutomationEventIdGet', 'shipmentId', shipmentId);
                            // verify required parameter 'automationEventId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdAutomationEventsAutomationEventIdGet', 'automationEventId', automationEventId);
                            localVarPath = "/shipments/{shipmentId}/automation/events/{automationEventId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("automationEventId", "}"), encodeURIComponent(String(automationEventId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a shipwell automation event
         * @param {string} shipmentId The id of the shipment
         * @param {string} automationEventId The id of the shipment automation event
         * @param {AutomationEvent} automationEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAutomationEventsAutomationEventIdPut: function (shipmentId, automationEventId, automationEvent, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdAutomationEventsAutomationEventIdPut', 'shipmentId', shipmentId);
                            // verify required parameter 'automationEventId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdAutomationEventsAutomationEventIdPut', 'automationEventId', automationEventId);
                            // verify required parameter 'automationEvent' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdAutomationEventsAutomationEventIdPut', 'automationEvent', automationEvent);
                            localVarPath = "/shipments/{shipmentId}/automation/events/{automationEventId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("automationEventId", "}"), encodeURIComponent(String(automationEventId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(automationEvent, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Cancel and delete all future scheduled automation events on a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAutomationEventsCancelScheduledDelete: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdAutomationEventsCancelScheduledDelete', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/automation/events/cancel-scheduled/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve automated shipwell events
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAutomationEventsGet: function (shipmentId, page, pageSize, ordering, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdAutomationEventsGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/automation/events/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Schedule an automated shipwell event
         * @param {string} shipmentId The id of the shipment
         * @param {AutomationEvent} automationEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAutomationEventsPost: function (shipmentId, automationEvent, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdAutomationEventsPost', 'shipmentId', shipmentId);
                            // verify required parameter 'automationEvent' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdAutomationEventsPost', 'automationEvent', automationEvent);
                            localVarPath = "/shipments/{shipmentId}/automation/events/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(automationEvent, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create multiple documents onto a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {ShipmentBulkDocument} [shipmentBulkDocument]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdBulkDocumentsPost: function (shipmentId, shipmentBulkDocument, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdBulkDocumentsPost', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/bulk-documents/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shipmentBulkDocument, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a CarrierAssignment by its id
         * @param {string} shipmentId The id of the shipment
         * @param {string} carrierAssignmentId The id of a CarrierAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCarrierAssignmentsCarrierAssignmentIdGet: function (shipmentId, carrierAssignmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdCarrierAssignmentsCarrierAssignmentIdGet', 'shipmentId', shipmentId);
                            // verify required parameter 'carrierAssignmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdCarrierAssignmentsCarrierAssignmentIdGet', 'carrierAssignmentId', carrierAssignmentId);
                            localVarPath = "/shipments/{shipmentId}/carrier-assignments/{carrierAssignmentId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("carrierAssignmentId", "}"), encodeURIComponent(String(carrierAssignmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update the charge line items of a CarrierAssignment
         * @param {string} shipmentId The id of the shipment
         * @param {string} carrierAssignmentId The id of a CarrierAssignment
         * @param {CarrierAssignment} carrierAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCarrierAssignmentsCarrierAssignmentIdPut: function (shipmentId, carrierAssignmentId, carrierAssignment, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdCarrierAssignmentsCarrierAssignmentIdPut', 'shipmentId', shipmentId);
                            // verify required parameter 'carrierAssignmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdCarrierAssignmentsCarrierAssignmentIdPut', 'carrierAssignmentId', carrierAssignmentId);
                            // verify required parameter 'carrierAssignment' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdCarrierAssignmentsCarrierAssignmentIdPut', 'carrierAssignment', carrierAssignment);
                            localVarPath = "/shipments/{shipmentId}/carrier-assignments/{carrierAssignmentId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("carrierAssignmentId", "}"), encodeURIComponent(String(carrierAssignmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(carrierAssignment, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete the carrier assignment associated with the shipment
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCarrierAssignmentsDelete: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdCarrierAssignmentsDelete', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/carrier-assignments/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the current assigned carrier associated with this shipment
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCarrierAssignmentsGet: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdCarrierAssignmentsGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/carrier-assignments/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Only one carrier assignment is associated with a company-shipment combo at a time.  Posting here will overwrite the companies carrier assignment. Carrier assignments are only shown to the user who sets it
         * @summary Create a new carrier assignment
         * @param {string} shipmentId The id of the shipment
         * @param {CarrierAssignment} carrierAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCarrierAssignmentsPost: function (shipmentId, carrierAssignment, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdCarrierAssignmentsPost', 'shipmentId', shipmentId);
                            // verify required parameter 'carrierAssignment' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdCarrierAssignmentsPost', 'carrierAssignment', carrierAssignment);
                            localVarPath = "/shipments/{shipmentId}/carrier-assignments/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(carrierAssignment, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the carrier and equipment data
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCarrierConfigGet: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdCarrierConfigGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/carrier-config/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Internal route used to provide and update information around the carrier and equipment section
         * @summary Update the carrier config data
         * @param {string} shipmentId The id of the shipment
         * @param {CarrierConfig} carrierConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCarrierConfigPost: function (shipmentId, carrierConfig, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdCarrierConfigPost', 'shipmentId', shipmentId);
                            // verify required parameter 'carrierConfig' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdCarrierConfigPost', 'carrierConfig', carrierConfig);
                            localVarPath = "/shipments/{shipmentId}/carrier-config/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(carrierConfig, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Initialize a shipment for appless cell phone tracking
         * @param {string} shipmentId The id of the shipment
         * @param {CellTrackingInitRequest} cellTrackingInitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCellTrackingPost: function (shipmentId, cellTrackingInitRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdCellTrackingPost', 'shipmentId', shipmentId);
                            // verify required parameter 'cellTrackingInitRequest' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdCellTrackingPost', 'cellTrackingInitRequest', cellTrackingInitRequest);
                            localVarPath = "/shipments/{shipmentId}/cell-tracking/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(cellTrackingInitRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the Shipment Container Details data
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdContainerDetailsGet: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdContainerDetailsGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/container-details/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDelete: function (shipmentId, xCompanyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDelete', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (xCompanyId !== undefined && xCompanyId !== null) {
                                localVarHeaderParameter['X-Company-Id'] = String(xCompanyId);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the particular dispatch job data associated with this shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} dispatchJobId The id of the dispatch job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDispatchJobDispatchJobIdGet: function (shipmentId, dispatchJobId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDispatchJobDispatchJobIdGet', 'shipmentId', shipmentId);
                            // verify required parameter 'dispatchJobId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDispatchJobDispatchJobIdGet', 'dispatchJobId', dispatchJobId);
                            localVarPath = "/shipments/{shipmentId}/dispatch-job/{dispatchJobId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("dispatchJobId", "}"), encodeURIComponent(String(dispatchJobId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get auditlog of documents sent
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsAuditlogGet: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDocumentsAuditlogGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/documents/auditlog/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a Document
         * @param {string} shipmentId The id of the shipment
         * @param {string} documentId The id of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsDocumentIdDelete: function (shipmentId, documentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDocumentsDocumentIdDelete', 'shipmentId', shipmentId);
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDocumentsDocumentIdDelete', 'documentId', documentId);
                            localVarPath = "/shipments/{shipmentId}/documents/{documentId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("documentId", "}"), encodeURIComponent(String(documentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get metadata about a document
         * @param {string} shipmentId The id of the shipment
         * @param {string} documentId The id of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsDocumentIdGet: function (shipmentId, documentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDocumentsDocumentIdGet', 'shipmentId', shipmentId);
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDocumentsDocumentIdGet', 'documentId', documentId);
                            localVarPath = "/shipments/{shipmentId}/documents/{documentId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("documentId", "}"), encodeURIComponent(String(documentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update metadata about a document
         * @param {string} shipmentId The id of the shipment
         * @param {string} documentId The id of the document
         * @param {ShipmentDocumentMetadata} shipmentDocumentMetadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsDocumentIdPut: function (shipmentId, documentId, shipmentDocumentMetadata, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDocumentsDocumentIdPut', 'shipmentId', shipmentId);
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDocumentsDocumentIdPut', 'documentId', documentId);
                            // verify required parameter 'shipmentDocumentMetadata' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDocumentsDocumentIdPut', 'shipmentDocumentMetadata', shipmentDocumentMetadata);
                            localVarPath = "/shipments/{shipmentId}/documents/{documentId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("documentId", "}"), encodeURIComponent(String(documentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shipmentDocumentMetadata, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new signature request for an specific document.
         * @param {string} shipmentId The id of the shipment
         * @param {string} documentId The id of the document
         * @param {ShipmentDocumentRequestSignature} [shipmentDocumentRequestSignature]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsDocumentIdRequestSignaturePost: function (shipmentId, documentId, shipmentDocumentRequestSignature, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDocumentsDocumentIdRequestSignaturePost', 'shipmentId', shipmentId);
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDocumentsDocumentIdRequestSignaturePost', 'documentId', documentId);
                            localVarPath = "/shipments/{shipmentId}/documents/{documentId}/request-signature/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("documentId", "}"), encodeURIComponent(String(documentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shipmentDocumentRequestSignature, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Attach the signature file to the existing request object.
         * @param {string} shipmentId The id of the shipment
         * @param {string} documentId The id of the document
         * @param {string} [description] An optional description of the signature
         * @param {any} [file] The signature file
         * @param {string} [signatoryName] The name of the signatory
         * @param {string} [signatoryRole] The role of the signatory
         * @param {string} [stopId] The Stop reference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsDocumentIdSignPost: function (shipmentId, documentId, description, file, signatoryName, signatoryRole, stopId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDocumentsDocumentIdSignPost', 'shipmentId', shipmentId);
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDocumentsDocumentIdSignPost', 'documentId', documentId);
                            localVarPath = "/shipments/{shipmentId}/documents/{documentId}/sign/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("documentId", "}"), encodeURIComponent(String(documentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (description !== undefined) {
                                localVarFormParams.append('description', description);
                            }
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            if (signatoryName !== undefined) {
                                localVarFormParams.append('signatory_name', signatoryName);
                            }
                            if (signatoryRole !== undefined) {
                                localVarFormParams.append('signatory_role', signatoryRole);
                            }
                            if (stopId !== undefined) {
                                localVarFormParams.append('stop_id', stopId);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get signatures for a document
         * @param {string} shipmentId The id of the shipment
         * @param {string} documentId The id of the document
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsDocumentIdSignaturesGet: function (shipmentId, documentId, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDocumentsDocumentIdSignaturesGet', 'shipmentId', shipmentId);
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDocumentsDocumentIdSignaturesGet', 'documentId', documentId);
                            localVarPath = "/shipments/{shipmentId}/documents/{documentId}/signatures/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("documentId", "}"), encodeURIComponent(String(documentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Generate a BOL for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsGenerateBolGet: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDocumentsGenerateBolGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/documents/generate_bol/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Generate a rate confirmation for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsGenerateRateConfirmationGet: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDocumentsGenerateRateConfirmationGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/documents/generate_rate_confirmation/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Generate shipping labels for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsGenerateShippingLabelGet: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDocumentsGenerateShippingLabelGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/documents/generate_shipping_label/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get metadata about a documents on a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsGet: function (shipmentId, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDocumentsGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/documents/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a document on a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} description
         * @param {any} file
         * @param {boolean} isCarrierDocument
         * @param {string} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsPost: function (shipmentId, description, file, isCarrierDocument, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDocumentsPost', 'shipmentId', shipmentId);
                            // verify required parameter 'description' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDocumentsPost', 'description', description);
                            // verify required parameter 'file' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDocumentsPost', 'file', file);
                            // verify required parameter 'isCarrierDocument' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDocumentsPost', 'isCarrierDocument', isCarrierDocument);
                            // verify required parameter 'type' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDocumentsPost', 'type', type);
                            localVarPath = "/shipments/{shipmentId}/documents/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (description !== undefined) {
                                localVarFormParams.append('description', description);
                            }
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            if (isCarrierDocument !== undefined) {
                                localVarFormParams.append('is_carrier_document', isCarrierDocument);
                            }
                            if (type !== undefined) {
                                localVarFormParams.append('type', type);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Send shipment documents to a list of email recipients
         * @param {string} shipmentId The id of the shipment
         * @param {SendDocument} sendDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsSendPost: function (shipmentId, sendDocument, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDocumentsSendPost', 'shipmentId', shipmentId);
                            // verify required parameter 'sendDocument' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdDocumentsSendPost', 'sendDocument', sendDocument);
                            localVarPath = "/shipments/{shipmentId}/documents/send/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(sendDocument, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the current equipment config associated with this shipment
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdEquipmentConfigGet: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdEquipmentConfigGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/equipment-config/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Only one equipment config is associated with a shipment at a time.  Posting here will overwrite the previous equipment config and attempt to track with the new configuration.
         * @summary Create a new equipment config
         * @param {string} shipmentId The id of the shipment
         * @param {CreateEquipmentConfig} createEquipmentConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdEquipmentConfigPost: function (shipmentId, createEquipmentConfig, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdEquipmentConfigPost', 'shipmentId', shipmentId);
                            // verify required parameter 'createEquipmentConfig' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdEquipmentConfigPost', 'createEquipmentConfig', createEquipmentConfig);
                            localVarPath = "/shipments/{shipmentId}/equipment-config/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createEquipmentConfig, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdGet: function (shipmentId, xCompanyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (xCompanyId !== undefined && xCompanyId !== null) {
                                localVarHeaderParameter['X-Company-Id'] = String(xCompanyId);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of ShipmentTimelineEvents grouped by Stop for a given Shipment
         * @param {string} shipmentId The id of the shipment
         * @param {'location' | 'status'} [groupType] The type of timeline events to return, defaults to all
         * @param {boolean} [filterFutureStops] Whether to remove future stops from the list of grouped timeline events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdGroupedTimelineEventsGet: function (shipmentId, groupType, filterFutureStops, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdGroupedTimelineEventsGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/grouped-timeline-events/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (groupType !== undefined) {
                                localVarQueryParameter['groupType'] = groupType;
                            }
                            if (filterFutureStops !== undefined) {
                                localVarQueryParameter['filterFutureStops'] = filterFutureStops;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List messages for a Shipment
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [q] search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdMessagesGet: function (shipmentId, page, pageSize, q, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdMessagesGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/messages/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new message for a Shipment
         * @param {string} shipmentId The id of the shipment
         * @param {ShipmentMessage} shipmentMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdMessagesPost: function (shipmentId, shipmentMessage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdMessagesPost', 'shipmentId', shipmentId);
                            // verify required parameter 'shipmentMessage' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdMessagesPost', 'shipmentMessage', shipmentMessage);
                            localVarPath = "/shipments/{shipmentId}/messages/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shipmentMessage, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a ShipmentMessage
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentMessageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdMessagesShipmentMessageIdDelete: function (shipmentId, shipmentMessageId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdMessagesShipmentMessageIdDelete', 'shipmentId', shipmentId);
                            // verify required parameter 'shipmentMessageId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdMessagesShipmentMessageIdDelete', 'shipmentMessageId', shipmentMessageId);
                            localVarPath = "/shipments/{shipmentId}/messages/{shipmentMessageId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("shipmentMessageId", "}"), encodeURIComponent(String(shipmentMessageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve data for a ShipmentMessage
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentMessageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdMessagesShipmentMessageIdGet: function (shipmentId, shipmentMessageId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdMessagesShipmentMessageIdGet', 'shipmentId', shipmentId);
                            // verify required parameter 'shipmentMessageId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdMessagesShipmentMessageIdGet', 'shipmentMessageId', shipmentMessageId);
                            localVarPath = "/shipments/{shipmentId}/messages/{shipmentMessageId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("shipmentMessageId", "}"), encodeURIComponent(String(shipmentMessageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Mark a ShipmentMessage as read
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentMessageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdMessagesShipmentMessageIdMarkAsReadPost: function (shipmentId, shipmentMessageId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdMessagesShipmentMessageIdMarkAsReadPost', 'shipmentId', shipmentId);
                            // verify required parameter 'shipmentMessageId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdMessagesShipmentMessageIdMarkAsReadPost', 'shipmentMessageId', shipmentMessageId);
                            localVarPath = "/shipments/{shipmentId}/messages/{shipmentMessageId}/mark-as-read/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("shipmentMessageId", "}"), encodeURIComponent(String(shipmentMessageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Mark a ShipmentMessage as unread
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentMessageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdMessagesShipmentMessageIdMarkAsUnreadPost: function (shipmentId, shipmentMessageId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdMessagesShipmentMessageIdMarkAsUnreadPost', 'shipmentId', shipmentId);
                            // verify required parameter 'shipmentMessageId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdMessagesShipmentMessageIdMarkAsUnreadPost', 'shipmentMessageId', shipmentMessageId);
                            localVarPath = "/shipments/{shipmentId}/messages/{shipmentMessageId}/mark-as-unread/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("shipmentMessageId", "}"), encodeURIComponent(String(shipmentMessageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a ShipmentMessage
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentMessageId
         * @param {ShipmentMessage} shipmentMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdMessagesShipmentMessageIdPut: function (shipmentId, shipmentMessageId, shipmentMessage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdMessagesShipmentMessageIdPut', 'shipmentId', shipmentId);
                            // verify required parameter 'shipmentMessageId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdMessagesShipmentMessageIdPut', 'shipmentMessageId', shipmentMessageId);
                            // verify required parameter 'shipmentMessage' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdMessagesShipmentMessageIdPut', 'shipmentMessage', shipmentMessage);
                            localVarPath = "/shipments/{shipmentId}/messages/{shipmentMessageId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("shipmentMessageId", "}"), encodeURIComponent(String(shipmentMessageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shipmentMessage, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List notes for a Shipment or Shipment Quote
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdNotesGet: function (shipmentId, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdNotesGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/notes/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new note for a Shipment or Shipment Quote
         * @param {string} shipmentId The id of the shipment
         * @param {ShipmentNote} shipmentNote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdNotesPost: function (shipmentId, shipmentNote, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdNotesPost', 'shipmentId', shipmentId);
                            // verify required parameter 'shipmentNote' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdNotesPost', 'shipmentNote', shipmentNote);
                            localVarPath = "/shipments/{shipmentId}/notes/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shipmentNote, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a ShipmentNote
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdNotesShipmentNoteIdDelete: function (shipmentId, shipmentNoteId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdNotesShipmentNoteIdDelete', 'shipmentId', shipmentId);
                            // verify required parameter 'shipmentNoteId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdNotesShipmentNoteIdDelete', 'shipmentNoteId', shipmentNoteId);
                            localVarPath = "/shipments/{shipmentId}/notes/{shipmentNoteId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("shipmentNoteId", "}"), encodeURIComponent(String(shipmentNoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve data for a ShipmentNote
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdNotesShipmentNoteIdGet: function (shipmentId, shipmentNoteId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdNotesShipmentNoteIdGet', 'shipmentId', shipmentId);
                            // verify required parameter 'shipmentNoteId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdNotesShipmentNoteIdGet', 'shipmentNoteId', shipmentNoteId);
                            localVarPath = "/shipments/{shipmentId}/notes/{shipmentNoteId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("shipmentNoteId", "}"), encodeURIComponent(String(shipmentNoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a ShipmentNote
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentNoteId
         * @param {ShipmentNote} shipmentNote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdNotesShipmentNoteIdPut: function (shipmentId, shipmentNoteId, shipmentNote, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdNotesShipmentNoteIdPut', 'shipmentId', shipmentId);
                            // verify required parameter 'shipmentNoteId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdNotesShipmentNoteIdPut', 'shipmentNoteId', shipmentNoteId);
                            // verify required parameter 'shipmentNote' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdNotesShipmentNoteIdPut', 'shipmentNote', shipmentNote);
                            localVarPath = "/shipments/{shipmentId}/notes/{shipmentNoteId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("shipmentNoteId", "}"), encodeURIComponent(String(shipmentNoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shipmentNote, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * After a successful update, the \'stops\' and \'line_items\' of the Shipment will be exactly the same as those provided in the request. This means that if existing \'stops\' or \'ShipmentLineItems\' were left out of their arrays, those objects would be deleted. Providing existing objects in those arrays with their ids will update those objects instead of creating or deleting them. Providing objects in the arrays that do not have ids will create new objects. If you omit the \'stops\' or \'line_items\' arrays from the request body, no changes will be made to those related object sets.
         * @summary Update a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {Shipment} shipment
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdPut: function (shipmentId, shipment, xCompanyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdPut', 'shipmentId', shipmentId);
                            // verify required parameter 'shipment' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdPut', 'shipment', shipment);
                            localVarPath = "/shipments/{shipmentId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (xCompanyId !== undefined && xCompanyId !== null) {
                                localVarHeaderParameter['X-Company-Id'] = String(xCompanyId);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shipment, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Remove a purchase order from an existing shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} orderId The id of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdRemoveOrdersOrderIdPut: function (shipmentId, orderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdRemoveOrdersOrderIdPut', 'shipmentId', shipmentId);
                            // verify required parameter 'orderId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdRemoveOrdersOrderIdPut', 'orderId', orderId);
                            localVarPath = "/shipments/{shipmentId}/remove-orders/{orderId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("orderId", "}"), encodeURIComponent(String(orderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the list of the shipment reps
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdRepsGet: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdRepsGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/reps/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Add a rep to a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {CreateShipmentRepRequest} createShipmentRepRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdRepsPost: function (shipmentId, createShipmentRepRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdRepsPost', 'shipmentId', shipmentId);
                            // verify required parameter 'createShipmentRepRequest' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdRepsPost', 'createShipmentRepRequest', createShipmentRepRequest);
                            localVarPath = "/shipments/{shipmentId}/reps/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createShipmentRepRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a rep record
         * @param {string} shipmentId The id of the shipment
         * @param {string} repId The id of the rep
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdRepsRepIdDelete: function (shipmentId, repId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdRepsRepIdDelete', 'shipmentId', shipmentId);
                            // verify required parameter 'repId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdRepsRepIdDelete', 'repId', repId);
                            localVarPath = "/shipments/{shipmentId}/reps/{repId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("repId", "}"), encodeURIComponent(String(repId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a specific shipment rep
         * @param {string} shipmentId The id of the shipment
         * @param {string} repId The id of the rep
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdRepsRepIdGet: function (shipmentId, repId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdRepsRepIdGet', 'shipmentId', shipmentId);
                            // verify required parameter 'repId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdRepsRepIdGet', 'repId', repId);
                            localVarPath = "/shipments/{shipmentId}/reps/{repId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("repId", "}"), encodeURIComponent(String(repId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a Rep record
         * @param {string} shipmentId The id of the shipment
         * @param {string} repId The id of the rep
         * @param {UpdateShipmentRepRequest} updateShipmentRepRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdRepsRepIdPut: function (shipmentId, repId, updateShipmentRepRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdRepsRepIdPut', 'shipmentId', shipmentId);
                            // verify required parameter 'repId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdRepsRepIdPut', 'repId', repId);
                            // verify required parameter 'updateShipmentRepRequest' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdRepsRepIdPut', 'updateShipmentRepRequest', updateShipmentRepRequest);
                            localVarPath = "/shipments/{shipmentId}/reps/{repId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("repId", "}"), encodeURIComponent(String(repId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateShipmentRepRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Send an SMS message requesting that someone download Shipwell app
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdRequestAppDownloadPost: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdRequestAppDownloadPost', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/request-app-download/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Send an SMS to locate request to a Driver
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdSmsTrackingPost: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdSmsTrackingPost', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/sms-tracking/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of Stops for a given Shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsGet: function (shipmentId, xCompanyId, page, pageSize, ordering, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/stops/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (xCompanyId !== undefined && xCompanyId !== null) {
                                localVarHeaderParameter['X-Company-Id'] = String(xCompanyId);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * The new Stop must not have the same \'ordinal_index\' as any other Stop associated with that Shipment.
         * @summary Create a new Stop
         * @param {string} shipmentId The id of the shipment
         * @param {Stop} stop
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsPost: function (shipmentId, stop, xCompanyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsPost', 'shipmentId', shipmentId);
                            // verify required parameter 'stop' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsPost', 'stop', stop);
                            localVarPath = "/shipments/{shipmentId}/stops/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (xCompanyId !== undefined && xCompanyId !== null) {
                                localVarHeaderParameter['X-Company-Id'] = String(xCompanyId);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(stop, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of StopAlerts for a given Stop
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdAlertsGet: function (shipmentId, stopId, page, pageSize, ordering, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsStopIdAlertsGet', 'shipmentId', shipmentId);
                            // verify required parameter 'stopId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsStopIdAlertsGet', 'stopId', stopId);
                            localVarPath = "/shipments/{shipmentId}/stops/{stopId}/alerts/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("stopId", "}"), encodeURIComponent(String(stopId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new StopAlert
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {StopAlert} stopAlert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdAlertsPost: function (shipmentId, stopId, stopAlert, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsStopIdAlertsPost', 'shipmentId', shipmentId);
                            // verify required parameter 'stopId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsStopIdAlertsPost', 'stopId', stopId);
                            // verify required parameter 'stopAlert' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsStopIdAlertsPost', 'stopAlert', stopAlert);
                            localVarPath = "/shipments/{shipmentId}/stops/{stopId}/alerts/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("stopId", "}"), encodeURIComponent(String(stopId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(stopAlert, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a StopAlert
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {string} stopAlertId The id of the stop alert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdAlertsStopAlertIdDelete: function (shipmentId, stopId, stopAlertId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsStopIdAlertsStopAlertIdDelete', 'shipmentId', shipmentId);
                            // verify required parameter 'stopId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsStopIdAlertsStopAlertIdDelete', 'stopId', stopId);
                            // verify required parameter 'stopAlertId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsStopIdAlertsStopAlertIdDelete', 'stopAlertId', stopAlertId);
                            localVarPath = "/shipments/{shipmentId}/stops/{stopId}/alerts/{stopAlertId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("stopId", "}"), encodeURIComponent(String(stopId)))
                                .replace("{".concat("stopAlertId", "}"), encodeURIComponent(String(stopAlertId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a StopAlert
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {string} stopAlertId The id of the stop alert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdAlertsStopAlertIdGet: function (shipmentId, stopId, stopAlertId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsStopIdAlertsStopAlertIdGet', 'shipmentId', shipmentId);
                            // verify required parameter 'stopId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsStopIdAlertsStopAlertIdGet', 'stopId', stopId);
                            // verify required parameter 'stopAlertId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsStopIdAlertsStopAlertIdGet', 'stopAlertId', stopAlertId);
                            localVarPath = "/shipments/{shipmentId}/stops/{stopId}/alerts/{stopAlertId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("stopId", "}"), encodeURIComponent(String(stopId)))
                                .replace("{".concat("stopAlertId", "}"), encodeURIComponent(String(stopAlertId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a StopAlert
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {string} stopAlertId The id of the stop alert
         * @param {StopAlert} stopAlert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdAlertsStopAlertIdPut: function (shipmentId, stopId, stopAlertId, stopAlert, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsStopIdAlertsStopAlertIdPut', 'shipmentId', shipmentId);
                            // verify required parameter 'stopId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsStopIdAlertsStopAlertIdPut', 'stopId', stopId);
                            // verify required parameter 'stopAlertId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsStopIdAlertsStopAlertIdPut', 'stopAlertId', stopAlertId);
                            // verify required parameter 'stopAlert' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsStopIdAlertsStopAlertIdPut', 'stopAlert', stopAlert);
                            localVarPath = "/shipments/{shipmentId}/stops/{stopId}/alerts/{stopAlertId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("stopId", "}"), encodeURIComponent(String(stopId)))
                                .replace("{".concat("stopAlertId", "}"), encodeURIComponent(String(stopAlertId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(stopAlert, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a Stop
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdDelete: function (shipmentId, stopId, xCompanyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsStopIdDelete', 'shipmentId', shipmentId);
                            // verify required parameter 'stopId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsStopIdDelete', 'stopId', stopId);
                            localVarPath = "/shipments/{shipmentId}/stops/{stopId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("stopId", "}"), encodeURIComponent(String(stopId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (xCompanyId !== undefined && xCompanyId !== null) {
                                localVarHeaderParameter['X-Company-Id'] = String(xCompanyId);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new stop-related shipment timeline event
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {StopEvent} stopEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdEventsPost: function (shipmentId, stopId, stopEvent, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsStopIdEventsPost', 'shipmentId', shipmentId);
                            // verify required parameter 'stopId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsStopIdEventsPost', 'stopId', stopId);
                            // verify required parameter 'stopEvent' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsStopIdEventsPost', 'stopEvent', stopEvent);
                            localVarPath = "/shipments/{shipmentId}/stops/{stopId}/events/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("stopId", "}"), encodeURIComponent(String(stopId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(stopEvent, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a Stop
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdGet: function (shipmentId, stopId, xCompanyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsStopIdGet', 'shipmentId', shipmentId);
                            // verify required parameter 'stopId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsStopIdGet', 'stopId', stopId);
                            localVarPath = "/shipments/{shipmentId}/stops/{stopId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("stopId", "}"), encodeURIComponent(String(stopId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (xCompanyId !== undefined && xCompanyId !== null) {
                                localVarHeaderParameter['X-Company-Id'] = String(xCompanyId);
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a Stop
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {Stop} stop
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdPut: function (shipmentId, stopId, stop, xCompanyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsStopIdPut', 'shipmentId', shipmentId);
                            // verify required parameter 'stopId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsStopIdPut', 'stopId', stopId);
                            // verify required parameter 'stop' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdStopsStopIdPut', 'stop', stop);
                            localVarPath = "/shipments/{shipmentId}/stops/{stopId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("stopId", "}"), encodeURIComponent(String(stopId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (xCompanyId !== undefined && xCompanyId !== null) {
                                localVarHeaderParameter['X-Company-Id'] = String(xCompanyId);
                            }
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(stop, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of ShipmentTimelineEvents for a given Shipment
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdTimelineEventsGet: function (shipmentId, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdTimelineEventsGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/timeline-events/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new ShipmentTimelineEvent
         * @param {string} shipmentId The id of the shipment
         * @param {CreateShipmentTimelineEvent} createShipmentTimelineEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdTimelineEventsPost: function (shipmentId, createShipmentTimelineEvent, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdTimelineEventsPost', 'shipmentId', shipmentId);
                            // verify required parameter 'createShipmentTimelineEvent' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdTimelineEventsPost', 'createShipmentTimelineEvent', createShipmentTimelineEvent);
                            localVarPath = "/shipments/{shipmentId}/timeline-events/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createShipmentTimelineEvent, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a ShipmentTimelineEvent
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentTimelineEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdDelete: function (shipmentId, shipmentTimelineEventId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdDelete', 'shipmentId', shipmentId);
                            // verify required parameter 'shipmentTimelineEventId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdDelete', 'shipmentTimelineEventId', shipmentTimelineEventId);
                            localVarPath = "/shipments/{shipmentId}/timeline-events/{shipmentTimelineEventId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("shipmentTimelineEventId", "}"), encodeURIComponent(String(shipmentTimelineEventId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a ShipmentTimelineEvent
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentTimelineEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdGet: function (shipmentId, shipmentTimelineEventId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdGet', 'shipmentId', shipmentId);
                            // verify required parameter 'shipmentTimelineEventId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdGet', 'shipmentTimelineEventId', shipmentTimelineEventId);
                            localVarPath = "/shipments/{shipmentId}/timeline-events/{shipmentTimelineEventId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("shipmentTimelineEventId", "}"), encodeURIComponent(String(shipmentTimelineEventId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a ShipmentTimelineEvent
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentTimelineEventId
         * @param {CreateShipmentTimelineEvent} createShipmentTimelineEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdPut: function (shipmentId, shipmentTimelineEventId, createShipmentTimelineEvent, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdPut', 'shipmentId', shipmentId);
                            // verify required parameter 'shipmentTimelineEventId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdPut', 'shipmentTimelineEventId', shipmentTimelineEventId);
                            // verify required parameter 'createShipmentTimelineEvent' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdPut', 'createShipmentTimelineEvent', createShipmentTimelineEvent);
                            localVarPath = "/shipments/{shipmentId}/timeline-events/{shipmentTimelineEventId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("shipmentTimelineEventId", "}"), encodeURIComponent(String(shipmentTimelineEventId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createShipmentTimelineEvent, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get locations for the shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} [beginDatetime] For requesting data starting at a given date
         * @param {string} [endDatetime] For requesting data ending at a given date
         * @param {string} [filterDistance] Applies a distance filter and only returns points greater than filter_distance km apart. To return all, set this to -1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdTrackingGet: function (shipmentId, beginDatetime, endDatetime, filterDistance, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdTrackingGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/tracking/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (beginDatetime !== undefined) {
                                localVarQueryParameter['beginDatetime'] = (beginDatetime instanceof Date) ?
                                    beginDatetime.toISOString() :
                                    beginDatetime;
                            }
                            if (endDatetime !== undefined) {
                                localVarQueryParameter['endDatetime'] = (endDatetime instanceof Date) ?
                                    endDatetime.toISOString() :
                                    endDatetime;
                            }
                            if (filterDistance !== undefined) {
                                localVarQueryParameter['filter_distance'] = filterDistance;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Manually update Shipment Location. Authenticated drivers can also use this route to update their location
         * @param {string} shipmentId The id of the shipment
         * @param {ELDLocationUpdateRequest} eLDLocationUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdTrackingPost: function (shipmentId, eLDLocationUpdateRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdTrackingPost', 'shipmentId', shipmentId);
                            // verify required parameter 'eLDLocationUpdateRequest' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdTrackingPost', 'eLDLocationUpdateRequest', eLDLocationUpdateRequest);
                            localVarPath = "/shipments/{shipmentId}/tracking/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(eLDLocationUpdateRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List of all stop event types supported by the API along with their categorial groupings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsStopEventTypesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipments/stop-event-types/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of all stop locations for shipments user is associated with
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [companyName] Return stop locations whose company_name is equivalent to this value
         * @param {string} [companyNameContains] Return stop locations with this value in the company_name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsStopLocationsGet: function (page, pageSize, companyName, companyNameContains, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipments/stop-locations/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (companyName !== undefined) {
                                localVarQueryParameter['company_name'] = companyName;
                            }
                            if (companyNameContains !== undefined) {
                                localVarQueryParameter['company_name__contains'] = companyNameContains;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List all ShipmentTags for the authenticated company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTagsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipments/tags/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a ShipmentTag for the authenticated company
         * @param {ShipmentTag} shipmentTag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTagsPost: function (shipmentTag, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentTag' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsTagsPost', 'shipmentTag', shipmentTag);
                            localVarPath = "/shipments/tags/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shipmentTag, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a ShipmentTag
         * @param {string} shipmentTagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTagsShipmentTagIdDelete: function (shipmentTagId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentTagId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsTagsShipmentTagIdDelete', 'shipmentTagId', shipmentTagId);
                            localVarPath = "/shipments/tags/{shipmentTagId}/"
                                .replace("{".concat("shipmentTagId", "}"), encodeURIComponent(String(shipmentTagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a ShipmentTag by its id
         * @param {string} shipmentTagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTagsShipmentTagIdGet: function (shipmentTagId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentTagId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsTagsShipmentTagIdGet', 'shipmentTagId', shipmentTagId);
                            localVarPath = "/shipments/tags/{shipmentTagId}/"
                                .replace("{".concat("shipmentTagId", "}"), encodeURIComponent(String(shipmentTagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a ShipmentTag
         * @param {string} shipmentTagId
         * @param {ShipmentTag} shipmentTag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTagsShipmentTagIdPut: function (shipmentTagId, shipmentTag, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentTagId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsTagsShipmentTagIdPut', 'shipmentTagId', shipmentTagId);
                            // verify required parameter 'shipmentTag' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsTagsShipmentTagIdPut', 'shipmentTag', shipmentTag);
                            localVarPath = "/shipments/tags/{shipmentTagId}/"
                                .replace("{".concat("shipmentTagId", "}"), encodeURIComponent(String(shipmentTagId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shipmentTag, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List all Shipment Templates for the authenticated company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTemplatesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipments/templates/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a ShipmentTemplate for the authenticated company
         * @param {ShipmentTemplateRequest} shipmentTemplateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTemplatesPost: function (shipmentTemplateRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentTemplateRequest' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsTemplatesPost', 'shipmentTemplateRequest', shipmentTemplateRequest);
                            localVarPath = "/shipments/templates/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shipmentTemplateRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a Shipment Template
         * @param {string} shipmentTemplateId The ID of the shipment template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTemplatesShipmentTemplateIdDelete: function (shipmentTemplateId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentTemplateId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsTemplatesShipmentTemplateIdDelete', 'shipmentTemplateId', shipmentTemplateId);
                            localVarPath = "/shipments/templates/{shipmentTemplateId}/"
                                .replace("{".concat("shipmentTemplateId", "}"), encodeURIComponent(String(shipmentTemplateId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a Shipment Template by its id
         * @param {string} shipmentTemplateId The ID of the shipment template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTemplatesShipmentTemplateIdGet: function (shipmentTemplateId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentTemplateId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsTemplatesShipmentTemplateIdGet', 'shipmentTemplateId', shipmentTemplateId);
                            localVarPath = "/shipments/templates/{shipmentTemplateId}/"
                                .replace("{".concat("shipmentTemplateId", "}"), encodeURIComponent(String(shipmentTemplateId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a Shipment Template
         * @param {string} shipmentTemplateId The ID of the shipment template
         * @param {ShipmentTemplateRequest} shipmentTemplateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTemplatesShipmentTemplateIdPut: function (shipmentTemplateId, shipmentTemplateRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentTemplateId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsTemplatesShipmentTemplateIdPut', 'shipmentTemplateId', shipmentTemplateId);
                            // verify required parameter 'shipmentTemplateRequest' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsTemplatesShipmentTemplateIdPut', 'shipmentTemplateRequest', shipmentTemplateRequest);
                            localVarPath = "/shipments/templates/{shipmentTemplateId}/"
                                .replace("{".concat("shipmentTemplateId", "}"), encodeURIComponent(String(shipmentTemplateId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shipmentTemplateRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List tendered shipments
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [closedByCustomer] Restrict SpotNegotiations based on whether customer closed
         * @param {boolean} [closedByVendor] Restrict SpotNegotiations based on whether vendor closed
         * @param {string} [customerId] ID of customer company to which to restrict SpotNegotiations
         * @param {string} [customerNameContains] Partial name of customer company to which to restrict SpotNegotiations
         * @param {boolean} [involvedOnly] Restrict SpotNegotiations to those in which user is explicitly involved
         * @param {Array<string>} [involvedVendorUsers] Restrict SpotNegotiations to those with provided User IDs involved on the vendor side
         * @param {boolean} [isMostRecentWinner] Restrict SpotNegotiations to those that are or are not the most recent winner
         * @param {boolean} [isOpen] Restrict SpotNegotiations based on both sides agreeing the negotiation is open
         * @param {string} [shipment] Return SpotNegotiations where Shipment ID matches
         * @param {string} [shipmentBolNumber] Return SpotNegotiations where Shipment BOL number matches
         * @param {string} [shipmentBolNumberContains] Return SpotNegotiations where Shipment BOL number partially matches
         * @param {string} [shipmentCapacityProviderCustomerReferenceNumber] Return SpotNegotiations where Shipment capacity provider customer reference number matches
         * @param {string} [shipmentCapacityProviderCustomerReferenceNumberContains] Return SpotNegotiations where Shipment capacity provider customer reference number partially matches
         * @param {string} [shipmentCustomerReferenceNumber] Return SpotNegotiations where Shipment customer reference number matches
         * @param {string} [shipmentCustomerReferenceNumberContains] Return SpotNegotiations where Shipment customer reference number partially matches
         * @param {string} [shipmentDelayed] Return SpotNegotiations where Shipment delayed matches
         * @param {string} [shipmentDestinationContains] Return SpotNegotiations where Shipment destination partially matches
         * @param {string} [shipmentDropoffGte] Return SpotNegotiations with a dropoff stop with a planned date greater than or equal to this value
         * @param {string} [shipmentDropoffLte] Return SpotNegotiations with a dropoff stop with a planned data less than or equal to this value
         * @param {string} [shipmentName] Return SpotNegotiations where Shipment name matches
         * @param {string} [shipmentNameContains] Return SpotNegotiations where Shipment name partially matches
         * @param {string} [shipmentOriginContains] Return SpotNegotiations where Shipment origin partially matches
         * @param {string} [shipmentPickupGte] Return SpotNegotiations with a pickup stop with a planned date greater than or equal to this value
         * @param {string} [shipmentPickupLte] Return SpotNegotiations with a pickup stop with a planned date less than or equal to this value
         * @param {string} [shipmentPickupNumber] Return SpotNegotiations where Shipment pickup number matches
         * @param {string} [shipmentPickupNumberContains] Return SpotNegotiations where Shipment pickup number partially matches
         * @param {string} [shipmentProNumber] Return SpotNegotiations where Shipment PRO number matches
         * @param {string} [shipmentProNumberContains] Return SpotNegotiations where Shipment PRO number partially matches
         * @param {string} [shipmentPurchaseOrderNumber] Return SpotNegotiations where Shipment purchase order number matches
         * @param {string} [shipmentPurchaseOrderNumberContains] Return SpotNegotiations where Shipment purchase order number partially matches
         * @param {string} [shipmentReferenceId] Return SpotNegotiations where Shipment reference_id matches
         * @param {string} [shipmentReferenceIdContains] Return SpotNegotiations where Shipment reference_id partially matches
         * @param {string} [shipmentState] Return SpotNegotiations where Shipment state matches
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [shipmentStatus] Return SpotNegotiations with shipments that have provided statuses
         * @param {string} [vendorId] ID of the vendor company to which to restrict SpotNegotiations
         * @param {string} [vendorNameContains] Partial name of the vendor company to which to restrict SpotNegotiations
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        shipmentsTenderGet: function (page, pageSize, ordering, q, closedByCustomer, closedByVendor, customerId, customerNameContains, involvedOnly, involvedVendorUsers, isMostRecentWinner, isOpen, shipment, shipmentBolNumber, shipmentBolNumberContains, shipmentCapacityProviderCustomerReferenceNumber, shipmentCapacityProviderCustomerReferenceNumberContains, shipmentCustomerReferenceNumber, shipmentCustomerReferenceNumberContains, shipmentDelayed, shipmentDestinationContains, shipmentDropoffGte, shipmentDropoffLte, shipmentName, shipmentNameContains, shipmentOriginContains, shipmentPickupGte, shipmentPickupLte, shipmentPickupNumber, shipmentPickupNumberContains, shipmentProNumber, shipmentProNumberContains, shipmentPurchaseOrderNumber, shipmentPurchaseOrderNumberContains, shipmentReferenceId, shipmentReferenceIdContains, shipmentState, shipmentStatus, vendorId, vendorNameContains, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipments/tender/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (closedByCustomer !== undefined) {
                                localVarQueryParameter['closed_by_customer'] = closedByCustomer;
                            }
                            if (closedByVendor !== undefined) {
                                localVarQueryParameter['closed_by_vendor'] = closedByVendor;
                            }
                            if (customerId !== undefined) {
                                localVarQueryParameter['customer_id'] = customerId;
                            }
                            if (customerNameContains !== undefined) {
                                localVarQueryParameter['customer_name__contains'] = customerNameContains;
                            }
                            if (involvedOnly !== undefined) {
                                localVarQueryParameter['involved_only'] = involvedOnly;
                            }
                            if (involvedVendorUsers) {
                                localVarQueryParameter['involved_vendor_users'] = involvedVendorUsers;
                            }
                            if (isMostRecentWinner !== undefined) {
                                localVarQueryParameter['is_most_recent_winner'] = isMostRecentWinner;
                            }
                            if (isOpen !== undefined) {
                                localVarQueryParameter['is_open'] = isOpen;
                            }
                            if (shipment !== undefined) {
                                localVarQueryParameter['shipment'] = shipment;
                            }
                            if (shipmentBolNumber !== undefined) {
                                localVarQueryParameter['shipment_bol_number'] = shipmentBolNumber;
                            }
                            if (shipmentBolNumberContains !== undefined) {
                                localVarQueryParameter['shipment_bol_number__contains'] = shipmentBolNumberContains;
                            }
                            if (shipmentCapacityProviderCustomerReferenceNumber !== undefined) {
                                localVarQueryParameter['shipment_capacity_provider_customer_reference_number'] = shipmentCapacityProviderCustomerReferenceNumber;
                            }
                            if (shipmentCapacityProviderCustomerReferenceNumberContains !== undefined) {
                                localVarQueryParameter['shipment_capacity_provider_customer_reference_number__contains'] = shipmentCapacityProviderCustomerReferenceNumberContains;
                            }
                            if (shipmentCustomerReferenceNumber !== undefined) {
                                localVarQueryParameter['shipment_customer_reference_number'] = shipmentCustomerReferenceNumber;
                            }
                            if (shipmentCustomerReferenceNumberContains !== undefined) {
                                localVarQueryParameter['shipment_customer_reference_number__contains'] = shipmentCustomerReferenceNumberContains;
                            }
                            if (shipmentDelayed !== undefined) {
                                localVarQueryParameter['shipment_delayed'] = shipmentDelayed;
                            }
                            if (shipmentDestinationContains !== undefined) {
                                localVarQueryParameter['shipment_destination__contains'] = shipmentDestinationContains;
                            }
                            if (shipmentDropoffGte !== undefined) {
                                localVarQueryParameter['shipment_dropoff__gte'] = (shipmentDropoffGte instanceof Date) ?
                                    shipmentDropoffGte.toISOString().substr(0, 10) :
                                    shipmentDropoffGte;
                            }
                            if (shipmentDropoffLte !== undefined) {
                                localVarQueryParameter['shipment_dropoff__lte'] = (shipmentDropoffLte instanceof Date) ?
                                    shipmentDropoffLte.toISOString().substr(0, 10) :
                                    shipmentDropoffLte;
                            }
                            if (shipmentName !== undefined) {
                                localVarQueryParameter['shipment_name'] = shipmentName;
                            }
                            if (shipmentNameContains !== undefined) {
                                localVarQueryParameter['shipment_name__contains'] = shipmentNameContains;
                            }
                            if (shipmentOriginContains !== undefined) {
                                localVarQueryParameter['shipment_origin__contains'] = shipmentOriginContains;
                            }
                            if (shipmentPickupGte !== undefined) {
                                localVarQueryParameter['shipment_pickup__gte'] = (shipmentPickupGte instanceof Date) ?
                                    shipmentPickupGte.toISOString().substr(0, 10) :
                                    shipmentPickupGte;
                            }
                            if (shipmentPickupLte !== undefined) {
                                localVarQueryParameter['shipment_pickup__lte'] = (shipmentPickupLte instanceof Date) ?
                                    shipmentPickupLte.toISOString().substr(0, 10) :
                                    shipmentPickupLte;
                            }
                            if (shipmentPickupNumber !== undefined) {
                                localVarQueryParameter['shipment_pickup_number'] = shipmentPickupNumber;
                            }
                            if (shipmentPickupNumberContains !== undefined) {
                                localVarQueryParameter['shipment_pickup_number__contains'] = shipmentPickupNumberContains;
                            }
                            if (shipmentProNumber !== undefined) {
                                localVarQueryParameter['shipment_pro_number'] = shipmentProNumber;
                            }
                            if (shipmentProNumberContains !== undefined) {
                                localVarQueryParameter['shipment_pro_number__contains'] = shipmentProNumberContains;
                            }
                            if (shipmentPurchaseOrderNumber !== undefined) {
                                localVarQueryParameter['shipment_purchase_order_number'] = shipmentPurchaseOrderNumber;
                            }
                            if (shipmentPurchaseOrderNumberContains !== undefined) {
                                localVarQueryParameter['shipment_purchase_order_number__contains'] = shipmentPurchaseOrderNumberContains;
                            }
                            if (shipmentReferenceId !== undefined) {
                                localVarQueryParameter['shipment_reference_id'] = shipmentReferenceId;
                            }
                            if (shipmentReferenceIdContains !== undefined) {
                                localVarQueryParameter['shipment_reference_id__contains'] = shipmentReferenceIdContains;
                            }
                            if (shipmentState !== undefined) {
                                localVarQueryParameter['shipment_state'] = shipmentState;
                            }
                            if (shipmentStatus) {
                                localVarQueryParameter['shipment_status'] = shipmentStatus;
                            }
                            if (vendorId !== undefined) {
                                localVarQueryParameter['vendor_id'] = vendorId;
                            }
                            if (vendorNameContains !== undefined) {
                                localVarQueryParameter['vendor_name__contains'] = vendorNameContains;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create and tender a shipment to a Shipwell company
         * @param {TenderRequest} tenderRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        shipmentsTenderPost: function (tenderRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenderRequest' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsTenderPost', 'tenderRequest', tenderRequest);
                            localVarPath = "/shipments/tender/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(tenderRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Accept or reject tendered shipments.
         * @param {string} tenderId
         * @param {TenderAcceptReject} tenderAcceptReject
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        shipmentsTenderTenderIdActionsPost: function (tenderId, tenderAcceptReject, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenderId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsTenderTenderIdActionsPost', 'tenderId', tenderId);
                            // verify required parameter 'tenderAcceptReject' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsTenderTenderIdActionsPost', 'tenderAcceptReject', tenderAcceptReject);
                            localVarPath = "/shipments/tender/{tenderId}/actions/"
                                .replace("{".concat("tenderId", "}"), encodeURIComponent(String(tenderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(tenderAcceptReject, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Mark a tendered shipment as no longer available. Renders as \'closed\' in our system.
         * @param {string} tenderId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        shipmentsTenderTenderIdDelete: function (tenderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenderId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsTenderTenderIdDelete', 'tenderId', tenderId);
                            localVarPath = "/shipments/tender/{tenderId}/"
                                .replace("{".concat("tenderId", "}"), encodeURIComponent(String(tenderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update tendered shipment events
         * @param {string} tenderId
         * @param {TenderEventRequest} tenderEventRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        shipmentsTenderTenderIdEventsPost: function (tenderId, tenderEventRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenderId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsTenderTenderIdEventsPost', 'tenderId', tenderId);
                            // verify required parameter 'tenderEventRequest' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsTenderTenderIdEventsPost', 'tenderEventRequest', tenderEventRequest);
                            localVarPath = "/shipments/tender/{tenderId}/events/"
                                .replace("{".concat("tenderId", "}"), encodeURIComponent(String(tenderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(tenderEventRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a tendered shipment to a shipwell company NOTE: Only valid for shipments created by posting to this endpoint. Shipments created via other methods are not guaranteed to work and may have unintended side effects.
         * @param {string} tenderId
         * @param {TenderRequest} tenderRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        shipmentsTenderTenderIdPut: function (tenderId, tenderRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenderId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsTenderTenderIdPut', 'tenderId', tenderId);
                            // verify required parameter 'tenderRequest' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsTenderTenderIdPut', 'tenderRequest', tenderRequest);
                            localVarPath = "/shipments/tender/{tenderId}/"
                                .replace("{".concat("tenderId", "}"), encodeURIComponent(String(tenderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(tenderRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List tendered shipments
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [createdByCompanyId] Restrict Tenders by created by customer ID
         * @param {string} [shipmentCustomerReferenceNumber] Restrict Tenders by custoemr shipment reference number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTendersGet: function (page, pageSize, ordering, q, createdByCompanyId, shipmentCustomerReferenceNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipments/tenders/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (createdByCompanyId !== undefined) {
                                localVarQueryParameter['created_by_company__id'] = createdByCompanyId;
                            }
                            if (shipmentCustomerReferenceNumber !== undefined) {
                                localVarQueryParameter['shipment__customer_reference_number'] = shipmentCustomerReferenceNumber;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create and tender a shipment to a Shipwell company
         * @param {TenderRequest} tenderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTendersPost: function (tenderRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenderRequest' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsTendersPost', 'tenderRequest', tenderRequest);
                            localVarPath = "/shipments/tenders/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(tenderRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Accept or reject tendered shipments.
         * @param {string} tenderId
         * @param {TenderAcceptReject} tenderAcceptReject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTendersTenderIdActionsPost: function (tenderId, tenderAcceptReject, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenderId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsTendersTenderIdActionsPost', 'tenderId', tenderId);
                            // verify required parameter 'tenderAcceptReject' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsTendersTenderIdActionsPost', 'tenderAcceptReject', tenderAcceptReject);
                            localVarPath = "/shipments/tenders/{tenderId}/actions/"
                                .replace("{".concat("tenderId", "}"), encodeURIComponent(String(tenderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(tenderAcceptReject, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Mark a tendered shipment as no longer available. Renders as \'closed\' in the Shipwell platform.
         * @param {string} tenderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTendersTenderIdDelete: function (tenderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenderId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsTendersTenderIdDelete', 'tenderId', tenderId);
                            localVarPath = "/shipments/tenders/{tenderId}/"
                                .replace("{".concat("tenderId", "}"), encodeURIComponent(String(tenderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update tendered Shipment events.
         * @param {string} tenderId
         * @param {TenderEventRequest} tenderEventRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTendersTenderIdEventsPost: function (tenderId, tenderEventRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenderId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsTendersTenderIdEventsPost', 'tenderId', tenderId);
                            // verify required parameter 'tenderEventRequest' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsTendersTenderIdEventsPost', 'tenderEventRequest', tenderEventRequest);
                            localVarPath = "/shipments/tenders/{tenderId}/events/"
                                .replace("{".concat("tenderId", "}"), encodeURIComponent(String(tenderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(tenderEventRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a tendered shipment to a shipwell company NOTE: Only valid for shipments created by posting to this endpoint. Shipments created via other methods are not guaranteed to work and may have unintended side effects.
         * @param {string} tenderId
         * @param {TenderRequest} tenderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTendersTenderIdPut: function (tenderId, tenderRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenderId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsTendersTenderIdPut', 'tenderId', tenderId);
                            // verify required parameter 'tenderRequest' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsTendersTenderIdPut', 'tenderRequest', tenderRequest);
                            localVarPath = "/shipments/tenders/{tenderId}/"
                                .replace("{".concat("tenderId", "}"), encodeURIComponent(String(tenderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(tenderRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ShipmentsApiAxiosParamCreator = ShipmentsApiAxiosParamCreator;
/**
 * ShipmentsApi - functional programming interface
 * @export
 */
var ShipmentsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ShipmentsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Generate a BOL number for a shipment (Internal Shipwell Microservice use only)
         * @summary Generate BOL Number
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBolNumber: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.generateBolNumber(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns auction stats for shipments by their shipment id
         * @param {Array<string>} [shipmentId] Shipment ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsAuctionStatsGet: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsAuctionStatsGet(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List all ShipmentTags for the authenticated company for v3 shipment
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsBundlesShipmentIdTagsGet: function (shipmentId, page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsBundlesShipmentIdTagsGet(shipmentId, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a ShipmentTag for v3 shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentTagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsBundlesShipmentIdTagsShipmentTagIdDelete: function (shipmentId, shipmentTagId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsBundlesShipmentIdTagsShipmentTagIdDelete(shipmentId, shipmentTagId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a ShipmentTag by its id for v3 shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentTagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsBundlesShipmentIdTagsShipmentTagIdGet: function (shipmentId, shipmentTagId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsBundlesShipmentIdTagsShipmentTagIdGet(shipmentId, shipmentTagId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Add a ShipmentTag to v3 shipment bundle
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentTagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsBundlesShipmentIdTagsShipmentTagIdPost: function (shipmentId, shipmentTagId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsBundlesShipmentIdTagsShipmentTagIdPost(shipmentId, shipmentTagId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Return a limited amount of shipment details using API Key authentication and query params to search. Returns an empty list if no query params are passed
         * @param {Array<string>} [bolNumber] Include shipments with these BOL Numbers
         * @param {Array<string>} [pickupNumber] Include shipments with these Pickup Numbers
         * @param {Array<string>} [proNumber] Include shipments with these PRO Numbers
         * @param {Array<string>} [purchaseOrderNumber] Include shipments with these PO Numbers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsExternalGet: function (bolNumber, pickupNumber, proNumber, purchaseOrderNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsExternalGet(bolNumber, pickupNumber, proNumber, purchaseOrderNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a limited amount of shipment details using a query param key instead of authentication
         * @param {string} shipmentId The id of the shipment
         * @param {string} key Secret view key authorizing user to see the Shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsExternalShipmentIdGet: function (shipmentId, key, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsExternalShipmentIdGet(shipmentId, key, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get locations for the shipment using a query param key instead of authentication
         * @param {string} shipmentId The id of the shipment
         * @param {string} key Secret view key authorizing user to see the Shipment
         * @param {string} [beginDatetime] For requesting data starting at a given date
         * @param {string} [endDatetime] For requesting data ending at a given date
         * @param {string} [filterDistance] Applies a distance filter and only returns points greater than filter_distance km apart. To return all, set this to -1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsExternalShipmentIdTrackingGet: function (shipmentId, key, beginDatetime, endDatetime, filterDistance, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsExternalShipmentIdTrackingGet(shipmentId, key, beginDatetime, endDatetime, filterDistance, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of shipments
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [activeVendorAssignment] Include or exclude shipments with active CarrierAssignments
         * @param {'MOBILE_DEVICE_ALERT' | 'NON_ACTIVE_CARRIER'} [alertTypes] Filter on shipments that have alerts of this type
         * @param {boolean} [alerts] Filter on whether or not a Shipment has alert messages
         * @param {boolean} [archived] Filter on whether or not a shipment is archived
         * @param {Array<string>} [bolNumber] Include shipments with these BOL Numbers
         * @param {string} [bolNumberContains] Return shipments where the BOL number contains this value
         * @param {Array<string>} [bolNumberExclude] Exclude shipments with these BOL Numbers
         * @param {string} [createdAt] For requesting data created at a certain datetime
         * @param {Array<'SHIPWELL_WEB' | 'IMPORT' | 'TENDER' | 'SHIPWELL_WEB_UNAUTH' | 'OTHER'>} [createdBySource] Return shipments created by sources in the array.
         * @param {string} [createdByUserContains] Return shipments where created_by_user object contains this string e.g first_name, last_name or email
         * @param {Array<string>} [createdByUserId] Return shipments where created_by_user_id in the array.
         * @param {string} [createdByUserName] Return shipments where created_by_user_name is exactly this string
         * @param {string} [createdByUserNameContains] Return shipments where created_by_user_name contains this string
         * @param {string} [customer] Return shipments with this exact value as the customer company name
         * @param {string} [customerContains] Return shipments where the customer company name contains this value
         * @param {string} [customerId] Return shipments with this exact id for the customer company
         * @param {Array<string>} [customerReferenceNumber] Include shipments with these Customer Reference Numbers
         * @param {string} [customerReferenceNumberContains] Include shipments where the Customer Reference Numbers contains this value
         * @param {Array<string>} [customerReferenceNumberExclude] Exclude shipments with these Customer Reference Numbers
         * @param {string} [destinationContains] Return shipments with this value in the destination
         * @param {string} [deliveryStopsContains] Return shipments with this value in one of its dropoff stops
         * @param {string} [deliveryStopsCompanyNameContains] Return shipments with this value in one of its delivery stops location company_name
         * @param {string} [destinationStateProvince] Return shipments with this state province on its destination stop
         * @param {string} [deliveryStopsStateProvince] Return shipments with this state province on its delivery stops
         * @param {string} [drayageBookingNumberContains] Include shipments where the drayage booking number contains this value
         * @param {string} [drayageChassisNumberContains] Include shipments where the drayage chassis number contains this value
         * @param {string} [drayageContainerNumberContains] Include shipments where the drayage container number contains this value
         * @param {string} [drayageContainerReturnDateGte] Include shipments where the drayage container return date is greater than or equal to this value
         * @param {string} [drayageContainerReturnDateLte] Include shipments where the drayage container return date is less than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateGte] Include shipments where the drayage estimated arrival date is greater than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateLte] Include shipments where the drayage estimated arrival date is less than or equal to this value
         * @param {string} [drayageLastFreeDateGte] Include shipments where the drayage last free datetime is greater than or equal to this value
         * @param {string} [drayageLastFreeDateLte] Include shipments where the drayage last free datetime is less than or equal to this value
         * @param {string} [drayageReleaseDateGte] Include shipments where the drayage release datetime is greater than or equal to this value
         * @param {string} [drayageReleaseDateLte] Include shipments where the drayage release datetime is less than or equal to this value
         * @param {string} [drayageSealNumberContains] Include shipments where the drayage seal number contains this value
         * @param {boolean} [driverAssigned] Return shipments where the driver is assigned/unassigned
         * @param {string} [dropoffGte] Return shipments with a dropoff stop with a planned date greater than or equal to this value
         * @param {string} [dropoffLte] Return shipments with a dropoff stop with a planned data less than or equal to this value
         * @param {string} [equipmentType] Return shipments with this equipment type
         * @param {string} [equipmentTypeContains] Return shipments where the equipment type contains this value
         * @param {string} [fedexAccount] Return pickups specific to this FedEx account
         * @param {string} [groupId] Group id for a shipment
         * @param {boolean} [hasInvoice] If true, show shipments which have at least one invoice otherwise show those with none.
         * @param {boolean} [hasBill] If true, show shipments which have at least one bill otherwise show those with none.
         * @param {Array<string>} [include] [v3] A list of properties to include in the response resource
         * @param {boolean} [loadBoardEnabled] Filter on whether or not a shipment is posted on the company load board
         * @param {string} [loadBoardId] Return shipments where the load board ID is equal to this value
         * @param {string} [loadBoardIdContains] Return shipments where the load board ID contains this value
         * @param {string} [mode] Return shipments with this shipment mode
         * @param {string} [modeContains] Return shipments where the shipment mode contains this value
         * @param {string} [nameContains] Return shipments where the shipment name contains this value
         * @param {boolean} [open] Filter on whether or not a shipment is open
         * @param {string} [originContains] Return shipments with this value in the origin
         * @param {string} [originStateProvince] Return shipments with this state province on its origin stop
         * @param {string} [pickupStopsStateProvince] Return shipments with this state province on its pickup stops
         * @param {string} [pickupStopsContains] Return shipments with this value in one of its pickup stops
         * @param {string} [pickupStopsCompanyNameContains] Return shipments with this value in one of its pickup stops location company_name
         * @param {Array<'CANCELLED' | 'DELAYED' | 'DELIVERED' | 'IN_TRANSIT' | 'NOT_SCHEDULED' | 'SCHEDULED'>} [parcelPickupStatus] Include shipments where the parcel pickup status equals one of these values
         * @param {string} [pickupGte] Return shipments with a pickup stop with a planned date greater than or equal to this value
         * @param {string} [updatedAtGte] Return shipments updated greater than or equal to this value
         * @param {string} [updatedAtLte] Return shipments updated less than or equal to this value
         * @param {string} [pickupLte] Return shipments with a pickup stop with a planned date less than or equal to this value
         * @param {string} [pickupId] Include shipments currently associated with the provided ShipmentPickup\&#39;s ID
         * @param {Array<string>} [pickupNumber] Include shipments with these Pickup Numbers
         * @param {string} [pickupNumberContains] Include shipments where the Pickup Number contains this value
         * @param {Array<string>} [pickupNumberExclude] Exclude shipments with these Pickup Numbers
         * @param {Array<string>} [proNumber] Include shipments with these PRO Numbers
         * @param {string} [proNumberContains] Return shipments where the PRO number contains this value
         * @param {Array<string>} [proNumberExclude] Exclude shipments with these PRO Numbers
         * @param {string} [powerUnit] Return shipments where this power unit is assigned
         * @param {Array<string>} [purchaseOrderNumber] Include shipments with these PO Numbers
         * @param {string} [purchaseOrderNumberContains] Include shipments where the PO number contains this value
         * @param {Array<string>} [purchaseOrderNumberExclude] Exclude shipments with these PO Numbers
         * @param {Array<string>} [referenceId] Include shipments with these Reference IDs
         * @param {string} [referenceIdContains] Include shipments where the reference ID contains this value
         * @param {Array<string>} [referenceIdExclude] Exclude shipments with these Reference IDs
         * @param {Array<string>} [masterAirWaybill] Include shipments with these Master Air Waybill Numbers
         * @param {string} [masterAirWaybillContains] Include shipments where the Master Air Waybill number contains this value
         * @param {Array<string>} [houseAirWaybill] Include shipments with these House Air Waybill Numbers
         * @param {string} [houseAirWaybillContains] Include shipments where the House Air Waybill number contains this value
         * @param {Array<string>} [reps] Include shipments with these reps
         * @param {'owner_operator'} [role] Get results based on a specific perspective such as owner_operator
         * @param {string} [serviceLevel] Return shipments with this service level
         * @param {Array<string>} [accessorials] Include only shipments with at least one matching ShipmentAccessorial
         * @param {string} [createdAtGte] Include shipments where created_at is greater than or equal to the time value
         * @param {string} [createdAtLte] Include shipments where created_at is less than or equal to this value
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [statusExclude] Exclude shipments with these statuses
         * @param {string} [statusContains] Include shipments where the status contains this string
         * @param {Array<string>} [tags] Include only shipments with at least one matching ShipmentTag
         * @param {Array<string>} [tagsExclude] Excludes shipments with at least one matching tag
         * @param {Array<string>} [shipmentShipwellCustomData] Include shipments that contain these shipment-level custom data values
         * @param {string} [stopsContains] Return shipments with this value in one of its stops
         * @param {string} [stopsCompanyNameContains] Return shipments with this value in one of its stops location company_name
         * @param {string} [stopsStateProvince] Return shipments with this state province on one of its stops
         * @param {string} [timelineLastUpdatedAtGte] Return shipments where last timeline update was greater than or equal to the value or was never updated
         * @param {string} [timelineLastUpdatedAtLte] Return shipments where last timeline update was less than or equal to the value or was never updated
         * @param {'current' | 'upcoming' | 'active' | 'past'} [timeFrame] Return shipments that are within the given time frame. active &#x3D; current + upcoming
         * @param {number} [totalMilesGte] Return shipments with total miles greater than or equal to this value
         * @param {number} [totalMilesLte] Return shipments with total miles less than or equal to this value
         * @param {string} [upsAccount] Return pickups specific to this UPS account
         * @param {string} [vendorId] Return shipments with this exact value as the vendor Carrier id
         * @param {string} [vendorContains] Return shipments where the vendor company name contains this value
         * @param {number} [totalWeightOverrideGte] Return shipments with weight greater than or equal to this value
         * @param {number} [totalWeightOverrideLte] Return shipments with weight less than or equal to this value
         * @param {number} [originRadius] Radius from origin stop
         * @param {number} [originLat] Latitude of location to filter on for origin stop
         * @param {number} [originLon] Longitude of location to filter on for origin stop
         * @param {number} [pickupRadius] Radius from a pickup stop
         * @param {number} [pickupLat] Latitude of location to filter on for pickup stop
         * @param {number} [pickupLon] Longitude of location to filter on for pickup stop
         * @param {number} [destinationRadius] Radius from the destination stop
         * @param {number} [destinationLat] Latitude of location to filter on for destination stop
         * @param {number} [destinationLon] Longitude of location to filter on for destination stop
         * @param {number} [deliveryRadius] Radius from a delivery stop
         * @param {number} [deliveryLat] Latitude of location to filter on for delivery stop
         * @param {number} [deliveryLon] Longitude of location to filter on for delivery stop
         * @param {Array<'RUNNING' | 'CANCELLED' | 'FAILED' | 'SUCCESS'>} [workflowExecutionStatus] Include shipments with these workflow execution statuses
         * @param {boolean} [showClonedResults] If true, show shipments that have a non null last_cloned_at value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsGet: function (xCompanyId, page, pageSize, ordering, q, activeVendorAssignment, alertTypes, alerts, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, updatedAtGte, updatedAtLte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, accessorials, createdAtGte, createdAtLte, status, statusExclude, statusContains, tags, tagsExclude, shipmentShipwellCustomData, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, workflowExecutionStatus, showClonedResults, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsGet(xCompanyId, page, pageSize, ordering, q, activeVendorAssignment, alertTypes, alerts, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, updatedAtGte, updatedAtLte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, accessorials, createdAtGte, createdAtLte, status, statusExclude, statusContains, tags, tagsExclude, shipmentShipwellCustomData, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, workflowExecutionStatus, showClonedResults, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Estimate how many linear feet of a truck that ShipmentLineItems would fill if packed optimally
         * @param {LinearFeetEstimate} linearFeetEstimate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsLinearFeetPost: function (linearFeetEstimate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsLinearFeetPost(linearFeetEstimate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List of pickups for a company
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [scheduledDate] Date of a scheduled pickup
         * @param {string} [scheduledDateGte] Return pickups with a scheduled date greater than or equal to this value
         * @param {string} [scheduledDateLte] Return pickups with a scheduled date less than or equal to this value
         * @param {string} [scheduledTimeWindowStartGte] Return pickups with a scheduled start time window date and time greater than or equal to this value
         * @param {string} [scheduledTimeWindowStartLte] Return pickups with a scheduled start time window date and time less than or equal to this value
         * @param {string} [scheduledTimeWindowEndGte] Return pickups with a scheduled end time window date and time greater than or equal to this value
         * @param {string} [scheduledTimeWindowEndLte] Return pickups with a scheduled end time window date and time less than or equal to this value
         * @param {string} [pointOfContact] Include pickups with this point of contact name
         * @param {string} [pointOfContactContains] Include pickups where the point of contact includes this value
         * @param {string} [pointOfContactExcludes] Exclude pickups where the point of contact includes this value
         * @param {string} [specialInstructions] Include pickups with these special instructions
         * @param {string} [specialInstructionsContains] Include pickups where the special instructions includes this value
         * @param {string} [specialInstructionsExcludes] Exclude pickups where the special instructions includes this value
         * @param {string} [pickupNumber] Include pickups with this pickup number
         * @param {string} [pickupNumberContains] Include pickups where the pickup number contains this value
         * @param {string} [pickupNumberExcludes] Exclude pickups with this pickup number
         * @param {string} [providerCode] Include pickups with this provider code
         * @param {string} [providerCarrierCode] Include pickups with this provider carrier code
         * @param {string} [providerCarrierCodeContains] Include pickups where the provider carrier code contains this value
         * @param {string} [providerCarrierCodeExcludes] Exclude pickups with this provider carrier code
         * @param {string} [providerLocationId] Include pickups with this provider location id
         * @param {string} [providerLocationIdContains] Include pickups where the provider location id  contains this value
         * @param {string} [providerLocationIdExcludes] Exclude pickups with this provider location id
         * @param {string} [addressBookEntry] Include pickups with this address book entry id
         * @param {boolean} [isRegularlyScheduled] Include pickups with this is_regularly_scheduled value
         * @param {boolean} [cancelled] Return pickups based on if they are cancelled
         * @param {string} [shipmentIds] Return pickup with that include this shipment
         * @param {string} [company] Return pickups specific to this company
         * @param {string} [fedexAccount] Return pickups specific to this FedEx account
         * @param {string} [upsAccount] Return pickups specific to this UPS account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsPickupsGet: function (page, pageSize, ordering, q, scheduledDate, scheduledDateGte, scheduledDateLte, scheduledTimeWindowStartGte, scheduledTimeWindowStartLte, scheduledTimeWindowEndGte, scheduledTimeWindowEndLte, pointOfContact, pointOfContactContains, pointOfContactExcludes, specialInstructions, specialInstructionsContains, specialInstructionsExcludes, pickupNumber, pickupNumberContains, pickupNumberExcludes, providerCode, providerCarrierCode, providerCarrierCodeContains, providerCarrierCodeExcludes, providerLocationId, providerLocationIdContains, providerLocationIdExcludes, addressBookEntry, isRegularlyScheduled, cancelled, shipmentIds, company, fedexAccount, upsAccount, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsPickupsGet(page, pageSize, ordering, q, scheduledDate, scheduledDateGte, scheduledDateLte, scheduledTimeWindowStartGte, scheduledTimeWindowStartLte, scheduledTimeWindowEndGte, scheduledTimeWindowEndLte, pointOfContact, pointOfContactContains, pointOfContactExcludes, specialInstructions, specialInstructionsContains, specialInstructionsExcludes, pickupNumber, pickupNumberContains, pickupNumberExcludes, providerCode, providerCarrierCode, providerCarrierCodeContains, providerCarrierCodeExcludes, providerLocationId, providerLocationIdContains, providerLocationIdExcludes, addressBookEntry, isRegularlyScheduled, cancelled, shipmentIds, company, fedexAccount, upsAccount, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Schedule a pickup
         * @param {ScheduleShipmentPickupRequest} scheduleShipmentPickupRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsPickupsPost: function (scheduleShipmentPickupRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsPickupsPost(scheduleShipmentPickupRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve data for a shipment pickup
         * @param {string} shipmentPickupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsPickupsShipmentPickupIdGet: function (shipmentPickupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsPickupsShipmentPickupIdGet(shipmentPickupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a shipment pickup
         * @param {string} shipmentPickupId
         * @param {ShipmentPickup} shipmentPickup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsPickupsShipmentPickupIdPut: function (shipmentPickupId, shipmentPickup, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsPickupsShipmentPickupIdPut(shipmentPickupId, shipmentPickup, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Shipments start in a \"draft\" state by default. Only the `metadata` parameter set to `\"open\": false, \"archived\": false,` and `tags:` set to `[]` are required to begin a draft shipment.
         * @summary Create a new Shipment
         * @param {Shipment} shipment
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsPost: function (shipment, xCompanyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsPost(shipment, xCompanyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Transform shipments into round trips
         * @param {InlineObject22} [inlineObject22]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsRoundTripJobPost: function (inlineObject22, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsRoundTripJobPost(inlineObject22, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Return results from round trip job
         * @param {string} roundTripJobId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsRoundTripJobRoundTripJobIdGet: function (roundTripJobId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsRoundTripJobRoundTripJobIdGet(roundTripJobId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the shipment OpenAPI schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsSchemaGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsSchemaGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update an existing shipment to add one or more purchase orders
         * @param {string} shipmentId The id of the shipment
         * @param {InlineObject23} [inlineObject23]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAddOrdersPut: function (shipmentId, inlineObject23, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdAddOrdersPut(shipmentId, inlineObject23, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a shipwell automation event
         * @param {string} shipmentId The id of the shipment
         * @param {string} automationEventId The id of the shipment automation event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAutomationEventsAutomationEventIdDelete: function (shipmentId, automationEventId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdAutomationEventsAutomationEventIdDelete(shipmentId, automationEventId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a shipwell automation event
         * @param {string} shipmentId The id of the shipment
         * @param {string} automationEventId The id of the shipment automation event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAutomationEventsAutomationEventIdGet: function (shipmentId, automationEventId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdAutomationEventsAutomationEventIdGet(shipmentId, automationEventId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a shipwell automation event
         * @param {string} shipmentId The id of the shipment
         * @param {string} automationEventId The id of the shipment automation event
         * @param {AutomationEvent} automationEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAutomationEventsAutomationEventIdPut: function (shipmentId, automationEventId, automationEvent, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdAutomationEventsAutomationEventIdPut(shipmentId, automationEventId, automationEvent, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Cancel and delete all future scheduled automation events on a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAutomationEventsCancelScheduledDelete: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdAutomationEventsCancelScheduledDelete(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve automated shipwell events
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAutomationEventsGet: function (shipmentId, page, pageSize, ordering, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdAutomationEventsGet(shipmentId, page, pageSize, ordering, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Schedule an automated shipwell event
         * @param {string} shipmentId The id of the shipment
         * @param {AutomationEvent} automationEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAutomationEventsPost: function (shipmentId, automationEvent, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdAutomationEventsPost(shipmentId, automationEvent, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create multiple documents onto a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {ShipmentBulkDocument} [shipmentBulkDocument]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdBulkDocumentsPost: function (shipmentId, shipmentBulkDocument, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdBulkDocumentsPost(shipmentId, shipmentBulkDocument, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a CarrierAssignment by its id
         * @param {string} shipmentId The id of the shipment
         * @param {string} carrierAssignmentId The id of a CarrierAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCarrierAssignmentsCarrierAssignmentIdGet: function (shipmentId, carrierAssignmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdCarrierAssignmentsCarrierAssignmentIdGet(shipmentId, carrierAssignmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update the charge line items of a CarrierAssignment
         * @param {string} shipmentId The id of the shipment
         * @param {string} carrierAssignmentId The id of a CarrierAssignment
         * @param {CarrierAssignment} carrierAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCarrierAssignmentsCarrierAssignmentIdPut: function (shipmentId, carrierAssignmentId, carrierAssignment, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdCarrierAssignmentsCarrierAssignmentIdPut(shipmentId, carrierAssignmentId, carrierAssignment, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete the carrier assignment associated with the shipment
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCarrierAssignmentsDelete: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdCarrierAssignmentsDelete(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the current assigned carrier associated with this shipment
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCarrierAssignmentsGet: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdCarrierAssignmentsGet(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Only one carrier assignment is associated with a company-shipment combo at a time.  Posting here will overwrite the companies carrier assignment. Carrier assignments are only shown to the user who sets it
         * @summary Create a new carrier assignment
         * @param {string} shipmentId The id of the shipment
         * @param {CarrierAssignment} carrierAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCarrierAssignmentsPost: function (shipmentId, carrierAssignment, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdCarrierAssignmentsPost(shipmentId, carrierAssignment, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the carrier and equipment data
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCarrierConfigGet: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdCarrierConfigGet(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Internal route used to provide and update information around the carrier and equipment section
         * @summary Update the carrier config data
         * @param {string} shipmentId The id of the shipment
         * @param {CarrierConfig} carrierConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCarrierConfigPost: function (shipmentId, carrierConfig, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdCarrierConfigPost(shipmentId, carrierConfig, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Initialize a shipment for appless cell phone tracking
         * @param {string} shipmentId The id of the shipment
         * @param {CellTrackingInitRequest} cellTrackingInitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCellTrackingPost: function (shipmentId, cellTrackingInitRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdCellTrackingPost(shipmentId, cellTrackingInitRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the Shipment Container Details data
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdContainerDetailsGet: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdContainerDetailsGet(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDelete: function (shipmentId, xCompanyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdDelete(shipmentId, xCompanyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the particular dispatch job data associated with this shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} dispatchJobId The id of the dispatch job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDispatchJobDispatchJobIdGet: function (shipmentId, dispatchJobId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdDispatchJobDispatchJobIdGet(shipmentId, dispatchJobId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get auditlog of documents sent
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsAuditlogGet: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdDocumentsAuditlogGet(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a Document
         * @param {string} shipmentId The id of the shipment
         * @param {string} documentId The id of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsDocumentIdDelete: function (shipmentId, documentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdDocumentsDocumentIdDelete(shipmentId, documentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get metadata about a document
         * @param {string} shipmentId The id of the shipment
         * @param {string} documentId The id of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsDocumentIdGet: function (shipmentId, documentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdDocumentsDocumentIdGet(shipmentId, documentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update metadata about a document
         * @param {string} shipmentId The id of the shipment
         * @param {string} documentId The id of the document
         * @param {ShipmentDocumentMetadata} shipmentDocumentMetadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsDocumentIdPut: function (shipmentId, documentId, shipmentDocumentMetadata, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdDocumentsDocumentIdPut(shipmentId, documentId, shipmentDocumentMetadata, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new signature request for an specific document.
         * @param {string} shipmentId The id of the shipment
         * @param {string} documentId The id of the document
         * @param {ShipmentDocumentRequestSignature} [shipmentDocumentRequestSignature]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsDocumentIdRequestSignaturePost: function (shipmentId, documentId, shipmentDocumentRequestSignature, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdDocumentsDocumentIdRequestSignaturePost(shipmentId, documentId, shipmentDocumentRequestSignature, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Attach the signature file to the existing request object.
         * @param {string} shipmentId The id of the shipment
         * @param {string} documentId The id of the document
         * @param {string} [description] An optional description of the signature
         * @param {any} [file] The signature file
         * @param {string} [signatoryName] The name of the signatory
         * @param {string} [signatoryRole] The role of the signatory
         * @param {string} [stopId] The Stop reference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsDocumentIdSignPost: function (shipmentId, documentId, description, file, signatoryName, signatoryRole, stopId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdDocumentsDocumentIdSignPost(shipmentId, documentId, description, file, signatoryName, signatoryRole, stopId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get signatures for a document
         * @param {string} shipmentId The id of the shipment
         * @param {string} documentId The id of the document
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsDocumentIdSignaturesGet: function (shipmentId, documentId, page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdDocumentsDocumentIdSignaturesGet(shipmentId, documentId, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Generate a BOL for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsGenerateBolGet: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdDocumentsGenerateBolGet(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Generate a rate confirmation for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsGenerateRateConfirmationGet: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdDocumentsGenerateRateConfirmationGet(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Generate shipping labels for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsGenerateShippingLabelGet: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdDocumentsGenerateShippingLabelGet(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get metadata about a documents on a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsGet: function (shipmentId, page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdDocumentsGet(shipmentId, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a document on a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} description
         * @param {any} file
         * @param {boolean} isCarrierDocument
         * @param {string} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsPost: function (shipmentId, description, file, isCarrierDocument, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdDocumentsPost(shipmentId, description, file, isCarrierDocument, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Send shipment documents to a list of email recipients
         * @param {string} shipmentId The id of the shipment
         * @param {SendDocument} sendDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsSendPost: function (shipmentId, sendDocument, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdDocumentsSendPost(shipmentId, sendDocument, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the current equipment config associated with this shipment
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdEquipmentConfigGet: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdEquipmentConfigGet(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Only one equipment config is associated with a shipment at a time.  Posting here will overwrite the previous equipment config and attempt to track with the new configuration.
         * @summary Create a new equipment config
         * @param {string} shipmentId The id of the shipment
         * @param {CreateEquipmentConfig} createEquipmentConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdEquipmentConfigPost: function (shipmentId, createEquipmentConfig, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdEquipmentConfigPost(shipmentId, createEquipmentConfig, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdGet: function (shipmentId, xCompanyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdGet(shipmentId, xCompanyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of ShipmentTimelineEvents grouped by Stop for a given Shipment
         * @param {string} shipmentId The id of the shipment
         * @param {'location' | 'status'} [groupType] The type of timeline events to return, defaults to all
         * @param {boolean} [filterFutureStops] Whether to remove future stops from the list of grouped timeline events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdGroupedTimelineEventsGet: function (shipmentId, groupType, filterFutureStops, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdGroupedTimelineEventsGet(shipmentId, groupType, filterFutureStops, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List messages for a Shipment
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [q] search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdMessagesGet: function (shipmentId, page, pageSize, q, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdMessagesGet(shipmentId, page, pageSize, q, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new message for a Shipment
         * @param {string} shipmentId The id of the shipment
         * @param {ShipmentMessage} shipmentMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdMessagesPost: function (shipmentId, shipmentMessage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdMessagesPost(shipmentId, shipmentMessage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a ShipmentMessage
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentMessageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdMessagesShipmentMessageIdDelete: function (shipmentId, shipmentMessageId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdMessagesShipmentMessageIdDelete(shipmentId, shipmentMessageId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve data for a ShipmentMessage
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentMessageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdMessagesShipmentMessageIdGet: function (shipmentId, shipmentMessageId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdMessagesShipmentMessageIdGet(shipmentId, shipmentMessageId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Mark a ShipmentMessage as read
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentMessageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdMessagesShipmentMessageIdMarkAsReadPost: function (shipmentId, shipmentMessageId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdMessagesShipmentMessageIdMarkAsReadPost(shipmentId, shipmentMessageId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Mark a ShipmentMessage as unread
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentMessageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdMessagesShipmentMessageIdMarkAsUnreadPost: function (shipmentId, shipmentMessageId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdMessagesShipmentMessageIdMarkAsUnreadPost(shipmentId, shipmentMessageId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a ShipmentMessage
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentMessageId
         * @param {ShipmentMessage} shipmentMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdMessagesShipmentMessageIdPut: function (shipmentId, shipmentMessageId, shipmentMessage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdMessagesShipmentMessageIdPut(shipmentId, shipmentMessageId, shipmentMessage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List notes for a Shipment or Shipment Quote
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdNotesGet: function (shipmentId, page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdNotesGet(shipmentId, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new note for a Shipment or Shipment Quote
         * @param {string} shipmentId The id of the shipment
         * @param {ShipmentNote} shipmentNote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdNotesPost: function (shipmentId, shipmentNote, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdNotesPost(shipmentId, shipmentNote, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a ShipmentNote
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdNotesShipmentNoteIdDelete: function (shipmentId, shipmentNoteId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdNotesShipmentNoteIdDelete(shipmentId, shipmentNoteId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve data for a ShipmentNote
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdNotesShipmentNoteIdGet: function (shipmentId, shipmentNoteId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdNotesShipmentNoteIdGet(shipmentId, shipmentNoteId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a ShipmentNote
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentNoteId
         * @param {ShipmentNote} shipmentNote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdNotesShipmentNoteIdPut: function (shipmentId, shipmentNoteId, shipmentNote, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdNotesShipmentNoteIdPut(shipmentId, shipmentNoteId, shipmentNote, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * After a successful update, the \'stops\' and \'line_items\' of the Shipment will be exactly the same as those provided in the request. This means that if existing \'stops\' or \'ShipmentLineItems\' were left out of their arrays, those objects would be deleted. Providing existing objects in those arrays with their ids will update those objects instead of creating or deleting them. Providing objects in the arrays that do not have ids will create new objects. If you omit the \'stops\' or \'line_items\' arrays from the request body, no changes will be made to those related object sets.
         * @summary Update a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {Shipment} shipment
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdPut: function (shipmentId, shipment, xCompanyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdPut(shipmentId, shipment, xCompanyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Remove a purchase order from an existing shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} orderId The id of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdRemoveOrdersOrderIdPut: function (shipmentId, orderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdRemoveOrdersOrderIdPut(shipmentId, orderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the list of the shipment reps
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdRepsGet: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdRepsGet(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Add a rep to a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {CreateShipmentRepRequest} createShipmentRepRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdRepsPost: function (shipmentId, createShipmentRepRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdRepsPost(shipmentId, createShipmentRepRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a rep record
         * @param {string} shipmentId The id of the shipment
         * @param {string} repId The id of the rep
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdRepsRepIdDelete: function (shipmentId, repId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdRepsRepIdDelete(shipmentId, repId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a specific shipment rep
         * @param {string} shipmentId The id of the shipment
         * @param {string} repId The id of the rep
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdRepsRepIdGet: function (shipmentId, repId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdRepsRepIdGet(shipmentId, repId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a Rep record
         * @param {string} shipmentId The id of the shipment
         * @param {string} repId The id of the rep
         * @param {UpdateShipmentRepRequest} updateShipmentRepRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdRepsRepIdPut: function (shipmentId, repId, updateShipmentRepRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdRepsRepIdPut(shipmentId, repId, updateShipmentRepRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Send an SMS message requesting that someone download Shipwell app
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdRequestAppDownloadPost: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdRequestAppDownloadPost(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Send an SMS to locate request to a Driver
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdSmsTrackingPost: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdSmsTrackingPost(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of Stops for a given Shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsGet: function (shipmentId, xCompanyId, page, pageSize, ordering, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdStopsGet(shipmentId, xCompanyId, page, pageSize, ordering, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * The new Stop must not have the same \'ordinal_index\' as any other Stop associated with that Shipment.
         * @summary Create a new Stop
         * @param {string} shipmentId The id of the shipment
         * @param {Stop} stop
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsPost: function (shipmentId, stop, xCompanyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdStopsPost(shipmentId, stop, xCompanyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of StopAlerts for a given Stop
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdAlertsGet: function (shipmentId, stopId, page, pageSize, ordering, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdStopsStopIdAlertsGet(shipmentId, stopId, page, pageSize, ordering, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new StopAlert
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {StopAlert} stopAlert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdAlertsPost: function (shipmentId, stopId, stopAlert, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdStopsStopIdAlertsPost(shipmentId, stopId, stopAlert, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a StopAlert
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {string} stopAlertId The id of the stop alert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdAlertsStopAlertIdDelete: function (shipmentId, stopId, stopAlertId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdStopsStopIdAlertsStopAlertIdDelete(shipmentId, stopId, stopAlertId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a StopAlert
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {string} stopAlertId The id of the stop alert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdAlertsStopAlertIdGet: function (shipmentId, stopId, stopAlertId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdStopsStopIdAlertsStopAlertIdGet(shipmentId, stopId, stopAlertId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a StopAlert
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {string} stopAlertId The id of the stop alert
         * @param {StopAlert} stopAlert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdAlertsStopAlertIdPut: function (shipmentId, stopId, stopAlertId, stopAlert, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdStopsStopIdAlertsStopAlertIdPut(shipmentId, stopId, stopAlertId, stopAlert, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a Stop
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdDelete: function (shipmentId, stopId, xCompanyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdStopsStopIdDelete(shipmentId, stopId, xCompanyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new stop-related shipment timeline event
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {StopEvent} stopEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdEventsPost: function (shipmentId, stopId, stopEvent, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdStopsStopIdEventsPost(shipmentId, stopId, stopEvent, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a Stop
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdGet: function (shipmentId, stopId, xCompanyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdStopsStopIdGet(shipmentId, stopId, xCompanyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a Stop
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {Stop} stop
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdPut: function (shipmentId, stopId, stop, xCompanyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdStopsStopIdPut(shipmentId, stopId, stop, xCompanyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of ShipmentTimelineEvents for a given Shipment
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdTimelineEventsGet: function (shipmentId, page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdTimelineEventsGet(shipmentId, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new ShipmentTimelineEvent
         * @param {string} shipmentId The id of the shipment
         * @param {CreateShipmentTimelineEvent} createShipmentTimelineEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdTimelineEventsPost: function (shipmentId, createShipmentTimelineEvent, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdTimelineEventsPost(shipmentId, createShipmentTimelineEvent, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a ShipmentTimelineEvent
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentTimelineEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdDelete: function (shipmentId, shipmentTimelineEventId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdDelete(shipmentId, shipmentTimelineEventId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a ShipmentTimelineEvent
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentTimelineEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdGet: function (shipmentId, shipmentTimelineEventId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdGet(shipmentId, shipmentTimelineEventId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a ShipmentTimelineEvent
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentTimelineEventId
         * @param {CreateShipmentTimelineEvent} createShipmentTimelineEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdPut: function (shipmentId, shipmentTimelineEventId, createShipmentTimelineEvent, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdPut(shipmentId, shipmentTimelineEventId, createShipmentTimelineEvent, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get locations for the shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} [beginDatetime] For requesting data starting at a given date
         * @param {string} [endDatetime] For requesting data ending at a given date
         * @param {string} [filterDistance] Applies a distance filter and only returns points greater than filter_distance km apart. To return all, set this to -1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdTrackingGet: function (shipmentId, beginDatetime, endDatetime, filterDistance, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdTrackingGet(shipmentId, beginDatetime, endDatetime, filterDistance, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Manually update Shipment Location. Authenticated drivers can also use this route to update their location
         * @param {string} shipmentId The id of the shipment
         * @param {ELDLocationUpdateRequest} eLDLocationUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdTrackingPost: function (shipmentId, eLDLocationUpdateRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdTrackingPost(shipmentId, eLDLocationUpdateRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List of all stop event types supported by the API along with their categorial groupings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsStopEventTypesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsStopEventTypesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of all stop locations for shipments user is associated with
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [companyName] Return stop locations whose company_name is equivalent to this value
         * @param {string} [companyNameContains] Return stop locations with this value in the company_name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsStopLocationsGet: function (page, pageSize, companyName, companyNameContains, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsStopLocationsGet(page, pageSize, companyName, companyNameContains, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List all ShipmentTags for the authenticated company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTagsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsTagsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a ShipmentTag for the authenticated company
         * @param {ShipmentTag} shipmentTag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTagsPost: function (shipmentTag, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsTagsPost(shipmentTag, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a ShipmentTag
         * @param {string} shipmentTagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTagsShipmentTagIdDelete: function (shipmentTagId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsTagsShipmentTagIdDelete(shipmentTagId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a ShipmentTag by its id
         * @param {string} shipmentTagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTagsShipmentTagIdGet: function (shipmentTagId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsTagsShipmentTagIdGet(shipmentTagId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a ShipmentTag
         * @param {string} shipmentTagId
         * @param {ShipmentTag} shipmentTag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTagsShipmentTagIdPut: function (shipmentTagId, shipmentTag, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsTagsShipmentTagIdPut(shipmentTagId, shipmentTag, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List all Shipment Templates for the authenticated company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTemplatesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsTemplatesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a ShipmentTemplate for the authenticated company
         * @param {ShipmentTemplateRequest} shipmentTemplateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTemplatesPost: function (shipmentTemplateRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsTemplatesPost(shipmentTemplateRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a Shipment Template
         * @param {string} shipmentTemplateId The ID of the shipment template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTemplatesShipmentTemplateIdDelete: function (shipmentTemplateId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsTemplatesShipmentTemplateIdDelete(shipmentTemplateId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a Shipment Template by its id
         * @param {string} shipmentTemplateId The ID of the shipment template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTemplatesShipmentTemplateIdGet: function (shipmentTemplateId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsTemplatesShipmentTemplateIdGet(shipmentTemplateId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a Shipment Template
         * @param {string} shipmentTemplateId The ID of the shipment template
         * @param {ShipmentTemplateRequest} shipmentTemplateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTemplatesShipmentTemplateIdPut: function (shipmentTemplateId, shipmentTemplateRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsTemplatesShipmentTemplateIdPut(shipmentTemplateId, shipmentTemplateRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List tendered shipments
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [closedByCustomer] Restrict SpotNegotiations based on whether customer closed
         * @param {boolean} [closedByVendor] Restrict SpotNegotiations based on whether vendor closed
         * @param {string} [customerId] ID of customer company to which to restrict SpotNegotiations
         * @param {string} [customerNameContains] Partial name of customer company to which to restrict SpotNegotiations
         * @param {boolean} [involvedOnly] Restrict SpotNegotiations to those in which user is explicitly involved
         * @param {Array<string>} [involvedVendorUsers] Restrict SpotNegotiations to those with provided User IDs involved on the vendor side
         * @param {boolean} [isMostRecentWinner] Restrict SpotNegotiations to those that are or are not the most recent winner
         * @param {boolean} [isOpen] Restrict SpotNegotiations based on both sides agreeing the negotiation is open
         * @param {string} [shipment] Return SpotNegotiations where Shipment ID matches
         * @param {string} [shipmentBolNumber] Return SpotNegotiations where Shipment BOL number matches
         * @param {string} [shipmentBolNumberContains] Return SpotNegotiations where Shipment BOL number partially matches
         * @param {string} [shipmentCapacityProviderCustomerReferenceNumber] Return SpotNegotiations where Shipment capacity provider customer reference number matches
         * @param {string} [shipmentCapacityProviderCustomerReferenceNumberContains] Return SpotNegotiations where Shipment capacity provider customer reference number partially matches
         * @param {string} [shipmentCustomerReferenceNumber] Return SpotNegotiations where Shipment customer reference number matches
         * @param {string} [shipmentCustomerReferenceNumberContains] Return SpotNegotiations where Shipment customer reference number partially matches
         * @param {string} [shipmentDelayed] Return SpotNegotiations where Shipment delayed matches
         * @param {string} [shipmentDestinationContains] Return SpotNegotiations where Shipment destination partially matches
         * @param {string} [shipmentDropoffGte] Return SpotNegotiations with a dropoff stop with a planned date greater than or equal to this value
         * @param {string} [shipmentDropoffLte] Return SpotNegotiations with a dropoff stop with a planned data less than or equal to this value
         * @param {string} [shipmentName] Return SpotNegotiations where Shipment name matches
         * @param {string} [shipmentNameContains] Return SpotNegotiations where Shipment name partially matches
         * @param {string} [shipmentOriginContains] Return SpotNegotiations where Shipment origin partially matches
         * @param {string} [shipmentPickupGte] Return SpotNegotiations with a pickup stop with a planned date greater than or equal to this value
         * @param {string} [shipmentPickupLte] Return SpotNegotiations with a pickup stop with a planned date less than or equal to this value
         * @param {string} [shipmentPickupNumber] Return SpotNegotiations where Shipment pickup number matches
         * @param {string} [shipmentPickupNumberContains] Return SpotNegotiations where Shipment pickup number partially matches
         * @param {string} [shipmentProNumber] Return SpotNegotiations where Shipment PRO number matches
         * @param {string} [shipmentProNumberContains] Return SpotNegotiations where Shipment PRO number partially matches
         * @param {string} [shipmentPurchaseOrderNumber] Return SpotNegotiations where Shipment purchase order number matches
         * @param {string} [shipmentPurchaseOrderNumberContains] Return SpotNegotiations where Shipment purchase order number partially matches
         * @param {string} [shipmentReferenceId] Return SpotNegotiations where Shipment reference_id matches
         * @param {string} [shipmentReferenceIdContains] Return SpotNegotiations where Shipment reference_id partially matches
         * @param {string} [shipmentState] Return SpotNegotiations where Shipment state matches
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [shipmentStatus] Return SpotNegotiations with shipments that have provided statuses
         * @param {string} [vendorId] ID of the vendor company to which to restrict SpotNegotiations
         * @param {string} [vendorNameContains] Partial name of the vendor company to which to restrict SpotNegotiations
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        shipmentsTenderGet: function (page, pageSize, ordering, q, closedByCustomer, closedByVendor, customerId, customerNameContains, involvedOnly, involvedVendorUsers, isMostRecentWinner, isOpen, shipment, shipmentBolNumber, shipmentBolNumberContains, shipmentCapacityProviderCustomerReferenceNumber, shipmentCapacityProviderCustomerReferenceNumberContains, shipmentCustomerReferenceNumber, shipmentCustomerReferenceNumberContains, shipmentDelayed, shipmentDestinationContains, shipmentDropoffGte, shipmentDropoffLte, shipmentName, shipmentNameContains, shipmentOriginContains, shipmentPickupGte, shipmentPickupLte, shipmentPickupNumber, shipmentPickupNumberContains, shipmentProNumber, shipmentProNumberContains, shipmentPurchaseOrderNumber, shipmentPurchaseOrderNumberContains, shipmentReferenceId, shipmentReferenceIdContains, shipmentState, shipmentStatus, vendorId, vendorNameContains, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsTenderGet(page, pageSize, ordering, q, closedByCustomer, closedByVendor, customerId, customerNameContains, involvedOnly, involvedVendorUsers, isMostRecentWinner, isOpen, shipment, shipmentBolNumber, shipmentBolNumberContains, shipmentCapacityProviderCustomerReferenceNumber, shipmentCapacityProviderCustomerReferenceNumberContains, shipmentCustomerReferenceNumber, shipmentCustomerReferenceNumberContains, shipmentDelayed, shipmentDestinationContains, shipmentDropoffGte, shipmentDropoffLte, shipmentName, shipmentNameContains, shipmentOriginContains, shipmentPickupGte, shipmentPickupLte, shipmentPickupNumber, shipmentPickupNumberContains, shipmentProNumber, shipmentProNumberContains, shipmentPurchaseOrderNumber, shipmentPurchaseOrderNumberContains, shipmentReferenceId, shipmentReferenceIdContains, shipmentState, shipmentStatus, vendorId, vendorNameContains, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create and tender a shipment to a Shipwell company
         * @param {TenderRequest} tenderRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        shipmentsTenderPost: function (tenderRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsTenderPost(tenderRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Accept or reject tendered shipments.
         * @param {string} tenderId
         * @param {TenderAcceptReject} tenderAcceptReject
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        shipmentsTenderTenderIdActionsPost: function (tenderId, tenderAcceptReject, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsTenderTenderIdActionsPost(tenderId, tenderAcceptReject, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Mark a tendered shipment as no longer available. Renders as \'closed\' in our system.
         * @param {string} tenderId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        shipmentsTenderTenderIdDelete: function (tenderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsTenderTenderIdDelete(tenderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update tendered shipment events
         * @param {string} tenderId
         * @param {TenderEventRequest} tenderEventRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        shipmentsTenderTenderIdEventsPost: function (tenderId, tenderEventRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsTenderTenderIdEventsPost(tenderId, tenderEventRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a tendered shipment to a shipwell company NOTE: Only valid for shipments created by posting to this endpoint. Shipments created via other methods are not guaranteed to work and may have unintended side effects.
         * @param {string} tenderId
         * @param {TenderRequest} tenderRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        shipmentsTenderTenderIdPut: function (tenderId, tenderRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsTenderTenderIdPut(tenderId, tenderRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List tendered shipments
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [createdByCompanyId] Restrict Tenders by created by customer ID
         * @param {string} [shipmentCustomerReferenceNumber] Restrict Tenders by custoemr shipment reference number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTendersGet: function (page, pageSize, ordering, q, createdByCompanyId, shipmentCustomerReferenceNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsTendersGet(page, pageSize, ordering, q, createdByCompanyId, shipmentCustomerReferenceNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create and tender a shipment to a Shipwell company
         * @param {TenderRequest} tenderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTendersPost: function (tenderRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsTendersPost(tenderRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Accept or reject tendered shipments.
         * @param {string} tenderId
         * @param {TenderAcceptReject} tenderAcceptReject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTendersTenderIdActionsPost: function (tenderId, tenderAcceptReject, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsTendersTenderIdActionsPost(tenderId, tenderAcceptReject, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Mark a tendered shipment as no longer available. Renders as \'closed\' in the Shipwell platform.
         * @param {string} tenderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTendersTenderIdDelete: function (tenderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsTendersTenderIdDelete(tenderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update tendered Shipment events.
         * @param {string} tenderId
         * @param {TenderEventRequest} tenderEventRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTendersTenderIdEventsPost: function (tenderId, tenderEventRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsTendersTenderIdEventsPost(tenderId, tenderEventRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a tendered shipment to a shipwell company NOTE: Only valid for shipments created by posting to this endpoint. Shipments created via other methods are not guaranteed to work and may have unintended side effects.
         * @param {string} tenderId
         * @param {TenderRequest} tenderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTendersTenderIdPut: function (tenderId, tenderRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsTendersTenderIdPut(tenderId, tenderRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ShipmentsApiFp = ShipmentsApiFp;
/**
 * ShipmentsApi - factory interface
 * @export
 */
var ShipmentsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ShipmentsApiFp)(configuration);
    return {
        /**
         * Generate a BOL number for a shipment (Internal Shipwell Microservice use only)
         * @summary Generate BOL Number
         * @param {string} shipmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateBolNumber: function (shipmentId, options) {
            return localVarFp.generateBolNumber(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns auction stats for shipments by their shipment id
         * @param {Array<string>} [shipmentId] Shipment ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsAuctionStatsGet: function (shipmentId, options) {
            return localVarFp.shipmentsAuctionStatsGet(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List all ShipmentTags for the authenticated company for v3 shipment
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsBundlesShipmentIdTagsGet: function (shipmentId, page, pageSize, options) {
            return localVarFp.shipmentsBundlesShipmentIdTagsGet(shipmentId, page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a ShipmentTag for v3 shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentTagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsBundlesShipmentIdTagsShipmentTagIdDelete: function (shipmentId, shipmentTagId, options) {
            return localVarFp.shipmentsBundlesShipmentIdTagsShipmentTagIdDelete(shipmentId, shipmentTagId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a ShipmentTag by its id for v3 shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentTagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsBundlesShipmentIdTagsShipmentTagIdGet: function (shipmentId, shipmentTagId, options) {
            return localVarFp.shipmentsBundlesShipmentIdTagsShipmentTagIdGet(shipmentId, shipmentTagId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Add a ShipmentTag to v3 shipment bundle
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentTagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsBundlesShipmentIdTagsShipmentTagIdPost: function (shipmentId, shipmentTagId, options) {
            return localVarFp.shipmentsBundlesShipmentIdTagsShipmentTagIdPost(shipmentId, shipmentTagId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Return a limited amount of shipment details using API Key authentication and query params to search. Returns an empty list if no query params are passed
         * @param {Array<string>} [bolNumber] Include shipments with these BOL Numbers
         * @param {Array<string>} [pickupNumber] Include shipments with these Pickup Numbers
         * @param {Array<string>} [proNumber] Include shipments with these PRO Numbers
         * @param {Array<string>} [purchaseOrderNumber] Include shipments with these PO Numbers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsExternalGet: function (bolNumber, pickupNumber, proNumber, purchaseOrderNumber, options) {
            return localVarFp.shipmentsExternalGet(bolNumber, pickupNumber, proNumber, purchaseOrderNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a limited amount of shipment details using a query param key instead of authentication
         * @param {string} shipmentId The id of the shipment
         * @param {string} key Secret view key authorizing user to see the Shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsExternalShipmentIdGet: function (shipmentId, key, options) {
            return localVarFp.shipmentsExternalShipmentIdGet(shipmentId, key, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get locations for the shipment using a query param key instead of authentication
         * @param {string} shipmentId The id of the shipment
         * @param {string} key Secret view key authorizing user to see the Shipment
         * @param {string} [beginDatetime] For requesting data starting at a given date
         * @param {string} [endDatetime] For requesting data ending at a given date
         * @param {string} [filterDistance] Applies a distance filter and only returns points greater than filter_distance km apart. To return all, set this to -1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsExternalShipmentIdTrackingGet: function (shipmentId, key, beginDatetime, endDatetime, filterDistance, options) {
            return localVarFp.shipmentsExternalShipmentIdTrackingGet(shipmentId, key, beginDatetime, endDatetime, filterDistance, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a list of shipments
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [activeVendorAssignment] Include or exclude shipments with active CarrierAssignments
         * @param {'MOBILE_DEVICE_ALERT' | 'NON_ACTIVE_CARRIER'} [alertTypes] Filter on shipments that have alerts of this type
         * @param {boolean} [alerts] Filter on whether or not a Shipment has alert messages
         * @param {boolean} [archived] Filter on whether or not a shipment is archived
         * @param {Array<string>} [bolNumber] Include shipments with these BOL Numbers
         * @param {string} [bolNumberContains] Return shipments where the BOL number contains this value
         * @param {Array<string>} [bolNumberExclude] Exclude shipments with these BOL Numbers
         * @param {string} [createdAt] For requesting data created at a certain datetime
         * @param {Array<'SHIPWELL_WEB' | 'IMPORT' | 'TENDER' | 'SHIPWELL_WEB_UNAUTH' | 'OTHER'>} [createdBySource] Return shipments created by sources in the array.
         * @param {string} [createdByUserContains] Return shipments where created_by_user object contains this string e.g first_name, last_name or email
         * @param {Array<string>} [createdByUserId] Return shipments where created_by_user_id in the array.
         * @param {string} [createdByUserName] Return shipments where created_by_user_name is exactly this string
         * @param {string} [createdByUserNameContains] Return shipments where created_by_user_name contains this string
         * @param {string} [customer] Return shipments with this exact value as the customer company name
         * @param {string} [customerContains] Return shipments where the customer company name contains this value
         * @param {string} [customerId] Return shipments with this exact id for the customer company
         * @param {Array<string>} [customerReferenceNumber] Include shipments with these Customer Reference Numbers
         * @param {string} [customerReferenceNumberContains] Include shipments where the Customer Reference Numbers contains this value
         * @param {Array<string>} [customerReferenceNumberExclude] Exclude shipments with these Customer Reference Numbers
         * @param {string} [destinationContains] Return shipments with this value in the destination
         * @param {string} [deliveryStopsContains] Return shipments with this value in one of its dropoff stops
         * @param {string} [deliveryStopsCompanyNameContains] Return shipments with this value in one of its delivery stops location company_name
         * @param {string} [destinationStateProvince] Return shipments with this state province on its destination stop
         * @param {string} [deliveryStopsStateProvince] Return shipments with this state province on its delivery stops
         * @param {string} [drayageBookingNumberContains] Include shipments where the drayage booking number contains this value
         * @param {string} [drayageChassisNumberContains] Include shipments where the drayage chassis number contains this value
         * @param {string} [drayageContainerNumberContains] Include shipments where the drayage container number contains this value
         * @param {string} [drayageContainerReturnDateGte] Include shipments where the drayage container return date is greater than or equal to this value
         * @param {string} [drayageContainerReturnDateLte] Include shipments where the drayage container return date is less than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateGte] Include shipments where the drayage estimated arrival date is greater than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateLte] Include shipments where the drayage estimated arrival date is less than or equal to this value
         * @param {string} [drayageLastFreeDateGte] Include shipments where the drayage last free datetime is greater than or equal to this value
         * @param {string} [drayageLastFreeDateLte] Include shipments where the drayage last free datetime is less than or equal to this value
         * @param {string} [drayageReleaseDateGte] Include shipments where the drayage release datetime is greater than or equal to this value
         * @param {string} [drayageReleaseDateLte] Include shipments where the drayage release datetime is less than or equal to this value
         * @param {string} [drayageSealNumberContains] Include shipments where the drayage seal number contains this value
         * @param {boolean} [driverAssigned] Return shipments where the driver is assigned/unassigned
         * @param {string} [dropoffGte] Return shipments with a dropoff stop with a planned date greater than or equal to this value
         * @param {string} [dropoffLte] Return shipments with a dropoff stop with a planned data less than or equal to this value
         * @param {string} [equipmentType] Return shipments with this equipment type
         * @param {string} [equipmentTypeContains] Return shipments where the equipment type contains this value
         * @param {string} [fedexAccount] Return pickups specific to this FedEx account
         * @param {string} [groupId] Group id for a shipment
         * @param {boolean} [hasInvoice] If true, show shipments which have at least one invoice otherwise show those with none.
         * @param {boolean} [hasBill] If true, show shipments which have at least one bill otherwise show those with none.
         * @param {Array<string>} [include] [v3] A list of properties to include in the response resource
         * @param {boolean} [loadBoardEnabled] Filter on whether or not a shipment is posted on the company load board
         * @param {string} [loadBoardId] Return shipments where the load board ID is equal to this value
         * @param {string} [loadBoardIdContains] Return shipments where the load board ID contains this value
         * @param {string} [mode] Return shipments with this shipment mode
         * @param {string} [modeContains] Return shipments where the shipment mode contains this value
         * @param {string} [nameContains] Return shipments where the shipment name contains this value
         * @param {boolean} [open] Filter on whether or not a shipment is open
         * @param {string} [originContains] Return shipments with this value in the origin
         * @param {string} [originStateProvince] Return shipments with this state province on its origin stop
         * @param {string} [pickupStopsStateProvince] Return shipments with this state province on its pickup stops
         * @param {string} [pickupStopsContains] Return shipments with this value in one of its pickup stops
         * @param {string} [pickupStopsCompanyNameContains] Return shipments with this value in one of its pickup stops location company_name
         * @param {Array<'CANCELLED' | 'DELAYED' | 'DELIVERED' | 'IN_TRANSIT' | 'NOT_SCHEDULED' | 'SCHEDULED'>} [parcelPickupStatus] Include shipments where the parcel pickup status equals one of these values
         * @param {string} [pickupGte] Return shipments with a pickup stop with a planned date greater than or equal to this value
         * @param {string} [updatedAtGte] Return shipments updated greater than or equal to this value
         * @param {string} [updatedAtLte] Return shipments updated less than or equal to this value
         * @param {string} [pickupLte] Return shipments with a pickup stop with a planned date less than or equal to this value
         * @param {string} [pickupId] Include shipments currently associated with the provided ShipmentPickup\&#39;s ID
         * @param {Array<string>} [pickupNumber] Include shipments with these Pickup Numbers
         * @param {string} [pickupNumberContains] Include shipments where the Pickup Number contains this value
         * @param {Array<string>} [pickupNumberExclude] Exclude shipments with these Pickup Numbers
         * @param {Array<string>} [proNumber] Include shipments with these PRO Numbers
         * @param {string} [proNumberContains] Return shipments where the PRO number contains this value
         * @param {Array<string>} [proNumberExclude] Exclude shipments with these PRO Numbers
         * @param {string} [powerUnit] Return shipments where this power unit is assigned
         * @param {Array<string>} [purchaseOrderNumber] Include shipments with these PO Numbers
         * @param {string} [purchaseOrderNumberContains] Include shipments where the PO number contains this value
         * @param {Array<string>} [purchaseOrderNumberExclude] Exclude shipments with these PO Numbers
         * @param {Array<string>} [referenceId] Include shipments with these Reference IDs
         * @param {string} [referenceIdContains] Include shipments where the reference ID contains this value
         * @param {Array<string>} [referenceIdExclude] Exclude shipments with these Reference IDs
         * @param {Array<string>} [masterAirWaybill] Include shipments with these Master Air Waybill Numbers
         * @param {string} [masterAirWaybillContains] Include shipments where the Master Air Waybill number contains this value
         * @param {Array<string>} [houseAirWaybill] Include shipments with these House Air Waybill Numbers
         * @param {string} [houseAirWaybillContains] Include shipments where the House Air Waybill number contains this value
         * @param {Array<string>} [reps] Include shipments with these reps
         * @param {'owner_operator'} [role] Get results based on a specific perspective such as owner_operator
         * @param {string} [serviceLevel] Return shipments with this service level
         * @param {Array<string>} [accessorials] Include only shipments with at least one matching ShipmentAccessorial
         * @param {string} [createdAtGte] Include shipments where created_at is greater than or equal to the time value
         * @param {string} [createdAtLte] Include shipments where created_at is less than or equal to this value
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [statusExclude] Exclude shipments with these statuses
         * @param {string} [statusContains] Include shipments where the status contains this string
         * @param {Array<string>} [tags] Include only shipments with at least one matching ShipmentTag
         * @param {Array<string>} [tagsExclude] Excludes shipments with at least one matching tag
         * @param {Array<string>} [shipmentShipwellCustomData] Include shipments that contain these shipment-level custom data values
         * @param {string} [stopsContains] Return shipments with this value in one of its stops
         * @param {string} [stopsCompanyNameContains] Return shipments with this value in one of its stops location company_name
         * @param {string} [stopsStateProvince] Return shipments with this state province on one of its stops
         * @param {string} [timelineLastUpdatedAtGte] Return shipments where last timeline update was greater than or equal to the value or was never updated
         * @param {string} [timelineLastUpdatedAtLte] Return shipments where last timeline update was less than or equal to the value or was never updated
         * @param {'current' | 'upcoming' | 'active' | 'past'} [timeFrame] Return shipments that are within the given time frame. active &#x3D; current + upcoming
         * @param {number} [totalMilesGte] Return shipments with total miles greater than or equal to this value
         * @param {number} [totalMilesLte] Return shipments with total miles less than or equal to this value
         * @param {string} [upsAccount] Return pickups specific to this UPS account
         * @param {string} [vendorId] Return shipments with this exact value as the vendor Carrier id
         * @param {string} [vendorContains] Return shipments where the vendor company name contains this value
         * @param {number} [totalWeightOverrideGte] Return shipments with weight greater than or equal to this value
         * @param {number} [totalWeightOverrideLte] Return shipments with weight less than or equal to this value
         * @param {number} [originRadius] Radius from origin stop
         * @param {number} [originLat] Latitude of location to filter on for origin stop
         * @param {number} [originLon] Longitude of location to filter on for origin stop
         * @param {number} [pickupRadius] Radius from a pickup stop
         * @param {number} [pickupLat] Latitude of location to filter on for pickup stop
         * @param {number} [pickupLon] Longitude of location to filter on for pickup stop
         * @param {number} [destinationRadius] Radius from the destination stop
         * @param {number} [destinationLat] Latitude of location to filter on for destination stop
         * @param {number} [destinationLon] Longitude of location to filter on for destination stop
         * @param {number} [deliveryRadius] Radius from a delivery stop
         * @param {number} [deliveryLat] Latitude of location to filter on for delivery stop
         * @param {number} [deliveryLon] Longitude of location to filter on for delivery stop
         * @param {Array<'RUNNING' | 'CANCELLED' | 'FAILED' | 'SUCCESS'>} [workflowExecutionStatus] Include shipments with these workflow execution statuses
         * @param {boolean} [showClonedResults] If true, show shipments that have a non null last_cloned_at value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsGet: function (xCompanyId, page, pageSize, ordering, q, activeVendorAssignment, alertTypes, alerts, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, updatedAtGte, updatedAtLte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, accessorials, createdAtGte, createdAtLte, status, statusExclude, statusContains, tags, tagsExclude, shipmentShipwellCustomData, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, workflowExecutionStatus, showClonedResults, options) {
            return localVarFp.shipmentsGet(xCompanyId, page, pageSize, ordering, q, activeVendorAssignment, alertTypes, alerts, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, updatedAtGte, updatedAtLte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, accessorials, createdAtGte, createdAtLte, status, statusExclude, statusContains, tags, tagsExclude, shipmentShipwellCustomData, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, workflowExecutionStatus, showClonedResults, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Estimate how many linear feet of a truck that ShipmentLineItems would fill if packed optimally
         * @param {LinearFeetEstimate} linearFeetEstimate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsLinearFeetPost: function (linearFeetEstimate, options) {
            return localVarFp.shipmentsLinearFeetPost(linearFeetEstimate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List of pickups for a company
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [scheduledDate] Date of a scheduled pickup
         * @param {string} [scheduledDateGte] Return pickups with a scheduled date greater than or equal to this value
         * @param {string} [scheduledDateLte] Return pickups with a scheduled date less than or equal to this value
         * @param {string} [scheduledTimeWindowStartGte] Return pickups with a scheduled start time window date and time greater than or equal to this value
         * @param {string} [scheduledTimeWindowStartLte] Return pickups with a scheduled start time window date and time less than or equal to this value
         * @param {string} [scheduledTimeWindowEndGte] Return pickups with a scheduled end time window date and time greater than or equal to this value
         * @param {string} [scheduledTimeWindowEndLte] Return pickups with a scheduled end time window date and time less than or equal to this value
         * @param {string} [pointOfContact] Include pickups with this point of contact name
         * @param {string} [pointOfContactContains] Include pickups where the point of contact includes this value
         * @param {string} [pointOfContactExcludes] Exclude pickups where the point of contact includes this value
         * @param {string} [specialInstructions] Include pickups with these special instructions
         * @param {string} [specialInstructionsContains] Include pickups where the special instructions includes this value
         * @param {string} [specialInstructionsExcludes] Exclude pickups where the special instructions includes this value
         * @param {string} [pickupNumber] Include pickups with this pickup number
         * @param {string} [pickupNumberContains] Include pickups where the pickup number contains this value
         * @param {string} [pickupNumberExcludes] Exclude pickups with this pickup number
         * @param {string} [providerCode] Include pickups with this provider code
         * @param {string} [providerCarrierCode] Include pickups with this provider carrier code
         * @param {string} [providerCarrierCodeContains] Include pickups where the provider carrier code contains this value
         * @param {string} [providerCarrierCodeExcludes] Exclude pickups with this provider carrier code
         * @param {string} [providerLocationId] Include pickups with this provider location id
         * @param {string} [providerLocationIdContains] Include pickups where the provider location id  contains this value
         * @param {string} [providerLocationIdExcludes] Exclude pickups with this provider location id
         * @param {string} [addressBookEntry] Include pickups with this address book entry id
         * @param {boolean} [isRegularlyScheduled] Include pickups with this is_regularly_scheduled value
         * @param {boolean} [cancelled] Return pickups based on if they are cancelled
         * @param {string} [shipmentIds] Return pickup with that include this shipment
         * @param {string} [company] Return pickups specific to this company
         * @param {string} [fedexAccount] Return pickups specific to this FedEx account
         * @param {string} [upsAccount] Return pickups specific to this UPS account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsPickupsGet: function (page, pageSize, ordering, q, scheduledDate, scheduledDateGte, scheduledDateLte, scheduledTimeWindowStartGte, scheduledTimeWindowStartLte, scheduledTimeWindowEndGte, scheduledTimeWindowEndLte, pointOfContact, pointOfContactContains, pointOfContactExcludes, specialInstructions, specialInstructionsContains, specialInstructionsExcludes, pickupNumber, pickupNumberContains, pickupNumberExcludes, providerCode, providerCarrierCode, providerCarrierCodeContains, providerCarrierCodeExcludes, providerLocationId, providerLocationIdContains, providerLocationIdExcludes, addressBookEntry, isRegularlyScheduled, cancelled, shipmentIds, company, fedexAccount, upsAccount, options) {
            return localVarFp.shipmentsPickupsGet(page, pageSize, ordering, q, scheduledDate, scheduledDateGte, scheduledDateLte, scheduledTimeWindowStartGte, scheduledTimeWindowStartLte, scheduledTimeWindowEndGte, scheduledTimeWindowEndLte, pointOfContact, pointOfContactContains, pointOfContactExcludes, specialInstructions, specialInstructionsContains, specialInstructionsExcludes, pickupNumber, pickupNumberContains, pickupNumberExcludes, providerCode, providerCarrierCode, providerCarrierCodeContains, providerCarrierCodeExcludes, providerLocationId, providerLocationIdContains, providerLocationIdExcludes, addressBookEntry, isRegularlyScheduled, cancelled, shipmentIds, company, fedexAccount, upsAccount, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Schedule a pickup
         * @param {ScheduleShipmentPickupRequest} scheduleShipmentPickupRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsPickupsPost: function (scheduleShipmentPickupRequest, options) {
            return localVarFp.shipmentsPickupsPost(scheduleShipmentPickupRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve data for a shipment pickup
         * @param {string} shipmentPickupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsPickupsShipmentPickupIdGet: function (shipmentPickupId, options) {
            return localVarFp.shipmentsPickupsShipmentPickupIdGet(shipmentPickupId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a shipment pickup
         * @param {string} shipmentPickupId
         * @param {ShipmentPickup} shipmentPickup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsPickupsShipmentPickupIdPut: function (shipmentPickupId, shipmentPickup, options) {
            return localVarFp.shipmentsPickupsShipmentPickupIdPut(shipmentPickupId, shipmentPickup, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Shipments start in a \"draft\" state by default. Only the `metadata` parameter set to `\"open\": false, \"archived\": false,` and `tags:` set to `[]` are required to begin a draft shipment.
         * @summary Create a new Shipment
         * @param {Shipment} shipment
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsPost: function (shipment, xCompanyId, options) {
            return localVarFp.shipmentsPost(shipment, xCompanyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Transform shipments into round trips
         * @param {InlineObject22} [inlineObject22]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsRoundTripJobPost: function (inlineObject22, options) {
            return localVarFp.shipmentsRoundTripJobPost(inlineObject22, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Return results from round trip job
         * @param {string} roundTripJobId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsRoundTripJobRoundTripJobIdGet: function (roundTripJobId, options) {
            return localVarFp.shipmentsRoundTripJobRoundTripJobIdGet(roundTripJobId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the shipment OpenAPI schema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsSchemaGet: function (options) {
            return localVarFp.shipmentsSchemaGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update an existing shipment to add one or more purchase orders
         * @param {string} shipmentId The id of the shipment
         * @param {InlineObject23} [inlineObject23]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAddOrdersPut: function (shipmentId, inlineObject23, options) {
            return localVarFp.shipmentsShipmentIdAddOrdersPut(shipmentId, inlineObject23, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a shipwell automation event
         * @param {string} shipmentId The id of the shipment
         * @param {string} automationEventId The id of the shipment automation event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAutomationEventsAutomationEventIdDelete: function (shipmentId, automationEventId, options) {
            return localVarFp.shipmentsShipmentIdAutomationEventsAutomationEventIdDelete(shipmentId, automationEventId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a shipwell automation event
         * @param {string} shipmentId The id of the shipment
         * @param {string} automationEventId The id of the shipment automation event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAutomationEventsAutomationEventIdGet: function (shipmentId, automationEventId, options) {
            return localVarFp.shipmentsShipmentIdAutomationEventsAutomationEventIdGet(shipmentId, automationEventId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a shipwell automation event
         * @param {string} shipmentId The id of the shipment
         * @param {string} automationEventId The id of the shipment automation event
         * @param {AutomationEvent} automationEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAutomationEventsAutomationEventIdPut: function (shipmentId, automationEventId, automationEvent, options) {
            return localVarFp.shipmentsShipmentIdAutomationEventsAutomationEventIdPut(shipmentId, automationEventId, automationEvent, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Cancel and delete all future scheduled automation events on a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAutomationEventsCancelScheduledDelete: function (shipmentId, options) {
            return localVarFp.shipmentsShipmentIdAutomationEventsCancelScheduledDelete(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve automated shipwell events
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAutomationEventsGet: function (shipmentId, page, pageSize, ordering, options) {
            return localVarFp.shipmentsShipmentIdAutomationEventsGet(shipmentId, page, pageSize, ordering, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Schedule an automated shipwell event
         * @param {string} shipmentId The id of the shipment
         * @param {AutomationEvent} automationEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdAutomationEventsPost: function (shipmentId, automationEvent, options) {
            return localVarFp.shipmentsShipmentIdAutomationEventsPost(shipmentId, automationEvent, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create multiple documents onto a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {ShipmentBulkDocument} [shipmentBulkDocument]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdBulkDocumentsPost: function (shipmentId, shipmentBulkDocument, options) {
            return localVarFp.shipmentsShipmentIdBulkDocumentsPost(shipmentId, shipmentBulkDocument, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a CarrierAssignment by its id
         * @param {string} shipmentId The id of the shipment
         * @param {string} carrierAssignmentId The id of a CarrierAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCarrierAssignmentsCarrierAssignmentIdGet: function (shipmentId, carrierAssignmentId, options) {
            return localVarFp.shipmentsShipmentIdCarrierAssignmentsCarrierAssignmentIdGet(shipmentId, carrierAssignmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update the charge line items of a CarrierAssignment
         * @param {string} shipmentId The id of the shipment
         * @param {string} carrierAssignmentId The id of a CarrierAssignment
         * @param {CarrierAssignment} carrierAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCarrierAssignmentsCarrierAssignmentIdPut: function (shipmentId, carrierAssignmentId, carrierAssignment, options) {
            return localVarFp.shipmentsShipmentIdCarrierAssignmentsCarrierAssignmentIdPut(shipmentId, carrierAssignmentId, carrierAssignment, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete the carrier assignment associated with the shipment
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCarrierAssignmentsDelete: function (shipmentId, options) {
            return localVarFp.shipmentsShipmentIdCarrierAssignmentsDelete(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get the current assigned carrier associated with this shipment
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCarrierAssignmentsGet: function (shipmentId, options) {
            return localVarFp.shipmentsShipmentIdCarrierAssignmentsGet(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Only one carrier assignment is associated with a company-shipment combo at a time.  Posting here will overwrite the companies carrier assignment. Carrier assignments are only shown to the user who sets it
         * @summary Create a new carrier assignment
         * @param {string} shipmentId The id of the shipment
         * @param {CarrierAssignment} carrierAssignment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCarrierAssignmentsPost: function (shipmentId, carrierAssignment, options) {
            return localVarFp.shipmentsShipmentIdCarrierAssignmentsPost(shipmentId, carrierAssignment, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get the carrier and equipment data
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCarrierConfigGet: function (shipmentId, options) {
            return localVarFp.shipmentsShipmentIdCarrierConfigGet(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Internal route used to provide and update information around the carrier and equipment section
         * @summary Update the carrier config data
         * @param {string} shipmentId The id of the shipment
         * @param {CarrierConfig} carrierConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCarrierConfigPost: function (shipmentId, carrierConfig, options) {
            return localVarFp.shipmentsShipmentIdCarrierConfigPost(shipmentId, carrierConfig, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Initialize a shipment for appless cell phone tracking
         * @param {string} shipmentId The id of the shipment
         * @param {CellTrackingInitRequest} cellTrackingInitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCellTrackingPost: function (shipmentId, cellTrackingInitRequest, options) {
            return localVarFp.shipmentsShipmentIdCellTrackingPost(shipmentId, cellTrackingInitRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get the Shipment Container Details data
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdContainerDetailsGet: function (shipmentId, options) {
            return localVarFp.shipmentsShipmentIdContainerDetailsGet(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDelete: function (shipmentId, xCompanyId, options) {
            return localVarFp.shipmentsShipmentIdDelete(shipmentId, xCompanyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get the particular dispatch job data associated with this shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} dispatchJobId The id of the dispatch job
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDispatchJobDispatchJobIdGet: function (shipmentId, dispatchJobId, options) {
            return localVarFp.shipmentsShipmentIdDispatchJobDispatchJobIdGet(shipmentId, dispatchJobId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get auditlog of documents sent
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsAuditlogGet: function (shipmentId, options) {
            return localVarFp.shipmentsShipmentIdDocumentsAuditlogGet(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a Document
         * @param {string} shipmentId The id of the shipment
         * @param {string} documentId The id of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsDocumentIdDelete: function (shipmentId, documentId, options) {
            return localVarFp.shipmentsShipmentIdDocumentsDocumentIdDelete(shipmentId, documentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get metadata about a document
         * @param {string} shipmentId The id of the shipment
         * @param {string} documentId The id of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsDocumentIdGet: function (shipmentId, documentId, options) {
            return localVarFp.shipmentsShipmentIdDocumentsDocumentIdGet(shipmentId, documentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update metadata about a document
         * @param {string} shipmentId The id of the shipment
         * @param {string} documentId The id of the document
         * @param {ShipmentDocumentMetadata} shipmentDocumentMetadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsDocumentIdPut: function (shipmentId, documentId, shipmentDocumentMetadata, options) {
            return localVarFp.shipmentsShipmentIdDocumentsDocumentIdPut(shipmentId, documentId, shipmentDocumentMetadata, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new signature request for an specific document.
         * @param {string} shipmentId The id of the shipment
         * @param {string} documentId The id of the document
         * @param {ShipmentDocumentRequestSignature} [shipmentDocumentRequestSignature]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsDocumentIdRequestSignaturePost: function (shipmentId, documentId, shipmentDocumentRequestSignature, options) {
            return localVarFp.shipmentsShipmentIdDocumentsDocumentIdRequestSignaturePost(shipmentId, documentId, shipmentDocumentRequestSignature, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Attach the signature file to the existing request object.
         * @param {string} shipmentId The id of the shipment
         * @param {string} documentId The id of the document
         * @param {string} [description] An optional description of the signature
         * @param {any} [file] The signature file
         * @param {string} [signatoryName] The name of the signatory
         * @param {string} [signatoryRole] The role of the signatory
         * @param {string} [stopId] The Stop reference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsDocumentIdSignPost: function (shipmentId, documentId, description, file, signatoryName, signatoryRole, stopId, options) {
            return localVarFp.shipmentsShipmentIdDocumentsDocumentIdSignPost(shipmentId, documentId, description, file, signatoryName, signatoryRole, stopId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get signatures for a document
         * @param {string} shipmentId The id of the shipment
         * @param {string} documentId The id of the document
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsDocumentIdSignaturesGet: function (shipmentId, documentId, page, pageSize, options) {
            return localVarFp.shipmentsShipmentIdDocumentsDocumentIdSignaturesGet(shipmentId, documentId, page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Generate a BOL for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsGenerateBolGet: function (shipmentId, options) {
            return localVarFp.shipmentsShipmentIdDocumentsGenerateBolGet(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Generate a rate confirmation for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsGenerateRateConfirmationGet: function (shipmentId, options) {
            return localVarFp.shipmentsShipmentIdDocumentsGenerateRateConfirmationGet(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Generate shipping labels for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsGenerateShippingLabelGet: function (shipmentId, options) {
            return localVarFp.shipmentsShipmentIdDocumentsGenerateShippingLabelGet(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get metadata about a documents on a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsGet: function (shipmentId, page, pageSize, options) {
            return localVarFp.shipmentsShipmentIdDocumentsGet(shipmentId, page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a document on a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} description
         * @param {any} file
         * @param {boolean} isCarrierDocument
         * @param {string} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsPost: function (shipmentId, description, file, isCarrierDocument, type, options) {
            return localVarFp.shipmentsShipmentIdDocumentsPost(shipmentId, description, file, isCarrierDocument, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Send shipment documents to a list of email recipients
         * @param {string} shipmentId The id of the shipment
         * @param {SendDocument} sendDocument
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdDocumentsSendPost: function (shipmentId, sendDocument, options) {
            return localVarFp.shipmentsShipmentIdDocumentsSendPost(shipmentId, sendDocument, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get the current equipment config associated with this shipment
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdEquipmentConfigGet: function (shipmentId, options) {
            return localVarFp.shipmentsShipmentIdEquipmentConfigGet(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Only one equipment config is associated with a shipment at a time.  Posting here will overwrite the previous equipment config and attempt to track with the new configuration.
         * @summary Create a new equipment config
         * @param {string} shipmentId The id of the shipment
         * @param {CreateEquipmentConfig} createEquipmentConfig
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdEquipmentConfigPost: function (shipmentId, createEquipmentConfig, options) {
            return localVarFp.shipmentsShipmentIdEquipmentConfigPost(shipmentId, createEquipmentConfig, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdGet: function (shipmentId, xCompanyId, options) {
            return localVarFp.shipmentsShipmentIdGet(shipmentId, xCompanyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a list of ShipmentTimelineEvents grouped by Stop for a given Shipment
         * @param {string} shipmentId The id of the shipment
         * @param {'location' | 'status'} [groupType] The type of timeline events to return, defaults to all
         * @param {boolean} [filterFutureStops] Whether to remove future stops from the list of grouped timeline events
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdGroupedTimelineEventsGet: function (shipmentId, groupType, filterFutureStops, options) {
            return localVarFp.shipmentsShipmentIdGroupedTimelineEventsGet(shipmentId, groupType, filterFutureStops, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List messages for a Shipment
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [q] search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdMessagesGet: function (shipmentId, page, pageSize, q, options) {
            return localVarFp.shipmentsShipmentIdMessagesGet(shipmentId, page, pageSize, q, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new message for a Shipment
         * @param {string} shipmentId The id of the shipment
         * @param {ShipmentMessage} shipmentMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdMessagesPost: function (shipmentId, shipmentMessage, options) {
            return localVarFp.shipmentsShipmentIdMessagesPost(shipmentId, shipmentMessage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a ShipmentMessage
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentMessageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdMessagesShipmentMessageIdDelete: function (shipmentId, shipmentMessageId, options) {
            return localVarFp.shipmentsShipmentIdMessagesShipmentMessageIdDelete(shipmentId, shipmentMessageId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve data for a ShipmentMessage
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentMessageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdMessagesShipmentMessageIdGet: function (shipmentId, shipmentMessageId, options) {
            return localVarFp.shipmentsShipmentIdMessagesShipmentMessageIdGet(shipmentId, shipmentMessageId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Mark a ShipmentMessage as read
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentMessageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdMessagesShipmentMessageIdMarkAsReadPost: function (shipmentId, shipmentMessageId, options) {
            return localVarFp.shipmentsShipmentIdMessagesShipmentMessageIdMarkAsReadPost(shipmentId, shipmentMessageId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Mark a ShipmentMessage as unread
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentMessageId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdMessagesShipmentMessageIdMarkAsUnreadPost: function (shipmentId, shipmentMessageId, options) {
            return localVarFp.shipmentsShipmentIdMessagesShipmentMessageIdMarkAsUnreadPost(shipmentId, shipmentMessageId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a ShipmentMessage
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentMessageId
         * @param {ShipmentMessage} shipmentMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdMessagesShipmentMessageIdPut: function (shipmentId, shipmentMessageId, shipmentMessage, options) {
            return localVarFp.shipmentsShipmentIdMessagesShipmentMessageIdPut(shipmentId, shipmentMessageId, shipmentMessage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List notes for a Shipment or Shipment Quote
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdNotesGet: function (shipmentId, page, pageSize, options) {
            return localVarFp.shipmentsShipmentIdNotesGet(shipmentId, page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new note for a Shipment or Shipment Quote
         * @param {string} shipmentId The id of the shipment
         * @param {ShipmentNote} shipmentNote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdNotesPost: function (shipmentId, shipmentNote, options) {
            return localVarFp.shipmentsShipmentIdNotesPost(shipmentId, shipmentNote, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a ShipmentNote
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdNotesShipmentNoteIdDelete: function (shipmentId, shipmentNoteId, options) {
            return localVarFp.shipmentsShipmentIdNotesShipmentNoteIdDelete(shipmentId, shipmentNoteId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve data for a ShipmentNote
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentNoteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdNotesShipmentNoteIdGet: function (shipmentId, shipmentNoteId, options) {
            return localVarFp.shipmentsShipmentIdNotesShipmentNoteIdGet(shipmentId, shipmentNoteId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a ShipmentNote
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentNoteId
         * @param {ShipmentNote} shipmentNote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdNotesShipmentNoteIdPut: function (shipmentId, shipmentNoteId, shipmentNote, options) {
            return localVarFp.shipmentsShipmentIdNotesShipmentNoteIdPut(shipmentId, shipmentNoteId, shipmentNote, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * After a successful update, the \'stops\' and \'line_items\' of the Shipment will be exactly the same as those provided in the request. This means that if existing \'stops\' or \'ShipmentLineItems\' were left out of their arrays, those objects would be deleted. Providing existing objects in those arrays with their ids will update those objects instead of creating or deleting them. Providing objects in the arrays that do not have ids will create new objects. If you omit the \'stops\' or \'line_items\' arrays from the request body, no changes will be made to those related object sets.
         * @summary Update a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {Shipment} shipment
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdPut: function (shipmentId, shipment, xCompanyId, options) {
            return localVarFp.shipmentsShipmentIdPut(shipmentId, shipment, xCompanyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Remove a purchase order from an existing shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} orderId The id of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdRemoveOrdersOrderIdPut: function (shipmentId, orderId, options) {
            return localVarFp.shipmentsShipmentIdRemoveOrdersOrderIdPut(shipmentId, orderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get the list of the shipment reps
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdRepsGet: function (shipmentId, options) {
            return localVarFp.shipmentsShipmentIdRepsGet(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Add a rep to a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {CreateShipmentRepRequest} createShipmentRepRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdRepsPost: function (shipmentId, createShipmentRepRequest, options) {
            return localVarFp.shipmentsShipmentIdRepsPost(shipmentId, createShipmentRepRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a rep record
         * @param {string} shipmentId The id of the shipment
         * @param {string} repId The id of the rep
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdRepsRepIdDelete: function (shipmentId, repId, options) {
            return localVarFp.shipmentsShipmentIdRepsRepIdDelete(shipmentId, repId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a specific shipment rep
         * @param {string} shipmentId The id of the shipment
         * @param {string} repId The id of the rep
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdRepsRepIdGet: function (shipmentId, repId, options) {
            return localVarFp.shipmentsShipmentIdRepsRepIdGet(shipmentId, repId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a Rep record
         * @param {string} shipmentId The id of the shipment
         * @param {string} repId The id of the rep
         * @param {UpdateShipmentRepRequest} updateShipmentRepRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdRepsRepIdPut: function (shipmentId, repId, updateShipmentRepRequest, options) {
            return localVarFp.shipmentsShipmentIdRepsRepIdPut(shipmentId, repId, updateShipmentRepRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Send an SMS message requesting that someone download Shipwell app
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdRequestAppDownloadPost: function (shipmentId, options) {
            return localVarFp.shipmentsShipmentIdRequestAppDownloadPost(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Send an SMS to locate request to a Driver
         * @param {string} shipmentId The id of the shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdSmsTrackingPost: function (shipmentId, options) {
            return localVarFp.shipmentsShipmentIdSmsTrackingPost(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a list of Stops for a given Shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsGet: function (shipmentId, xCompanyId, page, pageSize, ordering, options) {
            return localVarFp.shipmentsShipmentIdStopsGet(shipmentId, xCompanyId, page, pageSize, ordering, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * The new Stop must not have the same \'ordinal_index\' as any other Stop associated with that Shipment.
         * @summary Create a new Stop
         * @param {string} shipmentId The id of the shipment
         * @param {Stop} stop
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsPost: function (shipmentId, stop, xCompanyId, options) {
            return localVarFp.shipmentsShipmentIdStopsPost(shipmentId, stop, xCompanyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a list of StopAlerts for a given Stop
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdAlertsGet: function (shipmentId, stopId, page, pageSize, ordering, options) {
            return localVarFp.shipmentsShipmentIdStopsStopIdAlertsGet(shipmentId, stopId, page, pageSize, ordering, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new StopAlert
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {StopAlert} stopAlert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdAlertsPost: function (shipmentId, stopId, stopAlert, options) {
            return localVarFp.shipmentsShipmentIdStopsStopIdAlertsPost(shipmentId, stopId, stopAlert, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a StopAlert
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {string} stopAlertId The id of the stop alert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdAlertsStopAlertIdDelete: function (shipmentId, stopId, stopAlertId, options) {
            return localVarFp.shipmentsShipmentIdStopsStopIdAlertsStopAlertIdDelete(shipmentId, stopId, stopAlertId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a StopAlert
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {string} stopAlertId The id of the stop alert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdAlertsStopAlertIdGet: function (shipmentId, stopId, stopAlertId, options) {
            return localVarFp.shipmentsShipmentIdStopsStopIdAlertsStopAlertIdGet(shipmentId, stopId, stopAlertId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a StopAlert
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {string} stopAlertId The id of the stop alert
         * @param {StopAlert} stopAlert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdAlertsStopAlertIdPut: function (shipmentId, stopId, stopAlertId, stopAlert, options) {
            return localVarFp.shipmentsShipmentIdStopsStopIdAlertsStopAlertIdPut(shipmentId, stopId, stopAlertId, stopAlert, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a Stop
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdDelete: function (shipmentId, stopId, xCompanyId, options) {
            return localVarFp.shipmentsShipmentIdStopsStopIdDelete(shipmentId, stopId, xCompanyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new stop-related shipment timeline event
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {StopEvent} stopEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdEventsPost: function (shipmentId, stopId, stopEvent, options) {
            return localVarFp.shipmentsShipmentIdStopsStopIdEventsPost(shipmentId, stopId, stopEvent, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about a Stop
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdGet: function (shipmentId, stopId, xCompanyId, options) {
            return localVarFp.shipmentsShipmentIdStopsStopIdGet(shipmentId, stopId, xCompanyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a Stop
         * @param {string} shipmentId The id of the shipment
         * @param {string} stopId The id of the stop
         * @param {Stop} stop
         * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdStopsStopIdPut: function (shipmentId, stopId, stop, xCompanyId, options) {
            return localVarFp.shipmentsShipmentIdStopsStopIdPut(shipmentId, stopId, stop, xCompanyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a list of ShipmentTimelineEvents for a given Shipment
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdTimelineEventsGet: function (shipmentId, page, pageSize, options) {
            return localVarFp.shipmentsShipmentIdTimelineEventsGet(shipmentId, page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new ShipmentTimelineEvent
         * @param {string} shipmentId The id of the shipment
         * @param {CreateShipmentTimelineEvent} createShipmentTimelineEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdTimelineEventsPost: function (shipmentId, createShipmentTimelineEvent, options) {
            return localVarFp.shipmentsShipmentIdTimelineEventsPost(shipmentId, createShipmentTimelineEvent, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a ShipmentTimelineEvent
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentTimelineEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdDelete: function (shipmentId, shipmentTimelineEventId, options) {
            return localVarFp.shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdDelete(shipmentId, shipmentTimelineEventId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about a ShipmentTimelineEvent
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentTimelineEventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdGet: function (shipmentId, shipmentTimelineEventId, options) {
            return localVarFp.shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdGet(shipmentId, shipmentTimelineEventId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a ShipmentTimelineEvent
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentTimelineEventId
         * @param {CreateShipmentTimelineEvent} createShipmentTimelineEvent
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdPut: function (shipmentId, shipmentTimelineEventId, createShipmentTimelineEvent, options) {
            return localVarFp.shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdPut(shipmentId, shipmentTimelineEventId, createShipmentTimelineEvent, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get locations for the shipment
         * @param {string} shipmentId The id of the shipment
         * @param {string} [beginDatetime] For requesting data starting at a given date
         * @param {string} [endDatetime] For requesting data ending at a given date
         * @param {string} [filterDistance] Applies a distance filter and only returns points greater than filter_distance km apart. To return all, set this to -1
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdTrackingGet: function (shipmentId, beginDatetime, endDatetime, filterDistance, options) {
            return localVarFp.shipmentsShipmentIdTrackingGet(shipmentId, beginDatetime, endDatetime, filterDistance, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Manually update Shipment Location. Authenticated drivers can also use this route to update their location
         * @param {string} shipmentId The id of the shipment
         * @param {ELDLocationUpdateRequest} eLDLocationUpdateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdTrackingPost: function (shipmentId, eLDLocationUpdateRequest, options) {
            return localVarFp.shipmentsShipmentIdTrackingPost(shipmentId, eLDLocationUpdateRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List of all stop event types supported by the API along with their categorial groupings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsStopEventTypesGet: function (options) {
            return localVarFp.shipmentsStopEventTypesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a list of all stop locations for shipments user is associated with
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [companyName] Return stop locations whose company_name is equivalent to this value
         * @param {string} [companyNameContains] Return stop locations with this value in the company_name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsStopLocationsGet: function (page, pageSize, companyName, companyNameContains, options) {
            return localVarFp.shipmentsStopLocationsGet(page, pageSize, companyName, companyNameContains, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List all ShipmentTags for the authenticated company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTagsGet: function (options) {
            return localVarFp.shipmentsTagsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a ShipmentTag for the authenticated company
         * @param {ShipmentTag} shipmentTag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTagsPost: function (shipmentTag, options) {
            return localVarFp.shipmentsTagsPost(shipmentTag, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a ShipmentTag
         * @param {string} shipmentTagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTagsShipmentTagIdDelete: function (shipmentTagId, options) {
            return localVarFp.shipmentsTagsShipmentTagIdDelete(shipmentTagId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a ShipmentTag by its id
         * @param {string} shipmentTagId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTagsShipmentTagIdGet: function (shipmentTagId, options) {
            return localVarFp.shipmentsTagsShipmentTagIdGet(shipmentTagId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a ShipmentTag
         * @param {string} shipmentTagId
         * @param {ShipmentTag} shipmentTag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTagsShipmentTagIdPut: function (shipmentTagId, shipmentTag, options) {
            return localVarFp.shipmentsTagsShipmentTagIdPut(shipmentTagId, shipmentTag, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List all Shipment Templates for the authenticated company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTemplatesGet: function (options) {
            return localVarFp.shipmentsTemplatesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a ShipmentTemplate for the authenticated company
         * @param {ShipmentTemplateRequest} shipmentTemplateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTemplatesPost: function (shipmentTemplateRequest, options) {
            return localVarFp.shipmentsTemplatesPost(shipmentTemplateRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a Shipment Template
         * @param {string} shipmentTemplateId The ID of the shipment template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTemplatesShipmentTemplateIdDelete: function (shipmentTemplateId, options) {
            return localVarFp.shipmentsTemplatesShipmentTemplateIdDelete(shipmentTemplateId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a Shipment Template by its id
         * @param {string} shipmentTemplateId The ID of the shipment template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTemplatesShipmentTemplateIdGet: function (shipmentTemplateId, options) {
            return localVarFp.shipmentsTemplatesShipmentTemplateIdGet(shipmentTemplateId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a Shipment Template
         * @param {string} shipmentTemplateId The ID of the shipment template
         * @param {ShipmentTemplateRequest} shipmentTemplateRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTemplatesShipmentTemplateIdPut: function (shipmentTemplateId, shipmentTemplateRequest, options) {
            return localVarFp.shipmentsTemplatesShipmentTemplateIdPut(shipmentTemplateId, shipmentTemplateRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List tendered shipments
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [closedByCustomer] Restrict SpotNegotiations based on whether customer closed
         * @param {boolean} [closedByVendor] Restrict SpotNegotiations based on whether vendor closed
         * @param {string} [customerId] ID of customer company to which to restrict SpotNegotiations
         * @param {string} [customerNameContains] Partial name of customer company to which to restrict SpotNegotiations
         * @param {boolean} [involvedOnly] Restrict SpotNegotiations to those in which user is explicitly involved
         * @param {Array<string>} [involvedVendorUsers] Restrict SpotNegotiations to those with provided User IDs involved on the vendor side
         * @param {boolean} [isMostRecentWinner] Restrict SpotNegotiations to those that are or are not the most recent winner
         * @param {boolean} [isOpen] Restrict SpotNegotiations based on both sides agreeing the negotiation is open
         * @param {string} [shipment] Return SpotNegotiations where Shipment ID matches
         * @param {string} [shipmentBolNumber] Return SpotNegotiations where Shipment BOL number matches
         * @param {string} [shipmentBolNumberContains] Return SpotNegotiations where Shipment BOL number partially matches
         * @param {string} [shipmentCapacityProviderCustomerReferenceNumber] Return SpotNegotiations where Shipment capacity provider customer reference number matches
         * @param {string} [shipmentCapacityProviderCustomerReferenceNumberContains] Return SpotNegotiations where Shipment capacity provider customer reference number partially matches
         * @param {string} [shipmentCustomerReferenceNumber] Return SpotNegotiations where Shipment customer reference number matches
         * @param {string} [shipmentCustomerReferenceNumberContains] Return SpotNegotiations where Shipment customer reference number partially matches
         * @param {string} [shipmentDelayed] Return SpotNegotiations where Shipment delayed matches
         * @param {string} [shipmentDestinationContains] Return SpotNegotiations where Shipment destination partially matches
         * @param {string} [shipmentDropoffGte] Return SpotNegotiations with a dropoff stop with a planned date greater than or equal to this value
         * @param {string} [shipmentDropoffLte] Return SpotNegotiations with a dropoff stop with a planned data less than or equal to this value
         * @param {string} [shipmentName] Return SpotNegotiations where Shipment name matches
         * @param {string} [shipmentNameContains] Return SpotNegotiations where Shipment name partially matches
         * @param {string} [shipmentOriginContains] Return SpotNegotiations where Shipment origin partially matches
         * @param {string} [shipmentPickupGte] Return SpotNegotiations with a pickup stop with a planned date greater than or equal to this value
         * @param {string} [shipmentPickupLte] Return SpotNegotiations with a pickup stop with a planned date less than or equal to this value
         * @param {string} [shipmentPickupNumber] Return SpotNegotiations where Shipment pickup number matches
         * @param {string} [shipmentPickupNumberContains] Return SpotNegotiations where Shipment pickup number partially matches
         * @param {string} [shipmentProNumber] Return SpotNegotiations where Shipment PRO number matches
         * @param {string} [shipmentProNumberContains] Return SpotNegotiations where Shipment PRO number partially matches
         * @param {string} [shipmentPurchaseOrderNumber] Return SpotNegotiations where Shipment purchase order number matches
         * @param {string} [shipmentPurchaseOrderNumberContains] Return SpotNegotiations where Shipment purchase order number partially matches
         * @param {string} [shipmentReferenceId] Return SpotNegotiations where Shipment reference_id matches
         * @param {string} [shipmentReferenceIdContains] Return SpotNegotiations where Shipment reference_id partially matches
         * @param {string} [shipmentState] Return SpotNegotiations where Shipment state matches
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [shipmentStatus] Return SpotNegotiations with shipments that have provided statuses
         * @param {string} [vendorId] ID of the vendor company to which to restrict SpotNegotiations
         * @param {string} [vendorNameContains] Partial name of the vendor company to which to restrict SpotNegotiations
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        shipmentsTenderGet: function (page, pageSize, ordering, q, closedByCustomer, closedByVendor, customerId, customerNameContains, involvedOnly, involvedVendorUsers, isMostRecentWinner, isOpen, shipment, shipmentBolNumber, shipmentBolNumberContains, shipmentCapacityProviderCustomerReferenceNumber, shipmentCapacityProviderCustomerReferenceNumberContains, shipmentCustomerReferenceNumber, shipmentCustomerReferenceNumberContains, shipmentDelayed, shipmentDestinationContains, shipmentDropoffGte, shipmentDropoffLte, shipmentName, shipmentNameContains, shipmentOriginContains, shipmentPickupGte, shipmentPickupLte, shipmentPickupNumber, shipmentPickupNumberContains, shipmentProNumber, shipmentProNumberContains, shipmentPurchaseOrderNumber, shipmentPurchaseOrderNumberContains, shipmentReferenceId, shipmentReferenceIdContains, shipmentState, shipmentStatus, vendorId, vendorNameContains, options) {
            return localVarFp.shipmentsTenderGet(page, pageSize, ordering, q, closedByCustomer, closedByVendor, customerId, customerNameContains, involvedOnly, involvedVendorUsers, isMostRecentWinner, isOpen, shipment, shipmentBolNumber, shipmentBolNumberContains, shipmentCapacityProviderCustomerReferenceNumber, shipmentCapacityProviderCustomerReferenceNumberContains, shipmentCustomerReferenceNumber, shipmentCustomerReferenceNumberContains, shipmentDelayed, shipmentDestinationContains, shipmentDropoffGte, shipmentDropoffLte, shipmentName, shipmentNameContains, shipmentOriginContains, shipmentPickupGte, shipmentPickupLte, shipmentPickupNumber, shipmentPickupNumberContains, shipmentProNumber, shipmentProNumberContains, shipmentPurchaseOrderNumber, shipmentPurchaseOrderNumberContains, shipmentReferenceId, shipmentReferenceIdContains, shipmentState, shipmentStatus, vendorId, vendorNameContains, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create and tender a shipment to a Shipwell company
         * @param {TenderRequest} tenderRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        shipmentsTenderPost: function (tenderRequest, options) {
            return localVarFp.shipmentsTenderPost(tenderRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Accept or reject tendered shipments.
         * @param {string} tenderId
         * @param {TenderAcceptReject} tenderAcceptReject
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        shipmentsTenderTenderIdActionsPost: function (tenderId, tenderAcceptReject, options) {
            return localVarFp.shipmentsTenderTenderIdActionsPost(tenderId, tenderAcceptReject, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Mark a tendered shipment as no longer available. Renders as \'closed\' in our system.
         * @param {string} tenderId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        shipmentsTenderTenderIdDelete: function (tenderId, options) {
            return localVarFp.shipmentsTenderTenderIdDelete(tenderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update tendered shipment events
         * @param {string} tenderId
         * @param {TenderEventRequest} tenderEventRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        shipmentsTenderTenderIdEventsPost: function (tenderId, tenderEventRequest, options) {
            return localVarFp.shipmentsTenderTenderIdEventsPost(tenderId, tenderEventRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a tendered shipment to a shipwell company NOTE: Only valid for shipments created by posting to this endpoint. Shipments created via other methods are not guaranteed to work and may have unintended side effects.
         * @param {string} tenderId
         * @param {TenderRequest} tenderRequest
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        shipmentsTenderTenderIdPut: function (tenderId, tenderRequest, options) {
            return localVarFp.shipmentsTenderTenderIdPut(tenderId, tenderRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List tendered shipments
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [createdByCompanyId] Restrict Tenders by created by customer ID
         * @param {string} [shipmentCustomerReferenceNumber] Restrict Tenders by custoemr shipment reference number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTendersGet: function (page, pageSize, ordering, q, createdByCompanyId, shipmentCustomerReferenceNumber, options) {
            return localVarFp.shipmentsTendersGet(page, pageSize, ordering, q, createdByCompanyId, shipmentCustomerReferenceNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create and tender a shipment to a Shipwell company
         * @param {TenderRequest} tenderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTendersPost: function (tenderRequest, options) {
            return localVarFp.shipmentsTendersPost(tenderRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Accept or reject tendered shipments.
         * @param {string} tenderId
         * @param {TenderAcceptReject} tenderAcceptReject
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTendersTenderIdActionsPost: function (tenderId, tenderAcceptReject, options) {
            return localVarFp.shipmentsTendersTenderIdActionsPost(tenderId, tenderAcceptReject, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Mark a tendered shipment as no longer available. Renders as \'closed\' in the Shipwell platform.
         * @param {string} tenderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTendersTenderIdDelete: function (tenderId, options) {
            return localVarFp.shipmentsTendersTenderIdDelete(tenderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update tendered Shipment events.
         * @param {string} tenderId
         * @param {TenderEventRequest} tenderEventRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTendersTenderIdEventsPost: function (tenderId, tenderEventRequest, options) {
            return localVarFp.shipmentsTendersTenderIdEventsPost(tenderId, tenderEventRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a tendered shipment to a shipwell company NOTE: Only valid for shipments created by posting to this endpoint. Shipments created via other methods are not guaranteed to work and may have unintended side effects.
         * @param {string} tenderId
         * @param {TenderRequest} tenderRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsTendersTenderIdPut: function (tenderId, tenderRequest, options) {
            return localVarFp.shipmentsTendersTenderIdPut(tenderId, tenderRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ShipmentsApiFactory = ShipmentsApiFactory;
/**
 * ShipmentsApi - object-oriented interface
 * @export
 * @class ShipmentsApi
 * @extends {BaseAPI}
 */
var ShipmentsApi = /** @class */ (function (_super) {
    __extends(ShipmentsApi, _super);
    function ShipmentsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Generate a BOL number for a shipment (Internal Shipwell Microservice use only)
     * @summary Generate BOL Number
     * @param {string} shipmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.generateBolNumber = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).generateBolNumber(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns auction stats for shipments by their shipment id
     * @param {Array<string>} [shipmentId] Shipment ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsAuctionStatsGet = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsAuctionStatsGet(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List all ShipmentTags for the authenticated company for v3 shipment
     * @param {string} shipmentId The id of the shipment
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsBundlesShipmentIdTagsGet = function (shipmentId, page, pageSize, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsBundlesShipmentIdTagsGet(shipmentId, page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a ShipmentTag for v3 shipment
     * @param {string} shipmentId The id of the shipment
     * @param {string} shipmentTagId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsBundlesShipmentIdTagsShipmentTagIdDelete = function (shipmentId, shipmentTagId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsBundlesShipmentIdTagsShipmentTagIdDelete(shipmentId, shipmentTagId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a ShipmentTag by its id for v3 shipment
     * @param {string} shipmentId The id of the shipment
     * @param {string} shipmentTagId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsBundlesShipmentIdTagsShipmentTagIdGet = function (shipmentId, shipmentTagId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsBundlesShipmentIdTagsShipmentTagIdGet(shipmentId, shipmentTagId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Add a ShipmentTag to v3 shipment bundle
     * @param {string} shipmentId The id of the shipment
     * @param {string} shipmentTagId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsBundlesShipmentIdTagsShipmentTagIdPost = function (shipmentId, shipmentTagId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsBundlesShipmentIdTagsShipmentTagIdPost(shipmentId, shipmentTagId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Return a limited amount of shipment details using API Key authentication and query params to search. Returns an empty list if no query params are passed
     * @param {Array<string>} [bolNumber] Include shipments with these BOL Numbers
     * @param {Array<string>} [pickupNumber] Include shipments with these Pickup Numbers
     * @param {Array<string>} [proNumber] Include shipments with these PRO Numbers
     * @param {Array<string>} [purchaseOrderNumber] Include shipments with these PO Numbers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsExternalGet = function (bolNumber, pickupNumber, proNumber, purchaseOrderNumber, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsExternalGet(bolNumber, pickupNumber, proNumber, purchaseOrderNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a limited amount of shipment details using a query param key instead of authentication
     * @param {string} shipmentId The id of the shipment
     * @param {string} key Secret view key authorizing user to see the Shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsExternalShipmentIdGet = function (shipmentId, key, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsExternalShipmentIdGet(shipmentId, key, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get locations for the shipment using a query param key instead of authentication
     * @param {string} shipmentId The id of the shipment
     * @param {string} key Secret view key authorizing user to see the Shipment
     * @param {string} [beginDatetime] For requesting data starting at a given date
     * @param {string} [endDatetime] For requesting data ending at a given date
     * @param {string} [filterDistance] Applies a distance filter and only returns points greater than filter_distance km apart. To return all, set this to -1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsExternalShipmentIdTrackingGet = function (shipmentId, key, beginDatetime, endDatetime, filterDistance, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsExternalShipmentIdTrackingGet(shipmentId, key, beginDatetime, endDatetime, filterDistance, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a list of shipments
     * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {boolean} [activeVendorAssignment] Include or exclude shipments with active CarrierAssignments
     * @param {'MOBILE_DEVICE_ALERT' | 'NON_ACTIVE_CARRIER'} [alertTypes] Filter on shipments that have alerts of this type
     * @param {boolean} [alerts] Filter on whether or not a Shipment has alert messages
     * @param {boolean} [archived] Filter on whether or not a shipment is archived
     * @param {Array<string>} [bolNumber] Include shipments with these BOL Numbers
     * @param {string} [bolNumberContains] Return shipments where the BOL number contains this value
     * @param {Array<string>} [bolNumberExclude] Exclude shipments with these BOL Numbers
     * @param {string} [createdAt] For requesting data created at a certain datetime
     * @param {Array<'SHIPWELL_WEB' | 'IMPORT' | 'TENDER' | 'SHIPWELL_WEB_UNAUTH' | 'OTHER'>} [createdBySource] Return shipments created by sources in the array.
     * @param {string} [createdByUserContains] Return shipments where created_by_user object contains this string e.g first_name, last_name or email
     * @param {Array<string>} [createdByUserId] Return shipments where created_by_user_id in the array.
     * @param {string} [createdByUserName] Return shipments where created_by_user_name is exactly this string
     * @param {string} [createdByUserNameContains] Return shipments where created_by_user_name contains this string
     * @param {string} [customer] Return shipments with this exact value as the customer company name
     * @param {string} [customerContains] Return shipments where the customer company name contains this value
     * @param {string} [customerId] Return shipments with this exact id for the customer company
     * @param {Array<string>} [customerReferenceNumber] Include shipments with these Customer Reference Numbers
     * @param {string} [customerReferenceNumberContains] Include shipments where the Customer Reference Numbers contains this value
     * @param {Array<string>} [customerReferenceNumberExclude] Exclude shipments with these Customer Reference Numbers
     * @param {string} [destinationContains] Return shipments with this value in the destination
     * @param {string} [deliveryStopsContains] Return shipments with this value in one of its dropoff stops
     * @param {string} [deliveryStopsCompanyNameContains] Return shipments with this value in one of its delivery stops location company_name
     * @param {string} [destinationStateProvince] Return shipments with this state province on its destination stop
     * @param {string} [deliveryStopsStateProvince] Return shipments with this state province on its delivery stops
     * @param {string} [drayageBookingNumberContains] Include shipments where the drayage booking number contains this value
     * @param {string} [drayageChassisNumberContains] Include shipments where the drayage chassis number contains this value
     * @param {string} [drayageContainerNumberContains] Include shipments where the drayage container number contains this value
     * @param {string} [drayageContainerReturnDateGte] Include shipments where the drayage container return date is greater than or equal to this value
     * @param {string} [drayageContainerReturnDateLte] Include shipments where the drayage container return date is less than or equal to this value
     * @param {string} [drayageEstimatedArrivalDateGte] Include shipments where the drayage estimated arrival date is greater than or equal to this value
     * @param {string} [drayageEstimatedArrivalDateLte] Include shipments where the drayage estimated arrival date is less than or equal to this value
     * @param {string} [drayageLastFreeDateGte] Include shipments where the drayage last free datetime is greater than or equal to this value
     * @param {string} [drayageLastFreeDateLte] Include shipments where the drayage last free datetime is less than or equal to this value
     * @param {string} [drayageReleaseDateGte] Include shipments where the drayage release datetime is greater than or equal to this value
     * @param {string} [drayageReleaseDateLte] Include shipments where the drayage release datetime is less than or equal to this value
     * @param {string} [drayageSealNumberContains] Include shipments where the drayage seal number contains this value
     * @param {boolean} [driverAssigned] Return shipments where the driver is assigned/unassigned
     * @param {string} [dropoffGte] Return shipments with a dropoff stop with a planned date greater than or equal to this value
     * @param {string} [dropoffLte] Return shipments with a dropoff stop with a planned data less than or equal to this value
     * @param {string} [equipmentType] Return shipments with this equipment type
     * @param {string} [equipmentTypeContains] Return shipments where the equipment type contains this value
     * @param {string} [fedexAccount] Return pickups specific to this FedEx account
     * @param {string} [groupId] Group id for a shipment
     * @param {boolean} [hasInvoice] If true, show shipments which have at least one invoice otherwise show those with none.
     * @param {boolean} [hasBill] If true, show shipments which have at least one bill otherwise show those with none.
     * @param {Array<string>} [include] [v3] A list of properties to include in the response resource
     * @param {boolean} [loadBoardEnabled] Filter on whether or not a shipment is posted on the company load board
     * @param {string} [loadBoardId] Return shipments where the load board ID is equal to this value
     * @param {string} [loadBoardIdContains] Return shipments where the load board ID contains this value
     * @param {string} [mode] Return shipments with this shipment mode
     * @param {string} [modeContains] Return shipments where the shipment mode contains this value
     * @param {string} [nameContains] Return shipments where the shipment name contains this value
     * @param {boolean} [open] Filter on whether or not a shipment is open
     * @param {string} [originContains] Return shipments with this value in the origin
     * @param {string} [originStateProvince] Return shipments with this state province on its origin stop
     * @param {string} [pickupStopsStateProvince] Return shipments with this state province on its pickup stops
     * @param {string} [pickupStopsContains] Return shipments with this value in one of its pickup stops
     * @param {string} [pickupStopsCompanyNameContains] Return shipments with this value in one of its pickup stops location company_name
     * @param {Array<'CANCELLED' | 'DELAYED' | 'DELIVERED' | 'IN_TRANSIT' | 'NOT_SCHEDULED' | 'SCHEDULED'>} [parcelPickupStatus] Include shipments where the parcel pickup status equals one of these values
     * @param {string} [pickupGte] Return shipments with a pickup stop with a planned date greater than or equal to this value
     * @param {string} [updatedAtGte] Return shipments updated greater than or equal to this value
     * @param {string} [updatedAtLte] Return shipments updated less than or equal to this value
     * @param {string} [pickupLte] Return shipments with a pickup stop with a planned date less than or equal to this value
     * @param {string} [pickupId] Include shipments currently associated with the provided ShipmentPickup\&#39;s ID
     * @param {Array<string>} [pickupNumber] Include shipments with these Pickup Numbers
     * @param {string} [pickupNumberContains] Include shipments where the Pickup Number contains this value
     * @param {Array<string>} [pickupNumberExclude] Exclude shipments with these Pickup Numbers
     * @param {Array<string>} [proNumber] Include shipments with these PRO Numbers
     * @param {string} [proNumberContains] Return shipments where the PRO number contains this value
     * @param {Array<string>} [proNumberExclude] Exclude shipments with these PRO Numbers
     * @param {string} [powerUnit] Return shipments where this power unit is assigned
     * @param {Array<string>} [purchaseOrderNumber] Include shipments with these PO Numbers
     * @param {string} [purchaseOrderNumberContains] Include shipments where the PO number contains this value
     * @param {Array<string>} [purchaseOrderNumberExclude] Exclude shipments with these PO Numbers
     * @param {Array<string>} [referenceId] Include shipments with these Reference IDs
     * @param {string} [referenceIdContains] Include shipments where the reference ID contains this value
     * @param {Array<string>} [referenceIdExclude] Exclude shipments with these Reference IDs
     * @param {Array<string>} [masterAirWaybill] Include shipments with these Master Air Waybill Numbers
     * @param {string} [masterAirWaybillContains] Include shipments where the Master Air Waybill number contains this value
     * @param {Array<string>} [houseAirWaybill] Include shipments with these House Air Waybill Numbers
     * @param {string} [houseAirWaybillContains] Include shipments where the House Air Waybill number contains this value
     * @param {Array<string>} [reps] Include shipments with these reps
     * @param {'owner_operator'} [role] Get results based on a specific perspective such as owner_operator
     * @param {string} [serviceLevel] Return shipments with this service level
     * @param {Array<string>} [accessorials] Include only shipments with at least one matching ShipmentAccessorial
     * @param {string} [createdAtGte] Include shipments where created_at is greater than or equal to the time value
     * @param {string} [createdAtLte] Include shipments where created_at is less than or equal to this value
     * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
     * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [statusExclude] Exclude shipments with these statuses
     * @param {string} [statusContains] Include shipments where the status contains this string
     * @param {Array<string>} [tags] Include only shipments with at least one matching ShipmentTag
     * @param {Array<string>} [tagsExclude] Excludes shipments with at least one matching tag
     * @param {Array<string>} [shipmentShipwellCustomData] Include shipments that contain these shipment-level custom data values
     * @param {string} [stopsContains] Return shipments with this value in one of its stops
     * @param {string} [stopsCompanyNameContains] Return shipments with this value in one of its stops location company_name
     * @param {string} [stopsStateProvince] Return shipments with this state province on one of its stops
     * @param {string} [timelineLastUpdatedAtGte] Return shipments where last timeline update was greater than or equal to the value or was never updated
     * @param {string} [timelineLastUpdatedAtLte] Return shipments where last timeline update was less than or equal to the value or was never updated
     * @param {'current' | 'upcoming' | 'active' | 'past'} [timeFrame] Return shipments that are within the given time frame. active &#x3D; current + upcoming
     * @param {number} [totalMilesGte] Return shipments with total miles greater than or equal to this value
     * @param {number} [totalMilesLte] Return shipments with total miles less than or equal to this value
     * @param {string} [upsAccount] Return pickups specific to this UPS account
     * @param {string} [vendorId] Return shipments with this exact value as the vendor Carrier id
     * @param {string} [vendorContains] Return shipments where the vendor company name contains this value
     * @param {number} [totalWeightOverrideGte] Return shipments with weight greater than or equal to this value
     * @param {number} [totalWeightOverrideLte] Return shipments with weight less than or equal to this value
     * @param {number} [originRadius] Radius from origin stop
     * @param {number} [originLat] Latitude of location to filter on for origin stop
     * @param {number} [originLon] Longitude of location to filter on for origin stop
     * @param {number} [pickupRadius] Radius from a pickup stop
     * @param {number} [pickupLat] Latitude of location to filter on for pickup stop
     * @param {number} [pickupLon] Longitude of location to filter on for pickup stop
     * @param {number} [destinationRadius] Radius from the destination stop
     * @param {number} [destinationLat] Latitude of location to filter on for destination stop
     * @param {number} [destinationLon] Longitude of location to filter on for destination stop
     * @param {number} [deliveryRadius] Radius from a delivery stop
     * @param {number} [deliveryLat] Latitude of location to filter on for delivery stop
     * @param {number} [deliveryLon] Longitude of location to filter on for delivery stop
     * @param {Array<'RUNNING' | 'CANCELLED' | 'FAILED' | 'SUCCESS'>} [workflowExecutionStatus] Include shipments with these workflow execution statuses
     * @param {boolean} [showClonedResults] If true, show shipments that have a non null last_cloned_at value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsGet = function (xCompanyId, page, pageSize, ordering, q, activeVendorAssignment, alertTypes, alerts, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, updatedAtGte, updatedAtLte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, accessorials, createdAtGte, createdAtLte, status, statusExclude, statusContains, tags, tagsExclude, shipmentShipwellCustomData, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, workflowExecutionStatus, showClonedResults, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsGet(xCompanyId, page, pageSize, ordering, q, activeVendorAssignment, alertTypes, alerts, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, updatedAtGte, updatedAtLte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, accessorials, createdAtGte, createdAtLte, status, statusExclude, statusContains, tags, tagsExclude, shipmentShipwellCustomData, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, workflowExecutionStatus, showClonedResults, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Estimate how many linear feet of a truck that ShipmentLineItems would fill if packed optimally
     * @param {LinearFeetEstimate} linearFeetEstimate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsLinearFeetPost = function (linearFeetEstimate, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsLinearFeetPost(linearFeetEstimate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List of pickups for a company
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {string} [scheduledDate] Date of a scheduled pickup
     * @param {string} [scheduledDateGte] Return pickups with a scheduled date greater than or equal to this value
     * @param {string} [scheduledDateLte] Return pickups with a scheduled date less than or equal to this value
     * @param {string} [scheduledTimeWindowStartGte] Return pickups with a scheduled start time window date and time greater than or equal to this value
     * @param {string} [scheduledTimeWindowStartLte] Return pickups with a scheduled start time window date and time less than or equal to this value
     * @param {string} [scheduledTimeWindowEndGte] Return pickups with a scheduled end time window date and time greater than or equal to this value
     * @param {string} [scheduledTimeWindowEndLte] Return pickups with a scheduled end time window date and time less than or equal to this value
     * @param {string} [pointOfContact] Include pickups with this point of contact name
     * @param {string} [pointOfContactContains] Include pickups where the point of contact includes this value
     * @param {string} [pointOfContactExcludes] Exclude pickups where the point of contact includes this value
     * @param {string} [specialInstructions] Include pickups with these special instructions
     * @param {string} [specialInstructionsContains] Include pickups where the special instructions includes this value
     * @param {string} [specialInstructionsExcludes] Exclude pickups where the special instructions includes this value
     * @param {string} [pickupNumber] Include pickups with this pickup number
     * @param {string} [pickupNumberContains] Include pickups where the pickup number contains this value
     * @param {string} [pickupNumberExcludes] Exclude pickups with this pickup number
     * @param {string} [providerCode] Include pickups with this provider code
     * @param {string} [providerCarrierCode] Include pickups with this provider carrier code
     * @param {string} [providerCarrierCodeContains] Include pickups where the provider carrier code contains this value
     * @param {string} [providerCarrierCodeExcludes] Exclude pickups with this provider carrier code
     * @param {string} [providerLocationId] Include pickups with this provider location id
     * @param {string} [providerLocationIdContains] Include pickups where the provider location id  contains this value
     * @param {string} [providerLocationIdExcludes] Exclude pickups with this provider location id
     * @param {string} [addressBookEntry] Include pickups with this address book entry id
     * @param {boolean} [isRegularlyScheduled] Include pickups with this is_regularly_scheduled value
     * @param {boolean} [cancelled] Return pickups based on if they are cancelled
     * @param {string} [shipmentIds] Return pickup with that include this shipment
     * @param {string} [company] Return pickups specific to this company
     * @param {string} [fedexAccount] Return pickups specific to this FedEx account
     * @param {string} [upsAccount] Return pickups specific to this UPS account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsPickupsGet = function (page, pageSize, ordering, q, scheduledDate, scheduledDateGte, scheduledDateLte, scheduledTimeWindowStartGte, scheduledTimeWindowStartLte, scheduledTimeWindowEndGte, scheduledTimeWindowEndLte, pointOfContact, pointOfContactContains, pointOfContactExcludes, specialInstructions, specialInstructionsContains, specialInstructionsExcludes, pickupNumber, pickupNumberContains, pickupNumberExcludes, providerCode, providerCarrierCode, providerCarrierCodeContains, providerCarrierCodeExcludes, providerLocationId, providerLocationIdContains, providerLocationIdExcludes, addressBookEntry, isRegularlyScheduled, cancelled, shipmentIds, company, fedexAccount, upsAccount, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsPickupsGet(page, pageSize, ordering, q, scheduledDate, scheduledDateGte, scheduledDateLte, scheduledTimeWindowStartGte, scheduledTimeWindowStartLte, scheduledTimeWindowEndGte, scheduledTimeWindowEndLte, pointOfContact, pointOfContactContains, pointOfContactExcludes, specialInstructions, specialInstructionsContains, specialInstructionsExcludes, pickupNumber, pickupNumberContains, pickupNumberExcludes, providerCode, providerCarrierCode, providerCarrierCodeContains, providerCarrierCodeExcludes, providerLocationId, providerLocationIdContains, providerLocationIdExcludes, addressBookEntry, isRegularlyScheduled, cancelled, shipmentIds, company, fedexAccount, upsAccount, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Schedule a pickup
     * @param {ScheduleShipmentPickupRequest} scheduleShipmentPickupRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsPickupsPost = function (scheduleShipmentPickupRequest, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsPickupsPost(scheduleShipmentPickupRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve data for a shipment pickup
     * @param {string} shipmentPickupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsPickupsShipmentPickupIdGet = function (shipmentPickupId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsPickupsShipmentPickupIdGet(shipmentPickupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a shipment pickup
     * @param {string} shipmentPickupId
     * @param {ShipmentPickup} shipmentPickup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsPickupsShipmentPickupIdPut = function (shipmentPickupId, shipmentPickup, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsPickupsShipmentPickupIdPut(shipmentPickupId, shipmentPickup, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Shipments start in a \"draft\" state by default. Only the `metadata` parameter set to `\"open\": false, \"archived\": false,` and `tags:` set to `[]` are required to begin a draft shipment.
     * @summary Create a new Shipment
     * @param {Shipment} shipment
     * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsPost = function (shipment, xCompanyId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsPost(shipment, xCompanyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Transform shipments into round trips
     * @param {InlineObject22} [inlineObject22]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsRoundTripJobPost = function (inlineObject22, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsRoundTripJobPost(inlineObject22, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Return results from round trip job
     * @param {string} roundTripJobId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsRoundTripJobRoundTripJobIdGet = function (roundTripJobId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsRoundTripJobRoundTripJobIdGet(roundTripJobId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the shipment OpenAPI schema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsSchemaGet = function (options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsSchemaGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update an existing shipment to add one or more purchase orders
     * @param {string} shipmentId The id of the shipment
     * @param {InlineObject23} [inlineObject23]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdAddOrdersPut = function (shipmentId, inlineObject23, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdAddOrdersPut(shipmentId, inlineObject23, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a shipwell automation event
     * @param {string} shipmentId The id of the shipment
     * @param {string} automationEventId The id of the shipment automation event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdAutomationEventsAutomationEventIdDelete = function (shipmentId, automationEventId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdAutomationEventsAutomationEventIdDelete(shipmentId, automationEventId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a shipwell automation event
     * @param {string} shipmentId The id of the shipment
     * @param {string} automationEventId The id of the shipment automation event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdAutomationEventsAutomationEventIdGet = function (shipmentId, automationEventId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdAutomationEventsAutomationEventIdGet(shipmentId, automationEventId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a shipwell automation event
     * @param {string} shipmentId The id of the shipment
     * @param {string} automationEventId The id of the shipment automation event
     * @param {AutomationEvent} automationEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdAutomationEventsAutomationEventIdPut = function (shipmentId, automationEventId, automationEvent, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdAutomationEventsAutomationEventIdPut(shipmentId, automationEventId, automationEvent, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Cancel and delete all future scheduled automation events on a shipment
     * @param {string} shipmentId The id of the shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdAutomationEventsCancelScheduledDelete = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdAutomationEventsCancelScheduledDelete(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve automated shipwell events
     * @param {string} shipmentId The id of the shipment
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdAutomationEventsGet = function (shipmentId, page, pageSize, ordering, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdAutomationEventsGet(shipmentId, page, pageSize, ordering, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Schedule an automated shipwell event
     * @param {string} shipmentId The id of the shipment
     * @param {AutomationEvent} automationEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdAutomationEventsPost = function (shipmentId, automationEvent, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdAutomationEventsPost(shipmentId, automationEvent, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create multiple documents onto a shipment
     * @param {string} shipmentId The id of the shipment
     * @param {ShipmentBulkDocument} [shipmentBulkDocument]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdBulkDocumentsPost = function (shipmentId, shipmentBulkDocument, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdBulkDocumentsPost(shipmentId, shipmentBulkDocument, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a CarrierAssignment by its id
     * @param {string} shipmentId The id of the shipment
     * @param {string} carrierAssignmentId The id of a CarrierAssignment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdCarrierAssignmentsCarrierAssignmentIdGet = function (shipmentId, carrierAssignmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdCarrierAssignmentsCarrierAssignmentIdGet(shipmentId, carrierAssignmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update the charge line items of a CarrierAssignment
     * @param {string} shipmentId The id of the shipment
     * @param {string} carrierAssignmentId The id of a CarrierAssignment
     * @param {CarrierAssignment} carrierAssignment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdCarrierAssignmentsCarrierAssignmentIdPut = function (shipmentId, carrierAssignmentId, carrierAssignment, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdCarrierAssignmentsCarrierAssignmentIdPut(shipmentId, carrierAssignmentId, carrierAssignment, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete the carrier assignment associated with the shipment
     * @param {string} shipmentId The id of the shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdCarrierAssignmentsDelete = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdCarrierAssignmentsDelete(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get the current assigned carrier associated with this shipment
     * @param {string} shipmentId The id of the shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdCarrierAssignmentsGet = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdCarrierAssignmentsGet(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Only one carrier assignment is associated with a company-shipment combo at a time.  Posting here will overwrite the companies carrier assignment. Carrier assignments are only shown to the user who sets it
     * @summary Create a new carrier assignment
     * @param {string} shipmentId The id of the shipment
     * @param {CarrierAssignment} carrierAssignment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdCarrierAssignmentsPost = function (shipmentId, carrierAssignment, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdCarrierAssignmentsPost(shipmentId, carrierAssignment, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get the carrier and equipment data
     * @param {string} shipmentId The id of the shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdCarrierConfigGet = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdCarrierConfigGet(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Internal route used to provide and update information around the carrier and equipment section
     * @summary Update the carrier config data
     * @param {string} shipmentId The id of the shipment
     * @param {CarrierConfig} carrierConfig
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdCarrierConfigPost = function (shipmentId, carrierConfig, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdCarrierConfigPost(shipmentId, carrierConfig, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Initialize a shipment for appless cell phone tracking
     * @param {string} shipmentId The id of the shipment
     * @param {CellTrackingInitRequest} cellTrackingInitRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdCellTrackingPost = function (shipmentId, cellTrackingInitRequest, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdCellTrackingPost(shipmentId, cellTrackingInitRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get the Shipment Container Details data
     * @param {string} shipmentId The id of the shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdContainerDetailsGet = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdContainerDetailsGet(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a shipment
     * @param {string} shipmentId The id of the shipment
     * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdDelete = function (shipmentId, xCompanyId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdDelete(shipmentId, xCompanyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get the particular dispatch job data associated with this shipment
     * @param {string} shipmentId The id of the shipment
     * @param {string} dispatchJobId The id of the dispatch job
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdDispatchJobDispatchJobIdGet = function (shipmentId, dispatchJobId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdDispatchJobDispatchJobIdGet(shipmentId, dispatchJobId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get auditlog of documents sent
     * @param {string} shipmentId The id of the shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdDocumentsAuditlogGet = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdDocumentsAuditlogGet(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a Document
     * @param {string} shipmentId The id of the shipment
     * @param {string} documentId The id of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdDocumentsDocumentIdDelete = function (shipmentId, documentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdDocumentsDocumentIdDelete(shipmentId, documentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get metadata about a document
     * @param {string} shipmentId The id of the shipment
     * @param {string} documentId The id of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdDocumentsDocumentIdGet = function (shipmentId, documentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdDocumentsDocumentIdGet(shipmentId, documentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update metadata about a document
     * @param {string} shipmentId The id of the shipment
     * @param {string} documentId The id of the document
     * @param {ShipmentDocumentMetadata} shipmentDocumentMetadata
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdDocumentsDocumentIdPut = function (shipmentId, documentId, shipmentDocumentMetadata, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdDocumentsDocumentIdPut(shipmentId, documentId, shipmentDocumentMetadata, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new signature request for an specific document.
     * @param {string} shipmentId The id of the shipment
     * @param {string} documentId The id of the document
     * @param {ShipmentDocumentRequestSignature} [shipmentDocumentRequestSignature]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdDocumentsDocumentIdRequestSignaturePost = function (shipmentId, documentId, shipmentDocumentRequestSignature, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdDocumentsDocumentIdRequestSignaturePost(shipmentId, documentId, shipmentDocumentRequestSignature, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Attach the signature file to the existing request object.
     * @param {string} shipmentId The id of the shipment
     * @param {string} documentId The id of the document
     * @param {string} [description] An optional description of the signature
     * @param {any} [file] The signature file
     * @param {string} [signatoryName] The name of the signatory
     * @param {string} [signatoryRole] The role of the signatory
     * @param {string} [stopId] The Stop reference
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdDocumentsDocumentIdSignPost = function (shipmentId, documentId, description, file, signatoryName, signatoryRole, stopId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdDocumentsDocumentIdSignPost(shipmentId, documentId, description, file, signatoryName, signatoryRole, stopId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get signatures for a document
     * @param {string} shipmentId The id of the shipment
     * @param {string} documentId The id of the document
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdDocumentsDocumentIdSignaturesGet = function (shipmentId, documentId, page, pageSize, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdDocumentsDocumentIdSignaturesGet(shipmentId, documentId, page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Generate a BOL for a shipment
     * @param {string} shipmentId The id of the shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdDocumentsGenerateBolGet = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdDocumentsGenerateBolGet(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Generate a rate confirmation for a shipment
     * @param {string} shipmentId The id of the shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdDocumentsGenerateRateConfirmationGet = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdDocumentsGenerateRateConfirmationGet(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Generate shipping labels for a shipment
     * @param {string} shipmentId The id of the shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdDocumentsGenerateShippingLabelGet = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdDocumentsGenerateShippingLabelGet(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get metadata about a documents on a shipment
     * @param {string} shipmentId The id of the shipment
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdDocumentsGet = function (shipmentId, page, pageSize, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdDocumentsGet(shipmentId, page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a document on a shipment
     * @param {string} shipmentId The id of the shipment
     * @param {string} description
     * @param {any} file
     * @param {boolean} isCarrierDocument
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdDocumentsPost = function (shipmentId, description, file, isCarrierDocument, type, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdDocumentsPost(shipmentId, description, file, isCarrierDocument, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Send shipment documents to a list of email recipients
     * @param {string} shipmentId The id of the shipment
     * @param {SendDocument} sendDocument
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdDocumentsSendPost = function (shipmentId, sendDocument, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdDocumentsSendPost(shipmentId, sendDocument, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get the current equipment config associated with this shipment
     * @param {string} shipmentId The id of the shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdEquipmentConfigGet = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdEquipmentConfigGet(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Only one equipment config is associated with a shipment at a time.  Posting here will overwrite the previous equipment config and attempt to track with the new configuration.
     * @summary Create a new equipment config
     * @param {string} shipmentId The id of the shipment
     * @param {CreateEquipmentConfig} createEquipmentConfig
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdEquipmentConfigPost = function (shipmentId, createEquipmentConfig, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdEquipmentConfigPost(shipmentId, createEquipmentConfig, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about a shipment
     * @param {string} shipmentId The id of the shipment
     * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdGet = function (shipmentId, xCompanyId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdGet(shipmentId, xCompanyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a list of ShipmentTimelineEvents grouped by Stop for a given Shipment
     * @param {string} shipmentId The id of the shipment
     * @param {'location' | 'status'} [groupType] The type of timeline events to return, defaults to all
     * @param {boolean} [filterFutureStops] Whether to remove future stops from the list of grouped timeline events
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdGroupedTimelineEventsGet = function (shipmentId, groupType, filterFutureStops, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdGroupedTimelineEventsGet(shipmentId, groupType, filterFutureStops, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List messages for a Shipment
     * @param {string} shipmentId The id of the shipment
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [q] search query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdMessagesGet = function (shipmentId, page, pageSize, q, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdMessagesGet(shipmentId, page, pageSize, q, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new message for a Shipment
     * @param {string} shipmentId The id of the shipment
     * @param {ShipmentMessage} shipmentMessage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdMessagesPost = function (shipmentId, shipmentMessage, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdMessagesPost(shipmentId, shipmentMessage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a ShipmentMessage
     * @param {string} shipmentId The id of the shipment
     * @param {string} shipmentMessageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdMessagesShipmentMessageIdDelete = function (shipmentId, shipmentMessageId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdMessagesShipmentMessageIdDelete(shipmentId, shipmentMessageId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve data for a ShipmentMessage
     * @param {string} shipmentId The id of the shipment
     * @param {string} shipmentMessageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdMessagesShipmentMessageIdGet = function (shipmentId, shipmentMessageId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdMessagesShipmentMessageIdGet(shipmentId, shipmentMessageId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Mark a ShipmentMessage as read
     * @param {string} shipmentId The id of the shipment
     * @param {string} shipmentMessageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdMessagesShipmentMessageIdMarkAsReadPost = function (shipmentId, shipmentMessageId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdMessagesShipmentMessageIdMarkAsReadPost(shipmentId, shipmentMessageId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Mark a ShipmentMessage as unread
     * @param {string} shipmentId The id of the shipment
     * @param {string} shipmentMessageId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdMessagesShipmentMessageIdMarkAsUnreadPost = function (shipmentId, shipmentMessageId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdMessagesShipmentMessageIdMarkAsUnreadPost(shipmentId, shipmentMessageId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a ShipmentMessage
     * @param {string} shipmentId The id of the shipment
     * @param {string} shipmentMessageId
     * @param {ShipmentMessage} shipmentMessage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdMessagesShipmentMessageIdPut = function (shipmentId, shipmentMessageId, shipmentMessage, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdMessagesShipmentMessageIdPut(shipmentId, shipmentMessageId, shipmentMessage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List notes for a Shipment or Shipment Quote
     * @param {string} shipmentId The id of the shipment
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdNotesGet = function (shipmentId, page, pageSize, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdNotesGet(shipmentId, page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new note for a Shipment or Shipment Quote
     * @param {string} shipmentId The id of the shipment
     * @param {ShipmentNote} shipmentNote
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdNotesPost = function (shipmentId, shipmentNote, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdNotesPost(shipmentId, shipmentNote, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a ShipmentNote
     * @param {string} shipmentId The id of the shipment
     * @param {string} shipmentNoteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdNotesShipmentNoteIdDelete = function (shipmentId, shipmentNoteId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdNotesShipmentNoteIdDelete(shipmentId, shipmentNoteId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve data for a ShipmentNote
     * @param {string} shipmentId The id of the shipment
     * @param {string} shipmentNoteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdNotesShipmentNoteIdGet = function (shipmentId, shipmentNoteId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdNotesShipmentNoteIdGet(shipmentId, shipmentNoteId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a ShipmentNote
     * @param {string} shipmentId The id of the shipment
     * @param {string} shipmentNoteId
     * @param {ShipmentNote} shipmentNote
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdNotesShipmentNoteIdPut = function (shipmentId, shipmentNoteId, shipmentNote, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdNotesShipmentNoteIdPut(shipmentId, shipmentNoteId, shipmentNote, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * After a successful update, the \'stops\' and \'line_items\' of the Shipment will be exactly the same as those provided in the request. This means that if existing \'stops\' or \'ShipmentLineItems\' were left out of their arrays, those objects would be deleted. Providing existing objects in those arrays with their ids will update those objects instead of creating or deleting them. Providing objects in the arrays that do not have ids will create new objects. If you omit the \'stops\' or \'line_items\' arrays from the request body, no changes will be made to those related object sets.
     * @summary Update a shipment
     * @param {string} shipmentId The id of the shipment
     * @param {Shipment} shipment
     * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdPut = function (shipmentId, shipment, xCompanyId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdPut(shipmentId, shipment, xCompanyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Remove a purchase order from an existing shipment
     * @param {string} shipmentId The id of the shipment
     * @param {string} orderId The id of the order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdRemoveOrdersOrderIdPut = function (shipmentId, orderId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdRemoveOrdersOrderIdPut(shipmentId, orderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get the list of the shipment reps
     * @param {string} shipmentId The id of the shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdRepsGet = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdRepsGet(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Add a rep to a shipment
     * @param {string} shipmentId The id of the shipment
     * @param {CreateShipmentRepRequest} createShipmentRepRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdRepsPost = function (shipmentId, createShipmentRepRequest, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdRepsPost(shipmentId, createShipmentRepRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a rep record
     * @param {string} shipmentId The id of the shipment
     * @param {string} repId The id of the rep
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdRepsRepIdDelete = function (shipmentId, repId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdRepsRepIdDelete(shipmentId, repId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a specific shipment rep
     * @param {string} shipmentId The id of the shipment
     * @param {string} repId The id of the rep
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdRepsRepIdGet = function (shipmentId, repId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdRepsRepIdGet(shipmentId, repId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a Rep record
     * @param {string} shipmentId The id of the shipment
     * @param {string} repId The id of the rep
     * @param {UpdateShipmentRepRequest} updateShipmentRepRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdRepsRepIdPut = function (shipmentId, repId, updateShipmentRepRequest, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdRepsRepIdPut(shipmentId, repId, updateShipmentRepRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Send an SMS message requesting that someone download Shipwell app
     * @param {string} shipmentId The id of the shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdRequestAppDownloadPost = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdRequestAppDownloadPost(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Send an SMS to locate request to a Driver
     * @param {string} shipmentId The id of the shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdSmsTrackingPost = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdSmsTrackingPost(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a list of Stops for a given Shipment
     * @param {string} shipmentId The id of the shipment
     * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdStopsGet = function (shipmentId, xCompanyId, page, pageSize, ordering, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdStopsGet(shipmentId, xCompanyId, page, pageSize, ordering, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * The new Stop must not have the same \'ordinal_index\' as any other Stop associated with that Shipment.
     * @summary Create a new Stop
     * @param {string} shipmentId The id of the shipment
     * @param {Stop} stop
     * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdStopsPost = function (shipmentId, stop, xCompanyId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdStopsPost(shipmentId, stop, xCompanyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a list of StopAlerts for a given Stop
     * @param {string} shipmentId The id of the shipment
     * @param {string} stopId The id of the stop
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdStopsStopIdAlertsGet = function (shipmentId, stopId, page, pageSize, ordering, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdStopsStopIdAlertsGet(shipmentId, stopId, page, pageSize, ordering, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new StopAlert
     * @param {string} shipmentId The id of the shipment
     * @param {string} stopId The id of the stop
     * @param {StopAlert} stopAlert
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdStopsStopIdAlertsPost = function (shipmentId, stopId, stopAlert, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdStopsStopIdAlertsPost(shipmentId, stopId, stopAlert, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a StopAlert
     * @param {string} shipmentId The id of the shipment
     * @param {string} stopId The id of the stop
     * @param {string} stopAlertId The id of the stop alert
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdStopsStopIdAlertsStopAlertIdDelete = function (shipmentId, stopId, stopAlertId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdStopsStopIdAlertsStopAlertIdDelete(shipmentId, stopId, stopAlertId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a StopAlert
     * @param {string} shipmentId The id of the shipment
     * @param {string} stopId The id of the stop
     * @param {string} stopAlertId The id of the stop alert
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdStopsStopIdAlertsStopAlertIdGet = function (shipmentId, stopId, stopAlertId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdStopsStopIdAlertsStopAlertIdGet(shipmentId, stopId, stopAlertId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a StopAlert
     * @param {string} shipmentId The id of the shipment
     * @param {string} stopId The id of the stop
     * @param {string} stopAlertId The id of the stop alert
     * @param {StopAlert} stopAlert
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdStopsStopIdAlertsStopAlertIdPut = function (shipmentId, stopId, stopAlertId, stopAlert, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdStopsStopIdAlertsStopAlertIdPut(shipmentId, stopId, stopAlertId, stopAlert, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a Stop
     * @param {string} shipmentId The id of the shipment
     * @param {string} stopId The id of the stop
     * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdStopsStopIdDelete = function (shipmentId, stopId, xCompanyId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdStopsStopIdDelete(shipmentId, stopId, xCompanyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new stop-related shipment timeline event
     * @param {string} shipmentId The id of the shipment
     * @param {string} stopId The id of the stop
     * @param {StopEvent} stopEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdStopsStopIdEventsPost = function (shipmentId, stopId, stopEvent, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdStopsStopIdEventsPost(shipmentId, stopId, stopEvent, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about a Stop
     * @param {string} shipmentId The id of the shipment
     * @param {string} stopId The id of the stop
     * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdStopsStopIdGet = function (shipmentId, stopId, xCompanyId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdStopsStopIdGet(shipmentId, stopId, xCompanyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a Stop
     * @param {string} shipmentId The id of the shipment
     * @param {string} stopId The id of the stop
     * @param {Stop} stop
     * @param {string} [xCompanyId] allows request to retrieve information about the company given in the header instead of the company associated with the requesting user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdStopsStopIdPut = function (shipmentId, stopId, stop, xCompanyId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdStopsStopIdPut(shipmentId, stopId, stop, xCompanyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a list of ShipmentTimelineEvents for a given Shipment
     * @param {string} shipmentId The id of the shipment
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdTimelineEventsGet = function (shipmentId, page, pageSize, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdTimelineEventsGet(shipmentId, page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new ShipmentTimelineEvent
     * @param {string} shipmentId The id of the shipment
     * @param {CreateShipmentTimelineEvent} createShipmentTimelineEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdTimelineEventsPost = function (shipmentId, createShipmentTimelineEvent, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdTimelineEventsPost(shipmentId, createShipmentTimelineEvent, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a ShipmentTimelineEvent
     * @param {string} shipmentId The id of the shipment
     * @param {string} shipmentTimelineEventId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdDelete = function (shipmentId, shipmentTimelineEventId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdDelete(shipmentId, shipmentTimelineEventId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about a ShipmentTimelineEvent
     * @param {string} shipmentId The id of the shipment
     * @param {string} shipmentTimelineEventId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdGet = function (shipmentId, shipmentTimelineEventId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdGet(shipmentId, shipmentTimelineEventId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a ShipmentTimelineEvent
     * @param {string} shipmentId The id of the shipment
     * @param {string} shipmentTimelineEventId
     * @param {CreateShipmentTimelineEvent} createShipmentTimelineEvent
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdPut = function (shipmentId, shipmentTimelineEventId, createShipmentTimelineEvent, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdTimelineEventsShipmentTimelineEventIdPut(shipmentId, shipmentTimelineEventId, createShipmentTimelineEvent, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get locations for the shipment
     * @param {string} shipmentId The id of the shipment
     * @param {string} [beginDatetime] For requesting data starting at a given date
     * @param {string} [endDatetime] For requesting data ending at a given date
     * @param {string} [filterDistance] Applies a distance filter and only returns points greater than filter_distance km apart. To return all, set this to -1
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdTrackingGet = function (shipmentId, beginDatetime, endDatetime, filterDistance, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdTrackingGet(shipmentId, beginDatetime, endDatetime, filterDistance, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Manually update Shipment Location. Authenticated drivers can also use this route to update their location
     * @param {string} shipmentId The id of the shipment
     * @param {ELDLocationUpdateRequest} eLDLocationUpdateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsShipmentIdTrackingPost = function (shipmentId, eLDLocationUpdateRequest, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsShipmentIdTrackingPost(shipmentId, eLDLocationUpdateRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List of all stop event types supported by the API along with their categorial groupings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsStopEventTypesGet = function (options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsStopEventTypesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a list of all stop locations for shipments user is associated with
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [companyName] Return stop locations whose company_name is equivalent to this value
     * @param {string} [companyNameContains] Return stop locations with this value in the company_name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsStopLocationsGet = function (page, pageSize, companyName, companyNameContains, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsStopLocationsGet(page, pageSize, companyName, companyNameContains, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List all ShipmentTags for the authenticated company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsTagsGet = function (options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsTagsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a ShipmentTag for the authenticated company
     * @param {ShipmentTag} shipmentTag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsTagsPost = function (shipmentTag, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsTagsPost(shipmentTag, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a ShipmentTag
     * @param {string} shipmentTagId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsTagsShipmentTagIdDelete = function (shipmentTagId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsTagsShipmentTagIdDelete(shipmentTagId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a ShipmentTag by its id
     * @param {string} shipmentTagId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsTagsShipmentTagIdGet = function (shipmentTagId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsTagsShipmentTagIdGet(shipmentTagId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a ShipmentTag
     * @param {string} shipmentTagId
     * @param {ShipmentTag} shipmentTag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsTagsShipmentTagIdPut = function (shipmentTagId, shipmentTag, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsTagsShipmentTagIdPut(shipmentTagId, shipmentTag, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List all Shipment Templates for the authenticated company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsTemplatesGet = function (options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsTemplatesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a ShipmentTemplate for the authenticated company
     * @param {ShipmentTemplateRequest} shipmentTemplateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsTemplatesPost = function (shipmentTemplateRequest, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsTemplatesPost(shipmentTemplateRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a Shipment Template
     * @param {string} shipmentTemplateId The ID of the shipment template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsTemplatesShipmentTemplateIdDelete = function (shipmentTemplateId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsTemplatesShipmentTemplateIdDelete(shipmentTemplateId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a Shipment Template by its id
     * @param {string} shipmentTemplateId The ID of the shipment template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsTemplatesShipmentTemplateIdGet = function (shipmentTemplateId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsTemplatesShipmentTemplateIdGet(shipmentTemplateId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a Shipment Template
     * @param {string} shipmentTemplateId The ID of the shipment template
     * @param {ShipmentTemplateRequest} shipmentTemplateRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsTemplatesShipmentTemplateIdPut = function (shipmentTemplateId, shipmentTemplateRequest, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsTemplatesShipmentTemplateIdPut(shipmentTemplateId, shipmentTemplateRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List tendered shipments
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {boolean} [closedByCustomer] Restrict SpotNegotiations based on whether customer closed
     * @param {boolean} [closedByVendor] Restrict SpotNegotiations based on whether vendor closed
     * @param {string} [customerId] ID of customer company to which to restrict SpotNegotiations
     * @param {string} [customerNameContains] Partial name of customer company to which to restrict SpotNegotiations
     * @param {boolean} [involvedOnly] Restrict SpotNegotiations to those in which user is explicitly involved
     * @param {Array<string>} [involvedVendorUsers] Restrict SpotNegotiations to those with provided User IDs involved on the vendor side
     * @param {boolean} [isMostRecentWinner] Restrict SpotNegotiations to those that are or are not the most recent winner
     * @param {boolean} [isOpen] Restrict SpotNegotiations based on both sides agreeing the negotiation is open
     * @param {string} [shipment] Return SpotNegotiations where Shipment ID matches
     * @param {string} [shipmentBolNumber] Return SpotNegotiations where Shipment BOL number matches
     * @param {string} [shipmentBolNumberContains] Return SpotNegotiations where Shipment BOL number partially matches
     * @param {string} [shipmentCapacityProviderCustomerReferenceNumber] Return SpotNegotiations where Shipment capacity provider customer reference number matches
     * @param {string} [shipmentCapacityProviderCustomerReferenceNumberContains] Return SpotNegotiations where Shipment capacity provider customer reference number partially matches
     * @param {string} [shipmentCustomerReferenceNumber] Return SpotNegotiations where Shipment customer reference number matches
     * @param {string} [shipmentCustomerReferenceNumberContains] Return SpotNegotiations where Shipment customer reference number partially matches
     * @param {string} [shipmentDelayed] Return SpotNegotiations where Shipment delayed matches
     * @param {string} [shipmentDestinationContains] Return SpotNegotiations where Shipment destination partially matches
     * @param {string} [shipmentDropoffGte] Return SpotNegotiations with a dropoff stop with a planned date greater than or equal to this value
     * @param {string} [shipmentDropoffLte] Return SpotNegotiations with a dropoff stop with a planned data less than or equal to this value
     * @param {string} [shipmentName] Return SpotNegotiations where Shipment name matches
     * @param {string} [shipmentNameContains] Return SpotNegotiations where Shipment name partially matches
     * @param {string} [shipmentOriginContains] Return SpotNegotiations where Shipment origin partially matches
     * @param {string} [shipmentPickupGte] Return SpotNegotiations with a pickup stop with a planned date greater than or equal to this value
     * @param {string} [shipmentPickupLte] Return SpotNegotiations with a pickup stop with a planned date less than or equal to this value
     * @param {string} [shipmentPickupNumber] Return SpotNegotiations where Shipment pickup number matches
     * @param {string} [shipmentPickupNumberContains] Return SpotNegotiations where Shipment pickup number partially matches
     * @param {string} [shipmentProNumber] Return SpotNegotiations where Shipment PRO number matches
     * @param {string} [shipmentProNumberContains] Return SpotNegotiations where Shipment PRO number partially matches
     * @param {string} [shipmentPurchaseOrderNumber] Return SpotNegotiations where Shipment purchase order number matches
     * @param {string} [shipmentPurchaseOrderNumberContains] Return SpotNegotiations where Shipment purchase order number partially matches
     * @param {string} [shipmentReferenceId] Return SpotNegotiations where Shipment reference_id matches
     * @param {string} [shipmentReferenceIdContains] Return SpotNegotiations where Shipment reference_id partially matches
     * @param {string} [shipmentState] Return SpotNegotiations where Shipment state matches
     * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [shipmentStatus] Return SpotNegotiations with shipments that have provided statuses
     * @param {string} [vendorId] ID of the vendor company to which to restrict SpotNegotiations
     * @param {string} [vendorNameContains] Partial name of the vendor company to which to restrict SpotNegotiations
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsTenderGet = function (page, pageSize, ordering, q, closedByCustomer, closedByVendor, customerId, customerNameContains, involvedOnly, involvedVendorUsers, isMostRecentWinner, isOpen, shipment, shipmentBolNumber, shipmentBolNumberContains, shipmentCapacityProviderCustomerReferenceNumber, shipmentCapacityProviderCustomerReferenceNumberContains, shipmentCustomerReferenceNumber, shipmentCustomerReferenceNumberContains, shipmentDelayed, shipmentDestinationContains, shipmentDropoffGte, shipmentDropoffLte, shipmentName, shipmentNameContains, shipmentOriginContains, shipmentPickupGte, shipmentPickupLte, shipmentPickupNumber, shipmentPickupNumberContains, shipmentProNumber, shipmentProNumberContains, shipmentPurchaseOrderNumber, shipmentPurchaseOrderNumberContains, shipmentReferenceId, shipmentReferenceIdContains, shipmentState, shipmentStatus, vendorId, vendorNameContains, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsTenderGet(page, pageSize, ordering, q, closedByCustomer, closedByVendor, customerId, customerNameContains, involvedOnly, involvedVendorUsers, isMostRecentWinner, isOpen, shipment, shipmentBolNumber, shipmentBolNumberContains, shipmentCapacityProviderCustomerReferenceNumber, shipmentCapacityProviderCustomerReferenceNumberContains, shipmentCustomerReferenceNumber, shipmentCustomerReferenceNumberContains, shipmentDelayed, shipmentDestinationContains, shipmentDropoffGte, shipmentDropoffLte, shipmentName, shipmentNameContains, shipmentOriginContains, shipmentPickupGte, shipmentPickupLte, shipmentPickupNumber, shipmentPickupNumberContains, shipmentProNumber, shipmentProNumberContains, shipmentPurchaseOrderNumber, shipmentPurchaseOrderNumberContains, shipmentReferenceId, shipmentReferenceIdContains, shipmentState, shipmentStatus, vendorId, vendorNameContains, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create and tender a shipment to a Shipwell company
     * @param {TenderRequest} tenderRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsTenderPost = function (tenderRequest, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsTenderPost(tenderRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Accept or reject tendered shipments.
     * @param {string} tenderId
     * @param {TenderAcceptReject} tenderAcceptReject
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsTenderTenderIdActionsPost = function (tenderId, tenderAcceptReject, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsTenderTenderIdActionsPost(tenderId, tenderAcceptReject, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Mark a tendered shipment as no longer available. Renders as \'closed\' in our system.
     * @param {string} tenderId
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsTenderTenderIdDelete = function (tenderId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsTenderTenderIdDelete(tenderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update tendered shipment events
     * @param {string} tenderId
     * @param {TenderEventRequest} tenderEventRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsTenderTenderIdEventsPost = function (tenderId, tenderEventRequest, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsTenderTenderIdEventsPost(tenderId, tenderEventRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a tendered shipment to a shipwell company NOTE: Only valid for shipments created by posting to this endpoint. Shipments created via other methods are not guaranteed to work and may have unintended side effects.
     * @param {string} tenderId
     * @param {TenderRequest} tenderRequest
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsTenderTenderIdPut = function (tenderId, tenderRequest, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsTenderTenderIdPut(tenderId, tenderRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List tendered shipments
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {string} [createdByCompanyId] Restrict Tenders by created by customer ID
     * @param {string} [shipmentCustomerReferenceNumber] Restrict Tenders by custoemr shipment reference number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsTendersGet = function (page, pageSize, ordering, q, createdByCompanyId, shipmentCustomerReferenceNumber, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsTendersGet(page, pageSize, ordering, q, createdByCompanyId, shipmentCustomerReferenceNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create and tender a shipment to a Shipwell company
     * @param {TenderRequest} tenderRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsTendersPost = function (tenderRequest, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsTendersPost(tenderRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Accept or reject tendered shipments.
     * @param {string} tenderId
     * @param {TenderAcceptReject} tenderAcceptReject
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsTendersTenderIdActionsPost = function (tenderId, tenderAcceptReject, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsTendersTenderIdActionsPost(tenderId, tenderAcceptReject, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Mark a tendered shipment as no longer available. Renders as \'closed\' in the Shipwell platform.
     * @param {string} tenderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsTendersTenderIdDelete = function (tenderId, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsTendersTenderIdDelete(tenderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update tendered Shipment events.
     * @param {string} tenderId
     * @param {TenderEventRequest} tenderEventRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsTendersTenderIdEventsPost = function (tenderId, tenderEventRequest, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsTendersTenderIdEventsPost(tenderId, tenderEventRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a tendered shipment to a shipwell company NOTE: Only valid for shipments created by posting to this endpoint. Shipments created via other methods are not guaranteed to work and may have unintended side effects.
     * @param {string} tenderId
     * @param {TenderRequest} tenderRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipmentsApi
     */
    ShipmentsApi.prototype.shipmentsTendersTenderIdPut = function (tenderId, tenderRequest, options) {
        var _this = this;
        return (0, exports.ShipmentsApiFp)(this.configuration).shipmentsTendersTenderIdPut(tenderId, tenderRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ShipmentsApi;
}(base_1.BaseAPI));
exports.ShipmentsApi = ShipmentsApi;
/**
 * ShipperCarrierRelationshipsApi - axios parameter creator
 * @export
 */
var ShipperCarrierRelationshipsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Returns a list of carrier relationships for a given shipper to brokerage relationship
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdCarriersGet: function (brokerageId, shipperRelationshipId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'brokerageId' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdCarriersGet', 'brokerageId', brokerageId);
                            // verify required parameter 'shipperRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdCarriersGet', 'shipperRelationshipId', shipperRelationshipId);
                            localVarPath = "/brokerages/{brokerageId}/shipper-relationships/{shipperRelationshipId}/carriers/"
                                .replace("{".concat("brokerageId", "}"), encodeURIComponent(String(brokerageId)))
                                .replace("{".concat("shipperRelationshipId", "}"), encodeURIComponent(String(shipperRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates any modified carrier relationships
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {Array<CarrierSpecificShipperRelationship>} carrierSpecificShipperRelationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdCarriersPut: function (brokerageId, shipperRelationshipId, carrierSpecificShipperRelationship, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'brokerageId' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdCarriersPut', 'brokerageId', brokerageId);
                            // verify required parameter 'shipperRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdCarriersPut', 'shipperRelationshipId', shipperRelationshipId);
                            // verify required parameter 'carrierSpecificShipperRelationship' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdCarriersPut', 'carrierSpecificShipperRelationship', carrierSpecificShipperRelationship);
                            localVarPath = "/brokerages/{brokerageId}/shipper-relationships/{shipperRelationshipId}/carriers/"
                                .replace("{".concat("brokerageId", "}"), encodeURIComponent(String(brokerageId)))
                                .replace("{".concat("shipperRelationshipId", "}"), encodeURIComponent(String(shipperRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(carrierSpecificShipperRelationship, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ShipperCarrierRelationshipsApiAxiosParamCreator = ShipperCarrierRelationshipsApiAxiosParamCreator;
/**
 * ShipperCarrierRelationshipsApi - functional programming interface
 * @export
 */
var ShipperCarrierRelationshipsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ShipperCarrierRelationshipsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Returns a list of carrier relationships for a given shipper to brokerage relationship
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdCarriersGet: function (brokerageId, shipperRelationshipId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdCarriersGet(brokerageId, shipperRelationshipId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates any modified carrier relationships
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {Array<CarrierSpecificShipperRelationship>} carrierSpecificShipperRelationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdCarriersPut: function (brokerageId, shipperRelationshipId, carrierSpecificShipperRelationship, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdCarriersPut(brokerageId, shipperRelationshipId, carrierSpecificShipperRelationship, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ShipperCarrierRelationshipsApiFp = ShipperCarrierRelationshipsApiFp;
/**
 * ShipperCarrierRelationshipsApi - factory interface
 * @export
 */
var ShipperCarrierRelationshipsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ShipperCarrierRelationshipsApiFp)(configuration);
    return {
        /**
         *
         * @summary Returns a list of carrier relationships for a given shipper to brokerage relationship
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdCarriersGet: function (brokerageId, shipperRelationshipId, options) {
            return localVarFp.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdCarriersGet(brokerageId, shipperRelationshipId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates any modified carrier relationships
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {Array<CarrierSpecificShipperRelationship>} carrierSpecificShipperRelationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdCarriersPut: function (brokerageId, shipperRelationshipId, carrierSpecificShipperRelationship, options) {
            return localVarFp.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdCarriersPut(brokerageId, shipperRelationshipId, carrierSpecificShipperRelationship, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ShipperCarrierRelationshipsApiFactory = ShipperCarrierRelationshipsApiFactory;
/**
 * ShipperCarrierRelationshipsApi - object-oriented interface
 * @export
 * @class ShipperCarrierRelationshipsApi
 * @extends {BaseAPI}
 */
var ShipperCarrierRelationshipsApi = /** @class */ (function (_super) {
    __extends(ShipperCarrierRelationshipsApi, _super);
    function ShipperCarrierRelationshipsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Returns a list of carrier relationships for a given shipper to brokerage relationship
     * @param {string} brokerageId The id of the brokerage
     * @param {string} shipperRelationshipId The id of the shipper relationship
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipperCarrierRelationshipsApi
     */
    ShipperCarrierRelationshipsApi.prototype.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdCarriersGet = function (brokerageId, shipperRelationshipId, options) {
        var _this = this;
        return (0, exports.ShipperCarrierRelationshipsApiFp)(this.configuration).brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdCarriersGet(brokerageId, shipperRelationshipId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates any modified carrier relationships
     * @param {string} brokerageId The id of the brokerage
     * @param {string} shipperRelationshipId The id of the shipper relationship
     * @param {Array<CarrierSpecificShipperRelationship>} carrierSpecificShipperRelationship
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipperCarrierRelationshipsApi
     */
    ShipperCarrierRelationshipsApi.prototype.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdCarriersPut = function (brokerageId, shipperRelationshipId, carrierSpecificShipperRelationship, options) {
        var _this = this;
        return (0, exports.ShipperCarrierRelationshipsApiFp)(this.configuration).brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdCarriersPut(brokerageId, shipperRelationshipId, carrierSpecificShipperRelationship, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ShipperCarrierRelationshipsApi;
}(base_1.BaseAPI));
exports.ShipperCarrierRelationshipsApi = ShipperCarrierRelationshipsApi;
/**
 * ShipperRelationshipApi - axios parameter creator
 * @export
 */
var ShipperRelationshipApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Returns a list of a brokerage shipper relationships
         * @param {string} brokerageId The id of the brokerage
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [accountsRepsContains] Return RateShareConfigs where once of the account reps names contains this string
         * @param {Array<string>} [accountRepsIds] Return RateShareConfigs where these user IDs are listed as account reps
         * @param {string} [salesRepsContains] Return RateShareConfigs where once of the sales reps names contains this string
         * @param {Array<string>} [salesRepsIds] Return RateShareConfigs where these user IDs are listed as sales repss
         * @param {string} [companyContains] Return objects where the company name contains this string
         * @param {string} [primaryEmailContains] Return objects where the company primary email contains this string
         * @param {string} [primaryPhoneNumberContains] Return objects where the company primary phone number contains this string
         * @param {string} [customerId] Return shipments with this exact id for the customer company
         * @param {boolean} [expandUsers] If True, render slim users on a CompanyWithOptionalUsers object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsGet: function (brokerageId, page, pageSize, ordering, q, accountsRepsContains, accountRepsIds, salesRepsContains, salesRepsIds, companyContains, primaryEmailContains, primaryPhoneNumberContains, customerId, expandUsers, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'brokerageId' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsGet', 'brokerageId', brokerageId);
                            localVarPath = "/brokerages/{brokerageId}/shipper-relationships/"
                                .replace("{".concat("brokerageId", "}"), encodeURIComponent(String(brokerageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (accountsRepsContains !== undefined) {
                                localVarQueryParameter['accounts_reps__contains'] = accountsRepsContains;
                            }
                            if (accountRepsIds) {
                                localVarQueryParameter['account_reps_ids'] = accountRepsIds;
                            }
                            if (salesRepsContains !== undefined) {
                                localVarQueryParameter['sales_reps__contains'] = salesRepsContains;
                            }
                            if (salesRepsIds) {
                                localVarQueryParameter['sales_reps_ids'] = salesRepsIds;
                            }
                            if (companyContains !== undefined) {
                                localVarQueryParameter['company__contains'] = companyContains;
                            }
                            if (primaryEmailContains !== undefined) {
                                localVarQueryParameter['primary_email__contains'] = primaryEmailContains;
                            }
                            if (primaryPhoneNumberContains !== undefined) {
                                localVarQueryParameter['primary_phone_number__contains'] = primaryPhoneNumberContains;
                            }
                            if (customerId !== undefined) {
                                localVarQueryParameter['customer_id'] = customerId;
                            }
                            if (expandUsers !== undefined) {
                                localVarQueryParameter['expand_users'] = expandUsers;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information exceptions to brokers default mileage preferance
         * @param {string} brokerageId The id of the brokerage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsMileageExceptionsGet: function (brokerageId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'brokerageId' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsMileageExceptionsGet', 'brokerageId', brokerageId);
                            localVarPath = "/brokerages/{brokerageId}/shipper-relationships/mileage-exceptions"
                                .replace("{".concat("brokerageId", "}"), encodeURIComponent(String(brokerageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new shipper along with a relationship to the authenticated broker
         * @param {string} brokerageId The id of the brokerage
         * @param {CreateShipperRelationship} createShipperRelationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsPost: function (brokerageId, createShipperRelationship, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'brokerageId' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsPost', 'brokerageId', brokerageId);
                            // verify required parameter 'createShipperRelationship' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsPost', 'createShipperRelationship', createShipperRelationship);
                            localVarPath = "/brokerages/{brokerageId}/shipper-relationships/"
                                .replace("{".concat("brokerageId", "}"), encodeURIComponent(String(brokerageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createShipperRelationship, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a shipper relationship
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDelete: function (brokerageId, shipperRelationshipId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'brokerageId' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDelete', 'brokerageId', brokerageId);
                            // verify required parameter 'shipperRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDelete', 'shipperRelationshipId', shipperRelationshipId);
                            localVarPath = "/brokerages/{brokerageId}/shipper-relationships/{shipperRelationshipId}/"
                                .replace("{".concat("brokerageId", "}"), encodeURIComponent(String(brokerageId)))
                                .replace("{".concat("shipperRelationshipId", "}"), encodeURIComponent(String(shipperRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a Document
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {string} documentId The id of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdDelete: function (brokerageId, shipperRelationshipId, documentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'brokerageId' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdDelete', 'brokerageId', brokerageId);
                            // verify required parameter 'shipperRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdDelete', 'shipperRelationshipId', shipperRelationshipId);
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdDelete', 'documentId', documentId);
                            localVarPath = "/brokerages/{brokerageId}/shipper-relationships/{shipperRelationshipId}/documents/{documentId}/"
                                .replace("{".concat("brokerageId", "}"), encodeURIComponent(String(brokerageId)))
                                .replace("{".concat("shipperRelationshipId", "}"), encodeURIComponent(String(shipperRelationshipId)))
                                .replace("{".concat("documentId", "}"), encodeURIComponent(String(documentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get metadata about a document
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {string} documentId The id of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdGet: function (brokerageId, shipperRelationshipId, documentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'brokerageId' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdGet', 'brokerageId', brokerageId);
                            // verify required parameter 'shipperRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdGet', 'shipperRelationshipId', shipperRelationshipId);
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdGet', 'documentId', documentId);
                            localVarPath = "/brokerages/{brokerageId}/shipper-relationships/{shipperRelationshipId}/documents/{documentId}/"
                                .replace("{".concat("brokerageId", "}"), encodeURIComponent(String(brokerageId)))
                                .replace("{".concat("shipperRelationshipId", "}"), encodeURIComponent(String(shipperRelationshipId)))
                                .replace("{".concat("documentId", "}"), encodeURIComponent(String(documentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update metadata about a document
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {string} documentId The id of the document
         * @param {ShipmentDocumentMetadata} shipmentDocumentMetadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdPut: function (brokerageId, shipperRelationshipId, documentId, shipmentDocumentMetadata, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'brokerageId' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdPut', 'brokerageId', brokerageId);
                            // verify required parameter 'shipperRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdPut', 'shipperRelationshipId', shipperRelationshipId);
                            // verify required parameter 'documentId' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdPut', 'documentId', documentId);
                            // verify required parameter 'shipmentDocumentMetadata' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdPut', 'shipmentDocumentMetadata', shipmentDocumentMetadata);
                            localVarPath = "/brokerages/{brokerageId}/shipper-relationships/{shipperRelationshipId}/documents/{documentId}/"
                                .replace("{".concat("brokerageId", "}"), encodeURIComponent(String(brokerageId)))
                                .replace("{".concat("shipperRelationshipId", "}"), encodeURIComponent(String(shipperRelationshipId)))
                                .replace("{".concat("documentId", "}"), encodeURIComponent(String(documentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shipmentDocumentMetadata, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get metadata about documents on a shipper relationship
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsGet: function (brokerageId, shipperRelationshipId, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'brokerageId' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsGet', 'brokerageId', brokerageId);
                            // verify required parameter 'shipperRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsGet', 'shipperRelationshipId', shipperRelationshipId);
                            localVarPath = "/brokerages/{brokerageId}/shipper-relationships/{shipperRelationshipId}/documents/"
                                .replace("{".concat("brokerageId", "}"), encodeURIComponent(String(brokerageId)))
                                .replace("{".concat("shipperRelationshipId", "}"), encodeURIComponent(String(shipperRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a document on a shipment
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {PostBrokeragesBrokerageidShipperRelationshipsShipperrelationshipidDocuments} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsPost: function (brokerageId, shipperRelationshipId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'brokerageId' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsPost', 'brokerageId', brokerageId);
                            // verify required parameter 'shipperRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsPost', 'shipperRelationshipId', shipperRelationshipId);
                            localVarPath = "/brokerages/{brokerageId}/shipper-relationships/{shipperRelationshipId}/documents/"
                                .replace("{".concat("brokerageId", "}"), encodeURIComponent(String(brokerageId)))
                                .replace("{".concat("shipperRelationshipId", "}"), encodeURIComponent(String(shipperRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a shipper relationship
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdGet: function (brokerageId, shipperRelationshipId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'brokerageId' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdGet', 'brokerageId', brokerageId);
                            // verify required parameter 'shipperRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdGet', 'shipperRelationshipId', shipperRelationshipId);
                            localVarPath = "/brokerages/{brokerageId}/shipper-relationships/{shipperRelationshipId}/"
                                .replace("{".concat("brokerageId", "}"), encodeURIComponent(String(brokerageId)))
                                .replace("{".concat("shipperRelationshipId", "}"), encodeURIComponent(String(shipperRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a shipper relationship
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {ShipperRelationship} shipperRelationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdPut: function (brokerageId, shipperRelationshipId, shipperRelationship, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'brokerageId' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdPut', 'brokerageId', brokerageId);
                            // verify required parameter 'shipperRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdPut', 'shipperRelationshipId', shipperRelationshipId);
                            // verify required parameter 'shipperRelationship' is not null or undefined
                            (0, common_1.assertParamExists)('brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdPut', 'shipperRelationship', shipperRelationship);
                            localVarPath = "/brokerages/{brokerageId}/shipper-relationships/{shipperRelationshipId}/"
                                .replace("{".concat("brokerageId", "}"), encodeURIComponent(String(brokerageId)))
                                .replace("{".concat("shipperRelationshipId", "}"), encodeURIComponent(String(shipperRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shipperRelationship, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ShipperRelationshipApiAxiosParamCreator = ShipperRelationshipApiAxiosParamCreator;
/**
 * ShipperRelationshipApi - functional programming interface
 * @export
 */
var ShipperRelationshipApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ShipperRelationshipApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Returns a list of a brokerage shipper relationships
         * @param {string} brokerageId The id of the brokerage
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [accountsRepsContains] Return RateShareConfigs where once of the account reps names contains this string
         * @param {Array<string>} [accountRepsIds] Return RateShareConfigs where these user IDs are listed as account reps
         * @param {string} [salesRepsContains] Return RateShareConfigs where once of the sales reps names contains this string
         * @param {Array<string>} [salesRepsIds] Return RateShareConfigs where these user IDs are listed as sales repss
         * @param {string} [companyContains] Return objects where the company name contains this string
         * @param {string} [primaryEmailContains] Return objects where the company primary email contains this string
         * @param {string} [primaryPhoneNumberContains] Return objects where the company primary phone number contains this string
         * @param {string} [customerId] Return shipments with this exact id for the customer company
         * @param {boolean} [expandUsers] If True, render slim users on a CompanyWithOptionalUsers object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsGet: function (brokerageId, page, pageSize, ordering, q, accountsRepsContains, accountRepsIds, salesRepsContains, salesRepsIds, companyContains, primaryEmailContains, primaryPhoneNumberContains, customerId, expandUsers, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.brokeragesBrokerageIdShipperRelationshipsGet(brokerageId, page, pageSize, ordering, q, accountsRepsContains, accountRepsIds, salesRepsContains, salesRepsIds, companyContains, primaryEmailContains, primaryPhoneNumberContains, customerId, expandUsers, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information exceptions to brokers default mileage preferance
         * @param {string} brokerageId The id of the brokerage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsMileageExceptionsGet: function (brokerageId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.brokeragesBrokerageIdShipperRelationshipsMileageExceptionsGet(brokerageId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new shipper along with a relationship to the authenticated broker
         * @param {string} brokerageId The id of the brokerage
         * @param {CreateShipperRelationship} createShipperRelationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsPost: function (brokerageId, createShipperRelationship, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.brokeragesBrokerageIdShipperRelationshipsPost(brokerageId, createShipperRelationship, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a shipper relationship
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDelete: function (brokerageId, shipperRelationshipId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDelete(brokerageId, shipperRelationshipId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a Document
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {string} documentId The id of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdDelete: function (brokerageId, shipperRelationshipId, documentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdDelete(brokerageId, shipperRelationshipId, documentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get metadata about a document
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {string} documentId The id of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdGet: function (brokerageId, shipperRelationshipId, documentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdGet(brokerageId, shipperRelationshipId, documentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update metadata about a document
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {string} documentId The id of the document
         * @param {ShipmentDocumentMetadata} shipmentDocumentMetadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdPut: function (brokerageId, shipperRelationshipId, documentId, shipmentDocumentMetadata, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdPut(brokerageId, shipperRelationshipId, documentId, shipmentDocumentMetadata, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get metadata about documents on a shipper relationship
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsGet: function (brokerageId, shipperRelationshipId, page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsGet(brokerageId, shipperRelationshipId, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a document on a shipment
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {PostBrokeragesBrokerageidShipperRelationshipsShipperrelationshipidDocuments} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsPost: function (brokerageId, shipperRelationshipId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsPost(brokerageId, shipperRelationshipId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a shipper relationship
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdGet: function (brokerageId, shipperRelationshipId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdGet(brokerageId, shipperRelationshipId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a shipper relationship
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {ShipperRelationship} shipperRelationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdPut: function (brokerageId, shipperRelationshipId, shipperRelationship, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdPut(brokerageId, shipperRelationshipId, shipperRelationship, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ShipperRelationshipApiFp = ShipperRelationshipApiFp;
/**
 * ShipperRelationshipApi - factory interface
 * @export
 */
var ShipperRelationshipApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ShipperRelationshipApiFp)(configuration);
    return {
        /**
         *
         * @summary Returns a list of a brokerage shipper relationships
         * @param {string} brokerageId The id of the brokerage
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [accountsRepsContains] Return RateShareConfigs where once of the account reps names contains this string
         * @param {Array<string>} [accountRepsIds] Return RateShareConfigs where these user IDs are listed as account reps
         * @param {string} [salesRepsContains] Return RateShareConfigs where once of the sales reps names contains this string
         * @param {Array<string>} [salesRepsIds] Return RateShareConfigs where these user IDs are listed as sales repss
         * @param {string} [companyContains] Return objects where the company name contains this string
         * @param {string} [primaryEmailContains] Return objects where the company primary email contains this string
         * @param {string} [primaryPhoneNumberContains] Return objects where the company primary phone number contains this string
         * @param {string} [customerId] Return shipments with this exact id for the customer company
         * @param {boolean} [expandUsers] If True, render slim users on a CompanyWithOptionalUsers object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsGet: function (brokerageId, page, pageSize, ordering, q, accountsRepsContains, accountRepsIds, salesRepsContains, salesRepsIds, companyContains, primaryEmailContains, primaryPhoneNumberContains, customerId, expandUsers, options) {
            return localVarFp.brokeragesBrokerageIdShipperRelationshipsGet(brokerageId, page, pageSize, ordering, q, accountsRepsContains, accountRepsIds, salesRepsContains, salesRepsIds, companyContains, primaryEmailContains, primaryPhoneNumberContains, customerId, expandUsers, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information exceptions to brokers default mileage preferance
         * @param {string} brokerageId The id of the brokerage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsMileageExceptionsGet: function (brokerageId, options) {
            return localVarFp.brokeragesBrokerageIdShipperRelationshipsMileageExceptionsGet(brokerageId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a new shipper along with a relationship to the authenticated broker
         * @param {string} brokerageId The id of the brokerage
         * @param {CreateShipperRelationship} createShipperRelationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsPost: function (brokerageId, createShipperRelationship, options) {
            return localVarFp.brokeragesBrokerageIdShipperRelationshipsPost(brokerageId, createShipperRelationship, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a shipper relationship
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDelete: function (brokerageId, shipperRelationshipId, options) {
            return localVarFp.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDelete(brokerageId, shipperRelationshipId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a Document
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {string} documentId The id of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdDelete: function (brokerageId, shipperRelationshipId, documentId, options) {
            return localVarFp.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdDelete(brokerageId, shipperRelationshipId, documentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get metadata about a document
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {string} documentId The id of the document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdGet: function (brokerageId, shipperRelationshipId, documentId, options) {
            return localVarFp.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdGet(brokerageId, shipperRelationshipId, documentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update metadata about a document
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {string} documentId The id of the document
         * @param {ShipmentDocumentMetadata} shipmentDocumentMetadata
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdPut: function (brokerageId, shipperRelationshipId, documentId, shipmentDocumentMetadata, options) {
            return localVarFp.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdPut(brokerageId, shipperRelationshipId, documentId, shipmentDocumentMetadata, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get metadata about documents on a shipper relationship
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsGet: function (brokerageId, shipperRelationshipId, page, pageSize, options) {
            return localVarFp.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsGet(brokerageId, shipperRelationshipId, page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a document on a shipment
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {PostBrokeragesBrokerageidShipperRelationshipsShipperrelationshipidDocuments} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsPost: function (brokerageId, shipperRelationshipId, body, options) {
            return localVarFp.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsPost(brokerageId, shipperRelationshipId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about a shipper relationship
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdGet: function (brokerageId, shipperRelationshipId, options) {
            return localVarFp.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdGet(brokerageId, shipperRelationshipId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a shipper relationship
         * @param {string} brokerageId The id of the brokerage
         * @param {string} shipperRelationshipId The id of the shipper relationship
         * @param {ShipperRelationship} shipperRelationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdPut: function (brokerageId, shipperRelationshipId, shipperRelationship, options) {
            return localVarFp.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdPut(brokerageId, shipperRelationshipId, shipperRelationship, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ShipperRelationshipApiFactory = ShipperRelationshipApiFactory;
/**
 * ShipperRelationshipApi - object-oriented interface
 * @export
 * @class ShipperRelationshipApi
 * @extends {BaseAPI}
 */
var ShipperRelationshipApi = /** @class */ (function (_super) {
    __extends(ShipperRelationshipApi, _super);
    function ShipperRelationshipApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Returns a list of a brokerage shipper relationships
     * @param {string} brokerageId The id of the brokerage
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {string} [accountsRepsContains] Return RateShareConfigs where once of the account reps names contains this string
     * @param {Array<string>} [accountRepsIds] Return RateShareConfigs where these user IDs are listed as account reps
     * @param {string} [salesRepsContains] Return RateShareConfigs where once of the sales reps names contains this string
     * @param {Array<string>} [salesRepsIds] Return RateShareConfigs where these user IDs are listed as sales repss
     * @param {string} [companyContains] Return objects where the company name contains this string
     * @param {string} [primaryEmailContains] Return objects where the company primary email contains this string
     * @param {string} [primaryPhoneNumberContains] Return objects where the company primary phone number contains this string
     * @param {string} [customerId] Return shipments with this exact id for the customer company
     * @param {boolean} [expandUsers] If True, render slim users on a CompanyWithOptionalUsers object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipperRelationshipApi
     */
    ShipperRelationshipApi.prototype.brokeragesBrokerageIdShipperRelationshipsGet = function (brokerageId, page, pageSize, ordering, q, accountsRepsContains, accountRepsIds, salesRepsContains, salesRepsIds, companyContains, primaryEmailContains, primaryPhoneNumberContains, customerId, expandUsers, options) {
        var _this = this;
        return (0, exports.ShipperRelationshipApiFp)(this.configuration).brokeragesBrokerageIdShipperRelationshipsGet(brokerageId, page, pageSize, ordering, q, accountsRepsContains, accountRepsIds, salesRepsContains, salesRepsIds, companyContains, primaryEmailContains, primaryPhoneNumberContains, customerId, expandUsers, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information exceptions to brokers default mileage preferance
     * @param {string} brokerageId The id of the brokerage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipperRelationshipApi
     */
    ShipperRelationshipApi.prototype.brokeragesBrokerageIdShipperRelationshipsMileageExceptionsGet = function (brokerageId, options) {
        var _this = this;
        return (0, exports.ShipperRelationshipApiFp)(this.configuration).brokeragesBrokerageIdShipperRelationshipsMileageExceptionsGet(brokerageId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a new shipper along with a relationship to the authenticated broker
     * @param {string} brokerageId The id of the brokerage
     * @param {CreateShipperRelationship} createShipperRelationship
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipperRelationshipApi
     */
    ShipperRelationshipApi.prototype.brokeragesBrokerageIdShipperRelationshipsPost = function (brokerageId, createShipperRelationship, options) {
        var _this = this;
        return (0, exports.ShipperRelationshipApiFp)(this.configuration).brokeragesBrokerageIdShipperRelationshipsPost(brokerageId, createShipperRelationship, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a shipper relationship
     * @param {string} brokerageId The id of the brokerage
     * @param {string} shipperRelationshipId The id of the shipper relationship
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipperRelationshipApi
     */
    ShipperRelationshipApi.prototype.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDelete = function (brokerageId, shipperRelationshipId, options) {
        var _this = this;
        return (0, exports.ShipperRelationshipApiFp)(this.configuration).brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDelete(brokerageId, shipperRelationshipId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a Document
     * @param {string} brokerageId The id of the brokerage
     * @param {string} shipperRelationshipId The id of the shipper relationship
     * @param {string} documentId The id of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipperRelationshipApi
     */
    ShipperRelationshipApi.prototype.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdDelete = function (brokerageId, shipperRelationshipId, documentId, options) {
        var _this = this;
        return (0, exports.ShipperRelationshipApiFp)(this.configuration).brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdDelete(brokerageId, shipperRelationshipId, documentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get metadata about a document
     * @param {string} brokerageId The id of the brokerage
     * @param {string} shipperRelationshipId The id of the shipper relationship
     * @param {string} documentId The id of the document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipperRelationshipApi
     */
    ShipperRelationshipApi.prototype.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdGet = function (brokerageId, shipperRelationshipId, documentId, options) {
        var _this = this;
        return (0, exports.ShipperRelationshipApiFp)(this.configuration).brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdGet(brokerageId, shipperRelationshipId, documentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update metadata about a document
     * @param {string} brokerageId The id of the brokerage
     * @param {string} shipperRelationshipId The id of the shipper relationship
     * @param {string} documentId The id of the document
     * @param {ShipmentDocumentMetadata} shipmentDocumentMetadata
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipperRelationshipApi
     */
    ShipperRelationshipApi.prototype.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdPut = function (brokerageId, shipperRelationshipId, documentId, shipmentDocumentMetadata, options) {
        var _this = this;
        return (0, exports.ShipperRelationshipApiFp)(this.configuration).brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsDocumentIdPut(brokerageId, shipperRelationshipId, documentId, shipmentDocumentMetadata, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get metadata about documents on a shipper relationship
     * @param {string} brokerageId The id of the brokerage
     * @param {string} shipperRelationshipId The id of the shipper relationship
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipperRelationshipApi
     */
    ShipperRelationshipApi.prototype.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsGet = function (brokerageId, shipperRelationshipId, page, pageSize, options) {
        var _this = this;
        return (0, exports.ShipperRelationshipApiFp)(this.configuration).brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsGet(brokerageId, shipperRelationshipId, page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a document on a shipment
     * @param {string} brokerageId The id of the brokerage
     * @param {string} shipperRelationshipId The id of the shipper relationship
     * @param {PostBrokeragesBrokerageidShipperRelationshipsShipperrelationshipidDocuments} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipperRelationshipApi
     */
    ShipperRelationshipApi.prototype.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsPost = function (brokerageId, shipperRelationshipId, body, options) {
        var _this = this;
        return (0, exports.ShipperRelationshipApiFp)(this.configuration).brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdDocumentsPost(brokerageId, shipperRelationshipId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about a shipper relationship
     * @param {string} brokerageId The id of the brokerage
     * @param {string} shipperRelationshipId The id of the shipper relationship
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipperRelationshipApi
     */
    ShipperRelationshipApi.prototype.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdGet = function (brokerageId, shipperRelationshipId, options) {
        var _this = this;
        return (0, exports.ShipperRelationshipApiFp)(this.configuration).brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdGet(brokerageId, shipperRelationshipId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a shipper relationship
     * @param {string} brokerageId The id of the brokerage
     * @param {string} shipperRelationshipId The id of the shipper relationship
     * @param {ShipperRelationship} shipperRelationship
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipperRelationshipApi
     */
    ShipperRelationshipApi.prototype.brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdPut = function (brokerageId, shipperRelationshipId, shipperRelationship, options) {
        var _this = this;
        return (0, exports.ShipperRelationshipApiFp)(this.configuration).brokeragesBrokerageIdShipperRelationshipsShipperRelationshipIdPut(brokerageId, shipperRelationshipId, shipperRelationship, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ShipperRelationshipApi;
}(base_1.BaseAPI));
exports.ShipperRelationshipApi = ShipperRelationshipApi;
/**
 * ShippingDashboardApi - axios parameter creator
 * @export
 */
var ShippingDashboardApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get a list of V3 shipping dashboard rows (includes V2 Shipments, V3 Legs, and V3 Shipment Services)
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [activeVendorAssignment] Include or exclude shipments with active CarrierAssignments
         * @param {'MOBILE_DEVICE_ALERT' | 'NON_ACTIVE_CARRIER'} [alertTypes] Filter on shipments that have alerts of this type
         * @param {boolean} [alerts] Filter on whether or not a Shipment has alert messages
         * @param {boolean} [archived] Filter on whether or not a shipment is archived
         * @param {Array<string>} [bolNumber] Include shipments with these BOL Numbers
         * @param {string} [bolNumberContains] Return shipments where the BOL number contains this value
         * @param {Array<string>} [bolNumberExclude] Exclude shipments with these BOL Numbers
         * @param {string} [createdAt] For requesting data created at a certain datetime
         * @param {Array<'SHIPWELL_WEB' | 'IMPORT' | 'TENDER' | 'SHIPWELL_WEB_UNAUTH' | 'OTHER'>} [createdBySource] Return shipments created by sources in the array.
         * @param {string} [createdByUserContains] Return shipments where created_by_user object contains this string e.g first_name, last_name or email
         * @param {Array<string>} [createdByUserId] Return shipments where created_by_user_id in the array.
         * @param {string} [createdByUserName] Return shipments where created_by_user_name is exactly this string
         * @param {string} [createdByUserNameContains] Return shipments where created_by_user_name contains this string
         * @param {string} [customer] Return shipments with this exact value as the customer company name
         * @param {string} [customerContains] Return shipments where the customer company name contains this value
         * @param {string} [customerId] Return shipments with this exact id for the customer company
         * @param {Array<string>} [customerReferenceNumber] Include shipments with these Customer Reference Numbers
         * @param {string} [customerReferenceNumberContains] Include shipments where the Customer Reference Numbers contains this value
         * @param {Array<string>} [customerReferenceNumberExclude] Exclude shipments with these Customer Reference Numbers
         * @param {string} [destinationContains] Return shipments with this value in the destination
         * @param {string} [deliveryStopsContains] Return shipments with this value in one of its dropoff stops
         * @param {string} [deliveryStopsCompanyNameContains] Return shipments with this value in one of its delivery stops location company_name
         * @param {string} [destinationStateProvince] Return shipments with this state province on its destination stop
         * @param {string} [deliveryStopsStateProvince] Return shipments with this state province on its delivery stops
         * @param {string} [drayageBookingNumberContains] Include shipments where the drayage booking number contains this value
         * @param {string} [drayageChassisNumberContains] Include shipments where the drayage chassis number contains this value
         * @param {string} [drayageContainerNumberContains] Include shipments where the drayage container number contains this value
         * @param {string} [drayageContainerReturnDateGte] Include shipments where the drayage container return date is greater than or equal to this value
         * @param {string} [drayageContainerReturnDateLte] Include shipments where the drayage container return date is less than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateGte] Include shipments where the drayage estimated arrival date is greater than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateLte] Include shipments where the drayage estimated arrival date is less than or equal to this value
         * @param {string} [drayageLastFreeDateGte] Include shipments where the drayage last free datetime is greater than or equal to this value
         * @param {string} [drayageLastFreeDateLte] Include shipments where the drayage last free datetime is less than or equal to this value
         * @param {string} [drayageReleaseDateGte] Include shipments where the drayage release datetime is greater than or equal to this value
         * @param {string} [drayageReleaseDateLte] Include shipments where the drayage release datetime is less than or equal to this value
         * @param {string} [drayageSealNumberContains] Include shipments where the drayage seal number contains this value
         * @param {boolean} [driverAssigned] Return shipments where the driver is assigned/unassigned
         * @param {string} [dropoffGte] Return shipments with a dropoff stop with a planned date greater than or equal to this value
         * @param {string} [dropoffLte] Return shipments with a dropoff stop with a planned data less than or equal to this value
         * @param {string} [equipmentType] Return shipments with this equipment type
         * @param {string} [equipmentTypeContains] Return shipments where the equipment type contains this value
         * @param {string} [fedexAccount] Return pickups specific to this FedEx account
         * @param {string} [groupId] Group id for a shipment
         * @param {boolean} [hasInvoice] If true, show shipments which have at least one invoice otherwise show those with none.
         * @param {boolean} [hasBill] If true, show shipments which have at least one bill otherwise show those with none.
         * @param {Array<string>} [include] [v3] A list of properties to include in the response resource
         * @param {boolean} [loadBoardEnabled] Filter on whether or not a shipment is posted on the company load board
         * @param {string} [loadBoardId] Return shipments where the load board ID is equal to this value
         * @param {string} [loadBoardIdContains] Return shipments where the load board ID contains this value
         * @param {string} [mode] Return shipments with this shipment mode
         * @param {string} [modeContains] Return shipments where the shipment mode contains this value
         * @param {string} [nameContains] Return shipments where the shipment name contains this value
         * @param {boolean} [open] Filter on whether or not a shipment is open
         * @param {string} [originContains] Return shipments with this value in the origin
         * @param {string} [originStateProvince] Return shipments with this state province on its origin stop
         * @param {string} [pickupStopsStateProvince] Return shipments with this state province on its pickup stops
         * @param {string} [pickupStopsContains] Return shipments with this value in one of its pickup stops
         * @param {string} [pickupStopsCompanyNameContains] Return shipments with this value in one of its pickup stops location company_name
         * @param {Array<'CANCELLED' | 'DELAYED' | 'DELIVERED' | 'IN_TRANSIT' | 'NOT_SCHEDULED' | 'SCHEDULED'>} [parcelPickupStatus] Include shipments where the parcel pickup status equals one of these values
         * @param {string} [pickupGte] Return shipments with a pickup stop with a planned date greater than or equal to this value
         * @param {string} [pickupLte] Return shipments with a pickup stop with a planned date less than or equal to this value
         * @param {string} [pickupId] Include shipments currently associated with the provided ShipmentPickup\&#39;s ID
         * @param {Array<string>} [pickupNumber] Include shipments with these Pickup Numbers
         * @param {string} [pickupNumberContains] Include shipments where the Pickup Number contains this value
         * @param {Array<string>} [pickupNumberExclude] Exclude shipments with these Pickup Numbers
         * @param {Array<string>} [proNumber] Include shipments with these PRO Numbers
         * @param {string} [proNumberContains] Return shipments where the PRO number contains this value
         * @param {Array<string>} [proNumberExclude] Exclude shipments with these PRO Numbers
         * @param {string} [powerUnit] Return shipments where this power unit is assigned
         * @param {string} [powerUnitName] PowerUnit name to query on
         * @param {Array<string>} [purchaseOrderNumber] Include shipments with these PO Numbers
         * @param {string} [purchaseOrderNumberContains] Include shipments where the PO number contains this value
         * @param {Array<string>} [purchaseOrderNumberExclude] Exclude shipments with these PO Numbers
         * @param {Array<string>} [referenceId] Include shipments with these Reference IDs
         * @param {string} [referenceIdContains] Include shipments where the reference ID contains this value
         * @param {Array<string>} [referenceIdExclude] Exclude shipments with these Reference IDs
         * @param {Array<string>} [masterAirWaybill] Include shipments with these Master Air Waybill Numbers
         * @param {string} [masterAirWaybillContains] Include shipments where the Master Air Waybill number contains this value
         * @param {Array<string>} [houseAirWaybill] Include shipments with these House Air Waybill Numbers
         * @param {string} [houseAirWaybillContains] Include shipments where the House Air Waybill number contains this value
         * @param {Array<string>} [reps] Include shipments with these reps
         * @param {'owner_operator'} [role] Get results based on a specific perspective such as owner_operator
         * @param {string} [serviceLevel] Return shipments with this service level
         * @param {Array<string>} [accessorials] Include only shipments with at least one matching ShipmentAccessorial
         * @param {string} [createdAtGte] Include shipments where created_at is greater than or equal to the time value
         * @param {string} [createdAtLte] Include shipments where created_at is less than or equal to this value
         * @param {Array<string>} [shipmentShipwellCustomData] Include shipments that contain these shipment-level custom data values
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [statusExclude] Exclude shipments with these statuses
         * @param {string} [statusContains] Include shipments where the status contains this string
         * @param {Array<string>} [tags] Include only shipments with at least one matching ShipmentTag
         * @param {Array<string>} [tagsExclude] Excludes shipments with at least one matching tag
         * @param {string} [stopsContains] Return shipments with this value in one of its stops
         * @param {string} [stopsCompanyNameContains] Return shipments with this value in one of its stops location company_name
         * @param {string} [stopsStateProvince] Return shipments with this state province on one of its stops
         * @param {string} [timelineLastUpdatedAtGte] Return shipments where last timeline update was greater than or equal to the value or was never updated
         * @param {string} [timelineLastUpdatedAtLte] Return shipments where last timeline update was less than or equal to the value or was never updated
         * @param {'current' | 'upcoming' | 'active' | 'past'} [timeFrame] Return shipments that are within the given time frame. active &#x3D; current + upcoming
         * @param {number} [totalMilesGte] Return shipments with total miles greater than or equal to this value
         * @param {number} [totalMilesLte] Return shipments with total miles less than or equal to this value
         * @param {string} [upsAccount] Return pickups specific to this UPS account
         * @param {string} [vendorId] Return shipments with this exact value as the vendor Carrier id
         * @param {string} [vendorContains] Return shipments where the vendor company name contains this value
         * @param {number} [totalWeightOverrideGte] Return shipments with weight greater than or equal to this value
         * @param {number} [totalWeightOverrideLte] Return shipments with weight less than or equal to this value
         * @param {number} [originRadius] Radius from origin stop
         * @param {number} [originLat] Latitude of location to filter on for origin stop
         * @param {number} [originLon] Longitude of location to filter on for origin stop
         * @param {number} [pickupRadius] Radius from a pickup stop
         * @param {number} [pickupLat] Latitude of location to filter on for pickup stop
         * @param {number} [pickupLon] Longitude of location to filter on for pickup stop
         * @param {number} [destinationRadius] Radius from the destination stop
         * @param {number} [destinationLat] Latitude of location to filter on for destination stop
         * @param {number} [destinationLon] Longitude of location to filter on for destination stop
         * @param {number} [deliveryRadius] Radius from a delivery stop
         * @param {number} [deliveryLat] Latitude of location to filter on for delivery stop
         * @param {number} [deliveryLon] Longitude of location to filter on for delivery stop
         * @param {Array<'RUNNING' | 'CANCELLED' | 'FAILED' | 'SUCCESS'>} [workflowExecutionStatus] Include shipments with these workflow execution statuses
         * @param {Array<'open' | 'accepted' | 'rejected' | 'revoked' | 'expired' | 'updated'>} [tenderStatus] Tender status on the shipment
         * @param {boolean} [optimized] Whether or not to explicitly use the optimized backend flows for data retrieval
         * @param {boolean} [showClonedResults] If true, show shipments that have a non null last_cloned_at value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShippingDashboardGet: function (page, pageSize, ordering, q, activeVendorAssignment, alertTypes, alerts, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, powerUnitName, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, accessorials, createdAtGte, createdAtLte, shipmentShipwellCustomData, status, statusExclude, statusContains, tags, tagsExclude, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, workflowExecutionStatus, tenderStatus, optimized, showClonedResults, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipwell-ui/shipping-dashboard/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (activeVendorAssignment !== undefined) {
                                localVarQueryParameter['active_vendor_assignment'] = activeVendorAssignment;
                            }
                            if (alertTypes !== undefined) {
                                localVarQueryParameter['alert_types'] = alertTypes;
                            }
                            if (alerts !== undefined) {
                                localVarQueryParameter['alerts'] = alerts;
                            }
                            if (archived !== undefined) {
                                localVarQueryParameter['archived'] = archived;
                            }
                            if (bolNumber) {
                                localVarQueryParameter['bol_number'] = bolNumber;
                            }
                            if (bolNumberContains !== undefined) {
                                localVarQueryParameter['bol_number__contains'] = bolNumberContains;
                            }
                            if (bolNumberExclude) {
                                localVarQueryParameter['bol_number__exclude'] = bolNumberExclude;
                            }
                            if (createdAt !== undefined) {
                                localVarQueryParameter['created_at'] = (createdAt instanceof Date) ?
                                    createdAt.toISOString() :
                                    createdAt;
                            }
                            if (createdBySource) {
                                localVarQueryParameter['created_by_source'] = createdBySource;
                            }
                            if (createdByUserContains !== undefined) {
                                localVarQueryParameter['created_by_user__contains'] = createdByUserContains;
                            }
                            if (createdByUserId) {
                                localVarQueryParameter['created_by_user_id'] = createdByUserId;
                            }
                            if (createdByUserName !== undefined) {
                                localVarQueryParameter['created_by_user_name'] = createdByUserName;
                            }
                            if (createdByUserNameContains !== undefined) {
                                localVarQueryParameter['created_by_user_name__contains'] = createdByUserNameContains;
                            }
                            if (customer !== undefined) {
                                localVarQueryParameter['customer'] = customer;
                            }
                            if (customerContains !== undefined) {
                                localVarQueryParameter['customer__contains'] = customerContains;
                            }
                            if (customerId !== undefined) {
                                localVarQueryParameter['customer_id'] = customerId;
                            }
                            if (customerReferenceNumber) {
                                localVarQueryParameter['customer_reference_number'] = customerReferenceNumber;
                            }
                            if (customerReferenceNumberContains !== undefined) {
                                localVarQueryParameter['customer_reference_number__contains'] = customerReferenceNumberContains;
                            }
                            if (customerReferenceNumberExclude) {
                                localVarQueryParameter['customer_reference_number__exclude'] = customerReferenceNumberExclude;
                            }
                            if (destinationContains !== undefined) {
                                localVarQueryParameter['destination__contains'] = destinationContains;
                            }
                            if (deliveryStopsContains !== undefined) {
                                localVarQueryParameter['delivery_stops__contains'] = deliveryStopsContains;
                            }
                            if (deliveryStopsCompanyNameContains !== undefined) {
                                localVarQueryParameter['delivery_stops_company_name__contains'] = deliveryStopsCompanyNameContains;
                            }
                            if (destinationStateProvince !== undefined) {
                                localVarQueryParameter['destination_state_province'] = destinationStateProvince;
                            }
                            if (deliveryStopsStateProvince !== undefined) {
                                localVarQueryParameter['delivery_stops_state_province'] = deliveryStopsStateProvince;
                            }
                            if (drayageBookingNumberContains !== undefined) {
                                localVarQueryParameter['drayage_booking_number__contains'] = drayageBookingNumberContains;
                            }
                            if (drayageChassisNumberContains !== undefined) {
                                localVarQueryParameter['drayage_chassis_number__contains'] = drayageChassisNumberContains;
                            }
                            if (drayageContainerNumberContains !== undefined) {
                                localVarQueryParameter['drayage_container_number__contains'] = drayageContainerNumberContains;
                            }
                            if (drayageContainerReturnDateGte !== undefined) {
                                localVarQueryParameter['drayage_container_return_date__gte'] = drayageContainerReturnDateGte;
                            }
                            if (drayageContainerReturnDateLte !== undefined) {
                                localVarQueryParameter['drayage_container_return_date__lte'] = drayageContainerReturnDateLte;
                            }
                            if (drayageEstimatedArrivalDateGte !== undefined) {
                                localVarQueryParameter['drayage_estimated_arrival_date__gte'] = drayageEstimatedArrivalDateGte;
                            }
                            if (drayageEstimatedArrivalDateLte !== undefined) {
                                localVarQueryParameter['drayage_estimated_arrival_date__lte'] = drayageEstimatedArrivalDateLte;
                            }
                            if (drayageLastFreeDateGte !== undefined) {
                                localVarQueryParameter['drayage_last_free_date__gte'] = drayageLastFreeDateGte;
                            }
                            if (drayageLastFreeDateLte !== undefined) {
                                localVarQueryParameter['drayage_last_free_date__lte'] = drayageLastFreeDateLte;
                            }
                            if (drayageReleaseDateGte !== undefined) {
                                localVarQueryParameter['drayage_release_date__gte'] = drayageReleaseDateGte;
                            }
                            if (drayageReleaseDateLte !== undefined) {
                                localVarQueryParameter['drayage_release_date__lte'] = drayageReleaseDateLte;
                            }
                            if (drayageSealNumberContains !== undefined) {
                                localVarQueryParameter['drayage_seal_number__contains'] = drayageSealNumberContains;
                            }
                            if (driverAssigned !== undefined) {
                                localVarQueryParameter['driver_assigned'] = driverAssigned;
                            }
                            if (dropoffGte !== undefined) {
                                localVarQueryParameter['dropoff__gte'] = (dropoffGte instanceof Date) ?
                                    dropoffGte.toISOString().substr(0, 10) :
                                    dropoffGte;
                            }
                            if (dropoffLte !== undefined) {
                                localVarQueryParameter['dropoff__lte'] = (dropoffLte instanceof Date) ?
                                    dropoffLte.toISOString().substr(0, 10) :
                                    dropoffLte;
                            }
                            if (equipmentType !== undefined) {
                                localVarQueryParameter['equipment_type'] = equipmentType;
                            }
                            if (equipmentTypeContains !== undefined) {
                                localVarQueryParameter['equipment_type__contains'] = equipmentTypeContains;
                            }
                            if (fedexAccount !== undefined) {
                                localVarQueryParameter['fedex_account'] = fedexAccount;
                            }
                            if (groupId !== undefined) {
                                localVarQueryParameter['groupId'] = groupId;
                            }
                            if (hasInvoice !== undefined) {
                                localVarQueryParameter['has_invoice'] = hasInvoice;
                            }
                            if (hasBill !== undefined) {
                                localVarQueryParameter['has_bill'] = hasBill;
                            }
                            if (include) {
                                localVarQueryParameter['include'] = include;
                            }
                            if (loadBoardEnabled !== undefined) {
                                localVarQueryParameter['load_board_enabled'] = loadBoardEnabled;
                            }
                            if (loadBoardId !== undefined) {
                                localVarQueryParameter['load_board_id'] = loadBoardId;
                            }
                            if (loadBoardIdContains !== undefined) {
                                localVarQueryParameter['load_board_id__contains'] = loadBoardIdContains;
                            }
                            if (mode !== undefined) {
                                localVarQueryParameter['mode'] = mode;
                            }
                            if (modeContains !== undefined) {
                                localVarQueryParameter['mode__contains'] = modeContains;
                            }
                            if (nameContains !== undefined) {
                                localVarQueryParameter['name__contains'] = nameContains;
                            }
                            if (open !== undefined) {
                                localVarQueryParameter['open'] = open;
                            }
                            if (originContains !== undefined) {
                                localVarQueryParameter['origin__contains'] = originContains;
                            }
                            if (originStateProvince !== undefined) {
                                localVarQueryParameter['origin_state_province'] = originStateProvince;
                            }
                            if (pickupStopsStateProvince !== undefined) {
                                localVarQueryParameter['pickup_stops_state_province'] = pickupStopsStateProvince;
                            }
                            if (pickupStopsContains !== undefined) {
                                localVarQueryParameter['pickup_stops__contains'] = pickupStopsContains;
                            }
                            if (pickupStopsCompanyNameContains !== undefined) {
                                localVarQueryParameter['pickup_stops_company_name__contains'] = pickupStopsCompanyNameContains;
                            }
                            if (parcelPickupStatus) {
                                localVarQueryParameter['parcel_pickup_status'] = parcelPickupStatus;
                            }
                            if (pickupGte !== undefined) {
                                localVarQueryParameter['pickup__gte'] = (pickupGte instanceof Date) ?
                                    pickupGte.toISOString().substr(0, 10) :
                                    pickupGte;
                            }
                            if (pickupLte !== undefined) {
                                localVarQueryParameter['pickup__lte'] = (pickupLte instanceof Date) ?
                                    pickupLte.toISOString().substr(0, 10) :
                                    pickupLte;
                            }
                            if (pickupId !== undefined) {
                                localVarQueryParameter['pickup_id'] = pickupId;
                            }
                            if (pickupNumber) {
                                localVarQueryParameter['pickup_number'] = pickupNumber;
                            }
                            if (pickupNumberContains !== undefined) {
                                localVarQueryParameter['pickup_number__contains'] = pickupNumberContains;
                            }
                            if (pickupNumberExclude) {
                                localVarQueryParameter['pickup_number__exclude'] = pickupNumberExclude;
                            }
                            if (proNumber) {
                                localVarQueryParameter['pro_number'] = proNumber;
                            }
                            if (proNumberContains !== undefined) {
                                localVarQueryParameter['pro_number__contains'] = proNumberContains;
                            }
                            if (proNumberExclude) {
                                localVarQueryParameter['pro_number__exclude'] = proNumberExclude;
                            }
                            if (powerUnit !== undefined) {
                                localVarQueryParameter['power_unit'] = powerUnit;
                            }
                            if (powerUnitName !== undefined) {
                                localVarQueryParameter['power_unit_name'] = powerUnitName;
                            }
                            if (purchaseOrderNumber) {
                                localVarQueryParameter['purchase_order_number'] = purchaseOrderNumber;
                            }
                            if (purchaseOrderNumberContains !== undefined) {
                                localVarQueryParameter['purchase_order_number__contains'] = purchaseOrderNumberContains;
                            }
                            if (purchaseOrderNumberExclude) {
                                localVarQueryParameter['purchase_order_number__exclude'] = purchaseOrderNumberExclude;
                            }
                            if (referenceId) {
                                localVarQueryParameter['reference_id'] = referenceId;
                            }
                            if (referenceIdContains !== undefined) {
                                localVarQueryParameter['reference_id__contains'] = referenceIdContains;
                            }
                            if (referenceIdExclude) {
                                localVarQueryParameter['reference_id__exclude'] = referenceIdExclude;
                            }
                            if (masterAirWaybill) {
                                localVarQueryParameter['master_air_waybill'] = masterAirWaybill;
                            }
                            if (masterAirWaybillContains !== undefined) {
                                localVarQueryParameter['master_air_waybill__contains'] = masterAirWaybillContains;
                            }
                            if (houseAirWaybill) {
                                localVarQueryParameter['house_air_waybill'] = houseAirWaybill;
                            }
                            if (houseAirWaybillContains !== undefined) {
                                localVarQueryParameter['house_air_waybill__contains'] = houseAirWaybillContains;
                            }
                            if (reps) {
                                localVarQueryParameter['reps'] = reps;
                            }
                            if (role !== undefined) {
                                localVarQueryParameter['role'] = role;
                            }
                            if (serviceLevel !== undefined) {
                                localVarQueryParameter['service_level'] = serviceLevel;
                            }
                            if (accessorials) {
                                localVarQueryParameter['accessorials'] = accessorials;
                            }
                            if (createdAtGte !== undefined) {
                                localVarQueryParameter['created_at__gte'] = (createdAtGte instanceof Date) ?
                                    createdAtGte.toISOString() :
                                    createdAtGte;
                            }
                            if (createdAtLte !== undefined) {
                                localVarQueryParameter['created_at__lte'] = (createdAtLte instanceof Date) ?
                                    createdAtLte.toISOString() :
                                    createdAtLte;
                            }
                            if (shipmentShipwellCustomData) {
                                localVarQueryParameter['shipment_shipwell_custom_data'] = shipmentShipwellCustomData;
                            }
                            if (status) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (statusExclude) {
                                localVarQueryParameter['status__exclude'] = statusExclude;
                            }
                            if (statusContains !== undefined) {
                                localVarQueryParameter['status__contains'] = statusContains;
                            }
                            if (tags) {
                                localVarQueryParameter['tags'] = tags;
                            }
                            if (tagsExclude) {
                                localVarQueryParameter['tags__exclude'] = tagsExclude;
                            }
                            if (stopsContains !== undefined) {
                                localVarQueryParameter['stops__contains'] = stopsContains;
                            }
                            if (stopsCompanyNameContains !== undefined) {
                                localVarQueryParameter['stops_company_name__contains'] = stopsCompanyNameContains;
                            }
                            if (stopsStateProvince !== undefined) {
                                localVarQueryParameter['stops_state_province'] = stopsStateProvince;
                            }
                            if (timelineLastUpdatedAtGte !== undefined) {
                                localVarQueryParameter['timeline_last_updated_at__gte'] = timelineLastUpdatedAtGte;
                            }
                            if (timelineLastUpdatedAtLte !== undefined) {
                                localVarQueryParameter['timeline_last_updated_at__lte'] = timelineLastUpdatedAtLte;
                            }
                            if (timeFrame !== undefined) {
                                localVarQueryParameter['time_frame'] = timeFrame;
                            }
                            if (totalMilesGte !== undefined) {
                                localVarQueryParameter['total_miles__gte'] = totalMilesGte;
                            }
                            if (totalMilesLte !== undefined) {
                                localVarQueryParameter['total_miles__lte'] = totalMilesLte;
                            }
                            if (upsAccount !== undefined) {
                                localVarQueryParameter['ups_account'] = upsAccount;
                            }
                            if (vendorId !== undefined) {
                                localVarQueryParameter['vendor_id'] = vendorId;
                            }
                            if (vendorContains !== undefined) {
                                localVarQueryParameter['vendor__contains'] = vendorContains;
                            }
                            if (totalWeightOverrideGte !== undefined) {
                                localVarQueryParameter['total_weight_override__gte'] = totalWeightOverrideGte;
                            }
                            if (totalWeightOverrideLte !== undefined) {
                                localVarQueryParameter['total_weight_override__lte'] = totalWeightOverrideLte;
                            }
                            if (originRadius !== undefined) {
                                localVarQueryParameter['origin_radius'] = originRadius;
                            }
                            if (originLat !== undefined) {
                                localVarQueryParameter['origin_lat'] = originLat;
                            }
                            if (originLon !== undefined) {
                                localVarQueryParameter['origin_lon'] = originLon;
                            }
                            if (pickupRadius !== undefined) {
                                localVarQueryParameter['pickup_radius'] = pickupRadius;
                            }
                            if (pickupLat !== undefined) {
                                localVarQueryParameter['pickup_lat'] = pickupLat;
                            }
                            if (pickupLon !== undefined) {
                                localVarQueryParameter['pickup_lon'] = pickupLon;
                            }
                            if (destinationRadius !== undefined) {
                                localVarQueryParameter['destination_radius'] = destinationRadius;
                            }
                            if (destinationLat !== undefined) {
                                localVarQueryParameter['destination_lat'] = destinationLat;
                            }
                            if (destinationLon !== undefined) {
                                localVarQueryParameter['destination_lon'] = destinationLon;
                            }
                            if (deliveryRadius !== undefined) {
                                localVarQueryParameter['delivery_radius'] = deliveryRadius;
                            }
                            if (deliveryLat !== undefined) {
                                localVarQueryParameter['delivery_lat'] = deliveryLat;
                            }
                            if (deliveryLon !== undefined) {
                                localVarQueryParameter['delivery_lon'] = deliveryLon;
                            }
                            if (workflowExecutionStatus) {
                                localVarQueryParameter['workflow_execution_status'] = workflowExecutionStatus;
                            }
                            if (tenderStatus) {
                                localVarQueryParameter['tender_status'] = tenderStatus;
                            }
                            if (optimized !== undefined) {
                                localVarQueryParameter['optimized'] = optimized;
                            }
                            if (showClonedResults !== undefined) {
                                localVarQueryParameter['show_cloned_results'] = showClonedResults;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Summarize all stages associated with the provided V3Shipment IDs
         * @param {MultiModeSummariesRequest} multiModeSummariesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShippingDashboardMultiModeSummariesPost: function (multiModeSummariesRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'multiModeSummariesRequest' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiShippingDashboardMultiModeSummariesPost', 'multiModeSummariesRequest', multiModeSummariesRequest);
                            localVarPath = "/shipwell-ui/shipping-dashboard/multi-mode-summaries/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(multiModeSummariesRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the most current workflow for each shipment id
         * @param {ShippingDashboardShipmentCurrentWorkflowRequest} shippingDashboardShipmentCurrentWorkflowRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShippingDashboardShipmentCurrentWorkflowExecutionsPost: function (shippingDashboardShipmentCurrentWorkflowRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shippingDashboardShipmentCurrentWorkflowRequest' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiShippingDashboardShipmentCurrentWorkflowExecutionsPost', 'shippingDashboardShipmentCurrentWorkflowRequest', shippingDashboardShipmentCurrentWorkflowRequest);
                            localVarPath = "/shipwell-ui/shipping-dashboard/shipment-current-workflow-executions/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shippingDashboardShipmentCurrentWorkflowRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ShippingDashboardApiAxiosParamCreator = ShippingDashboardApiAxiosParamCreator;
/**
 * ShippingDashboardApi - functional programming interface
 * @export
 */
var ShippingDashboardApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ShippingDashboardApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get a list of V3 shipping dashboard rows (includes V2 Shipments, V3 Legs, and V3 Shipment Services)
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [activeVendorAssignment] Include or exclude shipments with active CarrierAssignments
         * @param {'MOBILE_DEVICE_ALERT' | 'NON_ACTIVE_CARRIER'} [alertTypes] Filter on shipments that have alerts of this type
         * @param {boolean} [alerts] Filter on whether or not a Shipment has alert messages
         * @param {boolean} [archived] Filter on whether or not a shipment is archived
         * @param {Array<string>} [bolNumber] Include shipments with these BOL Numbers
         * @param {string} [bolNumberContains] Return shipments where the BOL number contains this value
         * @param {Array<string>} [bolNumberExclude] Exclude shipments with these BOL Numbers
         * @param {string} [createdAt] For requesting data created at a certain datetime
         * @param {Array<'SHIPWELL_WEB' | 'IMPORT' | 'TENDER' | 'SHIPWELL_WEB_UNAUTH' | 'OTHER'>} [createdBySource] Return shipments created by sources in the array.
         * @param {string} [createdByUserContains] Return shipments where created_by_user object contains this string e.g first_name, last_name or email
         * @param {Array<string>} [createdByUserId] Return shipments where created_by_user_id in the array.
         * @param {string} [createdByUserName] Return shipments where created_by_user_name is exactly this string
         * @param {string} [createdByUserNameContains] Return shipments where created_by_user_name contains this string
         * @param {string} [customer] Return shipments with this exact value as the customer company name
         * @param {string} [customerContains] Return shipments where the customer company name contains this value
         * @param {string} [customerId] Return shipments with this exact id for the customer company
         * @param {Array<string>} [customerReferenceNumber] Include shipments with these Customer Reference Numbers
         * @param {string} [customerReferenceNumberContains] Include shipments where the Customer Reference Numbers contains this value
         * @param {Array<string>} [customerReferenceNumberExclude] Exclude shipments with these Customer Reference Numbers
         * @param {string} [destinationContains] Return shipments with this value in the destination
         * @param {string} [deliveryStopsContains] Return shipments with this value in one of its dropoff stops
         * @param {string} [deliveryStopsCompanyNameContains] Return shipments with this value in one of its delivery stops location company_name
         * @param {string} [destinationStateProvince] Return shipments with this state province on its destination stop
         * @param {string} [deliveryStopsStateProvince] Return shipments with this state province on its delivery stops
         * @param {string} [drayageBookingNumberContains] Include shipments where the drayage booking number contains this value
         * @param {string} [drayageChassisNumberContains] Include shipments where the drayage chassis number contains this value
         * @param {string} [drayageContainerNumberContains] Include shipments where the drayage container number contains this value
         * @param {string} [drayageContainerReturnDateGte] Include shipments where the drayage container return date is greater than or equal to this value
         * @param {string} [drayageContainerReturnDateLte] Include shipments where the drayage container return date is less than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateGte] Include shipments where the drayage estimated arrival date is greater than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateLte] Include shipments where the drayage estimated arrival date is less than or equal to this value
         * @param {string} [drayageLastFreeDateGte] Include shipments where the drayage last free datetime is greater than or equal to this value
         * @param {string} [drayageLastFreeDateLte] Include shipments where the drayage last free datetime is less than or equal to this value
         * @param {string} [drayageReleaseDateGte] Include shipments where the drayage release datetime is greater than or equal to this value
         * @param {string} [drayageReleaseDateLte] Include shipments where the drayage release datetime is less than or equal to this value
         * @param {string} [drayageSealNumberContains] Include shipments where the drayage seal number contains this value
         * @param {boolean} [driverAssigned] Return shipments where the driver is assigned/unassigned
         * @param {string} [dropoffGte] Return shipments with a dropoff stop with a planned date greater than or equal to this value
         * @param {string} [dropoffLte] Return shipments with a dropoff stop with a planned data less than or equal to this value
         * @param {string} [equipmentType] Return shipments with this equipment type
         * @param {string} [equipmentTypeContains] Return shipments where the equipment type contains this value
         * @param {string} [fedexAccount] Return pickups specific to this FedEx account
         * @param {string} [groupId] Group id for a shipment
         * @param {boolean} [hasInvoice] If true, show shipments which have at least one invoice otherwise show those with none.
         * @param {boolean} [hasBill] If true, show shipments which have at least one bill otherwise show those with none.
         * @param {Array<string>} [include] [v3] A list of properties to include in the response resource
         * @param {boolean} [loadBoardEnabled] Filter on whether or not a shipment is posted on the company load board
         * @param {string} [loadBoardId] Return shipments where the load board ID is equal to this value
         * @param {string} [loadBoardIdContains] Return shipments where the load board ID contains this value
         * @param {string} [mode] Return shipments with this shipment mode
         * @param {string} [modeContains] Return shipments where the shipment mode contains this value
         * @param {string} [nameContains] Return shipments where the shipment name contains this value
         * @param {boolean} [open] Filter on whether or not a shipment is open
         * @param {string} [originContains] Return shipments with this value in the origin
         * @param {string} [originStateProvince] Return shipments with this state province on its origin stop
         * @param {string} [pickupStopsStateProvince] Return shipments with this state province on its pickup stops
         * @param {string} [pickupStopsContains] Return shipments with this value in one of its pickup stops
         * @param {string} [pickupStopsCompanyNameContains] Return shipments with this value in one of its pickup stops location company_name
         * @param {Array<'CANCELLED' | 'DELAYED' | 'DELIVERED' | 'IN_TRANSIT' | 'NOT_SCHEDULED' | 'SCHEDULED'>} [parcelPickupStatus] Include shipments where the parcel pickup status equals one of these values
         * @param {string} [pickupGte] Return shipments with a pickup stop with a planned date greater than or equal to this value
         * @param {string} [pickupLte] Return shipments with a pickup stop with a planned date less than or equal to this value
         * @param {string} [pickupId] Include shipments currently associated with the provided ShipmentPickup\&#39;s ID
         * @param {Array<string>} [pickupNumber] Include shipments with these Pickup Numbers
         * @param {string} [pickupNumberContains] Include shipments where the Pickup Number contains this value
         * @param {Array<string>} [pickupNumberExclude] Exclude shipments with these Pickup Numbers
         * @param {Array<string>} [proNumber] Include shipments with these PRO Numbers
         * @param {string} [proNumberContains] Return shipments where the PRO number contains this value
         * @param {Array<string>} [proNumberExclude] Exclude shipments with these PRO Numbers
         * @param {string} [powerUnit] Return shipments where this power unit is assigned
         * @param {string} [powerUnitName] PowerUnit name to query on
         * @param {Array<string>} [purchaseOrderNumber] Include shipments with these PO Numbers
         * @param {string} [purchaseOrderNumberContains] Include shipments where the PO number contains this value
         * @param {Array<string>} [purchaseOrderNumberExclude] Exclude shipments with these PO Numbers
         * @param {Array<string>} [referenceId] Include shipments with these Reference IDs
         * @param {string} [referenceIdContains] Include shipments where the reference ID contains this value
         * @param {Array<string>} [referenceIdExclude] Exclude shipments with these Reference IDs
         * @param {Array<string>} [masterAirWaybill] Include shipments with these Master Air Waybill Numbers
         * @param {string} [masterAirWaybillContains] Include shipments where the Master Air Waybill number contains this value
         * @param {Array<string>} [houseAirWaybill] Include shipments with these House Air Waybill Numbers
         * @param {string} [houseAirWaybillContains] Include shipments where the House Air Waybill number contains this value
         * @param {Array<string>} [reps] Include shipments with these reps
         * @param {'owner_operator'} [role] Get results based on a specific perspective such as owner_operator
         * @param {string} [serviceLevel] Return shipments with this service level
         * @param {Array<string>} [accessorials] Include only shipments with at least one matching ShipmentAccessorial
         * @param {string} [createdAtGte] Include shipments where created_at is greater than or equal to the time value
         * @param {string} [createdAtLte] Include shipments where created_at is less than or equal to this value
         * @param {Array<string>} [shipmentShipwellCustomData] Include shipments that contain these shipment-level custom data values
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [statusExclude] Exclude shipments with these statuses
         * @param {string} [statusContains] Include shipments where the status contains this string
         * @param {Array<string>} [tags] Include only shipments with at least one matching ShipmentTag
         * @param {Array<string>} [tagsExclude] Excludes shipments with at least one matching tag
         * @param {string} [stopsContains] Return shipments with this value in one of its stops
         * @param {string} [stopsCompanyNameContains] Return shipments with this value in one of its stops location company_name
         * @param {string} [stopsStateProvince] Return shipments with this state province on one of its stops
         * @param {string} [timelineLastUpdatedAtGte] Return shipments where last timeline update was greater than or equal to the value or was never updated
         * @param {string} [timelineLastUpdatedAtLte] Return shipments where last timeline update was less than or equal to the value or was never updated
         * @param {'current' | 'upcoming' | 'active' | 'past'} [timeFrame] Return shipments that are within the given time frame. active &#x3D; current + upcoming
         * @param {number} [totalMilesGte] Return shipments with total miles greater than or equal to this value
         * @param {number} [totalMilesLte] Return shipments with total miles less than or equal to this value
         * @param {string} [upsAccount] Return pickups specific to this UPS account
         * @param {string} [vendorId] Return shipments with this exact value as the vendor Carrier id
         * @param {string} [vendorContains] Return shipments where the vendor company name contains this value
         * @param {number} [totalWeightOverrideGte] Return shipments with weight greater than or equal to this value
         * @param {number} [totalWeightOverrideLte] Return shipments with weight less than or equal to this value
         * @param {number} [originRadius] Radius from origin stop
         * @param {number} [originLat] Latitude of location to filter on for origin stop
         * @param {number} [originLon] Longitude of location to filter on for origin stop
         * @param {number} [pickupRadius] Radius from a pickup stop
         * @param {number} [pickupLat] Latitude of location to filter on for pickup stop
         * @param {number} [pickupLon] Longitude of location to filter on for pickup stop
         * @param {number} [destinationRadius] Radius from the destination stop
         * @param {number} [destinationLat] Latitude of location to filter on for destination stop
         * @param {number} [destinationLon] Longitude of location to filter on for destination stop
         * @param {number} [deliveryRadius] Radius from a delivery stop
         * @param {number} [deliveryLat] Latitude of location to filter on for delivery stop
         * @param {number} [deliveryLon] Longitude of location to filter on for delivery stop
         * @param {Array<'RUNNING' | 'CANCELLED' | 'FAILED' | 'SUCCESS'>} [workflowExecutionStatus] Include shipments with these workflow execution statuses
         * @param {Array<'open' | 'accepted' | 'rejected' | 'revoked' | 'expired' | 'updated'>} [tenderStatus] Tender status on the shipment
         * @param {boolean} [optimized] Whether or not to explicitly use the optimized backend flows for data retrieval
         * @param {boolean} [showClonedResults] If true, show shipments that have a non null last_cloned_at value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShippingDashboardGet: function (page, pageSize, ordering, q, activeVendorAssignment, alertTypes, alerts, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, powerUnitName, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, accessorials, createdAtGte, createdAtLte, shipmentShipwellCustomData, status, statusExclude, statusContains, tags, tagsExclude, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, workflowExecutionStatus, tenderStatus, optimized, showClonedResults, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiShippingDashboardGet(page, pageSize, ordering, q, activeVendorAssignment, alertTypes, alerts, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, powerUnitName, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, accessorials, createdAtGte, createdAtLte, shipmentShipwellCustomData, status, statusExclude, statusContains, tags, tagsExclude, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, workflowExecutionStatus, tenderStatus, optimized, showClonedResults, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Summarize all stages associated with the provided V3Shipment IDs
         * @param {MultiModeSummariesRequest} multiModeSummariesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShippingDashboardMultiModeSummariesPost: function (multiModeSummariesRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiShippingDashboardMultiModeSummariesPost(multiModeSummariesRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the most current workflow for each shipment id
         * @param {ShippingDashboardShipmentCurrentWorkflowRequest} shippingDashboardShipmentCurrentWorkflowRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShippingDashboardShipmentCurrentWorkflowExecutionsPost: function (shippingDashboardShipmentCurrentWorkflowRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiShippingDashboardShipmentCurrentWorkflowExecutionsPost(shippingDashboardShipmentCurrentWorkflowRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ShippingDashboardApiFp = ShippingDashboardApiFp;
/**
 * ShippingDashboardApi - factory interface
 * @export
 */
var ShippingDashboardApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ShippingDashboardApiFp)(configuration);
    return {
        /**
         *
         * @summary Get a list of V3 shipping dashboard rows (includes V2 Shipments, V3 Legs, and V3 Shipment Services)
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [activeVendorAssignment] Include or exclude shipments with active CarrierAssignments
         * @param {'MOBILE_DEVICE_ALERT' | 'NON_ACTIVE_CARRIER'} [alertTypes] Filter on shipments that have alerts of this type
         * @param {boolean} [alerts] Filter on whether or not a Shipment has alert messages
         * @param {boolean} [archived] Filter on whether or not a shipment is archived
         * @param {Array<string>} [bolNumber] Include shipments with these BOL Numbers
         * @param {string} [bolNumberContains] Return shipments where the BOL number contains this value
         * @param {Array<string>} [bolNumberExclude] Exclude shipments with these BOL Numbers
         * @param {string} [createdAt] For requesting data created at a certain datetime
         * @param {Array<'SHIPWELL_WEB' | 'IMPORT' | 'TENDER' | 'SHIPWELL_WEB_UNAUTH' | 'OTHER'>} [createdBySource] Return shipments created by sources in the array.
         * @param {string} [createdByUserContains] Return shipments where created_by_user object contains this string e.g first_name, last_name or email
         * @param {Array<string>} [createdByUserId] Return shipments where created_by_user_id in the array.
         * @param {string} [createdByUserName] Return shipments where created_by_user_name is exactly this string
         * @param {string} [createdByUserNameContains] Return shipments where created_by_user_name contains this string
         * @param {string} [customer] Return shipments with this exact value as the customer company name
         * @param {string} [customerContains] Return shipments where the customer company name contains this value
         * @param {string} [customerId] Return shipments with this exact id for the customer company
         * @param {Array<string>} [customerReferenceNumber] Include shipments with these Customer Reference Numbers
         * @param {string} [customerReferenceNumberContains] Include shipments where the Customer Reference Numbers contains this value
         * @param {Array<string>} [customerReferenceNumberExclude] Exclude shipments with these Customer Reference Numbers
         * @param {string} [destinationContains] Return shipments with this value in the destination
         * @param {string} [deliveryStopsContains] Return shipments with this value in one of its dropoff stops
         * @param {string} [deliveryStopsCompanyNameContains] Return shipments with this value in one of its delivery stops location company_name
         * @param {string} [destinationStateProvince] Return shipments with this state province on its destination stop
         * @param {string} [deliveryStopsStateProvince] Return shipments with this state province on its delivery stops
         * @param {string} [drayageBookingNumberContains] Include shipments where the drayage booking number contains this value
         * @param {string} [drayageChassisNumberContains] Include shipments where the drayage chassis number contains this value
         * @param {string} [drayageContainerNumberContains] Include shipments where the drayage container number contains this value
         * @param {string} [drayageContainerReturnDateGte] Include shipments where the drayage container return date is greater than or equal to this value
         * @param {string} [drayageContainerReturnDateLte] Include shipments where the drayage container return date is less than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateGte] Include shipments where the drayage estimated arrival date is greater than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateLte] Include shipments where the drayage estimated arrival date is less than or equal to this value
         * @param {string} [drayageLastFreeDateGte] Include shipments where the drayage last free datetime is greater than or equal to this value
         * @param {string} [drayageLastFreeDateLte] Include shipments where the drayage last free datetime is less than or equal to this value
         * @param {string} [drayageReleaseDateGte] Include shipments where the drayage release datetime is greater than or equal to this value
         * @param {string} [drayageReleaseDateLte] Include shipments where the drayage release datetime is less than or equal to this value
         * @param {string} [drayageSealNumberContains] Include shipments where the drayage seal number contains this value
         * @param {boolean} [driverAssigned] Return shipments where the driver is assigned/unassigned
         * @param {string} [dropoffGte] Return shipments with a dropoff stop with a planned date greater than or equal to this value
         * @param {string} [dropoffLte] Return shipments with a dropoff stop with a planned data less than or equal to this value
         * @param {string} [equipmentType] Return shipments with this equipment type
         * @param {string} [equipmentTypeContains] Return shipments where the equipment type contains this value
         * @param {string} [fedexAccount] Return pickups specific to this FedEx account
         * @param {string} [groupId] Group id for a shipment
         * @param {boolean} [hasInvoice] If true, show shipments which have at least one invoice otherwise show those with none.
         * @param {boolean} [hasBill] If true, show shipments which have at least one bill otherwise show those with none.
         * @param {Array<string>} [include] [v3] A list of properties to include in the response resource
         * @param {boolean} [loadBoardEnabled] Filter on whether or not a shipment is posted on the company load board
         * @param {string} [loadBoardId] Return shipments where the load board ID is equal to this value
         * @param {string} [loadBoardIdContains] Return shipments where the load board ID contains this value
         * @param {string} [mode] Return shipments with this shipment mode
         * @param {string} [modeContains] Return shipments where the shipment mode contains this value
         * @param {string} [nameContains] Return shipments where the shipment name contains this value
         * @param {boolean} [open] Filter on whether or not a shipment is open
         * @param {string} [originContains] Return shipments with this value in the origin
         * @param {string} [originStateProvince] Return shipments with this state province on its origin stop
         * @param {string} [pickupStopsStateProvince] Return shipments with this state province on its pickup stops
         * @param {string} [pickupStopsContains] Return shipments with this value in one of its pickup stops
         * @param {string} [pickupStopsCompanyNameContains] Return shipments with this value in one of its pickup stops location company_name
         * @param {Array<'CANCELLED' | 'DELAYED' | 'DELIVERED' | 'IN_TRANSIT' | 'NOT_SCHEDULED' | 'SCHEDULED'>} [parcelPickupStatus] Include shipments where the parcel pickup status equals one of these values
         * @param {string} [pickupGte] Return shipments with a pickup stop with a planned date greater than or equal to this value
         * @param {string} [pickupLte] Return shipments with a pickup stop with a planned date less than or equal to this value
         * @param {string} [pickupId] Include shipments currently associated with the provided ShipmentPickup\&#39;s ID
         * @param {Array<string>} [pickupNumber] Include shipments with these Pickup Numbers
         * @param {string} [pickupNumberContains] Include shipments where the Pickup Number contains this value
         * @param {Array<string>} [pickupNumberExclude] Exclude shipments with these Pickup Numbers
         * @param {Array<string>} [proNumber] Include shipments with these PRO Numbers
         * @param {string} [proNumberContains] Return shipments where the PRO number contains this value
         * @param {Array<string>} [proNumberExclude] Exclude shipments with these PRO Numbers
         * @param {string} [powerUnit] Return shipments where this power unit is assigned
         * @param {string} [powerUnitName] PowerUnit name to query on
         * @param {Array<string>} [purchaseOrderNumber] Include shipments with these PO Numbers
         * @param {string} [purchaseOrderNumberContains] Include shipments where the PO number contains this value
         * @param {Array<string>} [purchaseOrderNumberExclude] Exclude shipments with these PO Numbers
         * @param {Array<string>} [referenceId] Include shipments with these Reference IDs
         * @param {string} [referenceIdContains] Include shipments where the reference ID contains this value
         * @param {Array<string>} [referenceIdExclude] Exclude shipments with these Reference IDs
         * @param {Array<string>} [masterAirWaybill] Include shipments with these Master Air Waybill Numbers
         * @param {string} [masterAirWaybillContains] Include shipments where the Master Air Waybill number contains this value
         * @param {Array<string>} [houseAirWaybill] Include shipments with these House Air Waybill Numbers
         * @param {string} [houseAirWaybillContains] Include shipments where the House Air Waybill number contains this value
         * @param {Array<string>} [reps] Include shipments with these reps
         * @param {'owner_operator'} [role] Get results based on a specific perspective such as owner_operator
         * @param {string} [serviceLevel] Return shipments with this service level
         * @param {Array<string>} [accessorials] Include only shipments with at least one matching ShipmentAccessorial
         * @param {string} [createdAtGte] Include shipments where created_at is greater than or equal to the time value
         * @param {string} [createdAtLte] Include shipments where created_at is less than or equal to this value
         * @param {Array<string>} [shipmentShipwellCustomData] Include shipments that contain these shipment-level custom data values
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [statusExclude] Exclude shipments with these statuses
         * @param {string} [statusContains] Include shipments where the status contains this string
         * @param {Array<string>} [tags] Include only shipments with at least one matching ShipmentTag
         * @param {Array<string>} [tagsExclude] Excludes shipments with at least one matching tag
         * @param {string} [stopsContains] Return shipments with this value in one of its stops
         * @param {string} [stopsCompanyNameContains] Return shipments with this value in one of its stops location company_name
         * @param {string} [stopsStateProvince] Return shipments with this state province on one of its stops
         * @param {string} [timelineLastUpdatedAtGte] Return shipments where last timeline update was greater than or equal to the value or was never updated
         * @param {string} [timelineLastUpdatedAtLte] Return shipments where last timeline update was less than or equal to the value or was never updated
         * @param {'current' | 'upcoming' | 'active' | 'past'} [timeFrame] Return shipments that are within the given time frame. active &#x3D; current + upcoming
         * @param {number} [totalMilesGte] Return shipments with total miles greater than or equal to this value
         * @param {number} [totalMilesLte] Return shipments with total miles less than or equal to this value
         * @param {string} [upsAccount] Return pickups specific to this UPS account
         * @param {string} [vendorId] Return shipments with this exact value as the vendor Carrier id
         * @param {string} [vendorContains] Return shipments where the vendor company name contains this value
         * @param {number} [totalWeightOverrideGte] Return shipments with weight greater than or equal to this value
         * @param {number} [totalWeightOverrideLte] Return shipments with weight less than or equal to this value
         * @param {number} [originRadius] Radius from origin stop
         * @param {number} [originLat] Latitude of location to filter on for origin stop
         * @param {number} [originLon] Longitude of location to filter on for origin stop
         * @param {number} [pickupRadius] Radius from a pickup stop
         * @param {number} [pickupLat] Latitude of location to filter on for pickup stop
         * @param {number} [pickupLon] Longitude of location to filter on for pickup stop
         * @param {number} [destinationRadius] Radius from the destination stop
         * @param {number} [destinationLat] Latitude of location to filter on for destination stop
         * @param {number} [destinationLon] Longitude of location to filter on for destination stop
         * @param {number} [deliveryRadius] Radius from a delivery stop
         * @param {number} [deliveryLat] Latitude of location to filter on for delivery stop
         * @param {number} [deliveryLon] Longitude of location to filter on for delivery stop
         * @param {Array<'RUNNING' | 'CANCELLED' | 'FAILED' | 'SUCCESS'>} [workflowExecutionStatus] Include shipments with these workflow execution statuses
         * @param {Array<'open' | 'accepted' | 'rejected' | 'revoked' | 'expired' | 'updated'>} [tenderStatus] Tender status on the shipment
         * @param {boolean} [optimized] Whether or not to explicitly use the optimized backend flows for data retrieval
         * @param {boolean} [showClonedResults] If true, show shipments that have a non null last_cloned_at value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShippingDashboardGet: function (page, pageSize, ordering, q, activeVendorAssignment, alertTypes, alerts, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, powerUnitName, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, accessorials, createdAtGte, createdAtLte, shipmentShipwellCustomData, status, statusExclude, statusContains, tags, tagsExclude, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, workflowExecutionStatus, tenderStatus, optimized, showClonedResults, options) {
            return localVarFp.shipwellUiShippingDashboardGet(page, pageSize, ordering, q, activeVendorAssignment, alertTypes, alerts, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, powerUnitName, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, accessorials, createdAtGte, createdAtLte, shipmentShipwellCustomData, status, statusExclude, statusContains, tags, tagsExclude, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, workflowExecutionStatus, tenderStatus, optimized, showClonedResults, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Summarize all stages associated with the provided V3Shipment IDs
         * @param {MultiModeSummariesRequest} multiModeSummariesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShippingDashboardMultiModeSummariesPost: function (multiModeSummariesRequest, options) {
            return localVarFp.shipwellUiShippingDashboardMultiModeSummariesPost(multiModeSummariesRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the most current workflow for each shipment id
         * @param {ShippingDashboardShipmentCurrentWorkflowRequest} shippingDashboardShipmentCurrentWorkflowRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShippingDashboardShipmentCurrentWorkflowExecutionsPost: function (shippingDashboardShipmentCurrentWorkflowRequest, options) {
            return localVarFp.shipwellUiShippingDashboardShipmentCurrentWorkflowExecutionsPost(shippingDashboardShipmentCurrentWorkflowRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ShippingDashboardApiFactory = ShippingDashboardApiFactory;
/**
 * ShippingDashboardApi - object-oriented interface
 * @export
 * @class ShippingDashboardApi
 * @extends {BaseAPI}
 */
var ShippingDashboardApi = /** @class */ (function (_super) {
    __extends(ShippingDashboardApi, _super);
    function ShippingDashboardApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get a list of V3 shipping dashboard rows (includes V2 Shipments, V3 Legs, and V3 Shipment Services)
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {boolean} [activeVendorAssignment] Include or exclude shipments with active CarrierAssignments
     * @param {'MOBILE_DEVICE_ALERT' | 'NON_ACTIVE_CARRIER'} [alertTypes] Filter on shipments that have alerts of this type
     * @param {boolean} [alerts] Filter on whether or not a Shipment has alert messages
     * @param {boolean} [archived] Filter on whether or not a shipment is archived
     * @param {Array<string>} [bolNumber] Include shipments with these BOL Numbers
     * @param {string} [bolNumberContains] Return shipments where the BOL number contains this value
     * @param {Array<string>} [bolNumberExclude] Exclude shipments with these BOL Numbers
     * @param {string} [createdAt] For requesting data created at a certain datetime
     * @param {Array<'SHIPWELL_WEB' | 'IMPORT' | 'TENDER' | 'SHIPWELL_WEB_UNAUTH' | 'OTHER'>} [createdBySource] Return shipments created by sources in the array.
     * @param {string} [createdByUserContains] Return shipments where created_by_user object contains this string e.g first_name, last_name or email
     * @param {Array<string>} [createdByUserId] Return shipments where created_by_user_id in the array.
     * @param {string} [createdByUserName] Return shipments where created_by_user_name is exactly this string
     * @param {string} [createdByUserNameContains] Return shipments where created_by_user_name contains this string
     * @param {string} [customer] Return shipments with this exact value as the customer company name
     * @param {string} [customerContains] Return shipments where the customer company name contains this value
     * @param {string} [customerId] Return shipments with this exact id for the customer company
     * @param {Array<string>} [customerReferenceNumber] Include shipments with these Customer Reference Numbers
     * @param {string} [customerReferenceNumberContains] Include shipments where the Customer Reference Numbers contains this value
     * @param {Array<string>} [customerReferenceNumberExclude] Exclude shipments with these Customer Reference Numbers
     * @param {string} [destinationContains] Return shipments with this value in the destination
     * @param {string} [deliveryStopsContains] Return shipments with this value in one of its dropoff stops
     * @param {string} [deliveryStopsCompanyNameContains] Return shipments with this value in one of its delivery stops location company_name
     * @param {string} [destinationStateProvince] Return shipments with this state province on its destination stop
     * @param {string} [deliveryStopsStateProvince] Return shipments with this state province on its delivery stops
     * @param {string} [drayageBookingNumberContains] Include shipments where the drayage booking number contains this value
     * @param {string} [drayageChassisNumberContains] Include shipments where the drayage chassis number contains this value
     * @param {string} [drayageContainerNumberContains] Include shipments where the drayage container number contains this value
     * @param {string} [drayageContainerReturnDateGte] Include shipments where the drayage container return date is greater than or equal to this value
     * @param {string} [drayageContainerReturnDateLte] Include shipments where the drayage container return date is less than or equal to this value
     * @param {string} [drayageEstimatedArrivalDateGte] Include shipments where the drayage estimated arrival date is greater than or equal to this value
     * @param {string} [drayageEstimatedArrivalDateLte] Include shipments where the drayage estimated arrival date is less than or equal to this value
     * @param {string} [drayageLastFreeDateGte] Include shipments where the drayage last free datetime is greater than or equal to this value
     * @param {string} [drayageLastFreeDateLte] Include shipments where the drayage last free datetime is less than or equal to this value
     * @param {string} [drayageReleaseDateGte] Include shipments where the drayage release datetime is greater than or equal to this value
     * @param {string} [drayageReleaseDateLte] Include shipments where the drayage release datetime is less than or equal to this value
     * @param {string} [drayageSealNumberContains] Include shipments where the drayage seal number contains this value
     * @param {boolean} [driverAssigned] Return shipments where the driver is assigned/unassigned
     * @param {string} [dropoffGte] Return shipments with a dropoff stop with a planned date greater than or equal to this value
     * @param {string} [dropoffLte] Return shipments with a dropoff stop with a planned data less than or equal to this value
     * @param {string} [equipmentType] Return shipments with this equipment type
     * @param {string} [equipmentTypeContains] Return shipments where the equipment type contains this value
     * @param {string} [fedexAccount] Return pickups specific to this FedEx account
     * @param {string} [groupId] Group id for a shipment
     * @param {boolean} [hasInvoice] If true, show shipments which have at least one invoice otherwise show those with none.
     * @param {boolean} [hasBill] If true, show shipments which have at least one bill otherwise show those with none.
     * @param {Array<string>} [include] [v3] A list of properties to include in the response resource
     * @param {boolean} [loadBoardEnabled] Filter on whether or not a shipment is posted on the company load board
     * @param {string} [loadBoardId] Return shipments where the load board ID is equal to this value
     * @param {string} [loadBoardIdContains] Return shipments where the load board ID contains this value
     * @param {string} [mode] Return shipments with this shipment mode
     * @param {string} [modeContains] Return shipments where the shipment mode contains this value
     * @param {string} [nameContains] Return shipments where the shipment name contains this value
     * @param {boolean} [open] Filter on whether or not a shipment is open
     * @param {string} [originContains] Return shipments with this value in the origin
     * @param {string} [originStateProvince] Return shipments with this state province on its origin stop
     * @param {string} [pickupStopsStateProvince] Return shipments with this state province on its pickup stops
     * @param {string} [pickupStopsContains] Return shipments with this value in one of its pickup stops
     * @param {string} [pickupStopsCompanyNameContains] Return shipments with this value in one of its pickup stops location company_name
     * @param {Array<'CANCELLED' | 'DELAYED' | 'DELIVERED' | 'IN_TRANSIT' | 'NOT_SCHEDULED' | 'SCHEDULED'>} [parcelPickupStatus] Include shipments where the parcel pickup status equals one of these values
     * @param {string} [pickupGte] Return shipments with a pickup stop with a planned date greater than or equal to this value
     * @param {string} [pickupLte] Return shipments with a pickup stop with a planned date less than or equal to this value
     * @param {string} [pickupId] Include shipments currently associated with the provided ShipmentPickup\&#39;s ID
     * @param {Array<string>} [pickupNumber] Include shipments with these Pickup Numbers
     * @param {string} [pickupNumberContains] Include shipments where the Pickup Number contains this value
     * @param {Array<string>} [pickupNumberExclude] Exclude shipments with these Pickup Numbers
     * @param {Array<string>} [proNumber] Include shipments with these PRO Numbers
     * @param {string} [proNumberContains] Return shipments where the PRO number contains this value
     * @param {Array<string>} [proNumberExclude] Exclude shipments with these PRO Numbers
     * @param {string} [powerUnit] Return shipments where this power unit is assigned
     * @param {string} [powerUnitName] PowerUnit name to query on
     * @param {Array<string>} [purchaseOrderNumber] Include shipments with these PO Numbers
     * @param {string} [purchaseOrderNumberContains] Include shipments where the PO number contains this value
     * @param {Array<string>} [purchaseOrderNumberExclude] Exclude shipments with these PO Numbers
     * @param {Array<string>} [referenceId] Include shipments with these Reference IDs
     * @param {string} [referenceIdContains] Include shipments where the reference ID contains this value
     * @param {Array<string>} [referenceIdExclude] Exclude shipments with these Reference IDs
     * @param {Array<string>} [masterAirWaybill] Include shipments with these Master Air Waybill Numbers
     * @param {string} [masterAirWaybillContains] Include shipments where the Master Air Waybill number contains this value
     * @param {Array<string>} [houseAirWaybill] Include shipments with these House Air Waybill Numbers
     * @param {string} [houseAirWaybillContains] Include shipments where the House Air Waybill number contains this value
     * @param {Array<string>} [reps] Include shipments with these reps
     * @param {'owner_operator'} [role] Get results based on a specific perspective such as owner_operator
     * @param {string} [serviceLevel] Return shipments with this service level
     * @param {Array<string>} [accessorials] Include only shipments with at least one matching ShipmentAccessorial
     * @param {string} [createdAtGte] Include shipments where created_at is greater than or equal to the time value
     * @param {string} [createdAtLte] Include shipments where created_at is less than or equal to this value
     * @param {Array<string>} [shipmentShipwellCustomData] Include shipments that contain these shipment-level custom data values
     * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
     * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [statusExclude] Exclude shipments with these statuses
     * @param {string} [statusContains] Include shipments where the status contains this string
     * @param {Array<string>} [tags] Include only shipments with at least one matching ShipmentTag
     * @param {Array<string>} [tagsExclude] Excludes shipments with at least one matching tag
     * @param {string} [stopsContains] Return shipments with this value in one of its stops
     * @param {string} [stopsCompanyNameContains] Return shipments with this value in one of its stops location company_name
     * @param {string} [stopsStateProvince] Return shipments with this state province on one of its stops
     * @param {string} [timelineLastUpdatedAtGte] Return shipments where last timeline update was greater than or equal to the value or was never updated
     * @param {string} [timelineLastUpdatedAtLte] Return shipments where last timeline update was less than or equal to the value or was never updated
     * @param {'current' | 'upcoming' | 'active' | 'past'} [timeFrame] Return shipments that are within the given time frame. active &#x3D; current + upcoming
     * @param {number} [totalMilesGte] Return shipments with total miles greater than or equal to this value
     * @param {number} [totalMilesLte] Return shipments with total miles less than or equal to this value
     * @param {string} [upsAccount] Return pickups specific to this UPS account
     * @param {string} [vendorId] Return shipments with this exact value as the vendor Carrier id
     * @param {string} [vendorContains] Return shipments where the vendor company name contains this value
     * @param {number} [totalWeightOverrideGte] Return shipments with weight greater than or equal to this value
     * @param {number} [totalWeightOverrideLte] Return shipments with weight less than or equal to this value
     * @param {number} [originRadius] Radius from origin stop
     * @param {number} [originLat] Latitude of location to filter on for origin stop
     * @param {number} [originLon] Longitude of location to filter on for origin stop
     * @param {number} [pickupRadius] Radius from a pickup stop
     * @param {number} [pickupLat] Latitude of location to filter on for pickup stop
     * @param {number} [pickupLon] Longitude of location to filter on for pickup stop
     * @param {number} [destinationRadius] Radius from the destination stop
     * @param {number} [destinationLat] Latitude of location to filter on for destination stop
     * @param {number} [destinationLon] Longitude of location to filter on for destination stop
     * @param {number} [deliveryRadius] Radius from a delivery stop
     * @param {number} [deliveryLat] Latitude of location to filter on for delivery stop
     * @param {number} [deliveryLon] Longitude of location to filter on for delivery stop
     * @param {Array<'RUNNING' | 'CANCELLED' | 'FAILED' | 'SUCCESS'>} [workflowExecutionStatus] Include shipments with these workflow execution statuses
     * @param {Array<'open' | 'accepted' | 'rejected' | 'revoked' | 'expired' | 'updated'>} [tenderStatus] Tender status on the shipment
     * @param {boolean} [optimized] Whether or not to explicitly use the optimized backend flows for data retrieval
     * @param {boolean} [showClonedResults] If true, show shipments that have a non null last_cloned_at value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingDashboardApi
     */
    ShippingDashboardApi.prototype.shipwellUiShippingDashboardGet = function (page, pageSize, ordering, q, activeVendorAssignment, alertTypes, alerts, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, powerUnitName, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, accessorials, createdAtGte, createdAtLte, shipmentShipwellCustomData, status, statusExclude, statusContains, tags, tagsExclude, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, workflowExecutionStatus, tenderStatus, optimized, showClonedResults, options) {
        var _this = this;
        return (0, exports.ShippingDashboardApiFp)(this.configuration).shipwellUiShippingDashboardGet(page, pageSize, ordering, q, activeVendorAssignment, alertTypes, alerts, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, powerUnitName, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, accessorials, createdAtGte, createdAtLte, shipmentShipwellCustomData, status, statusExclude, statusContains, tags, tagsExclude, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, workflowExecutionStatus, tenderStatus, optimized, showClonedResults, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Summarize all stages associated with the provided V3Shipment IDs
     * @param {MultiModeSummariesRequest} multiModeSummariesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingDashboardApi
     */
    ShippingDashboardApi.prototype.shipwellUiShippingDashboardMultiModeSummariesPost = function (multiModeSummariesRequest, options) {
        var _this = this;
        return (0, exports.ShippingDashboardApiFp)(this.configuration).shipwellUiShippingDashboardMultiModeSummariesPost(multiModeSummariesRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the most current workflow for each shipment id
     * @param {ShippingDashboardShipmentCurrentWorkflowRequest} shippingDashboardShipmentCurrentWorkflowRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingDashboardApi
     */
    ShippingDashboardApi.prototype.shipwellUiShippingDashboardShipmentCurrentWorkflowExecutionsPost = function (shippingDashboardShipmentCurrentWorkflowRequest, options) {
        var _this = this;
        return (0, exports.ShippingDashboardApiFp)(this.configuration).shipwellUiShippingDashboardShipmentCurrentWorkflowExecutionsPost(shippingDashboardShipmentCurrentWorkflowRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ShippingDashboardApi;
}(base_1.BaseAPI));
exports.ShippingDashboardApi = ShippingDashboardApi;
/**
 * ShipwellUiApi - axios parameter creator
 * @export
 */
var ShipwellUiApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get a Slim Carrier Relationship for Alerts Dashboard
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {boolean} [resolvedAlerts] If true, return user resolved alert events instead of active ones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardCarrierRelationshipsCarrierRelationshipIdGet: function (carrierRelationshipId, resolvedAlerts, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiAlertsDashboardCarrierRelationshipsCarrierRelationshipIdGet', 'carrierRelationshipId', carrierRelationshipId);
                            localVarPath = "/shipwell-ui/alerts-dashboard/carrier-relationships/{carrierRelationshipId}/"
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (resolvedAlerts !== undefined) {
                                localVarQueryParameter['resolved_alerts'] = resolvedAlerts;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve alert count and shipment ids for particular alerts dashboard configuration
         * @param {string} alertsDashboardConfigurationId The id of the alerts dashboard configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdAlertCountGet: function (alertsDashboardConfigurationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'alertsDashboardConfigurationId' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdAlertCountGet', 'alertsDashboardConfigurationId', alertsDashboardConfigurationId);
                            localVarPath = "/shipwell-ui/alerts-dashboard-configuration/{alertsDashboardConfigurationId}/alert-count/"
                                .replace("{".concat("alertsDashboardConfigurationId", "}"), encodeURIComponent(String(alertsDashboardConfigurationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete an alerts dashboard configuration
         * @param {string} alertsDashboardConfigurationId The id of the alerts dashboard configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdDelete: function (alertsDashboardConfigurationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'alertsDashboardConfigurationId' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdDelete', 'alertsDashboardConfigurationId', alertsDashboardConfigurationId);
                            localVarPath = "/shipwell-ui/alerts-dashboard-configuration/{alertsDashboardConfigurationId}/"
                                .replace("{".concat("alertsDashboardConfigurationId", "}"), encodeURIComponent(String(alertsDashboardConfigurationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve an alerts dashboard configuration
         * @param {string} alertsDashboardConfigurationId The id of the alerts dashboard configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdGet: function (alertsDashboardConfigurationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'alertsDashboardConfigurationId' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdGet', 'alertsDashboardConfigurationId', alertsDashboardConfigurationId);
                            localVarPath = "/shipwell-ui/alerts-dashboard-configuration/{alertsDashboardConfigurationId}/"
                                .replace("{".concat("alertsDashboardConfigurationId", "}"), encodeURIComponent(String(alertsDashboardConfigurationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update configurations for a user\'s company
         * @param {string} alertsDashboardConfigurationId The id of the alerts dashboard configuration
         * @param {AlertsDashBoardConfiguration} alertsDashBoardConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdPut: function (alertsDashboardConfigurationId, alertsDashBoardConfiguration, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'alertsDashboardConfigurationId' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdPut', 'alertsDashboardConfigurationId', alertsDashboardConfigurationId);
                            // verify required parameter 'alertsDashBoardConfiguration' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdPut', 'alertsDashBoardConfiguration', alertsDashBoardConfiguration);
                            localVarPath = "/shipwell-ui/alerts-dashboard-configuration/{alertsDashboardConfigurationId}/"
                                .replace("{".concat("alertsDashboardConfigurationId", "}"), encodeURIComponent(String(alertsDashboardConfigurationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(alertsDashBoardConfiguration, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update configurations for a user\'s company
         * @param {Array<AlertsDashBoardConfiguration>} alertsDashBoardConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardConfigurationBulkUpdatePut: function (alertsDashBoardConfiguration, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'alertsDashBoardConfiguration' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiAlertsDashboardConfigurationBulkUpdatePut', 'alertsDashBoardConfiguration', alertsDashBoardConfiguration);
                            localVarPath = "/shipwell-ui/alerts-dashboard-configuration/bulk-update/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(alertsDashBoardConfiguration, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve configurations for a user\'s company
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardConfigurationGet: function (page, pageSize, ordering, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipwell-ui/alerts-dashboard-configuration/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve available configuration options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardConfigurationOptionsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipwell-ui/alerts-dashboard-configuration-options/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update configurations for a user\'s company
         * @param {AlertsDashBoardConfiguration} alertsDashBoardConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardConfigurationPost: function (alertsDashBoardConfiguration, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'alertsDashBoardConfiguration' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiAlertsDashboardConfigurationPost', 'alertsDashBoardConfiguration', alertsDashBoardConfiguration);
                            localVarPath = "/shipwell-ui/alerts-dashboard-configuration/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(alertsDashBoardConfiguration, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve shipments for alerts dashboard
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [activeVendorAssignment] Include or exclude shipments with active CarrierAssignments
         * @param {boolean} [alerts] Filter on whether or not a Shipment has alert messages
         * @param {string} [alertConfigurationId] Return shipments that match this alert configuration definition
         * @param {boolean} [alertShipments] Return shipments that match active alert configurations
         * @param {boolean} [archived] Filter on whether or not a shipment is archived
         * @param {Array<string>} [bolNumber] Include shipments with these BOL Numbers
         * @param {string} [bolNumberContains] Return shipments where the BOL number contains this value
         * @param {Array<string>} [bolNumberExclude] Exclude shipments with these BOL Numbers
         * @param {string} [createdAt] For requesting data created at a certain datetime
         * @param {Array<'SHIPWELL_WEB' | 'IMPORT' | 'TENDER' | 'SHIPWELL_WEB_UNAUTH' | 'OTHER'>} [createdBySource] Return shipments created by sources in the array.
         * @param {string} [createdByUserContains] Return shipments where created_by_user object contains this string e.g first_name, last_name or email
         * @param {Array<string>} [createdByUserId] Return shipments where created_by_user_id in the array.
         * @param {string} [createdByUserName] Return shipments where created_by_user_name is exactly this string
         * @param {string} [createdByUserNameContains] Return shipments where created_by_user_name contains this string
         * @param {string} [customer] Return shipments with this exact value as the customer company name
         * @param {string} [customerContains] Return shipments where the customer company name contains this value
         * @param {string} [customerId] Return shipments with this exact id for the customer company
         * @param {Array<string>} [customerReferenceNumber] Include shipments with these Customer Reference Numbers
         * @param {string} [customerReferenceNumberContains] Include shipments where the Customer Reference Numbers contains this value
         * @param {Array<string>} [customerReferenceNumberExclude] Exclude shipments with these Customer Reference Numbers
         * @param {string} [destinationContains] Return shipments with this value in the destination
         * @param {string} [deliveryStopsContains] Return shipments with this value in one of its dropoff stops
         * @param {string} [deliveryStopsCompanyNameContains] Return shipments with this value in one of its delivery stops location company_name
         * @param {string} [destinationStateProvince] Return shipments with this state province on its destination stop
         * @param {string} [deliveryStopsStateProvince] Return shipments with this state province on its delivery stops
         * @param {string} [drayageBookingNumberContains] Include shipments where the drayage booking number contains this value
         * @param {string} [drayageChassisNumberContains] Include shipments where the drayage chassis number contains this value
         * @param {string} [drayageContainerNumberContains] Include shipments where the drayage container number contains this value
         * @param {string} [drayageContainerReturnDateGte] Include shipments where the drayage container return date is greater than or equal to this value
         * @param {string} [drayageContainerReturnDateLte] Include shipments where the drayage container return date is less than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateGte] Include shipments where the drayage estimated arrival date is greater than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateLte] Include shipments where the drayage estimated arrival date is less than or equal to this value
         * @param {string} [drayageLastFreeDateGte] Include shipments where the drayage last free datetime is greater than or equal to this value
         * @param {string} [drayageLastFreeDateLte] Include shipments where the drayage last free datetime is less than or equal to this value
         * @param {string} [drayageReleaseDateGte] Include shipments where the drayage release datetime is greater than or equal to this value
         * @param {string} [drayageReleaseDateLte] Include shipments where the drayage release datetime is less than or equal to this value
         * @param {string} [drayageSealNumberContains] Include shipments where the drayage seal number contains this value
         * @param {boolean} [driverAssigned] Return shipments where the driver is assigned/unassigned
         * @param {string} [dropoffGte] Return shipments with a dropoff stop with a planned date greater than or equal to this value
         * @param {string} [dropoffLte] Return shipments with a dropoff stop with a planned data less than or equal to this value
         * @param {string} [equipmentType] Return shipments with this equipment type
         * @param {string} [equipmentTypeContains] Return shipments where the equipment type contains this value
         * @param {string} [fedexAccount] Return pickups specific to this FedEx account
         * @param {string} [groupId] Group id for a shipment
         * @param {boolean} [hasInvoice] If true, show shipments which have at least one invoice otherwise show those with none.
         * @param {boolean} [hasBill] If true, show shipments which have at least one bill otherwise show those with none.
         * @param {Array<string>} [include] [v3] A list of properties to include in the response resource
         * @param {boolean} [loadBoardEnabled] Filter on whether or not a shipment is posted on the company load board
         * @param {string} [loadBoardId] Return shipments where the load board ID is equal to this value
         * @param {string} [loadBoardIdContains] Return shipments where the load board ID contains this value
         * @param {string} [mode] Return shipments with this shipment mode
         * @param {string} [modeContains] Return shipments where the shipment mode contains this value
         * @param {string} [nameContains] Return shipments where the shipment name contains this value
         * @param {boolean} [open] Filter on whether or not a shipment is open
         * @param {string} [originContains] Return shipments with this value in the origin
         * @param {string} [originStateProvince] Return shipments with this state province on its origin stop
         * @param {string} [pickupStopsStateProvince] Return shipments with this state province on its pickup stops
         * @param {string} [pickupStopsContains] Return shipments with this value in one of its pickup stops
         * @param {string} [pickupStopsCompanyNameContains] Return shipments with this value in one of its pickup stops location company_name
         * @param {Array<'CANCELLED' | 'DELAYED' | 'DELIVERED' | 'IN_TRANSIT' | 'NOT_SCHEDULED' | 'SCHEDULED'>} [parcelPickupStatus] Include shipments where the parcel pickup status equals one of these values
         * @param {string} [pickupGte] Return shipments with a pickup stop with a planned date greater than or equal to this value
         * @param {string} [pickupLte] Return shipments with a pickup stop with a planned date less than or equal to this value
         * @param {string} [pickupId] Include shipments currently associated with the provided ShipmentPickup\&#39;s ID
         * @param {Array<string>} [pickupNumber] Include shipments with these Pickup Numbers
         * @param {string} [pickupNumberContains] Include shipments where the Pickup Number contains this value
         * @param {Array<string>} [pickupNumberExclude] Exclude shipments with these Pickup Numbers
         * @param {Array<string>} [proNumber] Include shipments with these PRO Numbers
         * @param {string} [proNumberContains] Return shipments where the PRO number contains this value
         * @param {Array<string>} [proNumberExclude] Exclude shipments with these PRO Numbers
         * @param {string} [powerUnit] Return shipments where this power unit is assigned
         * @param {Array<string>} [purchaseOrderNumber] Include shipments with these PO Numbers
         * @param {string} [purchaseOrderNumberContains] Include shipments where the PO number contains this value
         * @param {Array<string>} [purchaseOrderNumberExclude] Exclude shipments with these PO Numbers
         * @param {Array<string>} [referenceId] Include shipments with these Reference IDs
         * @param {string} [referenceIdContains] Include shipments where the reference ID contains this value
         * @param {Array<string>} [referenceIdExclude] Exclude shipments with these Reference IDs
         * @param {Array<string>} [masterAirWaybill] Include shipments with these Master Air Waybill Numbers
         * @param {string} [masterAirWaybillContains] Include shipments where the Master Air Waybill number contains this value
         * @param {Array<string>} [houseAirWaybill] Include shipments with these House Air Waybill Numbers
         * @param {string} [houseAirWaybillContains] Include shipments where the House Air Waybill number contains this value
         * @param {Array<string>} [reps] Include shipments with these reps
         * @param {'owner_operator'} [role] Get results based on a specific perspective such as owner_operator
         * @param {string} [serviceLevel] Return shipments with this service level
         * @param {string} [shipmentId] The id of the shipment
         * @param {Array<string>} [accessorials] Include only shipments with at least one matching ShipmentAccessorial
         * @param {string} [createdAtGte] Include shipments where created_at is greater than or equal to the time value
         * @param {string} [createdAtLte] Include shipments where created_at is less than or equal to this value
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [statusExclude] Exclude shipments with these statuses
         * @param {string} [statusContains] Include shipments where the status contains this string
         * @param {Array<string>} [tags] Include only shipments with at least one matching ShipmentTag
         * @param {string} [stopsContains] Return shipments with this value in one of its stops
         * @param {string} [stopsCompanyNameContains] Return shipments with this value in one of its stops location company_name
         * @param {string} [stopsStateProvince] Return shipments with this state province on one of its stops
         * @param {string} [timelineLastUpdatedAtGte] Return shipments where last timeline update was greater than or equal to the value or was never updated
         * @param {string} [timelineLastUpdatedAtLte] Return shipments where last timeline update was less than or equal to the value or was never updated
         * @param {'current' | 'upcoming' | 'active' | 'past'} [timeFrame] Return shipments that are within the given time frame. active &#x3D; current + upcoming
         * @param {number} [totalMilesGte] Return shipments with total miles greater than or equal to this value
         * @param {number} [totalMilesLte] Return shipments with total miles less than or equal to this value
         * @param {string} [upsAccount] Return pickups specific to this UPS account
         * @param {string} [vendorId] Return shipments with this exact value as the vendor Carrier id
         * @param {string} [vendorContains] Return shipments where the vendor company name contains this value
         * @param {number} [totalWeightOverrideGte] Return shipments with weight greater than or equal to this value
         * @param {number} [totalWeightOverrideLte] Return shipments with weight less than or equal to this value
         * @param {number} [originRadius] Radius from origin stop
         * @param {number} [originLat] Latitude of location to filter on for origin stop
         * @param {number} [originLon] Longitude of location to filter on for origin stop
         * @param {number} [pickupRadius] Radius from a pickup stop
         * @param {number} [pickupLat] Latitude of location to filter on for pickup stop
         * @param {number} [pickupLon] Longitude of location to filter on for pickup stop
         * @param {number} [destinationRadius] Radius from the destination stop
         * @param {number} [destinationLat] Latitude of location to filter on for destination stop
         * @param {number} [destinationLon] Longitude of location to filter on for destination stop
         * @param {number} [deliveryRadius] Radius from a delivery stop
         * @param {number} [deliveryLat] Latitude of location to filter on for delivery stop
         * @param {number} [deliveryLon] Longitude of location to filter on for delivery stop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardShipmentsGet: function (page, pageSize, ordering, q, activeVendorAssignment, alerts, alertConfigurationId, alertShipments, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, shipmentId, accessorials, createdAtGte, createdAtLte, status, statusExclude, statusContains, tags, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipwell-ui/alerts-dashboard-shipments/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (activeVendorAssignment !== undefined) {
                                localVarQueryParameter['active_vendor_assignment'] = activeVendorAssignment;
                            }
                            if (alerts !== undefined) {
                                localVarQueryParameter['alerts'] = alerts;
                            }
                            if (alertConfigurationId !== undefined) {
                                localVarQueryParameter['alert_configuration_id'] = alertConfigurationId;
                            }
                            if (alertShipments !== undefined) {
                                localVarQueryParameter['alert_shipments'] = alertShipments;
                            }
                            if (archived !== undefined) {
                                localVarQueryParameter['archived'] = archived;
                            }
                            if (bolNumber) {
                                localVarQueryParameter['bol_number'] = bolNumber;
                            }
                            if (bolNumberContains !== undefined) {
                                localVarQueryParameter['bol_number__contains'] = bolNumberContains;
                            }
                            if (bolNumberExclude) {
                                localVarQueryParameter['bol_number__exclude'] = bolNumberExclude;
                            }
                            if (createdAt !== undefined) {
                                localVarQueryParameter['created_at'] = (createdAt instanceof Date) ?
                                    createdAt.toISOString() :
                                    createdAt;
                            }
                            if (createdBySource) {
                                localVarQueryParameter['created_by_source'] = createdBySource;
                            }
                            if (createdByUserContains !== undefined) {
                                localVarQueryParameter['created_by_user__contains'] = createdByUserContains;
                            }
                            if (createdByUserId) {
                                localVarQueryParameter['created_by_user_id'] = createdByUserId;
                            }
                            if (createdByUserName !== undefined) {
                                localVarQueryParameter['created_by_user_name'] = createdByUserName;
                            }
                            if (createdByUserNameContains !== undefined) {
                                localVarQueryParameter['created_by_user_name__contains'] = createdByUserNameContains;
                            }
                            if (customer !== undefined) {
                                localVarQueryParameter['customer'] = customer;
                            }
                            if (customerContains !== undefined) {
                                localVarQueryParameter['customer__contains'] = customerContains;
                            }
                            if (customerId !== undefined) {
                                localVarQueryParameter['customer_id'] = customerId;
                            }
                            if (customerReferenceNumber) {
                                localVarQueryParameter['customer_reference_number'] = customerReferenceNumber;
                            }
                            if (customerReferenceNumberContains !== undefined) {
                                localVarQueryParameter['customer_reference_number__contains'] = customerReferenceNumberContains;
                            }
                            if (customerReferenceNumberExclude) {
                                localVarQueryParameter['customer_reference_number__exclude'] = customerReferenceNumberExclude;
                            }
                            if (destinationContains !== undefined) {
                                localVarQueryParameter['destination__contains'] = destinationContains;
                            }
                            if (deliveryStopsContains !== undefined) {
                                localVarQueryParameter['delivery_stops__contains'] = deliveryStopsContains;
                            }
                            if (deliveryStopsCompanyNameContains !== undefined) {
                                localVarQueryParameter['delivery_stops_company_name__contains'] = deliveryStopsCompanyNameContains;
                            }
                            if (destinationStateProvince !== undefined) {
                                localVarQueryParameter['destination_state_province'] = destinationStateProvince;
                            }
                            if (deliveryStopsStateProvince !== undefined) {
                                localVarQueryParameter['delivery_stops_state_province'] = deliveryStopsStateProvince;
                            }
                            if (drayageBookingNumberContains !== undefined) {
                                localVarQueryParameter['drayage_booking_number__contains'] = drayageBookingNumberContains;
                            }
                            if (drayageChassisNumberContains !== undefined) {
                                localVarQueryParameter['drayage_chassis_number__contains'] = drayageChassisNumberContains;
                            }
                            if (drayageContainerNumberContains !== undefined) {
                                localVarQueryParameter['drayage_container_number__contains'] = drayageContainerNumberContains;
                            }
                            if (drayageContainerReturnDateGte !== undefined) {
                                localVarQueryParameter['drayage_container_return_date__gte'] = drayageContainerReturnDateGte;
                            }
                            if (drayageContainerReturnDateLte !== undefined) {
                                localVarQueryParameter['drayage_container_return_date__lte'] = drayageContainerReturnDateLte;
                            }
                            if (drayageEstimatedArrivalDateGte !== undefined) {
                                localVarQueryParameter['drayage_estimated_arrival_date__gte'] = drayageEstimatedArrivalDateGte;
                            }
                            if (drayageEstimatedArrivalDateLte !== undefined) {
                                localVarQueryParameter['drayage_estimated_arrival_date__lte'] = drayageEstimatedArrivalDateLte;
                            }
                            if (drayageLastFreeDateGte !== undefined) {
                                localVarQueryParameter['drayage_last_free_date__gte'] = drayageLastFreeDateGte;
                            }
                            if (drayageLastFreeDateLte !== undefined) {
                                localVarQueryParameter['drayage_last_free_date__lte'] = drayageLastFreeDateLte;
                            }
                            if (drayageReleaseDateGte !== undefined) {
                                localVarQueryParameter['drayage_release_date__gte'] = drayageReleaseDateGte;
                            }
                            if (drayageReleaseDateLte !== undefined) {
                                localVarQueryParameter['drayage_release_date__lte'] = drayageReleaseDateLte;
                            }
                            if (drayageSealNumberContains !== undefined) {
                                localVarQueryParameter['drayage_seal_number__contains'] = drayageSealNumberContains;
                            }
                            if (driverAssigned !== undefined) {
                                localVarQueryParameter['driver_assigned'] = driverAssigned;
                            }
                            if (dropoffGte !== undefined) {
                                localVarQueryParameter['dropoff__gte'] = (dropoffGte instanceof Date) ?
                                    dropoffGte.toISOString().substr(0, 10) :
                                    dropoffGte;
                            }
                            if (dropoffLte !== undefined) {
                                localVarQueryParameter['dropoff__lte'] = (dropoffLte instanceof Date) ?
                                    dropoffLte.toISOString().substr(0, 10) :
                                    dropoffLte;
                            }
                            if (equipmentType !== undefined) {
                                localVarQueryParameter['equipment_type'] = equipmentType;
                            }
                            if (equipmentTypeContains !== undefined) {
                                localVarQueryParameter['equipment_type__contains'] = equipmentTypeContains;
                            }
                            if (fedexAccount !== undefined) {
                                localVarQueryParameter['fedex_account'] = fedexAccount;
                            }
                            if (groupId !== undefined) {
                                localVarQueryParameter['groupId'] = groupId;
                            }
                            if (hasInvoice !== undefined) {
                                localVarQueryParameter['has_invoice'] = hasInvoice;
                            }
                            if (hasBill !== undefined) {
                                localVarQueryParameter['has_bill'] = hasBill;
                            }
                            if (include) {
                                localVarQueryParameter['include'] = include;
                            }
                            if (loadBoardEnabled !== undefined) {
                                localVarQueryParameter['load_board_enabled'] = loadBoardEnabled;
                            }
                            if (loadBoardId !== undefined) {
                                localVarQueryParameter['load_board_id'] = loadBoardId;
                            }
                            if (loadBoardIdContains !== undefined) {
                                localVarQueryParameter['load_board_id__contains'] = loadBoardIdContains;
                            }
                            if (mode !== undefined) {
                                localVarQueryParameter['mode'] = mode;
                            }
                            if (modeContains !== undefined) {
                                localVarQueryParameter['mode__contains'] = modeContains;
                            }
                            if (nameContains !== undefined) {
                                localVarQueryParameter['name__contains'] = nameContains;
                            }
                            if (open !== undefined) {
                                localVarQueryParameter['open'] = open;
                            }
                            if (originContains !== undefined) {
                                localVarQueryParameter['origin__contains'] = originContains;
                            }
                            if (originStateProvince !== undefined) {
                                localVarQueryParameter['origin_state_province'] = originStateProvince;
                            }
                            if (pickupStopsStateProvince !== undefined) {
                                localVarQueryParameter['pickup_stops_state_province'] = pickupStopsStateProvince;
                            }
                            if (pickupStopsContains !== undefined) {
                                localVarQueryParameter['pickup_stops__contains'] = pickupStopsContains;
                            }
                            if (pickupStopsCompanyNameContains !== undefined) {
                                localVarQueryParameter['pickup_stops_company_name__contains'] = pickupStopsCompanyNameContains;
                            }
                            if (parcelPickupStatus) {
                                localVarQueryParameter['parcel_pickup_status'] = parcelPickupStatus;
                            }
                            if (pickupGte !== undefined) {
                                localVarQueryParameter['pickup__gte'] = (pickupGte instanceof Date) ?
                                    pickupGte.toISOString().substr(0, 10) :
                                    pickupGte;
                            }
                            if (pickupLte !== undefined) {
                                localVarQueryParameter['pickup__lte'] = (pickupLte instanceof Date) ?
                                    pickupLte.toISOString().substr(0, 10) :
                                    pickupLte;
                            }
                            if (pickupId !== undefined) {
                                localVarQueryParameter['pickup_id'] = pickupId;
                            }
                            if (pickupNumber) {
                                localVarQueryParameter['pickup_number'] = pickupNumber;
                            }
                            if (pickupNumberContains !== undefined) {
                                localVarQueryParameter['pickup_number__contains'] = pickupNumberContains;
                            }
                            if (pickupNumberExclude) {
                                localVarQueryParameter['pickup_number__exclude'] = pickupNumberExclude;
                            }
                            if (proNumber) {
                                localVarQueryParameter['pro_number'] = proNumber;
                            }
                            if (proNumberContains !== undefined) {
                                localVarQueryParameter['pro_number__contains'] = proNumberContains;
                            }
                            if (proNumberExclude) {
                                localVarQueryParameter['pro_number__exclude'] = proNumberExclude;
                            }
                            if (powerUnit !== undefined) {
                                localVarQueryParameter['power_unit'] = powerUnit;
                            }
                            if (purchaseOrderNumber) {
                                localVarQueryParameter['purchase_order_number'] = purchaseOrderNumber;
                            }
                            if (purchaseOrderNumberContains !== undefined) {
                                localVarQueryParameter['purchase_order_number__contains'] = purchaseOrderNumberContains;
                            }
                            if (purchaseOrderNumberExclude) {
                                localVarQueryParameter['purchase_order_number__exclude'] = purchaseOrderNumberExclude;
                            }
                            if (referenceId) {
                                localVarQueryParameter['reference_id'] = referenceId;
                            }
                            if (referenceIdContains !== undefined) {
                                localVarQueryParameter['reference_id__contains'] = referenceIdContains;
                            }
                            if (referenceIdExclude) {
                                localVarQueryParameter['reference_id__exclude'] = referenceIdExclude;
                            }
                            if (masterAirWaybill) {
                                localVarQueryParameter['master_air_waybill'] = masterAirWaybill;
                            }
                            if (masterAirWaybillContains !== undefined) {
                                localVarQueryParameter['master_air_waybill__contains'] = masterAirWaybillContains;
                            }
                            if (houseAirWaybill) {
                                localVarQueryParameter['house_air_waybill'] = houseAirWaybill;
                            }
                            if (houseAirWaybillContains !== undefined) {
                                localVarQueryParameter['house_air_waybill__contains'] = houseAirWaybillContains;
                            }
                            if (reps) {
                                localVarQueryParameter['reps'] = reps;
                            }
                            if (role !== undefined) {
                                localVarQueryParameter['role'] = role;
                            }
                            if (serviceLevel !== undefined) {
                                localVarQueryParameter['service_level'] = serviceLevel;
                            }
                            if (shipmentId !== undefined) {
                                localVarQueryParameter['shipment_id'] = shipmentId;
                            }
                            if (accessorials) {
                                localVarQueryParameter['accessorials'] = accessorials;
                            }
                            if (createdAtGte !== undefined) {
                                localVarQueryParameter['created_at__gte'] = (createdAtGte instanceof Date) ?
                                    createdAtGte.toISOString() :
                                    createdAtGte;
                            }
                            if (createdAtLte !== undefined) {
                                localVarQueryParameter['created_at__lte'] = (createdAtLte instanceof Date) ?
                                    createdAtLte.toISOString() :
                                    createdAtLte;
                            }
                            if (status) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (statusExclude) {
                                localVarQueryParameter['status__exclude'] = statusExclude;
                            }
                            if (statusContains !== undefined) {
                                localVarQueryParameter['status__contains'] = statusContains;
                            }
                            if (tags) {
                                localVarQueryParameter['tags'] = tags;
                            }
                            if (stopsContains !== undefined) {
                                localVarQueryParameter['stops__contains'] = stopsContains;
                            }
                            if (stopsCompanyNameContains !== undefined) {
                                localVarQueryParameter['stops_company_name__contains'] = stopsCompanyNameContains;
                            }
                            if (stopsStateProvince !== undefined) {
                                localVarQueryParameter['stops_state_province'] = stopsStateProvince;
                            }
                            if (timelineLastUpdatedAtGte !== undefined) {
                                localVarQueryParameter['timeline_last_updated_at__gte'] = timelineLastUpdatedAtGte;
                            }
                            if (timelineLastUpdatedAtLte !== undefined) {
                                localVarQueryParameter['timeline_last_updated_at__lte'] = timelineLastUpdatedAtLte;
                            }
                            if (timeFrame !== undefined) {
                                localVarQueryParameter['time_frame'] = timeFrame;
                            }
                            if (totalMilesGte !== undefined) {
                                localVarQueryParameter['total_miles__gte'] = totalMilesGte;
                            }
                            if (totalMilesLte !== undefined) {
                                localVarQueryParameter['total_miles__lte'] = totalMilesLte;
                            }
                            if (upsAccount !== undefined) {
                                localVarQueryParameter['ups_account'] = upsAccount;
                            }
                            if (vendorId !== undefined) {
                                localVarQueryParameter['vendor_id'] = vendorId;
                            }
                            if (vendorContains !== undefined) {
                                localVarQueryParameter['vendor__contains'] = vendorContains;
                            }
                            if (totalWeightOverrideGte !== undefined) {
                                localVarQueryParameter['total_weight_override__gte'] = totalWeightOverrideGte;
                            }
                            if (totalWeightOverrideLte !== undefined) {
                                localVarQueryParameter['total_weight_override__lte'] = totalWeightOverrideLte;
                            }
                            if (originRadius !== undefined) {
                                localVarQueryParameter['origin_radius'] = originRadius;
                            }
                            if (originLat !== undefined) {
                                localVarQueryParameter['origin_lat'] = originLat;
                            }
                            if (originLon !== undefined) {
                                localVarQueryParameter['origin_lon'] = originLon;
                            }
                            if (pickupRadius !== undefined) {
                                localVarQueryParameter['pickup_radius'] = pickupRadius;
                            }
                            if (pickupLat !== undefined) {
                                localVarQueryParameter['pickup_lat'] = pickupLat;
                            }
                            if (pickupLon !== undefined) {
                                localVarQueryParameter['pickup_lon'] = pickupLon;
                            }
                            if (destinationRadius !== undefined) {
                                localVarQueryParameter['destination_radius'] = destinationRadius;
                            }
                            if (destinationLat !== undefined) {
                                localVarQueryParameter['destination_lat'] = destinationLat;
                            }
                            if (destinationLon !== undefined) {
                                localVarQueryParameter['destination_lon'] = destinationLon;
                            }
                            if (deliveryRadius !== undefined) {
                                localVarQueryParameter['delivery_radius'] = deliveryRadius;
                            }
                            if (deliveryLat !== undefined) {
                                localVarQueryParameter['delivery_lat'] = deliveryLat;
                            }
                            if (deliveryLon !== undefined) {
                                localVarQueryParameter['delivery_lon'] = deliveryLon;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a Slim Shipment for Alerts Dashboard
         * @param {string} shipmentId The id of the shipment
         * @param {boolean} [resolvedAlerts] If true, return user resolved alert events instead of active ones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardShipmentsShipmentIdGet: function (shipmentId, resolvedAlerts, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiAlertsDashboardShipmentsShipmentIdGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipwell-ui/alerts-dashboard/shipments/{shipmentId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (resolvedAlerts !== undefined) {
                                localVarQueryParameter['resolved_alerts'] = resolvedAlerts;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a EmailNotificationTypes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiEmailNotificationsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipwell-ui/email-notifications/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Send an email
         * @param {EmailNotificationRequest} emailNotificationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiEmailNotificationsPost: function (emailNotificationRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'emailNotificationRequest' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiEmailNotificationsPost', 'emailNotificationRequest', emailNotificationRequest);
                            localVarPath = "/shipwell-ui/email-notifications/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(emailNotificationRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a list of unique product categories for the authenticated user\'s company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiFilteredProductsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipwell-ui/filtered-products/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a LegacyShipmentStage from a V3 shipment. Also cancel and archive the LegacyShipment.
         * @param {RemoveLegacyShipmentStageRequest} removeLegacyShipmentStageRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiLegacyShipmentsRemoveLegacyShipmentStagePost: function (removeLegacyShipmentStageRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'removeLegacyShipmentStageRequest' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiLegacyShipmentsRemoveLegacyShipmentStagePost', 'removeLegacyShipmentStageRequest', removeLegacyShipmentStageRequest);
                            localVarPath = "/shipwell-ui/legacy-shipments/remove-legacy-shipment-stage/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(removeLegacyShipmentStageRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request updated insurance information from a carrier
         * @param {UpdatedInsuranceRequest} [updatedInsuranceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiRequestUpdatedInsurancePost: function (updatedInsuranceRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipwell-ui/request-updated-insurance/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updatedInsuranceRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Return data for the settlements dashboard delivered
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [limit]
         * @param {string} [q] search query
         * @param {'SERVICE_PROVIDER' | 'BOOKING_PARTY'} [role] Filter invoices based on role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiSettlementsDashboardDeliveredGet: function (page, limit, q, role, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipwell-ui/settlements-dashboard/delivered/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (role !== undefined) {
                                localVarQueryParameter['role'] = role;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Return data for the settlements dashboard
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [limit]
         * @param {string} [invoiceableId] only include settlements invoices where there is an invoiceable, and it matches the provided ID
         * @param {string} [status] only include settlements invoices where there is a status, and it matches the provided value
         * @param {string} [statusIn] only include settlements invoices where the status matches the provided statuses
         * @param {string} [invoiceableReferenceNumber] only include settlements invoices where there is a invoiceable_reference_number, and it matches the provided value
         * @param {string} [invoiceSource] only include settlements invoices where there is a invoice_source, and it matches the provided value
         * @param {string} [serviceProviderName] only include settlements invoices where there is a service_provider_name, and it matches the provided value
         * @param {string} [serviceProviderNameContains] Filter Freight Invoices by service provider name.
         * @param {string} [invoiceNumber] only include settlements invoices where there is a invoice_number, and it matches the provided value
         * @param {string} [remitToName] only include settlements invoices that have a remit to and there is a name that matches the provided value
         * @param {string} [search] search query
         * @param {'SERVICE_PROVIDER' | 'BOOKING_PARTY'} [role] Filter invoices based on role
         * @param {string} [orderBy] Order Freight Invoices by the fields provided.
         * @param {string} [subStatusesSubStatus] Filter Freight Invoices by substatus value.
         * @param {string} [subStatusesSubStatusIn] Filter Freight Invoices by substatus values.
         * @param {string} [stopsAddress] Filter Freight Invoices by stops address.
         * @param {string} [stopsAddressContains] Filter Freight Invoices by stops address.
         * @param {string} [stopsCompanyName] Filter Freight Invoices by stops company name.
         * @param {string} [stopsCompanyNameContains] Filter Freight Invoices by stops company name.
         * @param {string} [stopsCompanyNameIn] Filter Freight Invoices by stops company name.
         * @param {string} [invoiceableMode] Filter Freight Invoices by invoiceable mode.
         * @param {string} [invoiceableModeIn] Filter Freight Invoices by invoiceable mode.
         * @param {string} [invoiceableShipwellCustomDataId] Filter Freight Invoices by invoiceable shipwell custom data id.
         * @param {string} [invoiceableShipwellCustomDataValue] Filter Freight Invoices by invoiceable shipwell custom data value.
         * @param {string} [dueDate] Filter Freight Invoices by due date.
         * @param {string} [dueDateLt] Filter Freight Invoices by due date.
         * @param {string} [dueDateLte] Filter Freight Invoices by due date.
         * @param {string} [dueDateGt] Filter Freight Invoices by due date.
         * @param {string} [dueDateGte] Filter Freight Invoices by due date.
         * @param {string} [invoiceDate] Filter Freight Invoices by invoice date.
         * @param {string} [invoiceDateLt] Filter Freight Invoices by invoice date.
         * @param {string} [invoiceDateLte] Filter Freight Invoices by invoice date.
         * @param {string} [invoiceDateGt] Filter Freight Invoices by invoice date.
         * @param {string} [invoiceDateGte] Filter Freight Invoices by invoice date.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiSettlementsDashboardGet: function (page, limit, invoiceableId, status, statusIn, invoiceableReferenceNumber, invoiceSource, serviceProviderName, serviceProviderNameContains, invoiceNumber, remitToName, search, role, orderBy, subStatusesSubStatus, subStatusesSubStatusIn, stopsAddress, stopsAddressContains, stopsCompanyName, stopsCompanyNameContains, stopsCompanyNameIn, invoiceableMode, invoiceableModeIn, invoiceableShipwellCustomDataId, invoiceableShipwellCustomDataValue, dueDate, dueDateLt, dueDateLte, dueDateGt, dueDateGte, invoiceDate, invoiceDateLt, invoiceDateLte, invoiceDateGt, invoiceDateGte, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipwell-ui/settlements-dashboard/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (invoiceableId !== undefined) {
                                localVarQueryParameter['invoiceable_id'] = invoiceableId;
                            }
                            if (status !== undefined) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (statusIn !== undefined) {
                                localVarQueryParameter['status__in'] = statusIn;
                            }
                            if (invoiceableReferenceNumber !== undefined) {
                                localVarQueryParameter['invoiceable_reference_number'] = invoiceableReferenceNumber;
                            }
                            if (invoiceSource !== undefined) {
                                localVarQueryParameter['invoice_source'] = invoiceSource;
                            }
                            if (serviceProviderName !== undefined) {
                                localVarQueryParameter['service_provider_name'] = serviceProviderName;
                            }
                            if (serviceProviderNameContains !== undefined) {
                                localVarQueryParameter['service_provider_name__contains'] = serviceProviderNameContains;
                            }
                            if (invoiceNumber !== undefined) {
                                localVarQueryParameter['invoice_number'] = invoiceNumber;
                            }
                            if (remitToName !== undefined) {
                                localVarQueryParameter['remit_to__name'] = remitToName;
                            }
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (role !== undefined) {
                                localVarQueryParameter['role'] = role;
                            }
                            if (orderBy !== undefined) {
                                localVarQueryParameter['order_by'] = orderBy;
                            }
                            if (subStatusesSubStatus !== undefined) {
                                localVarQueryParameter['sub_statuses__sub_status'] = subStatusesSubStatus;
                            }
                            if (subStatusesSubStatusIn !== undefined) {
                                localVarQueryParameter['sub_statuses__sub_status__in'] = subStatusesSubStatusIn;
                            }
                            if (stopsAddress !== undefined) {
                                localVarQueryParameter['stops__address'] = stopsAddress;
                            }
                            if (stopsAddressContains !== undefined) {
                                localVarQueryParameter['stops__address__contains'] = stopsAddressContains;
                            }
                            if (stopsCompanyName !== undefined) {
                                localVarQueryParameter['stops__company_name'] = stopsCompanyName;
                            }
                            if (stopsCompanyNameContains !== undefined) {
                                localVarQueryParameter['stops__company_name__contains'] = stopsCompanyNameContains;
                            }
                            if (stopsCompanyNameIn !== undefined) {
                                localVarQueryParameter['stops__company_name__in'] = stopsCompanyNameIn;
                            }
                            if (invoiceableMode !== undefined) {
                                localVarQueryParameter['invoiceable_mode'] = invoiceableMode;
                            }
                            if (invoiceableModeIn !== undefined) {
                                localVarQueryParameter['invoiceable_mode__in'] = invoiceableModeIn;
                            }
                            if (invoiceableShipwellCustomDataId !== undefined) {
                                localVarQueryParameter['invoiceable_shipwell_custom_data_id'] = invoiceableShipwellCustomDataId;
                            }
                            if (invoiceableShipwellCustomDataValue !== undefined) {
                                localVarQueryParameter['invoiceable_shipwell_custom_data_value'] = invoiceableShipwellCustomDataValue;
                            }
                            if (dueDate !== undefined) {
                                localVarQueryParameter['due_date'] = dueDate;
                            }
                            if (dueDateLt !== undefined) {
                                localVarQueryParameter['due_date__lt'] = dueDateLt;
                            }
                            if (dueDateLte !== undefined) {
                                localVarQueryParameter['due_date__lte'] = dueDateLte;
                            }
                            if (dueDateGt !== undefined) {
                                localVarQueryParameter['due_date__gt'] = dueDateGt;
                            }
                            if (dueDateGte !== undefined) {
                                localVarQueryParameter['due_date__gte'] = dueDateGte;
                            }
                            if (invoiceDate !== undefined) {
                                localVarQueryParameter['invoice_date'] = invoiceDate;
                            }
                            if (invoiceDateLt !== undefined) {
                                localVarQueryParameter['invoice_date__lt'] = invoiceDateLt;
                            }
                            if (invoiceDateLte !== undefined) {
                                localVarQueryParameter['invoice_date__lte'] = invoiceDateLte;
                            }
                            if (invoiceDateGt !== undefined) {
                                localVarQueryParameter['invoice_date__gt'] = invoiceDateGt;
                            }
                            if (invoiceDateGte !== undefined) {
                                localVarQueryParameter['invoice_date__gte'] = invoiceDateGte;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve list of Shipment Document Type short names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShipmentDocTypesShortNamesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipwell-ui/shipment-doc-types/short-names/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Allows a PhonePin user using the mobile app to create a StopAlert without having to specify the next Stop
         * @param {string} shipmentId The id of the shipment
         * @param {StopAlert} stopAlert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShipmentIdReportAProblemPost: function (shipmentId, stopAlert, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiShipmentIdReportAProblemPost', 'shipmentId', shipmentId);
                            // verify required parameter 'stopAlert' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiShipmentIdReportAProblemPost', 'stopAlert', stopAlert);
                            localVarPath = "/shipwell-ui/{shipmentId}/report-a-problem/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(stopAlert, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of metadata alerts for a given shipment id list
         * @param {ShipmentIdsAlertMetadata} [shipmentIdsAlertMetadata] ## List of shipment ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShipmentMetadataAlertsPost: function (shipmentIdsAlertMetadata, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipwell-ui/shipment-metadata-alerts/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shipmentIdsAlertMetadata, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Check carrier insurance
         * @param {string} shipmentId The id of the shipment
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShipmentShipmentIdCarrierRelationshipCarrierRelationshipIdCheckCarrierInsuranceGet: function (shipmentId, carrierRelationshipId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiShipmentShipmentIdCarrierRelationshipCarrierRelationshipIdCheckCarrierInsuranceGet', 'shipmentId', shipmentId);
                            // verify required parameter 'carrierRelationshipId' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiShipmentShipmentIdCarrierRelationshipCarrierRelationshipIdCheckCarrierInsuranceGet', 'carrierRelationshipId', carrierRelationshipId);
                            localVarPath = "/shipwell-ui/shipment/{shipmentId}/carrier-relationship/{carrierRelationshipId}/check-carrier-insurance/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("carrierRelationshipId", "}"), encodeURIComponent(String(carrierRelationshipId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns current bill-to information.
         * @param {string} shipmentId The id of the shipment
         * @param {string} [quote] The id of the quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShipmentsShipmentIdBillToGet: function (shipmentId, quote, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiShipmentsShipmentIdBillToGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipwell-ui/shipments/{shipmentId}/bill-to"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (quote !== undefined) {
                                localVarQueryParameter['quote'] = quote;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Consolidates line items in a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {ItemConsolidation} [itemConsolidation] Consolidate line items into a Shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShipmentsShipmentIdConsolidateLineItemsPost: function (shipmentId, itemConsolidation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiShipmentsShipmentIdConsolidateLineItemsPost', 'shipmentId', shipmentId);
                            localVarPath = "/shipwell-ui/shipments/{shipmentId}/consolidate-line-items/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(itemConsolidation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns status for shipments by their shipment id
         * @param {Array<string>} [shipmentId] Shipment ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShipmentsStatusGet: function (shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipwell-ui/shipments/status/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (shipmentId) {
                                localVarQueryParameter['shipment_id'] = shipmentId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of V3 shipping dashboard rows (includes V2 Shipments, V3 Legs, and V3 Shipment Services)
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [activeVendorAssignment] Include or exclude shipments with active CarrierAssignments
         * @param {'MOBILE_DEVICE_ALERT' | 'NON_ACTIVE_CARRIER'} [alertTypes] Filter on shipments that have alerts of this type
         * @param {boolean} [alerts] Filter on whether or not a Shipment has alert messages
         * @param {boolean} [archived] Filter on whether or not a shipment is archived
         * @param {Array<string>} [bolNumber] Include shipments with these BOL Numbers
         * @param {string} [bolNumberContains] Return shipments where the BOL number contains this value
         * @param {Array<string>} [bolNumberExclude] Exclude shipments with these BOL Numbers
         * @param {string} [createdAt] For requesting data created at a certain datetime
         * @param {Array<'SHIPWELL_WEB' | 'IMPORT' | 'TENDER' | 'SHIPWELL_WEB_UNAUTH' | 'OTHER'>} [createdBySource] Return shipments created by sources in the array.
         * @param {string} [createdByUserContains] Return shipments where created_by_user object contains this string e.g first_name, last_name or email
         * @param {Array<string>} [createdByUserId] Return shipments where created_by_user_id in the array.
         * @param {string} [createdByUserName] Return shipments where created_by_user_name is exactly this string
         * @param {string} [createdByUserNameContains] Return shipments where created_by_user_name contains this string
         * @param {string} [customer] Return shipments with this exact value as the customer company name
         * @param {string} [customerContains] Return shipments where the customer company name contains this value
         * @param {string} [customerId] Return shipments with this exact id for the customer company
         * @param {Array<string>} [customerReferenceNumber] Include shipments with these Customer Reference Numbers
         * @param {string} [customerReferenceNumberContains] Include shipments where the Customer Reference Numbers contains this value
         * @param {Array<string>} [customerReferenceNumberExclude] Exclude shipments with these Customer Reference Numbers
         * @param {string} [destinationContains] Return shipments with this value in the destination
         * @param {string} [deliveryStopsContains] Return shipments with this value in one of its dropoff stops
         * @param {string} [deliveryStopsCompanyNameContains] Return shipments with this value in one of its delivery stops location company_name
         * @param {string} [destinationStateProvince] Return shipments with this state province on its destination stop
         * @param {string} [deliveryStopsStateProvince] Return shipments with this state province on its delivery stops
         * @param {string} [drayageBookingNumberContains] Include shipments where the drayage booking number contains this value
         * @param {string} [drayageChassisNumberContains] Include shipments where the drayage chassis number contains this value
         * @param {string} [drayageContainerNumberContains] Include shipments where the drayage container number contains this value
         * @param {string} [drayageContainerReturnDateGte] Include shipments where the drayage container return date is greater than or equal to this value
         * @param {string} [drayageContainerReturnDateLte] Include shipments where the drayage container return date is less than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateGte] Include shipments where the drayage estimated arrival date is greater than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateLte] Include shipments where the drayage estimated arrival date is less than or equal to this value
         * @param {string} [drayageLastFreeDateGte] Include shipments where the drayage last free datetime is greater than or equal to this value
         * @param {string} [drayageLastFreeDateLte] Include shipments where the drayage last free datetime is less than or equal to this value
         * @param {string} [drayageReleaseDateGte] Include shipments where the drayage release datetime is greater than or equal to this value
         * @param {string} [drayageReleaseDateLte] Include shipments where the drayage release datetime is less than or equal to this value
         * @param {string} [drayageSealNumberContains] Include shipments where the drayage seal number contains this value
         * @param {boolean} [driverAssigned] Return shipments where the driver is assigned/unassigned
         * @param {string} [dropoffGte] Return shipments with a dropoff stop with a planned date greater than or equal to this value
         * @param {string} [dropoffLte] Return shipments with a dropoff stop with a planned data less than or equal to this value
         * @param {string} [equipmentType] Return shipments with this equipment type
         * @param {string} [equipmentTypeContains] Return shipments where the equipment type contains this value
         * @param {string} [fedexAccount] Return pickups specific to this FedEx account
         * @param {string} [groupId] Group id for a shipment
         * @param {boolean} [hasInvoice] If true, show shipments which have at least one invoice otherwise show those with none.
         * @param {boolean} [hasBill] If true, show shipments which have at least one bill otherwise show those with none.
         * @param {Array<string>} [include] [v3] A list of properties to include in the response resource
         * @param {boolean} [loadBoardEnabled] Filter on whether or not a shipment is posted on the company load board
         * @param {string} [loadBoardId] Return shipments where the load board ID is equal to this value
         * @param {string} [loadBoardIdContains] Return shipments where the load board ID contains this value
         * @param {string} [mode] Return shipments with this shipment mode
         * @param {string} [modeContains] Return shipments where the shipment mode contains this value
         * @param {string} [nameContains] Return shipments where the shipment name contains this value
         * @param {boolean} [open] Filter on whether or not a shipment is open
         * @param {string} [originContains] Return shipments with this value in the origin
         * @param {string} [originStateProvince] Return shipments with this state province on its origin stop
         * @param {string} [pickupStopsStateProvince] Return shipments with this state province on its pickup stops
         * @param {string} [pickupStopsContains] Return shipments with this value in one of its pickup stops
         * @param {string} [pickupStopsCompanyNameContains] Return shipments with this value in one of its pickup stops location company_name
         * @param {Array<'CANCELLED' | 'DELAYED' | 'DELIVERED' | 'IN_TRANSIT' | 'NOT_SCHEDULED' | 'SCHEDULED'>} [parcelPickupStatus] Include shipments where the parcel pickup status equals one of these values
         * @param {string} [pickupGte] Return shipments with a pickup stop with a planned date greater than or equal to this value
         * @param {string} [pickupLte] Return shipments with a pickup stop with a planned date less than or equal to this value
         * @param {string} [pickupId] Include shipments currently associated with the provided ShipmentPickup\&#39;s ID
         * @param {Array<string>} [pickupNumber] Include shipments with these Pickup Numbers
         * @param {string} [pickupNumberContains] Include shipments where the Pickup Number contains this value
         * @param {Array<string>} [pickupNumberExclude] Exclude shipments with these Pickup Numbers
         * @param {Array<string>} [proNumber] Include shipments with these PRO Numbers
         * @param {string} [proNumberContains] Return shipments where the PRO number contains this value
         * @param {Array<string>} [proNumberExclude] Exclude shipments with these PRO Numbers
         * @param {string} [powerUnit] Return shipments where this power unit is assigned
         * @param {string} [powerUnitName] PowerUnit name to query on
         * @param {Array<string>} [purchaseOrderNumber] Include shipments with these PO Numbers
         * @param {string} [purchaseOrderNumberContains] Include shipments where the PO number contains this value
         * @param {Array<string>} [purchaseOrderNumberExclude] Exclude shipments with these PO Numbers
         * @param {Array<string>} [referenceId] Include shipments with these Reference IDs
         * @param {string} [referenceIdContains] Include shipments where the reference ID contains this value
         * @param {Array<string>} [referenceIdExclude] Exclude shipments with these Reference IDs
         * @param {Array<string>} [masterAirWaybill] Include shipments with these Master Air Waybill Numbers
         * @param {string} [masterAirWaybillContains] Include shipments where the Master Air Waybill number contains this value
         * @param {Array<string>} [houseAirWaybill] Include shipments with these House Air Waybill Numbers
         * @param {string} [houseAirWaybillContains] Include shipments where the House Air Waybill number contains this value
         * @param {Array<string>} [reps] Include shipments with these reps
         * @param {'owner_operator'} [role] Get results based on a specific perspective such as owner_operator
         * @param {string} [serviceLevel] Return shipments with this service level
         * @param {Array<string>} [accessorials] Include only shipments with at least one matching ShipmentAccessorial
         * @param {string} [createdAtGte] Include shipments where created_at is greater than or equal to the time value
         * @param {string} [createdAtLte] Include shipments where created_at is less than or equal to this value
         * @param {Array<string>} [shipmentShipwellCustomData] Include shipments that contain these shipment-level custom data values
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [statusExclude] Exclude shipments with these statuses
         * @param {string} [statusContains] Include shipments where the status contains this string
         * @param {Array<string>} [tags] Include only shipments with at least one matching ShipmentTag
         * @param {Array<string>} [tagsExclude] Excludes shipments with at least one matching tag
         * @param {string} [stopsContains] Return shipments with this value in one of its stops
         * @param {string} [stopsCompanyNameContains] Return shipments with this value in one of its stops location company_name
         * @param {string} [stopsStateProvince] Return shipments with this state province on one of its stops
         * @param {string} [timelineLastUpdatedAtGte] Return shipments where last timeline update was greater than or equal to the value or was never updated
         * @param {string} [timelineLastUpdatedAtLte] Return shipments where last timeline update was less than or equal to the value or was never updated
         * @param {'current' | 'upcoming' | 'active' | 'past'} [timeFrame] Return shipments that are within the given time frame. active &#x3D; current + upcoming
         * @param {number} [totalMilesGte] Return shipments with total miles greater than or equal to this value
         * @param {number} [totalMilesLte] Return shipments with total miles less than or equal to this value
         * @param {string} [upsAccount] Return pickups specific to this UPS account
         * @param {string} [vendorId] Return shipments with this exact value as the vendor Carrier id
         * @param {string} [vendorContains] Return shipments where the vendor company name contains this value
         * @param {number} [totalWeightOverrideGte] Return shipments with weight greater than or equal to this value
         * @param {number} [totalWeightOverrideLte] Return shipments with weight less than or equal to this value
         * @param {number} [originRadius] Radius from origin stop
         * @param {number} [originLat] Latitude of location to filter on for origin stop
         * @param {number} [originLon] Longitude of location to filter on for origin stop
         * @param {number} [pickupRadius] Radius from a pickup stop
         * @param {number} [pickupLat] Latitude of location to filter on for pickup stop
         * @param {number} [pickupLon] Longitude of location to filter on for pickup stop
         * @param {number} [destinationRadius] Radius from the destination stop
         * @param {number} [destinationLat] Latitude of location to filter on for destination stop
         * @param {number} [destinationLon] Longitude of location to filter on for destination stop
         * @param {number} [deliveryRadius] Radius from a delivery stop
         * @param {number} [deliveryLat] Latitude of location to filter on for delivery stop
         * @param {number} [deliveryLon] Longitude of location to filter on for delivery stop
         * @param {Array<'RUNNING' | 'CANCELLED' | 'FAILED' | 'SUCCESS'>} [workflowExecutionStatus] Include shipments with these workflow execution statuses
         * @param {Array<'open' | 'accepted' | 'rejected' | 'revoked' | 'expired' | 'updated'>} [tenderStatus] Tender status on the shipment
         * @param {boolean} [optimized] Whether or not to explicitly use the optimized backend flows for data retrieval
         * @param {boolean} [showClonedResults] If true, show shipments that have a non null last_cloned_at value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShippingDashboardGet: function (page, pageSize, ordering, q, activeVendorAssignment, alertTypes, alerts, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, powerUnitName, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, accessorials, createdAtGte, createdAtLte, shipmentShipwellCustomData, status, statusExclude, statusContains, tags, tagsExclude, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, workflowExecutionStatus, tenderStatus, optimized, showClonedResults, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipwell-ui/shipping-dashboard/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (activeVendorAssignment !== undefined) {
                                localVarQueryParameter['active_vendor_assignment'] = activeVendorAssignment;
                            }
                            if (alertTypes !== undefined) {
                                localVarQueryParameter['alert_types'] = alertTypes;
                            }
                            if (alerts !== undefined) {
                                localVarQueryParameter['alerts'] = alerts;
                            }
                            if (archived !== undefined) {
                                localVarQueryParameter['archived'] = archived;
                            }
                            if (bolNumber) {
                                localVarQueryParameter['bol_number'] = bolNumber;
                            }
                            if (bolNumberContains !== undefined) {
                                localVarQueryParameter['bol_number__contains'] = bolNumberContains;
                            }
                            if (bolNumberExclude) {
                                localVarQueryParameter['bol_number__exclude'] = bolNumberExclude;
                            }
                            if (createdAt !== undefined) {
                                localVarQueryParameter['created_at'] = (createdAt instanceof Date) ?
                                    createdAt.toISOString() :
                                    createdAt;
                            }
                            if (createdBySource) {
                                localVarQueryParameter['created_by_source'] = createdBySource;
                            }
                            if (createdByUserContains !== undefined) {
                                localVarQueryParameter['created_by_user__contains'] = createdByUserContains;
                            }
                            if (createdByUserId) {
                                localVarQueryParameter['created_by_user_id'] = createdByUserId;
                            }
                            if (createdByUserName !== undefined) {
                                localVarQueryParameter['created_by_user_name'] = createdByUserName;
                            }
                            if (createdByUserNameContains !== undefined) {
                                localVarQueryParameter['created_by_user_name__contains'] = createdByUserNameContains;
                            }
                            if (customer !== undefined) {
                                localVarQueryParameter['customer'] = customer;
                            }
                            if (customerContains !== undefined) {
                                localVarQueryParameter['customer__contains'] = customerContains;
                            }
                            if (customerId !== undefined) {
                                localVarQueryParameter['customer_id'] = customerId;
                            }
                            if (customerReferenceNumber) {
                                localVarQueryParameter['customer_reference_number'] = customerReferenceNumber;
                            }
                            if (customerReferenceNumberContains !== undefined) {
                                localVarQueryParameter['customer_reference_number__contains'] = customerReferenceNumberContains;
                            }
                            if (customerReferenceNumberExclude) {
                                localVarQueryParameter['customer_reference_number__exclude'] = customerReferenceNumberExclude;
                            }
                            if (destinationContains !== undefined) {
                                localVarQueryParameter['destination__contains'] = destinationContains;
                            }
                            if (deliveryStopsContains !== undefined) {
                                localVarQueryParameter['delivery_stops__contains'] = deliveryStopsContains;
                            }
                            if (deliveryStopsCompanyNameContains !== undefined) {
                                localVarQueryParameter['delivery_stops_company_name__contains'] = deliveryStopsCompanyNameContains;
                            }
                            if (destinationStateProvince !== undefined) {
                                localVarQueryParameter['destination_state_province'] = destinationStateProvince;
                            }
                            if (deliveryStopsStateProvince !== undefined) {
                                localVarQueryParameter['delivery_stops_state_province'] = deliveryStopsStateProvince;
                            }
                            if (drayageBookingNumberContains !== undefined) {
                                localVarQueryParameter['drayage_booking_number__contains'] = drayageBookingNumberContains;
                            }
                            if (drayageChassisNumberContains !== undefined) {
                                localVarQueryParameter['drayage_chassis_number__contains'] = drayageChassisNumberContains;
                            }
                            if (drayageContainerNumberContains !== undefined) {
                                localVarQueryParameter['drayage_container_number__contains'] = drayageContainerNumberContains;
                            }
                            if (drayageContainerReturnDateGte !== undefined) {
                                localVarQueryParameter['drayage_container_return_date__gte'] = drayageContainerReturnDateGte;
                            }
                            if (drayageContainerReturnDateLte !== undefined) {
                                localVarQueryParameter['drayage_container_return_date__lte'] = drayageContainerReturnDateLte;
                            }
                            if (drayageEstimatedArrivalDateGte !== undefined) {
                                localVarQueryParameter['drayage_estimated_arrival_date__gte'] = drayageEstimatedArrivalDateGte;
                            }
                            if (drayageEstimatedArrivalDateLte !== undefined) {
                                localVarQueryParameter['drayage_estimated_arrival_date__lte'] = drayageEstimatedArrivalDateLte;
                            }
                            if (drayageLastFreeDateGte !== undefined) {
                                localVarQueryParameter['drayage_last_free_date__gte'] = drayageLastFreeDateGte;
                            }
                            if (drayageLastFreeDateLte !== undefined) {
                                localVarQueryParameter['drayage_last_free_date__lte'] = drayageLastFreeDateLte;
                            }
                            if (drayageReleaseDateGte !== undefined) {
                                localVarQueryParameter['drayage_release_date__gte'] = drayageReleaseDateGte;
                            }
                            if (drayageReleaseDateLte !== undefined) {
                                localVarQueryParameter['drayage_release_date__lte'] = drayageReleaseDateLte;
                            }
                            if (drayageSealNumberContains !== undefined) {
                                localVarQueryParameter['drayage_seal_number__contains'] = drayageSealNumberContains;
                            }
                            if (driverAssigned !== undefined) {
                                localVarQueryParameter['driver_assigned'] = driverAssigned;
                            }
                            if (dropoffGte !== undefined) {
                                localVarQueryParameter['dropoff__gte'] = (dropoffGte instanceof Date) ?
                                    dropoffGte.toISOString().substr(0, 10) :
                                    dropoffGte;
                            }
                            if (dropoffLte !== undefined) {
                                localVarQueryParameter['dropoff__lte'] = (dropoffLte instanceof Date) ?
                                    dropoffLte.toISOString().substr(0, 10) :
                                    dropoffLte;
                            }
                            if (equipmentType !== undefined) {
                                localVarQueryParameter['equipment_type'] = equipmentType;
                            }
                            if (equipmentTypeContains !== undefined) {
                                localVarQueryParameter['equipment_type__contains'] = equipmentTypeContains;
                            }
                            if (fedexAccount !== undefined) {
                                localVarQueryParameter['fedex_account'] = fedexAccount;
                            }
                            if (groupId !== undefined) {
                                localVarQueryParameter['groupId'] = groupId;
                            }
                            if (hasInvoice !== undefined) {
                                localVarQueryParameter['has_invoice'] = hasInvoice;
                            }
                            if (hasBill !== undefined) {
                                localVarQueryParameter['has_bill'] = hasBill;
                            }
                            if (include) {
                                localVarQueryParameter['include'] = include;
                            }
                            if (loadBoardEnabled !== undefined) {
                                localVarQueryParameter['load_board_enabled'] = loadBoardEnabled;
                            }
                            if (loadBoardId !== undefined) {
                                localVarQueryParameter['load_board_id'] = loadBoardId;
                            }
                            if (loadBoardIdContains !== undefined) {
                                localVarQueryParameter['load_board_id__contains'] = loadBoardIdContains;
                            }
                            if (mode !== undefined) {
                                localVarQueryParameter['mode'] = mode;
                            }
                            if (modeContains !== undefined) {
                                localVarQueryParameter['mode__contains'] = modeContains;
                            }
                            if (nameContains !== undefined) {
                                localVarQueryParameter['name__contains'] = nameContains;
                            }
                            if (open !== undefined) {
                                localVarQueryParameter['open'] = open;
                            }
                            if (originContains !== undefined) {
                                localVarQueryParameter['origin__contains'] = originContains;
                            }
                            if (originStateProvince !== undefined) {
                                localVarQueryParameter['origin_state_province'] = originStateProvince;
                            }
                            if (pickupStopsStateProvince !== undefined) {
                                localVarQueryParameter['pickup_stops_state_province'] = pickupStopsStateProvince;
                            }
                            if (pickupStopsContains !== undefined) {
                                localVarQueryParameter['pickup_stops__contains'] = pickupStopsContains;
                            }
                            if (pickupStopsCompanyNameContains !== undefined) {
                                localVarQueryParameter['pickup_stops_company_name__contains'] = pickupStopsCompanyNameContains;
                            }
                            if (parcelPickupStatus) {
                                localVarQueryParameter['parcel_pickup_status'] = parcelPickupStatus;
                            }
                            if (pickupGte !== undefined) {
                                localVarQueryParameter['pickup__gte'] = (pickupGte instanceof Date) ?
                                    pickupGte.toISOString().substr(0, 10) :
                                    pickupGte;
                            }
                            if (pickupLte !== undefined) {
                                localVarQueryParameter['pickup__lte'] = (pickupLte instanceof Date) ?
                                    pickupLte.toISOString().substr(0, 10) :
                                    pickupLte;
                            }
                            if (pickupId !== undefined) {
                                localVarQueryParameter['pickup_id'] = pickupId;
                            }
                            if (pickupNumber) {
                                localVarQueryParameter['pickup_number'] = pickupNumber;
                            }
                            if (pickupNumberContains !== undefined) {
                                localVarQueryParameter['pickup_number__contains'] = pickupNumberContains;
                            }
                            if (pickupNumberExclude) {
                                localVarQueryParameter['pickup_number__exclude'] = pickupNumberExclude;
                            }
                            if (proNumber) {
                                localVarQueryParameter['pro_number'] = proNumber;
                            }
                            if (proNumberContains !== undefined) {
                                localVarQueryParameter['pro_number__contains'] = proNumberContains;
                            }
                            if (proNumberExclude) {
                                localVarQueryParameter['pro_number__exclude'] = proNumberExclude;
                            }
                            if (powerUnit !== undefined) {
                                localVarQueryParameter['power_unit'] = powerUnit;
                            }
                            if (powerUnitName !== undefined) {
                                localVarQueryParameter['power_unit_name'] = powerUnitName;
                            }
                            if (purchaseOrderNumber) {
                                localVarQueryParameter['purchase_order_number'] = purchaseOrderNumber;
                            }
                            if (purchaseOrderNumberContains !== undefined) {
                                localVarQueryParameter['purchase_order_number__contains'] = purchaseOrderNumberContains;
                            }
                            if (purchaseOrderNumberExclude) {
                                localVarQueryParameter['purchase_order_number__exclude'] = purchaseOrderNumberExclude;
                            }
                            if (referenceId) {
                                localVarQueryParameter['reference_id'] = referenceId;
                            }
                            if (referenceIdContains !== undefined) {
                                localVarQueryParameter['reference_id__contains'] = referenceIdContains;
                            }
                            if (referenceIdExclude) {
                                localVarQueryParameter['reference_id__exclude'] = referenceIdExclude;
                            }
                            if (masterAirWaybill) {
                                localVarQueryParameter['master_air_waybill'] = masterAirWaybill;
                            }
                            if (masterAirWaybillContains !== undefined) {
                                localVarQueryParameter['master_air_waybill__contains'] = masterAirWaybillContains;
                            }
                            if (houseAirWaybill) {
                                localVarQueryParameter['house_air_waybill'] = houseAirWaybill;
                            }
                            if (houseAirWaybillContains !== undefined) {
                                localVarQueryParameter['house_air_waybill__contains'] = houseAirWaybillContains;
                            }
                            if (reps) {
                                localVarQueryParameter['reps'] = reps;
                            }
                            if (role !== undefined) {
                                localVarQueryParameter['role'] = role;
                            }
                            if (serviceLevel !== undefined) {
                                localVarQueryParameter['service_level'] = serviceLevel;
                            }
                            if (accessorials) {
                                localVarQueryParameter['accessorials'] = accessorials;
                            }
                            if (createdAtGte !== undefined) {
                                localVarQueryParameter['created_at__gte'] = (createdAtGte instanceof Date) ?
                                    createdAtGte.toISOString() :
                                    createdAtGte;
                            }
                            if (createdAtLte !== undefined) {
                                localVarQueryParameter['created_at__lte'] = (createdAtLte instanceof Date) ?
                                    createdAtLte.toISOString() :
                                    createdAtLte;
                            }
                            if (shipmentShipwellCustomData) {
                                localVarQueryParameter['shipment_shipwell_custom_data'] = shipmentShipwellCustomData;
                            }
                            if (status) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (statusExclude) {
                                localVarQueryParameter['status__exclude'] = statusExclude;
                            }
                            if (statusContains !== undefined) {
                                localVarQueryParameter['status__contains'] = statusContains;
                            }
                            if (tags) {
                                localVarQueryParameter['tags'] = tags;
                            }
                            if (tagsExclude) {
                                localVarQueryParameter['tags__exclude'] = tagsExclude;
                            }
                            if (stopsContains !== undefined) {
                                localVarQueryParameter['stops__contains'] = stopsContains;
                            }
                            if (stopsCompanyNameContains !== undefined) {
                                localVarQueryParameter['stops_company_name__contains'] = stopsCompanyNameContains;
                            }
                            if (stopsStateProvince !== undefined) {
                                localVarQueryParameter['stops_state_province'] = stopsStateProvince;
                            }
                            if (timelineLastUpdatedAtGte !== undefined) {
                                localVarQueryParameter['timeline_last_updated_at__gte'] = timelineLastUpdatedAtGte;
                            }
                            if (timelineLastUpdatedAtLte !== undefined) {
                                localVarQueryParameter['timeline_last_updated_at__lte'] = timelineLastUpdatedAtLte;
                            }
                            if (timeFrame !== undefined) {
                                localVarQueryParameter['time_frame'] = timeFrame;
                            }
                            if (totalMilesGte !== undefined) {
                                localVarQueryParameter['total_miles__gte'] = totalMilesGte;
                            }
                            if (totalMilesLte !== undefined) {
                                localVarQueryParameter['total_miles__lte'] = totalMilesLte;
                            }
                            if (upsAccount !== undefined) {
                                localVarQueryParameter['ups_account'] = upsAccount;
                            }
                            if (vendorId !== undefined) {
                                localVarQueryParameter['vendor_id'] = vendorId;
                            }
                            if (vendorContains !== undefined) {
                                localVarQueryParameter['vendor__contains'] = vendorContains;
                            }
                            if (totalWeightOverrideGte !== undefined) {
                                localVarQueryParameter['total_weight_override__gte'] = totalWeightOverrideGte;
                            }
                            if (totalWeightOverrideLte !== undefined) {
                                localVarQueryParameter['total_weight_override__lte'] = totalWeightOverrideLte;
                            }
                            if (originRadius !== undefined) {
                                localVarQueryParameter['origin_radius'] = originRadius;
                            }
                            if (originLat !== undefined) {
                                localVarQueryParameter['origin_lat'] = originLat;
                            }
                            if (originLon !== undefined) {
                                localVarQueryParameter['origin_lon'] = originLon;
                            }
                            if (pickupRadius !== undefined) {
                                localVarQueryParameter['pickup_radius'] = pickupRadius;
                            }
                            if (pickupLat !== undefined) {
                                localVarQueryParameter['pickup_lat'] = pickupLat;
                            }
                            if (pickupLon !== undefined) {
                                localVarQueryParameter['pickup_lon'] = pickupLon;
                            }
                            if (destinationRadius !== undefined) {
                                localVarQueryParameter['destination_radius'] = destinationRadius;
                            }
                            if (destinationLat !== undefined) {
                                localVarQueryParameter['destination_lat'] = destinationLat;
                            }
                            if (destinationLon !== undefined) {
                                localVarQueryParameter['destination_lon'] = destinationLon;
                            }
                            if (deliveryRadius !== undefined) {
                                localVarQueryParameter['delivery_radius'] = deliveryRadius;
                            }
                            if (deliveryLat !== undefined) {
                                localVarQueryParameter['delivery_lat'] = deliveryLat;
                            }
                            if (deliveryLon !== undefined) {
                                localVarQueryParameter['delivery_lon'] = deliveryLon;
                            }
                            if (workflowExecutionStatus) {
                                localVarQueryParameter['workflow_execution_status'] = workflowExecutionStatus;
                            }
                            if (tenderStatus) {
                                localVarQueryParameter['tender_status'] = tenderStatus;
                            }
                            if (optimized !== undefined) {
                                localVarQueryParameter['optimized'] = optimized;
                            }
                            if (showClonedResults !== undefined) {
                                localVarQueryParameter['show_cloned_results'] = showClonedResults;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Summarize all stages associated with the provided V3Shipment IDs
         * @param {MultiModeSummariesRequest} multiModeSummariesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShippingDashboardMultiModeSummariesPost: function (multiModeSummariesRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'multiModeSummariesRequest' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiShippingDashboardMultiModeSummariesPost', 'multiModeSummariesRequest', multiModeSummariesRequest);
                            localVarPath = "/shipwell-ui/shipping-dashboard/multi-mode-summaries/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(multiModeSummariesRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the most current workflow for each shipment id
         * @param {ShippingDashboardShipmentCurrentWorkflowRequest} shippingDashboardShipmentCurrentWorkflowRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShippingDashboardShipmentCurrentWorkflowExecutionsPost: function (shippingDashboardShipmentCurrentWorkflowRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shippingDashboardShipmentCurrentWorkflowRequest' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiShippingDashboardShipmentCurrentWorkflowExecutionsPost', 'shippingDashboardShipmentCurrentWorkflowRequest', shippingDashboardShipmentCurrentWorkflowRequest);
                            localVarPath = "/shipwell-ui/shipping-dashboard/shipment-current-workflow-executions/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shippingDashboardShipmentCurrentWorkflowRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of the current user\'s timeline event templates.
         * @param {string} [search] search query
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTimelineEventTemplatesGet: function (search, page, pageSize, ordering, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipwell-ui/timeline-event-templates/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new TimelineEventTemplate
         * @param {CreateTimelineEventTemplate} createTimelineEventTemplate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTimelineEventTemplatesPost: function (createTimelineEventTemplate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createTimelineEventTemplate' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiTimelineEventTemplatesPost', 'createTimelineEventTemplate', createTimelineEventTemplate);
                            localVarPath = "/shipwell-ui/timeline-event-templates/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createTimelineEventTemplate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a TimelineEventTemplate
         * @param {string} templateId The id of the timeline event template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTimelineEventTemplatesTemplateIdDelete: function (templateId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'templateId' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiTimelineEventTemplatesTemplateIdDelete', 'templateId', templateId);
                            localVarPath = "/shipwell-ui/timeline-event-templates/{templateId}"
                                .replace("{".concat("templateId", "}"), encodeURIComponent(String(templateId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a timeline event template
         * @param {string} templateId The id of the timeline event template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTimelineEventTemplatesTemplateIdGet: function (templateId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'templateId' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiTimelineEventTemplatesTemplateIdGet', 'templateId', templateId);
                            localVarPath = "/shipwell-ui/timeline-event-templates/{templateId}"
                                .replace("{".concat("templateId", "}"), encodeURIComponent(String(templateId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a TimelineEventTemplate
         * @param {string} templateId The id of the timeline event template
         * @param {CreateTimelineEventTemplate} createTimelineEventTemplate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTimelineEventTemplatesTemplateIdPut: function (templateId, createTimelineEventTemplate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'templateId' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiTimelineEventTemplatesTemplateIdPut', 'templateId', templateId);
                            // verify required parameter 'createTimelineEventTemplate' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiTimelineEventTemplatesTemplateIdPut', 'createTimelineEventTemplate', createTimelineEventTemplate);
                            localVarPath = "/shipwell-ui/timeline-event-templates/{templateId}"
                                .replace("{".concat("templateId", "}"), encodeURIComponent(String(templateId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createTimelineEventTemplate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a ShipmentTimelineFilterPreferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTimelineFilterPreferencesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipwell-ui/timeline-filter-preferences/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a ShipmentTimelineFilterPreferences
         * @param {ShipmentTimelineFilterPreferences} shipmentTimelineFilterPreferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTimelineFilterPreferencesPut: function (shipmentTimelineFilterPreferences, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentTimelineFilterPreferences' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiTimelineFilterPreferencesPut', 'shipmentTimelineFilterPreferences', shipmentTimelineFilterPreferences);
                            localVarPath = "/shipwell-ui/timeline-filter-preferences/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shipmentTimelineFilterPreferences, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of available email templates for Tracking Failed Compass alert emails.
         * @param {string} [search] search query
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTrackingFailedEmailTemplatesGet: function (search, page, pageSize, ordering, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipwell-ui/tracking-failed-email-templates/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (search !== undefined) {
                                localVarQueryParameter['search'] = search;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Send an email alert to the carrier
         * @param {TrackingFailedEmailRequest} [trackingFailedEmailRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTrackingFailedEmailTemplatesSendEmailPost: function (trackingFailedEmailRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipwell-ui/tracking-failed-email-templates/send-email/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(trackingFailedEmailRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a ShipwellUserPreferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiUserPreferencesGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipwell-ui/user-preferences/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a ShipwellUserPreferences
         * @param {UserPreferences} userPreferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiUserPreferencesPut: function (userPreferences, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'userPreferences' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiUserPreferencesPut', 'userPreferences', userPreferences);
                            localVarPath = "/shipwell-ui/user-preferences/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userPreferences, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Stop watching a Shipment
         * @param {InlineObject26} inlineObject26
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiUserWatchedShipmentsDelete: function (inlineObject26, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'inlineObject26' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiUserWatchedShipmentsDelete', 'inlineObject26', inlineObject26);
                            localVarPath = "/shipwell-ui/user-watched-shipments/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject26, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve shipment ids being watched by user
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiUserWatchedShipmentsGet: function (page, pageSize, ordering, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipwell-ui/user-watched-shipments/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Start watching a Shipment
         * @param {InlineObject25} inlineObject25
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiUserWatchedShipmentsPost: function (inlineObject25, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'inlineObject25' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellUiUserWatchedShipmentsPost', 'inlineObject25', inlineObject25);
                            localVarPath = "/shipwell-ui/user-watched-shipments/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject25, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ShipwellUiApiAxiosParamCreator = ShipwellUiApiAxiosParamCreator;
/**
 * ShipwellUiApi - functional programming interface
 * @export
 */
var ShipwellUiApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ShipwellUiApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get a Slim Carrier Relationship for Alerts Dashboard
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {boolean} [resolvedAlerts] If true, return user resolved alert events instead of active ones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardCarrierRelationshipsCarrierRelationshipIdGet: function (carrierRelationshipId, resolvedAlerts, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiAlertsDashboardCarrierRelationshipsCarrierRelationshipIdGet(carrierRelationshipId, resolvedAlerts, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve alert count and shipment ids for particular alerts dashboard configuration
         * @param {string} alertsDashboardConfigurationId The id of the alerts dashboard configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdAlertCountGet: function (alertsDashboardConfigurationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdAlertCountGet(alertsDashboardConfigurationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete an alerts dashboard configuration
         * @param {string} alertsDashboardConfigurationId The id of the alerts dashboard configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdDelete: function (alertsDashboardConfigurationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdDelete(alertsDashboardConfigurationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve an alerts dashboard configuration
         * @param {string} alertsDashboardConfigurationId The id of the alerts dashboard configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdGet: function (alertsDashboardConfigurationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdGet(alertsDashboardConfigurationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update configurations for a user\'s company
         * @param {string} alertsDashboardConfigurationId The id of the alerts dashboard configuration
         * @param {AlertsDashBoardConfiguration} alertsDashBoardConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdPut: function (alertsDashboardConfigurationId, alertsDashBoardConfiguration, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdPut(alertsDashboardConfigurationId, alertsDashBoardConfiguration, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update configurations for a user\'s company
         * @param {Array<AlertsDashBoardConfiguration>} alertsDashBoardConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardConfigurationBulkUpdatePut: function (alertsDashBoardConfiguration, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiAlertsDashboardConfigurationBulkUpdatePut(alertsDashBoardConfiguration, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve configurations for a user\'s company
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardConfigurationGet: function (page, pageSize, ordering, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiAlertsDashboardConfigurationGet(page, pageSize, ordering, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve available configuration options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardConfigurationOptionsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiAlertsDashboardConfigurationOptionsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update configurations for a user\'s company
         * @param {AlertsDashBoardConfiguration} alertsDashBoardConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardConfigurationPost: function (alertsDashBoardConfiguration, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiAlertsDashboardConfigurationPost(alertsDashBoardConfiguration, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve shipments for alerts dashboard
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [activeVendorAssignment] Include or exclude shipments with active CarrierAssignments
         * @param {boolean} [alerts] Filter on whether or not a Shipment has alert messages
         * @param {string} [alertConfigurationId] Return shipments that match this alert configuration definition
         * @param {boolean} [alertShipments] Return shipments that match active alert configurations
         * @param {boolean} [archived] Filter on whether or not a shipment is archived
         * @param {Array<string>} [bolNumber] Include shipments with these BOL Numbers
         * @param {string} [bolNumberContains] Return shipments where the BOL number contains this value
         * @param {Array<string>} [bolNumberExclude] Exclude shipments with these BOL Numbers
         * @param {string} [createdAt] For requesting data created at a certain datetime
         * @param {Array<'SHIPWELL_WEB' | 'IMPORT' | 'TENDER' | 'SHIPWELL_WEB_UNAUTH' | 'OTHER'>} [createdBySource] Return shipments created by sources in the array.
         * @param {string} [createdByUserContains] Return shipments where created_by_user object contains this string e.g first_name, last_name or email
         * @param {Array<string>} [createdByUserId] Return shipments where created_by_user_id in the array.
         * @param {string} [createdByUserName] Return shipments where created_by_user_name is exactly this string
         * @param {string} [createdByUserNameContains] Return shipments where created_by_user_name contains this string
         * @param {string} [customer] Return shipments with this exact value as the customer company name
         * @param {string} [customerContains] Return shipments where the customer company name contains this value
         * @param {string} [customerId] Return shipments with this exact id for the customer company
         * @param {Array<string>} [customerReferenceNumber] Include shipments with these Customer Reference Numbers
         * @param {string} [customerReferenceNumberContains] Include shipments where the Customer Reference Numbers contains this value
         * @param {Array<string>} [customerReferenceNumberExclude] Exclude shipments with these Customer Reference Numbers
         * @param {string} [destinationContains] Return shipments with this value in the destination
         * @param {string} [deliveryStopsContains] Return shipments with this value in one of its dropoff stops
         * @param {string} [deliveryStopsCompanyNameContains] Return shipments with this value in one of its delivery stops location company_name
         * @param {string} [destinationStateProvince] Return shipments with this state province on its destination stop
         * @param {string} [deliveryStopsStateProvince] Return shipments with this state province on its delivery stops
         * @param {string} [drayageBookingNumberContains] Include shipments where the drayage booking number contains this value
         * @param {string} [drayageChassisNumberContains] Include shipments where the drayage chassis number contains this value
         * @param {string} [drayageContainerNumberContains] Include shipments where the drayage container number contains this value
         * @param {string} [drayageContainerReturnDateGte] Include shipments where the drayage container return date is greater than or equal to this value
         * @param {string} [drayageContainerReturnDateLte] Include shipments where the drayage container return date is less than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateGte] Include shipments where the drayage estimated arrival date is greater than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateLte] Include shipments where the drayage estimated arrival date is less than or equal to this value
         * @param {string} [drayageLastFreeDateGte] Include shipments where the drayage last free datetime is greater than or equal to this value
         * @param {string} [drayageLastFreeDateLte] Include shipments where the drayage last free datetime is less than or equal to this value
         * @param {string} [drayageReleaseDateGte] Include shipments where the drayage release datetime is greater than or equal to this value
         * @param {string} [drayageReleaseDateLte] Include shipments where the drayage release datetime is less than or equal to this value
         * @param {string} [drayageSealNumberContains] Include shipments where the drayage seal number contains this value
         * @param {boolean} [driverAssigned] Return shipments where the driver is assigned/unassigned
         * @param {string} [dropoffGte] Return shipments with a dropoff stop with a planned date greater than or equal to this value
         * @param {string} [dropoffLte] Return shipments with a dropoff stop with a planned data less than or equal to this value
         * @param {string} [equipmentType] Return shipments with this equipment type
         * @param {string} [equipmentTypeContains] Return shipments where the equipment type contains this value
         * @param {string} [fedexAccount] Return pickups specific to this FedEx account
         * @param {string} [groupId] Group id for a shipment
         * @param {boolean} [hasInvoice] If true, show shipments which have at least one invoice otherwise show those with none.
         * @param {boolean} [hasBill] If true, show shipments which have at least one bill otherwise show those with none.
         * @param {Array<string>} [include] [v3] A list of properties to include in the response resource
         * @param {boolean} [loadBoardEnabled] Filter on whether or not a shipment is posted on the company load board
         * @param {string} [loadBoardId] Return shipments where the load board ID is equal to this value
         * @param {string} [loadBoardIdContains] Return shipments where the load board ID contains this value
         * @param {string} [mode] Return shipments with this shipment mode
         * @param {string} [modeContains] Return shipments where the shipment mode contains this value
         * @param {string} [nameContains] Return shipments where the shipment name contains this value
         * @param {boolean} [open] Filter on whether or not a shipment is open
         * @param {string} [originContains] Return shipments with this value in the origin
         * @param {string} [originStateProvince] Return shipments with this state province on its origin stop
         * @param {string} [pickupStopsStateProvince] Return shipments with this state province on its pickup stops
         * @param {string} [pickupStopsContains] Return shipments with this value in one of its pickup stops
         * @param {string} [pickupStopsCompanyNameContains] Return shipments with this value in one of its pickup stops location company_name
         * @param {Array<'CANCELLED' | 'DELAYED' | 'DELIVERED' | 'IN_TRANSIT' | 'NOT_SCHEDULED' | 'SCHEDULED'>} [parcelPickupStatus] Include shipments where the parcel pickup status equals one of these values
         * @param {string} [pickupGte] Return shipments with a pickup stop with a planned date greater than or equal to this value
         * @param {string} [pickupLte] Return shipments with a pickup stop with a planned date less than or equal to this value
         * @param {string} [pickupId] Include shipments currently associated with the provided ShipmentPickup\&#39;s ID
         * @param {Array<string>} [pickupNumber] Include shipments with these Pickup Numbers
         * @param {string} [pickupNumberContains] Include shipments where the Pickup Number contains this value
         * @param {Array<string>} [pickupNumberExclude] Exclude shipments with these Pickup Numbers
         * @param {Array<string>} [proNumber] Include shipments with these PRO Numbers
         * @param {string} [proNumberContains] Return shipments where the PRO number contains this value
         * @param {Array<string>} [proNumberExclude] Exclude shipments with these PRO Numbers
         * @param {string} [powerUnit] Return shipments where this power unit is assigned
         * @param {Array<string>} [purchaseOrderNumber] Include shipments with these PO Numbers
         * @param {string} [purchaseOrderNumberContains] Include shipments where the PO number contains this value
         * @param {Array<string>} [purchaseOrderNumberExclude] Exclude shipments with these PO Numbers
         * @param {Array<string>} [referenceId] Include shipments with these Reference IDs
         * @param {string} [referenceIdContains] Include shipments where the reference ID contains this value
         * @param {Array<string>} [referenceIdExclude] Exclude shipments with these Reference IDs
         * @param {Array<string>} [masterAirWaybill] Include shipments with these Master Air Waybill Numbers
         * @param {string} [masterAirWaybillContains] Include shipments where the Master Air Waybill number contains this value
         * @param {Array<string>} [houseAirWaybill] Include shipments with these House Air Waybill Numbers
         * @param {string} [houseAirWaybillContains] Include shipments where the House Air Waybill number contains this value
         * @param {Array<string>} [reps] Include shipments with these reps
         * @param {'owner_operator'} [role] Get results based on a specific perspective such as owner_operator
         * @param {string} [serviceLevel] Return shipments with this service level
         * @param {string} [shipmentId] The id of the shipment
         * @param {Array<string>} [accessorials] Include only shipments with at least one matching ShipmentAccessorial
         * @param {string} [createdAtGte] Include shipments where created_at is greater than or equal to the time value
         * @param {string} [createdAtLte] Include shipments where created_at is less than or equal to this value
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [statusExclude] Exclude shipments with these statuses
         * @param {string} [statusContains] Include shipments where the status contains this string
         * @param {Array<string>} [tags] Include only shipments with at least one matching ShipmentTag
         * @param {string} [stopsContains] Return shipments with this value in one of its stops
         * @param {string} [stopsCompanyNameContains] Return shipments with this value in one of its stops location company_name
         * @param {string} [stopsStateProvince] Return shipments with this state province on one of its stops
         * @param {string} [timelineLastUpdatedAtGte] Return shipments where last timeline update was greater than or equal to the value or was never updated
         * @param {string} [timelineLastUpdatedAtLte] Return shipments where last timeline update was less than or equal to the value or was never updated
         * @param {'current' | 'upcoming' | 'active' | 'past'} [timeFrame] Return shipments that are within the given time frame. active &#x3D; current + upcoming
         * @param {number} [totalMilesGte] Return shipments with total miles greater than or equal to this value
         * @param {number} [totalMilesLte] Return shipments with total miles less than or equal to this value
         * @param {string} [upsAccount] Return pickups specific to this UPS account
         * @param {string} [vendorId] Return shipments with this exact value as the vendor Carrier id
         * @param {string} [vendorContains] Return shipments where the vendor company name contains this value
         * @param {number} [totalWeightOverrideGte] Return shipments with weight greater than or equal to this value
         * @param {number} [totalWeightOverrideLte] Return shipments with weight less than or equal to this value
         * @param {number} [originRadius] Radius from origin stop
         * @param {number} [originLat] Latitude of location to filter on for origin stop
         * @param {number} [originLon] Longitude of location to filter on for origin stop
         * @param {number} [pickupRadius] Radius from a pickup stop
         * @param {number} [pickupLat] Latitude of location to filter on for pickup stop
         * @param {number} [pickupLon] Longitude of location to filter on for pickup stop
         * @param {number} [destinationRadius] Radius from the destination stop
         * @param {number} [destinationLat] Latitude of location to filter on for destination stop
         * @param {number} [destinationLon] Longitude of location to filter on for destination stop
         * @param {number} [deliveryRadius] Radius from a delivery stop
         * @param {number} [deliveryLat] Latitude of location to filter on for delivery stop
         * @param {number} [deliveryLon] Longitude of location to filter on for delivery stop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardShipmentsGet: function (page, pageSize, ordering, q, activeVendorAssignment, alerts, alertConfigurationId, alertShipments, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, shipmentId, accessorials, createdAtGte, createdAtLte, status, statusExclude, statusContains, tags, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiAlertsDashboardShipmentsGet(page, pageSize, ordering, q, activeVendorAssignment, alerts, alertConfigurationId, alertShipments, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, shipmentId, accessorials, createdAtGte, createdAtLte, status, statusExclude, statusContains, tags, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a Slim Shipment for Alerts Dashboard
         * @param {string} shipmentId The id of the shipment
         * @param {boolean} [resolvedAlerts] If true, return user resolved alert events instead of active ones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardShipmentsShipmentIdGet: function (shipmentId, resolvedAlerts, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiAlertsDashboardShipmentsShipmentIdGet(shipmentId, resolvedAlerts, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a EmailNotificationTypes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiEmailNotificationsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiEmailNotificationsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Send an email
         * @param {EmailNotificationRequest} emailNotificationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiEmailNotificationsPost: function (emailNotificationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiEmailNotificationsPost(emailNotificationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a list of unique product categories for the authenticated user\'s company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiFilteredProductsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiFilteredProductsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a LegacyShipmentStage from a V3 shipment. Also cancel and archive the LegacyShipment.
         * @param {RemoveLegacyShipmentStageRequest} removeLegacyShipmentStageRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiLegacyShipmentsRemoveLegacyShipmentStagePost: function (removeLegacyShipmentStageRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiLegacyShipmentsRemoveLegacyShipmentStagePost(removeLegacyShipmentStageRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Request updated insurance information from a carrier
         * @param {UpdatedInsuranceRequest} [updatedInsuranceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiRequestUpdatedInsurancePost: function (updatedInsuranceRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiRequestUpdatedInsurancePost(updatedInsuranceRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Return data for the settlements dashboard delivered
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [limit]
         * @param {string} [q] search query
         * @param {'SERVICE_PROVIDER' | 'BOOKING_PARTY'} [role] Filter invoices based on role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiSettlementsDashboardDeliveredGet: function (page, limit, q, role, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiSettlementsDashboardDeliveredGet(page, limit, q, role, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Return data for the settlements dashboard
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [limit]
         * @param {string} [invoiceableId] only include settlements invoices where there is an invoiceable, and it matches the provided ID
         * @param {string} [status] only include settlements invoices where there is a status, and it matches the provided value
         * @param {string} [statusIn] only include settlements invoices where the status matches the provided statuses
         * @param {string} [invoiceableReferenceNumber] only include settlements invoices where there is a invoiceable_reference_number, and it matches the provided value
         * @param {string} [invoiceSource] only include settlements invoices where there is a invoice_source, and it matches the provided value
         * @param {string} [serviceProviderName] only include settlements invoices where there is a service_provider_name, and it matches the provided value
         * @param {string} [serviceProviderNameContains] Filter Freight Invoices by service provider name.
         * @param {string} [invoiceNumber] only include settlements invoices where there is a invoice_number, and it matches the provided value
         * @param {string} [remitToName] only include settlements invoices that have a remit to and there is a name that matches the provided value
         * @param {string} [search] search query
         * @param {'SERVICE_PROVIDER' | 'BOOKING_PARTY'} [role] Filter invoices based on role
         * @param {string} [orderBy] Order Freight Invoices by the fields provided.
         * @param {string} [subStatusesSubStatus] Filter Freight Invoices by substatus value.
         * @param {string} [subStatusesSubStatusIn] Filter Freight Invoices by substatus values.
         * @param {string} [stopsAddress] Filter Freight Invoices by stops address.
         * @param {string} [stopsAddressContains] Filter Freight Invoices by stops address.
         * @param {string} [stopsCompanyName] Filter Freight Invoices by stops company name.
         * @param {string} [stopsCompanyNameContains] Filter Freight Invoices by stops company name.
         * @param {string} [stopsCompanyNameIn] Filter Freight Invoices by stops company name.
         * @param {string} [invoiceableMode] Filter Freight Invoices by invoiceable mode.
         * @param {string} [invoiceableModeIn] Filter Freight Invoices by invoiceable mode.
         * @param {string} [invoiceableShipwellCustomDataId] Filter Freight Invoices by invoiceable shipwell custom data id.
         * @param {string} [invoiceableShipwellCustomDataValue] Filter Freight Invoices by invoiceable shipwell custom data value.
         * @param {string} [dueDate] Filter Freight Invoices by due date.
         * @param {string} [dueDateLt] Filter Freight Invoices by due date.
         * @param {string} [dueDateLte] Filter Freight Invoices by due date.
         * @param {string} [dueDateGt] Filter Freight Invoices by due date.
         * @param {string} [dueDateGte] Filter Freight Invoices by due date.
         * @param {string} [invoiceDate] Filter Freight Invoices by invoice date.
         * @param {string} [invoiceDateLt] Filter Freight Invoices by invoice date.
         * @param {string} [invoiceDateLte] Filter Freight Invoices by invoice date.
         * @param {string} [invoiceDateGt] Filter Freight Invoices by invoice date.
         * @param {string} [invoiceDateGte] Filter Freight Invoices by invoice date.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiSettlementsDashboardGet: function (page, limit, invoiceableId, status, statusIn, invoiceableReferenceNumber, invoiceSource, serviceProviderName, serviceProviderNameContains, invoiceNumber, remitToName, search, role, orderBy, subStatusesSubStatus, subStatusesSubStatusIn, stopsAddress, stopsAddressContains, stopsCompanyName, stopsCompanyNameContains, stopsCompanyNameIn, invoiceableMode, invoiceableModeIn, invoiceableShipwellCustomDataId, invoiceableShipwellCustomDataValue, dueDate, dueDateLt, dueDateLte, dueDateGt, dueDateGte, invoiceDate, invoiceDateLt, invoiceDateLte, invoiceDateGt, invoiceDateGte, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiSettlementsDashboardGet(page, limit, invoiceableId, status, statusIn, invoiceableReferenceNumber, invoiceSource, serviceProviderName, serviceProviderNameContains, invoiceNumber, remitToName, search, role, orderBy, subStatusesSubStatus, subStatusesSubStatusIn, stopsAddress, stopsAddressContains, stopsCompanyName, stopsCompanyNameContains, stopsCompanyNameIn, invoiceableMode, invoiceableModeIn, invoiceableShipwellCustomDataId, invoiceableShipwellCustomDataValue, dueDate, dueDateLt, dueDateLte, dueDateGt, dueDateGte, invoiceDate, invoiceDateLt, invoiceDateLte, invoiceDateGt, invoiceDateGte, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve list of Shipment Document Type short names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShipmentDocTypesShortNamesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiShipmentDocTypesShortNamesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Allows a PhonePin user using the mobile app to create a StopAlert without having to specify the next Stop
         * @param {string} shipmentId The id of the shipment
         * @param {StopAlert} stopAlert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShipmentIdReportAProblemPost: function (shipmentId, stopAlert, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiShipmentIdReportAProblemPost(shipmentId, stopAlert, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of metadata alerts for a given shipment id list
         * @param {ShipmentIdsAlertMetadata} [shipmentIdsAlertMetadata] ## List of shipment ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShipmentMetadataAlertsPost: function (shipmentIdsAlertMetadata, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiShipmentMetadataAlertsPost(shipmentIdsAlertMetadata, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Check carrier insurance
         * @param {string} shipmentId The id of the shipment
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShipmentShipmentIdCarrierRelationshipCarrierRelationshipIdCheckCarrierInsuranceGet: function (shipmentId, carrierRelationshipId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiShipmentShipmentIdCarrierRelationshipCarrierRelationshipIdCheckCarrierInsuranceGet(shipmentId, carrierRelationshipId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns current bill-to information.
         * @param {string} shipmentId The id of the shipment
         * @param {string} [quote] The id of the quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShipmentsShipmentIdBillToGet: function (shipmentId, quote, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiShipmentsShipmentIdBillToGet(shipmentId, quote, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Consolidates line items in a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {ItemConsolidation} [itemConsolidation] Consolidate line items into a Shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShipmentsShipmentIdConsolidateLineItemsPost: function (shipmentId, itemConsolidation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiShipmentsShipmentIdConsolidateLineItemsPost(shipmentId, itemConsolidation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns status for shipments by their shipment id
         * @param {Array<string>} [shipmentId] Shipment ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShipmentsStatusGet: function (shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiShipmentsStatusGet(shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a list of V3 shipping dashboard rows (includes V2 Shipments, V3 Legs, and V3 Shipment Services)
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [activeVendorAssignment] Include or exclude shipments with active CarrierAssignments
         * @param {'MOBILE_DEVICE_ALERT' | 'NON_ACTIVE_CARRIER'} [alertTypes] Filter on shipments that have alerts of this type
         * @param {boolean} [alerts] Filter on whether or not a Shipment has alert messages
         * @param {boolean} [archived] Filter on whether or not a shipment is archived
         * @param {Array<string>} [bolNumber] Include shipments with these BOL Numbers
         * @param {string} [bolNumberContains] Return shipments where the BOL number contains this value
         * @param {Array<string>} [bolNumberExclude] Exclude shipments with these BOL Numbers
         * @param {string} [createdAt] For requesting data created at a certain datetime
         * @param {Array<'SHIPWELL_WEB' | 'IMPORT' | 'TENDER' | 'SHIPWELL_WEB_UNAUTH' | 'OTHER'>} [createdBySource] Return shipments created by sources in the array.
         * @param {string} [createdByUserContains] Return shipments where created_by_user object contains this string e.g first_name, last_name or email
         * @param {Array<string>} [createdByUserId] Return shipments where created_by_user_id in the array.
         * @param {string} [createdByUserName] Return shipments where created_by_user_name is exactly this string
         * @param {string} [createdByUserNameContains] Return shipments where created_by_user_name contains this string
         * @param {string} [customer] Return shipments with this exact value as the customer company name
         * @param {string} [customerContains] Return shipments where the customer company name contains this value
         * @param {string} [customerId] Return shipments with this exact id for the customer company
         * @param {Array<string>} [customerReferenceNumber] Include shipments with these Customer Reference Numbers
         * @param {string} [customerReferenceNumberContains] Include shipments where the Customer Reference Numbers contains this value
         * @param {Array<string>} [customerReferenceNumberExclude] Exclude shipments with these Customer Reference Numbers
         * @param {string} [destinationContains] Return shipments with this value in the destination
         * @param {string} [deliveryStopsContains] Return shipments with this value in one of its dropoff stops
         * @param {string} [deliveryStopsCompanyNameContains] Return shipments with this value in one of its delivery stops location company_name
         * @param {string} [destinationStateProvince] Return shipments with this state province on its destination stop
         * @param {string} [deliveryStopsStateProvince] Return shipments with this state province on its delivery stops
         * @param {string} [drayageBookingNumberContains] Include shipments where the drayage booking number contains this value
         * @param {string} [drayageChassisNumberContains] Include shipments where the drayage chassis number contains this value
         * @param {string} [drayageContainerNumberContains] Include shipments where the drayage container number contains this value
         * @param {string} [drayageContainerReturnDateGte] Include shipments where the drayage container return date is greater than or equal to this value
         * @param {string} [drayageContainerReturnDateLte] Include shipments where the drayage container return date is less than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateGte] Include shipments where the drayage estimated arrival date is greater than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateLte] Include shipments where the drayage estimated arrival date is less than or equal to this value
         * @param {string} [drayageLastFreeDateGte] Include shipments where the drayage last free datetime is greater than or equal to this value
         * @param {string} [drayageLastFreeDateLte] Include shipments where the drayage last free datetime is less than or equal to this value
         * @param {string} [drayageReleaseDateGte] Include shipments where the drayage release datetime is greater than or equal to this value
         * @param {string} [drayageReleaseDateLte] Include shipments where the drayage release datetime is less than or equal to this value
         * @param {string} [drayageSealNumberContains] Include shipments where the drayage seal number contains this value
         * @param {boolean} [driverAssigned] Return shipments where the driver is assigned/unassigned
         * @param {string} [dropoffGte] Return shipments with a dropoff stop with a planned date greater than or equal to this value
         * @param {string} [dropoffLte] Return shipments with a dropoff stop with a planned data less than or equal to this value
         * @param {string} [equipmentType] Return shipments with this equipment type
         * @param {string} [equipmentTypeContains] Return shipments where the equipment type contains this value
         * @param {string} [fedexAccount] Return pickups specific to this FedEx account
         * @param {string} [groupId] Group id for a shipment
         * @param {boolean} [hasInvoice] If true, show shipments which have at least one invoice otherwise show those with none.
         * @param {boolean} [hasBill] If true, show shipments which have at least one bill otherwise show those with none.
         * @param {Array<string>} [include] [v3] A list of properties to include in the response resource
         * @param {boolean} [loadBoardEnabled] Filter on whether or not a shipment is posted on the company load board
         * @param {string} [loadBoardId] Return shipments where the load board ID is equal to this value
         * @param {string} [loadBoardIdContains] Return shipments where the load board ID contains this value
         * @param {string} [mode] Return shipments with this shipment mode
         * @param {string} [modeContains] Return shipments where the shipment mode contains this value
         * @param {string} [nameContains] Return shipments where the shipment name contains this value
         * @param {boolean} [open] Filter on whether or not a shipment is open
         * @param {string} [originContains] Return shipments with this value in the origin
         * @param {string} [originStateProvince] Return shipments with this state province on its origin stop
         * @param {string} [pickupStopsStateProvince] Return shipments with this state province on its pickup stops
         * @param {string} [pickupStopsContains] Return shipments with this value in one of its pickup stops
         * @param {string} [pickupStopsCompanyNameContains] Return shipments with this value in one of its pickup stops location company_name
         * @param {Array<'CANCELLED' | 'DELAYED' | 'DELIVERED' | 'IN_TRANSIT' | 'NOT_SCHEDULED' | 'SCHEDULED'>} [parcelPickupStatus] Include shipments where the parcel pickup status equals one of these values
         * @param {string} [pickupGte] Return shipments with a pickup stop with a planned date greater than or equal to this value
         * @param {string} [pickupLte] Return shipments with a pickup stop with a planned date less than or equal to this value
         * @param {string} [pickupId] Include shipments currently associated with the provided ShipmentPickup\&#39;s ID
         * @param {Array<string>} [pickupNumber] Include shipments with these Pickup Numbers
         * @param {string} [pickupNumberContains] Include shipments where the Pickup Number contains this value
         * @param {Array<string>} [pickupNumberExclude] Exclude shipments with these Pickup Numbers
         * @param {Array<string>} [proNumber] Include shipments with these PRO Numbers
         * @param {string} [proNumberContains] Return shipments where the PRO number contains this value
         * @param {Array<string>} [proNumberExclude] Exclude shipments with these PRO Numbers
         * @param {string} [powerUnit] Return shipments where this power unit is assigned
         * @param {string} [powerUnitName] PowerUnit name to query on
         * @param {Array<string>} [purchaseOrderNumber] Include shipments with these PO Numbers
         * @param {string} [purchaseOrderNumberContains] Include shipments where the PO number contains this value
         * @param {Array<string>} [purchaseOrderNumberExclude] Exclude shipments with these PO Numbers
         * @param {Array<string>} [referenceId] Include shipments with these Reference IDs
         * @param {string} [referenceIdContains] Include shipments where the reference ID contains this value
         * @param {Array<string>} [referenceIdExclude] Exclude shipments with these Reference IDs
         * @param {Array<string>} [masterAirWaybill] Include shipments with these Master Air Waybill Numbers
         * @param {string} [masterAirWaybillContains] Include shipments where the Master Air Waybill number contains this value
         * @param {Array<string>} [houseAirWaybill] Include shipments with these House Air Waybill Numbers
         * @param {string} [houseAirWaybillContains] Include shipments where the House Air Waybill number contains this value
         * @param {Array<string>} [reps] Include shipments with these reps
         * @param {'owner_operator'} [role] Get results based on a specific perspective such as owner_operator
         * @param {string} [serviceLevel] Return shipments with this service level
         * @param {Array<string>} [accessorials] Include only shipments with at least one matching ShipmentAccessorial
         * @param {string} [createdAtGte] Include shipments where created_at is greater than or equal to the time value
         * @param {string} [createdAtLte] Include shipments where created_at is less than or equal to this value
         * @param {Array<string>} [shipmentShipwellCustomData] Include shipments that contain these shipment-level custom data values
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [statusExclude] Exclude shipments with these statuses
         * @param {string} [statusContains] Include shipments where the status contains this string
         * @param {Array<string>} [tags] Include only shipments with at least one matching ShipmentTag
         * @param {Array<string>} [tagsExclude] Excludes shipments with at least one matching tag
         * @param {string} [stopsContains] Return shipments with this value in one of its stops
         * @param {string} [stopsCompanyNameContains] Return shipments with this value in one of its stops location company_name
         * @param {string} [stopsStateProvince] Return shipments with this state province on one of its stops
         * @param {string} [timelineLastUpdatedAtGte] Return shipments where last timeline update was greater than or equal to the value or was never updated
         * @param {string} [timelineLastUpdatedAtLte] Return shipments where last timeline update was less than or equal to the value or was never updated
         * @param {'current' | 'upcoming' | 'active' | 'past'} [timeFrame] Return shipments that are within the given time frame. active &#x3D; current + upcoming
         * @param {number} [totalMilesGte] Return shipments with total miles greater than or equal to this value
         * @param {number} [totalMilesLte] Return shipments with total miles less than or equal to this value
         * @param {string} [upsAccount] Return pickups specific to this UPS account
         * @param {string} [vendorId] Return shipments with this exact value as the vendor Carrier id
         * @param {string} [vendorContains] Return shipments where the vendor company name contains this value
         * @param {number} [totalWeightOverrideGte] Return shipments with weight greater than or equal to this value
         * @param {number} [totalWeightOverrideLte] Return shipments with weight less than or equal to this value
         * @param {number} [originRadius] Radius from origin stop
         * @param {number} [originLat] Latitude of location to filter on for origin stop
         * @param {number} [originLon] Longitude of location to filter on for origin stop
         * @param {number} [pickupRadius] Radius from a pickup stop
         * @param {number} [pickupLat] Latitude of location to filter on for pickup stop
         * @param {number} [pickupLon] Longitude of location to filter on for pickup stop
         * @param {number} [destinationRadius] Radius from the destination stop
         * @param {number} [destinationLat] Latitude of location to filter on for destination stop
         * @param {number} [destinationLon] Longitude of location to filter on for destination stop
         * @param {number} [deliveryRadius] Radius from a delivery stop
         * @param {number} [deliveryLat] Latitude of location to filter on for delivery stop
         * @param {number} [deliveryLon] Longitude of location to filter on for delivery stop
         * @param {Array<'RUNNING' | 'CANCELLED' | 'FAILED' | 'SUCCESS'>} [workflowExecutionStatus] Include shipments with these workflow execution statuses
         * @param {Array<'open' | 'accepted' | 'rejected' | 'revoked' | 'expired' | 'updated'>} [tenderStatus] Tender status on the shipment
         * @param {boolean} [optimized] Whether or not to explicitly use the optimized backend flows for data retrieval
         * @param {boolean} [showClonedResults] If true, show shipments that have a non null last_cloned_at value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShippingDashboardGet: function (page, pageSize, ordering, q, activeVendorAssignment, alertTypes, alerts, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, powerUnitName, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, accessorials, createdAtGte, createdAtLte, shipmentShipwellCustomData, status, statusExclude, statusContains, tags, tagsExclude, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, workflowExecutionStatus, tenderStatus, optimized, showClonedResults, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiShippingDashboardGet(page, pageSize, ordering, q, activeVendorAssignment, alertTypes, alerts, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, powerUnitName, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, accessorials, createdAtGte, createdAtLte, shipmentShipwellCustomData, status, statusExclude, statusContains, tags, tagsExclude, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, workflowExecutionStatus, tenderStatus, optimized, showClonedResults, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Summarize all stages associated with the provided V3Shipment IDs
         * @param {MultiModeSummariesRequest} multiModeSummariesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShippingDashboardMultiModeSummariesPost: function (multiModeSummariesRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiShippingDashboardMultiModeSummariesPost(multiModeSummariesRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the most current workflow for each shipment id
         * @param {ShippingDashboardShipmentCurrentWorkflowRequest} shippingDashboardShipmentCurrentWorkflowRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShippingDashboardShipmentCurrentWorkflowExecutionsPost: function (shippingDashboardShipmentCurrentWorkflowRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiShippingDashboardShipmentCurrentWorkflowExecutionsPost(shippingDashboardShipmentCurrentWorkflowRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of the current user\'s timeline event templates.
         * @param {string} [search] search query
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTimelineEventTemplatesGet: function (search, page, pageSize, ordering, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiTimelineEventTemplatesGet(search, page, pageSize, ordering, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new TimelineEventTemplate
         * @param {CreateTimelineEventTemplate} createTimelineEventTemplate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTimelineEventTemplatesPost: function (createTimelineEventTemplate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiTimelineEventTemplatesPost(createTimelineEventTemplate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a TimelineEventTemplate
         * @param {string} templateId The id of the timeline event template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTimelineEventTemplatesTemplateIdDelete: function (templateId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiTimelineEventTemplatesTemplateIdDelete(templateId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a timeline event template
         * @param {string} templateId The id of the timeline event template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTimelineEventTemplatesTemplateIdGet: function (templateId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiTimelineEventTemplatesTemplateIdGet(templateId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a TimelineEventTemplate
         * @param {string} templateId The id of the timeline event template
         * @param {CreateTimelineEventTemplate} createTimelineEventTemplate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTimelineEventTemplatesTemplateIdPut: function (templateId, createTimelineEventTemplate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiTimelineEventTemplatesTemplateIdPut(templateId, createTimelineEventTemplate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a ShipmentTimelineFilterPreferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTimelineFilterPreferencesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiTimelineFilterPreferencesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a ShipmentTimelineFilterPreferences
         * @param {ShipmentTimelineFilterPreferences} shipmentTimelineFilterPreferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTimelineFilterPreferencesPut: function (shipmentTimelineFilterPreferences, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiTimelineFilterPreferencesPut(shipmentTimelineFilterPreferences, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of available email templates for Tracking Failed Compass alert emails.
         * @param {string} [search] search query
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTrackingFailedEmailTemplatesGet: function (search, page, pageSize, ordering, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiTrackingFailedEmailTemplatesGet(search, page, pageSize, ordering, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Send an email alert to the carrier
         * @param {TrackingFailedEmailRequest} [trackingFailedEmailRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTrackingFailedEmailTemplatesSendEmailPost: function (trackingFailedEmailRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiTrackingFailedEmailTemplatesSendEmailPost(trackingFailedEmailRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a ShipwellUserPreferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiUserPreferencesGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiUserPreferencesGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a ShipwellUserPreferences
         * @param {UserPreferences} userPreferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiUserPreferencesPut: function (userPreferences, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiUserPreferencesPut(userPreferences, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Stop watching a Shipment
         * @param {InlineObject26} inlineObject26
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiUserWatchedShipmentsDelete: function (inlineObject26, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiUserWatchedShipmentsDelete(inlineObject26, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve shipment ids being watched by user
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiUserWatchedShipmentsGet: function (page, pageSize, ordering, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiUserWatchedShipmentsGet(page, pageSize, ordering, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Start watching a Shipment
         * @param {InlineObject25} inlineObject25
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiUserWatchedShipmentsPost: function (inlineObject25, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiUserWatchedShipmentsPost(inlineObject25, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ShipwellUiApiFp = ShipwellUiApiFp;
/**
 * ShipwellUiApi - factory interface
 * @export
 */
var ShipwellUiApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ShipwellUiApiFp)(configuration);
    return {
        /**
         *
         * @summary Get a Slim Carrier Relationship for Alerts Dashboard
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {boolean} [resolvedAlerts] If true, return user resolved alert events instead of active ones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardCarrierRelationshipsCarrierRelationshipIdGet: function (carrierRelationshipId, resolvedAlerts, options) {
            return localVarFp.shipwellUiAlertsDashboardCarrierRelationshipsCarrierRelationshipIdGet(carrierRelationshipId, resolvedAlerts, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve alert count and shipment ids for particular alerts dashboard configuration
         * @param {string} alertsDashboardConfigurationId The id of the alerts dashboard configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdAlertCountGet: function (alertsDashboardConfigurationId, options) {
            return localVarFp.shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdAlertCountGet(alertsDashboardConfigurationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete an alerts dashboard configuration
         * @param {string} alertsDashboardConfigurationId The id of the alerts dashboard configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdDelete: function (alertsDashboardConfigurationId, options) {
            return localVarFp.shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdDelete(alertsDashboardConfigurationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve an alerts dashboard configuration
         * @param {string} alertsDashboardConfigurationId The id of the alerts dashboard configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdGet: function (alertsDashboardConfigurationId, options) {
            return localVarFp.shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdGet(alertsDashboardConfigurationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update configurations for a user\'s company
         * @param {string} alertsDashboardConfigurationId The id of the alerts dashboard configuration
         * @param {AlertsDashBoardConfiguration} alertsDashBoardConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdPut: function (alertsDashboardConfigurationId, alertsDashBoardConfiguration, options) {
            return localVarFp.shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdPut(alertsDashboardConfigurationId, alertsDashBoardConfiguration, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update configurations for a user\'s company
         * @param {Array<AlertsDashBoardConfiguration>} alertsDashBoardConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardConfigurationBulkUpdatePut: function (alertsDashBoardConfiguration, options) {
            return localVarFp.shipwellUiAlertsDashboardConfigurationBulkUpdatePut(alertsDashBoardConfiguration, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve configurations for a user\'s company
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardConfigurationGet: function (page, pageSize, ordering, options) {
            return localVarFp.shipwellUiAlertsDashboardConfigurationGet(page, pageSize, ordering, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve available configuration options
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardConfigurationOptionsGet: function (options) {
            return localVarFp.shipwellUiAlertsDashboardConfigurationOptionsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update configurations for a user\'s company
         * @param {AlertsDashBoardConfiguration} alertsDashBoardConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardConfigurationPost: function (alertsDashBoardConfiguration, options) {
            return localVarFp.shipwellUiAlertsDashboardConfigurationPost(alertsDashBoardConfiguration, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve shipments for alerts dashboard
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [activeVendorAssignment] Include or exclude shipments with active CarrierAssignments
         * @param {boolean} [alerts] Filter on whether or not a Shipment has alert messages
         * @param {string} [alertConfigurationId] Return shipments that match this alert configuration definition
         * @param {boolean} [alertShipments] Return shipments that match active alert configurations
         * @param {boolean} [archived] Filter on whether or not a shipment is archived
         * @param {Array<string>} [bolNumber] Include shipments with these BOL Numbers
         * @param {string} [bolNumberContains] Return shipments where the BOL number contains this value
         * @param {Array<string>} [bolNumberExclude] Exclude shipments with these BOL Numbers
         * @param {string} [createdAt] For requesting data created at a certain datetime
         * @param {Array<'SHIPWELL_WEB' | 'IMPORT' | 'TENDER' | 'SHIPWELL_WEB_UNAUTH' | 'OTHER'>} [createdBySource] Return shipments created by sources in the array.
         * @param {string} [createdByUserContains] Return shipments where created_by_user object contains this string e.g first_name, last_name or email
         * @param {Array<string>} [createdByUserId] Return shipments where created_by_user_id in the array.
         * @param {string} [createdByUserName] Return shipments where created_by_user_name is exactly this string
         * @param {string} [createdByUserNameContains] Return shipments where created_by_user_name contains this string
         * @param {string} [customer] Return shipments with this exact value as the customer company name
         * @param {string} [customerContains] Return shipments where the customer company name contains this value
         * @param {string} [customerId] Return shipments with this exact id for the customer company
         * @param {Array<string>} [customerReferenceNumber] Include shipments with these Customer Reference Numbers
         * @param {string} [customerReferenceNumberContains] Include shipments where the Customer Reference Numbers contains this value
         * @param {Array<string>} [customerReferenceNumberExclude] Exclude shipments with these Customer Reference Numbers
         * @param {string} [destinationContains] Return shipments with this value in the destination
         * @param {string} [deliveryStopsContains] Return shipments with this value in one of its dropoff stops
         * @param {string} [deliveryStopsCompanyNameContains] Return shipments with this value in one of its delivery stops location company_name
         * @param {string} [destinationStateProvince] Return shipments with this state province on its destination stop
         * @param {string} [deliveryStopsStateProvince] Return shipments with this state province on its delivery stops
         * @param {string} [drayageBookingNumberContains] Include shipments where the drayage booking number contains this value
         * @param {string} [drayageChassisNumberContains] Include shipments where the drayage chassis number contains this value
         * @param {string} [drayageContainerNumberContains] Include shipments where the drayage container number contains this value
         * @param {string} [drayageContainerReturnDateGte] Include shipments where the drayage container return date is greater than or equal to this value
         * @param {string} [drayageContainerReturnDateLte] Include shipments where the drayage container return date is less than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateGte] Include shipments where the drayage estimated arrival date is greater than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateLte] Include shipments where the drayage estimated arrival date is less than or equal to this value
         * @param {string} [drayageLastFreeDateGte] Include shipments where the drayage last free datetime is greater than or equal to this value
         * @param {string} [drayageLastFreeDateLte] Include shipments where the drayage last free datetime is less than or equal to this value
         * @param {string} [drayageReleaseDateGte] Include shipments where the drayage release datetime is greater than or equal to this value
         * @param {string} [drayageReleaseDateLte] Include shipments where the drayage release datetime is less than or equal to this value
         * @param {string} [drayageSealNumberContains] Include shipments where the drayage seal number contains this value
         * @param {boolean} [driverAssigned] Return shipments where the driver is assigned/unassigned
         * @param {string} [dropoffGte] Return shipments with a dropoff stop with a planned date greater than or equal to this value
         * @param {string} [dropoffLte] Return shipments with a dropoff stop with a planned data less than or equal to this value
         * @param {string} [equipmentType] Return shipments with this equipment type
         * @param {string} [equipmentTypeContains] Return shipments where the equipment type contains this value
         * @param {string} [fedexAccount] Return pickups specific to this FedEx account
         * @param {string} [groupId] Group id for a shipment
         * @param {boolean} [hasInvoice] If true, show shipments which have at least one invoice otherwise show those with none.
         * @param {boolean} [hasBill] If true, show shipments which have at least one bill otherwise show those with none.
         * @param {Array<string>} [include] [v3] A list of properties to include in the response resource
         * @param {boolean} [loadBoardEnabled] Filter on whether or not a shipment is posted on the company load board
         * @param {string} [loadBoardId] Return shipments where the load board ID is equal to this value
         * @param {string} [loadBoardIdContains] Return shipments where the load board ID contains this value
         * @param {string} [mode] Return shipments with this shipment mode
         * @param {string} [modeContains] Return shipments where the shipment mode contains this value
         * @param {string} [nameContains] Return shipments where the shipment name contains this value
         * @param {boolean} [open] Filter on whether or not a shipment is open
         * @param {string} [originContains] Return shipments with this value in the origin
         * @param {string} [originStateProvince] Return shipments with this state province on its origin stop
         * @param {string} [pickupStopsStateProvince] Return shipments with this state province on its pickup stops
         * @param {string} [pickupStopsContains] Return shipments with this value in one of its pickup stops
         * @param {string} [pickupStopsCompanyNameContains] Return shipments with this value in one of its pickup stops location company_name
         * @param {Array<'CANCELLED' | 'DELAYED' | 'DELIVERED' | 'IN_TRANSIT' | 'NOT_SCHEDULED' | 'SCHEDULED'>} [parcelPickupStatus] Include shipments where the parcel pickup status equals one of these values
         * @param {string} [pickupGte] Return shipments with a pickup stop with a planned date greater than or equal to this value
         * @param {string} [pickupLte] Return shipments with a pickup stop with a planned date less than or equal to this value
         * @param {string} [pickupId] Include shipments currently associated with the provided ShipmentPickup\&#39;s ID
         * @param {Array<string>} [pickupNumber] Include shipments with these Pickup Numbers
         * @param {string} [pickupNumberContains] Include shipments where the Pickup Number contains this value
         * @param {Array<string>} [pickupNumberExclude] Exclude shipments with these Pickup Numbers
         * @param {Array<string>} [proNumber] Include shipments with these PRO Numbers
         * @param {string} [proNumberContains] Return shipments where the PRO number contains this value
         * @param {Array<string>} [proNumberExclude] Exclude shipments with these PRO Numbers
         * @param {string} [powerUnit] Return shipments where this power unit is assigned
         * @param {Array<string>} [purchaseOrderNumber] Include shipments with these PO Numbers
         * @param {string} [purchaseOrderNumberContains] Include shipments where the PO number contains this value
         * @param {Array<string>} [purchaseOrderNumberExclude] Exclude shipments with these PO Numbers
         * @param {Array<string>} [referenceId] Include shipments with these Reference IDs
         * @param {string} [referenceIdContains] Include shipments where the reference ID contains this value
         * @param {Array<string>} [referenceIdExclude] Exclude shipments with these Reference IDs
         * @param {Array<string>} [masterAirWaybill] Include shipments with these Master Air Waybill Numbers
         * @param {string} [masterAirWaybillContains] Include shipments where the Master Air Waybill number contains this value
         * @param {Array<string>} [houseAirWaybill] Include shipments with these House Air Waybill Numbers
         * @param {string} [houseAirWaybillContains] Include shipments where the House Air Waybill number contains this value
         * @param {Array<string>} [reps] Include shipments with these reps
         * @param {'owner_operator'} [role] Get results based on a specific perspective such as owner_operator
         * @param {string} [serviceLevel] Return shipments with this service level
         * @param {string} [shipmentId] The id of the shipment
         * @param {Array<string>} [accessorials] Include only shipments with at least one matching ShipmentAccessorial
         * @param {string} [createdAtGte] Include shipments where created_at is greater than or equal to the time value
         * @param {string} [createdAtLte] Include shipments where created_at is less than or equal to this value
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [statusExclude] Exclude shipments with these statuses
         * @param {string} [statusContains] Include shipments where the status contains this string
         * @param {Array<string>} [tags] Include only shipments with at least one matching ShipmentTag
         * @param {string} [stopsContains] Return shipments with this value in one of its stops
         * @param {string} [stopsCompanyNameContains] Return shipments with this value in one of its stops location company_name
         * @param {string} [stopsStateProvince] Return shipments with this state province on one of its stops
         * @param {string} [timelineLastUpdatedAtGte] Return shipments where last timeline update was greater than or equal to the value or was never updated
         * @param {string} [timelineLastUpdatedAtLte] Return shipments where last timeline update was less than or equal to the value or was never updated
         * @param {'current' | 'upcoming' | 'active' | 'past'} [timeFrame] Return shipments that are within the given time frame. active &#x3D; current + upcoming
         * @param {number} [totalMilesGte] Return shipments with total miles greater than or equal to this value
         * @param {number} [totalMilesLte] Return shipments with total miles less than or equal to this value
         * @param {string} [upsAccount] Return pickups specific to this UPS account
         * @param {string} [vendorId] Return shipments with this exact value as the vendor Carrier id
         * @param {string} [vendorContains] Return shipments where the vendor company name contains this value
         * @param {number} [totalWeightOverrideGte] Return shipments with weight greater than or equal to this value
         * @param {number} [totalWeightOverrideLte] Return shipments with weight less than or equal to this value
         * @param {number} [originRadius] Radius from origin stop
         * @param {number} [originLat] Latitude of location to filter on for origin stop
         * @param {number} [originLon] Longitude of location to filter on for origin stop
         * @param {number} [pickupRadius] Radius from a pickup stop
         * @param {number} [pickupLat] Latitude of location to filter on for pickup stop
         * @param {number} [pickupLon] Longitude of location to filter on for pickup stop
         * @param {number} [destinationRadius] Radius from the destination stop
         * @param {number} [destinationLat] Latitude of location to filter on for destination stop
         * @param {number} [destinationLon] Longitude of location to filter on for destination stop
         * @param {number} [deliveryRadius] Radius from a delivery stop
         * @param {number} [deliveryLat] Latitude of location to filter on for delivery stop
         * @param {number} [deliveryLon] Longitude of location to filter on for delivery stop
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardShipmentsGet: function (page, pageSize, ordering, q, activeVendorAssignment, alerts, alertConfigurationId, alertShipments, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, shipmentId, accessorials, createdAtGte, createdAtLte, status, statusExclude, statusContains, tags, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, options) {
            return localVarFp.shipwellUiAlertsDashboardShipmentsGet(page, pageSize, ordering, q, activeVendorAssignment, alerts, alertConfigurationId, alertShipments, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, shipmentId, accessorials, createdAtGte, createdAtLte, status, statusExclude, statusContains, tags, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a Slim Shipment for Alerts Dashboard
         * @param {string} shipmentId The id of the shipment
         * @param {boolean} [resolvedAlerts] If true, return user resolved alert events instead of active ones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiAlertsDashboardShipmentsShipmentIdGet: function (shipmentId, resolvedAlerts, options) {
            return localVarFp.shipwellUiAlertsDashboardShipmentsShipmentIdGet(shipmentId, resolvedAlerts, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a EmailNotificationTypes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiEmailNotificationsGet: function (options) {
            return localVarFp.shipwellUiEmailNotificationsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Send an email
         * @param {EmailNotificationRequest} emailNotificationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiEmailNotificationsPost: function (emailNotificationRequest, options) {
            return localVarFp.shipwellUiEmailNotificationsPost(emailNotificationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a list of unique product categories for the authenticated user\'s company
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiFilteredProductsGet: function (options) {
            return localVarFp.shipwellUiFilteredProductsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a LegacyShipmentStage from a V3 shipment. Also cancel and archive the LegacyShipment.
         * @param {RemoveLegacyShipmentStageRequest} removeLegacyShipmentStageRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiLegacyShipmentsRemoveLegacyShipmentStagePost: function (removeLegacyShipmentStageRequest, options) {
            return localVarFp.shipwellUiLegacyShipmentsRemoveLegacyShipmentStagePost(removeLegacyShipmentStageRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Request updated insurance information from a carrier
         * @param {UpdatedInsuranceRequest} [updatedInsuranceRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiRequestUpdatedInsurancePost: function (updatedInsuranceRequest, options) {
            return localVarFp.shipwellUiRequestUpdatedInsurancePost(updatedInsuranceRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Return data for the settlements dashboard delivered
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [limit]
         * @param {string} [q] search query
         * @param {'SERVICE_PROVIDER' | 'BOOKING_PARTY'} [role] Filter invoices based on role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiSettlementsDashboardDeliveredGet: function (page, limit, q, role, options) {
            return localVarFp.shipwellUiSettlementsDashboardDeliveredGet(page, limit, q, role, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Return data for the settlements dashboard
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [limit]
         * @param {string} [invoiceableId] only include settlements invoices where there is an invoiceable, and it matches the provided ID
         * @param {string} [status] only include settlements invoices where there is a status, and it matches the provided value
         * @param {string} [statusIn] only include settlements invoices where the status matches the provided statuses
         * @param {string} [invoiceableReferenceNumber] only include settlements invoices where there is a invoiceable_reference_number, and it matches the provided value
         * @param {string} [invoiceSource] only include settlements invoices where there is a invoice_source, and it matches the provided value
         * @param {string} [serviceProviderName] only include settlements invoices where there is a service_provider_name, and it matches the provided value
         * @param {string} [serviceProviderNameContains] Filter Freight Invoices by service provider name.
         * @param {string} [invoiceNumber] only include settlements invoices where there is a invoice_number, and it matches the provided value
         * @param {string} [remitToName] only include settlements invoices that have a remit to and there is a name that matches the provided value
         * @param {string} [search] search query
         * @param {'SERVICE_PROVIDER' | 'BOOKING_PARTY'} [role] Filter invoices based on role
         * @param {string} [orderBy] Order Freight Invoices by the fields provided.
         * @param {string} [subStatusesSubStatus] Filter Freight Invoices by substatus value.
         * @param {string} [subStatusesSubStatusIn] Filter Freight Invoices by substatus values.
         * @param {string} [stopsAddress] Filter Freight Invoices by stops address.
         * @param {string} [stopsAddressContains] Filter Freight Invoices by stops address.
         * @param {string} [stopsCompanyName] Filter Freight Invoices by stops company name.
         * @param {string} [stopsCompanyNameContains] Filter Freight Invoices by stops company name.
         * @param {string} [stopsCompanyNameIn] Filter Freight Invoices by stops company name.
         * @param {string} [invoiceableMode] Filter Freight Invoices by invoiceable mode.
         * @param {string} [invoiceableModeIn] Filter Freight Invoices by invoiceable mode.
         * @param {string} [invoiceableShipwellCustomDataId] Filter Freight Invoices by invoiceable shipwell custom data id.
         * @param {string} [invoiceableShipwellCustomDataValue] Filter Freight Invoices by invoiceable shipwell custom data value.
         * @param {string} [dueDate] Filter Freight Invoices by due date.
         * @param {string} [dueDateLt] Filter Freight Invoices by due date.
         * @param {string} [dueDateLte] Filter Freight Invoices by due date.
         * @param {string} [dueDateGt] Filter Freight Invoices by due date.
         * @param {string} [dueDateGte] Filter Freight Invoices by due date.
         * @param {string} [invoiceDate] Filter Freight Invoices by invoice date.
         * @param {string} [invoiceDateLt] Filter Freight Invoices by invoice date.
         * @param {string} [invoiceDateLte] Filter Freight Invoices by invoice date.
         * @param {string} [invoiceDateGt] Filter Freight Invoices by invoice date.
         * @param {string} [invoiceDateGte] Filter Freight Invoices by invoice date.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiSettlementsDashboardGet: function (page, limit, invoiceableId, status, statusIn, invoiceableReferenceNumber, invoiceSource, serviceProviderName, serviceProviderNameContains, invoiceNumber, remitToName, search, role, orderBy, subStatusesSubStatus, subStatusesSubStatusIn, stopsAddress, stopsAddressContains, stopsCompanyName, stopsCompanyNameContains, stopsCompanyNameIn, invoiceableMode, invoiceableModeIn, invoiceableShipwellCustomDataId, invoiceableShipwellCustomDataValue, dueDate, dueDateLt, dueDateLte, dueDateGt, dueDateGte, invoiceDate, invoiceDateLt, invoiceDateLte, invoiceDateGt, invoiceDateGte, options) {
            return localVarFp.shipwellUiSettlementsDashboardGet(page, limit, invoiceableId, status, statusIn, invoiceableReferenceNumber, invoiceSource, serviceProviderName, serviceProviderNameContains, invoiceNumber, remitToName, search, role, orderBy, subStatusesSubStatus, subStatusesSubStatusIn, stopsAddress, stopsAddressContains, stopsCompanyName, stopsCompanyNameContains, stopsCompanyNameIn, invoiceableMode, invoiceableModeIn, invoiceableShipwellCustomDataId, invoiceableShipwellCustomDataValue, dueDate, dueDateLt, dueDateLte, dueDateGt, dueDateGte, invoiceDate, invoiceDateLt, invoiceDateLte, invoiceDateGt, invoiceDateGte, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve list of Shipment Document Type short names
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShipmentDocTypesShortNamesGet: function (options) {
            return localVarFp.shipwellUiShipmentDocTypesShortNamesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Allows a PhonePin user using the mobile app to create a StopAlert without having to specify the next Stop
         * @param {string} shipmentId The id of the shipment
         * @param {StopAlert} stopAlert
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShipmentIdReportAProblemPost: function (shipmentId, stopAlert, options) {
            return localVarFp.shipwellUiShipmentIdReportAProblemPost(shipmentId, stopAlert, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a list of metadata alerts for a given shipment id list
         * @param {ShipmentIdsAlertMetadata} [shipmentIdsAlertMetadata] ## List of shipment ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShipmentMetadataAlertsPost: function (shipmentIdsAlertMetadata, options) {
            return localVarFp.shipwellUiShipmentMetadataAlertsPost(shipmentIdsAlertMetadata, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Check carrier insurance
         * @param {string} shipmentId The id of the shipment
         * @param {string} carrierRelationshipId The id of the vendor relationship
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShipmentShipmentIdCarrierRelationshipCarrierRelationshipIdCheckCarrierInsuranceGet: function (shipmentId, carrierRelationshipId, options) {
            return localVarFp.shipwellUiShipmentShipmentIdCarrierRelationshipCarrierRelationshipIdCheckCarrierInsuranceGet(shipmentId, carrierRelationshipId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns current bill-to information.
         * @param {string} shipmentId The id of the shipment
         * @param {string} [quote] The id of the quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShipmentsShipmentIdBillToGet: function (shipmentId, quote, options) {
            return localVarFp.shipwellUiShipmentsShipmentIdBillToGet(shipmentId, quote, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Consolidates line items in a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {ItemConsolidation} [itemConsolidation] Consolidate line items into a Shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShipmentsShipmentIdConsolidateLineItemsPost: function (shipmentId, itemConsolidation, options) {
            return localVarFp.shipwellUiShipmentsShipmentIdConsolidateLineItemsPost(shipmentId, itemConsolidation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns status for shipments by their shipment id
         * @param {Array<string>} [shipmentId] Shipment ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShipmentsStatusGet: function (shipmentId, options) {
            return localVarFp.shipwellUiShipmentsStatusGet(shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a list of V3 shipping dashboard rows (includes V2 Shipments, V3 Legs, and V3 Shipment Services)
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [activeVendorAssignment] Include or exclude shipments with active CarrierAssignments
         * @param {'MOBILE_DEVICE_ALERT' | 'NON_ACTIVE_CARRIER'} [alertTypes] Filter on shipments that have alerts of this type
         * @param {boolean} [alerts] Filter on whether or not a Shipment has alert messages
         * @param {boolean} [archived] Filter on whether or not a shipment is archived
         * @param {Array<string>} [bolNumber] Include shipments with these BOL Numbers
         * @param {string} [bolNumberContains] Return shipments where the BOL number contains this value
         * @param {Array<string>} [bolNumberExclude] Exclude shipments with these BOL Numbers
         * @param {string} [createdAt] For requesting data created at a certain datetime
         * @param {Array<'SHIPWELL_WEB' | 'IMPORT' | 'TENDER' | 'SHIPWELL_WEB_UNAUTH' | 'OTHER'>} [createdBySource] Return shipments created by sources in the array.
         * @param {string} [createdByUserContains] Return shipments where created_by_user object contains this string e.g first_name, last_name or email
         * @param {Array<string>} [createdByUserId] Return shipments where created_by_user_id in the array.
         * @param {string} [createdByUserName] Return shipments where created_by_user_name is exactly this string
         * @param {string} [createdByUserNameContains] Return shipments where created_by_user_name contains this string
         * @param {string} [customer] Return shipments with this exact value as the customer company name
         * @param {string} [customerContains] Return shipments where the customer company name contains this value
         * @param {string} [customerId] Return shipments with this exact id for the customer company
         * @param {Array<string>} [customerReferenceNumber] Include shipments with these Customer Reference Numbers
         * @param {string} [customerReferenceNumberContains] Include shipments where the Customer Reference Numbers contains this value
         * @param {Array<string>} [customerReferenceNumberExclude] Exclude shipments with these Customer Reference Numbers
         * @param {string} [destinationContains] Return shipments with this value in the destination
         * @param {string} [deliveryStopsContains] Return shipments with this value in one of its dropoff stops
         * @param {string} [deliveryStopsCompanyNameContains] Return shipments with this value in one of its delivery stops location company_name
         * @param {string} [destinationStateProvince] Return shipments with this state province on its destination stop
         * @param {string} [deliveryStopsStateProvince] Return shipments with this state province on its delivery stops
         * @param {string} [drayageBookingNumberContains] Include shipments where the drayage booking number contains this value
         * @param {string} [drayageChassisNumberContains] Include shipments where the drayage chassis number contains this value
         * @param {string} [drayageContainerNumberContains] Include shipments where the drayage container number contains this value
         * @param {string} [drayageContainerReturnDateGte] Include shipments where the drayage container return date is greater than or equal to this value
         * @param {string} [drayageContainerReturnDateLte] Include shipments where the drayage container return date is less than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateGte] Include shipments where the drayage estimated arrival date is greater than or equal to this value
         * @param {string} [drayageEstimatedArrivalDateLte] Include shipments where the drayage estimated arrival date is less than or equal to this value
         * @param {string} [drayageLastFreeDateGte] Include shipments where the drayage last free datetime is greater than or equal to this value
         * @param {string} [drayageLastFreeDateLte] Include shipments where the drayage last free datetime is less than or equal to this value
         * @param {string} [drayageReleaseDateGte] Include shipments where the drayage release datetime is greater than or equal to this value
         * @param {string} [drayageReleaseDateLte] Include shipments where the drayage release datetime is less than or equal to this value
         * @param {string} [drayageSealNumberContains] Include shipments where the drayage seal number contains this value
         * @param {boolean} [driverAssigned] Return shipments where the driver is assigned/unassigned
         * @param {string} [dropoffGte] Return shipments with a dropoff stop with a planned date greater than or equal to this value
         * @param {string} [dropoffLte] Return shipments with a dropoff stop with a planned data less than or equal to this value
         * @param {string} [equipmentType] Return shipments with this equipment type
         * @param {string} [equipmentTypeContains] Return shipments where the equipment type contains this value
         * @param {string} [fedexAccount] Return pickups specific to this FedEx account
         * @param {string} [groupId] Group id for a shipment
         * @param {boolean} [hasInvoice] If true, show shipments which have at least one invoice otherwise show those with none.
         * @param {boolean} [hasBill] If true, show shipments which have at least one bill otherwise show those with none.
         * @param {Array<string>} [include] [v3] A list of properties to include in the response resource
         * @param {boolean} [loadBoardEnabled] Filter on whether or not a shipment is posted on the company load board
         * @param {string} [loadBoardId] Return shipments where the load board ID is equal to this value
         * @param {string} [loadBoardIdContains] Return shipments where the load board ID contains this value
         * @param {string} [mode] Return shipments with this shipment mode
         * @param {string} [modeContains] Return shipments where the shipment mode contains this value
         * @param {string} [nameContains] Return shipments where the shipment name contains this value
         * @param {boolean} [open] Filter on whether or not a shipment is open
         * @param {string} [originContains] Return shipments with this value in the origin
         * @param {string} [originStateProvince] Return shipments with this state province on its origin stop
         * @param {string} [pickupStopsStateProvince] Return shipments with this state province on its pickup stops
         * @param {string} [pickupStopsContains] Return shipments with this value in one of its pickup stops
         * @param {string} [pickupStopsCompanyNameContains] Return shipments with this value in one of its pickup stops location company_name
         * @param {Array<'CANCELLED' | 'DELAYED' | 'DELIVERED' | 'IN_TRANSIT' | 'NOT_SCHEDULED' | 'SCHEDULED'>} [parcelPickupStatus] Include shipments where the parcel pickup status equals one of these values
         * @param {string} [pickupGte] Return shipments with a pickup stop with a planned date greater than or equal to this value
         * @param {string} [pickupLte] Return shipments with a pickup stop with a planned date less than or equal to this value
         * @param {string} [pickupId] Include shipments currently associated with the provided ShipmentPickup\&#39;s ID
         * @param {Array<string>} [pickupNumber] Include shipments with these Pickup Numbers
         * @param {string} [pickupNumberContains] Include shipments where the Pickup Number contains this value
         * @param {Array<string>} [pickupNumberExclude] Exclude shipments with these Pickup Numbers
         * @param {Array<string>} [proNumber] Include shipments with these PRO Numbers
         * @param {string} [proNumberContains] Return shipments where the PRO number contains this value
         * @param {Array<string>} [proNumberExclude] Exclude shipments with these PRO Numbers
         * @param {string} [powerUnit] Return shipments where this power unit is assigned
         * @param {string} [powerUnitName] PowerUnit name to query on
         * @param {Array<string>} [purchaseOrderNumber] Include shipments with these PO Numbers
         * @param {string} [purchaseOrderNumberContains] Include shipments where the PO number contains this value
         * @param {Array<string>} [purchaseOrderNumberExclude] Exclude shipments with these PO Numbers
         * @param {Array<string>} [referenceId] Include shipments with these Reference IDs
         * @param {string} [referenceIdContains] Include shipments where the reference ID contains this value
         * @param {Array<string>} [referenceIdExclude] Exclude shipments with these Reference IDs
         * @param {Array<string>} [masterAirWaybill] Include shipments with these Master Air Waybill Numbers
         * @param {string} [masterAirWaybillContains] Include shipments where the Master Air Waybill number contains this value
         * @param {Array<string>} [houseAirWaybill] Include shipments with these House Air Waybill Numbers
         * @param {string} [houseAirWaybillContains] Include shipments where the House Air Waybill number contains this value
         * @param {Array<string>} [reps] Include shipments with these reps
         * @param {'owner_operator'} [role] Get results based on a specific perspective such as owner_operator
         * @param {string} [serviceLevel] Return shipments with this service level
         * @param {Array<string>} [accessorials] Include only shipments with at least one matching ShipmentAccessorial
         * @param {string} [createdAtGte] Include shipments where created_at is greater than or equal to the time value
         * @param {string} [createdAtLte] Include shipments where created_at is less than or equal to this value
         * @param {Array<string>} [shipmentShipwellCustomData] Include shipments that contain these shipment-level custom data values
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [statusExclude] Exclude shipments with these statuses
         * @param {string} [statusContains] Include shipments where the status contains this string
         * @param {Array<string>} [tags] Include only shipments with at least one matching ShipmentTag
         * @param {Array<string>} [tagsExclude] Excludes shipments with at least one matching tag
         * @param {string} [stopsContains] Return shipments with this value in one of its stops
         * @param {string} [stopsCompanyNameContains] Return shipments with this value in one of its stops location company_name
         * @param {string} [stopsStateProvince] Return shipments with this state province on one of its stops
         * @param {string} [timelineLastUpdatedAtGte] Return shipments where last timeline update was greater than or equal to the value or was never updated
         * @param {string} [timelineLastUpdatedAtLte] Return shipments where last timeline update was less than or equal to the value or was never updated
         * @param {'current' | 'upcoming' | 'active' | 'past'} [timeFrame] Return shipments that are within the given time frame. active &#x3D; current + upcoming
         * @param {number} [totalMilesGte] Return shipments with total miles greater than or equal to this value
         * @param {number} [totalMilesLte] Return shipments with total miles less than or equal to this value
         * @param {string} [upsAccount] Return pickups specific to this UPS account
         * @param {string} [vendorId] Return shipments with this exact value as the vendor Carrier id
         * @param {string} [vendorContains] Return shipments where the vendor company name contains this value
         * @param {number} [totalWeightOverrideGte] Return shipments with weight greater than or equal to this value
         * @param {number} [totalWeightOverrideLte] Return shipments with weight less than or equal to this value
         * @param {number} [originRadius] Radius from origin stop
         * @param {number} [originLat] Latitude of location to filter on for origin stop
         * @param {number} [originLon] Longitude of location to filter on for origin stop
         * @param {number} [pickupRadius] Radius from a pickup stop
         * @param {number} [pickupLat] Latitude of location to filter on for pickup stop
         * @param {number} [pickupLon] Longitude of location to filter on for pickup stop
         * @param {number} [destinationRadius] Radius from the destination stop
         * @param {number} [destinationLat] Latitude of location to filter on for destination stop
         * @param {number} [destinationLon] Longitude of location to filter on for destination stop
         * @param {number} [deliveryRadius] Radius from a delivery stop
         * @param {number} [deliveryLat] Latitude of location to filter on for delivery stop
         * @param {number} [deliveryLon] Longitude of location to filter on for delivery stop
         * @param {Array<'RUNNING' | 'CANCELLED' | 'FAILED' | 'SUCCESS'>} [workflowExecutionStatus] Include shipments with these workflow execution statuses
         * @param {Array<'open' | 'accepted' | 'rejected' | 'revoked' | 'expired' | 'updated'>} [tenderStatus] Tender status on the shipment
         * @param {boolean} [optimized] Whether or not to explicitly use the optimized backend flows for data retrieval
         * @param {boolean} [showClonedResults] If true, show shipments that have a non null last_cloned_at value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShippingDashboardGet: function (page, pageSize, ordering, q, activeVendorAssignment, alertTypes, alerts, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, powerUnitName, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, accessorials, createdAtGte, createdAtLte, shipmentShipwellCustomData, status, statusExclude, statusContains, tags, tagsExclude, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, workflowExecutionStatus, tenderStatus, optimized, showClonedResults, options) {
            return localVarFp.shipwellUiShippingDashboardGet(page, pageSize, ordering, q, activeVendorAssignment, alertTypes, alerts, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, powerUnitName, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, accessorials, createdAtGte, createdAtLte, shipmentShipwellCustomData, status, statusExclude, statusContains, tags, tagsExclude, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, workflowExecutionStatus, tenderStatus, optimized, showClonedResults, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Summarize all stages associated with the provided V3Shipment IDs
         * @param {MultiModeSummariesRequest} multiModeSummariesRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShippingDashboardMultiModeSummariesPost: function (multiModeSummariesRequest, options) {
            return localVarFp.shipwellUiShippingDashboardMultiModeSummariesPost(multiModeSummariesRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the most current workflow for each shipment id
         * @param {ShippingDashboardShipmentCurrentWorkflowRequest} shippingDashboardShipmentCurrentWorkflowRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiShippingDashboardShipmentCurrentWorkflowExecutionsPost: function (shippingDashboardShipmentCurrentWorkflowRequest, options) {
            return localVarFp.shipwellUiShippingDashboardShipmentCurrentWorkflowExecutionsPost(shippingDashboardShipmentCurrentWorkflowRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a list of the current user\'s timeline event templates.
         * @param {string} [search] search query
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTimelineEventTemplatesGet: function (search, page, pageSize, ordering, options) {
            return localVarFp.shipwellUiTimelineEventTemplatesGet(search, page, pageSize, ordering, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new TimelineEventTemplate
         * @param {CreateTimelineEventTemplate} createTimelineEventTemplate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTimelineEventTemplatesPost: function (createTimelineEventTemplate, options) {
            return localVarFp.shipwellUiTimelineEventTemplatesPost(createTimelineEventTemplate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a TimelineEventTemplate
         * @param {string} templateId The id of the timeline event template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTimelineEventTemplatesTemplateIdDelete: function (templateId, options) {
            return localVarFp.shipwellUiTimelineEventTemplatesTemplateIdDelete(templateId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about a timeline event template
         * @param {string} templateId The id of the timeline event template
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTimelineEventTemplatesTemplateIdGet: function (templateId, options) {
            return localVarFp.shipwellUiTimelineEventTemplatesTemplateIdGet(templateId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a TimelineEventTemplate
         * @param {string} templateId The id of the timeline event template
         * @param {CreateTimelineEventTemplate} createTimelineEventTemplate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTimelineEventTemplatesTemplateIdPut: function (templateId, createTimelineEventTemplate, options) {
            return localVarFp.shipwellUiTimelineEventTemplatesTemplateIdPut(templateId, createTimelineEventTemplate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a ShipmentTimelineFilterPreferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTimelineFilterPreferencesGet: function (options) {
            return localVarFp.shipwellUiTimelineFilterPreferencesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a ShipmentTimelineFilterPreferences
         * @param {ShipmentTimelineFilterPreferences} shipmentTimelineFilterPreferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTimelineFilterPreferencesPut: function (shipmentTimelineFilterPreferences, options) {
            return localVarFp.shipwellUiTimelineFilterPreferencesPut(shipmentTimelineFilterPreferences, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a list of available email templates for Tracking Failed Compass alert emails.
         * @param {string} [search] search query
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTrackingFailedEmailTemplatesGet: function (search, page, pageSize, ordering, options) {
            return localVarFp.shipwellUiTrackingFailedEmailTemplatesGet(search, page, pageSize, ordering, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Send an email alert to the carrier
         * @param {TrackingFailedEmailRequest} [trackingFailedEmailRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiTrackingFailedEmailTemplatesSendEmailPost: function (trackingFailedEmailRequest, options) {
            return localVarFp.shipwellUiTrackingFailedEmailTemplatesSendEmailPost(trackingFailedEmailRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a ShipwellUserPreferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiUserPreferencesGet: function (options) {
            return localVarFp.shipwellUiUserPreferencesGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a ShipwellUserPreferences
         * @param {UserPreferences} userPreferences
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiUserPreferencesPut: function (userPreferences, options) {
            return localVarFp.shipwellUiUserPreferencesPut(userPreferences, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Stop watching a Shipment
         * @param {InlineObject26} inlineObject26
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiUserWatchedShipmentsDelete: function (inlineObject26, options) {
            return localVarFp.shipwellUiUserWatchedShipmentsDelete(inlineObject26, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve shipment ids being watched by user
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiUserWatchedShipmentsGet: function (page, pageSize, ordering, options) {
            return localVarFp.shipwellUiUserWatchedShipmentsGet(page, pageSize, ordering, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Start watching a Shipment
         * @param {InlineObject25} inlineObject25
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiUserWatchedShipmentsPost: function (inlineObject25, options) {
            return localVarFp.shipwellUiUserWatchedShipmentsPost(inlineObject25, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ShipwellUiApiFactory = ShipwellUiApiFactory;
/**
 * ShipwellUiApi - object-oriented interface
 * @export
 * @class ShipwellUiApi
 * @extends {BaseAPI}
 */
var ShipwellUiApi = /** @class */ (function (_super) {
    __extends(ShipwellUiApi, _super);
    function ShipwellUiApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get a Slim Carrier Relationship for Alerts Dashboard
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {boolean} [resolvedAlerts] If true, return user resolved alert events instead of active ones
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiAlertsDashboardCarrierRelationshipsCarrierRelationshipIdGet = function (carrierRelationshipId, resolvedAlerts, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiAlertsDashboardCarrierRelationshipsCarrierRelationshipIdGet(carrierRelationshipId, resolvedAlerts, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve alert count and shipment ids for particular alerts dashboard configuration
     * @param {string} alertsDashboardConfigurationId The id of the alerts dashboard configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdAlertCountGet = function (alertsDashboardConfigurationId, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdAlertCountGet(alertsDashboardConfigurationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete an alerts dashboard configuration
     * @param {string} alertsDashboardConfigurationId The id of the alerts dashboard configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdDelete = function (alertsDashboardConfigurationId, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdDelete(alertsDashboardConfigurationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve an alerts dashboard configuration
     * @param {string} alertsDashboardConfigurationId The id of the alerts dashboard configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdGet = function (alertsDashboardConfigurationId, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdGet(alertsDashboardConfigurationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update configurations for a user\'s company
     * @param {string} alertsDashboardConfigurationId The id of the alerts dashboard configuration
     * @param {AlertsDashBoardConfiguration} alertsDashBoardConfiguration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdPut = function (alertsDashboardConfigurationId, alertsDashBoardConfiguration, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiAlertsDashboardConfigurationAlertsDashboardConfigurationIdPut(alertsDashboardConfigurationId, alertsDashBoardConfiguration, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update configurations for a user\'s company
     * @param {Array<AlertsDashBoardConfiguration>} alertsDashBoardConfiguration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiAlertsDashboardConfigurationBulkUpdatePut = function (alertsDashBoardConfiguration, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiAlertsDashboardConfigurationBulkUpdatePut(alertsDashBoardConfiguration, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve configurations for a user\'s company
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiAlertsDashboardConfigurationGet = function (page, pageSize, ordering, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiAlertsDashboardConfigurationGet(page, pageSize, ordering, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve available configuration options
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiAlertsDashboardConfigurationOptionsGet = function (options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiAlertsDashboardConfigurationOptionsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update configurations for a user\'s company
     * @param {AlertsDashBoardConfiguration} alertsDashBoardConfiguration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiAlertsDashboardConfigurationPost = function (alertsDashBoardConfiguration, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiAlertsDashboardConfigurationPost(alertsDashBoardConfiguration, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve shipments for alerts dashboard
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {boolean} [activeVendorAssignment] Include or exclude shipments with active CarrierAssignments
     * @param {boolean} [alerts] Filter on whether or not a Shipment has alert messages
     * @param {string} [alertConfigurationId] Return shipments that match this alert configuration definition
     * @param {boolean} [alertShipments] Return shipments that match active alert configurations
     * @param {boolean} [archived] Filter on whether or not a shipment is archived
     * @param {Array<string>} [bolNumber] Include shipments with these BOL Numbers
     * @param {string} [bolNumberContains] Return shipments where the BOL number contains this value
     * @param {Array<string>} [bolNumberExclude] Exclude shipments with these BOL Numbers
     * @param {string} [createdAt] For requesting data created at a certain datetime
     * @param {Array<'SHIPWELL_WEB' | 'IMPORT' | 'TENDER' | 'SHIPWELL_WEB_UNAUTH' | 'OTHER'>} [createdBySource] Return shipments created by sources in the array.
     * @param {string} [createdByUserContains] Return shipments where created_by_user object contains this string e.g first_name, last_name or email
     * @param {Array<string>} [createdByUserId] Return shipments where created_by_user_id in the array.
     * @param {string} [createdByUserName] Return shipments where created_by_user_name is exactly this string
     * @param {string} [createdByUserNameContains] Return shipments where created_by_user_name contains this string
     * @param {string} [customer] Return shipments with this exact value as the customer company name
     * @param {string} [customerContains] Return shipments where the customer company name contains this value
     * @param {string} [customerId] Return shipments with this exact id for the customer company
     * @param {Array<string>} [customerReferenceNumber] Include shipments with these Customer Reference Numbers
     * @param {string} [customerReferenceNumberContains] Include shipments where the Customer Reference Numbers contains this value
     * @param {Array<string>} [customerReferenceNumberExclude] Exclude shipments with these Customer Reference Numbers
     * @param {string} [destinationContains] Return shipments with this value in the destination
     * @param {string} [deliveryStopsContains] Return shipments with this value in one of its dropoff stops
     * @param {string} [deliveryStopsCompanyNameContains] Return shipments with this value in one of its delivery stops location company_name
     * @param {string} [destinationStateProvince] Return shipments with this state province on its destination stop
     * @param {string} [deliveryStopsStateProvince] Return shipments with this state province on its delivery stops
     * @param {string} [drayageBookingNumberContains] Include shipments where the drayage booking number contains this value
     * @param {string} [drayageChassisNumberContains] Include shipments where the drayage chassis number contains this value
     * @param {string} [drayageContainerNumberContains] Include shipments where the drayage container number contains this value
     * @param {string} [drayageContainerReturnDateGte] Include shipments where the drayage container return date is greater than or equal to this value
     * @param {string} [drayageContainerReturnDateLte] Include shipments where the drayage container return date is less than or equal to this value
     * @param {string} [drayageEstimatedArrivalDateGte] Include shipments where the drayage estimated arrival date is greater than or equal to this value
     * @param {string} [drayageEstimatedArrivalDateLte] Include shipments where the drayage estimated arrival date is less than or equal to this value
     * @param {string} [drayageLastFreeDateGte] Include shipments where the drayage last free datetime is greater than or equal to this value
     * @param {string} [drayageLastFreeDateLte] Include shipments where the drayage last free datetime is less than or equal to this value
     * @param {string} [drayageReleaseDateGte] Include shipments where the drayage release datetime is greater than or equal to this value
     * @param {string} [drayageReleaseDateLte] Include shipments where the drayage release datetime is less than or equal to this value
     * @param {string} [drayageSealNumberContains] Include shipments where the drayage seal number contains this value
     * @param {boolean} [driverAssigned] Return shipments where the driver is assigned/unassigned
     * @param {string} [dropoffGte] Return shipments with a dropoff stop with a planned date greater than or equal to this value
     * @param {string} [dropoffLte] Return shipments with a dropoff stop with a planned data less than or equal to this value
     * @param {string} [equipmentType] Return shipments with this equipment type
     * @param {string} [equipmentTypeContains] Return shipments where the equipment type contains this value
     * @param {string} [fedexAccount] Return pickups specific to this FedEx account
     * @param {string} [groupId] Group id for a shipment
     * @param {boolean} [hasInvoice] If true, show shipments which have at least one invoice otherwise show those with none.
     * @param {boolean} [hasBill] If true, show shipments which have at least one bill otherwise show those with none.
     * @param {Array<string>} [include] [v3] A list of properties to include in the response resource
     * @param {boolean} [loadBoardEnabled] Filter on whether or not a shipment is posted on the company load board
     * @param {string} [loadBoardId] Return shipments where the load board ID is equal to this value
     * @param {string} [loadBoardIdContains] Return shipments where the load board ID contains this value
     * @param {string} [mode] Return shipments with this shipment mode
     * @param {string} [modeContains] Return shipments where the shipment mode contains this value
     * @param {string} [nameContains] Return shipments where the shipment name contains this value
     * @param {boolean} [open] Filter on whether or not a shipment is open
     * @param {string} [originContains] Return shipments with this value in the origin
     * @param {string} [originStateProvince] Return shipments with this state province on its origin stop
     * @param {string} [pickupStopsStateProvince] Return shipments with this state province on its pickup stops
     * @param {string} [pickupStopsContains] Return shipments with this value in one of its pickup stops
     * @param {string} [pickupStopsCompanyNameContains] Return shipments with this value in one of its pickup stops location company_name
     * @param {Array<'CANCELLED' | 'DELAYED' | 'DELIVERED' | 'IN_TRANSIT' | 'NOT_SCHEDULED' | 'SCHEDULED'>} [parcelPickupStatus] Include shipments where the parcel pickup status equals one of these values
     * @param {string} [pickupGte] Return shipments with a pickup stop with a planned date greater than or equal to this value
     * @param {string} [pickupLte] Return shipments with a pickup stop with a planned date less than or equal to this value
     * @param {string} [pickupId] Include shipments currently associated with the provided ShipmentPickup\&#39;s ID
     * @param {Array<string>} [pickupNumber] Include shipments with these Pickup Numbers
     * @param {string} [pickupNumberContains] Include shipments where the Pickup Number contains this value
     * @param {Array<string>} [pickupNumberExclude] Exclude shipments with these Pickup Numbers
     * @param {Array<string>} [proNumber] Include shipments with these PRO Numbers
     * @param {string} [proNumberContains] Return shipments where the PRO number contains this value
     * @param {Array<string>} [proNumberExclude] Exclude shipments with these PRO Numbers
     * @param {string} [powerUnit] Return shipments where this power unit is assigned
     * @param {Array<string>} [purchaseOrderNumber] Include shipments with these PO Numbers
     * @param {string} [purchaseOrderNumberContains] Include shipments where the PO number contains this value
     * @param {Array<string>} [purchaseOrderNumberExclude] Exclude shipments with these PO Numbers
     * @param {Array<string>} [referenceId] Include shipments with these Reference IDs
     * @param {string} [referenceIdContains] Include shipments where the reference ID contains this value
     * @param {Array<string>} [referenceIdExclude] Exclude shipments with these Reference IDs
     * @param {Array<string>} [masterAirWaybill] Include shipments with these Master Air Waybill Numbers
     * @param {string} [masterAirWaybillContains] Include shipments where the Master Air Waybill number contains this value
     * @param {Array<string>} [houseAirWaybill] Include shipments with these House Air Waybill Numbers
     * @param {string} [houseAirWaybillContains] Include shipments where the House Air Waybill number contains this value
     * @param {Array<string>} [reps] Include shipments with these reps
     * @param {'owner_operator'} [role] Get results based on a specific perspective such as owner_operator
     * @param {string} [serviceLevel] Return shipments with this service level
     * @param {string} [shipmentId] The id of the shipment
     * @param {Array<string>} [accessorials] Include only shipments with at least one matching ShipmentAccessorial
     * @param {string} [createdAtGte] Include shipments where created_at is greater than or equal to the time value
     * @param {string} [createdAtLte] Include shipments where created_at is less than or equal to this value
     * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
     * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [statusExclude] Exclude shipments with these statuses
     * @param {string} [statusContains] Include shipments where the status contains this string
     * @param {Array<string>} [tags] Include only shipments with at least one matching ShipmentTag
     * @param {string} [stopsContains] Return shipments with this value in one of its stops
     * @param {string} [stopsCompanyNameContains] Return shipments with this value in one of its stops location company_name
     * @param {string} [stopsStateProvince] Return shipments with this state province on one of its stops
     * @param {string} [timelineLastUpdatedAtGte] Return shipments where last timeline update was greater than or equal to the value or was never updated
     * @param {string} [timelineLastUpdatedAtLte] Return shipments where last timeline update was less than or equal to the value or was never updated
     * @param {'current' | 'upcoming' | 'active' | 'past'} [timeFrame] Return shipments that are within the given time frame. active &#x3D; current + upcoming
     * @param {number} [totalMilesGte] Return shipments with total miles greater than or equal to this value
     * @param {number} [totalMilesLte] Return shipments with total miles less than or equal to this value
     * @param {string} [upsAccount] Return pickups specific to this UPS account
     * @param {string} [vendorId] Return shipments with this exact value as the vendor Carrier id
     * @param {string} [vendorContains] Return shipments where the vendor company name contains this value
     * @param {number} [totalWeightOverrideGte] Return shipments with weight greater than or equal to this value
     * @param {number} [totalWeightOverrideLte] Return shipments with weight less than or equal to this value
     * @param {number} [originRadius] Radius from origin stop
     * @param {number} [originLat] Latitude of location to filter on for origin stop
     * @param {number} [originLon] Longitude of location to filter on for origin stop
     * @param {number} [pickupRadius] Radius from a pickup stop
     * @param {number} [pickupLat] Latitude of location to filter on for pickup stop
     * @param {number} [pickupLon] Longitude of location to filter on for pickup stop
     * @param {number} [destinationRadius] Radius from the destination stop
     * @param {number} [destinationLat] Latitude of location to filter on for destination stop
     * @param {number} [destinationLon] Longitude of location to filter on for destination stop
     * @param {number} [deliveryRadius] Radius from a delivery stop
     * @param {number} [deliveryLat] Latitude of location to filter on for delivery stop
     * @param {number} [deliveryLon] Longitude of location to filter on for delivery stop
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiAlertsDashboardShipmentsGet = function (page, pageSize, ordering, q, activeVendorAssignment, alerts, alertConfigurationId, alertShipments, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, shipmentId, accessorials, createdAtGte, createdAtLte, status, statusExclude, statusContains, tags, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiAlertsDashboardShipmentsGet(page, pageSize, ordering, q, activeVendorAssignment, alerts, alertConfigurationId, alertShipments, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, shipmentId, accessorials, createdAtGte, createdAtLte, status, statusExclude, statusContains, tags, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a Slim Shipment for Alerts Dashboard
     * @param {string} shipmentId The id of the shipment
     * @param {boolean} [resolvedAlerts] If true, return user resolved alert events instead of active ones
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiAlertsDashboardShipmentsShipmentIdGet = function (shipmentId, resolvedAlerts, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiAlertsDashboardShipmentsShipmentIdGet(shipmentId, resolvedAlerts, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a EmailNotificationTypes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiEmailNotificationsGet = function (options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiEmailNotificationsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Send an email
     * @param {EmailNotificationRequest} emailNotificationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiEmailNotificationsPost = function (emailNotificationRequest, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiEmailNotificationsPost(emailNotificationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a list of unique product categories for the authenticated user\'s company
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiFilteredProductsGet = function (options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiFilteredProductsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a LegacyShipmentStage from a V3 shipment. Also cancel and archive the LegacyShipment.
     * @param {RemoveLegacyShipmentStageRequest} removeLegacyShipmentStageRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiLegacyShipmentsRemoveLegacyShipmentStagePost = function (removeLegacyShipmentStageRequest, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiLegacyShipmentsRemoveLegacyShipmentStagePost(removeLegacyShipmentStageRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Request updated insurance information from a carrier
     * @param {UpdatedInsuranceRequest} [updatedInsuranceRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiRequestUpdatedInsurancePost = function (updatedInsuranceRequest, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiRequestUpdatedInsurancePost(updatedInsuranceRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Return data for the settlements dashboard delivered
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [limit]
     * @param {string} [q] search query
     * @param {'SERVICE_PROVIDER' | 'BOOKING_PARTY'} [role] Filter invoices based on role
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiSettlementsDashboardDeliveredGet = function (page, limit, q, role, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiSettlementsDashboardDeliveredGet(page, limit, q, role, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Return data for the settlements dashboard
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [limit]
     * @param {string} [invoiceableId] only include settlements invoices where there is an invoiceable, and it matches the provided ID
     * @param {string} [status] only include settlements invoices where there is a status, and it matches the provided value
     * @param {string} [statusIn] only include settlements invoices where the status matches the provided statuses
     * @param {string} [invoiceableReferenceNumber] only include settlements invoices where there is a invoiceable_reference_number, and it matches the provided value
     * @param {string} [invoiceSource] only include settlements invoices where there is a invoice_source, and it matches the provided value
     * @param {string} [serviceProviderName] only include settlements invoices where there is a service_provider_name, and it matches the provided value
     * @param {string} [serviceProviderNameContains] Filter Freight Invoices by service provider name.
     * @param {string} [invoiceNumber] only include settlements invoices where there is a invoice_number, and it matches the provided value
     * @param {string} [remitToName] only include settlements invoices that have a remit to and there is a name that matches the provided value
     * @param {string} [search] search query
     * @param {'SERVICE_PROVIDER' | 'BOOKING_PARTY'} [role] Filter invoices based on role
     * @param {string} [orderBy] Order Freight Invoices by the fields provided.
     * @param {string} [subStatusesSubStatus] Filter Freight Invoices by substatus value.
     * @param {string} [subStatusesSubStatusIn] Filter Freight Invoices by substatus values.
     * @param {string} [stopsAddress] Filter Freight Invoices by stops address.
     * @param {string} [stopsAddressContains] Filter Freight Invoices by stops address.
     * @param {string} [stopsCompanyName] Filter Freight Invoices by stops company name.
     * @param {string} [stopsCompanyNameContains] Filter Freight Invoices by stops company name.
     * @param {string} [stopsCompanyNameIn] Filter Freight Invoices by stops company name.
     * @param {string} [invoiceableMode] Filter Freight Invoices by invoiceable mode.
     * @param {string} [invoiceableModeIn] Filter Freight Invoices by invoiceable mode.
     * @param {string} [invoiceableShipwellCustomDataId] Filter Freight Invoices by invoiceable shipwell custom data id.
     * @param {string} [invoiceableShipwellCustomDataValue] Filter Freight Invoices by invoiceable shipwell custom data value.
     * @param {string} [dueDate] Filter Freight Invoices by due date.
     * @param {string} [dueDateLt] Filter Freight Invoices by due date.
     * @param {string} [dueDateLte] Filter Freight Invoices by due date.
     * @param {string} [dueDateGt] Filter Freight Invoices by due date.
     * @param {string} [dueDateGte] Filter Freight Invoices by due date.
     * @param {string} [invoiceDate] Filter Freight Invoices by invoice date.
     * @param {string} [invoiceDateLt] Filter Freight Invoices by invoice date.
     * @param {string} [invoiceDateLte] Filter Freight Invoices by invoice date.
     * @param {string} [invoiceDateGt] Filter Freight Invoices by invoice date.
     * @param {string} [invoiceDateGte] Filter Freight Invoices by invoice date.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiSettlementsDashboardGet = function (page, limit, invoiceableId, status, statusIn, invoiceableReferenceNumber, invoiceSource, serviceProviderName, serviceProviderNameContains, invoiceNumber, remitToName, search, role, orderBy, subStatusesSubStatus, subStatusesSubStatusIn, stopsAddress, stopsAddressContains, stopsCompanyName, stopsCompanyNameContains, stopsCompanyNameIn, invoiceableMode, invoiceableModeIn, invoiceableShipwellCustomDataId, invoiceableShipwellCustomDataValue, dueDate, dueDateLt, dueDateLte, dueDateGt, dueDateGte, invoiceDate, invoiceDateLt, invoiceDateLte, invoiceDateGt, invoiceDateGte, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiSettlementsDashboardGet(page, limit, invoiceableId, status, statusIn, invoiceableReferenceNumber, invoiceSource, serviceProviderName, serviceProviderNameContains, invoiceNumber, remitToName, search, role, orderBy, subStatusesSubStatus, subStatusesSubStatusIn, stopsAddress, stopsAddressContains, stopsCompanyName, stopsCompanyNameContains, stopsCompanyNameIn, invoiceableMode, invoiceableModeIn, invoiceableShipwellCustomDataId, invoiceableShipwellCustomDataValue, dueDate, dueDateLt, dueDateLte, dueDateGt, dueDateGte, invoiceDate, invoiceDateLt, invoiceDateLte, invoiceDateGt, invoiceDateGte, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve list of Shipment Document Type short names
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiShipmentDocTypesShortNamesGet = function (options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiShipmentDocTypesShortNamesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Allows a PhonePin user using the mobile app to create a StopAlert without having to specify the next Stop
     * @param {string} shipmentId The id of the shipment
     * @param {StopAlert} stopAlert
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiShipmentIdReportAProblemPost = function (shipmentId, stopAlert, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiShipmentIdReportAProblemPost(shipmentId, stopAlert, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a list of metadata alerts for a given shipment id list
     * @param {ShipmentIdsAlertMetadata} [shipmentIdsAlertMetadata] ## List of shipment ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiShipmentMetadataAlertsPost = function (shipmentIdsAlertMetadata, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiShipmentMetadataAlertsPost(shipmentIdsAlertMetadata, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Check carrier insurance
     * @param {string} shipmentId The id of the shipment
     * @param {string} carrierRelationshipId The id of the vendor relationship
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiShipmentShipmentIdCarrierRelationshipCarrierRelationshipIdCheckCarrierInsuranceGet = function (shipmentId, carrierRelationshipId, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiShipmentShipmentIdCarrierRelationshipCarrierRelationshipIdCheckCarrierInsuranceGet(shipmentId, carrierRelationshipId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns current bill-to information.
     * @param {string} shipmentId The id of the shipment
     * @param {string} [quote] The id of the quote
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiShipmentsShipmentIdBillToGet = function (shipmentId, quote, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiShipmentsShipmentIdBillToGet(shipmentId, quote, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Consolidates line items in a shipment
     * @param {string} shipmentId The id of the shipment
     * @param {ItemConsolidation} [itemConsolidation] Consolidate line items into a Shipment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiShipmentsShipmentIdConsolidateLineItemsPost = function (shipmentId, itemConsolidation, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiShipmentsShipmentIdConsolidateLineItemsPost(shipmentId, itemConsolidation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns status for shipments by their shipment id
     * @param {Array<string>} [shipmentId] Shipment ids
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiShipmentsStatusGet = function (shipmentId, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiShipmentsStatusGet(shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a list of V3 shipping dashboard rows (includes V2 Shipments, V3 Legs, and V3 Shipment Services)
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {boolean} [activeVendorAssignment] Include or exclude shipments with active CarrierAssignments
     * @param {'MOBILE_DEVICE_ALERT' | 'NON_ACTIVE_CARRIER'} [alertTypes] Filter on shipments that have alerts of this type
     * @param {boolean} [alerts] Filter on whether or not a Shipment has alert messages
     * @param {boolean} [archived] Filter on whether or not a shipment is archived
     * @param {Array<string>} [bolNumber] Include shipments with these BOL Numbers
     * @param {string} [bolNumberContains] Return shipments where the BOL number contains this value
     * @param {Array<string>} [bolNumberExclude] Exclude shipments with these BOL Numbers
     * @param {string} [createdAt] For requesting data created at a certain datetime
     * @param {Array<'SHIPWELL_WEB' | 'IMPORT' | 'TENDER' | 'SHIPWELL_WEB_UNAUTH' | 'OTHER'>} [createdBySource] Return shipments created by sources in the array.
     * @param {string} [createdByUserContains] Return shipments where created_by_user object contains this string e.g first_name, last_name or email
     * @param {Array<string>} [createdByUserId] Return shipments where created_by_user_id in the array.
     * @param {string} [createdByUserName] Return shipments where created_by_user_name is exactly this string
     * @param {string} [createdByUserNameContains] Return shipments where created_by_user_name contains this string
     * @param {string} [customer] Return shipments with this exact value as the customer company name
     * @param {string} [customerContains] Return shipments where the customer company name contains this value
     * @param {string} [customerId] Return shipments with this exact id for the customer company
     * @param {Array<string>} [customerReferenceNumber] Include shipments with these Customer Reference Numbers
     * @param {string} [customerReferenceNumberContains] Include shipments where the Customer Reference Numbers contains this value
     * @param {Array<string>} [customerReferenceNumberExclude] Exclude shipments with these Customer Reference Numbers
     * @param {string} [destinationContains] Return shipments with this value in the destination
     * @param {string} [deliveryStopsContains] Return shipments with this value in one of its dropoff stops
     * @param {string} [deliveryStopsCompanyNameContains] Return shipments with this value in one of its delivery stops location company_name
     * @param {string} [destinationStateProvince] Return shipments with this state province on its destination stop
     * @param {string} [deliveryStopsStateProvince] Return shipments with this state province on its delivery stops
     * @param {string} [drayageBookingNumberContains] Include shipments where the drayage booking number contains this value
     * @param {string} [drayageChassisNumberContains] Include shipments where the drayage chassis number contains this value
     * @param {string} [drayageContainerNumberContains] Include shipments where the drayage container number contains this value
     * @param {string} [drayageContainerReturnDateGte] Include shipments where the drayage container return date is greater than or equal to this value
     * @param {string} [drayageContainerReturnDateLte] Include shipments where the drayage container return date is less than or equal to this value
     * @param {string} [drayageEstimatedArrivalDateGte] Include shipments where the drayage estimated arrival date is greater than or equal to this value
     * @param {string} [drayageEstimatedArrivalDateLte] Include shipments where the drayage estimated arrival date is less than or equal to this value
     * @param {string} [drayageLastFreeDateGte] Include shipments where the drayage last free datetime is greater than or equal to this value
     * @param {string} [drayageLastFreeDateLte] Include shipments where the drayage last free datetime is less than or equal to this value
     * @param {string} [drayageReleaseDateGte] Include shipments where the drayage release datetime is greater than or equal to this value
     * @param {string} [drayageReleaseDateLte] Include shipments where the drayage release datetime is less than or equal to this value
     * @param {string} [drayageSealNumberContains] Include shipments where the drayage seal number contains this value
     * @param {boolean} [driverAssigned] Return shipments where the driver is assigned/unassigned
     * @param {string} [dropoffGte] Return shipments with a dropoff stop with a planned date greater than or equal to this value
     * @param {string} [dropoffLte] Return shipments with a dropoff stop with a planned data less than or equal to this value
     * @param {string} [equipmentType] Return shipments with this equipment type
     * @param {string} [equipmentTypeContains] Return shipments where the equipment type contains this value
     * @param {string} [fedexAccount] Return pickups specific to this FedEx account
     * @param {string} [groupId] Group id for a shipment
     * @param {boolean} [hasInvoice] If true, show shipments which have at least one invoice otherwise show those with none.
     * @param {boolean} [hasBill] If true, show shipments which have at least one bill otherwise show those with none.
     * @param {Array<string>} [include] [v3] A list of properties to include in the response resource
     * @param {boolean} [loadBoardEnabled] Filter on whether or not a shipment is posted on the company load board
     * @param {string} [loadBoardId] Return shipments where the load board ID is equal to this value
     * @param {string} [loadBoardIdContains] Return shipments where the load board ID contains this value
     * @param {string} [mode] Return shipments with this shipment mode
     * @param {string} [modeContains] Return shipments where the shipment mode contains this value
     * @param {string} [nameContains] Return shipments where the shipment name contains this value
     * @param {boolean} [open] Filter on whether or not a shipment is open
     * @param {string} [originContains] Return shipments with this value in the origin
     * @param {string} [originStateProvince] Return shipments with this state province on its origin stop
     * @param {string} [pickupStopsStateProvince] Return shipments with this state province on its pickup stops
     * @param {string} [pickupStopsContains] Return shipments with this value in one of its pickup stops
     * @param {string} [pickupStopsCompanyNameContains] Return shipments with this value in one of its pickup stops location company_name
     * @param {Array<'CANCELLED' | 'DELAYED' | 'DELIVERED' | 'IN_TRANSIT' | 'NOT_SCHEDULED' | 'SCHEDULED'>} [parcelPickupStatus] Include shipments where the parcel pickup status equals one of these values
     * @param {string} [pickupGte] Return shipments with a pickup stop with a planned date greater than or equal to this value
     * @param {string} [pickupLte] Return shipments with a pickup stop with a planned date less than or equal to this value
     * @param {string} [pickupId] Include shipments currently associated with the provided ShipmentPickup\&#39;s ID
     * @param {Array<string>} [pickupNumber] Include shipments with these Pickup Numbers
     * @param {string} [pickupNumberContains] Include shipments where the Pickup Number contains this value
     * @param {Array<string>} [pickupNumberExclude] Exclude shipments with these Pickup Numbers
     * @param {Array<string>} [proNumber] Include shipments with these PRO Numbers
     * @param {string} [proNumberContains] Return shipments where the PRO number contains this value
     * @param {Array<string>} [proNumberExclude] Exclude shipments with these PRO Numbers
     * @param {string} [powerUnit] Return shipments where this power unit is assigned
     * @param {string} [powerUnitName] PowerUnit name to query on
     * @param {Array<string>} [purchaseOrderNumber] Include shipments with these PO Numbers
     * @param {string} [purchaseOrderNumberContains] Include shipments where the PO number contains this value
     * @param {Array<string>} [purchaseOrderNumberExclude] Exclude shipments with these PO Numbers
     * @param {Array<string>} [referenceId] Include shipments with these Reference IDs
     * @param {string} [referenceIdContains] Include shipments where the reference ID contains this value
     * @param {Array<string>} [referenceIdExclude] Exclude shipments with these Reference IDs
     * @param {Array<string>} [masterAirWaybill] Include shipments with these Master Air Waybill Numbers
     * @param {string} [masterAirWaybillContains] Include shipments where the Master Air Waybill number contains this value
     * @param {Array<string>} [houseAirWaybill] Include shipments with these House Air Waybill Numbers
     * @param {string} [houseAirWaybillContains] Include shipments where the House Air Waybill number contains this value
     * @param {Array<string>} [reps] Include shipments with these reps
     * @param {'owner_operator'} [role] Get results based on a specific perspective such as owner_operator
     * @param {string} [serviceLevel] Return shipments with this service level
     * @param {Array<string>} [accessorials] Include only shipments with at least one matching ShipmentAccessorial
     * @param {string} [createdAtGte] Include shipments where created_at is greater than or equal to the time value
     * @param {string} [createdAtLte] Include shipments where created_at is less than or equal to this value
     * @param {Array<string>} [shipmentShipwellCustomData] Include shipments that contain these shipment-level custom data values
     * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [status] Include shipments with these statuses
     * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [statusExclude] Exclude shipments with these statuses
     * @param {string} [statusContains] Include shipments where the status contains this string
     * @param {Array<string>} [tags] Include only shipments with at least one matching ShipmentTag
     * @param {Array<string>} [tagsExclude] Excludes shipments with at least one matching tag
     * @param {string} [stopsContains] Return shipments with this value in one of its stops
     * @param {string} [stopsCompanyNameContains] Return shipments with this value in one of its stops location company_name
     * @param {string} [stopsStateProvince] Return shipments with this state province on one of its stops
     * @param {string} [timelineLastUpdatedAtGte] Return shipments where last timeline update was greater than or equal to the value or was never updated
     * @param {string} [timelineLastUpdatedAtLte] Return shipments where last timeline update was less than or equal to the value or was never updated
     * @param {'current' | 'upcoming' | 'active' | 'past'} [timeFrame] Return shipments that are within the given time frame. active &#x3D; current + upcoming
     * @param {number} [totalMilesGte] Return shipments with total miles greater than or equal to this value
     * @param {number} [totalMilesLte] Return shipments with total miles less than or equal to this value
     * @param {string} [upsAccount] Return pickups specific to this UPS account
     * @param {string} [vendorId] Return shipments with this exact value as the vendor Carrier id
     * @param {string} [vendorContains] Return shipments where the vendor company name contains this value
     * @param {number} [totalWeightOverrideGte] Return shipments with weight greater than or equal to this value
     * @param {number} [totalWeightOverrideLte] Return shipments with weight less than or equal to this value
     * @param {number} [originRadius] Radius from origin stop
     * @param {number} [originLat] Latitude of location to filter on for origin stop
     * @param {number} [originLon] Longitude of location to filter on for origin stop
     * @param {number} [pickupRadius] Radius from a pickup stop
     * @param {number} [pickupLat] Latitude of location to filter on for pickup stop
     * @param {number} [pickupLon] Longitude of location to filter on for pickup stop
     * @param {number} [destinationRadius] Radius from the destination stop
     * @param {number} [destinationLat] Latitude of location to filter on for destination stop
     * @param {number} [destinationLon] Longitude of location to filter on for destination stop
     * @param {number} [deliveryRadius] Radius from a delivery stop
     * @param {number} [deliveryLat] Latitude of location to filter on for delivery stop
     * @param {number} [deliveryLon] Longitude of location to filter on for delivery stop
     * @param {Array<'RUNNING' | 'CANCELLED' | 'FAILED' | 'SUCCESS'>} [workflowExecutionStatus] Include shipments with these workflow execution statuses
     * @param {Array<'open' | 'accepted' | 'rejected' | 'revoked' | 'expired' | 'updated'>} [tenderStatus] Tender status on the shipment
     * @param {boolean} [optimized] Whether or not to explicitly use the optimized backend flows for data retrieval
     * @param {boolean} [showClonedResults] If true, show shipments that have a non null last_cloned_at value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiShippingDashboardGet = function (page, pageSize, ordering, q, activeVendorAssignment, alertTypes, alerts, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, powerUnitName, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, accessorials, createdAtGte, createdAtLte, shipmentShipwellCustomData, status, statusExclude, statusContains, tags, tagsExclude, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, workflowExecutionStatus, tenderStatus, optimized, showClonedResults, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiShippingDashboardGet(page, pageSize, ordering, q, activeVendorAssignment, alertTypes, alerts, archived, bolNumber, bolNumberContains, bolNumberExclude, createdAt, createdBySource, createdByUserContains, createdByUserId, createdByUserName, createdByUserNameContains, customer, customerContains, customerId, customerReferenceNumber, customerReferenceNumberContains, customerReferenceNumberExclude, destinationContains, deliveryStopsContains, deliveryStopsCompanyNameContains, destinationStateProvince, deliveryStopsStateProvince, drayageBookingNumberContains, drayageChassisNumberContains, drayageContainerNumberContains, drayageContainerReturnDateGte, drayageContainerReturnDateLte, drayageEstimatedArrivalDateGte, drayageEstimatedArrivalDateLte, drayageLastFreeDateGte, drayageLastFreeDateLte, drayageReleaseDateGte, drayageReleaseDateLte, drayageSealNumberContains, driverAssigned, dropoffGte, dropoffLte, equipmentType, equipmentTypeContains, fedexAccount, groupId, hasInvoice, hasBill, include, loadBoardEnabled, loadBoardId, loadBoardIdContains, mode, modeContains, nameContains, open, originContains, originStateProvince, pickupStopsStateProvince, pickupStopsContains, pickupStopsCompanyNameContains, parcelPickupStatus, pickupGte, pickupLte, pickupId, pickupNumber, pickupNumberContains, pickupNumberExclude, proNumber, proNumberContains, proNumberExclude, powerUnit, powerUnitName, purchaseOrderNumber, purchaseOrderNumberContains, purchaseOrderNumberExclude, referenceId, referenceIdContains, referenceIdExclude, masterAirWaybill, masterAirWaybillContains, houseAirWaybill, houseAirWaybillContains, reps, role, serviceLevel, accessorials, createdAtGte, createdAtLte, shipmentShipwellCustomData, status, statusExclude, statusContains, tags, tagsExclude, stopsContains, stopsCompanyNameContains, stopsStateProvince, timelineLastUpdatedAtGte, timelineLastUpdatedAtLte, timeFrame, totalMilesGte, totalMilesLte, upsAccount, vendorId, vendorContains, totalWeightOverrideGte, totalWeightOverrideLte, originRadius, originLat, originLon, pickupRadius, pickupLat, pickupLon, destinationRadius, destinationLat, destinationLon, deliveryRadius, deliveryLat, deliveryLon, workflowExecutionStatus, tenderStatus, optimized, showClonedResults, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Summarize all stages associated with the provided V3Shipment IDs
     * @param {MultiModeSummariesRequest} multiModeSummariesRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiShippingDashboardMultiModeSummariesPost = function (multiModeSummariesRequest, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiShippingDashboardMultiModeSummariesPost(multiModeSummariesRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the most current workflow for each shipment id
     * @param {ShippingDashboardShipmentCurrentWorkflowRequest} shippingDashboardShipmentCurrentWorkflowRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiShippingDashboardShipmentCurrentWorkflowExecutionsPost = function (shippingDashboardShipmentCurrentWorkflowRequest, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiShippingDashboardShipmentCurrentWorkflowExecutionsPost(shippingDashboardShipmentCurrentWorkflowRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a list of the current user\'s timeline event templates.
     * @param {string} [search] search query
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiTimelineEventTemplatesGet = function (search, page, pageSize, ordering, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiTimelineEventTemplatesGet(search, page, pageSize, ordering, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new TimelineEventTemplate
     * @param {CreateTimelineEventTemplate} createTimelineEventTemplate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiTimelineEventTemplatesPost = function (createTimelineEventTemplate, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiTimelineEventTemplatesPost(createTimelineEventTemplate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a TimelineEventTemplate
     * @param {string} templateId The id of the timeline event template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiTimelineEventTemplatesTemplateIdDelete = function (templateId, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiTimelineEventTemplatesTemplateIdDelete(templateId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about a timeline event template
     * @param {string} templateId The id of the timeline event template
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiTimelineEventTemplatesTemplateIdGet = function (templateId, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiTimelineEventTemplatesTemplateIdGet(templateId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a TimelineEventTemplate
     * @param {string} templateId The id of the timeline event template
     * @param {CreateTimelineEventTemplate} createTimelineEventTemplate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiTimelineEventTemplatesTemplateIdPut = function (templateId, createTimelineEventTemplate, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiTimelineEventTemplatesTemplateIdPut(templateId, createTimelineEventTemplate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a ShipmentTimelineFilterPreferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiTimelineFilterPreferencesGet = function (options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiTimelineFilterPreferencesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a ShipmentTimelineFilterPreferences
     * @param {ShipmentTimelineFilterPreferences} shipmentTimelineFilterPreferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiTimelineFilterPreferencesPut = function (shipmentTimelineFilterPreferences, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiTimelineFilterPreferencesPut(shipmentTimelineFilterPreferences, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a list of available email templates for Tracking Failed Compass alert emails.
     * @param {string} [search] search query
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiTrackingFailedEmailTemplatesGet = function (search, page, pageSize, ordering, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiTrackingFailedEmailTemplatesGet(search, page, pageSize, ordering, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Send an email alert to the carrier
     * @param {TrackingFailedEmailRequest} [trackingFailedEmailRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiTrackingFailedEmailTemplatesSendEmailPost = function (trackingFailedEmailRequest, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiTrackingFailedEmailTemplatesSendEmailPost(trackingFailedEmailRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a ShipwellUserPreferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiUserPreferencesGet = function (options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiUserPreferencesGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a ShipwellUserPreferences
     * @param {UserPreferences} userPreferences
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiUserPreferencesPut = function (userPreferences, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiUserPreferencesPut(userPreferences, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Stop watching a Shipment
     * @param {InlineObject26} inlineObject26
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiUserWatchedShipmentsDelete = function (inlineObject26, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiUserWatchedShipmentsDelete(inlineObject26, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve shipment ids being watched by user
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiUserWatchedShipmentsGet = function (page, pageSize, ordering, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiUserWatchedShipmentsGet(page, pageSize, ordering, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Start watching a Shipment
     * @param {InlineObject25} inlineObject25
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShipwellUiApi
     */
    ShipwellUiApi.prototype.shipwellUiUserWatchedShipmentsPost = function (inlineObject25, options) {
        var _this = this;
        return (0, exports.ShipwellUiApiFp)(this.configuration).shipwellUiUserWatchedShipmentsPost(inlineObject25, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ShipwellUiApi;
}(base_1.BaseAPI));
exports.ShipwellUiApi = ShipwellUiApi;
/**
 * SmsApi - axios parameter creator
 * @export
 */
var SmsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Look up information about a phone number
         * @param {PhoneNumberLookup} phoneNumberLookup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smsLookupPost: function (phoneNumberLookup, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'phoneNumberLookup' is not null or undefined
                            (0, common_1.assertParamExists)('smsLookupPost', 'phoneNumberLookup', phoneNumberLookup);
                            localVarPath = "/sms/lookup/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(phoneNumberLookup, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SmsApiAxiosParamCreator = SmsApiAxiosParamCreator;
/**
 * SmsApi - functional programming interface
 * @export
 */
var SmsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SmsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Look up information about a phone number
         * @param {PhoneNumberLookup} phoneNumberLookup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smsLookupPost: function (phoneNumberLookup, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.smsLookupPost(phoneNumberLookup, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SmsApiFp = SmsApiFp;
/**
 * SmsApi - factory interface
 * @export
 */
var SmsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SmsApiFp)(configuration);
    return {
        /**
         *
         * @summary Look up information about a phone number
         * @param {PhoneNumberLookup} phoneNumberLookup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        smsLookupPost: function (phoneNumberLookup, options) {
            return localVarFp.smsLookupPost(phoneNumberLookup, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SmsApiFactory = SmsApiFactory;
/**
 * SmsApi - object-oriented interface
 * @export
 * @class SmsApi
 * @extends {BaseAPI}
 */
var SmsApi = /** @class */ (function (_super) {
    __extends(SmsApi, _super);
    function SmsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Look up information about a phone number
     * @param {PhoneNumberLookup} phoneNumberLookup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmsApi
     */
    SmsApi.prototype.smsLookupPost = function (phoneNumberLookup, options) {
        var _this = this;
        return (0, exports.SmsApiFp)(this.configuration).smsLookupPost(phoneNumberLookup, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SmsApi;
}(base_1.BaseAPI));
exports.SmsApi = SmsApi;
/**
 * SpotNegotiationsApi - axios parameter creator
 * @export
 */
var SpotNegotiationsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get, create, or update a negotiation in which you are the vendor and the shipment\'s customer_freight_authority is the customer. Only available to companies that are already assigned as a vendor to that customer.
         * @param {string} shipmentId The id of the shipment
         * @param {SpotNegotiation} spotNegotiation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsCustomerNegotiationPost: function (shipmentId, spotNegotiation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsCustomerNegotiationPost', 'shipmentId', shipmentId);
                            // verify required parameter 'spotNegotiation' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsCustomerNegotiationPost', 'spotNegotiation', spotNegotiation);
                            localVarPath = "/quoting/spotnegotiations/shipments/{shipmentId}/spot-negotiations/customer-negotiation/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(spotNegotiation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List all outstanding negotiations under this shipment where the authenticated user is a customer
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {boolean} [expandQuotes] Boolean, if True will include quotes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsGet: function (shipmentId, page, pageSize, expandQuotes, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsGet', 'shipmentId', shipmentId);
                            localVarPath = "/quoting/spotnegotiations/shipments/{shipmentId}/spot-negotiations/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (expandQuotes !== undefined) {
                                localVarQueryParameter['expand_quotes'] = expandQuotes;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Bulk create SpotNegotiations for a Shipment
         * @param {string} shipmentId The id of the shipment
         * @param {BulkCreateSpotNegotiationRequest} bulkCreateSpotNegotiationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsPost: function (shipmentId, bulkCreateSpotNegotiationRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsPost', 'shipmentId', shipmentId);
                            // verify required parameter 'bulkCreateSpotNegotiationRequest' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsPost', 'bulkCreateSpotNegotiationRequest', bulkCreateSpotNegotiationRequest);
                            localVarPath = "/quoting/spotnegotiations/shipments/{shipmentId}/spot-negotiations/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(bulkCreateSpotNegotiationRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a preview of the HTML Email that will be sent and the included message
         * @param {string} shipmentId The id of the shipment
         * @param {boolean} [isCustomerFacing] If True, render a template for sending a quote to a customer. Else, render a request for quote to be sent to a vendor.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsPreviewGet: function (shipmentId, isCustomerFacing, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsPreviewGet', 'shipmentId', shipmentId);
                            localVarPath = "/quoting/spotnegotiations/shipments/{shipmentId}/spot-negotiations/preview/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (isCustomerFacing !== undefined) {
                                localVarQueryParameter['is_customer_facing'] = isCustomerFacing;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List all SpotNegotiations in which the user\'s company is involved
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [closedByCustomer] Restrict SpotNegotiations based on whether customer closed
         * @param {boolean} [closedByVendor] Restrict SpotNegotiations based on whether vendor closed
         * @param {string} [customerId] ID of customer company to which to restrict SpotNegotiations
         * @param {string} [customerNameContains] Partial name of customer company to which to restrict SpotNegotiations
         * @param {boolean} [involvedOnly] Restrict SpotNegotiations to those in which user is explicitly involved
         * @param {Array<string>} [involvedVendorUsers] Restrict SpotNegotiations to those with provided User IDs involved on the vendor side
         * @param {boolean} [isMostRecentWinner] Restrict SpotNegotiations to those that are or are not the most recent winner
         * @param {boolean} [isOpen] Restrict SpotNegotiations based on both sides agreeing the negotiation is open
         * @param {string} [shipment] Return SpotNegotiations where Shipment ID matches
         * @param {string} [shipmentBolNumber] Return SpotNegotiations where Shipment BOL number matches
         * @param {string} [shipmentBolNumberContains] Return SpotNegotiations where Shipment BOL number partially matches
         * @param {string} [shipmentCapacityProviderCustomerReferenceNumber] Return SpotNegotiations where Shipment capacity provider customer reference number matches
         * @param {string} [shipmentCapacityProviderCustomerReferenceNumberContains] Return SpotNegotiations where Shipment capacity provider customer reference number partially matches
         * @param {string} [shipmentCustomerReferenceNumber] Return SpotNegotiations where Shipment customer reference number matches
         * @param {string} [shipmentCustomerReferenceNumberContains] Return SpotNegotiations where Shipment customer reference number partially matches
         * @param {string} [shipmentDelayed] Return SpotNegotiations where Shipment delayed matches
         * @param {string} [shipmentDestinationContains] Return SpotNegotiations where Shipment destination partially matches
         * @param {string} [shipmentDropoffGte] Return SpotNegotiations with a dropoff stop with a planned date greater than or equal to this value
         * @param {string} [shipmentDropoffLte] Return SpotNegotiations with a dropoff stop with a planned data less than or equal to this value
         * @param {string} [shipmentName] Return SpotNegotiations where Shipment name matches
         * @param {string} [shipmentNameContains] Return SpotNegotiations where Shipment name partially matches
         * @param {string} [shipmentOriginContains] Return SpotNegotiations where Shipment origin partially matches
         * @param {string} [shipmentPickupGte] Return SpotNegotiations with a pickup stop with a planned date greater than or equal to this value
         * @param {string} [shipmentPickupLte] Return SpotNegotiations with a pickup stop with a planned date less than or equal to this value
         * @param {string} [shipmentPickupNumber] Return SpotNegotiations where Shipment pickup number matches
         * @param {string} [shipmentPickupNumberContains] Return SpotNegotiations where Shipment pickup number partially matches
         * @param {string} [shipmentProNumber] Return SpotNegotiations where Shipment PRO number matches
         * @param {string} [shipmentProNumberContains] Return SpotNegotiations where Shipment PRO number partially matches
         * @param {string} [shipmentPurchaseOrderNumber] Return SpotNegotiations where Shipment purchase order number matches
         * @param {string} [shipmentPurchaseOrderNumberContains] Return SpotNegotiations where Shipment purchase order number partially matches
         * @param {string} [shipmentReferenceId] Return SpotNegotiations where Shipment reference_id matches
         * @param {string} [shipmentReferenceIdContains] Return SpotNegotiations where Shipment reference_id partially matches
         * @param {string} [shipmentState] Return SpotNegotiations where Shipment state matches
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [shipmentStatus] Return SpotNegotiations with shipments that have provided statuses
         * @param {string} [vendorId] ID of the vendor company to which to restrict SpotNegotiations
         * @param {string} [vendorNameContains] Partial name of the vendor company to which to restrict SpotNegotiations
         * @param {number} [expandQuotes] Boolean, if True will include quotes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsGet: function (page, pageSize, ordering, q, closedByCustomer, closedByVendor, customerId, customerNameContains, involvedOnly, involvedVendorUsers, isMostRecentWinner, isOpen, shipment, shipmentBolNumber, shipmentBolNumberContains, shipmentCapacityProviderCustomerReferenceNumber, shipmentCapacityProviderCustomerReferenceNumberContains, shipmentCustomerReferenceNumber, shipmentCustomerReferenceNumberContains, shipmentDelayed, shipmentDestinationContains, shipmentDropoffGte, shipmentDropoffLte, shipmentName, shipmentNameContains, shipmentOriginContains, shipmentPickupGte, shipmentPickupLte, shipmentPickupNumber, shipmentPickupNumberContains, shipmentProNumber, shipmentProNumberContains, shipmentPurchaseOrderNumber, shipmentPurchaseOrderNumberContains, shipmentReferenceId, shipmentReferenceIdContains, shipmentState, shipmentStatus, vendorId, vendorNameContains, expandQuotes, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/quoting/spotnegotiations/spot-negotiations/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (closedByCustomer !== undefined) {
                                localVarQueryParameter['closed_by_customer'] = closedByCustomer;
                            }
                            if (closedByVendor !== undefined) {
                                localVarQueryParameter['closed_by_vendor'] = closedByVendor;
                            }
                            if (customerId !== undefined) {
                                localVarQueryParameter['customer_id'] = customerId;
                            }
                            if (customerNameContains !== undefined) {
                                localVarQueryParameter['customer_name__contains'] = customerNameContains;
                            }
                            if (involvedOnly !== undefined) {
                                localVarQueryParameter['involved_only'] = involvedOnly;
                            }
                            if (involvedVendorUsers) {
                                localVarQueryParameter['involved_vendor_users'] = involvedVendorUsers;
                            }
                            if (isMostRecentWinner !== undefined) {
                                localVarQueryParameter['is_most_recent_winner'] = isMostRecentWinner;
                            }
                            if (isOpen !== undefined) {
                                localVarQueryParameter['is_open'] = isOpen;
                            }
                            if (shipment !== undefined) {
                                localVarQueryParameter['shipment'] = shipment;
                            }
                            if (shipmentBolNumber !== undefined) {
                                localVarQueryParameter['shipment_bol_number'] = shipmentBolNumber;
                            }
                            if (shipmentBolNumberContains !== undefined) {
                                localVarQueryParameter['shipment_bol_number__contains'] = shipmentBolNumberContains;
                            }
                            if (shipmentCapacityProviderCustomerReferenceNumber !== undefined) {
                                localVarQueryParameter['shipment_capacity_provider_customer_reference_number'] = shipmentCapacityProviderCustomerReferenceNumber;
                            }
                            if (shipmentCapacityProviderCustomerReferenceNumberContains !== undefined) {
                                localVarQueryParameter['shipment_capacity_provider_customer_reference_number__contains'] = shipmentCapacityProviderCustomerReferenceNumberContains;
                            }
                            if (shipmentCustomerReferenceNumber !== undefined) {
                                localVarQueryParameter['shipment_customer_reference_number'] = shipmentCustomerReferenceNumber;
                            }
                            if (shipmentCustomerReferenceNumberContains !== undefined) {
                                localVarQueryParameter['shipment_customer_reference_number__contains'] = shipmentCustomerReferenceNumberContains;
                            }
                            if (shipmentDelayed !== undefined) {
                                localVarQueryParameter['shipment_delayed'] = shipmentDelayed;
                            }
                            if (shipmentDestinationContains !== undefined) {
                                localVarQueryParameter['shipment_destination__contains'] = shipmentDestinationContains;
                            }
                            if (shipmentDropoffGte !== undefined) {
                                localVarQueryParameter['shipment_dropoff__gte'] = (shipmentDropoffGte instanceof Date) ?
                                    shipmentDropoffGte.toISOString().substr(0, 10) :
                                    shipmentDropoffGte;
                            }
                            if (shipmentDropoffLte !== undefined) {
                                localVarQueryParameter['shipment_dropoff__lte'] = (shipmentDropoffLte instanceof Date) ?
                                    shipmentDropoffLte.toISOString().substr(0, 10) :
                                    shipmentDropoffLte;
                            }
                            if (shipmentName !== undefined) {
                                localVarQueryParameter['shipment_name'] = shipmentName;
                            }
                            if (shipmentNameContains !== undefined) {
                                localVarQueryParameter['shipment_name__contains'] = shipmentNameContains;
                            }
                            if (shipmentOriginContains !== undefined) {
                                localVarQueryParameter['shipment_origin__contains'] = shipmentOriginContains;
                            }
                            if (shipmentPickupGte !== undefined) {
                                localVarQueryParameter['shipment_pickup__gte'] = (shipmentPickupGte instanceof Date) ?
                                    shipmentPickupGte.toISOString().substr(0, 10) :
                                    shipmentPickupGte;
                            }
                            if (shipmentPickupLte !== undefined) {
                                localVarQueryParameter['shipment_pickup__lte'] = (shipmentPickupLte instanceof Date) ?
                                    shipmentPickupLte.toISOString().substr(0, 10) :
                                    shipmentPickupLte;
                            }
                            if (shipmentPickupNumber !== undefined) {
                                localVarQueryParameter['shipment_pickup_number'] = shipmentPickupNumber;
                            }
                            if (shipmentPickupNumberContains !== undefined) {
                                localVarQueryParameter['shipment_pickup_number__contains'] = shipmentPickupNumberContains;
                            }
                            if (shipmentProNumber !== undefined) {
                                localVarQueryParameter['shipment_pro_number'] = shipmentProNumber;
                            }
                            if (shipmentProNumberContains !== undefined) {
                                localVarQueryParameter['shipment_pro_number__contains'] = shipmentProNumberContains;
                            }
                            if (shipmentPurchaseOrderNumber !== undefined) {
                                localVarQueryParameter['shipment_purchase_order_number'] = shipmentPurchaseOrderNumber;
                            }
                            if (shipmentPurchaseOrderNumberContains !== undefined) {
                                localVarQueryParameter['shipment_purchase_order_number__contains'] = shipmentPurchaseOrderNumberContains;
                            }
                            if (shipmentReferenceId !== undefined) {
                                localVarQueryParameter['shipment_reference_id'] = shipmentReferenceId;
                            }
                            if (shipmentReferenceIdContains !== undefined) {
                                localVarQueryParameter['shipment_reference_id__contains'] = shipmentReferenceIdContains;
                            }
                            if (shipmentState !== undefined) {
                                localVarQueryParameter['shipment_state'] = shipmentState;
                            }
                            if (shipmentStatus) {
                                localVarQueryParameter['shipment_status'] = shipmentStatus;
                            }
                            if (vendorId !== undefined) {
                                localVarQueryParameter['vendor_id'] = vendorId;
                            }
                            if (vendorNameContains !== undefined) {
                                localVarQueryParameter['vendor_name__contains'] = vendorNameContains;
                            }
                            if (expandQuotes !== undefined) {
                                localVarQueryParameter['expand_quotes'] = expandQuotes;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Open or close authenticated company\'s side of the provided negotiations
         * @param {OpenCloseSpotNegotiationsRequest} openCloseSpotNegotiationsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsOpenClosePost: function (openCloseSpotNegotiationsRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'openCloseSpotNegotiationsRequest' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsOpenClosePost', 'openCloseSpotNegotiationsRequest', openCloseSpotNegotiationsRequest);
                            localVarPath = "/quoting/spotnegotiations/spot-negotiations/open-close/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(openCloseSpotNegotiationsRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Accept a shipment for the customer buy-it-now amount
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {BuyItNow} buyItNow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdBuyItNowPost: function (spotNegotiationId, buyItNow, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdBuyItNowPost', 'spotNegotiationId', spotNegotiationId);
                            // verify required parameter 'buyItNow' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdBuyItNowPost', 'buyItNow', buyItNow);
                            localVarPath = "/quoting/spotnegotiations/spot-negotiations/{spotNegotiationId}/buy-it-now/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(buyItNow, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a ShipmentSpotNegotiation by its id
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdGet: function (spotNegotiationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdGet', 'spotNegotiationId', spotNegotiationId);
                            localVarPath = "/quoting/spotnegotiations/spot-negotiations/{spotNegotiationId}/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List all SpotNegotiationMessages of a SpotNegotiation
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} [q] search query
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesGet: function (spotNegotiationId, q, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesGet', 'spotNegotiationId', spotNegotiationId);
                            localVarPath = "/quoting/spotnegotiations/spot-negotiations/{spotNegotiationId}/messages/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a SpotNegotiationMessage
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {SpotNegotiationMessage} spotNegotiationMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesPost: function (spotNegotiationId, spotNegotiationMessage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesPost', 'spotNegotiationId', spotNegotiationId);
                            // verify required parameter 'spotNegotiationMessage' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesPost', 'spotNegotiationMessage', spotNegotiationMessage);
                            localVarPath = "/quoting/spotnegotiations/spot-negotiations/{spotNegotiationId}/messages/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(spotNegotiationMessage, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a SpotNegotiationMessage
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationMessageId The id of the spot negotiation message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdDelete: function (spotNegotiationId, spotNegotiationMessageId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdDelete', 'spotNegotiationId', spotNegotiationId);
                            // verify required parameter 'spotNegotiationMessageId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdDelete', 'spotNegotiationMessageId', spotNegotiationMessageId);
                            localVarPath = "/quoting/spotnegotiations/spot-negotiations/{spotNegotiationId}/messages/{spotNegotiationMessageId}/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)))
                                .replace("{".concat("spotNegotiationMessageId", "}"), encodeURIComponent(String(spotNegotiationMessageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a SpotNegotiationMessage
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationMessageId The id of the spot negotiation message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdGet: function (spotNegotiationId, spotNegotiationMessageId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdGet', 'spotNegotiationId', spotNegotiationId);
                            // verify required parameter 'spotNegotiationMessageId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdGet', 'spotNegotiationMessageId', spotNegotiationMessageId);
                            localVarPath = "/quoting/spotnegotiations/spot-negotiations/{spotNegotiationId}/messages/{spotNegotiationMessageId}/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)))
                                .replace("{".concat("spotNegotiationMessageId", "}"), encodeURIComponent(String(spotNegotiationMessageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a SpotNegotiationMessage
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationMessageId The id of the spot negotiation message
         * @param {SpotNegotiationMessage} spotNegotiationMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdPut: function (spotNegotiationId, spotNegotiationMessageId, spotNegotiationMessage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdPut', 'spotNegotiationId', spotNegotiationId);
                            // verify required parameter 'spotNegotiationMessageId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdPut', 'spotNegotiationMessageId', spotNegotiationMessageId);
                            // verify required parameter 'spotNegotiationMessage' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdPut', 'spotNegotiationMessage', spotNegotiationMessage);
                            localVarPath = "/quoting/spotnegotiations/spot-negotiations/{spotNegotiationId}/messages/{spotNegotiationMessageId}/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)))
                                .replace("{".concat("spotNegotiationMessageId", "}"), encodeURIComponent(String(spotNegotiationMessageId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(spotNegotiationMessage, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a ShipmentSpotNegotiation
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {ShipmentSpotNegotiation} shipmentSpotNegotiation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdPut: function (spotNegotiationId, shipmentSpotNegotiation, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdPut', 'spotNegotiationId', spotNegotiationId);
                            // verify required parameter 'shipmentSpotNegotiation' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdPut', 'shipmentSpotNegotiation', shipmentSpotNegotiation);
                            localVarPath = "/quoting/spotnegotiations/spot-negotiations/{spotNegotiationId}/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shipmentSpotNegotiation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List all Quotes of the SpotNegotiation
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesGet: function (spotNegotiationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesGet', 'spotNegotiationId', spotNegotiationId);
                            localVarPath = "/quoting/spotnegotiations/spot-negotiations/{spotNegotiationId}/quotes/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a Quote on the SpotNegotiation
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {CreateSpotNegotiationQuote} createSpotNegotiationQuote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesPost: function (spotNegotiationId, createSpotNegotiationQuote, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesPost', 'spotNegotiationId', spotNegotiationId);
                            // verify required parameter 'createSpotNegotiationQuote' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesPost', 'createSpotNegotiationQuote', createSpotNegotiationQuote);
                            localVarPath = "/quoting/spotnegotiations/spot-negotiations/{spotNegotiationId}/quotes/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createSpotNegotiationQuote, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Award or decline a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {AwardDeclineQuoteRequest} awardDeclineQuoteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdAwardDeclinePut: function (spotNegotiationId, spotNegotiationQuoteId, awardDeclineQuoteRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdAwardDeclinePut', 'spotNegotiationId', spotNegotiationId);
                            // verify required parameter 'spotNegotiationQuoteId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdAwardDeclinePut', 'spotNegotiationQuoteId', spotNegotiationQuoteId);
                            // verify required parameter 'awardDeclineQuoteRequest' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdAwardDeclinePut', 'awardDeclineQuoteRequest', awardDeclineQuoteRequest);
                            localVarPath = "/quoting/spotnegotiations/spot-negotiations/{spotNegotiationId}/quotes/{spotNegotiationQuoteId}/award-decline/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)))
                                .replace("{".concat("spotNegotiationQuoteId", "}"), encodeURIComponent(String(spotNegotiationQuoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(awardDeclineQuoteRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDelete: function (spotNegotiationId, spotNegotiationQuoteId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDelete', 'spotNegotiationId', spotNegotiationId);
                            // verify required parameter 'spotNegotiationQuoteId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDelete', 'spotNegotiationQuoteId', spotNegotiationQuoteId);
                            localVarPath = "/quoting/spotnegotiations/spot-negotiations/{spotNegotiationId}/quotes/{spotNegotiationQuoteId}/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)))
                                .replace("{".concat("spotNegotiationQuoteId", "}"), encodeURIComponent(String(spotNegotiationQuoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List of all Documents under a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsGet: function (spotNegotiationId, spotNegotiationQuoteId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsGet', 'spotNegotiationId', spotNegotiationId);
                            // verify required parameter 'spotNegotiationQuoteId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsGet', 'spotNegotiationQuoteId', spotNegotiationQuoteId);
                            localVarPath = "/quoting/spotnegotiations/spot-negotiations/{spotNegotiationId}/quotes/{spotNegotiationQuoteId}/documents/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)))
                                .replace("{".concat("spotNegotiationQuoteId", "}"), encodeURIComponent(String(spotNegotiationQuoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a SpotNegotiation Quote Document
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {string} description
         * @param {any} file
         * @param {boolean} isCarrierDocument
         * @param {string} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsPost: function (spotNegotiationId, spotNegotiationQuoteId, description, file, isCarrierDocument, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsPost', 'spotNegotiationId', spotNegotiationId);
                            // verify required parameter 'spotNegotiationQuoteId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsPost', 'spotNegotiationQuoteId', spotNegotiationQuoteId);
                            // verify required parameter 'description' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsPost', 'description', description);
                            // verify required parameter 'file' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsPost', 'file', file);
                            // verify required parameter 'isCarrierDocument' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsPost', 'isCarrierDocument', isCarrierDocument);
                            // verify required parameter 'type' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsPost', 'type', type);
                            localVarPath = "/quoting/spotnegotiations/spot-negotiations/{spotNegotiationId}/quotes/{spotNegotiationQuoteId}/documents/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)))
                                .replace("{".concat("spotNegotiationQuoteId", "}"), encodeURIComponent(String(spotNegotiationQuoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (description !== undefined) {
                                localVarFormParams.append('description', description);
                            }
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            if (isCarrierDocument !== undefined) {
                                localVarFormParams.append('is_carrier_document', isCarrierDocument);
                            }
                            if (type !== undefined) {
                                localVarFormParams.append('type', type);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a spot negotiation quote document
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {string} spotNegotiationQuoteDocumentId The id of the spot negotiation quote document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdDelete: function (spotNegotiationId, spotNegotiationQuoteId, spotNegotiationQuoteDocumentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdDelete', 'spotNegotiationId', spotNegotiationId);
                            // verify required parameter 'spotNegotiationQuoteId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdDelete', 'spotNegotiationQuoteId', spotNegotiationQuoteId);
                            // verify required parameter 'spotNegotiationQuoteDocumentId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdDelete', 'spotNegotiationQuoteDocumentId', spotNegotiationQuoteDocumentId);
                            localVarPath = "/quoting/spotnegotiations/spot-negotiations/{spotNegotiationId}/quotes/{spotNegotiationQuoteId}/documents/{spotNegotiationQuoteDocumentId}"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)))
                                .replace("{".concat("spotNegotiationQuoteId", "}"), encodeURIComponent(String(spotNegotiationQuoteId)))
                                .replace("{".concat("spotNegotiationQuoteDocumentId", "}"), encodeURIComponent(String(spotNegotiationQuoteDocumentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a Documents under a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {string} spotNegotiationQuoteDocumentId The id of the spot negotiation quote document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdGet: function (spotNegotiationId, spotNegotiationQuoteId, spotNegotiationQuoteDocumentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdGet', 'spotNegotiationId', spotNegotiationId);
                            // verify required parameter 'spotNegotiationQuoteId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdGet', 'spotNegotiationQuoteId', spotNegotiationQuoteId);
                            // verify required parameter 'spotNegotiationQuoteDocumentId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdGet', 'spotNegotiationQuoteDocumentId', spotNegotiationQuoteDocumentId);
                            localVarPath = "/quoting/spotnegotiations/spot-negotiations/{spotNegotiationId}/quotes/{spotNegotiationQuoteId}/documents/{spotNegotiationQuoteDocumentId}"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)))
                                .replace("{".concat("spotNegotiationQuoteId", "}"), encodeURIComponent(String(spotNegotiationQuoteId)))
                                .replace("{".concat("spotNegotiationQuoteDocumentId", "}"), encodeURIComponent(String(spotNegotiationQuoteDocumentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a SpotNegotiation Quote Document
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {string} spotNegotiationQuoteDocumentId The id of the spot negotiation quote document
         * @param {string} description
         * @param {any} file
         * @param {boolean} isCarrierDocument
         * @param {string} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdPut: function (spotNegotiationId, spotNegotiationQuoteId, spotNegotiationQuoteDocumentId, description, file, isCarrierDocument, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdPut', 'spotNegotiationId', spotNegotiationId);
                            // verify required parameter 'spotNegotiationQuoteId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdPut', 'spotNegotiationQuoteId', spotNegotiationQuoteId);
                            // verify required parameter 'spotNegotiationQuoteDocumentId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdPut', 'spotNegotiationQuoteDocumentId', spotNegotiationQuoteDocumentId);
                            // verify required parameter 'description' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdPut', 'description', description);
                            // verify required parameter 'file' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdPut', 'file', file);
                            // verify required parameter 'isCarrierDocument' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdPut', 'isCarrierDocument', isCarrierDocument);
                            // verify required parameter 'type' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdPut', 'type', type);
                            localVarPath = "/quoting/spotnegotiations/spot-negotiations/{spotNegotiationId}/quotes/{spotNegotiationQuoteId}/documents/{spotNegotiationQuoteDocumentId}"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)))
                                .replace("{".concat("spotNegotiationQuoteId", "}"), encodeURIComponent(String(spotNegotiationQuoteId)))
                                .replace("{".concat("spotNegotiationQuoteDocumentId", "}"), encodeURIComponent(String(spotNegotiationQuoteDocumentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (description !== undefined) {
                                localVarFormParams.append('description', description);
                            }
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            if (isCarrierDocument !== undefined) {
                                localVarFormParams.append('is_carrier_document', isCarrierDocument);
                            }
                            if (type !== undefined) {
                                localVarFormParams.append('type', type);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdGet: function (spotNegotiationId, spotNegotiationQuoteId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdGet', 'spotNegotiationId', spotNegotiationId);
                            // verify required parameter 'spotNegotiationQuoteId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdGet', 'spotNegotiationQuoteId', spotNegotiationQuoteId);
                            localVarPath = "/quoting/spotnegotiations/spot-negotiations/{spotNegotiationId}/quotes/{spotNegotiationQuoteId}/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)))
                                .replace("{".concat("spotNegotiationQuoteId", "}"), encodeURIComponent(String(spotNegotiationQuoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {Quote} quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdPut: function (spotNegotiationId, spotNegotiationQuoteId, quote, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'spotNegotiationId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdPut', 'spotNegotiationId', spotNegotiationId);
                            // verify required parameter 'spotNegotiationQuoteId' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdPut', 'spotNegotiationQuoteId', spotNegotiationQuoteId);
                            // verify required parameter 'quote' is not null or undefined
                            (0, common_1.assertParamExists)('quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdPut', 'quote', quote);
                            localVarPath = "/quoting/spotnegotiations/spot-negotiations/{spotNegotiationId}/quotes/{spotNegotiationQuoteId}/"
                                .replace("{".concat("spotNegotiationId", "}"), encodeURIComponent(String(spotNegotiationId)))
                                .replace("{".concat("spotNegotiationQuoteId", "}"), encodeURIComponent(String(spotNegotiationQuoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(quote, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SpotNegotiationsApiAxiosParamCreator = SpotNegotiationsApiAxiosParamCreator;
/**
 * SpotNegotiationsApi - functional programming interface
 * @export
 */
var SpotNegotiationsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SpotNegotiationsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get, create, or update a negotiation in which you are the vendor and the shipment\'s customer_freight_authority is the customer. Only available to companies that are already assigned as a vendor to that customer.
         * @param {string} shipmentId The id of the shipment
         * @param {SpotNegotiation} spotNegotiation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsCustomerNegotiationPost: function (shipmentId, spotNegotiation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsCustomerNegotiationPost(shipmentId, spotNegotiation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List all outstanding negotiations under this shipment where the authenticated user is a customer
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {boolean} [expandQuotes] Boolean, if True will include quotes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsGet: function (shipmentId, page, pageSize, expandQuotes, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsGet(shipmentId, page, pageSize, expandQuotes, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Bulk create SpotNegotiations for a Shipment
         * @param {string} shipmentId The id of the shipment
         * @param {BulkCreateSpotNegotiationRequest} bulkCreateSpotNegotiationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsPost: function (shipmentId, bulkCreateSpotNegotiationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsPost(shipmentId, bulkCreateSpotNegotiationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a preview of the HTML Email that will be sent and the included message
         * @param {string} shipmentId The id of the shipment
         * @param {boolean} [isCustomerFacing] If True, render a template for sending a quote to a customer. Else, render a request for quote to be sent to a vendor.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsPreviewGet: function (shipmentId, isCustomerFacing, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsPreviewGet(shipmentId, isCustomerFacing, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List all SpotNegotiations in which the user\'s company is involved
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [closedByCustomer] Restrict SpotNegotiations based on whether customer closed
         * @param {boolean} [closedByVendor] Restrict SpotNegotiations based on whether vendor closed
         * @param {string} [customerId] ID of customer company to which to restrict SpotNegotiations
         * @param {string} [customerNameContains] Partial name of customer company to which to restrict SpotNegotiations
         * @param {boolean} [involvedOnly] Restrict SpotNegotiations to those in which user is explicitly involved
         * @param {Array<string>} [involvedVendorUsers] Restrict SpotNegotiations to those with provided User IDs involved on the vendor side
         * @param {boolean} [isMostRecentWinner] Restrict SpotNegotiations to those that are or are not the most recent winner
         * @param {boolean} [isOpen] Restrict SpotNegotiations based on both sides agreeing the negotiation is open
         * @param {string} [shipment] Return SpotNegotiations where Shipment ID matches
         * @param {string} [shipmentBolNumber] Return SpotNegotiations where Shipment BOL number matches
         * @param {string} [shipmentBolNumberContains] Return SpotNegotiations where Shipment BOL number partially matches
         * @param {string} [shipmentCapacityProviderCustomerReferenceNumber] Return SpotNegotiations where Shipment capacity provider customer reference number matches
         * @param {string} [shipmentCapacityProviderCustomerReferenceNumberContains] Return SpotNegotiations where Shipment capacity provider customer reference number partially matches
         * @param {string} [shipmentCustomerReferenceNumber] Return SpotNegotiations where Shipment customer reference number matches
         * @param {string} [shipmentCustomerReferenceNumberContains] Return SpotNegotiations where Shipment customer reference number partially matches
         * @param {string} [shipmentDelayed] Return SpotNegotiations where Shipment delayed matches
         * @param {string} [shipmentDestinationContains] Return SpotNegotiations where Shipment destination partially matches
         * @param {string} [shipmentDropoffGte] Return SpotNegotiations with a dropoff stop with a planned date greater than or equal to this value
         * @param {string} [shipmentDropoffLte] Return SpotNegotiations with a dropoff stop with a planned data less than or equal to this value
         * @param {string} [shipmentName] Return SpotNegotiations where Shipment name matches
         * @param {string} [shipmentNameContains] Return SpotNegotiations where Shipment name partially matches
         * @param {string} [shipmentOriginContains] Return SpotNegotiations where Shipment origin partially matches
         * @param {string} [shipmentPickupGte] Return SpotNegotiations with a pickup stop with a planned date greater than or equal to this value
         * @param {string} [shipmentPickupLte] Return SpotNegotiations with a pickup stop with a planned date less than or equal to this value
         * @param {string} [shipmentPickupNumber] Return SpotNegotiations where Shipment pickup number matches
         * @param {string} [shipmentPickupNumberContains] Return SpotNegotiations where Shipment pickup number partially matches
         * @param {string} [shipmentProNumber] Return SpotNegotiations where Shipment PRO number matches
         * @param {string} [shipmentProNumberContains] Return SpotNegotiations where Shipment PRO number partially matches
         * @param {string} [shipmentPurchaseOrderNumber] Return SpotNegotiations where Shipment purchase order number matches
         * @param {string} [shipmentPurchaseOrderNumberContains] Return SpotNegotiations where Shipment purchase order number partially matches
         * @param {string} [shipmentReferenceId] Return SpotNegotiations where Shipment reference_id matches
         * @param {string} [shipmentReferenceIdContains] Return SpotNegotiations where Shipment reference_id partially matches
         * @param {string} [shipmentState] Return SpotNegotiations where Shipment state matches
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [shipmentStatus] Return SpotNegotiations with shipments that have provided statuses
         * @param {string} [vendorId] ID of the vendor company to which to restrict SpotNegotiations
         * @param {string} [vendorNameContains] Partial name of the vendor company to which to restrict SpotNegotiations
         * @param {number} [expandQuotes] Boolean, if True will include quotes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsGet: function (page, pageSize, ordering, q, closedByCustomer, closedByVendor, customerId, customerNameContains, involvedOnly, involvedVendorUsers, isMostRecentWinner, isOpen, shipment, shipmentBolNumber, shipmentBolNumberContains, shipmentCapacityProviderCustomerReferenceNumber, shipmentCapacityProviderCustomerReferenceNumberContains, shipmentCustomerReferenceNumber, shipmentCustomerReferenceNumberContains, shipmentDelayed, shipmentDestinationContains, shipmentDropoffGte, shipmentDropoffLte, shipmentName, shipmentNameContains, shipmentOriginContains, shipmentPickupGte, shipmentPickupLte, shipmentPickupNumber, shipmentPickupNumberContains, shipmentProNumber, shipmentProNumberContains, shipmentPurchaseOrderNumber, shipmentPurchaseOrderNumberContains, shipmentReferenceId, shipmentReferenceIdContains, shipmentState, shipmentStatus, vendorId, vendorNameContains, expandQuotes, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingSpotnegotiationsSpotNegotiationsGet(page, pageSize, ordering, q, closedByCustomer, closedByVendor, customerId, customerNameContains, involvedOnly, involvedVendorUsers, isMostRecentWinner, isOpen, shipment, shipmentBolNumber, shipmentBolNumberContains, shipmentCapacityProviderCustomerReferenceNumber, shipmentCapacityProviderCustomerReferenceNumberContains, shipmentCustomerReferenceNumber, shipmentCustomerReferenceNumberContains, shipmentDelayed, shipmentDestinationContains, shipmentDropoffGte, shipmentDropoffLte, shipmentName, shipmentNameContains, shipmentOriginContains, shipmentPickupGte, shipmentPickupLte, shipmentPickupNumber, shipmentPickupNumberContains, shipmentProNumber, shipmentProNumberContains, shipmentPurchaseOrderNumber, shipmentPurchaseOrderNumberContains, shipmentReferenceId, shipmentReferenceIdContains, shipmentState, shipmentStatus, vendorId, vendorNameContains, expandQuotes, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Open or close authenticated company\'s side of the provided negotiations
         * @param {OpenCloseSpotNegotiationsRequest} openCloseSpotNegotiationsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsOpenClosePost: function (openCloseSpotNegotiationsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingSpotnegotiationsSpotNegotiationsOpenClosePost(openCloseSpotNegotiationsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Accept a shipment for the customer buy-it-now amount
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {BuyItNow} buyItNow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdBuyItNowPost: function (spotNegotiationId, buyItNow, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdBuyItNowPost(spotNegotiationId, buyItNow, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a ShipmentSpotNegotiation by its id
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdGet: function (spotNegotiationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdGet(spotNegotiationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List all SpotNegotiationMessages of a SpotNegotiation
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} [q] search query
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesGet: function (spotNegotiationId, q, page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesGet(spotNegotiationId, q, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a SpotNegotiationMessage
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {SpotNegotiationMessage} spotNegotiationMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesPost: function (spotNegotiationId, spotNegotiationMessage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesPost(spotNegotiationId, spotNegotiationMessage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a SpotNegotiationMessage
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationMessageId The id of the spot negotiation message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdDelete: function (spotNegotiationId, spotNegotiationMessageId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdDelete(spotNegotiationId, spotNegotiationMessageId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a SpotNegotiationMessage
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationMessageId The id of the spot negotiation message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdGet: function (spotNegotiationId, spotNegotiationMessageId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdGet(spotNegotiationId, spotNegotiationMessageId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a SpotNegotiationMessage
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationMessageId The id of the spot negotiation message
         * @param {SpotNegotiationMessage} spotNegotiationMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdPut: function (spotNegotiationId, spotNegotiationMessageId, spotNegotiationMessage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdPut(spotNegotiationId, spotNegotiationMessageId, spotNegotiationMessage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a ShipmentSpotNegotiation
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {ShipmentSpotNegotiation} shipmentSpotNegotiation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdPut: function (spotNegotiationId, shipmentSpotNegotiation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdPut(spotNegotiationId, shipmentSpotNegotiation, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List all Quotes of the SpotNegotiation
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesGet: function (spotNegotiationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesGet(spotNegotiationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a Quote on the SpotNegotiation
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {CreateSpotNegotiationQuote} createSpotNegotiationQuote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesPost: function (spotNegotiationId, createSpotNegotiationQuote, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesPost(spotNegotiationId, createSpotNegotiationQuote, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Award or decline a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {AwardDeclineQuoteRequest} awardDeclineQuoteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdAwardDeclinePut: function (spotNegotiationId, spotNegotiationQuoteId, awardDeclineQuoteRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdAwardDeclinePut(spotNegotiationId, spotNegotiationQuoteId, awardDeclineQuoteRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDelete: function (spotNegotiationId, spotNegotiationQuoteId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDelete(spotNegotiationId, spotNegotiationQuoteId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List of all Documents under a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsGet: function (spotNegotiationId, spotNegotiationQuoteId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsGet(spotNegotiationId, spotNegotiationQuoteId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a SpotNegotiation Quote Document
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {string} description
         * @param {any} file
         * @param {boolean} isCarrierDocument
         * @param {string} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsPost: function (spotNegotiationId, spotNegotiationQuoteId, description, file, isCarrierDocument, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsPost(spotNegotiationId, spotNegotiationQuoteId, description, file, isCarrierDocument, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a spot negotiation quote document
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {string} spotNegotiationQuoteDocumentId The id of the spot negotiation quote document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdDelete: function (spotNegotiationId, spotNegotiationQuoteId, spotNegotiationQuoteDocumentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdDelete(spotNegotiationId, spotNegotiationQuoteId, spotNegotiationQuoteDocumentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a Documents under a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {string} spotNegotiationQuoteDocumentId The id of the spot negotiation quote document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdGet: function (spotNegotiationId, spotNegotiationQuoteId, spotNegotiationQuoteDocumentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdGet(spotNegotiationId, spotNegotiationQuoteId, spotNegotiationQuoteDocumentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a SpotNegotiation Quote Document
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {string} spotNegotiationQuoteDocumentId The id of the spot negotiation quote document
         * @param {string} description
         * @param {any} file
         * @param {boolean} isCarrierDocument
         * @param {string} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdPut: function (spotNegotiationId, spotNegotiationQuoteId, spotNegotiationQuoteDocumentId, description, file, isCarrierDocument, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdPut(spotNegotiationId, spotNegotiationQuoteId, spotNegotiationQuoteDocumentId, description, file, isCarrierDocument, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdGet: function (spotNegotiationId, spotNegotiationQuoteId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdGet(spotNegotiationId, spotNegotiationQuoteId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {Quote} quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdPut: function (spotNegotiationId, spotNegotiationQuoteId, quote, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdPut(spotNegotiationId, spotNegotiationQuoteId, quote, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SpotNegotiationsApiFp = SpotNegotiationsApiFp;
/**
 * SpotNegotiationsApi - factory interface
 * @export
 */
var SpotNegotiationsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SpotNegotiationsApiFp)(configuration);
    return {
        /**
         *
         * @summary Get, create, or update a negotiation in which you are the vendor and the shipment\'s customer_freight_authority is the customer. Only available to companies that are already assigned as a vendor to that customer.
         * @param {string} shipmentId The id of the shipment
         * @param {SpotNegotiation} spotNegotiation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsCustomerNegotiationPost: function (shipmentId, spotNegotiation, options) {
            return localVarFp.quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsCustomerNegotiationPost(shipmentId, spotNegotiation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List all outstanding negotiations under this shipment where the authenticated user is a customer
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {boolean} [expandQuotes] Boolean, if True will include quotes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsGet: function (shipmentId, page, pageSize, expandQuotes, options) {
            return localVarFp.quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsGet(shipmentId, page, pageSize, expandQuotes, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Bulk create SpotNegotiations for a Shipment
         * @param {string} shipmentId The id of the shipment
         * @param {BulkCreateSpotNegotiationRequest} bulkCreateSpotNegotiationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsPost: function (shipmentId, bulkCreateSpotNegotiationRequest, options) {
            return localVarFp.quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsPost(shipmentId, bulkCreateSpotNegotiationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a preview of the HTML Email that will be sent and the included message
         * @param {string} shipmentId The id of the shipment
         * @param {boolean} [isCustomerFacing] If True, render a template for sending a quote to a customer. Else, render a request for quote to be sent to a vendor.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsPreviewGet: function (shipmentId, isCustomerFacing, options) {
            return localVarFp.quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsPreviewGet(shipmentId, isCustomerFacing, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List all SpotNegotiations in which the user\'s company is involved
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {boolean} [closedByCustomer] Restrict SpotNegotiations based on whether customer closed
         * @param {boolean} [closedByVendor] Restrict SpotNegotiations based on whether vendor closed
         * @param {string} [customerId] ID of customer company to which to restrict SpotNegotiations
         * @param {string} [customerNameContains] Partial name of customer company to which to restrict SpotNegotiations
         * @param {boolean} [involvedOnly] Restrict SpotNegotiations to those in which user is explicitly involved
         * @param {Array<string>} [involvedVendorUsers] Restrict SpotNegotiations to those with provided User IDs involved on the vendor side
         * @param {boolean} [isMostRecentWinner] Restrict SpotNegotiations to those that are or are not the most recent winner
         * @param {boolean} [isOpen] Restrict SpotNegotiations based on both sides agreeing the negotiation is open
         * @param {string} [shipment] Return SpotNegotiations where Shipment ID matches
         * @param {string} [shipmentBolNumber] Return SpotNegotiations where Shipment BOL number matches
         * @param {string} [shipmentBolNumberContains] Return SpotNegotiations where Shipment BOL number partially matches
         * @param {string} [shipmentCapacityProviderCustomerReferenceNumber] Return SpotNegotiations where Shipment capacity provider customer reference number matches
         * @param {string} [shipmentCapacityProviderCustomerReferenceNumberContains] Return SpotNegotiations where Shipment capacity provider customer reference number partially matches
         * @param {string} [shipmentCustomerReferenceNumber] Return SpotNegotiations where Shipment customer reference number matches
         * @param {string} [shipmentCustomerReferenceNumberContains] Return SpotNegotiations where Shipment customer reference number partially matches
         * @param {string} [shipmentDelayed] Return SpotNegotiations where Shipment delayed matches
         * @param {string} [shipmentDestinationContains] Return SpotNegotiations where Shipment destination partially matches
         * @param {string} [shipmentDropoffGte] Return SpotNegotiations with a dropoff stop with a planned date greater than or equal to this value
         * @param {string} [shipmentDropoffLte] Return SpotNegotiations with a dropoff stop with a planned data less than or equal to this value
         * @param {string} [shipmentName] Return SpotNegotiations where Shipment name matches
         * @param {string} [shipmentNameContains] Return SpotNegotiations where Shipment name partially matches
         * @param {string} [shipmentOriginContains] Return SpotNegotiations where Shipment origin partially matches
         * @param {string} [shipmentPickupGte] Return SpotNegotiations with a pickup stop with a planned date greater than or equal to this value
         * @param {string} [shipmentPickupLte] Return SpotNegotiations with a pickup stop with a planned date less than or equal to this value
         * @param {string} [shipmentPickupNumber] Return SpotNegotiations where Shipment pickup number matches
         * @param {string} [shipmentPickupNumberContains] Return SpotNegotiations where Shipment pickup number partially matches
         * @param {string} [shipmentProNumber] Return SpotNegotiations where Shipment PRO number matches
         * @param {string} [shipmentProNumberContains] Return SpotNegotiations where Shipment PRO number partially matches
         * @param {string} [shipmentPurchaseOrderNumber] Return SpotNegotiations where Shipment purchase order number matches
         * @param {string} [shipmentPurchaseOrderNumberContains] Return SpotNegotiations where Shipment purchase order number partially matches
         * @param {string} [shipmentReferenceId] Return SpotNegotiations where Shipment reference_id matches
         * @param {string} [shipmentReferenceIdContains] Return SpotNegotiations where Shipment reference_id partially matches
         * @param {string} [shipmentState] Return SpotNegotiations where Shipment state matches
         * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [shipmentStatus] Return SpotNegotiations with shipments that have provided statuses
         * @param {string} [vendorId] ID of the vendor company to which to restrict SpotNegotiations
         * @param {string} [vendorNameContains] Partial name of the vendor company to which to restrict SpotNegotiations
         * @param {number} [expandQuotes] Boolean, if True will include quotes
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsGet: function (page, pageSize, ordering, q, closedByCustomer, closedByVendor, customerId, customerNameContains, involvedOnly, involvedVendorUsers, isMostRecentWinner, isOpen, shipment, shipmentBolNumber, shipmentBolNumberContains, shipmentCapacityProviderCustomerReferenceNumber, shipmentCapacityProviderCustomerReferenceNumberContains, shipmentCustomerReferenceNumber, shipmentCustomerReferenceNumberContains, shipmentDelayed, shipmentDestinationContains, shipmentDropoffGte, shipmentDropoffLte, shipmentName, shipmentNameContains, shipmentOriginContains, shipmentPickupGte, shipmentPickupLte, shipmentPickupNumber, shipmentPickupNumberContains, shipmentProNumber, shipmentProNumberContains, shipmentPurchaseOrderNumber, shipmentPurchaseOrderNumberContains, shipmentReferenceId, shipmentReferenceIdContains, shipmentState, shipmentStatus, vendorId, vendorNameContains, expandQuotes, options) {
            return localVarFp.quotingSpotnegotiationsSpotNegotiationsGet(page, pageSize, ordering, q, closedByCustomer, closedByVendor, customerId, customerNameContains, involvedOnly, involvedVendorUsers, isMostRecentWinner, isOpen, shipment, shipmentBolNumber, shipmentBolNumberContains, shipmentCapacityProviderCustomerReferenceNumber, shipmentCapacityProviderCustomerReferenceNumberContains, shipmentCustomerReferenceNumber, shipmentCustomerReferenceNumberContains, shipmentDelayed, shipmentDestinationContains, shipmentDropoffGte, shipmentDropoffLte, shipmentName, shipmentNameContains, shipmentOriginContains, shipmentPickupGte, shipmentPickupLte, shipmentPickupNumber, shipmentPickupNumberContains, shipmentProNumber, shipmentProNumberContains, shipmentPurchaseOrderNumber, shipmentPurchaseOrderNumberContains, shipmentReferenceId, shipmentReferenceIdContains, shipmentState, shipmentStatus, vendorId, vendorNameContains, expandQuotes, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Open or close authenticated company\'s side of the provided negotiations
         * @param {OpenCloseSpotNegotiationsRequest} openCloseSpotNegotiationsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsOpenClosePost: function (openCloseSpotNegotiationsRequest, options) {
            return localVarFp.quotingSpotnegotiationsSpotNegotiationsOpenClosePost(openCloseSpotNegotiationsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Accept a shipment for the customer buy-it-now amount
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {BuyItNow} buyItNow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdBuyItNowPost: function (spotNegotiationId, buyItNow, options) {
            return localVarFp.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdBuyItNowPost(spotNegotiationId, buyItNow, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a ShipmentSpotNegotiation by its id
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdGet: function (spotNegotiationId, options) {
            return localVarFp.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdGet(spotNegotiationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List all SpotNegotiationMessages of a SpotNegotiation
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} [q] search query
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesGet: function (spotNegotiationId, q, page, pageSize, options) {
            return localVarFp.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesGet(spotNegotiationId, q, page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a SpotNegotiationMessage
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {SpotNegotiationMessage} spotNegotiationMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesPost: function (spotNegotiationId, spotNegotiationMessage, options) {
            return localVarFp.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesPost(spotNegotiationId, spotNegotiationMessage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a SpotNegotiationMessage
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationMessageId The id of the spot negotiation message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdDelete: function (spotNegotiationId, spotNegotiationMessageId, options) {
            return localVarFp.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdDelete(spotNegotiationId, spotNegotiationMessageId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a SpotNegotiationMessage
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationMessageId The id of the spot negotiation message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdGet: function (spotNegotiationId, spotNegotiationMessageId, options) {
            return localVarFp.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdGet(spotNegotiationId, spotNegotiationMessageId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a SpotNegotiationMessage
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationMessageId The id of the spot negotiation message
         * @param {SpotNegotiationMessage} spotNegotiationMessage
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdPut: function (spotNegotiationId, spotNegotiationMessageId, spotNegotiationMessage, options) {
            return localVarFp.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdPut(spotNegotiationId, spotNegotiationMessageId, spotNegotiationMessage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a ShipmentSpotNegotiation
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {ShipmentSpotNegotiation} shipmentSpotNegotiation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdPut: function (spotNegotiationId, shipmentSpotNegotiation, options) {
            return localVarFp.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdPut(spotNegotiationId, shipmentSpotNegotiation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List all Quotes of the SpotNegotiation
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesGet: function (spotNegotiationId, options) {
            return localVarFp.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesGet(spotNegotiationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a Quote on the SpotNegotiation
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {CreateSpotNegotiationQuote} createSpotNegotiationQuote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesPost: function (spotNegotiationId, createSpotNegotiationQuote, options) {
            return localVarFp.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesPost(spotNegotiationId, createSpotNegotiationQuote, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Award or decline a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {AwardDeclineQuoteRequest} awardDeclineQuoteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdAwardDeclinePut: function (spotNegotiationId, spotNegotiationQuoteId, awardDeclineQuoteRequest, options) {
            return localVarFp.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdAwardDeclinePut(spotNegotiationId, spotNegotiationQuoteId, awardDeclineQuoteRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDelete: function (spotNegotiationId, spotNegotiationQuoteId, options) {
            return localVarFp.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDelete(spotNegotiationId, spotNegotiationQuoteId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List of all Documents under a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsGet: function (spotNegotiationId, spotNegotiationQuoteId, options) {
            return localVarFp.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsGet(spotNegotiationId, spotNegotiationQuoteId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a SpotNegotiation Quote Document
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {string} description
         * @param {any} file
         * @param {boolean} isCarrierDocument
         * @param {string} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsPost: function (spotNegotiationId, spotNegotiationQuoteId, description, file, isCarrierDocument, type, options) {
            return localVarFp.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsPost(spotNegotiationId, spotNegotiationQuoteId, description, file, isCarrierDocument, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a spot negotiation quote document
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {string} spotNegotiationQuoteDocumentId The id of the spot negotiation quote document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdDelete: function (spotNegotiationId, spotNegotiationQuoteId, spotNegotiationQuoteDocumentId, options) {
            return localVarFp.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdDelete(spotNegotiationId, spotNegotiationQuoteId, spotNegotiationQuoteDocumentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a Documents under a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {string} spotNegotiationQuoteDocumentId The id of the spot negotiation quote document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdGet: function (spotNegotiationId, spotNegotiationQuoteId, spotNegotiationQuoteDocumentId, options) {
            return localVarFp.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdGet(spotNegotiationId, spotNegotiationQuoteId, spotNegotiationQuoteDocumentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a SpotNegotiation Quote Document
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {string} spotNegotiationQuoteDocumentId The id of the spot negotiation quote document
         * @param {string} description
         * @param {any} file
         * @param {boolean} isCarrierDocument
         * @param {string} type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdPut: function (spotNegotiationId, spotNegotiationQuoteId, spotNegotiationQuoteDocumentId, description, file, isCarrierDocument, type, options) {
            return localVarFp.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdPut(spotNegotiationId, spotNegotiationQuoteId, spotNegotiationQuoteDocumentId, description, file, isCarrierDocument, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdGet: function (spotNegotiationId, spotNegotiationQuoteId, options) {
            return localVarFp.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdGet(spotNegotiationId, spotNegotiationQuoteId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a SpotNegotiation Quote
         * @param {string} spotNegotiationId The id of the spot negotiation
         * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
         * @param {Quote} quote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdPut: function (spotNegotiationId, spotNegotiationQuoteId, quote, options) {
            return localVarFp.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdPut(spotNegotiationId, spotNegotiationQuoteId, quote, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SpotNegotiationsApiFactory = SpotNegotiationsApiFactory;
/**
 * SpotNegotiationsApi - object-oriented interface
 * @export
 * @class SpotNegotiationsApi
 * @extends {BaseAPI}
 */
var SpotNegotiationsApi = /** @class */ (function (_super) {
    __extends(SpotNegotiationsApi, _super);
    function SpotNegotiationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get, create, or update a negotiation in which you are the vendor and the shipment\'s customer_freight_authority is the customer. Only available to companies that are already assigned as a vendor to that customer.
     * @param {string} shipmentId The id of the shipment
     * @param {SpotNegotiation} spotNegotiation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotNegotiationsApi
     */
    SpotNegotiationsApi.prototype.quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsCustomerNegotiationPost = function (shipmentId, spotNegotiation, options) {
        var _this = this;
        return (0, exports.SpotNegotiationsApiFp)(this.configuration).quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsCustomerNegotiationPost(shipmentId, spotNegotiation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List all outstanding negotiations under this shipment where the authenticated user is a customer
     * @param {string} shipmentId The id of the shipment
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {boolean} [expandQuotes] Boolean, if True will include quotes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotNegotiationsApi
     */
    SpotNegotiationsApi.prototype.quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsGet = function (shipmentId, page, pageSize, expandQuotes, options) {
        var _this = this;
        return (0, exports.SpotNegotiationsApiFp)(this.configuration).quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsGet(shipmentId, page, pageSize, expandQuotes, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Bulk create SpotNegotiations for a Shipment
     * @param {string} shipmentId The id of the shipment
     * @param {BulkCreateSpotNegotiationRequest} bulkCreateSpotNegotiationRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotNegotiationsApi
     */
    SpotNegotiationsApi.prototype.quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsPost = function (shipmentId, bulkCreateSpotNegotiationRequest, options) {
        var _this = this;
        return (0, exports.SpotNegotiationsApiFp)(this.configuration).quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsPost(shipmentId, bulkCreateSpotNegotiationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a preview of the HTML Email that will be sent and the included message
     * @param {string} shipmentId The id of the shipment
     * @param {boolean} [isCustomerFacing] If True, render a template for sending a quote to a customer. Else, render a request for quote to be sent to a vendor.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotNegotiationsApi
     */
    SpotNegotiationsApi.prototype.quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsPreviewGet = function (shipmentId, isCustomerFacing, options) {
        var _this = this;
        return (0, exports.SpotNegotiationsApiFp)(this.configuration).quotingSpotnegotiationsShipmentsShipmentIdSpotNegotiationsPreviewGet(shipmentId, isCustomerFacing, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List all SpotNegotiations in which the user\'s company is involved
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {boolean} [closedByCustomer] Restrict SpotNegotiations based on whether customer closed
     * @param {boolean} [closedByVendor] Restrict SpotNegotiations based on whether vendor closed
     * @param {string} [customerId] ID of customer company to which to restrict SpotNegotiations
     * @param {string} [customerNameContains] Partial name of customer company to which to restrict SpotNegotiations
     * @param {boolean} [involvedOnly] Restrict SpotNegotiations to those in which user is explicitly involved
     * @param {Array<string>} [involvedVendorUsers] Restrict SpotNegotiations to those with provided User IDs involved on the vendor side
     * @param {boolean} [isMostRecentWinner] Restrict SpotNegotiations to those that are or are not the most recent winner
     * @param {boolean} [isOpen] Restrict SpotNegotiations based on both sides agreeing the negotiation is open
     * @param {string} [shipment] Return SpotNegotiations where Shipment ID matches
     * @param {string} [shipmentBolNumber] Return SpotNegotiations where Shipment BOL number matches
     * @param {string} [shipmentBolNumberContains] Return SpotNegotiations where Shipment BOL number partially matches
     * @param {string} [shipmentCapacityProviderCustomerReferenceNumber] Return SpotNegotiations where Shipment capacity provider customer reference number matches
     * @param {string} [shipmentCapacityProviderCustomerReferenceNumberContains] Return SpotNegotiations where Shipment capacity provider customer reference number partially matches
     * @param {string} [shipmentCustomerReferenceNumber] Return SpotNegotiations where Shipment customer reference number matches
     * @param {string} [shipmentCustomerReferenceNumberContains] Return SpotNegotiations where Shipment customer reference number partially matches
     * @param {string} [shipmentDelayed] Return SpotNegotiations where Shipment delayed matches
     * @param {string} [shipmentDestinationContains] Return SpotNegotiations where Shipment destination partially matches
     * @param {string} [shipmentDropoffGte] Return SpotNegotiations with a dropoff stop with a planned date greater than or equal to this value
     * @param {string} [shipmentDropoffLte] Return SpotNegotiations with a dropoff stop with a planned data less than or equal to this value
     * @param {string} [shipmentName] Return SpotNegotiations where Shipment name matches
     * @param {string} [shipmentNameContains] Return SpotNegotiations where Shipment name partially matches
     * @param {string} [shipmentOriginContains] Return SpotNegotiations where Shipment origin partially matches
     * @param {string} [shipmentPickupGte] Return SpotNegotiations with a pickup stop with a planned date greater than or equal to this value
     * @param {string} [shipmentPickupLte] Return SpotNegotiations with a pickup stop with a planned date less than or equal to this value
     * @param {string} [shipmentPickupNumber] Return SpotNegotiations where Shipment pickup number matches
     * @param {string} [shipmentPickupNumberContains] Return SpotNegotiations where Shipment pickup number partially matches
     * @param {string} [shipmentProNumber] Return SpotNegotiations where Shipment PRO number matches
     * @param {string} [shipmentProNumberContains] Return SpotNegotiations where Shipment PRO number partially matches
     * @param {string} [shipmentPurchaseOrderNumber] Return SpotNegotiations where Shipment purchase order number matches
     * @param {string} [shipmentPurchaseOrderNumberContains] Return SpotNegotiations where Shipment purchase order number partially matches
     * @param {string} [shipmentReferenceId] Return SpotNegotiations where Shipment reference_id matches
     * @param {string} [shipmentReferenceIdContains] Return SpotNegotiations where Shipment reference_id partially matches
     * @param {string} [shipmentState] Return SpotNegotiations where Shipment state matches
     * @param {Array<'appointment_pending' | 'at_pickup' | 'at_delivery' | 'auction_running' | 'cancelled' | 'carrier_confirmed' | 'delayed' | 'delivered' | 'dispatched' | 'draft' | 'in_transit' | 'out_for_delivery' | 'quote_accepted' | 'quoting' | 'reconciled' | 'scheduled' | 'tendered'>} [shipmentStatus] Return SpotNegotiations with shipments that have provided statuses
     * @param {string} [vendorId] ID of the vendor company to which to restrict SpotNegotiations
     * @param {string} [vendorNameContains] Partial name of the vendor company to which to restrict SpotNegotiations
     * @param {number} [expandQuotes] Boolean, if True will include quotes
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotNegotiationsApi
     */
    SpotNegotiationsApi.prototype.quotingSpotnegotiationsSpotNegotiationsGet = function (page, pageSize, ordering, q, closedByCustomer, closedByVendor, customerId, customerNameContains, involvedOnly, involvedVendorUsers, isMostRecentWinner, isOpen, shipment, shipmentBolNumber, shipmentBolNumberContains, shipmentCapacityProviderCustomerReferenceNumber, shipmentCapacityProviderCustomerReferenceNumberContains, shipmentCustomerReferenceNumber, shipmentCustomerReferenceNumberContains, shipmentDelayed, shipmentDestinationContains, shipmentDropoffGte, shipmentDropoffLte, shipmentName, shipmentNameContains, shipmentOriginContains, shipmentPickupGte, shipmentPickupLte, shipmentPickupNumber, shipmentPickupNumberContains, shipmentProNumber, shipmentProNumberContains, shipmentPurchaseOrderNumber, shipmentPurchaseOrderNumberContains, shipmentReferenceId, shipmentReferenceIdContains, shipmentState, shipmentStatus, vendorId, vendorNameContains, expandQuotes, options) {
        var _this = this;
        return (0, exports.SpotNegotiationsApiFp)(this.configuration).quotingSpotnegotiationsSpotNegotiationsGet(page, pageSize, ordering, q, closedByCustomer, closedByVendor, customerId, customerNameContains, involvedOnly, involvedVendorUsers, isMostRecentWinner, isOpen, shipment, shipmentBolNumber, shipmentBolNumberContains, shipmentCapacityProviderCustomerReferenceNumber, shipmentCapacityProviderCustomerReferenceNumberContains, shipmentCustomerReferenceNumber, shipmentCustomerReferenceNumberContains, shipmentDelayed, shipmentDestinationContains, shipmentDropoffGte, shipmentDropoffLte, shipmentName, shipmentNameContains, shipmentOriginContains, shipmentPickupGte, shipmentPickupLte, shipmentPickupNumber, shipmentPickupNumberContains, shipmentProNumber, shipmentProNumberContains, shipmentPurchaseOrderNumber, shipmentPurchaseOrderNumberContains, shipmentReferenceId, shipmentReferenceIdContains, shipmentState, shipmentStatus, vendorId, vendorNameContains, expandQuotes, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Open or close authenticated company\'s side of the provided negotiations
     * @param {OpenCloseSpotNegotiationsRequest} openCloseSpotNegotiationsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotNegotiationsApi
     */
    SpotNegotiationsApi.prototype.quotingSpotnegotiationsSpotNegotiationsOpenClosePost = function (openCloseSpotNegotiationsRequest, options) {
        var _this = this;
        return (0, exports.SpotNegotiationsApiFp)(this.configuration).quotingSpotnegotiationsSpotNegotiationsOpenClosePost(openCloseSpotNegotiationsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Accept a shipment for the customer buy-it-now amount
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {BuyItNow} buyItNow
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotNegotiationsApi
     */
    SpotNegotiationsApi.prototype.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdBuyItNowPost = function (spotNegotiationId, buyItNow, options) {
        var _this = this;
        return (0, exports.SpotNegotiationsApiFp)(this.configuration).quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdBuyItNowPost(spotNegotiationId, buyItNow, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a ShipmentSpotNegotiation by its id
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotNegotiationsApi
     */
    SpotNegotiationsApi.prototype.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdGet = function (spotNegotiationId, options) {
        var _this = this;
        return (0, exports.SpotNegotiationsApiFp)(this.configuration).quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdGet(spotNegotiationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List all SpotNegotiationMessages of a SpotNegotiation
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {string} [q] search query
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotNegotiationsApi
     */
    SpotNegotiationsApi.prototype.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesGet = function (spotNegotiationId, q, page, pageSize, options) {
        var _this = this;
        return (0, exports.SpotNegotiationsApiFp)(this.configuration).quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesGet(spotNegotiationId, q, page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a SpotNegotiationMessage
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {SpotNegotiationMessage} spotNegotiationMessage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotNegotiationsApi
     */
    SpotNegotiationsApi.prototype.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesPost = function (spotNegotiationId, spotNegotiationMessage, options) {
        var _this = this;
        return (0, exports.SpotNegotiationsApiFp)(this.configuration).quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesPost(spotNegotiationId, spotNegotiationMessage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a SpotNegotiationMessage
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {string} spotNegotiationMessageId The id of the spot negotiation message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotNegotiationsApi
     */
    SpotNegotiationsApi.prototype.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdDelete = function (spotNegotiationId, spotNegotiationMessageId, options) {
        var _this = this;
        return (0, exports.SpotNegotiationsApiFp)(this.configuration).quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdDelete(spotNegotiationId, spotNegotiationMessageId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a SpotNegotiationMessage
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {string} spotNegotiationMessageId The id of the spot negotiation message
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotNegotiationsApi
     */
    SpotNegotiationsApi.prototype.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdGet = function (spotNegotiationId, spotNegotiationMessageId, options) {
        var _this = this;
        return (0, exports.SpotNegotiationsApiFp)(this.configuration).quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdGet(spotNegotiationId, spotNegotiationMessageId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a SpotNegotiationMessage
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {string} spotNegotiationMessageId The id of the spot negotiation message
     * @param {SpotNegotiationMessage} spotNegotiationMessage
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotNegotiationsApi
     */
    SpotNegotiationsApi.prototype.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdPut = function (spotNegotiationId, spotNegotiationMessageId, spotNegotiationMessage, options) {
        var _this = this;
        return (0, exports.SpotNegotiationsApiFp)(this.configuration).quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdMessagesSpotNegotiationMessageIdPut(spotNegotiationId, spotNegotiationMessageId, spotNegotiationMessage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a ShipmentSpotNegotiation
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {ShipmentSpotNegotiation} shipmentSpotNegotiation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotNegotiationsApi
     */
    SpotNegotiationsApi.prototype.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdPut = function (spotNegotiationId, shipmentSpotNegotiation, options) {
        var _this = this;
        return (0, exports.SpotNegotiationsApiFp)(this.configuration).quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdPut(spotNegotiationId, shipmentSpotNegotiation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List all Quotes of the SpotNegotiation
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotNegotiationsApi
     */
    SpotNegotiationsApi.prototype.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesGet = function (spotNegotiationId, options) {
        var _this = this;
        return (0, exports.SpotNegotiationsApiFp)(this.configuration).quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesGet(spotNegotiationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a Quote on the SpotNegotiation
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {CreateSpotNegotiationQuote} createSpotNegotiationQuote
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotNegotiationsApi
     */
    SpotNegotiationsApi.prototype.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesPost = function (spotNegotiationId, createSpotNegotiationQuote, options) {
        var _this = this;
        return (0, exports.SpotNegotiationsApiFp)(this.configuration).quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesPost(spotNegotiationId, createSpotNegotiationQuote, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Award or decline a SpotNegotiation Quote
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
     * @param {AwardDeclineQuoteRequest} awardDeclineQuoteRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotNegotiationsApi
     */
    SpotNegotiationsApi.prototype.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdAwardDeclinePut = function (spotNegotiationId, spotNegotiationQuoteId, awardDeclineQuoteRequest, options) {
        var _this = this;
        return (0, exports.SpotNegotiationsApiFp)(this.configuration).quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdAwardDeclinePut(spotNegotiationId, spotNegotiationQuoteId, awardDeclineQuoteRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a SpotNegotiation Quote
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotNegotiationsApi
     */
    SpotNegotiationsApi.prototype.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDelete = function (spotNegotiationId, spotNegotiationQuoteId, options) {
        var _this = this;
        return (0, exports.SpotNegotiationsApiFp)(this.configuration).quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDelete(spotNegotiationId, spotNegotiationQuoteId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List of all Documents under a SpotNegotiation Quote
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotNegotiationsApi
     */
    SpotNegotiationsApi.prototype.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsGet = function (spotNegotiationId, spotNegotiationQuoteId, options) {
        var _this = this;
        return (0, exports.SpotNegotiationsApiFp)(this.configuration).quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsGet(spotNegotiationId, spotNegotiationQuoteId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a SpotNegotiation Quote Document
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
     * @param {string} description
     * @param {any} file
     * @param {boolean} isCarrierDocument
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotNegotiationsApi
     */
    SpotNegotiationsApi.prototype.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsPost = function (spotNegotiationId, spotNegotiationQuoteId, description, file, isCarrierDocument, type, options) {
        var _this = this;
        return (0, exports.SpotNegotiationsApiFp)(this.configuration).quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsPost(spotNegotiationId, spotNegotiationQuoteId, description, file, isCarrierDocument, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a spot negotiation quote document
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
     * @param {string} spotNegotiationQuoteDocumentId The id of the spot negotiation quote document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotNegotiationsApi
     */
    SpotNegotiationsApi.prototype.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdDelete = function (spotNegotiationId, spotNegotiationQuoteId, spotNegotiationQuoteDocumentId, options) {
        var _this = this;
        return (0, exports.SpotNegotiationsApiFp)(this.configuration).quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdDelete(spotNegotiationId, spotNegotiationQuoteId, spotNegotiationQuoteDocumentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a Documents under a SpotNegotiation Quote
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
     * @param {string} spotNegotiationQuoteDocumentId The id of the spot negotiation quote document
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotNegotiationsApi
     */
    SpotNegotiationsApi.prototype.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdGet = function (spotNegotiationId, spotNegotiationQuoteId, spotNegotiationQuoteDocumentId, options) {
        var _this = this;
        return (0, exports.SpotNegotiationsApiFp)(this.configuration).quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdGet(spotNegotiationId, spotNegotiationQuoteId, spotNegotiationQuoteDocumentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a SpotNegotiation Quote Document
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
     * @param {string} spotNegotiationQuoteDocumentId The id of the spot negotiation quote document
     * @param {string} description
     * @param {any} file
     * @param {boolean} isCarrierDocument
     * @param {string} type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotNegotiationsApi
     */
    SpotNegotiationsApi.prototype.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdPut = function (spotNegotiationId, spotNegotiationQuoteId, spotNegotiationQuoteDocumentId, description, file, isCarrierDocument, type, options) {
        var _this = this;
        return (0, exports.SpotNegotiationsApiFp)(this.configuration).quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdDocumentsSpotNegotiationQuoteDocumentIdPut(spotNegotiationId, spotNegotiationQuoteId, spotNegotiationQuoteDocumentId, description, file, isCarrierDocument, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about a SpotNegotiation Quote
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotNegotiationsApi
     */
    SpotNegotiationsApi.prototype.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdGet = function (spotNegotiationId, spotNegotiationQuoteId, options) {
        var _this = this;
        return (0, exports.SpotNegotiationsApiFp)(this.configuration).quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdGet(spotNegotiationId, spotNegotiationQuoteId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a SpotNegotiation Quote
     * @param {string} spotNegotiationId The id of the spot negotiation
     * @param {string} spotNegotiationQuoteId The id of the spot negotiation quote
     * @param {Quote} quote
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SpotNegotiationsApi
     */
    SpotNegotiationsApi.prototype.quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdPut = function (spotNegotiationId, spotNegotiationQuoteId, quote, options) {
        var _this = this;
        return (0, exports.SpotNegotiationsApiFp)(this.configuration).quotingSpotnegotiationsSpotNegotiationsSpotNegotiationIdQuotesSpotNegotiationQuoteIdPut(spotNegotiationId, spotNegotiationQuoteId, quote, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SpotNegotiationsApi;
}(base_1.BaseAPI));
exports.SpotNegotiationsApi = SpotNegotiationsApi;
/**
 * SuppliersApi - axios parameter creator
 * @export
 */
var SuppliersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get a list of address book entries that are owned by the tenant that owns the Suppliers related to the authenticated User
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [supplierId] Supplier id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersAddressesGet: function (page, pageSize, ordering, q, supplierId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/suppliers/addresses/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (supplierId !== undefined) {
                                localVarQueryParameter['supplier_id'] = supplierId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the list of Suppliers
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [name] The name of the Supplier
         * @param {string} [supplierUserFullName] The full name of the Supplier User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersGet: function (page, pageSize, ordering, q, name, supplierUserFullName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/suppliers/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (name !== undefined) {
                                localVarQueryParameter['name'] = name;
                            }
                            if (supplierUserFullName !== undefined) {
                                localVarQueryParameter['supplier_user_full_name'] = supplierUserFullName;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new Supplier
         * @param {CreateSupplier} [createSupplier]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersPost: function (createSupplier, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/suppliers/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createSupplier, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a Supplier
         * @param {string} supplierId Supplier id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersSupplierIdDelete: function (supplierId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'supplierId' is not null or undefined
                            (0, common_1.assertParamExists)('suppliersSupplierIdDelete', 'supplierId', supplierId);
                            localVarPath = "/suppliers/{supplierId}"
                                .replace("{".concat("supplierId", "}"), encodeURIComponent(String(supplierId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a Supplier
         * @param {string} supplierId Supplier id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersSupplierIdGet: function (supplierId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'supplierId' is not null or undefined
                            (0, common_1.assertParamExists)('suppliersSupplierIdGet', 'supplierId', supplierId);
                            localVarPath = "/suppliers/{supplierId}"
                                .replace("{".concat("supplierId", "}"), encodeURIComponent(String(supplierId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a Supplier
         * @param {string} supplierId Supplier id
         * @param {UpdateSupplier} [updateSupplier]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersSupplierIdPut: function (supplierId, updateSupplier, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'supplierId' is not null or undefined
                            (0, common_1.assertParamExists)('suppliersSupplierIdPut', 'supplierId', supplierId);
                            localVarPath = "/suppliers/{supplierId}"
                                .replace("{".concat("supplierId", "}"), encodeURIComponent(String(supplierId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateSupplier, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new Supplier User
         * @param {string} supplierId Supplier id
         * @param {CreateSupplierUser} [createSupplierUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersSupplierIdUsersPost: function (supplierId, createSupplierUser, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'supplierId' is not null or undefined
                            (0, common_1.assertParamExists)('suppliersSupplierIdUsersPost', 'supplierId', supplierId);
                            localVarPath = "/suppliers/{supplierId}/users/"
                                .replace("{".concat("supplierId", "}"), encodeURIComponent(String(supplierId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createSupplierUser, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a Supplier User Relationship
         * @param {string} supplierId Supplier id
         * @param {string} supplierUserId Supplier User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersSupplierIdUsersSupplierUserIdDelete: function (supplierId, supplierUserId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'supplierId' is not null or undefined
                            (0, common_1.assertParamExists)('suppliersSupplierIdUsersSupplierUserIdDelete', 'supplierId', supplierId);
                            // verify required parameter 'supplierUserId' is not null or undefined
                            (0, common_1.assertParamExists)('suppliersSupplierIdUsersSupplierUserIdDelete', 'supplierUserId', supplierUserId);
                            localVarPath = "/suppliers/{supplierId}/users/{supplierUserId}"
                                .replace("{".concat("supplierId", "}"), encodeURIComponent(String(supplierId)))
                                .replace("{".concat("supplierUserId", "}"), encodeURIComponent(String(supplierUserId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a new Supplier User
         * @param {string} supplierId Supplier id
         * @param {string} supplierUserId Supplier User id
         * @param {CreateSupplierUser} [createSupplierUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersSupplierIdUsersSupplierUserIdPut: function (supplierId, supplierUserId, createSupplierUser, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'supplierId' is not null or undefined
                            (0, common_1.assertParamExists)('suppliersSupplierIdUsersSupplierUserIdPut', 'supplierId', supplierId);
                            // verify required parameter 'supplierUserId' is not null or undefined
                            (0, common_1.assertParamExists)('suppliersSupplierIdUsersSupplierUserIdPut', 'supplierUserId', supplierUserId);
                            localVarPath = "/suppliers/{supplierId}/users/{supplierUserId}"
                                .replace("{".concat("supplierId", "}"), encodeURIComponent(String(supplierId)))
                                .replace("{".concat("supplierUserId", "}"), encodeURIComponent(String(supplierUserId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createSupplierUser, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the list of Suppliers that the requesting User is part of
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersSuppliersGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/users/suppliers";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SuppliersApiAxiosParamCreator = SuppliersApiAxiosParamCreator;
/**
 * SuppliersApi - functional programming interface
 * @export
 */
var SuppliersApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SuppliersApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get a list of address book entries that are owned by the tenant that owns the Suppliers related to the authenticated User
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [supplierId] Supplier id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersAddressesGet: function (page, pageSize, ordering, q, supplierId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.suppliersAddressesGet(page, pageSize, ordering, q, supplierId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the list of Suppliers
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [name] The name of the Supplier
         * @param {string} [supplierUserFullName] The full name of the Supplier User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersGet: function (page, pageSize, ordering, q, name, supplierUserFullName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.suppliersGet(page, pageSize, ordering, q, name, supplierUserFullName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new Supplier
         * @param {CreateSupplier} [createSupplier]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersPost: function (createSupplier, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.suppliersPost(createSupplier, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a Supplier
         * @param {string} supplierId Supplier id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersSupplierIdDelete: function (supplierId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.suppliersSupplierIdDelete(supplierId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get a Supplier
         * @param {string} supplierId Supplier id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersSupplierIdGet: function (supplierId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.suppliersSupplierIdGet(supplierId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a Supplier
         * @param {string} supplierId Supplier id
         * @param {UpdateSupplier} [updateSupplier]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersSupplierIdPut: function (supplierId, updateSupplier, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.suppliersSupplierIdPut(supplierId, updateSupplier, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new Supplier User
         * @param {string} supplierId Supplier id
         * @param {CreateSupplierUser} [createSupplierUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersSupplierIdUsersPost: function (supplierId, createSupplierUser, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.suppliersSupplierIdUsersPost(supplierId, createSupplierUser, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a Supplier User Relationship
         * @param {string} supplierId Supplier id
         * @param {string} supplierUserId Supplier User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersSupplierIdUsersSupplierUserIdDelete: function (supplierId, supplierUserId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.suppliersSupplierIdUsersSupplierUserIdDelete(supplierId, supplierUserId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a new Supplier User
         * @param {string} supplierId Supplier id
         * @param {string} supplierUserId Supplier User id
         * @param {CreateSupplierUser} [createSupplierUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersSupplierIdUsersSupplierUserIdPut: function (supplierId, supplierUserId, createSupplierUser, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.suppliersSupplierIdUsersSupplierUserIdPut(supplierId, supplierUserId, createSupplierUser, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get the list of Suppliers that the requesting User is part of
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersSuppliersGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.usersSuppliersGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SuppliersApiFp = SuppliersApiFp;
/**
 * SuppliersApi - factory interface
 * @export
 */
var SuppliersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SuppliersApiFp)(configuration);
    return {
        /**
         *
         * @summary Get a list of address book entries that are owned by the tenant that owns the Suppliers related to the authenticated User
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [supplierId] Supplier id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersAddressesGet: function (page, pageSize, ordering, q, supplierId, options) {
            return localVarFp.suppliersAddressesGet(page, pageSize, ordering, q, supplierId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get the list of Suppliers
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [name] The name of the Supplier
         * @param {string} [supplierUserFullName] The full name of the Supplier User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersGet: function (page, pageSize, ordering, q, name, supplierUserFullName, options) {
            return localVarFp.suppliersGet(page, pageSize, ordering, q, name, supplierUserFullName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new Supplier
         * @param {CreateSupplier} [createSupplier]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersPost: function (createSupplier, options) {
            return localVarFp.suppliersPost(createSupplier, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a Supplier
         * @param {string} supplierId Supplier id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersSupplierIdDelete: function (supplierId, options) {
            return localVarFp.suppliersSupplierIdDelete(supplierId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get a Supplier
         * @param {string} supplierId Supplier id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersSupplierIdGet: function (supplierId, options) {
            return localVarFp.suppliersSupplierIdGet(supplierId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a Supplier
         * @param {string} supplierId Supplier id
         * @param {UpdateSupplier} [updateSupplier]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersSupplierIdPut: function (supplierId, updateSupplier, options) {
            return localVarFp.suppliersSupplierIdPut(supplierId, updateSupplier, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new Supplier User
         * @param {string} supplierId Supplier id
         * @param {CreateSupplierUser} [createSupplierUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersSupplierIdUsersPost: function (supplierId, createSupplierUser, options) {
            return localVarFp.suppliersSupplierIdUsersPost(supplierId, createSupplierUser, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a Supplier User Relationship
         * @param {string} supplierId Supplier id
         * @param {string} supplierUserId Supplier User id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersSupplierIdUsersSupplierUserIdDelete: function (supplierId, supplierUserId, options) {
            return localVarFp.suppliersSupplierIdUsersSupplierUserIdDelete(supplierId, supplierUserId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a new Supplier User
         * @param {string} supplierId Supplier id
         * @param {string} supplierUserId Supplier User id
         * @param {CreateSupplierUser} [createSupplierUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suppliersSupplierIdUsersSupplierUserIdPut: function (supplierId, supplierUserId, createSupplierUser, options) {
            return localVarFp.suppliersSupplierIdUsersSupplierUserIdPut(supplierId, supplierUserId, createSupplierUser, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get the list of Suppliers that the requesting User is part of
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersSuppliersGet: function (options) {
            return localVarFp.usersSuppliersGet(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SuppliersApiFactory = SuppliersApiFactory;
/**
 * SuppliersApi - object-oriented interface
 * @export
 * @class SuppliersApi
 * @extends {BaseAPI}
 */
var SuppliersApi = /** @class */ (function (_super) {
    __extends(SuppliersApi, _super);
    function SuppliersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get a list of address book entries that are owned by the tenant that owns the Suppliers related to the authenticated User
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {string} [supplierId] Supplier id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    SuppliersApi.prototype.suppliersAddressesGet = function (page, pageSize, ordering, q, supplierId, options) {
        var _this = this;
        return (0, exports.SuppliersApiFp)(this.configuration).suppliersAddressesGet(page, pageSize, ordering, q, supplierId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get the list of Suppliers
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {string} [name] The name of the Supplier
     * @param {string} [supplierUserFullName] The full name of the Supplier User
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    SuppliersApi.prototype.suppliersGet = function (page, pageSize, ordering, q, name, supplierUserFullName, options) {
        var _this = this;
        return (0, exports.SuppliersApiFp)(this.configuration).suppliersGet(page, pageSize, ordering, q, name, supplierUserFullName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new Supplier
     * @param {CreateSupplier} [createSupplier]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    SuppliersApi.prototype.suppliersPost = function (createSupplier, options) {
        var _this = this;
        return (0, exports.SuppliersApiFp)(this.configuration).suppliersPost(createSupplier, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a Supplier
     * @param {string} supplierId Supplier id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    SuppliersApi.prototype.suppliersSupplierIdDelete = function (supplierId, options) {
        var _this = this;
        return (0, exports.SuppliersApiFp)(this.configuration).suppliersSupplierIdDelete(supplierId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get a Supplier
     * @param {string} supplierId Supplier id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    SuppliersApi.prototype.suppliersSupplierIdGet = function (supplierId, options) {
        var _this = this;
        return (0, exports.SuppliersApiFp)(this.configuration).suppliersSupplierIdGet(supplierId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a Supplier
     * @param {string} supplierId Supplier id
     * @param {UpdateSupplier} [updateSupplier]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    SuppliersApi.prototype.suppliersSupplierIdPut = function (supplierId, updateSupplier, options) {
        var _this = this;
        return (0, exports.SuppliersApiFp)(this.configuration).suppliersSupplierIdPut(supplierId, updateSupplier, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new Supplier User
     * @param {string} supplierId Supplier id
     * @param {CreateSupplierUser} [createSupplierUser]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    SuppliersApi.prototype.suppliersSupplierIdUsersPost = function (supplierId, createSupplierUser, options) {
        var _this = this;
        return (0, exports.SuppliersApiFp)(this.configuration).suppliersSupplierIdUsersPost(supplierId, createSupplierUser, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a Supplier User Relationship
     * @param {string} supplierId Supplier id
     * @param {string} supplierUserId Supplier User id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    SuppliersApi.prototype.suppliersSupplierIdUsersSupplierUserIdDelete = function (supplierId, supplierUserId, options) {
        var _this = this;
        return (0, exports.SuppliersApiFp)(this.configuration).suppliersSupplierIdUsersSupplierUserIdDelete(supplierId, supplierUserId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a new Supplier User
     * @param {string} supplierId Supplier id
     * @param {string} supplierUserId Supplier User id
     * @param {CreateSupplierUser} [createSupplierUser]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    SuppliersApi.prototype.suppliersSupplierIdUsersSupplierUserIdPut = function (supplierId, supplierUserId, createSupplierUser, options) {
        var _this = this;
        return (0, exports.SuppliersApiFp)(this.configuration).suppliersSupplierIdUsersSupplierUserIdPut(supplierId, supplierUserId, createSupplierUser, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get the list of Suppliers that the requesting User is part of
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuppliersApi
     */
    SuppliersApi.prototype.usersSuppliersGet = function (options) {
        var _this = this;
        return (0, exports.SuppliersApiFp)(this.configuration).usersSuppliersGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SuppliersApi;
}(base_1.BaseAPI));
exports.SuppliersApi = SuppliersApi;
/**
 * TasksApi - axios parameter creator
 * @export
 */
var TasksApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Delete a Case
         * @param {string} caseId The id of the case
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        casesCaseIdDelete: function (caseId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'caseId' is not null or undefined
                            (0, common_1.assertParamExists)('casesCaseIdDelete', 'caseId', caseId);
                            localVarPath = "/cases/{caseId}/"
                                .replace("{".concat("caseId", "}"), encodeURIComponent(String(caseId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve data for a case
         * @param {string} caseId The id of the case
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        casesCaseIdGet: function (caseId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'caseId' is not null or undefined
                            (0, common_1.assertParamExists)('casesCaseIdGet', 'caseId', caseId);
                            localVarPath = "/cases/{caseId}/"
                                .replace("{".concat("caseId", "}"), encodeURIComponent(String(caseId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a Case
         * @param {string} caseId The id of the case
         * @param {ShipmentCase} shipmentCase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        casesCaseIdPut: function (caseId, shipmentCase, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'caseId' is not null or undefined
                            (0, common_1.assertParamExists)('casesCaseIdPut', 'caseId', caseId);
                            // verify required parameter 'shipmentCase' is not null or undefined
                            (0, common_1.assertParamExists)('casesCaseIdPut', 'shipmentCase', shipmentCase);
                            localVarPath = "/cases/{caseId}/"
                                .replace("{".concat("caseId", "}"), encodeURIComponent(String(caseId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shipmentCase, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List cases for a Company
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        casesGet: function (page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/cases/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new case
         * @param {InlineObject4} inlineObject4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        casesPost: function (inlineObject4, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'inlineObject4' is not null or undefined
                            (0, common_1.assertParamExists)('casesPost', 'inlineObject4', inlineObject4);
                            localVarPath = "/cases/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(inlineObject4, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a CaseNote
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {string} caseNoteId The id of the case note
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdNotesCaseNoteIdDelete: function (shipmentCaseId, caseNoteId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentCaseId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsCasesShipmentCaseIdNotesCaseNoteIdDelete', 'shipmentCaseId', shipmentCaseId);
                            // verify required parameter 'caseNoteId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsCasesShipmentCaseIdNotesCaseNoteIdDelete', 'caseNoteId', caseNoteId);
                            localVarPath = "/shipments/cases/{shipmentCaseId}/notes/{caseNoteId}/"
                                .replace("{".concat("shipmentCaseId", "}"), encodeURIComponent(String(shipmentCaseId)))
                                .replace("{".concat("caseNoteId", "}"), encodeURIComponent(String(caseNoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve data for a note
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {string} caseNoteId The id of the case note
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdNotesCaseNoteIdGet: function (shipmentCaseId, caseNoteId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentCaseId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsCasesShipmentCaseIdNotesCaseNoteIdGet', 'shipmentCaseId', shipmentCaseId);
                            // verify required parameter 'caseNoteId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsCasesShipmentCaseIdNotesCaseNoteIdGet', 'caseNoteId', caseNoteId);
                            localVarPath = "/shipments/cases/{shipmentCaseId}/notes/{caseNoteId}/"
                                .replace("{".concat("shipmentCaseId", "}"), encodeURIComponent(String(shipmentCaseId)))
                                .replace("{".concat("caseNoteId", "}"), encodeURIComponent(String(caseNoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a CaseNote
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {string} caseNoteId The id of the case note
         * @param {CaseNote} caseNote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdNotesCaseNoteIdPut: function (shipmentCaseId, caseNoteId, caseNote, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentCaseId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsCasesShipmentCaseIdNotesCaseNoteIdPut', 'shipmentCaseId', shipmentCaseId);
                            // verify required parameter 'caseNoteId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsCasesShipmentCaseIdNotesCaseNoteIdPut', 'caseNoteId', caseNoteId);
                            // verify required parameter 'caseNote' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsCasesShipmentCaseIdNotesCaseNoteIdPut', 'caseNote', caseNote);
                            localVarPath = "/shipments/cases/{shipmentCaseId}/notes/{caseNoteId}/"
                                .replace("{".concat("shipmentCaseId", "}"), encodeURIComponent(String(shipmentCaseId)))
                                .replace("{".concat("caseNoteId", "}"), encodeURIComponent(String(caseNoteId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(caseNote, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List notes for a ShipmentCase
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdNotesGet: function (shipmentCaseId, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentCaseId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsCasesShipmentCaseIdNotesGet', 'shipmentCaseId', shipmentCaseId);
                            localVarPath = "/shipments/cases/{shipmentCaseId}/notes/"
                                .replace("{".concat("shipmentCaseId", "}"), encodeURIComponent(String(shipmentCaseId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new Note for a ShipmentCase
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {CaseNote} caseNote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdNotesPost: function (shipmentCaseId, caseNote, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentCaseId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsCasesShipmentCaseIdNotesPost', 'shipmentCaseId', shipmentCaseId);
                            // verify required parameter 'caseNote' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsCasesShipmentCaseIdNotesPost', 'caseNote', caseNote);
                            localVarPath = "/shipments/cases/{shipmentCaseId}/notes/"
                                .replace("{".concat("shipmentCaseId", "}"), encodeURIComponent(String(shipmentCaseId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(caseNote, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List tasks for a ShipmentCase
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdTasksGet: function (shipmentCaseId, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentCaseId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsCasesShipmentCaseIdTasksGet', 'shipmentCaseId', shipmentCaseId);
                            localVarPath = "/shipments/cases/{shipmentCaseId}/tasks/"
                                .replace("{".concat("shipmentCaseId", "}"), encodeURIComponent(String(shipmentCaseId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new Task for a ShipmentCase
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {Task} task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdTasksPost: function (shipmentCaseId, task, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentCaseId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsCasesShipmentCaseIdTasksPost', 'shipmentCaseId', shipmentCaseId);
                            // verify required parameter 'task' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsCasesShipmentCaseIdTasksPost', 'task', task);
                            localVarPath = "/shipments/cases/{shipmentCaseId}/tasks/"
                                .replace("{".concat("shipmentCaseId", "}"), encodeURIComponent(String(shipmentCaseId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(task, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a task
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {string} taskId The id of the task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdTasksTaskIdDelete: function (shipmentCaseId, taskId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentCaseId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsCasesShipmentCaseIdTasksTaskIdDelete', 'shipmentCaseId', shipmentCaseId);
                            // verify required parameter 'taskId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsCasesShipmentCaseIdTasksTaskIdDelete', 'taskId', taskId);
                            localVarPath = "/shipments/cases/{shipmentCaseId}/tasks/{taskId}/"
                                .replace("{".concat("shipmentCaseId", "}"), encodeURIComponent(String(shipmentCaseId)))
                                .replace("{".concat("taskId", "}"), encodeURIComponent(String(taskId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve data for a task
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {string} taskId The id of the task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdTasksTaskIdGet: function (shipmentCaseId, taskId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentCaseId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsCasesShipmentCaseIdTasksTaskIdGet', 'shipmentCaseId', shipmentCaseId);
                            // verify required parameter 'taskId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsCasesShipmentCaseIdTasksTaskIdGet', 'taskId', taskId);
                            localVarPath = "/shipments/cases/{shipmentCaseId}/tasks/{taskId}/"
                                .replace("{".concat("shipmentCaseId", "}"), encodeURIComponent(String(shipmentCaseId)))
                                .replace("{".concat("taskId", "}"), encodeURIComponent(String(taskId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a Task
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {string} taskId The id of the task
         * @param {Task} task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdTasksTaskIdPut: function (shipmentCaseId, taskId, task, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentCaseId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsCasesShipmentCaseIdTasksTaskIdPut', 'shipmentCaseId', shipmentCaseId);
                            // verify required parameter 'taskId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsCasesShipmentCaseIdTasksTaskIdPut', 'taskId', taskId);
                            // verify required parameter 'task' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsCasesShipmentCaseIdTasksTaskIdPut', 'task', task);
                            localVarPath = "/shipments/cases/{shipmentCaseId}/tasks/{taskId}/"
                                .replace("{".concat("shipmentCaseId", "}"), encodeURIComponent(String(shipmentCaseId)))
                                .replace("{".concat("taskId", "}"), encodeURIComponent(String(taskId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(task, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List cases for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCasesGet: function (shipmentId, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdCasesGet', 'shipmentId', shipmentId);
                            localVarPath = "/shipments/{shipmentId}/cases/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new case for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {ShipmentCase} shipmentCase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCasesPost: function (shipmentId, shipmentCase, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdCasesPost', 'shipmentId', shipmentId);
                            // verify required parameter 'shipmentCase' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdCasesPost', 'shipmentCase', shipmentCase);
                            localVarPath = "/shipments/{shipmentId}/cases/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shipmentCase, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a ShipmentCase
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCasesShipmentCaseIdDelete: function (shipmentId, shipmentCaseId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdCasesShipmentCaseIdDelete', 'shipmentId', shipmentId);
                            // verify required parameter 'shipmentCaseId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdCasesShipmentCaseIdDelete', 'shipmentCaseId', shipmentCaseId);
                            localVarPath = "/shipments/{shipmentId}/cases/{shipmentCaseId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("shipmentCaseId", "}"), encodeURIComponent(String(shipmentCaseId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve data for a ShipmentCase
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCasesShipmentCaseIdGet: function (shipmentId, shipmentCaseId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdCasesShipmentCaseIdGet', 'shipmentId', shipmentId);
                            // verify required parameter 'shipmentCaseId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdCasesShipmentCaseIdGet', 'shipmentCaseId', shipmentCaseId);
                            localVarPath = "/shipments/{shipmentId}/cases/{shipmentCaseId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("shipmentCaseId", "}"), encodeURIComponent(String(shipmentCaseId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a ShipmentCase
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {ShipmentCase} shipmentCase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCasesShipmentCaseIdPut: function (shipmentId, shipmentCaseId, shipmentCase, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'shipmentId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdCasesShipmentCaseIdPut', 'shipmentId', shipmentId);
                            // verify required parameter 'shipmentCaseId' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdCasesShipmentCaseIdPut', 'shipmentCaseId', shipmentCaseId);
                            // verify required parameter 'shipmentCase' is not null or undefined
                            (0, common_1.assertParamExists)('shipmentsShipmentIdCasesShipmentCaseIdPut', 'shipmentCase', shipmentCase);
                            localVarPath = "/shipments/{shipmentId}/cases/{shipmentCaseId}/"
                                .replace("{".concat("shipmentId", "}"), encodeURIComponent(String(shipmentId)))
                                .replace("{".concat("shipmentCaseId", "}"), encodeURIComponent(String(shipmentCaseId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shipmentCase, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List all tasks
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [assigneeId] ID of the user assigned to the task
         * @param {string} [caseId] ID of the case the task belongs to
         * @param {string} [createdByUserId] ID of the user who created the task
         * @param {string} [descriptionContains] Text search of the task description
         * @param {string} [dueDateGte] Search tasks with a due date greater than or equal to the value
         * @param {string} [dueDateLte] Search tasks with a due date less than or equal to the value
         * @param {boolean} [isOpen] Whether or not the task is open
         * @param {string} [shipmentId] ID of the shipment the task belongs to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksGet: function (page, pageSize, ordering, assigneeId, caseId, createdByUserId, descriptionContains, dueDateGte, dueDateLte, isOpen, shipmentId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/tasks/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (assigneeId !== undefined) {
                                localVarQueryParameter['assignee_id'] = assigneeId;
                            }
                            if (caseId !== undefined) {
                                localVarQueryParameter['case_id'] = caseId;
                            }
                            if (createdByUserId !== undefined) {
                                localVarQueryParameter['created_by_user_id'] = createdByUserId;
                            }
                            if (descriptionContains !== undefined) {
                                localVarQueryParameter['description__contains'] = descriptionContains;
                            }
                            if (dueDateGte !== undefined) {
                                localVarQueryParameter['due_date__gte'] = (dueDateGte instanceof Date) ?
                                    dueDateGte.toISOString() :
                                    dueDateGte;
                            }
                            if (dueDateLte !== undefined) {
                                localVarQueryParameter['due_date__lte'] = (dueDateLte instanceof Date) ?
                                    dueDateLte.toISOString() :
                                    dueDateLte;
                            }
                            if (isOpen !== undefined) {
                                localVarQueryParameter['is_open'] = isOpen;
                            }
                            if (shipmentId !== undefined) {
                                localVarQueryParameter['shipment_id'] = shipmentId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new Task
         * @param {Task} task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksPost: function (task, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'task' is not null or undefined
                            (0, common_1.assertParamExists)('tasksPost', 'task', task);
                            localVarPath = "/tasks/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(task, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a Task
         * @param {string} taskId The id of the task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksTaskIdDelete: function (taskId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'taskId' is not null or undefined
                            (0, common_1.assertParamExists)('tasksTaskIdDelete', 'taskId', taskId);
                            localVarPath = "/tasks/{taskId}/"
                                .replace("{".concat("taskId", "}"), encodeURIComponent(String(taskId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve data for a task
         * @param {string} taskId The id of the task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksTaskIdGet: function (taskId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'taskId' is not null or undefined
                            (0, common_1.assertParamExists)('tasksTaskIdGet', 'taskId', taskId);
                            localVarPath = "/tasks/{taskId}/"
                                .replace("{".concat("taskId", "}"), encodeURIComponent(String(taskId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a Task
         * @param {string} taskId The id of the task
         * @param {Task} task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksTaskIdPut: function (taskId, task, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'taskId' is not null or undefined
                            (0, common_1.assertParamExists)('tasksTaskIdPut', 'taskId', taskId);
                            // verify required parameter 'task' is not null or undefined
                            (0, common_1.assertParamExists)('tasksTaskIdPut', 'task', task);
                            localVarPath = "/tasks/{taskId}/"
                                .replace("{".concat("taskId", "}"), encodeURIComponent(String(taskId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(task, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.TasksApiAxiosParamCreator = TasksApiAxiosParamCreator;
/**
 * TasksApi - functional programming interface
 * @export
 */
var TasksApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TasksApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Delete a Case
         * @param {string} caseId The id of the case
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        casesCaseIdDelete: function (caseId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.casesCaseIdDelete(caseId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve data for a case
         * @param {string} caseId The id of the case
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        casesCaseIdGet: function (caseId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.casesCaseIdGet(caseId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a Case
         * @param {string} caseId The id of the case
         * @param {ShipmentCase} shipmentCase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        casesCaseIdPut: function (caseId, shipmentCase, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.casesCaseIdPut(caseId, shipmentCase, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List cases for a Company
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        casesGet: function (page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.casesGet(page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new case
         * @param {InlineObject4} inlineObject4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        casesPost: function (inlineObject4, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.casesPost(inlineObject4, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a CaseNote
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {string} caseNoteId The id of the case note
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdNotesCaseNoteIdDelete: function (shipmentCaseId, caseNoteId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsCasesShipmentCaseIdNotesCaseNoteIdDelete(shipmentCaseId, caseNoteId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve data for a note
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {string} caseNoteId The id of the case note
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdNotesCaseNoteIdGet: function (shipmentCaseId, caseNoteId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsCasesShipmentCaseIdNotesCaseNoteIdGet(shipmentCaseId, caseNoteId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a CaseNote
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {string} caseNoteId The id of the case note
         * @param {CaseNote} caseNote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdNotesCaseNoteIdPut: function (shipmentCaseId, caseNoteId, caseNote, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsCasesShipmentCaseIdNotesCaseNoteIdPut(shipmentCaseId, caseNoteId, caseNote, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List notes for a ShipmentCase
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdNotesGet: function (shipmentCaseId, page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsCasesShipmentCaseIdNotesGet(shipmentCaseId, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new Note for a ShipmentCase
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {CaseNote} caseNote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdNotesPost: function (shipmentCaseId, caseNote, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsCasesShipmentCaseIdNotesPost(shipmentCaseId, caseNote, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List tasks for a ShipmentCase
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdTasksGet: function (shipmentCaseId, page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsCasesShipmentCaseIdTasksGet(shipmentCaseId, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new Task for a ShipmentCase
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {Task} task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdTasksPost: function (shipmentCaseId, task, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsCasesShipmentCaseIdTasksPost(shipmentCaseId, task, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a task
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {string} taskId The id of the task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdTasksTaskIdDelete: function (shipmentCaseId, taskId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsCasesShipmentCaseIdTasksTaskIdDelete(shipmentCaseId, taskId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve data for a task
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {string} taskId The id of the task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdTasksTaskIdGet: function (shipmentCaseId, taskId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsCasesShipmentCaseIdTasksTaskIdGet(shipmentCaseId, taskId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a Task
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {string} taskId The id of the task
         * @param {Task} task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdTasksTaskIdPut: function (shipmentCaseId, taskId, task, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsCasesShipmentCaseIdTasksTaskIdPut(shipmentCaseId, taskId, task, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List cases for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCasesGet: function (shipmentId, page, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdCasesGet(shipmentId, page, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new case for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {ShipmentCase} shipmentCase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCasesPost: function (shipmentId, shipmentCase, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdCasesPost(shipmentId, shipmentCase, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a ShipmentCase
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCasesShipmentCaseIdDelete: function (shipmentId, shipmentCaseId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdCasesShipmentCaseIdDelete(shipmentId, shipmentCaseId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve data for a ShipmentCase
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCasesShipmentCaseIdGet: function (shipmentId, shipmentCaseId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdCasesShipmentCaseIdGet(shipmentId, shipmentCaseId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a ShipmentCase
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {ShipmentCase} shipmentCase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCasesShipmentCaseIdPut: function (shipmentId, shipmentCaseId, shipmentCase, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipmentsShipmentIdCasesShipmentCaseIdPut(shipmentId, shipmentCaseId, shipmentCase, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary List all tasks
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [assigneeId] ID of the user assigned to the task
         * @param {string} [caseId] ID of the case the task belongs to
         * @param {string} [createdByUserId] ID of the user who created the task
         * @param {string} [descriptionContains] Text search of the task description
         * @param {string} [dueDateGte] Search tasks with a due date greater than or equal to the value
         * @param {string} [dueDateLte] Search tasks with a due date less than or equal to the value
         * @param {boolean} [isOpen] Whether or not the task is open
         * @param {string} [shipmentId] ID of the shipment the task belongs to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksGet: function (page, pageSize, ordering, assigneeId, caseId, createdByUserId, descriptionContains, dueDateGte, dueDateLte, isOpen, shipmentId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tasksGet(page, pageSize, ordering, assigneeId, caseId, createdByUserId, descriptionContains, dueDateGte, dueDateLte, isOpen, shipmentId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new Task
         * @param {Task} task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksPost: function (task, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tasksPost(task, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a Task
         * @param {string} taskId The id of the task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksTaskIdDelete: function (taskId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tasksTaskIdDelete(taskId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve data for a task
         * @param {string} taskId The id of the task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksTaskIdGet: function (taskId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tasksTaskIdGet(taskId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a Task
         * @param {string} taskId The id of the task
         * @param {Task} task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksTaskIdPut: function (taskId, task, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tasksTaskIdPut(taskId, task, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TasksApiFp = TasksApiFp;
/**
 * TasksApi - factory interface
 * @export
 */
var TasksApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TasksApiFp)(configuration);
    return {
        /**
         *
         * @summary Delete a Case
         * @param {string} caseId The id of the case
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        casesCaseIdDelete: function (caseId, options) {
            return localVarFp.casesCaseIdDelete(caseId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve data for a case
         * @param {string} caseId The id of the case
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        casesCaseIdGet: function (caseId, options) {
            return localVarFp.casesCaseIdGet(caseId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a Case
         * @param {string} caseId The id of the case
         * @param {ShipmentCase} shipmentCase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        casesCaseIdPut: function (caseId, shipmentCase, options) {
            return localVarFp.casesCaseIdPut(caseId, shipmentCase, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List cases for a Company
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        casesGet: function (page, pageSize, options) {
            return localVarFp.casesGet(page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new case
         * @param {InlineObject4} inlineObject4
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        casesPost: function (inlineObject4, options) {
            return localVarFp.casesPost(inlineObject4, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a CaseNote
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {string} caseNoteId The id of the case note
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdNotesCaseNoteIdDelete: function (shipmentCaseId, caseNoteId, options) {
            return localVarFp.shipmentsCasesShipmentCaseIdNotesCaseNoteIdDelete(shipmentCaseId, caseNoteId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve data for a note
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {string} caseNoteId The id of the case note
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdNotesCaseNoteIdGet: function (shipmentCaseId, caseNoteId, options) {
            return localVarFp.shipmentsCasesShipmentCaseIdNotesCaseNoteIdGet(shipmentCaseId, caseNoteId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a CaseNote
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {string} caseNoteId The id of the case note
         * @param {CaseNote} caseNote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdNotesCaseNoteIdPut: function (shipmentCaseId, caseNoteId, caseNote, options) {
            return localVarFp.shipmentsCasesShipmentCaseIdNotesCaseNoteIdPut(shipmentCaseId, caseNoteId, caseNote, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List notes for a ShipmentCase
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdNotesGet: function (shipmentCaseId, page, pageSize, options) {
            return localVarFp.shipmentsCasesShipmentCaseIdNotesGet(shipmentCaseId, page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new Note for a ShipmentCase
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {CaseNote} caseNote
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdNotesPost: function (shipmentCaseId, caseNote, options) {
            return localVarFp.shipmentsCasesShipmentCaseIdNotesPost(shipmentCaseId, caseNote, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List tasks for a ShipmentCase
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdTasksGet: function (shipmentCaseId, page, pageSize, options) {
            return localVarFp.shipmentsCasesShipmentCaseIdTasksGet(shipmentCaseId, page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new Task for a ShipmentCase
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {Task} task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdTasksPost: function (shipmentCaseId, task, options) {
            return localVarFp.shipmentsCasesShipmentCaseIdTasksPost(shipmentCaseId, task, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a task
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {string} taskId The id of the task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdTasksTaskIdDelete: function (shipmentCaseId, taskId, options) {
            return localVarFp.shipmentsCasesShipmentCaseIdTasksTaskIdDelete(shipmentCaseId, taskId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve data for a task
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {string} taskId The id of the task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdTasksTaskIdGet: function (shipmentCaseId, taskId, options) {
            return localVarFp.shipmentsCasesShipmentCaseIdTasksTaskIdGet(shipmentCaseId, taskId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a Task
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {string} taskId The id of the task
         * @param {Task} task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsCasesShipmentCaseIdTasksTaskIdPut: function (shipmentCaseId, taskId, task, options) {
            return localVarFp.shipmentsCasesShipmentCaseIdTasksTaskIdPut(shipmentCaseId, taskId, task, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List cases for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCasesGet: function (shipmentId, page, pageSize, options) {
            return localVarFp.shipmentsShipmentIdCasesGet(shipmentId, page, pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new case for a shipment
         * @param {string} shipmentId The id of the shipment
         * @param {ShipmentCase} shipmentCase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCasesPost: function (shipmentId, shipmentCase, options) {
            return localVarFp.shipmentsShipmentIdCasesPost(shipmentId, shipmentCase, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a ShipmentCase
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCasesShipmentCaseIdDelete: function (shipmentId, shipmentCaseId, options) {
            return localVarFp.shipmentsShipmentIdCasesShipmentCaseIdDelete(shipmentId, shipmentCaseId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve data for a ShipmentCase
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCasesShipmentCaseIdGet: function (shipmentId, shipmentCaseId, options) {
            return localVarFp.shipmentsShipmentIdCasesShipmentCaseIdGet(shipmentId, shipmentCaseId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a ShipmentCase
         * @param {string} shipmentId The id of the shipment
         * @param {string} shipmentCaseId The id of the shipment case
         * @param {ShipmentCase} shipmentCase
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipmentsShipmentIdCasesShipmentCaseIdPut: function (shipmentId, shipmentCaseId, shipmentCase, options) {
            return localVarFp.shipmentsShipmentIdCasesShipmentCaseIdPut(shipmentId, shipmentCaseId, shipmentCase, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List all tasks
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [assigneeId] ID of the user assigned to the task
         * @param {string} [caseId] ID of the case the task belongs to
         * @param {string} [createdByUserId] ID of the user who created the task
         * @param {string} [descriptionContains] Text search of the task description
         * @param {string} [dueDateGte] Search tasks with a due date greater than or equal to the value
         * @param {string} [dueDateLte] Search tasks with a due date less than or equal to the value
         * @param {boolean} [isOpen] Whether or not the task is open
         * @param {string} [shipmentId] ID of the shipment the task belongs to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksGet: function (page, pageSize, ordering, assigneeId, caseId, createdByUserId, descriptionContains, dueDateGte, dueDateLte, isOpen, shipmentId, options) {
            return localVarFp.tasksGet(page, pageSize, ordering, assigneeId, caseId, createdByUserId, descriptionContains, dueDateGte, dueDateLte, isOpen, shipmentId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new Task
         * @param {Task} task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksPost: function (task, options) {
            return localVarFp.tasksPost(task, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a Task
         * @param {string} taskId The id of the task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksTaskIdDelete: function (taskId, options) {
            return localVarFp.tasksTaskIdDelete(taskId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve data for a task
         * @param {string} taskId The id of the task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksTaskIdGet: function (taskId, options) {
            return localVarFp.tasksTaskIdGet(taskId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a Task
         * @param {string} taskId The id of the task
         * @param {Task} task
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tasksTaskIdPut: function (taskId, task, options) {
            return localVarFp.tasksTaskIdPut(taskId, task, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TasksApiFactory = TasksApiFactory;
/**
 * TasksApi - object-oriented interface
 * @export
 * @class TasksApi
 * @extends {BaseAPI}
 */
var TasksApi = /** @class */ (function (_super) {
    __extends(TasksApi, _super);
    function TasksApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Delete a Case
     * @param {string} caseId The id of the case
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.casesCaseIdDelete = function (caseId, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration).casesCaseIdDelete(caseId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve data for a case
     * @param {string} caseId The id of the case
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.casesCaseIdGet = function (caseId, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration).casesCaseIdGet(caseId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a Case
     * @param {string} caseId The id of the case
     * @param {ShipmentCase} shipmentCase
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.casesCaseIdPut = function (caseId, shipmentCase, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration).casesCaseIdPut(caseId, shipmentCase, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List cases for a Company
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.casesGet = function (page, pageSize, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration).casesGet(page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new case
     * @param {InlineObject4} inlineObject4
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.casesPost = function (inlineObject4, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration).casesPost(inlineObject4, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a CaseNote
     * @param {string} shipmentCaseId The id of the shipment case
     * @param {string} caseNoteId The id of the case note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.shipmentsCasesShipmentCaseIdNotesCaseNoteIdDelete = function (shipmentCaseId, caseNoteId, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration).shipmentsCasesShipmentCaseIdNotesCaseNoteIdDelete(shipmentCaseId, caseNoteId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve data for a note
     * @param {string} shipmentCaseId The id of the shipment case
     * @param {string} caseNoteId The id of the case note
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.shipmentsCasesShipmentCaseIdNotesCaseNoteIdGet = function (shipmentCaseId, caseNoteId, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration).shipmentsCasesShipmentCaseIdNotesCaseNoteIdGet(shipmentCaseId, caseNoteId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a CaseNote
     * @param {string} shipmentCaseId The id of the shipment case
     * @param {string} caseNoteId The id of the case note
     * @param {CaseNote} caseNote
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.shipmentsCasesShipmentCaseIdNotesCaseNoteIdPut = function (shipmentCaseId, caseNoteId, caseNote, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration).shipmentsCasesShipmentCaseIdNotesCaseNoteIdPut(shipmentCaseId, caseNoteId, caseNote, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List notes for a ShipmentCase
     * @param {string} shipmentCaseId The id of the shipment case
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.shipmentsCasesShipmentCaseIdNotesGet = function (shipmentCaseId, page, pageSize, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration).shipmentsCasesShipmentCaseIdNotesGet(shipmentCaseId, page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new Note for a ShipmentCase
     * @param {string} shipmentCaseId The id of the shipment case
     * @param {CaseNote} caseNote
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.shipmentsCasesShipmentCaseIdNotesPost = function (shipmentCaseId, caseNote, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration).shipmentsCasesShipmentCaseIdNotesPost(shipmentCaseId, caseNote, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List tasks for a ShipmentCase
     * @param {string} shipmentCaseId The id of the shipment case
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.shipmentsCasesShipmentCaseIdTasksGet = function (shipmentCaseId, page, pageSize, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration).shipmentsCasesShipmentCaseIdTasksGet(shipmentCaseId, page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new Task for a ShipmentCase
     * @param {string} shipmentCaseId The id of the shipment case
     * @param {Task} task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.shipmentsCasesShipmentCaseIdTasksPost = function (shipmentCaseId, task, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration).shipmentsCasesShipmentCaseIdTasksPost(shipmentCaseId, task, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a task
     * @param {string} shipmentCaseId The id of the shipment case
     * @param {string} taskId The id of the task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.shipmentsCasesShipmentCaseIdTasksTaskIdDelete = function (shipmentCaseId, taskId, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration).shipmentsCasesShipmentCaseIdTasksTaskIdDelete(shipmentCaseId, taskId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve data for a task
     * @param {string} shipmentCaseId The id of the shipment case
     * @param {string} taskId The id of the task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.shipmentsCasesShipmentCaseIdTasksTaskIdGet = function (shipmentCaseId, taskId, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration).shipmentsCasesShipmentCaseIdTasksTaskIdGet(shipmentCaseId, taskId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a Task
     * @param {string} shipmentCaseId The id of the shipment case
     * @param {string} taskId The id of the task
     * @param {Task} task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.shipmentsCasesShipmentCaseIdTasksTaskIdPut = function (shipmentCaseId, taskId, task, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration).shipmentsCasesShipmentCaseIdTasksTaskIdPut(shipmentCaseId, taskId, task, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List cases for a shipment
     * @param {string} shipmentId The id of the shipment
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.shipmentsShipmentIdCasesGet = function (shipmentId, page, pageSize, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration).shipmentsShipmentIdCasesGet(shipmentId, page, pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new case for a shipment
     * @param {string} shipmentId The id of the shipment
     * @param {ShipmentCase} shipmentCase
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.shipmentsShipmentIdCasesPost = function (shipmentId, shipmentCase, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration).shipmentsShipmentIdCasesPost(shipmentId, shipmentCase, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a ShipmentCase
     * @param {string} shipmentId The id of the shipment
     * @param {string} shipmentCaseId The id of the shipment case
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.shipmentsShipmentIdCasesShipmentCaseIdDelete = function (shipmentId, shipmentCaseId, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration).shipmentsShipmentIdCasesShipmentCaseIdDelete(shipmentId, shipmentCaseId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve data for a ShipmentCase
     * @param {string} shipmentId The id of the shipment
     * @param {string} shipmentCaseId The id of the shipment case
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.shipmentsShipmentIdCasesShipmentCaseIdGet = function (shipmentId, shipmentCaseId, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration).shipmentsShipmentIdCasesShipmentCaseIdGet(shipmentId, shipmentCaseId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a ShipmentCase
     * @param {string} shipmentId The id of the shipment
     * @param {string} shipmentCaseId The id of the shipment case
     * @param {ShipmentCase} shipmentCase
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.shipmentsShipmentIdCasesShipmentCaseIdPut = function (shipmentId, shipmentCaseId, shipmentCase, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration).shipmentsShipmentIdCasesShipmentCaseIdPut(shipmentId, shipmentCaseId, shipmentCase, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List all tasks
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [assigneeId] ID of the user assigned to the task
     * @param {string} [caseId] ID of the case the task belongs to
     * @param {string} [createdByUserId] ID of the user who created the task
     * @param {string} [descriptionContains] Text search of the task description
     * @param {string} [dueDateGte] Search tasks with a due date greater than or equal to the value
     * @param {string} [dueDateLte] Search tasks with a due date less than or equal to the value
     * @param {boolean} [isOpen] Whether or not the task is open
     * @param {string} [shipmentId] ID of the shipment the task belongs to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.tasksGet = function (page, pageSize, ordering, assigneeId, caseId, createdByUserId, descriptionContains, dueDateGte, dueDateLte, isOpen, shipmentId, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration).tasksGet(page, pageSize, ordering, assigneeId, caseId, createdByUserId, descriptionContains, dueDateGte, dueDateLte, isOpen, shipmentId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new Task
     * @param {Task} task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.tasksPost = function (task, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration).tasksPost(task, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a Task
     * @param {string} taskId The id of the task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.tasksTaskIdDelete = function (taskId, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration).tasksTaskIdDelete(taskId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve data for a task
     * @param {string} taskId The id of the task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.tasksTaskIdGet = function (taskId, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration).tasksTaskIdGet(taskId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a Task
     * @param {string} taskId The id of the task
     * @param {Task} task
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApi
     */
    TasksApi.prototype.tasksTaskIdPut = function (taskId, task, options) {
        var _this = this;
        return (0, exports.TasksApiFp)(this.configuration).tasksTaskIdPut(taskId, task, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TasksApi;
}(base_1.BaseAPI));
exports.TasksApi = TasksApi;
/**
 * TendersApi - axios parameter creator
 * @export
 */
var TendersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary List Tenders Shipments
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [createdByCompanyId] Restrict Tenders by created by customer ID
         * @param {string} [shipmentCustomerReferenceNumber] Restrict Tenders by custoemr shipment reference number
         * @param {string} [externalEdiSystemShipmentId] Restrict Tenders by the external EDI system shipment ID
         * @param {string} [shipmentId] Restrict Tenders by shipment ID
         * @param {string} [shipmentReferenceId] Restrict Tenders by the shipment reference_id on the platform
         * @param {string} [tenderToCompanyId] Restrict Tenders by company ID of carrier assigned to tender
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tendersGet: function (page, pageSize, createdByCompanyId, shipmentCustomerReferenceNumber, externalEdiSystemShipmentId, shipmentId, shipmentReferenceId, tenderToCompanyId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/tenders/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (createdByCompanyId !== undefined) {
                                localVarQueryParameter['created_by_company__id'] = createdByCompanyId;
                            }
                            if (shipmentCustomerReferenceNumber !== undefined) {
                                localVarQueryParameter['shipment__customer_reference_number'] = shipmentCustomerReferenceNumber;
                            }
                            if (externalEdiSystemShipmentId !== undefined) {
                                localVarQueryParameter['external_edi_system_shipment_id'] = externalEdiSystemShipmentId;
                            }
                            if (shipmentId !== undefined) {
                                localVarQueryParameter['shipment_id'] = shipmentId;
                            }
                            if (shipmentReferenceId !== undefined) {
                                localVarQueryParameter['shipment__reference_id'] = shipmentReferenceId;
                            }
                            if (tenderToCompanyId !== undefined) {
                                localVarQueryParameter['tender_to_company_id'] = tenderToCompanyId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Tender a shipment to a company
         * @param {TenderCreate} tenderCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tendersPost: function (tenderCreate, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenderCreate' is not null or undefined
                            (0, common_1.assertParamExists)('tendersPost', 'tenderCreate', tenderCreate);
                            localVarPath = "/tenders/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(tenderCreate, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Accept a Tender
         * @param {string} tenderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tendersTenderIdAcceptPost: function (tenderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenderId' is not null or undefined
                            (0, common_1.assertParamExists)('tendersTenderIdAcceptPost', 'tenderId', tenderId);
                            localVarPath = "/tenders/{tenderId}/accept/"
                                .replace("{".concat("tenderId", "}"), encodeURIComponent(String(tenderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns slim details of a load and tender
         * @param {string} tenderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tendersTenderIdAcceptRejectDetailsGet: function (tenderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenderId' is not null or undefined
                            (0, common_1.assertParamExists)('tendersTenderIdAcceptRejectDetailsGet', 'tenderId', tenderId);
                            localVarPath = "/tenders/{tenderId}/accept-reject-details/"
                                .replace("{".concat("tenderId", "}"), encodeURIComponent(String(tenderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a preview of the HTML Email that will be sent and the included message
         * @param {string} tenderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tendersTenderIdEmailPreviewGet: function (tenderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenderId' is not null or undefined
                            (0, common_1.assertParamExists)('tendersTenderIdEmailPreviewGet', 'tenderId', tenderId);
                            localVarPath = "/tenders/{tenderId}/email-preview/"
                                .replace("{".concat("tenderId", "}"), encodeURIComponent(String(tenderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Fetch Details about a tender
         * @param {string} tenderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tendersTenderIdGet: function (tenderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenderId' is not null or undefined
                            (0, common_1.assertParamExists)('tendersTenderIdGet', 'tenderId', tenderId);
                            localVarPath = "/tenders/{tenderId}/"
                                .replace("{".concat("tenderId", "}"), encodeURIComponent(String(tenderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Rejects a Tender
         * @param {string} tenderId
         * @param {TenderRejectRequest} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tendersTenderIdRejectPost: function (tenderId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenderId' is not null or undefined
                            (0, common_1.assertParamExists)('tendersTenderIdRejectPost', 'tenderId', tenderId);
                            localVarPath = "/tenders/{tenderId}/reject/"
                                .replace("{".concat("tenderId", "}"), encodeURIComponent(String(tenderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Revokes a Tender
         * @param {string} tenderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tendersTenderIdRevokePost: function (tenderId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'tenderId' is not null or undefined
                            (0, common_1.assertParamExists)('tendersTenderIdRevokePost', 'tenderId', tenderId);
                            localVarPath = "/tenders/{tenderId}/revoke/"
                                .replace("{".concat("tenderId", "}"), encodeURIComponent(String(tenderId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.TendersApiAxiosParamCreator = TendersApiAxiosParamCreator;
/**
 * TendersApi - functional programming interface
 * @export
 */
var TendersApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TendersApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary List Tenders Shipments
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [createdByCompanyId] Restrict Tenders by created by customer ID
         * @param {string} [shipmentCustomerReferenceNumber] Restrict Tenders by custoemr shipment reference number
         * @param {string} [externalEdiSystemShipmentId] Restrict Tenders by the external EDI system shipment ID
         * @param {string} [shipmentId] Restrict Tenders by shipment ID
         * @param {string} [shipmentReferenceId] Restrict Tenders by the shipment reference_id on the platform
         * @param {string} [tenderToCompanyId] Restrict Tenders by company ID of carrier assigned to tender
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tendersGet: function (page, pageSize, createdByCompanyId, shipmentCustomerReferenceNumber, externalEdiSystemShipmentId, shipmentId, shipmentReferenceId, tenderToCompanyId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tendersGet(page, pageSize, createdByCompanyId, shipmentCustomerReferenceNumber, externalEdiSystemShipmentId, shipmentId, shipmentReferenceId, tenderToCompanyId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Tender a shipment to a company
         * @param {TenderCreate} tenderCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tendersPost: function (tenderCreate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tendersPost(tenderCreate, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Accept a Tender
         * @param {string} tenderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tendersTenderIdAcceptPost: function (tenderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tendersTenderIdAcceptPost(tenderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns slim details of a load and tender
         * @param {string} tenderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tendersTenderIdAcceptRejectDetailsGet: function (tenderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tendersTenderIdAcceptRejectDetailsGet(tenderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a preview of the HTML Email that will be sent and the included message
         * @param {string} tenderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tendersTenderIdEmailPreviewGet: function (tenderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tendersTenderIdEmailPreviewGet(tenderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Fetch Details about a tender
         * @param {string} tenderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tendersTenderIdGet: function (tenderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tendersTenderIdGet(tenderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Rejects a Tender
         * @param {string} tenderId
         * @param {TenderRejectRequest} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tendersTenderIdRejectPost: function (tenderId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tendersTenderIdRejectPost(tenderId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Revokes a Tender
         * @param {string} tenderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tendersTenderIdRevokePost: function (tenderId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.tendersTenderIdRevokePost(tenderId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TendersApiFp = TendersApiFp;
/**
 * TendersApi - factory interface
 * @export
 */
var TendersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TendersApiFp)(configuration);
    return {
        /**
         *
         * @summary List Tenders Shipments
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [createdByCompanyId] Restrict Tenders by created by customer ID
         * @param {string} [shipmentCustomerReferenceNumber] Restrict Tenders by custoemr shipment reference number
         * @param {string} [externalEdiSystemShipmentId] Restrict Tenders by the external EDI system shipment ID
         * @param {string} [shipmentId] Restrict Tenders by shipment ID
         * @param {string} [shipmentReferenceId] Restrict Tenders by the shipment reference_id on the platform
         * @param {string} [tenderToCompanyId] Restrict Tenders by company ID of carrier assigned to tender
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tendersGet: function (page, pageSize, createdByCompanyId, shipmentCustomerReferenceNumber, externalEdiSystemShipmentId, shipmentId, shipmentReferenceId, tenderToCompanyId, options) {
            return localVarFp.tendersGet(page, pageSize, createdByCompanyId, shipmentCustomerReferenceNumber, externalEdiSystemShipmentId, shipmentId, shipmentReferenceId, tenderToCompanyId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Tender a shipment to a company
         * @param {TenderCreate} tenderCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tendersPost: function (tenderCreate, options) {
            return localVarFp.tendersPost(tenderCreate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Accept a Tender
         * @param {string} tenderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tendersTenderIdAcceptPost: function (tenderId, options) {
            return localVarFp.tendersTenderIdAcceptPost(tenderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns slim details of a load and tender
         * @param {string} tenderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tendersTenderIdAcceptRejectDetailsGet: function (tenderId, options) {
            return localVarFp.tendersTenderIdAcceptRejectDetailsGet(tenderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a preview of the HTML Email that will be sent and the included message
         * @param {string} tenderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tendersTenderIdEmailPreviewGet: function (tenderId, options) {
            return localVarFp.tendersTenderIdEmailPreviewGet(tenderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Fetch Details about a tender
         * @param {string} tenderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tendersTenderIdGet: function (tenderId, options) {
            return localVarFp.tendersTenderIdGet(tenderId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Rejects a Tender
         * @param {string} tenderId
         * @param {TenderRejectRequest} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tendersTenderIdRejectPost: function (tenderId, body, options) {
            return localVarFp.tendersTenderIdRejectPost(tenderId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Revokes a Tender
         * @param {string} tenderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tendersTenderIdRevokePost: function (tenderId, options) {
            return localVarFp.tendersTenderIdRevokePost(tenderId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TendersApiFactory = TendersApiFactory;
/**
 * TendersApi - object-oriented interface
 * @export
 * @class TendersApi
 * @extends {BaseAPI}
 */
var TendersApi = /** @class */ (function (_super) {
    __extends(TendersApi, _super);
    function TendersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary List Tenders Shipments
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [createdByCompanyId] Restrict Tenders by created by customer ID
     * @param {string} [shipmentCustomerReferenceNumber] Restrict Tenders by custoemr shipment reference number
     * @param {string} [externalEdiSystemShipmentId] Restrict Tenders by the external EDI system shipment ID
     * @param {string} [shipmentId] Restrict Tenders by shipment ID
     * @param {string} [shipmentReferenceId] Restrict Tenders by the shipment reference_id on the platform
     * @param {string} [tenderToCompanyId] Restrict Tenders by company ID of carrier assigned to tender
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TendersApi
     */
    TendersApi.prototype.tendersGet = function (page, pageSize, createdByCompanyId, shipmentCustomerReferenceNumber, externalEdiSystemShipmentId, shipmentId, shipmentReferenceId, tenderToCompanyId, options) {
        var _this = this;
        return (0, exports.TendersApiFp)(this.configuration).tendersGet(page, pageSize, createdByCompanyId, shipmentCustomerReferenceNumber, externalEdiSystemShipmentId, shipmentId, shipmentReferenceId, tenderToCompanyId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Tender a shipment to a company
     * @param {TenderCreate} tenderCreate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TendersApi
     */
    TendersApi.prototype.tendersPost = function (tenderCreate, options) {
        var _this = this;
        return (0, exports.TendersApiFp)(this.configuration).tendersPost(tenderCreate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Accept a Tender
     * @param {string} tenderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TendersApi
     */
    TendersApi.prototype.tendersTenderIdAcceptPost = function (tenderId, options) {
        var _this = this;
        return (0, exports.TendersApiFp)(this.configuration).tendersTenderIdAcceptPost(tenderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns slim details of a load and tender
     * @param {string} tenderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TendersApi
     */
    TendersApi.prototype.tendersTenderIdAcceptRejectDetailsGet = function (tenderId, options) {
        var _this = this;
        return (0, exports.TendersApiFp)(this.configuration).tendersTenderIdAcceptRejectDetailsGet(tenderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a preview of the HTML Email that will be sent and the included message
     * @param {string} tenderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TendersApi
     */
    TendersApi.prototype.tendersTenderIdEmailPreviewGet = function (tenderId, options) {
        var _this = this;
        return (0, exports.TendersApiFp)(this.configuration).tendersTenderIdEmailPreviewGet(tenderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Fetch Details about a tender
     * @param {string} tenderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TendersApi
     */
    TendersApi.prototype.tendersTenderIdGet = function (tenderId, options) {
        var _this = this;
        return (0, exports.TendersApiFp)(this.configuration).tendersTenderIdGet(tenderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Rejects a Tender
     * @param {string} tenderId
     * @param {TenderRejectRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TendersApi
     */
    TendersApi.prototype.tendersTenderIdRejectPost = function (tenderId, body, options) {
        var _this = this;
        return (0, exports.TendersApiFp)(this.configuration).tendersTenderIdRejectPost(tenderId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Revokes a Tender
     * @param {string} tenderId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TendersApi
     */
    TendersApi.prototype.tendersTenderIdRevokePost = function (tenderId, options) {
        var _this = this;
        return (0, exports.TendersApiFp)(this.configuration).tendersTenderIdRevokePost(tenderId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TendersApi;
}(base_1.BaseAPI));
exports.TendersApi = TendersApi;
/**
 * UsersApi - axios parameter creator
 * @export
 */
var UsersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Returns a list of API Keys of the company of the current authenticated user
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {boolean} [isActive]
         * @param {string} [expiresAtLte] Include api keys where expires_at is less than or equal to this value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authApikeysGet: function (page, pageSize, ordering, isActive, expiresAtLte, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/auth/apikeys/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (isActive !== undefined) {
                                localVarQueryParameter['is_active'] = isActive;
                            }
                            if (expiresAtLte !== undefined) {
                                localVarQueryParameter['expires_at__lte'] = (expiresAtLte instanceof Date) ?
                                    expiresAtLte.toISOString() :
                                    expiresAtLte;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns information about a specific API Key
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authApikeysIdGet: function (id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('authApikeysIdGet', 'id', id);
                            localVarPath = "/auth/apikeys/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates information about the current API Key
         * @param {string} id
         * @param {ApiKey} apiKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authApikeysIdPatch: function (id, apiKey, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('authApikeysIdPatch', 'id', id);
                            // verify required parameter 'apiKey' is not null or undefined
                            (0, common_1.assertParamExists)('authApikeysIdPatch', 'apiKey', apiKey);
                            localVarPath = "/auth/apikeys/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(apiKey, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates information about the current API Key
         * @param {string} id
         * @param {ApiKey} apiKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authApikeysIdPut: function (id, apiKey, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('authApikeysIdPut', 'id', id);
                            // verify required parameter 'apiKey' is not null or undefined
                            (0, common_1.assertParamExists)('authApikeysIdPut', 'apiKey', apiKey);
                            localVarPath = "/auth/apikeys/{id}/"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(apiKey, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Use this route to generate a new API Key
         * @param {ApiKey} apiKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authApikeysPost: function (apiKey, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'apiKey' is not null or undefined
                            (0, common_1.assertParamExists)('authApikeysPost', 'apiKey', apiKey);
                            localVarPath = "/auth/apikeys/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(apiKey, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Change a user\'s password
         * @param {ChangePassword} changePassword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authChangePasswordPost: function (changePassword, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'changePassword' is not null or undefined
                            (0, common_1.assertParamExists)('authChangePasswordPost', 'changePassword', changePassword);
                            localVarPath = "/auth/change-password/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(changePassword, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Exchanges an impersonation token for a valid user authentication token
         * @param {string} impersonationToken Token from the start impersonation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authImpersonationImpersonateGet: function (impersonationToken, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'impersonationToken' is not null or undefined
                            (0, common_1.assertParamExists)('authImpersonationImpersonateGet', 'impersonationToken', impersonationToken);
                            localVarPath = "/auth/impersonation/impersonate/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (impersonationToken !== undefined) {
                                localVarQueryParameter['impersonation_token'] = impersonationToken;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a URL frontend redirect for a token to impersonate a different user account
         * @param {string} impersonableUserId User id to impersonate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authImpersonationStartGet: function (impersonableUserId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'impersonableUserId' is not null or undefined
                            (0, common_1.assertParamExists)('authImpersonationStartGet', 'impersonableUserId', impersonableUserId);
                            localVarPath = "/auth/impersonation/start/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (impersonableUserId !== undefined) {
                                localVarQueryParameter['impersonable_user_id'] = impersonableUserId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns all tenants that can be impersonated from the current user account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authImpersonationTenantsGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/auth/impersonation/tenants/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a token that can be used to impersonate a different user account
         * @param {string} impersonableUserId User id to impersonate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authImpersonationTokenGet: function (impersonableUserId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'impersonableUserId' is not null or undefined
                            (0, common_1.assertParamExists)('authImpersonationTokenGet', 'impersonableUserId', impersonableUserId);
                            localVarPath = "/auth/impersonation/token/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (impersonableUserId !== undefined) {
                                localVarQueryParameter['impersonable_user_id'] = impersonableUserId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the currently authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authMeGet: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/auth/me/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Submit a password reset token
         * @param {ResetPassword} resetPassword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPasswordResetPost: function (resetPassword, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'resetPassword' is not null or undefined
                            (0, common_1.assertParamExists)('authPasswordResetPost', 'resetPassword', resetPassword);
                            localVarPath = "/auth/password-reset/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(resetPassword, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Request a magic link email to be sent to a specified address
         * @param {MagicLinkRequest} magicLinkRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRequestMagicLinkPost: function (magicLinkRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'magicLinkRequest' is not null or undefined
                            (0, common_1.assertParamExists)('authRequestMagicLinkPost', 'magicLinkRequest', magicLinkRequest);
                            localVarPath = "/auth/request-magic-link/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(magicLinkRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Requests a Reset Password Email
         * @param {RequestPasswordReset} requestPasswordReset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRequestPasswordResetPost: function (requestPasswordReset, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'requestPasswordReset' is not null or undefined
                            (0, common_1.assertParamExists)('authRequestPasswordResetPost', 'requestPasswordReset', requestPasswordReset);
                            localVarPath = "/auth/request-password-reset/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestPasswordReset, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Requests a Verification Email
         * @param {RequestVerificationEmail} requestVerificationEmail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRequestVerificationEmailPost: function (requestVerificationEmail, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'requestVerificationEmail' is not null or undefined
                            (0, common_1.assertParamExists)('authRequestVerificationEmailPost', 'requestVerificationEmail', requestVerificationEmail);
                            localVarPath = "/auth/request-verification-email/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestVerificationEmail, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Submit a set password token
         * @param {SetPassword} setPassword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSetPasswordPost: function (setPassword, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'setPassword' is not null or undefined
                            (0, common_1.assertParamExists)('authSetPasswordPost', 'setPassword', setPassword);
                            localVarPath = "/auth/set-password/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(setPassword, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Login given a users credentials
         * @param {Login} login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authTokenPost: function (login, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'login' is not null or undefined
                    (0, common_1.assertParamExists)('authTokenPost', 'login', login);
                    localVarPath = "/auth/token/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(login, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary If the user set the incorrect phone or email when signing up, use this route to update it
         * @param {ResetSignupInfo} resetSignupInfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUpdateSignupInfoPost: function (resetSignupInfo, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'resetSignupInfo' is not null or undefined
                            (0, common_1.assertParamExists)('authUpdateSignupInfoPost', 'resetSignupInfo', resetSignupInfo);
                            localVarPath = "/auth/update-signup-info/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(resetSignupInfo, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Submit an email verification token
         * @param {VerifyEmail} verifyEmail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authVerifyEmailPost: function (verifyEmail, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'verifyEmail' is not null or undefined
                            (0, common_1.assertParamExists)('authVerifyEmailPost', 'verifyEmail', verifyEmail);
                            localVarPath = "/auth/verify-email/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(verifyEmail, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of users associated to a company
         * @param {string} companyId The id of the company
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [firstName] Include users with this first name
         * @param {string} [lastName] Include users with this last name
         * @param {string} [email] Include users with this email
         * @param {Array<string>} [id] Include users with this id
         * @param {boolean} [isActive] Include users with this active status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdUsersGet: function (companyId, page, pageSize, ordering, q, firstName, lastName, email, id, isActive, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdUsersGet', 'companyId', companyId);
                            localVarPath = "/companies/{companyId}/users/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (firstName !== undefined) {
                                localVarQueryParameter['first_name'] = firstName;
                            }
                            if (lastName !== undefined) {
                                localVarQueryParameter['last_name'] = lastName;
                            }
                            if (email !== undefined) {
                                localVarQueryParameter['email'] = email;
                            }
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (isActive !== undefined) {
                                localVarQueryParameter['is_active'] = isActive;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new user
         * @param {string} companyId The id of the company
         * @param {PostCompaniesCompanyidUsers} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdUsersPost: function (companyId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdUsersPost', 'companyId', companyId);
                            localVarPath = "/companies/{companyId}/users/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a user
         * @param {string} companyId The id of the company
         * @param {string} userId The id of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdUsersUserIdDelete: function (companyId, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdUsersUserIdDelete', 'companyId', companyId);
                            // verify required parameter 'userId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdUsersUserIdDelete', 'userId', userId);
                            localVarPath = "/companies/{companyId}/users/{userId}/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)))
                                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a user
         * @param {string} companyId The id of the company
         * @param {string} userId The id of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdUsersUserIdGet: function (companyId, userId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdUsersUserIdGet', 'companyId', companyId);
                            // verify required parameter 'userId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdUsersUserIdGet', 'userId', userId);
                            localVarPath = "/companies/{companyId}/users/{userId}/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)))
                                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a user
         * @param {string} companyId The id of the company
         * @param {string} userId The id of the user
         * @param {PostCompaniesCompanyidUsers} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdUsersUserIdPut: function (companyId, userId, body, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'companyId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdUsersUserIdPut', 'companyId', companyId);
                            // verify required parameter 'userId' is not null or undefined
                            (0, common_1.assertParamExists)('companiesCompanyIdUsersUserIdPut', 'userId', userId);
                            localVarPath = "/companies/{companyId}/users/{userId}/"
                                .replace("{".concat("companyId", "}"), encodeURIComponent(String(companyId)))
                                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve dashboard configurations for a user or driver
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [tableType] filter for dashboard config to return a specific table type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesDashboardConfigurationsGet: function (page, pageSize, ordering, tableType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/preferences/dashboard-configurations/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (tableType !== undefined) {
                                localVarQueryParameter['table_type'] = tableType;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new dashboard configuration
         * @param {UserDashboardConfiguration} userDashboardConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesDashboardConfigurationsPost: function (userDashboardConfiguration, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'userDashboardConfiguration' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesDashboardConfigurationsPost', 'userDashboardConfiguration', userDashboardConfiguration);
                            localVarPath = "/preferences/dashboard-configurations/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userDashboardConfiguration, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a dashboard configuration
         * @param {string} userDashboardConfigurationId The id of the user dashboard configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesDashboardConfigurationsUserDashboardConfigurationIdDelete: function (userDashboardConfigurationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'userDashboardConfigurationId' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesDashboardConfigurationsUserDashboardConfigurationIdDelete', 'userDashboardConfigurationId', userDashboardConfigurationId);
                            localVarPath = "/preferences/dashboard-configurations/{userDashboardConfigurationId}/"
                                .replace("{".concat("userDashboardConfigurationId", "}"), encodeURIComponent(String(userDashboardConfigurationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a dashboard configuration
         * @param {string} userDashboardConfigurationId The id of the user dashboard configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesDashboardConfigurationsUserDashboardConfigurationIdGet: function (userDashboardConfigurationId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'userDashboardConfigurationId' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesDashboardConfigurationsUserDashboardConfigurationIdGet', 'userDashboardConfigurationId', userDashboardConfigurationId);
                            localVarPath = "/preferences/dashboard-configurations/{userDashboardConfigurationId}/"
                                .replace("{".concat("userDashboardConfigurationId", "}"), encodeURIComponent(String(userDashboardConfigurationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a dashboard configuration
         * @param {string} userDashboardConfigurationId The id of the user dashboard configuration
         * @param {UserDashboardConfiguration} userDashboardConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesDashboardConfigurationsUserDashboardConfigurationIdPut: function (userDashboardConfigurationId, userDashboardConfiguration, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'userDashboardConfigurationId' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesDashboardConfigurationsUserDashboardConfigurationIdPut', 'userDashboardConfigurationId', userDashboardConfigurationId);
                            // verify required parameter 'userDashboardConfiguration' is not null or undefined
                            (0, common_1.assertParamExists)('preferencesDashboardConfigurationsUserDashboardConfigurationIdPut', 'userDashboardConfiguration', userDashboardConfiguration);
                            localVarPath = "/preferences/dashboard-configurations/{userDashboardConfigurationId}/"
                                .replace("{".concat("userDashboardConfigurationId", "}"), encodeURIComponent(String(userDashboardConfigurationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(userDashboardConfiguration, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.UsersApiAxiosParamCreator = UsersApiAxiosParamCreator;
/**
 * UsersApi - functional programming interface
 * @export
 */
var UsersApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.UsersApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Returns a list of API Keys of the company of the current authenticated user
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {boolean} [isActive]
         * @param {string} [expiresAtLte] Include api keys where expires_at is less than or equal to this value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authApikeysGet: function (page, pageSize, ordering, isActive, expiresAtLte, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authApikeysGet(page, pageSize, ordering, isActive, expiresAtLte, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns information about a specific API Key
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authApikeysIdGet: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authApikeysIdGet(id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates information about the current API Key
         * @param {string} id
         * @param {ApiKey} apiKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authApikeysIdPatch: function (id, apiKey, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authApikeysIdPatch(id, apiKey, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Updates information about the current API Key
         * @param {string} id
         * @param {ApiKey} apiKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authApikeysIdPut: function (id, apiKey, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authApikeysIdPut(id, apiKey, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Use this route to generate a new API Key
         * @param {ApiKey} apiKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authApikeysPost: function (apiKey, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authApikeysPost(apiKey, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Change a user\'s password
         * @param {ChangePassword} changePassword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authChangePasswordPost: function (changePassword, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authChangePasswordPost(changePassword, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Exchanges an impersonation token for a valid user authentication token
         * @param {string} impersonationToken Token from the start impersonation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authImpersonationImpersonateGet: function (impersonationToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authImpersonationImpersonateGet(impersonationToken, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a URL frontend redirect for a token to impersonate a different user account
         * @param {string} impersonableUserId User id to impersonate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authImpersonationStartGet: function (impersonableUserId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authImpersonationStartGet(impersonableUserId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns all tenants that can be impersonated from the current user account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authImpersonationTenantsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authImpersonationTenantsGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a token that can be used to impersonate a different user account
         * @param {string} impersonableUserId User id to impersonate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authImpersonationTokenGet: function (impersonableUserId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authImpersonationTokenGet(impersonableUserId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns the currently authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authMeGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authMeGet(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Submit a password reset token
         * @param {ResetPassword} resetPassword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPasswordResetPost: function (resetPassword, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authPasswordResetPost(resetPassword, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Request a magic link email to be sent to a specified address
         * @param {MagicLinkRequest} magicLinkRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRequestMagicLinkPost: function (magicLinkRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authRequestMagicLinkPost(magicLinkRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Requests a Reset Password Email
         * @param {RequestPasswordReset} requestPasswordReset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRequestPasswordResetPost: function (requestPasswordReset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authRequestPasswordResetPost(requestPasswordReset, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Requests a Verification Email
         * @param {RequestVerificationEmail} requestVerificationEmail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRequestVerificationEmailPost: function (requestVerificationEmail, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authRequestVerificationEmailPost(requestVerificationEmail, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Submit a set password token
         * @param {SetPassword} setPassword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSetPasswordPost: function (setPassword, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authSetPasswordPost(setPassword, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Login given a users credentials
         * @param {Login} login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authTokenPost: function (login, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authTokenPost(login, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary If the user set the incorrect phone or email when signing up, use this route to update it
         * @param {ResetSignupInfo} resetSignupInfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUpdateSignupInfoPost: function (resetSignupInfo, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authUpdateSignupInfoPost(resetSignupInfo, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Submit an email verification token
         * @param {VerifyEmail} verifyEmail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authVerifyEmailPost: function (verifyEmail, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.authVerifyEmailPost(verifyEmail, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Returns a list of users associated to a company
         * @param {string} companyId The id of the company
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [firstName] Include users with this first name
         * @param {string} [lastName] Include users with this last name
         * @param {string} [email] Include users with this email
         * @param {Array<string>} [id] Include users with this id
         * @param {boolean} [isActive] Include users with this active status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdUsersGet: function (companyId, page, pageSize, ordering, q, firstName, lastName, email, id, isActive, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdUsersGet(companyId, page, pageSize, ordering, q, firstName, lastName, email, id, isActive, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Creates a new user
         * @param {string} companyId The id of the company
         * @param {PostCompaniesCompanyidUsers} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdUsersPost: function (companyId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdUsersPost(companyId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a user
         * @param {string} companyId The id of the company
         * @param {string} userId The id of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdUsersUserIdDelete: function (companyId, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdUsersUserIdDelete(companyId, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Get information about a user
         * @param {string} companyId The id of the company
         * @param {string} userId The id of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdUsersUserIdGet: function (companyId, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdUsersUserIdGet(companyId, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a user
         * @param {string} companyId The id of the company
         * @param {string} userId The id of the user
         * @param {PostCompaniesCompanyidUsers} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdUsersUserIdPut: function (companyId, userId, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.companiesCompanyIdUsersUserIdPut(companyId, userId, body, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve dashboard configurations for a user or driver
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [tableType] filter for dashboard config to return a specific table type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesDashboardConfigurationsGet: function (page, pageSize, ordering, tableType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.preferencesDashboardConfigurationsGet(page, pageSize, ordering, tableType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a new dashboard configuration
         * @param {UserDashboardConfiguration} userDashboardConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesDashboardConfigurationsPost: function (userDashboardConfiguration, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.preferencesDashboardConfigurationsPost(userDashboardConfiguration, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Delete a dashboard configuration
         * @param {string} userDashboardConfigurationId The id of the user dashboard configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesDashboardConfigurationsUserDashboardConfigurationIdDelete: function (userDashboardConfigurationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.preferencesDashboardConfigurationsUserDashboardConfigurationIdDelete(userDashboardConfigurationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieve a dashboard configuration
         * @param {string} userDashboardConfigurationId The id of the user dashboard configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesDashboardConfigurationsUserDashboardConfigurationIdGet: function (userDashboardConfigurationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.preferencesDashboardConfigurationsUserDashboardConfigurationIdGet(userDashboardConfigurationId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Update a dashboard configuration
         * @param {string} userDashboardConfigurationId The id of the user dashboard configuration
         * @param {UserDashboardConfiguration} userDashboardConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesDashboardConfigurationsUserDashboardConfigurationIdPut: function (userDashboardConfigurationId, userDashboardConfiguration, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.preferencesDashboardConfigurationsUserDashboardConfigurationIdPut(userDashboardConfigurationId, userDashboardConfiguration, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.UsersApiFp = UsersApiFp;
/**
 * UsersApi - factory interface
 * @export
 */
var UsersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.UsersApiFp)(configuration);
    return {
        /**
         *
         * @summary Returns a list of API Keys of the company of the current authenticated user
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {boolean} [isActive]
         * @param {string} [expiresAtLte] Include api keys where expires_at is less than or equal to this value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authApikeysGet: function (page, pageSize, ordering, isActive, expiresAtLte, options) {
            return localVarFp.authApikeysGet(page, pageSize, ordering, isActive, expiresAtLte, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns information about a specific API Key
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authApikeysIdGet: function (id, options) {
            return localVarFp.authApikeysIdGet(id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates information about the current API Key
         * @param {string} id
         * @param {ApiKey} apiKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authApikeysIdPatch: function (id, apiKey, options) {
            return localVarFp.authApikeysIdPatch(id, apiKey, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Updates information about the current API Key
         * @param {string} id
         * @param {ApiKey} apiKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authApikeysIdPut: function (id, apiKey, options) {
            return localVarFp.authApikeysIdPut(id, apiKey, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Use this route to generate a new API Key
         * @param {ApiKey} apiKey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authApikeysPost: function (apiKey, options) {
            return localVarFp.authApikeysPost(apiKey, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Change a user\'s password
         * @param {ChangePassword} changePassword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authChangePasswordPost: function (changePassword, options) {
            return localVarFp.authChangePasswordPost(changePassword, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Exchanges an impersonation token for a valid user authentication token
         * @param {string} impersonationToken Token from the start impersonation process
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authImpersonationImpersonateGet: function (impersonationToken, options) {
            return localVarFp.authImpersonationImpersonateGet(impersonationToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a URL frontend redirect for a token to impersonate a different user account
         * @param {string} impersonableUserId User id to impersonate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authImpersonationStartGet: function (impersonableUserId, options) {
            return localVarFp.authImpersonationStartGet(impersonableUserId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns all tenants that can be impersonated from the current user account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authImpersonationTenantsGet: function (options) {
            return localVarFp.authImpersonationTenantsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a token that can be used to impersonate a different user account
         * @param {string} impersonableUserId User id to impersonate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authImpersonationTokenGet: function (impersonableUserId, options) {
            return localVarFp.authImpersonationTokenGet(impersonableUserId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns the currently authenticated user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authMeGet: function (options) {
            return localVarFp.authMeGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Submit a password reset token
         * @param {ResetPassword} resetPassword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authPasswordResetPost: function (resetPassword, options) {
            return localVarFp.authPasswordResetPost(resetPassword, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Request a magic link email to be sent to a specified address
         * @param {MagicLinkRequest} magicLinkRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRequestMagicLinkPost: function (magicLinkRequest, options) {
            return localVarFp.authRequestMagicLinkPost(magicLinkRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Requests a Reset Password Email
         * @param {RequestPasswordReset} requestPasswordReset
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRequestPasswordResetPost: function (requestPasswordReset, options) {
            return localVarFp.authRequestPasswordResetPost(requestPasswordReset, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Requests a Verification Email
         * @param {RequestVerificationEmail} requestVerificationEmail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authRequestVerificationEmailPost: function (requestVerificationEmail, options) {
            return localVarFp.authRequestVerificationEmailPost(requestVerificationEmail, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Submit a set password token
         * @param {SetPassword} setPassword
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authSetPasswordPost: function (setPassword, options) {
            return localVarFp.authSetPasswordPost(setPassword, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Login given a users credentials
         * @param {Login} login
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authTokenPost: function (login, options) {
            return localVarFp.authTokenPost(login, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary If the user set the incorrect phone or email when signing up, use this route to update it
         * @param {ResetSignupInfo} resetSignupInfo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUpdateSignupInfoPost: function (resetSignupInfo, options) {
            return localVarFp.authUpdateSignupInfoPost(resetSignupInfo, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Submit an email verification token
         * @param {VerifyEmail} verifyEmail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authVerifyEmailPost: function (verifyEmail, options) {
            return localVarFp.authVerifyEmailPost(verifyEmail, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Returns a list of users associated to a company
         * @param {string} companyId The id of the company
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {string} [firstName] Include users with this first name
         * @param {string} [lastName] Include users with this last name
         * @param {string} [email] Include users with this email
         * @param {Array<string>} [id] Include users with this id
         * @param {boolean} [isActive] Include users with this active status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdUsersGet: function (companyId, page, pageSize, ordering, q, firstName, lastName, email, id, isActive, options) {
            return localVarFp.companiesCompanyIdUsersGet(companyId, page, pageSize, ordering, q, firstName, lastName, email, id, isActive, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Creates a new user
         * @param {string} companyId The id of the company
         * @param {PostCompaniesCompanyidUsers} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdUsersPost: function (companyId, body, options) {
            return localVarFp.companiesCompanyIdUsersPost(companyId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a user
         * @param {string} companyId The id of the company
         * @param {string} userId The id of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdUsersUserIdDelete: function (companyId, userId, options) {
            return localVarFp.companiesCompanyIdUsersUserIdDelete(companyId, userId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get information about a user
         * @param {string} companyId The id of the company
         * @param {string} userId The id of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdUsersUserIdGet: function (companyId, userId, options) {
            return localVarFp.companiesCompanyIdUsersUserIdGet(companyId, userId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a user
         * @param {string} companyId The id of the company
         * @param {string} userId The id of the user
         * @param {PostCompaniesCompanyidUsers} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companiesCompanyIdUsersUserIdPut: function (companyId, userId, body, options) {
            return localVarFp.companiesCompanyIdUsersUserIdPut(companyId, userId, body, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve dashboard configurations for a user or driver
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [tableType] filter for dashboard config to return a specific table type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesDashboardConfigurationsGet: function (page, pageSize, ordering, tableType, options) {
            return localVarFp.preferencesDashboardConfigurationsGet(page, pageSize, ordering, tableType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a new dashboard configuration
         * @param {UserDashboardConfiguration} userDashboardConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesDashboardConfigurationsPost: function (userDashboardConfiguration, options) {
            return localVarFp.preferencesDashboardConfigurationsPost(userDashboardConfiguration, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Delete a dashboard configuration
         * @param {string} userDashboardConfigurationId The id of the user dashboard configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesDashboardConfigurationsUserDashboardConfigurationIdDelete: function (userDashboardConfigurationId, options) {
            return localVarFp.preferencesDashboardConfigurationsUserDashboardConfigurationIdDelete(userDashboardConfigurationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieve a dashboard configuration
         * @param {string} userDashboardConfigurationId The id of the user dashboard configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesDashboardConfigurationsUserDashboardConfigurationIdGet: function (userDashboardConfigurationId, options) {
            return localVarFp.preferencesDashboardConfigurationsUserDashboardConfigurationIdGet(userDashboardConfigurationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update a dashboard configuration
         * @param {string} userDashboardConfigurationId The id of the user dashboard configuration
         * @param {UserDashboardConfiguration} userDashboardConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        preferencesDashboardConfigurationsUserDashboardConfigurationIdPut: function (userDashboardConfigurationId, userDashboardConfiguration, options) {
            return localVarFp.preferencesDashboardConfigurationsUserDashboardConfigurationIdPut(userDashboardConfigurationId, userDashboardConfiguration, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.UsersApiFactory = UsersApiFactory;
/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
var UsersApi = /** @class */ (function (_super) {
    __extends(UsersApi, _super);
    function UsersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Returns a list of API Keys of the company of the current authenticated user
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {boolean} [isActive]
     * @param {string} [expiresAtLte] Include api keys where expires_at is less than or equal to this value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.authApikeysGet = function (page, pageSize, ordering, isActive, expiresAtLte, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).authApikeysGet(page, pageSize, ordering, isActive, expiresAtLte, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns information about a specific API Key
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.authApikeysIdGet = function (id, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).authApikeysIdGet(id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates information about the current API Key
     * @param {string} id
     * @param {ApiKey} apiKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.authApikeysIdPatch = function (id, apiKey, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).authApikeysIdPatch(id, apiKey, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Updates information about the current API Key
     * @param {string} id
     * @param {ApiKey} apiKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.authApikeysIdPut = function (id, apiKey, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).authApikeysIdPut(id, apiKey, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Use this route to generate a new API Key
     * @param {ApiKey} apiKey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.authApikeysPost = function (apiKey, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).authApikeysPost(apiKey, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Change a user\'s password
     * @param {ChangePassword} changePassword
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.authChangePasswordPost = function (changePassword, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).authChangePasswordPost(changePassword, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Exchanges an impersonation token for a valid user authentication token
     * @param {string} impersonationToken Token from the start impersonation process
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.authImpersonationImpersonateGet = function (impersonationToken, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).authImpersonationImpersonateGet(impersonationToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a URL frontend redirect for a token to impersonate a different user account
     * @param {string} impersonableUserId User id to impersonate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.authImpersonationStartGet = function (impersonableUserId, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).authImpersonationStartGet(impersonableUserId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns all tenants that can be impersonated from the current user account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.authImpersonationTenantsGet = function (options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).authImpersonationTenantsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a token that can be used to impersonate a different user account
     * @param {string} impersonableUserId User id to impersonate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.authImpersonationTokenGet = function (impersonableUserId, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).authImpersonationTokenGet(impersonableUserId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns the currently authenticated user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.authMeGet = function (options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).authMeGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Submit a password reset token
     * @param {ResetPassword} resetPassword
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.authPasswordResetPost = function (resetPassword, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).authPasswordResetPost(resetPassword, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Request a magic link email to be sent to a specified address
     * @param {MagicLinkRequest} magicLinkRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.authRequestMagicLinkPost = function (magicLinkRequest, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).authRequestMagicLinkPost(magicLinkRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Requests a Reset Password Email
     * @param {RequestPasswordReset} requestPasswordReset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.authRequestPasswordResetPost = function (requestPasswordReset, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).authRequestPasswordResetPost(requestPasswordReset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Requests a Verification Email
     * @param {RequestVerificationEmail} requestVerificationEmail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.authRequestVerificationEmailPost = function (requestVerificationEmail, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).authRequestVerificationEmailPost(requestVerificationEmail, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Submit a set password token
     * @param {SetPassword} setPassword
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.authSetPasswordPost = function (setPassword, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).authSetPasswordPost(setPassword, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Login given a users credentials
     * @param {Login} login
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.authTokenPost = function (login, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).authTokenPost(login, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary If the user set the incorrect phone or email when signing up, use this route to update it
     * @param {ResetSignupInfo} resetSignupInfo
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.authUpdateSignupInfoPost = function (resetSignupInfo, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).authUpdateSignupInfoPost(resetSignupInfo, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Submit an email verification token
     * @param {VerifyEmail} verifyEmail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.authVerifyEmailPost = function (verifyEmail, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).authVerifyEmailPost(verifyEmail, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Returns a list of users associated to a company
     * @param {string} companyId The id of the company
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {string} [firstName] Include users with this first name
     * @param {string} [lastName] Include users with this last name
     * @param {string} [email] Include users with this email
     * @param {Array<string>} [id] Include users with this id
     * @param {boolean} [isActive] Include users with this active status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.companiesCompanyIdUsersGet = function (companyId, page, pageSize, ordering, q, firstName, lastName, email, id, isActive, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).companiesCompanyIdUsersGet(companyId, page, pageSize, ordering, q, firstName, lastName, email, id, isActive, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Creates a new user
     * @param {string} companyId The id of the company
     * @param {PostCompaniesCompanyidUsers} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.companiesCompanyIdUsersPost = function (companyId, body, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).companiesCompanyIdUsersPost(companyId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a user
     * @param {string} companyId The id of the company
     * @param {string} userId The id of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.companiesCompanyIdUsersUserIdDelete = function (companyId, userId, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).companiesCompanyIdUsersUserIdDelete(companyId, userId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get information about a user
     * @param {string} companyId The id of the company
     * @param {string} userId The id of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.companiesCompanyIdUsersUserIdGet = function (companyId, userId, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).companiesCompanyIdUsersUserIdGet(companyId, userId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a user
     * @param {string} companyId The id of the company
     * @param {string} userId The id of the user
     * @param {PostCompaniesCompanyidUsers} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.companiesCompanyIdUsersUserIdPut = function (companyId, userId, body, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).companiesCompanyIdUsersUserIdPut(companyId, userId, body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve dashboard configurations for a user or driver
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [tableType] filter for dashboard config to return a specific table type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.preferencesDashboardConfigurationsGet = function (page, pageSize, ordering, tableType, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).preferencesDashboardConfigurationsGet(page, pageSize, ordering, tableType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a new dashboard configuration
     * @param {UserDashboardConfiguration} userDashboardConfiguration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.preferencesDashboardConfigurationsPost = function (userDashboardConfiguration, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).preferencesDashboardConfigurationsPost(userDashboardConfiguration, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Delete a dashboard configuration
     * @param {string} userDashboardConfigurationId The id of the user dashboard configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.preferencesDashboardConfigurationsUserDashboardConfigurationIdDelete = function (userDashboardConfigurationId, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).preferencesDashboardConfigurationsUserDashboardConfigurationIdDelete(userDashboardConfigurationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieve a dashboard configuration
     * @param {string} userDashboardConfigurationId The id of the user dashboard configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.preferencesDashboardConfigurationsUserDashboardConfigurationIdGet = function (userDashboardConfigurationId, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).preferencesDashboardConfigurationsUserDashboardConfigurationIdGet(userDashboardConfigurationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update a dashboard configuration
     * @param {string} userDashboardConfigurationId The id of the user dashboard configuration
     * @param {UserDashboardConfiguration} userDashboardConfiguration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.preferencesDashboardConfigurationsUserDashboardConfigurationIdPut = function (userDashboardConfigurationId, userDashboardConfiguration, options) {
        var _this = this;
        return (0, exports.UsersApiFp)(this.configuration).preferencesDashboardConfigurationsUserDashboardConfigurationIdPut(userDashboardConfigurationId, userDashboardConfiguration, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UsersApi;
}(base_1.BaseAPI));
exports.UsersApi = UsersApi;
/**
 * VendorRelationshipsApi - axios parameter creator
 * @export
 */
var VendorRelationshipsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Get the list of relationships with vendors
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiVendorRelationshipsGet: function (page, pageSize, ordering, q, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/shipwell-ui/vendor-relationships/";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication AuthToken required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication AuthToken required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (pageSize !== undefined) {
                                localVarQueryParameter['page-size'] = pageSize;
                            }
                            if (ordering !== undefined) {
                                localVarQueryParameter['ordering'] = ordering;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.VendorRelationshipsApiAxiosParamCreator = VendorRelationshipsApiAxiosParamCreator;
/**
 * VendorRelationshipsApi - functional programming interface
 * @export
 */
var VendorRelationshipsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.VendorRelationshipsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Get the list of relationships with vendors
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiVendorRelationshipsGet: function (page, pageSize, ordering, q, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellUiVendorRelationshipsGet(page, pageSize, ordering, q, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.VendorRelationshipsApiFp = VendorRelationshipsApiFp;
/**
 * VendorRelationshipsApi - factory interface
 * @export
 */
var VendorRelationshipsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.VendorRelationshipsApiFp)(configuration);
    return {
        /**
         *
         * @summary Get the list of relationships with vendors
         * @param {number} [page] indicates what page of a list of query results you want to view
         * @param {number} [pageSize] indicates the how many items to return per page in a list request
         * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
         * @param {string} [q] search query
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellUiVendorRelationshipsGet: function (page, pageSize, ordering, q, options) {
            return localVarFp.shipwellUiVendorRelationshipsGet(page, pageSize, ordering, q, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.VendorRelationshipsApiFactory = VendorRelationshipsApiFactory;
/**
 * VendorRelationshipsApi - object-oriented interface
 * @export
 * @class VendorRelationshipsApi
 * @extends {BaseAPI}
 */
var VendorRelationshipsApi = /** @class */ (function (_super) {
    __extends(VendorRelationshipsApi, _super);
    function VendorRelationshipsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get the list of relationships with vendors
     * @param {number} [page] indicates what page of a list of query results you want to view
     * @param {number} [pageSize] indicates the how many items to return per page in a list request
     * @param {string} [ordering] determines which column to sort by. Prepend with \&#39;-\&#39; to sort desc
     * @param {string} [q] search query
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorRelationshipsApi
     */
    VendorRelationshipsApi.prototype.shipwellUiVendorRelationshipsGet = function (page, pageSize, ordering, q, options) {
        var _this = this;
        return (0, exports.VendorRelationshipsApiFp)(this.configuration).shipwellUiVendorRelationshipsGet(page, pageSize, ordering, q, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return VendorRelationshipsApi;
}(base_1.BaseAPI));
exports.VendorRelationshipsApi = VendorRelationshipsApi;
